// @ts-nocheck
import { newDate, newDateTime } from "src/utils/tests/testDates";
import {
  AbortAssetMultipartUploadResult,
  ActivateItemTemplateVersionsResult,
  ActivateUserResult,
  ActivateUsersResult,
  ActivityPlanningState,
  ActivityPlanningStateDetail,
  ActivityResponsibility,
  ActivityResponsibilityDetail,
  ActivityType,
  ActivityTypeDetail,
  AddJobResult,
  AddJobsResult,
  Address,
  AggregateVersionStatus,
  AggregateVersionStatusDetail,
  AiDataConfidence,
  AiDataConfidenceDetail,
  AiEntityProposal,
  AiEntityProposalEntity,
  AiEntityProposalEntityType,
  AiEntityProposalEntityTypeDetail,
  AiEntityProposalsPage,
  AiEntityProposalType,
  AiEntityProposalTypeDetail,
  AiFieldProposal,
  AiFieldProposalsPage,
  AiFieldProposalStatus,
  AiFieldProposalStatusDetail,
  AiProposal,
  AiProposalStatus,
  AiProposalStatusDetail,
  AiProposalType,
  AiProposalTypeDetail,
  AllEnumDetails,
  AllocationStrategy,
  AllocationStrategyDetail,
  AnnotatedCost,
  ApplyInvoiceScheduleResult,
  ApplyItemTemplateResult,
  ApplyItemTemplateToChangeEventResult,
  ApplyProjectReadyPlanConfigsResult,
  ApplyScheduleTemplatesResult,
  Approval,
  ApprovalPage,
  ApprovalSource,
  ApprovalStatus,
  ApprovalStatusDetail,
  ApprovalSubject,
  ApprovePreConBudgetLineItemResult,
  Approver,
  ApproverStatus,
  ApproverStatusDetail,
  ApproverSubjectData,
  ApproverUser,
  Asset,
  Attachment,
  AttachmentParent,
  BackfillResponse,
  BaseItemLike,
  BaseItemParentVersion,
  BidContract,
  BidContractLineItem,
  BidContractLineItemsPageResult,
  BidContractPotentialItem,
  BidContractRevision,
  BidContractRevisionDraw,
  BidContractRevisionStatus,
  BidContractRevisionStatusDetail,
  BidContractsPage,
  BidContractTradeLineItem,
  BidContractType,
  BidContractTypeDetail,
  BidItem,
  BidItemEstimate,
  BidItemEstimatesPageResult,
  BidItemsPage,
  BidPackage,
  BidPackageAward,
  BidPackageBidder,
  BidPackageBidderKind,
  BidPackageGroup,
  BidPackageGroupProductOfferingsResult,
  BidPackageGroupsPageResult,
  BidPackageIncomingUpdate,
  BidPackageIncomingUpdateStats,
  BidPackageLineItem,
  BidPackageProductOfferingSummary,
  BidPackageRequest,
  BidPackageScopeLine,
  BidPackagesPageResult,
  BidPackageStatus,
  BidPackageStatusDetail,
  BidPackageVersion,
  BidPlanChildGroup,
  BidPlanChildGroupLine,
  BidPlanChildGroupScopedLine,
  BidPlanGroup,
  BidPlanGroupDimension,
  Bill,
  BillGmailAttachment,
  BillGmailAttachmentResult,
  BillGmailAttachmentResultDetail,
  BillGmailMessage,
  BillGmailMessageResult,
  BillGmailMessageResultDetail,
  BillLineItem,
  BillLineItemAllocation,
  BillMetric,
  BillMetricsResult,
  BillOcr,
  BillReviewReason,
  BillReviewReasonDetail,
  BillSource,
  BillSourceDetail,
  BillsPage,
  BillStatus,
  BillStatusDetail,
  BillType,
  BillTypeDetail,
  BudgetPhaseRollup,
  Builder,
  BulkSaveGlobalPlanTagsResult,
  BulkSavePlanTasksResult,
  BulkUpdateProjectRoleResult,
  BusinessFunction,
  BusinessFunctionType,
  BusinessFunctionTypeDetail,
  BuyoutStatus,
  BuyoutStatusDetail,
  CalculateScopeChangeResult,
  CalendarInterval,
  CalendarInterval2,
  ChangeEvent,
  ChangeEventBudgetPhase,
  ChangeEventBudgetPhaseDetail,
  ChangeEventCreatedBy,
  ChangeEventLineItem,
  ChangeEventLineItemAllocation,
  ChangeEventLineItemType,
  ChangeEventLineItemTypeDetail,
  ChangeEventMaterialVariantSwap,
  ChangeEventOriginalOption,
  ChangeEventProposedOption,
  ChangeEventReason,
  ChangeEventStatus,
  ChangeEventStatusDetail,
  ChangeEventTemplateConfig,
  ChangeEventType,
  ChangeEventTypeDetail,
  ChangeEventWorkflow,
  ChangeEventWorkflowDetail,
  ChangeRequest,
  ChangeRequestApproverSubjectData,
  ChangeRequestAsset,
  ChangeRequestAssetPlatform,
  ChangeRequestAssetPlatformDetail,
  ChangeRequestAssetScope,
  ChangeRequestAssetScopeDetail,
  ChangeRequestAssetsPageResult,
  ChangeRequestGroup,
  ChangeRequestPriority,
  ChangeRequestPriorityDetail,
  ChangeRequestScope,
  ChangeRequestScopeTarget,
  ChangeRequestSource,
  ChangeRequestSourceDetail,
  ChangeRequestsPageResult,
  ChangeRequestStatus,
  ChangeRequestStatusDetail,
  ChangeRequestToDo,
  ChangeRequestToDoType,
  ChangeRequestToDoTypeDetail,
  ChangeType,
  ChangeTypeDetail,
  CheckoutConfig,
  CheckoutConfigInteriorSubStep,
  CheckoutConfigOption,
  CheckoutConfigOptionGroup,
  CheckoutConfigOptionGroupStep,
  CheckoutConfigOptionGroupStepDetail,
  CheckoutConfigPackageOptionProduct,
  CheckoutConfigPackageOptionSlot,
  CheckoutConfigPotentialOption,
  CheckoutConfigsPage,
  CheckoutConfigStatus,
  CheckoutConfigStatusDetail,
  CheckoutPricingTrace,
  CheckoutPricingTraceOption,
  CheckoutPricingTraceOptionChange,
  CheckoutPricingTraceOptionGroup,
  Client,
  ClientPlatform,
  ClientPlatformDetail,
  CloneItemTemplateResult,
  CloneProjectCostAllocationsResult,
  Cohort,
  CohortLotSummaryChart,
  Comment,
  Commentable,
  CommentStream,
  CommentStreams,
  CommentStreamVisibility,
  CommentStreamVisibilityDetail,
  CommentTag,
  Commitment,
  CommitmentBillingScheduleItem,
  CommitmentBillingScheduleLineItem,
  CommitmentChangeOrder,
  CommitmentCostCodeSummary,
  CommitmentCostCodeSummaryLineItem,
  CommitmentDraw,
  CommitmentLike,
  CommitmentLineItem,
  CommitmentLineItemAllocation,
  CommitmentLineItemSummary,
  CommitmentsPage,
  CommitmentStatus,
  CommitmentStatusDetail,
  CommitmentType,
  CommitmentTypeDetail,
  CommunicationChannel,
  CommunicationChannelDetail,
  CommunitiesPageResult,
  Community,
  CommunityType,
  CommunityTypeDetail,
  CompanyInfo,
  ComputeProductOfferingConfigCostsResult,
  ComputeProductOfferingCostsAndPricesResponse,
  ComputeReadyPlanCostResult,
  ConfigCostsResult,
  ConstructionType,
  ConstructionTypeDetail,
  ContractProjectFinancials,
  ContractType,
  ContractTypeDetail,
  ConvertExpenseToBillResult,
  CopyDesignPackageCardsResult,
  CopyDesignPackageSelectionsResult,
  CopyItemTemplateItemsResult,
  CopyPlanBasedBidCostsResult,
  CopyTakeoffLineItemsResult,
  CostAccrualAdjustmentType,
  CostClassificationType,
  CostClassificationTypeDetail,
  CostCode,
  CostCodeAward,
  CostCodeBidSummariesPageResult,
  CostCodeBidSummary,
  CostCodeBidSummaryFlag,
  CostCodeBidSummaryFlagDetail,
  CostCodeBidSummaryReportFlagItem,
  CostCodeBidSummaryReportStatusItem,
  CostCodeBidSummaryStatus,
  CostCodeBidSummaryStatusDetail,
  CostCodeInvoiceCategory,
  CostCodeInvoiceCategoryDetail,
  CostConfidence,
  CostConfidenceDetail,
  CostConfigurationSummariesPage,
  CostConfigurationSummary,
  CostDivision,
  CostEstimate,
  CostLineItem,
  CostLineItemAllocation,
  CostLineItemEntity,
  CostMappingProgress,
  CostSubClassificationType,
  CostSubClassificationTypeDetail,
  CostType,
  CostTypeDetail,
  CreateAssetMultipartUploadUrlResult,
  CreateAssetResult,
  CreateAssetUploadUrlResult,
  CreateCommitmentFromBillResult,
  CreateDesignPackageAlternateLocationResult,
  CreateDesignPackagePlaceholderTliResult,
  CreateDocumentPendingUploadResult,
  CreateMaterialVariantsFromPayloadResult,
  CreateNewItemTemplateVersionsResult,
  Customer,
  CustomerItemConfig,
  CustomerOwnerEntity,
  DashboardConfig,
  DashboardTile,
  DashboardTileConfig,
  DashboardTileSize,
  DayOfWeek,
  DayOfWeekDetail,
  DeactivateUserResult,
  DeactivateUsersResult,
  DedupedItemTemplateItemVersion,
  DedupeReadyPlanItemTemplateItemVersionsResult,
  DeleteAttachmentResult,
  DeleteAuditEventResult,
  DeleteAuditEventsResult,
  DeleteBidContractLineItemResult,
  DeleteCommentResult,
  DeleteDevelopmentCommitmentProjectsAndCommitmentsResult,
  DeleteDocumentsResult,
  DeleteInvoiceScheduleResult,
  DeleteJobLogImageResult,
  DeleteJobLogNoteResult,
  DeleteMaterialVariantResult,
  DeletePandaDocResult,
  DeletePreConBudgetLineItemResult,
  DeleteReadyPlanAggregateVersionResult,
  DeleteReadyPlanOptionProgramDataModificationsResult,
  DeleteRequiredTaskDocumentResult,
  DeleteScheduleFlagResult,
  DeleteSchedulePhasesResult,
  DeleteScheduleSubPhasesResult,
  DeleteTradePartnerAgreementResult,
  DeleteTradePartnerContactResult,
  DeleteTradePartnerMarketContactResult,
  DesignPackage,
  DesignPackageCombination,
  DesignPackageFinishSchedulePageResult,
  DesignPackageLocation,
  DesignPackageLocationDetail,
  DesignPackageOptionCombination,
  DesignPackagePlanUpdate,
  DesignPackageSlot,
  DesignPackageSource,
  DesignPackageSourceVersion,
  DesignPackagesPageResult,
  DesignPackageVersion,
  Development,
  DevelopmentCommitment,
  DevelopmentCommitmentCostCodeSummary,
  DevelopmentCommitmentPotentialLineItem,
  DevelopmentCommitmentsPage,
  DevelopmentCommitmentSummary,
  DevelopmentCommitmentSummaryLineItem,
  DevelopmentCommitmentType,
  DevelopmentCommitmentTypeDetail,
  DevelopmentItemMapping,
  DevelopmentLotSummaryChartsResult,
  DevelopmentOption,
  DevelopmentTeamMember,
  Document,
  DocumentAttachmentPlace,
  DocumentAttachmentPlaceDetail,
  DocumentCategory,
  DocumentCategoryDetail,
  DocumentOwner,
  DocumentParent,
  DocumentsPageResult,
  DocumentType,
  DocumentTypeDetail,
  DraftScheduleResult,
  Drop,
  DuplicateJobLogsResult,
  DuplicateProjectItemsResult,
  DuplicateScheduleTemplateResult,
  EarnedValueCurve,
  EarnedValueDataPoint,
  EmptyResult,
  Entity,
  ErpAccountBillLineItem,
  ErpAccountBillLineItemErpSource,
  ErpAccrualLineItemSourceLine,
  ErpAccrualType,
  ErpAccrualTypeDetail,
  ErpRevenueLineItemSourceEvent,
  ErpRevenueLineItemSourceEventDetail,
  ErpTransactionGroupEvent,
  ErpTransactionGroupEventDetail,
  ErpTransactionGroupStatus,
  ErpTransactionGroupStatusDetail,
  ErpTransactionStatus,
  ErpTransactionStatusDetail,
  Estimate,
  EstimatedInvoiceScheduleItem,
  EstimateLineItem,
  EstimateStatus,
  EstimateStatusDetail,
  EstimateType,
  EstimateTypeDetail,
  Expense,
  ExpenseAllocation,
  ExpenseAllocationAllocation,
  ExpensesPage,
  ExportProjectBillsResult,
  FeatureFlag,
  FeatureFlagStatus,
  FeatureFlagStatusDetail,
  FeatureFlagTarget,
  FeatureFlagTargetTarget,
  FeatureFlagType,
  FeatureFlagTypeDetail,
  FeatureType,
  FinishScheduleColumnType,
  FinishScheduleColumnTypeDetail,
  FinishScheduleConfig,
  FinishScheduleCoreColumn,
  FinishScheduleCoreColumnDetail,
  FloodPlain,
  FloodPlainDetail,
  FloodZone,
  FloodZoneDetail,
  Followable,
  FollowSequenceSheetResult,
  ForceScalePlanMilestoneTargetsResult,
  FoundationType,
  FoundationTypeDetail,
  GenerateReadyPlanVersionNotesResult,
  GlobalOption,
  GlobalOptionGroup,
  GlobalOptionStatus,
  GlobalOptionStatusDetail,
  GlobalOptionTag,
  GlobalOptionType,
  GlobalOptionTypeStatus,
  GlobalOptionTypeStatusDetail,
  GlobalPhase,
  GlobalPlanAllowance,
  GlobalPlanConstraint,
  GlobalPlanConstraintItem,
  GlobalPlanMilestone,
  GlobalPlanMilestoneGroup,
  GlobalPlanMilestonesPageResult,
  GlobalPlanMilestoneType,
  GlobalPlanMilestoneTypeDetail,
  GlobalPlanStage,
  GlobalPlanStageVariant,
  GlobalPlanTag,
  GlobalPlanTask,
  GlobalPlanTaskChecklistItem,
  GlobalPlanTaskScope,
  GlobalPlanTasksPageResult,
  GlobalPlanTaskVariant,
  GlobalRequiredTaskDocument,
  GlobalSearchRecord,
  GlobalSearchRecordParent,
  GlobalSearchResult,
  GlobalSubPhase,
  GlobalTask,
  HasBlueprintUrl,
  HasDisplayName,
  History,
  HomeboundHoliday,
  Homeowner,
  HomeownerContract,
  HomeownerContractChangeOrder,
  HomeownerContractDraw,
  HomeownerContractLike,
  HomeownerContractLineItem,
  HomeownerContractLineItemAllocation,
  HomeownerContractLineItemsByProjectItem,
  HomeownerNote,
  HomeownersPage,
  IdentifyProjectAccrualAdjustmentsResult,
  InboxItemStatus,
  InboxItemStatusDetail,
  IncomingChanges,
  InsideMapsCamera,
  InsideMapsCameraTextureSwaps,
  InsideMapsDebugSlot,
  InsideMapsRoomRendering,
  InsideMapsSlotAuditResult,
  InsideMapsSlotDiffResult,
  InsideMapsTextureSwap,
  InsideMapsTextureSwaps,
  InteriorRoomRendering,
  InternalEstimateType,
  InternalEstimateTypeDetail,
  InternalUser,
  Invoice,
  InvoiceAccruedLineItem,
  InvoiceDisplayLineItem,
  InvoiceDocument,
  InvoiceDocumentSource,
  InvoiceDocumentSourceDetail,
  InvoiceDrawLineItem,
  InvoiceLineItem,
  InvoiceLineItemsByCostCode,
  InvoiceParent,
  InvoiceSchedule,
  InvoiceScheduleAmountType,
  InvoiceScheduleAmountTypeDetail,
  InvoiceScheduledLineItem,
  InvoiceScheduleItem,
  InvoiceScheduleItemFrequency,
  InvoiceScheduleItemFrequencyDetail,
  InvoiceScheduleItemGlobalParent,
  InvoiceScheduleItemParent,
  InvoiceScheduleTemplate,
  InvoiceScheduleTemplateItem,
  InvoiceScheduleTriggerType,
  InvoiceScheduleTriggerTypeDetail,
  InvoiceSource,
  InvoiceSourceDetail,
  InvoicesPage,
  InvoiceStatus,
  InvoiceStatusDetail,
  InvoiceType,
  InvoiceTypeDetail,
  Item,
  ItemPlanTaskMapping,
  ItemPlanTaskMappingPage,
  ItemSlot,
  ItemStatus,
  ItemStatusDetail,
  ItemTemplate,
  ItemTemplateAnomaly,
  ItemTemplateAnomalyParent,
  ItemTemplateAnomalyType,
  ItemTemplateCollection,
  ItemTemplateCostUpdate,
  ItemTemplateItem,
  ItemTemplateItemCostStatus,
  ItemTemplateItemCostStatusDetail,
  ItemTemplateItemPlan,
  ItemTemplateItemVersion,
  ItemTemplateItemVersionGroupTotal,
  ItemTemplateItemVersionsPage,
  ItemTemplateStatus,
  ItemTemplateStatusDetail,
  ItiAnomaly,
  JobLog,
  JobLogFlag,
  JobLogFlagDetail,
  JobLogImage,
  JobLogImageParent,
  JobLogNote,
  JobLogNoteType,
  JobLogNoteTypeDetail,
  JobLogsPageResult,
  LienWaiver,
  LienWaiverClaimant,
  LienWaiverCondition,
  LienWaiverConditionDetail,
  LienWaiverOwner,
  LienWaiverParent,
  LienWaiverPayer,
  LienWaiverSignatory,
  LienWaiversPage,
  LienWaiverStatus,
  LienWaiverStatusDetail,
  LienWaiverType,
  LienWaiverTypeDetail,
  Location,
  LocationType,
  LocationTypeDetail,
  Lot,
  LotRating,
  LotSalesStatus,
  LotSalesStatusDetail,
  LotType,
  LotTypeDetail,
  MarkDocumentAsUploadedResult,
  Market,
  MarketContactWithRoles,
  MarkupApplicationMethod,
  MarkupApplicationMethodDetail,
  MaterialAssemblyComponent,
  MaterialAttributeDimension,
  MaterialAttributeDimensionType,
  MaterialAttributeDimensionTypeDetail,
  MaterialAttributeValue,
  MaterialAttributeValueType,
  MaterialAttributeValueTypeDetail,
  MaterialBrand,
  MaterialCostSource,
  MaterialImportAiProposal,
  MaterialLeadTimeConfig,
  MaterialLeadTimeConfigParent,
  MaterialLeadTimeConfigVariant,
  MaterialListing,
  MaterialListingsPage,
  MaterialType,
  MaterialTypeDetail,
  MaterialVariant,
  MaterialVariantCostSourcesPage,
  MaterialVariantImage,
  MaterialVariantMerge,
  MaterialVariantMergesPage,
  MaterialVariantsPage,
  MaterialVariantTag,
  Maybe,
  MergeMaterialListingsResult,
  MergeMaterialVariantsResult,
  MergeReadyPlanOptionsResult,
  MermaidResult,
  MigrateBidPackageCostsResult,
  MigrateMaterialListingItemResult,
  MissingBidPlanOption,
  MobileSyncUpdate,
  MobileSyncUpdatesPageResult,
  MobileSyncUpdateType,
  MobileSyncUpdateTypeDetail,
  MoveScheduleSubPhasesResult,
  MultipartPartUploadUrl,
  NewProgramData,
  OptionPricingConfig,
  OptionPricingConfigParent,
  OptionPricingConfigVariant,
  OptionToUpdate,
  OptionWithCutoffDate,
  OverlappingBidPackagesResult,
  Page,
  PageInfo,
  PandaDoc,
  PandaDocIntendedRecipient,
  PandaDocOwner,
  PandaDocRecipient,
  PandaDocRole,
  PandaDocRoleDetail,
  PandaDocSession,
  PandaDocStatus,
  PandaDocStatusDetail,
  PandaDocWorkspace,
  PandaDocWorkspaceDetail,
  PaymentTerm,
  PaymentTermDueFrom,
  PaymentTermDueFromDetail,
  Permissions,
  Permit,
  PermitDetail,
  PlaceholderCombinationsResult,
  PlanBasedBidContractLineItem,
  PlanMilestone,
  PlanMilestoneSnapshot,
  PlanMilestonesResult,
  PlanMilestoneTarget,
  PlanPackage,
  PlanPackageAiProposal,
  PlanPackageIncomingSlot,
  PlanPackageIncomingSlotStatus,
  PlanPackageIncomingSlotStatusDetail,
  PlanPackageSlotDeletionRequest,
  PlanPackagesPageResult,
  PlanPackageVersion,
  PlanSchedule,
  PlanScheduleParent,
  PlanScheduleSnapshotsResult,
  PlanTask,
  PlanTaskChecklistItem,
  PlanTasksResult,
  PotentialBidContractLineItem,
  PotentialBidContractRevision,
  PotentialBidPlanDimensionKind,
  PotentialBidPlanDimensionResult,
  PotentialBidPlanOption,
  PotentialDateBasisPoints,
  PotentialOperation,
  PotentialOperation2,
  PotentialProjectItem,
  PreConBudgetCostCodeLineItem,
  PreConBudgetCostDivisionLineItem,
  PreconContractType,
  PreviewSaveBidPackageResult,
  ProductOffering,
  ProductOfferingConfig,
  ProductOfferingConfigsPage,
  ProductOfferingIncomingUpdate,
  ProductOfferingIncomingUpdateSource,
  ProductOfferingInfo,
  ProductOfferingsPageResult,
  ProductOfferingStartingConfig,
  ProductOfferingStartingConfigsPage,
  ProductOfferingStartingConfigType,
  ProductOfferingStartingConfigTypeDetail,
  ProductOfferingVersion,
  ProductType,
  ProgramData,
  ProgramDataBasementConfig,
  ProgramDataBasementConfigDetail,
  ProgramDataGarageConfig,
  ProgramDataGarageConfigDetail,
  ProgramDataMatchState,
  ProgramDataMatchStateDetail,
  ProgramDataPrimaryBedroomConfig,
  ProgramDataPrimaryBedroomConfigDetail,
  ProgramDataWindowColor,
  ProgramDataWindowColorDetail,
  ProgressSummary,
  ProgressSummaryStatus,
  Project,
  ProjectAllocationRule,
  ProjectBudgetFinancials,
  ProjectChangeEventGraph,
  ProjectChangeEventGraphData,
  ProjectChangeEventGraphsResult,
  ProjectChangeEventGraphType,
  ProjectCollaborator,
  ProjectCollaboratorRole,
  ProjectCollaboratorRoleDetail,
  ProjectCompletedTaskBudgetReview,
  ProjectContact,
  ProjectCostCode,
  ProjectCostCodeBidSummaryReport,
  ProjectCostCodesPageResult,
  ProjectDictionary,
  ProjectDirectMarginGraph,
  ProjectDirectMarginGraphData,
  ProjectDirectMarginGraphResolution,
  ProjectDocumentAssociation,
  ProjectFeature,
  ProjectFeatureDetail,
  ProjectInvoiceSetting,
  ProjectItem,
  ProjectItemAllocation,
  ProjectItemBudgetFinancials,
  ProjectItemScopeChange,
  ProjectItemsPage,
  ProjectJobLogInsights,
  ProjectLotDetail,
  ProjectReadyPlanConfig,
  ProjectReadyPlanConfigOption,
  ProjectReadyPlanConfigOrientation,
  ProjectReadyPlanConfigOrientationDetail,
  ProjectReadyPlanConfigPotentialOption,
  ProjectReadyPlanConfigPotentialOptionGroup,
  ProjectRole,
  ProjectRoleDetail,
  ProjectSalesforceOpportunity,
  ProjectSiteCondition,
  ProjectSiteSpecificInfo,
  ProjectSnapshot,
  ProjectsPageResult,
  ProjectStage,
  ProjectStageHocFinancials,
  ProjectStageHomeownerFinancials,
  ProjectStageStatus,
  ProjectStageStatusDetail,
  ProjectStageTemplateConfig,
  ProjectStatus,
  ProjectStatusChange,
  ProjectStatusChangeReason,
  ProjectStatusDetail,
  ProjectsToUpdateByTemplatesResult,
  ProjectTeamMember,
  ProjectToUpdate,
  ProjectUpdate,
  ProjectUpdateActionType,
  ProjectUpdateActionTypeDetail,
  ProtoBill,
  ProtoBillLineItem,
  ProtoCommitmentLineItemToBuyout,
  ProtoProjectItem,
  PunchlistItemTodo,
  PushNotificationEnvironment,
  PushNotificationEnvironmentDetail,
  PushNotificationPlatform,
  PushNotificationPlatformDetail,
  PushNotificationToken,
  ReadyPlan,
  ReadyPlanAggregateVersion,
  ReadyPlanAggregateVersionsPageResult,
  ReadyPlanAsset,
  ReadyPlanAssetParent,
  ReadyPlanAssetType,
  ReadyPlanAssetTypeDetail,
  ReadyPlanAssetVersion,
  ReadyPlanDesignNote,
  ReadyPlanDesignNoteVersion,
  ReadyPlanDesignPackage,
  ReadyPlanDesignPackageVersion,
  ReadyPlanDocumentVersion,
  ReadyPlanLike,
  ReadyPlanLocation,
  ReadyPlanLocationVersion,
  ReadyPlanOption,
  ReadyPlanOptionConfigCosts,
  ReadyPlanOptionCostAndPriceDelta,
  ReadyPlanOptionCostDelta,
  ReadyPlanOptionGroup,
  ReadyPlanOptionGroupPersonalizationType,
  ReadyPlanOptionGroupPersonalizationTypeDetail,
  ReadyPlanOptionGroupRequiredWhen,
  ReadyPlanOptionGroupVersion,
  ReadyPlanOptionProgramDataModification,
  ReadyPlanOptionVersion,
  ReadyPlanProgramData,
  ReadyPlanProgramDataVersion,
  ReadyPlanRequiredOption,
  ReadyPlanRequiredOptionVersion,
  ReadyPlanStatus,
  ReadyPlanStatusDetail,
  ReadyPlanType,
  ReadyPlanTypeDetail,
  ReadyPlanVersion,
  Reason,
  Referencable,
  Reference,
  Region,
  RegisterPushNotificationTokenResult,
  RelevantProjectBidPackage,
  RenderingAsset,
  ReplaceGlobalSubPhaseResult,
  RequiredTaskDocument,
  ResetScheduleBaselinesResult,
  ResolveAiFieldProposalsResult,
  ResultingDelay,
  ResyncPreconProjectItemCostResult,
  ReviseBidPackageCostsResult,
  RoomType,
  RunBillParserResult,
  RunCheckoutPricingReportResult,
  SaveApprovalResult,
  SaveApprovalsResult,
  SaveApproverResult,
  SaveApproversResult,
  SaveAttachmentResult,
  SaveBidContractLineItemResult,
  SaveBidContractLineItemsResult,
  SaveBidContractResult,
  SaveBidContractRevisionResult,
  SaveBidContractTradeLineItemsResult,
  SaveBidItemEstimateResult,
  SaveBidItemResult,
  SaveBidPackageAwardsResult,
  SaveBidPackageRequestResult,
  SaveBidPackageResult,
  SaveBidPackagesResult,
  SaveBillResult,
  SaveBillsResult,
  SaveBuilderResult,
  SaveBusinessFunctionResult,
  SaveChangeEventLineItemsResult,
  SaveChangeEventReasonResult,
  SaveChangeEventResult,
  SaveChangeEventsResult,
  SaveChangeRequestAssetsResult,
  SaveChangeRequestGroupResult,
  SaveChangeRequestGroupsResult,
  SaveChangeRequestResult,
  SaveChangeRequestsResult,
  SaveCheckoutConfigResult,
  SaveCohortsResult,
  SaveCommentResult,
  SaveCommitmentChangeOrderResult,
  SaveCommitmentResult,
  SaveCommitmentsResult,
  SaveCommunityResult,
  SaveCostCodesResult,
  SaveCostDivisionsResult,
  SaveCustomerItemConfigResult,
  SaveCustomerOwnerEntityResult,
  SaveCustomerResult,
  SaveDesignPackageLocationPlanMappingsResult,
  SaveDesignPackageResult,
  SaveDesignPackageSourceResult,
  SaveDesignPackageUpdatesResult,
  SaveDevelopmentCommitmentResult,
  SaveDevelopmentOptionsResult,
  SaveDevelopmentsResult,
  SaveDocumentsResult,
  SaveDropResult,
  SaveEstimateResult,
  SaveExpenseAllocationsResult,
  SaveExpensesResult,
  SaveFeatureFlagResult,
  SaveFeatureFlagTargetResult,
  SaveFeatureTypeResult,
  SaveFollowersResult,
  SaveGlobalOptionGroupResult,
  SaveGlobalOptionsResult,
  SaveGlobalOptionTagsResult,
  SaveGlobalOptionTypesResult,
  SaveGlobalPhasesResult,
  SaveGlobalPlanConstraintItemResult,
  SaveGlobalPlanConstraintItemsResult,
  SaveGlobalPlanMilestoneGroupResult,
  SaveGlobalPlanMilestoneResult,
  SaveGlobalPlanMilestonesResult,
  SaveGlobalPlanStageResult,
  SaveGlobalPlanStageVariantsResult,
  SaveGlobalPlanTagResult,
  SaveGlobalPlanTaskResult,
  SaveGlobalPlanTasksResult,
  SaveGlobalRequiredTaskDocumentResult,
  SaveGlobalSubPhasesResult,
  SaveGlobalTasksResult,
  SaveHomeboundHolidayResult,
  SaveHomeownerContractChangeOrderResult,
  SaveHomeownerContractResult,
  SaveHomeownerNoteResult,
  SaveHomeownerResult,
  SaveInternalUserResult,
  SaveInvoiceDocumentResult,
  SaveInvoiceResult,
  SaveInvoiceScheduleTemplateResult,
  SaveInvoicesResult,
  SaveItemPlanTaskMappingResult,
  SaveItemSlotResult,
  SaveItemTemplateItemVersionsResult,
  SaveItemTemplateResult,
  SaveItemTemplatesResult,
  SaveJobLogImageResult,
  SaveJobLogNoteResult,
  SaveJobLogResult,
  SaveLienWaiverResult,
  SaveLocationsResult,
  SaveLotRatingResult,
  SaveLotResult,
  SaveMarketResult,
  SaveMaterialAssemblyComponentResult,
  SaveMaterialAttributeDimensionResult,
  SaveMaterialAttributeDimensionResults,
  SaveMaterialAttributeValueResult,
  SaveMaterialBrandResult,
  SaveMaterialLeadTimeConfigResult,
  SaveMaterialVariantResult,
  SaveMaterialVariantTagResult,
  SaveOptionPricingConfigsResult,
  SavePandaDocResult,
  SavePaymentTermResult,
  SavePersonalizationOptionGroupResult,
  SavePlanPackageResult,
  SavePlanScheduleResult,
  SavePlanTaskChecklistItemResult,
  SavePlanTaskResult,
  SavePreConBudgetLineItemResult,
  SavePreconContractTypeResult,
  SaveProductOfferingConfigResult,
  SaveProductOfferingResult,
  SaveProductOfferingStartingConfigResult,
  SaveProductTypeResult,
  SaveProjectAllocationRuleResult,
  SaveProjectContactResult,
  SaveProjectInvoiceSettingResult,
  SaveProjectItemsResult,
  SaveProjectLotDetailsResult,
  SaveProjectReadyPlanConfigOptionsResult,
  SaveProjectReadyPlanConfigsResult,
  SaveProjectResult,
  SaveProjectSiteConditionResult,
  SaveProjectSiteSpecificInfoResult,
  SaveProjectStatusChangeReasonsResult,
  SavePunchlistItemTodoResult,
  SavePunchlistItemTodosResult,
  SaveReadyPlanAggregateVersionResult,
  SaveReadyPlanDesignNoteResult,
  SaveReadyPlanLocationBulkResult,
  SaveReadyPlanOptionGroupResult,
  SaveReadyPlanOptionGroupsResult,
  SaveReadyPlanOptionProgramDataModificationsResult,
  SaveReadyPlanOptionsResult,
  SaveReadyPlanRequiredOptionsResult,
  SaveReadyPlanResult,
  SaveReadyPlansResult,
  SaveReferencesResult,
  SaveRegionResult,
  SaveRequiredTaskDocumentResult,
  SaveRoomTypeResult,
  SaveScheduleFlagReasonsResult,
  SaveScheduleFlagResult,
  SaveSchedulePhasesResult,
  SaveScheduleResult,
  SaveScheduleSettingsResult,
  SaveScheduleSubPhasesResult,
  SaveScheduleTaskChecklistItemResult,
  SaveScheduleTasksResult,
  SaveScheduleTemplateItemMappingsResult,
  SaveScheduleTemplatesResult,
  SaveScopeChangeReasonResult,
  SaveSiteSpecificInfoResult,
  SaveStructureResult,
  SaveSubdivisionResult,
  SaveSubmarketResult,
  SaveTakeoffLineItemResult,
  SaveTaskWorkDayResult,
  SaveToDoChecklistItemResult,
  SaveToDosResult,
  SaveTradeCategoryLeadTimesResult,
  SaveTradeCategoryResult,
  SaveTradePartnerAgreementResult,
  SaveTradePartnerAvailabilityRequestResult,
  SaveTradePartnerAvailabilityRequestsResult,
  SaveTradePartnerContactResult,
  SaveTradePartnerMarketContactResult,
  SaveTradePartnerRequirementResult,
  SaveTradePartnerResult,
  SaveTradePartnerReviewResult,
  SaveTradePartnersResult,
  SaveUnitResult,
  SaveUnitsOfMeasureResult,
  SaveUserCommunicationPreferenceResult,
  SaveUserGroupResult,
  SaveUserResult,
  SaveWarrantyTicketItemResult,
  SaveWarrantyTicketItemsResult,
  SaveWarrantyTicketResult,
  SaveWorkAuthorizationResult,
  Schedule,
  ScheduleEntity,
  ScheduleFlag,
  ScheduleFlagImpact,
  ScheduleFlagImpactImpacted,
  ScheduleFlagReason,
  ScheduleFlagReasonType,
  ScheduleFlagReasonTypeDetail,
  ScheduleLike,
  ScheduleParent,
  SchedulePhase,
  SchedulePhaseProgress,
  ScheduleSetting,
  SchedulesResult,
  ScheduleStatus,
  ScheduleStatusDetail,
  ScheduleSubPhase,
  ScheduleSubPhaseProgress,
  ScheduleTask,
  ScheduleTaskChecklistItem,
  ScheduleTaskDependency,
  ScheduleTemplate,
  ScheduleTemplateItemMapping,
  ScheduleTemplateStatus,
  ScheduleTemplateStatusDetail,
  SchedulingExclusionDate,
  SchedulingExclusionDateParent,
  ScopeChangeReason,
  ScopeChangeType,
  ScopeChangeTypeDetail,
  ScopeGlobalOptionGroupsToReadyPlansResult,
  ScopeMode,
  ScopeModeDetail,
  SelectionCutoff,
  SelectionCutoffDetail,
  SendInviteEmailResult,
  SendPunchlistExportEmailFailure,
  SendPunchlistExportEmailResult,
  SendPunchlistExportEmailResults,
  SendPunchlistExportEmailSuccess,
  SendTradePartnerPunchlistEmailFailure,
  SendTradePartnerPunchlistEmailResult,
  SendTradePartnerPunchlistEmailResults,
  SendTradePartnerPunchlistEmailSuccess,
  SimulationProbability,
  SiteSpecificInfo,
  Stage,
  StageDetail,
  StageProgress,
  StandaloneProject,
  Structure,
  StructuresPageResult,
  Subdivision,
  Submarket,
  SuburbanAssetCategory,
  SuburbanAssetCategoryDetail,
  SystemChangeRequestAsset,
  SystemChangeRequestAssetDetail,
  SystemPlanMilestone,
  SystemPlanMilestoneDetail,
  SystemTask,
  SystemTaskDetail,
  TakeoffLineItem,
  TakeoffLineItemAction,
  TakeoffLineItemActionDetail,
  TakeoffLineItemDesignPackageType,
  TakeoffLineItemDesignPackageTypeDetail,
  TakeoffLineItemGroupTotal,
  TakeoffLineItemsPage,
  TakeoffLineItemType,
  TakeoffLineItemTypeDetail,
  TakeoffLineItemVersion,
  Task,
  TaskDeadlineType,
  TaskDeadlineTypeDetail,
  TaskDependency,
  TaskDependencyType,
  TaskDependencyTypeDetail,
  TaskPage,
  TaskPurchaseOrderRow,
  TaskSchedulingStatus,
  TaskSnapshot,
  TaskStatus,
  TaskStatusDetail,
  TaskType,
  TaskTypeDetail,
  TaskWorkDay,
  TestMutationResult,
  TimeFrequency,
  TimeFrequencyDetail,
  TimeOfDay,
  TimeOfDayDetail,
  TlivChangeSummary,
  TlivLocationCount,
  ToDo,
  ToDoChecklistItem,
  ToDoChecklistProgress,
  ToDoParent,
  ToDoStatus,
  ToDoStatusDetail,
  ToDoType,
  ToDoTypeDetail,
  ToggleDocumentAsFavoritedResult,
  TrackedJob,
  TrackedJobParent,
  TrackedJobResult,
  TrackedJobStatus,
  TrackedJobStatusDetail,
  TradeCategory,
  TradeCategoryLeadTime,
  TradeCategoryLeadTimeDefault,
  TradePartner,
  TradePartnerAgreement,
  TradePartnerAvailabilityRequest,
  TradePartnerAvailabilityRequestEmail,
  TradePartnerAvailabilityRequestEmailPreview,
  TradePartnerAvailabilityRequestStatus,
  TradePartnerAvailabilityRequestStatusDetail,
  TradePartnerAvailabilityRequestTextMessage,
  TradePartnerContact,
  TradePartnerMailingList,
  TradePartnerMarketContact,
  TradePartnerMarketRole,
  TradePartnerMarketRoleDetail,
  TradePartnerOnboardingStatus,
  TradePartnerOnboardingStatusDetail,
  TradePartnerRequirement,
  TradePartnerRequirementStatus,
  TradePartnerRequirementStatusDetail,
  TradePartnerRequirementType,
  TradePartnerRequirementTypeDetail,
  TradePartnerReview,
  TradePartnersPage,
  TradePartnerTaskStatus,
  TradePartnerTaskStatusDetail,
  TradePartnerUser,
  TriggerQaDatabaseResetResult,
  Unit,
  UnitOfMeasure,
  UpdateProjectRoleResult,
  UploadMaterialVariantResult,
  UploadMaterialVariantsResult,
  UploadPandaDocResult,
  Url,
  User,
  UserCommunicationPreference,
  UserError,
  UserEvent,
  UserEventParent,
  UserEventParentType,
  UserEventType,
  UserEventTypeDetail,
  UserGroup,
  UserRelevantCommentStreamsResult,
  UserType,
  UserTypeDetail,
  VerificationMethod,
  VerificationMethodDetail,
  WarrantyTicket,
  WarrantyTicketAvailability,
  WarrantyTicketItem,
  WarrantyTicketItemStatus,
  WarrantyTicketItemStatusDetail,
  WarrantyTicketItemType,
  WarrantyTicketItemTypeDetail,
  WarrantyTicketsPage,
  WarrantyTicketStatus,
  WarrantyTicketStatusDetail,
  WarrantyTicketType,
  WarrantyTicketTypeDetail,
  WarrantyTrueUpType,
  WarrantyTrueUpTypeDetail,
  WeatherType,
  WeatherTypeDetail,
  WorkAuthorization,
} from "./graphqlTypes";

const factories: Record<string, Function> = {};
export interface FactoryOptions {
  avoidCycles?: boolean;
}
type RequireTypename<T extends { __typename?: string }> = Omit<T, "__typename"> & Required<Pick<T, "__typename">>;
/**
 * Mirrors factory runtime behavior by requiring __typename on factory-created object results.
 *
 * GraphQL Codegen's base schema types correctly keep __typename optional because raw GraphQL
 * objects only include it when an operation selects it or a client adds it. Operation and
 * fragment result types can require __typename when it is selected. Factory results are a
 * separate case: these factories always assign __typename recursively at runtime, so their
 * public return type should expose that stronger shape without changing the base schema types.
 */
type FactoryResult<T> = T extends ReadonlyArray<infer U> ? Array<FactoryResult<U>>
  : T extends object
    ? "__typename" extends keyof T
      ? T & Omit<{ [K in keyof T]: FactoryResult<T[K]> }, "__typename"> & {
        __typename: NonNullable<T extends { __typename?: infer N } ? N : never>;
      }
    : T
  : T;

type FactoryInput<T, TOptions> = T | FactoryResult<T> | TOptions;
type FactoryCache = Record<string, any> & { active?: Set<object>; all?: Set<object>; avoidCycles?: boolean };
export interface ScheduleTaskOptions {
  __typename?: "ScheduleTask";
  kind?: ScheduleTask["kind"];
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ScheduleTask["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ScheduleTask["isFollowed"];
  id?: ScheduleTask["id"];
  globalPhase?: FactoryInput<GlobalPhase, GlobalPhaseOptions> | null;
  globalSubPhase?: FactoryInput<GlobalSubPhase, GlobalSubPhaseOptions> | null;
  schedulePhase?: FactoryInput<SchedulePhase, SchedulePhaseOptions> | null;
  scheduleSubPhase?: FactoryInput<ScheduleSubPhase, ScheduleSubPhaseOptions> | null;
  schedule?: FactoryInput<Schedule, ScheduleOptions>;
  parent?:
    | ScheduleParent
    | FactoryResult<ScheduleParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  name?: ScheduleTask["name"];
  status?: ScheduleTask["status"];
  statusDetail?: TaskStatusDetailOptions | TaskStatus;
  schedulingStatus?: ScheduleTask["schedulingStatus"];
  homeownerVisible?: ScheduleTask["homeownerVisible"];
  homeownerDescription?: ScheduleTask["homeownerDescription"];
  interval?: FactoryInput<CalendarInterval, CalendarIntervalOptions>;
  baselineInterval?: FactoryInput<CalendarInterval, CalendarIntervalOptions>;
  baselineInterval2?: FactoryInput<CalendarInterval2, CalendarInterval2Options> | null;
  completedAt?: ScheduleTask["completedAt"];
  startDate?: ScheduleTask["startDate"];
  assignee?: FactoryInput<InternalUser, InternalUserOptions> | null;
  internalNote?: ScheduleTask["internalNote"];
  slackInDays?: ScheduleTask["slackInDays"];
  aheadOrBehindInDays?: ScheduleTask["aheadOrBehindInDays"];
  isStale?: ScheduleTask["isStale"];
  isCriticalPath?: ScheduleTask["isCriticalPath"];
  predecessors?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  successors?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  predecessorDependencies?: Array<FactoryInput<ScheduleTaskDependency, ScheduleTaskDependencyOptions>>;
  successorDependencies?: Array<FactoryInput<ScheduleTaskDependency, ScheduleTaskDependencyOptions>>;
  homeownerContractDraws?: Array<FactoryInput<HomeownerContractDraw, HomeownerContractDrawOptions>>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  salesforceId?: ScheduleTask["salesforceId"];
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  canEditStartDate?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditEndDate?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditDuration?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canComplete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canStart?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canSetTraderPartner?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
  deadlineType?: ScheduleTask["deadlineType"];
  templateProjectRole?: ScheduleTask["templateProjectRole"];
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  globalTask?: FactoryInput<GlobalTask, GlobalTaskOptions> | null;
  isGlobalMilestoneTask?: ScheduleTask["isGlobalMilestoneTask"];
  sortOrder?: ScheduleTask["sortOrder"];
  requiredTaskDocuments?: Array<FactoryInput<RequiredTaskDocument, RequiredTaskDocumentOptions>>;
  history?: Array<FactoryInput<History, HistoryOptions>>;
  scheduleTaskChecklistItems?: Array<FactoryInput<ScheduleTaskChecklistItem, ScheduleTaskChecklistItemOptions>>;
  scheduleFlags?: Array<FactoryInput<ScheduleFlag, ScheduleFlagOptions>>;
  jobLogNotes?: Array<FactoryInput<JobLogNote, JobLogNoteOptions>>;
  tradePartnerIsScheduled?: ScheduleTask["tradePartnerIsScheduled"];
  checklistComplete?: ScheduleTask["checklistComplete"];
  hasScheduleFlags?: ScheduleTask["hasScheduleFlags"];
  systemTask?: ScheduleTask["systemTask"];
  bills?: Array<FactoryInput<Bill, BillOptions>>;
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  committedTradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  billLineItems?: Array<FactoryInput<BillLineItem, BillLineItemOptions>>;
  defaultedHomeownerDescription?: ScheduleTask["defaultedHomeownerDescription"];
  templateTask?: FactoryInput<Task, TaskOptions> | null;
  tradePartnerStatus?: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus;
  tradePartnerAvailabilityRequests?:
    | Array<FactoryInput<TradePartnerAvailabilityRequest, TradePartnerAvailabilityRequestOptions>>
    | null;
  protoBills?: Array<FactoryInput<ProtoBill, ProtoBillOptions>>;
  type?: TaskTypeDetailOptions | TaskType;
  workDays?: Array<FactoryInput<TaskWorkDay, TaskWorkDayOptions>>;
  commitmentDraws?: Array<FactoryInput<CommitmentDraw, CommitmentDrawOptions>>;
}

export function newScheduleTask(
  options?: ScheduleTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTask>;
export function newScheduleTask(
  options: ScheduleTaskOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleTask> {
  const o = (options.__typename ? options : cache["ScheduleTask"] = {}) as ScheduleTask;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleTask";
    o.kind = options.kind ?? "kind";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("ScheduleTask");
    o.globalPhase = maybeNewOrNull("GlobalPhase", options.globalPhase, cache);
    o.globalSubPhase = maybeNewOrNull("GlobalSubPhase", options.globalSubPhase, cache);
    o.schedulePhase = maybeNewOrNull("SchedulePhase", options.schedulePhase, cache);
    o.scheduleSubPhase = maybeNewOrNull("ScheduleSubPhase", options.scheduleSubPhase, cache);
    o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
    o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.name = options.name ?? "name";
    o.status = options.status ?? TaskStatus.NotStarted;
    o.statusDetail = enumOrDetailOfTaskStatus(options.statusDetail);
    o.schedulingStatus = options.schedulingStatus ?? TaskSchedulingStatus.Stale;
    o.homeownerVisible = options.homeownerVisible ?? false;
    o.homeownerDescription = options.homeownerDescription ?? null;
    o.interval = maybeNew("CalendarInterval", options.interval, cache, options.hasOwnProperty("interval"));
    o.baselineInterval = maybeNew(
      "CalendarInterval",
      options.baselineInterval,
      cache,
      options.hasOwnProperty("baselineInterval"),
    );
    o.baselineInterval2 = maybeNewOrNull("CalendarInterval2", options.baselineInterval2, cache);
    o.completedAt = options.completedAt ?? null;
    o.startDate = options.startDate ?? null;
    o.assignee = maybeNewOrNull("InternalUser", options.assignee, cache);
    o.internalNote = options.internalNote ?? null;
    o.slackInDays = options.slackInDays ?? null;
    o.aheadOrBehindInDays = options.aheadOrBehindInDays ?? null;
    o.isStale = options.isStale ?? false;
    o.isCriticalPath = options.isCriticalPath ?? false;
    o.predecessors = (options.predecessors ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("predecessors"))
    );
    o.successors = (options.successors ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("successors"))
    );
    o.predecessorDependencies = (options.predecessorDependencies ?? []).map((i) =>
      maybeNew("ScheduleTaskDependency", i, cache, options.hasOwnProperty("predecessorDependencies"))
    );
    o.successorDependencies = (options.successorDependencies ?? []).map((i) =>
      maybeNew("ScheduleTaskDependency", i, cache, options.hasOwnProperty("successorDependencies"))
    );
    o.homeownerContractDraws = (options.homeownerContractDraws ?? []).map((i) =>
      maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("homeownerContractDraws"))
    );
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.salesforceId = options.salesforceId ?? null;
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.canEditStartDate = maybeNew(
      "PotentialOperation2",
      options.canEditStartDate,
      cache,
      options.hasOwnProperty("canEditStartDate"),
    );
    o.canEditEndDate = maybeNew(
      "PotentialOperation2",
      options.canEditEndDate,
      cache,
      options.hasOwnProperty("canEditEndDate"),
    );
    o.canEditDuration = maybeNew(
      "PotentialOperation2",
      options.canEditDuration,
      cache,
      options.hasOwnProperty("canEditDuration"),
    );
    o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
    o.canStart = maybeNew("PotentialOperation2", options.canStart, cache, options.hasOwnProperty("canStart"));
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.canSetTraderPartner = maybeNew(
      "PotentialOperation2",
      options.canSetTraderPartner,
      cache,
      options.hasOwnProperty("canSetTraderPartner"),
    );
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    o.deadlineType = options.deadlineType ?? null;
    o.templateProjectRole = options.templateProjectRole ?? null;
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.globalTask = maybeNewOrNull("GlobalTask", options.globalTask, cache);
    o.isGlobalMilestoneTask = options.isGlobalMilestoneTask ?? false;
    o.sortOrder = options.sortOrder ?? 0;
    o.requiredTaskDocuments = (options.requiredTaskDocuments ?? []).map((i) =>
      maybeNew("RequiredTaskDocument", i, cache, options.hasOwnProperty("requiredTaskDocuments"))
    );
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.scheduleTaskChecklistItems = (options.scheduleTaskChecklistItems ?? []).map((i) =>
      maybeNew("ScheduleTaskChecklistItem", i, cache, options.hasOwnProperty("scheduleTaskChecklistItems"))
    );
    o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
      maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
    );
    o.jobLogNotes = (options.jobLogNotes ?? []).map((i) =>
      maybeNew("JobLogNote", i, cache, options.hasOwnProperty("jobLogNotes"))
    );
    o.tradePartnerIsScheduled = options.tradePartnerIsScheduled ?? null;
    o.checklistComplete = options.checklistComplete ?? null;
    o.hasScheduleFlags = options.hasScheduleFlags ?? false;
    o.systemTask = options.systemTask ?? null;
    o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.committedTradePartners = (options.committedTradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("committedTradePartners"))
    );
    o.billLineItems = (options.billLineItems ?? []).map((i) =>
      maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
    );
    o.defaultedHomeownerDescription = options.defaultedHomeownerDescription ?? "defaultedHomeownerDescription";
    o.templateTask = maybeNewOrNull("Task", options.templateTask, cache);
    o.tradePartnerStatus = enumOrDetailOfTradePartnerTaskStatus(options.tradePartnerStatus);
    o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
      maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
    );
    o.protoBills = (options.protoBills ?? []).map((i) =>
      maybeNew("ProtoBill", i, cache, options.hasOwnProperty("protoBills"))
    );
    o.type = enumOrDetailOfTaskType(options.type);
    o.workDays = (options.workDays ?? []).map((i) =>
      maybeNew("TaskWorkDay", i, cache, options.hasOwnProperty("workDays"))
    );
    o.commitmentDraws = (options.commitmentDraws ?? []).map((i) =>
      maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("commitmentDraws"))
    );
    return o as FactoryResult<ScheduleTask>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleTask"] = newScheduleTask;

export interface HomeownerContractLineItemOptions {
  __typename?: "HomeownerContractLineItem";
  id?: HomeownerContractLineItem["id"];
  priceChangeInCents?: HomeownerContractLineItem["priceChangeInCents"];
  budgetChangeInCents?: HomeownerContractLineItem["budgetChangeInCents"];
  quantity?: HomeownerContractLineItem["quantity"];
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  internalNote?: HomeownerContractLineItem["internalNote"];
  invoiceLineItems?: Array<FactoryInput<InvoiceLineItem, InvoiceLineItemOptions>>;
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  parent?: HomeownerContractLike | FactoryResult<HomeownerContractLikeType> | HomeownerContractLikeOptions;
  owner?: HomeownerContractLike | FactoryResult<HomeownerContractLikeType> | HomeownerContractLikeOptions;
  amountPaidInCents?: HomeownerContractLineItem["amountPaidInCents"];
  invoicedAmountInCents?: HomeownerContractLineItem["invoicedAmountInCents"];
  changeEventLineItem?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions> | null;
  tradePartnerNote?: HomeownerContractLineItem["tradePartnerNote"];
  specifications?: HomeownerContractLineItem["specifications"];
  bidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  allocations?: Array<FactoryInput<HomeownerContractLineItemAllocation, HomeownerContractLineItemAllocationOptions>>;
}

export function newHomeownerContractLineItem(
  options?: HomeownerContractLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractLineItem>;
export function newHomeownerContractLineItem(
  options: HomeownerContractLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeownerContractLineItem> {
  const o = (options.__typename ? options : cache["HomeownerContractLineItem"] = {}) as HomeownerContractLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "HomeownerContractLineItem";
    o.id = options.id ?? nextFactoryId("HomeownerContractLineItem");
    o.priceChangeInCents = options.priceChangeInCents ?? null;
    o.budgetChangeInCents = options.budgetChangeInCents ?? null;
    o.quantity = options.quantity ?? null;
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.internalNote = options.internalNote ?? null;
    o.invoiceLineItems = (options.invoiceLineItems ?? []).map((i) =>
      maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("invoiceLineItems"))
    );
    o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
    o.parent = maybeNew("HomeownerContractLike", options.parent, cache, options.hasOwnProperty("parent"));
    o.owner = maybeNew("HomeownerContractLike", options.owner, cache, options.hasOwnProperty("owner"));
    o.amountPaidInCents = options.amountPaidInCents ?? null;
    o.invoicedAmountInCents = options.invoicedAmountInCents ?? 0;
    o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.specifications = options.specifications ?? null;
    o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
    o.allocations = (options.allocations ?? []).map((i) =>
      maybeNew("HomeownerContractLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
    );
    return o as FactoryResult<HomeownerContractLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["HomeownerContractLineItem"] = newHomeownerContractLineItem;

export interface AddressOptions {
  __typename?: "Address";
  id?: Address["id"];
  street1?: Address["street1"];
  street2?: Address["street2"];
  city?: Address["city"];
  state?: Address["state"];
  postalCode?: Address["postalCode"];
  country?: Address["country"];
}

export function newAddress(options?: AddressOptions, factoryOptions?: FactoryOptions): FactoryResult<Address>;
export function newAddress(
  options: AddressOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Address> {
  const o = (options.__typename ? options : cache["Address"] = {}) as Address;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Address";
    o.id = options.id ?? nextFactoryId("Address");
    o.street1 = options.street1 ?? "street1";
    o.street2 = options.street2 ?? null;
    o.city = options.city ?? "city";
    o.state = options.state ?? "state";
    o.postalCode = options.postalCode ?? "postalCode";
    o.country = options.country ?? "country";
    return o as FactoryResult<Address>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Address"] = newAddress;

export interface AiEntityProposalsPageOptions {
  __typename?: "AiEntityProposalsPage";
  entities?: Array<FactoryInput<AiEntityProposal, AiEntityProposalOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newAiEntityProposalsPage(
  options?: AiEntityProposalsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiEntityProposalsPage>;
export function newAiEntityProposalsPage(
  options: AiEntityProposalsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiEntityProposalsPage> {
  const o = (options.__typename ? options : cache["AiEntityProposalsPage"] = {}) as AiEntityProposalsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiEntityProposalsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("AiEntityProposal", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<AiEntityProposalsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiEntityProposalsPage"] = newAiEntityProposalsPage;

export interface AiEntityProposalOptions {
  __typename?: "AiEntityProposal";
  id?: AiEntityProposal["id"];
  createdAt?: AiEntityProposal["createdAt"];
  updatedAt?: AiEntityProposal["updatedAt"];
  type?: AiEntityProposalTypeDetailOptions | AiEntityProposalType;
  parent?: FactoryInput<AiProposal, AiProposalOptions>;
  entity?:
    | AiEntityProposalEntity
    | FactoryResult<AiEntityProposalEntity>
    | MaterialListingOptions
    | RequireTypename<MaterialVariantOptions>
    | RequireTypename<ReadyPlanLocationOptions>
    | RequireTypename<ReadyPlanOptionOptions>
    | RequireTypename<ReadyPlanProgramDataOptions>;
  fieldProposals?: Array<FactoryInput<AiFieldProposal, AiFieldProposalOptions>>;
  entityType?: AiEntityProposalEntityTypeDetailOptions | AiEntityProposalEntityType;
}

export function newAiEntityProposal(
  options?: AiEntityProposalOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiEntityProposal>;
export function newAiEntityProposal(
  options: AiEntityProposalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiEntityProposal> {
  const o = (options.__typename ? options : cache["AiEntityProposal"] = {}) as AiEntityProposal;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiEntityProposal";
    o.id = options.id ?? nextFactoryId("AiEntityProposal");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.type = enumOrDetailOfAiEntityProposalType(options.type);
    o.parent = maybeNew("AiProposal", options.parent, cache, options.hasOwnProperty("parent"));
    o.entity = maybeNew(options.entity?.__typename ?? "MaterialListing", options.entity, cache);
    o.fieldProposals = (options.fieldProposals ?? []).map((i) =>
      maybeNew("AiFieldProposal", i, cache, options.hasOwnProperty("fieldProposals"))
    );
    o.entityType = enumOrDetailOfAiEntityProposalEntityType(options.entityType);
    return o as FactoryResult<AiEntityProposal>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiEntityProposal"] = newAiEntityProposal;

export interface AiFieldProposalsPageOptions {
  __typename?: "AiFieldProposalsPage";
  entities?: Array<FactoryInput<AiFieldProposal, AiFieldProposalOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newAiFieldProposalsPage(
  options?: AiFieldProposalsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiFieldProposalsPage>;
export function newAiFieldProposalsPage(
  options: AiFieldProposalsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiFieldProposalsPage> {
  const o = (options.__typename ? options : cache["AiFieldProposalsPage"] = {}) as AiFieldProposalsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiFieldProposalsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("AiFieldProposal", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<AiFieldProposalsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiFieldProposalsPage"] = newAiFieldProposalsPage;

export interface AiFieldProposalOptions {
  __typename?: "AiFieldProposal";
  id?: AiFieldProposal["id"];
  fieldName?: AiFieldProposal["fieldName"];
  fieldValue?: AiFieldProposal["fieldValue"];
  status?: AiFieldProposalStatusDetailOptions | AiFieldProposalStatus;
  createdAt?: AiFieldProposal["createdAt"];
  updatedAt?: AiFieldProposal["updatedAt"];
  parent?: FactoryInput<AiEntityProposal, AiEntityProposalOptions>;
  parentType?: AiFieldProposal["parentType"];
  rationalization?: AiFieldProposal["rationalization"];
  dataConfidence?: AiDataConfidenceDetailOptions | AiDataConfidence | null;
  pageNumbers?: AiFieldProposal["pageNumbers"] | null;
}

export function newAiFieldProposal(
  options?: AiFieldProposalOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiFieldProposal>;
export function newAiFieldProposal(
  options: AiFieldProposalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiFieldProposal> {
  const o = (options.__typename ? options : cache["AiFieldProposal"] = {}) as AiFieldProposal;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiFieldProposal";
    o.id = options.id ?? nextFactoryId("AiFieldProposal");
    o.fieldName = options.fieldName ?? "fieldName";
    o.fieldValue = options.fieldValue ?? null;
    o.status = enumOrDetailOfAiFieldProposalStatus(options.status);
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.parent = maybeNew("AiEntityProposal", options.parent, cache, options.hasOwnProperty("parent"));
    o.parentType = options.parentType ?? AiEntityProposalType.Create;
    o.rationalization = options.rationalization ?? null;
    o.dataConfidence = enumOrDetailOrNullOfAiDataConfidence(options.dataConfidence);
    o.pageNumbers = options.pageNumbers ?? [];
    return o as FactoryResult<AiFieldProposal>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiFieldProposal"] = newAiFieldProposal;

export interface ResolveAiFieldProposalsResultOptions {
  __typename?: "ResolveAiFieldProposalsResult";
  aiFieldProposals?: Array<FactoryInput<AiFieldProposal, AiFieldProposalOptions>>;
}

export function newResolveAiFieldProposalsResult(
  options?: ResolveAiFieldProposalsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ResolveAiFieldProposalsResult>;
export function newResolveAiFieldProposalsResult(
  options: ResolveAiFieldProposalsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ResolveAiFieldProposalsResult> {
  const o =
    (options.__typename ? options : cache["ResolveAiFieldProposalsResult"] = {}) as ResolveAiFieldProposalsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ResolveAiFieldProposalsResult";
    o.aiFieldProposals = (options.aiFieldProposals ?? []).map((i) =>
      maybeNew("AiFieldProposal", i, cache, options.hasOwnProperty("aiFieldProposals"))
    );
    return o as FactoryResult<ResolveAiFieldProposalsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ResolveAiFieldProposalsResult"] = newResolveAiFieldProposalsResult;

export interface AiProposalOptions {
  __typename?: "AiProposal";
  id?: AiProposal["id"];
  createdAt?: AiProposal["createdAt"];
  updatedAt?: AiProposal["updatedAt"];
  type?: AiProposalTypeDetailOptions | AiProposalType;
  status?: AiProposalStatusDetailOptions | AiProposalStatus;
  failureReason?: AiProposal["failureReason"];
  agentCompletedAt?: AiProposal["agentCompletedAt"];
  progressText?: AiProposal["progressText"];
  entityProposals?: Array<FactoryInput<AiEntityProposal, AiEntityProposalOptions>>;
}

export function newAiProposal(options?: AiProposalOptions, factoryOptions?: FactoryOptions): FactoryResult<AiProposal>;
export function newAiProposal(
  options: AiProposalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiProposal> {
  const o = (options.__typename ? options : cache["AiProposal"] = {}) as AiProposal;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiProposal";
    o.id = options.id ?? nextFactoryId("AiProposal");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.type = enumOrDetailOfAiProposalType(options.type);
    o.status = enumOrDetailOfAiProposalStatus(options.status);
    o.failureReason = options.failureReason ?? null;
    o.agentCompletedAt = options.agentCompletedAt ?? null;
    o.progressText = options.progressText ?? null;
    o.entityProposals = (options.entityProposals ?? []).map((i) =>
      maybeNew("AiEntityProposal", i, cache, options.hasOwnProperty("entityProposals"))
    );
    return o as FactoryResult<AiProposal>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiProposal"] = newAiProposal;

export interface ApprovalOptions {
  __typename?: "Approval";
  id?: Approval["id"];
  name?: Approval["name"];
  requestedAt?: Approval["requestedAt"];
  dueOn?: Approval["dueOn"];
  createdAt?: Approval["createdAt"];
  updatedAt?: Approval["updatedAt"];
  status?: ApprovalStatusDetailOptions | ApprovalStatus;
  requestedBy?: FactoryInput<User, UserOptions> | null;
  rootProject?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  approvers?: Array<FactoryInput<Approver, ApproverOptions>>;
  source?:
    | ApprovalSource
    | FactoryResult<ApprovalSource>
    | BidContractRevisionOptions
    | RequireTypename<ItemTemplateOptions>
    | RequireTypename<ReadyPlanAggregateVersionOptions>
    | null;
  subject?:
    | ApprovalSubject
    | FactoryResult<ApprovalSubject>
    | BillOptions
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<ChangeRequestOptions>
    | RequireTypename<InvoiceOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  isFinalized?: Approval["isFinalized"];
  userEvents?: Array<FactoryInput<UserEvent, UserEventOptions>>;
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Approval["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Approval["isFollowed"];
}

export function newApproval(options?: ApprovalOptions, factoryOptions?: FactoryOptions): FactoryResult<Approval>;
export function newApproval(
  options: ApprovalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Approval> {
  const o = (options.__typename ? options : cache["Approval"] = {}) as Approval;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Approval";
    o.id = options.id ?? nextFactoryId("Approval");
    o.name = options.name ?? "name";
    o.requestedAt = options.requestedAt ?? null;
    o.dueOn = options.dueOn ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = enumOrDetailOfApprovalStatus(options.status);
    o.requestedBy = maybeNewOrNull("User", options.requestedBy, cache);
    o.rootProject = maybeNewOrNull("Project", options.rootProject, cache);
    o.approvers = (options.approvers ?? []).map((i) =>
      maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
    );
    o.source = maybeNewOrNull(options.source?.__typename ?? "BidContractRevision", options.source, cache);
    o.subject = maybeNew(options.subject?.__typename ?? "Bill", options.subject, cache);
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.isFinalized = options.isFinalized ?? false;
    o.userEvents = (options.userEvents ?? []).map((i) =>
      maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
    );
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    return o as FactoryResult<Approval>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Approval"] = newApproval;

export interface ApprovalPageOptions {
  __typename?: "ApprovalPage";
  approvals?: Array<FactoryInput<Approval, ApprovalOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newApprovalPage(
  options?: ApprovalPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ApprovalPage>;
export function newApprovalPage(
  options: ApprovalPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ApprovalPage> {
  const o = (options.__typename ? options : cache["ApprovalPage"] = {}) as ApprovalPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ApprovalPage";
    o.approvals = (options.approvals ?? []).map((i) =>
      maybeNew("Approval", i, cache, options.hasOwnProperty("approvals"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ApprovalPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ApprovalPage"] = newApprovalPage;

export interface SaveApprovalResultOptions {
  __typename?: "SaveApprovalResult";
  approval?: FactoryInput<Approval, ApprovalOptions>;
}

export function newSaveApprovalResult(
  options?: SaveApprovalResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveApprovalResult>;
export function newSaveApprovalResult(
  options: SaveApprovalResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveApprovalResult> {
  const o = (options.__typename ? options : cache["SaveApprovalResult"] = {}) as SaveApprovalResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveApprovalResult";
    o.approval = maybeNew("Approval", options.approval, cache, options.hasOwnProperty("approval"));
    return o as FactoryResult<SaveApprovalResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveApprovalResult"] = newSaveApprovalResult;

export interface SaveApprovalsResultOptions {
  __typename?: "SaveApprovalsResult";
  approvals?: Array<FactoryInput<Approval, ApprovalOptions>>;
}

export function newSaveApprovalsResult(
  options?: SaveApprovalsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveApprovalsResult>;
export function newSaveApprovalsResult(
  options: SaveApprovalsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveApprovalsResult> {
  const o = (options.__typename ? options : cache["SaveApprovalsResult"] = {}) as SaveApprovalsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveApprovalsResult";
    o.approvals = (options.approvals ?? []).map((i) =>
      maybeNew("Approval", i, cache, options.hasOwnProperty("approvals"))
    );
    return o as FactoryResult<SaveApprovalsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveApprovalsResult"] = newSaveApprovalsResult;

export interface ApproverOptions {
  __typename?: "Approver";
  id?: Approver["id"];
  order?: Approver["order"];
  statusUpdatedAt?: Approver["statusUpdatedAt"];
  createdAt?: Approver["createdAt"];
  updatedAt?: Approver["updatedAt"];
  status?: ApproverStatusDetailOptions | ApproverStatus;
  nextApprover?: FactoryInput<Approver, ApproverOptions> | null;
  approval?: FactoryInput<Approval, ApprovalOptions>;
  user?:
    | ApproverUser
    | FactoryResult<ApproverUser>
    | ClientOptions
    | RequireTypename<InternalUserOptions>
    | RequireTypename<TradePartnerUserOptions>;
  wasAutoApproved?: Approver["wasAutoApproved"];
  subjectData?:
    | ApproverSubjectData
    | FactoryResult<ApproverSubjectData>
    | ChangeRequestApproverSubjectDataOptions
    | null;
  requireSignature?: Approver["requireSignature"];
  pandaDocRecipient?: FactoryInput<PandaDocRecipient, PandaDocRecipientOptions> | null;
}

export function newApprover(options?: ApproverOptions, factoryOptions?: FactoryOptions): FactoryResult<Approver>;
export function newApprover(
  options: ApproverOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Approver> {
  const o = (options.__typename ? options : cache["Approver"] = {}) as Approver;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Approver";
    o.id = options.id ?? nextFactoryId("Approver");
    o.order = options.order ?? 0;
    o.statusUpdatedAt = options.statusUpdatedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = enumOrDetailOfApproverStatus(options.status);
    o.nextApprover = maybeNewOrNull("Approver", options.nextApprover, cache);
    o.approval = maybeNew("Approval", options.approval, cache, options.hasOwnProperty("approval"));
    o.user = maybeNew(options.user?.__typename ?? "Client", options.user, cache);
    o.wasAutoApproved = options.wasAutoApproved ?? false;
    o.subjectData = maybeNewOrNull(
      options.subjectData?.__typename ?? "ChangeRequestApproverSubjectData",
      options.subjectData,
      cache,
    );
    o.requireSignature = options.requireSignature ?? false;
    o.pandaDocRecipient = maybeNewOrNull("PandaDocRecipient", options.pandaDocRecipient, cache);
    return o as FactoryResult<Approver>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Approver"] = newApprover;

export interface SaveApproverResultOptions {
  __typename?: "SaveApproverResult";
  approver?: FactoryInput<Approver, ApproverOptions>;
}

export function newSaveApproverResult(
  options?: SaveApproverResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveApproverResult>;
export function newSaveApproverResult(
  options: SaveApproverResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveApproverResult> {
  const o = (options.__typename ? options : cache["SaveApproverResult"] = {}) as SaveApproverResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveApproverResult";
    o.approver = maybeNew("Approver", options.approver, cache, options.hasOwnProperty("approver"));
    return o as FactoryResult<SaveApproverResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveApproverResult"] = newSaveApproverResult;

export interface SaveApproversResultOptions {
  __typename?: "SaveApproversResult";
  approvers?: Array<FactoryInput<Approver, ApproverOptions>>;
}

export function newSaveApproversResult(
  options?: SaveApproversResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveApproversResult>;
export function newSaveApproversResult(
  options: SaveApproversResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveApproversResult> {
  const o = (options.__typename ? options : cache["SaveApproversResult"] = {}) as SaveApproversResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveApproversResult";
    o.approvers = (options.approvers ?? []).map((i) =>
      maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
    );
    return o as FactoryResult<SaveApproversResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveApproversResult"] = newSaveApproversResult;

export interface CreateAssetUploadUrlResultOptions {
  __typename?: "CreateAssetUploadUrlResult";
  s3Key?: CreateAssetUploadUrlResult["s3Key"];
  uploadUrl?: CreateAssetUploadUrlResult["uploadUrl"];
  downloadUrl?: CreateAssetUploadUrlResult["downloadUrl"];
  attachmentUrl?: CreateAssetUploadUrlResult["attachmentUrl"];
  previewUrl?: CreateAssetUploadUrlResult["previewUrl"];
}

export function newCreateAssetUploadUrlResult(
  options?: CreateAssetUploadUrlResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CreateAssetUploadUrlResult>;
export function newCreateAssetUploadUrlResult(
  options: CreateAssetUploadUrlResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CreateAssetUploadUrlResult> {
  const o = (options.__typename ? options : cache["CreateAssetUploadUrlResult"] = {}) as CreateAssetUploadUrlResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CreateAssetUploadUrlResult";
    o.s3Key = options.s3Key ?? "s3Key";
    o.uploadUrl = options.uploadUrl ?? "uploadUrl";
    o.downloadUrl = options.downloadUrl ?? "downloadUrl";
    o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
    o.previewUrl = options.previewUrl ?? null;
    return o as FactoryResult<CreateAssetUploadUrlResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CreateAssetUploadUrlResult"] = newCreateAssetUploadUrlResult;

export interface CreateAssetMultipartUploadUrlResultOptions {
  __typename?: "CreateAssetMultipartUploadUrlResult";
  uploadId?: CreateAssetMultipartUploadUrlResult["uploadId"];
  s3Key?: CreateAssetMultipartUploadUrlResult["s3Key"];
  totalParts?: CreateAssetMultipartUploadUrlResult["totalParts"];
  partUploadUrls?: Array<FactoryInput<MultipartPartUploadUrl, MultipartPartUploadUrlOptions>>;
  expiresAt?: CreateAssetMultipartUploadUrlResult["expiresAt"];
}

export function newCreateAssetMultipartUploadUrlResult(
  options?: CreateAssetMultipartUploadUrlResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CreateAssetMultipartUploadUrlResult>;
export function newCreateAssetMultipartUploadUrlResult(
  options: CreateAssetMultipartUploadUrlResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CreateAssetMultipartUploadUrlResult> {
  const o =
    (options.__typename
      ? options
      : cache["CreateAssetMultipartUploadUrlResult"] = {}) as CreateAssetMultipartUploadUrlResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CreateAssetMultipartUploadUrlResult";
    o.uploadId = options.uploadId ?? "uploadId";
    o.s3Key = options.s3Key ?? "s3Key";
    o.totalParts = options.totalParts ?? 0;
    o.partUploadUrls = (options.partUploadUrls ?? []).map((i) =>
      maybeNew("MultipartPartUploadUrl", i, cache, options.hasOwnProperty("partUploadUrls"))
    );
    o.expiresAt = options.expiresAt ?? newDateTime();
    return o as FactoryResult<CreateAssetMultipartUploadUrlResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CreateAssetMultipartUploadUrlResult"] = newCreateAssetMultipartUploadUrlResult;

export interface MultipartPartUploadUrlOptions {
  __typename?: "MultipartPartUploadUrl";
  partNumber?: MultipartPartUploadUrl["partNumber"];
  uploadUrl?: MultipartPartUploadUrl["uploadUrl"];
}

export function newMultipartPartUploadUrl(
  options?: MultipartPartUploadUrlOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MultipartPartUploadUrl>;
export function newMultipartPartUploadUrl(
  options: MultipartPartUploadUrlOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MultipartPartUploadUrl> {
  const o = (options.__typename ? options : cache["MultipartPartUploadUrl"] = {}) as MultipartPartUploadUrl;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MultipartPartUploadUrl";
    o.partNumber = options.partNumber ?? 0;
    o.uploadUrl = options.uploadUrl ?? "uploadUrl";
    return o as FactoryResult<MultipartPartUploadUrl>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MultipartPartUploadUrl"] = newMultipartPartUploadUrl;

export interface AbortAssetMultipartUploadResultOptions {
  __typename?: "AbortAssetMultipartUploadResult";
  uploadId?: AbortAssetMultipartUploadResult["uploadId"];
  s3Key?: AbortAssetMultipartUploadResult["s3Key"];
}

export function newAbortAssetMultipartUploadResult(
  options?: AbortAssetMultipartUploadResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AbortAssetMultipartUploadResult>;
export function newAbortAssetMultipartUploadResult(
  options: AbortAssetMultipartUploadResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AbortAssetMultipartUploadResult> {
  const o =
    (options.__typename ? options : cache["AbortAssetMultipartUploadResult"] = {}) as AbortAssetMultipartUploadResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AbortAssetMultipartUploadResult";
    o.uploadId = options.uploadId ?? "uploadId";
    o.s3Key = options.s3Key ?? "s3Key";
    return o as FactoryResult<AbortAssetMultipartUploadResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AbortAssetMultipartUploadResult"] = newAbortAssetMultipartUploadResult;

export interface AssetOptions {
  __typename?: "Asset";
  id?: Asset["id"];
  contentType?: Asset["contentType"];
  isVideo?: Asset["isVideo"];
  downloadUrl?: Asset["downloadUrl"];
  attachmentUrl?: Asset["attachmentUrl"];
  previewUrl?: Asset["previewUrl"];
  url?: Asset["url"];
  fileName?: Asset["fileName"];
  sizeInBytes?: Asset["sizeInBytes"];
  createdAt?: Asset["createdAt"];
  updatedAt?: Asset["updatedAt"];
  version?: Asset["version"];
  s3Key?: Asset["s3Key"];
}

export function newAsset(options?: AssetOptions, factoryOptions?: FactoryOptions): FactoryResult<Asset>;
export function newAsset(
  options: AssetOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Asset> {
  const o = (options.__typename ? options : cache["Asset"] = {}) as Asset;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Asset";
    o.id = options.id ?? nextFactoryId("Asset");
    o.contentType = options.contentType ?? "contentType";
    o.isVideo = options.isVideo ?? false;
    o.downloadUrl = options.downloadUrl ?? "downloadUrl";
    o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
    o.previewUrl = options.previewUrl ?? null;
    o.url = options.url ?? "url";
    o.fileName = options.fileName ?? null;
    o.sizeInBytes = options.sizeInBytes ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.version = options.version ?? "version";
    o.s3Key = options.s3Key ?? "s3Key";
    return o as FactoryResult<Asset>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Asset"] = newAsset;

export interface CreateAssetResultOptions {
  __typename?: "CreateAssetResult";
  asset?: FactoryInput<Asset, AssetOptions>;
}

export function newCreateAssetResult(
  options?: CreateAssetResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CreateAssetResult>;
export function newCreateAssetResult(
  options: CreateAssetResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CreateAssetResult> {
  const o = (options.__typename ? options : cache["CreateAssetResult"] = {}) as CreateAssetResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CreateAssetResult";
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    return o as FactoryResult<CreateAssetResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CreateAssetResult"] = newCreateAssetResult;

export interface AttachmentOptions {
  __typename?: "Attachment";
  id?: Attachment["id"];
  createdAt?: Attachment["createdAt"];
  updatedAt?: Attachment["updatedAt"];
  asset?: FactoryInput<Asset, AssetOptions>;
  parent?:
    | AttachmentParent
    | FactoryResult<AttachmentParent>
    | ChangeRequestOptions
    | RequireTypename<CommentOptions>
    | RequireTypename<GlobalOptionOptions>
    | RequireTypename<ProjectSiteConditionOptions>
    | RequireTypename<ScheduleFlagOptions>
    | RequireTypename<ToDoOptions>
    | RequireTypename<TradePartnerAvailabilityRequestEmailOptions>
    | RequireTypename<TradePartnerRequirementOptions>
    | RequireTypename<WarrantyTicketOptions>
    | RequireTypename<WarrantyTicketItemOptions>;
}

export function newAttachment(options?: AttachmentOptions, factoryOptions?: FactoryOptions): FactoryResult<Attachment>;
export function newAttachment(
  options: AttachmentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Attachment> {
  const o = (options.__typename ? options : cache["Attachment"] = {}) as Attachment;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Attachment";
    o.id = options.id ?? nextFactoryId("Attachment");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    o.parent = maybeNew(options.parent?.__typename ?? "ChangeRequest", options.parent, cache);
    return o as FactoryResult<Attachment>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Attachment"] = newAttachment;

export interface SaveAttachmentResultOptions {
  __typename?: "SaveAttachmentResult";
  attachment?: FactoryInput<Attachment, AttachmentOptions>;
}

export function newSaveAttachmentResult(
  options?: SaveAttachmentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveAttachmentResult>;
export function newSaveAttachmentResult(
  options: SaveAttachmentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveAttachmentResult> {
  const o = (options.__typename ? options : cache["SaveAttachmentResult"] = {}) as SaveAttachmentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveAttachmentResult";
    o.attachment = maybeNew("Attachment", options.attachment, cache, options.hasOwnProperty("attachment"));
    return o as FactoryResult<SaveAttachmentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveAttachmentResult"] = newSaveAttachmentResult;

export interface DeleteAttachmentResultOptions {
  __typename?: "DeleteAttachmentResult";
  parent?:
    | AttachmentParent
    | FactoryResult<AttachmentParent>
    | ChangeRequestOptions
    | RequireTypename<CommentOptions>
    | RequireTypename<GlobalOptionOptions>
    | RequireTypename<ProjectSiteConditionOptions>
    | RequireTypename<ScheduleFlagOptions>
    | RequireTypename<ToDoOptions>
    | RequireTypename<TradePartnerAvailabilityRequestEmailOptions>
    | RequireTypename<TradePartnerRequirementOptions>
    | RequireTypename<WarrantyTicketOptions>
    | RequireTypename<WarrantyTicketItemOptions>
    | null;
}

export function newDeleteAttachmentResult(
  options?: DeleteAttachmentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteAttachmentResult>;
export function newDeleteAttachmentResult(
  options: DeleteAttachmentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteAttachmentResult> {
  const o = (options.__typename ? options : cache["DeleteAttachmentResult"] = {}) as DeleteAttachmentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteAttachmentResult";
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "ChangeRequest", options.parent, cache);
    return o as FactoryResult<DeleteAttachmentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteAttachmentResult"] = newDeleteAttachmentResult;

export interface DeleteAuditEventsResultOptions {
  __typename?: "DeleteAuditEventsResult";
  results?: Array<FactoryInput<DeleteAuditEventResult, DeleteAuditEventResultOptions>>;
}

export function newDeleteAuditEventsResult(
  options?: DeleteAuditEventsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteAuditEventsResult>;
export function newDeleteAuditEventsResult(
  options: DeleteAuditEventsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteAuditEventsResult> {
  const o = (options.__typename ? options : cache["DeleteAuditEventsResult"] = {}) as DeleteAuditEventsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteAuditEventsResult";
    o.results = (options.results ?? []).map((i) =>
      maybeNew("DeleteAuditEventResult", i, cache, options.hasOwnProperty("results"))
    );
    return o as FactoryResult<DeleteAuditEventsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteAuditEventsResult"] = newDeleteAuditEventsResult;

export interface DeleteAuditEventResultOptions {
  __typename?: "DeleteAuditEventResult";
  table?: DeleteAuditEventResult["table"];
  column?: DeleteAuditEventResult["column"];
  deletedCount?: DeleteAuditEventResult["deletedCount"];
}

export function newDeleteAuditEventResult(
  options?: DeleteAuditEventResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteAuditEventResult>;
export function newDeleteAuditEventResult(
  options: DeleteAuditEventResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteAuditEventResult> {
  const o = (options.__typename ? options : cache["DeleteAuditEventResult"] = {}) as DeleteAuditEventResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteAuditEventResult";
    o.table = options.table ?? "table";
    o.column = options.column ?? "column";
    o.deletedCount = options.deletedCount ?? 0;
    return o as FactoryResult<DeleteAuditEventResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteAuditEventResult"] = newDeleteAuditEventResult;

export interface BidContractOptions {
  __typename?: "BidContract";
  id?: BidContract["id"];
  name?: BidContract["name"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  displayName?: BidContract["displayName"];
  isPrimary?: BidContract["isPrimary"];
  createdAt?: BidContract["createdAt"];
  updatedAt?: BidContract["updatedAt"];
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  revisions?: Array<FactoryInput<BidContractRevision, BidContractRevisionOptions>>;
  currentRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  latestSignedRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions> | null;
  unsignedRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions> | null;
  latestRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  isInternalEstimate?: BidContract["isInternalEstimate"];
  developments?: Array<FactoryInput<Development, DevelopmentOptions>>;
  bidRequest?: FactoryInput<BidPackageRequest, BidPackageRequestOptions> | null;
  bidder?: FactoryInput<BidPackageBidder, BidPackageBidderOptions>;
  type?: BidContractTypeDetailOptions | BidContractType;
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  relevantMarket?: FactoryInput<Market, MarketOptions>;
  internalEstimateBidPackage?: FactoryInput<BidPackage, BidPackageOptions> | null;
  archivedAt?: BidContract["archivedAt"];
  internalEstimateType?: InternalEstimateTypeDetailOptions | InternalEstimateType | null;
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: BidContract["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: BidContract["isFollowed"];
}

export function newBidContract(
  options?: BidContractOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContract>;
export function newBidContract(
  options: BidContractOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContract> {
  const o = (options.__typename ? options : cache["BidContract"] = {}) as BidContract;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContract";
    o.id = options.id ?? nextFactoryId("BidContract");
    o.name = options.name ?? "name";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.displayName = options.displayName ?? "displayName";
    o.isPrimary = options.isPrimary ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.revisions = (options.revisions ?? []).map((i) =>
      maybeNew("BidContractRevision", i, cache, options.hasOwnProperty("revisions"))
    );
    o.currentRevision = maybeNew(
      "BidContractRevision",
      options.currentRevision,
      cache,
      options.hasOwnProperty("currentRevision"),
    );
    o.latestSignedRevision = maybeNewOrNull("BidContractRevision", options.latestSignedRevision, cache);
    o.unsignedRevision = maybeNewOrNull("BidContractRevision", options.unsignedRevision, cache);
    o.latestRevision = maybeNew(
      "BidContractRevision",
      options.latestRevision,
      cache,
      options.hasOwnProperty("latestRevision"),
    );
    o.isInternalEstimate = options.isInternalEstimate ?? false;
    o.developments = (options.developments ?? []).map((i) =>
      maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
    );
    o.bidRequest = maybeNewOrNull("BidPackageRequest", options.bidRequest, cache);
    o.bidder = maybeNew("BidPackageBidder", options.bidder, cache, options.hasOwnProperty("bidder"));
    o.type = enumOrDetailOfBidContractType(options.type);
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    o.relevantMarket = maybeNew("Market", options.relevantMarket, cache, options.hasOwnProperty("relevantMarket"));
    o.internalEstimateBidPackage = maybeNewOrNull("BidPackage", options.internalEstimateBidPackage, cache);
    o.archivedAt = options.archivedAt ?? null;
    o.internalEstimateType = enumOrDetailOrNullOfInternalEstimateType(options.internalEstimateType);
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    return o as FactoryResult<BidContract>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContract"] = newBidContract;

export interface SaveBidContractResultOptions {
  __typename?: "SaveBidContractResult";
  bidContract?: FactoryInput<BidContract, BidContractOptions>;
}

export function newSaveBidContractResult(
  options?: SaveBidContractResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidContractResult>;
export function newSaveBidContractResult(
  options: SaveBidContractResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidContractResult> {
  const o = (options.__typename ? options : cache["SaveBidContractResult"] = {}) as SaveBidContractResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidContractResult";
    o.bidContract = maybeNew("BidContract", options.bidContract, cache, options.hasOwnProperty("bidContract"));
    return o as FactoryResult<SaveBidContractResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidContractResult"] = newSaveBidContractResult;

export interface CopyPlanBasedBidCostsResultOptions {
  __typename?: "CopyPlanBasedBidCostsResult";
  bidContract?: FactoryInput<BidContract, BidContractOptions>;
}

export function newCopyPlanBasedBidCostsResult(
  options?: CopyPlanBasedBidCostsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CopyPlanBasedBidCostsResult>;
export function newCopyPlanBasedBidCostsResult(
  options: CopyPlanBasedBidCostsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CopyPlanBasedBidCostsResult> {
  const o = (options.__typename ? options : cache["CopyPlanBasedBidCostsResult"] = {}) as CopyPlanBasedBidCostsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CopyPlanBasedBidCostsResult";
    o.bidContract = maybeNew("BidContract", options.bidContract, cache, options.hasOwnProperty("bidContract"));
    return o as FactoryResult<CopyPlanBasedBidCostsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CopyPlanBasedBidCostsResult"] = newCopyPlanBasedBidCostsResult;

export interface BidContractPotentialItemOptions {
  __typename?: "BidContractPotentialItem";
  item?: FactoryInput<Item, ItemOptions>;
  templateItemIds?: BidContractPotentialItem["templateItemIds"];
  needsBid?: BidContractPotentialItem["needsBid"];
}

export function newBidContractPotentialItem(
  options?: BidContractPotentialItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractPotentialItem>;
export function newBidContractPotentialItem(
  options: BidContractPotentialItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContractPotentialItem> {
  const o = (options.__typename ? options : cache["BidContractPotentialItem"] = {}) as BidContractPotentialItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContractPotentialItem";
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.templateItemIds = options.templateItemIds ?? [];
    o.needsBid = options.needsBid ?? false;
    return o as FactoryResult<BidContractPotentialItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContractPotentialItem"] = newBidContractPotentialItem;

export interface BidContractsPageOptions {
  __typename?: "BidContractsPage";
  entities?: Array<FactoryInput<BidContract, BidContractOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newBidContractsPage(
  options?: BidContractsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractsPage>;
export function newBidContractsPage(
  options: BidContractsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContractsPage> {
  const o = (options.__typename ? options : cache["BidContractsPage"] = {}) as BidContractsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContractsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<BidContractsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContractsPage"] = newBidContractsPage;

export interface BidContractLineItemOptions {
  __typename?: "BidContractLineItem";
  id?: BidContractLineItem["id"];
  name?: BidContractLineItem["name"];
  totalCostInCents?: BidContractLineItem["totalCostInCents"];
  unitCostInCents?: BidContractLineItem["unitCostInCents"];
  unitCostInMills?: BidContractLineItem["unitCostInMills"];
  createdAt?: BidContractLineItem["createdAt"];
  updatedAt?: BidContractLineItem["updatedAt"];
  itemTemplateItem?: BaseItemLike | FactoryResult<BaseItemLikeType> | BaseItemLikeOptions | null;
  revision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  previousLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  bidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  scopeUpdated?: BidContractLineItem["scopeUpdated"];
  ofIti?: BidContractLineItem["ofIti"];
  ofBi?: BidContractLineItem["ofBi"];
  preferredByItemTemplateItems?: Array<BaseItemLike | FactoryResult<BaseItemLikeType> | BaseItemLikeOptions>;
  potentialUsages?: Array<BaseItemLike | FactoryResult<BaseItemLikeType> | BaseItemLikeOptions>;
  isTaxExempt?: BidContractLineItem["isTaxExempt"];
  tradeLineItem?: FactoryInput<BidContractTradeLineItem, BidContractTradeLineItemOptions> | null;
  forCoveringTakeoffs?: BidContractLineItem["forCoveringTakeoffs"];
  isNoCost?: BidContractLineItem["isNoCost"];
  isMissingCost?: BidContractLineItem["isMissingCost"];
  userSet?: BidContractLineItem["userSet"];
}

export function newBidContractLineItem(
  options?: BidContractLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractLineItem>;
export function newBidContractLineItem(
  options: BidContractLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContractLineItem> {
  const o = (options.__typename ? options : cache["BidContractLineItem"] = {}) as BidContractLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContractLineItem";
    o.id = options.id ?? nextFactoryId("BidContractLineItem");
    o.name = options.name ?? "name";
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.unitCostInCents = options.unitCostInCents ?? 0;
    o.unitCostInMills = options.unitCostInMills ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
    o.revision = maybeNew("BidContractRevision", options.revision, cache, options.hasOwnProperty("revision"));
    o.previousLineItem = maybeNewOrNull("BidContractLineItem", options.previousLineItem, cache);
    o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
    o.scopeUpdated = options.scopeUpdated ?? false;
    o.ofIti = options.ofIti ?? false;
    o.ofBi = options.ofBi ?? false;
    o.preferredByItemTemplateItems = (options.preferredByItemTemplateItems ?? []).map((i) =>
      maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("preferredByItemTemplateItems"))
    );
    o.potentialUsages = (options.potentialUsages ?? []).map((i) =>
      maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("potentialUsages"))
    );
    o.isTaxExempt = options.isTaxExempt ?? false;
    o.tradeLineItem = maybeNewOrNull("BidContractTradeLineItem", options.tradeLineItem, cache);
    o.forCoveringTakeoffs = options.forCoveringTakeoffs ?? false;
    o.isNoCost = options.isNoCost ?? false;
    o.isMissingCost = options.isMissingCost ?? false;
    o.userSet = options.userSet ?? false;
    return o as FactoryResult<BidContractLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContractLineItem"] = newBidContractLineItem;

export interface SaveBidContractLineItemResultOptions {
  __typename?: "SaveBidContractLineItemResult";
  bidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions>;
}

export function newSaveBidContractLineItemResult(
  options?: SaveBidContractLineItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidContractLineItemResult>;
export function newSaveBidContractLineItemResult(
  options: SaveBidContractLineItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidContractLineItemResult> {
  const o =
    (options.__typename ? options : cache["SaveBidContractLineItemResult"] = {}) as SaveBidContractLineItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidContractLineItemResult";
    o.bidContractLineItem = maybeNew(
      "BidContractLineItem",
      options.bidContractLineItem,
      cache,
      options.hasOwnProperty("bidContractLineItem"),
    );
    return o as FactoryResult<SaveBidContractLineItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidContractLineItemResult"] = newSaveBidContractLineItemResult;

export interface SaveBidContractLineItemsResultOptions {
  __typename?: "SaveBidContractLineItemsResult";
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newSaveBidContractLineItemsResult(
  options?: SaveBidContractLineItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidContractLineItemsResult>;
export function newSaveBidContractLineItemsResult(
  options: SaveBidContractLineItemsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidContractLineItemsResult> {
  const o =
    (options.__typename ? options : cache["SaveBidContractLineItemsResult"] = {}) as SaveBidContractLineItemsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidContractLineItemsResult";
    o.bidContractRevision = maybeNew(
      "BidContractRevision",
      options.bidContractRevision,
      cache,
      options.hasOwnProperty("bidContractRevision"),
    );
    return o as FactoryResult<SaveBidContractLineItemsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidContractLineItemsResult"] = newSaveBidContractLineItemsResult;

export interface DeleteBidContractLineItemResultOptions {
  __typename?: "DeleteBidContractLineItemResult";
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newDeleteBidContractLineItemResult(
  options?: DeleteBidContractLineItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteBidContractLineItemResult>;
export function newDeleteBidContractLineItemResult(
  options: DeleteBidContractLineItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteBidContractLineItemResult> {
  const o =
    (options.__typename ? options : cache["DeleteBidContractLineItemResult"] = {}) as DeleteBidContractLineItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteBidContractLineItemResult";
    o.bidContractRevision = maybeNew(
      "BidContractRevision",
      options.bidContractRevision,
      cache,
      options.hasOwnProperty("bidContractRevision"),
    );
    return o as FactoryResult<DeleteBidContractLineItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteBidContractLineItemResult"] = newDeleteBidContractLineItemResult;

export interface BidContractLineItemsPageResultOptions {
  __typename?: "BidContractLineItemsPageResult";
  entities?: Array<FactoryInput<BidContractLineItem, BidContractLineItemOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newBidContractLineItemsPageResult(
  options?: BidContractLineItemsPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractLineItemsPageResult>;
export function newBidContractLineItemsPageResult(
  options: BidContractLineItemsPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContractLineItemsPageResult> {
  const o =
    (options.__typename ? options : cache["BidContractLineItemsPageResult"] = {}) as BidContractLineItemsPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContractLineItemsPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<BidContractLineItemsPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContractLineItemsPageResult"] = newBidContractLineItemsPageResult;

export interface BidContractRevisionOptions {
  __typename?: "BidContractRevision";
  id?: BidContractRevision["id"];
  displayName?: BidContractRevision["displayName"];
  version?: BidContractRevision["version"];
  createdAt?: BidContractRevision["createdAt"];
  updatedAt?: BidContractRevision["updatedAt"];
  status?: BidContractRevisionStatusDetailOptions | BidContractRevisionStatus;
  bidContract?: FactoryInput<BidContract, BidContractOptions>;
  lineItems?: Array<FactoryInput<BidContractLineItem, BidContractLineItemOptions>>;
  planBasedLineItems?: Array<FactoryInput<PlanBasedBidContractLineItem, PlanBasedBidContractLineItemOptions>>;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canReviseCosts?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  costCodeAwards?: Array<FactoryInput<CostCodeAward, CostCodeAwardOptions>>;
  pandaDocRecipients?: Array<FactoryInput<PandaDocIntendedRecipient, PandaDocIntendedRecipientOptions>>;
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions> | null;
  document?: FactoryInput<Document, DocumentOptions> | null;
  canCreatePandaDoc?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  startDate?: BidContractRevision["startDate"];
  endDate?: BidContractRevision["endDate"];
  isEffective?: BidContractRevision["isEffective"];
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  hasOutdatedScope?: BidContractRevision["hasOutdatedScope"];
  sourceForApprovals?: Array<FactoryInput<Approval, ApprovalOptions>>;
  tradeSignatory?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  potentialProjectItems?: Array<FactoryInput<PotentialProjectItem, PotentialProjectItemOptions>>;
  itemTemplateCostUpdates?: Array<FactoryInput<ItemTemplateCostUpdate, ItemTemplateCostUpdateOptions>>;
  signedOn?: BidContractRevision["signedOn"];
  internalNote?: BidContractRevision["internalNote"];
  tradeLineItems?: Array<FactoryInput<BidContractTradeLineItem, BidContractTradeLineItemOptions>>;
  hasValidTradeCosts?: BidContractRevision["hasValidTradeCosts"];
  draws?: Array<FactoryInput<BidContractRevisionDraw, BidContractRevisionDrawOptions>>;
  canAddDraws?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditDraws?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  primaryRevisionBidPackageAwards?: Array<FactoryInput<BidPackageAward, BidPackageAwardOptions>>;
  bidPackageVersion?: FactoryInput<BidPackageVersion, BidPackageVersionOptions> | null;
  hasValidDrawTasks?: BidContractRevision["hasValidDrawTasks"];
  hasAwardedBidPackageVersion?: BidContractRevision["hasAwardedBidPackageVersion"];
}

export function newBidContractRevision(
  options?: BidContractRevisionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractRevision>;
export function newBidContractRevision(
  options: BidContractRevisionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContractRevision> {
  const o = (options.__typename ? options : cache["BidContractRevision"] = {}) as BidContractRevision;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContractRevision";
    o.id = options.id ?? nextFactoryId("BidContractRevision");
    o.displayName = options.displayName ?? "displayName";
    o.version = options.version ?? "version";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = enumOrDetailOfBidContractRevisionStatus(options.status);
    o.bidContract = maybeNew("BidContract", options.bidContract, cache, options.hasOwnProperty("bidContract"));
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.planBasedLineItems = (options.planBasedLineItems ?? []).map((i) =>
      maybeNew("PlanBasedBidContractLineItem", i, cache, options.hasOwnProperty("planBasedLineItems"))
    );
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.canReviseCosts = maybeNew(
      "PotentialOperation2",
      options.canReviseCosts,
      cache,
      options.hasOwnProperty("canReviseCosts"),
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.costCodeAwards = (options.costCodeAwards ?? []).map((i) =>
      maybeNew("CostCodeAward", i, cache, options.hasOwnProperty("costCodeAwards"))
    );
    o.pandaDocRecipients = (options.pandaDocRecipients ?? []).map((i) =>
      maybeNew("PandaDocIntendedRecipient", i, cache, options.hasOwnProperty("pandaDocRecipients"))
    );
    o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.canCreatePandaDoc = maybeNew(
      "PotentialOperation2",
      options.canCreatePandaDoc,
      cache,
      options.hasOwnProperty("canCreatePandaDoc"),
    );
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.startDate = options.startDate ?? newDate();
    o.endDate = options.endDate ?? null;
    o.isEffective = options.isEffective ?? false;
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.hasOutdatedScope = options.hasOutdatedScope ?? false;
    o.sourceForApprovals = (options.sourceForApprovals ?? []).map((i) =>
      maybeNew("Approval", i, cache, options.hasOwnProperty("sourceForApprovals"))
    );
    o.tradeSignatory = maybeNewOrNull("TradePartnerContact", options.tradeSignatory, cache);
    o.potentialProjectItems = (options.potentialProjectItems ?? []).map((i) =>
      maybeNew("PotentialProjectItem", i, cache, options.hasOwnProperty("potentialProjectItems"))
    );
    o.itemTemplateCostUpdates = (options.itemTemplateCostUpdates ?? []).map((i) =>
      maybeNew("ItemTemplateCostUpdate", i, cache, options.hasOwnProperty("itemTemplateCostUpdates"))
    );
    o.signedOn = options.signedOn ?? null;
    o.internalNote = options.internalNote ?? null;
    o.tradeLineItems = (options.tradeLineItems ?? []).map((i) =>
      maybeNew("BidContractTradeLineItem", i, cache, options.hasOwnProperty("tradeLineItems"))
    );
    o.hasValidTradeCosts = options.hasValidTradeCosts ?? false;
    o.draws = (options.draws ?? []).map((i) =>
      maybeNew("BidContractRevisionDraw", i, cache, options.hasOwnProperty("draws"))
    );
    o.canAddDraws = maybeNew("PotentialOperation2", options.canAddDraws, cache, options.hasOwnProperty("canAddDraws"));
    o.canEditDraws = maybeNew(
      "PotentialOperation2",
      options.canEditDraws,
      cache,
      options.hasOwnProperty("canEditDraws"),
    );
    o.primaryRevisionBidPackageAwards = (options.primaryRevisionBidPackageAwards ?? []).map((i) =>
      maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("primaryRevisionBidPackageAwards"))
    );
    o.bidPackageVersion = maybeNewOrNull("BidPackageVersion", options.bidPackageVersion, cache);
    o.hasValidDrawTasks = options.hasValidDrawTasks ?? false;
    o.hasAwardedBidPackageVersion = options.hasAwardedBidPackageVersion ?? false;
    return o as FactoryResult<BidContractRevision>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContractRevision"] = newBidContractRevision;

export interface SaveBidContractRevisionResultOptions {
  __typename?: "SaveBidContractRevisionResult";
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newSaveBidContractRevisionResult(
  options?: SaveBidContractRevisionResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidContractRevisionResult>;
export function newSaveBidContractRevisionResult(
  options: SaveBidContractRevisionResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidContractRevisionResult> {
  const o =
    (options.__typename ? options : cache["SaveBidContractRevisionResult"] = {}) as SaveBidContractRevisionResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidContractRevisionResult";
    o.bidContractRevision = maybeNew(
      "BidContractRevision",
      options.bidContractRevision,
      cache,
      options.hasOwnProperty("bidContractRevision"),
    );
    return o as FactoryResult<SaveBidContractRevisionResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidContractRevisionResult"] = newSaveBidContractRevisionResult;

export interface PandaDocIntendedRecipientOptions {
  __typename?: "PandaDocIntendedRecipient";
  name?: PandaDocIntendedRecipient["name"];
  email?: PandaDocIntendedRecipient["email"];
  role?: PandaDocIntendedRecipient["role"];
  tradePartnerContact?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  user?: FactoryInput<User, UserOptions> | null;
  signingOrder?: PandaDocIntendedRecipient["signingOrder"];
}

export function newPandaDocIntendedRecipient(
  options?: PandaDocIntendedRecipientOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PandaDocIntendedRecipient>;
export function newPandaDocIntendedRecipient(
  options: PandaDocIntendedRecipientOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PandaDocIntendedRecipient> {
  const o = (options.__typename ? options : cache["PandaDocIntendedRecipient"] = {}) as PandaDocIntendedRecipient;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PandaDocIntendedRecipient";
    o.name = options.name ?? "name";
    o.email = options.email ?? "email";
    o.role = options.role ?? PandaDocRole.User;
    o.tradePartnerContact = maybeNewOrNull("TradePartnerContact", options.tradePartnerContact, cache);
    o.user = maybeNewOrNull("User", options.user, cache);
    o.signingOrder = options.signingOrder ?? null;
    return o as FactoryResult<PandaDocIntendedRecipient>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PandaDocIntendedRecipient"] = newPandaDocIntendedRecipient;

export interface PotentialProjectItemOptions {
  __typename?: "PotentialProjectItem";
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  totalCostInCents?: PotentialProjectItem["totalCostInCents"];
}

export function newPotentialProjectItem(
  options?: PotentialProjectItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PotentialProjectItem>;
export function newPotentialProjectItem(
  options: PotentialProjectItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialProjectItem> {
  const o = (options.__typename ? options : cache["PotentialProjectItem"] = {}) as PotentialProjectItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PotentialProjectItem";
    o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
    o.totalCostInCents = options.totalCostInCents ?? 0;
    return o as FactoryResult<PotentialProjectItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PotentialProjectItem"] = newPotentialProjectItem;

export interface CostCodeAwardOptions {
  __typename?: "CostCodeAward";
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  isPrimary?: CostCodeAward["isPrimary"];
  isSecondary?: CostCodeAward["isSecondary"];
}

export function newCostCodeAward(
  options?: CostCodeAwardOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCodeAward>;
export function newCostCodeAward(
  options: CostCodeAwardOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostCodeAward> {
  const o = (options.__typename ? options : cache["CostCodeAward"] = {}) as CostCodeAward;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostCodeAward";
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.isPrimary = options.isPrimary ?? false;
    o.isSecondary = options.isSecondary ?? false;
    return o as FactoryResult<CostCodeAward>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostCodeAward"] = newCostCodeAward;

export interface BidContractRevisionDrawOptions {
  __typename?: "BidContractRevisionDraw";
  id?: BidContractRevisionDraw["id"];
  amountInBasisPoints?: BidContractRevisionDraw["amountInBasisPoints"];
  isDeposit?: BidContractRevisionDraw["isDeposit"];
  description?: BidContractRevisionDraw["description"];
  createdAt?: BidContractRevisionDraw["createdAt"];
  updatedAt?: BidContractRevisionDraw["updatedAt"];
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  globalPlanTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newBidContractRevisionDraw(
  options?: BidContractRevisionDrawOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractRevisionDraw>;
export function newBidContractRevisionDraw(
  options: BidContractRevisionDrawOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContractRevisionDraw> {
  const o = (options.__typename ? options : cache["BidContractRevisionDraw"] = {}) as BidContractRevisionDraw;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContractRevisionDraw";
    o.id = options.id ?? nextFactoryId("BidContractRevisionDraw");
    o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
    o.isDeposit = options.isDeposit ?? false;
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.bidContractRevision = maybeNew(
      "BidContractRevision",
      options.bidContractRevision,
      cache,
      options.hasOwnProperty("bidContractRevision"),
    );
    o.globalPlanTask = maybeNewOrNull("GlobalPlanTask", options.globalPlanTask, cache);
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    return o as FactoryResult<BidContractRevisionDraw>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContractRevisionDraw"] = newBidContractRevisionDraw;

export interface BidContractTradeLineItemOptions {
  __typename?: "BidContractTradeLineItem";
  id?: BidContractTradeLineItem["id"];
  totalCostInCents?: BidContractTradeLineItem["totalCostInCents"];
  createdAt?: BidContractTradeLineItem["createdAt"];
  updatedAt?: BidContractTradeLineItem["updatedAt"];
  revision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  hasValidCost?: BidContractTradeLineItem["hasValidCost"];
  lineItems?: Array<FactoryInput<BidContractLineItem, BidContractLineItemOptions>>;
}

export function newBidContractTradeLineItem(
  options?: BidContractTradeLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractTradeLineItem>;
export function newBidContractTradeLineItem(
  options: BidContractTradeLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContractTradeLineItem> {
  const o = (options.__typename ? options : cache["BidContractTradeLineItem"] = {}) as BidContractTradeLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContractTradeLineItem";
    o.id = options.id ?? nextFactoryId("BidContractTradeLineItem");
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.revision = maybeNew("BidContractRevision", options.revision, cache, options.hasOwnProperty("revision"));
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.hasValidCost = options.hasValidCost ?? false;
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    return o as FactoryResult<BidContractTradeLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContractTradeLineItem"] = newBidContractTradeLineItem;

export interface SaveBidContractTradeLineItemsResultOptions {
  __typename?: "SaveBidContractTradeLineItemsResult";
  bidContractTradeLineItems?: Array<FactoryInput<BidContractTradeLineItem, BidContractTradeLineItemOptions>>;
}

export function newSaveBidContractTradeLineItemsResult(
  options?: SaveBidContractTradeLineItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidContractTradeLineItemsResult>;
export function newSaveBidContractTradeLineItemsResult(
  options: SaveBidContractTradeLineItemsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidContractTradeLineItemsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveBidContractTradeLineItemsResult"] = {}) as SaveBidContractTradeLineItemsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidContractTradeLineItemsResult";
    o.bidContractTradeLineItems = (options.bidContractTradeLineItems ?? []).map((i) =>
      maybeNew("BidContractTradeLineItem", i, cache, options.hasOwnProperty("bidContractTradeLineItems"))
    );
    return o as FactoryResult<SaveBidContractTradeLineItemsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidContractTradeLineItemsResult"] = newSaveBidContractTradeLineItemsResult;

export interface BidItemOptions {
  __typename?: "BidItem";
  id?: BidItem["id"];
  name?: BidItem["name"];
  code?: BidItem["code"];
  displayName?: BidItem["displayName"];
  createdAt?: BidItem["createdAt"];
  updatedAt?: BidItem["updatedAt"];
  costType?: CostTypeDetailOptions | CostType;
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  items?: Array<FactoryInput<Item, ItemOptions>>;
  bidContractLineItems?: Array<FactoryInput<BidContractLineItem, BidContractLineItemOptions>>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  parentMaterialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  parentTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  estimates?: Array<FactoryInput<BidItemEstimate, BidItemEstimateOptions>>;
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: BidItem["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: BidItem["isFollowed"];
}

export function newBidItem(options?: BidItemOptions, factoryOptions?: FactoryOptions): FactoryResult<BidItem>;
export function newBidItem(
  options: BidItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidItem> {
  const o = (options.__typename ? options : cache["BidItem"] = {}) as BidItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidItem";
    o.id = options.id ?? nextFactoryId("BidItem");
    o.name = options.name ?? "name";
    o.code = options.code ?? "code";
    o.displayName = options.displayName ?? "displayName";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costType = enumOrDetailOfCostType(options.costType);
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
    o.bidContractLineItems = (options.bidContractLineItems ?? []).map((i) =>
      maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("bidContractLineItems"))
    );
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.parentMaterialVariant = maybeNewOrNull("MaterialVariant", options.parentMaterialVariant, cache);
    o.parentTask = maybeNewOrNull("GlobalPlanTask", options.parentTask, cache);
    o.estimates = (options.estimates ?? []).map((i) =>
      maybeNew("BidItemEstimate", i, cache, options.hasOwnProperty("estimates"))
    );
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    return o as FactoryResult<BidItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidItem"] = newBidItem;

export interface BidItemsPageOptions {
  __typename?: "BidItemsPage";
  bidItems?: Array<FactoryInput<BidItem, BidItemOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newBidItemsPage(
  options?: BidItemsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidItemsPage>;
export function newBidItemsPage(
  options: BidItemsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidItemsPage> {
  const o = (options.__typename ? options : cache["BidItemsPage"] = {}) as BidItemsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidItemsPage";
    o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<BidItemsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidItemsPage"] = newBidItemsPage;

export interface SaveBidItemResultOptions {
  __typename?: "SaveBidItemResult";
  bidItem?: FactoryInput<BidItem, BidItemOptions>;
}

export function newSaveBidItemResult(
  options?: SaveBidItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidItemResult>;
export function newSaveBidItemResult(
  options: SaveBidItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidItemResult> {
  const o = (options.__typename ? options : cache["SaveBidItemResult"] = {}) as SaveBidItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidItemResult";
    o.bidItem = maybeNew("BidItem", options.bidItem, cache, options.hasOwnProperty("bidItem"));
    return o as FactoryResult<SaveBidItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidItemResult"] = newSaveBidItemResult;

export interface BidItemEstimateOptions {
  __typename?: "BidItemEstimate";
  id?: BidItemEstimate["id"];
  costInMills?: BidItemEstimate["costInMills"];
  sourceUrl?: BidItemEstimate["sourceUrl"];
  createdAt?: BidItemEstimate["createdAt"];
  updatedAt?: BidItemEstimate["updatedAt"];
  bidItem?: FactoryInput<BidItem, BidItemOptions>;
  createdBy?: FactoryInput<User, UserOptions>;
  markets?: Array<FactoryInput<Market, MarketOptions>>;
}

export function newBidItemEstimate(
  options?: BidItemEstimateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidItemEstimate>;
export function newBidItemEstimate(
  options: BidItemEstimateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidItemEstimate> {
  const o = (options.__typename ? options : cache["BidItemEstimate"] = {}) as BidItemEstimate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidItemEstimate";
    o.id = options.id ?? nextFactoryId("BidItemEstimate");
    o.costInMills = options.costInMills ?? 0;
    o.sourceUrl = options.sourceUrl ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.bidItem = maybeNew("BidItem", options.bidItem, cache, options.hasOwnProperty("bidItem"));
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
    return o as FactoryResult<BidItemEstimate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidItemEstimate"] = newBidItemEstimate;

export interface SaveBidItemEstimateResultOptions {
  __typename?: "SaveBidItemEstimateResult";
  bidItemEstimate?: FactoryInput<BidItemEstimate, BidItemEstimateOptions>;
}

export function newSaveBidItemEstimateResult(
  options?: SaveBidItemEstimateResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidItemEstimateResult>;
export function newSaveBidItemEstimateResult(
  options: SaveBidItemEstimateResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidItemEstimateResult> {
  const o = (options.__typename ? options : cache["SaveBidItemEstimateResult"] = {}) as SaveBidItemEstimateResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidItemEstimateResult";
    o.bidItemEstimate = maybeNew(
      "BidItemEstimate",
      options.bidItemEstimate,
      cache,
      options.hasOwnProperty("bidItemEstimate"),
    );
    return o as FactoryResult<SaveBidItemEstimateResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidItemEstimateResult"] = newSaveBidItemEstimateResult;

export interface BidItemEstimatesPageResultOptions {
  __typename?: "BidItemEstimatesPageResult";
  entities?: Array<FactoryInput<BidItemEstimate, BidItemEstimateOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newBidItemEstimatesPageResult(
  options?: BidItemEstimatesPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidItemEstimatesPageResult>;
export function newBidItemEstimatesPageResult(
  options: BidItemEstimatesPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidItemEstimatesPageResult> {
  const o = (options.__typename ? options : cache["BidItemEstimatesPageResult"] = {}) as BidItemEstimatesPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidItemEstimatesPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("BidItemEstimate", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<BidItemEstimatesPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidItemEstimatesPageResult"] = newBidItemEstimatesPageResult;

export interface MigrateBidPackageCostsResultOptions {
  __typename?: "MigrateBidPackageCostsResult";
  trackedJob?: FactoryInput<TrackedJob, TrackedJobOptions>;
}

export function newMigrateBidPackageCostsResult(
  options?: MigrateBidPackageCostsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MigrateBidPackageCostsResult>;
export function newMigrateBidPackageCostsResult(
  options: MigrateBidPackageCostsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MigrateBidPackageCostsResult> {
  const o = (options.__typename ? options : cache["MigrateBidPackageCostsResult"] = {}) as MigrateBidPackageCostsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MigrateBidPackageCostsResult";
    o.trackedJob = maybeNew("TrackedJob", options.trackedJob, cache, options.hasOwnProperty("trackedJob"));
    return o as FactoryResult<MigrateBidPackageCostsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MigrateBidPackageCostsResult"] = newMigrateBidPackageCostsResult;

export interface BidPackageOptions {
  __typename?: "BidPackage";
  id?: BidPackage["id"];
  name?: BidPackage["name"];
  costCodesName?: BidPackage["costCodesName"];
  createdAt?: BidPackage["createdAt"];
  updatedAt?: BidPackage["updatedAt"];
  productOfferings?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  status?: BidPackageStatusDetailOptions | BidPackageStatus;
  lineItems?: Array<FactoryInput<BidPackageLineItem, BidPackageLineItemOptions>>;
  requests?: Array<FactoryInput<BidPackageRequest, BidPackageRequestOptions>>;
  potentialBidPackageLineItems?: Array<FactoryInput<BidItem, BidItemOptions>>;
  bidPackageGroup?: FactoryInput<BidPackageGroup, BidPackageGroupOptions> | null;
  scopeLines?: Array<FactoryInput<BidPackageScopeLine, BidPackageScopeLineOptions>>;
  awards?: Array<FactoryInput<BidPackageAward, BidPackageAwardOptions>>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  costType?: CostTypeDetailOptions | CostType;
  basePlanGlobalPlanTasks?: Array<FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>>;
  isUnitBased?: BidPackage["isUnitBased"];
  versions?: Array<FactoryInput<BidPackageVersion, BidPackageVersionOptions>>;
  latestVersion?: FactoryInput<BidPackageVersion, BidPackageVersionOptions>;
  canComplete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  versionNotes?: BidPackage["versionNotes"];
  availableUpdates?: Array<FactoryInput<BidPackageIncomingUpdate, BidPackageIncomingUpdateOptions>>;
  activeRequests?: Array<FactoryInput<BidPackageRequest, BidPackageRequestOptions>>;
  activeBidders?: Array<FactoryInput<BidPackageBidder, BidPackageBidderOptions>>;
  bidders?: Array<FactoryInput<BidPackageBidder, BidPackageBidderOptions>>;
  scopeHasChanged?: BidPackage["scopeHasChanged"];
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canReviseCosts?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  relevantMarket?: FactoryInput<Market, MarketOptions>;
  primaryHomeboundUser?: FactoryInput<User, UserOptions> | null;
  secondaryHomeboundUsers?: Array<FactoryInput<User, UserOptions>>;
  overlappingBidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  latestAwards?: Array<FactoryInput<BidPackageAward, BidPackageAwardOptions>>;
  isPlanBasedV2?: BidPackage["isPlanBasedV2"];
  internalEstimateBidContract?: FactoryInput<BidContract, BidContractOptions> | null;
  archivedAt?: BidPackage["archivedAt"];
  lastAwardedAt?: BidPackage["lastAwardedAt"];
  bidPlanGroups?: Array<FactoryInput<BidPlanGroup, BidPlanGroupOptions>>;
  scopedLineItems?: Array<FactoryInput<BidPlanChildGroupScopedLine, BidPlanChildGroupScopedLineOptions>>;
  potentialBidPlanOptions?: Array<FactoryInput<PotentialBidPlanOption, PotentialBidPlanOptionOptions>>;
  optionsMissingFromPackage?: Array<FactoryInput<MissingBidPlanOption, MissingBidPlanOptionOptions>>;
  isMissingOptions?: BidPackage["isMissingOptions"];
  costCodeBidSummaries?: Array<FactoryInput<CostCodeBidSummary, CostCodeBidSummaryOptions>>;
  isMissingCosts?: BidPackage["isMissingCosts"];
  productOfferingSummaries?: Array<
    FactoryInput<BidPackageProductOfferingSummary, BidPackageProductOfferingSummaryOptions>
  >;
  primaryContract?: FactoryInput<BidContract, BidContractOptions> | null;
}

export function newBidPackage(options?: BidPackageOptions, factoryOptions?: FactoryOptions): FactoryResult<BidPackage>;
export function newBidPackage(
  options: BidPackageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackage> {
  const o = (options.__typename ? options : cache["BidPackage"] = {}) as BidPackage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackage";
    o.id = options.id ?? nextFactoryId("BidPackage");
    o.name = options.name ?? "name";
    o.costCodesName = options.costCodesName ?? "costCodesName";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.productOfferings = (options.productOfferings ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
    );
    o.status = enumOrDetailOfBidPackageStatus(options.status);
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("BidPackageLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.requests = (options.requests ?? []).map((i) =>
      maybeNew("BidPackageRequest", i, cache, options.hasOwnProperty("requests"))
    );
    o.potentialBidPackageLineItems = (options.potentialBidPackageLineItems ?? []).map((i) =>
      maybeNew("BidItem", i, cache, options.hasOwnProperty("potentialBidPackageLineItems"))
    );
    o.bidPackageGroup = maybeNewOrNull("BidPackageGroup", options.bidPackageGroup, cache);
    o.scopeLines = (options.scopeLines ?? []).map((i) =>
      maybeNew("BidPackageScopeLine", i, cache, options.hasOwnProperty("scopeLines"))
    );
    o.awards = (options.awards ?? []).map((i) =>
      maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("awards"))
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.costType = enumOrDetailOfCostType(options.costType);
    o.basePlanGlobalPlanTasks = (options.basePlanGlobalPlanTasks ?? []).map((i) =>
      maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("basePlanGlobalPlanTasks"))
    );
    o.isUnitBased = options.isUnitBased ?? false;
    o.versions = (options.versions ?? []).map((i) =>
      maybeNew("BidPackageVersion", i, cache, options.hasOwnProperty("versions"))
    );
    o.latestVersion = maybeNew(
      "BidPackageVersion",
      options.latestVersion,
      cache,
      options.hasOwnProperty("latestVersion"),
    );
    o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
    o.versionNotes = options.versionNotes ?? null;
    o.availableUpdates = (options.availableUpdates ?? []).map((i) =>
      maybeNew("BidPackageIncomingUpdate", i, cache, options.hasOwnProperty("availableUpdates"))
    );
    o.activeRequests = (options.activeRequests ?? []).map((i) =>
      maybeNew("BidPackageRequest", i, cache, options.hasOwnProperty("activeRequests"))
    );
    o.activeBidders = (options.activeBidders ?? []).map((i) =>
      maybeNew("BidPackageBidder", i, cache, options.hasOwnProperty("activeBidders"))
    );
    o.bidders = (options.bidders ?? []).map((i) =>
      maybeNew("BidPackageBidder", i, cache, options.hasOwnProperty("bidders"))
    );
    o.scopeHasChanged = options.scopeHasChanged ?? false;
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.canReviseCosts = maybeNew(
      "PotentialOperation2",
      options.canReviseCosts,
      cache,
      options.hasOwnProperty("canReviseCosts"),
    );
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    o.relevantMarket = maybeNew("Market", options.relevantMarket, cache, options.hasOwnProperty("relevantMarket"));
    o.primaryHomeboundUser = maybeNewOrNull("User", options.primaryHomeboundUser, cache);
    o.secondaryHomeboundUsers = (options.secondaryHomeboundUsers ?? []).map((i) =>
      maybeNew("User", i, cache, options.hasOwnProperty("secondaryHomeboundUsers"))
    );
    o.overlappingBidPackages = (options.overlappingBidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("overlappingBidPackages"))
    );
    o.latestAwards = (options.latestAwards ?? []).map((i) =>
      maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("latestAwards"))
    );
    o.isPlanBasedV2 = options.isPlanBasedV2 ?? false;
    o.internalEstimateBidContract = maybeNewOrNull("BidContract", options.internalEstimateBidContract, cache);
    o.archivedAt = options.archivedAt ?? null;
    o.lastAwardedAt = options.lastAwardedAt ?? null;
    o.bidPlanGroups = (options.bidPlanGroups ?? []).map((i) =>
      maybeNew("BidPlanGroup", i, cache, options.hasOwnProperty("bidPlanGroups"))
    );
    o.scopedLineItems = (options.scopedLineItems ?? []).map((i) =>
      maybeNew("BidPlanChildGroupScopedLine", i, cache, options.hasOwnProperty("scopedLineItems"))
    );
    o.potentialBidPlanOptions = (options.potentialBidPlanOptions ?? []).map((i) =>
      maybeNew("PotentialBidPlanOption", i, cache, options.hasOwnProperty("potentialBidPlanOptions"))
    );
    o.optionsMissingFromPackage = (options.optionsMissingFromPackage ?? []).map((i) =>
      maybeNew("MissingBidPlanOption", i, cache, options.hasOwnProperty("optionsMissingFromPackage"))
    );
    o.isMissingOptions = options.isMissingOptions ?? false;
    o.costCodeBidSummaries = (options.costCodeBidSummaries ?? []).map((i) =>
      maybeNew("CostCodeBidSummary", i, cache, options.hasOwnProperty("costCodeBidSummaries"))
    );
    o.isMissingCosts = options.isMissingCosts ?? false;
    o.productOfferingSummaries = (options.productOfferingSummaries ?? []).map((i) =>
      maybeNew("BidPackageProductOfferingSummary", i, cache, options.hasOwnProperty("productOfferingSummaries"))
    );
    o.primaryContract = maybeNewOrNull("BidContract", options.primaryContract, cache);
    return o as FactoryResult<BidPackage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackage"] = newBidPackage;

export interface BidPackageProductOfferingSummaryOptions {
  __typename?: "BidPackageProductOfferingSummary";
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  missingCostCount?: BidPackageProductOfferingSummary["missingCostCount"];
}

export function newBidPackageProductOfferingSummary(
  options?: BidPackageProductOfferingSummaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageProductOfferingSummary>;
export function newBidPackageProductOfferingSummary(
  options: BidPackageProductOfferingSummaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageProductOfferingSummary> {
  const o =
    (options.__typename ? options : cache["BidPackageProductOfferingSummary"] = {}) as BidPackageProductOfferingSummary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageProductOfferingSummary";
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    o.missingCostCount = options.missingCostCount ?? 0;
    return o as FactoryResult<BidPackageProductOfferingSummary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageProductOfferingSummary"] = newBidPackageProductOfferingSummary;

export interface PotentialBidPlanOptionOptions {
  __typename?: "PotentialBidPlanOption";
  globalOption?: FactoryInput<GlobalOption, GlobalOptionOptions>;
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
}

export function newPotentialBidPlanOption(
  options?: PotentialBidPlanOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PotentialBidPlanOption>;
export function newPotentialBidPlanOption(
  options: PotentialBidPlanOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialBidPlanOption> {
  const o = (options.__typename ? options : cache["PotentialBidPlanOption"] = {}) as PotentialBidPlanOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PotentialBidPlanOption";
    o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    return o as FactoryResult<PotentialBidPlanOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PotentialBidPlanOption"] = newPotentialBidPlanOption;

export interface MissingBidPlanOptionOptions {
  __typename?: "MissingBidPlanOption";
  globalOption?: FactoryInput<GlobalOption, GlobalOptionOptions>;
  productOfferings?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
}

export function newMissingBidPlanOption(
  options?: MissingBidPlanOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MissingBidPlanOption>;
export function newMissingBidPlanOption(
  options: MissingBidPlanOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MissingBidPlanOption> {
  const o = (options.__typename ? options : cache["MissingBidPlanOption"] = {}) as MissingBidPlanOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MissingBidPlanOption";
    o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
    o.productOfferings = (options.productOfferings ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
    );
    return o as FactoryResult<MissingBidPlanOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MissingBidPlanOption"] = newMissingBidPlanOption;

export interface BidPackageScopeLineOptions {
  __typename?: "BidPackageScopeLine";
  takeoffLineItemVersion?: FactoryInput<TakeoffLineItemVersion, TakeoffLineItemVersionOptions>;
  changeType?: BidPackageScopeLine["changeType"];
  previous?: FactoryInput<TakeoffLineItemVersion, TakeoffLineItemVersionOptions> | null;
}

export function newBidPackageScopeLine(
  options?: BidPackageScopeLineOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageScopeLine>;
export function newBidPackageScopeLine(
  options: BidPackageScopeLineOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageScopeLine> {
  const o = (options.__typename ? options : cache["BidPackageScopeLine"] = {}) as BidPackageScopeLine;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageScopeLine";
    o.takeoffLineItemVersion = maybeNew(
      "TakeoffLineItemVersion",
      options.takeoffLineItemVersion,
      cache,
      options.hasOwnProperty("takeoffLineItemVersion"),
    );
    o.changeType = options.changeType ?? null;
    o.previous = maybeNewOrNull("TakeoffLineItemVersion", options.previous, cache);
    return o as FactoryResult<BidPackageScopeLine>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageScopeLine"] = newBidPackageScopeLine;

export interface BidPackagesPageResultOptions {
  __typename?: "BidPackagesPageResult";
  entities?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newBidPackagesPageResult(
  options?: BidPackagesPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackagesPageResult>;
export function newBidPackagesPageResult(
  options: BidPackagesPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackagesPageResult> {
  const o = (options.__typename ? options : cache["BidPackagesPageResult"] = {}) as BidPackagesPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackagesPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<BidPackagesPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackagesPageResult"] = newBidPackagesPageResult;

export interface SaveBidPackageResultOptions {
  __typename?: "SaveBidPackageResult";
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newSaveBidPackageResult(
  options?: SaveBidPackageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidPackageResult>;
export function newSaveBidPackageResult(
  options: SaveBidPackageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidPackageResult> {
  const o = (options.__typename ? options : cache["SaveBidPackageResult"] = {}) as SaveBidPackageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidPackageResult";
    o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
    return o as FactoryResult<SaveBidPackageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidPackageResult"] = newSaveBidPackageResult;

export interface SaveBidPackagesResultOptions {
  __typename?: "SaveBidPackagesResult";
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
}

export function newSaveBidPackagesResult(
  options?: SaveBidPackagesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidPackagesResult>;
export function newSaveBidPackagesResult(
  options: SaveBidPackagesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidPackagesResult> {
  const o = (options.__typename ? options : cache["SaveBidPackagesResult"] = {}) as SaveBidPackagesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidPackagesResult";
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    return o as FactoryResult<SaveBidPackagesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidPackagesResult"] = newSaveBidPackagesResult;

export interface PreviewSaveBidPackageResultOptions {
  __typename?: "PreviewSaveBidPackageResult";
  removedCostedLines?: Array<FactoryInput<BidPlanChildGroupLine, BidPlanChildGroupLineOptions>>;
}

export function newPreviewSaveBidPackageResult(
  options?: PreviewSaveBidPackageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PreviewSaveBidPackageResult>;
export function newPreviewSaveBidPackageResult(
  options: PreviewSaveBidPackageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PreviewSaveBidPackageResult> {
  const o = (options.__typename ? options : cache["PreviewSaveBidPackageResult"] = {}) as PreviewSaveBidPackageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PreviewSaveBidPackageResult";
    o.removedCostedLines = (options.removedCostedLines ?? []).map((i) =>
      maybeNew("BidPlanChildGroupLine", i, cache, options.hasOwnProperty("removedCostedLines"))
    );
    return o as FactoryResult<PreviewSaveBidPackageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PreviewSaveBidPackageResult"] = newPreviewSaveBidPackageResult;

export interface OverlappingBidPackagesResultOptions {
  __typename?: "OverlappingBidPackagesResult";
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
}

export function newOverlappingBidPackagesResult(
  options?: OverlappingBidPackagesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<OverlappingBidPackagesResult>;
export function newOverlappingBidPackagesResult(
  options: OverlappingBidPackagesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<OverlappingBidPackagesResult> {
  const o = (options.__typename ? options : cache["OverlappingBidPackagesResult"] = {}) as OverlappingBidPackagesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "OverlappingBidPackagesResult";
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    return o as FactoryResult<OverlappingBidPackagesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["OverlappingBidPackagesResult"] = newOverlappingBidPackagesResult;

export interface ReviseBidPackageCostsResultOptions {
  __typename?: "ReviseBidPackageCostsResult";
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newReviseBidPackageCostsResult(
  options?: ReviseBidPackageCostsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReviseBidPackageCostsResult>;
export function newReviseBidPackageCostsResult(
  options: ReviseBidPackageCostsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReviseBidPackageCostsResult> {
  const o = (options.__typename ? options : cache["ReviseBidPackageCostsResult"] = {}) as ReviseBidPackageCostsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReviseBidPackageCostsResult";
    o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
    return o as FactoryResult<ReviseBidPackageCostsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReviseBidPackageCostsResult"] = newReviseBidPackageCostsResult;

export interface PotentialBidPlanDimensionResultOptions {
  __typename?: "PotentialBidPlanDimensionResult";
  id?: PotentialBidPlanDimensionResult["id"];
  kind?: PotentialBidPlanDimensionResult["kind"];
  type?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions> | null;
  group?: FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions> | null;
  options?: Array<FactoryInput<GlobalOption, GlobalOptionOptions>>;
  productOfferings?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  displayName?: PotentialBidPlanDimensionResult["displayName"];
}

export function newPotentialBidPlanDimensionResult(
  options?: PotentialBidPlanDimensionResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PotentialBidPlanDimensionResult>;
export function newPotentialBidPlanDimensionResult(
  options: PotentialBidPlanDimensionResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialBidPlanDimensionResult> {
  const o =
    (options.__typename ? options : cache["PotentialBidPlanDimensionResult"] = {}) as PotentialBidPlanDimensionResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PotentialBidPlanDimensionResult";
    o.id = options.id ?? nextFactoryId("PotentialBidPlanDimensionResult");
    o.kind = options.kind ?? PotentialBidPlanDimensionKind.GlobalOptionType;
    o.type = maybeNewOrNull("GlobalOptionType", options.type, cache);
    o.group = maybeNewOrNull("GlobalOptionGroup", options.group, cache);
    o.options = (options.options ?? []).map((i) =>
      maybeNew("GlobalOption", i, cache, options.hasOwnProperty("options"))
    );
    o.productOfferings = (options.productOfferings ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
    );
    o.displayName = options.displayName ?? "displayName";
    return o as FactoryResult<PotentialBidPlanDimensionResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PotentialBidPlanDimensionResult"] = newPotentialBidPlanDimensionResult;

export interface BidPackageBidderOptions {
  __typename?: "BidPackageBidder";
  id?: BidPackageBidder["id"];
  name?: BidPackageBidder["name"];
  kind?: BidPackageBidder["kind"];
  bidContract?: FactoryInput<BidContract, BidContractOptions> | null;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  request?: FactoryInput<BidPackageRequest, BidPackageRequestOptions> | null;
  archivedAt?: BidPackageBidder["archivedAt"];
  hasCosts?: BidPackageBidder["hasCosts"];
}

export function newBidPackageBidder(
  options?: BidPackageBidderOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageBidder>;
export function newBidPackageBidder(
  options: BidPackageBidderOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageBidder> {
  const o = (options.__typename ? options : cache["BidPackageBidder"] = {}) as BidPackageBidder;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageBidder";
    o.id = options.id ?? nextFactoryId("BidPackageBidder");
    o.name = options.name ?? "name";
    o.kind = options.kind ?? BidPackageBidderKind.TradeRequest;
    o.bidContract = maybeNewOrNull("BidContract", options.bidContract, cache);
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.request = maybeNewOrNull("BidPackageRequest", options.request, cache);
    o.archivedAt = options.archivedAt ?? null;
    o.hasCosts = options.hasCosts ?? false;
    return o as FactoryResult<BidPackageBidder>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageBidder"] = newBidPackageBidder;

export interface BidPlanChildGroupScopedLineOptions {
  __typename?: "BidPlanChildGroupScopedLine";
  id?: BidPlanChildGroupScopedLine["id"];
  group?: FactoryInput<BidPlanGroup, BidPlanGroupOptions>;
  childGroup?: FactoryInput<BidPlanChildGroup, BidPlanChildGroupOptions>;
  groupLine?: FactoryInput<BidPlanChildGroupLine, BidPlanChildGroupLineOptions> | null;
  scopeLines?: Array<FactoryInput<BidPackageScopeLine, BidPackageScopeLineOptions>>;
}

export function newBidPlanChildGroupScopedLine(
  options?: BidPlanChildGroupScopedLineOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPlanChildGroupScopedLine>;
export function newBidPlanChildGroupScopedLine(
  options: BidPlanChildGroupScopedLineOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPlanChildGroupScopedLine> {
  const o = (options.__typename ? options : cache["BidPlanChildGroupScopedLine"] = {}) as BidPlanChildGroupScopedLine;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPlanChildGroupScopedLine";
    o.id = options.id ?? nextFactoryId("BidPlanChildGroupScopedLine");
    o.group = maybeNew("BidPlanGroup", options.group, cache, options.hasOwnProperty("group"));
    o.childGroup = maybeNew("BidPlanChildGroup", options.childGroup, cache, options.hasOwnProperty("childGroup"));
    o.groupLine = maybeNewOrNull("BidPlanChildGroupLine", options.groupLine, cache);
    o.scopeLines = (options.scopeLines ?? []).map((i) =>
      maybeNew("BidPackageScopeLine", i, cache, options.hasOwnProperty("scopeLines"))
    );
    return o as FactoryResult<BidPlanChildGroupScopedLine>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPlanChildGroupScopedLine"] = newBidPlanChildGroupScopedLine;

export interface BidPackageAwardOptions {
  __typename?: "BidPackageAward";
  id?: BidPackageAward["id"];
  createdAt?: BidPackageAward["createdAt"];
  updatedAt?: BidPackageAward["updatedAt"];
  primaryRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  secondaryRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions> | null;
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  bidPackageVersion?: FactoryInput<BidPackageVersion, BidPackageVersionOptions> | null;
}

export function newBidPackageAward(
  options?: BidPackageAwardOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageAward>;
export function newBidPackageAward(
  options: BidPackageAwardOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageAward> {
  const o = (options.__typename ? options : cache["BidPackageAward"] = {}) as BidPackageAward;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageAward";
    o.id = options.id ?? nextFactoryId("BidPackageAward");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.primaryRevision = maybeNew(
      "BidContractRevision",
      options.primaryRevision,
      cache,
      options.hasOwnProperty("primaryRevision"),
    );
    o.secondaryRevision = maybeNewOrNull("BidContractRevision", options.secondaryRevision, cache);
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.bidPackageVersion = maybeNewOrNull("BidPackageVersion", options.bidPackageVersion, cache);
    return o as FactoryResult<BidPackageAward>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageAward"] = newBidPackageAward;

export interface SaveBidPackageAwardsResultOptions {
  __typename?: "SaveBidPackageAwardsResult";
  bidPackageAwards?: Array<FactoryInput<BidPackageAward, BidPackageAwardOptions>>;
}

export function newSaveBidPackageAwardsResult(
  options?: SaveBidPackageAwardsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidPackageAwardsResult>;
export function newSaveBidPackageAwardsResult(
  options: SaveBidPackageAwardsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidPackageAwardsResult> {
  const o = (options.__typename ? options : cache["SaveBidPackageAwardsResult"] = {}) as SaveBidPackageAwardsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidPackageAwardsResult";
    o.bidPackageAwards = (options.bidPackageAwards ?? []).map((i) =>
      maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("bidPackageAwards"))
    );
    return o as FactoryResult<SaveBidPackageAwardsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidPackageAwardsResult"] = newSaveBidPackageAwardsResult;

export interface BidPackageGroupOptions {
  __typename?: "BidPackageGroup";
  id?: BidPackageGroup["id"];
  createdAt?: BidPackageGroup["createdAt"];
  updatedAt?: BidPackageGroup["updatedAt"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  displayName?: BidPackageGroup["displayName"];
  productOfferings?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  status?: BidPackageStatusDetailOptions | BidPackageStatus;
  isPlanBasedV2?: BidPackageGroup["isPlanBasedV2"];
}

export function newBidPackageGroup(
  options?: BidPackageGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageGroup>;
export function newBidPackageGroup(
  options: BidPackageGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageGroup> {
  const o = (options.__typename ? options : cache["BidPackageGroup"] = {}) as BidPackageGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageGroup";
    o.id = options.id ?? nextFactoryId("BidPackageGroup");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.displayName = options.displayName ?? "displayName";
    o.productOfferings = (options.productOfferings ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
    );
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    o.status = enumOrDetailOfBidPackageStatus(options.status);
    o.isPlanBasedV2 = options.isPlanBasedV2 ?? false;
    return o as FactoryResult<BidPackageGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageGroup"] = newBidPackageGroup;

export interface BidPackageGroupProductOfferingsResultOptions {
  __typename?: "BidPackageGroupProductOfferingsResult";
  productOfferingInfos?: Array<FactoryInput<ProductOfferingInfo, ProductOfferingInfoOptions>>;
}

export function newBidPackageGroupProductOfferingsResult(
  options?: BidPackageGroupProductOfferingsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageGroupProductOfferingsResult>;
export function newBidPackageGroupProductOfferingsResult(
  options: BidPackageGroupProductOfferingsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageGroupProductOfferingsResult> {
  const o =
    (options.__typename
      ? options
      : cache["BidPackageGroupProductOfferingsResult"] = {}) as BidPackageGroupProductOfferingsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageGroupProductOfferingsResult";
    o.productOfferingInfos = (options.productOfferingInfos ?? []).map((i) =>
      maybeNew("ProductOfferingInfo", i, cache, options.hasOwnProperty("productOfferingInfos"))
    );
    return o as FactoryResult<BidPackageGroupProductOfferingsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageGroupProductOfferingsResult"] = newBidPackageGroupProductOfferingsResult;

export interface ProductOfferingInfoOptions {
  __typename?: "ProductOfferingInfo";
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
  numberOfLineItems?: ProductOfferingInfo["numberOfLineItems"];
  relevantOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
}

export function newProductOfferingInfo(
  options?: ProductOfferingInfoOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingInfo>;
export function newProductOfferingInfo(
  options: ProductOfferingInfoOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOfferingInfo> {
  const o = (options.__typename ? options : cache["ProductOfferingInfo"] = {}) as ProductOfferingInfo;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOfferingInfo";
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
    o.numberOfLineItems = options.numberOfLineItems ?? 0;
    o.relevantOptions = (options.relevantOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("relevantOptions"))
    );
    return o as FactoryResult<ProductOfferingInfo>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOfferingInfo"] = newProductOfferingInfo;

export interface BidPackageGroupsPageResultOptions {
  __typename?: "BidPackageGroupsPageResult";
  entities?: Array<FactoryInput<BidPackageGroup, BidPackageGroupOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newBidPackageGroupsPageResult(
  options?: BidPackageGroupsPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageGroupsPageResult>;
export function newBidPackageGroupsPageResult(
  options: BidPackageGroupsPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageGroupsPageResult> {
  const o = (options.__typename ? options : cache["BidPackageGroupsPageResult"] = {}) as BidPackageGroupsPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageGroupsPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("BidPackageGroup", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<BidPackageGroupsPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageGroupsPageResult"] = newBidPackageGroupsPageResult;

export interface BidPackageIncomingUpdateOptions {
  __typename?: "BidPackageIncomingUpdate";
  id?: BidPackageIncomingUpdate["id"];
  accepted?: BidPackageIncomingUpdate["accepted"];
  createdAt?: BidPackageIncomingUpdate["createdAt"];
  updatedAt?: BidPackageIncomingUpdate["updatedAt"];
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
  source?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  updateStats?: FactoryInput<BidPackageIncomingUpdateStats, BidPackageIncomingUpdateStatsOptions>;
}

export function newBidPackageIncomingUpdate(
  options?: BidPackageIncomingUpdateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageIncomingUpdate>;
export function newBidPackageIncomingUpdate(
  options: BidPackageIncomingUpdateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageIncomingUpdate> {
  const o = (options.__typename ? options : cache["BidPackageIncomingUpdate"] = {}) as BidPackageIncomingUpdate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageIncomingUpdate";
    o.id = options.id ?? nextFactoryId("BidPackageIncomingUpdate");
    o.accepted = options.accepted ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
    o.source = maybeNew("ReadyPlanAggregateVersion", options.source, cache, options.hasOwnProperty("source"));
    o.updateStats = maybeNew(
      "BidPackageIncomingUpdateStats",
      options.updateStats,
      cache,
      options.hasOwnProperty("updateStats"),
    );
    return o as FactoryResult<BidPackageIncomingUpdate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageIncomingUpdate"] = newBidPackageIncomingUpdate;

export interface BidPackageIncomingUpdateStatsOptions {
  __typename?: "BidPackageIncomingUpdateStats";
  tlivs?: FactoryInput<IncomingChanges, IncomingChangesOptions>;
  rplvs?: FactoryInput<IncomingChanges, IncomingChangesOptions>;
}

export function newBidPackageIncomingUpdateStats(
  options?: BidPackageIncomingUpdateStatsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageIncomingUpdateStats>;
export function newBidPackageIncomingUpdateStats(
  options: BidPackageIncomingUpdateStatsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageIncomingUpdateStats> {
  const o =
    (options.__typename ? options : cache["BidPackageIncomingUpdateStats"] = {}) as BidPackageIncomingUpdateStats;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageIncomingUpdateStats";
    o.tlivs = maybeNew("IncomingChanges", options.tlivs, cache, options.hasOwnProperty("tlivs"));
    o.rplvs = maybeNew("IncomingChanges", options.rplvs, cache, options.hasOwnProperty("rplvs"));
    return o as FactoryResult<BidPackageIncomingUpdateStats>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageIncomingUpdateStats"] = newBidPackageIncomingUpdateStats;

export interface IncomingChangesOptions {
  __typename?: "IncomingChanges";
  added?: IncomingChanges["added"];
  removed?: IncomingChanges["removed"];
  updated?: IncomingChanges["updated"];
}

export function newIncomingChanges(
  options?: IncomingChangesOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<IncomingChanges>;
export function newIncomingChanges(
  options: IncomingChangesOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<IncomingChanges> {
  const o = (options.__typename ? options : cache["IncomingChanges"] = {}) as IncomingChanges;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "IncomingChanges";
    o.added = options.added ?? 0;
    o.removed = options.removed ?? 0;
    o.updated = options.updated ?? 0;
    return o as FactoryResult<IncomingChanges>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["IncomingChanges"] = newIncomingChanges;

export interface BidPackageLineItemOptions {
  __typename?: "BidPackageLineItem";
  id?: BidPackageLineItem["id"];
  createdAt?: BidPackageLineItem["createdAt"];
  updatedAt?: BidPackageLineItem["updatedAt"];
  bidItem?: FactoryInput<BidItem, BidItemOptions>;
  bidPackageVersion?: FactoryInput<BidPackageVersion, BidPackageVersionOptions> | null;
  isInUse?: BidPackageLineItem["isInUse"];
  hasBidderCost?: BidPackageLineItem["hasBidderCost"];
  isMissingCost?: BidPackageLineItem["isMissingCost"];
}

export function newBidPackageLineItem(
  options?: BidPackageLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageLineItem>;
export function newBidPackageLineItem(
  options: BidPackageLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageLineItem> {
  const o = (options.__typename ? options : cache["BidPackageLineItem"] = {}) as BidPackageLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageLineItem";
    o.id = options.id ?? nextFactoryId("BidPackageLineItem");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.bidItem = maybeNew("BidItem", options.bidItem, cache, options.hasOwnProperty("bidItem"));
    o.bidPackageVersion = maybeNewOrNull("BidPackageVersion", options.bidPackageVersion, cache);
    o.isInUse = options.isInUse ?? false;
    o.hasBidderCost = options.hasBidderCost ?? false;
    o.isMissingCost = options.isMissingCost ?? false;
    return o as FactoryResult<BidPackageLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageLineItem"] = newBidPackageLineItem;

export interface BidPackageRequestOptions {
  __typename?: "BidPackageRequest";
  id?: BidPackageRequest["id"];
  name?: BidPackageRequest["name"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  createdAt?: BidPackageRequest["createdAt"];
  updatedAt?: BidPackageRequest["updatedAt"];
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  primaryContact?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  secondaryContact?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  bidContract?: FactoryInput<BidContract, BidContractOptions> | null;
  sentDate?: BidPackageRequest["sentDate"];
  archivedAt?: BidPackageRequest["archivedAt"];
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: BidPackageRequest["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: BidPackageRequest["isFollowed"];
}

export function newBidPackageRequest(
  options?: BidPackageRequestOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageRequest>;
export function newBidPackageRequest(
  options: BidPackageRequestOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageRequest> {
  const o = (options.__typename ? options : cache["BidPackageRequest"] = {}) as BidPackageRequest;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageRequest";
    o.id = options.id ?? nextFactoryId("BidPackageRequest");
    o.name = options.name ?? "name";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.primaryContact = maybeNewOrNull("TradePartnerContact", options.primaryContact, cache);
    o.secondaryContact = maybeNewOrNull("TradePartnerContact", options.secondaryContact, cache);
    o.bidContract = maybeNewOrNull("BidContract", options.bidContract, cache);
    o.sentDate = options.sentDate ?? null;
    o.archivedAt = options.archivedAt ?? null;
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    return o as FactoryResult<BidPackageRequest>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageRequest"] = newBidPackageRequest;

export interface SaveBidPackageRequestResultOptions {
  __typename?: "SaveBidPackageRequestResult";
  bidPackageRequest?: FactoryInput<BidPackageRequest, BidPackageRequestOptions>;
}

export function newSaveBidPackageRequestResult(
  options?: SaveBidPackageRequestResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBidPackageRequestResult>;
export function newSaveBidPackageRequestResult(
  options: SaveBidPackageRequestResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBidPackageRequestResult> {
  const o = (options.__typename ? options : cache["SaveBidPackageRequestResult"] = {}) as SaveBidPackageRequestResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBidPackageRequestResult";
    o.bidPackageRequest = maybeNew(
      "BidPackageRequest",
      options.bidPackageRequest,
      cache,
      options.hasOwnProperty("bidPackageRequest"),
    );
    return o as FactoryResult<SaveBidPackageRequestResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBidPackageRequestResult"] = newSaveBidPackageRequestResult;

export interface BidPackageVersionOptions {
  __typename?: "BidPackageVersion";
  id?: BidPackageVersion["id"];
  createdAt?: BidPackageVersion["createdAt"];
  updatedAt?: BidPackageVersion["updatedAt"];
  displayVersion?: BidPackageVersion["displayVersion"];
  version?: BidPackageVersion["version"];
  status?: BidPackageStatusDetailOptions | BidPackageStatus;
  readyPlanAggregateVersions?: Array<FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>>;
  previous?: FactoryInput<BidPackageVersion, BidPackageVersionOptions> | null;
  lineItems?: Array<FactoryInput<BidPackageLineItem, BidPackageLineItemOptions>>;
  latestBidContractRevisions?: Array<FactoryInput<BidContractRevision, BidContractRevisionOptions>>;
  relevantTakeoffLineItemVersions?: Array<FactoryInput<TakeoffLineItemVersion, TakeoffLineItemVersionOptions>>;
  scopeLines?: Array<FactoryInput<BidPackageScopeLine, BidPackageScopeLineOptions>>;
  basePlanGlobalPlanTasks?: Array<FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>>;
  awards?: Array<FactoryInput<BidPackageAward, BidPackageAwardOptions>>;
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
  canComplete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveDraws?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
}

export function newBidPackageVersion(
  options?: BidPackageVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageVersion>;
export function newBidPackageVersion(
  options: BidPackageVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageVersion> {
  const o = (options.__typename ? options : cache["BidPackageVersion"] = {}) as BidPackageVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageVersion";
    o.id = options.id ?? nextFactoryId("BidPackageVersion");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.displayVersion = options.displayVersion ?? "displayVersion";
    o.version = options.version ?? 0;
    o.status = enumOrDetailOfBidPackageStatus(options.status);
    o.readyPlanAggregateVersions = (options.readyPlanAggregateVersions ?? []).map((i) =>
      maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("readyPlanAggregateVersions"))
    );
    o.previous = maybeNewOrNull("BidPackageVersion", options.previous, cache);
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("BidPackageLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.latestBidContractRevisions = (options.latestBidContractRevisions ?? []).map((i) =>
      maybeNew("BidContractRevision", i, cache, options.hasOwnProperty("latestBidContractRevisions"))
    );
    o.relevantTakeoffLineItemVersions = (options.relevantTakeoffLineItemVersions ?? []).map((i) =>
      maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("relevantTakeoffLineItemVersions"))
    );
    o.scopeLines = (options.scopeLines ?? []).map((i) =>
      maybeNew("BidPackageScopeLine", i, cache, options.hasOwnProperty("scopeLines"))
    );
    o.basePlanGlobalPlanTasks = (options.basePlanGlobalPlanTasks ?? []).map((i) =>
      maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("basePlanGlobalPlanTasks"))
    );
    o.awards = (options.awards ?? []).map((i) =>
      maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("awards"))
    );
    o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
    o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
    o.canHaveDraws = maybeNew(
      "PotentialOperation2",
      options.canHaveDraws,
      cache,
      options.hasOwnProperty("canHaveDraws"),
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    return o as FactoryResult<BidPackageVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageVersion"] = newBidPackageVersion;

export interface BidPlanChildGroupOptions {
  __typename?: "BidPlanChildGroup";
  id?: BidPlanChildGroup["id"];
  displayName?: BidPlanChildGroup["displayName"];
  deletedAt?: BidPlanChildGroup["deletedAt"];
  createdAt?: BidPlanChildGroup["createdAt"];
  updatedAt?: BidPlanChildGroup["updatedAt"];
  group?: FactoryInput<BidPlanGroup, BidPlanGroupOptions>;
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions> | null;
  readyPlanOptionGroup?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions> | null;
  lines?: Array<FactoryInput<BidPlanChildGroupLine, BidPlanChildGroupLineOptions>>;
}

export function newBidPlanChildGroup(
  options?: BidPlanChildGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPlanChildGroup>;
export function newBidPlanChildGroup(
  options: BidPlanChildGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPlanChildGroup> {
  const o = (options.__typename ? options : cache["BidPlanChildGroup"] = {}) as BidPlanChildGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPlanChildGroup";
    o.id = options.id ?? nextFactoryId("BidPlanChildGroup");
    o.displayName = options.displayName ?? "displayName";
    o.deletedAt = options.deletedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.group = maybeNew("BidPlanGroup", options.group, cache, options.hasOwnProperty("group"));
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    o.readyPlanOption = maybeNewOrNull("ReadyPlanOption", options.readyPlanOption, cache);
    o.readyPlanOptionGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.readyPlanOptionGroup, cache);
    o.lines = (options.lines ?? []).map((i) =>
      maybeNew("BidPlanChildGroupLine", i, cache, options.hasOwnProperty("lines"))
    );
    return o as FactoryResult<BidPlanChildGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPlanChildGroup"] = newBidPlanChildGroup;

export interface BidPlanChildGroupLineOptions {
  __typename?: "BidPlanChildGroupLine";
  id?: BidPlanChildGroupLine["id"];
  displayName?: BidPlanChildGroupLine["displayName"];
  deletedAt?: BidPlanChildGroupLine["deletedAt"];
  createdAt?: BidPlanChildGroupLine["createdAt"];
  updatedAt?: BidPlanChildGroupLine["updatedAt"];
  group?: FactoryInput<BidPlanChildGroup, BidPlanChildGroupOptions>;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  planBasedBidContractLineItems?: Array<
    FactoryInput<PlanBasedBidContractLineItem, PlanBasedBidContractLineItemOptions>
  >;
  isMissingCost?: BidPlanChildGroupLine["isMissingCost"];
}

export function newBidPlanChildGroupLine(
  options?: BidPlanChildGroupLineOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPlanChildGroupLine>;
export function newBidPlanChildGroupLine(
  options: BidPlanChildGroupLineOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPlanChildGroupLine> {
  const o = (options.__typename ? options : cache["BidPlanChildGroupLine"] = {}) as BidPlanChildGroupLine;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPlanChildGroupLine";
    o.id = options.id ?? nextFactoryId("BidPlanChildGroupLine");
    o.displayName = options.displayName ?? "displayName";
    o.deletedAt = options.deletedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.group = maybeNew("BidPlanChildGroup", options.group, cache, options.hasOwnProperty("group"));
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.planBasedBidContractLineItems = (options.planBasedBidContractLineItems ?? []).map((i) =>
      maybeNew("PlanBasedBidContractLineItem", i, cache, options.hasOwnProperty("planBasedBidContractLineItems"))
    );
    o.isMissingCost = options.isMissingCost ?? false;
    return o as FactoryResult<BidPlanChildGroupLine>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPlanChildGroupLine"] = newBidPlanChildGroupLine;

export interface BidPlanGroupOptions {
  __typename?: "BidPlanGroup";
  id?: BidPlanGroup["id"];
  displayName?: BidPlanGroup["displayName"];
  createdAt?: BidPlanGroup["createdAt"];
  updatedAt?: BidPlanGroup["updatedAt"];
  globalOption?: FactoryInput<GlobalOption, GlobalOptionOptions> | null;
  productOfferings?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  dimensions?: Array<FactoryInput<BidPlanGroupDimension, BidPlanGroupDimensionOptions>>;
  order?: BidPlanGroup["order"];
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
  childGroups?: Array<FactoryInput<BidPlanChildGroup, BidPlanChildGroupOptions>>;
  deletedAt?: BidPlanGroup["deletedAt"];
  primaryOptionGroup?: FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions> | null;
  isNoCost?: BidPlanGroup["isNoCost"];
}

export function newBidPlanGroup(
  options?: BidPlanGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPlanGroup>;
export function newBidPlanGroup(
  options: BidPlanGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPlanGroup> {
  const o = (options.__typename ? options : cache["BidPlanGroup"] = {}) as BidPlanGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPlanGroup";
    o.id = options.id ?? nextFactoryId("BidPlanGroup");
    o.displayName = options.displayName ?? "displayName";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalOption = maybeNewOrNull("GlobalOption", options.globalOption, cache);
    o.productOfferings = (options.productOfferings ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
    );
    o.dimensions = (options.dimensions ?? []).map((i) =>
      maybeNew("BidPlanGroupDimension", i, cache, options.hasOwnProperty("dimensions"))
    );
    o.order = options.order ?? 0;
    o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
    o.childGroups = (options.childGroups ?? []).map((i) =>
      maybeNew("BidPlanChildGroup", i, cache, options.hasOwnProperty("childGroups"))
    );
    o.deletedAt = options.deletedAt ?? null;
    o.primaryOptionGroup = maybeNewOrNull("GlobalOptionGroup", options.primaryOptionGroup, cache);
    o.isNoCost = options.isNoCost ?? false;
    return o as FactoryResult<BidPlanGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPlanGroup"] = newBidPlanGroup;

export interface BidPlanGroupDimensionOptions {
  __typename?: "BidPlanGroupDimension";
  id?: BidPlanGroupDimension["id"];
  createdAt?: BidPlanGroupDimension["createdAt"];
  updatedAt?: BidPlanGroupDimension["updatedAt"];
  group?: FactoryInput<BidPlanGroup, BidPlanGroupOptions>;
  name?: BidPlanGroupDimension["name"];
  globalOptions?: Array<FactoryInput<GlobalOption, GlobalOptionOptions>>;
  globalOptionType?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions> | null;
  globalOptionGroup?: FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions> | null;
}

export function newBidPlanGroupDimension(
  options?: BidPlanGroupDimensionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPlanGroupDimension>;
export function newBidPlanGroupDimension(
  options: BidPlanGroupDimensionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPlanGroupDimension> {
  const o = (options.__typename ? options : cache["BidPlanGroupDimension"] = {}) as BidPlanGroupDimension;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPlanGroupDimension";
    o.id = options.id ?? nextFactoryId("BidPlanGroupDimension");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.group = maybeNew("BidPlanGroup", options.group, cache, options.hasOwnProperty("group"));
    o.name = options.name ?? "name";
    o.globalOptions = (options.globalOptions ?? []).map((i) =>
      maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
    );
    o.globalOptionType = maybeNewOrNull("GlobalOptionType", options.globalOptionType, cache);
    o.globalOptionGroup = maybeNewOrNull("GlobalOptionGroup", options.globalOptionGroup, cache);
    return o as FactoryResult<BidPlanGroupDimension>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPlanGroupDimension"] = newBidPlanGroupDimension;

export interface BillMetricsResultOptions {
  __typename?: "BillMetricsResult";
  openPayables?: Array<FactoryInput<BillMetric, BillMetricOptions>>;
  totalOpenPayables?: BillMetricsResult["totalOpenPayables"];
  agingOfPayables?: Array<FactoryInput<BillMetric, BillMetricOptions>>;
  totalAgingOfPayables?: BillMetricsResult["totalAgingOfPayables"];
  awaitingApprovals?: Array<FactoryInput<BillMetric, BillMetricOptions>>;
  totalAwaitingApprovals?: BillMetricsResult["totalAwaitingApprovals"];
}

export function newBillMetricsResult(
  options?: BillMetricsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillMetricsResult>;
export function newBillMetricsResult(
  options: BillMetricsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillMetricsResult> {
  const o = (options.__typename ? options : cache["BillMetricsResult"] = {}) as BillMetricsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillMetricsResult";
    o.openPayables = (options.openPayables ?? []).map((i) =>
      maybeNew("BillMetric", i, cache, options.hasOwnProperty("openPayables"))
    );
    o.totalOpenPayables = options.totalOpenPayables ?? 0;
    o.agingOfPayables = (options.agingOfPayables ?? []).map((i) =>
      maybeNew("BillMetric", i, cache, options.hasOwnProperty("agingOfPayables"))
    );
    o.totalAgingOfPayables = options.totalAgingOfPayables ?? 0;
    o.awaitingApprovals = (options.awaitingApprovals ?? []).map((i) =>
      maybeNew("BillMetric", i, cache, options.hasOwnProperty("awaitingApprovals"))
    );
    o.totalAwaitingApprovals = options.totalAwaitingApprovals ?? 0;
    return o as FactoryResult<BillMetricsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillMetricsResult"] = newBillMetricsResult;

export interface BillMetricOptions {
  __typename?: "BillMetric";
  label?: BillMetric["label"];
  totalCount?: BillMetric["totalCount"];
  totalAmount?: BillMetric["totalAmount"];
}

export function newBillMetric(options?: BillMetricOptions, factoryOptions?: FactoryOptions): FactoryResult<BillMetric>;
export function newBillMetric(
  options: BillMetricOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillMetric> {
  const o = (options.__typename ? options : cache["BillMetric"] = {}) as BillMetric;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillMetric";
    o.label = options.label ?? "label";
    o.totalCount = options.totalCount ?? 0;
    o.totalAmount = options.totalAmount ?? null;
    return o as FactoryResult<BillMetric>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillMetric"] = newBillMetric;

export interface TradePartnerOptions {
  __typename?: "TradePartner";
  bills?: Array<FactoryInput<Bill, BillOptions>>;
  id?: TradePartner["id"];
  name?: TradePartner["name"];
  internalNote?: TradePartner["internalNote"];
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  quickbooksId?: TradePartner["quickbooksId"];
  tasks?: Array<FactoryInput<Task, TaskOptions>>;
  markets?: Array<FactoryInput<Market, MarketOptions>>;
  users?: Array<FactoryInput<TradePartnerUser, TradePartnerUserOptions>>;
  contacts?: Array<FactoryInput<TradePartnerContact, TradePartnerContactOptions>>;
  doesMaterials?: TradePartner["doesMaterials"];
  doesLabor?: TradePartner["doesLabor"];
  isSweetheart?: TradePartner["isSweetheart"];
  sourceNote?: TradePartner["sourceNote"];
  source?: FactoryInput<InternalUser, InternalUserOptions> | null;
  website?: TradePartner["website"];
  agreements?: Array<FactoryInput<TradePartnerAgreement, TradePartnerAgreementOptions>>;
  reviews?: Array<FactoryInput<TradePartnerReview, TradePartnerReviewOptions>>;
  reviewCount?: TradePartner["reviewCount"];
  doNotUse?: TradePartner["doNotUse"];
  intacctId?: TradePartner["intacctId"];
  developmentCommitments?: Array<FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  tradeCategories?: Array<FactoryInput<TradeCategory, TradeCategoryOptions>>;
  requirements?: Array<FactoryInput<TradePartnerRequirement, TradePartnerRequirementOptions>>;
  meetsRequirements?: TradePartner["meetsRequirements"];
  meetsRequirementsExpiresAt?: TradePartner["meetsRequirementsExpiresAt"];
  meetsRequirementsExpiresOn?: TradePartner["meetsRequirementsExpiresOn"];
  averageScore?: TradePartner["averageScore"];
  homeboundAccountNumber?: TradePartner["homeboundAccountNumber"];
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  createdAt?: TradePartner["createdAt"];
  onboardingStatus?: TradePartnerOnboardingStatusDetailOptions | TradePartnerOnboardingStatus;
  contactsForDevelopmentAndRoles?: Array<Maybe<FactoryInput<TradePartnerContact, TradePartnerContactOptions>>>;
  contactsForProjectAndRoles?: Array<Maybe<FactoryInput<TradePartnerContact, TradePartnerContactOptions>>>;
  contactsForMarket?: Array<Maybe<FactoryInput<TradePartnerContact, TradePartnerContactOptions>>>;
  billDueDateFor?: TradePartner["billDueDateFor"];
  primaryForMarket?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  signatoryForMarket?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  primaryForDevelopment?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  signatoryForDevelopment?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  billApproverForDevelopment?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  primaryForProject?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  signatoryForProject?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  billApproverForProject?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  marketContacts?: Array<FactoryInput<TradePartnerMarketContact, TradePartnerMarketContactOptions>>;
  pendingChangeEventsToCreateCommitments?: Array<FactoryInput<ChangeEvent, ChangeEventOptions>>;
  leadTimeInDays?: TradePartner["leadTimeInDays"];
  canLoginToPortal?: TradePartner["canLoginToPortal"];
  paymentTerm?: FactoryInput<PaymentTerm, PaymentTermOptions>;
  lienWaivers?: Array<FactoryInput<LienWaiver, LienWaiverOptions>>;
  enableClickToPay?: TradePartner["enableClickToPay"];
  isLienWaiverReceiver?: TradePartner["isLienWaiverReceiver"];
  activeTasksCount?: TradePartner["activeTasksCount"];
  activeProjectsCount?: TradePartner["activeProjectsCount"];
  activeContractsCount?: TradePartner["activeContractsCount"];
  totalBilledInCents?: TradePartner["totalBilledInCents"];
  totalPaidInCents?: TradePartner["totalPaidInCents"];
  totalCommittedInCents?: TradePartner["totalCommittedInCents"];
  commitmentCountThisWeek?: TradePartner["commitmentCountThisWeek"];
  commitmentCountLastWeek?: TradePartner["commitmentCountLastWeek"];
  bidPackageRequests?: Array<FactoryInput<BidPackageRequest, BidPackageRequestOptions>>;
}

export function newTradePartner(
  options?: TradePartnerOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartner>;
export function newTradePartner(
  options: TradePartnerOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartner> {
  const o = (options.__typename ? options : cache["TradePartner"] = {}) as TradePartner;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartner";
    o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
    o.id = options.id ?? nextFactoryId("TradePartner");
    o.name = options.name ?? "name";
    o.internalNote = options.internalNote ?? null;
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    o.quickbooksId = options.quickbooksId ?? null;
    o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
    o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
    o.users = (options.users ?? []).map((i) => maybeNew("TradePartnerUser", i, cache, options.hasOwnProperty("users")));
    o.contacts = (options.contacts ?? []).map((i) =>
      maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("contacts"))
    );
    o.doesMaterials = options.doesMaterials ?? false;
    o.doesLabor = options.doesLabor ?? false;
    o.isSweetheart = options.isSweetheart ?? false;
    o.sourceNote = options.sourceNote ?? null;
    o.source = maybeNewOrNull("InternalUser", options.source, cache);
    o.website = options.website ?? null;
    o.agreements = (options.agreements ?? []).map((i) =>
      maybeNew("TradePartnerAgreement", i, cache, options.hasOwnProperty("agreements"))
    );
    o.reviews = (options.reviews ?? []).map((i) =>
      maybeNew("TradePartnerReview", i, cache, options.hasOwnProperty("reviews"))
    );
    o.reviewCount = options.reviewCount ?? 0;
    o.doNotUse = options.doNotUse ?? false;
    o.intacctId = options.intacctId ?? null;
    o.developmentCommitments = (options.developmentCommitments ?? []).map((i) =>
      maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("developmentCommitments"))
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
      maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
    );
    o.requirements = (options.requirements ?? []).map((i) =>
      maybeNew("TradePartnerRequirement", i, cache, options.hasOwnProperty("requirements"))
    );
    o.meetsRequirements = options.meetsRequirements ?? false;
    o.meetsRequirementsExpiresAt = options.meetsRequirementsExpiresAt ?? null;
    o.meetsRequirementsExpiresOn = options.meetsRequirementsExpiresOn ?? null;
    o.averageScore = options.averageScore ?? "" as any;
    o.homeboundAccountNumber = options.homeboundAccountNumber ?? null;
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.createdAt = options.createdAt ?? newDateTime();
    o.onboardingStatus = enumOrDetailOfTradePartnerOnboardingStatus(options.onboardingStatus);
    o.contactsForDevelopmentAndRoles = (options.contactsForDevelopmentAndRoles ?? []).map((i) =>
      maybeNewOrNull("TradePartnerContact", i, cache)
    );
    o.contactsForProjectAndRoles = (options.contactsForProjectAndRoles ?? []).map((i) =>
      maybeNewOrNull("TradePartnerContact", i, cache)
    );
    o.contactsForMarket = (options.contactsForMarket ?? []).map((i) => maybeNewOrNull("TradePartnerContact", i, cache));
    o.billDueDateFor = options.billDueDateFor ?? newDate();
    o.primaryForMarket = maybeNewOrNull("TradePartnerContact", options.primaryForMarket, cache);
    o.signatoryForMarket = maybeNewOrNull("TradePartnerContact", options.signatoryForMarket, cache);
    o.primaryForDevelopment = maybeNewOrNull("TradePartnerContact", options.primaryForDevelopment, cache);
    o.signatoryForDevelopment = maybeNewOrNull("TradePartnerContact", options.signatoryForDevelopment, cache);
    o.billApproverForDevelopment = maybeNewOrNull("TradePartnerContact", options.billApproverForDevelopment, cache);
    o.primaryForProject = maybeNewOrNull("TradePartnerContact", options.primaryForProject, cache);
    o.signatoryForProject = maybeNewOrNull("TradePartnerContact", options.signatoryForProject, cache);
    o.billApproverForProject = maybeNewOrNull("TradePartnerContact", options.billApproverForProject, cache);
    o.marketContacts = (options.marketContacts ?? []).map((i) =>
      maybeNew("TradePartnerMarketContact", i, cache, options.hasOwnProperty("marketContacts"))
    );
    o.pendingChangeEventsToCreateCommitments = (options.pendingChangeEventsToCreateCommitments ?? []).map((i) =>
      maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("pendingChangeEventsToCreateCommitments"))
    );
    o.leadTimeInDays = options.leadTimeInDays ?? 0;
    o.canLoginToPortal = options.canLoginToPortal ?? false;
    o.paymentTerm = maybeNew("PaymentTerm", options.paymentTerm, cache, options.hasOwnProperty("paymentTerm"));
    o.lienWaivers = (options.lienWaivers ?? []).map((i) =>
      maybeNew("LienWaiver", i, cache, options.hasOwnProperty("lienWaivers"))
    );
    o.enableClickToPay = options.enableClickToPay ?? false;
    o.isLienWaiverReceiver = options.isLienWaiverReceiver ?? false;
    o.activeTasksCount = options.activeTasksCount ?? 0;
    o.activeProjectsCount = options.activeProjectsCount ?? 0;
    o.activeContractsCount = options.activeContractsCount ?? 0;
    o.totalBilledInCents = options.totalBilledInCents ?? 0;
    o.totalPaidInCents = options.totalPaidInCents ?? 0;
    o.totalCommittedInCents = options.totalCommittedInCents ?? 0;
    o.commitmentCountThisWeek = options.commitmentCountThisWeek ?? 0;
    o.commitmentCountLastWeek = options.commitmentCountLastWeek ?? 0;
    o.bidPackageRequests = (options.bidPackageRequests ?? []).map((i) =>
      maybeNew("BidPackageRequest", i, cache, options.hasOwnProperty("bidPackageRequests"))
    );
    return o as FactoryResult<TradePartner>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartner"] = newTradePartner;

export interface BillOptions {
  __typename?: "Bill";
  id?: Bill["id"];
  name?: Bill["name"];
  tradePartnerNumber?: Bill["tradePartnerNumber"];
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  parents?: Array<CommitmentLike | FactoryResult<CommitmentLikeType> | CommitmentLikeOptions>;
  document?: FactoryInput<Document, DocumentOptions> | null;
  internalNote?: Bill["internalNote"];
  billDate?: Bill["billDate"];
  dueDate?: Bill["dueDate"];
  billedInCents?: Bill["billedInCents"];
  paidInCents?: Bill["paidInCents"];
  balanceInCents?: Bill["balanceInCents"];
  lineItems?: Array<FactoryInput<BillLineItem, BillLineItemOptions>>;
  quickbooksId?: Bill["quickbooksId"];
  history?: Array<FactoryInput<History, HistoryOptions>>;
  quickbooksPullOnly?: Bill["quickbooksPullOnly"];
  isTradePartnerCredit?: Bill["isTradePartnerCredit"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  quickbooksAmountPaidInCents?: Bill["quickbooksAmountPaidInCents"];
  intacctAmountPaidInCents?: Bill["intacctAmountPaidInCents"];
  intacctSyncError?: Bill["intacctSyncError"];
  createdBy?: FactoryInput<User, UserOptions> | null;
  intacctId?: Bill["intacctId"];
  paidDate?: Bill["paidDate"];
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  postedDate?: Bill["postedDate"];
  shouldSyncToIntacct?: Bill["shouldSyncToIntacct"];
  predictedApprovers?: Array<
    | ApproverUser
    | FactoryResult<ApproverUser>
    | ClientOptions
    | RequireTypename<InternalUserOptions>
    | RequireTypename<TradePartnerUserOptions>
  >;
  type?: BillTypeDetailOptions | BillType;
  status?: BillStatusDetailOptions | BillStatus;
  approval?: FactoryInput<Approval, ApprovalOptions> | null;
  approvedAt?: Bill["approvedAt"];
  sentDate?: Bill["sentDate"];
  isEditable?: Bill["isEditable"];
  isPendingOrBilled?: Bill["isPendingOrBilled"];
  isProcessingReversal?: Bill["isProcessingReversal"];
  canSubmitForApproval?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canReverse?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  updatedAt?: Bill["updatedAt"];
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  lienWaivers?: Array<FactoryInput<LienWaiver, LienWaiverOptions>>;
  referenceNumber?: Bill["referenceNumber"];
  reversalIntacctId?: Bill["reversalIntacctId"];
  canCancel?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  skipCostAccountDerivation?: Bill["skipCostAccountDerivation"];
  pendingReview?: Bill["pendingReview"];
  reviewReason?: Bill["reviewReason"];
  reviewReasonDetail?: BillReviewReasonDetailOptions | BillReviewReason | null;
  isHeadless?: Bill["isHeadless"];
  syncedToIntacctAt?: Bill["syncedToIntacctAt"];
  isBilled?: Bill["isBilled"];
  proposedAmountInCents?: Bill["proposedAmountInCents"];
  amountInCents?: Bill["amountInCents"];
  changeEvents?: Array<FactoryInput<ChangeEvent, ChangeEventOptions>>;
  source?: BillSourceDetailOptions | BillSource;
  ocrs?: Array<FactoryInput<BillOcr, BillOcrOptions>>;
  isDeferred?: Bill["isDeferred"];
  reviewers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  erpAccountLines?: Array<FactoryInput<ErpAccountBillLineItem, ErpAccountBillLineItemOptions>>;
  billOcr?: FactoryInput<BillOcr, BillOcrOptions> | null;
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Bill["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Bill["isFollowed"];
}

export function newBill(options?: BillOptions, factoryOptions?: FactoryOptions): FactoryResult<Bill>;
export function newBill(
  options: BillOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Bill> {
  const o = (options.__typename ? options : cache["Bill"] = {}) as Bill;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Bill";
    o.id = options.id ?? nextFactoryId("Bill");
    o.name = options.name ?? "name";
    o.tradePartnerNumber = options.tradePartnerNumber ?? "tradePartnerNumber";
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.parents = (options.parents ?? []).map((i) =>
      maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("parents"))
    );
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.internalNote = options.internalNote ?? null;
    o.billDate = options.billDate ?? newDate();
    o.dueDate = options.dueDate ?? null;
    o.billedInCents = options.billedInCents ?? 0;
    o.paidInCents = options.paidInCents ?? 0;
    o.balanceInCents = options.balanceInCents ?? 0;
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("BillLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.quickbooksId = options.quickbooksId ?? null;
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.quickbooksPullOnly = options.quickbooksPullOnly ?? false;
    o.isTradePartnerCredit = options.isTradePartnerCredit ?? false;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.quickbooksAmountPaidInCents = options.quickbooksAmountPaidInCents ?? 0;
    o.intacctAmountPaidInCents = options.intacctAmountPaidInCents ?? 0;
    o.intacctSyncError = options.intacctSyncError ?? null;
    o.createdBy = maybeNewOrNull("User", options.createdBy, cache);
    o.intacctId = options.intacctId ?? null;
    o.paidDate = options.paidDate ?? null;
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.postedDate = options.postedDate ?? null;
    o.shouldSyncToIntacct = options.shouldSyncToIntacct ?? false;
    o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
      maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
    );
    o.type = enumOrDetailOfBillType(options.type);
    o.status = enumOrDetailOfBillStatus(options.status);
    o.approval = maybeNewOrNull("Approval", options.approval, cache);
    o.approvedAt = options.approvedAt ?? null;
    o.sentDate = options.sentDate ?? null;
    o.isEditable = options.isEditable ?? false;
    o.isPendingOrBilled = options.isPendingOrBilled ?? false;
    o.isProcessingReversal = options.isProcessingReversal ?? false;
    o.canSubmitForApproval = maybeNew(
      "PotentialOperation2",
      options.canSubmitForApproval,
      cache,
      options.hasOwnProperty("canSubmitForApproval"),
    );
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.canReverse = maybeNew("PotentialOperation2", options.canReverse, cache, options.hasOwnProperty("canReverse"));
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.lienWaivers = (options.lienWaivers ?? []).map((i) =>
      maybeNew("LienWaiver", i, cache, options.hasOwnProperty("lienWaivers"))
    );
    o.referenceNumber = options.referenceNumber ?? null;
    o.reversalIntacctId = options.reversalIntacctId ?? null;
    o.canCancel = maybeNew("PotentialOperation2", options.canCancel, cache, options.hasOwnProperty("canCancel"));
    o.skipCostAccountDerivation = options.skipCostAccountDerivation ?? null;
    o.pendingReview = options.pendingReview ?? false;
    o.reviewReason = options.reviewReason ?? null;
    o.reviewReasonDetail = enumOrDetailOrNullOfBillReviewReason(options.reviewReasonDetail);
    o.isHeadless = options.isHeadless ?? false;
    o.syncedToIntacctAt = options.syncedToIntacctAt ?? null;
    o.isBilled = options.isBilled ?? false;
    o.proposedAmountInCents = options.proposedAmountInCents ?? 0;
    o.amountInCents = options.amountInCents ?? 0;
    o.changeEvents = (options.changeEvents ?? []).map((i) =>
      maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
    );
    o.source = enumOrDetailOfBillSource(options.source);
    o.ocrs = (options.ocrs ?? []).map((i) => maybeNew("BillOcr", i, cache, options.hasOwnProperty("ocrs")));
    o.isDeferred = options.isDeferred ?? false;
    o.reviewers = (options.reviewers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("reviewers"))
    );
    o.erpAccountLines = (options.erpAccountLines ?? []).map((i) =>
      maybeNew("ErpAccountBillLineItem", i, cache, options.hasOwnProperty("erpAccountLines"))
    );
    o.billOcr = maybeNewOrNull("BillOcr", options.billOcr, cache);
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    return o as FactoryResult<Bill>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Bill"] = newBill;

export interface SaveBillResultOptions {
  __typename?: "SaveBillResult";
  bill?: FactoryInput<Bill, BillOptions> | null;
}

export function newSaveBillResult(
  options?: SaveBillResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBillResult>;
export function newSaveBillResult(
  options: SaveBillResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBillResult> {
  const o = (options.__typename ? options : cache["SaveBillResult"] = {}) as SaveBillResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBillResult";
    o.bill = maybeNewOrNull("Bill", options.bill, cache);
    return o as FactoryResult<SaveBillResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBillResult"] = newSaveBillResult;

export interface SaveBillsResultOptions {
  __typename?: "SaveBillsResult";
  bills?: Array<FactoryInput<Bill, BillOptions>>;
}

export function newSaveBillsResult(
  options?: SaveBillsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBillsResult>;
export function newSaveBillsResult(
  options: SaveBillsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBillsResult> {
  const o = (options.__typename ? options : cache["SaveBillsResult"] = {}) as SaveBillsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBillsResult";
    o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
    return o as FactoryResult<SaveBillsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBillsResult"] = newSaveBillsResult;

export interface BillsPageOptions {
  __typename?: "BillsPage";
  entities?: Array<FactoryInput<Bill, BillOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newBillsPage(options?: BillsPageOptions, factoryOptions?: FactoryOptions): FactoryResult<BillsPage>;
export function newBillsPage(
  options: BillsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillsPage> {
  const o = (options.__typename ? options : cache["BillsPage"] = {}) as BillsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillsPage";
    o.entities = (options.entities ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("entities")));
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<BillsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillsPage"] = newBillsPage;

export interface ProtoBillOptions {
  __typename?: "ProtoBill";
  id?: ProtoBill["id"];
  existingBills?: Array<FactoryInput<Bill, BillOptions>>;
  commitmentLineItems?: Array<FactoryInput<CommitmentLineItem, CommitmentLineItemOptions>>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  lineItems?: Array<FactoryInput<ProtoBillLineItem, ProtoBillLineItemOptions>>;
}

export function newProtoBill(options?: ProtoBillOptions, factoryOptions?: FactoryOptions): FactoryResult<ProtoBill>;
export function newProtoBill(
  options: ProtoBillOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProtoBill> {
  const o = (options.__typename ? options : cache["ProtoBill"] = {}) as ProtoBill;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProtoBill";
    o.id = options.id ?? nextFactoryId("ProtoBill");
    o.existingBills = (options.existingBills ?? []).map((i) =>
      maybeNew("Bill", i, cache, options.hasOwnProperty("existingBills"))
    );
    o.commitmentLineItems = (options.commitmentLineItems ?? []).map((i) =>
      maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("commitmentLineItems"))
    );
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("ProtoBillLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    return o as FactoryResult<ProtoBill>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProtoBill"] = newProtoBill;

export interface ErpAccountBillLineItemOptions {
  __typename?: "ErpAccountBillLineItem";
  amountInCents?: ErpAccountBillLineItem["amountInCents"];
  sourceLine?:
    | ErpAccrualLineItemSourceLine
    | FactoryResult<ErpAccrualLineItemSourceLine>
    | BillLineItemAllocationOptions
    | RequireTypename<CommitmentDrawOptions>
    | RequireTypename<CommitmentLineItemOptions>
    | RequireTypename<ExpenseAllocationAllocationOptions>
    | RequireTypename<ProjectItemOptions>
    | RequireTypename<CostCodeOptions>;
  erpSource?:
    | ErpAccountBillLineItemErpSource
    | FactoryResult<ErpAccountBillLineItemErpSource>
    | CommitmentDrawOptions
    | RequireTypename<CommitmentLineItemOptions>
    | RequireTypename<ProjectItemOptions>
    | RequireTypename<CostCodeOptions>
    | RequireTypename<CommitmentOptions>;
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  task?: FactoryInput<Task, TaskOptions> | null;
  shouldAccrueAsComplete?: ErpAccountBillLineItem["shouldAccrueAsComplete"];
}

export function newErpAccountBillLineItem(
  options?: ErpAccountBillLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ErpAccountBillLineItem>;
export function newErpAccountBillLineItem(
  options: ErpAccountBillLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ErpAccountBillLineItem> {
  const o = (options.__typename ? options : cache["ErpAccountBillLineItem"] = {}) as ErpAccountBillLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ErpAccountBillLineItem";
    o.amountInCents = options.amountInCents ?? 0;
    o.sourceLine = maybeNew(options.sourceLine?.__typename ?? "BillLineItemAllocation", options.sourceLine, cache);
    o.erpSource = maybeNew(options.erpSource?.__typename ?? "CommitmentDraw", options.erpSource, cache);
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.task = maybeNewOrNull("Task", options.task, cache);
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    return o as FactoryResult<ErpAccountBillLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ErpAccountBillLineItem"] = newErpAccountBillLineItem;

export interface BillGmailAttachmentOptions {
  __typename?: "BillGmailAttachment";
  id?: BillGmailAttachment["id"];
  filename?: BillGmailAttachment["filename"];
  mimeType?: BillGmailAttachment["mimeType"];
  sizeInBytes?: BillGmailAttachment["sizeInBytes"];
  createdAt?: BillGmailAttachment["createdAt"];
  updatedAt?: BillGmailAttachment["updatedAt"];
  results?: BillGmailAttachment["results"];
  message?: FactoryInput<BillGmailMessage, BillGmailMessageOptions>;
  gmailPartId?: BillGmailAttachment["gmailPartId"];
  gmailAttachmentId?: BillGmailAttachment["gmailAttachmentId"];
  billOcrs?: Array<FactoryInput<BillOcr, BillOcrOptions>>;
  asset?: FactoryInput<Asset, AssetOptions> | null;
}

export function newBillGmailAttachment(
  options?: BillGmailAttachmentOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillGmailAttachment>;
export function newBillGmailAttachment(
  options: BillGmailAttachmentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillGmailAttachment> {
  const o = (options.__typename ? options : cache["BillGmailAttachment"] = {}) as BillGmailAttachment;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillGmailAttachment";
    o.id = options.id ?? nextFactoryId("BillGmailAttachment");
    o.filename = options.filename ?? "filename";
    o.mimeType = options.mimeType ?? "mimeType";
    o.sizeInBytes = options.sizeInBytes ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.results = options.results ?? [];
    o.message = maybeNew("BillGmailMessage", options.message, cache, options.hasOwnProperty("message"));
    o.gmailPartId = options.gmailPartId ?? "gmailPartId";
    o.gmailAttachmentId = options.gmailAttachmentId ?? null;
    o.billOcrs = (options.billOcrs ?? []).map((i) => maybeNew("BillOcr", i, cache, options.hasOwnProperty("billOcrs")));
    o.asset = maybeNewOrNull("Asset", options.asset, cache);
    return o as FactoryResult<BillGmailAttachment>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillGmailAttachment"] = newBillGmailAttachment;

export interface BillGmailMessageOptions {
  __typename?: "BillGmailMessage";
  id?: BillGmailMessage["id"];
  gmailMessageId?: BillGmailMessage["gmailMessageId"];
  gmailUserId?: BillGmailMessage["gmailUserId"];
  subject?: BillGmailMessage["subject"];
  sender?: BillGmailMessage["sender"];
  receivedAt?: BillGmailMessage["receivedAt"];
  createdAt?: BillGmailMessage["createdAt"];
  updatedAt?: BillGmailMessage["updatedAt"];
  result?: BillGmailMessageResultDetailOptions | BillGmailMessageResult;
  attachments?: Array<FactoryInput<BillGmailAttachment, BillGmailAttachmentOptions>>;
}

export function newBillGmailMessage(
  options?: BillGmailMessageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillGmailMessage>;
export function newBillGmailMessage(
  options: BillGmailMessageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillGmailMessage> {
  const o = (options.__typename ? options : cache["BillGmailMessage"] = {}) as BillGmailMessage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillGmailMessage";
    o.id = options.id ?? nextFactoryId("BillGmailMessage");
    o.gmailMessageId = options.gmailMessageId ?? "gmailMessageId";
    o.gmailUserId = options.gmailUserId ?? "gmailUserId";
    o.subject = options.subject ?? null;
    o.sender = options.sender ?? null;
    o.receivedAt = options.receivedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.result = enumOrDetailOfBillGmailMessageResult(options.result);
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("BillGmailAttachment", i, cache, options.hasOwnProperty("attachments"))
    );
    return o as FactoryResult<BillGmailMessage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillGmailMessage"] = newBillGmailMessage;

export interface BillLineItemOptions {
  __typename?: "BillLineItem";
  id?: BillLineItem["id"];
  bill?: FactoryInput<Bill, BillOptions>;
  amountInCents?: BillLineItem["amountInCents"];
  commitmentLineItem?: FactoryInput<CommitmentLineItem, CommitmentLineItemOptions> | null;
  paidInCents?: BillLineItem["paidInCents"];
  historicBillAmountInvoiced?: BillLineItem["historicBillAmountInvoiced"];
  scheduleTask?: FactoryInput<Task, TaskOptions> | null;
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  commitmentDraw?: FactoryInput<CommitmentDraw, CommitmentDrawOptions> | null;
  task?: FactoryInput<Task, TaskOptions> | null;
  shouldAccrueAsComplete?: BillLineItem["shouldAccrueAsComplete"];
  isTaxExempt?: BillLineItem["isTaxExempt"];
  taxableAmountInCents?: BillLineItem["taxableAmountInCents"];
  taxInCents?: BillLineItem["taxInCents"];
  allocations?: Array<FactoryInput<BillLineItemAllocation, BillLineItemAllocationOptions>>;
}

export function newBillLineItem(
  options?: BillLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillLineItem>;
export function newBillLineItem(
  options: BillLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillLineItem> {
  const o = (options.__typename ? options : cache["BillLineItem"] = {}) as BillLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillLineItem";
    o.id = options.id ?? nextFactoryId("BillLineItem");
    o.bill = maybeNew("Bill", options.bill, cache, options.hasOwnProperty("bill"));
    o.amountInCents = options.amountInCents ?? 0;
    o.commitmentLineItem = maybeNewOrNull("CommitmentLineItem", options.commitmentLineItem, cache);
    o.paidInCents = options.paidInCents ?? 0;
    o.historicBillAmountInvoiced = options.historicBillAmountInvoiced ?? null;
    o.scheduleTask = maybeNewOrNull("Task", options.scheduleTask, cache);
    o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
    o.commitmentDraw = maybeNewOrNull("CommitmentDraw", options.commitmentDraw, cache);
    o.task = maybeNewOrNull("Task", options.task, cache);
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    o.isTaxExempt = options.isTaxExempt ?? false;
    o.taxableAmountInCents = options.taxableAmountInCents ?? 0;
    o.taxInCents = options.taxInCents ?? 0;
    o.allocations = (options.allocations ?? []).map((i) =>
      maybeNew("BillLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
    );
    return o as FactoryResult<BillLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillLineItem"] = newBillLineItem;

export interface ProtoBillLineItemOptions {
  __typename?: "ProtoBillLineItem";
  commitmentLineItem?: FactoryInput<CommitmentLineItem, CommitmentLineItemOptions>;
  commitmentDraw?: FactoryInput<CommitmentDraw, CommitmentDrawOptions> | null;
  amountInCents?: ProtoBillLineItem["amountInCents"];
}

export function newProtoBillLineItem(
  options?: ProtoBillLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProtoBillLineItem>;
export function newProtoBillLineItem(
  options: ProtoBillLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProtoBillLineItem> {
  const o = (options.__typename ? options : cache["ProtoBillLineItem"] = {}) as ProtoBillLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProtoBillLineItem";
    o.commitmentLineItem = maybeNew(
      "CommitmentLineItem",
      options.commitmentLineItem,
      cache,
      options.hasOwnProperty("commitmentLineItem"),
    );
    o.commitmentDraw = maybeNewOrNull("CommitmentDraw", options.commitmentDraw, cache);
    o.amountInCents = options.amountInCents ?? 0;
    return o as FactoryResult<ProtoBillLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProtoBillLineItem"] = newProtoBillLineItem;

export interface BillLineItemAllocationOptions {
  __typename?: "BillLineItemAllocation";
  id?: BillLineItemAllocation["id"];
  createdAt?: BillLineItemAllocation["createdAt"];
  updatedAt?: BillLineItemAllocation["updatedAt"];
  costInCents?: BillLineItemAllocation["costInCents"];
  paidCostInCents?: BillLineItemAllocation["paidCostInCents"];
  commitmentLineItemAllocation?: FactoryInput<CommitmentLineItemAllocation, CommitmentLineItemAllocationOptions> | null;
  projectItemAllocation?: FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>;
}

export function newBillLineItemAllocation(
  options?: BillLineItemAllocationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillLineItemAllocation>;
export function newBillLineItemAllocation(
  options: BillLineItemAllocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillLineItemAllocation> {
  const o = (options.__typename ? options : cache["BillLineItemAllocation"] = {}) as BillLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillLineItemAllocation";
    o.id = options.id ?? nextFactoryId("BillLineItemAllocation");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costInCents = options.costInCents ?? 0;
    o.paidCostInCents = options.paidCostInCents ?? 0;
    o.commitmentLineItemAllocation = maybeNewOrNull(
      "CommitmentLineItemAllocation",
      options.commitmentLineItemAllocation,
      cache,
    );
    o.projectItemAllocation = maybeNew(
      "ProjectItemAllocation",
      options.projectItemAllocation,
      cache,
      options.hasOwnProperty("projectItemAllocation"),
    );
    return o as FactoryResult<BillLineItemAllocation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillLineItemAllocation"] = newBillLineItemAllocation;

export interface BillOcrOptions {
  __typename?: "BillOcr";
  id?: BillOcr["id"];
  createdAt?: BillOcr["createdAt"];
  updatedAt?: BillOcr["updatedAt"];
  asset?: FactoryInput<Asset, AssetOptions>;
  bill?: FactoryInput<Bill, BillOptions> | null;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  commitmentLikes?: Array<CommitmentLike | FactoryResult<CommitmentLikeType> | CommitmentLikeOptions>;
  invoiceNumber?: BillOcr["invoiceNumber"];
  billDate?: BillOcr["billDate"];
  dueDate?: BillOcr["dueDate"];
  totalInCents?: BillOcr["totalInCents"];
  type?: BillTypeDetailOptions | BillType;
  gmailAttachment?: FactoryInput<BillGmailAttachment, BillGmailAttachmentOptions> | null;
  billOcrBill?: FactoryInput<Bill, BillOptions> | null;
  trackedJobs?: Array<FactoryInput<TrackedJob, TrackedJobOptions>>;
}

export function newBillOcr(options?: BillOcrOptions, factoryOptions?: FactoryOptions): FactoryResult<BillOcr>;
export function newBillOcr(
  options: BillOcrOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillOcr> {
  const o = (options.__typename ? options : cache["BillOcr"] = {}) as BillOcr;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillOcr";
    o.id = options.id ?? nextFactoryId("BillOcr");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    o.bill = maybeNewOrNull("Bill", options.bill, cache);
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.commitmentLikes = (options.commitmentLikes ?? []).map((i) =>
      maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("commitmentLikes"))
    );
    o.invoiceNumber = options.invoiceNumber ?? null;
    o.billDate = options.billDate ?? null;
    o.dueDate = options.dueDate ?? null;
    o.totalInCents = options.totalInCents ?? null;
    o.type = enumOrDetailOfBillType(options.type);
    o.gmailAttachment = maybeNewOrNull("BillGmailAttachment", options.gmailAttachment, cache);
    o.billOcrBill = maybeNewOrNull("Bill", options.billOcrBill, cache);
    o.trackedJobs = (options.trackedJobs ?? []).map((i) =>
      maybeNew("TrackedJob", i, cache, options.hasOwnProperty("trackedJobs"))
    );
    return o as FactoryResult<BillOcr>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillOcr"] = newBillOcr;

export interface RunBillParserResultOptions {
  __typename?: "RunBillParserResult";
  trackedJob?: FactoryInput<TrackedJob, TrackedJobOptions>;
}

export function newRunBillParserResult(
  options?: RunBillParserResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<RunBillParserResult>;
export function newRunBillParserResult(
  options: RunBillParserResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<RunBillParserResult> {
  const o = (options.__typename ? options : cache["RunBillParserResult"] = {}) as RunBillParserResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "RunBillParserResult";
    o.trackedJob = maybeNew("TrackedJob", options.trackedJob, cache, options.hasOwnProperty("trackedJob"));
    return o as FactoryResult<RunBillParserResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["RunBillParserResult"] = newRunBillParserResult;

export interface PreConBudgetCostDivisionLineItemOptions {
  __typename?: "PreConBudgetCostDivisionLineItem";
  costDivision?: FactoryInput<CostDivision, CostDivisionOptions>;
  lines?: Array<FactoryInput<PreConBudgetCostCodeLineItem, PreConBudgetCostCodeLineItemOptions>>;
  priceInCents?: PreConBudgetCostDivisionLineItem["priceInCents"];
  budgetInCents?: PreConBudgetCostDivisionLineItem["budgetInCents"];
}

export function newPreConBudgetCostDivisionLineItem(
  options?: PreConBudgetCostDivisionLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PreConBudgetCostDivisionLineItem>;
export function newPreConBudgetCostDivisionLineItem(
  options: PreConBudgetCostDivisionLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PreConBudgetCostDivisionLineItem> {
  const o =
    (options.__typename ? options : cache["PreConBudgetCostDivisionLineItem"] = {}) as PreConBudgetCostDivisionLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PreConBudgetCostDivisionLineItem";
    o.costDivision = maybeNew("CostDivision", options.costDivision, cache, options.hasOwnProperty("costDivision"));
    o.lines = (options.lines ?? []).map((i) =>
      maybeNew("PreConBudgetCostCodeLineItem", i, cache, options.hasOwnProperty("lines"))
    );
    o.priceInCents = options.priceInCents ?? null;
    o.budgetInCents = options.budgetInCents ?? null;
    return o as FactoryResult<PreConBudgetCostDivisionLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PreConBudgetCostDivisionLineItem"] = newPreConBudgetCostDivisionLineItem;

export interface PreConBudgetCostCodeLineItemOptions {
  __typename?: "PreConBudgetCostCodeLineItem";
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  internalNote?: PreConBudgetCostCodeLineItem["internalNote"];
  priceInCents?: PreConBudgetCostCodeLineItem["priceInCents"];
  budgetInCents?: PreConBudgetCostCodeLineItem["budgetInCents"];
}

export function newPreConBudgetCostCodeLineItem(
  options?: PreConBudgetCostCodeLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PreConBudgetCostCodeLineItem>;
export function newPreConBudgetCostCodeLineItem(
  options: PreConBudgetCostCodeLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PreConBudgetCostCodeLineItem> {
  const o = (options.__typename ? options : cache["PreConBudgetCostCodeLineItem"] = {}) as PreConBudgetCostCodeLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PreConBudgetCostCodeLineItem";
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.internalNote = options.internalNote ?? null;
    o.priceInCents = options.priceInCents ?? null;
    o.budgetInCents = options.budgetInCents ?? null;
    return o as FactoryResult<PreConBudgetCostCodeLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PreConBudgetCostCodeLineItem"] = newPreConBudgetCostCodeLineItem;

export interface SavePreConBudgetLineItemResultOptions {
  __typename?: "SavePreConBudgetLineItemResult";
  lineItem?: FactoryInput<PreConBudgetCostCodeLineItem, PreConBudgetCostCodeLineItemOptions>;
}

export function newSavePreConBudgetLineItemResult(
  options?: SavePreConBudgetLineItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePreConBudgetLineItemResult>;
export function newSavePreConBudgetLineItemResult(
  options: SavePreConBudgetLineItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePreConBudgetLineItemResult> {
  const o =
    (options.__typename ? options : cache["SavePreConBudgetLineItemResult"] = {}) as SavePreConBudgetLineItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePreConBudgetLineItemResult";
    o.lineItem = maybeNew("PreConBudgetCostCodeLineItem", options.lineItem, cache, options.hasOwnProperty("lineItem"));
    return o as FactoryResult<SavePreConBudgetLineItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePreConBudgetLineItemResult"] = newSavePreConBudgetLineItemResult;

export interface DeletePreConBudgetLineItemResultOptions {
  __typename?: "DeletePreConBudgetLineItemResult";
  emptyResult?: FactoryInput<EmptyResult, EmptyResultOptions> | null;
}

export function newDeletePreConBudgetLineItemResult(
  options?: DeletePreConBudgetLineItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeletePreConBudgetLineItemResult>;
export function newDeletePreConBudgetLineItemResult(
  options: DeletePreConBudgetLineItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeletePreConBudgetLineItemResult> {
  const o =
    (options.__typename ? options : cache["DeletePreConBudgetLineItemResult"] = {}) as DeletePreConBudgetLineItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeletePreConBudgetLineItemResult";
    o.emptyResult = maybeNewOrNull("EmptyResult", options.emptyResult, cache);
    return o as FactoryResult<DeletePreConBudgetLineItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeletePreConBudgetLineItemResult"] = newDeletePreConBudgetLineItemResult;

export interface ApprovePreConBudgetLineItemResultOptions {
  __typename?: "ApprovePreConBudgetLineItemResult";
  contract?: FactoryInput<HomeownerContract, HomeownerContractOptions>;
}

export function newApprovePreConBudgetLineItemResult(
  options?: ApprovePreConBudgetLineItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ApprovePreConBudgetLineItemResult>;
export function newApprovePreConBudgetLineItemResult(
  options: ApprovePreConBudgetLineItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ApprovePreConBudgetLineItemResult> {
  const o =
    (options.__typename
      ? options
      : cache["ApprovePreConBudgetLineItemResult"] = {}) as ApprovePreConBudgetLineItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ApprovePreConBudgetLineItemResult";
    o.contract = maybeNew("HomeownerContract", options.contract, cache, options.hasOwnProperty("contract"));
    return o as FactoryResult<ApprovePreConBudgetLineItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ApprovePreConBudgetLineItemResult"] = newApprovePreConBudgetLineItemResult;

export interface BuilderOptions {
  __typename?: "Builder";
  id?: Builder["id"];
  name?: Builder["name"];
}

export function newBuilder(options?: BuilderOptions, factoryOptions?: FactoryOptions): FactoryResult<Builder>;
export function newBuilder(
  options: BuilderOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Builder> {
  const o = (options.__typename ? options : cache["Builder"] = {}) as Builder;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Builder";
    o.id = options.id ?? nextFactoryId("Builder");
    o.name = options.name ?? "name";
    return o as FactoryResult<Builder>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Builder"] = newBuilder;

export interface SaveBuilderResultOptions {
  __typename?: "SaveBuilderResult";
  builder?: FactoryInput<Builder, BuilderOptions>;
}

export function newSaveBuilderResult(
  options?: SaveBuilderResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBuilderResult>;
export function newSaveBuilderResult(
  options: SaveBuilderResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBuilderResult> {
  const o = (options.__typename ? options : cache["SaveBuilderResult"] = {}) as SaveBuilderResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBuilderResult";
    o.builder = maybeNew("Builder", options.builder, cache, options.hasOwnProperty("builder"));
    return o as FactoryResult<SaveBuilderResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBuilderResult"] = newSaveBuilderResult;

export interface BusinessFunctionOptions {
  __typename?: "BusinessFunction";
  id?: BusinessFunction["id"];
  name?: BusinessFunction["name"];
  priority?: BusinessFunction["priority"];
  autoApprovalAmountInCents?: BusinessFunction["autoApprovalAmountInCents"];
  createdAt?: BusinessFunction["createdAt"];
  updatedAt?: BusinessFunction["updatedAt"];
  impactReviewer?: ProjectRoleDetailOptions | ProjectRole | null;
  initialReviewer?: ProjectRoleDetailOptions | ProjectRole | null;
  businessFunctionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  approverProjectRole?: ProjectRoleDetailOptions | ProjectRole | null;
  applicableChangeTypes?: Array<FactoryInput<ChangeTypeDetail, ChangeTypeDetailOptions>>;
}

export function newBusinessFunction(
  options?: BusinessFunctionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BusinessFunction>;
export function newBusinessFunction(
  options: BusinessFunctionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BusinessFunction> {
  const o = (options.__typename ? options : cache["BusinessFunction"] = {}) as BusinessFunction;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BusinessFunction";
    o.id = options.id ?? nextFactoryId("BusinessFunction");
    o.name = options.name ?? "name";
    o.priority = options.priority ?? 0;
    o.autoApprovalAmountInCents = options.autoApprovalAmountInCents ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.impactReviewer = enumOrDetailOrNullOfProjectRole(options.impactReviewer);
    o.initialReviewer = enumOrDetailOrNullOfProjectRole(options.initialReviewer);
    o.businessFunctionType = enumOrDetailOfBusinessFunctionType(options.businessFunctionType);
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.approverProjectRole = enumOrDetailOrNullOfProjectRole(options.approverProjectRole);
    o.applicableChangeTypes = (options.applicableChangeTypes ?? []).map((i) => enumOrDetailOfChangeType(i));
    return o as FactoryResult<BusinessFunction>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BusinessFunction"] = newBusinessFunction;

export interface SaveBusinessFunctionResultOptions {
  __typename?: "SaveBusinessFunctionResult";
  businessFunction?: FactoryInput<BusinessFunction, BusinessFunctionOptions>;
}

export function newSaveBusinessFunctionResult(
  options?: SaveBusinessFunctionResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveBusinessFunctionResult>;
export function newSaveBusinessFunctionResult(
  options: SaveBusinessFunctionResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveBusinessFunctionResult> {
  const o = (options.__typename ? options : cache["SaveBusinessFunctionResult"] = {}) as SaveBusinessFunctionResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveBusinessFunctionResult";
    o.businessFunction = maybeNew(
      "BusinessFunction",
      options.businessFunction,
      cache,
      options.hasOwnProperty("businessFunction"),
    );
    return o as FactoryResult<SaveBusinessFunctionResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveBusinessFunctionResult"] = newSaveBusinessFunctionResult;

export interface CalendarIntervalOptions {
  __typename?: "CalendarInterval";
  startDate?: CalendarInterval["startDate"];
  endDate?: CalendarInterval["endDate"];
  durationInDays?: CalendarInterval["durationInDays"];
  calendarProgress?: CalendarInterval["calendarProgress"];
}

export function newCalendarInterval(
  options?: CalendarIntervalOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CalendarInterval>;
export function newCalendarInterval(
  options: CalendarIntervalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CalendarInterval> {
  const o = (options.__typename ? options : cache["CalendarInterval"] = {}) as CalendarInterval;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CalendarInterval";
    o.startDate = options.startDate ?? newDate();
    o.endDate = options.endDate ?? newDate();
    o.durationInDays = options.durationInDays ?? 0;
    o.calendarProgress = options.calendarProgress ?? 0;
    return o as FactoryResult<CalendarInterval>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CalendarInterval"] = newCalendarInterval;

export interface CalendarInterval2Options {
  __typename?: "CalendarInterval2";
  startDate?: CalendarInterval2["startDate"];
  endDate?: CalendarInterval2["endDate"];
  durationInDays?: CalendarInterval2["durationInDays"];
}

export function newCalendarInterval2(
  options?: CalendarInterval2Options,
  factoryOptions?: FactoryOptions,
): FactoryResult<CalendarInterval2>;
export function newCalendarInterval2(
  options: CalendarInterval2Options = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CalendarInterval2> {
  const o = (options.__typename ? options : cache["CalendarInterval2"] = {}) as CalendarInterval2;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CalendarInterval2";
    o.startDate = options.startDate ?? null;
    o.endDate = options.endDate ?? null;
    o.durationInDays = options.durationInDays ?? null;
    return o as FactoryResult<CalendarInterval2>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CalendarInterval2"] = newCalendarInterval2;

export interface ChangeEventOptions {
  __typename?: "ChangeEvent";
  id?: ChangeEvent["id"];
  title?: ChangeEvent["title"];
  commitments?: Array<CommitmentLike | FactoryResult<CommitmentLikeType> | CommitmentLikeOptions>;
  internalNote?: ChangeEvent["internalNote"];
  createdAt?: ChangeEvent["createdAt"];
  displayName?: ChangeEvent["displayName"];
  updatedAt?: ChangeEvent["updatedAt"];
  status?: ChangeEvent["status"];
  statusDetail?: ChangeEventStatusDetailOptions | ChangeEventStatus;
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  lineItems?: Array<FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>>;
  homeownerContractChangeOrder?: FactoryInput<HomeownerContractChangeOrder, HomeownerContractChangeOrderOptions> | null;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  name?: ChangeEvent["name"];
  history?: Array<FactoryInput<History, HistoryOptions>>;
  estimates?: Array<FactoryInput<Estimate, EstimateOptions>>;
  canCreateFinalEstimate?: ChangeEvent["canCreateFinalEstimate"];
  totalCostInCents?: ChangeEvent["totalCostInCents"];
  totalPriceInCents?: ChangeEvent["totalPriceInCents"];
  originalTotalCostInCents?: ChangeEvent["originalTotalCostInCents"];
  originalTotalPriceInCents?: ChangeEvent["originalTotalPriceInCents"];
  proposedTotalCostInCents?: ChangeEvent["proposedTotalCostInCents"];
  proposedTotalPriceInCents?: ChangeEvent["proposedTotalPriceInCents"];
  budgetImpactInCents?: ChangeEvent["budgetImpactInCents"];
  revisedBudgetInCents?: ChangeEvent["revisedBudgetInCents"];
  isHomeownerChangeEvent?: ChangeEvent["isHomeownerChangeEvent"];
  isReadyHomeManaged?: ChangeEvent["isReadyHomeManaged"];
  canEditLineItems?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  internalImpactInDays?: ChangeEvent["internalImpactInDays"];
  homeownerImpactInDays?: ChangeEvent["homeownerImpactInDays"];
  reasonDetails?: ChangeEvent["reasonDetails"];
  reason?: FactoryInput<ChangeEventReason, ChangeEventReasonOptions>;
  identifier?: ChangeEvent["identifier"];
  appliedTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  templateConfigs?: Array<FactoryInput<ChangeEventTemplateConfig, ChangeEventTemplateConfigOptions>>;
  budgetPhase?: ChangeEventBudgetPhaseDetailOptions | ChangeEventBudgetPhase;
  acceptedAt?: ChangeEvent["acceptedAt"];
  approval?: FactoryInput<Approval, ApprovalOptions> | null;
  impactedCommitments?: Array<CommitmentLike | FactoryResult<CommitmentLikeType> | CommitmentLikeOptions>;
  predictedApprovers?: Array<
    | ApproverUser
    | FactoryResult<ApproverUser>
    | ClientOptions
    | RequireTypename<InternalUserOptions>
    | RequireTypename<TradePartnerUserOptions>
  >;
  type?: ChangeEventTypeDetailOptions | ChangeEventType;
  canBeLocked?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canSubmitForApproval?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  tradesToDraftCommitmentsFor?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  impactedTrades?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions> | null;
  requireSignature?: ChangeEvent["requireSignature"];
  createdBy?:
    | ChangeEventCreatedBy
    | FactoryResult<ChangeEventCreatedBy>
    | BillOptions
    | RequireTypename<ExpenseOptions>
    | null;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions | null;
  originalReadyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions | null;
  originalReadyPlanOptions?: Array<FactoryInput<ChangeEventOriginalOption, ChangeEventOriginalOptionOptions>>;
  proposedReadyPlanOptions?: Array<FactoryInput<ChangeEventProposedOption, ChangeEventProposedOptionOptions>>;
  isContractAddendum?: ChangeEvent["isContractAddendum"];
  removedReadyPlanOptions?: Array<FactoryInput<ChangeEventOriginalOption, ChangeEventOriginalOptionOptions>>;
  addedReadyPlanOptions?: Array<FactoryInput<ChangeEventProposedOption, ChangeEventProposedOptionOptions>>;
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions> | null;
  proposedOrientation?: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation | null;
  hasPreSignedContract?: ChangeEvent["hasPreSignedContract"];
  document?: FactoryInput<Document, DocumentOptions> | null;
  aggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  workflow?: ChangeEventWorkflowDetailOptions | ChangeEventWorkflow | null;
  materialVariantSwaps?: Array<FactoryInput<ChangeEventMaterialVariantSwap, ChangeEventMaterialVariantSwapOptions>>;
  isTitleAutoGenerated?: ChangeEvent["isTitleAutoGenerated"];
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ChangeEvent["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ChangeEvent["isFollowed"];
}

export function newChangeEvent(
  options?: ChangeEventOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEvent>;
export function newChangeEvent(
  options: ChangeEventOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEvent> {
  const o = (options.__typename ? options : cache["ChangeEvent"] = {}) as ChangeEvent;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEvent";
    o.id = options.id ?? nextFactoryId("ChangeEvent");
    o.title = options.title ?? "title";
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("commitments"))
    );
    o.internalNote = options.internalNote ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.displayName = options.displayName ?? "displayName";
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = options.status ?? ChangeEventStatus.Draft;
    o.statusDetail = enumOrDetailOfChangeEventStatus(options.statusDetail);
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.homeownerContractChangeOrder = maybeNewOrNull(
      "HomeownerContractChangeOrder",
      options.homeownerContractChangeOrder,
      cache,
    );
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.name = options.name ?? "name";
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.estimates = (options.estimates ?? []).map((i) =>
      maybeNew("Estimate", i, cache, options.hasOwnProperty("estimates"))
    );
    o.canCreateFinalEstimate = options.canCreateFinalEstimate ?? false;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.originalTotalCostInCents = options.originalTotalCostInCents ?? 0;
    o.originalTotalPriceInCents = options.originalTotalPriceInCents ?? 0;
    o.proposedTotalCostInCents = options.proposedTotalCostInCents ?? 0;
    o.proposedTotalPriceInCents = options.proposedTotalPriceInCents ?? 0;
    o.budgetImpactInCents = options.budgetImpactInCents ?? 0;
    o.revisedBudgetInCents = options.revisedBudgetInCents ?? 0;
    o.isHomeownerChangeEvent = options.isHomeownerChangeEvent ?? false;
    o.isReadyHomeManaged = options.isReadyHomeManaged ?? false;
    o.canEditLineItems = maybeNew(
      "PotentialOperation2",
      options.canEditLineItems,
      cache,
      options.hasOwnProperty("canEditLineItems"),
    );
    o.internalImpactInDays = options.internalImpactInDays ?? null;
    o.homeownerImpactInDays = options.homeownerImpactInDays ?? null;
    o.reasonDetails = options.reasonDetails ?? null;
    o.reason = maybeNew("ChangeEventReason", options.reason, cache, options.hasOwnProperty("reason"));
    o.identifier = options.identifier ?? 0;
    o.appliedTemplates = (options.appliedTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("appliedTemplates"))
    );
    o.templateConfigs = (options.templateConfigs ?? []).map((i) =>
      maybeNew("ChangeEventTemplateConfig", i, cache, options.hasOwnProperty("templateConfigs"))
    );
    o.budgetPhase = enumOrDetailOfChangeEventBudgetPhase(options.budgetPhase);
    o.acceptedAt = options.acceptedAt ?? null;
    o.approval = maybeNewOrNull("Approval", options.approval, cache);
    o.impactedCommitments = (options.impactedCommitments ?? []).map((i) =>
      maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("impactedCommitments"))
    );
    o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
      maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
    );
    o.type = enumOrDetailOfChangeEventType(options.type);
    o.canBeLocked = maybeNew("PotentialOperation2", options.canBeLocked, cache, options.hasOwnProperty("canBeLocked"));
    o.canSubmitForApproval = maybeNew(
      "PotentialOperation2",
      options.canSubmitForApproval,
      cache,
      options.hasOwnProperty("canSubmitForApproval"),
    );
    o.tradesToDraftCommitmentsFor = (options.tradesToDraftCommitmentsFor ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradesToDraftCommitmentsFor"))
    );
    o.impactedTrades = (options.impactedTrades ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("impactedTrades"))
    );
    o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
    o.requireSignature = options.requireSignature ?? false;
    o.createdBy = maybeNewOrNull(options.createdBy?.__typename ?? "Bill", options.createdBy, cache);
    o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
    o.originalReadyPlan = maybeNewOrNull("ReadyPlanLike", options.originalReadyPlan, cache);
    o.originalReadyPlanOptions = (options.originalReadyPlanOptions ?? []).map((i) =>
      maybeNew("ChangeEventOriginalOption", i, cache, options.hasOwnProperty("originalReadyPlanOptions"))
    );
    o.proposedReadyPlanOptions = (options.proposedReadyPlanOptions ?? []).map((i) =>
      maybeNew("ChangeEventProposedOption", i, cache, options.hasOwnProperty("proposedReadyPlanOptions"))
    );
    o.isContractAddendum = options.isContractAddendum ?? false;
    o.removedReadyPlanOptions = (options.removedReadyPlanOptions ?? []).map((i) =>
      maybeNew("ChangeEventOriginalOption", i, cache, options.hasOwnProperty("removedReadyPlanOptions"))
    );
    o.addedReadyPlanOptions = (options.addedReadyPlanOptions ?? []).map((i) =>
      maybeNew("ChangeEventProposedOption", i, cache, options.hasOwnProperty("addedReadyPlanOptions"))
    );
    o.checkoutConfig = maybeNewOrNull("CheckoutConfig", options.checkoutConfig, cache);
    o.proposedOrientation = enumOrDetailOrNullOfProjectReadyPlanConfigOrientation(options.proposedOrientation);
    o.hasPreSignedContract = options.hasPreSignedContract ?? false;
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.aggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateVersion, cache);
    o.workflow = enumOrDetailOrNullOfChangeEventWorkflow(options.workflow);
    o.materialVariantSwaps = (options.materialVariantSwaps ?? []).map((i) =>
      maybeNew("ChangeEventMaterialVariantSwap", i, cache, options.hasOwnProperty("materialVariantSwaps"))
    );
    o.isTitleAutoGenerated = options.isTitleAutoGenerated ?? false;
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    return o as FactoryResult<ChangeEvent>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEvent"] = newChangeEvent;

export interface SaveChangeEventResultOptions {
  __typename?: "SaveChangeEventResult";
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newSaveChangeEventResult(
  options?: SaveChangeEventResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveChangeEventResult>;
export function newSaveChangeEventResult(
  options: SaveChangeEventResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveChangeEventResult> {
  const o = (options.__typename ? options : cache["SaveChangeEventResult"] = {}) as SaveChangeEventResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveChangeEventResult";
    o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
    return o as FactoryResult<SaveChangeEventResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveChangeEventResult"] = newSaveChangeEventResult;

export interface SaveChangeEventsResultOptions {
  __typename?: "SaveChangeEventsResult";
  changeEvents?: Array<FactoryInput<ChangeEvent, ChangeEventOptions>>;
}

export function newSaveChangeEventsResult(
  options?: SaveChangeEventsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveChangeEventsResult>;
export function newSaveChangeEventsResult(
  options: SaveChangeEventsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveChangeEventsResult> {
  const o = (options.__typename ? options : cache["SaveChangeEventsResult"] = {}) as SaveChangeEventsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveChangeEventsResult";
    o.changeEvents = (options.changeEvents ?? []).map((i) =>
      maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
    );
    return o as FactoryResult<SaveChangeEventsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveChangeEventsResult"] = newSaveChangeEventsResult;

export interface ChangeEventLineItemOptions {
  __typename?: "ChangeEventLineItem";
  id?: ChangeEventLineItem["id"];
  createdAt?: ChangeEventLineItem["createdAt"];
  updatedAt?: ChangeEventLineItem["updatedAt"];
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  quantity?: ChangeEventLineItem["quantity"];
  totalPriceInCents?: ChangeEventLineItem["totalPriceInCents"];
  totalCostInCents?: ChangeEventLineItem["totalCostInCents"];
  unitCostInCents?: ChangeEventLineItem["unitCostInCents"];
  originalQuantity?: ChangeEventLineItem["originalQuantity"];
  originalTotalCostInCents?: ChangeEventLineItem["originalTotalCostInCents"];
  originalTotalPriceInCents?: ChangeEventLineItem["originalTotalPriceInCents"];
  proposedTotalCostInCents?: ChangeEventLineItem["proposedTotalCostInCents"];
  item?: FactoryInput<Item, ItemOptions>;
  name?: ChangeEventLineItem["name"];
  costType?: ChangeEventLineItem["costType"];
  location?: FactoryInput<Location, LocationOptions>;
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  displayName?: ChangeEventLineItem["displayName"];
  costConfidence?: ChangeEventLineItem["costConfidence"];
  costConfidenceDetail?: CostConfidenceDetailOptions | CostConfidence;
  type?: ChangeEventLineItem["type"];
  typeDetail?: ChangeEventLineItemTypeDetailOptions | ChangeEventLineItemType;
  specifications?: ChangeEventLineItem["specifications"];
  tradePartnerNote?: ChangeEventLineItem["tradePartnerNote"];
  canEditName?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditCost?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  itemTemplateItem?: BaseItemLike | FactoryResult<BaseItemLikeType> | BaseItemLikeOptions | null;
  modifyingTemplateItems?: Array<BaseItemLike | FactoryResult<BaseItemLikeType> | BaseItemLikeOptions>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  originalTradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  internalNote?: ChangeEventLineItem["internalNote"];
  originalBidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  proposedBidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  originalBidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  proposedBidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  originalTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  proposedTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  originalMaterialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  proposedMaterialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  allocations?: Array<FactoryInput<ChangeEventLineItemAllocation, ChangeEventLineItemAllocationOptions>>;
  originalPackageDesignNotes?: ChangeEventLineItem["originalPackageDesignNotes"];
  proposedPackageDesignNotes?: ChangeEventLineItem["proposedPackageDesignNotes"];
  isMetadataChangeOnly?: ChangeEventLineItem["isMetadataChangeOnly"];
}

export function newChangeEventLineItem(
  options?: ChangeEventLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventLineItem>;
export function newChangeEventLineItem(
  options: ChangeEventLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventLineItem> {
  const o = (options.__typename ? options : cache["ChangeEventLineItem"] = {}) as ChangeEventLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventLineItem";
    o.id = options.id ?? nextFactoryId("ChangeEventLineItem");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
    o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
    o.quantity = options.quantity ?? null;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.unitCostInCents = options.unitCostInCents ?? 0;
    o.originalQuantity = options.originalQuantity ?? null;
    o.originalTotalCostInCents = options.originalTotalCostInCents ?? 0;
    o.originalTotalPriceInCents = options.originalTotalPriceInCents ?? 0;
    o.proposedTotalCostInCents = options.proposedTotalCostInCents ?? 0;
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.name = options.name ?? "name";
    o.costType = options.costType ?? CostType.Labor;
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.displayName = options.displayName ?? "displayName";
    o.costConfidence = options.costConfidence ?? CostConfidence.Low;
    o.costConfidenceDetail = enumOrDetailOfCostConfidence(options.costConfidenceDetail);
    o.type = options.type ?? ChangeEventLineItemType.Add;
    o.typeDetail = enumOrDetailOfChangeEventLineItemType(options.typeDetail);
    o.specifications = options.specifications ?? null;
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.canEditName = maybeNew("PotentialOperation2", options.canEditName, cache, options.hasOwnProperty("canEditName"));
    o.canEditCost = maybeNew("PotentialOperation2", options.canEditCost, cache, options.hasOwnProperty("canEditCost"));
    o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
    o.modifyingTemplateItems = (options.modifyingTemplateItems ?? []).map((i) =>
      maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("modifyingTemplateItems"))
    );
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.originalTradePartner = maybeNewOrNull("TradePartner", options.originalTradePartner, cache);
    o.internalNote = options.internalNote ?? null;
    o.originalBidItem = maybeNewOrNull("BidItem", options.originalBidItem, cache);
    o.proposedBidItem = maybeNewOrNull("BidItem", options.proposedBidItem, cache);
    o.originalBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.originalBidContractLineItem, cache);
    o.proposedBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.proposedBidContractLineItem, cache);
    o.originalTask = maybeNewOrNull("GlobalPlanTask", options.originalTask, cache);
    o.proposedTask = maybeNewOrNull("GlobalPlanTask", options.proposedTask, cache);
    o.originalMaterialVariant = maybeNewOrNull("MaterialVariant", options.originalMaterialVariant, cache);
    o.proposedMaterialVariant = maybeNewOrNull("MaterialVariant", options.proposedMaterialVariant, cache);
    o.allocations = (options.allocations ?? []).map((i) =>
      maybeNew("ChangeEventLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
    );
    o.originalPackageDesignNotes = options.originalPackageDesignNotes ?? null;
    o.proposedPackageDesignNotes = options.proposedPackageDesignNotes ?? null;
    o.isMetadataChangeOnly = options.isMetadataChangeOnly ?? false;
    return o as FactoryResult<ChangeEventLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventLineItem"] = newChangeEventLineItem;

export interface SaveChangeEventLineItemsResultOptions {
  __typename?: "SaveChangeEventLineItemsResult";
  changeEventLineItems?: Array<FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>>;
  autoAddedLaborLines?: Array<FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>>;
}

export function newSaveChangeEventLineItemsResult(
  options?: SaveChangeEventLineItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveChangeEventLineItemsResult>;
export function newSaveChangeEventLineItemsResult(
  options: SaveChangeEventLineItemsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveChangeEventLineItemsResult> {
  const o =
    (options.__typename ? options : cache["SaveChangeEventLineItemsResult"] = {}) as SaveChangeEventLineItemsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveChangeEventLineItemsResult";
    o.changeEventLineItems = (options.changeEventLineItems ?? []).map((i) =>
      maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("changeEventLineItems"))
    );
    o.autoAddedLaborLines = (options.autoAddedLaborLines ?? []).map((i) =>
      maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("autoAddedLaborLines"))
    );
    return o as FactoryResult<SaveChangeEventLineItemsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveChangeEventLineItemsResult"] = newSaveChangeEventLineItemsResult;

export interface ChangeEventLineItemAllocationOptions {
  __typename?: "ChangeEventLineItemAllocation";
  id?: ChangeEventLineItemAllocation["id"];
  costInCents?: ChangeEventLineItemAllocation["costInCents"];
  priceInCents?: ChangeEventLineItemAllocation["priceInCents"];
  createdAt?: ChangeEventLineItemAllocation["createdAt"];
  updatedAt?: ChangeEventLineItemAllocation["updatedAt"];
  changeEventLineItem?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>;
  projectItemAllocation?: FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>;
}

export function newChangeEventLineItemAllocation(
  options?: ChangeEventLineItemAllocationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventLineItemAllocation>;
export function newChangeEventLineItemAllocation(
  options: ChangeEventLineItemAllocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventLineItemAllocation> {
  const o =
    (options.__typename ? options : cache["ChangeEventLineItemAllocation"] = {}) as ChangeEventLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventLineItemAllocation";
    o.id = options.id ?? nextFactoryId("ChangeEventLineItemAllocation");
    o.costInCents = options.costInCents ?? 0;
    o.priceInCents = options.priceInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.changeEventLineItem = maybeNew(
      "ChangeEventLineItem",
      options.changeEventLineItem,
      cache,
      options.hasOwnProperty("changeEventLineItem"),
    );
    o.projectItemAllocation = maybeNew(
      "ProjectItemAllocation",
      options.projectItemAllocation,
      cache,
      options.hasOwnProperty("projectItemAllocation"),
    );
    return o as FactoryResult<ChangeEventLineItemAllocation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventLineItemAllocation"] = newChangeEventLineItemAllocation;

export interface ChangeEventMaterialVariantSwapOptions {
  __typename?: "ChangeEventMaterialVariantSwap";
  id?: ChangeEventMaterialVariantSwap["id"];
  createdAt?: ChangeEventMaterialVariantSwap["createdAt"];
  updatedAt?: ChangeEventMaterialVariantSwap["updatedAt"];
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
  originalMaterialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  proposedMaterialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  originalProjectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  proposedProjectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  proposedTradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  totalCostInCents?: ChangeEventMaterialVariantSwap["totalCostInCents"];
  totalPriceInCents?: ChangeEventMaterialVariantSwap["totalPriceInCents"];
  canEditCost?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditPrice?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditTradePartner?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  addedLineItem?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>;
  removalLineItem?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>;
  priceOnlyLineItem?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions> | null;
  isPlanBasedSwap?: ChangeEventMaterialVariantSwap["isPlanBasedSwap"];
  planBasedLineItems?: Array<FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>>;
  matchesPlaceholder?: ChangeEventMaterialVariantSwap["matchesPlaceholder"];
  hasAwardedCost?: ChangeEventMaterialVariantSwap["hasAwardedCost"];
  proposedMaterialVariantWasCreated?: ChangeEventMaterialVariantSwap["proposedMaterialVariantWasCreated"];
}

export function newChangeEventMaterialVariantSwap(
  options?: ChangeEventMaterialVariantSwapOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventMaterialVariantSwap>;
export function newChangeEventMaterialVariantSwap(
  options: ChangeEventMaterialVariantSwapOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventMaterialVariantSwap> {
  const o =
    (options.__typename ? options : cache["ChangeEventMaterialVariantSwap"] = {}) as ChangeEventMaterialVariantSwap;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventMaterialVariantSwap";
    o.id = options.id ?? nextFactoryId("ChangeEventMaterialVariantSwap");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
    o.originalMaterialVariant = maybeNew(
      "MaterialVariant",
      options.originalMaterialVariant,
      cache,
      options.hasOwnProperty("originalMaterialVariant"),
    );
    o.proposedMaterialVariant = maybeNew(
      "MaterialVariant",
      options.proposedMaterialVariant,
      cache,
      options.hasOwnProperty("proposedMaterialVariant"),
    );
    o.originalProjectItem = maybeNew(
      "ProjectItem",
      options.originalProjectItem,
      cache,
      options.hasOwnProperty("originalProjectItem"),
    );
    o.proposedProjectItem = maybeNew(
      "ProjectItem",
      options.proposedProjectItem,
      cache,
      options.hasOwnProperty("proposedProjectItem"),
    );
    o.proposedTradePartner = maybeNewOrNull("TradePartner", options.proposedTradePartner, cache);
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.canEditCost = maybeNew("PotentialOperation2", options.canEditCost, cache, options.hasOwnProperty("canEditCost"));
    o.canEditPrice = maybeNew(
      "PotentialOperation2",
      options.canEditPrice,
      cache,
      options.hasOwnProperty("canEditPrice"),
    );
    o.canEditTradePartner = maybeNew(
      "PotentialOperation2",
      options.canEditTradePartner,
      cache,
      options.hasOwnProperty("canEditTradePartner"),
    );
    o.addedLineItem = maybeNew(
      "ChangeEventLineItem",
      options.addedLineItem,
      cache,
      options.hasOwnProperty("addedLineItem"),
    );
    o.removalLineItem = maybeNew(
      "ChangeEventLineItem",
      options.removalLineItem,
      cache,
      options.hasOwnProperty("removalLineItem"),
    );
    o.priceOnlyLineItem = maybeNewOrNull("ChangeEventLineItem", options.priceOnlyLineItem, cache);
    o.isPlanBasedSwap = options.isPlanBasedSwap ?? false;
    o.planBasedLineItems = (options.planBasedLineItems ?? []).map((i) =>
      maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("planBasedLineItems"))
    );
    o.matchesPlaceholder = options.matchesPlaceholder ?? false;
    o.hasAwardedCost = options.hasAwardedCost ?? false;
    o.proposedMaterialVariantWasCreated = options.proposedMaterialVariantWasCreated ?? false;
    return o as FactoryResult<ChangeEventMaterialVariantSwap>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventMaterialVariantSwap"] = newChangeEventMaterialVariantSwap;

export interface ChangeEventOriginalOptionOptions {
  __typename?: "ChangeEventOriginalOption";
  id?: ChangeEventOriginalOption["id"];
  createdAt?: ChangeEventOriginalOption["createdAt"];
  priceInCents?: ChangeEventOriginalOption["priceInCents"];
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
}

export function newChangeEventOriginalOption(
  options?: ChangeEventOriginalOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventOriginalOption>;
export function newChangeEventOriginalOption(
  options: ChangeEventOriginalOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventOriginalOption> {
  const o = (options.__typename ? options : cache["ChangeEventOriginalOption"] = {}) as ChangeEventOriginalOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventOriginalOption";
    o.id = options.id ?? nextFactoryId("ChangeEventOriginalOption");
    o.createdAt = options.createdAt ?? newDateTime();
    o.priceInCents = options.priceInCents ?? 0;
    o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
    o.readyPlanOption = maybeNew(
      "ReadyPlanOption",
      options.readyPlanOption,
      cache,
      options.hasOwnProperty("readyPlanOption"),
    );
    return o as FactoryResult<ChangeEventOriginalOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventOriginalOption"] = newChangeEventOriginalOption;

export interface ChangeEventProposedOptionOptions {
  __typename?: "ChangeEventProposedOption";
  id?: ChangeEventProposedOption["id"];
  createdAt?: ChangeEventProposedOption["createdAt"];
  priceInCents?: ChangeEventProposedOption["priceInCents"];
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
}

export function newChangeEventProposedOption(
  options?: ChangeEventProposedOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventProposedOption>;
export function newChangeEventProposedOption(
  options: ChangeEventProposedOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventProposedOption> {
  const o = (options.__typename ? options : cache["ChangeEventProposedOption"] = {}) as ChangeEventProposedOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventProposedOption";
    o.id = options.id ?? nextFactoryId("ChangeEventProposedOption");
    o.createdAt = options.createdAt ?? newDateTime();
    o.priceInCents = options.priceInCents ?? 0;
    o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
    o.readyPlanOption = maybeNew(
      "ReadyPlanOption",
      options.readyPlanOption,
      cache,
      options.hasOwnProperty("readyPlanOption"),
    );
    return o as FactoryResult<ChangeEventProposedOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventProposedOption"] = newChangeEventProposedOption;

export interface ChangeEventReasonOptions {
  __typename?: "ChangeEventReason";
  id?: ChangeEventReason["id"];
  code?: ChangeEventReason["code"];
  name?: ChangeEventReason["name"];
  createdAt?: ChangeEventReason["createdAt"];
  updatedAt?: ChangeEventReason["updatedAt"];
  changeEvents?: Array<FactoryInput<ChangeEvent, ChangeEventOptions>>;
  isEpo?: ChangeEventReason["isEpo"];
  archived?: ChangeEventReason["archived"];
  isIncludedInVariance?: ChangeEventReason["isIncludedInVariance"];
  workflows?: ChangeEventReason["workflows"];
}

export function newChangeEventReason(
  options?: ChangeEventReasonOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventReason>;
export function newChangeEventReason(
  options: ChangeEventReasonOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventReason> {
  const o = (options.__typename ? options : cache["ChangeEventReason"] = {}) as ChangeEventReason;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventReason";
    o.id = options.id ?? nextFactoryId("ChangeEventReason");
    o.code = options.code ?? "code";
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.changeEvents = (options.changeEvents ?? []).map((i) =>
      maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
    );
    o.isEpo = options.isEpo ?? false;
    o.archived = options.archived ?? false;
    o.isIncludedInVariance = options.isIncludedInVariance ?? null;
    o.workflows = options.workflows ?? [];
    return o as FactoryResult<ChangeEventReason>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventReason"] = newChangeEventReason;

export interface SaveChangeEventReasonResultOptions {
  __typename?: "SaveChangeEventReasonResult";
  changeEventReason?: FactoryInput<ChangeEventReason, ChangeEventReasonOptions>;
}

export function newSaveChangeEventReasonResult(
  options?: SaveChangeEventReasonResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveChangeEventReasonResult>;
export function newSaveChangeEventReasonResult(
  options: SaveChangeEventReasonResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveChangeEventReasonResult> {
  const o = (options.__typename ? options : cache["SaveChangeEventReasonResult"] = {}) as SaveChangeEventReasonResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveChangeEventReasonResult";
    o.changeEventReason = maybeNew(
      "ChangeEventReason",
      options.changeEventReason,
      cache,
      options.hasOwnProperty("changeEventReason"),
    );
    return o as FactoryResult<SaveChangeEventReasonResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveChangeEventReasonResult"] = newSaveChangeEventReasonResult;

export interface ChangeEventTemplateConfigOptions {
  __typename?: "ChangeEventTemplateConfig";
  id?: ChangeEventTemplateConfig["id"];
  onlyChangedInVersion?: ChangeEventTemplateConfig["onlyChangedInVersion"];
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  parent?: BaseItemParentVersion | FactoryResult<BaseItemParentVersionType> | BaseItemParentVersionOptions;
  name?: ChangeEventTemplateConfig["name"];
  createdAt?: ChangeEventTemplateConfig["createdAt"];
}

export function newChangeEventTemplateConfig(
  options?: ChangeEventTemplateConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventTemplateConfig>;
export function newChangeEventTemplateConfig(
  options: ChangeEventTemplateConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventTemplateConfig> {
  const o = (options.__typename ? options : cache["ChangeEventTemplateConfig"] = {}) as ChangeEventTemplateConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventTemplateConfig";
    o.id = options.id ?? nextFactoryId("ChangeEventTemplateConfig");
    o.onlyChangedInVersion = options.onlyChangedInVersion ?? null;
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
    o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
    o.parent = maybeNew("BaseItemParentVersion", options.parent, cache, options.hasOwnProperty("parent"));
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    return o as FactoryResult<ChangeEventTemplateConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventTemplateConfig"] = newChangeEventTemplateConfig;

export interface ChangeRequestOptions {
  __typename?: "ChangeRequest";
  id?: ChangeRequest["id"];
  title?: ChangeRequest["title"];
  name?: ChangeRequest["name"];
  rationale?: ChangeRequest["rationale"];
  estimateBudgetImpactInCents?: ChangeRequest["estimateBudgetImpactInCents"];
  estimateBudgetImpactInCentsFallback?: ChangeRequest["estimateBudgetImpactInCentsFallback"];
  estimateScheduleImpactInDays?: ChangeRequest["estimateScheduleImpactInDays"];
  createdAt?: ChangeRequest["createdAt"];
  updatedAt?: ChangeRequest["updatedAt"];
  priority?: ChangeRequestPriorityDetailOptions | ChangeRequestPriority;
  source?: ChangeRequestSourceDetailOptions | ChangeRequestSource;
  status?: ChangeRequestStatusDetailOptions | ChangeRequestStatus;
  createdBy?: FactoryInput<User, UserOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  scopes?: Array<FactoryInput<ChangeRequestScope, ChangeRequestScopeOptions>>;
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
  blocking?: Array<FactoryInput<ChangeRequest, ChangeRequestOptions>>;
  blockers?: Array<FactoryInput<ChangeRequest, ChangeRequestOptions>>;
  changeRequestAssets?: Array<FactoryInput<ChangeRequestAsset, ChangeRequestAssetOptions>>;
  toDos?: Array<FactoryInput<ChangeRequestToDo, ChangeRequestToDoOptions>>;
  history?: Array<FactoryInput<History, HistoryOptions>>;
  changeTypes?: ChangeRequest["changeTypes"];
  approval?: FactoryInput<Approval, ApprovalOptions> | null;
  predictedApprovers?: Array<
    | ApproverUser
    | FactoryResult<ApproverUser>
    | ClientOptions
    | RequireTypename<InternalUserOptions>
    | RequireTypename<TradePartnerUserOptions>
  >;
  estimateRevenueImpactInCents?: ChangeRequest["estimateRevenueImpactInCents"];
  estimateMarginImpactBasisPoints?: ChangeRequest["estimateMarginImpactBasisPoints"];
  linkedTo?: Array<FactoryInput<ChangeRequest, ChangeRequestOptions>>;
  groups?: Array<FactoryInput<ChangeRequestGroup, ChangeRequestGroupOptions>>;
  isStandardOffering?: ChangeRequest["isStandardOffering"];
  salesforceOpportunityUrl?: ChangeRequest["salesforceOpportunityUrl"];
  isUnderContract?: ChangeRequest["isUnderContract"];
  productSelection?: ChangeRequest["productSelection"];
  markupBasisPoints?: ChangeRequest["markupBasisPoints"];
  estimatedBuyerOutOfPocketInCents?: ChangeRequest["estimatedBuyerOutOfPocketInCents"];
  estimatedRetailPriceInCents?: ChangeRequest["estimatedRetailPriceInCents"];
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ChangeRequest["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ChangeRequest["isFollowed"];
}

export function newChangeRequest(
  options?: ChangeRequestOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequest>;
export function newChangeRequest(
  options: ChangeRequestOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequest> {
  const o = (options.__typename ? options : cache["ChangeRequest"] = {}) as ChangeRequest;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequest";
    o.id = options.id ?? nextFactoryId("ChangeRequest");
    o.title = options.title ?? "title";
    o.name = options.name ?? "name";
    o.rationale = options.rationale ?? "rationale";
    o.estimateBudgetImpactInCents = options.estimateBudgetImpactInCents ?? null;
    o.estimateBudgetImpactInCentsFallback = options.estimateBudgetImpactInCentsFallback ?? 0;
    o.estimateScheduleImpactInDays = options.estimateScheduleImpactInDays ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.priority = enumOrDetailOfChangeRequestPriority(options.priority);
    o.source = enumOrDetailOfChangeRequestSource(options.source);
    o.status = enumOrDetailOfChangeRequestStatus(options.status);
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.scopes = (options.scopes ?? []).map((i) =>
      maybeNew("ChangeRequestScope", i, cache, options.hasOwnProperty("scopes"))
    );
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    o.blocking = (options.blocking ?? []).map((i) =>
      maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("blocking"))
    );
    o.blockers = (options.blockers ?? []).map((i) =>
      maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("blockers"))
    );
    o.changeRequestAssets = (options.changeRequestAssets ?? []).map((i) =>
      maybeNew("ChangeRequestAsset", i, cache, options.hasOwnProperty("changeRequestAssets"))
    );
    o.toDos = (options.toDos ?? []).map((i) =>
      maybeNew("ChangeRequestToDo", i, cache, options.hasOwnProperty("toDos"))
    );
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.changeTypes = options.changeTypes ?? [];
    o.approval = maybeNewOrNull("Approval", options.approval, cache);
    o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
      maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
    );
    o.estimateRevenueImpactInCents = options.estimateRevenueImpactInCents ?? null;
    o.estimateMarginImpactBasisPoints = options.estimateMarginImpactBasisPoints ?? null;
    o.linkedTo = (options.linkedTo ?? []).map((i) =>
      maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("linkedTo"))
    );
    o.groups = (options.groups ?? []).map((i) =>
      maybeNew("ChangeRequestGroup", i, cache, options.hasOwnProperty("groups"))
    );
    o.isStandardOffering = options.isStandardOffering ?? null;
    o.salesforceOpportunityUrl = options.salesforceOpportunityUrl ?? null;
    o.isUnderContract = options.isUnderContract ?? null;
    o.productSelection = options.productSelection ?? null;
    o.markupBasisPoints = options.markupBasisPoints ?? null;
    o.estimatedBuyerOutOfPocketInCents = options.estimatedBuyerOutOfPocketInCents ?? null;
    o.estimatedRetailPriceInCents = options.estimatedRetailPriceInCents ?? null;
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    return o as FactoryResult<ChangeRequest>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequest"] = newChangeRequest;

export interface ChangeRequestsPageResultOptions {
  __typename?: "ChangeRequestsPageResult";
  entities?: Array<FactoryInput<ChangeRequest, ChangeRequestOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newChangeRequestsPageResult(
  options?: ChangeRequestsPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestsPageResult>;
export function newChangeRequestsPageResult(
  options: ChangeRequestsPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestsPageResult> {
  const o = (options.__typename ? options : cache["ChangeRequestsPageResult"] = {}) as ChangeRequestsPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestsPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ChangeRequestsPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestsPageResult"] = newChangeRequestsPageResult;

export interface SaveChangeRequestResultOptions {
  __typename?: "SaveChangeRequestResult";
  changeRequest?: FactoryInput<ChangeRequest, ChangeRequestOptions>;
}

export function newSaveChangeRequestResult(
  options?: SaveChangeRequestResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveChangeRequestResult>;
export function newSaveChangeRequestResult(
  options: SaveChangeRequestResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveChangeRequestResult> {
  const o = (options.__typename ? options : cache["SaveChangeRequestResult"] = {}) as SaveChangeRequestResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveChangeRequestResult";
    o.changeRequest = maybeNew("ChangeRequest", options.changeRequest, cache, options.hasOwnProperty("changeRequest"));
    return o as FactoryResult<SaveChangeRequestResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveChangeRequestResult"] = newSaveChangeRequestResult;

export interface SaveChangeRequestsResultOptions {
  __typename?: "SaveChangeRequestsResult";
  changeRequests?: Array<FactoryInput<ChangeRequest, ChangeRequestOptions>>;
}

export function newSaveChangeRequestsResult(
  options?: SaveChangeRequestsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveChangeRequestsResult>;
export function newSaveChangeRequestsResult(
  options: SaveChangeRequestsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveChangeRequestsResult> {
  const o = (options.__typename ? options : cache["SaveChangeRequestsResult"] = {}) as SaveChangeRequestsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveChangeRequestsResult";
    o.changeRequests = (options.changeRequests ?? []).map((i) =>
      maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("changeRequests"))
    );
    return o as FactoryResult<SaveChangeRequestsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveChangeRequestsResult"] = newSaveChangeRequestsResult;

export interface ChangeRequestApproverSubjectDataOptions {
  __typename?: "ChangeRequestApproverSubjectData";
  businessFunction?: ChangeRequestApproverSubjectData["businessFunction"];
  autoApprovalAmountInCents?: ChangeRequestApproverSubjectData["autoApprovalAmountInCents"];
}

export function newChangeRequestApproverSubjectData(
  options?: ChangeRequestApproverSubjectDataOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestApproverSubjectData>;
export function newChangeRequestApproverSubjectData(
  options: ChangeRequestApproverSubjectDataOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestApproverSubjectData> {
  const o =
    (options.__typename ? options : cache["ChangeRequestApproverSubjectData"] = {}) as ChangeRequestApproverSubjectData;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestApproverSubjectData";
    o.businessFunction = options.businessFunction ?? "businessFunction";
    o.autoApprovalAmountInCents = options.autoApprovalAmountInCents ?? null;
    return o as FactoryResult<ChangeRequestApproverSubjectData>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestApproverSubjectData"] = newChangeRequestApproverSubjectData;

export interface ChangeRequestAssetOptions {
  __typename?: "ChangeRequestAsset";
  id?: ChangeRequestAsset["id"];
  name?: ChangeRequestAsset["name"];
  deletedAt?: ChangeRequestAsset["deletedAt"];
  createdAt?: ChangeRequestAsset["createdAt"];
  updatedAt?: ChangeRequestAsset["updatedAt"];
  functionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  platform?: ChangeRequestAssetPlatformDetailOptions | ChangeRequestAssetPlatform;
  implementationReviewer?: ProjectRoleDetailOptions | ProjectRole | null;
  changeRequests?: Array<FactoryInput<ChangeRequest, ChangeRequestOptions>>;
  scopes?: ChangeRequestAsset["scopes"];
  implementer?: ProjectRoleDetailOptions | ProjectRole;
  requiredForChangeRequestSource?: ChangeRequestAsset["requiredForChangeRequestSource"];
  systemChangeRequestAsset?: SystemChangeRequestAssetDetailOptions | SystemChangeRequestAsset | null;
}

export function newChangeRequestAsset(
  options?: ChangeRequestAssetOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestAsset>;
export function newChangeRequestAsset(
  options: ChangeRequestAssetOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestAsset> {
  const o = (options.__typename ? options : cache["ChangeRequestAsset"] = {}) as ChangeRequestAsset;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestAsset";
    o.id = options.id ?? nextFactoryId("ChangeRequestAsset");
    o.name = options.name ?? "name";
    o.deletedAt = options.deletedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.functionType = enumOrDetailOfBusinessFunctionType(options.functionType);
    o.platform = enumOrDetailOfChangeRequestAssetPlatform(options.platform);
    o.implementationReviewer = enumOrDetailOrNullOfProjectRole(options.implementationReviewer);
    o.changeRequests = (options.changeRequests ?? []).map((i) =>
      maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("changeRequests"))
    );
    o.scopes = options.scopes ?? [];
    o.implementer = enumOrDetailOfProjectRole(options.implementer);
    o.requiredForChangeRequestSource = options.requiredForChangeRequestSource ?? [];
    o.systemChangeRequestAsset = enumOrDetailOrNullOfSystemChangeRequestAsset(options.systemChangeRequestAsset);
    return o as FactoryResult<ChangeRequestAsset>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestAsset"] = newChangeRequestAsset;

export interface SaveChangeRequestAssetsResultOptions {
  __typename?: "SaveChangeRequestAssetsResult";
  changeRequestAssets?: Array<FactoryInput<ChangeRequestAsset, ChangeRequestAssetOptions>>;
}

export function newSaveChangeRequestAssetsResult(
  options?: SaveChangeRequestAssetsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveChangeRequestAssetsResult>;
export function newSaveChangeRequestAssetsResult(
  options: SaveChangeRequestAssetsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveChangeRequestAssetsResult> {
  const o =
    (options.__typename ? options : cache["SaveChangeRequestAssetsResult"] = {}) as SaveChangeRequestAssetsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveChangeRequestAssetsResult";
    o.changeRequestAssets = (options.changeRequestAssets ?? []).map((i) =>
      maybeNew("ChangeRequestAsset", i, cache, options.hasOwnProperty("changeRequestAssets"))
    );
    return o as FactoryResult<SaveChangeRequestAssetsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveChangeRequestAssetsResult"] = newSaveChangeRequestAssetsResult;

export interface ChangeRequestAssetsPageResultOptions {
  __typename?: "ChangeRequestAssetsPageResult";
  entities?: Array<FactoryInput<ChangeRequestAsset, ChangeRequestAssetOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newChangeRequestAssetsPageResult(
  options?: ChangeRequestAssetsPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestAssetsPageResult>;
export function newChangeRequestAssetsPageResult(
  options: ChangeRequestAssetsPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestAssetsPageResult> {
  const o =
    (options.__typename ? options : cache["ChangeRequestAssetsPageResult"] = {}) as ChangeRequestAssetsPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestAssetsPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ChangeRequestAsset", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ChangeRequestAssetsPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestAssetsPageResult"] = newChangeRequestAssetsPageResult;

export interface ChangeRequestGroupOptions {
  __typename?: "ChangeRequestGroup";
  id?: ChangeRequestGroup["id"];
  name?: ChangeRequestGroup["name"];
  createdAt?: ChangeRequestGroup["createdAt"];
  updatedAt?: ChangeRequestGroup["updatedAt"];
  changeRequests?: Array<FactoryInput<ChangeRequest, ChangeRequestOptions>>;
  salesforceOpportunityLink?: ChangeRequestGroup["salesforceOpportunityLink"];
  underContract?: ChangeRequestGroup["underContract"];
}

export function newChangeRequestGroup(
  options?: ChangeRequestGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestGroup>;
export function newChangeRequestGroup(
  options: ChangeRequestGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestGroup> {
  const o = (options.__typename ? options : cache["ChangeRequestGroup"] = {}) as ChangeRequestGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestGroup";
    o.id = options.id ?? nextFactoryId("ChangeRequestGroup");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.changeRequests = (options.changeRequests ?? []).map((i) =>
      maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("changeRequests"))
    );
    o.salesforceOpportunityLink = options.salesforceOpportunityLink ?? null;
    o.underContract = options.underContract ?? null;
    return o as FactoryResult<ChangeRequestGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestGroup"] = newChangeRequestGroup;

export interface SaveChangeRequestGroupResultOptions {
  __typename?: "SaveChangeRequestGroupResult";
  changeRequestGroup?: FactoryInput<ChangeRequestGroup, ChangeRequestGroupOptions>;
}

export function newSaveChangeRequestGroupResult(
  options?: SaveChangeRequestGroupResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveChangeRequestGroupResult>;
export function newSaveChangeRequestGroupResult(
  options: SaveChangeRequestGroupResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveChangeRequestGroupResult> {
  const o = (options.__typename ? options : cache["SaveChangeRequestGroupResult"] = {}) as SaveChangeRequestGroupResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveChangeRequestGroupResult";
    o.changeRequestGroup = maybeNew(
      "ChangeRequestGroup",
      options.changeRequestGroup,
      cache,
      options.hasOwnProperty("changeRequestGroup"),
    );
    return o as FactoryResult<SaveChangeRequestGroupResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveChangeRequestGroupResult"] = newSaveChangeRequestGroupResult;

export interface SaveChangeRequestGroupsResultOptions {
  __typename?: "SaveChangeRequestGroupsResult";
  changeRequestGroups?: Array<FactoryInput<ChangeRequestGroup, ChangeRequestGroupOptions>>;
}

export function newSaveChangeRequestGroupsResult(
  options?: SaveChangeRequestGroupsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveChangeRequestGroupsResult>;
export function newSaveChangeRequestGroupsResult(
  options: SaveChangeRequestGroupsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveChangeRequestGroupsResult> {
  const o =
    (options.__typename ? options : cache["SaveChangeRequestGroupsResult"] = {}) as SaveChangeRequestGroupsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveChangeRequestGroupsResult";
    o.changeRequestGroups = (options.changeRequestGroups ?? []).map((i) =>
      maybeNew("ChangeRequestGroup", i, cache, options.hasOwnProperty("changeRequestGroups"))
    );
    return o as FactoryResult<SaveChangeRequestGroupsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveChangeRequestGroupsResult"] = newSaveChangeRequestGroupsResult;

export interface ChangeRequestScopeOptions {
  __typename?: "ChangeRequestScope";
  id?: ChangeRequestScope["id"];
  createdAt?: ChangeRequestScope["createdAt"];
  updatedAt?: ChangeRequestScope["updatedAt"];
  changeRequest?: FactoryInput<ChangeRequest, ChangeRequestOptions>;
  target?:
    | ChangeRequestScopeTarget
    | FactoryResult<ChangeRequestScopeTarget>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  deletedAt?: ChangeRequestScope["deletedAt"];
}

export function newChangeRequestScope(
  options?: ChangeRequestScopeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestScope>;
export function newChangeRequestScope(
  options: ChangeRequestScopeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestScope> {
  const o = (options.__typename ? options : cache["ChangeRequestScope"] = {}) as ChangeRequestScope;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestScope";
    o.id = options.id ?? nextFactoryId("ChangeRequestScope");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.changeRequest = maybeNew("ChangeRequest", options.changeRequest, cache, options.hasOwnProperty("changeRequest"));
    o.target = maybeNew(options.target?.__typename ?? "StandaloneProject", options.target, cache);
    o.deletedAt = options.deletedAt ?? null;
    return o as FactoryResult<ChangeRequestScope>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestScope"] = newChangeRequestScope;

export interface ChangeRequestToDoOptions {
  __typename?: "ChangeRequestToDo";
  id?: ChangeRequestToDo["id"];
  name?: ChangeRequestToDo["name"];
  description?: ChangeRequestToDo["description"];
  deletedAt?: ChangeRequestToDo["deletedAt"];
  createdAt?: ChangeRequestToDo["createdAt"];
  updatedAt?: ChangeRequestToDo["updatedAt"];
  dueDate?: ChangeRequestToDo["dueDate"];
  order?: ChangeRequestToDo["order"];
  urgent?: ChangeRequestToDo["urgent"];
  status?: ToDoStatusDetailOptions | ToDoStatus;
  type?: ToDoTypeDetailOptions | ToDoType;
  createdBy?: FactoryInput<User, UserOptions>;
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
  checklistItems?: Array<FactoryInput<ToDoChecklistItem, ToDoChecklistItemOptions>>;
  assignees?: Array<FactoryInput<User, UserOptions>>;
  parent?:
    | ToDoParent
    | FactoryResult<ToDoParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<CohortOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | null;
  priorityGroup?: ChangeRequestToDo["priorityGroup"];
  changeRequestToDoType?: ChangeRequestToDoTypeDetailOptions | ChangeRequestToDoType;
  businessFunction?: FactoryInput<BusinessFunction, BusinessFunctionOptions>;
  changeRequest?: FactoryInput<ChangeRequest, ChangeRequestOptions>;
  changeRequestAsset?: FactoryInput<ChangeRequestAsset, ChangeRequestAssetOptions> | null;
  originalAssignee?: FactoryInput<User, UserOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ChangeRequestToDo["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ChangeRequestToDo["isFollowed"];
}

export function newChangeRequestToDo(
  options?: ChangeRequestToDoOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestToDo>;
export function newChangeRequestToDo(
  options: ChangeRequestToDoOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestToDo> {
  const o = (options.__typename ? options : cache["ChangeRequestToDo"] = {}) as ChangeRequestToDo;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestToDo";
    o.id = options.id ?? nextFactoryId("ChangeRequestToDo");
    o.name = options.name ?? "name";
    o.description = options.description ?? null;
    o.deletedAt = options.deletedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.dueDate = options.dueDate ?? null;
    o.order = options.order ?? "order";
    o.urgent = options.urgent ?? false;
    o.status = enumOrDetailOfToDoStatus(options.status);
    o.type = enumOrDetailOfToDoType(options.type);
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    o.checklistItems = (options.checklistItems ?? []).map((i) =>
      maybeNew("ToDoChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
    );
    o.assignees = (options.assignees ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("assignees")));
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    o.priorityGroup = options.priorityGroup ?? 0;
    o.changeRequestToDoType = enumOrDetailOfChangeRequestToDoType(options.changeRequestToDoType);
    o.businessFunction = maybeNew(
      "BusinessFunction",
      options.businessFunction,
      cache,
      options.hasOwnProperty("businessFunction"),
    );
    o.changeRequest = maybeNew("ChangeRequest", options.changeRequest, cache, options.hasOwnProperty("changeRequest"));
    o.changeRequestAsset = maybeNewOrNull("ChangeRequestAsset", options.changeRequestAsset, cache);
    o.originalAssignee = maybeNew("User", options.originalAssignee, cache, options.hasOwnProperty("originalAssignee"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    return o as FactoryResult<ChangeRequestToDo>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestToDo"] = newChangeRequestToDo;

export interface CheckoutConfigOptions {
  __typename?: "CheckoutConfig";
  id?: CheckoutConfig["id"];
  name?: CheckoutConfig["name"];
  reservedAt?: CheckoutConfig["reservedAt"];
  expiresAt?: CheckoutConfig["expiresAt"];
  status?: CheckoutConfig["status"];
  customerEmail?: CheckoutConfig["customerEmail"];
  customerFirstName?: CheckoutConfig["customerFirstName"];
  customerLastName?: CheckoutConfig["customerLastName"];
  customerPhone?: CheckoutConfig["customerPhone"];
  structure?: FactoryInput<Structure, StructureOptions>;
  community?: FactoryInput<Community, CommunityOptions>;
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions> | null;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions | null;
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  mhExteriorOptionNames?: CheckoutConfig["mhExteriorOptionNames"];
  mhInteriorOptionNames?: CheckoutConfig["mhInteriorOptionNames"];
  exteriorOptionNames?: CheckoutConfig["exteriorOptionNames"];
  interiorOptionNames?: CheckoutConfig["interiorOptionNames"];
  aduExteriorOptionNames?: CheckoutConfig["aduExteriorOptionNames"];
  aduInteriorOptionNames?: CheckoutConfig["aduInteriorOptionNames"];
  isReversed?: CheckoutConfig["isReversed"];
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionGroups?: Array<FactoryInput<CheckoutConfigOptionGroup, CheckoutConfigOptionGroupOptions>>;
  mhOptionGroups?: Array<FactoryInput<CheckoutConfigOptionGroup, CheckoutConfigOptionGroupOptions>>;
  aduOptionGroups?: Array<FactoryInput<CheckoutConfigOptionGroup, CheckoutConfigOptionGroupOptions>>;
  mhSalesPriceInCents?: CheckoutConfig["mhSalesPriceInCents"];
  aduSalesPriceInCents?: CheckoutConfig["aduSalesPriceInCents"];
  salesPriceInCents?: CheckoutConfig["salesPriceInCents"];
  mhTotalPriceInCents?: CheckoutConfig["mhTotalPriceInCents"];
  aduTotalPriceInCents?: CheckoutConfig["aduTotalPriceInCents"];
  additionalSitePriceInCents?: CheckoutConfig["additionalSitePriceInCents"];
  totalPriceInCents?: CheckoutConfig["totalPriceInCents"];
  createdAt?: CheckoutConfig["createdAt"];
  updatedAt?: CheckoutConfig["updatedAt"];
  checkoutUrl?: FactoryInput<Url, UrlOptions>;
  pricingTraceUrl?: FactoryInput<Url, UrlOptions> | null;
  canChangeProductOffering?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  programData?: FactoryInput<ProgramData, ProgramDataOptions> | null;
  aduProgramData?: FactoryInput<ProgramData, ProgramDataOptions> | null;
  rendering?: FactoryInput<Asset, AssetOptions> | null;
  interiorRenderings?: Array<FactoryInput<InteriorRoomRendering, InteriorRoomRenderingOptions>>;
  renderings?: Array<FactoryInput<RenderingAsset, RenderingAssetOptions>>;
  storedPriceInCents?: CheckoutConfig["storedPriceInCents"];
  createdBy?: FactoryInput<User, UserOptions> | null;
  interiorSubSteps?: Array<FactoryInput<CheckoutConfigInteriorSubStep, CheckoutConfigInteriorSubStepOptions>>;
  insideMapsTextureSwaps?: FactoryInput<InsideMapsTextureSwaps, InsideMapsTextureSwapsOptions> | null;
  insideMapsRoomRenderings?: Array<FactoryInput<InsideMapsRoomRendering, InsideMapsRoomRenderingOptions>>;
  homeowners?: Array<FactoryInput<Homeowner, HomeownerOptions>>;
  aggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  changeEvents?: Array<FactoryInput<ChangeEvent, ChangeEventOptions>>;
  archivedAt?: CheckoutConfig["archivedAt"];
  useStackedPricing?: CheckoutConfig["useStackedPricing"];
  mhEstimatedInvoiceSchedule?: Array<FactoryInput<EstimatedInvoiceScheduleItem, EstimatedInvoiceScheduleItemOptions>>;
  aduEstimatedInvoiceSchedule?: Array<FactoryInput<EstimatedInvoiceScheduleItem, EstimatedInvoiceScheduleItemOptions>>;
  estimatedInvoiceSchedule?: Array<FactoryInput<EstimatedInvoiceScheduleItem, EstimatedInvoiceScheduleItemOptions>>;
  buildablePlans?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  buildableAduPlans?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  aduProductOffering?: FactoryInput<ProductOffering, ProductOfferingOptions> | null;
  aduAggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  potentialAdus?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  isPinned?: CheckoutConfig["isPinned"];
  isAduPinned?: CheckoutConfig["isAduPinned"];
}

export function newCheckoutConfig(
  options?: CheckoutConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfig>;
export function newCheckoutConfig(
  options: CheckoutConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfig> {
  const o = (options.__typename ? options : cache["CheckoutConfig"] = {}) as CheckoutConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfig";
    o.id = options.id ?? nextFactoryId("CheckoutConfig");
    o.name = options.name ?? null;
    o.reservedAt = options.reservedAt ?? null;
    o.expiresAt = options.expiresAt ?? null;
    o.status = options.status ?? CheckoutConfigStatus.Draft;
    o.customerEmail = options.customerEmail ?? null;
    o.customerFirstName = options.customerFirstName ?? null;
    o.customerLastName = options.customerLastName ?? null;
    o.customerPhone = options.customerPhone ?? null;
    o.structure = maybeNew("Structure", options.structure, cache, options.hasOwnProperty("structure"));
    o.community = maybeNew("Community", options.community, cache, options.hasOwnProperty("community"));
    o.productOffering = maybeNewOrNull("ProductOffering", options.productOffering, cache);
    o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    o.mhExteriorOptionNames = options.mhExteriorOptionNames ?? [];
    o.mhInteriorOptionNames = options.mhInteriorOptionNames ?? [];
    o.exteriorOptionNames = options.exteriorOptionNames ?? [];
    o.interiorOptionNames = options.interiorOptionNames ?? [];
    o.aduExteriorOptionNames = options.aduExteriorOptionNames ?? [];
    o.aduInteriorOptionNames = options.aduInteriorOptionNames ?? [];
    o.isReversed = options.isReversed ?? false;
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.optionGroups = (options.optionGroups ?? []).map((i) =>
      maybeNew("CheckoutConfigOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
    );
    o.mhOptionGroups = (options.mhOptionGroups ?? []).map((i) =>
      maybeNew("CheckoutConfigOptionGroup", i, cache, options.hasOwnProperty("mhOptionGroups"))
    );
    o.aduOptionGroups = (options.aduOptionGroups ?? []).map((i) =>
      maybeNew("CheckoutConfigOptionGroup", i, cache, options.hasOwnProperty("aduOptionGroups"))
    );
    o.mhSalesPriceInCents = options.mhSalesPriceInCents ?? 0;
    o.aduSalesPriceInCents = options.aduSalesPriceInCents ?? 0;
    o.salesPriceInCents = options.salesPriceInCents ?? 0;
    o.mhTotalPriceInCents = options.mhTotalPriceInCents ?? 0;
    o.aduTotalPriceInCents = options.aduTotalPriceInCents ?? 0;
    o.additionalSitePriceInCents = options.additionalSitePriceInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.checkoutUrl = maybeNew("Url", options.checkoutUrl, cache, options.hasOwnProperty("checkoutUrl"));
    o.pricingTraceUrl = maybeNewOrNull("Url", options.pricingTraceUrl, cache);
    o.canChangeProductOffering = maybeNew(
      "PotentialOperation2",
      options.canChangeProductOffering,
      cache,
      options.hasOwnProperty("canChangeProductOffering"),
    );
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.programData = maybeNewOrNull("ProgramData", options.programData, cache);
    o.aduProgramData = maybeNewOrNull("ProgramData", options.aduProgramData, cache);
    o.rendering = maybeNewOrNull("Asset", options.rendering, cache);
    o.interiorRenderings = (options.interiorRenderings ?? []).map((i) =>
      maybeNew("InteriorRoomRendering", i, cache, options.hasOwnProperty("interiorRenderings"))
    );
    o.renderings = (options.renderings ?? []).map((i) =>
      maybeNew("RenderingAsset", i, cache, options.hasOwnProperty("renderings"))
    );
    o.storedPriceInCents = options.storedPriceInCents ?? null;
    o.createdBy = maybeNewOrNull("User", options.createdBy, cache);
    o.interiorSubSteps = (options.interiorSubSteps ?? []).map((i) =>
      maybeNew("CheckoutConfigInteriorSubStep", i, cache, options.hasOwnProperty("interiorSubSteps"))
    );
    o.insideMapsTextureSwaps = maybeNewOrNull("InsideMapsTextureSwaps", options.insideMapsTextureSwaps, cache);
    o.insideMapsRoomRenderings = (options.insideMapsRoomRenderings ?? []).map((i) =>
      maybeNew("InsideMapsRoomRendering", i, cache, options.hasOwnProperty("insideMapsRoomRenderings"))
    );
    o.homeowners = (options.homeowners ?? []).map((i) =>
      maybeNew("Homeowner", i, cache, options.hasOwnProperty("homeowners"))
    );
    o.aggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateVersion, cache);
    o.changeEvents = (options.changeEvents ?? []).map((i) =>
      maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
    );
    o.archivedAt = options.archivedAt ?? null;
    o.useStackedPricing = options.useStackedPricing ?? false;
    o.mhEstimatedInvoiceSchedule = (options.mhEstimatedInvoiceSchedule ?? []).map((i) =>
      maybeNew("EstimatedInvoiceScheduleItem", i, cache, options.hasOwnProperty("mhEstimatedInvoiceSchedule"))
    );
    o.aduEstimatedInvoiceSchedule = (options.aduEstimatedInvoiceSchedule ?? []).map((i) =>
      maybeNew("EstimatedInvoiceScheduleItem", i, cache, options.hasOwnProperty("aduEstimatedInvoiceSchedule"))
    );
    o.estimatedInvoiceSchedule = (options.estimatedInvoiceSchedule ?? []).map((i) =>
      maybeNew("EstimatedInvoiceScheduleItem", i, cache, options.hasOwnProperty("estimatedInvoiceSchedule"))
    );
    o.buildablePlans = (options.buildablePlans ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildablePlans"))
    );
    o.buildableAduPlans = (options.buildableAduPlans ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildableAduPlans"))
    );
    o.aduProductOffering = maybeNewOrNull("ProductOffering", options.aduProductOffering, cache);
    o.aduAggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aduAggregateVersion, cache);
    o.potentialAdus = (options.potentialAdus ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("potentialAdus"))
    );
    o.isPinned = options.isPinned ?? false;
    o.isAduPinned = options.isAduPinned ?? false;
    return o as FactoryResult<CheckoutConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfig"] = newCheckoutConfig;

export interface EstimatedInvoiceScheduleItemOptions {
  __typename?: "EstimatedInvoiceScheduleItem";
  costCodeInvoiceCategory?: EstimatedInvoiceScheduleItem["costCodeInvoiceCategory"];
  invoiceAmountInCents?: EstimatedInvoiceScheduleItem["invoiceAmountInCents"];
}

export function newEstimatedInvoiceScheduleItem(
  options?: EstimatedInvoiceScheduleItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<EstimatedInvoiceScheduleItem>;
export function newEstimatedInvoiceScheduleItem(
  options: EstimatedInvoiceScheduleItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<EstimatedInvoiceScheduleItem> {
  const o = (options.__typename ? options : cache["EstimatedInvoiceScheduleItem"] = {}) as EstimatedInvoiceScheduleItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "EstimatedInvoiceScheduleItem";
    o.costCodeInvoiceCategory = options.costCodeInvoiceCategory ?? CostCodeInvoiceCategory.PreCon;
    o.invoiceAmountInCents = options.invoiceAmountInCents ?? 0;
    return o as FactoryResult<EstimatedInvoiceScheduleItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["EstimatedInvoiceScheduleItem"] = newEstimatedInvoiceScheduleItem;

export interface CheckoutConfigOptionGroupOptions {
  __typename?: "CheckoutConfigOptionGroup";
  id?: CheckoutConfigOptionGroup["id"];
  step?: CheckoutConfigOptionGroup["step"];
  subStepNumber?: CheckoutConfigOptionGroup["subStepNumber"];
  group?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>;
  options?: Array<FactoryInput<CheckoutConfigPotentialOption, CheckoutConfigPotentialOptionOptions>>;
  selectedOption?: FactoryInput<CheckoutConfigPotentialOption, CheckoutConfigPotentialOptionOptions> | null;
  cutoffDate?: CheckoutConfigOptionGroup["cutoffDate"];
  isEnabled?: CheckoutConfigOptionGroup["isEnabled"];
  canBeSelected?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  showOnCustomerSummary?: CheckoutConfigOptionGroup["showOnCustomerSummary"];
  parentGroup?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions> | null;
  childGroup?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions> | null;
}

export function newCheckoutConfigOptionGroup(
  options?: CheckoutConfigOptionGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigOptionGroup>;
export function newCheckoutConfigOptionGroup(
  options: CheckoutConfigOptionGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfigOptionGroup> {
  const o = (options.__typename ? options : cache["CheckoutConfigOptionGroup"] = {}) as CheckoutConfigOptionGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfigOptionGroup";
    o.id = options.id ?? nextFactoryId("CheckoutConfigOptionGroup");
    o.step = options.step ?? CheckoutConfigOptionGroupStep.ExteriorElevation;
    o.subStepNumber = options.subStepNumber ?? null;
    o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
    o.options = (options.options ?? []).map((i) =>
      maybeNew("CheckoutConfigPotentialOption", i, cache, options.hasOwnProperty("options"))
    );
    o.selectedOption = maybeNewOrNull("CheckoutConfigPotentialOption", options.selectedOption, cache);
    o.cutoffDate = options.cutoffDate ?? null;
    o.isEnabled = options.isEnabled ?? false;
    o.canBeSelected = maybeNew(
      "PotentialOperation2",
      options.canBeSelected,
      cache,
      options.hasOwnProperty("canBeSelected"),
    );
    o.showOnCustomerSummary = options.showOnCustomerSummary ?? false;
    o.parentGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.parentGroup, cache);
    o.childGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.childGroup, cache);
    return o as FactoryResult<CheckoutConfigOptionGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfigOptionGroup"] = newCheckoutConfigOptionGroup;

export interface CheckoutConfigPotentialOptionOptions {
  __typename?: "CheckoutConfigPotentialOption";
  id?: CheckoutConfigPotentialOption["id"];
  option?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  isSelected?: CheckoutConfigPotentialOption["isSelected"];
  isEnabled?: CheckoutConfigPotentialOption["isEnabled"];
  canBeSelected?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  showOnSummary?: CheckoutConfigPotentialOption["showOnSummary"];
  totalPriceInCents?: CheckoutConfigPotentialOption["totalPriceInCents"];
  totalCostInCents?: CheckoutConfigPotentialOption["totalCostInCents"];
  packageOptionMaterials?: Array<FactoryInput<MaterialVariant, MaterialVariantOptions>>;
  primaryProduct?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  displayProducts?: Array<FactoryInput<MaterialVariant, MaterialVariantOptions>>;
  includedBy?: FactoryInput<CheckoutConfigPotentialOption, CheckoutConfigPotentialOptionOptions> | null;
  includedByRoot?: FactoryInput<CheckoutConfigPotentialOption, CheckoutConfigPotentialOptionOptions> | null;
}

export function newCheckoutConfigPotentialOption(
  options?: CheckoutConfigPotentialOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigPotentialOption>;
export function newCheckoutConfigPotentialOption(
  options: CheckoutConfigPotentialOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfigPotentialOption> {
  const o =
    (options.__typename ? options : cache["CheckoutConfigPotentialOption"] = {}) as CheckoutConfigPotentialOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfigPotentialOption";
    o.id = options.id ?? nextFactoryId("CheckoutConfigPotentialOption");
    o.option = maybeNew("ReadyPlanOption", options.option, cache, options.hasOwnProperty("option"));
    o.isSelected = options.isSelected ?? false;
    o.isEnabled = options.isEnabled ?? false;
    o.canBeSelected = maybeNew(
      "PotentialOperation2",
      options.canBeSelected,
      cache,
      options.hasOwnProperty("canBeSelected"),
    );
    o.showOnSummary = options.showOnSummary ?? false;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.packageOptionMaterials = (options.packageOptionMaterials ?? []).map((i) =>
      maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("packageOptionMaterials"))
    );
    o.primaryProduct = maybeNewOrNull("MaterialVariant", options.primaryProduct, cache);
    o.displayProducts = (options.displayProducts ?? []).map((i) =>
      maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("displayProducts"))
    );
    o.includedBy = maybeNewOrNull("CheckoutConfigPotentialOption", options.includedBy, cache);
    o.includedByRoot = maybeNewOrNull("CheckoutConfigPotentialOption", options.includedByRoot, cache);
    return o as FactoryResult<CheckoutConfigPotentialOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfigPotentialOption"] = newCheckoutConfigPotentialOption;

export interface CheckoutConfigPackageOptionSlotOptions {
  __typename?: "CheckoutConfigPackageOptionSlot";
  id?: CheckoutConfigPackageOptionSlot["id"];
  location?: FactoryInput<Location, LocationOptions>;
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
}

export function newCheckoutConfigPackageOptionSlot(
  options?: CheckoutConfigPackageOptionSlotOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigPackageOptionSlot>;
export function newCheckoutConfigPackageOptionSlot(
  options: CheckoutConfigPackageOptionSlotOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfigPackageOptionSlot> {
  const o =
    (options.__typename ? options : cache["CheckoutConfigPackageOptionSlot"] = {}) as CheckoutConfigPackageOptionSlot;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfigPackageOptionSlot";
    o.id = options.id ?? nextFactoryId("CheckoutConfigPackageOptionSlot");
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.materialVariant = maybeNew(
      "MaterialVariant",
      options.materialVariant,
      cache,
      options.hasOwnProperty("materialVariant"),
    );
    return o as FactoryResult<CheckoutConfigPackageOptionSlot>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfigPackageOptionSlot"] = newCheckoutConfigPackageOptionSlot;

export interface CheckoutConfigPackageOptionProductOptions {
  __typename?: "CheckoutConfigPackageOptionProduct";
  id?: CheckoutConfigPackageOptionProduct["id"];
  slotId?: CheckoutConfigPackageOptionProduct["slotId"];
  placeholder?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  location?: FactoryInput<Location, LocationOptions>;
  product?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  displayPackageOptionsAsSingleProduct?: CheckoutConfigPackageOptionProduct["displayPackageOptionsAsSingleProduct"];
}

export function newCheckoutConfigPackageOptionProduct(
  options?: CheckoutConfigPackageOptionProductOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigPackageOptionProduct>;
export function newCheckoutConfigPackageOptionProduct(
  options: CheckoutConfigPackageOptionProductOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfigPackageOptionProduct> {
  const o =
    (options.__typename
      ? options
      : cache["CheckoutConfigPackageOptionProduct"] = {}) as CheckoutConfigPackageOptionProduct;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfigPackageOptionProduct";
    o.id = options.id ?? nextFactoryId("CheckoutConfigPackageOptionProduct");
    o.slotId = options.slotId ?? "slotId";
    o.placeholder = maybeNew("MaterialVariant", options.placeholder, cache, options.hasOwnProperty("placeholder"));
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.product = maybeNew("MaterialVariant", options.product, cache, options.hasOwnProperty("product"));
    o.displayPackageOptionsAsSingleProduct = options.displayPackageOptionsAsSingleProduct ?? false;
    return o as FactoryResult<CheckoutConfigPackageOptionProduct>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfigPackageOptionProduct"] = newCheckoutConfigPackageOptionProduct;

export interface SaveCheckoutConfigResultOptions {
  __typename?: "SaveCheckoutConfigResult";
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions>;
}

export function newSaveCheckoutConfigResult(
  options?: SaveCheckoutConfigResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCheckoutConfigResult>;
export function newSaveCheckoutConfigResult(
  options: SaveCheckoutConfigResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCheckoutConfigResult> {
  const o = (options.__typename ? options : cache["SaveCheckoutConfigResult"] = {}) as SaveCheckoutConfigResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCheckoutConfigResult";
    o.checkoutConfig = maybeNew(
      "CheckoutConfig",
      options.checkoutConfig,
      cache,
      options.hasOwnProperty("checkoutConfig"),
    );
    return o as FactoryResult<SaveCheckoutConfigResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCheckoutConfigResult"] = newSaveCheckoutConfigResult;

export interface CheckoutConfigsPageOptions {
  __typename?: "CheckoutConfigsPage";
  entities?: Array<FactoryInput<CheckoutConfig, CheckoutConfigOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newCheckoutConfigsPage(
  options?: CheckoutConfigsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigsPage>;
export function newCheckoutConfigsPage(
  options: CheckoutConfigsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfigsPage> {
  const o = (options.__typename ? options : cache["CheckoutConfigsPage"] = {}) as CheckoutConfigsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfigsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("CheckoutConfig", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<CheckoutConfigsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfigsPage"] = newCheckoutConfigsPage;

export interface CheckoutPricingTraceOptions {
  __typename?: "CheckoutPricingTrace";
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions> | null;
  baseHousePriceInCents?: CheckoutPricingTrace["baseHousePriceInCents"];
  includedPriceInCents?: CheckoutPricingTrace["includedPriceInCents"];
  selectedPriceInCents?: CheckoutPricingTrace["selectedPriceInCents"];
  reservedTotalPriceInCents?: CheckoutPricingTrace["reservedTotalPriceInCents"];
  optionGroups?: Array<FactoryInput<CheckoutPricingTraceOptionGroup, CheckoutPricingTraceOptionGroupOptions>>;
}

export function newCheckoutPricingTrace(
  options?: CheckoutPricingTraceOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutPricingTrace>;
export function newCheckoutPricingTrace(
  options: CheckoutPricingTraceOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutPricingTrace> {
  const o = (options.__typename ? options : cache["CheckoutPricingTrace"] = {}) as CheckoutPricingTrace;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutPricingTrace";
    o.checkoutConfig = maybeNewOrNull("CheckoutConfig", options.checkoutConfig, cache);
    o.baseHousePriceInCents = options.baseHousePriceInCents ?? 0;
    o.includedPriceInCents = options.includedPriceInCents ?? 0;
    o.selectedPriceInCents = options.selectedPriceInCents ?? 0;
    o.reservedTotalPriceInCents = options.reservedTotalPriceInCents ?? null;
    o.optionGroups = (options.optionGroups ?? []).map((i) =>
      maybeNew("CheckoutPricingTraceOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
    );
    return o as FactoryResult<CheckoutPricingTrace>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutPricingTrace"] = newCheckoutPricingTrace;

export interface CheckoutPricingTraceOptionGroupOptions {
  __typename?: "CheckoutPricingTraceOptionGroup";
  group?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>;
  included?: FactoryInput<CheckoutPricingTraceOption, CheckoutPricingTraceOptionOptions> | null;
  selected?: FactoryInput<CheckoutPricingTraceOption, CheckoutPricingTraceOptionOptions> | null;
  availableCreditInCents?: CheckoutPricingTraceOptionGroup["availableCreditInCents"];
  costChangeInCents?: CheckoutPricingTraceOptionGroup["costChangeInCents"];
  selectionFeeInCents?: CheckoutPricingTraceOptionGroup["selectionFeeInCents"];
  appliedMinimumPriceInCents?: CheckoutPricingTraceOptionGroup["appliedMinimumPriceInCents"];
  storedPriceInCents?: CheckoutPricingTraceOptionGroup["storedPriceInCents"];
  priceChangeInCents?: CheckoutPricingTraceOptionGroup["priceChangeInCents"];
  reservedPriceInCents?: CheckoutPricingTraceOptionGroup["reservedPriceInCents"];
}

export function newCheckoutPricingTraceOptionGroup(
  options?: CheckoutPricingTraceOptionGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutPricingTraceOptionGroup>;
export function newCheckoutPricingTraceOptionGroup(
  options: CheckoutPricingTraceOptionGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutPricingTraceOptionGroup> {
  const o =
    (options.__typename ? options : cache["CheckoutPricingTraceOptionGroup"] = {}) as CheckoutPricingTraceOptionGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutPricingTraceOptionGroup";
    o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
    o.included = maybeNewOrNull("CheckoutPricingTraceOption", options.included, cache);
    o.selected = maybeNewOrNull("CheckoutPricingTraceOption", options.selected, cache);
    o.availableCreditInCents = options.availableCreditInCents ?? 0;
    o.costChangeInCents = options.costChangeInCents ?? 0;
    o.selectionFeeInCents = options.selectionFeeInCents ?? 0;
    o.appliedMinimumPriceInCents = options.appliedMinimumPriceInCents ?? 0;
    o.storedPriceInCents = options.storedPriceInCents ?? null;
    o.priceChangeInCents = options.priceChangeInCents ?? 0;
    o.reservedPriceInCents = options.reservedPriceInCents ?? null;
    return o as FactoryResult<CheckoutPricingTraceOptionGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutPricingTraceOptionGroup"] = newCheckoutPricingTraceOptionGroup;

export interface CheckoutPricingTraceOptionOptions {
  __typename?: "CheckoutPricingTraceOption";
  option?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions> | null;
  totalPriceInCents?: CheckoutPricingTraceOption["totalPriceInCents"];
  changed?: Array<FactoryInput<CheckoutPricingTraceOptionChange, CheckoutPricingTraceOptionChangeOptions>>;
}

export function newCheckoutPricingTraceOption(
  options?: CheckoutPricingTraceOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutPricingTraceOption>;
export function newCheckoutPricingTraceOption(
  options: CheckoutPricingTraceOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutPricingTraceOption> {
  const o = (options.__typename ? options : cache["CheckoutPricingTraceOption"] = {}) as CheckoutPricingTraceOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutPricingTraceOption";
    o.option = maybeNewOrNull("ReadyPlanOption", options.option, cache);
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.changed = (options.changed ?? []).map((i) =>
      maybeNew("CheckoutPricingTraceOptionChange", i, cache, options.hasOwnProperty("changed"))
    );
    return o as FactoryResult<CheckoutPricingTraceOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutPricingTraceOption"] = newCheckoutPricingTraceOption;

export interface CheckoutPricingTraceOptionChangeOptions {
  __typename?: "CheckoutPricingTraceOptionChange";
  group?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>;
  option?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions> | null;
  previousOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions> | null;
  priceInCents?: CheckoutPricingTraceOptionChange["priceInCents"];
  storedPriceInCents?: CheckoutPricingTraceOptionChange["storedPriceInCents"];
  costInCents?: CheckoutPricingTraceOptionChange["costInCents"];
  selectionFeeInCents?: CheckoutPricingTraceOptionChange["selectionFeeInCents"];
  minimumPriceInCents?: CheckoutPricingTraceOptionChange["minimumPriceInCents"];
}

export function newCheckoutPricingTraceOptionChange(
  options?: CheckoutPricingTraceOptionChangeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutPricingTraceOptionChange>;
export function newCheckoutPricingTraceOptionChange(
  options: CheckoutPricingTraceOptionChangeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutPricingTraceOptionChange> {
  const o =
    (options.__typename ? options : cache["CheckoutPricingTraceOptionChange"] = {}) as CheckoutPricingTraceOptionChange;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutPricingTraceOptionChange";
    o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
    o.option = maybeNewOrNull("ReadyPlanOption", options.option, cache);
    o.previousOption = maybeNewOrNull("ReadyPlanOption", options.previousOption, cache);
    o.priceInCents = options.priceInCents ?? 0;
    o.storedPriceInCents = options.storedPriceInCents ?? null;
    o.costInCents = options.costInCents ?? 0;
    o.selectionFeeInCents = options.selectionFeeInCents ?? 0;
    o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
    return o as FactoryResult<CheckoutPricingTraceOptionChange>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutPricingTraceOptionChange"] = newCheckoutPricingTraceOptionChange;

export interface CheckoutConfigInteriorSubStepOptions {
  __typename?: "CheckoutConfigInteriorSubStep";
  id?: CheckoutConfigInteriorSubStep["id"];
  location?: FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions> | null;
  displayName?: CheckoutConfigInteriorSubStep["displayName"];
  stepNumber?: CheckoutConfigInteriorSubStep["stepNumber"];
}

export function newCheckoutConfigInteriorSubStep(
  options?: CheckoutConfigInteriorSubStepOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigInteriorSubStep>;
export function newCheckoutConfigInteriorSubStep(
  options: CheckoutConfigInteriorSubStepOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfigInteriorSubStep> {
  const o =
    (options.__typename ? options : cache["CheckoutConfigInteriorSubStep"] = {}) as CheckoutConfigInteriorSubStep;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfigInteriorSubStep";
    o.id = options.id ?? nextFactoryId("CheckoutConfigInteriorSubStep");
    o.location = maybeNewOrNull("ReadyPlanLocation", options.location, cache);
    o.displayName = options.displayName ?? "displayName";
    o.stepNumber = options.stepNumber ?? 0;
    return o as FactoryResult<CheckoutConfigInteriorSubStep>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfigInteriorSubStep"] = newCheckoutConfigInteriorSubStep;

export interface InsideMapsTextureSwapsOptions {
  __typename?: "InsideMapsTextureSwaps";
  cameras?: Array<FactoryInput<InsideMapsCamera, InsideMapsCameraOptions>>;
  textureSwapsByCamera?: Array<FactoryInput<InsideMapsCameraTextureSwaps, InsideMapsCameraTextureSwapsOptions>>;
  projectId?: InsideMapsTextureSwaps["projectId"];
  debugSlots?: Array<FactoryInput<InsideMapsDebugSlot, InsideMapsDebugSlotOptions>> | null;
}

export function newInsideMapsTextureSwaps(
  options?: InsideMapsTextureSwapsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InsideMapsTextureSwaps>;
export function newInsideMapsTextureSwaps(
  options: InsideMapsTextureSwapsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InsideMapsTextureSwaps> {
  const o = (options.__typename ? options : cache["InsideMapsTextureSwaps"] = {}) as InsideMapsTextureSwaps;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InsideMapsTextureSwaps";
    o.cameras = (options.cameras ?? []).map((i) =>
      maybeNew("InsideMapsCamera", i, cache, options.hasOwnProperty("cameras"))
    );
    o.textureSwapsByCamera = (options.textureSwapsByCamera ?? []).map((i) =>
      maybeNew("InsideMapsCameraTextureSwaps", i, cache, options.hasOwnProperty("textureSwapsByCamera"))
    );
    o.projectId = options.projectId ?? null;
    o.debugSlots = (options.debugSlots ?? []).map((i) =>
      maybeNew("InsideMapsDebugSlot", i, cache, options.hasOwnProperty("debugSlots"))
    );
    return o as FactoryResult<InsideMapsTextureSwaps>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InsideMapsTextureSwaps"] = newInsideMapsTextureSwaps;

export interface InsideMapsCameraOptions {
  __typename?: "InsideMapsCamera";
  cameraName?: InsideMapsCamera["cameraName"];
  displayName?: InsideMapsCamera["displayName"];
  isPrimary?: InsideMapsCamera["isPrimary"];
  isDefault?: InsideMapsCamera["isDefault"];
  locationId?: InsideMapsCamera["locationId"];
  alternateViewFor?: InsideMapsCamera["alternateViewFor"];
  alternateCameras?: Array<FactoryInput<InsideMapsCamera, InsideMapsCameraOptions>>;
}

export function newInsideMapsCamera(
  options?: InsideMapsCameraOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InsideMapsCamera>;
export function newInsideMapsCamera(
  options: InsideMapsCameraOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InsideMapsCamera> {
  const o = (options.__typename ? options : cache["InsideMapsCamera"] = {}) as InsideMapsCamera;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InsideMapsCamera";
    o.cameraName = options.cameraName ?? "cameraName";
    o.displayName = options.displayName ?? "displayName";
    o.isPrimary = options.isPrimary ?? false;
    o.isDefault = options.isDefault ?? false;
    o.locationId = options.locationId ?? null;
    o.alternateViewFor = options.alternateViewFor ?? null;
    o.alternateCameras = (options.alternateCameras ?? []).map((i) =>
      maybeNew("InsideMapsCamera", i, cache, options.hasOwnProperty("alternateCameras"))
    );
    return o as FactoryResult<InsideMapsCamera>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InsideMapsCamera"] = newInsideMapsCamera;

export interface InsideMapsCameraTextureSwapsOptions {
  __typename?: "InsideMapsCameraTextureSwaps";
  cameraName?: InsideMapsCameraTextureSwaps["cameraName"];
  textureSwaps?: Array<FactoryInput<InsideMapsTextureSwap, InsideMapsTextureSwapOptions>>;
}

export function newInsideMapsCameraTextureSwaps(
  options?: InsideMapsCameraTextureSwapsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InsideMapsCameraTextureSwaps>;
export function newInsideMapsCameraTextureSwaps(
  options: InsideMapsCameraTextureSwapsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InsideMapsCameraTextureSwaps> {
  const o = (options.__typename ? options : cache["InsideMapsCameraTextureSwaps"] = {}) as InsideMapsCameraTextureSwaps;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InsideMapsCameraTextureSwaps";
    o.cameraName = options.cameraName ?? "cameraName";
    o.textureSwaps = (options.textureSwaps ?? []).map((i) =>
      maybeNew("InsideMapsTextureSwap", i, cache, options.hasOwnProperty("textureSwaps"))
    );
    return o as FactoryResult<InsideMapsCameraTextureSwaps>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InsideMapsCameraTextureSwaps"] = newInsideMapsCameraTextureSwaps;

export interface InsideMapsTextureSwapOptions {
  __typename?: "InsideMapsTextureSwap";
  part?: InsideMapsTextureSwap["part"];
  texture?: InsideMapsTextureSwap["texture"];
}

export function newInsideMapsTextureSwap(
  options?: InsideMapsTextureSwapOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InsideMapsTextureSwap>;
export function newInsideMapsTextureSwap(
  options: InsideMapsTextureSwapOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InsideMapsTextureSwap> {
  const o = (options.__typename ? options : cache["InsideMapsTextureSwap"] = {}) as InsideMapsTextureSwap;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InsideMapsTextureSwap";
    o.part = options.part ?? "part";
    o.texture = options.texture ?? "texture";
    return o as FactoryResult<InsideMapsTextureSwap>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InsideMapsTextureSwap"] = newInsideMapsTextureSwap;

export interface InsideMapsDebugSlotOptions {
  __typename?: "InsideMapsDebugSlot";
  message?: InsideMapsDebugSlot["message"];
}

export function newInsideMapsDebugSlot(
  options?: InsideMapsDebugSlotOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InsideMapsDebugSlot>;
export function newInsideMapsDebugSlot(
  options: InsideMapsDebugSlotOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InsideMapsDebugSlot> {
  const o = (options.__typename ? options : cache["InsideMapsDebugSlot"] = {}) as InsideMapsDebugSlot;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InsideMapsDebugSlot";
    o.message = options.message ?? "message";
    return o as FactoryResult<InsideMapsDebugSlot>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InsideMapsDebugSlot"] = newInsideMapsDebugSlot;

export interface InsideMapsSlotAuditResultOptions {
  __typename?: "InsideMapsSlotAuditResult";
  audit?: InsideMapsSlotAuditResult["audit"];
}

export function newInsideMapsSlotAuditResult(
  options?: InsideMapsSlotAuditResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InsideMapsSlotAuditResult>;
export function newInsideMapsSlotAuditResult(
  options: InsideMapsSlotAuditResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InsideMapsSlotAuditResult> {
  const o = (options.__typename ? options : cache["InsideMapsSlotAuditResult"] = {}) as InsideMapsSlotAuditResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InsideMapsSlotAuditResult";
    o.audit = options.audit ?? [];
    return o as FactoryResult<InsideMapsSlotAuditResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InsideMapsSlotAuditResult"] = newInsideMapsSlotAuditResult;

export interface InsideMapsSlotDiffResultOptions {
  __typename?: "InsideMapsSlotDiffResult";
  diffs?: InsideMapsSlotDiffResult["diffs"];
}

export function newInsideMapsSlotDiffResult(
  options?: InsideMapsSlotDiffResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InsideMapsSlotDiffResult>;
export function newInsideMapsSlotDiffResult(
  options: InsideMapsSlotDiffResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InsideMapsSlotDiffResult> {
  const o = (options.__typename ? options : cache["InsideMapsSlotDiffResult"] = {}) as InsideMapsSlotDiffResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InsideMapsSlotDiffResult";
    o.diffs = options.diffs ?? [];
    return o as FactoryResult<InsideMapsSlotDiffResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InsideMapsSlotDiffResult"] = newInsideMapsSlotDiffResult;

export interface RunCheckoutPricingReportResultOptions {
  __typename?: "RunCheckoutPricingReportResult";
  report?: FactoryInput<TrackedJob, TrackedJobOptions>;
}

export function newRunCheckoutPricingReportResult(
  options?: RunCheckoutPricingReportResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<RunCheckoutPricingReportResult>;
export function newRunCheckoutPricingReportResult(
  options: RunCheckoutPricingReportResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<RunCheckoutPricingReportResult> {
  const o =
    (options.__typename ? options : cache["RunCheckoutPricingReportResult"] = {}) as RunCheckoutPricingReportResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "RunCheckoutPricingReportResult";
    o.report = maybeNew("TrackedJob", options.report, cache, options.hasOwnProperty("report"));
    return o as FactoryResult<RunCheckoutPricingReportResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["RunCheckoutPricingReportResult"] = newRunCheckoutPricingReportResult;

export interface CheckoutConfigOptionOptions {
  __typename?: "CheckoutConfigOption";
  id?: CheckoutConfigOption["id"];
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions>;
  createdAt?: CheckoutConfigOption["createdAt"];
  updatedAt?: CheckoutConfigOption["updatedAt"];
  reservedPriceInCents?: CheckoutConfigOption["reservedPriceInCents"];
  isIncluded?: CheckoutConfigOption["isIncluded"];
  showOnSummary?: CheckoutConfigOption["showOnSummary"];
  reservedCutoffDate?: CheckoutConfigOption["reservedCutoffDate"];
  includedByCheckoutConfigOption?: FactoryInput<CheckoutConfigOption, CheckoutConfigOptionOptions> | null;
  includedByRoot?: FactoryInput<CheckoutConfigOption, CheckoutConfigOptionOptions> | null;
}

export function newCheckoutConfigOption(
  options?: CheckoutConfigOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigOption>;
export function newCheckoutConfigOption(
  options: CheckoutConfigOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfigOption> {
  const o = (options.__typename ? options : cache["CheckoutConfigOption"] = {}) as CheckoutConfigOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfigOption";
    o.id = options.id ?? nextFactoryId("CheckoutConfigOption");
    o.readyPlanOption = maybeNew(
      "ReadyPlanOption",
      options.readyPlanOption,
      cache,
      options.hasOwnProperty("readyPlanOption"),
    );
    o.checkoutConfig = maybeNew(
      "CheckoutConfig",
      options.checkoutConfig,
      cache,
      options.hasOwnProperty("checkoutConfig"),
    );
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.reservedPriceInCents = options.reservedPriceInCents ?? null;
    o.isIncluded = options.isIncluded ?? false;
    o.showOnSummary = options.showOnSummary ?? false;
    o.reservedCutoffDate = options.reservedCutoffDate ?? null;
    o.includedByCheckoutConfigOption = maybeNewOrNull(
      "CheckoutConfigOption",
      options.includedByCheckoutConfigOption,
      cache,
    );
    o.includedByRoot = maybeNewOrNull("CheckoutConfigOption", options.includedByRoot, cache);
    return o as FactoryResult<CheckoutConfigOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfigOption"] = newCheckoutConfigOption;

export interface ClientOptions {
  __typename?: "Client";
  id?: Client["id"];
  name?: Client["name"];
  email?: Client["email"];
  firstName?: Client["firstName"];
  lastName?: Client["lastName"];
  shortName?: Client["shortName"];
  fullName?: Client["fullName"];
  lastActiveAt?: Client["lastActiveAt"];
  lastActive?: Client["lastActive"];
  address?: FactoryInput<Address, AddressOptions> | null;
  phone?: Client["phone"];
}

export function newClient(options?: ClientOptions, factoryOptions?: FactoryOptions): FactoryResult<Client>;
export function newClient(
  options: ClientOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Client> {
  const o = (options.__typename ? options : cache["Client"] = {}) as Client;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Client";
    o.id = options.id ?? nextFactoryId("Client");
    o.name = options.name ?? "name";
    o.email = options.email ?? "email";
    o.firstName = options.firstName ?? "firstName";
    o.lastName = options.lastName ?? "lastName";
    o.shortName = options.shortName ?? "shortName";
    o.fullName = options.fullName ?? "fullName";
    o.lastActiveAt = options.lastActiveAt ?? null;
    o.lastActive = options.lastActive ?? null;
    o.address = maybeNewOrNull("Address", options.address, cache);
    o.phone = options.phone ?? null;
    return o as FactoryResult<Client>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Client"] = newClient;

export interface CohortOptions {
  __typename?: "Cohort";
  id?: Cohort["id"];
  name?: Cohort["name"];
  market?: FactoryInput<Market, MarketOptions>;
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  developer?: FactoryInput<InternalUser, InternalUserOptions> | null;
  createdAt?: Cohort["createdAt"];
  updatedAt?: Cohort["updatedAt"];
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  isBoolDefaultForDevelopment?: Cohort["isBoolDefaultForDevelopment"];
}

export function newCohort(options?: CohortOptions, factoryOptions?: FactoryOptions): FactoryResult<Cohort>;
export function newCohort(
  options: CohortOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Cohort> {
  const o = (options.__typename ? options : cache["Cohort"] = {}) as Cohort;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Cohort";
    o.id = options.id ?? nextFactoryId("Cohort");
    o.name = options.name ?? "name";
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    o.developer = maybeNewOrNull("InternalUser", options.developer, cache);
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
    o.isBoolDefaultForDevelopment = options.isBoolDefaultForDevelopment ?? null;
    return o as FactoryResult<Cohort>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Cohort"] = newCohort;

export interface SaveCohortsResultOptions {
  __typename?: "SaveCohortsResult";
  cohorts?: Array<FactoryInput<Cohort, CohortOptions>>;
}

export function newSaveCohortsResult(
  options?: SaveCohortsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCohortsResult>;
export function newSaveCohortsResult(
  options: SaveCohortsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCohortsResult> {
  const o = (options.__typename ? options : cache["SaveCohortsResult"] = {}) as SaveCohortsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCohortsResult";
    o.cohorts = (options.cohorts ?? []).map((i) => maybeNew("Cohort", i, cache, options.hasOwnProperty("cohorts")));
    return o as FactoryResult<SaveCohortsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCohortsResult"] = newSaveCohortsResult;

export interface SchedulePhaseOptions {
  __typename?: "SchedulePhase";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: SchedulePhase["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: SchedulePhase["isFollowed"];
  id?: SchedulePhase["id"];
  name?: SchedulePhase["name"];
  parent?:
    | ScheduleParent
    | FactoryResult<ScheduleParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  schedule?: FactoryInput<Schedule, ScheduleOptions>;
  interval?: FactoryInput<CalendarInterval, CalendarIntervalOptions> | null;
  baselineInterval?: FactoryInput<CalendarInterval, CalendarIntervalOptions> | null;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  progress?: FactoryInput<SchedulePhaseProgress, SchedulePhaseProgressOptions>;
  cmsId?: SchedulePhase["cmsId"];
  scheduleSubPhases?: Array<FactoryInput<ScheduleSubPhase, ScheduleSubPhaseOptions>>;
  globalPhase?: FactoryInput<GlobalPhase, GlobalPhaseOptions>;
  taskStatusRollup?: SchedulePhase["taskStatusRollup"];
}

export function newSchedulePhase(
  options?: SchedulePhaseOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newSchedulePhase(
  options: SchedulePhaseOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SchedulePhase> {
  const o = (options.__typename ? options : cache["SchedulePhase"] = {}) as SchedulePhase;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SchedulePhase";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("SchedulePhase");
    o.name = options.name ?? "name";
    o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
    o.interval = maybeNewOrNull("CalendarInterval", options.interval, cache);
    o.baselineInterval = maybeNewOrNull("CalendarInterval", options.baselineInterval, cache);
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.progress = maybeNew("SchedulePhaseProgress", options.progress, cache, options.hasOwnProperty("progress"));
    o.cmsId = options.cmsId ?? null;
    o.scheduleSubPhases = (options.scheduleSubPhases ?? []).map((i) =>
      maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("scheduleSubPhases"))
    );
    o.globalPhase = maybeNew("GlobalPhase", options.globalPhase, cache, options.hasOwnProperty("globalPhase"));
    o.taskStatusRollup = options.taskStatusRollup ?? null;
    return o as FactoryResult<SchedulePhase>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SchedulePhase"] = newSchedulePhase;

export interface ScheduleSubPhaseOptions {
  __typename?: "ScheduleSubPhase";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ScheduleSubPhase["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ScheduleSubPhase["isFollowed"];
  id?: ScheduleSubPhase["id"];
  name?: ScheduleSubPhase["name"];
  parent?:
    | ScheduleParent
    | FactoryResult<ScheduleParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  schedule?: FactoryInput<Schedule, ScheduleOptions>;
  schedulePhase?: FactoryInput<SchedulePhase, SchedulePhaseOptions>;
  scheduleTasks?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  globalSubPhase?: FactoryInput<GlobalSubPhase, GlobalSubPhaseOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  interval?: FactoryInput<CalendarInterval, CalendarIntervalOptions> | null;
  baselineInterval?: FactoryInput<CalendarInterval, CalendarIntervalOptions> | null;
  progress?: FactoryInput<ScheduleSubPhaseProgress, ScheduleSubPhaseProgressOptions>;
  cmsId?: ScheduleSubPhase["cmsId"];
}

export function newScheduleSubPhase(
  options?: ScheduleSubPhaseOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newScheduleSubPhase(
  options: ScheduleSubPhaseOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleSubPhase> {
  const o = (options.__typename ? options : cache["ScheduleSubPhase"] = {}) as ScheduleSubPhase;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleSubPhase";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("ScheduleSubPhase");
    o.name = options.name ?? "name";
    o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
    o.schedulePhase = maybeNew("SchedulePhase", options.schedulePhase, cache, options.hasOwnProperty("schedulePhase"));
    o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
    );
    o.globalSubPhase = maybeNew(
      "GlobalSubPhase",
      options.globalSubPhase,
      cache,
      options.hasOwnProperty("globalSubPhase"),
    );
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.interval = maybeNewOrNull("CalendarInterval", options.interval, cache);
    o.baselineInterval = maybeNewOrNull("CalendarInterval", options.baselineInterval, cache);
    o.progress = maybeNew("ScheduleSubPhaseProgress", options.progress, cache, options.hasOwnProperty("progress"));
    o.cmsId = options.cmsId ?? null;
    return o as FactoryResult<ScheduleSubPhase>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleSubPhase"] = newScheduleSubPhase;

export interface TaskOptions {
  __typename?: "Task";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Task["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Task["isFollowed"];
  id?: Task["id"];
  stage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  name?: Task["name"];
  userCreated?: Task["userCreated"];
  status?: TaskStatusDetailOptions | TaskStatus;
  homeownerVisible?: Task["homeownerVisible"];
  homeownerDescription?: Task["homeownerDescription"];
  interval?: FactoryInput<CalendarInterval, CalendarIntervalOptions>;
  baselineInterval?: FactoryInput<CalendarInterval, CalendarIntervalOptions>;
  baselineInterval2?: FactoryInput<CalendarInterval2, CalendarInterval2Options> | null;
  completedAt?: Task["completedAt"];
  startDate?: Task["startDate"];
  assignee?: FactoryInput<InternalUser, InternalUserOptions> | null;
  internalNote?: Task["internalNote"];
  cmsId?: Task["cmsId"];
  slackInDays?: Task["slackInDays"];
  aheadOrBehindInDays?: Task["aheadOrBehindInDays"];
  isStale?: Task["isStale"];
  isCriticalPath?: Task["isCriticalPath"];
  predecessors?: Array<FactoryInput<Task, TaskOptions>>;
  successors?: Array<FactoryInput<Task, TaskOptions>>;
  predecessorDependencies?: Array<FactoryInput<TaskDependency, TaskDependencyOptions>>;
  successorDependencies?: Array<FactoryInput<TaskDependency, TaskDependencyOptions>>;
  homeownerContractDraws?: Array<FactoryInput<HomeownerContractDraw, HomeownerContractDrawOptions>>;
  isManuallyScheduled?: Task["isManuallyScheduled"];
  isBaselineManuallyScheduled?: Task["isBaselineManuallyScheduled"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  isMilestone?: Task["isMilestone"];
  salesforceId?: Task["salesforceId"];
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  canEditStartDate?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditEndDate?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditDuration?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canComplete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canStart?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canSetTraderPartner?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
  deadlineType?: Task["deadlineType"];
  deadlineTypeDetail?: TaskDeadlineTypeDetailOptions | TaskDeadlineType | null;
  templateProjectRole?: Task["templateProjectRole"];
  templateProjectRoleDetail?: ProjectRoleDetailOptions | ProjectRole | null;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  globalTask?: FactoryInput<GlobalTask, GlobalTaskOptions> | null;
  isGlobalMilestoneTask?: Task["isGlobalMilestoneTask"];
  scheduleTemplateItemMappings?: Array<FactoryInput<ScheduleTemplateItemMapping, ScheduleTemplateItemMappingOptions>>;
  requiredTaskDocuments?: Array<FactoryInput<RequiredTaskDocument, RequiredTaskDocumentOptions>>;
  scheduleTaskChecklistItems?: Array<FactoryInput<ScheduleTaskChecklistItem, ScheduleTaskChecklistItemOptions>>;
  scheduleFlags?: Array<FactoryInput<ScheduleFlag, ScheduleFlagOptions>>;
  jobLogNotes?: Array<FactoryInput<JobLogNote, JobLogNoteOptions>>;
  tradePartnerIsScheduled?: Task["tradePartnerIsScheduled"];
  hasScheduleFlags?: Task["hasScheduleFlags"];
  systemTask?: Task["systemTask"];
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  committedTradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  billLineItems?: Array<FactoryInput<BillLineItem, BillLineItemOptions>>;
  defaultedHomeownerDescription?: Task["defaultedHomeownerDescription"];
  templateTask?: FactoryInput<Task, TaskOptions> | null;
  tradePartnerStatus?: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus;
  tradePartnerAvailabilityRequests?:
    | Array<FactoryInput<TradePartnerAvailabilityRequest, TradePartnerAvailabilityRequestOptions>>
    | null;
  depositCommitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  type?: TaskTypeDetailOptions | TaskType;
  workDays?: Array<FactoryInput<TaskWorkDay, TaskWorkDayOptions>>;
  commitmentDraws?: Array<FactoryInput<CommitmentDraw, CommitmentDrawOptions>>;
  protoBills?: Array<FactoryInput<ProtoBill, ProtoBillOptions>>;
  checklistComplete?: Task["checklistComplete"];
  schedule?: ScheduleLike | FactoryResult<ScheduleLike> | ScheduleOptions | RequireTypename<PlanScheduleOptions>;
}

export function newTask(options?: TaskOptions, factoryOptions?: FactoryOptions): FactoryResult<Task>;
export function newTask(
  options: TaskOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Task> {
  const o = (options.__typename ? options : cache["Task"] = {}) as Task;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Task";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Task");
    o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.name = options.name ?? "name";
    o.userCreated = options.userCreated ?? false;
    o.status = enumOrDetailOfTaskStatus(options.status);
    o.homeownerVisible = options.homeownerVisible ?? false;
    o.homeownerDescription = options.homeownerDescription ?? null;
    o.interval = maybeNew("CalendarInterval", options.interval, cache, options.hasOwnProperty("interval"));
    o.baselineInterval = maybeNew(
      "CalendarInterval",
      options.baselineInterval,
      cache,
      options.hasOwnProperty("baselineInterval"),
    );
    o.baselineInterval2 = maybeNewOrNull("CalendarInterval2", options.baselineInterval2, cache);
    o.completedAt = options.completedAt ?? null;
    o.startDate = options.startDate ?? null;
    o.assignee = maybeNewOrNull("InternalUser", options.assignee, cache);
    o.internalNote = options.internalNote ?? null;
    o.cmsId = options.cmsId ?? "cmsId";
    o.slackInDays = options.slackInDays ?? null;
    o.aheadOrBehindInDays = options.aheadOrBehindInDays ?? null;
    o.isStale = options.isStale ?? false;
    o.isCriticalPath = options.isCriticalPath ?? false;
    o.predecessors = (options.predecessors ?? []).map((i) =>
      maybeNew("Task", i, cache, options.hasOwnProperty("predecessors"))
    );
    o.successors = (options.successors ?? []).map((i) =>
      maybeNew("Task", i, cache, options.hasOwnProperty("successors"))
    );
    o.predecessorDependencies = (options.predecessorDependencies ?? []).map((i) =>
      maybeNew("TaskDependency", i, cache, options.hasOwnProperty("predecessorDependencies"))
    );
    o.successorDependencies = (options.successorDependencies ?? []).map((i) =>
      maybeNew("TaskDependency", i, cache, options.hasOwnProperty("successorDependencies"))
    );
    o.homeownerContractDraws = (options.homeownerContractDraws ?? []).map((i) =>
      maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("homeownerContractDraws"))
    );
    o.isManuallyScheduled = options.isManuallyScheduled ?? false;
    o.isBaselineManuallyScheduled = options.isBaselineManuallyScheduled ?? null;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.isMilestone = options.isMilestone ?? false;
    o.salesforceId = options.salesforceId ?? null;
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.canEditStartDate = maybeNew(
      "PotentialOperation2",
      options.canEditStartDate,
      cache,
      options.hasOwnProperty("canEditStartDate"),
    );
    o.canEditEndDate = maybeNew(
      "PotentialOperation2",
      options.canEditEndDate,
      cache,
      options.hasOwnProperty("canEditEndDate"),
    );
    o.canEditDuration = maybeNew(
      "PotentialOperation2",
      options.canEditDuration,
      cache,
      options.hasOwnProperty("canEditDuration"),
    );
    o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
    o.canStart = maybeNew("PotentialOperation2", options.canStart, cache, options.hasOwnProperty("canStart"));
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.canSetTraderPartner = maybeNew(
      "PotentialOperation2",
      options.canSetTraderPartner,
      cache,
      options.hasOwnProperty("canSetTraderPartner"),
    );
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    o.deadlineType = options.deadlineType ?? null;
    o.deadlineTypeDetail = enumOrDetailOrNullOfTaskDeadlineType(options.deadlineTypeDetail);
    o.templateProjectRole = options.templateProjectRole ?? null;
    o.templateProjectRoleDetail = enumOrDetailOrNullOfProjectRole(options.templateProjectRoleDetail);
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.globalTask = maybeNewOrNull("GlobalTask", options.globalTask, cache);
    o.isGlobalMilestoneTask = options.isGlobalMilestoneTask ?? false;
    o.scheduleTemplateItemMappings = (options.scheduleTemplateItemMappings ?? []).map((i) =>
      maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("scheduleTemplateItemMappings"))
    );
    o.requiredTaskDocuments = (options.requiredTaskDocuments ?? []).map((i) =>
      maybeNew("RequiredTaskDocument", i, cache, options.hasOwnProperty("requiredTaskDocuments"))
    );
    o.scheduleTaskChecklistItems = (options.scheduleTaskChecklistItems ?? []).map((i) =>
      maybeNew("ScheduleTaskChecklistItem", i, cache, options.hasOwnProperty("scheduleTaskChecklistItems"))
    );
    o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
      maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
    );
    o.jobLogNotes = (options.jobLogNotes ?? []).map((i) =>
      maybeNew("JobLogNote", i, cache, options.hasOwnProperty("jobLogNotes"))
    );
    o.tradePartnerIsScheduled = options.tradePartnerIsScheduled ?? null;
    o.hasScheduleFlags = options.hasScheduleFlags ?? false;
    o.systemTask = options.systemTask ?? null;
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.committedTradePartners = (options.committedTradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("committedTradePartners"))
    );
    o.billLineItems = (options.billLineItems ?? []).map((i) =>
      maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
    );
    o.defaultedHomeownerDescription = options.defaultedHomeownerDescription ?? "defaultedHomeownerDescription";
    o.templateTask = maybeNewOrNull("Task", options.templateTask, cache);
    o.tradePartnerStatus = enumOrDetailOfTradePartnerTaskStatus(options.tradePartnerStatus);
    o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
      maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
    );
    o.depositCommitments = (options.depositCommitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("depositCommitments"))
    );
    o.type = enumOrDetailOfTaskType(options.type);
    o.workDays = (options.workDays ?? []).map((i) =>
      maybeNew("TaskWorkDay", i, cache, options.hasOwnProperty("workDays"))
    );
    o.commitmentDraws = (options.commitmentDraws ?? []).map((i) =>
      maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("commitmentDraws"))
    );
    o.protoBills = (options.protoBills ?? []).map((i) =>
      maybeNew("ProtoBill", i, cache, options.hasOwnProperty("protoBills"))
    );
    o.checklistComplete = options.checklistComplete ?? null;
    o.schedule = maybeNew(options.schedule?.__typename ?? "Schedule", options.schedule, cache);
    return o as FactoryResult<Task>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Task"] = newTask;

export interface PlanTaskOptions {
  __typename?: "PlanTask";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: PlanTask["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: PlanTask["isFollowed"];
  id?: PlanTask["id"];
  name?: PlanTask["name"];
  createdAt?: PlanTask["createdAt"];
  updatedAt?: PlanTask["updatedAt"];
  durationInDays?: PlanTask["durationInDays"];
  startDate?: PlanTask["startDate"];
  endDate?: PlanTask["endDate"];
  completedAt?: PlanTask["completedAt"];
  slackInDays?: PlanTask["slackInDays"];
  isCriticalPath?: PlanTask["isCriticalPath"];
  homeownerVisible?: PlanTask["homeownerVisible"];
  status?: TaskStatusDetailOptions | TaskStatus;
  type?: TaskTypeDetailOptions | TaskType;
  sortOrder?: PlanTask["sortOrder"];
  internalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  schedule?: FactoryInput<PlanSchedule, PlanScheduleOptions>;
  globalPlanTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
  globalChecklistItems?: Array<FactoryInput<GlobalPlanTaskChecklistItem, GlobalPlanTaskChecklistItemOptions>>;
  checklistItems?: Array<FactoryInput<PlanTaskChecklistItem, PlanTaskChecklistItemOptions>>;
  requiredTaskDocuments?: Array<FactoryInput<RequiredTaskDocument, RequiredTaskDocumentOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  history?: Array<FactoryInput<History, HistoryOptions>>;
  earliestStartDate?: PlanTask["earliestStartDate"];
  knownDurationInDays?: PlanTask["knownDurationInDays"];
  isManuallyScheduled?: PlanTask["isManuallyScheduled"];
  canStart?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canComplete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDeleteWithWarning?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canSetTraderPartner?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  constraintItems?: Array<FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>>;
  allowanceItems?: Array<FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  committedTradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  billLineItems?: Array<FactoryInput<BillLineItem, BillLineItemOptions>>;
  tradePartnerStatus?: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus;
  tradePartnerAvailabilityRequests?:
    | Array<FactoryInput<TradePartnerAvailabilityRequest, TradePartnerAvailabilityRequestOptions>>
    | null;
  simulationProbability?: FactoryInput<SimulationProbability, SimulationProbabilityOptions>;
  scheduleFlags?: Array<FactoryInput<ScheduleFlag, ScheduleFlagOptions>>;
  ignoredConstraintsOnTaskEnd?: Array<FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>>;
  ignoredConstraintsOnTaskStart?: Array<FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>>;
  workDays?: Array<FactoryInput<TaskWorkDay, TaskWorkDayOptions>>;
  workingDaysProgress?: PlanTask["workingDaysProgress"];
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
  isStale?: PlanTask["isStale"];
  isHiddenFromSchedule?: PlanTask["isHiddenFromSchedule"];
  stage?: FactoryInput<GlobalPlanStage, GlobalPlanStageOptions> | null;
  commitmentDraws?: Array<FactoryInput<CommitmentDraw, CommitmentDrawOptions>>;
  protoBills?: Array<FactoryInput<ProtoBill, ProtoBillOptions>>;
  taskPurchaseOrders?: Array<FactoryInput<TaskPurchaseOrderRow, TaskPurchaseOrderRowOptions>>;
  customWorkableDays?: PlanTask["customWorkableDays"];
  allowsPlanMilestones?: Array<FactoryInput<PlanMilestone, PlanMilestoneOptions>>;
  knownSchedulingContacts?: Array<FactoryInput<TradePartnerContact, TradePartnerContactOptions>>;
  tradeCommsEmailPreview?: FactoryInput<
    TradePartnerAvailabilityRequestEmailPreview,
    TradePartnerAvailabilityRequestEmailPreviewOptions
  >;
}

export function newPlanTask(options?: PlanTaskOptions, factoryOptions?: FactoryOptions): FactoryResult<PlanTask>;
export function newPlanTask(
  options: PlanTaskOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanTask> {
  const o = (options.__typename ? options : cache["PlanTask"] = {}) as PlanTask;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanTask";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("PlanTask");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.durationInDays = options.durationInDays ?? 0;
    o.startDate = options.startDate ?? newDate();
    o.endDate = options.endDate ?? newDate();
    o.completedAt = options.completedAt ?? null;
    o.slackInDays = options.slackInDays ?? null;
    o.isCriticalPath = options.isCriticalPath ?? false;
    o.homeownerVisible = options.homeownerVisible ?? null;
    o.status = enumOrDetailOfTaskStatus(options.status);
    o.type = enumOrDetailOfTaskType(options.type);
    o.sortOrder = options.sortOrder ?? 0;
    o.internalUser = maybeNewOrNull("InternalUser", options.internalUser, cache);
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.schedule = maybeNew("PlanSchedule", options.schedule, cache, options.hasOwnProperty("schedule"));
    o.globalPlanTask = maybeNew(
      "GlobalPlanTask",
      options.globalPlanTask,
      cache,
      options.hasOwnProperty("globalPlanTask"),
    );
    o.globalChecklistItems = (options.globalChecklistItems ?? []).map((i) =>
      maybeNew("GlobalPlanTaskChecklistItem", i, cache, options.hasOwnProperty("globalChecklistItems"))
    );
    o.checklistItems = (options.checklistItems ?? []).map((i) =>
      maybeNew("PlanTaskChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
    );
    o.requiredTaskDocuments = (options.requiredTaskDocuments ?? []).map((i) =>
      maybeNew("RequiredTaskDocument", i, cache, options.hasOwnProperty("requiredTaskDocuments"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.earliestStartDate = options.earliestStartDate ?? null;
    o.knownDurationInDays = options.knownDurationInDays ?? null;
    o.isManuallyScheduled = options.isManuallyScheduled ?? null;
    o.canStart = maybeNew("PotentialOperation2", options.canStart, cache, options.hasOwnProperty("canStart"));
    o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
    o.canDeleteWithWarning = maybeNew(
      "PotentialOperation2",
      options.canDeleteWithWarning,
      cache,
      options.hasOwnProperty("canDeleteWithWarning"),
    );
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.canSetTraderPartner = maybeNew(
      "PotentialOperation2",
      options.canSetTraderPartner,
      cache,
      options.hasOwnProperty("canSetTraderPartner"),
    );
    o.constraintItems = (options.constraintItems ?? []).map((i) =>
      maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("constraintItems"))
    );
    o.allowanceItems = (options.allowanceItems ?? []).map((i) =>
      maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("allowanceItems"))
    );
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.committedTradePartners = (options.committedTradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("committedTradePartners"))
    );
    o.billLineItems = (options.billLineItems ?? []).map((i) =>
      maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
    );
    o.tradePartnerStatus = enumOrDetailOfTradePartnerTaskStatus(options.tradePartnerStatus);
    o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
      maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
    );
    o.simulationProbability = maybeNew(
      "SimulationProbability",
      options.simulationProbability,
      cache,
      options.hasOwnProperty("simulationProbability"),
    );
    o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
      maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
    );
    o.ignoredConstraintsOnTaskEnd = (options.ignoredConstraintsOnTaskEnd ?? []).map((i) =>
      maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("ignoredConstraintsOnTaskEnd"))
    );
    o.ignoredConstraintsOnTaskStart = (options.ignoredConstraintsOnTaskStart ?? []).map((i) =>
      maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("ignoredConstraintsOnTaskStart"))
    );
    o.workDays = (options.workDays ?? []).map((i) =>
      maybeNew("TaskWorkDay", i, cache, options.hasOwnProperty("workDays"))
    );
    o.workingDaysProgress = options.workingDaysProgress ?? 0;
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    o.isStale = options.isStale ?? false;
    o.isHiddenFromSchedule = options.isHiddenFromSchedule ?? false;
    o.stage = maybeNewOrNull("GlobalPlanStage", options.stage, cache);
    o.commitmentDraws = (options.commitmentDraws ?? []).map((i) =>
      maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("commitmentDraws"))
    );
    o.protoBills = (options.protoBills ?? []).map((i) =>
      maybeNew("ProtoBill", i, cache, options.hasOwnProperty("protoBills"))
    );
    o.taskPurchaseOrders = (options.taskPurchaseOrders ?? []).map((i) =>
      maybeNew("TaskPurchaseOrderRow", i, cache, options.hasOwnProperty("taskPurchaseOrders"))
    );
    o.customWorkableDays = options.customWorkableDays ?? [];
    o.allowsPlanMilestones = (options.allowsPlanMilestones ?? []).map((i) =>
      maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("allowsPlanMilestones"))
    );
    o.knownSchedulingContacts = (options.knownSchedulingContacts ?? []).map((i) =>
      maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("knownSchedulingContacts"))
    );
    o.tradeCommsEmailPreview = maybeNew(
      "TradePartnerAvailabilityRequestEmailPreview",
      options.tradeCommsEmailPreview,
      cache,
      options.hasOwnProperty("tradeCommsEmailPreview"),
    );
    return o as FactoryResult<PlanTask>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanTask"] = newPlanTask;

export interface ToDoOptions {
  __typename?: "ToDo";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ToDo["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ToDo["isFollowed"];
  id?: ToDo["id"];
  name?: ToDo["name"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  description?: ToDo["description"];
  deletedAt?: ToDo["deletedAt"];
  createdAt?: ToDo["createdAt"];
  updatedAt?: ToDo["updatedAt"];
  dueDate?: ToDo["dueDate"];
  order?: ToDo["order"];
  status?: ToDoStatusDetailOptions | ToDoStatus;
  type?: ToDoTypeDetailOptions | ToDoType;
  parent?:
    | ToDoParent
    | FactoryResult<ToDoParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<CohortOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | null;
  createdBy?: FactoryInput<User, UserOptions>;
  assignee?: FactoryInput<User, UserOptions> | null;
  assignees?: Array<FactoryInput<User, UserOptions>>;
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
  urgent?: ToDo["urgent"];
  checklistItems?: Array<FactoryInput<ToDoChecklistItem, ToDoChecklistItemOptions>>;
  checklistProgress?: FactoryInput<ToDoChecklistProgress, ToDoChecklistProgressOptions>;
  changeRequest?: FactoryInput<ChangeRequest, ChangeRequestOptions> | null;
}

export function newToDo(options?: ToDoOptions, factoryOptions?: FactoryOptions): FactoryResult<ToDo>;
export function newToDo(
  options: ToDoOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ToDo> {
  const o = (options.__typename ? options : cache["ToDo"] = {}) as ToDo;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ToDo";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("ToDo");
    o.name = options.name ?? "name";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.description = options.description ?? null;
    o.deletedAt = options.deletedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.dueDate = options.dueDate ?? null;
    o.order = options.order ?? "order";
    o.status = enumOrDetailOfToDoStatus(options.status);
    o.type = enumOrDetailOfToDoType(options.type);
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.assignee = maybeNewOrNull("User", options.assignee, cache);
    o.assignees = (options.assignees ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("assignees")));
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    o.urgent = options.urgent ?? false;
    o.checklistItems = (options.checklistItems ?? []).map((i) =>
      maybeNew("ToDoChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
    );
    o.checklistProgress = maybeNew(
      "ToDoChecklistProgress",
      options.checklistProgress,
      cache,
      options.hasOwnProperty("checklistProgress"),
    );
    o.changeRequest = maybeNewOrNull("ChangeRequest", options.changeRequest, cache);
    return o as FactoryResult<ToDo>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ToDo"] = newToDo;

export interface InvoiceOptions {
  __typename?: "Invoice";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Invoice["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Invoice["isFollowed"];
  id?: Invoice["id"];
  name?: Invoice["name"];
  invoiceDate?: Invoice["invoiceDate"];
  dueDate?: Invoice["dueDate"];
  description?: Invoice["description"];
  title?: Invoice["title"];
  quickbooksId?: Invoice["quickbooksId"];
  amountInCents?: Invoice["amountInCents"];
  accruedAmountInCents?: Invoice["accruedAmountInCents"];
  balanceInCents?: Invoice["balanceInCents"];
  amountPaidInCents?: Invoice["amountPaidInCents"];
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  lineItems?: Array<FactoryInput<InvoiceLineItem, InvoiceLineItemOptions>>;
  lineItemsByCostCode?: Array<FactoryInput<InvoiceLineItemsByCostCode, InvoiceLineItemsByCostCodeOptions>>;
  drawLineItems?: Array<FactoryInput<InvoiceDrawLineItem, InvoiceDrawLineItemOptions>>;
  quickbooksPullOnly?: Invoice["quickbooksPullOnly"];
  document?: FactoryInput<Document, DocumentOptions> | null;
  invoiceNumber?: Invoice["invoiceNumber"];
  isHistoricalInvoiceNumber?: Invoice["isHistoricalInvoiceNumber"];
  isFinalInvoice?: Invoice["isFinalInvoice"];
  history?: Array<FactoryInput<History, HistoryOptions>>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  intacctAmountPaidInCents?: Invoice["intacctAmountPaidInCents"];
  documents?: Array<FactoryInput<InvoiceDocument, InvoiceDocumentOptions>>;
  quickbooksAmountPaidInCents?: Invoice["quickbooksAmountPaidInCents"];
  intacctSyncError?: Invoice["intacctSyncError"];
  approval?: FactoryInput<Approval, ApprovalOptions> | null;
  status?: InvoiceStatusDetailOptions | InvoiceStatus;
  lineItemCutoffDate?: Invoice["lineItemCutoffDate"];
  lineItemStartDate?: Invoice["lineItemStartDate"];
  predictedApprovers?: Array<
    | ApproverUser
    | FactoryResult<ApproverUser>
    | ClientOptions
    | RequireTypename<InternalUserOptions>
    | RequireTypename<TradePartnerUserOptions>
  >;
  paidDate?: Invoice["paidDate"];
  creditForInvoice?: FactoryInput<Invoice, InvoiceOptions> | null;
  shouldSyncToIntacct?: Invoice["shouldSyncToIntacct"];
  intacctId?: Invoice["intacctId"];
  type?: InvoiceTypeDetailOptions | InvoiceType;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  pandaDocs?: Array<FactoryInput<PandaDoc, PandaDocOptions>>;
  scheduledLineItems?: Array<FactoryInput<InvoiceScheduledLineItem, InvoiceScheduledLineItemOptions>>;
  accruedLineItems?: Array<FactoryInput<InvoiceAccruedLineItem, InvoiceAccruedLineItemOptions>>;
  displayLineItems?: Array<FactoryInput<InvoiceDisplayLineItem, InvoiceDisplayLineItemOptions>>;
  updatedAt?: Invoice["updatedAt"];
  createdAt?: Invoice["createdAt"];
  isHistorical?: Invoice["isHistorical"];
  parent?:
    | InvoiceParent
    | FactoryResult<InvoiceParent>
    | PlanMilestoneOptions
    | RequireTypename<TaskOptions>
    | RequireTypename<ScheduleTaskOptions>
    | RequireTypename<PlanTaskOptions>
    | null;
  source?: InvoiceSourceDetailOptions | InvoiceSource;
  remainingDownPaymentInCents?: Invoice["remainingDownPaymentInCents"];
  downPaymentConsumingLineItems?: Array<FactoryInput<InvoiceLineItem, InvoiceLineItemOptions>>;
  pocInvoicedToDateInCents?: Invoice["pocInvoicedToDateInCents"];
  contractPriceSnapshotInCents?: Invoice["contractPriceSnapshotInCents"];
}

export function newInvoice(options?: InvoiceOptions, factoryOptions?: FactoryOptions): FactoryResult<Invoice>;
export function newInvoice(
  options: InvoiceOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Invoice> {
  const o = (options.__typename ? options : cache["Invoice"] = {}) as Invoice;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Invoice";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Invoice");
    o.name = options.name ?? "name";
    o.invoiceDate = options.invoiceDate ?? newDate();
    o.dueDate = options.dueDate ?? newDate();
    o.description = options.description ?? null;
    o.title = options.title ?? "title";
    o.quickbooksId = options.quickbooksId ?? null;
    o.amountInCents = options.amountInCents ?? 0;
    o.accruedAmountInCents = options.accruedAmountInCents ?? 0;
    o.balanceInCents = options.balanceInCents ?? 0;
    o.amountPaidInCents = options.amountPaidInCents ?? 0;
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.lineItemsByCostCode = (options.lineItemsByCostCode ?? []).map((i) =>
      maybeNew("InvoiceLineItemsByCostCode", i, cache, options.hasOwnProperty("lineItemsByCostCode"))
    );
    o.drawLineItems = (options.drawLineItems ?? []).map((i) =>
      maybeNew("InvoiceDrawLineItem", i, cache, options.hasOwnProperty("drawLineItems"))
    );
    o.quickbooksPullOnly = options.quickbooksPullOnly ?? false;
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.invoiceNumber = options.invoiceNumber ?? "invoiceNumber";
    o.isHistoricalInvoiceNumber = options.isHistoricalInvoiceNumber ?? false;
    o.isFinalInvoice = options.isFinalInvoice ?? false;
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.intacctAmountPaidInCents = options.intacctAmountPaidInCents ?? 0;
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("InvoiceDocument", i, cache, options.hasOwnProperty("documents"))
    );
    o.quickbooksAmountPaidInCents = options.quickbooksAmountPaidInCents ?? 0;
    o.intacctSyncError = options.intacctSyncError ?? null;
    o.approval = maybeNewOrNull("Approval", options.approval, cache);
    o.status = enumOrDetailOfInvoiceStatus(options.status);
    o.lineItemCutoffDate = options.lineItemCutoffDate ?? null;
    o.lineItemStartDate = options.lineItemStartDate ?? null;
    o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
      maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
    );
    o.paidDate = options.paidDate ?? null;
    o.creditForInvoice = maybeNewOrNull("Invoice", options.creditForInvoice, cache);
    o.shouldSyncToIntacct = options.shouldSyncToIntacct ?? false;
    o.intacctId = options.intacctId ?? null;
    o.type = enumOrDetailOfInvoiceType(options.type);
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.pandaDocs = (options.pandaDocs ?? []).map((i) =>
      maybeNew("PandaDoc", i, cache, options.hasOwnProperty("pandaDocs"))
    );
    o.scheduledLineItems = (options.scheduledLineItems ?? []).map((i) =>
      maybeNew("InvoiceScheduledLineItem", i, cache, options.hasOwnProperty("scheduledLineItems"))
    );
    o.accruedLineItems = (options.accruedLineItems ?? []).map((i) =>
      maybeNew("InvoiceAccruedLineItem", i, cache, options.hasOwnProperty("accruedLineItems"))
    );
    o.displayLineItems = (options.displayLineItems ?? []).map((i) =>
      maybeNew("InvoiceDisplayLineItem", i, cache, options.hasOwnProperty("displayLineItems"))
    );
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.createdAt = options.createdAt ?? newDateTime();
    o.isHistorical = options.isHistorical ?? false;
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "PlanMilestone", options.parent, cache);
    o.source = enumOrDetailOfInvoiceSource(options.source);
    o.remainingDownPaymentInCents = options.remainingDownPaymentInCents ?? 0;
    o.downPaymentConsumingLineItems = (options.downPaymentConsumingLineItems ?? []).map((i) =>
      maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("downPaymentConsumingLineItems"))
    );
    o.pocInvoicedToDateInCents = options.pocInvoicedToDateInCents ?? 0;
    o.contractPriceSnapshotInCents = options.contractPriceSnapshotInCents ?? 0;
    return o as FactoryResult<Invoice>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Invoice"] = newInvoice;

export interface StandaloneProjectOptions {
  __typename?: "StandaloneProject";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: StandaloneProject["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: StandaloneProject["isFollowed"];
  id?: StandaloneProject["id"];
  buildAddress?: FactoryInput<Address, AddressOptions>;
  market?: FactoryInput<Market, MarketOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  cohort?: FactoryInput<Cohort, CohortOptions> | null;
  constructionConfidenceFactor?: StandaloneProject["constructionConfidenceFactor"];
  lotRating?: FactoryInput<LotRating, LotRatingOptions> | null;
  preConBudgetLineItems?: Array<
    FactoryInput<PreConBudgetCostDivisionLineItem, PreConBudgetCostDivisionLineItemOptions>
  >;
  preconContractType?: FactoryInput<PreconContractType, PreconContractTypeOptions> | null;
  primaryProject?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  quickbooksCustomerId?: StandaloneProject["quickbooksCustomerId"];
  shadowProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  submarket?: FactoryInput<Submarket, SubmarketOptions> | null;
  collaborators?: Array<FactoryInput<ProjectCollaborator, ProjectCollaboratorOptions>>;
  coverImage?: FactoryInput<Asset, AssetOptions> | null;
  teamMembers?: Array<FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>>;
  projectLead?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions> | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  stages?: Array<FactoryInput<ProjectStage, ProjectStageOptions>>;
  stage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  hopUrl?: StandaloneProject["hopUrl"];
  propcoUrl?: StandaloneProject["propcoUrl"];
  name?: StandaloneProject["name"];
  displayName?: StandaloneProject["displayName"];
  availableAssignees?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  startDate?: StandaloneProject["startDate"];
  features?: StandaloneProject["features"];
  isTest?: StandaloneProject["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: StandaloneProject["latitude"];
  longitude?: StandaloneProject["longitude"];
  googleDriveFolderId?: StandaloneProject["googleDriveFolderId"];
  salesforceAccountId?: StandaloneProject["salesforceAccountId"];
  salesforceOpportunities?: Array<FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions>>;
  projectStatusChange?: FactoryInput<ProjectStatusChange, ProjectStatusChangeOptions> | null;
  planRoomLink?: StandaloneProject["planRoomLink"];
  isDisaster?: StandaloneProject["isDisaster"];
  intakeStyleNotes?: StandaloneProject["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: FactoryInput<ProductType, ProductTypeOptions> | null;
  enableSchedulesV2?: StandaloneProject["enableSchedulesV2"];
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  jobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
  salesforcePropertyId?: StandaloneProject["salesforcePropertyId"];
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  expenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedExpenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedAmountInCents?: StandaloneProject["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: StandaloneProject["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: StandaloneProject["enableSchedulesCalendar"];
  readyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions> | null;
  earnedValueCurves?: Array<FactoryInput<EarnedValueCurve, EarnedValueCurveOptions>>;
  enableBidPackagesV2?: StandaloneProject["enableBidPackagesV2"];
  invoiceSettings?: FactoryInput<ProjectInvoiceSetting, ProjectInvoiceSettingOptions> | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: StandaloneProject["lotPartitionId"];
  budgetFinancials?: FactoryInput<ProjectBudgetFinancials, ProjectBudgetFinancialsOptions>;
  enableDelayFlags?: StandaloneProject["enableDelayFlags"];
  warrantyStartDate?: StandaloneProject["warrantyStartDate"];
  verticalCompleteDate?: StandaloneProject["verticalCompleteDate"];
  jobLogInsights?: FactoryInput<ProjectJobLogInsights, ProjectJobLogInsightsOptions>;
  targetEndDate?: StandaloneProject["targetEndDate"];
  latestActiveStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  primaryHomeowner?: FactoryInput<Client, ClientOptions> | null;
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>> | null;
  lotDetail?: FactoryInput<ProjectLotDetail, ProjectLotDetailOptions>;
  siteSpecificInfos?: Array<FactoryInput<ProjectSiteSpecificInfo, ProjectSiteSpecificInfoOptions>>;
  projectSiteCondition?: FactoryInput<ProjectSiteCondition, ProjectSiteConditionOptions> | null;
  unassignedTaskCount?: StandaloneProject["unassignedTaskCount"];
  enableHomeownerNotes?: StandaloneProject["enableHomeownerNotes"];
  checkoutCustomerConfigId?: StandaloneProject["checkoutCustomerConfigId"];
  canEditJobLogs?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditPrice?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveBudget?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  homeownerNotes?: Array<FactoryInput<HomeownerNote, HomeownerNoteOptions>>;
  enableHomeownerJourneyV2?: StandaloneProject["enableHomeownerJourneyV2"];
  featureFlags?: Array<FactoryInput<FeatureFlag, FeatureFlagOptions>>;
  homeownerDeliveryDate?: StandaloneProject["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: StandaloneProject["tasksCompletedThisWeek"];
  contacts?: Array<FactoryInput<ProjectContact, ProjectContactOptions>>;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  shouldAccrueAsComplete?: StandaloneProject["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: StandaloneProject["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: StandaloneProject["indirectCostMarkupOverrideBasisPoints"];
  customer?: FactoryInput<Customer, CustomerOptions> | null;
  customerOwnerEntity?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions> | null;
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions> | null;
  allowExcludedCostCodesOnPurchaseOrders?: StandaloneProject["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: StandaloneProject["enableProductConfigPlan"];
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions> | null;
  builder?: FactoryInput<Builder, BuilderOptions> | null;
  bidOutPercentage?: StandaloneProject["bidOutPercentage"];
  enableChangeEventSignatures?: StandaloneProject["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: StandaloneProject["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: StandaloneProject["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: StandaloneProject["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: StandaloneProject["directHardCostMarkupInBasisPoints"];
  legalDescription?: StandaloneProject["legalDescription"];
  salesTaxOverrideInBasisPoints?: StandaloneProject["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: StandaloneProject["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>>;
  allocationRules?: Array<FactoryInput<ProjectAllocationRule, ProjectAllocationRuleOptions>>;
  warrantyLengthInDays?: StandaloneProject["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: StandaloneProject["warrantyOverrideLengthInDays"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  homeownerContracts?: Array<FactoryInput<HomeownerContract, HomeownerContractOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  directCostInCents?: StandaloneProject["directCostInCents"];
  directPriceInCents?: StandaloneProject["directPriceInCents"];
  totalHardCostInCents?: StandaloneProject["totalHardCostInCents"];
  totalSoftCostInCents?: StandaloneProject["totalSoftCostInCents"];
  totalCostInCents?: StandaloneProject["totalCostInCents"];
  totalPriceInCents?: StandaloneProject["totalPriceInCents"];
  readyToStartDate?: StandaloneProject["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: StandaloneProject["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: StandaloneProject["directCostAtStartInCents"];
  directCostVarianceInCents?: StandaloneProject["directCostVarianceInCents"];
  uncommittedCostInCents?: StandaloneProject["uncommittedCostInCents"];
  snapshots?: Array<FactoryInput<ProjectSnapshot, ProjectSnapshotOptions>>;
  warrantyEndDate?: StandaloneProject["warrantyEndDate"];
  companyInfo?: FactoryInput<CompanyInfo, CompanyInfoOptions>;
  invoicePaymentNetDays?: StandaloneProject["invoicePaymentNetDays"];
  snapshotAsOf?: FactoryInput<ProjectSnapshot, ProjectSnapshotOptions> | null;
  purchaseCostInCents?: StandaloneProject["purchaseCostInCents"];
  grossSalesPriceInCents?: StandaloneProject["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: StandaloneProject["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: StandaloneProject["directMarginInBasisPoints"];
  projectCostCodes?: Array<FactoryInput<ProjectCostCode, ProjectCostCodeOptions>>;
  parent?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  children?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  parentsRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  childrenRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  siblingProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  sellableProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  isSellableProject?: StandaloneProject["isSellableProject"];
  originalCostInCents?: StandaloneProject["originalCostInCents"];
  startCostInCents?: StandaloneProject["startCostInCents"];
  changeEventCostInCents?: StandaloneProject["changeEventCostInCents"];
  projectedCostInCents?: StandaloneProject["projectedCostInCents"];
  revisedCostInCents?: StandaloneProject["revisedCostInCents"];
  committedCostInCents?: StandaloneProject["committedCostInCents"];
  availableCostInCents?: StandaloneProject["availableCostInCents"];
  billedCostInCents?: StandaloneProject["billedCostInCents"];
  unbilledCostInCents?: StandaloneProject["unbilledCostInCents"];
  client?: FactoryInput<Client, ClientOptions> | null;
  url?: StandaloneProject["url"];
  projectName?: StandaloneProject["projectName"];
  salesforceId?: StandaloneProject["salesforceId"];
  activeSalesforceOpportunity?: FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions> | null;
  dictionary?: FactoryInput<ProjectDictionary, ProjectDictionaryOptions>;
}

export function newStandaloneProject(
  options?: StandaloneProjectOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newStandaloneProject(
  options: StandaloneProjectOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<StandaloneProject> {
  const o = (options.__typename ? options : cache["StandaloneProject"] = {}) as StandaloneProject;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "StandaloneProject";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("StandaloneProject");
    o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
    o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
    o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
    o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
      maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
    );
    o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
    o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
    o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
    o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
    );
    o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
    o.collaborators = (options.collaborators ?? []).map((i) =>
      maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
    );
    o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
    o.teamMembers = (options.teamMembers ?? []).map((i) =>
      maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
    );
    o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
    o.activeStage = enumOrDetailOfStage(options.activeStage);
    o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
    o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
    o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.hopUrl = options.hopUrl ?? "hopUrl";
    o.propcoUrl = options.propcoUrl ?? null;
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
    );
    o.startDate = options.startDate ?? newDate();
    o.features = options.features ?? [];
    o.isTest = options.isTest ?? false;
    o.status = enumOrDetailOfProjectStatus(options.status);
    o.latitude = options.latitude ?? null;
    o.longitude = options.longitude ?? null;
    o.googleDriveFolderId = options.googleDriveFolderId ?? null;
    o.salesforceAccountId = options.salesforceAccountId ?? null;
    o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
      maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
    );
    o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
    o.planRoomLink = options.planRoomLink ?? null;
    o.isDisaster = options.isDisaster ?? null;
    o.intakeStyleNotes = options.intakeStyleNotes ?? null;
    o.lotType = enumOrDetailOfLotType(options.lotType);
    o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
    o.productType = maybeNewOrNull("ProductType", options.productType, cache);
    o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
    o.salesforcePropertyId = options.salesforcePropertyId ?? null;
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
    o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
      maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
    );
    o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
    o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
    o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
    o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
    o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
      maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
    );
    o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
    o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
    o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
    o.lotPartitionId = options.lotPartitionId ?? null;
    o.budgetFinancials = maybeNew(
      "ProjectBudgetFinancials",
      options.budgetFinancials,
      cache,
      options.hasOwnProperty("budgetFinancials"),
    );
    o.enableDelayFlags = options.enableDelayFlags ?? false;
    o.warrantyStartDate = options.warrantyStartDate ?? null;
    o.verticalCompleteDate = options.verticalCompleteDate ?? null;
    o.jobLogInsights = maybeNew(
      "ProjectJobLogInsights",
      options.jobLogInsights,
      cache,
      options.hasOwnProperty("jobLogInsights"),
    );
    o.targetEndDate = options.targetEndDate ?? null;
    o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
    o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
    o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
      maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
    );
    o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
    o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
    o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
    o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
    o.canEditJobLogs = maybeNew(
      "PotentialOperation2",
      options.canEditJobLogs,
      cache,
      options.hasOwnProperty("canEditJobLogs"),
    );
    o.canEditPrice = maybeNew(
      "PotentialOperation2",
      options.canEditPrice,
      cache,
      options.hasOwnProperty("canEditPrice"),
    );
    o.canHaveBudget = maybeNew(
      "PotentialOperation2",
      options.canHaveBudget,
      cache,
      options.hasOwnProperty("canHaveBudget"),
    );
    o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
      maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
    );
    o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
    o.featureFlags = (options.featureFlags ?? []).map((i) =>
      maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
    );
    o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
    o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
    o.contacts = (options.contacts ?? []).map((i) =>
      maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
    );
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
    o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
    o.customer = maybeNewOrNull("Customer", options.customer, cache);
    o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
    o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
    o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
    o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
    o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
    o.builder = maybeNewOrNull("Builder", options.builder, cache);
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
    o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
    o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
    o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
    o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
    o.legalDescription = options.legalDescription ?? null;
    o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
    o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
    o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
      maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
    );
    o.allocationRules = (options.allocationRules ?? []).map((i) =>
      maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
    );
    o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
    o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
      maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.directCostInCents = options.directCostInCents ?? 0;
    o.directPriceInCents = options.directPriceInCents ?? 0;
    o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
    o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.readyToStartDate = options.readyToStartDate ?? null;
    o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
    o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
    o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
    o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
    o.snapshots = (options.snapshots ?? []).map((i) =>
      maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
    );
    o.warrantyEndDate = options.warrantyEndDate ?? null;
    o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
    o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
    o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
    o.purchaseCostInCents = options.purchaseCostInCents ?? null;
    o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
    o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
      maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
    );
    o.parent = maybeNewOrNull("Project", options.parent, cache);
    o.children = (options.children ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("children")));
    o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
    );
    o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
    );
    o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
    );
    o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
    );
    o.isSellableProject = options.isSellableProject ?? false;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.client = maybeNewOrNull("Client", options.client, cache);
    o.url = options.url ?? "url";
    o.projectName = options.projectName ?? "projectName";
    o.salesforceId = options.salesforceId ?? null;
    o.activeSalesforceOpportunity = maybeNewOrNull(
      "ProjectSalesforceOpportunity",
      options.activeSalesforceOpportunity,
      cache,
    );
    o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
    return o as FactoryResult<StandaloneProject>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["StandaloneProject"] = newStandaloneProject;

export interface RegionOptions {
  __typename?: "Region";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Region["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Region["isFollowed"];
  id?: Region["id"];
  abbreviation?: Region["abbreviation"];
  createdAt?: Region["createdAt"];
  updatedAt?: Region["updatedAt"];
  children?: Array<FactoryInput<Market, MarketOptions>>;
  collaborators?: Array<FactoryInput<ProjectCollaborator, ProjectCollaboratorOptions>>;
  coverImage?: FactoryInput<Asset, AssetOptions> | null;
  buildAddress?: FactoryInput<Address, AddressOptions> | null;
  market?: FactoryInput<Market, MarketOptions> | null;
  teamMembers?: Array<FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>>;
  projectLead?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions> | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  stages?: Array<FactoryInput<ProjectStage, ProjectStageOptions>>;
  stage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  hopUrl?: Region["hopUrl"];
  name?: Region["name"];
  displayName?: Region["displayName"];
  availableAssignees?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  startDate?: Region["startDate"];
  features?: Region["features"];
  isTest?: Region["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Region["latitude"];
  longitude?: Region["longitude"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  googleDriveFolderId?: Region["googleDriveFolderId"];
  salesforceAccountId?: Region["salesforceAccountId"];
  salesforceOpportunities?: Array<FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions>>;
  projectStatusChange?: FactoryInput<ProjectStatusChange, ProjectStatusChangeOptions> | null;
  planRoomLink?: Region["planRoomLink"];
  isDisaster?: Region["isDisaster"];
  intakeStyleNotes?: Region["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: FactoryInput<ProductType, ProductTypeOptions> | null;
  enableSchedulesV2?: Region["enableSchedulesV2"];
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  jobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
  salesforcePropertyId?: Region["salesforcePropertyId"];
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  expenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedExpenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedAmountInCents?: Region["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Region["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Region["enableSchedulesCalendar"];
  readyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions> | null;
  earnedValueCurves?: Array<FactoryInput<EarnedValueCurve, EarnedValueCurveOptions>>;
  enableBidPackagesV2?: Region["enableBidPackagesV2"];
  invoiceSettings?: FactoryInput<ProjectInvoiceSetting, ProjectInvoiceSettingOptions> | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Region["lotPartitionId"];
  budgetFinancials?: FactoryInput<ProjectBudgetFinancials, ProjectBudgetFinancialsOptions>;
  enableDelayFlags?: Region["enableDelayFlags"];
  warrantyStartDate?: Region["warrantyStartDate"];
  verticalCompleteDate?: Region["verticalCompleteDate"];
  jobLogInsights?: FactoryInput<ProjectJobLogInsights, ProjectJobLogInsightsOptions>;
  targetEndDate?: Region["targetEndDate"];
  latestActiveStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  primaryHomeowner?: FactoryInput<Client, ClientOptions> | null;
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>> | null;
  lotDetail?: FactoryInput<ProjectLotDetail, ProjectLotDetailOptions>;
  siteSpecificInfos?: Array<FactoryInput<ProjectSiteSpecificInfo, ProjectSiteSpecificInfoOptions>>;
  projectSiteCondition?: FactoryInput<ProjectSiteCondition, ProjectSiteConditionOptions> | null;
  unassignedTaskCount?: Region["unassignedTaskCount"];
  enableHomeownerNotes?: Region["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Region["checkoutCustomerConfigId"];
  canEditJobLogs?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditPrice?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveBudget?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  homeownerNotes?: Array<FactoryInput<HomeownerNote, HomeownerNoteOptions>>;
  enableHomeownerJourneyV2?: Region["enableHomeownerJourneyV2"];
  featureFlags?: Array<FactoryInput<FeatureFlag, FeatureFlagOptions>>;
  homeownerDeliveryDate?: Region["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Region["tasksCompletedThisWeek"];
  contacts?: Array<FactoryInput<ProjectContact, ProjectContactOptions>>;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  shouldAccrueAsComplete?: Region["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Region["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Region["indirectCostMarkupOverrideBasisPoints"];
  customer?: FactoryInput<Customer, CustomerOptions> | null;
  customerOwnerEntity?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions> | null;
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions> | null;
  allowExcludedCostCodesOnPurchaseOrders?: Region["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Region["enableProductConfigPlan"];
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions> | null;
  builder?: FactoryInput<Builder, BuilderOptions> | null;
  bidOutPercentage?: Region["bidOutPercentage"];
  enableChangeEventSignatures?: Region["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Region["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Region["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Region["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Region["directHardCostMarkupInBasisPoints"];
  legalDescription?: Region["legalDescription"];
  salesTaxOverrideInBasisPoints?: Region["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Region["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>>;
  allocationRules?: Array<FactoryInput<ProjectAllocationRule, ProjectAllocationRuleOptions>>;
  warrantyLengthInDays?: Region["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Region["warrantyOverrideLengthInDays"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  homeownerContracts?: Array<FactoryInput<HomeownerContract, HomeownerContractOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  directCostInCents?: Region["directCostInCents"];
  directPriceInCents?: Region["directPriceInCents"];
  totalHardCostInCents?: Region["totalHardCostInCents"];
  totalSoftCostInCents?: Region["totalSoftCostInCents"];
  totalCostInCents?: Region["totalCostInCents"];
  totalPriceInCents?: Region["totalPriceInCents"];
  readyToStartDate?: Region["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Region["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Region["directCostAtStartInCents"];
  directCostVarianceInCents?: Region["directCostVarianceInCents"];
  uncommittedCostInCents?: Region["uncommittedCostInCents"];
  snapshots?: Array<FactoryInput<ProjectSnapshot, ProjectSnapshotOptions>>;
  companyInfo?: FactoryInput<CompanyInfo, CompanyInfoOptions>;
  invoicePaymentNetDays?: Region["invoicePaymentNetDays"];
  snapshotAsOf?: FactoryInput<ProjectSnapshot, ProjectSnapshotOptions> | null;
  purchaseCostInCents?: Region["purchaseCostInCents"];
  grossSalesPriceInCents?: Region["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Region["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Region["directMarginInBasisPoints"];
  projectCostCodes?: Array<FactoryInput<ProjectCostCode, ProjectCostCodeOptions>>;
  parent?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  parentsRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  childrenRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  siblingProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  sellableProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  isSellableProject?: Region["isSellableProject"];
  originalCostInCents?: Region["originalCostInCents"];
  startCostInCents?: Region["startCostInCents"];
  changeEventCostInCents?: Region["changeEventCostInCents"];
  projectedCostInCents?: Region["projectedCostInCents"];
  revisedCostInCents?: Region["revisedCostInCents"];
  committedCostInCents?: Region["committedCostInCents"];
  availableCostInCents?: Region["availableCostInCents"];
  billedCostInCents?: Region["billedCostInCents"];
  unbilledCostInCents?: Region["unbilledCostInCents"];
  cohort?: FactoryInput<Cohort, CohortOptions> | null;
  constructionConfidenceFactor?: Region["constructionConfidenceFactor"];
  lotRating?: FactoryInput<LotRating, LotRatingOptions> | null;
  preConBudgetLineItems?: Array<
    FactoryInput<PreConBudgetCostDivisionLineItem, PreConBudgetCostDivisionLineItemOptions>
  >;
  preconContractType?: FactoryInput<PreconContractType, PreconContractTypeOptions> | null;
  primaryProject?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  quickbooksCustomerId?: Region["quickbooksCustomerId"];
  shadowProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  submarket?: FactoryInput<Submarket, SubmarketOptions> | null;
  client?: FactoryInput<Client, ClientOptions> | null;
  url?: Region["url"];
  projectName?: Region["projectName"];
  salesforceId?: Region["salesforceId"];
  activeSalesforceOpportunity?: FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions> | null;
  dictionary?: FactoryInput<ProjectDictionary, ProjectDictionaryOptions>;
  warrantyEndDate?: Region["warrantyEndDate"];
  invoiceScheduleTemplates?: Array<FactoryInput<InvoiceScheduleTemplate, InvoiceScheduleTemplateOptions>>;
}

export function newRegion(options?: RegionOptions, factoryOptions?: FactoryOptions): FactoryResult<Region>;
export function newRegion(
  options: RegionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Region> {
  const o = (options.__typename ? options : cache["Region"] = {}) as Region;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Region";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Region");
    o.abbreviation = options.abbreviation ?? "abbreviation";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.children = (options.children ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("children")));
    o.collaborators = (options.collaborators ?? []).map((i) =>
      maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
    );
    o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
    o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
    o.market = maybeNewOrNull("Market", options.market, cache);
    o.teamMembers = (options.teamMembers ?? []).map((i) =>
      maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
    );
    o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
    o.activeStage = enumOrDetailOfStage(options.activeStage);
    o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
    o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
    o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.hopUrl = options.hopUrl ?? "hopUrl";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
    );
    o.startDate = options.startDate ?? newDate();
    o.features = options.features ?? [];
    o.isTest = options.isTest ?? false;
    o.status = enumOrDetailOfProjectStatus(options.status);
    o.latitude = options.latitude ?? null;
    o.longitude = options.longitude ?? null;
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.googleDriveFolderId = options.googleDriveFolderId ?? null;
    o.salesforceAccountId = options.salesforceAccountId ?? null;
    o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
      maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
    );
    o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
    o.planRoomLink = options.planRoomLink ?? null;
    o.isDisaster = options.isDisaster ?? null;
    o.intakeStyleNotes = options.intakeStyleNotes ?? null;
    o.lotType = enumOrDetailOfLotType(options.lotType);
    o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
    o.productType = maybeNewOrNull("ProductType", options.productType, cache);
    o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
    o.salesforcePropertyId = options.salesforcePropertyId ?? null;
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
    o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
      maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
    );
    o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
    o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
    o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
    o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
    o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
      maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
    );
    o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
    o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
    o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
    o.lotPartitionId = options.lotPartitionId ?? null;
    o.budgetFinancials = maybeNew(
      "ProjectBudgetFinancials",
      options.budgetFinancials,
      cache,
      options.hasOwnProperty("budgetFinancials"),
    );
    o.enableDelayFlags = options.enableDelayFlags ?? false;
    o.warrantyStartDate = options.warrantyStartDate ?? null;
    o.verticalCompleteDate = options.verticalCompleteDate ?? null;
    o.jobLogInsights = maybeNew(
      "ProjectJobLogInsights",
      options.jobLogInsights,
      cache,
      options.hasOwnProperty("jobLogInsights"),
    );
    o.targetEndDate = options.targetEndDate ?? null;
    o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
    o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
    o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
      maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
    );
    o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
    o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
    o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
    o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
    o.canEditJobLogs = maybeNew(
      "PotentialOperation2",
      options.canEditJobLogs,
      cache,
      options.hasOwnProperty("canEditJobLogs"),
    );
    o.canEditPrice = maybeNew(
      "PotentialOperation2",
      options.canEditPrice,
      cache,
      options.hasOwnProperty("canEditPrice"),
    );
    o.canHaveBudget = maybeNew(
      "PotentialOperation2",
      options.canHaveBudget,
      cache,
      options.hasOwnProperty("canHaveBudget"),
    );
    o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
      maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
    );
    o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
    o.featureFlags = (options.featureFlags ?? []).map((i) =>
      maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
    );
    o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
    o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
    o.contacts = (options.contacts ?? []).map((i) =>
      maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
    );
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
    o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
    o.customer = maybeNewOrNull("Customer", options.customer, cache);
    o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
    o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
    o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
    o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
    o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
    o.builder = maybeNewOrNull("Builder", options.builder, cache);
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
    o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
    o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
    o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
    o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
    o.legalDescription = options.legalDescription ?? null;
    o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
    o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
    o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
      maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
    );
    o.allocationRules = (options.allocationRules ?? []).map((i) =>
      maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
    );
    o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
    o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
      maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.directCostInCents = options.directCostInCents ?? 0;
    o.directPriceInCents = options.directPriceInCents ?? 0;
    o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
    o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.readyToStartDate = options.readyToStartDate ?? null;
    o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
    o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
    o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
    o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
    o.snapshots = (options.snapshots ?? []).map((i) =>
      maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
    );
    o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
    o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
    o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
    o.purchaseCostInCents = options.purchaseCostInCents ?? null;
    o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
    o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
      maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
    );
    o.parent = maybeNewOrNull("Project", options.parent, cache);
    o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
    );
    o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
    );
    o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
    );
    o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
    );
    o.isSellableProject = options.isSellableProject ?? false;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
    o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
    o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
    o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
      maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
    );
    o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
    o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
    o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
    o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
    );
    o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
    o.client = maybeNewOrNull("Client", options.client, cache);
    o.url = options.url ?? "url";
    o.projectName = options.projectName ?? "projectName";
    o.salesforceId = options.salesforceId ?? null;
    o.activeSalesforceOpportunity = maybeNewOrNull(
      "ProjectSalesforceOpportunity",
      options.activeSalesforceOpportunity,
      cache,
    );
    o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
    o.warrantyEndDate = options.warrantyEndDate ?? null;
    o.invoiceScheduleTemplates = (options.invoiceScheduleTemplates ?? []).map((i) =>
      maybeNew("InvoiceScheduleTemplate", i, cache, options.hasOwnProperty("invoiceScheduleTemplates"))
    );
    return o as FactoryResult<Region>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Region"] = newRegion;

export interface MarketOptions {
  __typename?: "Market";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Market["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Market["isFollowed"];
  id?: Market["id"];
  abbreviation?: Market["abbreviation"];
  phone?: Market["phone"];
  salesforceMarketCode?: Market["salesforceMarketCode"];
  submarkets?: Array<FactoryInput<Submarket, SubmarketOptions>>;
  timeZone?: Market["timeZone"];
  msaName?: Market["msaName"];
  developments?: Array<FactoryInput<Development, DevelopmentOptions>>;
  bidItemEstimates?: Array<FactoryInput<BidItemEstimate, BidItemEstimateOptions>>;
  readyPlans?: Array<FactoryInput<ReadyPlan, ReadyPlanOptions>>;
  optionPricingConfigVariants?: Array<FactoryInput<OptionPricingConfigVariant, OptionPricingConfigVariantOptions>>;
  state?: Market["state"];
  materialLeadTimeConfigVariants?: Array<
    FactoryInput<MaterialLeadTimeConfigVariant, MaterialLeadTimeConfigVariantOptions>
  >;
  standaloneProjects?: Array<FactoryInput<StandaloneProject, StandaloneProjectOptions>>;
  marketDevelopmentContracts?: Array<FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>>;
  drops?: Array<FactoryInput<Drop, DropOptions>>;
  market?: FactoryInput<Market, MarketOptions>;
  parent?: FactoryInput<Region, RegionOptions>;
  children?: Array<FactoryInput<Community, CommunityOptions>>;
  collaborators?: Array<FactoryInput<ProjectCollaborator, ProjectCollaboratorOptions>>;
  coverImage?: FactoryInput<Asset, AssetOptions> | null;
  buildAddress?: FactoryInput<Address, AddressOptions> | null;
  teamMembers?: Array<FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>>;
  projectLead?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions> | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  stages?: Array<FactoryInput<ProjectStage, ProjectStageOptions>>;
  stage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  hopUrl?: Market["hopUrl"];
  name?: Market["name"];
  displayName?: Market["displayName"];
  availableAssignees?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  startDate?: Market["startDate"];
  features?: Market["features"];
  isTest?: Market["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Market["latitude"];
  longitude?: Market["longitude"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  googleDriveFolderId?: Market["googleDriveFolderId"];
  salesforceAccountId?: Market["salesforceAccountId"];
  salesforceOpportunities?: Array<FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions>>;
  projectStatusChange?: FactoryInput<ProjectStatusChange, ProjectStatusChangeOptions> | null;
  planRoomLink?: Market["planRoomLink"];
  isDisaster?: Market["isDisaster"];
  intakeStyleNotes?: Market["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: FactoryInput<ProductType, ProductTypeOptions> | null;
  enableSchedulesV2?: Market["enableSchedulesV2"];
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  jobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
  salesforcePropertyId?: Market["salesforcePropertyId"];
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  expenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedExpenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedAmountInCents?: Market["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Market["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Market["enableSchedulesCalendar"];
  readyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions> | null;
  earnedValueCurves?: Array<FactoryInput<EarnedValueCurve, EarnedValueCurveOptions>>;
  enableBidPackagesV2?: Market["enableBidPackagesV2"];
  invoiceSettings?: FactoryInput<ProjectInvoiceSetting, ProjectInvoiceSettingOptions> | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Market["lotPartitionId"];
  budgetFinancials?: FactoryInput<ProjectBudgetFinancials, ProjectBudgetFinancialsOptions>;
  enableDelayFlags?: Market["enableDelayFlags"];
  warrantyStartDate?: Market["warrantyStartDate"];
  verticalCompleteDate?: Market["verticalCompleteDate"];
  jobLogInsights?: FactoryInput<ProjectJobLogInsights, ProjectJobLogInsightsOptions>;
  targetEndDate?: Market["targetEndDate"];
  latestActiveStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  primaryHomeowner?: FactoryInput<Client, ClientOptions> | null;
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>> | null;
  lotDetail?: FactoryInput<ProjectLotDetail, ProjectLotDetailOptions>;
  siteSpecificInfos?: Array<FactoryInput<ProjectSiteSpecificInfo, ProjectSiteSpecificInfoOptions>>;
  projectSiteCondition?: FactoryInput<ProjectSiteCondition, ProjectSiteConditionOptions> | null;
  unassignedTaskCount?: Market["unassignedTaskCount"];
  enableHomeownerNotes?: Market["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Market["checkoutCustomerConfigId"];
  canEditJobLogs?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditPrice?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveBudget?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  homeownerNotes?: Array<FactoryInput<HomeownerNote, HomeownerNoteOptions>>;
  enableHomeownerJourneyV2?: Market["enableHomeownerJourneyV2"];
  featureFlags?: Array<FactoryInput<FeatureFlag, FeatureFlagOptions>>;
  homeownerDeliveryDate?: Market["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Market["tasksCompletedThisWeek"];
  contacts?: Array<FactoryInput<ProjectContact, ProjectContactOptions>>;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  shouldAccrueAsComplete?: Market["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Market["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Market["indirectCostMarkupOverrideBasisPoints"];
  customer?: FactoryInput<Customer, CustomerOptions> | null;
  customerOwnerEntity?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions> | null;
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions> | null;
  allowExcludedCostCodesOnPurchaseOrders?: Market["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Market["enableProductConfigPlan"];
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions> | null;
  builder?: FactoryInput<Builder, BuilderOptions> | null;
  bidOutPercentage?: Market["bidOutPercentage"];
  enableChangeEventSignatures?: Market["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Market["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Market["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Market["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Market["directHardCostMarkupInBasisPoints"];
  legalDescription?: Market["legalDescription"];
  salesTaxOverrideInBasisPoints?: Market["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Market["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>>;
  allocationRules?: Array<FactoryInput<ProjectAllocationRule, ProjectAllocationRuleOptions>>;
  warrantyLengthInDays?: Market["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Market["warrantyOverrideLengthInDays"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  homeownerContracts?: Array<FactoryInput<HomeownerContract, HomeownerContractOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  directCostInCents?: Market["directCostInCents"];
  directPriceInCents?: Market["directPriceInCents"];
  totalHardCostInCents?: Market["totalHardCostInCents"];
  totalSoftCostInCents?: Market["totalSoftCostInCents"];
  totalCostInCents?: Market["totalCostInCents"];
  totalPriceInCents?: Market["totalPriceInCents"];
  readyToStartDate?: Market["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Market["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Market["directCostAtStartInCents"];
  directCostVarianceInCents?: Market["directCostVarianceInCents"];
  uncommittedCostInCents?: Market["uncommittedCostInCents"];
  snapshots?: Array<FactoryInput<ProjectSnapshot, ProjectSnapshotOptions>>;
  warrantyEndDate?: Market["warrantyEndDate"];
  companyInfo?: FactoryInput<CompanyInfo, CompanyInfoOptions>;
  invoicePaymentNetDays?: Market["invoicePaymentNetDays"];
  snapshotAsOf?: FactoryInput<ProjectSnapshot, ProjectSnapshotOptions> | null;
  purchaseCostInCents?: Market["purchaseCostInCents"];
  grossSalesPriceInCents?: Market["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Market["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Market["directMarginInBasisPoints"];
  projectCostCodes?: Array<FactoryInput<ProjectCostCode, ProjectCostCodeOptions>>;
  parentsRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  childrenRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  siblingProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  sellableProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  isSellableProject?: Market["isSellableProject"];
  originalCostInCents?: Market["originalCostInCents"];
  startCostInCents?: Market["startCostInCents"];
  changeEventCostInCents?: Market["changeEventCostInCents"];
  projectedCostInCents?: Market["projectedCostInCents"];
  revisedCostInCents?: Market["revisedCostInCents"];
  committedCostInCents?: Market["committedCostInCents"];
  availableCostInCents?: Market["availableCostInCents"];
  billedCostInCents?: Market["billedCostInCents"];
  unbilledCostInCents?: Market["unbilledCostInCents"];
  cohort?: FactoryInput<Cohort, CohortOptions> | null;
  constructionConfidenceFactor?: Market["constructionConfidenceFactor"];
  lotRating?: FactoryInput<LotRating, LotRatingOptions> | null;
  preConBudgetLineItems?: Array<
    FactoryInput<PreConBudgetCostDivisionLineItem, PreConBudgetCostDivisionLineItemOptions>
  >;
  preconContractType?: FactoryInput<PreconContractType, PreconContractTypeOptions> | null;
  primaryProject?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  quickbooksCustomerId?: Market["quickbooksCustomerId"];
  shadowProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  submarket?: FactoryInput<Submarket, SubmarketOptions> | null;
  client?: FactoryInput<Client, ClientOptions> | null;
  url?: Market["url"];
  projectName?: Market["projectName"];
  salesforceId?: Market["salesforceId"];
  activeSalesforceOpportunity?: FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions> | null;
  dictionary?: FactoryInput<ProjectDictionary, ProjectDictionaryOptions>;
}

export function newMarket(options?: MarketOptions, factoryOptions?: FactoryOptions): FactoryResult<Market>;
export function newMarket(
  options: MarketOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Market> {
  const o = (options.__typename ? options : cache["Market"] = {}) as Market;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Market";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Market");
    o.abbreviation = options.abbreviation ?? "abbreviation";
    o.phone = options.phone ?? null;
    o.salesforceMarketCode = options.salesforceMarketCode ?? null;
    o.submarkets = (options.submarkets ?? []).map((i) =>
      maybeNew("Submarket", i, cache, options.hasOwnProperty("submarkets"))
    );
    o.timeZone = options.timeZone ?? "timeZone";
    o.msaName = options.msaName ?? null;
    o.developments = (options.developments ?? []).map((i) =>
      maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
    );
    o.bidItemEstimates = (options.bidItemEstimates ?? []).map((i) =>
      maybeNew("BidItemEstimate", i, cache, options.hasOwnProperty("bidItemEstimates"))
    );
    o.readyPlans = (options.readyPlans ?? []).map((i) =>
      maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("readyPlans"))
    );
    o.optionPricingConfigVariants = (options.optionPricingConfigVariants ?? []).map((i) =>
      maybeNew("OptionPricingConfigVariant", i, cache, options.hasOwnProperty("optionPricingConfigVariants"))
    );
    o.state = options.state ?? "state";
    o.materialLeadTimeConfigVariants = (options.materialLeadTimeConfigVariants ?? []).map((i) =>
      maybeNew("MaterialLeadTimeConfigVariant", i, cache, options.hasOwnProperty("materialLeadTimeConfigVariants"))
    );
    o.standaloneProjects = (options.standaloneProjects ?? []).map((i) =>
      maybeNew("StandaloneProject", i, cache, options.hasOwnProperty("standaloneProjects"))
    );
    o.marketDevelopmentContracts = (options.marketDevelopmentContracts ?? []).map((i) =>
      maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("marketDevelopmentContracts"))
    );
    o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.parent = maybeNew("Region", options.parent, cache, options.hasOwnProperty("parent"));
    o.children = (options.children ?? []).map((i) =>
      maybeNew("Community", i, cache, options.hasOwnProperty("children"))
    );
    o.collaborators = (options.collaborators ?? []).map((i) =>
      maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
    );
    o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
    o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
    o.teamMembers = (options.teamMembers ?? []).map((i) =>
      maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
    );
    o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
    o.activeStage = enumOrDetailOfStage(options.activeStage);
    o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
    o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
    o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.hopUrl = options.hopUrl ?? "hopUrl";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
    );
    o.startDate = options.startDate ?? newDate();
    o.features = options.features ?? [];
    o.isTest = options.isTest ?? false;
    o.status = enumOrDetailOfProjectStatus(options.status);
    o.latitude = options.latitude ?? null;
    o.longitude = options.longitude ?? null;
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.googleDriveFolderId = options.googleDriveFolderId ?? null;
    o.salesforceAccountId = options.salesforceAccountId ?? null;
    o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
      maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
    );
    o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
    o.planRoomLink = options.planRoomLink ?? null;
    o.isDisaster = options.isDisaster ?? null;
    o.intakeStyleNotes = options.intakeStyleNotes ?? null;
    o.lotType = enumOrDetailOfLotType(options.lotType);
    o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
    o.productType = maybeNewOrNull("ProductType", options.productType, cache);
    o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
    o.salesforcePropertyId = options.salesforcePropertyId ?? null;
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
    o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
      maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
    );
    o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
    o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
    o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
    o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
    o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
      maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
    );
    o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
    o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
    o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
    o.lotPartitionId = options.lotPartitionId ?? null;
    o.budgetFinancials = maybeNew(
      "ProjectBudgetFinancials",
      options.budgetFinancials,
      cache,
      options.hasOwnProperty("budgetFinancials"),
    );
    o.enableDelayFlags = options.enableDelayFlags ?? false;
    o.warrantyStartDate = options.warrantyStartDate ?? null;
    o.verticalCompleteDate = options.verticalCompleteDate ?? null;
    o.jobLogInsights = maybeNew(
      "ProjectJobLogInsights",
      options.jobLogInsights,
      cache,
      options.hasOwnProperty("jobLogInsights"),
    );
    o.targetEndDate = options.targetEndDate ?? null;
    o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
    o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
    o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
      maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
    );
    o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
    o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
    o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
    o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
    o.canEditJobLogs = maybeNew(
      "PotentialOperation2",
      options.canEditJobLogs,
      cache,
      options.hasOwnProperty("canEditJobLogs"),
    );
    o.canEditPrice = maybeNew(
      "PotentialOperation2",
      options.canEditPrice,
      cache,
      options.hasOwnProperty("canEditPrice"),
    );
    o.canHaveBudget = maybeNew(
      "PotentialOperation2",
      options.canHaveBudget,
      cache,
      options.hasOwnProperty("canHaveBudget"),
    );
    o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
      maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
    );
    o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
    o.featureFlags = (options.featureFlags ?? []).map((i) =>
      maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
    );
    o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
    o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
    o.contacts = (options.contacts ?? []).map((i) =>
      maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
    );
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
    o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
    o.customer = maybeNewOrNull("Customer", options.customer, cache);
    o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
    o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
    o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
    o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
    o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
    o.builder = maybeNewOrNull("Builder", options.builder, cache);
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
    o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
    o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
    o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
    o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
    o.legalDescription = options.legalDescription ?? null;
    o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
    o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
    o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
      maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
    );
    o.allocationRules = (options.allocationRules ?? []).map((i) =>
      maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
    );
    o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
    o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
      maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.directCostInCents = options.directCostInCents ?? 0;
    o.directPriceInCents = options.directPriceInCents ?? 0;
    o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
    o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.readyToStartDate = options.readyToStartDate ?? null;
    o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
    o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
    o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
    o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
    o.snapshots = (options.snapshots ?? []).map((i) =>
      maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
    );
    o.warrantyEndDate = options.warrantyEndDate ?? null;
    o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
    o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
    o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
    o.purchaseCostInCents = options.purchaseCostInCents ?? null;
    o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
    o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
      maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
    );
    o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
    );
    o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
    );
    o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
    );
    o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
    );
    o.isSellableProject = options.isSellableProject ?? false;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
    o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
    o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
    o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
      maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
    );
    o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
    o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
    o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
    o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
    );
    o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
    o.client = maybeNewOrNull("Client", options.client, cache);
    o.url = options.url ?? "url";
    o.projectName = options.projectName ?? "projectName";
    o.salesforceId = options.salesforceId ?? null;
    o.activeSalesforceOpportunity = maybeNewOrNull(
      "ProjectSalesforceOpportunity",
      options.activeSalesforceOpportunity,
      cache,
    );
    o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
    return o as FactoryResult<Market>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Market"] = newMarket;

export interface CommunityOptions {
  __typename?: "Community";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Community["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Community["isFollowed"];
  id?: Community["id"];
  productOfferings?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  drops?: Array<FactoryInput<Drop, DropOptions>>;
  costCodesWithDraws?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  salesforceNeighborhoodId?: Community["salesforceNeighborhoodId"];
  pricingTeaser?: Community["pricingTeaser"];
  lotMap?: Community["lotMap"];
  market?: FactoryInput<Market, MarketOptions>;
  parent?: FactoryInput<Market, MarketOptions>;
  children?: Array<FactoryInput<Subdivision, SubdivisionOptions>>;
  collaborators?: Array<FactoryInput<ProjectCollaborator, ProjectCollaboratorOptions>>;
  coverImage?: FactoryInput<Asset, AssetOptions> | null;
  buildAddress?: FactoryInput<Address, AddressOptions> | null;
  teamMembers?: Array<FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>>;
  projectLead?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions> | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  stages?: Array<FactoryInput<ProjectStage, ProjectStageOptions>>;
  stage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  hopUrl?: Community["hopUrl"];
  name?: Community["name"];
  displayName?: Community["displayName"];
  availableAssignees?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  startDate?: Community["startDate"];
  features?: Community["features"];
  isTest?: Community["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Community["latitude"];
  longitude?: Community["longitude"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  googleDriveFolderId?: Community["googleDriveFolderId"];
  salesforceAccountId?: Community["salesforceAccountId"];
  salesforceOpportunities?: Array<FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions>>;
  projectStatusChange?: FactoryInput<ProjectStatusChange, ProjectStatusChangeOptions> | null;
  planRoomLink?: Community["planRoomLink"];
  isDisaster?: Community["isDisaster"];
  intakeStyleNotes?: Community["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: FactoryInput<ProductType, ProductTypeOptions> | null;
  enableSchedulesV2?: Community["enableSchedulesV2"];
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  jobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
  salesforcePropertyId?: Community["salesforcePropertyId"];
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  expenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedExpenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedAmountInCents?: Community["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Community["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Community["enableSchedulesCalendar"];
  readyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions> | null;
  earnedValueCurves?: Array<FactoryInput<EarnedValueCurve, EarnedValueCurveOptions>>;
  enableBidPackagesV2?: Community["enableBidPackagesV2"];
  invoiceSettings?: FactoryInput<ProjectInvoiceSetting, ProjectInvoiceSettingOptions> | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Community["lotPartitionId"];
  budgetFinancials?: FactoryInput<ProjectBudgetFinancials, ProjectBudgetFinancialsOptions>;
  enableDelayFlags?: Community["enableDelayFlags"];
  warrantyStartDate?: Community["warrantyStartDate"];
  verticalCompleteDate?: Community["verticalCompleteDate"];
  jobLogInsights?: FactoryInput<ProjectJobLogInsights, ProjectJobLogInsightsOptions>;
  targetEndDate?: Community["targetEndDate"];
  latestActiveStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  primaryHomeowner?: FactoryInput<Client, ClientOptions> | null;
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>> | null;
  lotDetail?: FactoryInput<ProjectLotDetail, ProjectLotDetailOptions>;
  siteSpecificInfos?: Array<FactoryInput<ProjectSiteSpecificInfo, ProjectSiteSpecificInfoOptions>>;
  projectSiteCondition?: FactoryInput<ProjectSiteCondition, ProjectSiteConditionOptions> | null;
  unassignedTaskCount?: Community["unassignedTaskCount"];
  enableHomeownerNotes?: Community["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Community["checkoutCustomerConfigId"];
  canEditJobLogs?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditPrice?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveBudget?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  homeownerNotes?: Array<FactoryInput<HomeownerNote, HomeownerNoteOptions>>;
  enableHomeownerJourneyV2?: Community["enableHomeownerJourneyV2"];
  featureFlags?: Array<FactoryInput<FeatureFlag, FeatureFlagOptions>>;
  homeownerDeliveryDate?: Community["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Community["tasksCompletedThisWeek"];
  contacts?: Array<FactoryInput<ProjectContact, ProjectContactOptions>>;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  shouldAccrueAsComplete?: Community["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Community["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Community["indirectCostMarkupOverrideBasisPoints"];
  customer?: FactoryInput<Customer, CustomerOptions> | null;
  customerOwnerEntity?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions> | null;
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions> | null;
  allowExcludedCostCodesOnPurchaseOrders?: Community["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Community["enableProductConfigPlan"];
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions> | null;
  builder?: FactoryInput<Builder, BuilderOptions> | null;
  bidOutPercentage?: Community["bidOutPercentage"];
  enableChangeEventSignatures?: Community["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Community["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Community["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Community["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Community["directHardCostMarkupInBasisPoints"];
  legalDescription?: Community["legalDescription"];
  salesTaxOverrideInBasisPoints?: Community["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Community["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>>;
  allocationRules?: Array<FactoryInput<ProjectAllocationRule, ProjectAllocationRuleOptions>>;
  warrantyLengthInDays?: Community["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Community["warrantyOverrideLengthInDays"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  homeownerContracts?: Array<FactoryInput<HomeownerContract, HomeownerContractOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  directCostInCents?: Community["directCostInCents"];
  directPriceInCents?: Community["directPriceInCents"];
  totalHardCostInCents?: Community["totalHardCostInCents"];
  totalSoftCostInCents?: Community["totalSoftCostInCents"];
  totalCostInCents?: Community["totalCostInCents"];
  totalPriceInCents?: Community["totalPriceInCents"];
  readyToStartDate?: Community["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Community["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Community["directCostAtStartInCents"];
  directCostVarianceInCents?: Community["directCostVarianceInCents"];
  uncommittedCostInCents?: Community["uncommittedCostInCents"];
  snapshots?: Array<FactoryInput<ProjectSnapshot, ProjectSnapshotOptions>>;
  warrantyEndDate?: Community["warrantyEndDate"];
  companyInfo?: FactoryInput<CompanyInfo, CompanyInfoOptions>;
  invoicePaymentNetDays?: Community["invoicePaymentNetDays"];
  snapshotAsOf?: FactoryInput<ProjectSnapshot, ProjectSnapshotOptions> | null;
  purchaseCostInCents?: Community["purchaseCostInCents"];
  grossSalesPriceInCents?: Community["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Community["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Community["directMarginInBasisPoints"];
  projectCostCodes?: Array<FactoryInput<ProjectCostCode, ProjectCostCodeOptions>>;
  showInCheckout?: Community["showInCheckout"];
  parentsRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  childrenRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  siblingProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  sellableProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  isSellableProject?: Community["isSellableProject"];
  originalCostInCents?: Community["originalCostInCents"];
  startCostInCents?: Community["startCostInCents"];
  changeEventCostInCents?: Community["changeEventCostInCents"];
  projectedCostInCents?: Community["projectedCostInCents"];
  revisedCostInCents?: Community["revisedCostInCents"];
  committedCostInCents?: Community["committedCostInCents"];
  availableCostInCents?: Community["availableCostInCents"];
  billedCostInCents?: Community["billedCostInCents"];
  unbilledCostInCents?: Community["unbilledCostInCents"];
  cohort?: FactoryInput<Cohort, CohortOptions> | null;
  constructionConfidenceFactor?: Community["constructionConfidenceFactor"];
  lotRating?: FactoryInput<LotRating, LotRatingOptions> | null;
  preConBudgetLineItems?: Array<
    FactoryInput<PreConBudgetCostDivisionLineItem, PreConBudgetCostDivisionLineItemOptions>
  >;
  preconContractType?: FactoryInput<PreconContractType, PreconContractTypeOptions> | null;
  primaryProject?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  quickbooksCustomerId?: Community["quickbooksCustomerId"];
  shadowProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  submarket?: FactoryInput<Submarket, SubmarketOptions> | null;
  client?: FactoryInput<Client, ClientOptions> | null;
  url?: Community["url"];
  projectName?: Community["projectName"];
  salesforceId?: Community["salesforceId"];
  activeSalesforceOpportunity?: FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions> | null;
  dictionary?: FactoryInput<ProjectDictionary, ProjectDictionaryOptions>;
  packageComparison?: FactoryInput<Asset, AssetOptions> | null;
  globalPlanStageVariants?: Array<FactoryInput<GlobalPlanStageVariant, GlobalPlanStageVariantOptions>>;
  biddingStartedAt?: Community["biddingStartedAt"];
  biddingCompletedAt?: Community["biddingCompletedAt"];
  budgetCertifiedAt?: Community["budgetCertifiedAt"];
  costCodeBidSummaryReport?: FactoryInput<ProjectCostCodeBidSummaryReport, ProjectCostCodeBidSummaryReportOptions>;
}

export function newCommunity(options?: CommunityOptions, factoryOptions?: FactoryOptions): FactoryResult<Community>;
export function newCommunity(
  options: CommunityOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Community> {
  const o = (options.__typename ? options : cache["Community"] = {}) as Community;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Community";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Community");
    o.productOfferings = (options.productOfferings ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
    );
    o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
    o.costCodesWithDraws = (options.costCodesWithDraws ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodesWithDraws"))
    );
    o.salesforceNeighborhoodId = options.salesforceNeighborhoodId ?? null;
    o.pricingTeaser = options.pricingTeaser ?? null;
    o.lotMap = options.lotMap ?? null;
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.parent = maybeNew("Market", options.parent, cache, options.hasOwnProperty("parent"));
    o.children = (options.children ?? []).map((i) =>
      maybeNew("Subdivision", i, cache, options.hasOwnProperty("children"))
    );
    o.collaborators = (options.collaborators ?? []).map((i) =>
      maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
    );
    o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
    o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
    o.teamMembers = (options.teamMembers ?? []).map((i) =>
      maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
    );
    o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
    o.activeStage = enumOrDetailOfStage(options.activeStage);
    o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
    o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
    o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.hopUrl = options.hopUrl ?? "hopUrl";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
    );
    o.startDate = options.startDate ?? newDate();
    o.features = options.features ?? [];
    o.isTest = options.isTest ?? false;
    o.status = enumOrDetailOfProjectStatus(options.status);
    o.latitude = options.latitude ?? null;
    o.longitude = options.longitude ?? null;
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.googleDriveFolderId = options.googleDriveFolderId ?? null;
    o.salesforceAccountId = options.salesforceAccountId ?? null;
    o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
      maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
    );
    o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
    o.planRoomLink = options.planRoomLink ?? null;
    o.isDisaster = options.isDisaster ?? null;
    o.intakeStyleNotes = options.intakeStyleNotes ?? null;
    o.lotType = enumOrDetailOfLotType(options.lotType);
    o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
    o.productType = maybeNewOrNull("ProductType", options.productType, cache);
    o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
    o.salesforcePropertyId = options.salesforcePropertyId ?? null;
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
    o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
      maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
    );
    o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
    o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
    o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
    o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
    o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
      maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
    );
    o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
    o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
    o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
    o.lotPartitionId = options.lotPartitionId ?? null;
    o.budgetFinancials = maybeNew(
      "ProjectBudgetFinancials",
      options.budgetFinancials,
      cache,
      options.hasOwnProperty("budgetFinancials"),
    );
    o.enableDelayFlags = options.enableDelayFlags ?? false;
    o.warrantyStartDate = options.warrantyStartDate ?? null;
    o.verticalCompleteDate = options.verticalCompleteDate ?? null;
    o.jobLogInsights = maybeNew(
      "ProjectJobLogInsights",
      options.jobLogInsights,
      cache,
      options.hasOwnProperty("jobLogInsights"),
    );
    o.targetEndDate = options.targetEndDate ?? null;
    o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
    o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
    o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
      maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
    );
    o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
    o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
    o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
    o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
    o.canEditJobLogs = maybeNew(
      "PotentialOperation2",
      options.canEditJobLogs,
      cache,
      options.hasOwnProperty("canEditJobLogs"),
    );
    o.canEditPrice = maybeNew(
      "PotentialOperation2",
      options.canEditPrice,
      cache,
      options.hasOwnProperty("canEditPrice"),
    );
    o.canHaveBudget = maybeNew(
      "PotentialOperation2",
      options.canHaveBudget,
      cache,
      options.hasOwnProperty("canHaveBudget"),
    );
    o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
      maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
    );
    o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
    o.featureFlags = (options.featureFlags ?? []).map((i) =>
      maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
    );
    o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
    o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
    o.contacts = (options.contacts ?? []).map((i) =>
      maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
    );
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
    o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
    o.customer = maybeNewOrNull("Customer", options.customer, cache);
    o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
    o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
    o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
    o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
    o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
    o.builder = maybeNewOrNull("Builder", options.builder, cache);
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
    o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
    o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
    o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
    o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
    o.legalDescription = options.legalDescription ?? null;
    o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
    o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
    o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
      maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
    );
    o.allocationRules = (options.allocationRules ?? []).map((i) =>
      maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
    );
    o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
    o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
      maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.directCostInCents = options.directCostInCents ?? 0;
    o.directPriceInCents = options.directPriceInCents ?? 0;
    o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
    o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.readyToStartDate = options.readyToStartDate ?? null;
    o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
    o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
    o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
    o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
    o.snapshots = (options.snapshots ?? []).map((i) =>
      maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
    );
    o.warrantyEndDate = options.warrantyEndDate ?? null;
    o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
    o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
    o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
    o.purchaseCostInCents = options.purchaseCostInCents ?? null;
    o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
    o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
      maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
    );
    o.showInCheckout = options.showInCheckout ?? false;
    o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
    );
    o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
    );
    o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
    );
    o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
    );
    o.isSellableProject = options.isSellableProject ?? false;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
    o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
    o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
    o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
      maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
    );
    o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
    o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
    o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
    o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
    );
    o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
    o.client = maybeNewOrNull("Client", options.client, cache);
    o.url = options.url ?? "url";
    o.projectName = options.projectName ?? "projectName";
    o.salesforceId = options.salesforceId ?? null;
    o.activeSalesforceOpportunity = maybeNewOrNull(
      "ProjectSalesforceOpportunity",
      options.activeSalesforceOpportunity,
      cache,
    );
    o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
    o.packageComparison = maybeNewOrNull("Asset", options.packageComparison, cache);
    o.globalPlanStageVariants = (options.globalPlanStageVariants ?? []).map((i) =>
      maybeNew("GlobalPlanStageVariant", i, cache, options.hasOwnProperty("globalPlanStageVariants"))
    );
    o.biddingStartedAt = options.biddingStartedAt ?? null;
    o.biddingCompletedAt = options.biddingCompletedAt ?? null;
    o.budgetCertifiedAt = options.budgetCertifiedAt ?? null;
    o.costCodeBidSummaryReport = maybeNew(
      "ProjectCostCodeBidSummaryReport",
      options.costCodeBidSummaryReport,
      cache,
      options.hasOwnProperty("costCodeBidSummaryReport"),
    );
    return o as FactoryResult<Community>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Community"] = newCommunity;

export interface SubdivisionOptions {
  __typename?: "Subdivision";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Subdivision["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Subdivision["isFollowed"];
  id?: Subdivision["id"];
  salesforceBusinessDevelopmentOpportunityId?: Subdivision["salesforceBusinessDevelopmentOpportunityId"];
  salesforceTakedownId?: Subdivision["salesforceTakedownId"];
  market?: FactoryInput<Market, MarketOptions>;
  parent?: FactoryInput<Community, CommunityOptions>;
  children?: Array<FactoryInput<Lot, LotOptions>>;
  collaborators?: Array<FactoryInput<ProjectCollaborator, ProjectCollaboratorOptions>>;
  coverImage?: FactoryInput<Asset, AssetOptions> | null;
  buildAddress?: FactoryInput<Address, AddressOptions> | null;
  teamMembers?: Array<FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>>;
  projectLead?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions> | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  stages?: Array<FactoryInput<ProjectStage, ProjectStageOptions>>;
  stage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  hopUrl?: Subdivision["hopUrl"];
  name?: Subdivision["name"];
  displayName?: Subdivision["displayName"];
  availableAssignees?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  startDate?: Subdivision["startDate"];
  features?: Subdivision["features"];
  isTest?: Subdivision["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Subdivision["latitude"];
  longitude?: Subdivision["longitude"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  googleDriveFolderId?: Subdivision["googleDriveFolderId"];
  salesforceAccountId?: Subdivision["salesforceAccountId"];
  salesforceOpportunities?: Array<FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions>>;
  projectStatusChange?: FactoryInput<ProjectStatusChange, ProjectStatusChangeOptions> | null;
  planRoomLink?: Subdivision["planRoomLink"];
  isDisaster?: Subdivision["isDisaster"];
  intakeStyleNotes?: Subdivision["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: FactoryInput<ProductType, ProductTypeOptions> | null;
  enableSchedulesV2?: Subdivision["enableSchedulesV2"];
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  jobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
  salesforcePropertyId?: Subdivision["salesforcePropertyId"];
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  expenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedExpenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedAmountInCents?: Subdivision["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Subdivision["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Subdivision["enableSchedulesCalendar"];
  readyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions> | null;
  earnedValueCurves?: Array<FactoryInput<EarnedValueCurve, EarnedValueCurveOptions>>;
  enableBidPackagesV2?: Subdivision["enableBidPackagesV2"];
  invoiceSettings?: FactoryInput<ProjectInvoiceSetting, ProjectInvoiceSettingOptions> | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Subdivision["lotPartitionId"];
  budgetFinancials?: FactoryInput<ProjectBudgetFinancials, ProjectBudgetFinancialsOptions>;
  enableDelayFlags?: Subdivision["enableDelayFlags"];
  warrantyStartDate?: Subdivision["warrantyStartDate"];
  verticalCompleteDate?: Subdivision["verticalCompleteDate"];
  jobLogInsights?: FactoryInput<ProjectJobLogInsights, ProjectJobLogInsightsOptions>;
  targetEndDate?: Subdivision["targetEndDate"];
  latestActiveStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  primaryHomeowner?: FactoryInput<Client, ClientOptions> | null;
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>> | null;
  lotDetail?: FactoryInput<ProjectLotDetail, ProjectLotDetailOptions>;
  siteSpecificInfos?: Array<FactoryInput<ProjectSiteSpecificInfo, ProjectSiteSpecificInfoOptions>>;
  projectSiteCondition?: FactoryInput<ProjectSiteCondition, ProjectSiteConditionOptions> | null;
  unassignedTaskCount?: Subdivision["unassignedTaskCount"];
  enableHomeownerNotes?: Subdivision["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Subdivision["checkoutCustomerConfigId"];
  canEditJobLogs?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditPrice?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveBudget?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  homeownerNotes?: Array<FactoryInput<HomeownerNote, HomeownerNoteOptions>>;
  enableHomeownerJourneyV2?: Subdivision["enableHomeownerJourneyV2"];
  featureFlags?: Array<FactoryInput<FeatureFlag, FeatureFlagOptions>>;
  homeownerDeliveryDate?: Subdivision["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Subdivision["tasksCompletedThisWeek"];
  contacts?: Array<FactoryInput<ProjectContact, ProjectContactOptions>>;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  shouldAccrueAsComplete?: Subdivision["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Subdivision["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Subdivision["indirectCostMarkupOverrideBasisPoints"];
  customer?: FactoryInput<Customer, CustomerOptions> | null;
  customerOwnerEntity?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions> | null;
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions> | null;
  allowExcludedCostCodesOnPurchaseOrders?: Subdivision["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Subdivision["enableProductConfigPlan"];
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions> | null;
  builder?: FactoryInput<Builder, BuilderOptions> | null;
  bidOutPercentage?: Subdivision["bidOutPercentage"];
  enableChangeEventSignatures?: Subdivision["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Subdivision["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Subdivision["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Subdivision["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Subdivision["directHardCostMarkupInBasisPoints"];
  legalDescription?: Subdivision["legalDescription"];
  salesTaxOverrideInBasisPoints?: Subdivision["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Subdivision["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>>;
  allocationRules?: Array<FactoryInput<ProjectAllocationRule, ProjectAllocationRuleOptions>>;
  warrantyLengthInDays?: Subdivision["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Subdivision["warrantyOverrideLengthInDays"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  homeownerContracts?: Array<FactoryInput<HomeownerContract, HomeownerContractOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  directCostInCents?: Subdivision["directCostInCents"];
  directPriceInCents?: Subdivision["directPriceInCents"];
  totalHardCostInCents?: Subdivision["totalHardCostInCents"];
  totalSoftCostInCents?: Subdivision["totalSoftCostInCents"];
  totalCostInCents?: Subdivision["totalCostInCents"];
  totalPriceInCents?: Subdivision["totalPriceInCents"];
  readyToStartDate?: Subdivision["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Subdivision["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Subdivision["directCostAtStartInCents"];
  directCostVarianceInCents?: Subdivision["directCostVarianceInCents"];
  uncommittedCostInCents?: Subdivision["uncommittedCostInCents"];
  snapshots?: Array<FactoryInput<ProjectSnapshot, ProjectSnapshotOptions>>;
  warrantyEndDate?: Subdivision["warrantyEndDate"];
  companyInfo?: FactoryInput<CompanyInfo, CompanyInfoOptions>;
  invoicePaymentNetDays?: Subdivision["invoicePaymentNetDays"];
  snapshotAsOf?: FactoryInput<ProjectSnapshot, ProjectSnapshotOptions> | null;
  purchaseCostInCents?: Subdivision["purchaseCostInCents"];
  grossSalesPriceInCents?: Subdivision["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Subdivision["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Subdivision["directMarginInBasisPoints"];
  projectCostCodes?: Array<FactoryInput<ProjectCostCode, ProjectCostCodeOptions>>;
  parentsRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  childrenRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  siblingProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  sellableProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  isSellableProject?: Subdivision["isSellableProject"];
  originalCostInCents?: Subdivision["originalCostInCents"];
  startCostInCents?: Subdivision["startCostInCents"];
  changeEventCostInCents?: Subdivision["changeEventCostInCents"];
  projectedCostInCents?: Subdivision["projectedCostInCents"];
  revisedCostInCents?: Subdivision["revisedCostInCents"];
  committedCostInCents?: Subdivision["committedCostInCents"];
  availableCostInCents?: Subdivision["availableCostInCents"];
  billedCostInCents?: Subdivision["billedCostInCents"];
  unbilledCostInCents?: Subdivision["unbilledCostInCents"];
  cohort?: FactoryInput<Cohort, CohortOptions> | null;
  constructionConfidenceFactor?: Subdivision["constructionConfidenceFactor"];
  lotRating?: FactoryInput<LotRating, LotRatingOptions> | null;
  preConBudgetLineItems?: Array<
    FactoryInput<PreConBudgetCostDivisionLineItem, PreConBudgetCostDivisionLineItemOptions>
  >;
  preconContractType?: FactoryInput<PreconContractType, PreconContractTypeOptions> | null;
  primaryProject?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  quickbooksCustomerId?: Subdivision["quickbooksCustomerId"];
  shadowProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  submarket?: FactoryInput<Submarket, SubmarketOptions> | null;
  client?: FactoryInput<Client, ClientOptions> | null;
  url?: Subdivision["url"];
  projectName?: Subdivision["projectName"];
  salesforceId?: Subdivision["salesforceId"];
  activeSalesforceOpportunity?: FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions> | null;
  dictionary?: FactoryInput<ProjectDictionary, ProjectDictionaryOptions>;
}

export function newSubdivision(
  options?: SubdivisionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newSubdivision(
  options: SubdivisionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Subdivision> {
  const o = (options.__typename ? options : cache["Subdivision"] = {}) as Subdivision;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Subdivision";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Subdivision");
    o.salesforceBusinessDevelopmentOpportunityId = options.salesforceBusinessDevelopmentOpportunityId ?? null;
    o.salesforceTakedownId = options.salesforceTakedownId ?? null;
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.parent = maybeNew("Community", options.parent, cache, options.hasOwnProperty("parent"));
    o.children = (options.children ?? []).map((i) => maybeNew("Lot", i, cache, options.hasOwnProperty("children")));
    o.collaborators = (options.collaborators ?? []).map((i) =>
      maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
    );
    o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
    o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
    o.teamMembers = (options.teamMembers ?? []).map((i) =>
      maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
    );
    o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
    o.activeStage = enumOrDetailOfStage(options.activeStage);
    o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
    o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
    o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.hopUrl = options.hopUrl ?? "hopUrl";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
    );
    o.startDate = options.startDate ?? newDate();
    o.features = options.features ?? [];
    o.isTest = options.isTest ?? false;
    o.status = enumOrDetailOfProjectStatus(options.status);
    o.latitude = options.latitude ?? null;
    o.longitude = options.longitude ?? null;
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.googleDriveFolderId = options.googleDriveFolderId ?? null;
    o.salesforceAccountId = options.salesforceAccountId ?? null;
    o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
      maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
    );
    o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
    o.planRoomLink = options.planRoomLink ?? null;
    o.isDisaster = options.isDisaster ?? null;
    o.intakeStyleNotes = options.intakeStyleNotes ?? null;
    o.lotType = enumOrDetailOfLotType(options.lotType);
    o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
    o.productType = maybeNewOrNull("ProductType", options.productType, cache);
    o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
    o.salesforcePropertyId = options.salesforcePropertyId ?? null;
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
    o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
      maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
    );
    o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
    o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
    o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
    o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
    o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
      maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
    );
    o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
    o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
    o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
    o.lotPartitionId = options.lotPartitionId ?? null;
    o.budgetFinancials = maybeNew(
      "ProjectBudgetFinancials",
      options.budgetFinancials,
      cache,
      options.hasOwnProperty("budgetFinancials"),
    );
    o.enableDelayFlags = options.enableDelayFlags ?? false;
    o.warrantyStartDate = options.warrantyStartDate ?? null;
    o.verticalCompleteDate = options.verticalCompleteDate ?? null;
    o.jobLogInsights = maybeNew(
      "ProjectJobLogInsights",
      options.jobLogInsights,
      cache,
      options.hasOwnProperty("jobLogInsights"),
    );
    o.targetEndDate = options.targetEndDate ?? null;
    o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
    o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
    o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
      maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
    );
    o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
    o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
    o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
    o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
    o.canEditJobLogs = maybeNew(
      "PotentialOperation2",
      options.canEditJobLogs,
      cache,
      options.hasOwnProperty("canEditJobLogs"),
    );
    o.canEditPrice = maybeNew(
      "PotentialOperation2",
      options.canEditPrice,
      cache,
      options.hasOwnProperty("canEditPrice"),
    );
    o.canHaveBudget = maybeNew(
      "PotentialOperation2",
      options.canHaveBudget,
      cache,
      options.hasOwnProperty("canHaveBudget"),
    );
    o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
      maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
    );
    o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
    o.featureFlags = (options.featureFlags ?? []).map((i) =>
      maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
    );
    o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
    o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
    o.contacts = (options.contacts ?? []).map((i) =>
      maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
    );
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
    o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
    o.customer = maybeNewOrNull("Customer", options.customer, cache);
    o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
    o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
    o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
    o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
    o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
    o.builder = maybeNewOrNull("Builder", options.builder, cache);
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
    o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
    o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
    o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
    o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
    o.legalDescription = options.legalDescription ?? null;
    o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
    o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
    o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
      maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
    );
    o.allocationRules = (options.allocationRules ?? []).map((i) =>
      maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
    );
    o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
    o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
      maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.directCostInCents = options.directCostInCents ?? 0;
    o.directPriceInCents = options.directPriceInCents ?? 0;
    o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
    o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.readyToStartDate = options.readyToStartDate ?? null;
    o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
    o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
    o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
    o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
    o.snapshots = (options.snapshots ?? []).map((i) =>
      maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
    );
    o.warrantyEndDate = options.warrantyEndDate ?? null;
    o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
    o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
    o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
    o.purchaseCostInCents = options.purchaseCostInCents ?? null;
    o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
    o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
      maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
    );
    o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
    );
    o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
    );
    o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
    );
    o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
    );
    o.isSellableProject = options.isSellableProject ?? false;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
    o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
    o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
    o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
      maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
    );
    o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
    o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
    o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
    o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
    );
    o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
    o.client = maybeNewOrNull("Client", options.client, cache);
    o.url = options.url ?? "url";
    o.projectName = options.projectName ?? "projectName";
    o.salesforceId = options.salesforceId ?? null;
    o.activeSalesforceOpportunity = maybeNewOrNull(
      "ProjectSalesforceOpportunity",
      options.activeSalesforceOpportunity,
      cache,
    );
    o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
    return o as FactoryResult<Subdivision>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Subdivision"] = newSubdivision;

export interface LotOptions {
  __typename?: "Lot";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Lot["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Lot["isFollowed"];
  id?: Lot["id"];
  buildablePlans?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  buildableSfhPlans?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  buildAddress?: FactoryInput<Address, AddressOptions>;
  market?: FactoryInput<Market, MarketOptions>;
  parent?: FactoryInput<Subdivision, SubdivisionOptions>;
  children?: Array<FactoryInput<Structure, StructureOptions>>;
  collaborators?: Array<FactoryInput<ProjectCollaborator, ProjectCollaboratorOptions>>;
  coverImage?: FactoryInput<Asset, AssetOptions> | null;
  teamMembers?: Array<FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>>;
  projectLead?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions> | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  stages?: Array<FactoryInput<ProjectStage, ProjectStageOptions>>;
  stage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  hopUrl?: Lot["hopUrl"];
  name?: Lot["name"];
  displayName?: Lot["displayName"];
  availableAssignees?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  startDate?: Lot["startDate"];
  features?: Lot["features"];
  isTest?: Lot["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Lot["latitude"];
  longitude?: Lot["longitude"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  googleDriveFolderId?: Lot["googleDriveFolderId"];
  salesforceAccountId?: Lot["salesforceAccountId"];
  salesforceOpportunities?: Array<FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions>>;
  projectStatusChange?: FactoryInput<ProjectStatusChange, ProjectStatusChangeOptions> | null;
  planRoomLink?: Lot["planRoomLink"];
  isDisaster?: Lot["isDisaster"];
  intakeStyleNotes?: Lot["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: FactoryInput<ProductType, ProductTypeOptions> | null;
  enableSchedulesV2?: Lot["enableSchedulesV2"];
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  jobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
  salesforcePropertyId?: Lot["salesforcePropertyId"];
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  expenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedExpenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedAmountInCents?: Lot["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Lot["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Lot["enableSchedulesCalendar"];
  readyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions> | null;
  earnedValueCurves?: Array<FactoryInput<EarnedValueCurve, EarnedValueCurveOptions>>;
  enableBidPackagesV2?: Lot["enableBidPackagesV2"];
  invoiceSettings?: FactoryInput<ProjectInvoiceSetting, ProjectInvoiceSettingOptions> | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Lot["lotPartitionId"];
  budgetFinancials?: FactoryInput<ProjectBudgetFinancials, ProjectBudgetFinancialsOptions>;
  enableDelayFlags?: Lot["enableDelayFlags"];
  warrantyStartDate?: Lot["warrantyStartDate"];
  verticalCompleteDate?: Lot["verticalCompleteDate"];
  jobLogInsights?: FactoryInput<ProjectJobLogInsights, ProjectJobLogInsightsOptions>;
  targetEndDate?: Lot["targetEndDate"];
  latestActiveStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  primaryHomeowner?: FactoryInput<Client, ClientOptions> | null;
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>> | null;
  lotDetail?: FactoryInput<ProjectLotDetail, ProjectLotDetailOptions>;
  siteSpecificInfos?: Array<FactoryInput<ProjectSiteSpecificInfo, ProjectSiteSpecificInfoOptions>>;
  projectSiteCondition?: FactoryInput<ProjectSiteCondition, ProjectSiteConditionOptions> | null;
  unassignedTaskCount?: Lot["unassignedTaskCount"];
  enableHomeownerNotes?: Lot["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Lot["checkoutCustomerConfigId"];
  canEditJobLogs?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditPrice?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveBudget?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  homeownerNotes?: Array<FactoryInput<HomeownerNote, HomeownerNoteOptions>>;
  enableHomeownerJourneyV2?: Lot["enableHomeownerJourneyV2"];
  featureFlags?: Array<FactoryInput<FeatureFlag, FeatureFlagOptions>>;
  homeownerDeliveryDate?: Lot["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Lot["tasksCompletedThisWeek"];
  contacts?: Array<FactoryInput<ProjectContact, ProjectContactOptions>>;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  shouldAccrueAsComplete?: Lot["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Lot["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Lot["indirectCostMarkupOverrideBasisPoints"];
  customer?: FactoryInput<Customer, CustomerOptions> | null;
  customerOwnerEntity?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions> | null;
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions> | null;
  allowExcludedCostCodesOnPurchaseOrders?: Lot["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Lot["enableProductConfigPlan"];
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions> | null;
  builder?: FactoryInput<Builder, BuilderOptions> | null;
  bidOutPercentage?: Lot["bidOutPercentage"];
  enableChangeEventSignatures?: Lot["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Lot["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Lot["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Lot["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Lot["directHardCostMarkupInBasisPoints"];
  legalDescription?: Lot["legalDescription"];
  salesTaxOverrideInBasisPoints?: Lot["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Lot["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>>;
  allocationRules?: Array<FactoryInput<ProjectAllocationRule, ProjectAllocationRuleOptions>>;
  warrantyLengthInDays?: Lot["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Lot["warrantyOverrideLengthInDays"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  homeownerContracts?: Array<FactoryInput<HomeownerContract, HomeownerContractOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  directCostInCents?: Lot["directCostInCents"];
  directPriceInCents?: Lot["directPriceInCents"];
  totalHardCostInCents?: Lot["totalHardCostInCents"];
  totalSoftCostInCents?: Lot["totalSoftCostInCents"];
  totalCostInCents?: Lot["totalCostInCents"];
  totalPriceInCents?: Lot["totalPriceInCents"];
  readyToStartDate?: Lot["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Lot["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Lot["directCostAtStartInCents"];
  directCostVarianceInCents?: Lot["directCostVarianceInCents"];
  uncommittedCostInCents?: Lot["uncommittedCostInCents"];
  snapshots?: Array<FactoryInput<ProjectSnapshot, ProjectSnapshotOptions>>;
  warrantyEndDate?: Lot["warrantyEndDate"];
  companyInfo?: FactoryInput<CompanyInfo, CompanyInfoOptions>;
  invoicePaymentNetDays?: Lot["invoicePaymentNetDays"];
  snapshotAsOf?: FactoryInput<ProjectSnapshot, ProjectSnapshotOptions> | null;
  purchaseCostInCents?: Lot["purchaseCostInCents"];
  grossSalesPriceInCents?: Lot["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Lot["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Lot["directMarginInBasisPoints"];
  projectCostCodes?: Array<FactoryInput<ProjectCostCode, ProjectCostCodeOptions>>;
  parentsRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  childrenRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  siblingProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  sellableProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  isSellableProject?: Lot["isSellableProject"];
  originalCostInCents?: Lot["originalCostInCents"];
  startCostInCents?: Lot["startCostInCents"];
  changeEventCostInCents?: Lot["changeEventCostInCents"];
  projectedCostInCents?: Lot["projectedCostInCents"];
  revisedCostInCents?: Lot["revisedCostInCents"];
  committedCostInCents?: Lot["committedCostInCents"];
  availableCostInCents?: Lot["availableCostInCents"];
  billedCostInCents?: Lot["billedCostInCents"];
  unbilledCostInCents?: Lot["unbilledCostInCents"];
  cohort?: FactoryInput<Cohort, CohortOptions> | null;
  constructionConfidenceFactor?: Lot["constructionConfidenceFactor"];
  lotRating?: FactoryInput<LotRating, LotRatingOptions> | null;
  preConBudgetLineItems?: Array<
    FactoryInput<PreConBudgetCostDivisionLineItem, PreConBudgetCostDivisionLineItemOptions>
  >;
  preconContractType?: FactoryInput<PreconContractType, PreconContractTypeOptions> | null;
  primaryProject?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  quickbooksCustomerId?: Lot["quickbooksCustomerId"];
  shadowProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  submarket?: FactoryInput<Submarket, SubmarketOptions> | null;
  client?: FactoryInput<Client, ClientOptions> | null;
  url?: Lot["url"];
  projectName?: Lot["projectName"];
  salesforceId?: Lot["salesforceId"];
  activeSalesforceOpportunity?: FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions> | null;
  dictionary?: FactoryInput<ProjectDictionary, ProjectDictionaryOptions>;
  landPriceInCents?: Lot["landPriceInCents"];
}

export function newLot(options?: LotOptions, factoryOptions?: FactoryOptions): FactoryResult<Lot>;
export function newLot(
  options: LotOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Lot> {
  const o = (options.__typename ? options : cache["Lot"] = {}) as Lot;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Lot";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Lot");
    o.buildablePlans = (options.buildablePlans ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildablePlans"))
    );
    o.buildableSfhPlans = (options.buildableSfhPlans ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildableSfhPlans"))
    );
    o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.parent = maybeNew("Subdivision", options.parent, cache, options.hasOwnProperty("parent"));
    o.children = (options.children ?? []).map((i) =>
      maybeNew("Structure", i, cache, options.hasOwnProperty("children"))
    );
    o.collaborators = (options.collaborators ?? []).map((i) =>
      maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
    );
    o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
    o.teamMembers = (options.teamMembers ?? []).map((i) =>
      maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
    );
    o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
    o.activeStage = enumOrDetailOfStage(options.activeStage);
    o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
    o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
    o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.hopUrl = options.hopUrl ?? "hopUrl";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
    );
    o.startDate = options.startDate ?? newDate();
    o.features = options.features ?? [];
    o.isTest = options.isTest ?? false;
    o.status = enumOrDetailOfProjectStatus(options.status);
    o.latitude = options.latitude ?? null;
    o.longitude = options.longitude ?? null;
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.googleDriveFolderId = options.googleDriveFolderId ?? null;
    o.salesforceAccountId = options.salesforceAccountId ?? null;
    o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
      maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
    );
    o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
    o.planRoomLink = options.planRoomLink ?? null;
    o.isDisaster = options.isDisaster ?? null;
    o.intakeStyleNotes = options.intakeStyleNotes ?? null;
    o.lotType = enumOrDetailOfLotType(options.lotType);
    o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
    o.productType = maybeNewOrNull("ProductType", options.productType, cache);
    o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
    o.salesforcePropertyId = options.salesforcePropertyId ?? null;
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
    o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
      maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
    );
    o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
    o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
    o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
    o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
    o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
      maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
    );
    o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
    o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
    o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
    o.lotPartitionId = options.lotPartitionId ?? null;
    o.budgetFinancials = maybeNew(
      "ProjectBudgetFinancials",
      options.budgetFinancials,
      cache,
      options.hasOwnProperty("budgetFinancials"),
    );
    o.enableDelayFlags = options.enableDelayFlags ?? false;
    o.warrantyStartDate = options.warrantyStartDate ?? null;
    o.verticalCompleteDate = options.verticalCompleteDate ?? null;
    o.jobLogInsights = maybeNew(
      "ProjectJobLogInsights",
      options.jobLogInsights,
      cache,
      options.hasOwnProperty("jobLogInsights"),
    );
    o.targetEndDate = options.targetEndDate ?? null;
    o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
    o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
    o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
      maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
    );
    o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
    o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
    o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
    o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
    o.canEditJobLogs = maybeNew(
      "PotentialOperation2",
      options.canEditJobLogs,
      cache,
      options.hasOwnProperty("canEditJobLogs"),
    );
    o.canEditPrice = maybeNew(
      "PotentialOperation2",
      options.canEditPrice,
      cache,
      options.hasOwnProperty("canEditPrice"),
    );
    o.canHaveBudget = maybeNew(
      "PotentialOperation2",
      options.canHaveBudget,
      cache,
      options.hasOwnProperty("canHaveBudget"),
    );
    o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
      maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
    );
    o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
    o.featureFlags = (options.featureFlags ?? []).map((i) =>
      maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
    );
    o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
    o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
    o.contacts = (options.contacts ?? []).map((i) =>
      maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
    );
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
    o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
    o.customer = maybeNewOrNull("Customer", options.customer, cache);
    o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
    o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
    o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
    o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
    o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
    o.builder = maybeNewOrNull("Builder", options.builder, cache);
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
    o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
    o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
    o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
    o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
    o.legalDescription = options.legalDescription ?? null;
    o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
    o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
    o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
      maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
    );
    o.allocationRules = (options.allocationRules ?? []).map((i) =>
      maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
    );
    o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
    o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
      maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.directCostInCents = options.directCostInCents ?? 0;
    o.directPriceInCents = options.directPriceInCents ?? 0;
    o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
    o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.readyToStartDate = options.readyToStartDate ?? null;
    o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
    o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
    o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
    o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
    o.snapshots = (options.snapshots ?? []).map((i) =>
      maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
    );
    o.warrantyEndDate = options.warrantyEndDate ?? null;
    o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
    o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
    o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
    o.purchaseCostInCents = options.purchaseCostInCents ?? null;
    o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
    o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
      maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
    );
    o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
    );
    o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
    );
    o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
    );
    o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
    );
    o.isSellableProject = options.isSellableProject ?? false;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
    o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
    o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
    o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
      maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
    );
    o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
    o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
    o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
    o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
    );
    o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
    o.client = maybeNewOrNull("Client", options.client, cache);
    o.url = options.url ?? "url";
    o.projectName = options.projectName ?? "projectName";
    o.salesforceId = options.salesforceId ?? null;
    o.activeSalesforceOpportunity = maybeNewOrNull(
      "ProjectSalesforceOpportunity",
      options.activeSalesforceOpportunity,
      cache,
    );
    o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
    o.landPriceInCents = options.landPriceInCents ?? 0;
    return o as FactoryResult<Lot>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Lot"] = newLot;

export interface StructureOptions {
  __typename?: "Structure";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Structure["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Structure["isFollowed"];
  id?: Structure["id"];
  buildAddress?: FactoryInput<Address, AddressOptions>;
  market?: FactoryInput<Market, MarketOptions>;
  parent?: FactoryInput<Lot, LotOptions>;
  children?: Array<FactoryInput<Unit, UnitOptions>>;
  primaryProject?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  showInCheckout?: Structure["showInCheckout"];
  community?: FactoryInput<Community, CommunityOptions>;
  modelHomeHardCostsInCents?: Structure["modelHomeHardCostsInCents"];
  modelHomeSoftCostsInCents?: Structure["modelHomeSoftCostsInCents"];
  mainHouseStructure?: FactoryInput<Structure, StructureOptions> | null;
  aduStructure?: FactoryInput<Structure, StructureOptions> | null;
  isAdu?: Structure["isAdu"];
  planType?: ReadyPlanTypeDetailOptions | ReadyPlanType | null;
  hasStartedConstruction?: Structure["hasStartedConstruction"];
  isConstructionComplete?: Structure["isConstructionComplete"];
  canChangeProductOffering?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  collaborators?: Array<FactoryInput<ProjectCollaborator, ProjectCollaboratorOptions>>;
  coverImage?: FactoryInput<Asset, AssetOptions> | null;
  teamMembers?: Array<FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>>;
  projectLead?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions> | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  stages?: Array<FactoryInput<ProjectStage, ProjectStageOptions>>;
  stage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  hopUrl?: Structure["hopUrl"];
  propcoUrl?: Structure["propcoUrl"];
  name?: Structure["name"];
  displayName?: Structure["displayName"];
  availableAssignees?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  startDate?: Structure["startDate"];
  features?: Structure["features"];
  isTest?: Structure["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Structure["latitude"];
  longitude?: Structure["longitude"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  googleDriveFolderId?: Structure["googleDriveFolderId"];
  salesforceAccountId?: Structure["salesforceAccountId"];
  salesforceOpportunities?: Array<FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions>>;
  projectStatusChange?: FactoryInput<ProjectStatusChange, ProjectStatusChangeOptions> | null;
  planRoomLink?: Structure["planRoomLink"];
  isDisaster?: Structure["isDisaster"];
  intakeStyleNotes?: Structure["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: FactoryInput<ProductType, ProductTypeOptions> | null;
  enableSchedulesV2?: Structure["enableSchedulesV2"];
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  jobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
  salesforcePropertyId?: Structure["salesforcePropertyId"];
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  expenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedExpenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedAmountInCents?: Structure["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Structure["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Structure["enableSchedulesCalendar"];
  readyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions> | null;
  earnedValueCurves?: Array<FactoryInput<EarnedValueCurve, EarnedValueCurveOptions>>;
  enableBidPackagesV2?: Structure["enableBidPackagesV2"];
  invoiceSettings?: FactoryInput<ProjectInvoiceSetting, ProjectInvoiceSettingOptions> | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Structure["lotPartitionId"];
  budgetFinancials?: FactoryInput<ProjectBudgetFinancials, ProjectBudgetFinancialsOptions>;
  enableDelayFlags?: Structure["enableDelayFlags"];
  warrantyStartDate?: Structure["warrantyStartDate"];
  verticalCompleteDate?: Structure["verticalCompleteDate"];
  jobLogInsights?: FactoryInput<ProjectJobLogInsights, ProjectJobLogInsightsOptions>;
  targetEndDate?: Structure["targetEndDate"];
  latestActiveStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  primaryHomeowner?: FactoryInput<Client, ClientOptions> | null;
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>> | null;
  lotDetail?: FactoryInput<ProjectLotDetail, ProjectLotDetailOptions>;
  siteSpecificInfos?: Array<FactoryInput<ProjectSiteSpecificInfo, ProjectSiteSpecificInfoOptions>>;
  projectSiteCondition?: FactoryInput<ProjectSiteCondition, ProjectSiteConditionOptions> | null;
  unassignedTaskCount?: Structure["unassignedTaskCount"];
  enableHomeownerNotes?: Structure["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Structure["checkoutCustomerConfigId"];
  canEditJobLogs?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditPrice?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveBudget?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  homeownerNotes?: Array<FactoryInput<HomeownerNote, HomeownerNoteOptions>>;
  enableHomeownerJourneyV2?: Structure["enableHomeownerJourneyV2"];
  featureFlags?: Array<FactoryInput<FeatureFlag, FeatureFlagOptions>>;
  homeownerDeliveryDate?: Structure["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Structure["tasksCompletedThisWeek"];
  contacts?: Array<FactoryInput<ProjectContact, ProjectContactOptions>>;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  shouldAccrueAsComplete?: Structure["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Structure["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Structure["indirectCostMarkupOverrideBasisPoints"];
  customer?: FactoryInput<Customer, CustomerOptions> | null;
  customerOwnerEntity?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions> | null;
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions> | null;
  allowExcludedCostCodesOnPurchaseOrders?: Structure["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Structure["enableProductConfigPlan"];
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions> | null;
  builder?: FactoryInput<Builder, BuilderOptions> | null;
  bidOutPercentage?: Structure["bidOutPercentage"];
  enableChangeEventSignatures?: Structure["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Structure["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Structure["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Structure["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Structure["directHardCostMarkupInBasisPoints"];
  legalDescription?: Structure["legalDescription"];
  salesTaxOverrideInBasisPoints?: Structure["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Structure["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>>;
  allocationRules?: Array<FactoryInput<ProjectAllocationRule, ProjectAllocationRuleOptions>>;
  warrantyLengthInDays?: Structure["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Structure["warrantyOverrideLengthInDays"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  homeownerContracts?: Array<FactoryInput<HomeownerContract, HomeownerContractOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  directCostInCents?: Structure["directCostInCents"];
  directPriceInCents?: Structure["directPriceInCents"];
  totalHardCostInCents?: Structure["totalHardCostInCents"];
  totalSoftCostInCents?: Structure["totalSoftCostInCents"];
  totalCostInCents?: Structure["totalCostInCents"];
  totalPriceInCents?: Structure["totalPriceInCents"];
  readyToStartDate?: Structure["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Structure["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Structure["directCostAtStartInCents"];
  directCostVarianceInCents?: Structure["directCostVarianceInCents"];
  uncommittedCostInCents?: Structure["uncommittedCostInCents"];
  snapshots?: Array<FactoryInput<ProjectSnapshot, ProjectSnapshotOptions>>;
  warrantyEndDate?: Structure["warrantyEndDate"];
  companyInfo?: FactoryInput<CompanyInfo, CompanyInfoOptions>;
  invoicePaymentNetDays?: Structure["invoicePaymentNetDays"];
  snapshotAsOf?: FactoryInput<ProjectSnapshot, ProjectSnapshotOptions> | null;
  purchaseCostInCents?: Structure["purchaseCostInCents"];
  grossSalesPriceInCents?: Structure["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Structure["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Structure["directMarginInBasisPoints"];
  projectCostCodes?: Array<FactoryInput<ProjectCostCode, ProjectCostCodeOptions>>;
  parentsRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  childrenRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  siblingProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  sellableProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  isSellableProject?: Structure["isSellableProject"];
  originalCostInCents?: Structure["originalCostInCents"];
  startCostInCents?: Structure["startCostInCents"];
  changeEventCostInCents?: Structure["changeEventCostInCents"];
  projectedCostInCents?: Structure["projectedCostInCents"];
  revisedCostInCents?: Structure["revisedCostInCents"];
  committedCostInCents?: Structure["committedCostInCents"];
  availableCostInCents?: Structure["availableCostInCents"];
  billedCostInCents?: Structure["billedCostInCents"];
  unbilledCostInCents?: Structure["unbilledCostInCents"];
  cohort?: FactoryInput<Cohort, CohortOptions> | null;
  constructionConfidenceFactor?: Structure["constructionConfidenceFactor"];
  lotRating?: FactoryInput<LotRating, LotRatingOptions> | null;
  preConBudgetLineItems?: Array<
    FactoryInput<PreConBudgetCostDivisionLineItem, PreConBudgetCostDivisionLineItemOptions>
  >;
  preconContractType?: FactoryInput<PreconContractType, PreconContractTypeOptions> | null;
  quickbooksCustomerId?: Structure["quickbooksCustomerId"];
  shadowProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  submarket?: FactoryInput<Submarket, SubmarketOptions> | null;
  client?: FactoryInput<Client, ClientOptions> | null;
  url?: Structure["url"];
  projectName?: Structure["projectName"];
  salesforceId?: Structure["salesforceId"];
  activeSalesforceOpportunity?: FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions> | null;
  dictionary?: FactoryInput<ProjectDictionary, ProjectDictionaryOptions>;
  suburbanAssetCategory?: SuburbanAssetCategoryDetailOptions | SuburbanAssetCategory | null;
  lotSalesStatus?: LotSalesStatusDetailOptions | LotSalesStatus | null;
}

export function newStructure(options?: StructureOptions, factoryOptions?: FactoryOptions): FactoryResult<Structure>;
export function newStructure(
  options: StructureOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Structure> {
  const o = (options.__typename ? options : cache["Structure"] = {}) as Structure;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Structure";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Structure");
    o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.parent = maybeNew("Lot", options.parent, cache, options.hasOwnProperty("parent"));
    o.children = (options.children ?? []).map((i) => maybeNew("Unit", i, cache, options.hasOwnProperty("children")));
    o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
    o.showInCheckout = options.showInCheckout ?? false;
    o.community = maybeNew("Community", options.community, cache, options.hasOwnProperty("community"));
    o.modelHomeHardCostsInCents = options.modelHomeHardCostsInCents ?? 0;
    o.modelHomeSoftCostsInCents = options.modelHomeSoftCostsInCents ?? 0;
    o.mainHouseStructure = maybeNewOrNull("Structure", options.mainHouseStructure, cache);
    o.aduStructure = maybeNewOrNull("Structure", options.aduStructure, cache);
    o.isAdu = options.isAdu ?? false;
    o.planType = enumOrDetailOrNullOfReadyPlanType(options.planType);
    o.hasStartedConstruction = options.hasStartedConstruction ?? false;
    o.isConstructionComplete = options.isConstructionComplete ?? false;
    o.canChangeProductOffering = maybeNew(
      "PotentialOperation2",
      options.canChangeProductOffering,
      cache,
      options.hasOwnProperty("canChangeProductOffering"),
    );
    o.collaborators = (options.collaborators ?? []).map((i) =>
      maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
    );
    o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
    o.teamMembers = (options.teamMembers ?? []).map((i) =>
      maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
    );
    o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
    o.activeStage = enumOrDetailOfStage(options.activeStage);
    o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
    o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
    o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.hopUrl = options.hopUrl ?? "hopUrl";
    o.propcoUrl = options.propcoUrl ?? null;
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
    );
    o.startDate = options.startDate ?? newDate();
    o.features = options.features ?? [];
    o.isTest = options.isTest ?? false;
    o.status = enumOrDetailOfProjectStatus(options.status);
    o.latitude = options.latitude ?? null;
    o.longitude = options.longitude ?? null;
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.googleDriveFolderId = options.googleDriveFolderId ?? null;
    o.salesforceAccountId = options.salesforceAccountId ?? null;
    o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
      maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
    );
    o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
    o.planRoomLink = options.planRoomLink ?? null;
    o.isDisaster = options.isDisaster ?? null;
    o.intakeStyleNotes = options.intakeStyleNotes ?? null;
    o.lotType = enumOrDetailOfLotType(options.lotType);
    o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
    o.productType = maybeNewOrNull("ProductType", options.productType, cache);
    o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
    o.salesforcePropertyId = options.salesforcePropertyId ?? null;
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
    o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
      maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
    );
    o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
    o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
    o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
    o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
    o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
      maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
    );
    o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
    o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
    o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
    o.lotPartitionId = options.lotPartitionId ?? null;
    o.budgetFinancials = maybeNew(
      "ProjectBudgetFinancials",
      options.budgetFinancials,
      cache,
      options.hasOwnProperty("budgetFinancials"),
    );
    o.enableDelayFlags = options.enableDelayFlags ?? false;
    o.warrantyStartDate = options.warrantyStartDate ?? null;
    o.verticalCompleteDate = options.verticalCompleteDate ?? null;
    o.jobLogInsights = maybeNew(
      "ProjectJobLogInsights",
      options.jobLogInsights,
      cache,
      options.hasOwnProperty("jobLogInsights"),
    );
    o.targetEndDate = options.targetEndDate ?? null;
    o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
    o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
    o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
      maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
    );
    o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
    o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
    o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
    o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
    o.canEditJobLogs = maybeNew(
      "PotentialOperation2",
      options.canEditJobLogs,
      cache,
      options.hasOwnProperty("canEditJobLogs"),
    );
    o.canEditPrice = maybeNew(
      "PotentialOperation2",
      options.canEditPrice,
      cache,
      options.hasOwnProperty("canEditPrice"),
    );
    o.canHaveBudget = maybeNew(
      "PotentialOperation2",
      options.canHaveBudget,
      cache,
      options.hasOwnProperty("canHaveBudget"),
    );
    o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
      maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
    );
    o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
    o.featureFlags = (options.featureFlags ?? []).map((i) =>
      maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
    );
    o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
    o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
    o.contacts = (options.contacts ?? []).map((i) =>
      maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
    );
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
    o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
    o.customer = maybeNewOrNull("Customer", options.customer, cache);
    o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
    o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
    o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
    o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
    o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
    o.builder = maybeNewOrNull("Builder", options.builder, cache);
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
    o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
    o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
    o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
    o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
    o.legalDescription = options.legalDescription ?? null;
    o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
    o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
    o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
      maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
    );
    o.allocationRules = (options.allocationRules ?? []).map((i) =>
      maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
    );
    o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
    o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
      maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.directCostInCents = options.directCostInCents ?? 0;
    o.directPriceInCents = options.directPriceInCents ?? 0;
    o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
    o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.readyToStartDate = options.readyToStartDate ?? null;
    o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
    o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
    o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
    o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
    o.snapshots = (options.snapshots ?? []).map((i) =>
      maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
    );
    o.warrantyEndDate = options.warrantyEndDate ?? null;
    o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
    o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
    o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
    o.purchaseCostInCents = options.purchaseCostInCents ?? null;
    o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
    o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
      maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
    );
    o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
    );
    o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
    );
    o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
    );
    o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
    );
    o.isSellableProject = options.isSellableProject ?? false;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
    o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
    o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
    o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
      maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
    );
    o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
    o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
    o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
    );
    o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
    o.client = maybeNewOrNull("Client", options.client, cache);
    o.url = options.url ?? "url";
    o.projectName = options.projectName ?? "projectName";
    o.salesforceId = options.salesforceId ?? null;
    o.activeSalesforceOpportunity = maybeNewOrNull(
      "ProjectSalesforceOpportunity",
      options.activeSalesforceOpportunity,
      cache,
    );
    o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
    o.suburbanAssetCategory = enumOrDetailOrNullOfSuburbanAssetCategory(options.suburbanAssetCategory);
    o.lotSalesStatus = enumOrDetailOrNullOfLotSalesStatus(options.lotSalesStatus);
    return o as FactoryResult<Structure>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Structure"] = newStructure;

export interface UnitOptions {
  __typename?: "Unit";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Unit["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Unit["isFollowed"];
  id?: Unit["id"];
  buildAddress?: FactoryInput<Address, AddressOptions>;
  market?: FactoryInput<Market, MarketOptions>;
  parent?: FactoryInput<Structure, StructureOptions>;
  collaborators?: Array<FactoryInput<ProjectCollaborator, ProjectCollaboratorOptions>>;
  coverImage?: FactoryInput<Asset, AssetOptions> | null;
  teamMembers?: Array<FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>>;
  projectLead?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions> | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  stages?: Array<FactoryInput<ProjectStage, ProjectStageOptions>>;
  stage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  hopUrl?: Unit["hopUrl"];
  name?: Unit["name"];
  displayName?: Unit["displayName"];
  availableAssignees?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  startDate?: Unit["startDate"];
  features?: Unit["features"];
  isTest?: Unit["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Unit["latitude"];
  longitude?: Unit["longitude"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  googleDriveFolderId?: Unit["googleDriveFolderId"];
  salesforceAccountId?: Unit["salesforceAccountId"];
  salesforceOpportunities?: Array<FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions>>;
  projectStatusChange?: FactoryInput<ProjectStatusChange, ProjectStatusChangeOptions> | null;
  planRoomLink?: Unit["planRoomLink"];
  isDisaster?: Unit["isDisaster"];
  intakeStyleNotes?: Unit["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: FactoryInput<ProductType, ProductTypeOptions> | null;
  enableSchedulesV2?: Unit["enableSchedulesV2"];
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  jobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
  salesforcePropertyId?: Unit["salesforcePropertyId"];
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  expenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedExpenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  unallocatedAmountInCents?: Unit["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Unit["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Unit["enableSchedulesCalendar"];
  readyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions> | null;
  earnedValueCurves?: Array<FactoryInput<EarnedValueCurve, EarnedValueCurveOptions>>;
  enableBidPackagesV2?: Unit["enableBidPackagesV2"];
  invoiceSettings?: FactoryInput<ProjectInvoiceSetting, ProjectInvoiceSettingOptions> | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Unit["lotPartitionId"];
  budgetFinancials?: FactoryInput<ProjectBudgetFinancials, ProjectBudgetFinancialsOptions>;
  enableDelayFlags?: Unit["enableDelayFlags"];
  warrantyStartDate?: Unit["warrantyStartDate"];
  verticalCompleteDate?: Unit["verticalCompleteDate"];
  jobLogInsights?: FactoryInput<ProjectJobLogInsights, ProjectJobLogInsightsOptions>;
  targetEndDate?: Unit["targetEndDate"];
  latestActiveStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  primaryHomeowner?: FactoryInput<Client, ClientOptions> | null;
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>> | null;
  lotDetail?: FactoryInput<ProjectLotDetail, ProjectLotDetailOptions>;
  siteSpecificInfos?: Array<FactoryInput<ProjectSiteSpecificInfo, ProjectSiteSpecificInfoOptions>>;
  projectSiteCondition?: FactoryInput<ProjectSiteCondition, ProjectSiteConditionOptions> | null;
  unassignedTaskCount?: Unit["unassignedTaskCount"];
  enableHomeownerNotes?: Unit["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Unit["checkoutCustomerConfigId"];
  canEditJobLogs?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditPrice?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveBudget?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  homeownerNotes?: Array<FactoryInput<HomeownerNote, HomeownerNoteOptions>>;
  enableHomeownerJourneyV2?: Unit["enableHomeownerJourneyV2"];
  featureFlags?: Array<FactoryInput<FeatureFlag, FeatureFlagOptions>>;
  homeownerDeliveryDate?: Unit["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Unit["tasksCompletedThisWeek"];
  contacts?: Array<FactoryInput<ProjectContact, ProjectContactOptions>>;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  shouldAccrueAsComplete?: Unit["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Unit["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Unit["indirectCostMarkupOverrideBasisPoints"];
  customer?: FactoryInput<Customer, CustomerOptions> | null;
  customerOwnerEntity?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions> | null;
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions> | null;
  allowExcludedCostCodesOnPurchaseOrders?: Unit["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Unit["enableProductConfigPlan"];
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions> | null;
  builder?: FactoryInput<Builder, BuilderOptions> | null;
  bidOutPercentage?: Unit["bidOutPercentage"];
  enableChangeEventSignatures?: Unit["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Unit["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Unit["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Unit["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Unit["directHardCostMarkupInBasisPoints"];
  legalDescription?: Unit["legalDescription"];
  salesTaxOverrideInBasisPoints?: Unit["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Unit["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>>;
  allocationRules?: Array<FactoryInput<ProjectAllocationRule, ProjectAllocationRuleOptions>>;
  warrantyLengthInDays?: Unit["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Unit["warrantyOverrideLengthInDays"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  homeownerContracts?: Array<FactoryInput<HomeownerContract, HomeownerContractOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  directCostInCents?: Unit["directCostInCents"];
  directPriceInCents?: Unit["directPriceInCents"];
  totalHardCostInCents?: Unit["totalHardCostInCents"];
  totalSoftCostInCents?: Unit["totalSoftCostInCents"];
  totalCostInCents?: Unit["totalCostInCents"];
  totalPriceInCents?: Unit["totalPriceInCents"];
  readyToStartDate?: Unit["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Unit["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Unit["directCostAtStartInCents"];
  directCostVarianceInCents?: Unit["directCostVarianceInCents"];
  uncommittedCostInCents?: Unit["uncommittedCostInCents"];
  snapshots?: Array<FactoryInput<ProjectSnapshot, ProjectSnapshotOptions>>;
  warrantyEndDate?: Unit["warrantyEndDate"];
  companyInfo?: FactoryInput<CompanyInfo, CompanyInfoOptions>;
  invoicePaymentNetDays?: Unit["invoicePaymentNetDays"];
  snapshotAsOf?: FactoryInput<ProjectSnapshot, ProjectSnapshotOptions> | null;
  purchaseCostInCents?: Unit["purchaseCostInCents"];
  grossSalesPriceInCents?: Unit["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Unit["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Unit["directMarginInBasisPoints"];
  projectCostCodes?: Array<FactoryInput<ProjectCostCode, ProjectCostCodeOptions>>;
  children?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  parentsRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  childrenRecursive?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  siblingProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  sellableProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  isSellableProject?: Unit["isSellableProject"];
  originalCostInCents?: Unit["originalCostInCents"];
  startCostInCents?: Unit["startCostInCents"];
  changeEventCostInCents?: Unit["changeEventCostInCents"];
  projectedCostInCents?: Unit["projectedCostInCents"];
  revisedCostInCents?: Unit["revisedCostInCents"];
  committedCostInCents?: Unit["committedCostInCents"];
  availableCostInCents?: Unit["availableCostInCents"];
  billedCostInCents?: Unit["billedCostInCents"];
  unbilledCostInCents?: Unit["unbilledCostInCents"];
  cohort?: FactoryInput<Cohort, CohortOptions> | null;
  constructionConfidenceFactor?: Unit["constructionConfidenceFactor"];
  lotRating?: FactoryInput<LotRating, LotRatingOptions> | null;
  preConBudgetLineItems?: Array<
    FactoryInput<PreConBudgetCostDivisionLineItem, PreConBudgetCostDivisionLineItemOptions>
  >;
  preconContractType?: FactoryInput<PreconContractType, PreconContractTypeOptions> | null;
  primaryProject?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  quickbooksCustomerId?: Unit["quickbooksCustomerId"];
  shadowProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  submarket?: FactoryInput<Submarket, SubmarketOptions> | null;
  client?: FactoryInput<Client, ClientOptions> | null;
  url?: Unit["url"];
  projectName?: Unit["projectName"];
  salesforceId?: Unit["salesforceId"];
  activeSalesforceOpportunity?: FactoryInput<ProjectSalesforceOpportunity, ProjectSalesforceOpportunityOptions> | null;
  dictionary?: FactoryInput<ProjectDictionary, ProjectDictionaryOptions>;
}

export function newUnit(options?: UnitOptions, factoryOptions?: FactoryOptions): FactoryResult<Unit>;
export function newUnit(
  options: UnitOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Unit> {
  const o = (options.__typename ? options : cache["Unit"] = {}) as Unit;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Unit";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Unit");
    o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.parent = maybeNew("Structure", options.parent, cache, options.hasOwnProperty("parent"));
    o.collaborators = (options.collaborators ?? []).map((i) =>
      maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
    );
    o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
    o.teamMembers = (options.teamMembers ?? []).map((i) =>
      maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
    );
    o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
    o.activeStage = enumOrDetailOfStage(options.activeStage);
    o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
    o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
    o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.hopUrl = options.hopUrl ?? "hopUrl";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
    );
    o.startDate = options.startDate ?? newDate();
    o.features = options.features ?? [];
    o.isTest = options.isTest ?? false;
    o.status = enumOrDetailOfProjectStatus(options.status);
    o.latitude = options.latitude ?? null;
    o.longitude = options.longitude ?? null;
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.googleDriveFolderId = options.googleDriveFolderId ?? null;
    o.salesforceAccountId = options.salesforceAccountId ?? null;
    o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
      maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
    );
    o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
    o.planRoomLink = options.planRoomLink ?? null;
    o.isDisaster = options.isDisaster ?? null;
    o.intakeStyleNotes = options.intakeStyleNotes ?? null;
    o.lotType = enumOrDetailOfLotType(options.lotType);
    o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
    o.productType = maybeNewOrNull("ProductType", options.productType, cache);
    o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
    o.salesforcePropertyId = options.salesforcePropertyId ?? null;
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
    o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
      maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
    );
    o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
    o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
    o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
    o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
    o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
      maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
    );
    o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
    o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
    o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
    o.lotPartitionId = options.lotPartitionId ?? null;
    o.budgetFinancials = maybeNew(
      "ProjectBudgetFinancials",
      options.budgetFinancials,
      cache,
      options.hasOwnProperty("budgetFinancials"),
    );
    o.enableDelayFlags = options.enableDelayFlags ?? false;
    o.warrantyStartDate = options.warrantyStartDate ?? null;
    o.verticalCompleteDate = options.verticalCompleteDate ?? null;
    o.jobLogInsights = maybeNew(
      "ProjectJobLogInsights",
      options.jobLogInsights,
      cache,
      options.hasOwnProperty("jobLogInsights"),
    );
    o.targetEndDate = options.targetEndDate ?? null;
    o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
    o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
    o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
      maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
    );
    o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
    o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
    o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
    o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
    o.canEditJobLogs = maybeNew(
      "PotentialOperation2",
      options.canEditJobLogs,
      cache,
      options.hasOwnProperty("canEditJobLogs"),
    );
    o.canEditPrice = maybeNew(
      "PotentialOperation2",
      options.canEditPrice,
      cache,
      options.hasOwnProperty("canEditPrice"),
    );
    o.canHaveBudget = maybeNew(
      "PotentialOperation2",
      options.canHaveBudget,
      cache,
      options.hasOwnProperty("canHaveBudget"),
    );
    o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
      maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
    );
    o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
    o.featureFlags = (options.featureFlags ?? []).map((i) =>
      maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
    );
    o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
    o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
    o.contacts = (options.contacts ?? []).map((i) =>
      maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
    );
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
    o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
    o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
    o.customer = maybeNewOrNull("Customer", options.customer, cache);
    o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
    o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
    o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
    o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
    o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
    o.builder = maybeNewOrNull("Builder", options.builder, cache);
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
    o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
    o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
    o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
    o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
    o.legalDescription = options.legalDescription ?? null;
    o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
    o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
    o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
      maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
    );
    o.allocationRules = (options.allocationRules ?? []).map((i) =>
      maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
    );
    o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
    o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
      maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.directCostInCents = options.directCostInCents ?? 0;
    o.directPriceInCents = options.directPriceInCents ?? 0;
    o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
    o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.readyToStartDate = options.readyToStartDate ?? null;
    o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
    o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
    o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
    o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
    o.snapshots = (options.snapshots ?? []).map((i) =>
      maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
    );
    o.warrantyEndDate = options.warrantyEndDate ?? null;
    o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
    o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
    o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
    o.purchaseCostInCents = options.purchaseCostInCents ?? null;
    o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
    o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
      maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
    );
    o.children = (options.children ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("children")));
    o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
    );
    o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
    );
    o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
    );
    o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
    );
    o.isSellableProject = options.isSellableProject ?? false;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
    o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
    o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
    o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
      maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
    );
    o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
    o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
    o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
    o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
    );
    o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
    o.client = maybeNewOrNull("Client", options.client, cache);
    o.url = options.url ?? "url";
    o.projectName = options.projectName ?? "projectName";
    o.salesforceId = options.salesforceId ?? null;
    o.activeSalesforceOpportunity = maybeNewOrNull(
      "ProjectSalesforceOpportunity",
      options.activeSalesforceOpportunity,
      cache,
    );
    o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
    return o as FactoryResult<Unit>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Unit"] = newUnit;

export interface ProjectItemOptions {
  __typename?: "ProjectItem";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ProjectItem["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ProjectItem["isFollowed"];
  id?: ProjectItem["id"];
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  slot?: FactoryInput<ItemSlot, ItemSlotOptions>;
  item?: FactoryInput<Item, ItemOptions>;
  name?: ProjectItem["name"];
  description?: ProjectItem["description"];
  markupInCents?: ProjectItem["markupInCents"];
  priceInCents?: ProjectItem["priceInCents"];
  costInCents?: ProjectItem["costInCents"];
  unitCostInCents?: ProjectItem["unitCostInCents"];
  unitPriceInCents?: ProjectItem["unitPriceInCents"];
  totalCostInCents?: ProjectItem["totalCostInCents"];
  totalPriceInCents?: ProjectItem["totalPriceInCents"];
  totalMarkupInCents?: ProjectItem["totalMarkupInCents"];
  markupBasisPoints?: ProjectItem["markupBasisPoints"];
  projectMarkupBasisPoints?: ProjectItem["projectMarkupBasisPoints"];
  quantity?: ProjectItem["quantity"];
  location?: FactoryInput<Location, LocationOptions>;
  quantityCalculated?: ProjectItem["quantityCalculated"];
  billedBills?: Array<FactoryInput<Bill, BillOptions>>;
  bills?: Array<FactoryInput<Bill, BillOptions>>;
  displayName?: ProjectItem["displayName"];
  billLineItems?: Array<FactoryInput<BillLineItem, BillLineItemOptions>>;
  commitmentLineItems?: Array<FactoryInput<CommitmentLineItem, CommitmentLineItemOptions>>;
  signedCommitmentLineItems?: Array<FactoryInput<CommitmentLineItem, CommitmentLineItemOptions>>;
  totalCommittedCostInCents?: ProjectItem["totalCommittedCostInCents"];
  allCommittedCostInCents?: ProjectItem["allCommittedCostInCents"];
  planBasedCostHoldingProjectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
  costType?: ProjectItem["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  estimateLineItems?: Array<FactoryInput<EstimateLineItem, EstimateLineItemOptions>>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  homeownerPaidInCents?: ProjectItem["homeownerPaidInCents"];
  tradePartnerNote?: ProjectItem["tradePartnerNote"];
  specifications?: ProjectItem["specifications"];
  history?: Array<FactoryInput<History, HistoryOptions>>;
  changeEventLineItems?: Array<FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>>;
  isPendingChangeEvent?: ProjectItem["isPendingChangeEvent"];
  internalNote?: ProjectItem["internalNote"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  costConfidence?: CostConfidenceDetailOptions | CostConfidence;
  buyoutStatus?: ProjectItem["buyoutStatus"];
  buyoutStatusDetail?: BuyoutStatusDetailOptions | BuyoutStatus;
  canEditCost?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  protoCommitmentLineItemToBuyout?:
    | FactoryInput<ProtoCommitmentLineItemToBuyout, ProtoCommitmentLineItemToBuyoutOptions>
    | null;
  scopeHistory?: Array<FactoryInput<ProjectItemScopeChange, ProjectItemScopeChangeOptions>>;
  canEditScope?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditName?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditCostConfidence?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditBuyoutStatus?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  itemTemplateItem?: BaseItemLike | FactoryResult<BaseItemLikeType> | BaseItemLikeOptions | null;
  modifyingTemplateItems?: Array<BaseItemLike | FactoryResult<BaseItemLikeType> | BaseItemLikeOptions>;
  task?: FactoryInput<Task, TaskOptions> | null;
  currentTradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  currentCommitment?: CommitmentLike | FactoryResult<CommitmentLikeType> | CommitmentLikeOptions | null;
  originalBudgetInCents?: ProjectItem["originalBudgetInCents"];
  originalPriceInCents?: ProjectItem["originalPriceInCents"];
  contractBudgetChangesInCents?: ProjectItem["contractBudgetChangesInCents"];
  budgetReallocationsInCents?: ProjectItem["budgetReallocationsInCents"];
  revisedApprovedBudgetInCents?: ProjectItem["revisedApprovedBudgetInCents"];
  uncommittedBudgetAmountInCents?: ProjectItem["uncommittedBudgetAmountInCents"];
  unbilledCommittedInCents?: ProjectItem["unbilledCommittedInCents"];
  actualCostInCents?: ProjectItem["actualCostInCents"];
  costToCompleteInCents?: ProjectItem["costToCompleteInCents"];
  homeownerContractLineItems?: Array<FactoryInput<HomeownerContractLineItem, HomeownerContractLineItemOptions>>;
  internalBudgetChangeInCents?: ProjectItem["internalBudgetChangeInCents"];
  bidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  probableBidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  potentialBidContractLineItems?: Array<
    FactoryInput<PotentialBidContractLineItem, PotentialBidContractLineItemOptions>
  >;
  preferredPotentialBidContractLineItem?:
    | FactoryInput<PotentialBidContractLineItem, PotentialBidContractLineItemOptions>
    | null;
  isFromReadyHomeTemplate?: ProjectItem["isFromReadyHomeTemplate"];
  isRemovedScope?: ProjectItem["isRemovedScope"];
  expenseAllocations?: Array<FactoryInput<ExpenseAllocation, ExpenseAllocationOptions>>;
  budgetRollupInCents?: FactoryInput<BudgetPhaseRollup, BudgetPhaseRollupOptions>;
  prebidBudgetChangeInCents?: ProjectItem["prebidBudgetChangeInCents"];
  awardedBudgetChangeInCents?: ProjectItem["awardedBudgetChangeInCents"];
  revisedBudgetChangeInCents?: ProjectItem["revisedBudgetChangeInCents"];
  costLineItems?: Array<FactoryInput<CostLineItem, CostLineItemOptions>>;
  workAuthorizations?: Array<FactoryInput<WorkAuthorization, WorkAuthorizationOptions>>;
  bidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  externalBudgetChangeInCents?: ProjectItem["externalBudgetChangeInCents"];
  budgetFinancials?: FactoryInput<ProjectItemBudgetFinancials, ProjectItemBudgetFinancialsOptions>;
  tradePartnerPaidInCents?: ProjectItem["tradePartnerPaidInCents"];
  tradeBilledInCents?: ProjectItem["tradeBilledInCents"];
  canAssignBidContractLineItem?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  currentPriceInCents?: ProjectItem["currentPriceInCents"];
  allocationReason?: ProjectItem["allocationReason"];
  configuredOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  baseOrOptionName?: ProjectItem["baseOrOptionName"];
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  lastAcceptedChangeEventLineItem?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions> | null;
  allocations?: Array<FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>>;
  directCostAtStartInCents?: ProjectItem["directCostAtStartInCents"];
  directCostVarianceInCents?: ProjectItem["directCostVarianceInCents"];
  projectCostCode?: FactoryInput<ProjectCostCode, ProjectCostCodeOptions>;
  originalCostInCents?: ProjectItem["originalCostInCents"];
  startCostInCents?: ProjectItem["startCostInCents"];
  changeEventCostInCents?: ProjectItem["changeEventCostInCents"];
  revisedCostInCents?: ProjectItem["revisedCostInCents"];
  revisedPriceInCents?: ProjectItem["revisedPriceInCents"];
  projectedCostInCents?: ProjectItem["projectedCostInCents"];
  committedCostInCents?: ProjectItem["committedCostInCents"];
  availableCostInCents?: ProjectItem["availableCostInCents"];
  billedCostInCents?: ProjectItem["billedCostInCents"];
  unbilledCostInCents?: ProjectItem["unbilledCostInCents"];
  bidTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  packageDesignNotes?: ProjectItem["packageDesignNotes"];
}

export function newProjectItem(
  options?: ProjectItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newProjectItem(
  options: ProjectItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectItem> {
  const o = (options.__typename ? options : cache["ProjectItem"] = {}) as ProjectItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectItem";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("ProjectItem");
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.name = options.name ?? "name";
    o.description = options.description ?? null;
    o.markupInCents = options.markupInCents ?? 0;
    o.priceInCents = options.priceInCents ?? 0;
    o.costInCents = options.costInCents ?? 0;
    o.unitCostInCents = options.unitCostInCents ?? 0;
    o.unitPriceInCents = options.unitPriceInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
    o.markupBasisPoints = options.markupBasisPoints ?? null;
    o.projectMarkupBasisPoints = options.projectMarkupBasisPoints ?? 0;
    o.quantity = options.quantity ?? null;
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.quantityCalculated = options.quantityCalculated ?? null;
    o.billedBills = (options.billedBills ?? []).map((i) =>
      maybeNew("Bill", i, cache, options.hasOwnProperty("billedBills"))
    );
    o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
    o.displayName = options.displayName ?? "displayName";
    o.billLineItems = (options.billLineItems ?? []).map((i) =>
      maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
    );
    o.commitmentLineItems = (options.commitmentLineItems ?? []).map((i) =>
      maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("commitmentLineItems"))
    );
    o.signedCommitmentLineItems = (options.signedCommitmentLineItems ?? []).map((i) =>
      maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("signedCommitmentLineItems"))
    );
    o.totalCommittedCostInCents = options.totalCommittedCostInCents ?? 0;
    o.allCommittedCostInCents = options.allCommittedCostInCents ?? 0;
    o.planBasedCostHoldingProjectItems = (options.planBasedCostHoldingProjectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("planBasedCostHoldingProjectItems"))
    );
    o.costType = options.costType ?? CostType.Labor;
    o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
    o.estimateLineItems = (options.estimateLineItems ?? []).map((i) =>
      maybeNew("EstimateLineItem", i, cache, options.hasOwnProperty("estimateLineItems"))
    );
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.homeownerPaidInCents = options.homeownerPaidInCents ?? null;
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.specifications = options.specifications ?? null;
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.changeEventLineItems = (options.changeEventLineItems ?? []).map((i) =>
      maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("changeEventLineItems"))
    );
    o.isPendingChangeEvent = options.isPendingChangeEvent ?? false;
    o.internalNote = options.internalNote ?? null;
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.costConfidence = enumOrDetailOfCostConfidence(options.costConfidence);
    o.buyoutStatus = options.buyoutStatus ?? BuyoutStatus.NotBoughtOut;
    o.buyoutStatusDetail = enumOrDetailOfBuyoutStatus(options.buyoutStatusDetail);
    o.canEditCost = maybeNew("PotentialOperation2", options.canEditCost, cache, options.hasOwnProperty("canEditCost"));
    o.protoCommitmentLineItemToBuyout = maybeNewOrNull(
      "ProtoCommitmentLineItemToBuyout",
      options.protoCommitmentLineItemToBuyout,
      cache,
    );
    o.scopeHistory = (options.scopeHistory ?? []).map((i) =>
      maybeNew("ProjectItemScopeChange", i, cache, options.hasOwnProperty("scopeHistory"))
    );
    o.canEditScope = maybeNew(
      "PotentialOperation2",
      options.canEditScope,
      cache,
      options.hasOwnProperty("canEditScope"),
    );
    o.canEditName = maybeNew("PotentialOperation2", options.canEditName, cache, options.hasOwnProperty("canEditName"));
    o.canEditCostConfidence = maybeNew(
      "PotentialOperation2",
      options.canEditCostConfidence,
      cache,
      options.hasOwnProperty("canEditCostConfidence"),
    );
    o.canEditBuyoutStatus = maybeNew(
      "PotentialOperation2",
      options.canEditBuyoutStatus,
      cache,
      options.hasOwnProperty("canEditBuyoutStatus"),
    );
    o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
    o.modifyingTemplateItems = (options.modifyingTemplateItems ?? []).map((i) =>
      maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("modifyingTemplateItems"))
    );
    o.task = maybeNewOrNull("Task", options.task, cache);
    o.currentTradePartner = maybeNewOrNull("TradePartner", options.currentTradePartner, cache);
    o.currentCommitment = maybeNewOrNull("CommitmentLike", options.currentCommitment, cache);
    o.originalBudgetInCents = options.originalBudgetInCents ?? 0;
    o.originalPriceInCents = options.originalPriceInCents ?? 0;
    o.contractBudgetChangesInCents = options.contractBudgetChangesInCents ?? 0;
    o.budgetReallocationsInCents = options.budgetReallocationsInCents ?? 0;
    o.revisedApprovedBudgetInCents = options.revisedApprovedBudgetInCents ?? 0;
    o.uncommittedBudgetAmountInCents = options.uncommittedBudgetAmountInCents ?? 0;
    o.unbilledCommittedInCents = options.unbilledCommittedInCents ?? 0;
    o.actualCostInCents = options.actualCostInCents ?? 0;
    o.costToCompleteInCents = options.costToCompleteInCents ?? 0;
    o.homeownerContractLineItems = (options.homeownerContractLineItems ?? []).map((i) =>
      maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("homeownerContractLineItems"))
    );
    o.internalBudgetChangeInCents = options.internalBudgetChangeInCents ?? 0;
    o.bidContractLineItem = maybeNewOrNull("BidContractLineItem", options.bidContractLineItem, cache);
    o.probableBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.probableBidContractLineItem, cache);
    o.potentialBidContractLineItems = (options.potentialBidContractLineItems ?? []).map((i) =>
      maybeNew("PotentialBidContractLineItem", i, cache, options.hasOwnProperty("potentialBidContractLineItems"))
    );
    o.preferredPotentialBidContractLineItem = maybeNewOrNull(
      "PotentialBidContractLineItem",
      options.preferredPotentialBidContractLineItem,
      cache,
    );
    o.isFromReadyHomeTemplate = options.isFromReadyHomeTemplate ?? false;
    o.isRemovedScope = options.isRemovedScope ?? false;
    o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
      maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
    );
    o.budgetRollupInCents = maybeNew(
      "BudgetPhaseRollup",
      options.budgetRollupInCents,
      cache,
      options.hasOwnProperty("budgetRollupInCents"),
    );
    o.prebidBudgetChangeInCents = options.prebidBudgetChangeInCents ?? 0;
    o.awardedBudgetChangeInCents = options.awardedBudgetChangeInCents ?? 0;
    o.revisedBudgetChangeInCents = options.revisedBudgetChangeInCents ?? 0;
    o.costLineItems = (options.costLineItems ?? []).map((i) =>
      maybeNew("CostLineItem", i, cache, options.hasOwnProperty("costLineItems"))
    );
    o.workAuthorizations = (options.workAuthorizations ?? []).map((i) =>
      maybeNew("WorkAuthorization", i, cache, options.hasOwnProperty("workAuthorizations"))
    );
    o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
    o.externalBudgetChangeInCents = options.externalBudgetChangeInCents ?? 0;
    o.budgetFinancials = maybeNew(
      "ProjectItemBudgetFinancials",
      options.budgetFinancials,
      cache,
      options.hasOwnProperty("budgetFinancials"),
    );
    o.tradePartnerPaidInCents = options.tradePartnerPaidInCents ?? 0;
    o.tradeBilledInCents = options.tradeBilledInCents ?? 0;
    o.canAssignBidContractLineItem = maybeNew(
      "PotentialOperation2",
      options.canAssignBidContractLineItem,
      cache,
      options.hasOwnProperty("canAssignBidContractLineItem"),
    );
    o.currentPriceInCents = options.currentPriceInCents ?? 0;
    o.allocationReason = options.allocationReason ?? null;
    o.configuredOptions = (options.configuredOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("configuredOptions"))
    );
    o.baseOrOptionName = options.baseOrOptionName ?? "baseOrOptionName";
    o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
    o.lastAcceptedChangeEventLineItem = maybeNewOrNull(
      "ChangeEventLineItem",
      options.lastAcceptedChangeEventLineItem,
      cache,
    );
    o.allocations = (options.allocations ?? []).map((i) =>
      maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("allocations"))
    );
    o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
    o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
    o.projectCostCode = maybeNew(
      "ProjectCostCode",
      options.projectCostCode,
      cache,
      options.hasOwnProperty("projectCostCode"),
    );
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.revisedPriceInCents = options.revisedPriceInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.bidTask = maybeNewOrNull("GlobalPlanTask", options.bidTask, cache);
    o.packageDesignNotes = options.packageDesignNotes ?? null;
    return o as FactoryResult<ProjectItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectItem"] = newProjectItem;

export interface EstimateOptions {
  __typename?: "Estimate";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Estimate["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Estimate["isFollowed"];
  id?: Estimate["id"];
  name?: Estimate["name"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  status?: EstimateStatusDetailOptions | EstimateStatus;
  type?: EstimateTypeDetailOptions | EstimateType;
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  lineItems?: Array<FactoryInput<EstimateLineItem, EstimateLineItemOptions>>;
  title?: Estimate["title"];
  description?: Estimate["description"];
  createdAt?: Estimate["createdAt"];
  updatedAt?: Estimate["updatedAt"];
  totalCostInCents?: Estimate["totalCostInCents"];
  totalMarkupInCents?: Estimate["totalMarkupInCents"];
  totalPriceInCents?: Estimate["totalPriceInCents"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions> | null;
  history?: Array<FactoryInput<History, HistoryOptions>>;
  homeownerContractChangeOrder?: FactoryInput<HomeownerContractChangeOrder, HomeownerContractChangeOrderOptions> | null;
  canEditStatus?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  softCostInCents?: Estimate["softCostInCents"];
  hardCostInCents?: Estimate["hardCostInCents"];
  directHardCostInCents?: Estimate["directHardCostInCents"];
  indirectHardCostInCents?: Estimate["indirectHardCostInCents"];
  annotatedCosts?: Array<FactoryInput<AnnotatedCost, AnnotatedCostOptions>>;
}

export function newEstimate(options?: EstimateOptions, factoryOptions?: FactoryOptions): FactoryResult<Estimate>;
export function newEstimate(
  options: EstimateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Estimate> {
  const o = (options.__typename ? options : cache["Estimate"] = {}) as Estimate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Estimate";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Estimate");
    o.name = options.name ?? "name";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.status = enumOrDetailOfEstimateStatus(options.status);
    o.type = enumOrDetailOfEstimateType(options.type);
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("EstimateLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.title = options.title ?? "title";
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.homeownerContractChangeOrder = maybeNewOrNull(
      "HomeownerContractChangeOrder",
      options.homeownerContractChangeOrder,
      cache,
    );
    o.canEditStatus = maybeNew(
      "PotentialOperation2",
      options.canEditStatus,
      cache,
      options.hasOwnProperty("canEditStatus"),
    );
    o.softCostInCents = options.softCostInCents ?? 0;
    o.hardCostInCents = options.hardCostInCents ?? 0;
    o.directHardCostInCents = options.directHardCostInCents ?? 0;
    o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
    o.annotatedCosts = (options.annotatedCosts ?? []).map((i) =>
      maybeNew("AnnotatedCost", i, cache, options.hasOwnProperty("annotatedCosts"))
    );
    return o as FactoryResult<Estimate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Estimate"] = newEstimate;

export interface DevelopmentCommitmentOptions {
  __typename?: "DevelopmentCommitment";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: DevelopmentCommitment["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: DevelopmentCommitment["isFollowed"];
  id?: DevelopmentCommitment["id"];
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  tradeCategories?: Array<FactoryInput<TradeCategory, TradeCategoryOptions>>;
  market?: FactoryInput<Market, MarketOptions>;
  status?: DevelopmentCommitment["status"];
  statusDetail?: CommitmentStatusDetailOptions | CommitmentStatus;
  statusText?: DevelopmentCommitment["statusText"];
  type?: DevelopmentCommitment["type"];
  typeDetail?: DevelopmentCommitmentTypeDetailOptions | DevelopmentCommitmentType | null;
  name?: DevelopmentCommitment["name"];
  executionDate?: DevelopmentCommitment["executionDate"];
  createdAt?: DevelopmentCommitment["createdAt"];
  updatedAt?: DevelopmentCommitment["updatedAt"];
  releasedDate?: DevelopmentCommitment["releasedDate"];
  releasedAt?: DevelopmentCommitment["releasedAt"];
  contractExhibits?: DevelopmentCommitment["contractExhibits"];
  contractSchedule?: DevelopmentCommitment["contractSchedule"];
  contractTerms?: DevelopmentCommitment["contractTerms"];
  contractExclusions?: DevelopmentCommitment["contractExclusions"];
  committedInCents?: DevelopmentCommitment["committedInCents"];
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions> | null;
  headOfConstruction?: FactoryInput<InternalUser, InternalUserOptions> | null;
  homeboundAuthorizedSignatory?: FactoryInput<InternalUser, InternalUserOptions> | null;
  conOpsProjectManager?: FactoryInput<InternalUser, InternalUserOptions> | null;
  areaManager?: FactoryInput<InternalUser, InternalUserOptions> | null;
  canCreatePandaDoc?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  history?: Array<FactoryInput<History, HistoryOptions>>;
  summary?: FactoryInput<DevelopmentCommitmentSummary, DevelopmentCommitmentSummaryOptions>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  stage?: DevelopmentCommitment["stage"];
  stageDetail?: StageDetailOptions | Stage;
  costTypes?: Array<FactoryInput<CostTypeDetail, CostTypeDetailOptions>> | null;
  internalNote?: DevelopmentCommitment["internalNote"];
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  costCodeSummary?: Array<
    FactoryInput<DevelopmentCommitmentCostCodeSummary, DevelopmentCommitmentCostCodeSummaryOptions>
  >;
  canBeEdited?: DevelopmentCommitment["canBeEdited"];
  development?: FactoryInput<Development, DevelopmentOptions>;
  document?: FactoryInput<Document, DocumentOptions> | null;
  signatoryContact?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
}

export function newDevelopmentCommitment(
  options?: DevelopmentCommitmentOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitment>;
export function newDevelopmentCommitment(
  options: DevelopmentCommitmentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentCommitment> {
  const o = (options.__typename ? options : cache["DevelopmentCommitment"] = {}) as DevelopmentCommitment;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentCommitment";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("DevelopmentCommitment");
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
      maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
    );
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.status = options.status ?? CommitmentStatus.Draft;
    o.statusDetail = enumOrDetailOfCommitmentStatus(options.statusDetail);
    o.statusText = options.statusText ?? "statusText";
    o.type = options.type ?? null;
    o.typeDetail = enumOrDetailOrNullOfDevelopmentCommitmentType(options.typeDetail);
    o.name = options.name ?? "name";
    o.executionDate = options.executionDate ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.releasedDate = options.releasedDate ?? null;
    o.releasedAt = options.releasedAt ?? null;
    o.contractExhibits = options.contractExhibits ?? null;
    o.contractSchedule = options.contractSchedule ?? null;
    o.contractTerms = options.contractTerms ?? null;
    o.contractExclusions = options.contractExclusions ?? null;
    o.committedInCents = options.committedInCents ?? 0;
    o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
    o.headOfConstruction = maybeNewOrNull("InternalUser", options.headOfConstruction, cache);
    o.homeboundAuthorizedSignatory = maybeNewOrNull("InternalUser", options.homeboundAuthorizedSignatory, cache);
    o.conOpsProjectManager = maybeNewOrNull("InternalUser", options.conOpsProjectManager, cache);
    o.areaManager = maybeNewOrNull("InternalUser", options.areaManager, cache);
    o.canCreatePandaDoc = maybeNew(
      "PotentialOperation2",
      options.canCreatePandaDoc,
      cache,
      options.hasOwnProperty("canCreatePandaDoc"),
    );
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.summary = maybeNew("DevelopmentCommitmentSummary", options.summary, cache, options.hasOwnProperty("summary"));
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.stage = options.stage ?? Stage.PreConPlanning;
    o.stageDetail = enumOrDetailOfStage(options.stageDetail);
    o.costTypes = (options.costTypes ?? []).map((i) => enumOrDetailOfCostType(i));
    o.internalNote = options.internalNote ?? null;
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.costCodeSummary = (options.costCodeSummary ?? []).map((i) =>
      maybeNew("DevelopmentCommitmentCostCodeSummary", i, cache, options.hasOwnProperty("costCodeSummary"))
    );
    o.canBeEdited = options.canBeEdited ?? false;
    o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.signatoryContact = maybeNewOrNull("TradePartnerContact", options.signatoryContact, cache);
    return o as FactoryResult<DevelopmentCommitment>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentCommitment"] = newDevelopmentCommitment;

export interface CommitmentOptions {
  __typename?: "Commitment";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Commitment["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Commitment["isFollowed"];
  id?: Commitment["id"];
  accountingNumber?: Commitment["accountingNumber"];
  name?: Commitment["name"];
  displayName?: Commitment["displayName"];
  shortName?: Commitment["shortName"];
  commitmentType?: CommitmentTypeDetailOptions | CommitmentType;
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  internalNote?: Commitment["internalNote"];
  costChangeInCents?: Commitment["costChangeInCents"];
  executionDate?: Commitment["executionDate"];
  createdAt?: Commitment["createdAt"];
  document?: FactoryInput<Document, DocumentOptions> | null;
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions> | null;
  canCreatePandaDoc?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  changeOrders?: Array<FactoryInput<CommitmentChangeOrder, CommitmentChangeOrderOptions>>;
  lineItems?: Array<FactoryInput<CommitmentLineItem, CommitmentLineItemOptions>>;
  bills?: Array<FactoryInput<Bill, BillOptions>>;
  expenseAllocations?: Array<FactoryInput<ExpenseAllocation, ExpenseAllocationOptions>>;
  lineItemSummaries?: Array<FactoryInput<CommitmentLineItemSummary, CommitmentLineItemSummaryOptions>>;
  committedInCents?: Commitment["committedInCents"];
  taxableCostInCents?: Commitment["taxableCostInCents"];
  remainingInCents?: Commitment["remainingInCents"];
  pendingRemainingInCents?: Commitment["pendingRemainingInCents"];
  billedInCents?: Commitment["billedInCents"];
  pendingBilledInCents?: Commitment["pendingBilledInCents"];
  unbilledInCents?: Commitment["unbilledInCents"];
  paidInCents?: Commitment["paidInCents"];
  balanceInCents?: Commitment["balanceInCents"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  protoCommitmentLineItemsToBuyout?: Array<
    FactoryInput<ProtoCommitmentLineItemToBuyout, ProtoCommitmentLineItemToBuyoutOptions>
  >;
  hasPartiallyBoughtOutScope?: Commitment["hasPartiallyBoughtOutScope"];
  status?: Commitment["status"];
  statusDetail?: CommitmentStatusDetailOptions | CommitmentStatus;
  statusText?: Commitment["statusText"];
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions> | null;
  contractExhibits?: Commitment["contractExhibits"];
  contractSchedule?: Commitment["contractSchedule"];
  contractTerms?: Commitment["contractTerms"];
  contractExclusions?: Commitment["contractExclusions"];
  updatedAt?: Commitment["updatedAt"];
  tradeCategories?: Array<FactoryInput<TradeCategory, TradeCategoryOptions>>;
  costTypes?: Array<FactoryInput<CostTypeDetail, CostTypeDetailOptions>>;
  costCodeSummary?: FactoryInput<CommitmentCostCodeSummary, CommitmentCostCodeSummaryOptions>;
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions> | null;
  canEditLineItems?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canBeReleased?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canBeReleasedWithinBudget?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  isBidCommitment?: Commitment["isBidCommitment"];
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions> | null;
  canBeVoided?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canBeEdited?: Commitment["canBeEdited"];
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  items?: Array<FactoryInput<Item, ItemOptions>>;
  potentialBidContractRevisions?: Array<
    FactoryInput<PotentialBidContractRevision, PotentialBidContractRevisionOptions>
  >;
  pandaDocRecipients?: Array<FactoryInput<PandaDocIntendedRecipient, PandaDocIntendedRecipientOptions>>;
  preferredBidContractRevision?: FactoryInput<PotentialBidContractRevision, PotentialBidContractRevisionOptions> | null;
  history?: Array<FactoryInput<History, HistoryOptions>> | null;
  tradeSignatory?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  readyPlanConfigOptions?:
    | Array<FactoryInput<ProjectReadyPlanConfigOption, ProjectReadyPlanConfigOptionOptions>>
    | null;
  percentagePaid?: Commitment["percentagePaid"];
  releaseWhenReady?: Commitment["releaseWhenReady"];
  eventuallyVoidedBy?: FactoryInput<Commitment, CommitmentOptions> | null;
  voidsCommitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  sentDate?: Commitment["sentDate"];
  depositInBasisPoints?: Commitment["depositInBasisPoints"];
  depositScheduleTask?: FactoryInput<Task, TaskOptions> | null;
  depositBill?: FactoryInput<Bill, BillOptions> | null;
  referenceNumber?: Commitment["referenceNumber"];
  drop?: FactoryInput<Drop, DropOptions> | null;
  draws?: Array<FactoryInput<CommitmentDraw, CommitmentDrawOptions>>;
  canEditDraws?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  billingSchedule?: Array<FactoryInput<CommitmentBillingScheduleItem, CommitmentBillingScheduleItemOptions>>;
}

export function newCommitment(options?: CommitmentOptions, factoryOptions?: FactoryOptions): FactoryResult<Commitment>;
export function newCommitment(
  options: CommitmentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Commitment> {
  const o = (options.__typename ? options : cache["Commitment"] = {}) as Commitment;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Commitment";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Commitment");
    o.accountingNumber = options.accountingNumber ?? 0;
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.shortName = options.shortName ?? "shortName";
    o.commitmentType = enumOrDetailOfCommitmentType(options.commitmentType);
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.internalNote = options.internalNote ?? null;
    o.costChangeInCents = options.costChangeInCents ?? 0;
    o.executionDate = options.executionDate ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
    o.canCreatePandaDoc = maybeNew(
      "PotentialOperation2",
      options.canCreatePandaDoc,
      cache,
      options.hasOwnProperty("canCreatePandaDoc"),
    );
    o.changeOrders = (options.changeOrders ?? []).map((i) =>
      maybeNew("CommitmentChangeOrder", i, cache, options.hasOwnProperty("changeOrders"))
    );
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
    o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
      maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
    );
    o.lineItemSummaries = (options.lineItemSummaries ?? []).map((i) =>
      maybeNew("CommitmentLineItemSummary", i, cache, options.hasOwnProperty("lineItemSummaries"))
    );
    o.committedInCents = options.committedInCents ?? 0;
    o.taxableCostInCents = options.taxableCostInCents ?? 0;
    o.remainingInCents = options.remainingInCents ?? 0;
    o.pendingRemainingInCents = options.pendingRemainingInCents ?? 0;
    o.billedInCents = options.billedInCents ?? null;
    o.pendingBilledInCents = options.pendingBilledInCents ?? null;
    o.unbilledInCents = options.unbilledInCents ?? 0;
    o.paidInCents = options.paidInCents ?? null;
    o.balanceInCents = options.balanceInCents ?? null;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.protoCommitmentLineItemsToBuyout = (options.protoCommitmentLineItemsToBuyout ?? []).map((i) =>
      maybeNew("ProtoCommitmentLineItemToBuyout", i, cache, options.hasOwnProperty("protoCommitmentLineItemsToBuyout"))
    );
    o.hasPartiallyBoughtOutScope = options.hasPartiallyBoughtOutScope ?? false;
    o.status = options.status ?? CommitmentStatus.Draft;
    o.statusDetail = enumOrDetailOfCommitmentStatus(options.statusDetail);
    o.statusText = options.statusText ?? "statusText";
    o.developmentCommitment = maybeNewOrNull("DevelopmentCommitment", options.developmentCommitment, cache);
    o.contractExhibits = options.contractExhibits ?? null;
    o.contractSchedule = options.contractSchedule ?? null;
    o.contractTerms = options.contractTerms ?? null;
    o.contractExclusions = options.contractExclusions ?? null;
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
      maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
    );
    o.costTypes = (options.costTypes ?? []).map((i) => enumOrDetailOfCostType(i));
    o.costCodeSummary = maybeNew(
      "CommitmentCostCodeSummary",
      options.costCodeSummary,
      cache,
      options.hasOwnProperty("costCodeSummary"),
    );
    o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
    o.canEditLineItems = maybeNew(
      "PotentialOperation2",
      options.canEditLineItems,
      cache,
      options.hasOwnProperty("canEditLineItems"),
    );
    o.canBeReleased = maybeNew(
      "PotentialOperation2",
      options.canBeReleased,
      cache,
      options.hasOwnProperty("canBeReleased"),
    );
    o.canBeReleasedWithinBudget = maybeNew(
      "PotentialOperation2",
      options.canBeReleasedWithinBudget,
      cache,
      options.hasOwnProperty("canBeReleasedWithinBudget"),
    );
    o.isBidCommitment = options.isBidCommitment ?? false;
    o.bidContractRevision = maybeNewOrNull("BidContractRevision", options.bidContractRevision, cache);
    o.canBeVoided = maybeNew("PotentialOperation2", options.canBeVoided, cache, options.hasOwnProperty("canBeVoided"));
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.canBeEdited = options.canBeEdited ?? false;
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
    o.potentialBidContractRevisions = (options.potentialBidContractRevisions ?? []).map((i) =>
      maybeNew("PotentialBidContractRevision", i, cache, options.hasOwnProperty("potentialBidContractRevisions"))
    );
    o.pandaDocRecipients = (options.pandaDocRecipients ?? []).map((i) =>
      maybeNew("PandaDocIntendedRecipient", i, cache, options.hasOwnProperty("pandaDocRecipients"))
    );
    o.preferredBidContractRevision = maybeNewOrNull(
      "PotentialBidContractRevision",
      options.preferredBidContractRevision,
      cache,
    );
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.tradeSignatory = maybeNewOrNull("TradePartnerContact", options.tradeSignatory, cache);
    o.readyPlanConfigOptions = (options.readyPlanConfigOptions ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfigOption", i, cache, options.hasOwnProperty("readyPlanConfigOptions"))
    );
    o.percentagePaid = options.percentagePaid ?? 0;
    o.releaseWhenReady = options.releaseWhenReady ?? null;
    o.eventuallyVoidedBy = maybeNewOrNull("Commitment", options.eventuallyVoidedBy, cache);
    o.voidsCommitments = (options.voidsCommitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("voidsCommitments"))
    );
    o.sentDate = options.sentDate ?? null;
    o.depositInBasisPoints = options.depositInBasisPoints ?? null;
    o.depositScheduleTask = maybeNewOrNull("Task", options.depositScheduleTask, cache);
    o.depositBill = maybeNewOrNull("Bill", options.depositBill, cache);
    o.referenceNumber = options.referenceNumber ?? null;
    o.drop = maybeNewOrNull("Drop", options.drop, cache);
    o.draws = (options.draws ?? []).map((i) => maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("draws")));
    o.canEditDraws = maybeNew(
      "PotentialOperation2",
      options.canEditDraws,
      cache,
      options.hasOwnProperty("canEditDraws"),
    );
    o.billingSchedule = (options.billingSchedule ?? []).map((i) =>
      maybeNew("CommitmentBillingScheduleItem", i, cache, options.hasOwnProperty("billingSchedule"))
    );
    return o as FactoryResult<Commitment>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Commitment"] = newCommitment;

export interface DocumentOptions {
  __typename?: "Document";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: Document["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: Document["isFollowed"];
  id?: Document["id"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  name?: Document["name"];
  sizeInBytes?: Document["sizeInBytes"];
  url?: Document["url"];
  displayName?: Document["displayName"];
  homeownerVisible?: Document["homeownerVisible"];
  asset?: FactoryInput<Asset, AssetOptions>;
  createdAt?: Document["createdAt"];
  updatedAt?: Document["updatedAt"];
  createdBy?: FactoryInput<User, UserOptions>;
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions> | null;
  assets?: Array<FactoryInput<Asset, AssetOptions>>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  isDeleted?: Document["isDeleted"];
  parent?:
    | DocumentParent
    | FactoryResult<DocumentParent>
    | DevelopmentOptions
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  category?: Document["category"];
  categoryDetail?: DocumentCategoryDetailOptions | DocumentCategory | null;
  tasks?: Array<FactoryInput<Task, TaskOptions>>;
  isFavorited?: Document["isFavorited"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  issuanceDate?: Document["issuanceDate"];
  ownerWorkAuthorization?: FactoryInput<WorkAuthorization, WorkAuthorizationOptions> | null;
  associatedProjects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  owner?:
    | DocumentOwner
    | FactoryResult<DocumentOwner>
    | HomeownerContractOptions
    | RequireTypename<HomeownerContractChangeOrderOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DevelopmentCommitmentOptions>
    | RequireTypename<InvoiceDocumentOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<BidContractRevisionOptions>
    | RequireTypename<LienWaiverOptions>
    | RequireTypename<ChangeEventOptions>
    | null;
  homeownerContract?: FactoryInput<HomeownerContract, HomeownerContractOptions> | null;
  homeownerContractChangeOrder?: FactoryInput<HomeownerContractChangeOrder, HomeownerContractChangeOrderOptions> | null;
  attachOn?: Document["attachOn"];
  lienWaiver?: FactoryInput<LienWaiver, LienWaiverOptions> | null;
  active?: Document["active"];
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canArchive?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newDocument(options?: DocumentOptions, factoryOptions?: FactoryOptions): FactoryResult<Document>;
export function newDocument(
  options: DocumentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Document> {
  const o = (options.__typename ? options : cache["Document"] = {}) as Document;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Document";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("Document");
    o.documentType = enumOrDetailOfDocumentType(options.documentType);
    o.name = options.name ?? "name";
    o.sizeInBytes = options.sizeInBytes ?? 0;
    o.url = options.url ?? "url";
    o.displayName = options.displayName ?? "displayName";
    o.homeownerVisible = options.homeownerVisible ?? false;
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
    o.assets = (options.assets ?? []).map((i) => maybeNew("Asset", i, cache, options.hasOwnProperty("assets")));
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.isDeleted = options.isDeleted ?? null;
    o.parent = maybeNew(options.parent?.__typename ?? "Development", options.parent, cache);
    o.category = options.category ?? DocumentCategory.Contractual;
    o.categoryDetail = enumOrDetailOrNullOfDocumentCategory(options.categoryDetail);
    o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
    o.isFavorited = options.isFavorited ?? false;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.issuanceDate = options.issuanceDate ?? null;
    o.ownerWorkAuthorization = maybeNewOrNull("WorkAuthorization", options.ownerWorkAuthorization, cache);
    o.associatedProjects = (options.associatedProjects ?? []).map((i) =>
      maybeNew("Project", i, cache, options.hasOwnProperty("associatedProjects"))
    );
    o.owner = maybeNewOrNull(options.owner?.__typename ?? "HomeownerContract", options.owner, cache);
    o.homeownerContract = maybeNewOrNull("HomeownerContract", options.homeownerContract, cache);
    o.homeownerContractChangeOrder = maybeNewOrNull(
      "HomeownerContractChangeOrder",
      options.homeownerContractChangeOrder,
      cache,
    );
    o.attachOn = options.attachOn ?? [];
    o.lienWaiver = maybeNewOrNull("LienWaiver", options.lienWaiver, cache);
    o.active = options.active ?? false;
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.canArchive = maybeNew("PotentialOperation2", options.canArchive, cache, options.hasOwnProperty("canArchive"));
    return o as FactoryResult<Document>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Document"] = newDocument;

export interface ItemTemplateItemVersionOptions {
  __typename?: "ItemTemplateItemVersion";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ItemTemplateItemVersion["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ItemTemplateItemVersion["isFollowed"];
  id?: ItemTemplateItemVersion["id"];
  identityId?: ItemTemplateItemVersion["identityId"];
  createdAt?: ItemTemplateItemVersion["createdAt"];
  updatedAt?: ItemTemplateItemVersion["updatedAt"];
  template?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  scope?: FactoryInput<ItemTemplateItem, ItemTemplateItemOptions>;
  scopeChangeType?: ItemTemplateItemVersion["scopeChangeType"];
  scopeChangeTypeDetail?: ScopeChangeTypeDetailOptions | ScopeChangeType;
  scopeChangeReason?: FactoryInput<ScopeChangeReason, ScopeChangeReasonOptions> | null;
  slot?: FactoryInput<ItemSlot, ItemSlotOptions>;
  item?: FactoryInput<Item, ItemOptions>;
  location?: FactoryInput<Location, LocationOptions>;
  quantity?: ItemTemplateItemVersion["quantity"];
  costType?: ItemTemplateItemVersion["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  specifications?: ItemTemplateItemVersion["specifications"];
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  tradePartnerNote?: ItemTemplateItemVersion["tradePartnerNote"];
  internalNote?: ItemTemplateItemVersion["internalNote"];
  name?: ItemTemplateItemVersion["name"];
  displayName?: ItemTemplateItemVersion["displayName"];
  parent?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  first?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  basedOn?: FactoryInput<ItemTemplateItem, ItemTemplateItemOptions> | null;
  totalCostInCents?: ItemTemplateItemVersion["totalCostInCents"];
  unitCostInCents?: ItemTemplateItemVersion["unitCostInCents"];
  canDeleteItem?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  preferredBidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  bidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  bidItemTemplateItem?: FactoryInput<ItemTemplateItem, ItemTemplateItemOptions> | null;
  potentialBidItems?: Array<FactoryInput<BidItem, BidItemOptions>>;
  elevationIds?: ItemTemplateItemVersion["elevationIds"];
  specOptionIds?: ItemTemplateItemVersion["specOptionIds"];
  otherOptionIds?: ItemTemplateItemVersion["otherOptionIds"];
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  customPlaceholderName?: ItemTemplateItemVersion["customPlaceholderName"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  scopeChangeReasonNote?: ItemTemplateItemVersion["scopeChangeReasonNote"];
  task?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  costEstimate?: FactoryInput<CostEstimate, CostEstimateOptions>;
}

export function newItemTemplateItemVersion(
  options?: ItemTemplateItemVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersion>;
export function newItemTemplateItemVersion(
  options: ItemTemplateItemVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateItemVersion> {
  const o = (options.__typename ? options : cache["ItemTemplateItemVersion"] = {}) as ItemTemplateItemVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateItemVersion";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("ItemTemplateItemVersion");
    o.identityId = options.identityId ?? "identityId";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.template = maybeNew("ItemTemplate", options.template, cache, options.hasOwnProperty("template"));
    o.scope = maybeNew("ItemTemplateItem", options.scope, cache, options.hasOwnProperty("scope"));
    o.scopeChangeType = options.scopeChangeType ?? ScopeChangeType.None;
    o.scopeChangeTypeDetail = enumOrDetailOfScopeChangeType(options.scopeChangeTypeDetail);
    o.scopeChangeReason = maybeNewOrNull("ScopeChangeReason", options.scopeChangeReason, cache);
    o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.quantity = options.quantity ?? null;
    o.costType = options.costType ?? CostType.Labor;
    o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
    o.specifications = options.specifications ?? null;
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.internalNote = options.internalNote ?? null;
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.parent = maybeNew("ItemTemplate", options.parent, cache, options.hasOwnProperty("parent"));
    o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.first = maybeNew("ItemTemplate", options.first, cache, options.hasOwnProperty("first"));
    o.basedOn = maybeNewOrNull("ItemTemplateItem", options.basedOn, cache);
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.unitCostInCents = options.unitCostInCents ?? 0;
    o.canDeleteItem = maybeNew(
      "PotentialOperation2",
      options.canDeleteItem,
      cache,
      options.hasOwnProperty("canDeleteItem"),
    );
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
    o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
    o.bidItemTemplateItem = maybeNewOrNull("ItemTemplateItem", options.bidItemTemplateItem, cache);
    o.potentialBidItems = (options.potentialBidItems ?? []).map((i) =>
      maybeNew("BidItem", i, cache, options.hasOwnProperty("potentialBidItems"))
    );
    o.elevationIds = options.elevationIds ?? [];
    o.specOptionIds = options.specOptionIds ?? [];
    o.otherOptionIds = options.otherOptionIds ?? [];
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.customPlaceholderName = options.customPlaceholderName ?? null;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.scopeChangeReasonNote = options.scopeChangeReasonNote ?? null;
    o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
    o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
    return o as FactoryResult<ItemTemplateItemVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateItemVersion"] = newItemTemplateItemVersion;

export interface JobLogNoteOptions {
  __typename?: "JobLogNote";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: JobLogNote["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: JobLogNote["isFollowed"];
  id?: JobLogNote["id"];
  name?: JobLogNote["name"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  title?: JobLogNote["title"];
  content?: JobLogNote["content"];
  createdAt?: JobLogNote["createdAt"];
  updatedAt?: JobLogNote["updatedAt"];
  type?: JobLogNote["type"];
  typeDetail?: JobLogNoteTypeDetailOptions | JobLogNoteType | null;
  internalUser?: FactoryInput<InternalUser, InternalUserOptions>;
  jobLog?: FactoryInput<JobLog, JobLogOptions>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  jobLogImages?: Array<FactoryInput<JobLogImage, JobLogImageOptions>> | null;
  flags?: JobLogNote["flags"];
  scheduleTasks?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  history?: Array<FactoryInput<History, HistoryOptions>>;
  clientPlatform?: ClientPlatformDetailOptions | ClientPlatform;
  additionalContext?: JobLogNote["additionalContext"];
  summarizedByAiNote?: FactoryInput<JobLogNote, JobLogNoteOptions> | null;
  summarizedNotes?: Array<FactoryInput<JobLogNote, JobLogNoteOptions>>;
}

export function newJobLogNote(options?: JobLogNoteOptions, factoryOptions?: FactoryOptions): FactoryResult<JobLogNote>;
export function newJobLogNote(
  options: JobLogNoteOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<JobLogNote> {
  const o = (options.__typename ? options : cache["JobLogNote"] = {}) as JobLogNote;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "JobLogNote";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("JobLogNote");
    o.name = options.name ?? "name";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.title = options.title ?? null;
    o.content = options.content ?? "content";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.type = options.type ?? null;
    o.typeDetail = enumOrDetailOrNullOfJobLogNoteType(options.typeDetail);
    o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
    o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.jobLogImages = (options.jobLogImages ?? []).map((i) =>
      maybeNew("JobLogImage", i, cache, options.hasOwnProperty("jobLogImages"))
    );
    o.flags = options.flags ?? [];
    o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
    );
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.clientPlatform = enumOrDetailOfClientPlatform(options.clientPlatform);
    o.additionalContext = options.additionalContext ?? null;
    o.summarizedByAiNote = maybeNewOrNull("JobLogNote", options.summarizedByAiNote, cache);
    o.summarizedNotes = (options.summarizedNotes ?? []).map((i) =>
      maybeNew("JobLogNote", i, cache, options.hasOwnProperty("summarizedNotes"))
    );
    return o as FactoryResult<JobLogNote>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["JobLogNote"] = newJobLogNote;

export interface TradePartnerAvailabilityRequestOptions {
  __typename?: "TradePartnerAvailabilityRequest";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: TradePartnerAvailabilityRequest["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: TradePartnerAvailabilityRequest["isFollowed"];
  id?: TradePartnerAvailabilityRequest["id"];
  name?: TradePartnerAvailabilityRequest["name"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  createdAt?: TradePartnerAvailabilityRequest["createdAt"];
  updatedAt?: TradePartnerAvailabilityRequest["updatedAt"];
  internalUser?: FactoryInput<InternalUser, InternalUserOptions>;
  task?: FactoryInput<Task, TaskOptions>;
  tradePartnerContacts?: Array<FactoryInput<TradePartnerContact, TradePartnerContactOptions>>;
  tradePartnerConfirmationDate?: TradePartnerAvailabilityRequest["tradePartnerConfirmationDate"];
  emails?: Array<FactoryInput<TradePartnerAvailabilityRequestEmail, TradePartnerAvailabilityRequestEmailOptions>>;
  textMessages?: Array<
    FactoryInput<TradePartnerAvailabilityRequestTextMessage, TradePartnerAvailabilityRequestTextMessageOptions>
  >;
  rescheduleDates?: TradePartnerAvailabilityRequest["rescheduleDates"] | null;
  status?: TradePartnerAvailabilityRequestStatusDetailOptions | TradePartnerAvailabilityRequestStatus;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  canSave?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  rescheduleReasonNote?: TradePartnerAvailabilityRequest["rescheduleReasonNote"];
}

export function newTradePartnerAvailabilityRequest(
  options?: TradePartnerAvailabilityRequestOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequest>;
export function newTradePartnerAvailabilityRequest(
  options: TradePartnerAvailabilityRequestOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerAvailabilityRequest> {
  const o =
    (options.__typename ? options : cache["TradePartnerAvailabilityRequest"] = {}) as TradePartnerAvailabilityRequest;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerAvailabilityRequest";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("TradePartnerAvailabilityRequest");
    o.name = options.name ?? "name";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    o.tradePartnerContacts = (options.tradePartnerContacts ?? []).map((i) =>
      maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("tradePartnerContacts"))
    );
    o.tradePartnerConfirmationDate = options.tradePartnerConfirmationDate ?? null;
    o.emails = (options.emails ?? []).map((i) =>
      maybeNew("TradePartnerAvailabilityRequestEmail", i, cache, options.hasOwnProperty("emails"))
    );
    o.textMessages = (options.textMessages ?? []).map((i) =>
      maybeNew("TradePartnerAvailabilityRequestTextMessage", i, cache, options.hasOwnProperty("textMessages"))
    );
    o.rescheduleDates = options.rescheduleDates ?? [];
    o.status = enumOrDetailOfTradePartnerAvailabilityRequestStatus(options.status);
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.canSave = maybeNew("PotentialOperation2", options.canSave, cache, options.hasOwnProperty("canSave"));
    o.rescheduleReasonNote = options.rescheduleReasonNote ?? null;
    return o as FactoryResult<TradePartnerAvailabilityRequest>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerAvailabilityRequest"] = newTradePartnerAvailabilityRequest;

export interface PunchlistItemTodoOptions {
  __typename?: "PunchlistItemTodo";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: PunchlistItemTodo["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: PunchlistItemTodo["isFollowed"];
  id?: PunchlistItemTodo["id"];
  name?: PunchlistItemTodo["name"];
  description?: PunchlistItemTodo["description"];
  deletedAt?: PunchlistItemTodo["deletedAt"];
  createdAt?: PunchlistItemTodo["createdAt"];
  updatedAt?: PunchlistItemTodo["updatedAt"];
  dueDate?: PunchlistItemTodo["dueDate"];
  order?: PunchlistItemTodo["order"];
  urgent?: PunchlistItemTodo["urgent"];
  status?: ToDoStatusDetailOptions | ToDoStatus;
  type?: ToDoTypeDetailOptions | ToDoType;
  createdBy?: FactoryInput<User, UserOptions>;
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
  assignees?: Array<FactoryInput<User, UserOptions>>;
  parent?:
    | ToDoParent
    | FactoryResult<ToDoParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<CohortOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | null;
  location?: FactoryInput<Location, LocationOptions> | null;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
}

export function newPunchlistItemTodo(
  options?: PunchlistItemTodoOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PunchlistItemTodo>;
export function newPunchlistItemTodo(
  options: PunchlistItemTodoOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PunchlistItemTodo> {
  const o = (options.__typename ? options : cache["PunchlistItemTodo"] = {}) as PunchlistItemTodo;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PunchlistItemTodo";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("PunchlistItemTodo");
    o.name = options.name ?? "name";
    o.description = options.description ?? null;
    o.deletedAt = options.deletedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.dueDate = options.dueDate ?? null;
    o.order = options.order ?? "order";
    o.urgent = options.urgent ?? false;
    o.status = enumOrDetailOfToDoStatus(options.status);
    o.type = enumOrDetailOfToDoType(options.type);
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    o.assignees = (options.assignees ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("assignees")));
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    o.location = maybeNewOrNull("Location", options.location, cache);
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    return o as FactoryResult<PunchlistItemTodo>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PunchlistItemTodo"] = newPunchlistItemTodo;

export interface WarrantyTicketOptions {
  __typename?: "WarrantyTicket";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: WarrantyTicket["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: WarrantyTicket["isFollowed"];
  id?: WarrantyTicket["id"];
  createdAt?: WarrantyTicket["createdAt"];
  updatedAt?: WarrantyTicket["updatedAt"];
  name?: WarrantyTicket["name"];
  type?: WarrantyTicketTypeDetailOptions | WarrantyTicketType | null;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  projectContacts?: Array<FactoryInput<ProjectContact, ProjectContactOptions>>;
  availabilities?: Array<FactoryInput<WarrantyTicketAvailability, WarrantyTicketAvailabilityOptions>>;
  items?: Array<FactoryInput<WarrantyTicketItem, WarrantyTicketItemOptions>>;
  title?: WarrantyTicket["title"];
  homeownerVisible?: WarrantyTicket["homeownerVisible"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  urgent?: WarrantyTicket["urgent"];
  history?: Array<FactoryInput<History, HistoryOptions>>;
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
  totalItems?: WarrantyTicket["totalItems"];
  totalAvailableItems?: WarrantyTicket["totalAvailableItems"];
  totalCompletedItems?: WarrantyTicket["totalCompletedItems"];
  totalRejectedItems?: WarrantyTicket["totalRejectedItems"];
  status?: WarrantyTicketStatusDetailOptions | WarrantyTicketStatus;
  assignees?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
}

export function newWarrantyTicket(
  options?: WarrantyTicketOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicket>;
export function newWarrantyTicket(
  options: WarrantyTicketOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WarrantyTicket> {
  const o = (options.__typename ? options : cache["WarrantyTicket"] = {}) as WarrantyTicket;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WarrantyTicket";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("WarrantyTicket");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.name = options.name ?? "name";
    o.type = enumOrDetailOrNullOfWarrantyTicketType(options.type);
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.projectContacts = (options.projectContacts ?? []).map((i) =>
      maybeNew("ProjectContact", i, cache, options.hasOwnProperty("projectContacts"))
    );
    o.availabilities = (options.availabilities ?? []).map((i) =>
      maybeNew("WarrantyTicketAvailability", i, cache, options.hasOwnProperty("availabilities"))
    );
    o.items = (options.items ?? []).map((i) =>
      maybeNew("WarrantyTicketItem", i, cache, options.hasOwnProperty("items"))
    );
    o.title = options.title ?? "title";
    o.homeownerVisible = options.homeownerVisible ?? false;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.urgent = options.urgent ?? false;
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    o.totalItems = options.totalItems ?? 0;
    o.totalAvailableItems = options.totalAvailableItems ?? 0;
    o.totalCompletedItems = options.totalCompletedItems ?? 0;
    o.totalRejectedItems = options.totalRejectedItems ?? 0;
    o.status = enumOrDetailOfWarrantyTicketStatus(options.status);
    o.assignees = (options.assignees ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("assignees"))
    );
    return o as FactoryResult<WarrantyTicket>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WarrantyTicket"] = newWarrantyTicket;

export interface HomeownerContractOptions {
  __typename?: "HomeownerContract";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: HomeownerContract["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: HomeownerContract["isFollowed"];
  id?: HomeownerContract["id"];
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  name?: HomeownerContract["name"];
  internalNote?: HomeownerContract["internalNote"];
  priceChangeInCents?: HomeownerContract["priceChangeInCents"];
  budgetChangeInCents?: HomeownerContract["budgetChangeInCents"];
  invoicedInCents?: HomeownerContract["invoicedInCents"];
  amountPaidInCents?: HomeownerContract["amountPaidInCents"];
  balanceInCents?: HomeownerContract["balanceInCents"];
  uninvoicedInCents?: HomeownerContract["uninvoicedInCents"];
  executionDate?: HomeownerContract["executionDate"];
  contractType?: HomeownerContract["contractType"];
  contractTypeDetail?: ContractTypeDetailOptions | ContractType;
  costPlusMarkupBasisPoints?: HomeownerContract["costPlusMarkupBasisPoints"];
  document?: FactoryInput<Document, DocumentOptions> | null;
  draws?: Array<FactoryInput<HomeownerContractDraw, HomeownerContractDrawOptions>>;
  changeOrders?: Array<FactoryInput<HomeownerContractChangeOrder, HomeownerContractChangeOrderOptions>>;
  lineItems?: Array<FactoryInput<HomeownerContractLineItem, HomeownerContractLineItemOptions>>;
  lineItemsByProjectItem?: Array<
    FactoryInput<HomeownerContractLineItemsByProjectItem, HomeownerContractLineItemsByProjectItemOptions>
  >;
  title?: HomeownerContract["title"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  softCostBudgetInCents?: HomeownerContract["softCostBudgetInCents"];
  directHardCostBudgetInCents?: HomeownerContract["directHardCostBudgetInCents"];
  indirectHardCostBudgetInCents?: HomeownerContract["indirectHardCostBudgetInCents"];
  totalMarkupInCents?: HomeownerContract["totalMarkupInCents"];
  annotatedCosts?: Array<FactoryInput<AnnotatedCost, AnnotatedCostOptions>>;
  projectFinancials?: Array<FactoryInput<ContractProjectFinancials, ContractProjectFinancialsOptions>>;
}

export function newHomeownerContract(
  options?: HomeownerContractOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContract>;
export function newHomeownerContract(
  options: HomeownerContractOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeownerContract> {
  const o = (options.__typename ? options : cache["HomeownerContract"] = {}) as HomeownerContract;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "HomeownerContract";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("HomeownerContract");
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.name = options.name ?? "name";
    o.internalNote = options.internalNote ?? null;
    o.priceChangeInCents = options.priceChangeInCents ?? 0;
    o.budgetChangeInCents = options.budgetChangeInCents ?? 0;
    o.invoicedInCents = options.invoicedInCents ?? null;
    o.amountPaidInCents = options.amountPaidInCents ?? null;
    o.balanceInCents = options.balanceInCents ?? null;
    o.uninvoicedInCents = options.uninvoicedInCents ?? null;
    o.executionDate = options.executionDate ?? null;
    o.contractType = options.contractType ?? ContractType.Fixed;
    o.contractTypeDetail = enumOrDetailOfContractType(options.contractTypeDetail);
    o.costPlusMarkupBasisPoints = options.costPlusMarkupBasisPoints ?? null;
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.draws = (options.draws ?? []).map((i) =>
      maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("draws"))
    );
    o.changeOrders = (options.changeOrders ?? []).map((i) =>
      maybeNew("HomeownerContractChangeOrder", i, cache, options.hasOwnProperty("changeOrders"))
    );
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.lineItemsByProjectItem = (options.lineItemsByProjectItem ?? []).map((i) =>
      maybeNew("HomeownerContractLineItemsByProjectItem", i, cache, options.hasOwnProperty("lineItemsByProjectItem"))
    );
    o.title = options.title ?? "title";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.softCostBudgetInCents = options.softCostBudgetInCents ?? 0;
    o.directHardCostBudgetInCents = options.directHardCostBudgetInCents ?? 0;
    o.indirectHardCostBudgetInCents = options.indirectHardCostBudgetInCents ?? 0;
    o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
    o.annotatedCosts = (options.annotatedCosts ?? []).map((i) =>
      maybeNew("AnnotatedCost", i, cache, options.hasOwnProperty("annotatedCosts"))
    );
    o.projectFinancials = (options.projectFinancials ?? []).map((i) =>
      maybeNew("ContractProjectFinancials", i, cache, options.hasOwnProperty("projectFinancials"))
    );
    return o as FactoryResult<HomeownerContract>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["HomeownerContract"] = newHomeownerContract;

export interface HomeownerContractChangeOrderOptions {
  __typename?: "HomeownerContractChangeOrder";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: HomeownerContractChangeOrder["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: HomeownerContractChangeOrder["isFollowed"];
  id?: HomeownerContractChangeOrder["id"];
  contract?: FactoryInput<HomeownerContract, HomeownerContractOptions>;
  identifier?: HomeownerContractChangeOrder["identifier"];
  name?: HomeownerContractChangeOrder["name"];
  shortName?: HomeownerContractChangeOrder["shortName"];
  internalNote?: HomeownerContractChangeOrder["internalNote"];
  priceChangeInCents?: HomeownerContractChangeOrder["priceChangeInCents"];
  budgetChangeInCents?: HomeownerContractChangeOrder["budgetChangeInCents"];
  invoicedInCents?: HomeownerContractChangeOrder["invoicedInCents"];
  amountPaidInCents?: HomeownerContractChangeOrder["amountPaidInCents"];
  balanceInCents?: HomeownerContractChangeOrder["balanceInCents"];
  uninvoicedInCents?: HomeownerContractChangeOrder["uninvoicedInCents"];
  executionDate?: HomeownerContractChangeOrder["executionDate"];
  contractType?: HomeownerContractChangeOrder["contractType"];
  costPlusMarkupBasisPoints?: HomeownerContractChangeOrder["costPlusMarkupBasisPoints"];
  document?: FactoryInput<Document, DocumentOptions> | null;
  draws?: Array<FactoryInput<HomeownerContractDraw, HomeownerContractDrawOptions>>;
  lineItems?: Array<FactoryInput<HomeownerContractLineItem, HomeownerContractLineItemOptions>>;
  title?: HomeownerContractChangeOrder["title"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions> | null;
  estimate?: FactoryInput<Estimate, EstimateOptions> | null;
  softCostBudgetInCents?: HomeownerContractChangeOrder["softCostBudgetInCents"];
  directHardCostBudgetInCents?: HomeownerContractChangeOrder["directHardCostBudgetInCents"];
  indirectHardCostBudgetInCents?: HomeownerContractChangeOrder["indirectHardCostBudgetInCents"];
  totalMarkupInCents?: HomeownerContractChangeOrder["totalMarkupInCents"];
  annotatedCosts?: Array<FactoryInput<AnnotatedCost, AnnotatedCostOptions>>;
  projectFinancials?: Array<FactoryInput<ContractProjectFinancials, ContractProjectFinancialsOptions>>;
  isContractAddendum?: HomeownerContractChangeOrder["isContractAddendum"];
}

export function newHomeownerContractChangeOrder(
  options?: HomeownerContractChangeOrderOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractChangeOrder>;
export function newHomeownerContractChangeOrder(
  options: HomeownerContractChangeOrderOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeownerContractChangeOrder> {
  const o = (options.__typename ? options : cache["HomeownerContractChangeOrder"] = {}) as HomeownerContractChangeOrder;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "HomeownerContractChangeOrder";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("HomeownerContractChangeOrder");
    o.contract = maybeNew("HomeownerContract", options.contract, cache, options.hasOwnProperty("contract"));
    o.identifier = options.identifier ?? "identifier";
    o.name = options.name ?? "name";
    o.shortName = options.shortName ?? "shortName";
    o.internalNote = options.internalNote ?? null;
    o.priceChangeInCents = options.priceChangeInCents ?? 0;
    o.budgetChangeInCents = options.budgetChangeInCents ?? 0;
    o.invoicedInCents = options.invoicedInCents ?? null;
    o.amountPaidInCents = options.amountPaidInCents ?? null;
    o.balanceInCents = options.balanceInCents ?? null;
    o.uninvoicedInCents = options.uninvoicedInCents ?? null;
    o.executionDate = options.executionDate ?? null;
    o.contractType = options.contractType ?? ContractType.Fixed;
    o.costPlusMarkupBasisPoints = options.costPlusMarkupBasisPoints ?? null;
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.draws = (options.draws ?? []).map((i) =>
      maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("draws"))
    );
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.title = options.title ?? "title";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
    o.estimate = maybeNewOrNull("Estimate", options.estimate, cache);
    o.softCostBudgetInCents = options.softCostBudgetInCents ?? 0;
    o.directHardCostBudgetInCents = options.directHardCostBudgetInCents ?? 0;
    o.indirectHardCostBudgetInCents = options.indirectHardCostBudgetInCents ?? 0;
    o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
    o.annotatedCosts = (options.annotatedCosts ?? []).map((i) =>
      maybeNew("AnnotatedCost", i, cache, options.hasOwnProperty("annotatedCosts"))
    );
    o.projectFinancials = (options.projectFinancials ?? []).map((i) =>
      maybeNew("ContractProjectFinancials", i, cache, options.hasOwnProperty("projectFinancials"))
    );
    o.isContractAddendum = options.isContractAddendum ?? false;
    return o as FactoryResult<HomeownerContractChangeOrder>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["HomeownerContractChangeOrder"] = newHomeownerContractChangeOrder;

export interface ReadyPlanOptions {
  __typename?: "ReadyPlan";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ReadyPlan["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ReadyPlan["isFollowed"];
  id?: ReadyPlan["id"];
  name?: ReadyPlan["name"];
  displayName?: ReadyPlan["displayName"];
  description?: ReadyPlan["description"];
  createdAt?: ReadyPlan["createdAt"];
  updatedAt?: ReadyPlan["updatedAt"];
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  itemTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  hasOptions?: ReadyPlan["hasOptions"];
  code?: ReadyPlan["code"];
  activeOptionsCount?: ReadyPlan["activeOptionsCount"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType | null;
  isValidForReadyPlanConfiguration?: ReadyPlan["isValidForReadyPlanConfiguration"];
  displayCode?: ReadyPlan["displayCode"];
  programData?: FactoryInput<ProgramData, ProgramDataOptions>;
  maxProgramData?: FactoryInput<ProgramData, ProgramDataOptions>;
  minProgramData?: FactoryInput<ProgramData, ProgramDataOptions>;
  optionGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  userEvents?: Array<FactoryInput<UserEvent, UserEventOptions>>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  underwritingTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions> | null;
  constructionDocumentCompletePercentage?: ReadyPlan["constructionDocumentCompletePercentage"];
  programDatas?: Array<FactoryInput<ReadyPlanProgramData, ReadyPlanProgramDataOptions>>;
  assets?: Array<FactoryInput<ReadyPlanAsset, ReadyPlanAssetOptions>>;
  lotTypes?: ReadyPlan["lotTypes"];
  aggregateActive?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  aggregateDraft?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  aggregateLatest?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  aggregateVersions?: Array<FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>>;
  version?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  itemLocations?: Array<FactoryInput<Location, LocationOptions>>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  canCreateNewVersion?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditLineItems?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  contingencyMarkupPercentage?: ReadyPlan["contingencyMarkupPercentage"];
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  requiredOptions?: Array<FactoryInput<ReadyPlanRequiredOption, ReadyPlanRequiredOptionOptions>>;
  projectConfigs?: Array<FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>>;
  owner?: FactoryInput<InternalUser, InternalUserOptions> | null;
  cloneInProgress?: ReadyPlan["cloneInProgress"];
}

export function newReadyPlan(options?: ReadyPlanOptions, factoryOptions?: FactoryOptions): FactoryResult<ReadyPlan>;
export function newReadyPlan(
  options: ReadyPlanOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlan> {
  const o = (options.__typename ? options : cache["ReadyPlan"] = {}) as ReadyPlan;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlan";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("ReadyPlan");
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = enumOrDetailOfReadyPlanStatus(options.status);
    o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
    );
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.hasOptions = options.hasOptions ?? false;
    o.code = options.code ?? null;
    o.activeOptionsCount = options.activeOptionsCount ?? 0;
    o.type = enumOrDetailOrNullOfReadyPlanType(options.type);
    o.isValidForReadyPlanConfiguration = options.isValidForReadyPlanConfiguration ?? false;
    o.displayCode = options.displayCode ?? null;
    o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
    o.maxProgramData = maybeNew("ProgramData", options.maxProgramData, cache, options.hasOwnProperty("maxProgramData"));
    o.minProgramData = maybeNew("ProgramData", options.minProgramData, cache, options.hasOwnProperty("minProgramData"));
    o.optionGroups = (options.optionGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
    );
    o.userEvents = (options.userEvents ?? []).map((i) =>
      maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
    );
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.underwritingTemplate = maybeNewOrNull("ItemTemplate", options.underwritingTemplate, cache);
    o.constructionDocumentCompletePercentage = options.constructionDocumentCompletePercentage ?? 0;
    o.programDatas = (options.programDatas ?? []).map((i) =>
      maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
    );
    o.assets = (options.assets ?? []).map((i) =>
      maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets"))
    );
    o.lotTypes = options.lotTypes ?? [];
    o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
    o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
    o.aggregateLatest = maybeNew(
      "ReadyPlanAggregateVersion",
      options.aggregateLatest,
      cache,
      options.hasOwnProperty("aggregateLatest"),
    );
    o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
      maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
    );
    o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
    o.itemLocations = (options.itemLocations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.canCreateNewVersion = maybeNew(
      "PotentialOperation2",
      options.canCreateNewVersion,
      cache,
      options.hasOwnProperty("canCreateNewVersion"),
    );
    o.canEditLineItems = maybeNew(
      "PotentialOperation2",
      options.canEditLineItems,
      cache,
      options.hasOwnProperty("canEditLineItems"),
    );
    o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
      maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
    );
    o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
    );
    o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
    o.cloneInProgress = options.cloneInProgress ?? false;
    return o as FactoryResult<ReadyPlan>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlan"] = newReadyPlan;

export interface PlanPackageOptions {
  __typename?: "PlanPackage";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: PlanPackage["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: PlanPackage["isFollowed"];
  id?: PlanPackage["id"];
  name?: PlanPackage["name"];
  displayName?: PlanPackage["displayName"];
  description?: PlanPackage["description"];
  createdAt?: PlanPackage["createdAt"];
  updatedAt?: PlanPackage["updatedAt"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  code?: PlanPackage["code"];
  displayCode?: PlanPackage["displayCode"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  constructionDocumentCompletePercentage?: PlanPackage["constructionDocumentCompletePercentage"];
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  maxProgramData?: FactoryInput<ProgramData, ProgramDataOptions>;
  minProgramData?: FactoryInput<ProgramData, ProgramDataOptions>;
  programData?: FactoryInput<ProgramData, ProgramDataOptions>;
  itemTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  takeoff?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  projectConfigs?: Array<FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>>;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  productOfferings?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  designPackages?: Array<FactoryInput<DesignPackage, DesignPackageOptions>>;
  designPackageSources?: Array<FactoryInput<DesignPackageSource, DesignPackageSourceOptions>>;
  incomingSlots?: Array<FactoryInput<PlanPackageIncomingSlot, PlanPackageIncomingSlotOptions>>;
  lotTypes?: PlanPackage["lotTypes"] | null;
  programDatas?: Array<FactoryInput<ReadyPlanProgramData, ReadyPlanProgramDataOptions>>;
  assets?: Array<FactoryInput<ReadyPlanAsset, ReadyPlanAssetOptions>>;
  activeOptionsCount?: PlanPackage["activeOptionsCount"];
  projectCount?: PlanPackage["projectCount"];
  designPackageCount?: PlanPackage["designPackageCount"];
  productOfferingCount?: PlanPackage["productOfferingCount"];
  asGlobalOption?: FactoryInput<GlobalOption, GlobalOptionOptions> | null;
  markets?: Array<FactoryInput<Market, MarketOptions>>;
  aggregateActive?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  aggregateDraft?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  aggregateLatest?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  aggregateVersions?: Array<FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>>;
  version?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  itemLocations?: Array<FactoryInput<Location, LocationOptions>>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  canEditLineItems?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  locations?: Array<FactoryInput<Location, LocationOptions>>;
  roomLocations?: Array<FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>>;
  contingencyMarkupPercentage?: PlanPackage["contingencyMarkupPercentage"];
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  insideMapsProjectId?: PlanPackage["insideMapsProjectId"];
  maxInsideMapsRooms?: PlanPackage["maxInsideMapsRooms"];
  insideMapsConfig?: PlanPackage["insideMapsConfig"];
  requiredOptions?: Array<FactoryInput<ReadyPlanRequiredOption, ReadyPlanRequiredOptionOptions>>;
  owner?: FactoryInput<InternalUser, InternalUserOptions> | null;
  cloneInProgress?: PlanPackage["cloneInProgress"];
  slotDeletionRequests?: Array<FactoryInput<PlanPackageSlotDeletionRequest, PlanPackageSlotDeletionRequestOptions>>;
  aiProposal?: FactoryInput<PlanPackageAiProposal, PlanPackageAiProposalOptions> | null;
  takeoffsStartedAt?: PlanPackage["takeoffsStartedAt"];
  takeoffsCompletedAt?: PlanPackage["takeoffsCompletedAt"];
}

export function newPlanPackage(
  options?: PlanPackageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newPlanPackage(
  options: PlanPackageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanPackage> {
  const o = (options.__typename ? options : cache["PlanPackage"] = {}) as PlanPackage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanPackage";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("PlanPackage");
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.type = enumOrDetailOfReadyPlanType(options.type);
    o.code = options.code ?? null;
    o.displayCode = options.displayCode ?? null;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.constructionDocumentCompletePercentage = options.constructionDocumentCompletePercentage ?? 0;
    o.status = enumOrDetailOfReadyPlanStatus(options.status);
    o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.maxProgramData = maybeNew("ProgramData", options.maxProgramData, cache, options.hasOwnProperty("maxProgramData"));
    o.minProgramData = maybeNew("ProgramData", options.minProgramData, cache, options.hasOwnProperty("minProgramData"));
    o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
    o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
    );
    o.takeoff = maybeNew("ItemTemplate", options.takeoff, cache, options.hasOwnProperty("takeoff"));
    o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
    );
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.optionGroups = (options.optionGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
    );
    o.productOfferings = (options.productOfferings ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
    );
    o.designPackages = (options.designPackages ?? []).map((i) =>
      maybeNew("DesignPackage", i, cache, options.hasOwnProperty("designPackages"))
    );
    o.designPackageSources = (options.designPackageSources ?? []).map((i) =>
      maybeNew("DesignPackageSource", i, cache, options.hasOwnProperty("designPackageSources"))
    );
    o.incomingSlots = (options.incomingSlots ?? []).map((i) =>
      maybeNew("PlanPackageIncomingSlot", i, cache, options.hasOwnProperty("incomingSlots"))
    );
    o.lotTypes = options.lotTypes ?? [];
    o.programDatas = (options.programDatas ?? []).map((i) =>
      maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
    );
    o.assets = (options.assets ?? []).map((i) =>
      maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets"))
    );
    o.activeOptionsCount = options.activeOptionsCount ?? 0;
    o.projectCount = options.projectCount ?? 0;
    o.designPackageCount = options.designPackageCount ?? 0;
    o.productOfferingCount = options.productOfferingCount ?? 0;
    o.asGlobalOption = maybeNewOrNull("GlobalOption", options.asGlobalOption, cache);
    o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
    o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
    o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
    o.aggregateLatest = maybeNew(
      "ReadyPlanAggregateVersion",
      options.aggregateLatest,
      cache,
      options.hasOwnProperty("aggregateLatest"),
    );
    o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
      maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
    );
    o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
    o.itemLocations = (options.itemLocations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.canEditLineItems = maybeNew(
      "PotentialOperation2",
      options.canEditLineItems,
      cache,
      options.hasOwnProperty("canEditLineItems"),
    );
    o.locations = (options.locations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
    );
    o.roomLocations = (options.roomLocations ?? []).map((i) =>
      maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("roomLocations"))
    );
    o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.insideMapsProjectId = options.insideMapsProjectId ?? null;
    o.maxInsideMapsRooms = options.maxInsideMapsRooms ?? 0;
    o.insideMapsConfig = options.insideMapsConfig ?? null;
    o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
      maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
    );
    o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
    o.cloneInProgress = options.cloneInProgress ?? false;
    o.slotDeletionRequests = (options.slotDeletionRequests ?? []).map((i) =>
      maybeNew("PlanPackageSlotDeletionRequest", i, cache, options.hasOwnProperty("slotDeletionRequests"))
    );
    o.aiProposal = maybeNewOrNull("PlanPackageAiProposal", options.aiProposal, cache);
    o.takeoffsStartedAt = options.takeoffsStartedAt ?? null;
    o.takeoffsCompletedAt = options.takeoffsCompletedAt ?? null;
    return o as FactoryResult<PlanPackage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanPackage"] = newPlanPackage;

export interface GlobalOptionOptions {
  __typename?: "GlobalOption";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: GlobalOption["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: GlobalOption["isFollowed"];
  id?: GlobalOption["id"];
  group?: FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions>;
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  name?: GlobalOption["name"];
  displayName?: GlobalOption["displayName"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  description?: GlobalOption["description"];
  isPlanSpecific?: GlobalOption["isPlanSpecific"];
  standardDetailRequired?: GlobalOption["standardDetailRequired"];
  status?: GlobalOption["status"];
  statusDetail?: GlobalOptionStatusDetailOptions | GlobalOptionStatus;
  type?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>;
  locations?: Array<FactoryInput<Location, LocationOptions>>;
  locationsInUse?: Array<FactoryInput<Location, LocationOptions>>;
  activeDate?: GlobalOption["activeDate"];
  archivedDate?: GlobalOption["archivedDate"];
  elevationRequired?: GlobalOption["elevationRequired"];
  requiredInPlanDrawing?: GlobalOption["requiredInPlanDrawing"];
  shopDrawingRequired?: GlobalOption["shopDrawingRequired"];
  tags?: Array<FactoryInput<GlobalOptionTag, GlobalOptionTagOptions>>;
  supportedTags?: Array<FactoryInput<GlobalOptionTag, GlobalOptionTagOptions>>;
  canEditType?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditLocations?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  code?: GlobalOption["code"];
  designUpgradeIconName?: GlobalOption["designUpgradeIconName"];
  defaultOrder?: GlobalOption["defaultOrder"];
  lastUsedAt?: GlobalOption["lastUsedAt"];
  createdAt?: GlobalOption["createdAt"];
  updatedAt?: GlobalOption["updatedAt"];
  asset?: FactoryInput<Asset, AssetOptions> | null;
  estimatedLeadTimeInDays?: GlobalOption["estimatedLeadTimeInDays"];
  marketingDescription?: GlobalOption["marketingDescription"];
  permits?: GlobalOption["permits"];
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  optionPricingConfig?: FactoryInput<OptionPricingConfig, OptionPricingConfigOptions> | null;
  version?: GlobalOption["version"];
  history?: Array<FactoryInput<History, HistoryOptions>>;
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions> | null;
}

export function newGlobalOption(
  options?: GlobalOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOption>;
export function newGlobalOption(
  options: GlobalOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalOption> {
  const o = (options.__typename ? options : cache["GlobalOption"] = {}) as GlobalOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalOption";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("GlobalOption");
    o.group = maybeNew("GlobalOptionGroup", options.group, cache, options.hasOwnProperty("group"));
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.description = options.description ?? null;
    o.isPlanSpecific = options.isPlanSpecific ?? null;
    o.standardDetailRequired = options.standardDetailRequired ?? null;
    o.status = options.status ?? GlobalOptionStatus.Active;
    o.statusDetail = enumOrDetailOfGlobalOptionStatus(options.statusDetail);
    o.type = maybeNew("GlobalOptionType", options.type, cache, options.hasOwnProperty("type"));
    o.locations = (options.locations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
    );
    o.locationsInUse = (options.locationsInUse ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("locationsInUse"))
    );
    o.activeDate = options.activeDate ?? null;
    o.archivedDate = options.archivedDate ?? null;
    o.elevationRequired = options.elevationRequired ?? null;
    o.requiredInPlanDrawing = options.requiredInPlanDrawing ?? null;
    o.shopDrawingRequired = options.shopDrawingRequired ?? null;
    o.tags = (options.tags ?? []).map((i) => maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("tags")));
    o.supportedTags = (options.supportedTags ?? []).map((i) =>
      maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("supportedTags"))
    );
    o.canEditType = maybeNew("PotentialOperation2", options.canEditType, cache, options.hasOwnProperty("canEditType"));
    o.canEditLocations = maybeNew(
      "PotentialOperation2",
      options.canEditLocations,
      cache,
      options.hasOwnProperty("canEditLocations"),
    );
    o.code = options.code ?? "code";
    o.designUpgradeIconName = options.designUpgradeIconName ?? null;
    o.defaultOrder = options.defaultOrder ?? null;
    o.lastUsedAt = options.lastUsedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.asset = maybeNewOrNull("Asset", options.asset, cache);
    o.estimatedLeadTimeInDays = options.estimatedLeadTimeInDays ?? 0;
    o.marketingDescription = options.marketingDescription ?? null;
    o.permits = options.permits ?? [];
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
    o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
    o.version = options.version ?? 0;
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.readyPlan = maybeNewOrNull("ReadyPlan", options.readyPlan, cache);
    return o as FactoryResult<GlobalOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalOption"] = newGlobalOption;

export interface ProjectCostCodeOptions {
  __typename?: "ProjectCostCode";
  references?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  referencedBy?: Array<Referencable | FactoryResult<ReferencableType> | ReferencableOptions>;
  commentStreams?: FactoryInput<CommentStreams, CommentStreamsOptions>;
  streams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  supportedVisibilities?: ProjectCostCode["supportedVisibilities"];
  followers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  availableFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isFollowed?: ProjectCostCode["isFollowed"];
  id?: ProjectCostCode["id"];
  name?: ProjectCostCode["name"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
  committedAtStartInCents?: ProjectCostCode["committedAtStartInCents"];
  originalCostInCents?: ProjectCostCode["originalCostInCents"];
  startCostInCents?: ProjectCostCode["startCostInCents"];
  changeEventCostInCents?: ProjectCostCode["changeEventCostInCents"];
  revisedCostInCents?: ProjectCostCode["revisedCostInCents"];
  projectedCostInCents?: ProjectCostCode["projectedCostInCents"];
  committedCostInCents?: ProjectCostCode["committedCostInCents"];
  availableCostInCents?: ProjectCostCode["availableCostInCents"];
  billedCostInCents?: ProjectCostCode["billedCostInCents"];
  unbilledCostInCents?: ProjectCostCode["unbilledCostInCents"];
  totalCostInCents?: ProjectCostCode["totalCostInCents"];
  totalPriceInCents?: ProjectCostCode["totalPriceInCents"];
}

export function newProjectCostCode(
  options?: ProjectCostCodeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCostCode>;
export function newProjectCostCode(
  options: ProjectCostCodeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectCostCode> {
  const o = (options.__typename ? options : cache["ProjectCostCode"] = {}) as ProjectCostCode;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectCostCode";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
    );
    o.referencedBy = (options.referencedBy ?? []).map((i) =>
      maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
    );
    o.commentStreams = maybeNew(
      "CommentStreams",
      options.commentStreams,
      cache,
      options.hasOwnProperty("commentStreams"),
    );
    o.streams = (options.streams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
    );
    o.supportedVisibilities = options.supportedVisibilities ?? [];
    o.followers = (options.followers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
    );
    o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
    );
    o.isFollowed = options.isFollowed ?? false;
    o.id = options.id ?? nextFactoryId("ProjectCostCode");
    o.name = options.name ?? "name";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    o.committedAtStartInCents = options.committedAtStartInCents ?? 0;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    return o as FactoryResult<ProjectCostCode>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectCostCode"] = newProjectCostCode;

export interface CommentOptions {
  __typename?: "Comment";
  id?: Comment["id"];
  html?: Comment["html"];
  text?: Comment["text"];
  createdAt?: Comment["createdAt"];
  updatedAt?: Comment["updatedAt"];
  stream?: FactoryInput<CommentStream, CommentStreamOptions>;
  author?: FactoryInput<User, UserOptions>;
  permissions?: FactoryInput<Permissions, PermissionsOptions>;
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
  tags?: Array<FactoryInput<CommentTag, CommentTagOptions>>;
}

export function newComment(options?: CommentOptions, factoryOptions?: FactoryOptions): FactoryResult<Comment>;
export function newComment(
  options: CommentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Comment> {
  const o = (options.__typename ? options : cache["Comment"] = {}) as Comment;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Comment";
    o.id = options.id ?? nextFactoryId("Comment");
    o.html = options.html ?? "html";
    o.text = options.text ?? "text";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.stream = maybeNew("CommentStream", options.stream, cache, options.hasOwnProperty("stream"));
    o.author = maybeNew("User", options.author, cache, options.hasOwnProperty("author"));
    o.permissions = maybeNew("Permissions", options.permissions, cache, options.hasOwnProperty("permissions"));
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    o.tags = (options.tags ?? []).map((i) => maybeNew("CommentTag", i, cache, options.hasOwnProperty("tags")));
    return o as FactoryResult<Comment>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Comment"] = newComment;

export interface SaveCommentResultOptions {
  __typename?: "SaveCommentResult";
  comment?: FactoryInput<Comment, CommentOptions> | null;
  userErrors?: Array<FactoryInput<UserError, UserErrorOptions>>;
}

export function newSaveCommentResult(
  options?: SaveCommentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCommentResult>;
export function newSaveCommentResult(
  options: SaveCommentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCommentResult> {
  const o = (options.__typename ? options : cache["SaveCommentResult"] = {}) as SaveCommentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCommentResult";
    o.comment = maybeNewOrNull("Comment", options.comment, cache);
    o.userErrors = (options.userErrors ?? []).map((i) =>
      maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
    );
    return o as FactoryResult<SaveCommentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCommentResult"] = newSaveCommentResult;

export interface DeleteCommentResultOptions {
  __typename?: "DeleteCommentResult";
  stream?: FactoryInput<CommentStream, CommentStreamOptions> | null;
  userErrors?: Array<FactoryInput<UserError, UserErrorOptions>>;
}

export function newDeleteCommentResult(
  options?: DeleteCommentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteCommentResult>;
export function newDeleteCommentResult(
  options: DeleteCommentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteCommentResult> {
  const o = (options.__typename ? options : cache["DeleteCommentResult"] = {}) as DeleteCommentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteCommentResult";
    o.stream = maybeNewOrNull("CommentStream", options.stream, cache);
    o.userErrors = (options.userErrors ?? []).map((i) =>
      maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
    );
    return o as FactoryResult<DeleteCommentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteCommentResult"] = newDeleteCommentResult;

export interface CommentStreamOptions {
  __typename?: "CommentStream";
  id?: CommentStream["id"];
  streamVisibility?: CommentStreamVisibilityDetailOptions | CommentStreamVisibility;
  name?: CommentStream["name"];
  commentable?: Commentable | FactoryResult<CommentableType> | CommentableOptions;
  comments?: Array<FactoryInput<Comment, CommentOptions>>;
  latestComment?: FactoryInput<Comment, CommentOptions> | null;
  commentCount?: CommentStream["commentCount"];
  unreadCount?: CommentStream["unreadCount"];
  fromAddress?: CommentStream["fromAddress"];
  tradePartnerUsers?: Array<FactoryInput<TradePartnerUser, TradePartnerUserOptions>>;
}

export function newCommentStream(
  options?: CommentStreamOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommentStream>;
export function newCommentStream(
  options: CommentStreamOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommentStream> {
  const o = (options.__typename ? options : cache["CommentStream"] = {}) as CommentStream;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommentStream";
    o.id = options.id ?? nextFactoryId("CommentStream");
    o.streamVisibility = enumOrDetailOfCommentStreamVisibility(options.streamVisibility);
    o.name = options.name ?? "name";
    o.commentable = maybeNew("Commentable", options.commentable, cache, options.hasOwnProperty("commentable"));
    o.comments = (options.comments ?? []).map((i) => maybeNew("Comment", i, cache, options.hasOwnProperty("comments")));
    o.latestComment = maybeNewOrNull("Comment", options.latestComment, cache);
    o.commentCount = options.commentCount ?? 0;
    o.unreadCount = options.unreadCount ?? 0;
    o.fromAddress = options.fromAddress ?? "fromAddress";
    o.tradePartnerUsers = (options.tradePartnerUsers ?? []).map((i) =>
      maybeNew("TradePartnerUser", i, cache, options.hasOwnProperty("tradePartnerUsers"))
    );
    return o as FactoryResult<CommentStream>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommentStream"] = newCommentStream;

export interface CommentStreamsOptions {
  __typename?: "CommentStreams";
  internalStream?: FactoryInput<CommentStream, CommentStreamOptions> | null;
  tradesStream?: FactoryInput<CommentStream, CommentStreamOptions> | null;
  homeownerStream?: FactoryInput<CommentStream, CommentStreamOptions> | null;
  commentCount?: CommentStreams["commentCount"];
}

export function newCommentStreams(
  options?: CommentStreamsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommentStreams>;
export function newCommentStreams(
  options: CommentStreamsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommentStreams> {
  const o = (options.__typename ? options : cache["CommentStreams"] = {}) as CommentStreams;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommentStreams";
    o.internalStream = maybeNewOrNull("CommentStream", options.internalStream, cache);
    o.tradesStream = maybeNewOrNull("CommentStream", options.tradesStream, cache);
    o.homeownerStream = maybeNewOrNull("CommentStream", options.homeownerStream, cache);
    o.commentCount = options.commentCount ?? 0;
    return o as FactoryResult<CommentStreams>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommentStreams"] = newCommentStreams;

export interface UserRelevantCommentStreamsResultOptions {
  __typename?: "UserRelevantCommentStreamsResult";
  entities?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newUserRelevantCommentStreamsResult(
  options?: UserRelevantCommentStreamsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UserRelevantCommentStreamsResult>;
export function newUserRelevantCommentStreamsResult(
  options: UserRelevantCommentStreamsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UserRelevantCommentStreamsResult> {
  const o =
    (options.__typename ? options : cache["UserRelevantCommentStreamsResult"] = {}) as UserRelevantCommentStreamsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UserRelevantCommentStreamsResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<UserRelevantCommentStreamsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UserRelevantCommentStreamsResult"] = newUserRelevantCommentStreamsResult;

export interface CommentTagOptions {
  __typename?: "CommentTag";
  id?: CommentTag["id"];
  createdAt?: CommentTag["createdAt"];
  updatedAt?: CommentTag["updatedAt"];
  comment?: FactoryInput<Comment, CommentOptions>;
  internalUser?: FactoryInput<InternalUser, InternalUserOptions>;
}

export function newCommentTag(options?: CommentTagOptions, factoryOptions?: FactoryOptions): FactoryResult<CommentTag>;
export function newCommentTag(
  options: CommentTagOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommentTag> {
  const o = (options.__typename ? options : cache["CommentTag"] = {}) as CommentTag;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommentTag";
    o.id = options.id ?? nextFactoryId("CommentTag");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.comment = maybeNew("Comment", options.comment, cache, options.hasOwnProperty("comment"));
    o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
    return o as FactoryResult<CommentTag>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommentTag"] = newCommentTag;

export interface ProjectStageOptions {
  __typename?: "ProjectStage";
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  commitmentLikes?: Array<CommitmentLike | FactoryResult<CommitmentLikeType> | CommitmentLikeOptions>;
  homeownerContracts?: Array<FactoryInput<HomeownerContract, HomeownerContractOptions>>;
  id?: ProjectStage["id"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  stage?: StageDetailOptions | Stage;
  hasSignedContract?: ProjectStage["hasSignedContract"];
  canEditProjectItemsDirectly?: ProjectStage["canEditProjectItemsDirectly"];
  canEditProjectScope?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canCreateFinalEstimate?: ProjectStage["canCreateFinalEstimate"];
  canCompleteStage?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canPublishSchedule?: FactoryInput<PotentialOperation, PotentialOperationOptions>;
  nextStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  previousStage?: FactoryInput<ProjectStage, ProjectStageOptions> | null;
  status?: ProjectStageStatusDetailOptions | ProjectStageStatus;
  interval?: FactoryInput<CalendarInterval, CalendarIntervalOptions>;
  baselineInterval?: FactoryInput<CalendarInterval, CalendarIntervalOptions>;
  schedulePhases?: Array<FactoryInput<SchedulePhase, SchedulePhaseOptions>>;
  bills?: Array<FactoryInput<Bill, BillOptions>>;
  priceInCents?: ProjectStage["priceInCents"];
  progress?: FactoryInput<StageProgress, StageProgressOptions>;
  cmsId?: ProjectStage["cmsId"];
  invoices?: Array<FactoryInput<Invoice, InvoiceOptions>>;
  homeownerFinancials?: FactoryInput<ProjectStageHomeownerFinancials, ProjectStageHomeownerFinancialsOptions>;
  estimates?: Array<FactoryInput<Estimate, EstimateOptions>>;
  hocFinancials?: FactoryInput<ProjectStageHocFinancials, ProjectStageHocFinancialsOptions>;
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
  itemLocations?: Array<FactoryInput<Location, LocationOptions>>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  changeEvents?: Array<FactoryInput<ChangeEvent, ChangeEventOptions>>;
  totalCostInCents?: ProjectStage["totalCostInCents"];
  clientPresentationDate?: ProjectStage["clientPresentationDate"];
  appliedTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  templateConfigs?: Array<FactoryInput<ProjectStageTemplateConfig, ProjectStageTemplateConfigOptions>>;
  readyHomePlanTemplate?: FactoryInput<ProjectStageTemplateConfig, ProjectStageTemplateConfigOptions> | null;
  percentReleased?: ProjectStage["percentReleased"];
  unallocatedExpenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
  hasDrawsToInvoice?: ProjectStage["hasDrawsToInvoice"];
  hasCostsToInvoice?: ProjectStage["hasCostsToInvoice"];
  hasFixedToInvoice?: ProjectStage["hasFixedToInvoice"];
  workAuthorizations?: Array<FactoryInput<WorkAuthorization, WorkAuthorizationOptions>>;
  allContractDraws?: Array<FactoryInput<HomeownerContractDraw, HomeownerContractDrawOptions>>;
}

export function newProjectStage(
  options?: ProjectStageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStage>;
export function newProjectStage(
  options: ProjectStageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectStage> {
  const o = (options.__typename ? options : cache["ProjectStage"] = {}) as ProjectStage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectStage";
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.commitmentLikes = (options.commitmentLikes ?? []).map((i) =>
      maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("commitmentLikes"))
    );
    o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
      maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
    );
    o.id = options.id ?? nextFactoryId("ProjectStage");
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.stage = enumOrDetailOfStage(options.stage);
    o.hasSignedContract = options.hasSignedContract ?? false;
    o.canEditProjectItemsDirectly = options.canEditProjectItemsDirectly ?? false;
    o.canEditProjectScope = maybeNew(
      "PotentialOperation2",
      options.canEditProjectScope,
      cache,
      options.hasOwnProperty("canEditProjectScope"),
    );
    o.canCreateFinalEstimate = options.canCreateFinalEstimate ?? false;
    o.canCompleteStage = maybeNew(
      "PotentialOperation2",
      options.canCompleteStage,
      cache,
      options.hasOwnProperty("canCompleteStage"),
    );
    o.canPublishSchedule = maybeNew(
      "PotentialOperation",
      options.canPublishSchedule,
      cache,
      options.hasOwnProperty("canPublishSchedule"),
    );
    o.nextStage = maybeNewOrNull("ProjectStage", options.nextStage, cache);
    o.previousStage = maybeNewOrNull("ProjectStage", options.previousStage, cache);
    o.status = enumOrDetailOfProjectStageStatus(options.status);
    o.interval = maybeNew("CalendarInterval", options.interval, cache, options.hasOwnProperty("interval"));
    o.baselineInterval = maybeNew(
      "CalendarInterval",
      options.baselineInterval,
      cache,
      options.hasOwnProperty("baselineInterval"),
    );
    o.schedulePhases = (options.schedulePhases ?? []).map((i) =>
      maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("schedulePhases"))
    );
    o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
    o.priceInCents = options.priceInCents ?? 0;
    o.progress = maybeNew("StageProgress", options.progress, cache, options.hasOwnProperty("progress"));
    o.cmsId = options.cmsId ?? null;
    o.invoices = (options.invoices ?? []).map((i) => maybeNew("Invoice", i, cache, options.hasOwnProperty("invoices")));
    o.homeownerFinancials = maybeNew(
      "ProjectStageHomeownerFinancials",
      options.homeownerFinancials,
      cache,
      options.hasOwnProperty("homeownerFinancials"),
    );
    o.estimates = (options.estimates ?? []).map((i) =>
      maybeNew("Estimate", i, cache, options.hasOwnProperty("estimates"))
    );
    o.hocFinancials = maybeNew(
      "ProjectStageHocFinancials",
      options.hocFinancials,
      cache,
      options.hasOwnProperty("hocFinancials"),
    );
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    o.itemLocations = (options.itemLocations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.changeEvents = (options.changeEvents ?? []).map((i) =>
      maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
    );
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.clientPresentationDate = options.clientPresentationDate ?? null;
    o.appliedTemplates = (options.appliedTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("appliedTemplates"))
    );
    o.templateConfigs = (options.templateConfigs ?? []).map((i) =>
      maybeNew("ProjectStageTemplateConfig", i, cache, options.hasOwnProperty("templateConfigs"))
    );
    o.readyHomePlanTemplate = maybeNewOrNull("ProjectStageTemplateConfig", options.readyHomePlanTemplate, cache);
    o.percentReleased = options.percentReleased ?? 0;
    o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
      maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
    );
    o.hasDrawsToInvoice = options.hasDrawsToInvoice ?? false;
    o.hasCostsToInvoice = options.hasCostsToInvoice ?? false;
    o.hasFixedToInvoice = options.hasFixedToInvoice ?? false;
    o.workAuthorizations = (options.workAuthorizations ?? []).map((i) =>
      maybeNew("WorkAuthorization", i, cache, options.hasOwnProperty("workAuthorizations"))
    );
    o.allContractDraws = (options.allContractDraws ?? []).map((i) =>
      maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("allContractDraws"))
    );
    return o as FactoryResult<ProjectStage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectStage"] = newProjectStage;

export interface CommitmentLineItemSummaryOptions {
  __typename?: "CommitmentLineItemSummary";
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  committedInCents?: CommitmentLineItemSummary["committedInCents"];
  changeOrderInCents?: CommitmentLineItemSummary["changeOrderInCents"];
  totalCommittedInCents?: CommitmentLineItemSummary["totalCommittedInCents"];
  billedInCents?: CommitmentLineItemSummary["billedInCents"];
  paidInCents?: CommitmentLineItemSummary["paidInCents"];
  balanceInCents?: CommitmentLineItemSummary["balanceInCents"];
}

export function newCommitmentLineItemSummary(
  options?: CommitmentLineItemSummaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentLineItemSummary>;
export function newCommitmentLineItemSummary(
  options: CommitmentLineItemSummaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentLineItemSummary> {
  const o = (options.__typename ? options : cache["CommitmentLineItemSummary"] = {}) as CommitmentLineItemSummary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentLineItemSummary";
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.committedInCents = options.committedInCents ?? 0;
    o.changeOrderInCents = options.changeOrderInCents ?? 0;
    o.totalCommittedInCents = options.totalCommittedInCents ?? 0;
    o.billedInCents = options.billedInCents ?? 0;
    o.paidInCents = options.paidInCents ?? 0;
    o.balanceInCents = options.balanceInCents ?? 0;
    return o as FactoryResult<CommitmentLineItemSummary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentLineItemSummary"] = newCommitmentLineItemSummary;

export interface CommitmentsPageOptions {
  __typename?: "CommitmentsPage";
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newCommitmentsPage(
  options?: CommitmentsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentsPage>;
export function newCommitmentsPage(
  options: CommitmentsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentsPage> {
  const o = (options.__typename ? options : cache["CommitmentsPage"] = {}) as CommitmentsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentsPage";
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<CommitmentsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentsPage"] = newCommitmentsPage;

export interface PotentialBidContractRevisionOptions {
  __typename?: "PotentialBidContractRevision";
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  totalCostInCents?: PotentialBidContractRevision["totalCostInCents"];
}

export function newPotentialBidContractRevision(
  options?: PotentialBidContractRevisionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PotentialBidContractRevision>;
export function newPotentialBidContractRevision(
  options: PotentialBidContractRevisionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialBidContractRevision> {
  const o = (options.__typename ? options : cache["PotentialBidContractRevision"] = {}) as PotentialBidContractRevision;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PotentialBidContractRevision";
    o.bidContractRevision = maybeNew(
      "BidContractRevision",
      options.bidContractRevision,
      cache,
      options.hasOwnProperty("bidContractRevision"),
    );
    o.totalCostInCents = options.totalCostInCents ?? 0;
    return o as FactoryResult<PotentialBidContractRevision>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PotentialBidContractRevision"] = newPotentialBidContractRevision;

export interface CommitmentCostCodeSummaryOptions {
  __typename?: "CommitmentCostCodeSummary";
  lineItems?: Array<FactoryInput<CommitmentCostCodeSummaryLineItem, CommitmentCostCodeSummaryLineItemOptions>>;
}

export function newCommitmentCostCodeSummary(
  options?: CommitmentCostCodeSummaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentCostCodeSummary>;
export function newCommitmentCostCodeSummary(
  options: CommitmentCostCodeSummaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentCostCodeSummary> {
  const o = (options.__typename ? options : cache["CommitmentCostCodeSummary"] = {}) as CommitmentCostCodeSummary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentCostCodeSummary";
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("CommitmentCostCodeSummaryLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    return o as FactoryResult<CommitmentCostCodeSummary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentCostCodeSummary"] = newCommitmentCostCodeSummary;

export interface CommitmentCostCodeSummaryLineItemOptions {
  __typename?: "CommitmentCostCodeSummaryLineItem";
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  quantity?: CommitmentCostCodeSummaryLineItem["quantity"];
}

export function newCommitmentCostCodeSummaryLineItem(
  options?: CommitmentCostCodeSummaryLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentCostCodeSummaryLineItem>;
export function newCommitmentCostCodeSummaryLineItem(
  options: CommitmentCostCodeSummaryLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentCostCodeSummaryLineItem> {
  const o =
    (options.__typename
      ? options
      : cache["CommitmentCostCodeSummaryLineItem"] = {}) as CommitmentCostCodeSummaryLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentCostCodeSummaryLineItem";
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.quantity = options.quantity ?? 0;
    return o as FactoryResult<CommitmentCostCodeSummaryLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentCostCodeSummaryLineItem"] = newCommitmentCostCodeSummaryLineItem;

export interface SaveCommitmentResultOptions {
  __typename?: "SaveCommitmentResult";
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
}

export function newSaveCommitmentResult(
  options?: SaveCommitmentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCommitmentResult>;
export function newSaveCommitmentResult(
  options: SaveCommitmentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCommitmentResult> {
  const o = (options.__typename ? options : cache["SaveCommitmentResult"] = {}) as SaveCommitmentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCommitmentResult";
    o.commitment = maybeNew("Commitment", options.commitment, cache, options.hasOwnProperty("commitment"));
    return o as FactoryResult<SaveCommitmentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCommitmentResult"] = newSaveCommitmentResult;

export interface SaveCommitmentsResultOptions {
  __typename?: "SaveCommitmentsResult";
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
}

export function newSaveCommitmentsResult(
  options?: SaveCommitmentsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCommitmentsResult>;
export function newSaveCommitmentsResult(
  options: SaveCommitmentsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCommitmentsResult> {
  const o = (options.__typename ? options : cache["SaveCommitmentsResult"] = {}) as SaveCommitmentsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCommitmentsResult";
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    return o as FactoryResult<SaveCommitmentsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCommitmentsResult"] = newSaveCommitmentsResult;

export interface CreateCommitmentFromBillResultOptions {
  __typename?: "CreateCommitmentFromBillResult";
  commitment?: FactoryInput<Commitment, CommitmentOptions> | null;
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions> | null;
}

export function newCreateCommitmentFromBillResult(
  options?: CreateCommitmentFromBillResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CreateCommitmentFromBillResult>;
export function newCreateCommitmentFromBillResult(
  options: CreateCommitmentFromBillResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CreateCommitmentFromBillResult> {
  const o =
    (options.__typename ? options : cache["CreateCommitmentFromBillResult"] = {}) as CreateCommitmentFromBillResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CreateCommitmentFromBillResult";
    o.commitment = maybeNewOrNull("Commitment", options.commitment, cache);
    o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
    return o as FactoryResult<CreateCommitmentFromBillResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CreateCommitmentFromBillResult"] = newCreateCommitmentFromBillResult;

export interface CommitmentBillingScheduleItemOptions {
  __typename?: "CommitmentBillingScheduleItem";
  commitmentDraw?: FactoryInput<CommitmentDraw, CommitmentDrawOptions> | null;
  isDeposit?: CommitmentBillingScheduleItem["isDeposit"];
  committedInCents?: CommitmentBillingScheduleItem["committedInCents"];
  pendingBilledInCents?: CommitmentBillingScheduleItem["pendingBilledInCents"];
  pendingUnbilledInCents?: CommitmentBillingScheduleItem["pendingUnbilledInCents"];
  lineItems?: Array<FactoryInput<CommitmentBillingScheduleLineItem, CommitmentBillingScheduleLineItemOptions>>;
}

export function newCommitmentBillingScheduleItem(
  options?: CommitmentBillingScheduleItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentBillingScheduleItem>;
export function newCommitmentBillingScheduleItem(
  options: CommitmentBillingScheduleItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentBillingScheduleItem> {
  const o =
    (options.__typename ? options : cache["CommitmentBillingScheduleItem"] = {}) as CommitmentBillingScheduleItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentBillingScheduleItem";
    o.commitmentDraw = maybeNewOrNull("CommitmentDraw", options.commitmentDraw, cache);
    o.isDeposit = options.isDeposit ?? false;
    o.committedInCents = options.committedInCents ?? 0;
    o.pendingBilledInCents = options.pendingBilledInCents ?? 0;
    o.pendingUnbilledInCents = options.pendingUnbilledInCents ?? 0;
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("CommitmentBillingScheduleLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    return o as FactoryResult<CommitmentBillingScheduleItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentBillingScheduleItem"] = newCommitmentBillingScheduleItem;

export interface CommitmentBillingScheduleLineItemOptions {
  __typename?: "CommitmentBillingScheduleLineItem";
  amountInCents?: CommitmentBillingScheduleLineItem["amountInCents"];
  commitmentLineItem?: FactoryInput<CommitmentLineItem, CommitmentLineItemOptions>;
}

export function newCommitmentBillingScheduleLineItem(
  options?: CommitmentBillingScheduleLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentBillingScheduleLineItem>;
export function newCommitmentBillingScheduleLineItem(
  options: CommitmentBillingScheduleLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentBillingScheduleLineItem> {
  const o =
    (options.__typename
      ? options
      : cache["CommitmentBillingScheduleLineItem"] = {}) as CommitmentBillingScheduleLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentBillingScheduleLineItem";
    o.amountInCents = options.amountInCents ?? 0;
    o.commitmentLineItem = maybeNew(
      "CommitmentLineItem",
      options.commitmentLineItem,
      cache,
      options.hasOwnProperty("commitmentLineItem"),
    );
    return o as FactoryResult<CommitmentBillingScheduleLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentBillingScheduleLineItem"] = newCommitmentBillingScheduleLineItem;

export interface TaskPurchaseOrderRowOptions {
  __typename?: "TaskPurchaseOrderRow";
  commitmentLike?: CommitmentLike | FactoryResult<CommitmentLikeType> | CommitmentLikeOptions;
  committedInCents?: TaskPurchaseOrderRow["committedInCents"];
  unbilledInCents?: TaskPurchaseOrderRow["unbilledInCents"];
  changeOrders?: Array<FactoryInput<TaskPurchaseOrderRow, TaskPurchaseOrderRowOptions>>;
}

export function newTaskPurchaseOrderRow(
  options?: TaskPurchaseOrderRowOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TaskPurchaseOrderRow>;
export function newTaskPurchaseOrderRow(
  options: TaskPurchaseOrderRowOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TaskPurchaseOrderRow> {
  const o = (options.__typename ? options : cache["TaskPurchaseOrderRow"] = {}) as TaskPurchaseOrderRow;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TaskPurchaseOrderRow";
    o.commitmentLike = maybeNew(
      "CommitmentLike",
      options.commitmentLike,
      cache,
      options.hasOwnProperty("commitmentLike"),
    );
    o.committedInCents = options.committedInCents ?? 0;
    o.unbilledInCents = options.unbilledInCents ?? 0;
    o.changeOrders = (options.changeOrders ?? []).map((i) =>
      maybeNew("TaskPurchaseOrderRow", i, cache, options.hasOwnProperty("changeOrders"))
    );
    return o as FactoryResult<TaskPurchaseOrderRow>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TaskPurchaseOrderRow"] = newTaskPurchaseOrderRow;

export interface CommitmentChangeOrderOptions {
  __typename?: "CommitmentChangeOrder";
  id?: CommitmentChangeOrder["id"];
  accountingNumber?: CommitmentChangeOrder["accountingNumber"];
  name?: CommitmentChangeOrder["name"];
  displayName?: CommitmentChangeOrder["displayName"];
  shortName?: CommitmentChangeOrder["shortName"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
  commitmentType?: CommitmentTypeDetailOptions | CommitmentType;
  identifier?: CommitmentChangeOrder["identifier"];
  costChangeInCents?: CommitmentChangeOrder["costChangeInCents"];
  internalNote?: CommitmentChangeOrder["internalNote"];
  executionDate?: CommitmentChangeOrder["executionDate"];
  createdAt?: CommitmentChangeOrder["createdAt"];
  document?: FactoryInput<Document, DocumentOptions> | null;
  lineItems?: Array<FactoryInput<CommitmentLineItem, CommitmentLineItemOptions>>;
  bills?: Array<FactoryInput<Bill, BillOptions>>;
  committedInCents?: CommitmentChangeOrder["committedInCents"];
  taxableCostInCents?: CommitmentChangeOrder["taxableCostInCents"];
  remainingInCents?: CommitmentChangeOrder["remainingInCents"];
  pendingRemainingInCents?: CommitmentChangeOrder["pendingRemainingInCents"];
  billedInCents?: CommitmentChangeOrder["billedInCents"];
  pendingBilledInCents?: CommitmentChangeOrder["pendingBilledInCents"];
  unbilledInCents?: CommitmentChangeOrder["unbilledInCents"];
  paidInCents?: CommitmentChangeOrder["paidInCents"];
  balanceInCents?: CommitmentChangeOrder["balanceInCents"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  updatedAt?: CommitmentChangeOrder["updatedAt"];
  tradeCategories?: Array<FactoryInput<TradeCategory, TradeCategoryOptions>>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions> | null;
  status?: CommitmentChangeOrder["status"];
  statusDetail?: CommitmentStatusDetailOptions | CommitmentStatus;
  statusText?: CommitmentChangeOrder["statusText"];
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions> | null;
  canEditLineItems?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canCreatePandaDoc?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  isBidCommitment?: CommitmentChangeOrder["isBidCommitment"];
  canBeEdited?: CommitmentChangeOrder["canBeEdited"];
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  items?: Array<FactoryInput<Item, ItemOptions>>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canVoid?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canBeReleased?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  tradeSignatory?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  percentagePaid?: CommitmentChangeOrder["percentagePaid"];
  sentDate?: CommitmentChangeOrder["sentDate"];
  referenceNumber?: CommitmentChangeOrder["referenceNumber"];
}

export function newCommitmentChangeOrder(
  options?: CommitmentChangeOrderOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentChangeOrder>;
export function newCommitmentChangeOrder(
  options: CommitmentChangeOrderOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentChangeOrder> {
  const o = (options.__typename ? options : cache["CommitmentChangeOrder"] = {}) as CommitmentChangeOrder;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentChangeOrder";
    o.id = options.id ?? nextFactoryId("CommitmentChangeOrder");
    o.accountingNumber = options.accountingNumber ?? 0;
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.shortName = options.shortName ?? "shortName";
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.commitment = maybeNew("Commitment", options.commitment, cache, options.hasOwnProperty("commitment"));
    o.commitmentType = enumOrDetailOfCommitmentType(options.commitmentType);
    o.identifier = options.identifier ?? "identifier";
    o.costChangeInCents = options.costChangeInCents ?? 0;
    o.internalNote = options.internalNote ?? null;
    o.executionDate = options.executionDate ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
    o.committedInCents = options.committedInCents ?? 0;
    o.taxableCostInCents = options.taxableCostInCents ?? 0;
    o.remainingInCents = options.remainingInCents ?? 0;
    o.pendingRemainingInCents = options.pendingRemainingInCents ?? 0;
    o.billedInCents = options.billedInCents ?? null;
    o.pendingBilledInCents = options.pendingBilledInCents ?? null;
    o.unbilledInCents = options.unbilledInCents ?? 0;
    o.paidInCents = options.paidInCents ?? null;
    o.balanceInCents = options.balanceInCents ?? null;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
      maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
    );
    o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
    o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
    o.status = options.status ?? CommitmentStatus.Draft;
    o.statusDetail = enumOrDetailOfCommitmentStatus(options.statusDetail);
    o.statusText = options.statusText ?? "statusText";
    o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
    o.canEditLineItems = maybeNew(
      "PotentialOperation2",
      options.canEditLineItems,
      cache,
      options.hasOwnProperty("canEditLineItems"),
    );
    o.canCreatePandaDoc = maybeNew(
      "PotentialOperation2",
      options.canCreatePandaDoc,
      cache,
      options.hasOwnProperty("canCreatePandaDoc"),
    );
    o.isBidCommitment = options.isBidCommitment ?? false;
    o.canBeEdited = options.canBeEdited ?? false;
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.canVoid = maybeNew("PotentialOperation2", options.canVoid, cache, options.hasOwnProperty("canVoid"));
    o.canBeReleased = maybeNew(
      "PotentialOperation2",
      options.canBeReleased,
      cache,
      options.hasOwnProperty("canBeReleased"),
    );
    o.tradeSignatory = maybeNewOrNull("TradePartnerContact", options.tradeSignatory, cache);
    o.percentagePaid = options.percentagePaid ?? 0;
    o.sentDate = options.sentDate ?? null;
    o.referenceNumber = options.referenceNumber ?? null;
    return o as FactoryResult<CommitmentChangeOrder>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentChangeOrder"] = newCommitmentChangeOrder;

export interface SaveCommitmentChangeOrderResultOptions {
  __typename?: "SaveCommitmentChangeOrderResult";
  commitmentChangeOrder?: FactoryInput<CommitmentChangeOrder, CommitmentChangeOrderOptions>;
}

export function newSaveCommitmentChangeOrderResult(
  options?: SaveCommitmentChangeOrderResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCommitmentChangeOrderResult>;
export function newSaveCommitmentChangeOrderResult(
  options: SaveCommitmentChangeOrderResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCommitmentChangeOrderResult> {
  const o =
    (options.__typename ? options : cache["SaveCommitmentChangeOrderResult"] = {}) as SaveCommitmentChangeOrderResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCommitmentChangeOrderResult";
    o.commitmentChangeOrder = maybeNew(
      "CommitmentChangeOrder",
      options.commitmentChangeOrder,
      cache,
      options.hasOwnProperty("commitmentChangeOrder"),
    );
    return o as FactoryResult<SaveCommitmentChangeOrderResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCommitmentChangeOrderResult"] = newSaveCommitmentChangeOrderResult;

export interface CommitmentDrawOptions {
  __typename?: "CommitmentDraw";
  id?: CommitmentDraw["id"];
  amountInBasisPoints?: CommitmentDraw["amountInBasisPoints"];
  description?: CommitmentDraw["description"];
  createdAt?: CommitmentDraw["createdAt"];
  updatedAt?: CommitmentDraw["updatedAt"];
  bidContractRevisionDraw?: FactoryInput<BidContractRevisionDraw, BidContractRevisionDrawOptions> | null;
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
  task?: FactoryInput<Task, TaskOptions>;
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
}

export function newCommitmentDraw(
  options?: CommitmentDrawOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentDraw>;
export function newCommitmentDraw(
  options: CommitmentDrawOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentDraw> {
  const o = (options.__typename ? options : cache["CommitmentDraw"] = {}) as CommitmentDraw;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentDraw";
    o.id = options.id ?? nextFactoryId("CommitmentDraw");
    o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.bidContractRevisionDraw = maybeNewOrNull("BidContractRevisionDraw", options.bidContractRevisionDraw, cache);
    o.commitment = maybeNew("Commitment", options.commitment, cache, options.hasOwnProperty("commitment"));
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    return o as FactoryResult<CommitmentDraw>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentDraw"] = newCommitmentDraw;

export interface CommitmentLineItemOptions {
  __typename?: "CommitmentLineItem";
  id?: CommitmentLineItem["id"];
  owner?: CommitmentLike | FactoryResult<CommitmentLikeType> | CommitmentLikeOptions;
  ownerCommitment?: FactoryInput<Commitment, CommitmentOptions>;
  costChangeInCents?: CommitmentLineItem["costChangeInCents"];
  internalNote?: CommitmentLineItem["internalNote"];
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  committedInCents?: CommitmentLineItem["committedInCents"];
  billedInCents?: CommitmentLineItem["billedInCents"];
  unbilledInCents?: CommitmentLineItem["unbilledInCents"];
  pendingBilledInCents?: CommitmentLineItem["pendingBilledInCents"];
  pendingUnbilledInCents?: CommitmentLineItem["pendingUnbilledInCents"];
  billableLimitInCents?: CommitmentLineItem["billableLimitInCents"];
  paidInCents?: CommitmentLineItem["paidInCents"];
  balanceInCents?: CommitmentLineItem["balanceInCents"];
  quantity?: CommitmentLineItem["quantity"];
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  specifications?: CommitmentLineItem["specifications"];
  tradePartnerNote?: CommitmentLineItem["tradePartnerNote"];
  changeEventLineItem?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions> | null;
  newTaxableCostInCents?: CommitmentLineItem["newTaxableCostInCents"];
  newTaxInCents?: CommitmentLineItem["newTaxInCents"];
  newTotalCostInCents?: CommitmentLineItem["newTotalCostInCents"];
  originalTaxableCostInCents?: CommitmentLineItem["originalTaxableCostInCents"];
  originalTaxInCents?: CommitmentLineItem["originalTaxInCents"];
  originalTotalCostInCents?: CommitmentLineItem["originalTotalCostInCents"];
  originalQuantity?: CommitmentLineItem["originalQuantity"];
  newQuantity?: CommitmentLineItem["newQuantity"];
  bidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  primaryBidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  modifyingBidContractLineItems?: Array<FactoryInput<BidContractLineItem, BidContractLineItemOptions>>;
  planBasedLineItem?: FactoryInput<PlanBasedBidContractLineItem, PlanBasedBidContractLineItemOptions> | null;
  expenseAllocations?: Array<FactoryInput<ExpenseAllocation, ExpenseAllocationOptions>>;
  isTaxExempt?: CommitmentLineItem["isTaxExempt"];
  taxableCostInCents?: CommitmentLineItem["taxableCostInCents"];
  taxInCents?: CommitmentLineItem["taxInCents"];
  allocations?: Array<FactoryInput<CommitmentLineItemAllocation, CommitmentLineItemAllocationOptions>>;
}

export function newCommitmentLineItem(
  options?: CommitmentLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentLineItem>;
export function newCommitmentLineItem(
  options: CommitmentLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentLineItem> {
  const o = (options.__typename ? options : cache["CommitmentLineItem"] = {}) as CommitmentLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentLineItem";
    o.id = options.id ?? nextFactoryId("CommitmentLineItem");
    o.owner = maybeNew("CommitmentLike", options.owner, cache, options.hasOwnProperty("owner"));
    o.ownerCommitment = maybeNew(
      "Commitment",
      options.ownerCommitment,
      cache,
      options.hasOwnProperty("ownerCommitment"),
    );
    o.costChangeInCents = options.costChangeInCents ?? null;
    o.internalNote = options.internalNote ?? null;
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.committedInCents = options.committedInCents ?? 0;
    o.billedInCents = options.billedInCents ?? null;
    o.unbilledInCents = options.unbilledInCents ?? 0;
    o.pendingBilledInCents = options.pendingBilledInCents ?? 0;
    o.pendingUnbilledInCents = options.pendingUnbilledInCents ?? 0;
    o.billableLimitInCents = options.billableLimitInCents ?? 0;
    o.paidInCents = options.paidInCents ?? null;
    o.balanceInCents = options.balanceInCents ?? null;
    o.quantity = options.quantity ?? null;
    o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
    o.specifications = options.specifications ?? null;
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
    o.newTaxableCostInCents = options.newTaxableCostInCents ?? 0;
    o.newTaxInCents = options.newTaxInCents ?? 0;
    o.newTotalCostInCents = options.newTotalCostInCents ?? 0;
    o.originalTaxableCostInCents = options.originalTaxableCostInCents ?? 0;
    o.originalTaxInCents = options.originalTaxInCents ?? 0;
    o.originalTotalCostInCents = options.originalTotalCostInCents ?? 0;
    o.originalQuantity = options.originalQuantity ?? 0;
    o.newQuantity = options.newQuantity ?? 0;
    o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
    o.primaryBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.primaryBidContractLineItem, cache);
    o.modifyingBidContractLineItems = (options.modifyingBidContractLineItems ?? []).map((i) =>
      maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("modifyingBidContractLineItems"))
    );
    o.planBasedLineItem = maybeNewOrNull("PlanBasedBidContractLineItem", options.planBasedLineItem, cache);
    o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
      maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
    );
    o.isTaxExempt = options.isTaxExempt ?? false;
    o.taxableCostInCents = options.taxableCostInCents ?? 0;
    o.taxInCents = options.taxInCents ?? 0;
    o.allocations = (options.allocations ?? []).map((i) =>
      maybeNew("CommitmentLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
    );
    return o as FactoryResult<CommitmentLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentLineItem"] = newCommitmentLineItem;

export interface ProtoCommitmentLineItemToBuyoutOptions {
  __typename?: "ProtoCommitmentLineItemToBuyout";
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  quantity?: ProtoCommitmentLineItemToBuyout["quantity"];
  costChangeInCents?: ProtoCommitmentLineItemToBuyout["costChangeInCents"];
  specifications?: ProtoCommitmentLineItemToBuyout["specifications"];
  tradePartnerNote?: ProtoCommitmentLineItemToBuyout["tradePartnerNote"];
}

export function newProtoCommitmentLineItemToBuyout(
  options?: ProtoCommitmentLineItemToBuyoutOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProtoCommitmentLineItemToBuyout>;
export function newProtoCommitmentLineItemToBuyout(
  options: ProtoCommitmentLineItemToBuyoutOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProtoCommitmentLineItemToBuyout> {
  const o =
    (options.__typename ? options : cache["ProtoCommitmentLineItemToBuyout"] = {}) as ProtoCommitmentLineItemToBuyout;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProtoCommitmentLineItemToBuyout";
    o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
    o.quantity = options.quantity ?? null;
    o.costChangeInCents = options.costChangeInCents ?? null;
    o.specifications = options.specifications ?? null;
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    return o as FactoryResult<ProtoCommitmentLineItemToBuyout>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProtoCommitmentLineItemToBuyout"] = newProtoCommitmentLineItemToBuyout;

export interface CommitmentLineItemAllocationOptions {
  __typename?: "CommitmentLineItemAllocation";
  id?: CommitmentLineItemAllocation["id"];
  costInCents?: CommitmentLineItemAllocation["costInCents"];
  createdAt?: CommitmentLineItemAllocation["createdAt"];
  updatedAt?: CommitmentLineItemAllocation["updatedAt"];
  commitmentLineItem?: FactoryInput<CommitmentLineItem, CommitmentLineItemOptions>;
  projectItemAllocation?: FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>;
  billLineItemAllocations?: Array<FactoryInput<BillLineItemAllocation, BillLineItemAllocationOptions>>;
}

export function newCommitmentLineItemAllocation(
  options?: CommitmentLineItemAllocationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentLineItemAllocation>;
export function newCommitmentLineItemAllocation(
  options: CommitmentLineItemAllocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentLineItemAllocation> {
  const o = (options.__typename ? options : cache["CommitmentLineItemAllocation"] = {}) as CommitmentLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentLineItemAllocation";
    o.id = options.id ?? nextFactoryId("CommitmentLineItemAllocation");
    o.costInCents = options.costInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.commitmentLineItem = maybeNew(
      "CommitmentLineItem",
      options.commitmentLineItem,
      cache,
      options.hasOwnProperty("commitmentLineItem"),
    );
    o.projectItemAllocation = maybeNew(
      "ProjectItemAllocation",
      options.projectItemAllocation,
      cache,
      options.hasOwnProperty("projectItemAllocation"),
    );
    o.billLineItemAllocations = (options.billLineItemAllocations ?? []).map((i) =>
      maybeNew("BillLineItemAllocation", i, cache, options.hasOwnProperty("billLineItemAllocations"))
    );
    return o as FactoryResult<CommitmentLineItemAllocation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentLineItemAllocation"] = newCommitmentLineItemAllocation;

export interface SaveCommunityResultOptions {
  __typename?: "SaveCommunityResult";
  community?: FactoryInput<Community, CommunityOptions>;
}

export function newSaveCommunityResult(
  options?: SaveCommunityResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCommunityResult>;
export function newSaveCommunityResult(
  options: SaveCommunityResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCommunityResult> {
  const o = (options.__typename ? options : cache["SaveCommunityResult"] = {}) as SaveCommunityResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCommunityResult";
    o.community = maybeNew("Community", options.community, cache, options.hasOwnProperty("community"));
    return o as FactoryResult<SaveCommunityResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCommunityResult"] = newSaveCommunityResult;

export interface CommunitiesPageResultOptions {
  __typename?: "CommunitiesPageResult";
  entities?: Array<FactoryInput<Community, CommunityOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newCommunitiesPageResult(
  options?: CommunitiesPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommunitiesPageResult>;
export function newCommunitiesPageResult(
  options: CommunitiesPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommunitiesPageResult> {
  const o = (options.__typename ? options : cache["CommunitiesPageResult"] = {}) as CommunitiesPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommunitiesPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("Community", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<CommunitiesPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommunitiesPageResult"] = newCommunitiesPageResult;

export interface ProjectCostCodeBidSummaryReportOptions {
  __typename?: "ProjectCostCodeBidSummaryReport";
  statusItems?: Array<FactoryInput<CostCodeBidSummaryReportStatusItem, CostCodeBidSummaryReportStatusItemOptions>>;
  flagItems?: Array<FactoryInput<CostCodeBidSummaryReportFlagItem, CostCodeBidSummaryReportFlagItemOptions>>;
  totalStatuses?: ProjectCostCodeBidSummaryReport["totalStatuses"];
  totalFlags?: ProjectCostCodeBidSummaryReport["totalFlags"];
}

export function newProjectCostCodeBidSummaryReport(
  options?: ProjectCostCodeBidSummaryReportOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCostCodeBidSummaryReport>;
export function newProjectCostCodeBidSummaryReport(
  options: ProjectCostCodeBidSummaryReportOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectCostCodeBidSummaryReport> {
  const o =
    (options.__typename ? options : cache["ProjectCostCodeBidSummaryReport"] = {}) as ProjectCostCodeBidSummaryReport;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectCostCodeBidSummaryReport";
    o.statusItems = (options.statusItems ?? []).map((i) =>
      maybeNew("CostCodeBidSummaryReportStatusItem", i, cache, options.hasOwnProperty("statusItems"))
    );
    o.flagItems = (options.flagItems ?? []).map((i) =>
      maybeNew("CostCodeBidSummaryReportFlagItem", i, cache, options.hasOwnProperty("flagItems"))
    );
    o.totalStatuses = options.totalStatuses ?? 0;
    o.totalFlags = options.totalFlags ?? 0;
    return o as FactoryResult<ProjectCostCodeBidSummaryReport>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectCostCodeBidSummaryReport"] = newProjectCostCodeBidSummaryReport;

export interface CostCodeBidSummaryReportStatusItemOptions {
  __typename?: "CostCodeBidSummaryReportStatusItem";
  id?: CostCodeBidSummaryReportStatusItem["id"];
  count?: CostCodeBidSummaryReportStatusItem["count"];
  status?: CostCodeBidSummaryStatusDetailOptions | CostCodeBidSummaryStatus;
  percentage?: CostCodeBidSummaryReportStatusItem["percentage"];
}

export function newCostCodeBidSummaryReportStatusItem(
  options?: CostCodeBidSummaryReportStatusItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCodeBidSummaryReportStatusItem>;
export function newCostCodeBidSummaryReportStatusItem(
  options: CostCodeBidSummaryReportStatusItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostCodeBidSummaryReportStatusItem> {
  const o =
    (options.__typename
      ? options
      : cache["CostCodeBidSummaryReportStatusItem"] = {}) as CostCodeBidSummaryReportStatusItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostCodeBidSummaryReportStatusItem";
    o.id = options.id ?? nextFactoryId("CostCodeBidSummaryReportStatusItem");
    o.count = options.count ?? 0;
    o.status = enumOrDetailOfCostCodeBidSummaryStatus(options.status);
    o.percentage = options.percentage ?? "" as any;
    return o as FactoryResult<CostCodeBidSummaryReportStatusItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostCodeBidSummaryReportStatusItem"] = newCostCodeBidSummaryReportStatusItem;

export interface CostCodeBidSummaryReportFlagItemOptions {
  __typename?: "CostCodeBidSummaryReportFlagItem";
  id?: CostCodeBidSummaryReportFlagItem["id"];
  count?: CostCodeBidSummaryReportFlagItem["count"];
  flags?: Array<FactoryInput<CostCodeBidSummaryFlagDetail, CostCodeBidSummaryFlagDetailOptions>>;
}

export function newCostCodeBidSummaryReportFlagItem(
  options?: CostCodeBidSummaryReportFlagItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCodeBidSummaryReportFlagItem>;
export function newCostCodeBidSummaryReportFlagItem(
  options: CostCodeBidSummaryReportFlagItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostCodeBidSummaryReportFlagItem> {
  const o =
    (options.__typename ? options : cache["CostCodeBidSummaryReportFlagItem"] = {}) as CostCodeBidSummaryReportFlagItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostCodeBidSummaryReportFlagItem";
    o.id = options.id ?? nextFactoryId("CostCodeBidSummaryReportFlagItem");
    o.count = options.count ?? 0;
    o.flags = (options.flags ?? []).map((i) => enumOrDetailOfCostCodeBidSummaryFlag(i));
    return o as FactoryResult<CostCodeBidSummaryReportFlagItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostCodeBidSummaryReportFlagItem"] = newCostCodeBidSummaryReportFlagItem;

export interface CostCodeOptions {
  __typename?: "CostCode";
  id?: CostCode["id"];
  version?: CostCode["version"];
  division?: FactoryInput<CostDivision, CostDivisionOptions>;
  number?: CostCode["number"];
  name?: CostCode["name"];
  displayName?: CostCode["displayName"];
  quickbooksCategoryId?: CostCode["quickbooksCategoryId"];
  quickbooksItemId?: CostCode["quickbooksItemId"];
  items?: Array<FactoryInput<Item, ItemOptions>>;
  tsaSpecifications?: CostCode["tsaSpecifications"];
  intacctApAccountId?: CostCode["intacctApAccountId"];
  costClassification?: CostClassificationTypeDetailOptions | CostClassificationType;
  costSubClassification?: CostSubClassificationTypeDetailOptions | CostSubClassificationType | null;
  excludeFromPurchaseOrders?: CostCode["excludeFromPurchaseOrders"];
  billType?: BillTypeDetailOptions | BillType | null;
  excludeFromBudget?: CostCode["excludeFromBudget"];
  changeEventAutoAcceptThresholdInCents?: CostCode["changeEventAutoAcceptThresholdInCents"];
  isPriceOnly?: CostCode["isPriceOnly"];
  optionPricingConfig?: FactoryInput<OptionPricingConfig, OptionPricingConfigOptions> | null;
  materialLeadTimeConfig?: FactoryInput<MaterialLeadTimeConfig, MaterialLeadTimeConfigOptions> | null;
  minLeadTimeInDays?: CostCode["minLeadTimeInDays"];
  expectedLeadTimeInDays?: CostCode["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: CostCode["maxLeadTimeInDays"];
  history?: Array<FactoryInput<History, HistoryOptions>>;
  isUnderwritingBudget?: CostCode["isUnderwritingBudget"];
  invoiceCategory?: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | null;
  interiorFinishScheduleConfigs?: Array<FactoryInput<FinishScheduleConfig, FinishScheduleConfigOptions>>;
  exteriorFinishScheduleConfigs?: Array<FactoryInput<FinishScheduleConfig, FinishScheduleConfigOptions>>;
  finishScheduleChildItems?: Array<FactoryInput<Item, ItemOptions>>;
  interiorFinishScheduleLabel?: CostCode["interiorFinishScheduleLabel"];
  exteriorFinishScheduleLabel?: CostCode["exteriorFinishScheduleLabel"];
  interiorFinishScheduleDescription?: CostCode["interiorFinishScheduleDescription"];
  exteriorFinishScheduleDescription?: CostCode["exteriorFinishScheduleDescription"];
  interiorFinishScheduleOrder?: CostCode["interiorFinishScheduleOrder"];
  exteriorFinishScheduleOrder?: CostCode["exteriorFinishScheduleOrder"];
  expectedBidCostTypes?: Array<FactoryInput<CostTypeDetail, CostTypeDetailOptions>>;
  bidSummaries?: Array<FactoryInput<CostCodeBidSummary, CostCodeBidSummaryOptions>>;
}

export function newCostCode(options?: CostCodeOptions, factoryOptions?: FactoryOptions): FactoryResult<CostCode>;
export function newCostCode(
  options: CostCodeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostCode> {
  const o = (options.__typename ? options : cache["CostCode"] = {}) as CostCode;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostCode";
    o.id = options.id ?? nextFactoryId("CostCode");
    o.version = options.version ?? 0;
    o.division = maybeNew("CostDivision", options.division, cache, options.hasOwnProperty("division"));
    o.number = options.number ?? "number";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.quickbooksCategoryId = options.quickbooksCategoryId ?? null;
    o.quickbooksItemId = options.quickbooksItemId ?? null;
    o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
    o.tsaSpecifications = options.tsaSpecifications ?? null;
    o.intacctApAccountId = options.intacctApAccountId ?? null;
    o.costClassification = enumOrDetailOfCostClassificationType(options.costClassification);
    o.costSubClassification = enumOrDetailOrNullOfCostSubClassificationType(options.costSubClassification);
    o.excludeFromPurchaseOrders = options.excludeFromPurchaseOrders ?? false;
    o.billType = enumOrDetailOrNullOfBillType(options.billType);
    o.excludeFromBudget = options.excludeFromBudget ?? false;
    o.changeEventAutoAcceptThresholdInCents = options.changeEventAutoAcceptThresholdInCents ?? null;
    o.isPriceOnly = options.isPriceOnly ?? null;
    o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
    o.materialLeadTimeConfig = maybeNewOrNull("MaterialLeadTimeConfig", options.materialLeadTimeConfig, cache);
    o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
    o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
    o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.isUnderwritingBudget = options.isUnderwritingBudget ?? false;
    o.invoiceCategory = enumOrDetailOrNullOfCostCodeInvoiceCategory(options.invoiceCategory);
    o.interiorFinishScheduleConfigs = (options.interiorFinishScheduleConfigs ?? []).map((i) =>
      maybeNew("FinishScheduleConfig", i, cache, options.hasOwnProperty("interiorFinishScheduleConfigs"))
    );
    o.exteriorFinishScheduleConfigs = (options.exteriorFinishScheduleConfigs ?? []).map((i) =>
      maybeNew("FinishScheduleConfig", i, cache, options.hasOwnProperty("exteriorFinishScheduleConfigs"))
    );
    o.finishScheduleChildItems = (options.finishScheduleChildItems ?? []).map((i) =>
      maybeNew("Item", i, cache, options.hasOwnProperty("finishScheduleChildItems"))
    );
    o.interiorFinishScheduleLabel = options.interiorFinishScheduleLabel ?? null;
    o.exteriorFinishScheduleLabel = options.exteriorFinishScheduleLabel ?? null;
    o.interiorFinishScheduleDescription = options.interiorFinishScheduleDescription ?? null;
    o.exteriorFinishScheduleDescription = options.exteriorFinishScheduleDescription ?? null;
    o.interiorFinishScheduleOrder = options.interiorFinishScheduleOrder ?? null;
    o.exteriorFinishScheduleOrder = options.exteriorFinishScheduleOrder ?? null;
    o.expectedBidCostTypes = (options.expectedBidCostTypes ?? []).map((i) => enumOrDetailOfCostType(i));
    o.bidSummaries = (options.bidSummaries ?? []).map((i) =>
      maybeNew("CostCodeBidSummary", i, cache, options.hasOwnProperty("bidSummaries"))
    );
    return o as FactoryResult<CostCode>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostCode"] = newCostCode;

export interface SaveCostCodesResultOptions {
  __typename?: "SaveCostCodesResult";
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
}

export function newSaveCostCodesResult(
  options?: SaveCostCodesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCostCodesResult>;
export function newSaveCostCodesResult(
  options: SaveCostCodesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCostCodesResult> {
  const o = (options.__typename ? options : cache["SaveCostCodesResult"] = {}) as SaveCostCodesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCostCodesResult";
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    return o as FactoryResult<SaveCostCodesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCostCodesResult"] = newSaveCostCodesResult;

export interface CostCodeBidSummaryOptions {
  __typename?: "CostCodeBidSummary";
  id?: CostCodeBidSummary["id"];
  createdAt?: CostCodeBidSummary["createdAt"];
  updatedAt?: CostCodeBidSummary["updatedAt"];
  costType?: CostTypeDetailOptions | CostType;
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  status?: CostCodeBidSummaryStatusDetailOptions | CostCodeBidSummaryStatus;
  flags?: CostCodeBidSummary["flags"];
}

export function newCostCodeBidSummary(
  options?: CostCodeBidSummaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCodeBidSummary>;
export function newCostCodeBidSummary(
  options: CostCodeBidSummaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostCodeBidSummary> {
  const o = (options.__typename ? options : cache["CostCodeBidSummary"] = {}) as CostCodeBidSummary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostCodeBidSummary";
    o.id = options.id ?? nextFactoryId("CostCodeBidSummary");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costType = enumOrDetailOfCostType(options.costType);
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.status = enumOrDetailOfCostCodeBidSummaryStatus(options.status);
    o.flags = options.flags ?? [];
    return o as FactoryResult<CostCodeBidSummary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostCodeBidSummary"] = newCostCodeBidSummary;

export interface CostCodeBidSummariesPageResultOptions {
  __typename?: "CostCodeBidSummariesPageResult";
  entities?: Array<FactoryInput<CostCodeBidSummary, CostCodeBidSummaryOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newCostCodeBidSummariesPageResult(
  options?: CostCodeBidSummariesPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCodeBidSummariesPageResult>;
export function newCostCodeBidSummariesPageResult(
  options: CostCodeBidSummariesPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostCodeBidSummariesPageResult> {
  const o =
    (options.__typename ? options : cache["CostCodeBidSummariesPageResult"] = {}) as CostCodeBidSummariesPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostCodeBidSummariesPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("CostCodeBidSummary", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<CostCodeBidSummariesPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostCodeBidSummariesPageResult"] = newCostCodeBidSummariesPageResult;

export interface CostConfigurationSummariesPageOptions {
  __typename?: "CostConfigurationSummariesPage";
  entities?: Array<FactoryInput<CostConfigurationSummary, CostConfigurationSummaryOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newCostConfigurationSummariesPage(
  options?: CostConfigurationSummariesPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostConfigurationSummariesPage>;
export function newCostConfigurationSummariesPage(
  options: CostConfigurationSummariesPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostConfigurationSummariesPage> {
  const o =
    (options.__typename ? options : cache["CostConfigurationSummariesPage"] = {}) as CostConfigurationSummariesPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostConfigurationSummariesPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("CostConfigurationSummary", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<CostConfigurationSummariesPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostConfigurationSummariesPage"] = newCostConfigurationSummariesPage;

export interface CostConfigurationSummaryOptions {
  __typename?: "CostConfigurationSummary";
  id?: CostConfigurationSummary["id"];
  totalCostInCents?: CostConfigurationSummary["totalCostInCents"];
  totalPriceInCents?: CostConfigurationSummary["totalPriceInCents"];
  createdAt?: CostConfigurationSummary["createdAt"];
  updatedAt?: CostConfigurationSummary["updatedAt"];
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  expandedOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  pinnedOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  programData?: FactoryInput<ProgramData, ProgramDataOptions>;
}

export function newCostConfigurationSummary(
  options?: CostConfigurationSummaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostConfigurationSummary>;
export function newCostConfigurationSummary(
  options: CostConfigurationSummaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostConfigurationSummary> {
  const o = (options.__typename ? options : cache["CostConfigurationSummary"] = {}) as CostConfigurationSummary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostConfigurationSummary";
    o.id = options.id ?? nextFactoryId("CostConfigurationSummary");
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    o.expandedOptions = (options.expandedOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("expandedOptions"))
    );
    o.pinnedOptions = (options.pinnedOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("pinnedOptions"))
    );
    o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
    return o as FactoryResult<CostConfigurationSummary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostConfigurationSummary"] = newCostConfigurationSummary;

export interface CostDivisionOptions {
  __typename?: "CostDivision";
  id?: CostDivision["id"];
  version?: CostDivision["version"];
  number?: CostDivision["number"];
  name?: CostDivision["name"];
  displayName?: CostDivision["displayName"];
  stage?: StageDetailOptions | Stage;
  selectionCutoff?: SelectionCutoffDetailOptions | SelectionCutoff | null;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  tsaPolicySection?: CostDivision["tsaPolicySection"];
  tsaPaymentSection?: CostDivision["tsaPaymentSection"];
  tsaWarrantySection?: CostDivision["tsaWarrantySection"];
  tsaGeneralScope?: CostDivision["tsaGeneralScope"];
}

export function newCostDivision(
  options?: CostDivisionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostDivision>;
export function newCostDivision(
  options: CostDivisionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostDivision> {
  const o = (options.__typename ? options : cache["CostDivision"] = {}) as CostDivision;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostDivision";
    o.id = options.id ?? nextFactoryId("CostDivision");
    o.version = options.version ?? 0;
    o.number = options.number ?? "number";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.stage = enumOrDetailOfStage(options.stage);
    o.selectionCutoff = enumOrDetailOrNullOfSelectionCutoff(options.selectionCutoff);
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.tsaPolicySection = options.tsaPolicySection ?? null;
    o.tsaPaymentSection = options.tsaPaymentSection ?? null;
    o.tsaWarrantySection = options.tsaWarrantySection ?? null;
    o.tsaGeneralScope = options.tsaGeneralScope ?? null;
    return o as FactoryResult<CostDivision>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostDivision"] = newCostDivision;

export interface SaveCostDivisionsResultOptions {
  __typename?: "SaveCostDivisionsResult";
  costDivisions?: Array<FactoryInput<CostDivision, CostDivisionOptions>>;
}

export function newSaveCostDivisionsResult(
  options?: SaveCostDivisionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCostDivisionsResult>;
export function newSaveCostDivisionsResult(
  options: SaveCostDivisionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCostDivisionsResult> {
  const o = (options.__typename ? options : cache["SaveCostDivisionsResult"] = {}) as SaveCostDivisionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCostDivisionsResult";
    o.costDivisions = (options.costDivisions ?? []).map((i) =>
      maybeNew("CostDivision", i, cache, options.hasOwnProperty("costDivisions"))
    );
    return o as FactoryResult<SaveCostDivisionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCostDivisionsResult"] = newSaveCostDivisionsResult;

export interface CostLineItemAllocationOptions {
  __typename?: "CostLineItemAllocation";
  id?: CostLineItemAllocation["id"];
  invoicedAmountInCents?: CostLineItemAllocation["invoicedAmountInCents"];
  createdAt?: CostLineItemAllocation["createdAt"];
  updatedAt?: CostLineItemAllocation["updatedAt"];
  billLineItem?: FactoryInput<BillLineItem, BillLineItemOptions> | null;
  expenseAllocation?: FactoryInput<ExpenseAllocation, ExpenseAllocationOptions> | null;
  invoiceLineItem?: FactoryInput<InvoiceLineItem, InvoiceLineItemOptions>;
  costAmountInCents?: CostLineItemAllocation["costAmountInCents"];
  costLineItemId?: CostLineItemAllocation["costLineItemId"];
}

export function newCostLineItemAllocation(
  options?: CostLineItemAllocationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostLineItemAllocation>;
export function newCostLineItemAllocation(
  options: CostLineItemAllocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostLineItemAllocation> {
  const o = (options.__typename ? options : cache["CostLineItemAllocation"] = {}) as CostLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostLineItemAllocation";
    o.id = options.id ?? nextFactoryId("CostLineItemAllocation");
    o.invoicedAmountInCents = options.invoicedAmountInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.billLineItem = maybeNewOrNull("BillLineItem", options.billLineItem, cache);
    o.expenseAllocation = maybeNewOrNull("ExpenseAllocation", options.expenseAllocation, cache);
    o.invoiceLineItem = maybeNew(
      "InvoiceLineItem",
      options.invoiceLineItem,
      cache,
      options.hasOwnProperty("invoiceLineItem"),
    );
    o.costAmountInCents = options.costAmountInCents ?? 0;
    o.costLineItemId = options.costLineItemId ?? "costLineItemId";
    return o as FactoryResult<CostLineItemAllocation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostLineItemAllocation"] = newCostLineItemAllocation;

export interface CustomerOptions {
  __typename?: "Customer";
  id?: Customer["id"];
  name?: Customer["name"];
  softCostMarkupInBasisPoints?: Customer["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Customer["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Customer["directHardCostMarkupInBasisPoints"];
  createdAt?: Customer["createdAt"];
  updatedAt?: Customer["updatedAt"];
  isHti?: Customer["isHti"];
  itemConfigs?: Array<FactoryInput<CustomerItemConfig, CustomerItemConfigOptions>>;
  shouldCoverConstructionCosts?: Customer["shouldCoverConstructionCosts"];
}

export function newCustomer(options?: CustomerOptions, factoryOptions?: FactoryOptions): FactoryResult<Customer>;
export function newCustomer(
  options: CustomerOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Customer> {
  const o = (options.__typename ? options : cache["Customer"] = {}) as Customer;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Customer";
    o.id = options.id ?? nextFactoryId("Customer");
    o.name = options.name ?? "name";
    o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? 0;
    o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? 0;
    o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.isHti = options.isHti ?? null;
    o.itemConfigs = (options.itemConfigs ?? []).map((i) =>
      maybeNew("CustomerItemConfig", i, cache, options.hasOwnProperty("itemConfigs"))
    );
    o.shouldCoverConstructionCosts = options.shouldCoverConstructionCosts ?? false;
    return o as FactoryResult<Customer>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Customer"] = newCustomer;

export interface SaveCustomerResultOptions {
  __typename?: "SaveCustomerResult";
  customer?: FactoryInput<Customer, CustomerOptions>;
}

export function newSaveCustomerResult(
  options?: SaveCustomerResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCustomerResult>;
export function newSaveCustomerResult(
  options: SaveCustomerResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCustomerResult> {
  const o = (options.__typename ? options : cache["SaveCustomerResult"] = {}) as SaveCustomerResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCustomerResult";
    o.customer = maybeNew("Customer", options.customer, cache, options.hasOwnProperty("customer"));
    return o as FactoryResult<SaveCustomerResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCustomerResult"] = newSaveCustomerResult;

export interface CustomerItemConfigOptions {
  __typename?: "CustomerItemConfig";
  id?: CustomerItemConfig["id"];
  markupInBasisPoints?: CustomerItemConfig["markupInBasisPoints"];
  createdAt?: CustomerItemConfig["createdAt"];
  updatedAt?: CustomerItemConfig["updatedAt"];
  customer?: FactoryInput<Customer, CustomerOptions>;
  item?: FactoryInput<Item, ItemOptions>;
}

export function newCustomerItemConfig(
  options?: CustomerItemConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CustomerItemConfig>;
export function newCustomerItemConfig(
  options: CustomerItemConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CustomerItemConfig> {
  const o = (options.__typename ? options : cache["CustomerItemConfig"] = {}) as CustomerItemConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CustomerItemConfig";
    o.id = options.id ?? nextFactoryId("CustomerItemConfig");
    o.markupInBasisPoints = options.markupInBasisPoints ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.customer = maybeNew("Customer", options.customer, cache, options.hasOwnProperty("customer"));
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    return o as FactoryResult<CustomerItemConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CustomerItemConfig"] = newCustomerItemConfig;

export interface SaveCustomerItemConfigResultOptions {
  __typename?: "SaveCustomerItemConfigResult";
  customerItemConfig?: FactoryInput<CustomerItemConfig, CustomerItemConfigOptions>;
}

export function newSaveCustomerItemConfigResult(
  options?: SaveCustomerItemConfigResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCustomerItemConfigResult>;
export function newSaveCustomerItemConfigResult(
  options: SaveCustomerItemConfigResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCustomerItemConfigResult> {
  const o = (options.__typename ? options : cache["SaveCustomerItemConfigResult"] = {}) as SaveCustomerItemConfigResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCustomerItemConfigResult";
    o.customerItemConfig = maybeNew(
      "CustomerItemConfig",
      options.customerItemConfig,
      cache,
      options.hasOwnProperty("customerItemConfig"),
    );
    return o as FactoryResult<SaveCustomerItemConfigResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCustomerItemConfigResult"] = newSaveCustomerItemConfigResult;

export interface CustomerOwnerEntityOptions {
  __typename?: "CustomerOwnerEntity";
  id?: CustomerOwnerEntity["id"];
  name?: CustomerOwnerEntity["name"];
  intacctId?: CustomerOwnerEntity["intacctId"];
  createdAt?: CustomerOwnerEntity["createdAt"];
  updatedAt?: CustomerOwnerEntity["updatedAt"];
  isHti?: CustomerOwnerEntity["isHti"];
  warrantyLengthInDays?: CustomerOwnerEntity["warrantyLengthInDays"];
}

export function newCustomerOwnerEntity(
  options?: CustomerOwnerEntityOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CustomerOwnerEntity>;
export function newCustomerOwnerEntity(
  options: CustomerOwnerEntityOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CustomerOwnerEntity> {
  const o = (options.__typename ? options : cache["CustomerOwnerEntity"] = {}) as CustomerOwnerEntity;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CustomerOwnerEntity";
    o.id = options.id ?? nextFactoryId("CustomerOwnerEntity");
    o.name = options.name ?? "name";
    o.intacctId = options.intacctId ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.isHti = options.isHti ?? false;
    o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
    return o as FactoryResult<CustomerOwnerEntity>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CustomerOwnerEntity"] = newCustomerOwnerEntity;

export interface SaveCustomerOwnerEntityResultOptions {
  __typename?: "SaveCustomerOwnerEntityResult";
  customerOwnerEntity?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions>;
}

export function newSaveCustomerOwnerEntityResult(
  options?: SaveCustomerOwnerEntityResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveCustomerOwnerEntityResult>;
export function newSaveCustomerOwnerEntityResult(
  options: SaveCustomerOwnerEntityResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveCustomerOwnerEntityResult> {
  const o =
    (options.__typename ? options : cache["SaveCustomerOwnerEntityResult"] = {}) as SaveCustomerOwnerEntityResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveCustomerOwnerEntityResult";
    o.customerOwnerEntity = maybeNew(
      "CustomerOwnerEntity",
      options.customerOwnerEntity,
      cache,
      options.hasOwnProperty("customerOwnerEntity"),
    );
    return o as FactoryResult<SaveCustomerOwnerEntityResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveCustomerOwnerEntityResult"] = newSaveCustomerOwnerEntityResult;

export interface DesignPackageOptions {
  __typename?: "DesignPackage";
  id?: DesignPackage["id"];
  name?: DesignPackage["name"];
  displayName?: DesignPackage["displayName"];
  description?: DesignPackage["description"];
  createdAt?: DesignPackage["createdAt"];
  updatedAt?: DesignPackage["updatedAt"];
  code?: DesignPackage["code"];
  displayCode?: DesignPackage["displayCode"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  interiorDesignPackageProductOfferings?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  exteriorDesignPackageProductOfferings?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  planPackages?: Array<FactoryInput<PlanPackage, PlanPackageOptions>>;
  designPackageSources?: Array<FactoryInput<DesignPackageSource, DesignPackageSourceOptions>>;
  copyInProgress?: DesignPackage["copyInProgress"];
  slots?: Array<FactoryInput<DesignPackageSlot, DesignPackageSlotOptions>>;
  assets?: Array<FactoryInput<ReadyPlanAsset, ReadyPlanAssetOptions>>;
  lotTypes?: DesignPackage["lotTypes"];
  location?: DesignPackageLocationDetailOptions | DesignPackageLocation;
  markets?: Array<FactoryInput<Market, MarketOptions>>;
  aggregateActive?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  aggregateDraft?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  aggregateLatest?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  aggregateVersions?: Array<FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>>;
  availableUpdates?: Array<FactoryInput<DesignPackagePlanUpdate, DesignPackagePlanUpdateOptions>>;
  version?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  itemLocations?: Array<FactoryInput<Location, LocationOptions>>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  canEditLineItems?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  contingencyMarkupPercentage?: DesignPackage["contingencyMarkupPercentage"];
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  syncErrors?: DesignPackage["syncErrors"];
  readyPlanLocations?: Array<FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>>;
  potentialPersonalizationOptions?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  potentialAddOnOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  combinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
  availableTargetGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  requiredOptions?: Array<FactoryInput<ReadyPlanRequiredOption, ReadyPlanRequiredOptionOptions>>;
  projectConfigs?: Array<FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>>;
  owner?: FactoryInput<InternalUser, InternalUserOptions> | null;
  cabinetNotes?: DesignPackage["cabinetNotes"];
  cloneInProgress?: DesignPackage["cloneInProgress"];
  startedAt?: DesignPackage["startedAt"];
  completedAt?: DesignPackage["completedAt"];
}

export function newDesignPackage(
  options?: DesignPackageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackage>;
export function newDesignPackage(
  options: DesignPackageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackage> {
  const o = (options.__typename ? options : cache["DesignPackage"] = {}) as DesignPackage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackage";
    o.id = options.id ?? nextFactoryId("DesignPackage");
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.code = options.code ?? null;
    o.displayCode = options.displayCode ?? null;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.status = enumOrDetailOfReadyPlanStatus(options.status);
    o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.optionGroups = (options.optionGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
    );
    o.interiorDesignPackageProductOfferings = (options.interiorDesignPackageProductOfferings ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("interiorDesignPackageProductOfferings"))
    );
    o.exteriorDesignPackageProductOfferings = (options.exteriorDesignPackageProductOfferings ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("exteriorDesignPackageProductOfferings"))
    );
    o.planPackages = (options.planPackages ?? []).map((i) =>
      maybeNew("PlanPackage", i, cache, options.hasOwnProperty("planPackages"))
    );
    o.designPackageSources = (options.designPackageSources ?? []).map((i) =>
      maybeNew("DesignPackageSource", i, cache, options.hasOwnProperty("designPackageSources"))
    );
    o.copyInProgress = options.copyInProgress ?? false;
    o.slots = (options.slots ?? []).map((i) =>
      maybeNew("DesignPackageSlot", i, cache, options.hasOwnProperty("slots"))
    );
    o.assets = (options.assets ?? []).map((i) =>
      maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets"))
    );
    o.lotTypes = options.lotTypes ?? [];
    o.location = enumOrDetailOfDesignPackageLocation(options.location);
    o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
    o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
    o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
    o.aggregateLatest = maybeNew(
      "ReadyPlanAggregateVersion",
      options.aggregateLatest,
      cache,
      options.hasOwnProperty("aggregateLatest"),
    );
    o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
      maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
    );
    o.availableUpdates = (options.availableUpdates ?? []).map((i) =>
      maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("availableUpdates"))
    );
    o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
    o.itemLocations = (options.itemLocations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.canEditLineItems = maybeNew(
      "PotentialOperation2",
      options.canEditLineItems,
      cache,
      options.hasOwnProperty("canEditLineItems"),
    );
    o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.syncErrors = options.syncErrors ?? null;
    o.readyPlanLocations = (options.readyPlanLocations ?? []).map((i) =>
      maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("readyPlanLocations"))
    );
    o.potentialPersonalizationOptions = (options.potentialPersonalizationOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("potentialPersonalizationOptions"))
    );
    o.potentialAddOnOptions = (options.potentialAddOnOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("potentialAddOnOptions"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.combinations = (options.combinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("combinations"))
    );
    o.availableTargetGroups = (options.availableTargetGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("availableTargetGroups"))
    );
    o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
      maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
    );
    o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
    );
    o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
    o.cabinetNotes = options.cabinetNotes ?? null;
    o.cloneInProgress = options.cloneInProgress ?? false;
    o.startedAt = options.startedAt ?? null;
    o.completedAt = options.completedAt ?? null;
    return o as FactoryResult<DesignPackage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackage"] = newDesignPackage;

export interface CreateDesignPackagePlaceholderTliResultOptions {
  __typename?: "CreateDesignPackagePlaceholderTliResult";
  placeholderTli?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
  readyPlanAggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  planPackageIncomingSlots?: Array<FactoryInput<PlanPackageIncomingSlot, PlanPackageIncomingSlotOptions>>;
}

export function newCreateDesignPackagePlaceholderTliResult(
  options?: CreateDesignPackagePlaceholderTliResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CreateDesignPackagePlaceholderTliResult>;
export function newCreateDesignPackagePlaceholderTliResult(
  options: CreateDesignPackagePlaceholderTliResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CreateDesignPackagePlaceholderTliResult> {
  const o =
    (options.__typename
      ? options
      : cache["CreateDesignPackagePlaceholderTliResult"] = {}) as CreateDesignPackagePlaceholderTliResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CreateDesignPackagePlaceholderTliResult";
    o.placeholderTli = maybeNew(
      "TakeoffLineItem",
      options.placeholderTli,
      cache,
      options.hasOwnProperty("placeholderTli"),
    );
    o.readyPlanAggregateVersion = maybeNew(
      "ReadyPlanAggregateVersion",
      options.readyPlanAggregateVersion,
      cache,
      options.hasOwnProperty("readyPlanAggregateVersion"),
    );
    o.planPackageIncomingSlots = (options.planPackageIncomingSlots ?? []).map((i) =>
      maybeNew("PlanPackageIncomingSlot", i, cache, options.hasOwnProperty("planPackageIncomingSlots"))
    );
    return o as FactoryResult<CreateDesignPackagePlaceholderTliResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CreateDesignPackagePlaceholderTliResult"] = newCreateDesignPackagePlaceholderTliResult;

export interface SaveDesignPackageResultOptions {
  __typename?: "SaveDesignPackageResult";
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newSaveDesignPackageResult(
  options?: SaveDesignPackageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveDesignPackageResult>;
export function newSaveDesignPackageResult(
  options: SaveDesignPackageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveDesignPackageResult> {
  const o = (options.__typename ? options : cache["SaveDesignPackageResult"] = {}) as SaveDesignPackageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveDesignPackageResult";
    o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
    return o as FactoryResult<SaveDesignPackageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveDesignPackageResult"] = newSaveDesignPackageResult;

export interface SaveDesignPackageUpdatesResultOptions {
  __typename?: "SaveDesignPackageUpdatesResult";
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newSaveDesignPackageUpdatesResult(
  options?: SaveDesignPackageUpdatesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveDesignPackageUpdatesResult>;
export function newSaveDesignPackageUpdatesResult(
  options: SaveDesignPackageUpdatesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveDesignPackageUpdatesResult> {
  const o =
    (options.__typename ? options : cache["SaveDesignPackageUpdatesResult"] = {}) as SaveDesignPackageUpdatesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveDesignPackageUpdatesResult";
    o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
    return o as FactoryResult<SaveDesignPackageUpdatesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveDesignPackageUpdatesResult"] = newSaveDesignPackageUpdatesResult;

export interface DesignPackagesPageResultOptions {
  __typename?: "DesignPackagesPageResult";
  entities?: Array<FactoryInput<DesignPackage, DesignPackageOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newDesignPackagesPageResult(
  options?: DesignPackagesPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackagesPageResult>;
export function newDesignPackagesPageResult(
  options: DesignPackagesPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackagesPageResult> {
  const o = (options.__typename ? options : cache["DesignPackagesPageResult"] = {}) as DesignPackagesPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackagesPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("DesignPackage", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<DesignPackagesPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackagesPageResult"] = newDesignPackagesPageResult;

export interface DesignPackageSlotOptions {
  __typename?: "DesignPackageSlot";
  id?: DesignPackageSlot["id"];
  slot?: FactoryInput<ItemSlot, ItemSlotOptions>;
  coverage?: DesignPackageSlot["coverage"];
  isFullyAssigned?: DesignPackageSlot["isFullyAssigned"];
  items?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  hasPendingPlanPackageIncomingSlots?: DesignPackageSlot["hasPendingPlanPackageIncomingSlots"];
  isRejectedIncomingSlot?: DesignPackageSlot["isRejectedIncomingSlot"];
  pendingDeletion?: DesignPackageSlot["pendingDeletion"];
}

export function newDesignPackageSlot(
  options?: DesignPackageSlotOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackageSlot>;
export function newDesignPackageSlot(
  options: DesignPackageSlotOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackageSlot> {
  const o = (options.__typename ? options : cache["DesignPackageSlot"] = {}) as DesignPackageSlot;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackageSlot";
    o.id = options.id ?? nextFactoryId("DesignPackageSlot");
    o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
    o.coverage = options.coverage ?? 0;
    o.isFullyAssigned = options.isFullyAssigned ?? false;
    o.items = (options.items ?? []).map((i) => maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("items")));
    o.hasPendingPlanPackageIncomingSlots = options.hasPendingPlanPackageIncomingSlots ?? false;
    o.isRejectedIncomingSlot = options.isRejectedIncomingSlot ?? false;
    o.pendingDeletion = options.pendingDeletion ?? false;
    return o as FactoryResult<DesignPackageSlot>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackageSlot"] = newDesignPackageSlot;

export interface DesignPackageOptionCombinationOptions {
  __typename?: "DesignPackageOptionCombination";
  id?: DesignPackageOptionCombination["id"];
  combination?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  name?: DesignPackageOptionCombination["name"];
}

export function newDesignPackageOptionCombination(
  options?: DesignPackageOptionCombinationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackageOptionCombination>;
export function newDesignPackageOptionCombination(
  options: DesignPackageOptionCombinationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackageOptionCombination> {
  const o =
    (options.__typename ? options : cache["DesignPackageOptionCombination"] = {}) as DesignPackageOptionCombination;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackageOptionCombination";
    o.id = options.id ?? nextFactoryId("DesignPackageOptionCombination");
    o.combination = (options.combination ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("combination"))
    );
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.name = options.name ?? "name";
    return o as FactoryResult<DesignPackageOptionCombination>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackageOptionCombination"] = newDesignPackageOptionCombination;

export interface DesignPackageFinishSchedulePageResultOptions {
  __typename?: "DesignPackageFinishSchedulePageResult";
  entities?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newDesignPackageFinishSchedulePageResult(
  options?: DesignPackageFinishSchedulePageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackageFinishSchedulePageResult>;
export function newDesignPackageFinishSchedulePageResult(
  options: DesignPackageFinishSchedulePageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackageFinishSchedulePageResult> {
  const o =
    (options.__typename
      ? options
      : cache["DesignPackageFinishSchedulePageResult"] = {}) as DesignPackageFinishSchedulePageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackageFinishSchedulePageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<DesignPackageFinishSchedulePageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackageFinishSchedulePageResult"] = newDesignPackageFinishSchedulePageResult;

export interface PlaceholderCombinationsResultOptions {
  __typename?: "PlaceholderCombinationsResult";
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
  combinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
}

export function newPlaceholderCombinationsResult(
  options?: PlaceholderCombinationsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlaceholderCombinationsResult>;
export function newPlaceholderCombinationsResult(
  options: PlaceholderCombinationsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlaceholderCombinationsResult> {
  const o =
    (options.__typename ? options : cache["PlaceholderCombinationsResult"] = {}) as PlaceholderCombinationsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlaceholderCombinationsResult";
    o.takeoffLineItem = maybeNew(
      "TakeoffLineItem",
      options.takeoffLineItem,
      cache,
      options.hasOwnProperty("takeoffLineItem"),
    );
    o.combinations = (options.combinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("combinations"))
    );
    return o as FactoryResult<PlaceholderCombinationsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlaceholderCombinationsResult"] = newPlaceholderCombinationsResult;

export interface SavePersonalizationOptionGroupResultOptions {
  __typename?: "SavePersonalizationOptionGroupResult";
  version?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  optionGroup?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>;
}

export function newSavePersonalizationOptionGroupResult(
  options?: SavePersonalizationOptionGroupResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePersonalizationOptionGroupResult>;
export function newSavePersonalizationOptionGroupResult(
  options: SavePersonalizationOptionGroupResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePersonalizationOptionGroupResult> {
  const o =
    (options.__typename
      ? options
      : cache["SavePersonalizationOptionGroupResult"] = {}) as SavePersonalizationOptionGroupResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePersonalizationOptionGroupResult";
    o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
    o.optionGroup = maybeNew("ReadyPlanOptionGroup", options.optionGroup, cache, options.hasOwnProperty("optionGroup"));
    return o as FactoryResult<SavePersonalizationOptionGroupResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePersonalizationOptionGroupResult"] = newSavePersonalizationOptionGroupResult;

export interface CopyDesignPackageCardsResultOptions {
  __typename?: "CopyDesignPackageCardsResult";
  sourePlaceholderTli?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
  targetPlaceholderTlis?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  addedTlis?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  version?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
}

export function newCopyDesignPackageCardsResult(
  options?: CopyDesignPackageCardsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CopyDesignPackageCardsResult>;
export function newCopyDesignPackageCardsResult(
  options: CopyDesignPackageCardsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CopyDesignPackageCardsResult> {
  const o = (options.__typename ? options : cache["CopyDesignPackageCardsResult"] = {}) as CopyDesignPackageCardsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CopyDesignPackageCardsResult";
    o.sourePlaceholderTli = maybeNew(
      "TakeoffLineItem",
      options.sourePlaceholderTli,
      cache,
      options.hasOwnProperty("sourePlaceholderTli"),
    );
    o.targetPlaceholderTlis = (options.targetPlaceholderTlis ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("targetPlaceholderTlis"))
    );
    o.addedTlis = (options.addedTlis ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("addedTlis"))
    );
    o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
    return o as FactoryResult<CopyDesignPackageCardsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CopyDesignPackageCardsResult"] = newCopyDesignPackageCardsResult;

export interface CopyDesignPackageSelectionsResultOptions {
  __typename?: "CopyDesignPackageSelectionsResult";
  updatedTakeoffLineItems?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  updatedReadyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  updatedReadyPlanRequiredOptions?: Array<FactoryInput<ReadyPlanRequiredOption, ReadyPlanRequiredOptionOptions>>;
}

export function newCopyDesignPackageSelectionsResult(
  options?: CopyDesignPackageSelectionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CopyDesignPackageSelectionsResult>;
export function newCopyDesignPackageSelectionsResult(
  options: CopyDesignPackageSelectionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CopyDesignPackageSelectionsResult> {
  const o =
    (options.__typename
      ? options
      : cache["CopyDesignPackageSelectionsResult"] = {}) as CopyDesignPackageSelectionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CopyDesignPackageSelectionsResult";
    o.updatedTakeoffLineItems = (options.updatedTakeoffLineItems ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("updatedTakeoffLineItems"))
    );
    o.updatedReadyPlanOptions = (options.updatedReadyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("updatedReadyPlanOptions"))
    );
    o.updatedReadyPlanRequiredOptions = (options.updatedReadyPlanRequiredOptions ?? []).map((i) =>
      maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("updatedReadyPlanRequiredOptions"))
    );
    return o as FactoryResult<CopyDesignPackageSelectionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CopyDesignPackageSelectionsResult"] = newCopyDesignPackageSelectionsResult;

export interface DesignPackagePlanUpdateOptions {
  __typename?: "DesignPackagePlanUpdate";
  id?: DesignPackagePlanUpdate["id"];
  createdAt?: DesignPackagePlanUpdate["createdAt"];
  updatedAt?: DesignPackagePlanUpdate["updatedAt"];
  source?: FactoryInput<DesignPackageSource, DesignPackageSourceOptions>;
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  accepted?: DesignPackagePlanUpdate["accepted"];
  planVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  acceptedInVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
}

export function newDesignPackagePlanUpdate(
  options?: DesignPackagePlanUpdateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackagePlanUpdate>;
export function newDesignPackagePlanUpdate(
  options: DesignPackagePlanUpdateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackagePlanUpdate> {
  const o = (options.__typename ? options : cache["DesignPackagePlanUpdate"] = {}) as DesignPackagePlanUpdate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackagePlanUpdate";
    o.id = options.id ?? nextFactoryId("DesignPackagePlanUpdate");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.source = maybeNew("DesignPackageSource", options.source, cache, options.hasOwnProperty("source"));
    o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
    o.accepted = options.accepted ?? false;
    o.planVersion = maybeNew(
      "ReadyPlanAggregateVersion",
      options.planVersion,
      cache,
      options.hasOwnProperty("planVersion"),
    );
    o.acceptedInVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.acceptedInVersion, cache);
    return o as FactoryResult<DesignPackagePlanUpdate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackagePlanUpdate"] = newDesignPackagePlanUpdate;

export interface DesignPackageSourceOptions {
  __typename?: "DesignPackageSource";
  id?: DesignPackageSource["id"];
  createdAt?: DesignPackageSource["createdAt"];
  updatedAt?: DesignPackageSource["updatedAt"];
  readyPlan?: FactoryInput<DesignPackage, DesignPackageOptions>;
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  copyInProgress?: DesignPackageSource["copyInProgress"];
  active?: DesignPackageSource["active"];
  versions?: Array<FactoryInput<DesignPackageSourceVersion, DesignPackageSourceVersionOptions>>;
  planUpdates?: Array<FactoryInput<DesignPackagePlanUpdate, DesignPackagePlanUpdateOptions>>;
  planPackageVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
}

export function newDesignPackageSource(
  options?: DesignPackageSourceOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackageSource>;
export function newDesignPackageSource(
  options: DesignPackageSourceOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackageSource> {
  const o = (options.__typename ? options : cache["DesignPackageSource"] = {}) as DesignPackageSource;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackageSource";
    o.id = options.id ?? nextFactoryId("DesignPackageSource");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.readyPlan = maybeNew("DesignPackage", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
    o.copyInProgress = options.copyInProgress ?? false;
    o.active = options.active ?? false;
    o.versions = (options.versions ?? []).map((i) =>
      maybeNew("DesignPackageSourceVersion", i, cache, options.hasOwnProperty("versions"))
    );
    o.planUpdates = (options.planUpdates ?? []).map((i) =>
      maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("planUpdates"))
    );
    o.planPackageVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.planPackageVersion, cache);
    return o as FactoryResult<DesignPackageSource>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackageSource"] = newDesignPackageSource;

export interface SaveDesignPackageSourceResultOptions {
  __typename?: "SaveDesignPackageSourceResult";
  designPackageSource?: FactoryInput<DesignPackageSource, DesignPackageSourceOptions>;
}

export function newSaveDesignPackageSourceResult(
  options?: SaveDesignPackageSourceResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveDesignPackageSourceResult>;
export function newSaveDesignPackageSourceResult(
  options: SaveDesignPackageSourceResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveDesignPackageSourceResult> {
  const o =
    (options.__typename ? options : cache["SaveDesignPackageSourceResult"] = {}) as SaveDesignPackageSourceResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveDesignPackageSourceResult";
    o.designPackageSource = maybeNew(
      "DesignPackageSource",
      options.designPackageSource,
      cache,
      options.hasOwnProperty("designPackageSource"),
    );
    return o as FactoryResult<SaveDesignPackageSourceResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveDesignPackageSourceResult"] = newSaveDesignPackageSourceResult;

export interface DesignPackageSourceVersionOptions {
  __typename?: "DesignPackageSourceVersion";
  id?: DesignPackageSourceVersion["id"];
  active?: DesignPackageSourceVersion["active"];
  createdAt?: DesignPackageSourceVersion["createdAt"];
  updatedAt?: DesignPackageSourceVersion["updatedAt"];
  identity?: FactoryInput<DesignPackageSource, DesignPackageSourceOptions>;
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
}

export function newDesignPackageSourceVersion(
  options?: DesignPackageSourceVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackageSourceVersion>;
export function newDesignPackageSourceVersion(
  options: DesignPackageSourceVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackageSourceVersion> {
  const o = (options.__typename ? options : cache["DesignPackageSourceVersion"] = {}) as DesignPackageSourceVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackageSourceVersion";
    o.id = options.id ?? nextFactoryId("DesignPackageSourceVersion");
    o.active = options.active ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.identity = maybeNew("DesignPackageSource", options.identity, cache, options.hasOwnProperty("identity"));
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    return o as FactoryResult<DesignPackageSourceVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackageSourceVersion"] = newDesignPackageSourceVersion;

export interface DesignPackageVersionOptions {
  __typename?: "DesignPackageVersion";
  id?: DesignPackageVersion["id"];
  name?: DesignPackageVersion["name"];
  createdAt?: DesignPackageVersion["createdAt"];
  updatedAt?: DesignPackageVersion["updatedAt"];
  code?: DesignPackageVersion["code"];
  contingencyMarkupPercentage?: DesignPackageVersion["contingencyMarkupPercentage"];
  description?: DesignPackageVersion["description"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  lotTypes?: DesignPackageVersion["lotTypes"];
  identity?: FactoryInput<DesignPackage, DesignPackageOptions>;
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  markets?: Array<FactoryInput<Market, MarketOptions>>;
  owner?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newDesignPackageVersion(
  options?: DesignPackageVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackageVersion>;
export function newDesignPackageVersion(
  options: DesignPackageVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackageVersion> {
  const o = (options.__typename ? options : cache["DesignPackageVersion"] = {}) as DesignPackageVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackageVersion";
    o.id = options.id ?? nextFactoryId("DesignPackageVersion");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.code = options.code ?? null;
    o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
    o.description = options.description ?? null;
    o.type = enumOrDetailOfReadyPlanType(options.type);
    o.lotTypes = options.lotTypes ?? [];
    o.identity = maybeNew("DesignPackage", options.identity, cache, options.hasOwnProperty("identity"));
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
    o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
    return o as FactoryResult<DesignPackageVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackageVersion"] = newDesignPackageVersion;

export interface DevelopmentOptions {
  __typename?: "Development";
  id?: Development["id"];
  name?: Development["name"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  createdAt?: Development["createdAt"];
  updatedAt?: Development["updatedAt"];
  market?: FactoryInput<Market, MarketOptions>;
  cohorts?: Array<FactoryInput<Cohort, CohortOptions>> | null;
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  itemTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  commitments?: Array<FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  bidContracts?: Array<FactoryInput<BidContract, BidContractOptions>>;
  readyPlans?: Array<FactoryInput<ReadyPlan, ReadyPlanOptions>>;
  directorOfConstruction?: FactoryInput<InternalUser, InternalUserOptions> | null;
  teamMembers?: Array<FactoryInput<DevelopmentTeamMember, DevelopmentTeamMemberOptions>>;
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>>;
  options?: Array<FactoryInput<DevelopmentOption, DevelopmentOptionOptions>>;
  scheduleTemplates?: Array<FactoryInput<ScheduleTemplate, ScheduleTemplateOptions>>;
  sequenceSheetFollowers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
  isSequenceSheetFollower?: Development["isSequenceSheetFollower"];
  isTeamMember?: Development["isTeamMember"];
  canStopFollowingSequenceSheet?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canGenerateTemplates?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  itemMappings?: Array<FactoryInput<DevelopmentItemMapping, DevelopmentItemMappingOptions>>;
  costMappingProgress?: FactoryInput<CostMappingProgress, CostMappingProgressOptions>;
  internalBudgetEstimate?: FactoryInput<BidContract, BidContractOptions>;
  specOptions?: Array<FactoryInput<GlobalOption, GlobalOptionOptions>>;
  featureFlags?: Array<FactoryInput<FeatureFlag, FeatureFlagOptions>>;
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  drops?: Array<FactoryInput<Drop, DropOptions>>;
  costCodesWithDraws?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  schedulingExclusionDates?: Array<FactoryInput<SchedulingExclusionDate, SchedulingExclusionDateOptions>>;
  salesTaxOverrideInBasisPoints?: Development["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Development["salesTaxInBasisPoints"];
}

export function newDevelopment(
  options?: DevelopmentOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<Development>;
export function newDevelopment(
  options: DevelopmentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Development> {
  const o = (options.__typename ? options : cache["Development"] = {}) as Development;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Development";
    o.id = options.id ?? nextFactoryId("Development");
    o.name = options.name ?? "name";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.cohorts = (options.cohorts ?? []).map((i) => maybeNew("Cohort", i, cache, options.hasOwnProperty("cohorts")));
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
    );
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.bidContracts = (options.bidContracts ?? []).map((i) =>
      maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
    );
    o.readyPlans = (options.readyPlans ?? []).map((i) =>
      maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("readyPlans"))
    );
    o.directorOfConstruction = maybeNewOrNull("InternalUser", options.directorOfConstruction, cache);
    o.teamMembers = (options.teamMembers ?? []).map((i) =>
      maybeNew("DevelopmentTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
    );
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    o.options = (options.options ?? []).map((i) =>
      maybeNew("DevelopmentOption", i, cache, options.hasOwnProperty("options"))
    );
    o.scheduleTemplates = (options.scheduleTemplates ?? []).map((i) =>
      maybeNew("ScheduleTemplate", i, cache, options.hasOwnProperty("scheduleTemplates"))
    );
    o.sequenceSheetFollowers = (options.sequenceSheetFollowers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("sequenceSheetFollowers"))
    );
    o.isSequenceSheetFollower = options.isSequenceSheetFollower ?? false;
    o.isTeamMember = options.isTeamMember ?? false;
    o.canStopFollowingSequenceSheet = maybeNew(
      "PotentialOperation2",
      options.canStopFollowingSequenceSheet,
      cache,
      options.hasOwnProperty("canStopFollowingSequenceSheet"),
    );
    o.canGenerateTemplates = maybeNew(
      "PotentialOperation2",
      options.canGenerateTemplates,
      cache,
      options.hasOwnProperty("canGenerateTemplates"),
    );
    o.itemMappings = (options.itemMappings ?? []).map((i) =>
      maybeNew("DevelopmentItemMapping", i, cache, options.hasOwnProperty("itemMappings"))
    );
    o.costMappingProgress = maybeNew(
      "CostMappingProgress",
      options.costMappingProgress,
      cache,
      options.hasOwnProperty("costMappingProgress"),
    );
    o.internalBudgetEstimate = maybeNew(
      "BidContract",
      options.internalBudgetEstimate,
      cache,
      options.hasOwnProperty("internalBudgetEstimate"),
    );
    o.specOptions = (options.specOptions ?? []).map((i) =>
      maybeNew("GlobalOption", i, cache, options.hasOwnProperty("specOptions"))
    );
    o.featureFlags = (options.featureFlags ?? []).map((i) =>
      maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
    );
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
    o.costCodesWithDraws = (options.costCodesWithDraws ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodesWithDraws"))
    );
    o.schedulingExclusionDates = (options.schedulingExclusionDates ?? []).map((i) =>
      maybeNew("SchedulingExclusionDate", i, cache, options.hasOwnProperty("schedulingExclusionDates"))
    );
    o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
    o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
    return o as FactoryResult<Development>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Development"] = newDevelopment;

export interface SaveDevelopmentsResultOptions {
  __typename?: "SaveDevelopmentsResult";
  developments?: Array<FactoryInput<Development, DevelopmentOptions>>;
}

export function newSaveDevelopmentsResult(
  options?: SaveDevelopmentsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveDevelopmentsResult>;
export function newSaveDevelopmentsResult(
  options: SaveDevelopmentsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveDevelopmentsResult> {
  const o = (options.__typename ? options : cache["SaveDevelopmentsResult"] = {}) as SaveDevelopmentsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveDevelopmentsResult";
    o.developments = (options.developments ?? []).map((i) =>
      maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
    );
    return o as FactoryResult<SaveDevelopmentsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveDevelopmentsResult"] = newSaveDevelopmentsResult;

export interface DevelopmentItemMappingOptions {
  __typename?: "DevelopmentItemMapping";
  item?: FactoryInput<Item, ItemOptions>;
  costType?: DevelopmentItemMapping["costType"];
  location?: FactoryInput<Location, LocationOptions>;
  stage?: DevelopmentItemMapping["stage"];
  scheduleTemplateItemMappings?: Array<FactoryInput<ScheduleTemplateItemMapping, ScheduleTemplateItemMappingOptions>>;
}

export function newDevelopmentItemMapping(
  options?: DevelopmentItemMappingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentItemMapping>;
export function newDevelopmentItemMapping(
  options: DevelopmentItemMappingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentItemMapping> {
  const o = (options.__typename ? options : cache["DevelopmentItemMapping"] = {}) as DevelopmentItemMapping;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentItemMapping";
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.costType = options.costType ?? CostType.Labor;
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.stage = options.stage ?? Stage.PreConPlanning;
    o.scheduleTemplateItemMappings = (options.scheduleTemplateItemMappings ?? []).map((i) =>
      maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("scheduleTemplateItemMappings"))
    );
    return o as FactoryResult<DevelopmentItemMapping>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentItemMapping"] = newDevelopmentItemMapping;

export interface CostMappingProgressOptions {
  __typename?: "CostMappingProgress";
  totalScheduleTemplateItemMappings?: CostMappingProgress["totalScheduleTemplateItemMappings"];
  totalMappingsForDevelopment?: CostMappingProgress["totalMappingsForDevelopment"];
  showCostMappingProgress?: CostMappingProgress["showCostMappingProgress"];
}

export function newCostMappingProgress(
  options?: CostMappingProgressOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostMappingProgress>;
export function newCostMappingProgress(
  options: CostMappingProgressOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostMappingProgress> {
  const o = (options.__typename ? options : cache["CostMappingProgress"] = {}) as CostMappingProgress;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostMappingProgress";
    o.totalScheduleTemplateItemMappings = options.totalScheduleTemplateItemMappings ?? 0;
    o.totalMappingsForDevelopment = options.totalMappingsForDevelopment ?? 0;
    o.showCostMappingProgress = options.showCostMappingProgress ?? false;
    return o as FactoryResult<CostMappingProgress>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostMappingProgress"] = newCostMappingProgress;

export interface DevelopmentLotSummaryChartsResultOptions {
  __typename?: "DevelopmentLotSummaryChartsResult";
  development?: FactoryInput<Development, DevelopmentOptions>;
  acquired?: Array<FactoryInput<CohortLotSummaryChart, CohortLotSummaryChartOptions>>;
  totalAcquired?: DevelopmentLotSummaryChartsResult["totalAcquired"];
  permitSubmitted?: Array<FactoryInput<CohortLotSummaryChart, CohortLotSummaryChartOptions>>;
  totalPermitSubmitted?: DevelopmentLotSummaryChartsResult["totalPermitSubmitted"];
  permitReceived?: Array<FactoryInput<CohortLotSummaryChart, CohortLotSummaryChartOptions>>;
  totalPermitReceived?: DevelopmentLotSummaryChartsResult["totalPermitReceived"];
  verticalMobilization?: Array<FactoryInput<CohortLotSummaryChart, CohortLotSummaryChartOptions>>;
  totalVerticalMobilization?: DevelopmentLotSummaryChartsResult["totalVerticalMobilization"];
  verticalComplete?: Array<FactoryInput<CohortLotSummaryChart, CohortLotSummaryChartOptions>>;
  totalVerticalComplete?: DevelopmentLotSummaryChartsResult["totalVerticalComplete"];
  delivered?: Array<FactoryInput<CohortLotSummaryChart, CohortLotSummaryChartOptions>>;
  totalDelivered?: DevelopmentLotSummaryChartsResult["totalDelivered"];
}

export function newDevelopmentLotSummaryChartsResult(
  options?: DevelopmentLotSummaryChartsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentLotSummaryChartsResult>;
export function newDevelopmentLotSummaryChartsResult(
  options: DevelopmentLotSummaryChartsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentLotSummaryChartsResult> {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentLotSummaryChartsResult"] = {}) as DevelopmentLotSummaryChartsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentLotSummaryChartsResult";
    o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
    o.acquired = (options.acquired ?? []).map((i) =>
      maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("acquired"))
    );
    o.totalAcquired = options.totalAcquired ?? 0;
    o.permitSubmitted = (options.permitSubmitted ?? []).map((i) =>
      maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("permitSubmitted"))
    );
    o.totalPermitSubmitted = options.totalPermitSubmitted ?? 0;
    o.permitReceived = (options.permitReceived ?? []).map((i) =>
      maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("permitReceived"))
    );
    o.totalPermitReceived = options.totalPermitReceived ?? 0;
    o.verticalMobilization = (options.verticalMobilization ?? []).map((i) =>
      maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("verticalMobilization"))
    );
    o.totalVerticalMobilization = options.totalVerticalMobilization ?? 0;
    o.verticalComplete = (options.verticalComplete ?? []).map((i) =>
      maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("verticalComplete"))
    );
    o.totalVerticalComplete = options.totalVerticalComplete ?? 0;
    o.delivered = (options.delivered ?? []).map((i) =>
      maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("delivered"))
    );
    o.totalDelivered = options.totalDelivered ?? 0;
    return o as FactoryResult<DevelopmentLotSummaryChartsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentLotSummaryChartsResult"] = newDevelopmentLotSummaryChartsResult;

export interface CohortLotSummaryChartOptions {
  __typename?: "CohortLotSummaryChart";
  cohort?: FactoryInput<Cohort, CohortOptions>;
  total?: CohortLotSummaryChart["total"];
}

export function newCohortLotSummaryChart(
  options?: CohortLotSummaryChartOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CohortLotSummaryChart>;
export function newCohortLotSummaryChart(
  options: CohortLotSummaryChartOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CohortLotSummaryChart> {
  const o = (options.__typename ? options : cache["CohortLotSummaryChart"] = {}) as CohortLotSummaryChart;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CohortLotSummaryChart";
    o.cohort = maybeNew("Cohort", options.cohort, cache, options.hasOwnProperty("cohort"));
    o.total = options.total ?? 0;
    return o as FactoryResult<CohortLotSummaryChart>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CohortLotSummaryChart"] = newCohortLotSummaryChart;

export interface DevelopmentCommitmentSummaryLineItemOptions {
  __typename?: "DevelopmentCommitmentSummaryLineItem";
  costInCents?: DevelopmentCommitmentSummaryLineItem["costInCents"];
  numberOfProjects?: DevelopmentCommitmentSummaryLineItem["numberOfProjects"];
  item?: FactoryInput<Item, ItemOptions>;
  quantity?: DevelopmentCommitmentSummaryLineItem["quantity"];
}

export function newDevelopmentCommitmentSummaryLineItem(
  options?: DevelopmentCommitmentSummaryLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitmentSummaryLineItem>;
export function newDevelopmentCommitmentSummaryLineItem(
  options: DevelopmentCommitmentSummaryLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentCommitmentSummaryLineItem> {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentCommitmentSummaryLineItem"] = {}) as DevelopmentCommitmentSummaryLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentCommitmentSummaryLineItem";
    o.costInCents = options.costInCents ?? 0;
    o.numberOfProjects = options.numberOfProjects ?? 0;
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.quantity = options.quantity ?? 0;
    return o as FactoryResult<DevelopmentCommitmentSummaryLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentCommitmentSummaryLineItem"] = newDevelopmentCommitmentSummaryLineItem;

export interface DevelopmentCommitmentSummaryOptions {
  __typename?: "DevelopmentCommitmentSummary";
  lineItems?: Array<FactoryInput<DevelopmentCommitmentSummaryLineItem, DevelopmentCommitmentSummaryLineItemOptions>>;
}

export function newDevelopmentCommitmentSummary(
  options?: DevelopmentCommitmentSummaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitmentSummary>;
export function newDevelopmentCommitmentSummary(
  options: DevelopmentCommitmentSummaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentCommitmentSummary> {
  const o = (options.__typename ? options : cache["DevelopmentCommitmentSummary"] = {}) as DevelopmentCommitmentSummary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentCommitmentSummary";
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("DevelopmentCommitmentSummaryLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    return o as FactoryResult<DevelopmentCommitmentSummary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentCommitmentSummary"] = newDevelopmentCommitmentSummary;

export interface SaveDevelopmentCommitmentResultOptions {
  __typename?: "SaveDevelopmentCommitmentResult";
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>;
}

export function newSaveDevelopmentCommitmentResult(
  options?: SaveDevelopmentCommitmentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveDevelopmentCommitmentResult>;
export function newSaveDevelopmentCommitmentResult(
  options: SaveDevelopmentCommitmentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveDevelopmentCommitmentResult> {
  const o =
    (options.__typename ? options : cache["SaveDevelopmentCommitmentResult"] = {}) as SaveDevelopmentCommitmentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveDevelopmentCommitmentResult";
    o.developmentCommitment = maybeNew(
      "DevelopmentCommitment",
      options.developmentCommitment,
      cache,
      options.hasOwnProperty("developmentCommitment"),
    );
    return o as FactoryResult<SaveDevelopmentCommitmentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveDevelopmentCommitmentResult"] = newSaveDevelopmentCommitmentResult;

export interface DevelopmentCommitmentPotentialLineItemOptions {
  __typename?: "DevelopmentCommitmentPotentialLineItem";
  item?: FactoryInput<Item, ItemOptions>;
  costType?: DevelopmentCommitmentPotentialLineItem["costType"];
  location?: FactoryInput<Location, LocationOptions>;
  totalCostInCents?: DevelopmentCommitmentPotentialLineItem["totalCostInCents"];
  projects?: DevelopmentCommitmentPotentialLineItem["projects"];
}

export function newDevelopmentCommitmentPotentialLineItem(
  options?: DevelopmentCommitmentPotentialLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitmentPotentialLineItem>;
export function newDevelopmentCommitmentPotentialLineItem(
  options: DevelopmentCommitmentPotentialLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentCommitmentPotentialLineItem> {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentCommitmentPotentialLineItem"] = {}) as DevelopmentCommitmentPotentialLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentCommitmentPotentialLineItem";
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.costType = options.costType ?? CostType.Labor;
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.projects = options.projects ?? [];
    return o as FactoryResult<DevelopmentCommitmentPotentialLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentCommitmentPotentialLineItem"] = newDevelopmentCommitmentPotentialLineItem;

export interface DevelopmentCommitmentCostCodeSummaryOptions {
  __typename?: "DevelopmentCommitmentCostCodeSummary";
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  numberOfProjects?: DevelopmentCommitmentCostCodeSummary["numberOfProjects"];
  quantity?: DevelopmentCommitmentCostCodeSummary["quantity"];
}

export function newDevelopmentCommitmentCostCodeSummary(
  options?: DevelopmentCommitmentCostCodeSummaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitmentCostCodeSummary>;
export function newDevelopmentCommitmentCostCodeSummary(
  options: DevelopmentCommitmentCostCodeSummaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentCommitmentCostCodeSummary> {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentCommitmentCostCodeSummary"] = {}) as DevelopmentCommitmentCostCodeSummary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentCommitmentCostCodeSummary";
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.numberOfProjects = options.numberOfProjects ?? 0;
    o.quantity = options.quantity ?? 0;
    return o as FactoryResult<DevelopmentCommitmentCostCodeSummary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentCommitmentCostCodeSummary"] = newDevelopmentCommitmentCostCodeSummary;

export interface DeleteDevelopmentCommitmentProjectsAndCommitmentsResultOptions {
  __typename?: "DeleteDevelopmentCommitmentProjectsAndCommitmentsResult";
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>;
}

export function newDeleteDevelopmentCommitmentProjectsAndCommitmentsResult(
  options?: DeleteDevelopmentCommitmentProjectsAndCommitmentsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteDevelopmentCommitmentProjectsAndCommitmentsResult>;
export function newDeleteDevelopmentCommitmentProjectsAndCommitmentsResult(
  options: DeleteDevelopmentCommitmentProjectsAndCommitmentsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteDevelopmentCommitmentProjectsAndCommitmentsResult> {
  const o =
    (options.__typename
      ? options
      : cache["DeleteDevelopmentCommitmentProjectsAndCommitmentsResult"] =
        {}) as DeleteDevelopmentCommitmentProjectsAndCommitmentsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteDevelopmentCommitmentProjectsAndCommitmentsResult";
    o.developmentCommitment = maybeNew(
      "DevelopmentCommitment",
      options.developmentCommitment,
      cache,
      options.hasOwnProperty("developmentCommitment"),
    );
    return o as FactoryResult<DeleteDevelopmentCommitmentProjectsAndCommitmentsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteDevelopmentCommitmentProjectsAndCommitmentsResult"] =
  newDeleteDevelopmentCommitmentProjectsAndCommitmentsResult;

export interface DevelopmentCommitmentsPageOptions {
  __typename?: "DevelopmentCommitmentsPage";
  entities?: Array<FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newDevelopmentCommitmentsPage(
  options?: DevelopmentCommitmentsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitmentsPage>;
export function newDevelopmentCommitmentsPage(
  options: DevelopmentCommitmentsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentCommitmentsPage> {
  const o = (options.__typename ? options : cache["DevelopmentCommitmentsPage"] = {}) as DevelopmentCommitmentsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentCommitmentsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<DevelopmentCommitmentsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentCommitmentsPage"] = newDevelopmentCommitmentsPage;

export interface DevelopmentOptionOptions {
  __typename?: "DevelopmentOption";
  id?: DevelopmentOption["id"];
  shortName?: DevelopmentOption["shortName"];
  createdAt?: DevelopmentOption["createdAt"];
  updatedAt?: DevelopmentOption["updatedAt"];
  development?: FactoryInput<Development, DevelopmentOptions>;
  globalOption?: FactoryInput<GlobalOption, GlobalOptionOptions>;
}

export function newDevelopmentOption(
  options?: DevelopmentOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentOption>;
export function newDevelopmentOption(
  options: DevelopmentOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentOption> {
  const o = (options.__typename ? options : cache["DevelopmentOption"] = {}) as DevelopmentOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentOption";
    o.id = options.id ?? nextFactoryId("DevelopmentOption");
    o.shortName = options.shortName ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
    o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
    return o as FactoryResult<DevelopmentOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentOption"] = newDevelopmentOption;

export interface SaveDevelopmentOptionsResultOptions {
  __typename?: "SaveDevelopmentOptionsResult";
  developmentOptions?: Array<FactoryInput<DevelopmentOption, DevelopmentOptionOptions>>;
}

export function newSaveDevelopmentOptionsResult(
  options?: SaveDevelopmentOptionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveDevelopmentOptionsResult>;
export function newSaveDevelopmentOptionsResult(
  options: SaveDevelopmentOptionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveDevelopmentOptionsResult> {
  const o = (options.__typename ? options : cache["SaveDevelopmentOptionsResult"] = {}) as SaveDevelopmentOptionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveDevelopmentOptionsResult";
    o.developmentOptions = (options.developmentOptions ?? []).map((i) =>
      maybeNew("DevelopmentOption", i, cache, options.hasOwnProperty("developmentOptions"))
    );
    return o as FactoryResult<SaveDevelopmentOptionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveDevelopmentOptionsResult"] = newSaveDevelopmentOptionsResult;

export interface DevelopmentTeamMemberOptions {
  __typename?: "DevelopmentTeamMember";
  id?: DevelopmentTeamMember["id"];
  createdAt?: DevelopmentTeamMember["createdAt"];
  updatedAt?: DevelopmentTeamMember["updatedAt"];
  projectRole?: ProjectRoleDetailOptions | ProjectRole;
  development?: FactoryInput<Development, DevelopmentOptions>;
  internalUser?: FactoryInput<InternalUser, InternalUserOptions>;
}

export function newDevelopmentTeamMember(
  options?: DevelopmentTeamMemberOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentTeamMember>;
export function newDevelopmentTeamMember(
  options: DevelopmentTeamMemberOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentTeamMember> {
  const o = (options.__typename ? options : cache["DevelopmentTeamMember"] = {}) as DevelopmentTeamMember;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentTeamMember";
    o.id = options.id ?? nextFactoryId("DevelopmentTeamMember");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.projectRole = enumOrDetailOfProjectRole(options.projectRole);
    o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
    o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
    return o as FactoryResult<DevelopmentTeamMember>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentTeamMember"] = newDevelopmentTeamMember;

export interface DocumentsPageResultOptions {
  __typename?: "DocumentsPageResult";
  entities?: Array<FactoryInput<Document, DocumentOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newDocumentsPageResult(
  options?: DocumentsPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DocumentsPageResult>;
export function newDocumentsPageResult(
  options: DocumentsPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DocumentsPageResult> {
  const o = (options.__typename ? options : cache["DocumentsPageResult"] = {}) as DocumentsPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DocumentsPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<DocumentsPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DocumentsPageResult"] = newDocumentsPageResult;

export interface DeleteDocumentsResultOptions {
  __typename?: "DeleteDocumentsResult";
  parents?: Array<
    | DocumentParent
    | FactoryResult<DocumentParent>
    | DevelopmentOptions
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
  >;
  emptyResult?: DeleteDocumentsResult["emptyResult"];
  dummyString?: DeleteDocumentsResult["dummyString"];
}

export function newDeleteDocumentsResult(
  options?: DeleteDocumentsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteDocumentsResult>;
export function newDeleteDocumentsResult(
  options: DeleteDocumentsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteDocumentsResult> {
  const o = (options.__typename ? options : cache["DeleteDocumentsResult"] = {}) as DeleteDocumentsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteDocumentsResult";
    o.parents = (options.parents ?? []).map((i) =>
      maybeNew(i?.__typename ?? "{Development", i, cache, options.hasOwnProperty("parents"))
    );
    o.emptyResult = options.emptyResult ?? null;
    o.dummyString = options.dummyString ?? null;
    return o as FactoryResult<DeleteDocumentsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteDocumentsResult"] = newDeleteDocumentsResult;

export interface CreateDocumentPendingUploadResultOptions {
  __typename?: "CreateDocumentPendingUploadResult";
  signedUrl?: CreateDocumentPendingUploadResult["signedUrl"];
  documentId?: CreateDocumentPendingUploadResult["documentId"];
}

export function newCreateDocumentPendingUploadResult(
  options?: CreateDocumentPendingUploadResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CreateDocumentPendingUploadResult>;
export function newCreateDocumentPendingUploadResult(
  options: CreateDocumentPendingUploadResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CreateDocumentPendingUploadResult> {
  const o =
    (options.__typename
      ? options
      : cache["CreateDocumentPendingUploadResult"] = {}) as CreateDocumentPendingUploadResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CreateDocumentPendingUploadResult";
    o.signedUrl = options.signedUrl ?? "signedUrl";
    o.documentId = options.documentId ?? "documentId";
    return o as FactoryResult<CreateDocumentPendingUploadResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CreateDocumentPendingUploadResult"] = newCreateDocumentPendingUploadResult;

export interface MarkDocumentAsUploadedResultOptions {
  __typename?: "MarkDocumentAsUploadedResult";
  document?: FactoryInput<Document, DocumentOptions>;
}

export function newMarkDocumentAsUploadedResult(
  options?: MarkDocumentAsUploadedResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MarkDocumentAsUploadedResult>;
export function newMarkDocumentAsUploadedResult(
  options: MarkDocumentAsUploadedResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MarkDocumentAsUploadedResult> {
  const o = (options.__typename ? options : cache["MarkDocumentAsUploadedResult"] = {}) as MarkDocumentAsUploadedResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MarkDocumentAsUploadedResult";
    o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
    return o as FactoryResult<MarkDocumentAsUploadedResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MarkDocumentAsUploadedResult"] = newMarkDocumentAsUploadedResult;

export interface ToggleDocumentAsFavoritedResultOptions {
  __typename?: "ToggleDocumentAsFavoritedResult";
  document?: FactoryInput<Document, DocumentOptions>;
}

export function newToggleDocumentAsFavoritedResult(
  options?: ToggleDocumentAsFavoritedResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToggleDocumentAsFavoritedResult>;
export function newToggleDocumentAsFavoritedResult(
  options: ToggleDocumentAsFavoritedResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ToggleDocumentAsFavoritedResult> {
  const o =
    (options.__typename ? options : cache["ToggleDocumentAsFavoritedResult"] = {}) as ToggleDocumentAsFavoritedResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ToggleDocumentAsFavoritedResult";
    o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
    return o as FactoryResult<ToggleDocumentAsFavoritedResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ToggleDocumentAsFavoritedResult"] = newToggleDocumentAsFavoritedResult;

export interface SaveDocumentsResultOptions {
  __typename?: "SaveDocumentsResult";
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
}

export function newSaveDocumentsResult(
  options?: SaveDocumentsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveDocumentsResult>;
export function newSaveDocumentsResult(
  options: SaveDocumentsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveDocumentsResult> {
  const o = (options.__typename ? options : cache["SaveDocumentsResult"] = {}) as SaveDocumentsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveDocumentsResult";
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    return o as FactoryResult<SaveDocumentsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveDocumentsResult"] = newSaveDocumentsResult;

export interface DropOptions {
  __typename?: "Drop";
  id?: Drop["id"];
  name?: Drop["name"];
  code?: Drop["code"];
  createdAt?: Drop["createdAt"];
  updatedAt?: Drop["updatedAt"];
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  globalPlanTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
  locations?: Array<FactoryInput<Location, LocationOptions>>;
  order?: Drop["order"];
  commitments?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  productOfferingIncomingUpdates?: Array<
    FactoryInput<ProductOfferingIncomingUpdate, ProductOfferingIncomingUpdateOptions>
  >;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
}

export function newDrop(options?: DropOptions, factoryOptions?: FactoryOptions): FactoryResult<Drop>;
export function newDrop(
  options: DropOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Drop> {
  const o = (options.__typename ? options : cache["Drop"] = {}) as Drop;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Drop";
    o.id = options.id ?? nextFactoryId("Drop");
    o.name = options.name ?? "name";
    o.code = options.code ?? "code";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.globalPlanTask = maybeNew(
      "GlobalPlanTask",
      options.globalPlanTask,
      cache,
      options.hasOwnProperty("globalPlanTask"),
    );
    o.locations = (options.locations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
    );
    o.order = options.order ?? 0;
    o.commitments = (options.commitments ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
    );
    o.productOfferingIncomingUpdates = (options.productOfferingIncomingUpdates ?? []).map((i) =>
      maybeNew("ProductOfferingIncomingUpdate", i, cache, options.hasOwnProperty("productOfferingIncomingUpdates"))
    );
    o.project = maybeNewOrNull("Project", options.project, cache);
    return o as FactoryResult<Drop>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Drop"] = newDrop;

export interface SaveDropResultOptions {
  __typename?: "SaveDropResult";
  drop?: FactoryInput<Drop, DropOptions>;
}

export function newSaveDropResult(
  options?: SaveDropResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveDropResult>;
export function newSaveDropResult(
  options: SaveDropResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveDropResult> {
  const o = (options.__typename ? options : cache["SaveDropResult"] = {}) as SaveDropResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveDropResult";
    o.drop = maybeNew("Drop", options.drop, cache, options.hasOwnProperty("drop"));
    return o as FactoryResult<SaveDropResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveDropResult"] = newSaveDropResult;

export interface ActivityPlanningStateDetailOptions {
  __typename?: "ActivityPlanningStateDetail";
  code?: ActivityPlanningStateDetail["code"];
  name?: ActivityPlanningStateDetail["name"];
}

export function newActivityPlanningStateDetail(
  options?: ActivityPlanningStateDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ActivityPlanningStateDetail>;
export function newActivityPlanningStateDetail(
  options: ActivityPlanningStateDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ActivityPlanningStateDetail> {
  const o = (options.__typename ? options : cache["ActivityPlanningStateDetail"] = {}) as ActivityPlanningStateDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ActivityPlanningStateDetail";
    o.code = options.code ?? ActivityPlanningState.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<ActivityPlanningStateDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ActivityPlanningStateDetail"] = newActivityPlanningStateDetail;

export interface ActivityResponsibilityDetailOptions {
  __typename?: "ActivityResponsibilityDetail";
  code?: ActivityResponsibilityDetail["code"];
  name?: ActivityResponsibilityDetail["name"];
}

export function newActivityResponsibilityDetail(
  options?: ActivityResponsibilityDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ActivityResponsibilityDetail>;
export function newActivityResponsibilityDetail(
  options: ActivityResponsibilityDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ActivityResponsibilityDetail> {
  const o = (options.__typename ? options : cache["ActivityResponsibilityDetail"] = {}) as ActivityResponsibilityDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ActivityResponsibilityDetail";
    o.code = options.code ?? ActivityResponsibility.Homebound;
    o.name = options.name ?? "Homebound";
    return o as FactoryResult<ActivityResponsibilityDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ActivityResponsibilityDetail"] = newActivityResponsibilityDetail;

export interface ActivityTypeDetailOptions {
  __typename?: "ActivityTypeDetail";
  code?: ActivityTypeDetail["code"];
  name?: ActivityTypeDetail["name"];
}

export function newActivityTypeDetail(
  options?: ActivityTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ActivityTypeDetail>;
export function newActivityTypeDetail(
  options: ActivityTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ActivityTypeDetail> {
  const o = (options.__typename ? options : cache["ActivityTypeDetail"] = {}) as ActivityTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ActivityTypeDetail";
    o.code = options.code ?? ActivityType.PreconPlanning;
    o.name = options.name ?? "Precon planning";
    return o as FactoryResult<ActivityTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ActivityTypeDetail"] = newActivityTypeDetail;

export interface AggregateVersionStatusDetailOptions {
  __typename?: "AggregateVersionStatusDetail";
  code?: AggregateVersionStatusDetail["code"];
  name?: AggregateVersionStatusDetail["name"];
}

export function newAggregateVersionStatusDetail(
  options?: AggregateVersionStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AggregateVersionStatusDetail>;
export function newAggregateVersionStatusDetail(
  options: AggregateVersionStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AggregateVersionStatusDetail> {
  const o = (options.__typename ? options : cache["AggregateVersionStatusDetail"] = {}) as AggregateVersionStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AggregateVersionStatusDetail";
    o.code = options.code ?? AggregateVersionStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<AggregateVersionStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AggregateVersionStatusDetail"] = newAggregateVersionStatusDetail;

export interface AiDataConfidenceDetailOptions {
  __typename?: "AiDataConfidenceDetail";
  code?: AiDataConfidenceDetail["code"];
  name?: AiDataConfidenceDetail["name"];
}

export function newAiDataConfidenceDetail(
  options?: AiDataConfidenceDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiDataConfidenceDetail>;
export function newAiDataConfidenceDetail(
  options: AiDataConfidenceDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiDataConfidenceDetail> {
  const o = (options.__typename ? options : cache["AiDataConfidenceDetail"] = {}) as AiDataConfidenceDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiDataConfidenceDetail";
    o.code = options.code ?? AiDataConfidence.Low;
    o.name = options.name ?? "Low";
    return o as FactoryResult<AiDataConfidenceDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiDataConfidenceDetail"] = newAiDataConfidenceDetail;

export interface AiEntityProposalEntityTypeDetailOptions {
  __typename?: "AiEntityProposalEntityTypeDetail";
  code?: AiEntityProposalEntityTypeDetail["code"];
  name?: AiEntityProposalEntityTypeDetail["name"];
}

export function newAiEntityProposalEntityTypeDetail(
  options?: AiEntityProposalEntityTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiEntityProposalEntityTypeDetail>;
export function newAiEntityProposalEntityTypeDetail(
  options: AiEntityProposalEntityTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiEntityProposalEntityTypeDetail> {
  const o =
    (options.__typename ? options : cache["AiEntityProposalEntityTypeDetail"] = {}) as AiEntityProposalEntityTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiEntityProposalEntityTypeDetail";
    o.code = options.code ?? AiEntityProposalEntityType.MaterialVariant;
    o.name = options.name ?? "Material variant";
    return o as FactoryResult<AiEntityProposalEntityTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiEntityProposalEntityTypeDetail"] = newAiEntityProposalEntityTypeDetail;

export interface AiEntityProposalTypeDetailOptions {
  __typename?: "AiEntityProposalTypeDetail";
  code?: AiEntityProposalTypeDetail["code"];
  name?: AiEntityProposalTypeDetail["name"];
}

export function newAiEntityProposalTypeDetail(
  options?: AiEntityProposalTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiEntityProposalTypeDetail>;
export function newAiEntityProposalTypeDetail(
  options: AiEntityProposalTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiEntityProposalTypeDetail> {
  const o = (options.__typename ? options : cache["AiEntityProposalTypeDetail"] = {}) as AiEntityProposalTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiEntityProposalTypeDetail";
    o.code = options.code ?? AiEntityProposalType.Create;
    o.name = options.name ?? "Create";
    return o as FactoryResult<AiEntityProposalTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiEntityProposalTypeDetail"] = newAiEntityProposalTypeDetail;

export interface AiFieldProposalStatusDetailOptions {
  __typename?: "AiFieldProposalStatusDetail";
  code?: AiFieldProposalStatusDetail["code"];
  name?: AiFieldProposalStatusDetail["name"];
}

export function newAiFieldProposalStatusDetail(
  options?: AiFieldProposalStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiFieldProposalStatusDetail>;
export function newAiFieldProposalStatusDetail(
  options: AiFieldProposalStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiFieldProposalStatusDetail> {
  const o = (options.__typename ? options : cache["AiFieldProposalStatusDetail"] = {}) as AiFieldProposalStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiFieldProposalStatusDetail";
    o.code = options.code ?? AiFieldProposalStatus.Pending;
    o.name = options.name ?? "Pending";
    return o as FactoryResult<AiFieldProposalStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiFieldProposalStatusDetail"] = newAiFieldProposalStatusDetail;

export interface AiProposalStatusDetailOptions {
  __typename?: "AiProposalStatusDetail";
  code?: AiProposalStatusDetail["code"];
  name?: AiProposalStatusDetail["name"];
}

export function newAiProposalStatusDetail(
  options?: AiProposalStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiProposalStatusDetail>;
export function newAiProposalStatusDetail(
  options: AiProposalStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiProposalStatusDetail> {
  const o = (options.__typename ? options : cache["AiProposalStatusDetail"] = {}) as AiProposalStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiProposalStatusDetail";
    o.code = options.code ?? AiProposalStatus.Pending;
    o.name = options.name ?? "Pending";
    return o as FactoryResult<AiProposalStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiProposalStatusDetail"] = newAiProposalStatusDetail;

export interface AiProposalTypeDetailOptions {
  __typename?: "AiProposalTypeDetail";
  code?: AiProposalTypeDetail["code"];
  name?: AiProposalTypeDetail["name"];
}

export function newAiProposalTypeDetail(
  options?: AiProposalTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AiProposalTypeDetail>;
export function newAiProposalTypeDetail(
  options: AiProposalTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AiProposalTypeDetail> {
  const o = (options.__typename ? options : cache["AiProposalTypeDetail"] = {}) as AiProposalTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AiProposalTypeDetail";
    o.code = options.code ?? AiProposalType.ConstructionDocumentImport;
    o.name = options.name ?? "Construction document import";
    return o as FactoryResult<AiProposalTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AiProposalTypeDetail"] = newAiProposalTypeDetail;

export interface AllocationStrategyDetailOptions {
  __typename?: "AllocationStrategyDetail";
  code?: AllocationStrategyDetail["code"];
  name?: AllocationStrategyDetail["name"];
}

export function newAllocationStrategyDetail(
  options?: AllocationStrategyDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AllocationStrategyDetail>;
export function newAllocationStrategyDetail(
  options: AllocationStrategyDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AllocationStrategyDetail> {
  const o = (options.__typename ? options : cache["AllocationStrategyDetail"] = {}) as AllocationStrategyDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AllocationStrategyDetail";
    o.code = options.code ?? AllocationStrategy.SizeBased;
    o.name = options.name ?? "Size based";
    return o as FactoryResult<AllocationStrategyDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AllocationStrategyDetail"] = newAllocationStrategyDetail;

export interface ApprovalStatusDetailOptions {
  __typename?: "ApprovalStatusDetail";
  code?: ApprovalStatusDetail["code"];
  name?: ApprovalStatusDetail["name"];
  sortOrder?: ApprovalStatusDetail["sortOrder"];
}

export function newApprovalStatusDetail(
  options?: ApprovalStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ApprovalStatusDetail>;
export function newApprovalStatusDetail(
  options: ApprovalStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ApprovalStatusDetail> {
  const o = (options.__typename ? options : cache["ApprovalStatusDetail"] = {}) as ApprovalStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ApprovalStatusDetail";
    o.code = options.code ?? ApprovalStatus.ChangesNeeded;
    o.name = options.name ?? "Changes needed";
    o.sortOrder = options.sortOrder ?? 0;
    return o as FactoryResult<ApprovalStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ApprovalStatusDetail"] = newApprovalStatusDetail;

export interface ApproverStatusDetailOptions {
  __typename?: "ApproverStatusDetail";
  code?: ApproverStatusDetail["code"];
  name?: ApproverStatusDetail["name"];
  sortOrder?: ApproverStatusDetail["sortOrder"];
}

export function newApproverStatusDetail(
  options?: ApproverStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ApproverStatusDetail>;
export function newApproverStatusDetail(
  options: ApproverStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ApproverStatusDetail> {
  const o = (options.__typename ? options : cache["ApproverStatusDetail"] = {}) as ApproverStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ApproverStatusDetail";
    o.code = options.code ?? ApproverStatus.Pending;
    o.name = options.name ?? "Pending";
    o.sortOrder = options.sortOrder ?? 0;
    return o as FactoryResult<ApproverStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ApproverStatusDetail"] = newApproverStatusDetail;

export interface BidContractRevisionStatusDetailOptions {
  __typename?: "BidContractRevisionStatusDetail";
  code?: BidContractRevisionStatusDetail["code"];
  name?: BidContractRevisionStatusDetail["name"];
}

export function newBidContractRevisionStatusDetail(
  options?: BidContractRevisionStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractRevisionStatusDetail>;
export function newBidContractRevisionStatusDetail(
  options: BidContractRevisionStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContractRevisionStatusDetail> {
  const o =
    (options.__typename ? options : cache["BidContractRevisionStatusDetail"] = {}) as BidContractRevisionStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContractRevisionStatusDetail";
    o.code = options.code ?? BidContractRevisionStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<BidContractRevisionStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContractRevisionStatusDetail"] = newBidContractRevisionStatusDetail;

export interface BidContractTypeDetailOptions {
  __typename?: "BidContractTypeDetail";
  code?: BidContractTypeDetail["code"];
  name?: BidContractTypeDetail["name"];
}

export function newBidContractTypeDetail(
  options?: BidContractTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractTypeDetail>;
export function newBidContractTypeDetail(
  options: BidContractTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidContractTypeDetail> {
  const o = (options.__typename ? options : cache["BidContractTypeDetail"] = {}) as BidContractTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidContractTypeDetail";
    o.code = options.code ?? BidContractType.UnitBased;
    o.name = options.name ?? "Unit based";
    return o as FactoryResult<BidContractTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidContractTypeDetail"] = newBidContractTypeDetail;

export interface BidPackageStatusDetailOptions {
  __typename?: "BidPackageStatusDetail";
  code?: BidPackageStatusDetail["code"];
  name?: BidPackageStatusDetail["name"];
}

export function newBidPackageStatusDetail(
  options?: BidPackageStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageStatusDetail>;
export function newBidPackageStatusDetail(
  options: BidPackageStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BidPackageStatusDetail> {
  const o = (options.__typename ? options : cache["BidPackageStatusDetail"] = {}) as BidPackageStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BidPackageStatusDetail";
    o.code = options.code ?? BidPackageStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<BidPackageStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BidPackageStatusDetail"] = newBidPackageStatusDetail;

export interface BillGmailAttachmentResultDetailOptions {
  __typename?: "BillGmailAttachmentResultDetail";
  code?: BillGmailAttachmentResultDetail["code"];
  name?: BillGmailAttachmentResultDetail["name"];
}

export function newBillGmailAttachmentResultDetail(
  options?: BillGmailAttachmentResultDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillGmailAttachmentResultDetail>;
export function newBillGmailAttachmentResultDetail(
  options: BillGmailAttachmentResultDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillGmailAttachmentResultDetail> {
  const o =
    (options.__typename ? options : cache["BillGmailAttachmentResultDetail"] = {}) as BillGmailAttachmentResultDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillGmailAttachmentResultDetail";
    o.code = options.code ?? BillGmailAttachmentResult.NotPdf;
    o.name = options.name ?? "Not pdf";
    return o as FactoryResult<BillGmailAttachmentResultDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillGmailAttachmentResultDetail"] = newBillGmailAttachmentResultDetail;

export interface BillGmailMessageResultDetailOptions {
  __typename?: "BillGmailMessageResultDetail";
  code?: BillGmailMessageResultDetail["code"];
  name?: BillGmailMessageResultDetail["name"];
}

export function newBillGmailMessageResultDetail(
  options?: BillGmailMessageResultDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillGmailMessageResultDetail>;
export function newBillGmailMessageResultDetail(
  options: BillGmailMessageResultDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillGmailMessageResultDetail> {
  const o = (options.__typename ? options : cache["BillGmailMessageResultDetail"] = {}) as BillGmailMessageResultDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillGmailMessageResultDetail";
    o.code = options.code ?? BillGmailMessageResult.NotFound;
    o.name = options.name ?? "Not found";
    return o as FactoryResult<BillGmailMessageResultDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillGmailMessageResultDetail"] = newBillGmailMessageResultDetail;

export interface BillReviewReasonDetailOptions {
  __typename?: "BillReviewReasonDetail";
  code?: BillReviewReasonDetail["code"];
  name?: BillReviewReasonDetail["name"];
}

export function newBillReviewReasonDetail(
  options?: BillReviewReasonDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillReviewReasonDetail>;
export function newBillReviewReasonDetail(
  options: BillReviewReasonDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillReviewReasonDetail> {
  const o = (options.__typename ? options : cache["BillReviewReasonDetail"] = {}) as BillReviewReasonDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillReviewReasonDetail";
    o.code = options.code ?? BillReviewReason.MissingPo;
    o.name = options.name ?? "Missing po";
    return o as FactoryResult<BillReviewReasonDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillReviewReasonDetail"] = newBillReviewReasonDetail;

export interface BillSourceDetailOptions {
  __typename?: "BillSourceDetail";
  code?: BillSourceDetail["code"];
  name?: BillSourceDetail["name"];
}

export function newBillSourceDetail(
  options?: BillSourceDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillSourceDetail>;
export function newBillSourceDetail(
  options: BillSourceDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillSourceDetail> {
  const o = (options.__typename ? options : cache["BillSourceDetail"] = {}) as BillSourceDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillSourceDetail";
    o.code = options.code ?? BillSource.Manual;
    o.name = options.name ?? "Manual";
    return o as FactoryResult<BillSourceDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillSourceDetail"] = newBillSourceDetail;

export interface BillStatusDetailOptions {
  __typename?: "BillStatusDetail";
  code?: BillStatusDetail["code"];
  name?: BillStatusDetail["name"];
}

export function newBillStatusDetail(
  options?: BillStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillStatusDetail>;
export function newBillStatusDetail(
  options: BillStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillStatusDetail> {
  const o = (options.__typename ? options : cache["BillStatusDetail"] = {}) as BillStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillStatusDetail";
    o.code = options.code ?? BillStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<BillStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillStatusDetail"] = newBillStatusDetail;

export interface BillTypeDetailOptions {
  __typename?: "BillTypeDetail";
  code?: BillTypeDetail["code"];
  name?: BillTypeDetail["name"];
}

export function newBillTypeDetail(
  options?: BillTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BillTypeDetail>;
export function newBillTypeDetail(
  options: BillTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BillTypeDetail> {
  const o = (options.__typename ? options : cache["BillTypeDetail"] = {}) as BillTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BillTypeDetail";
    o.code = options.code ?? BillType.Standard;
    o.name = options.name ?? "Standard";
    return o as FactoryResult<BillTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BillTypeDetail"] = newBillTypeDetail;

export interface BusinessFunctionTypeDetailOptions {
  __typename?: "BusinessFunctionTypeDetail";
  code?: BusinessFunctionTypeDetail["code"];
  name?: BusinessFunctionTypeDetail["name"];
}

export function newBusinessFunctionTypeDetail(
  options?: BusinessFunctionTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BusinessFunctionTypeDetail>;
export function newBusinessFunctionTypeDetail(
  options: BusinessFunctionTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BusinessFunctionTypeDetail> {
  const o = (options.__typename ? options : cache["BusinessFunctionTypeDetail"] = {}) as BusinessFunctionTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BusinessFunctionTypeDetail";
    o.code = options.code ?? BusinessFunctionType.Architecture;
    o.name = options.name ?? "Architecture";
    return o as FactoryResult<BusinessFunctionTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BusinessFunctionTypeDetail"] = newBusinessFunctionTypeDetail;

export interface BuyoutStatusDetailOptions {
  __typename?: "BuyoutStatusDetail";
  code?: BuyoutStatusDetail["code"];
  name?: BuyoutStatusDetail["name"];
  shortName?: BuyoutStatusDetail["shortName"];
}

export function newBuyoutStatusDetail(
  options?: BuyoutStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BuyoutStatusDetail>;
export function newBuyoutStatusDetail(
  options: BuyoutStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BuyoutStatusDetail> {
  const o = (options.__typename ? options : cache["BuyoutStatusDetail"] = {}) as BuyoutStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BuyoutStatusDetail";
    o.code = options.code ?? BuyoutStatus.NotBoughtOut;
    o.name = options.name ?? "Not bought out";
    o.shortName = options.shortName ?? "Not bought out";
    return o as FactoryResult<BuyoutStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BuyoutStatusDetail"] = newBuyoutStatusDetail;

export interface ChangeEventBudgetPhaseDetailOptions {
  __typename?: "ChangeEventBudgetPhaseDetail";
  code?: ChangeEventBudgetPhaseDetail["code"];
  name?: ChangeEventBudgetPhaseDetail["name"];
  sortOrder?: ChangeEventBudgetPhaseDetail["sortOrder"];
}

export function newChangeEventBudgetPhaseDetail(
  options?: ChangeEventBudgetPhaseDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventBudgetPhaseDetail>;
export function newChangeEventBudgetPhaseDetail(
  options: ChangeEventBudgetPhaseDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventBudgetPhaseDetail> {
  const o = (options.__typename ? options : cache["ChangeEventBudgetPhaseDetail"] = {}) as ChangeEventBudgetPhaseDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventBudgetPhaseDetail";
    o.code = options.code ?? ChangeEventBudgetPhase.Prebid;
    o.name = options.name ?? "Prebid";
    o.sortOrder = options.sortOrder ?? 0;
    return o as FactoryResult<ChangeEventBudgetPhaseDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventBudgetPhaseDetail"] = newChangeEventBudgetPhaseDetail;

export interface ChangeEventLineItemTypeDetailOptions {
  __typename?: "ChangeEventLineItemTypeDetail";
  code?: ChangeEventLineItemTypeDetail["code"];
  name?: ChangeEventLineItemTypeDetail["name"];
}

export function newChangeEventLineItemTypeDetail(
  options?: ChangeEventLineItemTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventLineItemTypeDetail>;
export function newChangeEventLineItemTypeDetail(
  options: ChangeEventLineItemTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventLineItemTypeDetail> {
  const o =
    (options.__typename ? options : cache["ChangeEventLineItemTypeDetail"] = {}) as ChangeEventLineItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventLineItemTypeDetail";
    o.code = options.code ?? ChangeEventLineItemType.Add;
    o.name = options.name ?? "Add";
    return o as FactoryResult<ChangeEventLineItemTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventLineItemTypeDetail"] = newChangeEventLineItemTypeDetail;

export interface ChangeEventStatusDetailOptions {
  __typename?: "ChangeEventStatusDetail";
  code?: ChangeEventStatusDetail["code"];
  name?: ChangeEventStatusDetail["name"];
}

export function newChangeEventStatusDetail(
  options?: ChangeEventStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventStatusDetail>;
export function newChangeEventStatusDetail(
  options: ChangeEventStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventStatusDetail> {
  const o = (options.__typename ? options : cache["ChangeEventStatusDetail"] = {}) as ChangeEventStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventStatusDetail";
    o.code = options.code ?? ChangeEventStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<ChangeEventStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventStatusDetail"] = newChangeEventStatusDetail;

export interface ChangeEventTypeDetailOptions {
  __typename?: "ChangeEventTypeDetail";
  code?: ChangeEventTypeDetail["code"];
  name?: ChangeEventTypeDetail["name"];
}

export function newChangeEventTypeDetail(
  options?: ChangeEventTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventTypeDetail>;
export function newChangeEventTypeDetail(
  options: ChangeEventTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventTypeDetail> {
  const o = (options.__typename ? options : cache["ChangeEventTypeDetail"] = {}) as ChangeEventTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventTypeDetail";
    o.code = options.code ?? ChangeEventType.Internal;
    o.name = options.name ?? "Internal";
    return o as FactoryResult<ChangeEventTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventTypeDetail"] = newChangeEventTypeDetail;

export interface ChangeEventWorkflowDetailOptions {
  __typename?: "ChangeEventWorkflowDetail";
  code?: ChangeEventWorkflowDetail["code"];
  name?: ChangeEventWorkflowDetail["name"];
  description?: ChangeEventWorkflowDetail["description"];
}

export function newChangeEventWorkflowDetail(
  options?: ChangeEventWorkflowDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventWorkflowDetail>;
export function newChangeEventWorkflowDetail(
  options: ChangeEventWorkflowDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeEventWorkflowDetail> {
  const o = (options.__typename ? options : cache["ChangeEventWorkflowDetail"] = {}) as ChangeEventWorkflowDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeEventWorkflowDetail";
    o.code = options.code ?? ChangeEventWorkflow.ApplyInitialConfiguration;
    o.name = options.name ?? "Apply initial configuration";
    o.description = options.description ?? "Apply initial configuration";
    return o as FactoryResult<ChangeEventWorkflowDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeEventWorkflowDetail"] = newChangeEventWorkflowDetail;

export interface ChangeRequestAssetPlatformDetailOptions {
  __typename?: "ChangeRequestAssetPlatformDetail";
  code?: ChangeRequestAssetPlatformDetail["code"];
  name?: ChangeRequestAssetPlatformDetail["name"];
}

export function newChangeRequestAssetPlatformDetail(
  options?: ChangeRequestAssetPlatformDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestAssetPlatformDetail>;
export function newChangeRequestAssetPlatformDetail(
  options: ChangeRequestAssetPlatformDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestAssetPlatformDetail> {
  const o =
    (options.__typename ? options : cache["ChangeRequestAssetPlatformDetail"] = {}) as ChangeRequestAssetPlatformDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestAssetPlatformDetail";
    o.code = options.code ?? ChangeRequestAssetPlatform.Blueprint;
    o.name = options.name ?? "Blueprint";
    return o as FactoryResult<ChangeRequestAssetPlatformDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestAssetPlatformDetail"] = newChangeRequestAssetPlatformDetail;

export interface ChangeRequestAssetScopeDetailOptions {
  __typename?: "ChangeRequestAssetScopeDetail";
  code?: ChangeRequestAssetScopeDetail["code"];
  name?: ChangeRequestAssetScopeDetail["name"];
}

export function newChangeRequestAssetScopeDetail(
  options?: ChangeRequestAssetScopeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestAssetScopeDetail>;
export function newChangeRequestAssetScopeDetail(
  options: ChangeRequestAssetScopeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestAssetScopeDetail> {
  const o =
    (options.__typename ? options : cache["ChangeRequestAssetScopeDetail"] = {}) as ChangeRequestAssetScopeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestAssetScopeDetail";
    o.code = options.code ?? ChangeRequestAssetScope.Project;
    o.name = options.name ?? "Project";
    return o as FactoryResult<ChangeRequestAssetScopeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestAssetScopeDetail"] = newChangeRequestAssetScopeDetail;

export interface ChangeRequestPriorityDetailOptions {
  __typename?: "ChangeRequestPriorityDetail";
  code?: ChangeRequestPriorityDetail["code"];
  name?: ChangeRequestPriorityDetail["name"];
}

export function newChangeRequestPriorityDetail(
  options?: ChangeRequestPriorityDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestPriorityDetail>;
export function newChangeRequestPriorityDetail(
  options: ChangeRequestPriorityDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestPriorityDetail> {
  const o = (options.__typename ? options : cache["ChangeRequestPriorityDetail"] = {}) as ChangeRequestPriorityDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestPriorityDetail";
    o.code = options.code ?? ChangeRequestPriority.Low;
    o.name = options.name ?? "Low";
    return o as FactoryResult<ChangeRequestPriorityDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestPriorityDetail"] = newChangeRequestPriorityDetail;

export interface ChangeRequestSourceDetailOptions {
  __typename?: "ChangeRequestSourceDetail";
  code?: ChangeRequestSourceDetail["code"];
  name?: ChangeRequestSourceDetail["name"];
}

export function newChangeRequestSourceDetail(
  options?: ChangeRequestSourceDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestSourceDetail>;
export function newChangeRequestSourceDetail(
  options: ChangeRequestSourceDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestSourceDetail> {
  const o = (options.__typename ? options : cache["ChangeRequestSourceDetail"] = {}) as ChangeRequestSourceDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestSourceDetail";
    o.code = options.code ?? ChangeRequestSource.Na;
    o.name = options.name ?? "Na";
    return o as FactoryResult<ChangeRequestSourceDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestSourceDetail"] = newChangeRequestSourceDetail;

export interface ChangeRequestStatusDetailOptions {
  __typename?: "ChangeRequestStatusDetail";
  code?: ChangeRequestStatusDetail["code"];
  name?: ChangeRequestStatusDetail["name"];
}

export function newChangeRequestStatusDetail(
  options?: ChangeRequestStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestStatusDetail>;
export function newChangeRequestStatusDetail(
  options: ChangeRequestStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestStatusDetail> {
  const o = (options.__typename ? options : cache["ChangeRequestStatusDetail"] = {}) as ChangeRequestStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestStatusDetail";
    o.code = options.code ?? ChangeRequestStatus.NeedsReview;
    o.name = options.name ?? "Needs review";
    return o as FactoryResult<ChangeRequestStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestStatusDetail"] = newChangeRequestStatusDetail;

export interface ChangeRequestToDoTypeDetailOptions {
  __typename?: "ChangeRequestToDoTypeDetail";
  code?: ChangeRequestToDoTypeDetail["code"];
  name?: ChangeRequestToDoTypeDetail["name"];
}

export function newChangeRequestToDoTypeDetail(
  options?: ChangeRequestToDoTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestToDoTypeDetail>;
export function newChangeRequestToDoTypeDetail(
  options: ChangeRequestToDoTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeRequestToDoTypeDetail> {
  const o = (options.__typename ? options : cache["ChangeRequestToDoTypeDetail"] = {}) as ChangeRequestToDoTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeRequestToDoTypeDetail";
    o.code = options.code ?? ChangeRequestToDoType.InitialReview;
    o.name = options.name ?? "Initial review";
    return o as FactoryResult<ChangeRequestToDoTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeRequestToDoTypeDetail"] = newChangeRequestToDoTypeDetail;

export interface ChangeTypeDetailOptions {
  __typename?: "ChangeTypeDetail";
  code?: ChangeTypeDetail["code"];
  name?: ChangeTypeDetail["name"];
  sortOrder?: ChangeTypeDetail["sortOrder"];
}

export function newChangeTypeDetail(
  options?: ChangeTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeTypeDetail>;
export function newChangeTypeDetail(
  options: ChangeTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ChangeTypeDetail> {
  const o = (options.__typename ? options : cache["ChangeTypeDetail"] = {}) as ChangeTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ChangeTypeDetail";
    o.code = options.code ?? ChangeType.Na;
    o.name = options.name ?? "Na";
    o.sortOrder = options.sortOrder ?? 0;
    return o as FactoryResult<ChangeTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ChangeTypeDetail"] = newChangeTypeDetail;

export interface CheckoutConfigOptionGroupStepDetailOptions {
  __typename?: "CheckoutConfigOptionGroupStepDetail";
  code?: CheckoutConfigOptionGroupStepDetail["code"];
  name?: CheckoutConfigOptionGroupStepDetail["name"];
}

export function newCheckoutConfigOptionGroupStepDetail(
  options?: CheckoutConfigOptionGroupStepDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigOptionGroupStepDetail>;
export function newCheckoutConfigOptionGroupStepDetail(
  options: CheckoutConfigOptionGroupStepDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfigOptionGroupStepDetail> {
  const o =
    (options.__typename
      ? options
      : cache["CheckoutConfigOptionGroupStepDetail"] = {}) as CheckoutConfigOptionGroupStepDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfigOptionGroupStepDetail";
    o.code = options.code ?? CheckoutConfigOptionGroupStep.ExteriorElevation;
    o.name = options.name ?? "Exterior elevation";
    return o as FactoryResult<CheckoutConfigOptionGroupStepDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfigOptionGroupStepDetail"] = newCheckoutConfigOptionGroupStepDetail;

export interface CheckoutConfigStatusDetailOptions {
  __typename?: "CheckoutConfigStatusDetail";
  code?: CheckoutConfigStatusDetail["code"];
  name?: CheckoutConfigStatusDetail["name"];
}

export function newCheckoutConfigStatusDetail(
  options?: CheckoutConfigStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigStatusDetail>;
export function newCheckoutConfigStatusDetail(
  options: CheckoutConfigStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CheckoutConfigStatusDetail> {
  const o = (options.__typename ? options : cache["CheckoutConfigStatusDetail"] = {}) as CheckoutConfigStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CheckoutConfigStatusDetail";
    o.code = options.code ?? CheckoutConfigStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<CheckoutConfigStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CheckoutConfigStatusDetail"] = newCheckoutConfigStatusDetail;

export interface ClientPlatformDetailOptions {
  __typename?: "ClientPlatformDetail";
  code?: ClientPlatformDetail["code"];
  name?: ClientPlatformDetail["name"];
}

export function newClientPlatformDetail(
  options?: ClientPlatformDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ClientPlatformDetail>;
export function newClientPlatformDetail(
  options: ClientPlatformDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ClientPlatformDetail> {
  const o = (options.__typename ? options : cache["ClientPlatformDetail"] = {}) as ClientPlatformDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ClientPlatformDetail";
    o.code = options.code ?? ClientPlatform.Web;
    o.name = options.name ?? "Web";
    return o as FactoryResult<ClientPlatformDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ClientPlatformDetail"] = newClientPlatformDetail;

export interface CommentStreamVisibilityDetailOptions {
  __typename?: "CommentStreamVisibilityDetail";
  code?: CommentStreamVisibilityDetail["code"];
  name?: CommentStreamVisibilityDetail["name"];
}

export function newCommentStreamVisibilityDetail(
  options?: CommentStreamVisibilityDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommentStreamVisibilityDetail>;
export function newCommentStreamVisibilityDetail(
  options: CommentStreamVisibilityDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommentStreamVisibilityDetail> {
  const o =
    (options.__typename ? options : cache["CommentStreamVisibilityDetail"] = {}) as CommentStreamVisibilityDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommentStreamVisibilityDetail";
    o.code = options.code ?? CommentStreamVisibility.Internal;
    o.name = options.name ?? "Internal";
    return o as FactoryResult<CommentStreamVisibilityDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommentStreamVisibilityDetail"] = newCommentStreamVisibilityDetail;

export interface CommitmentStatusDetailOptions {
  __typename?: "CommitmentStatusDetail";
  code?: CommitmentStatusDetail["code"];
  name?: CommitmentStatusDetail["name"];
}

export function newCommitmentStatusDetail(
  options?: CommitmentStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentStatusDetail>;
export function newCommitmentStatusDetail(
  options: CommitmentStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentStatusDetail> {
  const o = (options.__typename ? options : cache["CommitmentStatusDetail"] = {}) as CommitmentStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentStatusDetail";
    o.code = options.code ?? CommitmentStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<CommitmentStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentStatusDetail"] = newCommitmentStatusDetail;

export interface CommitmentTypeDetailOptions {
  __typename?: "CommitmentTypeDetail";
  code?: CommitmentTypeDetail["code"];
  name?: CommitmentTypeDetail["name"];
}

export function newCommitmentTypeDetail(
  options?: CommitmentTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentTypeDetail>;
export function newCommitmentTypeDetail(
  options: CommitmentTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentTypeDetail> {
  const o = (options.__typename ? options : cache["CommitmentTypeDetail"] = {}) as CommitmentTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommitmentTypeDetail";
    o.code = options.code ?? CommitmentType.PurchaseOrder;
    o.name = options.name ?? "Purchase order";
    return o as FactoryResult<CommitmentTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommitmentTypeDetail"] = newCommitmentTypeDetail;

export interface CommunicationChannelDetailOptions {
  __typename?: "CommunicationChannelDetail";
  code?: CommunicationChannelDetail["code"];
  name?: CommunicationChannelDetail["name"];
}

export function newCommunicationChannelDetail(
  options?: CommunicationChannelDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommunicationChannelDetail>;
export function newCommunicationChannelDetail(
  options: CommunicationChannelDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommunicationChannelDetail> {
  const o = (options.__typename ? options : cache["CommunicationChannelDetail"] = {}) as CommunicationChannelDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommunicationChannelDetail";
    o.code = options.code ?? CommunicationChannel.Email;
    o.name = options.name ?? "Email";
    return o as FactoryResult<CommunicationChannelDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommunicationChannelDetail"] = newCommunicationChannelDetail;

export interface CommunityTypeDetailOptions {
  __typename?: "CommunityTypeDetail";
  code?: CommunityTypeDetail["code"];
  name?: CommunityTypeDetail["name"];
}

export function newCommunityTypeDetail(
  options?: CommunityTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommunityTypeDetail>;
export function newCommunityTypeDetail(
  options: CommunityTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommunityTypeDetail> {
  const o = (options.__typename ? options : cache["CommunityTypeDetail"] = {}) as CommunityTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CommunityTypeDetail";
    o.code = options.code ?? CommunityType.Infill;
    o.name = options.name ?? "Infill";
    return o as FactoryResult<CommunityTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CommunityTypeDetail"] = newCommunityTypeDetail;

export interface ConstructionTypeDetailOptions {
  __typename?: "ConstructionTypeDetail";
  code?: ConstructionTypeDetail["code"];
  name?: ConstructionTypeDetail["name"];
}

export function newConstructionTypeDetail(
  options?: ConstructionTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ConstructionTypeDetail>;
export function newConstructionTypeDetail(
  options: ConstructionTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ConstructionTypeDetail> {
  const o = (options.__typename ? options : cache["ConstructionTypeDetail"] = {}) as ConstructionTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ConstructionTypeDetail";
    o.code = options.code ?? ConstructionType.TypeIii;
    o.name = options.name ?? "Type iii";
    return o as FactoryResult<ConstructionTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ConstructionTypeDetail"] = newConstructionTypeDetail;

export interface ContractTypeDetailOptions {
  __typename?: "ContractTypeDetail";
  code?: ContractTypeDetail["code"];
  name?: ContractTypeDetail["name"];
}

export function newContractTypeDetail(
  options?: ContractTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ContractTypeDetail>;
export function newContractTypeDetail(
  options: ContractTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ContractTypeDetail> {
  const o = (options.__typename ? options : cache["ContractTypeDetail"] = {}) as ContractTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ContractTypeDetail";
    o.code = options.code ?? ContractType.Fixed;
    o.name = options.name ?? "Fixed";
    return o as FactoryResult<ContractTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ContractTypeDetail"] = newContractTypeDetail;

export interface CostClassificationTypeDetailOptions {
  __typename?: "CostClassificationTypeDetail";
  code?: CostClassificationTypeDetail["code"];
  name?: CostClassificationTypeDetail["name"];
}

export function newCostClassificationTypeDetail(
  options?: CostClassificationTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostClassificationTypeDetail>;
export function newCostClassificationTypeDetail(
  options: CostClassificationTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostClassificationTypeDetail> {
  const o = (options.__typename ? options : cache["CostClassificationTypeDetail"] = {}) as CostClassificationTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostClassificationTypeDetail";
    o.code = options.code ?? CostClassificationType.Soft;
    o.name = options.name ?? "Soft";
    return o as FactoryResult<CostClassificationTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostClassificationTypeDetail"] = newCostClassificationTypeDetail;

export interface CostCodeBidSummaryFlagDetailOptions {
  __typename?: "CostCodeBidSummaryFlagDetail";
  code?: CostCodeBidSummaryFlagDetail["code"];
  name?: CostCodeBidSummaryFlagDetail["name"];
  isLevelOne?: CostCodeBidSummaryFlagDetail["isLevelOne"];
  isLevelTwo?: CostCodeBidSummaryFlagDetail["isLevelTwo"];
}

export function newCostCodeBidSummaryFlagDetail(
  options?: CostCodeBidSummaryFlagDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCodeBidSummaryFlagDetail>;
export function newCostCodeBidSummaryFlagDetail(
  options: CostCodeBidSummaryFlagDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostCodeBidSummaryFlagDetail> {
  const o = (options.__typename ? options : cache["CostCodeBidSummaryFlagDetail"] = {}) as CostCodeBidSummaryFlagDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostCodeBidSummaryFlagDetail";
    o.code = options.code ?? CostCodeBidSummaryFlag.MissingBid;
    o.name = options.name ?? "Missing bid";
    o.isLevelOne = options.isLevelOne ?? false;
    o.isLevelTwo = options.isLevelTwo ?? false;
    return o as FactoryResult<CostCodeBidSummaryFlagDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostCodeBidSummaryFlagDetail"] = newCostCodeBidSummaryFlagDetail;

export interface CostCodeBidSummaryStatusDetailOptions {
  __typename?: "CostCodeBidSummaryStatusDetail";
  code?: CostCodeBidSummaryStatusDetail["code"];
  name?: CostCodeBidSummaryStatusDetail["name"];
}

export function newCostCodeBidSummaryStatusDetail(
  options?: CostCodeBidSummaryStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCodeBidSummaryStatusDetail>;
export function newCostCodeBidSummaryStatusDetail(
  options: CostCodeBidSummaryStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostCodeBidSummaryStatusDetail> {
  const o =
    (options.__typename ? options : cache["CostCodeBidSummaryStatusDetail"] = {}) as CostCodeBidSummaryStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostCodeBidSummaryStatusDetail";
    o.code = options.code ?? CostCodeBidSummaryStatus.Missing;
    o.name = options.name ?? "Missing";
    return o as FactoryResult<CostCodeBidSummaryStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostCodeBidSummaryStatusDetail"] = newCostCodeBidSummaryStatusDetail;

export interface CostCodeInvoiceCategoryDetailOptions {
  __typename?: "CostCodeInvoiceCategoryDetail";
  code?: CostCodeInvoiceCategoryDetail["code"];
  name?: CostCodeInvoiceCategoryDetail["name"];
  includeInInvoiceScheduleProration?: CostCodeInvoiceCategoryDetail["includeInInvoiceScheduleProration"];
  sortOrder?: CostCodeInvoiceCategoryDetail["sortOrder"];
}

export function newCostCodeInvoiceCategoryDetail(
  options?: CostCodeInvoiceCategoryDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCodeInvoiceCategoryDetail>;
export function newCostCodeInvoiceCategoryDetail(
  options: CostCodeInvoiceCategoryDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostCodeInvoiceCategoryDetail> {
  const o =
    (options.__typename ? options : cache["CostCodeInvoiceCategoryDetail"] = {}) as CostCodeInvoiceCategoryDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostCodeInvoiceCategoryDetail";
    o.code = options.code ?? CostCodeInvoiceCategory.PreCon;
    o.name = options.name ?? "Pre con";
    o.includeInInvoiceScheduleProration = options.includeInInvoiceScheduleProration ?? false;
    o.sortOrder = options.sortOrder ?? 0;
    return o as FactoryResult<CostCodeInvoiceCategoryDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostCodeInvoiceCategoryDetail"] = newCostCodeInvoiceCategoryDetail;

export interface CostConfidenceDetailOptions {
  __typename?: "CostConfidenceDetail";
  code?: CostConfidenceDetail["code"];
  name?: CostConfidenceDetail["name"];
}

export function newCostConfidenceDetail(
  options?: CostConfidenceDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostConfidenceDetail>;
export function newCostConfidenceDetail(
  options: CostConfidenceDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostConfidenceDetail> {
  const o = (options.__typename ? options : cache["CostConfidenceDetail"] = {}) as CostConfidenceDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostConfidenceDetail";
    o.code = options.code ?? CostConfidence.Low;
    o.name = options.name ?? "Low";
    return o as FactoryResult<CostConfidenceDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostConfidenceDetail"] = newCostConfidenceDetail;

export interface CostSubClassificationTypeDetailOptions {
  __typename?: "CostSubClassificationTypeDetail";
  code?: CostSubClassificationTypeDetail["code"];
  name?: CostSubClassificationTypeDetail["name"];
}

export function newCostSubClassificationTypeDetail(
  options?: CostSubClassificationTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostSubClassificationTypeDetail>;
export function newCostSubClassificationTypeDetail(
  options: CostSubClassificationTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostSubClassificationTypeDetail> {
  const o =
    (options.__typename ? options : cache["CostSubClassificationTypeDetail"] = {}) as CostSubClassificationTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostSubClassificationTypeDetail";
    o.code = options.code ?? CostSubClassificationType.Indirect;
    o.name = options.name ?? "Indirect";
    return o as FactoryResult<CostSubClassificationTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostSubClassificationTypeDetail"] = newCostSubClassificationTypeDetail;

export interface CostTypeDetailOptions {
  __typename?: "CostTypeDetail";
  code?: CostTypeDetail["code"];
  name?: CostTypeDetail["name"];
  tradePartnerName?: CostTypeDetail["tradePartnerName"];
}

export function newCostTypeDetail(
  options?: CostTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostTypeDetail>;
export function newCostTypeDetail(
  options: CostTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostTypeDetail> {
  const o = (options.__typename ? options : cache["CostTypeDetail"] = {}) as CostTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostTypeDetail";
    o.code = options.code ?? CostType.Labor;
    o.name = options.name ?? "Labor";
    o.tradePartnerName = options.tradePartnerName ?? "Labor";
    return o as FactoryResult<CostTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostTypeDetail"] = newCostTypeDetail;

export interface DayOfWeekDetailOptions {
  __typename?: "DayOfWeekDetail";
  code?: DayOfWeekDetail["code"];
  name?: DayOfWeekDetail["name"];
  isBusinessDay?: DayOfWeekDetail["isBusinessDay"];
}

export function newDayOfWeekDetail(
  options?: DayOfWeekDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DayOfWeekDetail>;
export function newDayOfWeekDetail(
  options: DayOfWeekDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DayOfWeekDetail> {
  const o = (options.__typename ? options : cache["DayOfWeekDetail"] = {}) as DayOfWeekDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DayOfWeekDetail";
    o.code = options.code ?? DayOfWeek.Saturday;
    o.name = options.name ?? "Saturday";
    o.isBusinessDay = options.isBusinessDay ?? false;
    return o as FactoryResult<DayOfWeekDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DayOfWeekDetail"] = newDayOfWeekDetail;

export interface DesignPackageLocationDetailOptions {
  __typename?: "DesignPackageLocationDetail";
  code?: DesignPackageLocationDetail["code"];
  name?: DesignPackageLocationDetail["name"];
}

export function newDesignPackageLocationDetail(
  options?: DesignPackageLocationDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackageLocationDetail>;
export function newDesignPackageLocationDetail(
  options: DesignPackageLocationDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackageLocationDetail> {
  const o = (options.__typename ? options : cache["DesignPackageLocationDetail"] = {}) as DesignPackageLocationDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackageLocationDetail";
    o.code = options.code ?? DesignPackageLocation.Interior;
    o.name = options.name ?? "Interior";
    return o as FactoryResult<DesignPackageLocationDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackageLocationDetail"] = newDesignPackageLocationDetail;

export interface DevelopmentCommitmentTypeDetailOptions {
  __typename?: "DevelopmentCommitmentTypeDetail";
  code?: DevelopmentCommitmentTypeDetail["code"];
  name?: DevelopmentCommitmentTypeDetail["name"];
}

export function newDevelopmentCommitmentTypeDetail(
  options?: DevelopmentCommitmentTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitmentTypeDetail>;
export function newDevelopmentCommitmentTypeDetail(
  options: DevelopmentCommitmentTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DevelopmentCommitmentTypeDetail> {
  const o =
    (options.__typename ? options : cache["DevelopmentCommitmentTypeDetail"] = {}) as DevelopmentCommitmentTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DevelopmentCommitmentTypeDetail";
    o.code = options.code ?? DevelopmentCommitmentType.Materials;
    o.name = options.name ?? "Materials";
    return o as FactoryResult<DevelopmentCommitmentTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DevelopmentCommitmentTypeDetail"] = newDevelopmentCommitmentTypeDetail;

export interface DocumentAttachmentPlaceDetailOptions {
  __typename?: "DocumentAttachmentPlaceDetail";
  code?: DocumentAttachmentPlaceDetail["code"];
  name?: DocumentAttachmentPlaceDetail["name"];
}

export function newDocumentAttachmentPlaceDetail(
  options?: DocumentAttachmentPlaceDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DocumentAttachmentPlaceDetail>;
export function newDocumentAttachmentPlaceDetail(
  options: DocumentAttachmentPlaceDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DocumentAttachmentPlaceDetail> {
  const o =
    (options.__typename ? options : cache["DocumentAttachmentPlaceDetail"] = {}) as DocumentAttachmentPlaceDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DocumentAttachmentPlaceDetail";
    o.code = options.code ?? DocumentAttachmentPlace.PurchaseOrder;
    o.name = options.name ?? "Purchase order";
    return o as FactoryResult<DocumentAttachmentPlaceDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DocumentAttachmentPlaceDetail"] = newDocumentAttachmentPlaceDetail;

export interface DocumentCategoryDetailOptions {
  __typename?: "DocumentCategoryDetail";
  code?: DocumentCategoryDetail["code"];
  name?: DocumentCategoryDetail["name"];
}

export function newDocumentCategoryDetail(
  options?: DocumentCategoryDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DocumentCategoryDetail>;
export function newDocumentCategoryDetail(
  options: DocumentCategoryDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DocumentCategoryDetail> {
  const o = (options.__typename ? options : cache["DocumentCategoryDetail"] = {}) as DocumentCategoryDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DocumentCategoryDetail";
    o.code = options.code ?? DocumentCategory.Contractual;
    o.name = options.name ?? "Contractual";
    return o as FactoryResult<DocumentCategoryDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DocumentCategoryDetail"] = newDocumentCategoryDetail;

export interface DocumentTypeDetailOptions {
  __typename?: "DocumentTypeDetail";
  code?: DocumentTypeDetail["code"];
  name?: DocumentTypeDetail["name"];
  systemControlled?: DocumentTypeDetail["systemControlled"];
  defaultHomeownerVisible?: DocumentTypeDetail["defaultHomeownerVisible"];
  boolDefaultHomeownerVisible?: DocumentTypeDetail["boolDefaultHomeownerVisible"];
}

export function newDocumentTypeDetail(
  options?: DocumentTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DocumentTypeDetail>;
export function newDocumentTypeDetail(
  options: DocumentTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DocumentTypeDetail> {
  const o = (options.__typename ? options : cache["DocumentTypeDetail"] = {}) as DocumentTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DocumentTypeDetail";
    o.code = options.code ?? DocumentType.PreconAgreement;
    o.name = options.name ?? "Precon agreement";
    o.systemControlled = options.systemControlled ?? false;
    o.defaultHomeownerVisible = options.defaultHomeownerVisible ?? false;
    o.boolDefaultHomeownerVisible = options.boolDefaultHomeownerVisible ?? false;
    return o as FactoryResult<DocumentTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DocumentTypeDetail"] = newDocumentTypeDetail;

export interface ErpAccrualTypeDetailOptions {
  __typename?: "ErpAccrualTypeDetail";
  code?: ErpAccrualTypeDetail["code"];
  name?: ErpAccrualTypeDetail["name"];
}

export function newErpAccrualTypeDetail(
  options?: ErpAccrualTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ErpAccrualTypeDetail>;
export function newErpAccrualTypeDetail(
  options: ErpAccrualTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ErpAccrualTypeDetail> {
  const o = (options.__typename ? options : cache["ErpAccrualTypeDetail"] = {}) as ErpAccrualTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ErpAccrualTypeDetail";
    o.code = options.code ?? ErpAccrualType.TaskCompletion;
    o.name = options.name ?? "Task completion";
    return o as FactoryResult<ErpAccrualTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ErpAccrualTypeDetail"] = newErpAccrualTypeDetail;

export interface ErpRevenueLineItemSourceEventDetailOptions {
  __typename?: "ErpRevenueLineItemSourceEventDetail";
  code?: ErpRevenueLineItemSourceEventDetail["code"];
  name?: ErpRevenueLineItemSourceEventDetail["name"];
}

export function newErpRevenueLineItemSourceEventDetail(
  options?: ErpRevenueLineItemSourceEventDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ErpRevenueLineItemSourceEventDetail>;
export function newErpRevenueLineItemSourceEventDetail(
  options: ErpRevenueLineItemSourceEventDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ErpRevenueLineItemSourceEventDetail> {
  const o =
    (options.__typename
      ? options
      : cache["ErpRevenueLineItemSourceEventDetail"] = {}) as ErpRevenueLineItemSourceEventDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ErpRevenueLineItemSourceEventDetail";
    o.code = options.code ?? ErpRevenueLineItemSourceEvent.ContractPriceChange;
    o.name = options.name ?? "Contract price change";
    return o as FactoryResult<ErpRevenueLineItemSourceEventDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ErpRevenueLineItemSourceEventDetail"] = newErpRevenueLineItemSourceEventDetail;

export interface ErpTransactionGroupEventDetailOptions {
  __typename?: "ErpTransactionGroupEventDetail";
  code?: ErpTransactionGroupEventDetail["code"];
  name?: ErpTransactionGroupEventDetail["name"];
}

export function newErpTransactionGroupEventDetail(
  options?: ErpTransactionGroupEventDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ErpTransactionGroupEventDetail>;
export function newErpTransactionGroupEventDetail(
  options: ErpTransactionGroupEventDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ErpTransactionGroupEventDetail> {
  const o =
    (options.__typename ? options : cache["ErpTransactionGroupEventDetail"] = {}) as ErpTransactionGroupEventDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ErpTransactionGroupEventDetail";
    o.code = options.code ?? ErpTransactionGroupEvent.TaskCompletion;
    o.name = options.name ?? "Task completion";
    return o as FactoryResult<ErpTransactionGroupEventDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ErpTransactionGroupEventDetail"] = newErpTransactionGroupEventDetail;

export interface ErpTransactionGroupStatusDetailOptions {
  __typename?: "ErpTransactionGroupStatusDetail";
  code?: ErpTransactionGroupStatusDetail["code"];
  name?: ErpTransactionGroupStatusDetail["name"];
}

export function newErpTransactionGroupStatusDetail(
  options?: ErpTransactionGroupStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ErpTransactionGroupStatusDetail>;
export function newErpTransactionGroupStatusDetail(
  options: ErpTransactionGroupStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ErpTransactionGroupStatusDetail> {
  const o =
    (options.__typename ? options : cache["ErpTransactionGroupStatusDetail"] = {}) as ErpTransactionGroupStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ErpTransactionGroupStatusDetail";
    o.code = options.code ?? ErpTransactionGroupStatus.Pending;
    o.name = options.name ?? "Pending";
    return o as FactoryResult<ErpTransactionGroupStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ErpTransactionGroupStatusDetail"] = newErpTransactionGroupStatusDetail;

export interface ErpTransactionStatusDetailOptions {
  __typename?: "ErpTransactionStatusDetail";
  code?: ErpTransactionStatusDetail["code"];
  name?: ErpTransactionStatusDetail["name"];
}

export function newErpTransactionStatusDetail(
  options?: ErpTransactionStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ErpTransactionStatusDetail>;
export function newErpTransactionStatusDetail(
  options: ErpTransactionStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ErpTransactionStatusDetail> {
  const o = (options.__typename ? options : cache["ErpTransactionStatusDetail"] = {}) as ErpTransactionStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ErpTransactionStatusDetail";
    o.code = options.code ?? ErpTransactionStatus.Pending;
    o.name = options.name ?? "Pending";
    return o as FactoryResult<ErpTransactionStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ErpTransactionStatusDetail"] = newErpTransactionStatusDetail;

export interface EstimateStatusDetailOptions {
  __typename?: "EstimateStatusDetail";
  code?: EstimateStatusDetail["code"];
  name?: EstimateStatusDetail["name"];
}

export function newEstimateStatusDetail(
  options?: EstimateStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<EstimateStatusDetail>;
export function newEstimateStatusDetail(
  options: EstimateStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<EstimateStatusDetail> {
  const o = (options.__typename ? options : cache["EstimateStatusDetail"] = {}) as EstimateStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "EstimateStatusDetail";
    o.code = options.code ?? EstimateStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<EstimateStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["EstimateStatusDetail"] = newEstimateStatusDetail;

export interface EstimateTypeDetailOptions {
  __typename?: "EstimateTypeDetail";
  code?: EstimateTypeDetail["code"];
  name?: EstimateTypeDetail["name"];
}

export function newEstimateTypeDetail(
  options?: EstimateTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<EstimateTypeDetail>;
export function newEstimateTypeDetail(
  options: EstimateTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<EstimateTypeDetail> {
  const o = (options.__typename ? options : cache["EstimateTypeDetail"] = {}) as EstimateTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "EstimateTypeDetail";
    o.code = options.code ?? EstimateType.Preliminary;
    o.name = options.name ?? "Preliminary";
    return o as FactoryResult<EstimateTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["EstimateTypeDetail"] = newEstimateTypeDetail;

export interface FeatureFlagStatusDetailOptions {
  __typename?: "FeatureFlagStatusDetail";
  code?: FeatureFlagStatusDetail["code"];
  name?: FeatureFlagStatusDetail["name"];
}

export function newFeatureFlagStatusDetail(
  options?: FeatureFlagStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FeatureFlagStatusDetail>;
export function newFeatureFlagStatusDetail(
  options: FeatureFlagStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FeatureFlagStatusDetail> {
  const o = (options.__typename ? options : cache["FeatureFlagStatusDetail"] = {}) as FeatureFlagStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FeatureFlagStatusDetail";
    o.code = options.code ?? FeatureFlagStatus.Active;
    o.name = options.name ?? "Active";
    return o as FactoryResult<FeatureFlagStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FeatureFlagStatusDetail"] = newFeatureFlagStatusDetail;

export interface FeatureFlagTypeDetailOptions {
  __typename?: "FeatureFlagTypeDetail";
  code?: FeatureFlagTypeDetail["code"];
  name?: FeatureFlagTypeDetail["name"];
  description?: FeatureFlagTypeDetail["description"];
  presentational?: FeatureFlagTypeDetail["presentational"];
}

export function newFeatureFlagTypeDetail(
  options?: FeatureFlagTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FeatureFlagTypeDetail>;
export function newFeatureFlagTypeDetail(
  options: FeatureFlagTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FeatureFlagTypeDetail> {
  const o = (options.__typename ? options : cache["FeatureFlagTypeDetail"] = {}) as FeatureFlagTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FeatureFlagTypeDetail";
    o.code = options.code ?? FeatureFlagType.TestFeature;
    o.name = options.name ?? "Test feature";
    o.description = options.description ?? "Test feature";
    o.presentational = options.presentational ?? false;
    return o as FactoryResult<FeatureFlagTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FeatureFlagTypeDetail"] = newFeatureFlagTypeDetail;

export interface FinishScheduleColumnTypeDetailOptions {
  __typename?: "FinishScheduleColumnTypeDetail";
  code?: FinishScheduleColumnTypeDetail["code"];
  name?: FinishScheduleColumnTypeDetail["name"];
}

export function newFinishScheduleColumnTypeDetail(
  options?: FinishScheduleColumnTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FinishScheduleColumnTypeDetail>;
export function newFinishScheduleColumnTypeDetail(
  options: FinishScheduleColumnTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FinishScheduleColumnTypeDetail> {
  const o =
    (options.__typename ? options : cache["FinishScheduleColumnTypeDetail"] = {}) as FinishScheduleColumnTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FinishScheduleColumnTypeDetail";
    o.code = options.code ?? FinishScheduleColumnType.Core;
    o.name = options.name ?? "Core";
    return o as FactoryResult<FinishScheduleColumnTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FinishScheduleColumnTypeDetail"] = newFinishScheduleColumnTypeDetail;

export interface FinishScheduleCoreColumnDetailOptions {
  __typename?: "FinishScheduleCoreColumnDetail";
  code?: FinishScheduleCoreColumnDetail["code"];
  name?: FinishScheduleCoreColumnDetail["name"];
}

export function newFinishScheduleCoreColumnDetail(
  options?: FinishScheduleCoreColumnDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FinishScheduleCoreColumnDetail>;
export function newFinishScheduleCoreColumnDetail(
  options: FinishScheduleCoreColumnDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FinishScheduleCoreColumnDetail> {
  const o =
    (options.__typename ? options : cache["FinishScheduleCoreColumnDetail"] = {}) as FinishScheduleCoreColumnDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FinishScheduleCoreColumnDetail";
    o.code = options.code ?? FinishScheduleCoreColumn.Location;
    o.name = options.name ?? "Location";
    return o as FactoryResult<FinishScheduleCoreColumnDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FinishScheduleCoreColumnDetail"] = newFinishScheduleCoreColumnDetail;

export interface FloodPlainDetailOptions {
  __typename?: "FloodPlainDetail";
  code?: FloodPlainDetail["code"];
  name?: FloodPlainDetail["name"];
}

export function newFloodPlainDetail(
  options?: FloodPlainDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FloodPlainDetail>;
export function newFloodPlainDetail(
  options: FloodPlainDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FloodPlainDetail> {
  const o = (options.__typename ? options : cache["FloodPlainDetail"] = {}) as FloodPlainDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FloodPlainDetail";
    o.code = options.code ?? FloodPlain.Fp_0;
    o.name = options.name ?? "Fp 0";
    return o as FactoryResult<FloodPlainDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FloodPlainDetail"] = newFloodPlainDetail;

export interface FloodZoneDetailOptions {
  __typename?: "FloodZoneDetail";
  code?: FloodZoneDetail["code"];
  name?: FloodZoneDetail["name"];
}

export function newFloodZoneDetail(
  options?: FloodZoneDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FloodZoneDetail>;
export function newFloodZoneDetail(
  options: FloodZoneDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FloodZoneDetail> {
  const o = (options.__typename ? options : cache["FloodZoneDetail"] = {}) as FloodZoneDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FloodZoneDetail";
    o.code = options.code ?? FloodZone.FzNone;
    o.name = options.name ?? "Fz none";
    return o as FactoryResult<FloodZoneDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FloodZoneDetail"] = newFloodZoneDetail;

export interface FoundationTypeDetailOptions {
  __typename?: "FoundationTypeDetail";
  code?: FoundationTypeDetail["code"];
  name?: FoundationTypeDetail["name"];
}

export function newFoundationTypeDetail(
  options?: FoundationTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FoundationTypeDetail>;
export function newFoundationTypeDetail(
  options: FoundationTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FoundationTypeDetail> {
  const o = (options.__typename ? options : cache["FoundationTypeDetail"] = {}) as FoundationTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FoundationTypeDetail";
    o.code = options.code ?? FoundationType.Slab;
    o.name = options.name ?? "Slab";
    return o as FactoryResult<FoundationTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FoundationTypeDetail"] = newFoundationTypeDetail;

export interface GlobalOptionStatusDetailOptions {
  __typename?: "GlobalOptionStatusDetail";
  code?: GlobalOptionStatusDetail["code"];
  name?: GlobalOptionStatusDetail["name"];
}

export function newGlobalOptionStatusDetail(
  options?: GlobalOptionStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOptionStatusDetail>;
export function newGlobalOptionStatusDetail(
  options: GlobalOptionStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalOptionStatusDetail> {
  const o = (options.__typename ? options : cache["GlobalOptionStatusDetail"] = {}) as GlobalOptionStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalOptionStatusDetail";
    o.code = options.code ?? GlobalOptionStatus.Active;
    o.name = options.name ?? "Active";
    return o as FactoryResult<GlobalOptionStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalOptionStatusDetail"] = newGlobalOptionStatusDetail;

export interface GlobalOptionTypeStatusDetailOptions {
  __typename?: "GlobalOptionTypeStatusDetail";
  code?: GlobalOptionTypeStatusDetail["code"];
  name?: GlobalOptionTypeStatusDetail["name"];
}

export function newGlobalOptionTypeStatusDetail(
  options?: GlobalOptionTypeStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOptionTypeStatusDetail>;
export function newGlobalOptionTypeStatusDetail(
  options: GlobalOptionTypeStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalOptionTypeStatusDetail> {
  const o = (options.__typename ? options : cache["GlobalOptionTypeStatusDetail"] = {}) as GlobalOptionTypeStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalOptionTypeStatusDetail";
    o.code = options.code ?? GlobalOptionTypeStatus.Active;
    o.name = options.name ?? "Active";
    return o as FactoryResult<GlobalOptionTypeStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalOptionTypeStatusDetail"] = newGlobalOptionTypeStatusDetail;

export interface GlobalPlanMilestoneTypeDetailOptions {
  __typename?: "GlobalPlanMilestoneTypeDetail";
  code?: GlobalPlanMilestoneTypeDetail["code"];
  name?: GlobalPlanMilestoneTypeDetail["name"];
}

export function newGlobalPlanMilestoneTypeDetail(
  options?: GlobalPlanMilestoneTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanMilestoneTypeDetail>;
export function newGlobalPlanMilestoneTypeDetail(
  options: GlobalPlanMilestoneTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanMilestoneTypeDetail> {
  const o =
    (options.__typename ? options : cache["GlobalPlanMilestoneTypeDetail"] = {}) as GlobalPlanMilestoneTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanMilestoneTypeDetail";
    o.code = options.code ?? GlobalPlanMilestoneType.Construction;
    o.name = options.name ?? "Construction";
    return o as FactoryResult<GlobalPlanMilestoneTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanMilestoneTypeDetail"] = newGlobalPlanMilestoneTypeDetail;

export interface InboxItemStatusDetailOptions {
  __typename?: "InboxItemStatusDetail";
  code?: InboxItemStatusDetail["code"];
  name?: InboxItemStatusDetail["name"];
}

export function newInboxItemStatusDetail(
  options?: InboxItemStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InboxItemStatusDetail>;
export function newInboxItemStatusDetail(
  options: InboxItemStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InboxItemStatusDetail> {
  const o = (options.__typename ? options : cache["InboxItemStatusDetail"] = {}) as InboxItemStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InboxItemStatusDetail";
    o.code = options.code ?? InboxItemStatus.Read;
    o.name = options.name ?? "Read";
    return o as FactoryResult<InboxItemStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InboxItemStatusDetail"] = newInboxItemStatusDetail;

export interface InternalEstimateTypeDetailOptions {
  __typename?: "InternalEstimateTypeDetail";
  code?: InternalEstimateTypeDetail["code"];
  name?: InternalEstimateTypeDetail["name"];
}

export function newInternalEstimateTypeDetail(
  options?: InternalEstimateTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InternalEstimateTypeDetail>;
export function newInternalEstimateTypeDetail(
  options: InternalEstimateTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InternalEstimateTypeDetail> {
  const o = (options.__typename ? options : cache["InternalEstimateTypeDetail"] = {}) as InternalEstimateTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InternalEstimateTypeDetail";
    o.code = options.code ?? InternalEstimateType.Provisional;
    o.name = options.name ?? "Provisional";
    return o as FactoryResult<InternalEstimateTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InternalEstimateTypeDetail"] = newInternalEstimateTypeDetail;

export interface InvoiceDocumentSourceDetailOptions {
  __typename?: "InvoiceDocumentSourceDetail";
  code?: InvoiceDocumentSourceDetail["code"];
  name?: InvoiceDocumentSourceDetail["name"];
}

export function newInvoiceDocumentSourceDetail(
  options?: InvoiceDocumentSourceDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceDocumentSourceDetail>;
export function newInvoiceDocumentSourceDetail(
  options: InvoiceDocumentSourceDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceDocumentSourceDetail> {
  const o = (options.__typename ? options : cache["InvoiceDocumentSourceDetail"] = {}) as InvoiceDocumentSourceDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceDocumentSourceDetail";
    o.code = options.code ?? InvoiceDocumentSource.Quickbooks;
    o.name = options.name ?? "Quickbooks";
    return o as FactoryResult<InvoiceDocumentSourceDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceDocumentSourceDetail"] = newInvoiceDocumentSourceDetail;

export interface InvoiceScheduleAmountTypeDetailOptions {
  __typename?: "InvoiceScheduleAmountTypeDetail";
  code?: InvoiceScheduleAmountTypeDetail["code"];
  name?: InvoiceScheduleAmountTypeDetail["name"];
}

export function newInvoiceScheduleAmountTypeDetail(
  options?: InvoiceScheduleAmountTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceScheduleAmountTypeDetail>;
export function newInvoiceScheduleAmountTypeDetail(
  options: InvoiceScheduleAmountTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceScheduleAmountTypeDetail> {
  const o =
    (options.__typename ? options : cache["InvoiceScheduleAmountTypeDetail"] = {}) as InvoiceScheduleAmountTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceScheduleAmountTypeDetail";
    o.code = options.code ?? InvoiceScheduleAmountType.Cost;
    o.name = options.name ?? "Cost";
    return o as FactoryResult<InvoiceScheduleAmountTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceScheduleAmountTypeDetail"] = newInvoiceScheduleAmountTypeDetail;

export interface InvoiceScheduleItemFrequencyDetailOptions {
  __typename?: "InvoiceScheduleItemFrequencyDetail";
  code?: InvoiceScheduleItemFrequencyDetail["code"];
  name?: InvoiceScheduleItemFrequencyDetail["name"];
}

export function newInvoiceScheduleItemFrequencyDetail(
  options?: InvoiceScheduleItemFrequencyDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceScheduleItemFrequencyDetail>;
export function newInvoiceScheduleItemFrequencyDetail(
  options: InvoiceScheduleItemFrequencyDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceScheduleItemFrequencyDetail> {
  const o =
    (options.__typename
      ? options
      : cache["InvoiceScheduleItemFrequencyDetail"] = {}) as InvoiceScheduleItemFrequencyDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceScheduleItemFrequencyDetail";
    o.code = options.code ?? InvoiceScheduleItemFrequency.Once;
    o.name = options.name ?? "Once";
    return o as FactoryResult<InvoiceScheduleItemFrequencyDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceScheduleItemFrequencyDetail"] = newInvoiceScheduleItemFrequencyDetail;

export interface InvoiceScheduleTriggerTypeDetailOptions {
  __typename?: "InvoiceScheduleTriggerTypeDetail";
  code?: InvoiceScheduleTriggerTypeDetail["code"];
  name?: InvoiceScheduleTriggerTypeDetail["name"];
}

export function newInvoiceScheduleTriggerTypeDetail(
  options?: InvoiceScheduleTriggerTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceScheduleTriggerTypeDetail>;
export function newInvoiceScheduleTriggerTypeDetail(
  options: InvoiceScheduleTriggerTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceScheduleTriggerTypeDetail> {
  const o =
    (options.__typename ? options : cache["InvoiceScheduleTriggerTypeDetail"] = {}) as InvoiceScheduleTriggerTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceScheduleTriggerTypeDetail";
    o.code = options.code ?? InvoiceScheduleTriggerType.Date;
    o.name = options.name ?? "Date";
    return o as FactoryResult<InvoiceScheduleTriggerTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceScheduleTriggerTypeDetail"] = newInvoiceScheduleTriggerTypeDetail;

export interface InvoiceSourceDetailOptions {
  __typename?: "InvoiceSourceDetail";
  code?: InvoiceSourceDetail["code"];
  name?: InvoiceSourceDetail["name"];
}

export function newInvoiceSourceDetail(
  options?: InvoiceSourceDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceSourceDetail>;
export function newInvoiceSourceDetail(
  options: InvoiceSourceDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceSourceDetail> {
  const o = (options.__typename ? options : cache["InvoiceSourceDetail"] = {}) as InvoiceSourceDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceSourceDetail";
    o.code = options.code ?? InvoiceSource.Auto;
    o.name = options.name ?? "Auto";
    return o as FactoryResult<InvoiceSourceDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceSourceDetail"] = newInvoiceSourceDetail;

export interface InvoiceStatusDetailOptions {
  __typename?: "InvoiceStatusDetail";
  code?: InvoiceStatusDetail["code"];
  name?: InvoiceStatusDetail["name"];
}

export function newInvoiceStatusDetail(
  options?: InvoiceStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceStatusDetail>;
export function newInvoiceStatusDetail(
  options: InvoiceStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceStatusDetail> {
  const o = (options.__typename ? options : cache["InvoiceStatusDetail"] = {}) as InvoiceStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceStatusDetail";
    o.code = options.code ?? InvoiceStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<InvoiceStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceStatusDetail"] = newInvoiceStatusDetail;

export interface InvoiceTypeDetailOptions {
  __typename?: "InvoiceTypeDetail";
  code?: InvoiceTypeDetail["code"];
  name?: InvoiceTypeDetail["name"];
}

export function newInvoiceTypeDetail(
  options?: InvoiceTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceTypeDetail>;
export function newInvoiceTypeDetail(
  options: InvoiceTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceTypeDetail> {
  const o = (options.__typename ? options : cache["InvoiceTypeDetail"] = {}) as InvoiceTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceTypeDetail";
    o.code = options.code ?? InvoiceType.PercentageOfCompletion;
    o.name = options.name ?? "Percentage of completion";
    return o as FactoryResult<InvoiceTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceTypeDetail"] = newInvoiceTypeDetail;

export interface ItemStatusDetailOptions {
  __typename?: "ItemStatusDetail";
  code?: ItemStatusDetail["code"];
  name?: ItemStatusDetail["name"];
}

export function newItemStatusDetail(
  options?: ItemStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemStatusDetail>;
export function newItemStatusDetail(
  options: ItemStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemStatusDetail> {
  const o = (options.__typename ? options : cache["ItemStatusDetail"] = {}) as ItemStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemStatusDetail";
    o.code = options.code ?? ItemStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<ItemStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemStatusDetail"] = newItemStatusDetail;

export interface ItemTemplateItemCostStatusDetailOptions {
  __typename?: "ItemTemplateItemCostStatusDetail";
  code?: ItemTemplateItemCostStatusDetail["code"];
  name?: ItemTemplateItemCostStatusDetail["name"];
}

export function newItemTemplateItemCostStatusDetail(
  options?: ItemTemplateItemCostStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemCostStatusDetail>;
export function newItemTemplateItemCostStatusDetail(
  options: ItemTemplateItemCostStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateItemCostStatusDetail> {
  const o =
    (options.__typename ? options : cache["ItemTemplateItemCostStatusDetail"] = {}) as ItemTemplateItemCostStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateItemCostStatusDetail";
    o.code = options.code ?? ItemTemplateItemCostStatus.InternalEstimate;
    o.name = options.name ?? "Internal estimate";
    return o as FactoryResult<ItemTemplateItemCostStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateItemCostStatusDetail"] = newItemTemplateItemCostStatusDetail;

export interface ItemTemplateStatusDetailOptions {
  __typename?: "ItemTemplateStatusDetail";
  code?: ItemTemplateStatusDetail["code"];
  name?: ItemTemplateStatusDetail["name"];
}

export function newItemTemplateStatusDetail(
  options?: ItemTemplateStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateStatusDetail>;
export function newItemTemplateStatusDetail(
  options: ItemTemplateStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateStatusDetail> {
  const o = (options.__typename ? options : cache["ItemTemplateStatusDetail"] = {}) as ItemTemplateStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateStatusDetail";
    o.code = options.code ?? ItemTemplateStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<ItemTemplateStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateStatusDetail"] = newItemTemplateStatusDetail;

export interface JobLogFlagDetailOptions {
  __typename?: "JobLogFlagDetail";
  code?: JobLogFlagDetail["code"];
  name?: JobLogFlagDetail["name"];
}

export function newJobLogFlagDetail(
  options?: JobLogFlagDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogFlagDetail>;
export function newJobLogFlagDetail(
  options: JobLogFlagDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<JobLogFlagDetail> {
  const o = (options.__typename ? options : cache["JobLogFlagDetail"] = {}) as JobLogFlagDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "JobLogFlagDetail";
    o.code = options.code ?? JobLogFlag.ChangeOrderDelay;
    o.name = options.name ?? "Change order delay";
    return o as FactoryResult<JobLogFlagDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["JobLogFlagDetail"] = newJobLogFlagDetail;

export interface JobLogNoteTypeDetailOptions {
  __typename?: "JobLogNoteTypeDetail";
  code?: JobLogNoteTypeDetail["code"];
  name?: JobLogNoteTypeDetail["name"];
}

export function newJobLogNoteTypeDetail(
  options?: JobLogNoteTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogNoteTypeDetail>;
export function newJobLogNoteTypeDetail(
  options: JobLogNoteTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<JobLogNoteTypeDetail> {
  const o = (options.__typename ? options : cache["JobLogNoteTypeDetail"] = {}) as JobLogNoteTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "JobLogNoteTypeDetail";
    o.code = options.code ?? JobLogNoteType.Delay;
    o.name = options.name ?? "Delay";
    return o as FactoryResult<JobLogNoteTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["JobLogNoteTypeDetail"] = newJobLogNoteTypeDetail;

export interface LienWaiverConditionDetailOptions {
  __typename?: "LienWaiverConditionDetail";
  code?: LienWaiverConditionDetail["code"];
  name?: LienWaiverConditionDetail["name"];
}

export function newLienWaiverConditionDetail(
  options?: LienWaiverConditionDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<LienWaiverConditionDetail>;
export function newLienWaiverConditionDetail(
  options: LienWaiverConditionDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<LienWaiverConditionDetail> {
  const o = (options.__typename ? options : cache["LienWaiverConditionDetail"] = {}) as LienWaiverConditionDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "LienWaiverConditionDetail";
    o.code = options.code ?? LienWaiverCondition.Unconditional;
    o.name = options.name ?? "Unconditional";
    return o as FactoryResult<LienWaiverConditionDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["LienWaiverConditionDetail"] = newLienWaiverConditionDetail;

export interface LienWaiverStatusDetailOptions {
  __typename?: "LienWaiverStatusDetail";
  code?: LienWaiverStatusDetail["code"];
  name?: LienWaiverStatusDetail["name"];
}

export function newLienWaiverStatusDetail(
  options?: LienWaiverStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<LienWaiverStatusDetail>;
export function newLienWaiverStatusDetail(
  options: LienWaiverStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<LienWaiverStatusDetail> {
  const o = (options.__typename ? options : cache["LienWaiverStatusDetail"] = {}) as LienWaiverStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "LienWaiverStatusDetail";
    o.code = options.code ?? LienWaiverStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<LienWaiverStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["LienWaiverStatusDetail"] = newLienWaiverStatusDetail;

export interface LienWaiverTypeDetailOptions {
  __typename?: "LienWaiverTypeDetail";
  code?: LienWaiverTypeDetail["code"];
  name?: LienWaiverTypeDetail["name"];
}

export function newLienWaiverTypeDetail(
  options?: LienWaiverTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<LienWaiverTypeDetail>;
export function newLienWaiverTypeDetail(
  options: LienWaiverTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<LienWaiverTypeDetail> {
  const o = (options.__typename ? options : cache["LienWaiverTypeDetail"] = {}) as LienWaiverTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "LienWaiverTypeDetail";
    o.code = options.code ?? LienWaiverType.Progress;
    o.name = options.name ?? "Progress";
    return o as FactoryResult<LienWaiverTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["LienWaiverTypeDetail"] = newLienWaiverTypeDetail;

export interface LocationTypeDetailOptions {
  __typename?: "LocationTypeDetail";
  code?: LocationTypeDetail["code"];
  name?: LocationTypeDetail["name"];
  sortOrder?: LocationTypeDetail["sortOrder"];
}

export function newLocationTypeDetail(
  options?: LocationTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<LocationTypeDetail>;
export function newLocationTypeDetail(
  options: LocationTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<LocationTypeDetail> {
  const o = (options.__typename ? options : cache["LocationTypeDetail"] = {}) as LocationTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "LocationTypeDetail";
    o.code = options.code ?? LocationType.Group;
    o.name = options.name ?? "Group";
    o.sortOrder = options.sortOrder ?? 0;
    return o as FactoryResult<LocationTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["LocationTypeDetail"] = newLocationTypeDetail;

export interface LotSalesStatusDetailOptions {
  __typename?: "LotSalesStatusDetail";
  code?: LotSalesStatusDetail["code"];
  name?: LotSalesStatusDetail["name"];
}

export function newLotSalesStatusDetail(
  options?: LotSalesStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<LotSalesStatusDetail>;
export function newLotSalesStatusDetail(
  options: LotSalesStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<LotSalesStatusDetail> {
  const o = (options.__typename ? options : cache["LotSalesStatusDetail"] = {}) as LotSalesStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "LotSalesStatusDetail";
    o.code = options.code ?? LotSalesStatus.NotAvailable;
    o.name = options.name ?? "Not available";
    return o as FactoryResult<LotSalesStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["LotSalesStatusDetail"] = newLotSalesStatusDetail;

export interface LotTypeDetailOptions {
  __typename?: "LotTypeDetail";
  code?: LotTypeDetail["code"];
  name?: LotTypeDetail["name"];
  clientContract?: LotTypeDetail["clientContract"];
  clientNoun?: LotTypeDetail["clientNoun"];
  initialBudget?: LotTypeDetail["initialBudget"];
  shortClientNoun?: LotTypeDetail["shortClientNoun"];
  clientInvoice?: LotTypeDetail["clientInvoice"];
  description?: LotTypeDetail["description"];
}

export function newLotTypeDetail(
  options?: LotTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<LotTypeDetail>;
export function newLotTypeDetail(
  options: LotTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<LotTypeDetail> {
  const o = (options.__typename ? options : cache["LotTypeDetail"] = {}) as LotTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "LotTypeDetail";
    o.code = options.code ?? LotType.Boyl;
    o.name = options.name ?? "Boyl";
    o.clientContract = options.clientContract ?? "Boyl";
    o.clientNoun = options.clientNoun ?? "Boyl";
    o.initialBudget = options.initialBudget ?? "Boyl";
    o.shortClientNoun = options.shortClientNoun ?? "Boyl";
    o.clientInvoice = options.clientInvoice ?? "Boyl";
    o.description = options.description ?? "Boyl";
    return o as FactoryResult<LotTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["LotTypeDetail"] = newLotTypeDetail;

export interface MarkupApplicationMethodDetailOptions {
  __typename?: "MarkupApplicationMethodDetail";
  code?: MarkupApplicationMethodDetail["code"];
  name?: MarkupApplicationMethodDetail["name"];
}

export function newMarkupApplicationMethodDetail(
  options?: MarkupApplicationMethodDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MarkupApplicationMethodDetail>;
export function newMarkupApplicationMethodDetail(
  options: MarkupApplicationMethodDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MarkupApplicationMethodDetail> {
  const o =
    (options.__typename ? options : cache["MarkupApplicationMethodDetail"] = {}) as MarkupApplicationMethodDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MarkupApplicationMethodDetail";
    o.code = options.code ?? MarkupApplicationMethod.PerLineItem;
    o.name = options.name ?? "Per line item";
    return o as FactoryResult<MarkupApplicationMethodDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MarkupApplicationMethodDetail"] = newMarkupApplicationMethodDetail;

export interface MaterialAttributeDimensionTypeDetailOptions {
  __typename?: "MaterialAttributeDimensionTypeDetail";
  code?: MaterialAttributeDimensionTypeDetail["code"];
  name?: MaterialAttributeDimensionTypeDetail["name"];
}

export function newMaterialAttributeDimensionTypeDetail(
  options?: MaterialAttributeDimensionTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialAttributeDimensionTypeDetail>;
export function newMaterialAttributeDimensionTypeDetail(
  options: MaterialAttributeDimensionTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialAttributeDimensionTypeDetail> {
  const o =
    (options.__typename
      ? options
      : cache["MaterialAttributeDimensionTypeDetail"] = {}) as MaterialAttributeDimensionTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialAttributeDimensionTypeDetail";
    o.code = options.code ?? MaterialAttributeDimensionType.Number;
    o.name = options.name ?? "Number";
    return o as FactoryResult<MaterialAttributeDimensionTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialAttributeDimensionTypeDetail"] = newMaterialAttributeDimensionTypeDetail;

export interface MaterialAttributeValueTypeDetailOptions {
  __typename?: "MaterialAttributeValueTypeDetail";
  code?: MaterialAttributeValueTypeDetail["code"];
  name?: MaterialAttributeValueTypeDetail["name"];
}

export function newMaterialAttributeValueTypeDetail(
  options?: MaterialAttributeValueTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialAttributeValueTypeDetail>;
export function newMaterialAttributeValueTypeDetail(
  options: MaterialAttributeValueTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialAttributeValueTypeDetail> {
  const o =
    (options.__typename ? options : cache["MaterialAttributeValueTypeDetail"] = {}) as MaterialAttributeValueTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialAttributeValueTypeDetail";
    o.code = options.code ?? MaterialAttributeValueType.Exact;
    o.name = options.name ?? "Exact";
    return o as FactoryResult<MaterialAttributeValueTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialAttributeValueTypeDetail"] = newMaterialAttributeValueTypeDetail;

export interface MaterialTypeDetailOptions {
  __typename?: "MaterialTypeDetail";
  code?: MaterialTypeDetail["code"];
  name?: MaterialTypeDetail["name"];
}

export function newMaterialTypeDetail(
  options?: MaterialTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialTypeDetail>;
export function newMaterialTypeDetail(
  options: MaterialTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialTypeDetail> {
  const o = (options.__typename ? options : cache["MaterialTypeDetail"] = {}) as MaterialTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialTypeDetail";
    o.code = options.code ?? MaterialType.Placeholder;
    o.name = options.name ?? "Placeholder";
    return o as FactoryResult<MaterialTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialTypeDetail"] = newMaterialTypeDetail;

export interface MobileSyncUpdateTypeDetailOptions {
  __typename?: "MobileSyncUpdateTypeDetail";
  code?: MobileSyncUpdateTypeDetail["code"];
  name?: MobileSyncUpdateTypeDetail["name"];
}

export function newMobileSyncUpdateTypeDetail(
  options?: MobileSyncUpdateTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MobileSyncUpdateTypeDetail>;
export function newMobileSyncUpdateTypeDetail(
  options: MobileSyncUpdateTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MobileSyncUpdateTypeDetail> {
  const o = (options.__typename ? options : cache["MobileSyncUpdateTypeDetail"] = {}) as MobileSyncUpdateTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MobileSyncUpdateTypeDetail";
    o.code = options.code ?? MobileSyncUpdateType.Created;
    o.name = options.name ?? "Created";
    return o as FactoryResult<MobileSyncUpdateTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MobileSyncUpdateTypeDetail"] = newMobileSyncUpdateTypeDetail;

export interface PandaDocRoleDetailOptions {
  __typename?: "PandaDocRoleDetail";
  code?: PandaDocRoleDetail["code"];
  name?: PandaDocRoleDetail["name"];
  shortName?: PandaDocRoleDetail["shortName"];
}

export function newPandaDocRoleDetail(
  options?: PandaDocRoleDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PandaDocRoleDetail>;
export function newPandaDocRoleDetail(
  options: PandaDocRoleDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PandaDocRoleDetail> {
  const o = (options.__typename ? options : cache["PandaDocRoleDetail"] = {}) as PandaDocRoleDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PandaDocRoleDetail";
    o.code = options.code ?? PandaDocRole.User;
    o.name = options.name ?? "User";
    o.shortName = options.shortName ?? "User";
    return o as FactoryResult<PandaDocRoleDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PandaDocRoleDetail"] = newPandaDocRoleDetail;

export interface PandaDocStatusDetailOptions {
  __typename?: "PandaDocStatusDetail";
  code?: PandaDocStatusDetail["code"];
  name?: PandaDocStatusDetail["name"];
  externalCode?: PandaDocStatusDetail["externalCode"];
  externalNumber?: PandaDocStatusDetail["externalNumber"];
}

export function newPandaDocStatusDetail(
  options?: PandaDocStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PandaDocStatusDetail>;
export function newPandaDocStatusDetail(
  options: PandaDocStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PandaDocStatusDetail> {
  const o = (options.__typename ? options : cache["PandaDocStatusDetail"] = {}) as PandaDocStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PandaDocStatusDetail";
    o.code = options.code ?? PandaDocStatus.Pending;
    o.name = options.name ?? "Pending";
    o.externalCode = options.externalCode ?? "Pending";
    o.externalNumber = options.externalNumber ?? 0;
    return o as FactoryResult<PandaDocStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PandaDocStatusDetail"] = newPandaDocStatusDetail;

export interface PandaDocWorkspaceDetailOptions {
  __typename?: "PandaDocWorkspaceDetail";
  code?: PandaDocWorkspaceDetail["code"];
  name?: PandaDocWorkspaceDetail["name"];
}

export function newPandaDocWorkspaceDetail(
  options?: PandaDocWorkspaceDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PandaDocWorkspaceDetail>;
export function newPandaDocWorkspaceDetail(
  options: PandaDocWorkspaceDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PandaDocWorkspaceDetail> {
  const o = (options.__typename ? options : cache["PandaDocWorkspaceDetail"] = {}) as PandaDocWorkspaceDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PandaDocWorkspaceDetail";
    o.code = options.code ?? PandaDocWorkspace.Homebound;
    o.name = options.name ?? "Homebound";
    return o as FactoryResult<PandaDocWorkspaceDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PandaDocWorkspaceDetail"] = newPandaDocWorkspaceDetail;

export interface PaymentTermDueFromDetailOptions {
  __typename?: "PaymentTermDueFromDetail";
  code?: PaymentTermDueFromDetail["code"];
  name?: PaymentTermDueFromDetail["name"];
}

export function newPaymentTermDueFromDetail(
  options?: PaymentTermDueFromDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PaymentTermDueFromDetail>;
export function newPaymentTermDueFromDetail(
  options: PaymentTermDueFromDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PaymentTermDueFromDetail> {
  const o = (options.__typename ? options : cache["PaymentTermDueFromDetail"] = {}) as PaymentTermDueFromDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PaymentTermDueFromDetail";
    o.code = options.code ?? PaymentTermDueFrom.FromInvoiceBillDate;
    o.name = options.name ?? "From invoice bill date";
    return o as FactoryResult<PaymentTermDueFromDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PaymentTermDueFromDetail"] = newPaymentTermDueFromDetail;

export interface PermitDetailOptions {
  __typename?: "PermitDetail";
  code?: PermitDetail["code"];
  name?: PermitDetail["name"];
}

export function newPermitDetail(
  options?: PermitDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PermitDetail>;
export function newPermitDetail(
  options: PermitDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PermitDetail> {
  const o = (options.__typename ? options : cache["PermitDetail"] = {}) as PermitDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PermitDetail";
    o.code = options.code ?? Permit.Zoning;
    o.name = options.name ?? "Zoning";
    return o as FactoryResult<PermitDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PermitDetail"] = newPermitDetail;

export interface PlanPackageIncomingSlotStatusDetailOptions {
  __typename?: "PlanPackageIncomingSlotStatusDetail";
  code?: PlanPackageIncomingSlotStatusDetail["code"];
  name?: PlanPackageIncomingSlotStatusDetail["name"];
}

export function newPlanPackageIncomingSlotStatusDetail(
  options?: PlanPackageIncomingSlotStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackageIncomingSlotStatusDetail>;
export function newPlanPackageIncomingSlotStatusDetail(
  options: PlanPackageIncomingSlotStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanPackageIncomingSlotStatusDetail> {
  const o =
    (options.__typename
      ? options
      : cache["PlanPackageIncomingSlotStatusDetail"] = {}) as PlanPackageIncomingSlotStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanPackageIncomingSlotStatusDetail";
    o.code = options.code ?? PlanPackageIncomingSlotStatus.Pending;
    o.name = options.name ?? "Pending";
    return o as FactoryResult<PlanPackageIncomingSlotStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanPackageIncomingSlotStatusDetail"] = newPlanPackageIncomingSlotStatusDetail;

export interface ProductOfferingStartingConfigTypeDetailOptions {
  __typename?: "ProductOfferingStartingConfigTypeDetail";
  code?: ProductOfferingStartingConfigTypeDetail["code"];
  name?: ProductOfferingStartingConfigTypeDetail["name"];
}

export function newProductOfferingStartingConfigTypeDetail(
  options?: ProductOfferingStartingConfigTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingStartingConfigTypeDetail>;
export function newProductOfferingStartingConfigTypeDetail(
  options: ProductOfferingStartingConfigTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOfferingStartingConfigTypeDetail> {
  const o =
    (options.__typename
      ? options
      : cache["ProductOfferingStartingConfigTypeDetail"] = {}) as ProductOfferingStartingConfigTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOfferingStartingConfigTypeDetail";
    o.code = options.code ?? ProductOfferingStartingConfigType.Checkout;
    o.name = options.name ?? "Checkout";
    return o as FactoryResult<ProductOfferingStartingConfigTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOfferingStartingConfigTypeDetail"] = newProductOfferingStartingConfigTypeDetail;

export interface ProgramDataBasementConfigDetailOptions {
  __typename?: "ProgramDataBasementConfigDetail";
  code?: ProgramDataBasementConfigDetail["code"];
  name?: ProgramDataBasementConfigDetail["name"];
}

export function newProgramDataBasementConfigDetail(
  options?: ProgramDataBasementConfigDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProgramDataBasementConfigDetail>;
export function newProgramDataBasementConfigDetail(
  options: ProgramDataBasementConfigDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProgramDataBasementConfigDetail> {
  const o =
    (options.__typename ? options : cache["ProgramDataBasementConfigDetail"] = {}) as ProgramDataBasementConfigDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProgramDataBasementConfigDetail";
    o.code = options.code ?? ProgramDataBasementConfig.No;
    o.name = options.name ?? "No";
    return o as FactoryResult<ProgramDataBasementConfigDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProgramDataBasementConfigDetail"] = newProgramDataBasementConfigDetail;

export interface ProgramDataGarageConfigDetailOptions {
  __typename?: "ProgramDataGarageConfigDetail";
  code?: ProgramDataGarageConfigDetail["code"];
  name?: ProgramDataGarageConfigDetail["name"];
}

export function newProgramDataGarageConfigDetail(
  options?: ProgramDataGarageConfigDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProgramDataGarageConfigDetail>;
export function newProgramDataGarageConfigDetail(
  options: ProgramDataGarageConfigDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProgramDataGarageConfigDetail> {
  const o =
    (options.__typename ? options : cache["ProgramDataGarageConfigDetail"] = {}) as ProgramDataGarageConfigDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProgramDataGarageConfigDetail";
    o.code = options.code ?? ProgramDataGarageConfig.FrontLoad;
    o.name = options.name ?? "Front load";
    return o as FactoryResult<ProgramDataGarageConfigDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProgramDataGarageConfigDetail"] = newProgramDataGarageConfigDetail;

export interface ProgramDataMatchStateDetailOptions {
  __typename?: "ProgramDataMatchStateDetail";
  code?: ProgramDataMatchStateDetail["code"];
  name?: ProgramDataMatchStateDetail["name"];
}

export function newProgramDataMatchStateDetail(
  options?: ProgramDataMatchStateDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProgramDataMatchStateDetail>;
export function newProgramDataMatchStateDetail(
  options: ProgramDataMatchStateDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProgramDataMatchStateDetail> {
  const o = (options.__typename ? options : cache["ProgramDataMatchStateDetail"] = {}) as ProgramDataMatchStateDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProgramDataMatchStateDetail";
    o.code = options.code ?? ProgramDataMatchState.Matches;
    o.name = options.name ?? "Matches";
    return o as FactoryResult<ProgramDataMatchStateDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProgramDataMatchStateDetail"] = newProgramDataMatchStateDetail;

export interface ProgramDataPrimaryBedroomConfigDetailOptions {
  __typename?: "ProgramDataPrimaryBedroomConfigDetail";
  code?: ProgramDataPrimaryBedroomConfigDetail["code"];
  name?: ProgramDataPrimaryBedroomConfigDetail["name"];
}

export function newProgramDataPrimaryBedroomConfigDetail(
  options?: ProgramDataPrimaryBedroomConfigDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProgramDataPrimaryBedroomConfigDetail>;
export function newProgramDataPrimaryBedroomConfigDetail(
  options: ProgramDataPrimaryBedroomConfigDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProgramDataPrimaryBedroomConfigDetail> {
  const o =
    (options.__typename
      ? options
      : cache["ProgramDataPrimaryBedroomConfigDetail"] = {}) as ProgramDataPrimaryBedroomConfigDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProgramDataPrimaryBedroomConfigDetail";
    o.code = options.code ?? ProgramDataPrimaryBedroomConfig.Up;
    o.name = options.name ?? "Up";
    return o as FactoryResult<ProgramDataPrimaryBedroomConfigDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProgramDataPrimaryBedroomConfigDetail"] = newProgramDataPrimaryBedroomConfigDetail;

export interface ProgramDataWindowColorDetailOptions {
  __typename?: "ProgramDataWindowColorDetail";
  code?: ProgramDataWindowColorDetail["code"];
  name?: ProgramDataWindowColorDetail["name"];
}

export function newProgramDataWindowColorDetail(
  options?: ProgramDataWindowColorDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProgramDataWindowColorDetail>;
export function newProgramDataWindowColorDetail(
  options: ProgramDataWindowColorDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProgramDataWindowColorDetail> {
  const o = (options.__typename ? options : cache["ProgramDataWindowColorDetail"] = {}) as ProgramDataWindowColorDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProgramDataWindowColorDetail";
    o.code = options.code ?? ProgramDataWindowColor.White;
    o.name = options.name ?? "White";
    return o as FactoryResult<ProgramDataWindowColorDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProgramDataWindowColorDetail"] = newProgramDataWindowColorDetail;

export interface ProjectCollaboratorRoleDetailOptions {
  __typename?: "ProjectCollaboratorRoleDetail";
  code?: ProjectCollaboratorRoleDetail["code"];
  name?: ProjectCollaboratorRoleDetail["name"];
}

export function newProjectCollaboratorRoleDetail(
  options?: ProjectCollaboratorRoleDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCollaboratorRoleDetail>;
export function newProjectCollaboratorRoleDetail(
  options: ProjectCollaboratorRoleDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectCollaboratorRoleDetail> {
  const o =
    (options.__typename ? options : cache["ProjectCollaboratorRoleDetail"] = {}) as ProjectCollaboratorRoleDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectCollaboratorRoleDetail";
    o.code = options.code ?? ProjectCollaboratorRole.Homeowner;
    o.name = options.name ?? "Homeowner";
    return o as FactoryResult<ProjectCollaboratorRoleDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectCollaboratorRoleDetail"] = newProjectCollaboratorRoleDetail;

export interface ProjectFeatureDetailOptions {
  __typename?: "ProjectFeatureDetail";
  code?: ProjectFeatureDetail["code"];
  name?: ProjectFeatureDetail["name"];
}

export function newProjectFeatureDetail(
  options?: ProjectFeatureDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectFeatureDetail>;
export function newProjectFeatureDetail(
  options: ProjectFeatureDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectFeatureDetail> {
  const o = (options.__typename ? options : cache["ProjectFeatureDetail"] = {}) as ProjectFeatureDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectFeatureDetail";
    o.code = options.code ?? ProjectFeature.SelectionsV1;
    o.name = options.name ?? "Selections v1";
    return o as FactoryResult<ProjectFeatureDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectFeatureDetail"] = newProjectFeatureDetail;

export interface ProjectReadyPlanConfigOrientationDetailOptions {
  __typename?: "ProjectReadyPlanConfigOrientationDetail";
  code?: ProjectReadyPlanConfigOrientationDetail["code"];
  name?: ProjectReadyPlanConfigOrientationDetail["name"];
}

export function newProjectReadyPlanConfigOrientationDetail(
  options?: ProjectReadyPlanConfigOrientationDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectReadyPlanConfigOrientationDetail>;
export function newProjectReadyPlanConfigOrientationDetail(
  options: ProjectReadyPlanConfigOrientationDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectReadyPlanConfigOrientationDetail> {
  const o =
    (options.__typename
      ? options
      : cache["ProjectReadyPlanConfigOrientationDetail"] = {}) as ProjectReadyPlanConfigOrientationDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectReadyPlanConfigOrientationDetail";
    o.code = options.code ?? ProjectReadyPlanConfigOrientation.Left;
    o.name = options.name ?? "Left";
    return o as FactoryResult<ProjectReadyPlanConfigOrientationDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectReadyPlanConfigOrientationDetail"] = newProjectReadyPlanConfigOrientationDetail;

export interface ProjectRoleDetailOptions {
  __typename?: "ProjectRoleDetail";
  code?: ProjectRoleDetail["code"];
  name?: ProjectRoleDetail["name"];
  sortOrder?: ProjectRoleDetail["sortOrder"];
  description?: ProjectRoleDetail["description"];
}

export function newProjectRoleDetail(
  options?: ProjectRoleDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectRoleDetail>;
export function newProjectRoleDetail(
  options: ProjectRoleDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectRoleDetail> {
  const o = (options.__typename ? options : cache["ProjectRoleDetail"] = {}) as ProjectRoleDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectRoleDetail";
    o.code = options.code ?? ProjectRole.HeadOfConstruction;
    o.name = options.name ?? "Head of construction";
    o.sortOrder = options.sortOrder ?? 0;
    o.description = options.description ?? "Head of construction";
    return o as FactoryResult<ProjectRoleDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectRoleDetail"] = newProjectRoleDetail;

export interface ProjectStageStatusDetailOptions {
  __typename?: "ProjectStageStatusDetail";
  code?: ProjectStageStatusDetail["code"];
  name?: ProjectStageStatusDetail["name"];
}

export function newProjectStageStatusDetail(
  options?: ProjectStageStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStageStatusDetail>;
export function newProjectStageStatusDetail(
  options: ProjectStageStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectStageStatusDetail> {
  const o = (options.__typename ? options : cache["ProjectStageStatusDetail"] = {}) as ProjectStageStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectStageStatusDetail";
    o.code = options.code ?? ProjectStageStatus.Active;
    o.name = options.name ?? "Active";
    return o as FactoryResult<ProjectStageStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectStageStatusDetail"] = newProjectStageStatusDetail;

export interface ProjectStatusDetailOptions {
  __typename?: "ProjectStatusDetail";
  code?: ProjectStatusDetail["code"];
  name?: ProjectStatusDetail["name"];
}

export function newProjectStatusDetail(
  options?: ProjectStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStatusDetail>;
export function newProjectStatusDetail(
  options: ProjectStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectStatusDetail> {
  const o = (options.__typename ? options : cache["ProjectStatusDetail"] = {}) as ProjectStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectStatusDetail";
    o.code = options.code ?? ProjectStatus.Active;
    o.name = options.name ?? "Active";
    return o as FactoryResult<ProjectStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectStatusDetail"] = newProjectStatusDetail;

export interface ProjectUpdateActionTypeDetailOptions {
  __typename?: "ProjectUpdateActionTypeDetail";
  code?: ProjectUpdateActionTypeDetail["code"];
  name?: ProjectUpdateActionTypeDetail["name"];
}

export function newProjectUpdateActionTypeDetail(
  options?: ProjectUpdateActionTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectUpdateActionTypeDetail>;
export function newProjectUpdateActionTypeDetail(
  options: ProjectUpdateActionTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectUpdateActionTypeDetail> {
  const o =
    (options.__typename ? options : cache["ProjectUpdateActionTypeDetail"] = {}) as ProjectUpdateActionTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectUpdateActionTypeDetail";
    o.code = options.code ?? ProjectUpdateActionType.ActivityComplete;
    o.name = options.name ?? "Activity complete";
    return o as FactoryResult<ProjectUpdateActionTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectUpdateActionTypeDetail"] = newProjectUpdateActionTypeDetail;

export interface PushNotificationEnvironmentDetailOptions {
  __typename?: "PushNotificationEnvironmentDetail";
  code?: PushNotificationEnvironmentDetail["code"];
  name?: PushNotificationEnvironmentDetail["name"];
}

export function newPushNotificationEnvironmentDetail(
  options?: PushNotificationEnvironmentDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PushNotificationEnvironmentDetail>;
export function newPushNotificationEnvironmentDetail(
  options: PushNotificationEnvironmentDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PushNotificationEnvironmentDetail> {
  const o =
    (options.__typename
      ? options
      : cache["PushNotificationEnvironmentDetail"] = {}) as PushNotificationEnvironmentDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PushNotificationEnvironmentDetail";
    o.code = options.code ?? PushNotificationEnvironment.Sandbox;
    o.name = options.name ?? "Sandbox";
    return o as FactoryResult<PushNotificationEnvironmentDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PushNotificationEnvironmentDetail"] = newPushNotificationEnvironmentDetail;

export interface PushNotificationPlatformDetailOptions {
  __typename?: "PushNotificationPlatformDetail";
  code?: PushNotificationPlatformDetail["code"];
  name?: PushNotificationPlatformDetail["name"];
}

export function newPushNotificationPlatformDetail(
  options?: PushNotificationPlatformDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PushNotificationPlatformDetail>;
export function newPushNotificationPlatformDetail(
  options: PushNotificationPlatformDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PushNotificationPlatformDetail> {
  const o =
    (options.__typename ? options : cache["PushNotificationPlatformDetail"] = {}) as PushNotificationPlatformDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PushNotificationPlatformDetail";
    o.code = options.code ?? PushNotificationPlatform.Ios;
    o.name = options.name ?? "Ios";
    return o as FactoryResult<PushNotificationPlatformDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PushNotificationPlatformDetail"] = newPushNotificationPlatformDetail;

export interface ReadyPlanAssetTypeDetailOptions {
  __typename?: "ReadyPlanAssetTypeDetail";
  code?: ReadyPlanAssetTypeDetail["code"];
  name?: ReadyPlanAssetTypeDetail["name"];
}

export function newReadyPlanAssetTypeDetail(
  options?: ReadyPlanAssetTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanAssetTypeDetail>;
export function newReadyPlanAssetTypeDetail(
  options: ReadyPlanAssetTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanAssetTypeDetail> {
  const o = (options.__typename ? options : cache["ReadyPlanAssetTypeDetail"] = {}) as ReadyPlanAssetTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanAssetTypeDetail";
    o.code = options.code ?? ReadyPlanAssetType.CoverPhoto;
    o.name = options.name ?? "Cover photo";
    return o as FactoryResult<ReadyPlanAssetTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanAssetTypeDetail"] = newReadyPlanAssetTypeDetail;

export interface ReadyPlanOptionGroupPersonalizationTypeDetailOptions {
  __typename?: "ReadyPlanOptionGroupPersonalizationTypeDetail";
  code?: ReadyPlanOptionGroupPersonalizationTypeDetail["code"];
  name?: ReadyPlanOptionGroupPersonalizationTypeDetail["name"];
}

export function newReadyPlanOptionGroupPersonalizationTypeDetail(
  options?: ReadyPlanOptionGroupPersonalizationTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionGroupPersonalizationTypeDetail>;
export function newReadyPlanOptionGroupPersonalizationTypeDetail(
  options: ReadyPlanOptionGroupPersonalizationTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOptionGroupPersonalizationTypeDetail> {
  const o =
    (options.__typename
      ? options
      : cache["ReadyPlanOptionGroupPersonalizationTypeDetail"] = {}) as ReadyPlanOptionGroupPersonalizationTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOptionGroupPersonalizationTypeDetail";
    o.code = options.code ?? ReadyPlanOptionGroupPersonalizationType.SingleProduct;
    o.name = options.name ?? "Single product";
    return o as FactoryResult<ReadyPlanOptionGroupPersonalizationTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOptionGroupPersonalizationTypeDetail"] = newReadyPlanOptionGroupPersonalizationTypeDetail;

export interface ReadyPlanStatusDetailOptions {
  __typename?: "ReadyPlanStatusDetail";
  code?: ReadyPlanStatusDetail["code"];
  name?: ReadyPlanStatusDetail["name"];
}

export function newReadyPlanStatusDetail(
  options?: ReadyPlanStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanStatusDetail>;
export function newReadyPlanStatusDetail(
  options: ReadyPlanStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanStatusDetail> {
  const o = (options.__typename ? options : cache["ReadyPlanStatusDetail"] = {}) as ReadyPlanStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanStatusDetail";
    o.code = options.code ?? ReadyPlanStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<ReadyPlanStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanStatusDetail"] = newReadyPlanStatusDetail;

export interface ReadyPlanTypeDetailOptions {
  __typename?: "ReadyPlanTypeDetail";
  code?: ReadyPlanTypeDetail["code"];
  name?: ReadyPlanTypeDetail["name"];
}

export function newReadyPlanTypeDetail(
  options?: ReadyPlanTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanTypeDetail>;
export function newReadyPlanTypeDetail(
  options: ReadyPlanTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanTypeDetail> {
  const o = (options.__typename ? options : cache["ReadyPlanTypeDetail"] = {}) as ReadyPlanTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanTypeDetail";
    o.code = options.code ?? ReadyPlanType.Sfh;
    o.name = options.name ?? "Sfh";
    return o as FactoryResult<ReadyPlanTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanTypeDetail"] = newReadyPlanTypeDetail;

export interface ScheduleFlagReasonTypeDetailOptions {
  __typename?: "ScheduleFlagReasonTypeDetail";
  code?: ScheduleFlagReasonTypeDetail["code"];
  name?: ScheduleFlagReasonTypeDetail["name"];
}

export function newScheduleFlagReasonTypeDetail(
  options?: ScheduleFlagReasonTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleFlagReasonTypeDetail>;
export function newScheduleFlagReasonTypeDetail(
  options: ScheduleFlagReasonTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleFlagReasonTypeDetail> {
  const o = (options.__typename ? options : cache["ScheduleFlagReasonTypeDetail"] = {}) as ScheduleFlagReasonTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleFlagReasonTypeDetail";
    o.code = options.code ?? ScheduleFlagReasonType.Client;
    o.name = options.name ?? "Client";
    return o as FactoryResult<ScheduleFlagReasonTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleFlagReasonTypeDetail"] = newScheduleFlagReasonTypeDetail;

export interface ScheduleStatusDetailOptions {
  __typename?: "ScheduleStatusDetail";
  code?: ScheduleStatusDetail["code"];
  name?: ScheduleStatusDetail["name"];
}

export function newScheduleStatusDetail(
  options?: ScheduleStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleStatusDetail>;
export function newScheduleStatusDetail(
  options: ScheduleStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleStatusDetail> {
  const o = (options.__typename ? options : cache["ScheduleStatusDetail"] = {}) as ScheduleStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleStatusDetail";
    o.code = options.code ?? ScheduleStatus.Active;
    o.name = options.name ?? "Active";
    return o as FactoryResult<ScheduleStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleStatusDetail"] = newScheduleStatusDetail;

export interface ScheduleTemplateStatusDetailOptions {
  __typename?: "ScheduleTemplateStatusDetail";
  code?: ScheduleTemplateStatusDetail["code"];
  name?: ScheduleTemplateStatusDetail["name"];
}

export function newScheduleTemplateStatusDetail(
  options?: ScheduleTemplateStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTemplateStatusDetail>;
export function newScheduleTemplateStatusDetail(
  options: ScheduleTemplateStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleTemplateStatusDetail> {
  const o = (options.__typename ? options : cache["ScheduleTemplateStatusDetail"] = {}) as ScheduleTemplateStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleTemplateStatusDetail";
    o.code = options.code ?? ScheduleTemplateStatus.Draft;
    o.name = options.name ?? "Draft";
    return o as FactoryResult<ScheduleTemplateStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleTemplateStatusDetail"] = newScheduleTemplateStatusDetail;

export interface ScopeChangeTypeDetailOptions {
  __typename?: "ScopeChangeTypeDetail";
  code?: ScopeChangeTypeDetail["code"];
  name?: ScopeChangeTypeDetail["name"];
}

export function newScopeChangeTypeDetail(
  options?: ScopeChangeTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScopeChangeTypeDetail>;
export function newScopeChangeTypeDetail(
  options: ScopeChangeTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScopeChangeTypeDetail> {
  const o = (options.__typename ? options : cache["ScopeChangeTypeDetail"] = {}) as ScopeChangeTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScopeChangeTypeDetail";
    o.code = options.code ?? ScopeChangeType.None;
    o.name = options.name ?? "None";
    return o as FactoryResult<ScopeChangeTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScopeChangeTypeDetail"] = newScopeChangeTypeDetail;

export interface ScopeModeDetailOptions {
  __typename?: "ScopeModeDetail";
  code?: ScopeModeDetail["code"];
  name?: ScopeModeDetail["name"];
}

export function newScopeModeDetail(
  options?: ScopeModeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScopeModeDetail>;
export function newScopeModeDetail(
  options: ScopeModeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScopeModeDetail> {
  const o = (options.__typename ? options : cache["ScopeModeDetail"] = {}) as ScopeModeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScopeModeDetail";
    o.code = options.code ?? ScopeMode.None;
    o.name = options.name ?? "None";
    return o as FactoryResult<ScopeModeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScopeModeDetail"] = newScopeModeDetail;

export interface SelectionCutoffDetailOptions {
  __typename?: "SelectionCutoffDetail";
  code?: SelectionCutoffDetail["code"];
  name?: SelectionCutoffDetail["name"];
}

export function newSelectionCutoffDetail(
  options?: SelectionCutoffDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SelectionCutoffDetail>;
export function newSelectionCutoffDetail(
  options: SelectionCutoffDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SelectionCutoffDetail> {
  const o = (options.__typename ? options : cache["SelectionCutoffDetail"] = {}) as SelectionCutoffDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SelectionCutoffDetail";
    o.code = options.code ?? SelectionCutoff.Cutoff_1;
    o.name = options.name ?? "Cutoff 1";
    return o as FactoryResult<SelectionCutoffDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SelectionCutoffDetail"] = newSelectionCutoffDetail;

export interface StageDetailOptions {
  __typename?: "StageDetail";
  code?: StageDetail["code"];
  name?: StageDetail["name"];
  sortOrder?: StageDetail["sortOrder"];
  slug?: StageDetail["slug"];
  forDevelopment?: StageDetail["forDevelopment"];
  forProject?: StageDetail["forProject"];
  isDeprecated?: StageDetail["isDeprecated"];
}

export function newStageDetail(
  options?: StageDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<StageDetail>;
export function newStageDetail(
  options: StageDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<StageDetail> {
  const o = (options.__typename ? options : cache["StageDetail"] = {}) as StageDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "StageDetail";
    o.code = options.code ?? Stage.PreConPlanning;
    o.name = options.name ?? "Pre con planning";
    o.sortOrder = options.sortOrder ?? 0;
    o.slug = options.slug ?? "Pre con planning";
    o.forDevelopment = options.forDevelopment ?? false;
    o.forProject = options.forProject ?? false;
    o.isDeprecated = options.isDeprecated ?? false;
    return o as FactoryResult<StageDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["StageDetail"] = newStageDetail;

export interface SuburbanAssetCategoryDetailOptions {
  __typename?: "SuburbanAssetCategoryDetail";
  code?: SuburbanAssetCategoryDetail["code"];
  name?: SuburbanAssetCategoryDetail["name"];
}

export function newSuburbanAssetCategoryDetail(
  options?: SuburbanAssetCategoryDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SuburbanAssetCategoryDetail>;
export function newSuburbanAssetCategoryDetail(
  options: SuburbanAssetCategoryDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SuburbanAssetCategoryDetail> {
  const o = (options.__typename ? options : cache["SuburbanAssetCategoryDetail"] = {}) as SuburbanAssetCategoryDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SuburbanAssetCategoryDetail";
    o.code = options.code ?? SuburbanAssetCategory.Inventory;
    o.name = options.name ?? "Inventory";
    return o as FactoryResult<SuburbanAssetCategoryDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SuburbanAssetCategoryDetail"] = newSuburbanAssetCategoryDetail;

export interface SystemChangeRequestAssetDetailOptions {
  __typename?: "SystemChangeRequestAssetDetail";
  code?: SystemChangeRequestAssetDetail["code"];
  name?: SystemChangeRequestAssetDetail["name"];
}

export function newSystemChangeRequestAssetDetail(
  options?: SystemChangeRequestAssetDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SystemChangeRequestAssetDetail>;
export function newSystemChangeRequestAssetDetail(
  options: SystemChangeRequestAssetDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SystemChangeRequestAssetDetail> {
  const o =
    (options.__typename ? options : cache["SystemChangeRequestAssetDetail"] = {}) as SystemChangeRequestAssetDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SystemChangeRequestAssetDetail";
    o.code = options.code ?? SystemChangeRequestAsset.PandaDoc;
    o.name = options.name ?? "Panda doc";
    return o as FactoryResult<SystemChangeRequestAssetDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SystemChangeRequestAssetDetail"] = newSystemChangeRequestAssetDetail;

export interface SystemPlanMilestoneDetailOptions {
  __typename?: "SystemPlanMilestoneDetail";
  code?: SystemPlanMilestoneDetail["code"];
  name?: SystemPlanMilestoneDetail["name"];
}

export function newSystemPlanMilestoneDetail(
  options?: SystemPlanMilestoneDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SystemPlanMilestoneDetail>;
export function newSystemPlanMilestoneDetail(
  options: SystemPlanMilestoneDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SystemPlanMilestoneDetail> {
  const o = (options.__typename ? options : cache["SystemPlanMilestoneDetail"] = {}) as SystemPlanMilestoneDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SystemPlanMilestoneDetail";
    o.code = options.code ?? SystemPlanMilestone.MobilizationStart;
    o.name = options.name ?? "Mobilization start";
    return o as FactoryResult<SystemPlanMilestoneDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SystemPlanMilestoneDetail"] = newSystemPlanMilestoneDetail;

export interface SystemTaskDetailOptions {
  __typename?: "SystemTaskDetail";
  code?: SystemTaskDetail["code"];
  name?: SystemTaskDetail["name"];
}

export function newSystemTaskDetail(
  options?: SystemTaskDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SystemTaskDetail>;
export function newSystemTaskDetail(
  options: SystemTaskDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SystemTaskDetail> {
  const o = (options.__typename ? options : cache["SystemTaskDetail"] = {}) as SystemTaskDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SystemTaskDetail";
    o.code = options.code ?? SystemTask.ConstructionRts;
    o.name = options.name ?? "Construction rts";
    return o as FactoryResult<SystemTaskDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SystemTaskDetail"] = newSystemTaskDetail;

export interface TakeoffLineItemActionDetailOptions {
  __typename?: "TakeoffLineItemActionDetail";
  code?: TakeoffLineItemActionDetail["code"];
  name?: TakeoffLineItemActionDetail["name"];
}

export function newTakeoffLineItemActionDetail(
  options?: TakeoffLineItemActionDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemActionDetail>;
export function newTakeoffLineItemActionDetail(
  options: TakeoffLineItemActionDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TakeoffLineItemActionDetail> {
  const o = (options.__typename ? options : cache["TakeoffLineItemActionDetail"] = {}) as TakeoffLineItemActionDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TakeoffLineItemActionDetail";
    o.code = options.code ?? TakeoffLineItemAction.Add;
    o.name = options.name ?? "Add";
    return o as FactoryResult<TakeoffLineItemActionDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TakeoffLineItemActionDetail"] = newTakeoffLineItemActionDetail;

export interface TakeoffLineItemDesignPackageTypeDetailOptions {
  __typename?: "TakeoffLineItemDesignPackageTypeDetail";
  code?: TakeoffLineItemDesignPackageTypeDetail["code"];
  name?: TakeoffLineItemDesignPackageTypeDetail["name"];
}

export function newTakeoffLineItemDesignPackageTypeDetail(
  options?: TakeoffLineItemDesignPackageTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemDesignPackageTypeDetail>;
export function newTakeoffLineItemDesignPackageTypeDetail(
  options: TakeoffLineItemDesignPackageTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TakeoffLineItemDesignPackageTypeDetail> {
  const o =
    (options.__typename
      ? options
      : cache["TakeoffLineItemDesignPackageTypeDetail"] = {}) as TakeoffLineItemDesignPackageTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TakeoffLineItemDesignPackageTypeDetail";
    o.code = options.code ?? TakeoffLineItemDesignPackageType.RegularPlaceholder;
    o.name = options.name ?? "Regular placeholder";
    return o as FactoryResult<TakeoffLineItemDesignPackageTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TakeoffLineItemDesignPackageTypeDetail"] = newTakeoffLineItemDesignPackageTypeDetail;

export interface TakeoffLineItemTypeDetailOptions {
  __typename?: "TakeoffLineItemTypeDetail";
  code?: TakeoffLineItemTypeDetail["code"];
  name?: TakeoffLineItemTypeDetail["name"];
}

export function newTakeoffLineItemTypeDetail(
  options?: TakeoffLineItemTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemTypeDetail>;
export function newTakeoffLineItemTypeDetail(
  options: TakeoffLineItemTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TakeoffLineItemTypeDetail> {
  const o = (options.__typename ? options : cache["TakeoffLineItemTypeDetail"] = {}) as TakeoffLineItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TakeoffLineItemTypeDetail";
    o.code = options.code ?? TakeoffLineItemType.Iti;
    o.name = options.name ?? "Iti";
    return o as FactoryResult<TakeoffLineItemTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TakeoffLineItemTypeDetail"] = newTakeoffLineItemTypeDetail;

export interface TaskDeadlineTypeDetailOptions {
  __typename?: "TaskDeadlineTypeDetail";
  code?: TaskDeadlineTypeDetail["code"];
  name?: TaskDeadlineTypeDetail["name"];
}

export function newTaskDeadlineTypeDetail(
  options?: TaskDeadlineTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TaskDeadlineTypeDetail>;
export function newTaskDeadlineTypeDetail(
  options: TaskDeadlineTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TaskDeadlineTypeDetail> {
  const o = (options.__typename ? options : cache["TaskDeadlineTypeDetail"] = {}) as TaskDeadlineTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TaskDeadlineTypeDetail";
    o.code = options.code ?? TaskDeadlineType.Cutoff;
    o.name = options.name ?? "Cutoff";
    return o as FactoryResult<TaskDeadlineTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TaskDeadlineTypeDetail"] = newTaskDeadlineTypeDetail;

export interface TaskDependencyTypeDetailOptions {
  __typename?: "TaskDependencyTypeDetail";
  code?: TaskDependencyTypeDetail["code"];
  name?: TaskDependencyTypeDetail["name"];
  shorthand?: TaskDependencyTypeDetail["shorthand"];
}

export function newTaskDependencyTypeDetail(
  options?: TaskDependencyTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TaskDependencyTypeDetail>;
export function newTaskDependencyTypeDetail(
  options: TaskDependencyTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TaskDependencyTypeDetail> {
  const o = (options.__typename ? options : cache["TaskDependencyTypeDetail"] = {}) as TaskDependencyTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TaskDependencyTypeDetail";
    o.code = options.code ?? TaskDependencyType.FinishStart;
    o.name = options.name ?? "Finish start";
    o.shorthand = options.shorthand ?? "Finish start";
    return o as FactoryResult<TaskDependencyTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TaskDependencyTypeDetail"] = newTaskDependencyTypeDetail;

export interface TaskStatusDetailOptions {
  __typename?: "TaskStatusDetail";
  code?: TaskStatusDetail["code"];
  name?: TaskStatusDetail["name"];
  sortOrder?: TaskStatusDetail["sortOrder"];
}

export function newTaskStatusDetail(
  options?: TaskStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TaskStatusDetail>;
export function newTaskStatusDetail(
  options: TaskStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TaskStatusDetail> {
  const o = (options.__typename ? options : cache["TaskStatusDetail"] = {}) as TaskStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TaskStatusDetail";
    o.code = options.code ?? TaskStatus.NotStarted;
    o.name = options.name ?? "Not started";
    o.sortOrder = options.sortOrder ?? 0;
    return o as FactoryResult<TaskStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TaskStatusDetail"] = newTaskStatusDetail;

export interface TaskTypeDetailOptions {
  __typename?: "TaskTypeDetail";
  code?: TaskTypeDetail["code"];
  name?: TaskTypeDetail["name"];
}

export function newTaskTypeDetail(
  options?: TaskTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TaskTypeDetail>;
export function newTaskTypeDetail(
  options: TaskTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TaskTypeDetail> {
  const o = (options.__typename ? options : cache["TaskTypeDetail"] = {}) as TaskTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TaskTypeDetail";
    o.code = options.code ?? TaskType.ScheduleTask;
    o.name = options.name ?? "Schedule task";
    return o as FactoryResult<TaskTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TaskTypeDetail"] = newTaskTypeDetail;

export interface TimeFrequencyDetailOptions {
  __typename?: "TimeFrequencyDetail";
  code?: TimeFrequencyDetail["code"];
  name?: TimeFrequencyDetail["name"];
}

export function newTimeFrequencyDetail(
  options?: TimeFrequencyDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TimeFrequencyDetail>;
export function newTimeFrequencyDetail(
  options: TimeFrequencyDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TimeFrequencyDetail> {
  const o = (options.__typename ? options : cache["TimeFrequencyDetail"] = {}) as TimeFrequencyDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TimeFrequencyDetail";
    o.code = options.code ?? TimeFrequency.Days;
    o.name = options.name ?? "Days";
    return o as FactoryResult<TimeFrequencyDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TimeFrequencyDetail"] = newTimeFrequencyDetail;

export interface TimeOfDayDetailOptions {
  __typename?: "TimeOfDayDetail";
  code?: TimeOfDayDetail["code"];
  name?: TimeOfDayDetail["name"];
}

export function newTimeOfDayDetail(
  options?: TimeOfDayDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TimeOfDayDetail>;
export function newTimeOfDayDetail(
  options: TimeOfDayDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TimeOfDayDetail> {
  const o = (options.__typename ? options : cache["TimeOfDayDetail"] = {}) as TimeOfDayDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TimeOfDayDetail";
    o.code = options.code ?? TimeOfDay.Morning;
    o.name = options.name ?? "Morning";
    return o as FactoryResult<TimeOfDayDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TimeOfDayDetail"] = newTimeOfDayDetail;

export interface ToDoStatusDetailOptions {
  __typename?: "ToDoStatusDetail";
  code?: ToDoStatusDetail["code"];
  name?: ToDoStatusDetail["name"];
  sortOrder?: ToDoStatusDetail["sortOrder"];
}

export function newToDoStatusDetail(
  options?: ToDoStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToDoStatusDetail>;
export function newToDoStatusDetail(
  options: ToDoStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ToDoStatusDetail> {
  const o = (options.__typename ? options : cache["ToDoStatusDetail"] = {}) as ToDoStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ToDoStatusDetail";
    o.code = options.code ?? ToDoStatus.Backlog;
    o.name = options.name ?? "Backlog";
    o.sortOrder = options.sortOrder ?? 0;
    return o as FactoryResult<ToDoStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ToDoStatusDetail"] = newToDoStatusDetail;

export interface ToDoTypeDetailOptions {
  __typename?: "ToDoTypeDetail";
  code?: ToDoTypeDetail["code"];
  name?: ToDoTypeDetail["name"];
}

export function newToDoTypeDetail(
  options?: ToDoTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToDoTypeDetail>;
export function newToDoTypeDetail(
  options: ToDoTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ToDoTypeDetail> {
  const o = (options.__typename ? options : cache["ToDoTypeDetail"] = {}) as ToDoTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ToDoTypeDetail";
    o.code = options.code ?? ToDoType.Submittals;
    o.name = options.name ?? "Submittals";
    return o as FactoryResult<ToDoTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ToDoTypeDetail"] = newToDoTypeDetail;

export interface TrackedJobStatusDetailOptions {
  __typename?: "TrackedJobStatusDetail";
  code?: TrackedJobStatusDetail["code"];
  name?: TrackedJobStatusDetail["name"];
}

export function newTrackedJobStatusDetail(
  options?: TrackedJobStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TrackedJobStatusDetail>;
export function newTrackedJobStatusDetail(
  options: TrackedJobStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TrackedJobStatusDetail> {
  const o = (options.__typename ? options : cache["TrackedJobStatusDetail"] = {}) as TrackedJobStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TrackedJobStatusDetail";
    o.code = options.code ?? TrackedJobStatus.Pending;
    o.name = options.name ?? "Pending";
    return o as FactoryResult<TrackedJobStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TrackedJobStatusDetail"] = newTrackedJobStatusDetail;

export interface TradePartnerAvailabilityRequestStatusDetailOptions {
  __typename?: "TradePartnerAvailabilityRequestStatusDetail";
  code?: TradePartnerAvailabilityRequestStatusDetail["code"];
  name?: TradePartnerAvailabilityRequestStatusDetail["name"];
}

export function newTradePartnerAvailabilityRequestStatusDetail(
  options?: TradePartnerAvailabilityRequestStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequestStatusDetail>;
export function newTradePartnerAvailabilityRequestStatusDetail(
  options: TradePartnerAvailabilityRequestStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerAvailabilityRequestStatusDetail> {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestStatusDetail"] = {}) as TradePartnerAvailabilityRequestStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerAvailabilityRequestStatusDetail";
    o.code = options.code ?? TradePartnerAvailabilityRequestStatus.Waiting;
    o.name = options.name ?? "Waiting";
    return o as FactoryResult<TradePartnerAvailabilityRequestStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerAvailabilityRequestStatusDetail"] = newTradePartnerAvailabilityRequestStatusDetail;

export interface TradePartnerMarketRoleDetailOptions {
  __typename?: "TradePartnerMarketRoleDetail";
  code?: TradePartnerMarketRoleDetail["code"];
  name?: TradePartnerMarketRoleDetail["name"];
  sortOrder?: TradePartnerMarketRoleDetail["sortOrder"];
  description?: TradePartnerMarketRoleDetail["description"];
}

export function newTradePartnerMarketRoleDetail(
  options?: TradePartnerMarketRoleDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerMarketRoleDetail>;
export function newTradePartnerMarketRoleDetail(
  options: TradePartnerMarketRoleDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerMarketRoleDetail> {
  const o = (options.__typename ? options : cache["TradePartnerMarketRoleDetail"] = {}) as TradePartnerMarketRoleDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerMarketRoleDetail";
    o.code = options.code ?? TradePartnerMarketRole.BillApprover;
    o.name = options.name ?? "Bill approver";
    o.sortOrder = options.sortOrder ?? 0;
    o.description = options.description ?? "Bill approver";
    return o as FactoryResult<TradePartnerMarketRoleDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerMarketRoleDetail"] = newTradePartnerMarketRoleDetail;

export interface TradePartnerOnboardingStatusDetailOptions {
  __typename?: "TradePartnerOnboardingStatusDetail";
  code?: TradePartnerOnboardingStatusDetail["code"];
  name?: TradePartnerOnboardingStatusDetail["name"];
}

export function newTradePartnerOnboardingStatusDetail(
  options?: TradePartnerOnboardingStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerOnboardingStatusDetail>;
export function newTradePartnerOnboardingStatusDetail(
  options: TradePartnerOnboardingStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerOnboardingStatusDetail> {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerOnboardingStatusDetail"] = {}) as TradePartnerOnboardingStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerOnboardingStatusDetail";
    o.code = options.code ?? TradePartnerOnboardingStatus.InProgress;
    o.name = options.name ?? "In progress";
    return o as FactoryResult<TradePartnerOnboardingStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerOnboardingStatusDetail"] = newTradePartnerOnboardingStatusDetail;

export interface TradePartnerRequirementStatusDetailOptions {
  __typename?: "TradePartnerRequirementStatusDetail";
  code?: TradePartnerRequirementStatusDetail["code"];
  name?: TradePartnerRequirementStatusDetail["name"];
}

export function newTradePartnerRequirementStatusDetail(
  options?: TradePartnerRequirementStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerRequirementStatusDetail>;
export function newTradePartnerRequirementStatusDetail(
  options: TradePartnerRequirementStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerRequirementStatusDetail> {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerRequirementStatusDetail"] = {}) as TradePartnerRequirementStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerRequirementStatusDetail";
    o.code = options.code ?? TradePartnerRequirementStatus.Meets;
    o.name = options.name ?? "Meets";
    return o as FactoryResult<TradePartnerRequirementStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerRequirementStatusDetail"] = newTradePartnerRequirementStatusDetail;

export interface TradePartnerRequirementTypeDetailOptions {
  __typename?: "TradePartnerRequirementTypeDetail";
  code?: TradePartnerRequirementTypeDetail["code"];
  name?: TradePartnerRequirementTypeDetail["name"];
  hasExpirationDate?: TradePartnerRequirementTypeDetail["hasExpirationDate"];
  hasCoverageAmount?: TradePartnerRequirementTypeDetail["hasCoverageAmount"];
  hasLicenseNumber?: TradePartnerRequirementTypeDetail["hasLicenseNumber"];
  hasSignedDate?: TradePartnerRequirementTypeDetail["hasSignedDate"];
  isTsa?: TradePartnerRequirementTypeDetail["isTsa"];
}

export function newTradePartnerRequirementTypeDetail(
  options?: TradePartnerRequirementTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerRequirementTypeDetail>;
export function newTradePartnerRequirementTypeDetail(
  options: TradePartnerRequirementTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerRequirementTypeDetail> {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerRequirementTypeDetail"] = {}) as TradePartnerRequirementTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerRequirementTypeDetail";
    o.code = options.code ?? TradePartnerRequirementType.W9;
    o.name = options.name ?? "W9";
    o.hasExpirationDate = options.hasExpirationDate ?? false;
    o.hasCoverageAmount = options.hasCoverageAmount ?? false;
    o.hasLicenseNumber = options.hasLicenseNumber ?? false;
    o.hasSignedDate = options.hasSignedDate ?? false;
    o.isTsa = options.isTsa ?? false;
    return o as FactoryResult<TradePartnerRequirementTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerRequirementTypeDetail"] = newTradePartnerRequirementTypeDetail;

export interface TradePartnerTaskStatusDetailOptions {
  __typename?: "TradePartnerTaskStatusDetail";
  code?: TradePartnerTaskStatusDetail["code"];
  name?: TradePartnerTaskStatusDetail["name"];
}

export function newTradePartnerTaskStatusDetail(
  options?: TradePartnerTaskStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerTaskStatusDetail>;
export function newTradePartnerTaskStatusDetail(
  options: TradePartnerTaskStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerTaskStatusDetail> {
  const o = (options.__typename ? options : cache["TradePartnerTaskStatusDetail"] = {}) as TradePartnerTaskStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerTaskStatusDetail";
    o.code = options.code ?? TradePartnerTaskStatus.NeedsConfirmation;
    o.name = options.name ?? "Needs confirmation";
    return o as FactoryResult<TradePartnerTaskStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerTaskStatusDetail"] = newTradePartnerTaskStatusDetail;

export interface UserEventTypeDetailOptions {
  __typename?: "UserEventTypeDetail";
  code?: UserEventTypeDetail["code"];
  name?: UserEventTypeDetail["name"];
  allowedEntities?: UserEventTypeDetail["allowedEntities"];
}

export function newUserEventTypeDetail(
  options?: UserEventTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UserEventTypeDetail>;
export function newUserEventTypeDetail(
  options: UserEventTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UserEventTypeDetail> {
  const o = (options.__typename ? options : cache["UserEventTypeDetail"] = {}) as UserEventTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UserEventTypeDetail";
    o.code = options.code ?? UserEventType.Created;
    o.name = options.name ?? "Created";
    o.allowedEntities = options.allowedEntities ?? "Created";
    return o as FactoryResult<UserEventTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UserEventTypeDetail"] = newUserEventTypeDetail;

export interface UserTypeDetailOptions {
  __typename?: "UserTypeDetail";
  code?: UserTypeDetail["code"];
  name?: UserTypeDetail["name"];
}

export function newUserTypeDetail(
  options?: UserTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UserTypeDetail>;
export function newUserTypeDetail(
  options: UserTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UserTypeDetail> {
  const o = (options.__typename ? options : cache["UserTypeDetail"] = {}) as UserTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UserTypeDetail";
    o.code = options.code ?? UserType.Anonymous;
    o.name = options.name ?? "Anonymous";
    return o as FactoryResult<UserTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UserTypeDetail"] = newUserTypeDetail;

export interface VerificationMethodDetailOptions {
  __typename?: "VerificationMethodDetail";
  code?: VerificationMethodDetail["code"];
  name?: VerificationMethodDetail["name"];
}

export function newVerificationMethodDetail(
  options?: VerificationMethodDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<VerificationMethodDetail>;
export function newVerificationMethodDetail(
  options: VerificationMethodDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<VerificationMethodDetail> {
  const o = (options.__typename ? options : cache["VerificationMethodDetail"] = {}) as VerificationMethodDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "VerificationMethodDetail";
    o.code = options.code ?? VerificationMethod.VisualInput;
    o.name = options.name ?? "Visual input";
    return o as FactoryResult<VerificationMethodDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["VerificationMethodDetail"] = newVerificationMethodDetail;

export interface WarrantyTicketItemStatusDetailOptions {
  __typename?: "WarrantyTicketItemStatusDetail";
  code?: WarrantyTicketItemStatusDetail["code"];
  name?: WarrantyTicketItemStatusDetail["name"];
  sortOrder?: WarrantyTicketItemStatusDetail["sortOrder"];
}

export function newWarrantyTicketItemStatusDetail(
  options?: WarrantyTicketItemStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicketItemStatusDetail>;
export function newWarrantyTicketItemStatusDetail(
  options: WarrantyTicketItemStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WarrantyTicketItemStatusDetail> {
  const o =
    (options.__typename ? options : cache["WarrantyTicketItemStatusDetail"] = {}) as WarrantyTicketItemStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WarrantyTicketItemStatusDetail";
    o.code = options.code ?? WarrantyTicketItemStatus.Submitted;
    o.name = options.name ?? "Submitted";
    o.sortOrder = options.sortOrder ?? 0;
    return o as FactoryResult<WarrantyTicketItemStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WarrantyTicketItemStatusDetail"] = newWarrantyTicketItemStatusDetail;

export interface WarrantyTicketItemTypeDetailOptions {
  __typename?: "WarrantyTicketItemTypeDetail";
  code?: WarrantyTicketItemTypeDetail["code"];
  name?: WarrantyTicketItemTypeDetail["name"];
}

export function newWarrantyTicketItemTypeDetail(
  options?: WarrantyTicketItemTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicketItemTypeDetail>;
export function newWarrantyTicketItemTypeDetail(
  options: WarrantyTicketItemTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WarrantyTicketItemTypeDetail> {
  const o = (options.__typename ? options : cache["WarrantyTicketItemTypeDetail"] = {}) as WarrantyTicketItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WarrantyTicketItemTypeDetail";
    o.code = options.code ?? WarrantyTicketItemType.Mechanical;
    o.name = options.name ?? "Mechanical";
    return o as FactoryResult<WarrantyTicketItemTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WarrantyTicketItemTypeDetail"] = newWarrantyTicketItemTypeDetail;

export interface WarrantyTicketStatusDetailOptions {
  __typename?: "WarrantyTicketStatusDetail";
  code?: WarrantyTicketStatusDetail["code"];
  name?: WarrantyTicketStatusDetail["name"];
}

export function newWarrantyTicketStatusDetail(
  options?: WarrantyTicketStatusDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicketStatusDetail>;
export function newWarrantyTicketStatusDetail(
  options: WarrantyTicketStatusDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WarrantyTicketStatusDetail> {
  const o = (options.__typename ? options : cache["WarrantyTicketStatusDetail"] = {}) as WarrantyTicketStatusDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WarrantyTicketStatusDetail";
    o.code = options.code ?? WarrantyTicketStatus.NotStarted;
    o.name = options.name ?? "Not started";
    return o as FactoryResult<WarrantyTicketStatusDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WarrantyTicketStatusDetail"] = newWarrantyTicketStatusDetail;

export interface WarrantyTicketTypeDetailOptions {
  __typename?: "WarrantyTicketTypeDetail";
  code?: WarrantyTicketTypeDetail["code"];
  name?: WarrantyTicketTypeDetail["name"];
}

export function newWarrantyTicketTypeDetail(
  options?: WarrantyTicketTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicketTypeDetail>;
export function newWarrantyTicketTypeDetail(
  options: WarrantyTicketTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WarrantyTicketTypeDetail> {
  const o = (options.__typename ? options : cache["WarrantyTicketTypeDetail"] = {}) as WarrantyTicketTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WarrantyTicketTypeDetail";
    o.code = options.code ?? WarrantyTicketType.ItemsOfContinuance;
    o.name = options.name ?? "Items of continuance";
    return o as FactoryResult<WarrantyTicketTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WarrantyTicketTypeDetail"] = newWarrantyTicketTypeDetail;

export interface WarrantyTrueUpTypeDetailOptions {
  __typename?: "WarrantyTrueUpTypeDetail";
  code?: WarrantyTrueUpTypeDetail["code"];
  name?: WarrantyTrueUpTypeDetail["name"];
  offsetInDays?: WarrantyTrueUpTypeDetail["offsetInDays"];
}

export function newWarrantyTrueUpTypeDetail(
  options?: WarrantyTrueUpTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTrueUpTypeDetail>;
export function newWarrantyTrueUpTypeDetail(
  options: WarrantyTrueUpTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WarrantyTrueUpTypeDetail> {
  const o = (options.__typename ? options : cache["WarrantyTrueUpTypeDetail"] = {}) as WarrantyTrueUpTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WarrantyTrueUpTypeDetail";
    o.code = options.code ?? WarrantyTrueUpType.TimeOfSale;
    o.name = options.name ?? "Time of sale";
    o.offsetInDays = options.offsetInDays ?? 0;
    return o as FactoryResult<WarrantyTrueUpTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WarrantyTrueUpTypeDetail"] = newWarrantyTrueUpTypeDetail;

export interface WeatherTypeDetailOptions {
  __typename?: "WeatherTypeDetail";
  code?: WeatherTypeDetail["code"];
  name?: WeatherTypeDetail["name"];
}

export function newWeatherTypeDetail(
  options?: WeatherTypeDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WeatherTypeDetail>;
export function newWeatherTypeDetail(
  options: WeatherTypeDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WeatherTypeDetail> {
  const o = (options.__typename ? options : cache["WeatherTypeDetail"] = {}) as WeatherTypeDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WeatherTypeDetail";
    o.code = options.code ?? WeatherType.ClearDay;
    o.name = options.name ?? "Clear day";
    return o as FactoryResult<WeatherTypeDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WeatherTypeDetail"] = newWeatherTypeDetail;

export interface AllEnumDetailsOptions {
  __typename?: "AllEnumDetails";
  activityPlanningState?: Array<FactoryInput<ActivityPlanningStateDetail, ActivityPlanningStateDetailOptions>>;
  activityResponsibility?: Array<FactoryInput<ActivityResponsibilityDetail, ActivityResponsibilityDetailOptions>>;
  activityType?: Array<FactoryInput<ActivityTypeDetail, ActivityTypeDetailOptions>>;
  aggregateVersionStatus?: Array<FactoryInput<AggregateVersionStatusDetail, AggregateVersionStatusDetailOptions>>;
  aiDataConfidence?: Array<FactoryInput<AiDataConfidenceDetail, AiDataConfidenceDetailOptions>>;
  aiEntityProposalEntityType?: Array<
    FactoryInput<AiEntityProposalEntityTypeDetail, AiEntityProposalEntityTypeDetailOptions>
  >;
  aiEntityProposalType?: Array<FactoryInput<AiEntityProposalTypeDetail, AiEntityProposalTypeDetailOptions>>;
  aiFieldProposalStatus?: Array<FactoryInput<AiFieldProposalStatusDetail, AiFieldProposalStatusDetailOptions>>;
  aiProposalStatus?: Array<FactoryInput<AiProposalStatusDetail, AiProposalStatusDetailOptions>>;
  aiProposalType?: Array<FactoryInput<AiProposalTypeDetail, AiProposalTypeDetailOptions>>;
  allocationStrategy?: Array<FactoryInput<AllocationStrategyDetail, AllocationStrategyDetailOptions>>;
  approvalStatus?: Array<FactoryInput<ApprovalStatusDetail, ApprovalStatusDetailOptions>>;
  approverStatus?: Array<FactoryInput<ApproverStatusDetail, ApproverStatusDetailOptions>>;
  bidContractRevisionStatus?: Array<
    FactoryInput<BidContractRevisionStatusDetail, BidContractRevisionStatusDetailOptions>
  >;
  bidContractType?: Array<FactoryInput<BidContractTypeDetail, BidContractTypeDetailOptions>>;
  bidPackageStatus?: Array<FactoryInput<BidPackageStatusDetail, BidPackageStatusDetailOptions>>;
  billGmailAttachmentResult?: Array<
    FactoryInput<BillGmailAttachmentResultDetail, BillGmailAttachmentResultDetailOptions>
  >;
  billGmailMessageResult?: Array<FactoryInput<BillGmailMessageResultDetail, BillGmailMessageResultDetailOptions>>;
  billReviewReason?: Array<FactoryInput<BillReviewReasonDetail, BillReviewReasonDetailOptions>>;
  billSource?: Array<FactoryInput<BillSourceDetail, BillSourceDetailOptions>>;
  billStatus?: Array<FactoryInput<BillStatusDetail, BillStatusDetailOptions>>;
  billType?: Array<FactoryInput<BillTypeDetail, BillTypeDetailOptions>>;
  businessFunctionType?: Array<FactoryInput<BusinessFunctionTypeDetail, BusinessFunctionTypeDetailOptions>>;
  buyoutStatus?: Array<FactoryInput<BuyoutStatusDetail, BuyoutStatusDetailOptions>>;
  changeEventBudgetPhase?: Array<FactoryInput<ChangeEventBudgetPhaseDetail, ChangeEventBudgetPhaseDetailOptions>>;
  changeEventLineItemType?: Array<FactoryInput<ChangeEventLineItemTypeDetail, ChangeEventLineItemTypeDetailOptions>>;
  changeEventStatus?: Array<FactoryInput<ChangeEventStatusDetail, ChangeEventStatusDetailOptions>>;
  changeEventType?: Array<FactoryInput<ChangeEventTypeDetail, ChangeEventTypeDetailOptions>>;
  changeEventWorkflow?: Array<FactoryInput<ChangeEventWorkflowDetail, ChangeEventWorkflowDetailOptions>>;
  changeRequestAssetPlatform?: Array<
    FactoryInput<ChangeRequestAssetPlatformDetail, ChangeRequestAssetPlatformDetailOptions>
  >;
  changeRequestAssetScope?: Array<FactoryInput<ChangeRequestAssetScopeDetail, ChangeRequestAssetScopeDetailOptions>>;
  changeRequestPriority?: Array<FactoryInput<ChangeRequestPriorityDetail, ChangeRequestPriorityDetailOptions>>;
  changeRequestSource?: Array<FactoryInput<ChangeRequestSourceDetail, ChangeRequestSourceDetailOptions>>;
  changeRequestStatus?: Array<FactoryInput<ChangeRequestStatusDetail, ChangeRequestStatusDetailOptions>>;
  changeRequestToDoType?: Array<FactoryInput<ChangeRequestToDoTypeDetail, ChangeRequestToDoTypeDetailOptions>>;
  changeType?: Array<FactoryInput<ChangeTypeDetail, ChangeTypeDetailOptions>>;
  checkoutConfigOptionGroupStep?: Array<
    FactoryInput<CheckoutConfigOptionGroupStepDetail, CheckoutConfigOptionGroupStepDetailOptions>
  >;
  checkoutConfigStatus?: Array<FactoryInput<CheckoutConfigStatusDetail, CheckoutConfigStatusDetailOptions>>;
  clientPlatform?: Array<FactoryInput<ClientPlatformDetail, ClientPlatformDetailOptions>>;
  commentStreamVisibility?: Array<FactoryInput<CommentStreamVisibilityDetail, CommentStreamVisibilityDetailOptions>>;
  commitmentStatus?: Array<FactoryInput<CommitmentStatusDetail, CommitmentStatusDetailOptions>>;
  commitmentType?: Array<FactoryInput<CommitmentTypeDetail, CommitmentTypeDetailOptions>>;
  communicationChannel?: Array<FactoryInput<CommunicationChannelDetail, CommunicationChannelDetailOptions>>;
  communityType?: Array<FactoryInput<CommunityTypeDetail, CommunityTypeDetailOptions>>;
  constructionType?: Array<FactoryInput<ConstructionTypeDetail, ConstructionTypeDetailOptions>>;
  contractType?: Array<FactoryInput<ContractTypeDetail, ContractTypeDetailOptions>>;
  costClassificationType?: Array<FactoryInput<CostClassificationTypeDetail, CostClassificationTypeDetailOptions>>;
  costCodeBidSummaryFlag?: Array<FactoryInput<CostCodeBidSummaryFlagDetail, CostCodeBidSummaryFlagDetailOptions>>;
  costCodeBidSummaryStatus?: Array<FactoryInput<CostCodeBidSummaryStatusDetail, CostCodeBidSummaryStatusDetailOptions>>;
  costCodeInvoiceCategory?: Array<FactoryInput<CostCodeInvoiceCategoryDetail, CostCodeInvoiceCategoryDetailOptions>>;
  costConfidence?: Array<FactoryInput<CostConfidenceDetail, CostConfidenceDetailOptions>>;
  costSubClassificationType?: Array<
    FactoryInput<CostSubClassificationTypeDetail, CostSubClassificationTypeDetailOptions>
  >;
  costType?: Array<FactoryInput<CostTypeDetail, CostTypeDetailOptions>>;
  dayOfWeek?: Array<FactoryInput<DayOfWeekDetail, DayOfWeekDetailOptions>>;
  designPackageLocation?: Array<FactoryInput<DesignPackageLocationDetail, DesignPackageLocationDetailOptions>>;
  developmentCommitmentType?: Array<
    FactoryInput<DevelopmentCommitmentTypeDetail, DevelopmentCommitmentTypeDetailOptions>
  >;
  documentAttachmentPlace?: Array<FactoryInput<DocumentAttachmentPlaceDetail, DocumentAttachmentPlaceDetailOptions>>;
  documentCategory?: Array<FactoryInput<DocumentCategoryDetail, DocumentCategoryDetailOptions>>;
  documentType?: Array<FactoryInput<DocumentTypeDetail, DocumentTypeDetailOptions>>;
  erpAccrualType?: Array<FactoryInput<ErpAccrualTypeDetail, ErpAccrualTypeDetailOptions>>;
  erpRevenueLineItemSourceEvent?: Array<
    FactoryInput<ErpRevenueLineItemSourceEventDetail, ErpRevenueLineItemSourceEventDetailOptions>
  >;
  erpTransactionGroupEvent?: Array<FactoryInput<ErpTransactionGroupEventDetail, ErpTransactionGroupEventDetailOptions>>;
  erpTransactionGroupStatus?: Array<
    FactoryInput<ErpTransactionGroupStatusDetail, ErpTransactionGroupStatusDetailOptions>
  >;
  erpTransactionStatus?: Array<FactoryInput<ErpTransactionStatusDetail, ErpTransactionStatusDetailOptions>>;
  estimateStatus?: Array<FactoryInput<EstimateStatusDetail, EstimateStatusDetailOptions>>;
  estimateType?: Array<FactoryInput<EstimateTypeDetail, EstimateTypeDetailOptions>>;
  featureFlagStatus?: Array<FactoryInput<FeatureFlagStatusDetail, FeatureFlagStatusDetailOptions>>;
  featureFlagType?: Array<FactoryInput<FeatureFlagTypeDetail, FeatureFlagTypeDetailOptions>>;
  finishScheduleColumnType?: Array<FactoryInput<FinishScheduleColumnTypeDetail, FinishScheduleColumnTypeDetailOptions>>;
  finishScheduleCoreColumn?: Array<FactoryInput<FinishScheduleCoreColumnDetail, FinishScheduleCoreColumnDetailOptions>>;
  floodPlain?: Array<FactoryInput<FloodPlainDetail, FloodPlainDetailOptions>>;
  floodZone?: Array<FactoryInput<FloodZoneDetail, FloodZoneDetailOptions>>;
  foundationType?: Array<FactoryInput<FoundationTypeDetail, FoundationTypeDetailOptions>>;
  globalOptionStatus?: Array<FactoryInput<GlobalOptionStatusDetail, GlobalOptionStatusDetailOptions>>;
  globalOptionTypeStatus?: Array<FactoryInput<GlobalOptionTypeStatusDetail, GlobalOptionTypeStatusDetailOptions>>;
  globalPlanMilestoneType?: Array<FactoryInput<GlobalPlanMilestoneTypeDetail, GlobalPlanMilestoneTypeDetailOptions>>;
  inboxItemStatus?: Array<FactoryInput<InboxItemStatusDetail, InboxItemStatusDetailOptions>>;
  internalEstimateType?: Array<FactoryInput<InternalEstimateTypeDetail, InternalEstimateTypeDetailOptions>>;
  invoiceDocumentSource?: Array<FactoryInput<InvoiceDocumentSourceDetail, InvoiceDocumentSourceDetailOptions>>;
  invoiceScheduleAmountType?: Array<
    FactoryInput<InvoiceScheduleAmountTypeDetail, InvoiceScheduleAmountTypeDetailOptions>
  >;
  invoiceScheduleItemFrequency?: Array<
    FactoryInput<InvoiceScheduleItemFrequencyDetail, InvoiceScheduleItemFrequencyDetailOptions>
  >;
  invoiceScheduleTriggerType?: Array<
    FactoryInput<InvoiceScheduleTriggerTypeDetail, InvoiceScheduleTriggerTypeDetailOptions>
  >;
  invoiceSource?: Array<FactoryInput<InvoiceSourceDetail, InvoiceSourceDetailOptions>>;
  invoiceStatus?: Array<FactoryInput<InvoiceStatusDetail, InvoiceStatusDetailOptions>>;
  invoiceType?: Array<FactoryInput<InvoiceTypeDetail, InvoiceTypeDetailOptions>>;
  itemStatus?: Array<FactoryInput<ItemStatusDetail, ItemStatusDetailOptions>>;
  itemTemplateItemCostStatus?: Array<
    FactoryInput<ItemTemplateItemCostStatusDetail, ItemTemplateItemCostStatusDetailOptions>
  >;
  itemTemplateStatus?: Array<FactoryInput<ItemTemplateStatusDetail, ItemTemplateStatusDetailOptions>>;
  jobLogFlag?: Array<FactoryInput<JobLogFlagDetail, JobLogFlagDetailOptions>>;
  jobLogNoteType?: Array<FactoryInput<JobLogNoteTypeDetail, JobLogNoteTypeDetailOptions>>;
  lienWaiverCondition?: Array<FactoryInput<LienWaiverConditionDetail, LienWaiverConditionDetailOptions>>;
  lienWaiverStatus?: Array<FactoryInput<LienWaiverStatusDetail, LienWaiverStatusDetailOptions>>;
  lienWaiverType?: Array<FactoryInput<LienWaiverTypeDetail, LienWaiverTypeDetailOptions>>;
  locationType?: Array<FactoryInput<LocationTypeDetail, LocationTypeDetailOptions>>;
  lotSalesStatus?: Array<FactoryInput<LotSalesStatusDetail, LotSalesStatusDetailOptions>>;
  lotType?: Array<FactoryInput<LotTypeDetail, LotTypeDetailOptions>>;
  markupApplicationMethod?: Array<FactoryInput<MarkupApplicationMethodDetail, MarkupApplicationMethodDetailOptions>>;
  materialAttributeDimensionType?: Array<
    FactoryInput<MaterialAttributeDimensionTypeDetail, MaterialAttributeDimensionTypeDetailOptions>
  >;
  materialAttributeValueType?: Array<
    FactoryInput<MaterialAttributeValueTypeDetail, MaterialAttributeValueTypeDetailOptions>
  >;
  materialType?: Array<FactoryInput<MaterialTypeDetail, MaterialTypeDetailOptions>>;
  mobileSyncUpdateType?: Array<FactoryInput<MobileSyncUpdateTypeDetail, MobileSyncUpdateTypeDetailOptions>>;
  pandaDocRole?: Array<FactoryInput<PandaDocRoleDetail, PandaDocRoleDetailOptions>>;
  pandaDocStatus?: Array<FactoryInput<PandaDocStatusDetail, PandaDocStatusDetailOptions>>;
  pandaDocWorkspace?: Array<FactoryInput<PandaDocWorkspaceDetail, PandaDocWorkspaceDetailOptions>>;
  paymentTermDueFrom?: Array<FactoryInput<PaymentTermDueFromDetail, PaymentTermDueFromDetailOptions>>;
  permit?: Array<FactoryInput<PermitDetail, PermitDetailOptions>>;
  planPackageIncomingSlotStatus?: Array<
    FactoryInput<PlanPackageIncomingSlotStatusDetail, PlanPackageIncomingSlotStatusDetailOptions>
  >;
  productOfferingStartingConfigType?: Array<
    FactoryInput<ProductOfferingStartingConfigTypeDetail, ProductOfferingStartingConfigTypeDetailOptions>
  >;
  programDataBasementConfig?: Array<
    FactoryInput<ProgramDataBasementConfigDetail, ProgramDataBasementConfigDetailOptions>
  >;
  programDataGarageConfig?: Array<FactoryInput<ProgramDataGarageConfigDetail, ProgramDataGarageConfigDetailOptions>>;
  programDataMatchState?: Array<FactoryInput<ProgramDataMatchStateDetail, ProgramDataMatchStateDetailOptions>>;
  programDataPrimaryBedroomConfig?: Array<
    FactoryInput<ProgramDataPrimaryBedroomConfigDetail, ProgramDataPrimaryBedroomConfigDetailOptions>
  >;
  programDataWindowColor?: Array<FactoryInput<ProgramDataWindowColorDetail, ProgramDataWindowColorDetailOptions>>;
  projectCollaboratorRole?: Array<FactoryInput<ProjectCollaboratorRoleDetail, ProjectCollaboratorRoleDetailOptions>>;
  projectFeature?: Array<FactoryInput<ProjectFeatureDetail, ProjectFeatureDetailOptions>>;
  projectReadyPlanConfigOrientation?: Array<
    FactoryInput<ProjectReadyPlanConfigOrientationDetail, ProjectReadyPlanConfigOrientationDetailOptions>
  >;
  projectRole?: Array<FactoryInput<ProjectRoleDetail, ProjectRoleDetailOptions>>;
  projectStageStatus?: Array<FactoryInput<ProjectStageStatusDetail, ProjectStageStatusDetailOptions>>;
  projectStatus?: Array<FactoryInput<ProjectStatusDetail, ProjectStatusDetailOptions>>;
  projectUpdateActionType?: Array<FactoryInput<ProjectUpdateActionTypeDetail, ProjectUpdateActionTypeDetailOptions>>;
  pushNotificationEnvironment?: Array<
    FactoryInput<PushNotificationEnvironmentDetail, PushNotificationEnvironmentDetailOptions>
  >;
  pushNotificationPlatform?: Array<FactoryInput<PushNotificationPlatformDetail, PushNotificationPlatformDetailOptions>>;
  readyPlanAssetType?: Array<FactoryInput<ReadyPlanAssetTypeDetail, ReadyPlanAssetTypeDetailOptions>>;
  readyPlanOptionGroupPersonalizationType?: Array<
    FactoryInput<ReadyPlanOptionGroupPersonalizationTypeDetail, ReadyPlanOptionGroupPersonalizationTypeDetailOptions>
  >;
  readyPlanStatus?: Array<FactoryInput<ReadyPlanStatusDetail, ReadyPlanStatusDetailOptions>>;
  readyPlanType?: Array<FactoryInput<ReadyPlanTypeDetail, ReadyPlanTypeDetailOptions>>;
  scheduleFlagReasonType?: Array<FactoryInput<ScheduleFlagReasonTypeDetail, ScheduleFlagReasonTypeDetailOptions>>;
  scheduleStatus?: Array<FactoryInput<ScheduleStatusDetail, ScheduleStatusDetailOptions>>;
  scheduleTemplateStatus?: Array<FactoryInput<ScheduleTemplateStatusDetail, ScheduleTemplateStatusDetailOptions>>;
  scopeChangeType?: Array<FactoryInput<ScopeChangeTypeDetail, ScopeChangeTypeDetailOptions>>;
  scopeMode?: Array<FactoryInput<ScopeModeDetail, ScopeModeDetailOptions>>;
  selectionCutoff?: Array<FactoryInput<SelectionCutoffDetail, SelectionCutoffDetailOptions>>;
  stage?: Array<FactoryInput<StageDetail, StageDetailOptions>>;
  suburbanAssetCategory?: Array<FactoryInput<SuburbanAssetCategoryDetail, SuburbanAssetCategoryDetailOptions>>;
  systemChangeRequestAsset?: Array<FactoryInput<SystemChangeRequestAssetDetail, SystemChangeRequestAssetDetailOptions>>;
  systemPlanMilestone?: Array<FactoryInput<SystemPlanMilestoneDetail, SystemPlanMilestoneDetailOptions>>;
  systemTask?: Array<FactoryInput<SystemTaskDetail, SystemTaskDetailOptions>>;
  takeoffLineItemAction?: Array<FactoryInput<TakeoffLineItemActionDetail, TakeoffLineItemActionDetailOptions>>;
  takeoffLineItemDesignPackageType?: Array<
    FactoryInput<TakeoffLineItemDesignPackageTypeDetail, TakeoffLineItemDesignPackageTypeDetailOptions>
  >;
  takeoffLineItemType?: Array<FactoryInput<TakeoffLineItemTypeDetail, TakeoffLineItemTypeDetailOptions>>;
  taskDeadlineType?: Array<FactoryInput<TaskDeadlineTypeDetail, TaskDeadlineTypeDetailOptions>>;
  taskDependencyType?: Array<FactoryInput<TaskDependencyTypeDetail, TaskDependencyTypeDetailOptions>>;
  taskStatus?: Array<FactoryInput<TaskStatusDetail, TaskStatusDetailOptions>>;
  taskType?: Array<FactoryInput<TaskTypeDetail, TaskTypeDetailOptions>>;
  timeFrequency?: Array<FactoryInput<TimeFrequencyDetail, TimeFrequencyDetailOptions>>;
  timeOfDay?: Array<FactoryInput<TimeOfDayDetail, TimeOfDayDetailOptions>>;
  toDoStatus?: Array<FactoryInput<ToDoStatusDetail, ToDoStatusDetailOptions>>;
  toDoType?: Array<FactoryInput<ToDoTypeDetail, ToDoTypeDetailOptions>>;
  trackedJobStatus?: Array<FactoryInput<TrackedJobStatusDetail, TrackedJobStatusDetailOptions>>;
  tradePartnerAvailabilityRequestStatus?: Array<
    FactoryInput<TradePartnerAvailabilityRequestStatusDetail, TradePartnerAvailabilityRequestStatusDetailOptions>
  >;
  tradePartnerMarketRole?: Array<FactoryInput<TradePartnerMarketRoleDetail, TradePartnerMarketRoleDetailOptions>>;
  tradePartnerOnboardingStatus?: Array<
    FactoryInput<TradePartnerOnboardingStatusDetail, TradePartnerOnboardingStatusDetailOptions>
  >;
  tradePartnerRequirementStatus?: Array<
    FactoryInput<TradePartnerRequirementStatusDetail, TradePartnerRequirementStatusDetailOptions>
  >;
  tradePartnerRequirementType?: Array<
    FactoryInput<TradePartnerRequirementTypeDetail, TradePartnerRequirementTypeDetailOptions>
  >;
  tradePartnerTaskStatus?: Array<FactoryInput<TradePartnerTaskStatusDetail, TradePartnerTaskStatusDetailOptions>>;
  userEventType?: Array<FactoryInput<UserEventTypeDetail, UserEventTypeDetailOptions>>;
  userType?: Array<FactoryInput<UserTypeDetail, UserTypeDetailOptions>>;
  verificationMethod?: Array<FactoryInput<VerificationMethodDetail, VerificationMethodDetailOptions>>;
  warrantyTicketItemStatus?: Array<FactoryInput<WarrantyTicketItemStatusDetail, WarrantyTicketItemStatusDetailOptions>>;
  warrantyTicketItemType?: Array<FactoryInput<WarrantyTicketItemTypeDetail, WarrantyTicketItemTypeDetailOptions>>;
  warrantyTicketStatus?: Array<FactoryInput<WarrantyTicketStatusDetail, WarrantyTicketStatusDetailOptions>>;
  warrantyTicketType?: Array<FactoryInput<WarrantyTicketTypeDetail, WarrantyTicketTypeDetailOptions>>;
  warrantyTrueUpType?: Array<FactoryInput<WarrantyTrueUpTypeDetail, WarrantyTrueUpTypeDetailOptions>>;
  weatherType?: Array<FactoryInput<WeatherTypeDetail, WeatherTypeDetailOptions>>;
}

export function newAllEnumDetails(
  options?: AllEnumDetailsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AllEnumDetails>;
export function newAllEnumDetails(
  options: AllEnumDetailsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AllEnumDetails> {
  const o = (options.__typename ? options : cache["AllEnumDetails"] = {}) as AllEnumDetails;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AllEnumDetails";
    o.activityPlanningState = (options.activityPlanningState ?? []).map((i) => enumOrDetailOfActivityPlanningState(i));
    o.activityResponsibility = (options.activityResponsibility ?? []).map((i) =>
      enumOrDetailOfActivityResponsibility(i)
    );
    o.activityType = (options.activityType ?? []).map((i) => enumOrDetailOfActivityType(i));
    o.aggregateVersionStatus = (options.aggregateVersionStatus ?? []).map((i) =>
      enumOrDetailOfAggregateVersionStatus(i)
    );
    o.aiDataConfidence = (options.aiDataConfidence ?? []).map((i) => enumOrDetailOfAiDataConfidence(i));
    o.aiEntityProposalEntityType = (options.aiEntityProposalEntityType ?? []).map((i) =>
      enumOrDetailOfAiEntityProposalEntityType(i)
    );
    o.aiEntityProposalType = (options.aiEntityProposalType ?? []).map((i) => enumOrDetailOfAiEntityProposalType(i));
    o.aiFieldProposalStatus = (options.aiFieldProposalStatus ?? []).map((i) => enumOrDetailOfAiFieldProposalStatus(i));
    o.aiProposalStatus = (options.aiProposalStatus ?? []).map((i) => enumOrDetailOfAiProposalStatus(i));
    o.aiProposalType = (options.aiProposalType ?? []).map((i) => enumOrDetailOfAiProposalType(i));
    o.allocationStrategy = (options.allocationStrategy ?? []).map((i) => enumOrDetailOfAllocationStrategy(i));
    o.approvalStatus = (options.approvalStatus ?? []).map((i) => enumOrDetailOfApprovalStatus(i));
    o.approverStatus = (options.approverStatus ?? []).map((i) => enumOrDetailOfApproverStatus(i));
    o.bidContractRevisionStatus = (options.bidContractRevisionStatus ?? []).map((i) =>
      enumOrDetailOfBidContractRevisionStatus(i)
    );
    o.bidContractType = (options.bidContractType ?? []).map((i) => enumOrDetailOfBidContractType(i));
    o.bidPackageStatus = (options.bidPackageStatus ?? []).map((i) => enumOrDetailOfBidPackageStatus(i));
    o.billGmailAttachmentResult = (options.billGmailAttachmentResult ?? []).map((i) =>
      enumOrDetailOfBillGmailAttachmentResult(i)
    );
    o.billGmailMessageResult = (options.billGmailMessageResult ?? []).map((i) =>
      enumOrDetailOfBillGmailMessageResult(i)
    );
    o.billReviewReason = (options.billReviewReason ?? []).map((i) => enumOrDetailOfBillReviewReason(i));
    o.billSource = (options.billSource ?? []).map((i) => enumOrDetailOfBillSource(i));
    o.billStatus = (options.billStatus ?? []).map((i) => enumOrDetailOfBillStatus(i));
    o.billType = (options.billType ?? []).map((i) => enumOrDetailOfBillType(i));
    o.businessFunctionType = (options.businessFunctionType ?? []).map((i) => enumOrDetailOfBusinessFunctionType(i));
    o.buyoutStatus = (options.buyoutStatus ?? []).map((i) => enumOrDetailOfBuyoutStatus(i));
    o.changeEventBudgetPhase = (options.changeEventBudgetPhase ?? []).map((i) =>
      enumOrDetailOfChangeEventBudgetPhase(i)
    );
    o.changeEventLineItemType = (options.changeEventLineItemType ?? []).map((i) =>
      enumOrDetailOfChangeEventLineItemType(i)
    );
    o.changeEventStatus = (options.changeEventStatus ?? []).map((i) => enumOrDetailOfChangeEventStatus(i));
    o.changeEventType = (options.changeEventType ?? []).map((i) => enumOrDetailOfChangeEventType(i));
    o.changeEventWorkflow = (options.changeEventWorkflow ?? []).map((i) => enumOrDetailOfChangeEventWorkflow(i));
    o.changeRequestAssetPlatform = (options.changeRequestAssetPlatform ?? []).map((i) =>
      enumOrDetailOfChangeRequestAssetPlatform(i)
    );
    o.changeRequestAssetScope = (options.changeRequestAssetScope ?? []).map((i) =>
      enumOrDetailOfChangeRequestAssetScope(i)
    );
    o.changeRequestPriority = (options.changeRequestPriority ?? []).map((i) => enumOrDetailOfChangeRequestPriority(i));
    o.changeRequestSource = (options.changeRequestSource ?? []).map((i) => enumOrDetailOfChangeRequestSource(i));
    o.changeRequestStatus = (options.changeRequestStatus ?? []).map((i) => enumOrDetailOfChangeRequestStatus(i));
    o.changeRequestToDoType = (options.changeRequestToDoType ?? []).map((i) => enumOrDetailOfChangeRequestToDoType(i));
    o.changeType = (options.changeType ?? []).map((i) => enumOrDetailOfChangeType(i));
    o.checkoutConfigOptionGroupStep = (options.checkoutConfigOptionGroupStep ?? []).map((i) =>
      enumOrDetailOfCheckoutConfigOptionGroupStep(i)
    );
    o.checkoutConfigStatus = (options.checkoutConfigStatus ?? []).map((i) => enumOrDetailOfCheckoutConfigStatus(i));
    o.clientPlatform = (options.clientPlatform ?? []).map((i) => enumOrDetailOfClientPlatform(i));
    o.commentStreamVisibility = (options.commentStreamVisibility ?? []).map((i) =>
      enumOrDetailOfCommentStreamVisibility(i)
    );
    o.commitmentStatus = (options.commitmentStatus ?? []).map((i) => enumOrDetailOfCommitmentStatus(i));
    o.commitmentType = (options.commitmentType ?? []).map((i) => enumOrDetailOfCommitmentType(i));
    o.communicationChannel = (options.communicationChannel ?? []).map((i) => enumOrDetailOfCommunicationChannel(i));
    o.communityType = (options.communityType ?? []).map((i) => enumOrDetailOfCommunityType(i));
    o.constructionType = (options.constructionType ?? []).map((i) => enumOrDetailOfConstructionType(i));
    o.contractType = (options.contractType ?? []).map((i) => enumOrDetailOfContractType(i));
    o.costClassificationType = (options.costClassificationType ?? []).map((i) =>
      enumOrDetailOfCostClassificationType(i)
    );
    o.costCodeBidSummaryFlag = (options.costCodeBidSummaryFlag ?? []).map((i) =>
      enumOrDetailOfCostCodeBidSummaryFlag(i)
    );
    o.costCodeBidSummaryStatus = (options.costCodeBidSummaryStatus ?? []).map((i) =>
      enumOrDetailOfCostCodeBidSummaryStatus(i)
    );
    o.costCodeInvoiceCategory = (options.costCodeInvoiceCategory ?? []).map((i) =>
      enumOrDetailOfCostCodeInvoiceCategory(i)
    );
    o.costConfidence = (options.costConfidence ?? []).map((i) => enumOrDetailOfCostConfidence(i));
    o.costSubClassificationType = (options.costSubClassificationType ?? []).map((i) =>
      enumOrDetailOfCostSubClassificationType(i)
    );
    o.costType = (options.costType ?? []).map((i) => enumOrDetailOfCostType(i));
    o.dayOfWeek = (options.dayOfWeek ?? []).map((i) => enumOrDetailOfDayOfWeek(i));
    o.designPackageLocation = (options.designPackageLocation ?? []).map((i) => enumOrDetailOfDesignPackageLocation(i));
    o.developmentCommitmentType = (options.developmentCommitmentType ?? []).map((i) =>
      enumOrDetailOfDevelopmentCommitmentType(i)
    );
    o.documentAttachmentPlace = (options.documentAttachmentPlace ?? []).map((i) =>
      enumOrDetailOfDocumentAttachmentPlace(i)
    );
    o.documentCategory = (options.documentCategory ?? []).map((i) => enumOrDetailOfDocumentCategory(i));
    o.documentType = (options.documentType ?? []).map((i) => enumOrDetailOfDocumentType(i));
    o.erpAccrualType = (options.erpAccrualType ?? []).map((i) => enumOrDetailOfErpAccrualType(i));
    o.erpRevenueLineItemSourceEvent = (options.erpRevenueLineItemSourceEvent ?? []).map((i) =>
      enumOrDetailOfErpRevenueLineItemSourceEvent(i)
    );
    o.erpTransactionGroupEvent = (options.erpTransactionGroupEvent ?? []).map((i) =>
      enumOrDetailOfErpTransactionGroupEvent(i)
    );
    o.erpTransactionGroupStatus = (options.erpTransactionGroupStatus ?? []).map((i) =>
      enumOrDetailOfErpTransactionGroupStatus(i)
    );
    o.erpTransactionStatus = (options.erpTransactionStatus ?? []).map((i) => enumOrDetailOfErpTransactionStatus(i));
    o.estimateStatus = (options.estimateStatus ?? []).map((i) => enumOrDetailOfEstimateStatus(i));
    o.estimateType = (options.estimateType ?? []).map((i) => enumOrDetailOfEstimateType(i));
    o.featureFlagStatus = (options.featureFlagStatus ?? []).map((i) => enumOrDetailOfFeatureFlagStatus(i));
    o.featureFlagType = (options.featureFlagType ?? []).map((i) => enumOrDetailOfFeatureFlagType(i));
    o.finishScheduleColumnType = (options.finishScheduleColumnType ?? []).map((i) =>
      enumOrDetailOfFinishScheduleColumnType(i)
    );
    o.finishScheduleCoreColumn = (options.finishScheduleCoreColumn ?? []).map((i) =>
      enumOrDetailOfFinishScheduleCoreColumn(i)
    );
    o.floodPlain = (options.floodPlain ?? []).map((i) => enumOrDetailOfFloodPlain(i));
    o.floodZone = (options.floodZone ?? []).map((i) => enumOrDetailOfFloodZone(i));
    o.foundationType = (options.foundationType ?? []).map((i) => enumOrDetailOfFoundationType(i));
    o.globalOptionStatus = (options.globalOptionStatus ?? []).map((i) => enumOrDetailOfGlobalOptionStatus(i));
    o.globalOptionTypeStatus = (options.globalOptionTypeStatus ?? []).map((i) =>
      enumOrDetailOfGlobalOptionTypeStatus(i)
    );
    o.globalPlanMilestoneType = (options.globalPlanMilestoneType ?? []).map((i) =>
      enumOrDetailOfGlobalPlanMilestoneType(i)
    );
    o.inboxItemStatus = (options.inboxItemStatus ?? []).map((i) => enumOrDetailOfInboxItemStatus(i));
    o.internalEstimateType = (options.internalEstimateType ?? []).map((i) => enumOrDetailOfInternalEstimateType(i));
    o.invoiceDocumentSource = (options.invoiceDocumentSource ?? []).map((i) => enumOrDetailOfInvoiceDocumentSource(i));
    o.invoiceScheduleAmountType = (options.invoiceScheduleAmountType ?? []).map((i) =>
      enumOrDetailOfInvoiceScheduleAmountType(i)
    );
    o.invoiceScheduleItemFrequency = (options.invoiceScheduleItemFrequency ?? []).map((i) =>
      enumOrDetailOfInvoiceScheduleItemFrequency(i)
    );
    o.invoiceScheduleTriggerType = (options.invoiceScheduleTriggerType ?? []).map((i) =>
      enumOrDetailOfInvoiceScheduleTriggerType(i)
    );
    o.invoiceSource = (options.invoiceSource ?? []).map((i) => enumOrDetailOfInvoiceSource(i));
    o.invoiceStatus = (options.invoiceStatus ?? []).map((i) => enumOrDetailOfInvoiceStatus(i));
    o.invoiceType = (options.invoiceType ?? []).map((i) => enumOrDetailOfInvoiceType(i));
    o.itemStatus = (options.itemStatus ?? []).map((i) => enumOrDetailOfItemStatus(i));
    o.itemTemplateItemCostStatus = (options.itemTemplateItemCostStatus ?? []).map((i) =>
      enumOrDetailOfItemTemplateItemCostStatus(i)
    );
    o.itemTemplateStatus = (options.itemTemplateStatus ?? []).map((i) => enumOrDetailOfItemTemplateStatus(i));
    o.jobLogFlag = (options.jobLogFlag ?? []).map((i) => enumOrDetailOfJobLogFlag(i));
    o.jobLogNoteType = (options.jobLogNoteType ?? []).map((i) => enumOrDetailOfJobLogNoteType(i));
    o.lienWaiverCondition = (options.lienWaiverCondition ?? []).map((i) => enumOrDetailOfLienWaiverCondition(i));
    o.lienWaiverStatus = (options.lienWaiverStatus ?? []).map((i) => enumOrDetailOfLienWaiverStatus(i));
    o.lienWaiverType = (options.lienWaiverType ?? []).map((i) => enumOrDetailOfLienWaiverType(i));
    o.locationType = (options.locationType ?? []).map((i) => enumOrDetailOfLocationType(i));
    o.lotSalesStatus = (options.lotSalesStatus ?? []).map((i) => enumOrDetailOfLotSalesStatus(i));
    o.lotType = (options.lotType ?? []).map((i) => enumOrDetailOfLotType(i));
    o.markupApplicationMethod = (options.markupApplicationMethod ?? []).map((i) =>
      enumOrDetailOfMarkupApplicationMethod(i)
    );
    o.materialAttributeDimensionType = (options.materialAttributeDimensionType ?? []).map((i) =>
      enumOrDetailOfMaterialAttributeDimensionType(i)
    );
    o.materialAttributeValueType = (options.materialAttributeValueType ?? []).map((i) =>
      enumOrDetailOfMaterialAttributeValueType(i)
    );
    o.materialType = (options.materialType ?? []).map((i) => enumOrDetailOfMaterialType(i));
    o.mobileSyncUpdateType = (options.mobileSyncUpdateType ?? []).map((i) => enumOrDetailOfMobileSyncUpdateType(i));
    o.pandaDocRole = (options.pandaDocRole ?? []).map((i) => enumOrDetailOfPandaDocRole(i));
    o.pandaDocStatus = (options.pandaDocStatus ?? []).map((i) => enumOrDetailOfPandaDocStatus(i));
    o.pandaDocWorkspace = (options.pandaDocWorkspace ?? []).map((i) => enumOrDetailOfPandaDocWorkspace(i));
    o.paymentTermDueFrom = (options.paymentTermDueFrom ?? []).map((i) => enumOrDetailOfPaymentTermDueFrom(i));
    o.permit = (options.permit ?? []).map((i) => enumOrDetailOfPermit(i));
    o.planPackageIncomingSlotStatus = (options.planPackageIncomingSlotStatus ?? []).map((i) =>
      enumOrDetailOfPlanPackageIncomingSlotStatus(i)
    );
    o.productOfferingStartingConfigType = (options.productOfferingStartingConfigType ?? []).map((i) =>
      enumOrDetailOfProductOfferingStartingConfigType(i)
    );
    o.programDataBasementConfig = (options.programDataBasementConfig ?? []).map((i) =>
      enumOrDetailOfProgramDataBasementConfig(i)
    );
    o.programDataGarageConfig = (options.programDataGarageConfig ?? []).map((i) =>
      enumOrDetailOfProgramDataGarageConfig(i)
    );
    o.programDataMatchState = (options.programDataMatchState ?? []).map((i) => enumOrDetailOfProgramDataMatchState(i));
    o.programDataPrimaryBedroomConfig = (options.programDataPrimaryBedroomConfig ?? []).map((i) =>
      enumOrDetailOfProgramDataPrimaryBedroomConfig(i)
    );
    o.programDataWindowColor = (options.programDataWindowColor ?? []).map((i) =>
      enumOrDetailOfProgramDataWindowColor(i)
    );
    o.projectCollaboratorRole = (options.projectCollaboratorRole ?? []).map((i) =>
      enumOrDetailOfProjectCollaboratorRole(i)
    );
    o.projectFeature = (options.projectFeature ?? []).map((i) => enumOrDetailOfProjectFeature(i));
    o.projectReadyPlanConfigOrientation = (options.projectReadyPlanConfigOrientation ?? []).map((i) =>
      enumOrDetailOfProjectReadyPlanConfigOrientation(i)
    );
    o.projectRole = (options.projectRole ?? []).map((i) => enumOrDetailOfProjectRole(i));
    o.projectStageStatus = (options.projectStageStatus ?? []).map((i) => enumOrDetailOfProjectStageStatus(i));
    o.projectStatus = (options.projectStatus ?? []).map((i) => enumOrDetailOfProjectStatus(i));
    o.projectUpdateActionType = (options.projectUpdateActionType ?? []).map((i) =>
      enumOrDetailOfProjectUpdateActionType(i)
    );
    o.pushNotificationEnvironment = (options.pushNotificationEnvironment ?? []).map((i) =>
      enumOrDetailOfPushNotificationEnvironment(i)
    );
    o.pushNotificationPlatform = (options.pushNotificationPlatform ?? []).map((i) =>
      enumOrDetailOfPushNotificationPlatform(i)
    );
    o.readyPlanAssetType = (options.readyPlanAssetType ?? []).map((i) => enumOrDetailOfReadyPlanAssetType(i));
    o.readyPlanOptionGroupPersonalizationType = (options.readyPlanOptionGroupPersonalizationType ?? []).map((i) =>
      enumOrDetailOfReadyPlanOptionGroupPersonalizationType(i)
    );
    o.readyPlanStatus = (options.readyPlanStatus ?? []).map((i) => enumOrDetailOfReadyPlanStatus(i));
    o.readyPlanType = (options.readyPlanType ?? []).map((i) => enumOrDetailOfReadyPlanType(i));
    o.scheduleFlagReasonType = (options.scheduleFlagReasonType ?? []).map((i) =>
      enumOrDetailOfScheduleFlagReasonType(i)
    );
    o.scheduleStatus = (options.scheduleStatus ?? []).map((i) => enumOrDetailOfScheduleStatus(i));
    o.scheduleTemplateStatus = (options.scheduleTemplateStatus ?? []).map((i) =>
      enumOrDetailOfScheduleTemplateStatus(i)
    );
    o.scopeChangeType = (options.scopeChangeType ?? []).map((i) => enumOrDetailOfScopeChangeType(i));
    o.scopeMode = (options.scopeMode ?? []).map((i) => enumOrDetailOfScopeMode(i));
    o.selectionCutoff = (options.selectionCutoff ?? []).map((i) => enumOrDetailOfSelectionCutoff(i));
    o.stage = (options.stage ?? []).map((i) => enumOrDetailOfStage(i));
    o.suburbanAssetCategory = (options.suburbanAssetCategory ?? []).map((i) => enumOrDetailOfSuburbanAssetCategory(i));
    o.systemChangeRequestAsset = (options.systemChangeRequestAsset ?? []).map((i) =>
      enumOrDetailOfSystemChangeRequestAsset(i)
    );
    o.systemPlanMilestone = (options.systemPlanMilestone ?? []).map((i) => enumOrDetailOfSystemPlanMilestone(i));
    o.systemTask = (options.systemTask ?? []).map((i) => enumOrDetailOfSystemTask(i));
    o.takeoffLineItemAction = (options.takeoffLineItemAction ?? []).map((i) => enumOrDetailOfTakeoffLineItemAction(i));
    o.takeoffLineItemDesignPackageType = (options.takeoffLineItemDesignPackageType ?? []).map((i) =>
      enumOrDetailOfTakeoffLineItemDesignPackageType(i)
    );
    o.takeoffLineItemType = (options.takeoffLineItemType ?? []).map((i) => enumOrDetailOfTakeoffLineItemType(i));
    o.taskDeadlineType = (options.taskDeadlineType ?? []).map((i) => enumOrDetailOfTaskDeadlineType(i));
    o.taskDependencyType = (options.taskDependencyType ?? []).map((i) => enumOrDetailOfTaskDependencyType(i));
    o.taskStatus = (options.taskStatus ?? []).map((i) => enumOrDetailOfTaskStatus(i));
    o.taskType = (options.taskType ?? []).map((i) => enumOrDetailOfTaskType(i));
    o.timeFrequency = (options.timeFrequency ?? []).map((i) => enumOrDetailOfTimeFrequency(i));
    o.timeOfDay = (options.timeOfDay ?? []).map((i) => enumOrDetailOfTimeOfDay(i));
    o.toDoStatus = (options.toDoStatus ?? []).map((i) => enumOrDetailOfToDoStatus(i));
    o.toDoType = (options.toDoType ?? []).map((i) => enumOrDetailOfToDoType(i));
    o.trackedJobStatus = (options.trackedJobStatus ?? []).map((i) => enumOrDetailOfTrackedJobStatus(i));
    o.tradePartnerAvailabilityRequestStatus = (options.tradePartnerAvailabilityRequestStatus ?? []).map((i) =>
      enumOrDetailOfTradePartnerAvailabilityRequestStatus(i)
    );
    o.tradePartnerMarketRole = (options.tradePartnerMarketRole ?? []).map((i) =>
      enumOrDetailOfTradePartnerMarketRole(i)
    );
    o.tradePartnerOnboardingStatus = (options.tradePartnerOnboardingStatus ?? []).map((i) =>
      enumOrDetailOfTradePartnerOnboardingStatus(i)
    );
    o.tradePartnerRequirementStatus = (options.tradePartnerRequirementStatus ?? []).map((i) =>
      enumOrDetailOfTradePartnerRequirementStatus(i)
    );
    o.tradePartnerRequirementType = (options.tradePartnerRequirementType ?? []).map((i) =>
      enumOrDetailOfTradePartnerRequirementType(i)
    );
    o.tradePartnerTaskStatus = (options.tradePartnerTaskStatus ?? []).map((i) =>
      enumOrDetailOfTradePartnerTaskStatus(i)
    );
    o.userEventType = (options.userEventType ?? []).map((i) => enumOrDetailOfUserEventType(i));
    o.userType = (options.userType ?? []).map((i) => enumOrDetailOfUserType(i));
    o.verificationMethod = (options.verificationMethod ?? []).map((i) => enumOrDetailOfVerificationMethod(i));
    o.warrantyTicketItemStatus = (options.warrantyTicketItemStatus ?? []).map((i) =>
      enumOrDetailOfWarrantyTicketItemStatus(i)
    );
    o.warrantyTicketItemType = (options.warrantyTicketItemType ?? []).map((i) =>
      enumOrDetailOfWarrantyTicketItemType(i)
    );
    o.warrantyTicketStatus = (options.warrantyTicketStatus ?? []).map((i) => enumOrDetailOfWarrantyTicketStatus(i));
    o.warrantyTicketType = (options.warrantyTicketType ?? []).map((i) => enumOrDetailOfWarrantyTicketType(i));
    o.warrantyTrueUpType = (options.warrantyTrueUpType ?? []).map((i) => enumOrDetailOfWarrantyTrueUpType(i));
    o.weatherType = (options.weatherType ?? []).map((i) => enumOrDetailOfWeatherType(i));
    return o as FactoryResult<AllEnumDetails>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AllEnumDetails"] = newAllEnumDetails;

export interface IdentifyProjectAccrualAdjustmentsResultOptions {
  __typename?: "IdentifyProjectAccrualAdjustmentsResult";
  type?: IdentifyProjectAccrualAdjustmentsResult["type"];
  commitmentLineItem?: FactoryInput<CommitmentLineItem, CommitmentLineItemOptions>;
  commitmentLikeReference?: IdentifyProjectAccrualAdjustmentsResult["commitmentLikeReference"];
  adjustInCents?: IdentifyProjectAccrualAdjustmentsResult["adjustInCents"];
  intacctVendorId?: IdentifyProjectAccrualAdjustmentsResult["intacctVendorId"];
  intacctGLAccountNo?: IdentifyProjectAccrualAdjustmentsResult["intacctGLAccountNo"];
  intacctProjectId?: IdentifyProjectAccrualAdjustmentsResult["intacctProjectId"];
  intacctItemId?: IdentifyProjectAccrualAdjustmentsResult["intacctItemId"];
  intacctCustomerId?: IdentifyProjectAccrualAdjustmentsResult["intacctCustomerId"];
  intacctLocationId?: IdentifyProjectAccrualAdjustmentsResult["intacctLocationId"];
}

export function newIdentifyProjectAccrualAdjustmentsResult(
  options?: IdentifyProjectAccrualAdjustmentsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<IdentifyProjectAccrualAdjustmentsResult>;
export function newIdentifyProjectAccrualAdjustmentsResult(
  options: IdentifyProjectAccrualAdjustmentsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<IdentifyProjectAccrualAdjustmentsResult> {
  const o =
    (options.__typename
      ? options
      : cache["IdentifyProjectAccrualAdjustmentsResult"] = {}) as IdentifyProjectAccrualAdjustmentsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "IdentifyProjectAccrualAdjustmentsResult";
    o.type = options.type ?? CostAccrualAdjustmentType.TaskWithOverbilled;
    o.commitmentLineItem = maybeNew(
      "CommitmentLineItem",
      options.commitmentLineItem,
      cache,
      options.hasOwnProperty("commitmentLineItem"),
    );
    o.commitmentLikeReference = options.commitmentLikeReference ?? "commitmentLikeReference";
    o.adjustInCents = options.adjustInCents ?? 0;
    o.intacctVendorId = options.intacctVendorId ?? "intacctVendorId";
    o.intacctGLAccountNo = options.intacctGLAccountNo ?? "intacctGLAccountNo";
    o.intacctProjectId = options.intacctProjectId ?? "intacctProjectId";
    o.intacctItemId = options.intacctItemId ?? "intacctItemId";
    o.intacctCustomerId = options.intacctCustomerId ?? "intacctCustomerId";
    o.intacctLocationId = options.intacctLocationId ?? "intacctLocationId";
    return o as FactoryResult<IdentifyProjectAccrualAdjustmentsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["IdentifyProjectAccrualAdjustmentsResult"] = newIdentifyProjectAccrualAdjustmentsResult;

export interface SaveEstimateResultOptions {
  __typename?: "SaveEstimateResult";
  estimate?: FactoryInput<Estimate, EstimateOptions>;
}

export function newSaveEstimateResult(
  options?: SaveEstimateResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveEstimateResult>;
export function newSaveEstimateResult(
  options: SaveEstimateResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveEstimateResult> {
  const o = (options.__typename ? options : cache["SaveEstimateResult"] = {}) as SaveEstimateResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveEstimateResult";
    o.estimate = maybeNew("Estimate", options.estimate, cache, options.hasOwnProperty("estimate"));
    return o as FactoryResult<SaveEstimateResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveEstimateResult"] = newSaveEstimateResult;

export interface AnnotatedCostOptions {
  __typename?: "AnnotatedCost";
  item?: FactoryInput<Item, ItemOptions>;
  totalPriceInCents?: AnnotatedCost["totalPriceInCents"];
}

export function newAnnotatedCost(
  options?: AnnotatedCostOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AnnotatedCost>;
export function newAnnotatedCost(
  options: AnnotatedCostOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AnnotatedCost> {
  const o = (options.__typename ? options : cache["AnnotatedCost"] = {}) as AnnotatedCost;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AnnotatedCost";
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    return o as FactoryResult<AnnotatedCost>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AnnotatedCost"] = newAnnotatedCost;

export interface EstimateLineItemOptions {
  __typename?: "EstimateLineItem";
  id?: EstimateLineItem["id"];
  quantity?: EstimateLineItem["quantity"];
  estimate?: FactoryInput<Estimate, EstimateOptions>;
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  projectItemHasDiverged?: EstimateLineItem["projectItemHasDiverged"];
  isPlaceholder?: EstimateLineItem["isPlaceholder"];
  unitCostInCents?: EstimateLineItem["unitCostInCents"];
  unitPriceInCents?: EstimateLineItem["unitPriceInCents"];
  totalCostInCents?: EstimateLineItem["totalCostInCents"];
  totalPriceInCents?: EstimateLineItem["totalPriceInCents"];
  changeEventLineItem?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions> | null;
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  displayName?: EstimateLineItem["displayName"];
}

export function newEstimateLineItem(
  options?: EstimateLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<EstimateLineItem>;
export function newEstimateLineItem(
  options: EstimateLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<EstimateLineItem> {
  const o = (options.__typename ? options : cache["EstimateLineItem"] = {}) as EstimateLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "EstimateLineItem";
    o.id = options.id ?? nextFactoryId("EstimateLineItem");
    o.quantity = options.quantity ?? null;
    o.estimate = maybeNew("Estimate", options.estimate, cache, options.hasOwnProperty("estimate"));
    o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
    o.projectItemHasDiverged = options.projectItemHasDiverged ?? false;
    o.isPlaceholder = options.isPlaceholder ?? false;
    o.unitCostInCents = options.unitCostInCents ?? 0;
    o.unitPriceInCents = options.unitPriceInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.displayName = options.displayName ?? "displayName";
    return o as FactoryResult<EstimateLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["EstimateLineItem"] = newEstimateLineItem;

export interface ExpenseOptions {
  __typename?: "Expense";
  id?: Expense["id"];
  amountInCents?: Expense["amountInCents"];
  unallocatedAmountInCents?: Expense["unallocatedAmountInCents"];
  expenseDate?: Expense["expenseDate"];
  dueDate?: Expense["dueDate"];
  description?: Expense["description"];
  createdAt?: Expense["createdAt"];
  updatedAt?: Expense["updatedAt"];
  costCode?: FactoryInput<CostCode, CostCodeOptions> | null;
  intacctApBillId?: Expense["intacctApBillId"];
  intacctApBillLineId?: Expense["intacctApBillLineId"];
  intacctItemId?: Expense["intacctItemId"];
  intacctVendorName?: Expense["intacctVendorName"];
  intacctVendorBlueprintId?: Expense["intacctVendorBlueprintId"];
  amountPaidInCents?: Expense["amountPaidInCents"];
  stage?: StageDetailOptions | Stage;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  potentialProjectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
  intacctVendorId?: Expense["intacctVendorId"];
  document?: FactoryInput<Document, DocumentOptions> | null;
  allocations?: Array<FactoryInput<ExpenseAllocation, ExpenseAllocationOptions>>;
  changeEvents?: Array<FactoryInput<ChangeEvent, ChangeEventOptions>>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  tradeNumber?: Expense["tradeNumber"];
  allLineItemsAreExpenses?: Expense["allLineItemsAreExpenses"];
  canBeConvertedToBill?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  isBrex?: Expense["isBrex"];
}

export function newExpense(options?: ExpenseOptions, factoryOptions?: FactoryOptions): FactoryResult<Expense>;
export function newExpense(
  options: ExpenseOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Expense> {
  const o = (options.__typename ? options : cache["Expense"] = {}) as Expense;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Expense";
    o.id = options.id ?? nextFactoryId("Expense");
    o.amountInCents = options.amountInCents ?? 0;
    o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
    o.expenseDate = options.expenseDate ?? newDate();
    o.dueDate = options.dueDate ?? null;
    o.description = options.description ?? "description";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costCode = maybeNewOrNull("CostCode", options.costCode, cache);
    o.intacctApBillId = options.intacctApBillId ?? "intacctApBillId";
    o.intacctApBillLineId = options.intacctApBillLineId ?? "intacctApBillLineId";
    o.intacctItemId = options.intacctItemId ?? "intacctItemId";
    o.intacctVendorName = options.intacctVendorName ?? "intacctVendorName";
    o.intacctVendorBlueprintId = options.intacctVendorBlueprintId ?? null;
    o.amountPaidInCents = options.amountPaidInCents ?? 0;
    o.stage = enumOrDetailOfStage(options.stage);
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.potentialProjectItems = (options.potentialProjectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("potentialProjectItems"))
    );
    o.intacctVendorId = options.intacctVendorId ?? "intacctVendorId";
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.allocations = (options.allocations ?? []).map((i) =>
      maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("allocations"))
    );
    o.changeEvents = (options.changeEvents ?? []).map((i) =>
      maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
    );
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.tradeNumber = options.tradeNumber ?? null;
    o.allLineItemsAreExpenses = options.allLineItemsAreExpenses ?? false;
    o.canBeConvertedToBill = maybeNew(
      "PotentialOperation2",
      options.canBeConvertedToBill,
      cache,
      options.hasOwnProperty("canBeConvertedToBill"),
    );
    o.isBrex = options.isBrex ?? false;
    return o as FactoryResult<Expense>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Expense"] = newExpense;

export interface SaveExpensesResultOptions {
  __typename?: "SaveExpensesResult";
  expenses?: Array<FactoryInput<Expense, ExpenseOptions>>;
}

export function newSaveExpensesResult(
  options?: SaveExpensesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveExpensesResult>;
export function newSaveExpensesResult(
  options: SaveExpensesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveExpensesResult> {
  const o = (options.__typename ? options : cache["SaveExpensesResult"] = {}) as SaveExpensesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveExpensesResult";
    o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
    return o as FactoryResult<SaveExpensesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveExpensesResult"] = newSaveExpensesResult;

export interface ConvertExpenseToBillResultOptions {
  __typename?: "ConvertExpenseToBillResult";
  bill?: FactoryInput<Bill, BillOptions>;
}

export function newConvertExpenseToBillResult(
  options?: ConvertExpenseToBillResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ConvertExpenseToBillResult>;
export function newConvertExpenseToBillResult(
  options: ConvertExpenseToBillResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ConvertExpenseToBillResult> {
  const o = (options.__typename ? options : cache["ConvertExpenseToBillResult"] = {}) as ConvertExpenseToBillResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ConvertExpenseToBillResult";
    o.bill = maybeNew("Bill", options.bill, cache, options.hasOwnProperty("bill"));
    return o as FactoryResult<ConvertExpenseToBillResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ConvertExpenseToBillResult"] = newConvertExpenseToBillResult;

export interface ExpensesPageOptions {
  __typename?: "ExpensesPage";
  entities?: Array<FactoryInput<Expense, ExpenseOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newExpensesPage(
  options?: ExpensesPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ExpensesPage>;
export function newExpensesPage(
  options: ExpensesPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ExpensesPage> {
  const o = (options.__typename ? options : cache["ExpensesPage"] = {}) as ExpensesPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ExpensesPage";
    o.entities = (options.entities ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("entities")));
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ExpensesPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ExpensesPage"] = newExpensesPage;

export interface ExpenseAllocationOptions {
  __typename?: "ExpenseAllocation";
  id?: ExpenseAllocation["id"];
  amountInCents?: ExpenseAllocation["amountInCents"];
  paidAmountInCents?: ExpenseAllocation["paidAmountInCents"];
  createdAt?: ExpenseAllocation["createdAt"];
  updatedAt?: ExpenseAllocation["updatedAt"];
  expense?: FactoryInput<Expense, ExpenseOptions>;
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  historicExpenseAmountInvoiced?: ExpenseAllocation["historicExpenseAmountInvoiced"];
  costLineItemAllocations?: Array<FactoryInput<CostLineItemAllocation, CostLineItemAllocationOptions>>;
  commitmentLineItem?: FactoryInput<CommitmentLineItem, CommitmentLineItemOptions> | null;
  invoiceAccruedLineItems?: Array<FactoryInput<InvoiceAccruedLineItem, InvoiceAccruedLineItemOptions>>;
  allocations?: Array<FactoryInput<ExpenseAllocationAllocation, ExpenseAllocationAllocationOptions>>;
}

export function newExpenseAllocation(
  options?: ExpenseAllocationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ExpenseAllocation>;
export function newExpenseAllocation(
  options: ExpenseAllocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ExpenseAllocation> {
  const o = (options.__typename ? options : cache["ExpenseAllocation"] = {}) as ExpenseAllocation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ExpenseAllocation";
    o.id = options.id ?? nextFactoryId("ExpenseAllocation");
    o.amountInCents = options.amountInCents ?? 0;
    o.paidAmountInCents = options.paidAmountInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.expense = maybeNew("Expense", options.expense, cache, options.hasOwnProperty("expense"));
    o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
    o.historicExpenseAmountInvoiced = options.historicExpenseAmountInvoiced ?? null;
    o.costLineItemAllocations = (options.costLineItemAllocations ?? []).map((i) =>
      maybeNew("CostLineItemAllocation", i, cache, options.hasOwnProperty("costLineItemAllocations"))
    );
    o.commitmentLineItem = maybeNewOrNull("CommitmentLineItem", options.commitmentLineItem, cache);
    o.invoiceAccruedLineItems = (options.invoiceAccruedLineItems ?? []).map((i) =>
      maybeNew("InvoiceAccruedLineItem", i, cache, options.hasOwnProperty("invoiceAccruedLineItems"))
    );
    o.allocations = (options.allocations ?? []).map((i) =>
      maybeNew("ExpenseAllocationAllocation", i, cache, options.hasOwnProperty("allocations"))
    );
    return o as FactoryResult<ExpenseAllocation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ExpenseAllocation"] = newExpenseAllocation;

export interface SaveExpenseAllocationsResultOptions {
  __typename?: "SaveExpenseAllocationsResult";
  expenseAllocations?: Array<FactoryInput<ExpenseAllocation, ExpenseAllocationOptions>>;
}

export function newSaveExpenseAllocationsResult(
  options?: SaveExpenseAllocationsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveExpenseAllocationsResult>;
export function newSaveExpenseAllocationsResult(
  options: SaveExpenseAllocationsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveExpenseAllocationsResult> {
  const o = (options.__typename ? options : cache["SaveExpenseAllocationsResult"] = {}) as SaveExpenseAllocationsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveExpenseAllocationsResult";
    o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
      maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
    );
    return o as FactoryResult<SaveExpenseAllocationsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveExpenseAllocationsResult"] = newSaveExpenseAllocationsResult;

export interface ExpenseAllocationAllocationOptions {
  __typename?: "ExpenseAllocationAllocation";
  id?: ExpenseAllocationAllocation["id"];
  costInCents?: ExpenseAllocationAllocation["costInCents"];
  createdAt?: ExpenseAllocationAllocation["createdAt"];
  updatedAt?: ExpenseAllocationAllocation["updatedAt"];
  expenseAllocation?: FactoryInput<ExpenseAllocation, ExpenseAllocationOptions>;
  projectItemAllocation?: FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>;
}

export function newExpenseAllocationAllocation(
  options?: ExpenseAllocationAllocationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ExpenseAllocationAllocation>;
export function newExpenseAllocationAllocation(
  options: ExpenseAllocationAllocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ExpenseAllocationAllocation> {
  const o = (options.__typename ? options : cache["ExpenseAllocationAllocation"] = {}) as ExpenseAllocationAllocation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ExpenseAllocationAllocation";
    o.id = options.id ?? nextFactoryId("ExpenseAllocationAllocation");
    o.costInCents = options.costInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.expenseAllocation = maybeNew(
      "ExpenseAllocation",
      options.expenseAllocation,
      cache,
      options.hasOwnProperty("expenseAllocation"),
    );
    o.projectItemAllocation = maybeNew(
      "ProjectItemAllocation",
      options.projectItemAllocation,
      cache,
      options.hasOwnProperty("projectItemAllocation"),
    );
    return o as FactoryResult<ExpenseAllocationAllocation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ExpenseAllocationAllocation"] = newExpenseAllocationAllocation;

export interface FeatureFlagOptions {
  __typename?: "FeatureFlag";
  id?: FeatureFlag["id"];
  type?: FeatureFlagTypeDetailOptions | FeatureFlagType;
  status?: FeatureFlagStatusDetailOptions | FeatureFlagStatus;
  targets?: Array<FactoryInput<FeatureFlagTarget, FeatureFlagTargetOptions>>;
  name?: FeatureFlag["name"];
  description?: FeatureFlag["description"];
  isPresentational?: FeatureFlag["isPresentational"];
  createdAt?: FeatureFlag["createdAt"];
  updatedAt?: FeatureFlag["updatedAt"];
  releaseVersion?: FeatureFlag["releaseVersion"];
}

export function newFeatureFlag(
  options?: FeatureFlagOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FeatureFlag>;
export function newFeatureFlag(
  options: FeatureFlagOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FeatureFlag> {
  const o = (options.__typename ? options : cache["FeatureFlag"] = {}) as FeatureFlag;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FeatureFlag";
    o.id = options.id ?? nextFactoryId("FeatureFlag");
    o.type = enumOrDetailOfFeatureFlagType(options.type);
    o.status = enumOrDetailOfFeatureFlagStatus(options.status);
    o.targets = (options.targets ?? []).map((i) =>
      maybeNew("FeatureFlagTarget", i, cache, options.hasOwnProperty("targets"))
    );
    o.name = options.name ?? "name";
    o.description = options.description ?? "description";
    o.isPresentational = options.isPresentational ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.releaseVersion = options.releaseVersion ?? 0;
    return o as FactoryResult<FeatureFlag>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FeatureFlag"] = newFeatureFlag;

export interface SaveFeatureFlagResultOptions {
  __typename?: "SaveFeatureFlagResult";
  featureFlag?: FactoryInput<FeatureFlag, FeatureFlagOptions>;
}

export function newSaveFeatureFlagResult(
  options?: SaveFeatureFlagResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveFeatureFlagResult>;
export function newSaveFeatureFlagResult(
  options: SaveFeatureFlagResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveFeatureFlagResult> {
  const o = (options.__typename ? options : cache["SaveFeatureFlagResult"] = {}) as SaveFeatureFlagResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveFeatureFlagResult";
    o.featureFlag = maybeNew("FeatureFlag", options.featureFlag, cache, options.hasOwnProperty("featureFlag"));
    return o as FactoryResult<SaveFeatureFlagResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveFeatureFlagResult"] = newSaveFeatureFlagResult;

export interface FeatureFlagTargetOptions {
  __typename?: "FeatureFlagTarget";
  id?: FeatureFlagTarget["id"];
  createdAt?: FeatureFlagTarget["createdAt"];
  updatedAt?: FeatureFlagTarget["updatedAt"];
  featureFlag?: FactoryInput<FeatureFlag, FeatureFlagOptions>;
  target?:
    | FeatureFlagTargetTarget
    | FactoryResult<FeatureFlagTargetTarget>
    | DevelopmentOptions
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<UserOptions>
    | RequireTypename<UserGroupOptions>
    | null;
}

export function newFeatureFlagTarget(
  options?: FeatureFlagTargetOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FeatureFlagTarget>;
export function newFeatureFlagTarget(
  options: FeatureFlagTargetOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FeatureFlagTarget> {
  const o = (options.__typename ? options : cache["FeatureFlagTarget"] = {}) as FeatureFlagTarget;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FeatureFlagTarget";
    o.id = options.id ?? nextFactoryId("FeatureFlagTarget");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.featureFlag = maybeNew("FeatureFlag", options.featureFlag, cache, options.hasOwnProperty("featureFlag"));
    o.target = maybeNewOrNull(options.target?.__typename ?? "Development", options.target, cache);
    return o as FactoryResult<FeatureFlagTarget>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FeatureFlagTarget"] = newFeatureFlagTarget;

export interface SaveFeatureFlagTargetResultOptions {
  __typename?: "SaveFeatureFlagTargetResult";
  featureFlagTarget?: FactoryInput<FeatureFlagTarget, FeatureFlagTargetOptions>;
}

export function newSaveFeatureFlagTargetResult(
  options?: SaveFeatureFlagTargetResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveFeatureFlagTargetResult>;
export function newSaveFeatureFlagTargetResult(
  options: SaveFeatureFlagTargetResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveFeatureFlagTargetResult> {
  const o = (options.__typename ? options : cache["SaveFeatureFlagTargetResult"] = {}) as SaveFeatureFlagTargetResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveFeatureFlagTargetResult";
    o.featureFlagTarget = maybeNew(
      "FeatureFlagTarget",
      options.featureFlagTarget,
      cache,
      options.hasOwnProperty("featureFlagTarget"),
    );
    return o as FactoryResult<SaveFeatureFlagTargetResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveFeatureFlagTargetResult"] = newSaveFeatureFlagTargetResult;

export interface FeatureTypeOptions {
  __typename?: "FeatureType";
  id?: FeatureType["id"];
  name?: FeatureType["name"];
  allowedInBuilding?: FeatureType["allowedInBuilding"];
  allowedInLevel?: FeatureType["allowedInLevel"];
  createdAt?: FeatureType["createdAt"];
  updatedAt?: FeatureType["updatedAt"];
  parent?: FactoryInput<FeatureType, FeatureTypeOptions> | null;
  children?: Array<FactoryInput<FeatureType, FeatureTypeOptions>>;
  roomTypes?: Array<FactoryInput<RoomType, RoomTypeOptions>>;
}

export function newFeatureType(
  options?: FeatureTypeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FeatureType>;
export function newFeatureType(
  options: FeatureTypeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FeatureType> {
  const o = (options.__typename ? options : cache["FeatureType"] = {}) as FeatureType;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FeatureType";
    o.id = options.id ?? nextFactoryId("FeatureType");
    o.name = options.name ?? "name";
    o.allowedInBuilding = options.allowedInBuilding ?? false;
    o.allowedInLevel = options.allowedInLevel ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.parent = maybeNewOrNull("FeatureType", options.parent, cache);
    o.children = (options.children ?? []).map((i) =>
      maybeNew("FeatureType", i, cache, options.hasOwnProperty("children"))
    );
    o.roomTypes = (options.roomTypes ?? []).map((i) =>
      maybeNew("RoomType", i, cache, options.hasOwnProperty("roomTypes"))
    );
    return o as FactoryResult<FeatureType>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FeatureType"] = newFeatureType;

export interface SaveFeatureTypeResultOptions {
  __typename?: "SaveFeatureTypeResult";
  featureType?: FactoryInput<FeatureType, FeatureTypeOptions>;
}

export function newSaveFeatureTypeResult(
  options?: SaveFeatureTypeResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveFeatureTypeResult>;
export function newSaveFeatureTypeResult(
  options: SaveFeatureTypeResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveFeatureTypeResult> {
  const o = (options.__typename ? options : cache["SaveFeatureTypeResult"] = {}) as SaveFeatureTypeResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveFeatureTypeResult";
    o.featureType = maybeNew("FeatureType", options.featureType, cache, options.hasOwnProperty("featureType"));
    return o as FactoryResult<SaveFeatureTypeResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveFeatureTypeResult"] = newSaveFeatureTypeResult;

export interface FinishScheduleConfigOptions {
  __typename?: "FinishScheduleConfig";
  id?: FinishScheduleConfig["id"];
  sortOrder?: FinishScheduleConfig["sortOrder"];
  shown?: FinishScheduleConfig["shown"];
  useInVisualMode?: FinishScheduleConfig["useInVisualMode"];
  createdAt?: FinishScheduleConfig["createdAt"];
  updatedAt?: FinishScheduleConfig["updatedAt"];
  type?: FinishScheduleColumnTypeDetailOptions | FinishScheduleColumnType;
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  coreColumn?: FinishScheduleCoreColumnDetailOptions | FinishScheduleCoreColumn | null;
  sourceAttribute?: FinishScheduleConfig["sourceAttribute"];
  label?: FinishScheduleConfig["label"];
  designPackageLocation?: DesignPackageLocationDetailOptions | DesignPackageLocation;
}

export function newFinishScheduleConfig(
  options?: FinishScheduleConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FinishScheduleConfig>;
export function newFinishScheduleConfig(
  options: FinishScheduleConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FinishScheduleConfig> {
  const o = (options.__typename ? options : cache["FinishScheduleConfig"] = {}) as FinishScheduleConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FinishScheduleConfig";
    o.id = options.id ?? nextFactoryId("FinishScheduleConfig");
    o.sortOrder = options.sortOrder ?? 0;
    o.shown = options.shown ?? false;
    o.useInVisualMode = options.useInVisualMode ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.type = enumOrDetailOfFinishScheduleColumnType(options.type);
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.coreColumn = enumOrDetailOrNullOfFinishScheduleCoreColumn(options.coreColumn);
    o.sourceAttribute = options.sourceAttribute ?? null;
    o.label = options.label ?? null;
    o.designPackageLocation = enumOrDetailOfDesignPackageLocation(options.designPackageLocation);
    return o as FactoryResult<FinishScheduleConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FinishScheduleConfig"] = newFinishScheduleConfig;

export interface FollowSequenceSheetResultOptions {
  __typename?: "FollowSequenceSheetResult";
  developments?: Array<FactoryInput<Development, DevelopmentOptions>>;
  internalUsers?: Array<FactoryInput<InternalUser, InternalUserOptions>>;
}

export function newFollowSequenceSheetResult(
  options?: FollowSequenceSheetResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<FollowSequenceSheetResult>;
export function newFollowSequenceSheetResult(
  options: FollowSequenceSheetResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FollowSequenceSheetResult> {
  const o = (options.__typename ? options : cache["FollowSequenceSheetResult"] = {}) as FollowSequenceSheetResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "FollowSequenceSheetResult";
    o.developments = (options.developments ?? []).map((i) =>
      maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
    );
    o.internalUsers = (options.internalUsers ?? []).map((i) =>
      maybeNew("InternalUser", i, cache, options.hasOwnProperty("internalUsers"))
    );
    return o as FactoryResult<FollowSequenceSheetResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["FollowSequenceSheetResult"] = newFollowSequenceSheetResult;

export interface SaveFollowersResultOptions {
  __typename?: "SaveFollowersResult";
  emptyResult?: SaveFollowersResult["emptyResult"];
  commentable?: Commentable | FactoryResult<CommentableType> | CommentableOptions;
  followable?: Followable | FactoryResult<FollowableType> | FollowableOptions;
}

export function newSaveFollowersResult(
  options?: SaveFollowersResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveFollowersResult>;
export function newSaveFollowersResult(
  options: SaveFollowersResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveFollowersResult> {
  const o = (options.__typename ? options : cache["SaveFollowersResult"] = {}) as SaveFollowersResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveFollowersResult";
    o.emptyResult = options.emptyResult ?? null;
    o.commentable = maybeNew("Commentable", options.commentable, cache, options.hasOwnProperty("commentable"));
    o.followable = maybeNew("Followable", options.followable, cache, options.hasOwnProperty("followable"));
    return o as FactoryResult<SaveFollowersResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveFollowersResult"] = newSaveFollowersResult;

export interface SaveGlobalOptionsResultOptions {
  __typename?: "SaveGlobalOptionsResult";
  globalOptions?: Array<FactoryInput<GlobalOption, GlobalOptionOptions>>;
}

export function newSaveGlobalOptionsResult(
  options?: SaveGlobalOptionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalOptionsResult>;
export function newSaveGlobalOptionsResult(
  options: SaveGlobalOptionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalOptionsResult> {
  const o = (options.__typename ? options : cache["SaveGlobalOptionsResult"] = {}) as SaveGlobalOptionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalOptionsResult";
    o.globalOptions = (options.globalOptions ?? []).map((i) =>
      maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
    );
    return o as FactoryResult<SaveGlobalOptionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalOptionsResult"] = newSaveGlobalOptionsResult;

export interface GlobalOptionGroupOptions {
  __typename?: "GlobalOptionGroup";
  id?: GlobalOptionGroup["id"];
  name?: GlobalOptionGroup["name"];
  createdAt?: GlobalOptionGroup["createdAt"];
  updatedAt?: GlobalOptionGroup["updatedAt"];
  globalOptions?: Array<FactoryInput<GlobalOption, GlobalOptionOptions>>;
  type?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>;
  isSingleOptionGroup?: GlobalOptionGroup["isSingleOptionGroup"];
  isMultiOptionGroup?: GlobalOptionGroup["isMultiOptionGroup"];
  salesforceFieldName?: GlobalOptionGroup["salesforceFieldName"];
  forDesignPackage?: GlobalOptionGroup["forDesignPackage"];
  forDesignInterior?: GlobalOptionGroup["forDesignInterior"];
  forDesignUpgrade?: GlobalOptionGroup["forDesignUpgrade"];
  forExteriors?: GlobalOptionGroup["forExteriors"];
  forDesignExterior?: GlobalOptionGroup["forDesignExterior"];
  forDesignPackages?: GlobalOptionGroup["forDesignPackages"];
  defaultRequired?: GlobalOptionGroup["defaultRequired"];
  designPackageTagColor?: GlobalOptionGroup["designPackageTagColor"];
  version?: GlobalOptionGroup["version"];
  canEditType?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions | null;
}

export function newGlobalOptionGroup(
  options?: GlobalOptionGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOptionGroup>;
export function newGlobalOptionGroup(
  options: GlobalOptionGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalOptionGroup> {
  const o = (options.__typename ? options : cache["GlobalOptionGroup"] = {}) as GlobalOptionGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalOptionGroup";
    o.id = options.id ?? nextFactoryId("GlobalOptionGroup");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalOptions = (options.globalOptions ?? []).map((i) =>
      maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
    );
    o.type = maybeNew("GlobalOptionType", options.type, cache, options.hasOwnProperty("type"));
    o.isSingleOptionGroup = options.isSingleOptionGroup ?? false;
    o.isMultiOptionGroup = options.isMultiOptionGroup ?? false;
    o.salesforceFieldName = options.salesforceFieldName ?? null;
    o.forDesignPackage = options.forDesignPackage ?? false;
    o.forDesignInterior = options.forDesignInterior ?? false;
    o.forDesignUpgrade = options.forDesignUpgrade ?? false;
    o.forExteriors = options.forExteriors ?? false;
    o.forDesignExterior = options.forDesignExterior ?? false;
    o.forDesignPackages = options.forDesignPackages ?? false;
    o.defaultRequired = options.defaultRequired ?? false;
    o.designPackageTagColor = options.designPackageTagColor ?? null;
    o.version = options.version ?? 0;
    o.canEditType = maybeNew("PotentialOperation2", options.canEditType, cache, options.hasOwnProperty("canEditType"));
    o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
    return o as FactoryResult<GlobalOptionGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalOptionGroup"] = newGlobalOptionGroup;

export interface SaveGlobalOptionGroupResultOptions {
  __typename?: "SaveGlobalOptionGroupResult";
  entity?: FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions>;
}

export function newSaveGlobalOptionGroupResult(
  options?: SaveGlobalOptionGroupResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalOptionGroupResult>;
export function newSaveGlobalOptionGroupResult(
  options: SaveGlobalOptionGroupResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalOptionGroupResult> {
  const o = (options.__typename ? options : cache["SaveGlobalOptionGroupResult"] = {}) as SaveGlobalOptionGroupResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalOptionGroupResult";
    o.entity = maybeNew("GlobalOptionGroup", options.entity, cache, options.hasOwnProperty("entity"));
    return o as FactoryResult<SaveGlobalOptionGroupResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalOptionGroupResult"] = newSaveGlobalOptionGroupResult;

export interface GlobalOptionTagOptions {
  __typename?: "GlobalOptionTag";
  id?: GlobalOptionTag["id"];
  name?: GlobalOptionTag["name"];
  globalOptions?: Array<FactoryInput<GlobalOption, GlobalOptionOptions>>;
  globalOptionTypes?: Array<FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>>;
}

export function newGlobalOptionTag(
  options?: GlobalOptionTagOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOptionTag>;
export function newGlobalOptionTag(
  options: GlobalOptionTagOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalOptionTag> {
  const o = (options.__typename ? options : cache["GlobalOptionTag"] = {}) as GlobalOptionTag;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalOptionTag";
    o.id = options.id ?? nextFactoryId("GlobalOptionTag");
    o.name = options.name ?? "name";
    o.globalOptions = (options.globalOptions ?? []).map((i) =>
      maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
    );
    o.globalOptionTypes = (options.globalOptionTypes ?? []).map((i) =>
      maybeNew("GlobalOptionType", i, cache, options.hasOwnProperty("globalOptionTypes"))
    );
    return o as FactoryResult<GlobalOptionTag>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalOptionTag"] = newGlobalOptionTag;

export interface SaveGlobalOptionTagsResultOptions {
  __typename?: "SaveGlobalOptionTagsResult";
  globalOptionTags?: Array<FactoryInput<GlobalOptionTag, GlobalOptionTagOptions>>;
}

export function newSaveGlobalOptionTagsResult(
  options?: SaveGlobalOptionTagsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalOptionTagsResult>;
export function newSaveGlobalOptionTagsResult(
  options: SaveGlobalOptionTagsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalOptionTagsResult> {
  const o = (options.__typename ? options : cache["SaveGlobalOptionTagsResult"] = {}) as SaveGlobalOptionTagsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalOptionTagsResult";
    o.globalOptionTags = (options.globalOptionTags ?? []).map((i) =>
      maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("globalOptionTags"))
    );
    return o as FactoryResult<SaveGlobalOptionTagsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalOptionTagsResult"] = newSaveGlobalOptionTagsResult;

export interface GlobalOptionTypeOptions {
  __typename?: "GlobalOptionType";
  id?: GlobalOptionType["id"];
  name?: GlobalOptionType["name"];
  description?: GlobalOptionType["description"];
  changesProgramData?: GlobalOptionType["changesProgramData"];
  changesSpecsAndSelections?: GlobalOptionType["changesSpecsAndSelections"];
  status?: GlobalOptionType["status"];
  statusDetail?: GlobalOptionTypeStatusDetailOptions | GlobalOptionTypeStatus;
  isElevation?: GlobalOptionType["isElevation"];
  isExteriorPalette?: GlobalOptionType["isExteriorPalette"];
  isSpecLevel?: GlobalOptionType["isSpecLevel"];
  isInteriorScheme?: GlobalOptionType["isInteriorScheme"];
  isExteriorScheme?: GlobalOptionType["isExteriorScheme"];
  isPlanPackage?: GlobalOptionType["isPlanPackage"];
  isInterior?: GlobalOptionType["isInterior"];
  isFloorPlan?: GlobalOptionType["isFloorPlan"];
  tags?: Array<FactoryInput<GlobalOptionTag, GlobalOptionTagOptions>>;
  globalOptionsCount?: GlobalOptionType["globalOptionsCount"];
  allowsLocations?: GlobalOptionType["allowsLocations"];
  order?: GlobalOptionType["order"];
  forDesignInterior?: GlobalOptionType["forDesignInterior"];
  forDesignExterior?: GlobalOptionType["forDesignExterior"];
  forDesignUpgrade?: GlobalOptionType["forDesignUpgrade"];
  forDesignPackage?: GlobalOptionType["forDesignPackage"];
  forExteriors?: GlobalOptionType["forExteriors"];
  forPlanBasedBids?: GlobalOptionType["forPlanBasedBids"];
  globalOptions?: Array<FactoryInput<GlobalOption, GlobalOptionOptions>>;
  isAddOnV2?: GlobalOptionType["isAddOnV2"];
  isStructuralV2?: GlobalOptionType["isStructuralV2"];
  isCatalogV2?: GlobalOptionType["isCatalogV2"];
  isProductOptionV2?: GlobalOptionType["isProductOptionV2"];
  isPackageOptionV2?: GlobalOptionType["isPackageOptionV2"];
  version?: GlobalOptionType["version"];
}

export function newGlobalOptionType(
  options?: GlobalOptionTypeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOptionType>;
export function newGlobalOptionType(
  options: GlobalOptionTypeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalOptionType> {
  const o = (options.__typename ? options : cache["GlobalOptionType"] = {}) as GlobalOptionType;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalOptionType";
    o.id = options.id ?? nextFactoryId("GlobalOptionType");
    o.name = options.name ?? "name";
    o.description = options.description ?? null;
    o.changesProgramData = options.changesProgramData ?? null;
    o.changesSpecsAndSelections = options.changesSpecsAndSelections ?? null;
    o.status = options.status ?? GlobalOptionTypeStatus.Active;
    o.statusDetail = enumOrDetailOfGlobalOptionTypeStatus(options.statusDetail);
    o.isElevation = options.isElevation ?? false;
    o.isExteriorPalette = options.isExteriorPalette ?? false;
    o.isSpecLevel = options.isSpecLevel ?? false;
    o.isInteriorScheme = options.isInteriorScheme ?? false;
    o.isExteriorScheme = options.isExteriorScheme ?? false;
    o.isPlanPackage = options.isPlanPackage ?? false;
    o.isInterior = options.isInterior ?? false;
    o.isFloorPlan = options.isFloorPlan ?? false;
    o.tags = (options.tags ?? []).map((i) => maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("tags")));
    o.globalOptionsCount = options.globalOptionsCount ?? 0;
    o.allowsLocations = options.allowsLocations ?? false;
    o.order = options.order ?? 0;
    o.forDesignInterior = options.forDesignInterior ?? false;
    o.forDesignExterior = options.forDesignExterior ?? false;
    o.forDesignUpgrade = options.forDesignUpgrade ?? false;
    o.forDesignPackage = options.forDesignPackage ?? false;
    o.forExteriors = options.forExteriors ?? false;
    o.forPlanBasedBids = options.forPlanBasedBids ?? false;
    o.globalOptions = (options.globalOptions ?? []).map((i) =>
      maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
    );
    o.isAddOnV2 = options.isAddOnV2 ?? null;
    o.isStructuralV2 = options.isStructuralV2 ?? null;
    o.isCatalogV2 = options.isCatalogV2 ?? null;
    o.isProductOptionV2 = options.isProductOptionV2 ?? false;
    o.isPackageOptionV2 = options.isPackageOptionV2 ?? false;
    o.version = options.version ?? 0;
    return o as FactoryResult<GlobalOptionType>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalOptionType"] = newGlobalOptionType;

export interface SaveGlobalOptionTypesResultOptions {
  __typename?: "SaveGlobalOptionTypesResult";
  globalOptionTypes?: Array<FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>>;
}

export function newSaveGlobalOptionTypesResult(
  options?: SaveGlobalOptionTypesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalOptionTypesResult>;
export function newSaveGlobalOptionTypesResult(
  options: SaveGlobalOptionTypesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalOptionTypesResult> {
  const o = (options.__typename ? options : cache["SaveGlobalOptionTypesResult"] = {}) as SaveGlobalOptionTypesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalOptionTypesResult";
    o.globalOptionTypes = (options.globalOptionTypes ?? []).map((i) =>
      maybeNew("GlobalOptionType", i, cache, options.hasOwnProperty("globalOptionTypes"))
    );
    return o as FactoryResult<SaveGlobalOptionTypesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalOptionTypesResult"] = newSaveGlobalOptionTypesResult;

export interface GlobalPhaseOptions {
  __typename?: "GlobalPhase";
  id?: GlobalPhase["id"];
  active?: GlobalPhase["active"];
  cmsId?: GlobalPhase["cmsId"];
  name?: GlobalPhase["name"];
  stage?: GlobalPhase["stage"];
  stageDetail?: StageDetailOptions | Stage;
  displayOrder?: GlobalPhase["displayOrder"];
  globalSubPhases?: Array<FactoryInput<GlobalSubPhase, GlobalSubPhaseOptions>>;
  globalTasks?: Array<FactoryInput<GlobalTask, GlobalTaskOptions>>;
}

export function newGlobalPhase(
  options?: GlobalPhaseOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPhase>;
export function newGlobalPhase(
  options: GlobalPhaseOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPhase> {
  const o = (options.__typename ? options : cache["GlobalPhase"] = {}) as GlobalPhase;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPhase";
    o.id = options.id ?? nextFactoryId("GlobalPhase");
    o.active = options.active ?? false;
    o.cmsId = options.cmsId ?? null;
    o.name = options.name ?? "name";
    o.stage = options.stage ?? Stage.PreConPlanning;
    o.stageDetail = enumOrDetailOfStage(options.stageDetail);
    o.displayOrder = options.displayOrder ?? null;
    o.globalSubPhases = (options.globalSubPhases ?? []).map((i) =>
      maybeNew("GlobalSubPhase", i, cache, options.hasOwnProperty("globalSubPhases"))
    );
    o.globalTasks = (options.globalTasks ?? []).map((i) =>
      maybeNew("GlobalTask", i, cache, options.hasOwnProperty("globalTasks"))
    );
    return o as FactoryResult<GlobalPhase>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPhase"] = newGlobalPhase;

export interface SaveGlobalPhasesResultOptions {
  __typename?: "SaveGlobalPhasesResult";
  globalPhases?: Array<FactoryInput<GlobalPhase, GlobalPhaseOptions>>;
}

export function newSaveGlobalPhasesResult(
  options?: SaveGlobalPhasesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPhasesResult>;
export function newSaveGlobalPhasesResult(
  options: SaveGlobalPhasesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPhasesResult> {
  const o = (options.__typename ? options : cache["SaveGlobalPhasesResult"] = {}) as SaveGlobalPhasesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPhasesResult";
    o.globalPhases = (options.globalPhases ?? []).map((i) =>
      maybeNew("GlobalPhase", i, cache, options.hasOwnProperty("globalPhases"))
    );
    return o as FactoryResult<SaveGlobalPhasesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPhasesResult"] = newSaveGlobalPhasesResult;

export interface GlobalPlanAllowanceOptions {
  __typename?: "GlobalPlanAllowance";
  id?: GlobalPlanAllowance["id"];
  createdAt?: GlobalPlanAllowance["createdAt"];
  updatedAt?: GlobalPlanAllowance["updatedAt"];
  constraintItem?: FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>;
  task?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
}

export function newGlobalPlanAllowance(
  options?: GlobalPlanAllowanceOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanAllowance>;
export function newGlobalPlanAllowance(
  options: GlobalPlanAllowanceOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanAllowance> {
  const o = (options.__typename ? options : cache["GlobalPlanAllowance"] = {}) as GlobalPlanAllowance;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanAllowance";
    o.id = options.id ?? nextFactoryId("GlobalPlanAllowance");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.constraintItem = maybeNew(
      "GlobalPlanConstraintItem",
      options.constraintItem,
      cache,
      options.hasOwnProperty("constraintItem"),
    );
    o.task = maybeNew("GlobalPlanTask", options.task, cache, options.hasOwnProperty("task"));
    return o as FactoryResult<GlobalPlanAllowance>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanAllowance"] = newGlobalPlanAllowance;

export interface GlobalPlanConstraintOptions {
  __typename?: "GlobalPlanConstraint";
  id?: GlobalPlanConstraint["id"];
  createdAt?: GlobalPlanConstraint["createdAt"];
  updatedAt?: GlobalPlanConstraint["updatedAt"];
  task?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
  constraintItem?: FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>;
}

export function newGlobalPlanConstraint(
  options?: GlobalPlanConstraintOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanConstraint>;
export function newGlobalPlanConstraint(
  options: GlobalPlanConstraintOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanConstraint> {
  const o = (options.__typename ? options : cache["GlobalPlanConstraint"] = {}) as GlobalPlanConstraint;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanConstraint";
    o.id = options.id ?? nextFactoryId("GlobalPlanConstraint");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.task = maybeNew("GlobalPlanTask", options.task, cache, options.hasOwnProperty("task"));
    o.constraintItem = maybeNew(
      "GlobalPlanConstraintItem",
      options.constraintItem,
      cache,
      options.hasOwnProperty("constraintItem"),
    );
    return o as FactoryResult<GlobalPlanConstraint>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanConstraint"] = newGlobalPlanConstraint;

export interface GlobalPlanConstraintItemOptions {
  __typename?: "GlobalPlanConstraintItem";
  id?: GlobalPlanConstraintItem["id"];
  name?: GlobalPlanConstraintItem["name"];
  createdAt?: GlobalPlanConstraintItem["createdAt"];
  updatedAt?: GlobalPlanConstraintItem["updatedAt"];
  allowances?: Array<FactoryInput<GlobalPlanAllowance, GlobalPlanAllowanceOptions>>;
  constraints?: Array<FactoryInput<GlobalPlanConstraint, GlobalPlanConstraintOptions>>;
  numberOfTimesUsed?: GlobalPlanConstraintItem["numberOfTimesUsed"];
  constrainedPlanTasks?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
  allowingPlanTasks?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
  lagInDays?: GlobalPlanConstraintItem["lagInDays"];
  deletedAt?: GlobalPlanConstraintItem["deletedAt"];
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newGlobalPlanConstraintItem(
  options?: GlobalPlanConstraintItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanConstraintItem>;
export function newGlobalPlanConstraintItem(
  options: GlobalPlanConstraintItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanConstraintItem> {
  const o = (options.__typename ? options : cache["GlobalPlanConstraintItem"] = {}) as GlobalPlanConstraintItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanConstraintItem";
    o.id = options.id ?? nextFactoryId("GlobalPlanConstraintItem");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.allowances = (options.allowances ?? []).map((i) =>
      maybeNew("GlobalPlanAllowance", i, cache, options.hasOwnProperty("allowances"))
    );
    o.constraints = (options.constraints ?? []).map((i) =>
      maybeNew("GlobalPlanConstraint", i, cache, options.hasOwnProperty("constraints"))
    );
    o.numberOfTimesUsed = options.numberOfTimesUsed ?? 0;
    o.constrainedPlanTasks = (options.constrainedPlanTasks ?? []).map((i) =>
      maybeNew("PlanTask", i, cache, options.hasOwnProperty("constrainedPlanTasks"))
    );
    o.allowingPlanTasks = (options.allowingPlanTasks ?? []).map((i) =>
      maybeNew("PlanTask", i, cache, options.hasOwnProperty("allowingPlanTasks"))
    );
    o.lagInDays = options.lagInDays ?? 0;
    o.deletedAt = options.deletedAt ?? null;
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    return o as FactoryResult<GlobalPlanConstraintItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanConstraintItem"] = newGlobalPlanConstraintItem;

export interface SaveGlobalPlanConstraintItemResultOptions {
  __typename?: "SaveGlobalPlanConstraintItemResult";
  globalPlanConstraintItem?: FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>;
}

export function newSaveGlobalPlanConstraintItemResult(
  options?: SaveGlobalPlanConstraintItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanConstraintItemResult>;
export function newSaveGlobalPlanConstraintItemResult(
  options: SaveGlobalPlanConstraintItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanConstraintItemResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanConstraintItemResult"] = {}) as SaveGlobalPlanConstraintItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanConstraintItemResult";
    o.globalPlanConstraintItem = maybeNew(
      "GlobalPlanConstraintItem",
      options.globalPlanConstraintItem,
      cache,
      options.hasOwnProperty("globalPlanConstraintItem"),
    );
    return o as FactoryResult<SaveGlobalPlanConstraintItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanConstraintItemResult"] = newSaveGlobalPlanConstraintItemResult;

export interface SaveGlobalPlanConstraintItemsResultOptions {
  __typename?: "SaveGlobalPlanConstraintItemsResult";
  globalPlanConstraintItems?: Array<FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>>;
}

export function newSaveGlobalPlanConstraintItemsResult(
  options?: SaveGlobalPlanConstraintItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanConstraintItemsResult>;
export function newSaveGlobalPlanConstraintItemsResult(
  options: SaveGlobalPlanConstraintItemsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanConstraintItemsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanConstraintItemsResult"] = {}) as SaveGlobalPlanConstraintItemsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanConstraintItemsResult";
    o.globalPlanConstraintItems = (options.globalPlanConstraintItems ?? []).map((i) =>
      maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("globalPlanConstraintItems"))
    );
    return o as FactoryResult<SaveGlobalPlanConstraintItemsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanConstraintItemsResult"] = newSaveGlobalPlanConstraintItemsResult;

export interface GlobalPlanMilestoneOptions {
  __typename?: "GlobalPlanMilestone";
  id?: GlobalPlanMilestone["id"];
  name?: GlobalPlanMilestone["name"];
  isDefault?: GlobalPlanMilestone["isDefault"];
  archived?: GlobalPlanMilestone["archived"];
  createdAt?: GlobalPlanMilestone["createdAt"];
  updatedAt?: GlobalPlanMilestone["updatedAt"];
  planMilestones?: Array<FactoryInput<PlanMilestone, PlanMilestoneOptions>>;
  groups?: Array<FactoryInput<GlobalPlanMilestoneGroup, GlobalPlanMilestoneGroupOptions>>;
  constraints?: Array<FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>>;
  systemPlanMilestone?: SystemPlanMilestoneDetailOptions | SystemPlanMilestone | null;
  isHomeownerVisible?: GlobalPlanMilestone["isHomeownerVisible"];
  isInvoiceMilestone?: GlobalPlanMilestone["isInvoiceMilestone"];
  homeownerName?: GlobalPlanMilestone["homeownerName"];
  homeownerDescription?: GlobalPlanMilestone["homeownerDescription"];
  homeownerIcon?: FactoryInput<Asset, AssetOptions> | null;
  description?: GlobalPlanMilestone["description"];
  type?: GlobalPlanMilestoneTypeDetailOptions | GlobalPlanMilestoneType;
}

export function newGlobalPlanMilestone(
  options?: GlobalPlanMilestoneOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanMilestone>;
export function newGlobalPlanMilestone(
  options: GlobalPlanMilestoneOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanMilestone> {
  const o = (options.__typename ? options : cache["GlobalPlanMilestone"] = {}) as GlobalPlanMilestone;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanMilestone";
    o.id = options.id ?? nextFactoryId("GlobalPlanMilestone");
    o.name = options.name ?? "name";
    o.isDefault = options.isDefault ?? false;
    o.archived = options.archived ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.planMilestones = (options.planMilestones ?? []).map((i) =>
      maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("planMilestones"))
    );
    o.groups = (options.groups ?? []).map((i) =>
      maybeNew("GlobalPlanMilestoneGroup", i, cache, options.hasOwnProperty("groups"))
    );
    o.constraints = (options.constraints ?? []).map((i) =>
      maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("constraints"))
    );
    o.systemPlanMilestone = enumOrDetailOrNullOfSystemPlanMilestone(options.systemPlanMilestone);
    o.isHomeownerVisible = options.isHomeownerVisible ?? false;
    o.isInvoiceMilestone = options.isInvoiceMilestone ?? false;
    o.homeownerName = options.homeownerName ?? null;
    o.homeownerDescription = options.homeownerDescription ?? null;
    o.homeownerIcon = maybeNewOrNull("Asset", options.homeownerIcon, cache);
    o.description = options.description ?? null;
    o.type = enumOrDetailOfGlobalPlanMilestoneType(options.type);
    return o as FactoryResult<GlobalPlanMilestone>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanMilestone"] = newGlobalPlanMilestone;

export interface SaveGlobalPlanMilestoneResultOptions {
  __typename?: "SaveGlobalPlanMilestoneResult";
  globalPlanMilestone?: FactoryInput<GlobalPlanMilestone, GlobalPlanMilestoneOptions>;
}

export function newSaveGlobalPlanMilestoneResult(
  options?: SaveGlobalPlanMilestoneResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanMilestoneResult>;
export function newSaveGlobalPlanMilestoneResult(
  options: SaveGlobalPlanMilestoneResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanMilestoneResult> {
  const o =
    (options.__typename ? options : cache["SaveGlobalPlanMilestoneResult"] = {}) as SaveGlobalPlanMilestoneResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanMilestoneResult";
    o.globalPlanMilestone = maybeNew(
      "GlobalPlanMilestone",
      options.globalPlanMilestone,
      cache,
      options.hasOwnProperty("globalPlanMilestone"),
    );
    return o as FactoryResult<SaveGlobalPlanMilestoneResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanMilestoneResult"] = newSaveGlobalPlanMilestoneResult;

export interface GlobalPlanMilestonesPageResultOptions {
  __typename?: "GlobalPlanMilestonesPageResult";
  entities?: Array<FactoryInput<GlobalPlanMilestone, GlobalPlanMilestoneOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newGlobalPlanMilestonesPageResult(
  options?: GlobalPlanMilestonesPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanMilestonesPageResult>;
export function newGlobalPlanMilestonesPageResult(
  options: GlobalPlanMilestonesPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanMilestonesPageResult> {
  const o =
    (options.__typename ? options : cache["GlobalPlanMilestonesPageResult"] = {}) as GlobalPlanMilestonesPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanMilestonesPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("GlobalPlanMilestone", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<GlobalPlanMilestonesPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanMilestonesPageResult"] = newGlobalPlanMilestonesPageResult;

export interface SaveGlobalPlanMilestonesResultOptions {
  __typename?: "SaveGlobalPlanMilestonesResult";
  globalPlanMilestones?: Array<FactoryInput<GlobalPlanMilestone, GlobalPlanMilestoneOptions>>;
}

export function newSaveGlobalPlanMilestonesResult(
  options?: SaveGlobalPlanMilestonesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanMilestonesResult>;
export function newSaveGlobalPlanMilestonesResult(
  options: SaveGlobalPlanMilestonesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanMilestonesResult> {
  const o =
    (options.__typename ? options : cache["SaveGlobalPlanMilestonesResult"] = {}) as SaveGlobalPlanMilestonesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanMilestonesResult";
    o.globalPlanMilestones = (options.globalPlanMilestones ?? []).map((i) =>
      maybeNew("GlobalPlanMilestone", i, cache, options.hasOwnProperty("globalPlanMilestones"))
    );
    return o as FactoryResult<SaveGlobalPlanMilestonesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanMilestonesResult"] = newSaveGlobalPlanMilestonesResult;

export interface GlobalPlanMilestoneGroupOptions {
  __typename?: "GlobalPlanMilestoneGroup";
  id?: GlobalPlanMilestoneGroup["id"];
  name?: GlobalPlanMilestoneGroup["name"];
  createdAt?: GlobalPlanMilestoneGroup["createdAt"];
  updatedAt?: GlobalPlanMilestoneGroup["updatedAt"];
  businessFunctionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  globalPlanMilestones?: Array<FactoryInput<GlobalPlanMilestone, GlobalPlanMilestoneOptions>>;
}

export function newGlobalPlanMilestoneGroup(
  options?: GlobalPlanMilestoneGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanMilestoneGroup>;
export function newGlobalPlanMilestoneGroup(
  options: GlobalPlanMilestoneGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanMilestoneGroup> {
  const o = (options.__typename ? options : cache["GlobalPlanMilestoneGroup"] = {}) as GlobalPlanMilestoneGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanMilestoneGroup";
    o.id = options.id ?? nextFactoryId("GlobalPlanMilestoneGroup");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.businessFunctionType = enumOrDetailOfBusinessFunctionType(options.businessFunctionType);
    o.globalPlanMilestones = (options.globalPlanMilestones ?? []).map((i) =>
      maybeNew("GlobalPlanMilestone", i, cache, options.hasOwnProperty("globalPlanMilestones"))
    );
    return o as FactoryResult<GlobalPlanMilestoneGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanMilestoneGroup"] = newGlobalPlanMilestoneGroup;

export interface SaveGlobalPlanMilestoneGroupResultOptions {
  __typename?: "SaveGlobalPlanMilestoneGroupResult";
  globalPlanMilestoneGroup?: FactoryInput<GlobalPlanMilestoneGroup, GlobalPlanMilestoneGroupOptions>;
}

export function newSaveGlobalPlanMilestoneGroupResult(
  options?: SaveGlobalPlanMilestoneGroupResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanMilestoneGroupResult>;
export function newSaveGlobalPlanMilestoneGroupResult(
  options: SaveGlobalPlanMilestoneGroupResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanMilestoneGroupResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanMilestoneGroupResult"] = {}) as SaveGlobalPlanMilestoneGroupResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanMilestoneGroupResult";
    o.globalPlanMilestoneGroup = maybeNew(
      "GlobalPlanMilestoneGroup",
      options.globalPlanMilestoneGroup,
      cache,
      options.hasOwnProperty("globalPlanMilestoneGroup"),
    );
    return o as FactoryResult<SaveGlobalPlanMilestoneGroupResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanMilestoneGroupResult"] = newSaveGlobalPlanMilestoneGroupResult;

export interface GlobalPlanStageOptions {
  __typename?: "GlobalPlanStage";
  id?: GlobalPlanStage["id"];
  name?: GlobalPlanStage["name"];
  createdAt?: GlobalPlanStage["createdAt"];
  updatedAt?: GlobalPlanStage["updatedAt"];
  globalPlanTasks?: Array<FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>>;
  globalPlanTaskVariants?: Array<FactoryInput<GlobalPlanTaskVariant, GlobalPlanTaskVariantOptions>>;
  variants?: Array<FactoryInput<GlobalPlanStageVariant, GlobalPlanStageVariantOptions>>;
  orderForProject?: GlobalPlanStage["orderForProject"];
}

export function newGlobalPlanStage(
  options?: GlobalPlanStageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanStage>;
export function newGlobalPlanStage(
  options: GlobalPlanStageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanStage> {
  const o = (options.__typename ? options : cache["GlobalPlanStage"] = {}) as GlobalPlanStage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanStage";
    o.id = options.id ?? nextFactoryId("GlobalPlanStage");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalPlanTasks = (options.globalPlanTasks ?? []).map((i) =>
      maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("globalPlanTasks"))
    );
    o.globalPlanTaskVariants = (options.globalPlanTaskVariants ?? []).map((i) =>
      maybeNew("GlobalPlanTaskVariant", i, cache, options.hasOwnProperty("globalPlanTaskVariants"))
    );
    o.variants = (options.variants ?? []).map((i) =>
      maybeNew("GlobalPlanStageVariant", i, cache, options.hasOwnProperty("variants"))
    );
    o.orderForProject = options.orderForProject ?? null;
    return o as FactoryResult<GlobalPlanStage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanStage"] = newGlobalPlanStage;

export interface SaveGlobalPlanStageResultOptions {
  __typename?: "SaveGlobalPlanStageResult";
  globalPlanStage?: FactoryInput<GlobalPlanStage, GlobalPlanStageOptions>;
}

export function newSaveGlobalPlanStageResult(
  options?: SaveGlobalPlanStageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanStageResult>;
export function newSaveGlobalPlanStageResult(
  options: SaveGlobalPlanStageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanStageResult> {
  const o = (options.__typename ? options : cache["SaveGlobalPlanStageResult"] = {}) as SaveGlobalPlanStageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanStageResult";
    o.globalPlanStage = maybeNew(
      "GlobalPlanStage",
      options.globalPlanStage,
      cache,
      options.hasOwnProperty("globalPlanStage"),
    );
    return o as FactoryResult<SaveGlobalPlanStageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanStageResult"] = newSaveGlobalPlanStageResult;

export interface GlobalPlanStageVariantOptions {
  __typename?: "GlobalPlanStageVariant";
  id?: GlobalPlanStageVariant["id"];
  order?: GlobalPlanStageVariant["order"];
  createdAt?: GlobalPlanStageVariant["createdAt"];
  updatedAt?: GlobalPlanStageVariant["updatedAt"];
  globalPlanStage?: FactoryInput<GlobalPlanStage, GlobalPlanStageOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
}

export function newGlobalPlanStageVariant(
  options?: GlobalPlanStageVariantOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanStageVariant>;
export function newGlobalPlanStageVariant(
  options: GlobalPlanStageVariantOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanStageVariant> {
  const o = (options.__typename ? options : cache["GlobalPlanStageVariant"] = {}) as GlobalPlanStageVariant;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanStageVariant";
    o.id = options.id ?? nextFactoryId("GlobalPlanStageVariant");
    o.order = options.order ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalPlanStage = maybeNew(
      "GlobalPlanStage",
      options.globalPlanStage,
      cache,
      options.hasOwnProperty("globalPlanStage"),
    );
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    return o as FactoryResult<GlobalPlanStageVariant>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanStageVariant"] = newGlobalPlanStageVariant;

export interface SaveGlobalPlanStageVariantsResultOptions {
  __typename?: "SaveGlobalPlanStageVariantsResult";
  globalPlanStageVariants?: Array<FactoryInput<GlobalPlanStageVariant, GlobalPlanStageVariantOptions>>;
}

export function newSaveGlobalPlanStageVariantsResult(
  options?: SaveGlobalPlanStageVariantsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanStageVariantsResult>;
export function newSaveGlobalPlanStageVariantsResult(
  options: SaveGlobalPlanStageVariantsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanStageVariantsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanStageVariantsResult"] = {}) as SaveGlobalPlanStageVariantsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanStageVariantsResult";
    o.globalPlanStageVariants = (options.globalPlanStageVariants ?? []).map((i) =>
      maybeNew("GlobalPlanStageVariant", i, cache, options.hasOwnProperty("globalPlanStageVariants"))
    );
    return o as FactoryResult<SaveGlobalPlanStageVariantsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanStageVariantsResult"] = newSaveGlobalPlanStageVariantsResult;

export interface GlobalPlanTagOptions {
  __typename?: "GlobalPlanTag";
  id?: GlobalPlanTag["id"];
  name?: GlobalPlanTag["name"];
  createdAt?: GlobalPlanTag["createdAt"];
  updatedAt?: GlobalPlanTag["updatedAt"];
  tasks?: Array<FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>>;
  isHiddenFromSchedule?: GlobalPlanTag["isHiddenFromSchedule"];
}

export function newGlobalPlanTag(
  options?: GlobalPlanTagOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanTag>;
export function newGlobalPlanTag(
  options: GlobalPlanTagOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanTag> {
  const o = (options.__typename ? options : cache["GlobalPlanTag"] = {}) as GlobalPlanTag;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanTag";
    o.id = options.id ?? nextFactoryId("GlobalPlanTag");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tasks = (options.tasks ?? []).map((i) => maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("tasks")));
    o.isHiddenFromSchedule = options.isHiddenFromSchedule ?? false;
    return o as FactoryResult<GlobalPlanTag>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanTag"] = newGlobalPlanTag;

export interface SaveGlobalPlanTagResultOptions {
  __typename?: "SaveGlobalPlanTagResult";
  globalPlanTag?: FactoryInput<GlobalPlanTag, GlobalPlanTagOptions>;
}

export function newSaveGlobalPlanTagResult(
  options?: SaveGlobalPlanTagResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanTagResult>;
export function newSaveGlobalPlanTagResult(
  options: SaveGlobalPlanTagResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanTagResult> {
  const o = (options.__typename ? options : cache["SaveGlobalPlanTagResult"] = {}) as SaveGlobalPlanTagResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanTagResult";
    o.globalPlanTag = maybeNew("GlobalPlanTag", options.globalPlanTag, cache, options.hasOwnProperty("globalPlanTag"));
    return o as FactoryResult<SaveGlobalPlanTagResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanTagResult"] = newSaveGlobalPlanTagResult;

export interface BulkSaveGlobalPlanTagsResultOptions {
  __typename?: "BulkSaveGlobalPlanTagsResult";
  globalPlanTags?: Array<FactoryInput<GlobalPlanTag, GlobalPlanTagOptions>>;
}

export function newBulkSaveGlobalPlanTagsResult(
  options?: BulkSaveGlobalPlanTagsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BulkSaveGlobalPlanTagsResult>;
export function newBulkSaveGlobalPlanTagsResult(
  options: BulkSaveGlobalPlanTagsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BulkSaveGlobalPlanTagsResult> {
  const o = (options.__typename ? options : cache["BulkSaveGlobalPlanTagsResult"] = {}) as BulkSaveGlobalPlanTagsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BulkSaveGlobalPlanTagsResult";
    o.globalPlanTags = (options.globalPlanTags ?? []).map((i) =>
      maybeNew("GlobalPlanTag", i, cache, options.hasOwnProperty("globalPlanTags"))
    );
    return o as FactoryResult<BulkSaveGlobalPlanTagsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BulkSaveGlobalPlanTagsResult"] = newBulkSaveGlobalPlanTagsResult;

export interface GlobalPlanTaskOptions {
  __typename?: "GlobalPlanTask";
  id?: GlobalPlanTask["id"];
  name?: GlobalPlanTask["name"];
  nameForEntity?: GlobalPlanTask["nameForEntity"];
  externalName?: GlobalPlanTask["externalName"];
  description?: GlobalPlanTask["description"];
  archived?: GlobalPlanTask["archived"];
  optimisticDurationInDays?: GlobalPlanTask["optimisticDurationInDays"];
  expectedDurationInDays?: GlobalPlanTask["expectedDurationInDays"];
  pessimisticDurationInDays?: GlobalPlanTask["pessimisticDurationInDays"];
  createdAt?: GlobalPlanTask["createdAt"];
  updatedAt?: GlobalPlanTask["updatedAt"];
  businessFunctionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  projectRole?: ProjectRoleDetailOptions | ProjectRole | null;
  tradeCategory?: FactoryInput<TradeCategory, TradeCategoryOptions> | null;
  allowances?: Array<FactoryInput<GlobalPlanAllowance, GlobalPlanAllowanceOptions>>;
  constraints?: Array<FactoryInput<GlobalPlanConstraint, GlobalPlanConstraintOptions>>;
  tags?: Array<FactoryInput<GlobalPlanTag, GlobalPlanTagOptions>>;
  scopes?: Array<FactoryInput<GlobalPlanTaskScope, GlobalPlanTaskScopeOptions>>;
  applyToAllSchedules?: GlobalPlanTask["applyToAllSchedules"];
  budgetItem?: FactoryInput<Item, ItemOptions>;
  itemPlanTaskMappings?: Array<FactoryInput<ItemPlanTaskMapping, ItemPlanTaskMappingOptions>>;
  planTasks?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
  numberOfTimesUsed?: GlobalPlanTask["numberOfTimesUsed"];
  checklistItems?: Array<FactoryInput<GlobalPlanTaskChecklistItem, GlobalPlanTaskChecklistItemOptions>>;
  globalRequiredTaskDocuments?: Array<FactoryInput<GlobalRequiredTaskDocument, GlobalRequiredTaskDocumentOptions>>;
  canEditBudgetItem?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  bidContractRevisionDraws?: Array<FactoryInput<BidContractRevisionDraw, BidContractRevisionDrawOptions>>;
  stage?: FactoryInput<GlobalPlanStage, GlobalPlanStageOptions> | null;
  variants?: Array<FactoryInput<GlobalPlanTaskVariant, GlobalPlanTaskVariantOptions>>;
  drops?: Array<FactoryInput<Drop, DropOptions>>;
  parent?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  children?: Array<FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>>;
  systemTask?: SystemTaskDetailOptions | SystemTask | null;
  verificationMethod?: VerificationMethodDetailOptions | VerificationMethod | null;
  aiVerifiable?: GlobalPlanTask["aiVerifiable"];
}

export function newGlobalPlanTask(
  options?: GlobalPlanTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanTask>;
export function newGlobalPlanTask(
  options: GlobalPlanTaskOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanTask> {
  const o = (options.__typename ? options : cache["GlobalPlanTask"] = {}) as GlobalPlanTask;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanTask";
    o.id = options.id ?? nextFactoryId("GlobalPlanTask");
    o.name = options.name ?? "name";
    o.nameForEntity = options.nameForEntity ?? "nameForEntity";
    o.externalName = options.externalName ?? null;
    o.description = options.description ?? "description";
    o.archived = options.archived ?? false;
    o.optimisticDurationInDays = options.optimisticDurationInDays ?? 0;
    o.expectedDurationInDays = options.expectedDurationInDays ?? 0;
    o.pessimisticDurationInDays = options.pessimisticDurationInDays ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.businessFunctionType = enumOrDetailOfBusinessFunctionType(options.businessFunctionType);
    o.projectRole = enumOrDetailOrNullOfProjectRole(options.projectRole);
    o.tradeCategory = maybeNewOrNull("TradeCategory", options.tradeCategory, cache);
    o.allowances = (options.allowances ?? []).map((i) =>
      maybeNew("GlobalPlanAllowance", i, cache, options.hasOwnProperty("allowances"))
    );
    o.constraints = (options.constraints ?? []).map((i) =>
      maybeNew("GlobalPlanConstraint", i, cache, options.hasOwnProperty("constraints"))
    );
    o.tags = (options.tags ?? []).map((i) => maybeNew("GlobalPlanTag", i, cache, options.hasOwnProperty("tags")));
    o.scopes = (options.scopes ?? []).map((i) =>
      maybeNew("GlobalPlanTaskScope", i, cache, options.hasOwnProperty("scopes"))
    );
    o.applyToAllSchedules = options.applyToAllSchedules ?? false;
    o.budgetItem = maybeNew("Item", options.budgetItem, cache, options.hasOwnProperty("budgetItem"));
    o.itemPlanTaskMappings = (options.itemPlanTaskMappings ?? []).map((i) =>
      maybeNew("ItemPlanTaskMapping", i, cache, options.hasOwnProperty("itemPlanTaskMappings"))
    );
    o.planTasks = (options.planTasks ?? []).map((i) =>
      maybeNew("PlanTask", i, cache, options.hasOwnProperty("planTasks"))
    );
    o.numberOfTimesUsed = options.numberOfTimesUsed ?? 0;
    o.checklistItems = (options.checklistItems ?? []).map((i) =>
      maybeNew("GlobalPlanTaskChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
    );
    o.globalRequiredTaskDocuments = (options.globalRequiredTaskDocuments ?? []).map((i) =>
      maybeNew("GlobalRequiredTaskDocument", i, cache, options.hasOwnProperty("globalRequiredTaskDocuments"))
    );
    o.canEditBudgetItem = maybeNew(
      "PotentialOperation2",
      options.canEditBudgetItem,
      cache,
      options.hasOwnProperty("canEditBudgetItem"),
    );
    o.bidContractRevisionDraws = (options.bidContractRevisionDraws ?? []).map((i) =>
      maybeNew("BidContractRevisionDraw", i, cache, options.hasOwnProperty("bidContractRevisionDraws"))
    );
    o.stage = maybeNewOrNull("GlobalPlanStage", options.stage, cache);
    o.variants = (options.variants ?? []).map((i) =>
      maybeNew("GlobalPlanTaskVariant", i, cache, options.hasOwnProperty("variants"))
    );
    o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
    o.parent = maybeNewOrNull("GlobalPlanTask", options.parent, cache);
    o.children = (options.children ?? []).map((i) =>
      maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("children"))
    );
    o.systemTask = enumOrDetailOrNullOfSystemTask(options.systemTask);
    o.verificationMethod = enumOrDetailOrNullOfVerificationMethod(options.verificationMethod);
    o.aiVerifiable = options.aiVerifiable ?? false;
    return o as FactoryResult<GlobalPlanTask>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanTask"] = newGlobalPlanTask;

export interface SaveGlobalPlanTaskResultOptions {
  __typename?: "SaveGlobalPlanTaskResult";
  globalPlanTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
}

export function newSaveGlobalPlanTaskResult(
  options?: SaveGlobalPlanTaskResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanTaskResult>;
export function newSaveGlobalPlanTaskResult(
  options: SaveGlobalPlanTaskResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanTaskResult> {
  const o = (options.__typename ? options : cache["SaveGlobalPlanTaskResult"] = {}) as SaveGlobalPlanTaskResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanTaskResult";
    o.globalPlanTask = maybeNew(
      "GlobalPlanTask",
      options.globalPlanTask,
      cache,
      options.hasOwnProperty("globalPlanTask"),
    );
    return o as FactoryResult<SaveGlobalPlanTaskResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanTaskResult"] = newSaveGlobalPlanTaskResult;

export interface SaveGlobalPlanTasksResultOptions {
  __typename?: "SaveGlobalPlanTasksResult";
  globalPlanTasks?: Array<FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>>;
}

export function newSaveGlobalPlanTasksResult(
  options?: SaveGlobalPlanTasksResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalPlanTasksResult>;
export function newSaveGlobalPlanTasksResult(
  options: SaveGlobalPlanTasksResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalPlanTasksResult> {
  const o = (options.__typename ? options : cache["SaveGlobalPlanTasksResult"] = {}) as SaveGlobalPlanTasksResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalPlanTasksResult";
    o.globalPlanTasks = (options.globalPlanTasks ?? []).map((i) =>
      maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("globalPlanTasks"))
    );
    return o as FactoryResult<SaveGlobalPlanTasksResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalPlanTasksResult"] = newSaveGlobalPlanTasksResult;

export interface GlobalPlanTasksPageResultOptions {
  __typename?: "GlobalPlanTasksPageResult";
  entities?: Array<FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newGlobalPlanTasksPageResult(
  options?: GlobalPlanTasksPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanTasksPageResult>;
export function newGlobalPlanTasksPageResult(
  options: GlobalPlanTasksPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanTasksPageResult> {
  const o = (options.__typename ? options : cache["GlobalPlanTasksPageResult"] = {}) as GlobalPlanTasksPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanTasksPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<GlobalPlanTasksPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanTasksPageResult"] = newGlobalPlanTasksPageResult;

export interface GlobalPlanTaskChecklistItemOptions {
  __typename?: "GlobalPlanTaskChecklistItem";
  id?: GlobalPlanTaskChecklistItem["id"];
  name?: GlobalPlanTaskChecklistItem["name"];
  deletedAt?: GlobalPlanTaskChecklistItem["deletedAt"];
  createdAt?: GlobalPlanTaskChecklistItem["createdAt"];
  updatedAt?: GlobalPlanTaskChecklistItem["updatedAt"];
  globalPlanTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
}

export function newGlobalPlanTaskChecklistItem(
  options?: GlobalPlanTaskChecklistItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanTaskChecklistItem>;
export function newGlobalPlanTaskChecklistItem(
  options: GlobalPlanTaskChecklistItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanTaskChecklistItem> {
  const o = (options.__typename ? options : cache["GlobalPlanTaskChecklistItem"] = {}) as GlobalPlanTaskChecklistItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanTaskChecklistItem";
    o.id = options.id ?? nextFactoryId("GlobalPlanTaskChecklistItem");
    o.name = options.name ?? "name";
    o.deletedAt = options.deletedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalPlanTask = maybeNew(
      "GlobalPlanTask",
      options.globalPlanTask,
      cache,
      options.hasOwnProperty("globalPlanTask"),
    );
    return o as FactoryResult<GlobalPlanTaskChecklistItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanTaskChecklistItem"] = newGlobalPlanTaskChecklistItem;

export interface GlobalPlanTaskScopeOptions {
  __typename?: "GlobalPlanTaskScope";
  id?: GlobalPlanTaskScope["id"];
  createdAt?: GlobalPlanTaskScope["createdAt"];
  updatedAt?: GlobalPlanTaskScope["updatedAt"];
  globalPlanTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
  target?: Project | FactoryResult<ProjectType> | ProjectOptions;
}

export function newGlobalPlanTaskScope(
  options?: GlobalPlanTaskScopeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanTaskScope>;
export function newGlobalPlanTaskScope(
  options: GlobalPlanTaskScopeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanTaskScope> {
  const o = (options.__typename ? options : cache["GlobalPlanTaskScope"] = {}) as GlobalPlanTaskScope;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanTaskScope";
    o.id = options.id ?? nextFactoryId("GlobalPlanTaskScope");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalPlanTask = maybeNew(
      "GlobalPlanTask",
      options.globalPlanTask,
      cache,
      options.hasOwnProperty("globalPlanTask"),
    );
    o.target = maybeNew("Project", options.target, cache, options.hasOwnProperty("target"));
    return o as FactoryResult<GlobalPlanTaskScope>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanTaskScope"] = newGlobalPlanTaskScope;

export interface GlobalPlanTaskVariantOptions {
  __typename?: "GlobalPlanTaskVariant";
  id?: GlobalPlanTaskVariant["id"];
  name?: GlobalPlanTaskVariant["name"];
  optimisticDurationInDays?: GlobalPlanTaskVariant["optimisticDurationInDays"];
  expectedDurationInDays?: GlobalPlanTaskVariant["expectedDurationInDays"];
  pessimisticDurationInDays?: GlobalPlanTaskVariant["pessimisticDurationInDays"];
  createdAt?: GlobalPlanTaskVariant["createdAt"];
  updatedAt?: GlobalPlanTaskVariant["updatedAt"];
  globalPlanTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
  allowances?: Array<FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>>;
  constraints?: Array<FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>>;
  stage?: FactoryInput<GlobalPlanStage, GlobalPlanStageOptions> | null;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
}

export function newGlobalPlanTaskVariant(
  options?: GlobalPlanTaskVariantOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanTaskVariant>;
export function newGlobalPlanTaskVariant(
  options: GlobalPlanTaskVariantOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalPlanTaskVariant> {
  const o = (options.__typename ? options : cache["GlobalPlanTaskVariant"] = {}) as GlobalPlanTaskVariant;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalPlanTaskVariant";
    o.id = options.id ?? nextFactoryId("GlobalPlanTaskVariant");
    o.name = options.name ?? null;
    o.optimisticDurationInDays = options.optimisticDurationInDays ?? null;
    o.expectedDurationInDays = options.expectedDurationInDays ?? null;
    o.pessimisticDurationInDays = options.pessimisticDurationInDays ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalPlanTask = maybeNew(
      "GlobalPlanTask",
      options.globalPlanTask,
      cache,
      options.hasOwnProperty("globalPlanTask"),
    );
    o.allowances = (options.allowances ?? []).map((i) =>
      maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("allowances"))
    );
    o.constraints = (options.constraints ?? []).map((i) =>
      maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("constraints"))
    );
    o.stage = maybeNewOrNull("GlobalPlanStage", options.stage, cache);
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    return o as FactoryResult<GlobalPlanTaskVariant>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalPlanTaskVariant"] = newGlobalPlanTaskVariant;

export interface GlobalRequiredTaskDocumentOptions {
  __typename?: "GlobalRequiredTaskDocument";
  id?: GlobalRequiredTaskDocument["id"];
  name?: GlobalRequiredTaskDocument["name"];
  createdAt?: GlobalRequiredTaskDocument["createdAt"];
  updatedAt?: GlobalRequiredTaskDocument["updatedAt"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  watchers?: GlobalRequiredTaskDocument["watchers"];
  canEditDocumentType?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newGlobalRequiredTaskDocument(
  options?: GlobalRequiredTaskDocumentOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalRequiredTaskDocument>;
export function newGlobalRequiredTaskDocument(
  options: GlobalRequiredTaskDocumentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalRequiredTaskDocument> {
  const o = (options.__typename ? options : cache["GlobalRequiredTaskDocument"] = {}) as GlobalRequiredTaskDocument;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalRequiredTaskDocument";
    o.id = options.id ?? nextFactoryId("GlobalRequiredTaskDocument");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.documentType = enumOrDetailOfDocumentType(options.documentType);
    o.watchers = options.watchers ?? [];
    o.canEditDocumentType = maybeNew(
      "PotentialOperation2",
      options.canEditDocumentType,
      cache,
      options.hasOwnProperty("canEditDocumentType"),
    );
    return o as FactoryResult<GlobalRequiredTaskDocument>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalRequiredTaskDocument"] = newGlobalRequiredTaskDocument;

export interface SaveGlobalRequiredTaskDocumentResultOptions {
  __typename?: "SaveGlobalRequiredTaskDocumentResult";
  globalRequiredTaskDocument?: FactoryInput<GlobalRequiredTaskDocument, GlobalRequiredTaskDocumentOptions>;
}

export function newSaveGlobalRequiredTaskDocumentResult(
  options?: SaveGlobalRequiredTaskDocumentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalRequiredTaskDocumentResult>;
export function newSaveGlobalRequiredTaskDocumentResult(
  options: SaveGlobalRequiredTaskDocumentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalRequiredTaskDocumentResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalRequiredTaskDocumentResult"] = {}) as SaveGlobalRequiredTaskDocumentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalRequiredTaskDocumentResult";
    o.globalRequiredTaskDocument = maybeNew(
      "GlobalRequiredTaskDocument",
      options.globalRequiredTaskDocument,
      cache,
      options.hasOwnProperty("globalRequiredTaskDocument"),
    );
    return o as FactoryResult<SaveGlobalRequiredTaskDocumentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalRequiredTaskDocumentResult"] = newSaveGlobalRequiredTaskDocumentResult;

export interface GlobalSearchResultOptions {
  __typename?: "GlobalSearchResult";
  record?: FactoryInput<GlobalSearchRecord, GlobalSearchRecordOptions>;
}

export function newGlobalSearchResult(
  options?: GlobalSearchResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalSearchResult>;
export function newGlobalSearchResult(
  options: GlobalSearchResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalSearchResult> {
  const o = (options.__typename ? options : cache["GlobalSearchResult"] = {}) as GlobalSearchResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalSearchResult";
    o.record = maybeNew("GlobalSearchRecord", options.record, cache, options.hasOwnProperty("record"));
    return o as FactoryResult<GlobalSearchResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalSearchResult"] = newGlobalSearchResult;

export interface GlobalSearchRecordOptions {
  __typename?: "GlobalSearchRecord";
  id?: GlobalSearchRecord["id"];
  search?: GlobalSearchRecord["search"];
  parent?:
    | GlobalSearchRecordParent
    | FactoryResult<GlobalSearchRecordParent>
    | BillOptions
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<DesignPackageOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<ProductOfferingOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<TradePartnerOptions>;
}

export function newGlobalSearchRecord(
  options?: GlobalSearchRecordOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalSearchRecord>;
export function newGlobalSearchRecord(
  options: GlobalSearchRecordOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalSearchRecord> {
  const o = (options.__typename ? options : cache["GlobalSearchRecord"] = {}) as GlobalSearchRecord;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalSearchRecord";
    o.id = options.id ?? nextFactoryId("GlobalSearchRecord");
    o.search = options.search ?? null;
    o.parent = maybeNew(options.parent?.__typename ?? "Bill", options.parent, cache);
    return o as FactoryResult<GlobalSearchRecord>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalSearchRecord"] = newGlobalSearchRecord;

export interface GlobalSubPhaseOptions {
  __typename?: "GlobalSubPhase";
  id?: GlobalSubPhase["id"];
  name?: GlobalSubPhase["name"];
  globalPhase?: FactoryInput<GlobalPhase, GlobalPhaseOptions>;
  displayOrder?: GlobalSubPhase["displayOrder"];
  stage?: GlobalSubPhase["stage"];
  stageDetail?: StageDetailOptions | Stage;
  cmsId?: GlobalSubPhase["cmsId"];
}

export function newGlobalSubPhase(
  options?: GlobalSubPhaseOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalSubPhase>;
export function newGlobalSubPhase(
  options: GlobalSubPhaseOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalSubPhase> {
  const o = (options.__typename ? options : cache["GlobalSubPhase"] = {}) as GlobalSubPhase;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalSubPhase";
    o.id = options.id ?? nextFactoryId("GlobalSubPhase");
    o.name = options.name ?? "name";
    o.globalPhase = maybeNew("GlobalPhase", options.globalPhase, cache, options.hasOwnProperty("globalPhase"));
    o.displayOrder = options.displayOrder ?? null;
    o.stage = options.stage ?? Stage.PreConPlanning;
    o.stageDetail = enumOrDetailOfStage(options.stageDetail);
    o.cmsId = options.cmsId ?? null;
    return o as FactoryResult<GlobalSubPhase>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalSubPhase"] = newGlobalSubPhase;

export interface SaveGlobalSubPhasesResultOptions {
  __typename?: "SaveGlobalSubPhasesResult";
  globalSubPhases?: Array<FactoryInput<GlobalSubPhase, GlobalSubPhaseOptions>>;
}

export function newSaveGlobalSubPhasesResult(
  options?: SaveGlobalSubPhasesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalSubPhasesResult>;
export function newSaveGlobalSubPhasesResult(
  options: SaveGlobalSubPhasesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalSubPhasesResult> {
  const o = (options.__typename ? options : cache["SaveGlobalSubPhasesResult"] = {}) as SaveGlobalSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalSubPhasesResult";
    o.globalSubPhases = (options.globalSubPhases ?? []).map((i) =>
      maybeNew("GlobalSubPhase", i, cache, options.hasOwnProperty("globalSubPhases"))
    );
    return o as FactoryResult<SaveGlobalSubPhasesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalSubPhasesResult"] = newSaveGlobalSubPhasesResult;

export interface ReplaceGlobalSubPhaseResultOptions {
  __typename?: "ReplaceGlobalSubPhaseResult";
  replaced?: FactoryInput<GlobalSubPhase, GlobalSubPhaseOptions>;
  with?: FactoryInput<GlobalSubPhase, GlobalSubPhaseOptions>;
  impactedCount?: ReplaceGlobalSubPhaseResult["impactedCount"];
  impacted?: Array<FactoryInput<ScheduleSubPhase, ScheduleSubPhaseOptions>>;
}

export function newReplaceGlobalSubPhaseResult(
  options?: ReplaceGlobalSubPhaseResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReplaceGlobalSubPhaseResult>;
export function newReplaceGlobalSubPhaseResult(
  options: ReplaceGlobalSubPhaseResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReplaceGlobalSubPhaseResult> {
  const o = (options.__typename ? options : cache["ReplaceGlobalSubPhaseResult"] = {}) as ReplaceGlobalSubPhaseResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReplaceGlobalSubPhaseResult";
    o.replaced = maybeNew("GlobalSubPhase", options.replaced, cache, options.hasOwnProperty("replaced"));
    o.with = maybeNew("GlobalSubPhase", options.with, cache, options.hasOwnProperty("with"));
    o.impactedCount = options.impactedCount ?? 0;
    o.impacted = (options.impacted ?? []).map((i) =>
      maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impacted"))
    );
    return o as FactoryResult<ReplaceGlobalSubPhaseResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReplaceGlobalSubPhaseResult"] = newReplaceGlobalSubPhaseResult;

export interface GlobalTaskOptions {
  __typename?: "GlobalTask";
  id?: GlobalTask["id"];
  name?: GlobalTask["name"];
  isMilestone?: GlobalTask["isMilestone"];
  createdAt?: GlobalTask["createdAt"];
  updatedAt?: GlobalTask["updatedAt"];
  globalPhase?: FactoryInput<GlobalPhase, GlobalPhaseOptions>;
  determinesStartDateForStage?: GlobalTask["determinesStartDateForStage"];
  beginsStage?: GlobalTask["beginsStage"];
  systemTask?: GlobalTask["systemTask"];
  sendEvent?: GlobalTask["sendEvent"];
  globalPlanMilestone?: FactoryInput<GlobalPlanMilestone, GlobalPlanMilestoneOptions> | null;
}

export function newGlobalTask(options?: GlobalTaskOptions, factoryOptions?: FactoryOptions): FactoryResult<GlobalTask>;
export function newGlobalTask(
  options: GlobalTaskOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GlobalTask> {
  const o = (options.__typename ? options : cache["GlobalTask"] = {}) as GlobalTask;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GlobalTask";
    o.id = options.id ?? nextFactoryId("GlobalTask");
    o.name = options.name ?? "name";
    o.isMilestone = options.isMilestone ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalPhase = maybeNew("GlobalPhase", options.globalPhase, cache, options.hasOwnProperty("globalPhase"));
    o.determinesStartDateForStage = options.determinesStartDateForStage ?? null;
    o.beginsStage = options.beginsStage ?? null;
    o.systemTask = options.systemTask ?? null;
    o.sendEvent = options.sendEvent ?? false;
    o.globalPlanMilestone = maybeNewOrNull("GlobalPlanMilestone", options.globalPlanMilestone, cache);
    return o as FactoryResult<GlobalTask>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GlobalTask"] = newGlobalTask;

export interface SaveGlobalTasksResultOptions {
  __typename?: "SaveGlobalTasksResult";
  globalTasks?: Array<FactoryInput<GlobalTask, GlobalTaskOptions>>;
}

export function newSaveGlobalTasksResult(
  options?: SaveGlobalTasksResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveGlobalTasksResult>;
export function newSaveGlobalTasksResult(
  options: SaveGlobalTasksResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveGlobalTasksResult> {
  const o = (options.__typename ? options : cache["SaveGlobalTasksResult"] = {}) as SaveGlobalTasksResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveGlobalTasksResult";
    o.globalTasks = (options.globalTasks ?? []).map((i) =>
      maybeNew("GlobalTask", i, cache, options.hasOwnProperty("globalTasks"))
    );
    return o as FactoryResult<SaveGlobalTasksResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveGlobalTasksResult"] = newSaveGlobalTasksResult;

export interface HistoryOptions {
  __typename?: "History";
  recordedAt?: History["recordedAt"];
  avatar?: History["avatar"];
  title?: History["title"];
  subtitle?: History["subtitle"];
  userName?: History["userName"];
}

export function newHistory(options?: HistoryOptions, factoryOptions?: FactoryOptions): FactoryResult<History>;
export function newHistory(
  options: HistoryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<History> {
  const o = (options.__typename ? options : cache["History"] = {}) as History;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "History";
    o.recordedAt = options.recordedAt ?? newDateTime();
    o.avatar = options.avatar ?? "avatar";
    o.title = options.title ?? "title";
    o.subtitle = options.subtitle ?? null;
    o.userName = options.userName ?? null;
    return o as FactoryResult<History>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["History"] = newHistory;

export interface HomeboundHolidayOptions {
  __typename?: "HomeboundHoliday";
  id?: HomeboundHoliday["id"];
  date?: HomeboundHoliday["date"];
  name?: HomeboundHoliday["name"];
  createdAt?: HomeboundHoliday["createdAt"];
  updatedAt?: HomeboundHoliday["updatedAt"];
}

export function newHomeboundHoliday(
  options?: HomeboundHolidayOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeboundHoliday>;
export function newHomeboundHoliday(
  options: HomeboundHolidayOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeboundHoliday> {
  const o = (options.__typename ? options : cache["HomeboundHoliday"] = {}) as HomeboundHoliday;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "HomeboundHoliday";
    o.id = options.id ?? nextFactoryId("HomeboundHoliday");
    o.date = options.date ?? newDate();
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    return o as FactoryResult<HomeboundHoliday>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["HomeboundHoliday"] = newHomeboundHoliday;

export interface SaveHomeboundHolidayResultOptions {
  __typename?: "SaveHomeboundHolidayResult";
  homeboundHoliday?: FactoryInput<HomeboundHoliday, HomeboundHolidayOptions>;
}

export function newSaveHomeboundHolidayResult(
  options?: SaveHomeboundHolidayResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveHomeboundHolidayResult>;
export function newSaveHomeboundHolidayResult(
  options: SaveHomeboundHolidayResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveHomeboundHolidayResult> {
  const o = (options.__typename ? options : cache["SaveHomeboundHolidayResult"] = {}) as SaveHomeboundHolidayResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveHomeboundHolidayResult";
    o.homeboundHoliday = maybeNew(
      "HomeboundHoliday",
      options.homeboundHoliday,
      cache,
      options.hasOwnProperty("homeboundHoliday"),
    );
    return o as FactoryResult<SaveHomeboundHolidayResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveHomeboundHolidayResult"] = newSaveHomeboundHolidayResult;

export interface HomeownerOptions {
  __typename?: "Homeowner";
  id?: Homeowner["id"];
  firstName?: Homeowner["firstName"];
  lastName?: Homeowner["lastName"];
  email?: Homeowner["email"];
  phone?: Homeowner["phone"];
  createdAt?: Homeowner["createdAt"];
  createdBy?: FactoryInput<User, UserOptions> | null;
  canViewCheckout?: Homeowner["canViewCheckout"];
  checkoutConfigs?: Array<FactoryInput<CheckoutConfig, CheckoutConfigOptions>>;
}

export function newHomeowner(options?: HomeownerOptions, factoryOptions?: FactoryOptions): FactoryResult<Homeowner>;
export function newHomeowner(
  options: HomeownerOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Homeowner> {
  const o = (options.__typename ? options : cache["Homeowner"] = {}) as Homeowner;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Homeowner";
    o.id = options.id ?? nextFactoryId("Homeowner");
    o.firstName = options.firstName ?? "firstName";
    o.lastName = options.lastName ?? "lastName";
    o.email = options.email ?? "email";
    o.phone = options.phone ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.createdBy = maybeNewOrNull("User", options.createdBy, cache);
    o.canViewCheckout = options.canViewCheckout ?? false;
    o.checkoutConfigs = (options.checkoutConfigs ?? []).map((i) =>
      maybeNew("CheckoutConfig", i, cache, options.hasOwnProperty("checkoutConfigs"))
    );
    return o as FactoryResult<Homeowner>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Homeowner"] = newHomeowner;

export interface HomeownersPageOptions {
  __typename?: "HomeownersPage";
  entities?: Array<FactoryInput<Homeowner, HomeownerOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newHomeownersPage(
  options?: HomeownersPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownersPage>;
export function newHomeownersPage(
  options: HomeownersPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeownersPage> {
  const o = (options.__typename ? options : cache["HomeownersPage"] = {}) as HomeownersPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "HomeownersPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("Homeowner", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<HomeownersPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["HomeownersPage"] = newHomeownersPage;

export interface SaveHomeownerResultOptions {
  __typename?: "SaveHomeownerResult";
  homeowner?: FactoryInput<Homeowner, HomeownerOptions>;
}

export function newSaveHomeownerResult(
  options?: SaveHomeownerResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveHomeownerResult>;
export function newSaveHomeownerResult(
  options: SaveHomeownerResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveHomeownerResult> {
  const o = (options.__typename ? options : cache["SaveHomeownerResult"] = {}) as SaveHomeownerResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveHomeownerResult";
    o.homeowner = maybeNew("Homeowner", options.homeowner, cache, options.hasOwnProperty("homeowner"));
    return o as FactoryResult<SaveHomeownerResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveHomeownerResult"] = newSaveHomeownerResult;

export interface HomeownerContractLineItemsByProjectItemOptions {
  __typename?: "HomeownerContractLineItemsByProjectItem";
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  lineItems?: Array<FactoryInput<HomeownerContractLineItem, HomeownerContractLineItemOptions>>;
}

export function newHomeownerContractLineItemsByProjectItem(
  options?: HomeownerContractLineItemsByProjectItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractLineItemsByProjectItem>;
export function newHomeownerContractLineItemsByProjectItem(
  options: HomeownerContractLineItemsByProjectItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeownerContractLineItemsByProjectItem> {
  const o =
    (options.__typename
      ? options
      : cache["HomeownerContractLineItemsByProjectItem"] = {}) as HomeownerContractLineItemsByProjectItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "HomeownerContractLineItemsByProjectItem";
    o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    return o as FactoryResult<HomeownerContractLineItemsByProjectItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["HomeownerContractLineItemsByProjectItem"] = newHomeownerContractLineItemsByProjectItem;

export interface SaveHomeownerContractResultOptions {
  __typename?: "SaveHomeownerContractResult";
  homeownerContract?: FactoryInput<HomeownerContract, HomeownerContractOptions>;
}

export function newSaveHomeownerContractResult(
  options?: SaveHomeownerContractResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveHomeownerContractResult>;
export function newSaveHomeownerContractResult(
  options: SaveHomeownerContractResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveHomeownerContractResult> {
  const o = (options.__typename ? options : cache["SaveHomeownerContractResult"] = {}) as SaveHomeownerContractResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveHomeownerContractResult";
    o.homeownerContract = maybeNew(
      "HomeownerContract",
      options.homeownerContract,
      cache,
      options.hasOwnProperty("homeownerContract"),
    );
    return o as FactoryResult<SaveHomeownerContractResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveHomeownerContractResult"] = newSaveHomeownerContractResult;

export interface SaveHomeownerContractChangeOrderResultOptions {
  __typename?: "SaveHomeownerContractChangeOrderResult";
  homeownerContractChangeOrder?: FactoryInput<HomeownerContractChangeOrder, HomeownerContractChangeOrderOptions>;
}

export function newSaveHomeownerContractChangeOrderResult(
  options?: SaveHomeownerContractChangeOrderResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveHomeownerContractChangeOrderResult>;
export function newSaveHomeownerContractChangeOrderResult(
  options: SaveHomeownerContractChangeOrderResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveHomeownerContractChangeOrderResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveHomeownerContractChangeOrderResult"] = {}) as SaveHomeownerContractChangeOrderResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveHomeownerContractChangeOrderResult";
    o.homeownerContractChangeOrder = maybeNew(
      "HomeownerContractChangeOrder",
      options.homeownerContractChangeOrder,
      cache,
      options.hasOwnProperty("homeownerContractChangeOrder"),
    );
    return o as FactoryResult<SaveHomeownerContractChangeOrderResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveHomeownerContractChangeOrderResult"] = newSaveHomeownerContractChangeOrderResult;

export interface ContractProjectFinancialsOptions {
  __typename?: "ContractProjectFinancials";
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  softCostBudgetInCents?: ContractProjectFinancials["softCostBudgetInCents"];
  directHardCostBudgetInCents?: ContractProjectFinancials["directHardCostBudgetInCents"];
  indirectHardCostBudgetInCents?: ContractProjectFinancials["indirectHardCostBudgetInCents"];
  totalMarkupInCents?: ContractProjectFinancials["totalMarkupInCents"];
}

export function newContractProjectFinancials(
  options?: ContractProjectFinancialsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ContractProjectFinancials>;
export function newContractProjectFinancials(
  options: ContractProjectFinancialsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ContractProjectFinancials> {
  const o = (options.__typename ? options : cache["ContractProjectFinancials"] = {}) as ContractProjectFinancials;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ContractProjectFinancials";
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.softCostBudgetInCents = options.softCostBudgetInCents ?? 0;
    o.directHardCostBudgetInCents = options.directHardCostBudgetInCents ?? 0;
    o.indirectHardCostBudgetInCents = options.indirectHardCostBudgetInCents ?? 0;
    o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
    return o as FactoryResult<ContractProjectFinancials>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ContractProjectFinancials"] = newContractProjectFinancials;

export interface HomeownerContractDrawOptions {
  __typename?: "HomeownerContractDraw";
  id?: HomeownerContractDraw["id"];
  parent?: HomeownerContractLike | FactoryResult<HomeownerContractLikeType> | HomeownerContractLikeOptions;
  task?: FactoryInput<Task, TaskOptions>;
  percent?: HomeownerContractDraw["percent"];
  amountInCents?: HomeownerContractDraw["amountInCents"];
  order?: HomeownerContractDraw["order"];
  isDrawn?: HomeownerContractDraw["isDrawn"];
  name?: HomeownerContractDraw["name"];
  description?: HomeownerContractDraw["description"];
  invoiceDrawLineItem?: FactoryInput<InvoiceDrawLineItem, InvoiceDrawLineItemOptions> | null;
}

export function newHomeownerContractDraw(
  options?: HomeownerContractDrawOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractDraw>;
export function newHomeownerContractDraw(
  options: HomeownerContractDrawOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeownerContractDraw> {
  const o = (options.__typename ? options : cache["HomeownerContractDraw"] = {}) as HomeownerContractDraw;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "HomeownerContractDraw";
    o.id = options.id ?? nextFactoryId("HomeownerContractDraw");
    o.parent = maybeNew("HomeownerContractLike", options.parent, cache, options.hasOwnProperty("parent"));
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    o.percent = options.percent ?? 0;
    o.amountInCents = options.amountInCents ?? 0;
    o.order = options.order ?? 0;
    o.isDrawn = options.isDrawn ?? false;
    o.name = options.name ?? "name";
    o.description = options.description ?? "description";
    o.invoiceDrawLineItem = maybeNewOrNull("InvoiceDrawLineItem", options.invoiceDrawLineItem, cache);
    return o as FactoryResult<HomeownerContractDraw>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["HomeownerContractDraw"] = newHomeownerContractDraw;

export interface HomeownerContractLineItemAllocationOptions {
  __typename?: "HomeownerContractLineItemAllocation";
  id?: HomeownerContractLineItemAllocation["id"];
  costInCents?: HomeownerContractLineItemAllocation["costInCents"];
  priceInCents?: HomeownerContractLineItemAllocation["priceInCents"];
  createdAt?: HomeownerContractLineItemAllocation["createdAt"];
  updatedAt?: HomeownerContractLineItemAllocation["updatedAt"];
  homeownerContractLineItem?: FactoryInput<HomeownerContractLineItem, HomeownerContractLineItemOptions>;
  projectItemAllocation?: FactoryInput<ProjectItemAllocation, ProjectItemAllocationOptions>;
  changeEventLineItemAllocation?:
    | FactoryInput<ChangeEventLineItemAllocation, ChangeEventLineItemAllocationOptions>
    | null;
}

export function newHomeownerContractLineItemAllocation(
  options?: HomeownerContractLineItemAllocationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractLineItemAllocation>;
export function newHomeownerContractLineItemAllocation(
  options: HomeownerContractLineItemAllocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeownerContractLineItemAllocation> {
  const o =
    (options.__typename
      ? options
      : cache["HomeownerContractLineItemAllocation"] = {}) as HomeownerContractLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "HomeownerContractLineItemAllocation";
    o.id = options.id ?? nextFactoryId("HomeownerContractLineItemAllocation");
    o.costInCents = options.costInCents ?? 0;
    o.priceInCents = options.priceInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.homeownerContractLineItem = maybeNew(
      "HomeownerContractLineItem",
      options.homeownerContractLineItem,
      cache,
      options.hasOwnProperty("homeownerContractLineItem"),
    );
    o.projectItemAllocation = maybeNew(
      "ProjectItemAllocation",
      options.projectItemAllocation,
      cache,
      options.hasOwnProperty("projectItemAllocation"),
    );
    o.changeEventLineItemAllocation = maybeNewOrNull(
      "ChangeEventLineItemAllocation",
      options.changeEventLineItemAllocation,
      cache,
    );
    return o as FactoryResult<HomeownerContractLineItemAllocation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["HomeownerContractLineItemAllocation"] = newHomeownerContractLineItemAllocation;

export interface HomeownerNoteOptions {
  __typename?: "HomeownerNote";
  id?: HomeownerNote["id"];
  title?: HomeownerNote["title"];
  description?: HomeownerNote["description"];
  jobLogImages?: Array<FactoryInput<JobLogImage, JobLogImageOptions>>;
  scheduleTasks?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  createdAt?: HomeownerNote["createdAt"];
  createdBy?: FactoryInput<User, UserOptions>;
  schedulePhases?: Array<FactoryInput<SchedulePhase, SchedulePhaseOptions>>;
}

export function newHomeownerNote(
  options?: HomeownerNoteOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerNote>;
export function newHomeownerNote(
  options: HomeownerNoteOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeownerNote> {
  const o = (options.__typename ? options : cache["HomeownerNote"] = {}) as HomeownerNote;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "HomeownerNote";
    o.id = options.id ?? nextFactoryId("HomeownerNote");
    o.title = options.title ?? "title";
    o.description = options.description ?? "description";
    o.jobLogImages = (options.jobLogImages ?? []).map((i) =>
      maybeNew("JobLogImage", i, cache, options.hasOwnProperty("jobLogImages"))
    );
    o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
    );
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.schedulePhases = (options.schedulePhases ?? []).map((i) =>
      maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("schedulePhases"))
    );
    return o as FactoryResult<HomeownerNote>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["HomeownerNote"] = newHomeownerNote;

export interface SaveHomeownerNoteResultOptions {
  __typename?: "SaveHomeownerNoteResult";
  homeownerNote?: FactoryInput<HomeownerNote, HomeownerNoteOptions>;
}

export function newSaveHomeownerNoteResult(
  options?: SaveHomeownerNoteResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveHomeownerNoteResult>;
export function newSaveHomeownerNoteResult(
  options: SaveHomeownerNoteResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveHomeownerNoteResult> {
  const o = (options.__typename ? options : cache["SaveHomeownerNoteResult"] = {}) as SaveHomeownerNoteResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveHomeownerNoteResult";
    o.homeownerNote = maybeNew("HomeownerNote", options.homeownerNote, cache, options.hasOwnProperty("homeownerNote"));
    return o as FactoryResult<SaveHomeownerNoteResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveHomeownerNoteResult"] = newSaveHomeownerNoteResult;

export interface InsideMapsRoomRenderingOptions {
  __typename?: "InsideMapsRoomRendering";
  id?: InsideMapsRoomRendering["id"];
  createdAt?: InsideMapsRoomRendering["createdAt"];
  updatedAt?: InsideMapsRoomRendering["updatedAt"];
  asset?: FactoryInput<Asset, AssetOptions> | null;
  readyPlanLocation?: FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>;
}

export function newInsideMapsRoomRendering(
  options?: InsideMapsRoomRenderingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InsideMapsRoomRendering>;
export function newInsideMapsRoomRendering(
  options: InsideMapsRoomRenderingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InsideMapsRoomRendering> {
  const o = (options.__typename ? options : cache["InsideMapsRoomRendering"] = {}) as InsideMapsRoomRendering;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InsideMapsRoomRendering";
    o.id = options.id ?? nextFactoryId("InsideMapsRoomRendering");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.asset = maybeNewOrNull("Asset", options.asset, cache);
    o.readyPlanLocation = maybeNew(
      "ReadyPlanLocation",
      options.readyPlanLocation,
      cache,
      options.hasOwnProperty("readyPlanLocation"),
    );
    return o as FactoryResult<InsideMapsRoomRendering>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InsideMapsRoomRendering"] = newInsideMapsRoomRendering;

export interface InternalUserOptions {
  __typename?: "InternalUser";
  id?: InternalUser["id"];
  name?: InternalUser["name"];
  email?: InternalUser["email"];
  avatar?: InternalUser["avatar"];
  projectRole?: InternalUser["projectRole"];
  projectRoleDetail?: ProjectRoleDetailOptions | ProjectRole | null;
  user?: FactoryInput<User, UserOptions>;
  approvals?: Array<FactoryInput<Approval, ApprovalOptions>>;
  approvers?: Array<FactoryInput<Approver, ApproverOptions>>;
  projectDashboardConfig?: FactoryInput<DashboardConfig, DashboardConfigOptions> | null;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  impersonateInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newInternalUser(
  options?: InternalUserOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InternalUser>;
export function newInternalUser(
  options: InternalUserOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InternalUser> {
  const o = (options.__typename ? options : cache["InternalUser"] = {}) as InternalUser;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InternalUser";
    o.id = options.id ?? nextFactoryId("InternalUser");
    o.name = options.name ?? "name";
    o.email = options.email ?? "email";
    o.avatar = options.avatar ?? "avatar";
    o.projectRole = options.projectRole ?? null;
    o.projectRoleDetail = enumOrDetailOrNullOfProjectRole(options.projectRoleDetail);
    o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
    o.approvals = (options.approvals ?? []).map((i) =>
      maybeNew("Approval", i, cache, options.hasOwnProperty("approvals"))
    );
    o.approvers = (options.approvers ?? []).map((i) =>
      maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
    );
    o.projectDashboardConfig = maybeNewOrNull("DashboardConfig", options.projectDashboardConfig, cache);
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    o.impersonateInternalUser = maybeNewOrNull("InternalUser", options.impersonateInternalUser, cache);
    return o as FactoryResult<InternalUser>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InternalUser"] = newInternalUser;

export interface SaveInternalUserResultOptions {
  __typename?: "SaveInternalUserResult";
  internalUser?: FactoryInput<InternalUser, InternalUserOptions>;
}

export function newSaveInternalUserResult(
  options?: SaveInternalUserResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveInternalUserResult>;
export function newSaveInternalUserResult(
  options: SaveInternalUserResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveInternalUserResult> {
  const o = (options.__typename ? options : cache["SaveInternalUserResult"] = {}) as SaveInternalUserResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveInternalUserResult";
    o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
    return o as FactoryResult<SaveInternalUserResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveInternalUserResult"] = newSaveInternalUserResult;

export interface DashboardConfigOptions {
  __typename?: "DashboardConfig";
  tileConfigs?: Array<FactoryInput<DashboardTileConfig, DashboardTileConfigOptions>> | null;
}

export function newDashboardConfig(
  options?: DashboardConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DashboardConfig>;
export function newDashboardConfig(
  options: DashboardConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DashboardConfig> {
  const o = (options.__typename ? options : cache["DashboardConfig"] = {}) as DashboardConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DashboardConfig";
    o.tileConfigs = (options.tileConfigs ?? []).map((i) =>
      maybeNew("DashboardTileConfig", i, cache, options.hasOwnProperty("tileConfigs"))
    );
    return o as FactoryResult<DashboardConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DashboardConfig"] = newDashboardConfig;

export interface DashboardTileConfigOptions {
  __typename?: "DashboardTileConfig";
  tile?: DashboardTileConfig["tile"];
  size?: DashboardTileConfig["size"];
}

export function newDashboardTileConfig(
  options?: DashboardTileConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DashboardTileConfig>;
export function newDashboardTileConfig(
  options: DashboardTileConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DashboardTileConfig> {
  const o = (options.__typename ? options : cache["DashboardTileConfig"] = {}) as DashboardTileConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DashboardTileConfig";
    o.tile = options.tile ?? DashboardTile.ProjectSchedule;
    o.size = options.size ?? DashboardTileSize.Small;
    return o as FactoryResult<DashboardTileConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DashboardTileConfig"] = newDashboardTileConfig;

export interface SaveInvoiceResultOptions {
  __typename?: "SaveInvoiceResult";
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
}

export function newSaveInvoiceResult(
  options?: SaveInvoiceResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveInvoiceResult>;
export function newSaveInvoiceResult(
  options: SaveInvoiceResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveInvoiceResult> {
  const o = (options.__typename ? options : cache["SaveInvoiceResult"] = {}) as SaveInvoiceResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveInvoiceResult";
    o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
    return o as FactoryResult<SaveInvoiceResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveInvoiceResult"] = newSaveInvoiceResult;

export interface SaveInvoicesResultOptions {
  __typename?: "SaveInvoicesResult";
  invoices?: Array<FactoryInput<Invoice, InvoiceOptions>>;
}

export function newSaveInvoicesResult(
  options?: SaveInvoicesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveInvoicesResult>;
export function newSaveInvoicesResult(
  options: SaveInvoicesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveInvoicesResult> {
  const o = (options.__typename ? options : cache["SaveInvoicesResult"] = {}) as SaveInvoicesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveInvoicesResult";
    o.invoices = (options.invoices ?? []).map((i) => maybeNew("Invoice", i, cache, options.hasOwnProperty("invoices")));
    return o as FactoryResult<SaveInvoicesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveInvoicesResult"] = newSaveInvoicesResult;

export interface InvoiceLineItemsByCostCodeOptions {
  __typename?: "InvoiceLineItemsByCostCode";
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  totalAmountInCents?: InvoiceLineItemsByCostCode["totalAmountInCents"];
  lineItems?: Array<FactoryInput<InvoiceLineItem, InvoiceLineItemOptions>>;
}

export function newInvoiceLineItemsByCostCode(
  options?: InvoiceLineItemsByCostCodeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceLineItemsByCostCode>;
export function newInvoiceLineItemsByCostCode(
  options: InvoiceLineItemsByCostCodeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceLineItemsByCostCode> {
  const o = (options.__typename ? options : cache["InvoiceLineItemsByCostCode"] = {}) as InvoiceLineItemsByCostCode;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceLineItemsByCostCode";
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.totalAmountInCents = options.totalAmountInCents ?? 0;
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    return o as FactoryResult<InvoiceLineItemsByCostCode>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceLineItemsByCostCode"] = newInvoiceLineItemsByCostCode;

export interface InvoiceLineItemOptions {
  __typename?: "InvoiceLineItem";
  id?: InvoiceLineItem["id"];
  amountInCents?: InvoiceLineItem["amountInCents"];
  marginInCents?: InvoiceLineItem["marginInCents"];
  homeownerContractLineItem?: FactoryInput<HomeownerContractLineItem, HomeownerContractLineItemOptions>;
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
  costLineItemAllocations?: Array<FactoryInput<CostLineItemAllocation, CostLineItemAllocationOptions>>;
  downPaymentInvoice?: FactoryInput<Invoice, InvoiceOptions> | null;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newInvoiceLineItem(
  options?: InvoiceLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceLineItem>;
export function newInvoiceLineItem(
  options: InvoiceLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceLineItem> {
  const o = (options.__typename ? options : cache["InvoiceLineItem"] = {}) as InvoiceLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceLineItem";
    o.id = options.id ?? nextFactoryId("InvoiceLineItem");
    o.amountInCents = options.amountInCents ?? 0;
    o.marginInCents = options.marginInCents ?? null;
    o.homeownerContractLineItem = maybeNew(
      "HomeownerContractLineItem",
      options.homeownerContractLineItem,
      cache,
      options.hasOwnProperty("homeownerContractLineItem"),
    );
    o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
    o.costLineItemAllocations = (options.costLineItemAllocations ?? []).map((i) =>
      maybeNew("CostLineItemAllocation", i, cache, options.hasOwnProperty("costLineItemAllocations"))
    );
    o.downPaymentInvoice = maybeNewOrNull("Invoice", options.downPaymentInvoice, cache);
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    return o as FactoryResult<InvoiceLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceLineItem"] = newInvoiceLineItem;

export interface InvoiceDrawLineItemOptions {
  __typename?: "InvoiceDrawLineItem";
  id?: InvoiceDrawLineItem["id"];
  draw?: FactoryInput<HomeownerContractDraw, HomeownerContractDrawOptions>;
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
}

export function newInvoiceDrawLineItem(
  options?: InvoiceDrawLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceDrawLineItem>;
export function newInvoiceDrawLineItem(
  options: InvoiceDrawLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceDrawLineItem> {
  const o = (options.__typename ? options : cache["InvoiceDrawLineItem"] = {}) as InvoiceDrawLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceDrawLineItem";
    o.id = options.id ?? nextFactoryId("InvoiceDrawLineItem");
    o.draw = maybeNew("HomeownerContractDraw", options.draw, cache, options.hasOwnProperty("draw"));
    o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
    return o as FactoryResult<InvoiceDrawLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceDrawLineItem"] = newInvoiceDrawLineItem;

export interface InvoiceScheduledLineItemOptions {
  __typename?: "InvoiceScheduledLineItem";
  id?: InvoiceScheduledLineItem["id"];
  amountInCents?: InvoiceScheduledLineItem["amountInCents"];
  amountInBasisPoints?: InvoiceScheduledLineItem["amountInBasisPoints"];
  marginInCents?: InvoiceScheduledLineItem["marginInCents"];
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
  invoiceScheduleItem?: FactoryInput<InvoiceScheduleItem, InvoiceScheduleItemOptions>;
  invoiceLineItems?: Array<FactoryInput<InvoiceLineItem, InvoiceLineItemOptions>>;
}

export function newInvoiceScheduledLineItem(
  options?: InvoiceScheduledLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceScheduledLineItem>;
export function newInvoiceScheduledLineItem(
  options: InvoiceScheduledLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceScheduledLineItem> {
  const o = (options.__typename ? options : cache["InvoiceScheduledLineItem"] = {}) as InvoiceScheduledLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceScheduledLineItem";
    o.id = options.id ?? nextFactoryId("InvoiceScheduledLineItem");
    o.amountInCents = options.amountInCents ?? 0;
    o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
    o.marginInCents = options.marginInCents ?? 0;
    o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
    o.invoiceScheduleItem = maybeNew(
      "InvoiceScheduleItem",
      options.invoiceScheduleItem,
      cache,
      options.hasOwnProperty("invoiceScheduleItem"),
    );
    o.invoiceLineItems = (options.invoiceLineItems ?? []).map((i) =>
      maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("invoiceLineItems"))
    );
    return o as FactoryResult<InvoiceScheduledLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceScheduledLineItem"] = newInvoiceScheduledLineItem;

export interface InvoiceAccruedLineItemOptions {
  __typename?: "InvoiceAccruedLineItem";
  id?: InvoiceAccruedLineItem["id"];
  amountInCents?: InvoiceAccruedLineItem["amountInCents"];
  marginInCents?: InvoiceAccruedLineItem["marginInCents"];
  createdAt?: InvoiceAccruedLineItem["createdAt"];
  updatedAt?: InvoiceAccruedLineItem["updatedAt"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType;
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
  invoiceCategory?: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | null;
}

export function newInvoiceAccruedLineItem(
  options?: InvoiceAccruedLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceAccruedLineItem>;
export function newInvoiceAccruedLineItem(
  options: InvoiceAccruedLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceAccruedLineItem> {
  const o = (options.__typename ? options : cache["InvoiceAccruedLineItem"] = {}) as InvoiceAccruedLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceAccruedLineItem";
    o.id = options.id ?? nextFactoryId("InvoiceAccruedLineItem");
    o.amountInCents = options.amountInCents ?? 0;
    o.marginInCents = options.marginInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costClassificationType = enumOrDetailOfCostClassificationType(options.costClassificationType);
    o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
    o.invoiceCategory = enumOrDetailOrNullOfCostCodeInvoiceCategory(options.invoiceCategory);
    return o as FactoryResult<InvoiceAccruedLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceAccruedLineItem"] = newInvoiceAccruedLineItem;

export interface InvoiceDisplayLineItemOptions {
  __typename?: "InvoiceDisplayLineItem";
  id?: InvoiceDisplayLineItem["id"];
  name?: InvoiceDisplayLineItem["name"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType | null;
  amountInCents?: InvoiceDisplayLineItem["amountInCents"];
  marginInCents?: InvoiceDisplayLineItem["marginInCents"];
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newInvoiceDisplayLineItem(
  options?: InvoiceDisplayLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceDisplayLineItem>;
export function newInvoiceDisplayLineItem(
  options: InvoiceDisplayLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceDisplayLineItem> {
  const o = (options.__typename ? options : cache["InvoiceDisplayLineItem"] = {}) as InvoiceDisplayLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceDisplayLineItem";
    o.id = options.id ?? nextFactoryId("InvoiceDisplayLineItem");
    o.name = options.name ?? "name";
    o.costClassificationType = enumOrDetailOrNullOfCostClassificationType(options.costClassificationType);
    o.amountInCents = options.amountInCents ?? 0;
    o.marginInCents = options.marginInCents ?? null;
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    return o as FactoryResult<InvoiceDisplayLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceDisplayLineItem"] = newInvoiceDisplayLineItem;

export interface InvoicesPageOptions {
  __typename?: "InvoicesPage";
  entities?: Array<FactoryInput<Invoice, InvoiceOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newInvoicesPage(
  options?: InvoicesPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoicesPage>;
export function newInvoicesPage(
  options: InvoicesPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoicesPage> {
  const o = (options.__typename ? options : cache["InvoicesPage"] = {}) as InvoicesPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoicesPage";
    o.entities = (options.entities ?? []).map((i) => maybeNew("Invoice", i, cache, options.hasOwnProperty("entities")));
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<InvoicesPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoicesPage"] = newInvoicesPage;

export interface InvoiceDocumentOptions {
  __typename?: "InvoiceDocument";
  id?: InvoiceDocument["id"];
  createdAt?: InvoiceDocument["createdAt"];
  updatedAt?: InvoiceDocument["updatedAt"];
  documentSource?: InvoiceDocumentSourceDetailOptions | InvoiceDocumentSource;
  document?: FactoryInput<Document, DocumentOptions>;
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
}

export function newInvoiceDocument(
  options?: InvoiceDocumentOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceDocument>;
export function newInvoiceDocument(
  options: InvoiceDocumentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceDocument> {
  const o = (options.__typename ? options : cache["InvoiceDocument"] = {}) as InvoiceDocument;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceDocument";
    o.id = options.id ?? nextFactoryId("InvoiceDocument");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.documentSource = enumOrDetailOfInvoiceDocumentSource(options.documentSource);
    o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
    o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
    return o as FactoryResult<InvoiceDocument>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceDocument"] = newInvoiceDocument;

export interface SaveInvoiceDocumentResultOptions {
  __typename?: "SaveInvoiceDocumentResult";
  invoiceDocument?: FactoryInput<InvoiceDocument, InvoiceDocumentOptions>;
}

export function newSaveInvoiceDocumentResult(
  options?: SaveInvoiceDocumentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveInvoiceDocumentResult>;
export function newSaveInvoiceDocumentResult(
  options: SaveInvoiceDocumentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveInvoiceDocumentResult> {
  const o = (options.__typename ? options : cache["SaveInvoiceDocumentResult"] = {}) as SaveInvoiceDocumentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveInvoiceDocumentResult";
    o.invoiceDocument = maybeNew(
      "InvoiceDocument",
      options.invoiceDocument,
      cache,
      options.hasOwnProperty("invoiceDocument"),
    );
    return o as FactoryResult<SaveInvoiceDocumentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveInvoiceDocumentResult"] = newSaveInvoiceDocumentResult;

export interface DeleteInvoiceScheduleResultOptions {
  __typename?: "DeleteInvoiceScheduleResult";
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
}

export function newDeleteInvoiceScheduleResult(
  options?: DeleteInvoiceScheduleResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteInvoiceScheduleResult>;
export function newDeleteInvoiceScheduleResult(
  options: DeleteInvoiceScheduleResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteInvoiceScheduleResult> {
  const o = (options.__typename ? options : cache["DeleteInvoiceScheduleResult"] = {}) as DeleteInvoiceScheduleResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteInvoiceScheduleResult";
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    return o as FactoryResult<DeleteInvoiceScheduleResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteInvoiceScheduleResult"] = newDeleteInvoiceScheduleResult;

export interface InvoiceScheduleOptions {
  __typename?: "InvoiceSchedule";
  id?: InvoiceSchedule["id"];
  softCostDayOfMonth?: InvoiceSchedule["softCostDayOfMonth"];
  hardCostDayOfMonth?: InvoiceSchedule["hardCostDayOfMonth"];
  hardCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  softCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  hardCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  softCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  invoiceScheduleTemplate?: FactoryInput<InvoiceScheduleTemplate, InvoiceScheduleTemplateOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  items?: Array<FactoryInput<InvoiceScheduleItem, InvoiceScheduleItemOptions>>;
  invoiceItemsIndependently?: InvoiceSchedule["invoiceItemsIndependently"];
}

export function newInvoiceSchedule(
  options?: InvoiceScheduleOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceSchedule>;
export function newInvoiceSchedule(
  options: InvoiceScheduleOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceSchedule> {
  const o = (options.__typename ? options : cache["InvoiceSchedule"] = {}) as InvoiceSchedule;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceSchedule";
    o.id = options.id ?? nextFactoryId("InvoiceSchedule");
    o.softCostDayOfMonth = options.softCostDayOfMonth ?? null;
    o.hardCostDayOfMonth = options.hardCostDayOfMonth ?? null;
    o.hardCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.hardCostAmountType);
    o.softCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.softCostAmountType);
    o.hardCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.hardCostTriggerType);
    o.softCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.softCostTriggerType);
    o.invoiceScheduleTemplate = maybeNew(
      "InvoiceScheduleTemplate",
      options.invoiceScheduleTemplate,
      cache,
      options.hasOwnProperty("invoiceScheduleTemplate"),
    );
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.items = (options.items ?? []).map((i) =>
      maybeNew("InvoiceScheduleItem", i, cache, options.hasOwnProperty("items"))
    );
    o.invoiceItemsIndependently = options.invoiceItemsIndependently ?? false;
    return o as FactoryResult<InvoiceSchedule>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceSchedule"] = newInvoiceSchedule;

export interface InvoiceScheduleItemOptions {
  __typename?: "InvoiceScheduleItem";
  id?: InvoiceScheduleItem["id"];
  order?: InvoiceScheduleItem["order"];
  iteration?: InvoiceScheduleItem["iteration"];
  invoiceDate?: InvoiceScheduleItem["invoiceDate"];
  amountInBasisPoints?: InvoiceScheduleItem["amountInBasisPoints"];
  originalAmountInCents?: InvoiceScheduleItem["originalAmountInCents"];
  changeOrderAmountInCents?: InvoiceScheduleItem["changeOrderAmountInCents"];
  revisedAmountInCents?: InvoiceScheduleItem["revisedAmountInCents"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType;
  invoiceScheduleItemFrequency?: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency;
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions>;
  parent?:
    | InvoiceScheduleItemParent
    | FactoryResult<InvoiceScheduleItemParent>
    | PlanMilestoneOptions
    | RequireTypename<ScheduleTaskOptions>
    | null;
  globalParent?:
    | InvoiceScheduleItemGlobalParent
    | FactoryResult<InvoiceScheduleItemGlobalParent>
    | GlobalPlanMilestoneOptions
    | RequireTypename<GlobalTaskOptions>;
  invoiceScheduledLineItems?: Array<FactoryInput<InvoiceScheduledLineItem, InvoiceScheduledLineItemOptions>>;
  changeOrders?: Array<FactoryInput<HomeownerContractChangeOrder, HomeownerContractChangeOrderOptions>>;
  invoiceDelayInDays?: InvoiceScheduleItem["invoiceDelayInDays"];
}

export function newInvoiceScheduleItem(
  options?: InvoiceScheduleItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceScheduleItem>;
export function newInvoiceScheduleItem(
  options: InvoiceScheduleItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceScheduleItem> {
  const o = (options.__typename ? options : cache["InvoiceScheduleItem"] = {}) as InvoiceScheduleItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceScheduleItem";
    o.id = options.id ?? nextFactoryId("InvoiceScheduleItem");
    o.order = options.order ?? 0;
    o.iteration = options.iteration ?? 0;
    o.invoiceDate = options.invoiceDate ?? null;
    o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
    o.originalAmountInCents = options.originalAmountInCents ?? 0;
    o.changeOrderAmountInCents = options.changeOrderAmountInCents ?? 0;
    o.revisedAmountInCents = options.revisedAmountInCents ?? 0;
    o.costClassificationType = enumOrDetailOfCostClassificationType(options.costClassificationType);
    o.invoiceScheduleItemFrequency = enumOrDetailOfInvoiceScheduleItemFrequency(options.invoiceScheduleItemFrequency);
    o.invoiceSchedule = maybeNew(
      "InvoiceSchedule",
      options.invoiceSchedule,
      cache,
      options.hasOwnProperty("invoiceSchedule"),
    );
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "PlanMilestone", options.parent, cache);
    o.globalParent = maybeNew(options.globalParent?.__typename ?? "GlobalPlanMilestone", options.globalParent, cache);
    o.invoiceScheduledLineItems = (options.invoiceScheduledLineItems ?? []).map((i) =>
      maybeNew("InvoiceScheduledLineItem", i, cache, options.hasOwnProperty("invoiceScheduledLineItems"))
    );
    o.changeOrders = (options.changeOrders ?? []).map((i) =>
      maybeNew("HomeownerContractChangeOrder", i, cache, options.hasOwnProperty("changeOrders"))
    );
    o.invoiceDelayInDays = options.invoiceDelayInDays ?? 0;
    return o as FactoryResult<InvoiceScheduleItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceScheduleItem"] = newInvoiceScheduleItem;

export interface InvoiceScheduleTemplateOptions {
  __typename?: "InvoiceScheduleTemplate";
  id?: InvoiceScheduleTemplate["id"];
  name?: InvoiceScheduleTemplate["name"];
  softCostDayOfMonth?: InvoiceScheduleTemplate["softCostDayOfMonth"];
  hardCostDayOfMonth?: InvoiceScheduleTemplate["hardCostDayOfMonth"];
  createdAt?: InvoiceScheduleTemplate["createdAt"];
  updatedAt?: InvoiceScheduleTemplate["updatedAt"];
  hardCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  softCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  hardCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  softCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  customer?: FactoryInput<Customer, CustomerOptions> | null;
  items?: Array<FactoryInput<InvoiceScheduleTemplateItem, InvoiceScheduleTemplateItemOptions>>;
  invoiceSchedules?: Array<FactoryInput<InvoiceSchedule, InvoiceScheduleOptions>>;
  regions?: Array<FactoryInput<Region, RegionOptions>>;
  invoiceItemsIndependently?: InvoiceScheduleTemplate["invoiceItemsIndependently"];
}

export function newInvoiceScheduleTemplate(
  options?: InvoiceScheduleTemplateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceScheduleTemplate>;
export function newInvoiceScheduleTemplate(
  options: InvoiceScheduleTemplateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceScheduleTemplate> {
  const o = (options.__typename ? options : cache["InvoiceScheduleTemplate"] = {}) as InvoiceScheduleTemplate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceScheduleTemplate";
    o.id = options.id ?? nextFactoryId("InvoiceScheduleTemplate");
    o.name = options.name ?? "name";
    o.softCostDayOfMonth = options.softCostDayOfMonth ?? null;
    o.hardCostDayOfMonth = options.hardCostDayOfMonth ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.hardCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.hardCostAmountType);
    o.softCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.softCostAmountType);
    o.hardCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.hardCostTriggerType);
    o.softCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.softCostTriggerType);
    o.lotType = enumOrDetailOfLotType(options.lotType);
    o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
    o.customer = maybeNewOrNull("Customer", options.customer, cache);
    o.items = (options.items ?? []).map((i) =>
      maybeNew("InvoiceScheduleTemplateItem", i, cache, options.hasOwnProperty("items"))
    );
    o.invoiceSchedules = (options.invoiceSchedules ?? []).map((i) =>
      maybeNew("InvoiceSchedule", i, cache, options.hasOwnProperty("invoiceSchedules"))
    );
    o.regions = (options.regions ?? []).map((i) => maybeNew("Region", i, cache, options.hasOwnProperty("regions")));
    o.invoiceItemsIndependently = options.invoiceItemsIndependently ?? false;
    return o as FactoryResult<InvoiceScheduleTemplate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceScheduleTemplate"] = newInvoiceScheduleTemplate;

export interface SaveInvoiceScheduleTemplateResultOptions {
  __typename?: "SaveInvoiceScheduleTemplateResult";
  invoiceScheduleTemplate?: FactoryInput<InvoiceScheduleTemplate, InvoiceScheduleTemplateOptions>;
}

export function newSaveInvoiceScheduleTemplateResult(
  options?: SaveInvoiceScheduleTemplateResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveInvoiceScheduleTemplateResult>;
export function newSaveInvoiceScheduleTemplateResult(
  options: SaveInvoiceScheduleTemplateResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveInvoiceScheduleTemplateResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveInvoiceScheduleTemplateResult"] = {}) as SaveInvoiceScheduleTemplateResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveInvoiceScheduleTemplateResult";
    o.invoiceScheduleTemplate = maybeNew(
      "InvoiceScheduleTemplate",
      options.invoiceScheduleTemplate,
      cache,
      options.hasOwnProperty("invoiceScheduleTemplate"),
    );
    return o as FactoryResult<SaveInvoiceScheduleTemplateResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveInvoiceScheduleTemplateResult"] = newSaveInvoiceScheduleTemplateResult;

export interface InvoiceScheduleTemplateItemOptions {
  __typename?: "InvoiceScheduleTemplateItem";
  id?: InvoiceScheduleTemplateItem["id"];
  iterations?: InvoiceScheduleTemplateItem["iterations"];
  amountInBasisPoints?: InvoiceScheduleTemplateItem["amountInBasisPoints"];
  createdAt?: InvoiceScheduleTemplateItem["createdAt"];
  updatedAt?: InvoiceScheduleTemplateItem["updatedAt"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType;
  frequency?: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency;
  globalTask?: FactoryInput<GlobalTask, GlobalTaskOptions> | null;
  invoiceScheduleTemplate?: FactoryInput<InvoiceScheduleTemplate, InvoiceScheduleTemplateOptions>;
  globalPlanMilestone?: FactoryInput<GlobalPlanMilestone, GlobalPlanMilestoneOptions>;
  invoiceDelayInDays?: InvoiceScheduleTemplateItem["invoiceDelayInDays"];
}

export function newInvoiceScheduleTemplateItem(
  options?: InvoiceScheduleTemplateItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceScheduleTemplateItem>;
export function newInvoiceScheduleTemplateItem(
  options: InvoiceScheduleTemplateItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InvoiceScheduleTemplateItem> {
  const o = (options.__typename ? options : cache["InvoiceScheduleTemplateItem"] = {}) as InvoiceScheduleTemplateItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InvoiceScheduleTemplateItem";
    o.id = options.id ?? nextFactoryId("InvoiceScheduleTemplateItem");
    o.iterations = options.iterations ?? 0;
    o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costClassificationType = enumOrDetailOfCostClassificationType(options.costClassificationType);
    o.frequency = enumOrDetailOfInvoiceScheduleItemFrequency(options.frequency);
    o.globalTask = maybeNewOrNull("GlobalTask", options.globalTask, cache);
    o.invoiceScheduleTemplate = maybeNew(
      "InvoiceScheduleTemplate",
      options.invoiceScheduleTemplate,
      cache,
      options.hasOwnProperty("invoiceScheduleTemplate"),
    );
    o.globalPlanMilestone = maybeNew(
      "GlobalPlanMilestone",
      options.globalPlanMilestone,
      cache,
      options.hasOwnProperty("globalPlanMilestone"),
    );
    o.invoiceDelayInDays = options.invoiceDelayInDays ?? 0;
    return o as FactoryResult<InvoiceScheduleTemplateItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InvoiceScheduleTemplateItem"] = newInvoiceScheduleTemplateItem;

export interface ItemOptions {
  __typename?: "Item";
  id?: Item["id"];
  name?: Item["name"];
  displayName?: Item["displayName"];
  shortName?: Item["shortName"];
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  itemCode?: Item["itemCode"];
  fullCode?: Item["fullCode"];
  status?: ItemStatusDetailOptions | ItemStatus;
  internalNote?: Item["internalNote"];
  specifications?: Item["specifications"];
  tradePartnerNote?: Item["tradePartnerNote"];
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  tradeCategory?: FactoryInput<TradeCategory, TradeCategoryOptions> | null;
  bidItems?: Array<FactoryInput<BidItem, BidItemOptions>>;
  isContingency?: Item["isContingency"];
  materialAttributeDimensions?: Array<FactoryInput<MaterialAttributeDimension, MaterialAttributeDimensionOptions>>;
  materialListings?: Array<FactoryInput<MaterialListing, MaterialListingOptions>>;
  materialBrands?: Array<FactoryInput<MaterialBrand, MaterialBrandOptions>>;
  materialCodePrefix?: Item["materialCodePrefix"];
  placeholderMaterialListing?: FactoryInput<MaterialListing, MaterialListingOptions> | null;
  isAnnotated?: Item["isAnnotated"];
  planTaskMappings?: Array<FactoryInput<ItemPlanTaskMapping, ItemPlanTaskMappingOptions>>;
  version?: Item["version"];
  materialNameFormat?: Item["materialNameFormat"];
  designPackageLocation?: DesignPackageLocationDetailOptions | DesignPackageLocation;
  isMaterialModifier?: Item["isMaterialModifier"];
  isAssemblyRelated?: Item["isAssemblyRelated"];
  parentModifierItems?: Array<FactoryInput<Item, ItemOptions>>;
  childModifierItems?: Array<FactoryInput<Item, ItemOptions>>;
  canBecomeMaterialModifier?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  optionPricingConfig?: FactoryInput<OptionPricingConfig, OptionPricingConfigOptions> | null;
  materialLeadTimeConfig?: FactoryInput<MaterialLeadTimeConfig, MaterialLeadTimeConfigOptions> | null;
  minLeadTimeInDays?: Item["minLeadTimeInDays"];
  expectedLeadTimeInDays?: Item["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: Item["maxLeadTimeInDays"];
  history?: Array<FactoryInput<History, HistoryOptions>>;
  isPlanBasedCost?: Item["isPlanBasedCost"];
  finishScheduleOrder?: Item["finishScheduleOrder"];
}

export function newItem(options?: ItemOptions, factoryOptions?: FactoryOptions): FactoryResult<Item>;
export function newItem(
  options: ItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Item> {
  const o = (options.__typename ? options : cache["Item"] = {}) as Item;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Item";
    o.id = options.id ?? nextFactoryId("Item");
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.shortName = options.shortName ?? "shortName";
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.itemCode = options.itemCode ?? 0;
    o.fullCode = options.fullCode ?? "fullCode";
    o.status = enumOrDetailOfItemStatus(options.status);
    o.internalNote = options.internalNote ?? null;
    o.specifications = options.specifications ?? null;
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.tradeCategory = maybeNewOrNull("TradeCategory", options.tradeCategory, cache);
    o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
    o.isContingency = options.isContingency ?? null;
    o.materialAttributeDimensions = (options.materialAttributeDimensions ?? []).map((i) =>
      maybeNew("MaterialAttributeDimension", i, cache, options.hasOwnProperty("materialAttributeDimensions"))
    );
    o.materialListings = (options.materialListings ?? []).map((i) =>
      maybeNew("MaterialListing", i, cache, options.hasOwnProperty("materialListings"))
    );
    o.materialBrands = (options.materialBrands ?? []).map((i) =>
      maybeNew("MaterialBrand", i, cache, options.hasOwnProperty("materialBrands"))
    );
    o.materialCodePrefix = options.materialCodePrefix ?? null;
    o.placeholderMaterialListing = maybeNewOrNull("MaterialListing", options.placeholderMaterialListing, cache);
    o.isAnnotated = options.isAnnotated ?? false;
    o.planTaskMappings = (options.planTaskMappings ?? []).map((i) =>
      maybeNew("ItemPlanTaskMapping", i, cache, options.hasOwnProperty("planTaskMappings"))
    );
    o.version = options.version ?? 0;
    o.materialNameFormat = options.materialNameFormat ?? null;
    o.designPackageLocation = enumOrDetailOfDesignPackageLocation(options.designPackageLocation);
    o.isMaterialModifier = options.isMaterialModifier ?? false;
    o.isAssemblyRelated = options.isAssemblyRelated ?? false;
    o.parentModifierItems = (options.parentModifierItems ?? []).map((i) =>
      maybeNew("Item", i, cache, options.hasOwnProperty("parentModifierItems"))
    );
    o.childModifierItems = (options.childModifierItems ?? []).map((i) =>
      maybeNew("Item", i, cache, options.hasOwnProperty("childModifierItems"))
    );
    o.canBecomeMaterialModifier = maybeNew(
      "PotentialOperation2",
      options.canBecomeMaterialModifier,
      cache,
      options.hasOwnProperty("canBecomeMaterialModifier"),
    );
    o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
    o.materialLeadTimeConfig = maybeNewOrNull("MaterialLeadTimeConfig", options.materialLeadTimeConfig, cache);
    o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
    o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
    o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.isPlanBasedCost = options.isPlanBasedCost ?? false;
    o.finishScheduleOrder = options.finishScheduleOrder ?? 0;
    return o as FactoryResult<Item>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Item"] = newItem;

export interface ItemPlanTaskMappingOptions {
  __typename?: "ItemPlanTaskMapping";
  id?: ItemPlanTaskMapping["id"];
  createdAt?: ItemPlanTaskMapping["createdAt"];
  updatedAt?: ItemPlanTaskMapping["updatedAt"];
  item?: FactoryInput<Item, ItemOptions>;
  location?: FactoryInput<Location, LocationOptions> | null;
  task?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
  estimatedLaborCostInCents?: ItemPlanTaskMapping["estimatedLaborCostInCents"];
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions> | null;
}

export function newItemPlanTaskMapping(
  options?: ItemPlanTaskMappingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemPlanTaskMapping>;
export function newItemPlanTaskMapping(
  options: ItemPlanTaskMappingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemPlanTaskMapping> {
  const o = (options.__typename ? options : cache["ItemPlanTaskMapping"] = {}) as ItemPlanTaskMapping;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemPlanTaskMapping";
    o.id = options.id ?? nextFactoryId("ItemPlanTaskMapping");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.location = maybeNewOrNull("Location", options.location, cache);
    o.task = maybeNew("GlobalPlanTask", options.task, cache, options.hasOwnProperty("task"));
    o.estimatedLaborCostInCents = options.estimatedLaborCostInCents ?? null;
    o.unitOfMeasure = maybeNewOrNull("UnitOfMeasure", options.unitOfMeasure, cache);
    return o as FactoryResult<ItemPlanTaskMapping>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemPlanTaskMapping"] = newItemPlanTaskMapping;

export interface SaveItemPlanTaskMappingResultOptions {
  __typename?: "SaveItemPlanTaskMappingResult";
  itemPlanTaskMapping?: FactoryInput<ItemPlanTaskMapping, ItemPlanTaskMappingOptions>;
}

export function newSaveItemPlanTaskMappingResult(
  options?: SaveItemPlanTaskMappingResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveItemPlanTaskMappingResult>;
export function newSaveItemPlanTaskMappingResult(
  options: SaveItemPlanTaskMappingResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveItemPlanTaskMappingResult> {
  const o =
    (options.__typename ? options : cache["SaveItemPlanTaskMappingResult"] = {}) as SaveItemPlanTaskMappingResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveItemPlanTaskMappingResult";
    o.itemPlanTaskMapping = maybeNew(
      "ItemPlanTaskMapping",
      options.itemPlanTaskMapping,
      cache,
      options.hasOwnProperty("itemPlanTaskMapping"),
    );
    return o as FactoryResult<SaveItemPlanTaskMappingResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveItemPlanTaskMappingResult"] = newSaveItemPlanTaskMappingResult;

export interface ItemPlanTaskMappingPageOptions {
  __typename?: "ItemPlanTaskMappingPage";
  entities?: Array<FactoryInput<ItemPlanTaskMapping, ItemPlanTaskMappingOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newItemPlanTaskMappingPage(
  options?: ItemPlanTaskMappingPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemPlanTaskMappingPage>;
export function newItemPlanTaskMappingPage(
  options: ItemPlanTaskMappingPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemPlanTaskMappingPage> {
  const o = (options.__typename ? options : cache["ItemPlanTaskMappingPage"] = {}) as ItemPlanTaskMappingPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemPlanTaskMappingPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ItemPlanTaskMapping", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ItemPlanTaskMappingPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemPlanTaskMappingPage"] = newItemPlanTaskMappingPage;

export interface ItemSlotOptions {
  __typename?: "ItemSlot";
  id?: ItemSlot["id"];
  name?: ItemSlot["name"];
  createdAt?: ItemSlot["createdAt"];
  updatedAt?: ItemSlot["updatedAt"];
  costType?: ItemSlot["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  item?: FactoryInput<Item, ItemOptions>;
  location?: FactoryInput<Location, LocationOptions>;
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
}

export function newItemSlot(options?: ItemSlotOptions, factoryOptions?: FactoryOptions): FactoryResult<ItemSlot>;
export function newItemSlot(
  options: ItemSlotOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemSlot> {
  const o = (options.__typename ? options : cache["ItemSlot"] = {}) as ItemSlot;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemSlot";
    o.id = options.id ?? nextFactoryId("ItemSlot");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costType = options.costType ?? CostType.Labor;
    o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    return o as FactoryResult<ItemSlot>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemSlot"] = newItemSlot;

export interface SaveItemSlotResultOptions {
  __typename?: "SaveItemSlotResult";
  itemSlot?: FactoryInput<ItemSlot, ItemSlotOptions>;
}

export function newSaveItemSlotResult(
  options?: SaveItemSlotResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveItemSlotResult>;
export function newSaveItemSlotResult(
  options: SaveItemSlotResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveItemSlotResult> {
  const o = (options.__typename ? options : cache["SaveItemSlotResult"] = {}) as SaveItemSlotResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveItemSlotResult";
    o.itemSlot = maybeNew("ItemSlot", options.itemSlot, cache, options.hasOwnProperty("itemSlot"));
    return o as FactoryResult<SaveItemSlotResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveItemSlotResult"] = newSaveItemSlotResult;

export interface ItemTemplateOptions {
  __typename?: "ItemTemplate";
  id?: ItemTemplate["id"];
  name?: ItemTemplate["name"];
  createdAt?: ItemTemplate["createdAt"];
  updatedAt?: ItemTemplate["updatedAt"];
  items?: Array<FactoryInput<ItemTemplateItem, ItemTemplateItemOptions>>;
  status?: ItemTemplate["status"];
  statusDetail?: ItemTemplateStatusDetailOptions | ItemTemplateStatus;
  isPlanTemplate?: ItemTemplate["isPlanTemplate"];
  stage?: ItemTemplate["stage"];
  stageDetail?: StageDetailOptions | Stage;
  description?: ItemTemplate["description"];
  applyTemplatePlan?: Array<FactoryInput<ItemTemplateItemPlan, ItemTemplateItemPlanOptions>>;
  applyTemplatePlanChangeEvent?: Array<FactoryInput<ItemTemplateItemPlan, ItemTemplateItemPlanOptions>>;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  specOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  totalCostInCents?: ItemTemplate["totalCostInCents"];
  isReadyHomeTemplate?: ItemTemplate["isReadyHomeTemplate"];
  canCopyItemsToTemplate?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canApplyTo?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canUnlock?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canActivate?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canCreateNewVersion?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditLineItems?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions> | null;
  displayName?: ItemTemplate["displayName"];
  hasCloneToTargets?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  cloneToTargets?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  activatedAt?: ItemTemplate["activatedAt"];
  archivedAt?: ItemTemplate["archivedAt"];
  collection?: FactoryInput<ItemTemplateCollection, ItemTemplateCollectionOptions> | null;
  itemVersions?: Array<FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>>;
  major?: ItemTemplate["major"];
  minor?: ItemTemplate["minor"];
  scopeChangeType?: ItemTemplate["scopeChangeType"];
  scopeChangeTypeDetail?: ScopeChangeTypeDetailOptions | ScopeChangeType;
  scopeChangeReason?: FactoryInput<ScopeChangeReason, ScopeChangeReasonOptions> | null;
  basedOn?: FactoryInput<ItemTemplate, ItemTemplateOptions> | null;
  templatesBasedOn?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  isVersioned?: ItemTemplate["isVersioned"];
  isLocked?: ItemTemplate["isLocked"];
  appliedToCount?: ItemTemplate["appliedToCount"];
  isLatest?: ItemTemplate["isLatest"];
  isLatestActive?: ItemTemplate["isLatestActive"];
  scopeChangeReasonNote?: ItemTemplate["scopeChangeReasonNote"];
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  version?: ItemTemplate["version"];
  displayVersion?: ItemTemplate["displayVersion"];
  anomalies?: Array<FactoryInput<ItemTemplateAnomaly, ItemTemplateAnomalyOptions>>;
  contingencyMarkupPercentage?: ItemTemplate["contingencyMarkupPercentage"];
  hasContingencyLineItem?: ItemTemplate["hasContingencyLineItem"];
  sourceForApprovals?: Array<FactoryInput<Approval, ApprovalOptions>>;
  isUnderwritingTemplate?: ItemTemplate["isUnderwritingTemplate"];
  lastUsedAsUnderwritingTemplate?: ItemTemplate["lastUsedAsUnderwritingTemplate"];
  itemLocations?: Array<FactoryInput<Location, LocationOptions>>;
  tradeCategories?: Array<FactoryInput<TradeCategory, TradeCategoryOptions>>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
}

export function newItemTemplate(
  options?: ItemTemplateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplate>;
export function newItemTemplate(
  options: ItemTemplateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplate> {
  const o = (options.__typename ? options : cache["ItemTemplate"] = {}) as ItemTemplate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplate";
    o.id = options.id ?? nextFactoryId("ItemTemplate");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.items = (options.items ?? []).map((i) => maybeNew("ItemTemplateItem", i, cache, options.hasOwnProperty("items")));
    o.status = options.status ?? ItemTemplateStatus.Draft;
    o.statusDetail = enumOrDetailOfItemTemplateStatus(options.statusDetail);
    o.isPlanTemplate = options.isPlanTemplate ?? false;
    o.stage = options.stage ?? Stage.PreConPlanning;
    o.stageDetail = enumOrDetailOfStage(options.stageDetail);
    o.description = options.description ?? null;
    o.applyTemplatePlan = (options.applyTemplatePlan ?? []).map((i) =>
      maybeNew("ItemTemplateItemPlan", i, cache, options.hasOwnProperty("applyTemplatePlan"))
    );
    o.applyTemplatePlanChangeEvent = (options.applyTemplatePlanChangeEvent ?? []).map((i) =>
      maybeNew("ItemTemplateItemPlan", i, cache, options.hasOwnProperty("applyTemplatePlanChangeEvent"))
    );
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.specOptions = (options.specOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("specOptions"))
    );
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.isReadyHomeTemplate = options.isReadyHomeTemplate ?? false;
    o.canCopyItemsToTemplate = maybeNew(
      "PotentialOperation2",
      options.canCopyItemsToTemplate,
      cache,
      options.hasOwnProperty("canCopyItemsToTemplate"),
    );
    o.canApplyTo = maybeNew("PotentialOperation2", options.canApplyTo, cache, options.hasOwnProperty("canApplyTo"));
    o.canUnlock = maybeNew("PotentialOperation2", options.canUnlock, cache, options.hasOwnProperty("canUnlock"));
    o.canActivate = maybeNew("PotentialOperation2", options.canActivate, cache, options.hasOwnProperty("canActivate"));
    o.canCreateNewVersion = maybeNew(
      "PotentialOperation2",
      options.canCreateNewVersion,
      cache,
      options.hasOwnProperty("canCreateNewVersion"),
    );
    o.canEditLineItems = maybeNew(
      "PotentialOperation2",
      options.canEditLineItems,
      cache,
      options.hasOwnProperty("canEditLineItems"),
    );
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.readyPlan = maybeNewOrNull("ReadyPlan", options.readyPlan, cache);
    o.displayName = options.displayName ?? "displayName";
    o.hasCloneToTargets = maybeNew(
      "PotentialOperation2",
      options.hasCloneToTargets,
      cache,
      options.hasOwnProperty("hasCloneToTargets"),
    );
    o.cloneToTargets = (options.cloneToTargets ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("cloneToTargets"))
    );
    o.activatedAt = options.activatedAt ?? null;
    o.archivedAt = options.archivedAt ?? null;
    o.collection = maybeNewOrNull("ItemTemplateCollection", options.collection, cache);
    o.itemVersions = (options.itemVersions ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("itemVersions"))
    );
    o.major = options.major ?? 0;
    o.minor = options.minor ?? 0;
    o.scopeChangeType = options.scopeChangeType ?? ScopeChangeType.None;
    o.scopeChangeTypeDetail = enumOrDetailOfScopeChangeType(options.scopeChangeTypeDetail);
    o.scopeChangeReason = maybeNewOrNull("ScopeChangeReason", options.scopeChangeReason, cache);
    o.basedOn = maybeNewOrNull("ItemTemplate", options.basedOn, cache);
    o.templatesBasedOn = (options.templatesBasedOn ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("templatesBasedOn"))
    );
    o.isVersioned = options.isVersioned ?? false;
    o.isLocked = options.isLocked ?? false;
    o.appliedToCount = options.appliedToCount ?? 0;
    o.isLatest = options.isLatest ?? false;
    o.isLatestActive = options.isLatestActive ?? false;
    o.scopeChangeReasonNote = options.scopeChangeReasonNote ?? null;
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.version = options.version ?? "version";
    o.displayVersion = options.displayVersion ?? "displayVersion";
    o.anomalies = (options.anomalies ?? []).map((i) =>
      maybeNew("ItemTemplateAnomaly", i, cache, options.hasOwnProperty("anomalies"))
    );
    o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
    o.hasContingencyLineItem = options.hasContingencyLineItem ?? false;
    o.sourceForApprovals = (options.sourceForApprovals ?? []).map((i) =>
      maybeNew("Approval", i, cache, options.hasOwnProperty("sourceForApprovals"))
    );
    o.isUnderwritingTemplate = options.isUnderwritingTemplate ?? false;
    o.lastUsedAsUnderwritingTemplate = options.lastUsedAsUnderwritingTemplate ?? null;
    o.itemLocations = (options.itemLocations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
    );
    o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
      maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    return o as FactoryResult<ItemTemplate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplate"] = newItemTemplate;

export interface ItemTemplateItemPlanOptions {
  __typename?: "ItemTemplateItemPlan";
  itemTemplateItem?: FactoryInput<ItemTemplateItem, ItemTemplateItemOptions>;
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions> | null;
}

export function newItemTemplateItemPlan(
  options?: ItemTemplateItemPlanOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemPlan>;
export function newItemTemplateItemPlan(
  options: ItemTemplateItemPlanOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateItemPlan> {
  const o = (options.__typename ? options : cache["ItemTemplateItemPlan"] = {}) as ItemTemplateItemPlan;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateItemPlan";
    o.itemTemplateItem = maybeNew(
      "ItemTemplateItem",
      options.itemTemplateItem,
      cache,
      options.hasOwnProperty("itemTemplateItem"),
    );
    o.projectItem = maybeNewOrNull("ProjectItem", options.projectItem, cache);
    return o as FactoryResult<ItemTemplateItemPlan>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateItemPlan"] = newItemTemplateItemPlan;

export interface SaveItemTemplateResultOptions {
  __typename?: "SaveItemTemplateResult";
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newSaveItemTemplateResult(
  options?: SaveItemTemplateResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveItemTemplateResult>;
export function newSaveItemTemplateResult(
  options: SaveItemTemplateResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveItemTemplateResult> {
  const o = (options.__typename ? options : cache["SaveItemTemplateResult"] = {}) as SaveItemTemplateResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveItemTemplateResult";
    o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
    return o as FactoryResult<SaveItemTemplateResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveItemTemplateResult"] = newSaveItemTemplateResult;

export interface SaveItemTemplatesResultOptions {
  __typename?: "SaveItemTemplatesResult";
  itemTemplates?: Array<Maybe<FactoryInput<ItemTemplate, ItemTemplateOptions>>> | null;
}

export function newSaveItemTemplatesResult(
  options?: SaveItemTemplatesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveItemTemplatesResult>;
export function newSaveItemTemplatesResult(
  options: SaveItemTemplatesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveItemTemplatesResult> {
  const o = (options.__typename ? options : cache["SaveItemTemplatesResult"] = {}) as SaveItemTemplatesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveItemTemplatesResult";
    o.itemTemplates = (options.itemTemplates ?? []).map((i) => maybeNewOrNull("ItemTemplate", i, cache));
    return o as FactoryResult<SaveItemTemplatesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveItemTemplatesResult"] = newSaveItemTemplatesResult;

export interface ApplyItemTemplateResultOptions {
  __typename?: "ApplyItemTemplateResult";
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  userErrors?: Array<FactoryInput<UserError, UserErrorOptions>> | null;
}

export function newApplyItemTemplateResult(
  options?: ApplyItemTemplateResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ApplyItemTemplateResult>;
export function newApplyItemTemplateResult(
  options: ApplyItemTemplateResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ApplyItemTemplateResult> {
  const o = (options.__typename ? options : cache["ApplyItemTemplateResult"] = {}) as ApplyItemTemplateResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ApplyItemTemplateResult";
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.userErrors = (options.userErrors ?? []).map((i) =>
      maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
    );
    return o as FactoryResult<ApplyItemTemplateResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ApplyItemTemplateResult"] = newApplyItemTemplateResult;

export interface ApplyItemTemplateToChangeEventResultOptions {
  __typename?: "ApplyItemTemplateToChangeEventResult";
  lineItems?: Array<FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>>;
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newApplyItemTemplateToChangeEventResult(
  options?: ApplyItemTemplateToChangeEventResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ApplyItemTemplateToChangeEventResult>;
export function newApplyItemTemplateToChangeEventResult(
  options: ApplyItemTemplateToChangeEventResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ApplyItemTemplateToChangeEventResult> {
  const o =
    (options.__typename
      ? options
      : cache["ApplyItemTemplateToChangeEventResult"] = {}) as ApplyItemTemplateToChangeEventResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ApplyItemTemplateToChangeEventResult";
    o.lineItems = (options.lineItems ?? []).map((i) =>
      maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("lineItems"))
    );
    o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
    return o as FactoryResult<ApplyItemTemplateToChangeEventResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ApplyItemTemplateToChangeEventResult"] = newApplyItemTemplateToChangeEventResult;

export interface CloneItemTemplateResultOptions {
  __typename?: "CloneItemTemplateResult";
  original?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  clone?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newCloneItemTemplateResult(
  options?: CloneItemTemplateResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CloneItemTemplateResult>;
export function newCloneItemTemplateResult(
  options: CloneItemTemplateResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CloneItemTemplateResult> {
  const o = (options.__typename ? options : cache["CloneItemTemplateResult"] = {}) as CloneItemTemplateResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CloneItemTemplateResult";
    o.original = maybeNew("ItemTemplate", options.original, cache, options.hasOwnProperty("original"));
    o.clone = maybeNew("ItemTemplate", options.clone, cache, options.hasOwnProperty("clone"));
    return o as FactoryResult<CloneItemTemplateResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CloneItemTemplateResult"] = newCloneItemTemplateResult;

export interface CopyItemTemplateItemsResultOptions {
  __typename?: "CopyItemTemplateItemsResult";
  targetTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  sourceTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  sourceItemVersions?: Array<FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>>;
  copiedItems?: Array<FactoryInput<ItemTemplateItem, ItemTemplateItemOptions>>;
  copiedItemVersions?: Array<FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>>;
}

export function newCopyItemTemplateItemsResult(
  options?: CopyItemTemplateItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CopyItemTemplateItemsResult>;
export function newCopyItemTemplateItemsResult(
  options: CopyItemTemplateItemsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CopyItemTemplateItemsResult> {
  const o = (options.__typename ? options : cache["CopyItemTemplateItemsResult"] = {}) as CopyItemTemplateItemsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CopyItemTemplateItemsResult";
    o.targetTemplate = maybeNew(
      "ItemTemplate",
      options.targetTemplate,
      cache,
      options.hasOwnProperty("targetTemplate"),
    );
    o.sourceTemplates = (options.sourceTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("sourceTemplates"))
    );
    o.sourceItemVersions = (options.sourceItemVersions ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("sourceItemVersions"))
    );
    o.copiedItems = (options.copiedItems ?? []).map((i) =>
      maybeNew("ItemTemplateItem", i, cache, options.hasOwnProperty("copiedItems"))
    );
    o.copiedItemVersions = (options.copiedItemVersions ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("copiedItemVersions"))
    );
    return o as FactoryResult<CopyItemTemplateItemsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CopyItemTemplateItemsResult"] = newCopyItemTemplateItemsResult;

export interface CreateNewItemTemplateVersionsResultOptions {
  __typename?: "CreateNewItemTemplateVersionsResult";
  newTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
}

export function newCreateNewItemTemplateVersionsResult(
  options?: CreateNewItemTemplateVersionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CreateNewItemTemplateVersionsResult>;
export function newCreateNewItemTemplateVersionsResult(
  options: CreateNewItemTemplateVersionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CreateNewItemTemplateVersionsResult> {
  const o =
    (options.__typename
      ? options
      : cache["CreateNewItemTemplateVersionsResult"] = {}) as CreateNewItemTemplateVersionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CreateNewItemTemplateVersionsResult";
    o.newTemplates = (options.newTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("newTemplates"))
    );
    return o as FactoryResult<CreateNewItemTemplateVersionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CreateNewItemTemplateVersionsResult"] = newCreateNewItemTemplateVersionsResult;

export interface ActivateItemTemplateVersionsResultOptions {
  __typename?: "ActivateItemTemplateVersionsResult";
  activatedTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
}

export function newActivateItemTemplateVersionsResult(
  options?: ActivateItemTemplateVersionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ActivateItemTemplateVersionsResult>;
export function newActivateItemTemplateVersionsResult(
  options: ActivateItemTemplateVersionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ActivateItemTemplateVersionsResult> {
  const o =
    (options.__typename
      ? options
      : cache["ActivateItemTemplateVersionsResult"] = {}) as ActivateItemTemplateVersionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ActivateItemTemplateVersionsResult";
    o.activatedTemplates = (options.activatedTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("activatedTemplates"))
    );
    return o as FactoryResult<ActivateItemTemplateVersionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ActivateItemTemplateVersionsResult"] = newActivateItemTemplateVersionsResult;

export interface ItemTemplateAnomalyOptions {
  __typename?: "ItemTemplateAnomaly";
  id?: ItemTemplateAnomaly["id"];
  type?: ItemTemplateAnomaly["type"];
  parent?:
    | ItemTemplateAnomalyParent
    | FactoryResult<ItemTemplateAnomalyParent>
    | ItemTemplateOptions
    | RequireTypename<ItemTemplateItemVersionOptions>;
  description?: ItemTemplateAnomaly["description"];
}

export function newItemTemplateAnomaly(
  options?: ItemTemplateAnomalyOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateAnomaly>;
export function newItemTemplateAnomaly(
  options: ItemTemplateAnomalyOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateAnomaly> {
  const o = (options.__typename ? options : cache["ItemTemplateAnomaly"] = {}) as ItemTemplateAnomaly;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateAnomaly";
    o.id = options.id ?? nextFactoryId("ItemTemplateAnomaly");
    o.type = options.type ?? ItemTemplateAnomalyType.TemplateMissingScopeForOption;
    o.parent = maybeNew(options.parent?.__typename ?? "ItemTemplate", options.parent, cache);
    o.description = options.description ?? "description";
    return o as FactoryResult<ItemTemplateAnomaly>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateAnomaly"] = newItemTemplateAnomaly;

export interface ItemTemplateCollectionOptions {
  __typename?: "ItemTemplateCollection";
  id?: ItemTemplateCollection["id"];
  createdAt?: ItemTemplateCollection["createdAt"];
  updatedAt?: ItemTemplateCollection["updatedAt"];
  templates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  latest?: FactoryInput<ItemTemplate, ItemTemplateOptions> | null;
}

export function newItemTemplateCollection(
  options?: ItemTemplateCollectionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateCollection>;
export function newItemTemplateCollection(
  options: ItemTemplateCollectionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateCollection> {
  const o = (options.__typename ? options : cache["ItemTemplateCollection"] = {}) as ItemTemplateCollection;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateCollection";
    o.id = options.id ?? nextFactoryId("ItemTemplateCollection");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.templates = (options.templates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("templates"))
    );
    o.latest = maybeNewOrNull("ItemTemplate", options.latest, cache);
    return o as FactoryResult<ItemTemplateCollection>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateCollection"] = newItemTemplateCollection;

export interface ItemTemplateCostUpdateOptions {
  __typename?: "ItemTemplateCostUpdate";
  id?: ItemTemplateCostUpdate["id"];
  completed?: ItemTemplateCostUpdate["completed"];
  createdAt?: ItemTemplateCostUpdate["createdAt"];
  updatedAt?: ItemTemplateCostUpdate["updatedAt"];
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newItemTemplateCostUpdate(
  options?: ItemTemplateCostUpdateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateCostUpdate>;
export function newItemTemplateCostUpdate(
  options: ItemTemplateCostUpdateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateCostUpdate> {
  const o = (options.__typename ? options : cache["ItemTemplateCostUpdate"] = {}) as ItemTemplateCostUpdate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateCostUpdate";
    o.id = options.id ?? nextFactoryId("ItemTemplateCostUpdate");
    o.completed = options.completed ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.bidContractRevision = maybeNew(
      "BidContractRevision",
      options.bidContractRevision,
      cache,
      options.hasOwnProperty("bidContractRevision"),
    );
    o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
    return o as FactoryResult<ItemTemplateCostUpdate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateCostUpdate"] = newItemTemplateCostUpdate;

export interface ItemTemplateItemOptions {
  __typename?: "ItemTemplateItem";
  id?: ItemTemplateItem["id"];
  identityId?: ItemTemplateItem["identityId"];
  slot?: FactoryInput<ItemSlot, ItemSlotOptions>;
  item?: FactoryInput<Item, ItemOptions>;
  template?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  location?: FactoryInput<Location, LocationOptions>;
  quantity?: ItemTemplateItem["quantity"];
  createdAt?: ItemTemplateItem["createdAt"];
  updatedAt?: ItemTemplateItem["updatedAt"];
  costType?: ItemTemplateItem["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  specifications?: ItemTemplateItem["specifications"];
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  tradePartnerNote?: ItemTemplateItem["tradePartnerNote"];
  internalNote?: ItemTemplateItem["internalNote"];
  name?: ItemTemplateItem["name"];
  displayName?: ItemTemplateItem["displayName"];
  parent?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions | null;
  first?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  totalCostInCents?: ItemTemplateItem["totalCostInCents"];
  unitCostInCents?: ItemTemplateItem["unitCostInCents"];
  canDeleteItem?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  preferredBidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  identityHash?: ItemTemplateItem["identityHash"];
  majorHash?: ItemTemplateItem["majorHash"];
  minorHash?: ItemTemplateItem["minorHash"];
  versions?: Array<FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>>;
  basedOn?: FactoryInput<ItemTemplateItem, ItemTemplateItemOptions> | null;
  itemsBasedOn?: Array<FactoryInput<ItemTemplateItem, ItemTemplateItemOptions>>;
  original?: FactoryInput<ItemTemplateItem, ItemTemplateItemOptions> | null;
  bidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  isDisabledMaterialVariant?: ItemTemplateItem["isDisabledMaterialVariant"];
  potentialBidItems?: Array<FactoryInput<BidItem, BidItemOptions>>;
  elevationIds?: ItemTemplateItem["elevationIds"];
  specOptionIds?: ItemTemplateItem["specOptionIds"];
  otherOptionIds?: ItemTemplateItem["otherOptionIds"];
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  bidItemTemplateItem?: FactoryInput<ItemTemplateItem, ItemTemplateItemOptions> | null;
  task?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  costStatus?: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus;
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  costEstimate?: FactoryInput<CostEstimate, CostEstimateOptions>;
  customPlaceholderName?: ItemTemplateItem["customPlaceholderName"];
}

export function newItemTemplateItem(
  options?: ItemTemplateItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItem>;
export function newItemTemplateItem(
  options: ItemTemplateItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateItem> {
  const o = (options.__typename ? options : cache["ItemTemplateItem"] = {}) as ItemTemplateItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateItem";
    o.id = options.id ?? nextFactoryId("ItemTemplateItem");
    o.identityId = options.identityId ?? "identityId";
    o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.template = maybeNew("ItemTemplate", options.template, cache, options.hasOwnProperty("template"));
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.quantity = options.quantity ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costType = options.costType ?? CostType.Labor;
    o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
    o.specifications = options.specifications ?? null;
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.internalNote = options.internalNote ?? null;
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.parent = maybeNew("ItemTemplate", options.parent, cache, options.hasOwnProperty("parent"));
    o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
    o.first = maybeNew("ItemTemplate", options.first, cache, options.hasOwnProperty("first"));
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.unitCostInCents = options.unitCostInCents ?? 0;
    o.canDeleteItem = maybeNew(
      "PotentialOperation2",
      options.canDeleteItem,
      cache,
      options.hasOwnProperty("canDeleteItem"),
    );
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
    o.identityHash = options.identityHash ?? null;
    o.majorHash = options.majorHash ?? null;
    o.minorHash = options.minorHash ?? null;
    o.versions = (options.versions ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("versions"))
    );
    o.basedOn = maybeNewOrNull("ItemTemplateItem", options.basedOn, cache);
    o.itemsBasedOn = (options.itemsBasedOn ?? []).map((i) =>
      maybeNew("ItemTemplateItem", i, cache, options.hasOwnProperty("itemsBasedOn"))
    );
    o.original = maybeNewOrNull("ItemTemplateItem", options.original, cache);
    o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
    o.isDisabledMaterialVariant = options.isDisabledMaterialVariant ?? false;
    o.potentialBidItems = (options.potentialBidItems ?? []).map((i) =>
      maybeNew("BidItem", i, cache, options.hasOwnProperty("potentialBidItems"))
    );
    o.elevationIds = options.elevationIds ?? [];
    o.specOptionIds = options.specOptionIds ?? [];
    o.otherOptionIds = options.otherOptionIds ?? [];
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.bidItemTemplateItem = maybeNewOrNull("ItemTemplateItem", options.bidItemTemplateItem, cache);
    o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
    o.costStatus = enumOrDetailOfItemTemplateItemCostStatus(options.costStatus);
    o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
    o.customPlaceholderName = options.customPlaceholderName ?? null;
    return o as FactoryResult<ItemTemplateItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateItem"] = newItemTemplateItem;

export interface CostEstimateOptions {
  __typename?: "CostEstimate";
  costInCents?: CostEstimate["costInCents"];
}

export function newCostEstimate(
  options?: CostEstimateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostEstimate>;
export function newCostEstimate(
  options: CostEstimateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostEstimate> {
  const o = (options.__typename ? options : cache["CostEstimate"] = {}) as CostEstimate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostEstimate";
    o.costInCents = options.costInCents ?? 0;
    return o as FactoryResult<CostEstimate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostEstimate"] = newCostEstimate;

export interface ItemTemplateItemVersionsPageOptions {
  __typename?: "ItemTemplateItemVersionsPage";
  items?: Array<FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
  groupTotals?: Array<FactoryInput<ItemTemplateItemVersionGroupTotal, ItemTemplateItemVersionGroupTotalOptions>>;
}

export function newItemTemplateItemVersionsPage(
  options?: ItemTemplateItemVersionsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersionsPage>;
export function newItemTemplateItemVersionsPage(
  options: ItemTemplateItemVersionsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateItemVersionsPage> {
  const o = (options.__typename ? options : cache["ItemTemplateItemVersionsPage"] = {}) as ItemTemplateItemVersionsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateItemVersionsPage";
    o.items = (options.items ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("items"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    o.groupTotals = (options.groupTotals ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersionGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
    );
    return o as FactoryResult<ItemTemplateItemVersionsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateItemVersionsPage"] = newItemTemplateItemVersionsPage;

export interface ItemTemplateItemVersionGroupTotalOptions {
  __typename?: "ItemTemplateItemVersionGroupTotal";
  groupId?: ItemTemplateItemVersionGroupTotal["groupId"];
  totalCostInCents?: ItemTemplateItemVersionGroupTotal["totalCostInCents"];
  itivsInGroup?: ItemTemplateItemVersionGroupTotal["itivsInGroup"];
  itivIdsInGroup?: ItemTemplateItemVersionGroupTotal["itivIdsInGroup"];
  displayName?: ItemTemplateItemVersionGroupTotal["displayName"];
  materialsInGroup?: ItemTemplateItemVersionGroupTotal["materialsInGroup"];
  tasksInGroup?: ItemTemplateItemVersionGroupTotal["tasksInGroup"];
}

export function newItemTemplateItemVersionGroupTotal(
  options?: ItemTemplateItemVersionGroupTotalOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersionGroupTotal>;
export function newItemTemplateItemVersionGroupTotal(
  options: ItemTemplateItemVersionGroupTotalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItemTemplateItemVersionGroupTotal> {
  const o =
    (options.__typename
      ? options
      : cache["ItemTemplateItemVersionGroupTotal"] = {}) as ItemTemplateItemVersionGroupTotal;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItemTemplateItemVersionGroupTotal";
    o.groupId = options.groupId ?? "groupId";
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.itivsInGroup = options.itivsInGroup ?? 0;
    o.itivIdsInGroup = options.itivIdsInGroup ?? [];
    o.displayName = options.displayName ?? "displayName";
    o.materialsInGroup = options.materialsInGroup ?? 0;
    o.tasksInGroup = options.tasksInGroup ?? 0;
    return o as FactoryResult<ItemTemplateItemVersionGroupTotal>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItemTemplateItemVersionGroupTotal"] = newItemTemplateItemVersionGroupTotal;

export interface ItiAnomalyOptions {
  __typename?: "ItiAnomaly";
  description?: ItiAnomaly["description"];
}

export function newItiAnomaly(options?: ItiAnomalyOptions, factoryOptions?: FactoryOptions): FactoryResult<ItiAnomaly>;
export function newItiAnomaly(
  options: ItiAnomalyOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ItiAnomaly> {
  const o = (options.__typename ? options : cache["ItiAnomaly"] = {}) as ItiAnomaly;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ItiAnomaly";
    o.description = options.description ?? "description";
    return o as FactoryResult<ItiAnomaly>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ItiAnomaly"] = newItiAnomaly;

export interface SaveItemTemplateItemVersionsResultOptions {
  __typename?: "SaveItemTemplateItemVersionsResult";
  itemTemplateItemVersions?: Array<FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>>;
  removed?: Array<FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>>;
  deleted?: SaveItemTemplateItemVersionsResult["deleted"];
  groupTotals?: Array<FactoryInput<ItemTemplateItemVersionGroupTotal, ItemTemplateItemVersionGroupTotalOptions>>;
}

export function newSaveItemTemplateItemVersionsResult(
  options?: SaveItemTemplateItemVersionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveItemTemplateItemVersionsResult>;
export function newSaveItemTemplateItemVersionsResult(
  options: SaveItemTemplateItemVersionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveItemTemplateItemVersionsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveItemTemplateItemVersionsResult"] = {}) as SaveItemTemplateItemVersionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveItemTemplateItemVersionsResult";
    o.itemTemplateItemVersions = (options.itemTemplateItemVersions ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("itemTemplateItemVersions"))
    );
    o.removed = (options.removed ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("removed"))
    );
    o.deleted = options.deleted ?? [];
    o.groupTotals = (options.groupTotals ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersionGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
    );
    return o as FactoryResult<SaveItemTemplateItemVersionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveItemTemplateItemVersionsResult"] = newSaveItemTemplateItemVersionsResult;

export interface DedupeReadyPlanItemTemplateItemVersionsResultOptions {
  __typename?: "DedupeReadyPlanItemTemplateItemVersionsResult";
  dedupedItemTemplateItemVersions?: Array<
    FactoryInput<DedupedItemTemplateItemVersion, DedupedItemTemplateItemVersionOptions>
  >;
  affectedTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  affectedDevelopments?: Array<FactoryInput<Development, DevelopmentOptions>>;
  affectedReadyPlans?: Array<FactoryInput<ReadyPlan, ReadyPlanOptions>>;
}

export function newDedupeReadyPlanItemTemplateItemVersionsResult(
  options?: DedupeReadyPlanItemTemplateItemVersionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DedupeReadyPlanItemTemplateItemVersionsResult>;
export function newDedupeReadyPlanItemTemplateItemVersionsResult(
  options: DedupeReadyPlanItemTemplateItemVersionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DedupeReadyPlanItemTemplateItemVersionsResult> {
  const o =
    (options.__typename
      ? options
      : cache["DedupeReadyPlanItemTemplateItemVersionsResult"] = {}) as DedupeReadyPlanItemTemplateItemVersionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DedupeReadyPlanItemTemplateItemVersionsResult";
    o.dedupedItemTemplateItemVersions = (options.dedupedItemTemplateItemVersions ?? []).map((i) =>
      maybeNew("DedupedItemTemplateItemVersion", i, cache, options.hasOwnProperty("dedupedItemTemplateItemVersions"))
    );
    o.affectedTemplates = (options.affectedTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("affectedTemplates"))
    );
    o.affectedDevelopments = (options.affectedDevelopments ?? []).map((i) =>
      maybeNew("Development", i, cache, options.hasOwnProperty("affectedDevelopments"))
    );
    o.affectedReadyPlans = (options.affectedReadyPlans ?? []).map((i) =>
      maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("affectedReadyPlans"))
    );
    return o as FactoryResult<DedupeReadyPlanItemTemplateItemVersionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DedupeReadyPlanItemTemplateItemVersionsResult"] = newDedupeReadyPlanItemTemplateItemVersionsResult;

export interface DedupedItemTemplateItemVersionOptions {
  __typename?: "DedupedItemTemplateItemVersion";
  primary?: FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>;
  removes?: Array<FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>>;
}

export function newDedupedItemTemplateItemVersion(
  options?: DedupedItemTemplateItemVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DedupedItemTemplateItemVersion>;
export function newDedupedItemTemplateItemVersion(
  options: DedupedItemTemplateItemVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DedupedItemTemplateItemVersion> {
  const o =
    (options.__typename ? options : cache["DedupedItemTemplateItemVersion"] = {}) as DedupedItemTemplateItemVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DedupedItemTemplateItemVersion";
    o.primary = maybeNew("ItemTemplateItemVersion", options.primary, cache, options.hasOwnProperty("primary"));
    o.removes = (options.removes ?? []).map((i) =>
      maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("removes"))
    );
    return o as FactoryResult<DedupedItemTemplateItemVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DedupedItemTemplateItemVersion"] = newDedupedItemTemplateItemVersion;

export interface AddJobResultOptions {
  __typename?: "AddJobResult";
  trackedJob?: FactoryInput<TrackedJob, TrackedJobOptions> | null;
  emptyResult?: AddJobResult["emptyResult"];
}

export function newAddJobResult(
  options?: AddJobResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AddJobResult>;
export function newAddJobResult(
  options: AddJobResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AddJobResult> {
  const o = (options.__typename ? options : cache["AddJobResult"] = {}) as AddJobResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AddJobResult";
    o.trackedJob = maybeNewOrNull("TrackedJob", options.trackedJob, cache);
    o.emptyResult = options.emptyResult ?? null;
    return o as FactoryResult<AddJobResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AddJobResult"] = newAddJobResult;

export interface AddJobsResultOptions {
  __typename?: "AddJobsResult";
  trackedJobs?: Array<FactoryInput<TrackedJob, TrackedJobOptions>>;
  emptyResult?: AddJobsResult["emptyResult"];
}

export function newAddJobsResult(
  options?: AddJobsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<AddJobsResult>;
export function newAddJobsResult(
  options: AddJobsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<AddJobsResult> {
  const o = (options.__typename ? options : cache["AddJobsResult"] = {}) as AddJobsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "AddJobsResult";
    o.trackedJobs = (options.trackedJobs ?? []).map((i) =>
      maybeNew("TrackedJob", i, cache, options.hasOwnProperty("trackedJobs"))
    );
    o.emptyResult = options.emptyResult ?? null;
    return o as FactoryResult<AddJobsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["AddJobsResult"] = newAddJobsResult;

export interface JobLogOptions {
  __typename?: "JobLog";
  id?: JobLog["id"];
  logDate?: JobLog["logDate"];
  createdAt?: JobLog["createdAt"];
  updatedAt?: JobLog["updatedAt"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  notes?: Array<FactoryInput<JobLogNote, JobLogNoteOptions>>;
  images?: Array<FactoryInput<JobLogImage, JobLogImageOptions>>;
  minTemperature?: JobLog["minTemperature"];
  maxTemperature?: JobLog["maxTemperature"];
  humidity?: JobLog["humidity"];
  wind?: JobLog["wind"];
  weatherType?: JobLog["weatherType"];
  weatherTypeDetail?: WeatherTypeDetailOptions | WeatherType | null;
  weatherTypeChanged?: JobLog["weatherTypeChanged"];
}

export function newJobLog(options?: JobLogOptions, factoryOptions?: FactoryOptions): FactoryResult<JobLog>;
export function newJobLog(
  options: JobLogOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<JobLog> {
  const o = (options.__typename ? options : cache["JobLog"] = {}) as JobLog;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "JobLog";
    o.id = options.id ?? nextFactoryId("JobLog");
    o.logDate = options.logDate ?? newDate();
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.notes = (options.notes ?? []).map((i) => maybeNew("JobLogNote", i, cache, options.hasOwnProperty("notes")));
    o.images = (options.images ?? []).map((i) => maybeNew("JobLogImage", i, cache, options.hasOwnProperty("images")));
    o.minTemperature = options.minTemperature ?? null;
    o.maxTemperature = options.maxTemperature ?? null;
    o.humidity = options.humidity ?? null;
    o.wind = options.wind ?? null;
    o.weatherType = options.weatherType ?? null;
    o.weatherTypeDetail = enumOrDetailOrNullOfWeatherType(options.weatherTypeDetail);
    o.weatherTypeChanged = options.weatherTypeChanged ?? null;
    return o as FactoryResult<JobLog>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["JobLog"] = newJobLog;

export interface SaveJobLogResultOptions {
  __typename?: "SaveJobLogResult";
  jobLog?: FactoryInput<JobLog, JobLogOptions>;
}

export function newSaveJobLogResult(
  options?: SaveJobLogResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveJobLogResult>;
export function newSaveJobLogResult(
  options: SaveJobLogResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveJobLogResult> {
  const o = (options.__typename ? options : cache["SaveJobLogResult"] = {}) as SaveJobLogResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveJobLogResult";
    o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
    return o as FactoryResult<SaveJobLogResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveJobLogResult"] = newSaveJobLogResult;

export interface DuplicateJobLogsResultOptions {
  __typename?: "DuplicateJobLogsResult";
  jobLog?: FactoryInput<JobLog, JobLogOptions>;
  clonedJobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
  copiedJobLogs?: Array<FactoryInput<JobLog, JobLogOptions>>;
}

export function newDuplicateJobLogsResult(
  options?: DuplicateJobLogsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DuplicateJobLogsResult>;
export function newDuplicateJobLogsResult(
  options: DuplicateJobLogsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DuplicateJobLogsResult> {
  const o = (options.__typename ? options : cache["DuplicateJobLogsResult"] = {}) as DuplicateJobLogsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DuplicateJobLogsResult";
    o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
    o.clonedJobLogs = (options.clonedJobLogs ?? []).map((i) =>
      maybeNew("JobLog", i, cache, options.hasOwnProperty("clonedJobLogs"))
    );
    o.copiedJobLogs = (options.copiedJobLogs ?? []).map((i) =>
      maybeNew("JobLog", i, cache, options.hasOwnProperty("copiedJobLogs"))
    );
    return o as FactoryResult<DuplicateJobLogsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DuplicateJobLogsResult"] = newDuplicateJobLogsResult;

export interface JobLogsPageResultOptions {
  __typename?: "JobLogsPageResult";
  entities?: Array<FactoryInput<JobLog, JobLogOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
  logDates?: JobLogsPageResult["logDates"];
}

export function newJobLogsPageResult(
  options?: JobLogsPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogsPageResult>;
export function newJobLogsPageResult(
  options: JobLogsPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<JobLogsPageResult> {
  const o = (options.__typename ? options : cache["JobLogsPageResult"] = {}) as JobLogsPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "JobLogsPageResult";
    o.entities = (options.entities ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("entities")));
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    o.logDates = options.logDates ?? [];
    return o as FactoryResult<JobLogsPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["JobLogsPageResult"] = newJobLogsPageResult;

export interface JobLogImageOptions {
  __typename?: "JobLogImage";
  id?: JobLogImage["id"];
  createdAt?: JobLogImage["createdAt"];
  updatedAt?: JobLogImage["updatedAt"];
  asset?: FactoryInput<Asset, AssetOptions>;
  jobLog?: FactoryInput<JobLog, JobLogOptions>;
  parent?:
    | JobLogImageParent
    | FactoryResult<JobLogImageParent>
    | JobLogOptions
    | RequireTypename<JobLogNoteOptions>
    | null;
  sightlineJobId?: JobLogImage["sightlineJobId"];
  sightlineUrl?: JobLogImage["sightlineUrl"];
  sightlineFrameId?: JobLogImage["sightlineFrameId"];
}

export function newJobLogImage(
  options?: JobLogImageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogImage>;
export function newJobLogImage(
  options: JobLogImageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<JobLogImage> {
  const o = (options.__typename ? options : cache["JobLogImage"] = {}) as JobLogImage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "JobLogImage";
    o.id = options.id ?? nextFactoryId("JobLogImage");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "JobLog", options.parent, cache);
    o.sightlineJobId = options.sightlineJobId ?? null;
    o.sightlineUrl = options.sightlineUrl ?? null;
    o.sightlineFrameId = options.sightlineFrameId ?? null;
    return o as FactoryResult<JobLogImage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["JobLogImage"] = newJobLogImage;

export interface SaveJobLogImageResultOptions {
  __typename?: "SaveJobLogImageResult";
  jobLogImage?: FactoryInput<JobLogImage, JobLogImageOptions>;
}

export function newSaveJobLogImageResult(
  options?: SaveJobLogImageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveJobLogImageResult>;
export function newSaveJobLogImageResult(
  options: SaveJobLogImageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveJobLogImageResult> {
  const o = (options.__typename ? options : cache["SaveJobLogImageResult"] = {}) as SaveJobLogImageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveJobLogImageResult";
    o.jobLogImage = maybeNew("JobLogImage", options.jobLogImage, cache, options.hasOwnProperty("jobLogImage"));
    return o as FactoryResult<SaveJobLogImageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveJobLogImageResult"] = newSaveJobLogImageResult;

export interface DeleteJobLogImageResultOptions {
  __typename?: "DeleteJobLogImageResult";
  jobLog?: FactoryInput<JobLog, JobLogOptions>;
  parent?:
    | JobLogImageParent
    | FactoryResult<JobLogImageParent>
    | JobLogOptions
    | RequireTypename<JobLogNoteOptions>
    | null;
}

export function newDeleteJobLogImageResult(
  options?: DeleteJobLogImageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteJobLogImageResult>;
export function newDeleteJobLogImageResult(
  options: DeleteJobLogImageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteJobLogImageResult> {
  const o = (options.__typename ? options : cache["DeleteJobLogImageResult"] = {}) as DeleteJobLogImageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteJobLogImageResult";
    o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "JobLog", options.parent, cache);
    return o as FactoryResult<DeleteJobLogImageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteJobLogImageResult"] = newDeleteJobLogImageResult;

export interface SaveJobLogNoteResultOptions {
  __typename?: "SaveJobLogNoteResult";
  jobLogNote?: FactoryInput<JobLogNote, JobLogNoteOptions>;
}

export function newSaveJobLogNoteResult(
  options?: SaveJobLogNoteResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveJobLogNoteResult>;
export function newSaveJobLogNoteResult(
  options: SaveJobLogNoteResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveJobLogNoteResult> {
  const o = (options.__typename ? options : cache["SaveJobLogNoteResult"] = {}) as SaveJobLogNoteResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveJobLogNoteResult";
    o.jobLogNote = maybeNew("JobLogNote", options.jobLogNote, cache, options.hasOwnProperty("jobLogNote"));
    return o as FactoryResult<SaveJobLogNoteResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveJobLogNoteResult"] = newSaveJobLogNoteResult;

export interface DeleteJobLogNoteResultOptions {
  __typename?: "DeleteJobLogNoteResult";
  jobLog?: FactoryInput<JobLog, JobLogOptions>;
}

export function newDeleteJobLogNoteResult(
  options?: DeleteJobLogNoteResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteJobLogNoteResult>;
export function newDeleteJobLogNoteResult(
  options: DeleteJobLogNoteResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteJobLogNoteResult> {
  const o = (options.__typename ? options : cache["DeleteJobLogNoteResult"] = {}) as DeleteJobLogNoteResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteJobLogNoteResult";
    o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
    return o as FactoryResult<DeleteJobLogNoteResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteJobLogNoteResult"] = newDeleteJobLogNoteResult;

export interface LienWaiverOptions {
  __typename?: "LienWaiver";
  id?: LienWaiver["id"];
  amountInCents?: LienWaiver["amountInCents"];
  createdAt?: LienWaiver["createdAt"];
  updatedAt?: LienWaiver["updatedAt"];
  condition?: LienWaiverConditionDetailOptions | LienWaiverCondition;
  type?: LienWaiverTypeDetailOptions | LienWaiverType;
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions> | null;
  status?: LienWaiverStatusDetailOptions | LienWaiverStatus;
  document?: FactoryInput<Document, DocumentOptions> | null;
  parent?:
    | LienWaiverParent
    | FactoryResult<LienWaiverParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<BillOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  throughDate?: LienWaiver["throughDate"];
  claimant?:
    | LienWaiverClaimant
    | FactoryResult<LienWaiverClaimant>
    | BuilderOptions
    | RequireTypename<TradePartnerOptions>;
  payer?: LienWaiverPayer | FactoryResult<LienWaiverPayer> | BuilderOptions | RequireTypename<ClientOptions>;
  payerName?: LienWaiver["payerName"];
  owner?: LienWaiverOwner | FactoryResult<LienWaiverOwner> | CustomerOptions | RequireTypename<ClientOptions>;
  signatory?:
    | LienWaiverSignatory
    | FactoryResult<LienWaiverSignatory>
    | InternalUserOptions
    | RequireTypename<TradePartnerContactOptions>
    | null;
  canCreatePandaDoc?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newLienWaiver(options?: LienWaiverOptions, factoryOptions?: FactoryOptions): FactoryResult<LienWaiver>;
export function newLienWaiver(
  options: LienWaiverOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<LienWaiver> {
  const o = (options.__typename ? options : cache["LienWaiver"] = {}) as LienWaiver;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "LienWaiver";
    o.id = options.id ?? nextFactoryId("LienWaiver");
    o.amountInCents = options.amountInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.condition = enumOrDetailOfLienWaiverCondition(options.condition);
    o.type = enumOrDetailOfLienWaiverType(options.type);
    o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
    o.status = enumOrDetailOfLienWaiverStatus(options.status);
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.throughDate = options.throughDate ?? null;
    o.claimant = maybeNew(options.claimant?.__typename ?? "Builder", options.claimant, cache);
    o.payer = maybeNew(options.payer?.__typename ?? "Builder", options.payer, cache);
    o.payerName = options.payerName ?? "payerName";
    o.owner = maybeNew(options.owner?.__typename ?? "Customer", options.owner, cache);
    o.signatory = maybeNewOrNull(options.signatory?.__typename ?? "InternalUser", options.signatory, cache);
    o.canCreatePandaDoc = maybeNew(
      "PotentialOperation2",
      options.canCreatePandaDoc,
      cache,
      options.hasOwnProperty("canCreatePandaDoc"),
    );
    return o as FactoryResult<LienWaiver>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["LienWaiver"] = newLienWaiver;

export interface SaveLienWaiverResultOptions {
  __typename?: "SaveLienWaiverResult";
  lienWaiver?: FactoryInput<LienWaiver, LienWaiverOptions>;
}

export function newSaveLienWaiverResult(
  options?: SaveLienWaiverResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveLienWaiverResult>;
export function newSaveLienWaiverResult(
  options: SaveLienWaiverResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveLienWaiverResult> {
  const o = (options.__typename ? options : cache["SaveLienWaiverResult"] = {}) as SaveLienWaiverResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveLienWaiverResult";
    o.lienWaiver = maybeNew("LienWaiver", options.lienWaiver, cache, options.hasOwnProperty("lienWaiver"));
    return o as FactoryResult<SaveLienWaiverResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveLienWaiverResult"] = newSaveLienWaiverResult;

export interface LienWaiversPageOptions {
  __typename?: "LienWaiversPage";
  entities?: Array<FactoryInput<LienWaiver, LienWaiverOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newLienWaiversPage(
  options?: LienWaiversPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<LienWaiversPage>;
export function newLienWaiversPage(
  options: LienWaiversPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<LienWaiversPage> {
  const o = (options.__typename ? options : cache["LienWaiversPage"] = {}) as LienWaiversPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "LienWaiversPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("LienWaiver", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<LienWaiversPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["LienWaiversPage"] = newLienWaiversPage;

export interface SaveLocationsResultOptions {
  __typename?: "SaveLocationsResult";
  locations?: Array<FactoryInput<Location, LocationOptions>>;
}

export function newSaveLocationsResult(
  options?: SaveLocationsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveLocationsResult>;
export function newSaveLocationsResult(
  options: SaveLocationsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveLocationsResult> {
  const o = (options.__typename ? options : cache["SaveLocationsResult"] = {}) as SaveLocationsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveLocationsResult";
    o.locations = (options.locations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
    );
    return o as FactoryResult<SaveLocationsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveLocationsResult"] = newSaveLocationsResult;

export interface LocationOptions {
  __typename?: "Location";
  id?: Location["id"];
  name?: Location["name"];
  image?: FactoryInput<Asset, AssetOptions> | null;
  isWholeHouse?: Location["isWholeHouse"];
  supportsRendering?: Location["supportsRendering"];
  code?: Location["code"];
  effectiveCode?: Location["effectiveCode"];
  version?: Location["version"];
  type?: LocationTypeDetailOptions | LocationType;
  parent?: FactoryInput<Location, LocationOptions> | null;
  parents?: Array<FactoryInput<Location, LocationOptions>>;
  path?: Location["path"];
  pathAsCode?: Location["pathAsCode"];
  pathArray?: Location["pathArray"];
  pathIds?: Location["pathIds"];
  group?: FactoryInput<Location, LocationOptions> | null;
  level?: FactoryInput<Location, LocationOptions> | null;
  room?: FactoryInput<Location, LocationOptions> | null;
  displayLocationPath?: Location["displayLocationPath"];
  locations?: Array<FactoryInput<Location, LocationOptions>>;
  feature?: FactoryInput<Location, LocationOptions> | null;
  effectiveLocation?: FactoryInput<Location, LocationOptions>;
  nonScopeLocation?: FactoryInput<Location, LocationOptions>;
  isNonStructural?: Location["isNonStructural"];
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  isModifiedRoom?: Location["isModifiedRoom"];
  roomType?: FactoryInput<RoomType, RoomTypeOptions> | null;
  featureType?: FactoryInput<FeatureType, FeatureTypeOptions> | null;
}

export function newLocation(options?: LocationOptions, factoryOptions?: FactoryOptions): FactoryResult<Location>;
export function newLocation(
  options: LocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Location> {
  const o = (options.__typename ? options : cache["Location"] = {}) as Location;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Location";
    o.id = options.id ?? nextFactoryId("Location");
    o.name = options.name ?? "name";
    o.image = maybeNewOrNull("Asset", options.image, cache);
    o.isWholeHouse = options.isWholeHouse ?? false;
    o.supportsRendering = options.supportsRendering ?? false;
    o.code = options.code ?? null;
    o.effectiveCode = options.effectiveCode ?? "effectiveCode";
    o.version = options.version ?? 0;
    o.type = enumOrDetailOfLocationType(options.type);
    o.parent = maybeNewOrNull("Location", options.parent, cache);
    o.parents = (options.parents ?? []).map((i) => maybeNew("Location", i, cache, options.hasOwnProperty("parents")));
    o.path = options.path ?? null;
    o.pathAsCode = options.pathAsCode ?? null;
    o.pathArray = options.pathArray ?? [];
    o.pathIds = options.pathIds ?? [];
    o.group = maybeNewOrNull("Location", options.group, cache);
    o.level = maybeNewOrNull("Location", options.level, cache);
    o.room = maybeNewOrNull("Location", options.room, cache);
    o.displayLocationPath = options.displayLocationPath ?? "displayLocationPath";
    o.locations = (options.locations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
    );
    o.feature = maybeNewOrNull("Location", options.feature, cache);
    o.effectiveLocation = maybeNew(
      "Location",
      options.effectiveLocation,
      cache,
      options.hasOwnProperty("effectiveLocation"),
    );
    o.nonScopeLocation = maybeNew(
      "Location",
      options.nonScopeLocation,
      cache,
      options.hasOwnProperty("nonScopeLocation"),
    );
    o.isNonStructural = options.isNonStructural ?? null;
    o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
    o.isModifiedRoom = options.isModifiedRoom ?? false;
    o.roomType = maybeNewOrNull("RoomType", options.roomType, cache);
    o.featureType = maybeNewOrNull("FeatureType", options.featureType, cache);
    return o as FactoryResult<Location>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Location"] = newLocation;

export interface SaveLotResultOptions {
  __typename?: "SaveLotResult";
  lot?: FactoryInput<Lot, LotOptions>;
}

export function newSaveLotResult(
  options?: SaveLotResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveLotResult>;
export function newSaveLotResult(
  options: SaveLotResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveLotResult> {
  const o = (options.__typename ? options : cache["SaveLotResult"] = {}) as SaveLotResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveLotResult";
    o.lot = maybeNew("Lot", options.lot, cache, options.hasOwnProperty("lot"));
    return o as FactoryResult<SaveLotResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveLotResult"] = newSaveLotResult;

export interface LotRatingOptions {
  __typename?: "LotRating";
  id?: LotRating["id"];
  grade?: LotRating["grade"];
  description?: LotRating["description"];
  createdAt?: LotRating["createdAt"];
  updatedAt?: LotRating["updatedAt"];
  projects?: Array<FactoryInput<StandaloneProject, StandaloneProjectOptions>>;
}

export function newLotRating(options?: LotRatingOptions, factoryOptions?: FactoryOptions): FactoryResult<LotRating>;
export function newLotRating(
  options: LotRatingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<LotRating> {
  const o = (options.__typename ? options : cache["LotRating"] = {}) as LotRating;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "LotRating";
    o.id = options.id ?? nextFactoryId("LotRating");
    o.grade = options.grade ?? "grade";
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.projects = (options.projects ?? []).map((i) =>
      maybeNew("StandaloneProject", i, cache, options.hasOwnProperty("projects"))
    );
    return o as FactoryResult<LotRating>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["LotRating"] = newLotRating;

export interface SaveLotRatingResultOptions {
  __typename?: "SaveLotRatingResult";
  lotRating?: FactoryInput<LotRating, LotRatingOptions>;
}

export function newSaveLotRatingResult(
  options?: SaveLotRatingResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveLotRatingResult>;
export function newSaveLotRatingResult(
  options: SaveLotRatingResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveLotRatingResult> {
  const o = (options.__typename ? options : cache["SaveLotRatingResult"] = {}) as SaveLotRatingResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveLotRatingResult";
    o.lotRating = maybeNew("LotRating", options.lotRating, cache, options.hasOwnProperty("lotRating"));
    return o as FactoryResult<SaveLotRatingResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveLotRatingResult"] = newSaveLotRatingResult;

export interface SaveMarketResultOptions {
  __typename?: "SaveMarketResult";
  market?: FactoryInput<Market, MarketOptions>;
}

export function newSaveMarketResult(
  options?: SaveMarketResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveMarketResult>;
export function newSaveMarketResult(
  options: SaveMarketResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveMarketResult> {
  const o = (options.__typename ? options : cache["SaveMarketResult"] = {}) as SaveMarketResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveMarketResult";
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    return o as FactoryResult<SaveMarketResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveMarketResult"] = newSaveMarketResult;

export interface MaterialAssemblyComponentOptions {
  __typename?: "MaterialAssemblyComponent";
  id?: MaterialAssemblyComponent["id"];
  createdAt?: MaterialAssemblyComponent["createdAt"];
  updatedAt?: MaterialAssemblyComponent["updatedAt"];
  assembly?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  component?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  name?: MaterialAssemblyComponent["name"];
  qualifier?: MaterialAssemblyComponent["qualifier"];
}

export function newMaterialAssemblyComponent(
  options?: MaterialAssemblyComponentOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialAssemblyComponent>;
export function newMaterialAssemblyComponent(
  options: MaterialAssemblyComponentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialAssemblyComponent> {
  const o = (options.__typename ? options : cache["MaterialAssemblyComponent"] = {}) as MaterialAssemblyComponent;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialAssemblyComponent";
    o.id = options.id ?? nextFactoryId("MaterialAssemblyComponent");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.assembly = maybeNew("MaterialVariant", options.assembly, cache, options.hasOwnProperty("assembly"));
    o.component = maybeNew("MaterialVariant", options.component, cache, options.hasOwnProperty("component"));
    o.name = options.name ?? null;
    o.qualifier = options.qualifier ?? null;
    return o as FactoryResult<MaterialAssemblyComponent>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialAssemblyComponent"] = newMaterialAssemblyComponent;

export interface SaveMaterialAssemblyComponentResultOptions {
  __typename?: "SaveMaterialAssemblyComponentResult";
  materialAssemblyComponent?: FactoryInput<MaterialAssemblyComponent, MaterialAssemblyComponentOptions>;
}

export function newSaveMaterialAssemblyComponentResult(
  options?: SaveMaterialAssemblyComponentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveMaterialAssemblyComponentResult>;
export function newSaveMaterialAssemblyComponentResult(
  options: SaveMaterialAssemblyComponentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveMaterialAssemblyComponentResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveMaterialAssemblyComponentResult"] = {}) as SaveMaterialAssemblyComponentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveMaterialAssemblyComponentResult";
    o.materialAssemblyComponent = maybeNew(
      "MaterialAssemblyComponent",
      options.materialAssemblyComponent,
      cache,
      options.hasOwnProperty("materialAssemblyComponent"),
    );
    return o as FactoryResult<SaveMaterialAssemblyComponentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveMaterialAssemblyComponentResult"] = newSaveMaterialAssemblyComponentResult;

export interface MaterialAttributeDimensionOptions {
  __typename?: "MaterialAttributeDimension";
  id?: MaterialAttributeDimension["id"];
  name?: MaterialAttributeDimension["name"];
  createdAt?: MaterialAttributeDimension["createdAt"];
  updatedAt?: MaterialAttributeDimension["updatedAt"];
  item?: FactoryInput<Item, ItemOptions>;
  values?: Array<FactoryInput<MaterialAttributeValue, MaterialAttributeValueOptions>>;
  isAdminManaged?: MaterialAttributeDimension["isAdminManaged"];
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions> | null;
  sortOrder?: MaterialAttributeDimension["sortOrder"];
  type?: MaterialAttributeDimensionTypeDetailOptions | MaterialAttributeDimensionType;
  useInTakeoff?: MaterialAttributeDimension["useInTakeoff"];
  useInVisualModePdf?: MaterialAttributeDimension["useInVisualModePdf"];
  showInFinishSchedule?: MaterialAttributeDimension["showInFinishSchedule"];
  showInCabinetsInfo?: MaterialAttributeDimension["showInCabinetsInfo"];
  copiedFromChildModifier?: FactoryInput<MaterialAttributeDimension, MaterialAttributeDimensionOptions> | null;
  isDeprecated?: MaterialAttributeDimension["isDeprecated"];
}

export function newMaterialAttributeDimension(
  options?: MaterialAttributeDimensionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialAttributeDimension>;
export function newMaterialAttributeDimension(
  options: MaterialAttributeDimensionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialAttributeDimension> {
  const o = (options.__typename ? options : cache["MaterialAttributeDimension"] = {}) as MaterialAttributeDimension;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialAttributeDimension";
    o.id = options.id ?? nextFactoryId("MaterialAttributeDimension");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.values = (options.values ?? []).map((i) =>
      maybeNew("MaterialAttributeValue", i, cache, options.hasOwnProperty("values"))
    );
    o.isAdminManaged = options.isAdminManaged ?? false;
    o.unitOfMeasure = maybeNewOrNull("UnitOfMeasure", options.unitOfMeasure, cache);
    o.sortOrder = options.sortOrder ?? 0;
    o.type = enumOrDetailOfMaterialAttributeDimensionType(options.type);
    o.useInTakeoff = options.useInTakeoff ?? false;
    o.useInVisualModePdf = options.useInVisualModePdf ?? false;
    o.showInFinishSchedule = options.showInFinishSchedule ?? false;
    o.showInCabinetsInfo = options.showInCabinetsInfo ?? false;
    o.copiedFromChildModifier = maybeNewOrNull("MaterialAttributeDimension", options.copiedFromChildModifier, cache);
    o.isDeprecated = options.isDeprecated ?? false;
    return o as FactoryResult<MaterialAttributeDimension>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialAttributeDimension"] = newMaterialAttributeDimension;

export interface SaveMaterialAttributeDimensionResultOptions {
  __typename?: "SaveMaterialAttributeDimensionResult";
  materialAttributeDimension?: FactoryInput<MaterialAttributeDimension, MaterialAttributeDimensionOptions>;
}

export function newSaveMaterialAttributeDimensionResult(
  options?: SaveMaterialAttributeDimensionResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveMaterialAttributeDimensionResult>;
export function newSaveMaterialAttributeDimensionResult(
  options: SaveMaterialAttributeDimensionResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveMaterialAttributeDimensionResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveMaterialAttributeDimensionResult"] = {}) as SaveMaterialAttributeDimensionResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveMaterialAttributeDimensionResult";
    o.materialAttributeDimension = maybeNew(
      "MaterialAttributeDimension",
      options.materialAttributeDimension,
      cache,
      options.hasOwnProperty("materialAttributeDimension"),
    );
    return o as FactoryResult<SaveMaterialAttributeDimensionResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveMaterialAttributeDimensionResult"] = newSaveMaterialAttributeDimensionResult;

export interface SaveMaterialAttributeDimensionResultsOptions {
  __typename?: "SaveMaterialAttributeDimensionResults";
  materialAttributeDimensions?: Array<FactoryInput<MaterialAttributeDimension, MaterialAttributeDimensionOptions>>;
}

export function newSaveMaterialAttributeDimensionResults(
  options?: SaveMaterialAttributeDimensionResultsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveMaterialAttributeDimensionResults>;
export function newSaveMaterialAttributeDimensionResults(
  options: SaveMaterialAttributeDimensionResultsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveMaterialAttributeDimensionResults> {
  const o =
    (options.__typename
      ? options
      : cache["SaveMaterialAttributeDimensionResults"] = {}) as SaveMaterialAttributeDimensionResults;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveMaterialAttributeDimensionResults";
    o.materialAttributeDimensions = (options.materialAttributeDimensions ?? []).map((i) =>
      maybeNew("MaterialAttributeDimension", i, cache, options.hasOwnProperty("materialAttributeDimensions"))
    );
    return o as FactoryResult<SaveMaterialAttributeDimensionResults>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveMaterialAttributeDimensionResults"] = newSaveMaterialAttributeDimensionResults;

export interface MaterialAttributeValueOptions {
  __typename?: "MaterialAttributeValue";
  id?: MaterialAttributeValue["id"];
  value?: MaterialAttributeValue["value"];
  textValue?: MaterialAttributeValue["textValue"];
  valueWithUom?: MaterialAttributeValue["valueWithUom"];
  createdAt?: MaterialAttributeValue["createdAt"];
  updatedAt?: MaterialAttributeValue["updatedAt"];
  dimension?: FactoryInput<MaterialAttributeDimension, MaterialAttributeDimensionOptions>;
  materialVariants?: Array<FactoryInput<MaterialVariant, MaterialVariantOptions>>;
  code?: MaterialAttributeValue["code"];
  type?: MaterialAttributeValueTypeDetailOptions | MaterialAttributeValueType;
  min?: MaterialAttributeValue["min"];
  max?: MaterialAttributeValue["max"];
}

export function newMaterialAttributeValue(
  options?: MaterialAttributeValueOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialAttributeValue>;
export function newMaterialAttributeValue(
  options: MaterialAttributeValueOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialAttributeValue> {
  const o = (options.__typename ? options : cache["MaterialAttributeValue"] = {}) as MaterialAttributeValue;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialAttributeValue";
    o.id = options.id ?? nextFactoryId("MaterialAttributeValue");
    o.value = options.value ?? "value";
    o.textValue = options.textValue ?? "textValue";
    o.valueWithUom = options.valueWithUom ?? "valueWithUom";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.dimension = maybeNew("MaterialAttributeDimension", options.dimension, cache, options.hasOwnProperty("dimension"));
    o.materialVariants = (options.materialVariants ?? []).map((i) =>
      maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
    );
    o.code = options.code ?? null;
    o.type = enumOrDetailOfMaterialAttributeValueType(options.type);
    o.min = options.min ?? null;
    o.max = options.max ?? null;
    return o as FactoryResult<MaterialAttributeValue>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialAttributeValue"] = newMaterialAttributeValue;

export interface SaveMaterialAttributeValueResultOptions {
  __typename?: "SaveMaterialAttributeValueResult";
  materialAttributeValue?: FactoryInput<MaterialAttributeValue, MaterialAttributeValueOptions>;
}

export function newSaveMaterialAttributeValueResult(
  options?: SaveMaterialAttributeValueResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveMaterialAttributeValueResult>;
export function newSaveMaterialAttributeValueResult(
  options: SaveMaterialAttributeValueResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveMaterialAttributeValueResult> {
  const o =
    (options.__typename ? options : cache["SaveMaterialAttributeValueResult"] = {}) as SaveMaterialAttributeValueResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveMaterialAttributeValueResult";
    o.materialAttributeValue = maybeNew(
      "MaterialAttributeValue",
      options.materialAttributeValue,
      cache,
      options.hasOwnProperty("materialAttributeValue"),
    );
    return o as FactoryResult<SaveMaterialAttributeValueResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveMaterialAttributeValueResult"] = newSaveMaterialAttributeValueResult;

export interface BackfillResponseOptions {
  __typename?: "BackfillResponse";
  processed?: BackfillResponse["processed"];
  skipped?: BackfillResponse["skipped"];
}

export function newBackfillResponse(
  options?: BackfillResponseOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BackfillResponse>;
export function newBackfillResponse(
  options: BackfillResponseOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BackfillResponse> {
  const o = (options.__typename ? options : cache["BackfillResponse"] = {}) as BackfillResponse;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BackfillResponse";
    o.processed = options.processed ?? 0;
    o.skipped = options.skipped ?? 0;
    return o as FactoryResult<BackfillResponse>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BackfillResponse"] = newBackfillResponse;

export interface MaterialBrandOptions {
  __typename?: "MaterialBrand";
  id?: MaterialBrand["id"];
  name?: MaterialBrand["name"];
  abbreviation?: MaterialBrand["abbreviation"];
  shortName?: MaterialBrand["shortName"];
  createdAt?: MaterialBrand["createdAt"];
  updatedAt?: MaterialBrand["updatedAt"];
  materialListings?: Array<FactoryInput<MaterialListing, MaterialListingOptions>>;
}

export function newMaterialBrand(
  options?: MaterialBrandOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialBrand>;
export function newMaterialBrand(
  options: MaterialBrandOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialBrand> {
  const o = (options.__typename ? options : cache["MaterialBrand"] = {}) as MaterialBrand;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialBrand";
    o.id = options.id ?? nextFactoryId("MaterialBrand");
    o.name = options.name ?? "name";
    o.abbreviation = options.abbreviation ?? null;
    o.shortName = options.shortName ?? "shortName";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.materialListings = (options.materialListings ?? []).map((i) =>
      maybeNew("MaterialListing", i, cache, options.hasOwnProperty("materialListings"))
    );
    return o as FactoryResult<MaterialBrand>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialBrand"] = newMaterialBrand;

export interface SaveMaterialBrandResultOptions {
  __typename?: "SaveMaterialBrandResult";
  materialBrand?: FactoryInput<MaterialBrand, MaterialBrandOptions>;
}

export function newSaveMaterialBrandResult(
  options?: SaveMaterialBrandResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveMaterialBrandResult>;
export function newSaveMaterialBrandResult(
  options: SaveMaterialBrandResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveMaterialBrandResult> {
  const o = (options.__typename ? options : cache["SaveMaterialBrandResult"] = {}) as SaveMaterialBrandResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveMaterialBrandResult";
    o.materialBrand = maybeNew("MaterialBrand", options.materialBrand, cache, options.hasOwnProperty("materialBrand"));
    return o as FactoryResult<SaveMaterialBrandResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveMaterialBrandResult"] = newSaveMaterialBrandResult;

export interface MaterialImportAiProposalOptions {
  __typename?: "MaterialImportAiProposal";
  id?: MaterialImportAiProposal["id"];
  createdAt?: MaterialImportAiProposal["createdAt"];
  updatedAt?: MaterialImportAiProposal["updatedAt"];
  status?: AiProposalStatusDetailOptions | AiProposalStatus;
  deletedAt?: MaterialImportAiProposal["deletedAt"];
  failureReason?: MaterialImportAiProposal["failureReason"];
  aiJobId?: MaterialImportAiProposal["aiJobId"];
  originalJsonResponse?: MaterialImportAiProposal["originalJsonResponse"];
  agentCompletedAt?: MaterialImportAiProposal["agentCompletedAt"];
  progressText?: MaterialImportAiProposal["progressText"];
  entityProposals?: Array<FactoryInput<AiEntityProposal, AiEntityProposalOptions>>;
  item?: FactoryInput<Item, ItemOptions>;
  manufacturerUrl?: MaterialImportAiProposal["manufacturerUrl"];
}

export function newMaterialImportAiProposal(
  options?: MaterialImportAiProposalOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialImportAiProposal>;
export function newMaterialImportAiProposal(
  options: MaterialImportAiProposalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialImportAiProposal> {
  const o = (options.__typename ? options : cache["MaterialImportAiProposal"] = {}) as MaterialImportAiProposal;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialImportAiProposal";
    o.id = options.id ?? nextFactoryId("MaterialImportAiProposal");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = enumOrDetailOfAiProposalStatus(options.status);
    o.deletedAt = options.deletedAt ?? null;
    o.failureReason = options.failureReason ?? null;
    o.aiJobId = options.aiJobId ?? null;
    o.originalJsonResponse = options.originalJsonResponse ?? null;
    o.agentCompletedAt = options.agentCompletedAt ?? null;
    o.progressText = options.progressText ?? null;
    o.entityProposals = (options.entityProposals ?? []).map((i) =>
      maybeNew("AiEntityProposal", i, cache, options.hasOwnProperty("entityProposals"))
    );
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.manufacturerUrl = options.manufacturerUrl ?? "manufacturerUrl";
    return o as FactoryResult<MaterialImportAiProposal>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialImportAiProposal"] = newMaterialImportAiProposal;

export interface CreateMaterialVariantsFromPayloadResultOptions {
  __typename?: "CreateMaterialVariantsFromPayloadResult";
  materialListing?: FactoryInput<MaterialListing, MaterialListingOptions>;
  proposal?: FactoryInput<MaterialImportAiProposal, MaterialImportAiProposalOptions>;
}

export function newCreateMaterialVariantsFromPayloadResult(
  options?: CreateMaterialVariantsFromPayloadResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CreateMaterialVariantsFromPayloadResult>;
export function newCreateMaterialVariantsFromPayloadResult(
  options: CreateMaterialVariantsFromPayloadResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CreateMaterialVariantsFromPayloadResult> {
  const o =
    (options.__typename
      ? options
      : cache["CreateMaterialVariantsFromPayloadResult"] = {}) as CreateMaterialVariantsFromPayloadResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CreateMaterialVariantsFromPayloadResult";
    o.materialListing = maybeNew(
      "MaterialListing",
      options.materialListing,
      cache,
      options.hasOwnProperty("materialListing"),
    );
    o.proposal = maybeNew("MaterialImportAiProposal", options.proposal, cache, options.hasOwnProperty("proposal"));
    return o as FactoryResult<CreateMaterialVariantsFromPayloadResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CreateMaterialVariantsFromPayloadResult"] = newCreateMaterialVariantsFromPayloadResult;

export interface MaterialLeadTimeConfigOptions {
  __typename?: "MaterialLeadTimeConfig";
  id?: MaterialLeadTimeConfig["id"];
  minLeadTimeInDays?: MaterialLeadTimeConfig["minLeadTimeInDays"];
  expectedLeadTimeInDays?: MaterialLeadTimeConfig["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: MaterialLeadTimeConfig["maxLeadTimeInDays"];
  reasonNote?: MaterialLeadTimeConfig["reasonNote"];
  createdAt?: MaterialLeadTimeConfig["createdAt"];
  updatedAt?: MaterialLeadTimeConfig["updatedAt"];
  variants?: Array<FactoryInput<MaterialLeadTimeConfigVariant, MaterialLeadTimeConfigVariantOptions>>;
  parent?:
    | MaterialLeadTimeConfigParent
    | FactoryResult<MaterialLeadTimeConfigParent>
    | CostCodeOptions
    | RequireTypename<ItemOptions>
    | RequireTypename<MaterialListingOptions>
    | null;
}

export function newMaterialLeadTimeConfig(
  options?: MaterialLeadTimeConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialLeadTimeConfig>;
export function newMaterialLeadTimeConfig(
  options: MaterialLeadTimeConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialLeadTimeConfig> {
  const o = (options.__typename ? options : cache["MaterialLeadTimeConfig"] = {}) as MaterialLeadTimeConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialLeadTimeConfig";
    o.id = options.id ?? nextFactoryId("MaterialLeadTimeConfig");
    o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
    o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
    o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
    o.reasonNote = options.reasonNote ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.variants = (options.variants ?? []).map((i) =>
      maybeNew("MaterialLeadTimeConfigVariant", i, cache, options.hasOwnProperty("variants"))
    );
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "CostCode", options.parent, cache);
    return o as FactoryResult<MaterialLeadTimeConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialLeadTimeConfig"] = newMaterialLeadTimeConfig;

export interface SaveMaterialLeadTimeConfigResultOptions {
  __typename?: "SaveMaterialLeadTimeConfigResult";
  materialLeadTimeConfig?: FactoryInput<MaterialLeadTimeConfig, MaterialLeadTimeConfigOptions>;
}

export function newSaveMaterialLeadTimeConfigResult(
  options?: SaveMaterialLeadTimeConfigResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveMaterialLeadTimeConfigResult>;
export function newSaveMaterialLeadTimeConfigResult(
  options: SaveMaterialLeadTimeConfigResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveMaterialLeadTimeConfigResult> {
  const o =
    (options.__typename ? options : cache["SaveMaterialLeadTimeConfigResult"] = {}) as SaveMaterialLeadTimeConfigResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveMaterialLeadTimeConfigResult";
    o.materialLeadTimeConfig = maybeNew(
      "MaterialLeadTimeConfig",
      options.materialLeadTimeConfig,
      cache,
      options.hasOwnProperty("materialLeadTimeConfig"),
    );
    return o as FactoryResult<SaveMaterialLeadTimeConfigResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveMaterialLeadTimeConfigResult"] = newSaveMaterialLeadTimeConfigResult;

export interface MaterialLeadTimeConfigVariantOptions {
  __typename?: "MaterialLeadTimeConfigVariant";
  id?: MaterialLeadTimeConfigVariant["id"];
  minLeadTimeInDays?: MaterialLeadTimeConfigVariant["minLeadTimeInDays"];
  expectedLeadTimeInDays?: MaterialLeadTimeConfigVariant["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: MaterialLeadTimeConfigVariant["maxLeadTimeInDays"];
  reasonNote?: MaterialLeadTimeConfigVariant["reasonNote"];
  createdAt?: MaterialLeadTimeConfigVariant["createdAt"];
  updatedAt?: MaterialLeadTimeConfigVariant["updatedAt"];
  market?: FactoryInput<Market, MarketOptions> | null;
  materialLeadTimeConfig?: FactoryInput<MaterialLeadTimeConfig, MaterialLeadTimeConfigOptions>;
}

export function newMaterialLeadTimeConfigVariant(
  options?: MaterialLeadTimeConfigVariantOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialLeadTimeConfigVariant>;
export function newMaterialLeadTimeConfigVariant(
  options: MaterialLeadTimeConfigVariantOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialLeadTimeConfigVariant> {
  const o =
    (options.__typename ? options : cache["MaterialLeadTimeConfigVariant"] = {}) as MaterialLeadTimeConfigVariant;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialLeadTimeConfigVariant";
    o.id = options.id ?? nextFactoryId("MaterialLeadTimeConfigVariant");
    o.minLeadTimeInDays = options.minLeadTimeInDays ?? null;
    o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? null;
    o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? null;
    o.reasonNote = options.reasonNote ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.market = maybeNewOrNull("Market", options.market, cache);
    o.materialLeadTimeConfig = maybeNew(
      "MaterialLeadTimeConfig",
      options.materialLeadTimeConfig,
      cache,
      options.hasOwnProperty("materialLeadTimeConfig"),
    );
    return o as FactoryResult<MaterialLeadTimeConfigVariant>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialLeadTimeConfigVariant"] = newMaterialLeadTimeConfigVariant;

export interface MaterialListingOptions {
  __typename?: "MaterialListing";
  id?: MaterialListing["id"];
  name?: MaterialListing["name"];
  createdAt?: MaterialListing["createdAt"];
  updatedAt?: MaterialListing["updatedAt"];
  item?: FactoryInput<Item, ItemOptions>;
  brand?: FactoryInput<MaterialBrand, MaterialBrandOptions> | null;
  materialVariants?: Array<FactoryInput<MaterialVariant, MaterialVariantOptions>>;
  defaultVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  type?: MaterialTypeDetailOptions | MaterialType;
  manufacturerUrl?: MaterialListing["manufacturerUrl"];
  description?: MaterialListing["description"];
  canEditItem?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  optionPricingConfig?: FactoryInput<OptionPricingConfig, OptionPricingConfigOptions> | null;
  preCutoffDesiredMarginInBasisPoints?: MaterialListing["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: MaterialListing["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: MaterialListing["selectionFeeInCents"];
  minimumPriceInCents?: MaterialListing["minimumPriceInCents"];
  materialLeadTimeConfig?: FactoryInput<MaterialLeadTimeConfig, MaterialLeadTimeConfigOptions> | null;
  minLeadTimeInDays?: MaterialListing["minLeadTimeInDays"];
  expectedLeadTimeInDays?: MaterialListing["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: MaterialListing["maxLeadTimeInDays"];
  history?: Array<FactoryInput<History, HistoryOptions>>;
  designNote?: MaterialListing["designNote"];
}

export function newMaterialListing(
  options?: MaterialListingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialListing>;
export function newMaterialListing(
  options: MaterialListingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialListing> {
  const o = (options.__typename ? options : cache["MaterialListing"] = {}) as MaterialListing;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialListing";
    o.id = options.id ?? nextFactoryId("MaterialListing");
    o.name = options.name ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.brand = maybeNewOrNull("MaterialBrand", options.brand, cache);
    o.materialVariants = (options.materialVariants ?? []).map((i) =>
      maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
    );
    o.defaultVariant = maybeNewOrNull("MaterialVariant", options.defaultVariant, cache);
    o.type = enumOrDetailOfMaterialType(options.type);
    o.manufacturerUrl = options.manufacturerUrl ?? null;
    o.description = options.description ?? null;
    o.canEditItem = maybeNew("PotentialOperation2", options.canEditItem, cache, options.hasOwnProperty("canEditItem"));
    o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
    o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
    o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
    o.selectionFeeInCents = options.selectionFeeInCents ?? null;
    o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
    o.materialLeadTimeConfig = maybeNewOrNull("MaterialLeadTimeConfig", options.materialLeadTimeConfig, cache);
    o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
    o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
    o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
    o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
    o.designNote = options.designNote ?? null;
    return o as FactoryResult<MaterialListing>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialListing"] = newMaterialListing;

export interface MaterialListingsPageOptions {
  __typename?: "MaterialListingsPage";
  entities?: Array<FactoryInput<MaterialListing, MaterialListingOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newMaterialListingsPage(
  options?: MaterialListingsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialListingsPage>;
export function newMaterialListingsPage(
  options: MaterialListingsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialListingsPage> {
  const o = (options.__typename ? options : cache["MaterialListingsPage"] = {}) as MaterialListingsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialListingsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("MaterialListing", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<MaterialListingsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialListingsPage"] = newMaterialListingsPage;

export interface MigrateMaterialListingItemResultOptions {
  __typename?: "MigrateMaterialListingItemResult";
  listings?: Array<FactoryInput<MaterialListing, MaterialListingOptions>>;
}

export function newMigrateMaterialListingItemResult(
  options?: MigrateMaterialListingItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MigrateMaterialListingItemResult>;
export function newMigrateMaterialListingItemResult(
  options: MigrateMaterialListingItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MigrateMaterialListingItemResult> {
  const o =
    (options.__typename ? options : cache["MigrateMaterialListingItemResult"] = {}) as MigrateMaterialListingItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MigrateMaterialListingItemResult";
    o.listings = (options.listings ?? []).map((i) =>
      maybeNew("MaterialListing", i, cache, options.hasOwnProperty("listings"))
    );
    return o as FactoryResult<MigrateMaterialListingItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MigrateMaterialListingItemResult"] = newMigrateMaterialListingItemResult;

export interface MergeMaterialListingsResultOptions {
  __typename?: "MergeMaterialListingsResult";
  target?: FactoryInput<MaterialListing, MaterialListingOptions>;
}

export function newMergeMaterialListingsResult(
  options?: MergeMaterialListingsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MergeMaterialListingsResult>;
export function newMergeMaterialListingsResult(
  options: MergeMaterialListingsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MergeMaterialListingsResult> {
  const o = (options.__typename ? options : cache["MergeMaterialListingsResult"] = {}) as MergeMaterialListingsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MergeMaterialListingsResult";
    o.target = maybeNew("MaterialListing", options.target, cache, options.hasOwnProperty("target"));
    return o as FactoryResult<MergeMaterialListingsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MergeMaterialListingsResult"] = newMergeMaterialListingsResult;

export interface DeleteMaterialVariantResultOptions {
  __typename?: "DeleteMaterialVariantResult";
  listing?: FactoryInput<MaterialListing, MaterialListingOptions> | null;
}

export function newDeleteMaterialVariantResult(
  options?: DeleteMaterialVariantResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteMaterialVariantResult>;
export function newDeleteMaterialVariantResult(
  options: DeleteMaterialVariantResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteMaterialVariantResult> {
  const o = (options.__typename ? options : cache["DeleteMaterialVariantResult"] = {}) as DeleteMaterialVariantResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteMaterialVariantResult";
    o.listing = maybeNewOrNull("MaterialListing", options.listing, cache);
    return o as FactoryResult<DeleteMaterialVariantResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteMaterialVariantResult"] = newDeleteMaterialVariantResult;

export interface UploadMaterialVariantsResultOptions {
  __typename?: "UploadMaterialVariantsResult";
  results?: Array<FactoryInput<UploadMaterialVariantResult, UploadMaterialVariantResultOptions>>;
}

export function newUploadMaterialVariantsResult(
  options?: UploadMaterialVariantsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UploadMaterialVariantsResult>;
export function newUploadMaterialVariantsResult(
  options: UploadMaterialVariantsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UploadMaterialVariantsResult> {
  const o = (options.__typename ? options : cache["UploadMaterialVariantsResult"] = {}) as UploadMaterialVariantsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UploadMaterialVariantsResult";
    o.results = (options.results ?? []).map((i) =>
      maybeNew("UploadMaterialVariantResult", i, cache, options.hasOwnProperty("results"))
    );
    return o as FactoryResult<UploadMaterialVariantsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UploadMaterialVariantsResult"] = newUploadMaterialVariantsResult;

export interface UploadMaterialVariantResultOptions {
  __typename?: "UploadMaterialVariantResult";
  data?: UploadMaterialVariantResult["data"];
  operation?: UploadMaterialVariantResult["operation"];
  newMaterialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  updatedMaterialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
}

export function newUploadMaterialVariantResult(
  options?: UploadMaterialVariantResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UploadMaterialVariantResult>;
export function newUploadMaterialVariantResult(
  options: UploadMaterialVariantResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UploadMaterialVariantResult> {
  const o = (options.__typename ? options : cache["UploadMaterialVariantResult"] = {}) as UploadMaterialVariantResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UploadMaterialVariantResult";
    o.data = options.data ?? "" as any;
    o.operation = options.operation ?? "operation";
    o.newMaterialVariant = maybeNewOrNull("MaterialVariant", options.newMaterialVariant, cache);
    o.updatedMaterialVariant = maybeNewOrNull("MaterialVariant", options.updatedMaterialVariant, cache);
    return o as FactoryResult<UploadMaterialVariantResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UploadMaterialVariantResult"] = newUploadMaterialVariantResult;

export interface MergeMaterialVariantsResultOptions {
  __typename?: "MergeMaterialVariantsResult";
  trackedJob?: FactoryInput<TrackedJob, TrackedJobOptions>;
}

export function newMergeMaterialVariantsResult(
  options?: MergeMaterialVariantsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MergeMaterialVariantsResult>;
export function newMergeMaterialVariantsResult(
  options: MergeMaterialVariantsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MergeMaterialVariantsResult> {
  const o = (options.__typename ? options : cache["MergeMaterialVariantsResult"] = {}) as MergeMaterialVariantsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MergeMaterialVariantsResult";
    o.trackedJob = maybeNew("TrackedJob", options.trackedJob, cache, options.hasOwnProperty("trackedJob"));
    return o as FactoryResult<MergeMaterialVariantsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MergeMaterialVariantsResult"] = newMergeMaterialVariantsResult;

export interface MaterialVariantOptions {
  __typename?: "MaterialVariant";
  id?: MaterialVariant["id"];
  code?: MaterialVariant["code"];
  displayName?: MaterialVariant["displayName"];
  modelNumber?: MaterialVariant["modelNumber"];
  createdAt?: MaterialVariant["createdAt"];
  updatedAt?: MaterialVariant["updatedAt"];
  deletedAt?: MaterialVariant["deletedAt"];
  listing?: FactoryInput<MaterialListing, MaterialListingOptions>;
  materialAttributeValues?: Array<FactoryInput<MaterialAttributeValue, MaterialAttributeValueOptions>>;
  bidItems?: Array<FactoryInput<BidItem, BidItemOptions>>;
  codeOverride?: MaterialVariant["codeOverride"];
  defaultBidItem?: FactoryInput<BidItem, BidItemOptions>;
  featuredImage?: FactoryInput<MaterialVariantImage, MaterialVariantImageOptions> | null;
  images?: Array<FactoryInput<MaterialVariantImage, MaterialVariantImageOptions>>;
  components?: Array<FactoryInput<MaterialAssemblyComponent, MaterialAssemblyComponentOptions>>;
  componentOf?: Array<FactoryInput<MaterialAssemblyComponent, MaterialAssemblyComponentOptions>>;
  lastUsedAt?: MaterialVariant["lastUsedAt"];
  effectiveMADs?: Array<FactoryInput<MaterialAttributeDimension, MaterialAttributeDimensionOptions>>;
  designFeedback?: MaterialVariant["designFeedback"];
  minCostInMills?: MaterialVariant["minCostInMills"];
  maxCostInMills?: MaterialVariant["maxCostInMills"];
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  tags?: Array<FactoryInput<MaterialVariantTag, MaterialVariantTagOptions>>;
  manufacturerUrl?: MaterialVariant["manufacturerUrl"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  sources?: Array<FactoryInput<MaterialVariant, MaterialVariantOptions>>;
  takeoffUsages?: Array<ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions>;
  matchesPlaceholder?: MaterialVariant["matchesPlaceholder"];
  hasAwardedCost?: MaterialVariant["hasAwardedCost"];
  merges?: Array<FactoryInput<MaterialVariantMerge, MaterialVariantMergeOptions>>;
}

export function newMaterialVariant(
  options?: MaterialVariantOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariant>;
export function newMaterialVariant(
  options: MaterialVariantOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialVariant> {
  const o = (options.__typename ? options : cache["MaterialVariant"] = {}) as MaterialVariant;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialVariant";
    o.id = options.id ?? nextFactoryId("MaterialVariant");
    o.code = options.code ?? "code";
    o.displayName = options.displayName ?? "displayName";
    o.modelNumber = options.modelNumber ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.deletedAt = options.deletedAt ?? null;
    o.listing = maybeNew("MaterialListing", options.listing, cache, options.hasOwnProperty("listing"));
    o.materialAttributeValues = (options.materialAttributeValues ?? []).map((i) =>
      maybeNew("MaterialAttributeValue", i, cache, options.hasOwnProperty("materialAttributeValues"))
    );
    o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
    o.codeOverride = options.codeOverride ?? null;
    o.defaultBidItem = maybeNew("BidItem", options.defaultBidItem, cache, options.hasOwnProperty("defaultBidItem"));
    o.featuredImage = maybeNewOrNull("MaterialVariantImage", options.featuredImage, cache);
    o.images = (options.images ?? []).map((i) =>
      maybeNew("MaterialVariantImage", i, cache, options.hasOwnProperty("images"))
    );
    o.components = (options.components ?? []).map((i) =>
      maybeNew("MaterialAssemblyComponent", i, cache, options.hasOwnProperty("components"))
    );
    o.componentOf = (options.componentOf ?? []).map((i) =>
      maybeNew("MaterialAssemblyComponent", i, cache, options.hasOwnProperty("componentOf"))
    );
    o.lastUsedAt = options.lastUsedAt ?? null;
    o.effectiveMADs = (options.effectiveMADs ?? []).map((i) =>
      maybeNew("MaterialAttributeDimension", i, cache, options.hasOwnProperty("effectiveMADs"))
    );
    o.designFeedback = options.designFeedback ?? null;
    o.minCostInMills = options.minCostInMills ?? null;
    o.maxCostInMills = options.maxCostInMills ?? null;
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.tags = (options.tags ?? []).map((i) => maybeNew("MaterialVariantTag", i, cache, options.hasOwnProperty("tags")));
    o.manufacturerUrl = options.manufacturerUrl ?? null;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.sources = (options.sources ?? []).map((i) =>
      maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("sources"))
    );
    o.takeoffUsages = (options.takeoffUsages ?? []).map((i) =>
      maybeNew("ReadyPlanLike", i, cache, options.hasOwnProperty("takeoffUsages"))
    );
    o.matchesPlaceholder = options.matchesPlaceholder ?? false;
    o.hasAwardedCost = options.hasAwardedCost ?? false;
    o.merges = (options.merges ?? []).map((i) =>
      maybeNew("MaterialVariantMerge", i, cache, options.hasOwnProperty("merges"))
    );
    return o as FactoryResult<MaterialVariant>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialVariant"] = newMaterialVariant;

export interface SaveMaterialVariantResultOptions {
  __typename?: "SaveMaterialVariantResult";
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
}

export function newSaveMaterialVariantResult(
  options?: SaveMaterialVariantResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveMaterialVariantResult>;
export function newSaveMaterialVariantResult(
  options: SaveMaterialVariantResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveMaterialVariantResult> {
  const o = (options.__typename ? options : cache["SaveMaterialVariantResult"] = {}) as SaveMaterialVariantResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveMaterialVariantResult";
    o.materialVariant = maybeNew(
      "MaterialVariant",
      options.materialVariant,
      cache,
      options.hasOwnProperty("materialVariant"),
    );
    return o as FactoryResult<SaveMaterialVariantResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveMaterialVariantResult"] = newSaveMaterialVariantResult;

export interface MaterialVariantsPageOptions {
  __typename?: "MaterialVariantsPage";
  entities?: Array<FactoryInput<MaterialVariant, MaterialVariantOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newMaterialVariantsPage(
  options?: MaterialVariantsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariantsPage>;
export function newMaterialVariantsPage(
  options: MaterialVariantsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialVariantsPage> {
  const o = (options.__typename ? options : cache["MaterialVariantsPage"] = {}) as MaterialVariantsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialVariantsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<MaterialVariantsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialVariantsPage"] = newMaterialVariantsPage;

export interface MaterialVariantCostSourcesPageOptions {
  __typename?: "MaterialVariantCostSourcesPage";
  entities?: Array<
    | MaterialCostSource
    | FactoryResult<MaterialCostSource>
    | BidItemEstimateOptions
    | RequireTypename<BidContractLineItemOptions>
  >;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newMaterialVariantCostSourcesPage(
  options?: MaterialVariantCostSourcesPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariantCostSourcesPage>;
export function newMaterialVariantCostSourcesPage(
  options: MaterialVariantCostSourcesPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialVariantCostSourcesPage> {
  const o =
    (options.__typename ? options : cache["MaterialVariantCostSourcesPage"] = {}) as MaterialVariantCostSourcesPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialVariantCostSourcesPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew(i?.__typename ?? "{BidItemEstimate", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<MaterialVariantCostSourcesPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialVariantCostSourcesPage"] = newMaterialVariantCostSourcesPage;

export interface MaterialVariantImageOptions {
  __typename?: "MaterialVariantImage";
  id?: MaterialVariantImage["id"];
  sortOrder?: MaterialVariantImage["sortOrder"];
  createdAt?: MaterialVariantImage["createdAt"];
  updatedAt?: MaterialVariantImage["updatedAt"];
  variant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  asset?: FactoryInput<Asset, AssetOptions> | null;
}

export function newMaterialVariantImage(
  options?: MaterialVariantImageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariantImage>;
export function newMaterialVariantImage(
  options: MaterialVariantImageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialVariantImage> {
  const o = (options.__typename ? options : cache["MaterialVariantImage"] = {}) as MaterialVariantImage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialVariantImage";
    o.id = options.id ?? nextFactoryId("MaterialVariantImage");
    o.sortOrder = options.sortOrder ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.variant = maybeNew("MaterialVariant", options.variant, cache, options.hasOwnProperty("variant"));
    o.asset = maybeNewOrNull("Asset", options.asset, cache);
    return o as FactoryResult<MaterialVariantImage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialVariantImage"] = newMaterialVariantImage;

export interface MaterialVariantMergesPageOptions {
  __typename?: "MaterialVariantMergesPage";
  entities?: Array<FactoryInput<MaterialVariantMerge, MaterialVariantMergeOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newMaterialVariantMergesPage(
  options?: MaterialVariantMergesPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariantMergesPage>;
export function newMaterialVariantMergesPage(
  options: MaterialVariantMergesPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialVariantMergesPage> {
  const o = (options.__typename ? options : cache["MaterialVariantMergesPage"] = {}) as MaterialVariantMergesPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialVariantMergesPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("MaterialVariantMerge", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<MaterialVariantMergesPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialVariantMergesPage"] = newMaterialVariantMergesPage;

export interface MaterialVariantMergeOptions {
  __typename?: "MaterialVariantMerge";
  id?: MaterialVariantMerge["id"];
  mergedIntoId?: MaterialVariantMerge["mergedIntoId"];
  mergedFromId?: MaterialVariantMerge["mergedFromId"];
  mergedFromCode?: MaterialVariantMerge["mergedFromCode"];
  mergedFromDisplayName?: MaterialVariantMerge["mergedFromDisplayName"];
  mergedFromListingId?: MaterialVariantMerge["mergedFromListingId"];
  mergedFromListingName?: MaterialVariantMerge["mergedFromListingName"];
  createdAt?: MaterialVariantMerge["createdAt"];
  updatedAt?: MaterialVariantMerge["updatedAt"];
  source?: MaterialVariantMerge["source"];
  winner?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  mergedBy?: FactoryInput<User, UserOptions> | null;
}

export function newMaterialVariantMerge(
  options?: MaterialVariantMergeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariantMerge>;
export function newMaterialVariantMerge(
  options: MaterialVariantMergeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialVariantMerge> {
  const o = (options.__typename ? options : cache["MaterialVariantMerge"] = {}) as MaterialVariantMerge;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialVariantMerge";
    o.id = options.id ?? nextFactoryId("MaterialVariantMerge");
    o.mergedIntoId = options.mergedIntoId ?? "mergedIntoId";
    o.mergedFromId = options.mergedFromId ?? "mergedFromId";
    o.mergedFromCode = options.mergedFromCode ?? "mergedFromCode";
    o.mergedFromDisplayName = options.mergedFromDisplayName ?? "mergedFromDisplayName";
    o.mergedFromListingId = options.mergedFromListingId ?? "mergedFromListingId";
    o.mergedFromListingName = options.mergedFromListingName ?? "mergedFromListingName";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.source = options.source ?? "source";
    o.winner = maybeNew("MaterialVariant", options.winner, cache, options.hasOwnProperty("winner"));
    o.mergedBy = maybeNewOrNull("User", options.mergedBy, cache);
    return o as FactoryResult<MaterialVariantMerge>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialVariantMerge"] = newMaterialVariantMerge;

export interface MaterialVariantTagOptions {
  __typename?: "MaterialVariantTag";
  id?: MaterialVariantTag["id"];
  name?: MaterialVariantTag["name"];
  createdAt?: MaterialVariantTag["createdAt"];
  updatedAt?: MaterialVariantTag["updatedAt"];
  materialVariants?: Array<FactoryInput<MaterialVariant, MaterialVariantOptions>>;
}

export function newMaterialVariantTag(
  options?: MaterialVariantTagOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariantTag>;
export function newMaterialVariantTag(
  options: MaterialVariantTagOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaterialVariantTag> {
  const o = (options.__typename ? options : cache["MaterialVariantTag"] = {}) as MaterialVariantTag;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MaterialVariantTag";
    o.id = options.id ?? nextFactoryId("MaterialVariantTag");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.materialVariants = (options.materialVariants ?? []).map((i) =>
      maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
    );
    return o as FactoryResult<MaterialVariantTag>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MaterialVariantTag"] = newMaterialVariantTag;

export interface SaveMaterialVariantTagResultOptions {
  __typename?: "SaveMaterialVariantTagResult";
  materialVariantTag?: FactoryInput<MaterialVariantTag, MaterialVariantTagOptions>;
}

export function newSaveMaterialVariantTagResult(
  options?: SaveMaterialVariantTagResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveMaterialVariantTagResult>;
export function newSaveMaterialVariantTagResult(
  options: SaveMaterialVariantTagResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveMaterialVariantTagResult> {
  const o = (options.__typename ? options : cache["SaveMaterialVariantTagResult"] = {}) as SaveMaterialVariantTagResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveMaterialVariantTagResult";
    o.materialVariantTag = maybeNew(
      "MaterialVariantTag",
      options.materialVariantTag,
      cache,
      options.hasOwnProperty("materialVariantTag"),
    );
    return o as FactoryResult<SaveMaterialVariantTagResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveMaterialVariantTagResult"] = newSaveMaterialVariantTagResult;

export interface MermaidResultOptions {
  __typename?: "MermaidResult";
  url?: MermaidResult["url"];
  code?: MermaidResult["code"];
}

export function newMermaidResult(
  options?: MermaidResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MermaidResult>;
export function newMermaidResult(
  options: MermaidResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MermaidResult> {
  const o = (options.__typename ? options : cache["MermaidResult"] = {}) as MermaidResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MermaidResult";
    o.url = options.url ?? "url";
    o.code = options.code ?? "code";
    return o as FactoryResult<MermaidResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MermaidResult"] = newMermaidResult;

export interface MobileSyncUpdatesPageResultOptions {
  __typename?: "MobileSyncUpdatesPageResult";
  entities?: Array<FactoryInput<MobileSyncUpdate, MobileSyncUpdateOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newMobileSyncUpdatesPageResult(
  options?: MobileSyncUpdatesPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MobileSyncUpdatesPageResult>;
export function newMobileSyncUpdatesPageResult(
  options: MobileSyncUpdatesPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MobileSyncUpdatesPageResult> {
  const o = (options.__typename ? options : cache["MobileSyncUpdatesPageResult"] = {}) as MobileSyncUpdatesPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MobileSyncUpdatesPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("MobileSyncUpdate", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<MobileSyncUpdatesPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MobileSyncUpdatesPageResult"] = newMobileSyncUpdatesPageResult;

export interface MobileSyncUpdateOptions {
  __typename?: "MobileSyncUpdate";
  id?: MobileSyncUpdate["id"];
  type?: MobileSyncUpdate["type"];
  createdAt?: MobileSyncUpdate["createdAt"];
  updatedAt?: MobileSyncUpdate["updatedAt"];
  entityId?: MobileSyncUpdate["entityId"];
  entity?: Entity | FactoryResult<EntityType> | EntityOptions | null;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
}

export function newMobileSyncUpdate(
  options?: MobileSyncUpdateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MobileSyncUpdate>;
export function newMobileSyncUpdate(
  options: MobileSyncUpdateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MobileSyncUpdate> {
  const o = (options.__typename ? options : cache["MobileSyncUpdate"] = {}) as MobileSyncUpdate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MobileSyncUpdate";
    o.id = options.id ?? nextFactoryId("MobileSyncUpdate");
    o.type = options.type ?? MobileSyncUpdateType.Created;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.entityId = options.entityId ?? "entityId";
    o.entity = maybeNewOrNull("Entity", options.entity, cache);
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    return o as FactoryResult<MobileSyncUpdate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MobileSyncUpdate"] = newMobileSyncUpdate;

export interface OptionPricingConfigOptions {
  __typename?: "OptionPricingConfig";
  id?: OptionPricingConfig["id"];
  selectionFeeInCents?: OptionPricingConfig["selectionFeeInCents"];
  createdAt?: OptionPricingConfig["createdAt"];
  updatedAt?: OptionPricingConfig["updatedAt"];
  variants?: Array<FactoryInput<OptionPricingConfigVariant, OptionPricingConfigVariantOptions>>;
  parent?:
    | OptionPricingConfigParent
    | FactoryResult<OptionPricingConfigParent>
    | CostCodeOptions
    | RequireTypename<GlobalOptionOptions>
    | RequireTypename<ItemOptions>
    | RequireTypename<MaterialListingOptions>
    | null;
  preCutoffDesiredMarginInBasisPoints?: OptionPricingConfig["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: OptionPricingConfig["postCutoffDesiredMarginInBasisPoints"];
  reasonNote?: OptionPricingConfig["reasonNote"];
  minimumPriceInCents?: OptionPricingConfig["minimumPriceInCents"];
}

export function newOptionPricingConfig(
  options?: OptionPricingConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<OptionPricingConfig>;
export function newOptionPricingConfig(
  options: OptionPricingConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<OptionPricingConfig> {
  const o = (options.__typename ? options : cache["OptionPricingConfig"] = {}) as OptionPricingConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "OptionPricingConfig";
    o.id = options.id ?? nextFactoryId("OptionPricingConfig");
    o.selectionFeeInCents = options.selectionFeeInCents ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.variants = (options.variants ?? []).map((i) =>
      maybeNew("OptionPricingConfigVariant", i, cache, options.hasOwnProperty("variants"))
    );
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "CostCode", options.parent, cache);
    o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
    o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
    o.reasonNote = options.reasonNote ?? null;
    o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
    return o as FactoryResult<OptionPricingConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["OptionPricingConfig"] = newOptionPricingConfig;

export interface SaveOptionPricingConfigsResultOptions {
  __typename?: "SaveOptionPricingConfigsResult";
  optionPricingConfigs?: Array<FactoryInput<OptionPricingConfig, OptionPricingConfigOptions>>;
}

export function newSaveOptionPricingConfigsResult(
  options?: SaveOptionPricingConfigsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveOptionPricingConfigsResult>;
export function newSaveOptionPricingConfigsResult(
  options: SaveOptionPricingConfigsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveOptionPricingConfigsResult> {
  const o =
    (options.__typename ? options : cache["SaveOptionPricingConfigsResult"] = {}) as SaveOptionPricingConfigsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveOptionPricingConfigsResult";
    o.optionPricingConfigs = (options.optionPricingConfigs ?? []).map((i) =>
      maybeNew("OptionPricingConfig", i, cache, options.hasOwnProperty("optionPricingConfigs"))
    );
    return o as FactoryResult<SaveOptionPricingConfigsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveOptionPricingConfigsResult"] = newSaveOptionPricingConfigsResult;

export interface OptionPricingConfigVariantOptions {
  __typename?: "OptionPricingConfigVariant";
  id?: OptionPricingConfigVariant["id"];
  createdAt?: OptionPricingConfigVariant["createdAt"];
  updatedAt?: OptionPricingConfigVariant["updatedAt"];
  optionPricingConfig?: FactoryInput<OptionPricingConfig, OptionPricingConfigOptions>;
  preCutoffDesiredMarginInBasisPoints?: OptionPricingConfigVariant["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: OptionPricingConfigVariant["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: OptionPricingConfigVariant["selectionFeeInCents"];
  reasonNote?: OptionPricingConfigVariant["reasonNote"];
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  minimumPriceInCents?: OptionPricingConfigVariant["minimumPriceInCents"];
}

export function newOptionPricingConfigVariant(
  options?: OptionPricingConfigVariantOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<OptionPricingConfigVariant>;
export function newOptionPricingConfigVariant(
  options: OptionPricingConfigVariantOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<OptionPricingConfigVariant> {
  const o = (options.__typename ? options : cache["OptionPricingConfigVariant"] = {}) as OptionPricingConfigVariant;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "OptionPricingConfigVariant";
    o.id = options.id ?? nextFactoryId("OptionPricingConfigVariant");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.optionPricingConfig = maybeNew(
      "OptionPricingConfig",
      options.optionPricingConfig,
      cache,
      options.hasOwnProperty("optionPricingConfig"),
    );
    o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
    o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
    o.selectionFeeInCents = options.selectionFeeInCents ?? null;
    o.reasonNote = options.reasonNote ?? null;
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    o.minimumPriceInCents = options.minimumPriceInCents ?? null;
    return o as FactoryResult<OptionPricingConfigVariant>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["OptionPricingConfigVariant"] = newOptionPricingConfigVariant;

export interface PageInfoOptions {
  __typename?: "PageInfo";
  hasNextPage?: PageInfo["hasNextPage"];
  totalCount?: PageInfo["totalCount"];
  nextPage?: FactoryInput<Page, PageOptions> | null;
}

export function newPageInfo(options?: PageInfoOptions, factoryOptions?: FactoryOptions): FactoryResult<PageInfo>;
export function newPageInfo(
  options: PageInfoOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PageInfo> {
  const o = (options.__typename ? options : cache["PageInfo"] = {}) as PageInfo;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PageInfo";
    o.hasNextPage = options.hasNextPage ?? false;
    o.totalCount = options.totalCount ?? 0;
    o.nextPage = maybeNewOrNull("Page", options.nextPage, cache);
    return o as FactoryResult<PageInfo>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PageInfo"] = newPageInfo;

export interface PageOptions {
  __typename?: "Page";
  limit?: Page["limit"];
  offset?: Page["offset"];
}

export function newPage(options?: PageOptions, factoryOptions?: FactoryOptions): FactoryResult<Page>;
export function newPage(
  options: PageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Page> {
  const o = (options.__typename ? options : cache["Page"] = {}) as Page;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Page";
    o.limit = options.limit ?? 0;
    o.offset = options.offset ?? 0;
    return o as FactoryResult<Page>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Page"] = newPage;

export interface PandaDocSessionOptions {
  __typename?: "PandaDocSession";
  sessionId?: PandaDocSession["sessionId"];
}

export function newPandaDocSession(
  options?: PandaDocSessionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PandaDocSession>;
export function newPandaDocSession(
  options: PandaDocSessionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PandaDocSession> {
  const o = (options.__typename ? options : cache["PandaDocSession"] = {}) as PandaDocSession;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PandaDocSession";
    o.sessionId = options.sessionId ?? "sessionId";
    return o as FactoryResult<PandaDocSession>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PandaDocSession"] = newPandaDocSession;

export interface PandaDocOptions {
  __typename?: "PandaDoc";
  id?: PandaDoc["id"];
  name?: PandaDoc["name"];
  externalPandaDocId?: PandaDoc["externalPandaDocId"];
  externalPandaDocUrl?: PandaDoc["externalPandaDocUrl"];
  status?: PandaDoc["status"];
  statusDetail?: PandaDocStatusDetailOptions | PandaDocStatus;
  recipients?: Array<FactoryInput<PandaDocRecipient, PandaDocRecipientOptions>>;
  commitment?: FactoryInput<Commitment, CommitmentOptions> | null;
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions> | null;
  commitmentChangeOrder?: FactoryInput<CommitmentChangeOrder, CommitmentChangeOrderOptions> | null;
  tags?: PandaDoc["tags"];
  document?: FactoryInput<Document, DocumentOptions> | null;
  owner?:
    | PandaDocOwner
    | FactoryResult<PandaDocOwner>
    | BidContractRevisionOptions
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DevelopmentCommitmentOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<LienWaiverOptions>
    | null;
  externalError?: PandaDoc["externalError"];
  canUpload?: FactoryInput<PotentialOperation2, PotentialOperation2Options> | null;
  canCreatePandaDocSession?: FactoryInput<PotentialOperation2, PotentialOperation2Options> | null;
}

export function newPandaDoc(options?: PandaDocOptions, factoryOptions?: FactoryOptions): FactoryResult<PandaDoc>;
export function newPandaDoc(
  options: PandaDocOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PandaDoc> {
  const o = (options.__typename ? options : cache["PandaDoc"] = {}) as PandaDoc;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PandaDoc";
    o.id = options.id ?? nextFactoryId("PandaDoc");
    o.name = options.name ?? "name";
    o.externalPandaDocId = options.externalPandaDocId ?? null;
    o.externalPandaDocUrl = options.externalPandaDocUrl ?? null;
    o.status = options.status ?? PandaDocStatus.Pending;
    o.statusDetail = enumOrDetailOfPandaDocStatus(options.statusDetail);
    o.recipients = (options.recipients ?? []).map((i) =>
      maybeNew("PandaDocRecipient", i, cache, options.hasOwnProperty("recipients"))
    );
    o.commitment = maybeNewOrNull("Commitment", options.commitment, cache);
    o.developmentCommitment = maybeNewOrNull("DevelopmentCommitment", options.developmentCommitment, cache);
    o.commitmentChangeOrder = maybeNewOrNull("CommitmentChangeOrder", options.commitmentChangeOrder, cache);
    o.tags = options.tags ?? [];
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.owner = maybeNewOrNull(options.owner?.__typename ?? "BidContractRevision", options.owner, cache);
    o.externalError = options.externalError ?? null;
    o.canUpload = maybeNewOrNull("PotentialOperation2", options.canUpload, cache);
    o.canCreatePandaDocSession = maybeNewOrNull("PotentialOperation2", options.canCreatePandaDocSession, cache);
    return o as FactoryResult<PandaDoc>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PandaDoc"] = newPandaDoc;

export interface SavePandaDocResultOptions {
  __typename?: "SavePandaDocResult";
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions>;
}

export function newSavePandaDocResult(
  options?: SavePandaDocResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePandaDocResult>;
export function newSavePandaDocResult(
  options: SavePandaDocResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePandaDocResult> {
  const o = (options.__typename ? options : cache["SavePandaDocResult"] = {}) as SavePandaDocResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePandaDocResult";
    o.pandaDoc = maybeNew("PandaDoc", options.pandaDoc, cache, options.hasOwnProperty("pandaDoc"));
    return o as FactoryResult<SavePandaDocResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePandaDocResult"] = newSavePandaDocResult;

export interface DeletePandaDocResultOptions {
  __typename?: "DeletePandaDocResult";
  owner?:
    | PandaDocOwner
    | FactoryResult<PandaDocOwner>
    | BidContractRevisionOptions
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DevelopmentCommitmentOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<LienWaiverOptions>;
}

export function newDeletePandaDocResult(
  options?: DeletePandaDocResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeletePandaDocResult>;
export function newDeletePandaDocResult(
  options: DeletePandaDocResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeletePandaDocResult> {
  const o = (options.__typename ? options : cache["DeletePandaDocResult"] = {}) as DeletePandaDocResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeletePandaDocResult";
    o.owner = maybeNew(options.owner?.__typename ?? "BidContractRevision", options.owner, cache);
    return o as FactoryResult<DeletePandaDocResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeletePandaDocResult"] = newDeletePandaDocResult;

export interface UploadPandaDocResultOptions {
  __typename?: "UploadPandaDocResult";
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions>;
}

export function newUploadPandaDocResult(
  options?: UploadPandaDocResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UploadPandaDocResult>;
export function newUploadPandaDocResult(
  options: UploadPandaDocResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UploadPandaDocResult> {
  const o = (options.__typename ? options : cache["UploadPandaDocResult"] = {}) as UploadPandaDocResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UploadPandaDocResult";
    o.pandaDoc = maybeNew("PandaDoc", options.pandaDoc, cache, options.hasOwnProperty("pandaDoc"));
    return o as FactoryResult<UploadPandaDocResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UploadPandaDocResult"] = newUploadPandaDocResult;

export interface PandaDocRecipientOptions {
  __typename?: "PandaDocRecipient";
  id?: PandaDocRecipient["id"];
  name?: PandaDocRecipient["name"];
  firstName?: PandaDocRecipient["firstName"];
  lastName?: PandaDocRecipient["lastName"];
  email?: PandaDocRecipient["email"];
  role?: PandaDocRecipient["role"];
  roleDetail?: PandaDocRoleDetailOptions | PandaDocRole;
  pandaDoc?: FactoryInput<PandaDoc, PandaDocOptions>;
  signingOrder?: PandaDocRecipient["signingOrder"];
  hasCompleted?: PandaDocRecipient["hasCompleted"];
}

export function newPandaDocRecipient(
  options?: PandaDocRecipientOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PandaDocRecipient>;
export function newPandaDocRecipient(
  options: PandaDocRecipientOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PandaDocRecipient> {
  const o = (options.__typename ? options : cache["PandaDocRecipient"] = {}) as PandaDocRecipient;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PandaDocRecipient";
    o.id = options.id ?? nextFactoryId("PandaDocRecipient");
    o.name = options.name ?? "name";
    o.firstName = options.firstName ?? "firstName";
    o.lastName = options.lastName ?? "lastName";
    o.email = options.email ?? "email";
    o.role = options.role ?? PandaDocRole.User;
    o.roleDetail = enumOrDetailOfPandaDocRole(options.roleDetail);
    o.pandaDoc = maybeNew("PandaDoc", options.pandaDoc, cache, options.hasOwnProperty("pandaDoc"));
    o.signingOrder = options.signingOrder ?? null;
    o.hasCompleted = options.hasCompleted ?? false;
    return o as FactoryResult<PandaDocRecipient>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PandaDocRecipient"] = newPandaDocRecipient;

export interface PaymentTermOptions {
  __typename?: "PaymentTerm";
  id?: PaymentTerm["id"];
  name?: PaymentTerm["name"];
  description?: PaymentTerm["description"];
  active?: PaymentTerm["active"];
  intacctId?: PaymentTerm["intacctId"];
  createdAt?: PaymentTerm["createdAt"];
  updatedAt?: PaymentTerm["updatedAt"];
  alignWithPaymentCycle?: PaymentTerm["alignWithPaymentCycle"];
  dueDay?: PaymentTerm["dueDay"];
  dueFrom?: PaymentTermDueFromDetailOptions | PaymentTermDueFrom;
}

export function newPaymentTerm(
  options?: PaymentTermOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PaymentTerm>;
export function newPaymentTerm(
  options: PaymentTermOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PaymentTerm> {
  const o = (options.__typename ? options : cache["PaymentTerm"] = {}) as PaymentTerm;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PaymentTerm";
    o.id = options.id ?? nextFactoryId("PaymentTerm");
    o.name = options.name ?? "name";
    o.description = options.description ?? null;
    o.active = options.active ?? false;
    o.intacctId = options.intacctId ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.alignWithPaymentCycle = options.alignWithPaymentCycle ?? false;
    o.dueDay = options.dueDay ?? 0;
    o.dueFrom = enumOrDetailOfPaymentTermDueFrom(options.dueFrom);
    return o as FactoryResult<PaymentTerm>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PaymentTerm"] = newPaymentTerm;

export interface SavePaymentTermResultOptions {
  __typename?: "SavePaymentTermResult";
  paymentTerm?: FactoryInput<PaymentTerm, PaymentTermOptions>;
}

export function newSavePaymentTermResult(
  options?: SavePaymentTermResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePaymentTermResult>;
export function newSavePaymentTermResult(
  options: SavePaymentTermResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePaymentTermResult> {
  const o = (options.__typename ? options : cache["SavePaymentTermResult"] = {}) as SavePaymentTermResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePaymentTermResult";
    o.paymentTerm = maybeNew("PaymentTerm", options.paymentTerm, cache, options.hasOwnProperty("paymentTerm"));
    return o as FactoryResult<SavePaymentTermResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePaymentTermResult"] = newSavePaymentTermResult;

export interface PermissionsOptions {
  __typename?: "Permissions";
  canEdit?: Permissions["canEdit"];
  canDelete?: Permissions["canDelete"];
}

export function newPermissions(
  options?: PermissionsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<Permissions>;
export function newPermissions(
  options: PermissionsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Permissions> {
  const o = (options.__typename ? options : cache["Permissions"] = {}) as Permissions;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Permissions";
    o.canEdit = options.canEdit ?? false;
    o.canDelete = options.canDelete ?? false;
    return o as FactoryResult<Permissions>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Permissions"] = newPermissions;

export interface PlanBasedBidContractLineItemOptions {
  __typename?: "PlanBasedBidContractLineItem";
  id?: PlanBasedBidContractLineItem["id"];
  totalCostInCents?: PlanBasedBidContractLineItem["totalCostInCents"];
  createdAt?: PlanBasedBidContractLineItem["createdAt"];
  updatedAt?: PlanBasedBidContractLineItem["updatedAt"];
  revision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  costCode?: FactoryInput<CostCode, CostCodeOptions>;
  groupLine?: FactoryInput<BidPlanChildGroupLine, BidPlanChildGroupLineOptions>;
  forCoveringTakeoffs?: PlanBasedBidContractLineItem["forCoveringTakeoffs"];
  isNoCost?: PlanBasedBidContractLineItem["isNoCost"];
  userSet?: PlanBasedBidContractLineItem["userSet"];
}

export function newPlanBasedBidContractLineItem(
  options?: PlanBasedBidContractLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanBasedBidContractLineItem>;
export function newPlanBasedBidContractLineItem(
  options: PlanBasedBidContractLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanBasedBidContractLineItem> {
  const o = (options.__typename ? options : cache["PlanBasedBidContractLineItem"] = {}) as PlanBasedBidContractLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanBasedBidContractLineItem";
    o.id = options.id ?? nextFactoryId("PlanBasedBidContractLineItem");
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.revision = maybeNew("BidContractRevision", options.revision, cache, options.hasOwnProperty("revision"));
    o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
    o.groupLine = maybeNew("BidPlanChildGroupLine", options.groupLine, cache, options.hasOwnProperty("groupLine"));
    o.forCoveringTakeoffs = options.forCoveringTakeoffs ?? false;
    o.isNoCost = options.isNoCost ?? false;
    o.userSet = options.userSet ?? false;
    return o as FactoryResult<PlanBasedBidContractLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanBasedBidContractLineItem"] = newPlanBasedBidContractLineItem;

export interface PlanMilestoneOptions {
  __typename?: "PlanMilestone";
  id?: PlanMilestone["id"];
  name?: PlanMilestone["name"];
  estStartDate?: PlanMilestone["estStartDate"];
  estEndDate?: PlanMilestone["estEndDate"];
  totalDays?: PlanMilestone["totalDays"];
  progress?: PlanMilestone["progress"];
  confidence?: PlanMilestone["confidence"];
  durationInDays?: PlanMilestone["durationInDays"];
  createdAt?: PlanMilestone["createdAt"];
  updatedAt?: PlanMilestone["updatedAt"];
  globalPlanMilestone?: FactoryInput<GlobalPlanMilestone, GlobalPlanMilestoneOptions>;
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions>;
  allowingPlanTasks?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
  taskStatusRollup?: TaskStatusDetailOptions | TaskStatus;
  completedAt?: PlanMilestone["completedAt"];
}

export function newPlanMilestone(
  options?: PlanMilestoneOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanMilestone>;
export function newPlanMilestone(
  options: PlanMilestoneOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanMilestone> {
  const o = (options.__typename ? options : cache["PlanMilestone"] = {}) as PlanMilestone;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanMilestone";
    o.id = options.id ?? nextFactoryId("PlanMilestone");
    o.name = options.name ?? "name";
    o.estStartDate = options.estStartDate ?? null;
    o.estEndDate = options.estEndDate ?? null;
    o.totalDays = options.totalDays ?? 0;
    o.progress = options.progress ?? 0;
    o.confidence = options.confidence ?? 0;
    o.durationInDays = options.durationInDays ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalPlanMilestone = maybeNew(
      "GlobalPlanMilestone",
      options.globalPlanMilestone,
      cache,
      options.hasOwnProperty("globalPlanMilestone"),
    );
    o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
    o.allowingPlanTasks = (options.allowingPlanTasks ?? []).map((i) =>
      maybeNew("PlanTask", i, cache, options.hasOwnProperty("allowingPlanTasks"))
    );
    o.taskStatusRollup = enumOrDetailOfTaskStatus(options.taskStatusRollup);
    o.completedAt = options.completedAt ?? null;
    return o as FactoryResult<PlanMilestone>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanMilestone"] = newPlanMilestone;

export interface PlanMilestonesResultOptions {
  __typename?: "PlanMilestonesResult";
  entities?: Array<FactoryInput<PlanMilestone, PlanMilestoneOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newPlanMilestonesResult(
  options?: PlanMilestonesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanMilestonesResult>;
export function newPlanMilestonesResult(
  options: PlanMilestonesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanMilestonesResult> {
  const o = (options.__typename ? options : cache["PlanMilestonesResult"] = {}) as PlanMilestonesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanMilestonesResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<PlanMilestonesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanMilestonesResult"] = newPlanMilestonesResult;

export interface PlanMilestoneSnapshotOptions {
  __typename?: "PlanMilestoneSnapshot";
  id?: PlanMilestoneSnapshot["id"];
  range?: PlanMilestoneSnapshot["range"];
  estStartDate?: PlanMilestoneSnapshot["estStartDate"];
  estEndDate?: PlanMilestoneSnapshot["estEndDate"];
  durationInDays?: PlanMilestoneSnapshot["durationInDays"];
  createdAt?: PlanMilestoneSnapshot["createdAt"];
  updatedAt?: PlanMilestoneSnapshot["updatedAt"];
  planMilestone?: FactoryInput<PlanMilestone, PlanMilestoneOptions>;
}

export function newPlanMilestoneSnapshot(
  options?: PlanMilestoneSnapshotOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanMilestoneSnapshot>;
export function newPlanMilestoneSnapshot(
  options: PlanMilestoneSnapshotOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanMilestoneSnapshot> {
  const o = (options.__typename ? options : cache["PlanMilestoneSnapshot"] = {}) as PlanMilestoneSnapshot;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanMilestoneSnapshot";
    o.id = options.id ?? nextFactoryId("PlanMilestoneSnapshot");
    o.range = options.range ?? "range";
    o.estStartDate = options.estStartDate ?? null;
    o.estEndDate = options.estEndDate ?? null;
    o.durationInDays = options.durationInDays ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.planMilestone = maybeNew("PlanMilestone", options.planMilestone, cache, options.hasOwnProperty("planMilestone"));
    return o as FactoryResult<PlanMilestoneSnapshot>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanMilestoneSnapshot"] = newPlanMilestoneSnapshot;

export interface PlanMilestoneTargetOptions {
  __typename?: "PlanMilestoneTarget";
  id?: PlanMilestoneTarget["id"];
  targetDaysFromRts?: PlanMilestoneTarget["targetDaysFromRts"];
  createdAt?: PlanMilestoneTarget["createdAt"];
  updatedAt?: PlanMilestoneTarget["updatedAt"];
  globalPlanMilestone?: FactoryInput<GlobalPlanMilestone, GlobalPlanMilestoneOptions>;
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions>;
  communityTarget?: FactoryInput<PlanMilestoneTarget, PlanMilestoneTargetOptions> | null;
  planMilestone?: FactoryInput<PlanMilestone, PlanMilestoneOptions> | null;
  targetDaysFromRtsSetByUser?: PlanMilestoneTarget["targetDaysFromRtsSetByUser"];
}

export function newPlanMilestoneTarget(
  options?: PlanMilestoneTargetOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanMilestoneTarget>;
export function newPlanMilestoneTarget(
  options: PlanMilestoneTargetOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanMilestoneTarget> {
  const o = (options.__typename ? options : cache["PlanMilestoneTarget"] = {}) as PlanMilestoneTarget;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanMilestoneTarget";
    o.id = options.id ?? nextFactoryId("PlanMilestoneTarget");
    o.targetDaysFromRts = options.targetDaysFromRts ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.globalPlanMilestone = maybeNew(
      "GlobalPlanMilestone",
      options.globalPlanMilestone,
      cache,
      options.hasOwnProperty("globalPlanMilestone"),
    );
    o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
    o.communityTarget = maybeNewOrNull("PlanMilestoneTarget", options.communityTarget, cache);
    o.planMilestone = maybeNewOrNull("PlanMilestone", options.planMilestone, cache);
    o.targetDaysFromRtsSetByUser = options.targetDaysFromRtsSetByUser ?? null;
    return o as FactoryResult<PlanMilestoneTarget>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanMilestoneTarget"] = newPlanMilestoneTarget;

export interface SavePlanPackageResultOptions {
  __typename?: "SavePlanPackageResult";
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newSavePlanPackageResult(
  options?: SavePlanPackageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePlanPackageResult>;
export function newSavePlanPackageResult(
  options: SavePlanPackageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePlanPackageResult> {
  const o = (options.__typename ? options : cache["SavePlanPackageResult"] = {}) as SavePlanPackageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePlanPackageResult";
    o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
    return o as FactoryResult<SavePlanPackageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePlanPackageResult"] = newSavePlanPackageResult;

export interface PlanPackagesPageResultOptions {
  __typename?: "PlanPackagesPageResult";
  entities?: Array<FactoryInput<PlanPackage, PlanPackageOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newPlanPackagesPageResult(
  options?: PlanPackagesPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackagesPageResult>;
export function newPlanPackagesPageResult(
  options: PlanPackagesPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanPackagesPageResult> {
  const o = (options.__typename ? options : cache["PlanPackagesPageResult"] = {}) as PlanPackagesPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanPackagesPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("PlanPackage", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<PlanPackagesPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanPackagesPageResult"] = newPlanPackagesPageResult;

export interface PlanPackageAiProposalOptions {
  __typename?: "PlanPackageAiProposal";
  id?: PlanPackageAiProposal["id"];
  createdAt?: PlanPackageAiProposal["createdAt"];
  updatedAt?: PlanPackageAiProposal["updatedAt"];
  status?: AiProposalStatusDetailOptions | AiProposalStatus;
  failureReason?: PlanPackageAiProposal["failureReason"];
  agentCompletedAt?: PlanPackageAiProposal["agentCompletedAt"];
  progressText?: PlanPackageAiProposal["progressText"];
  entityProposals?: Array<FactoryInput<AiEntityProposal, AiEntityProposalOptions>>;
  hasEntityProposals?: PlanPackageAiProposal["hasEntityProposals"];
  hasLocationProposals?: PlanPackageAiProposal["hasLocationProposals"];
  hasOptionProposals?: PlanPackageAiProposal["hasOptionProposals"];
  hasProgramDataProposals?: PlanPackageAiProposal["hasProgramDataProposals"];
  hasElevationProposals?: PlanPackageAiProposal["hasElevationProposals"];
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  asset?: FactoryInput<Asset, AssetOptions>;
}

export function newPlanPackageAiProposal(
  options?: PlanPackageAiProposalOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackageAiProposal>;
export function newPlanPackageAiProposal(
  options: PlanPackageAiProposalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanPackageAiProposal> {
  const o = (options.__typename ? options : cache["PlanPackageAiProposal"] = {}) as PlanPackageAiProposal;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanPackageAiProposal";
    o.id = options.id ?? nextFactoryId("PlanPackageAiProposal");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = enumOrDetailOfAiProposalStatus(options.status);
    o.failureReason = options.failureReason ?? null;
    o.agentCompletedAt = options.agentCompletedAt ?? null;
    o.progressText = options.progressText ?? null;
    o.entityProposals = (options.entityProposals ?? []).map((i) =>
      maybeNew("AiEntityProposal", i, cache, options.hasOwnProperty("entityProposals"))
    );
    o.hasEntityProposals = options.hasEntityProposals ?? false;
    o.hasLocationProposals = options.hasLocationProposals ?? false;
    o.hasOptionProposals = options.hasOptionProposals ?? false;
    o.hasProgramDataProposals = options.hasProgramDataProposals ?? false;
    o.hasElevationProposals = options.hasElevationProposals ?? false;
    o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    return o as FactoryResult<PlanPackageAiProposal>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanPackageAiProposal"] = newPlanPackageAiProposal;

export interface PlanPackageIncomingSlotOptions {
  __typename?: "PlanPackageIncomingSlot";
  id?: PlanPackageIncomingSlot["id"];
  createdAt?: PlanPackageIncomingSlot["createdAt"];
  createdBy?: FactoryInput<User, UserOptions>;
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  designPackagePlaceholder?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
  status?: PlanPackageIncomingSlotStatusDetailOptions | PlanPackageIncomingSlotStatus;
  planPackageRpl?: FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>;
}

export function newPlanPackageIncomingSlot(
  options?: PlanPackageIncomingSlotOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackageIncomingSlot>;
export function newPlanPackageIncomingSlot(
  options: PlanPackageIncomingSlotOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanPackageIncomingSlot> {
  const o = (options.__typename ? options : cache["PlanPackageIncomingSlot"] = {}) as PlanPackageIncomingSlot;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanPackageIncomingSlot";
    o.id = options.id ?? nextFactoryId("PlanPackageIncomingSlot");
    o.createdAt = options.createdAt ?? newDateTime();
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
    o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
    o.designPackagePlaceholder = maybeNew(
      "TakeoffLineItem",
      options.designPackagePlaceholder,
      cache,
      options.hasOwnProperty("designPackagePlaceholder"),
    );
    o.status = enumOrDetailOfPlanPackageIncomingSlotStatus(options.status);
    o.planPackageRpl = maybeNew(
      "ReadyPlanLocation",
      options.planPackageRpl,
      cache,
      options.hasOwnProperty("planPackageRpl"),
    );
    return o as FactoryResult<PlanPackageIncomingSlot>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanPackageIncomingSlot"] = newPlanPackageIncomingSlot;

export interface PlanPackageSlotDeletionRequestOptions {
  __typename?: "PlanPackageSlotDeletionRequest";
  id?: PlanPackageSlotDeletionRequest["id"];
}

export function newPlanPackageSlotDeletionRequest(
  options?: PlanPackageSlotDeletionRequestOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackageSlotDeletionRequest>;
export function newPlanPackageSlotDeletionRequest(
  options: PlanPackageSlotDeletionRequestOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanPackageSlotDeletionRequest> {
  const o =
    (options.__typename ? options : cache["PlanPackageSlotDeletionRequest"] = {}) as PlanPackageSlotDeletionRequest;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanPackageSlotDeletionRequest";
    o.id = options.id ?? nextFactoryId("PlanPackageSlotDeletionRequest");
    return o as FactoryResult<PlanPackageSlotDeletionRequest>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanPackageSlotDeletionRequest"] = newPlanPackageSlotDeletionRequest;

export interface PlanPackageVersionOptions {
  __typename?: "PlanPackageVersion";
  id?: PlanPackageVersion["id"];
  name?: PlanPackageVersion["name"];
  createdAt?: PlanPackageVersion["createdAt"];
  updatedAt?: PlanPackageVersion["updatedAt"];
  code?: PlanPackageVersion["code"];
  contingencyMarkupPercentage?: PlanPackageVersion["contingencyMarkupPercentage"];
  description?: PlanPackageVersion["description"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  lotTypes?: PlanPackageVersion["lotTypes"];
  identity?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  markets?: Array<FactoryInput<Market, MarketOptions>>;
  insideMapsProjectId?: PlanPackageVersion["insideMapsProjectId"];
  owner?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newPlanPackageVersion(
  options?: PlanPackageVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackageVersion>;
export function newPlanPackageVersion(
  options: PlanPackageVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanPackageVersion> {
  const o = (options.__typename ? options : cache["PlanPackageVersion"] = {}) as PlanPackageVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanPackageVersion";
    o.id = options.id ?? nextFactoryId("PlanPackageVersion");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.code = options.code ?? null;
    o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
    o.description = options.description ?? null;
    o.type = enumOrDetailOfReadyPlanType(options.type);
    o.lotTypes = options.lotTypes ?? [];
    o.identity = maybeNew("ReadyPlan", options.identity, cache, options.hasOwnProperty("identity"));
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
    o.insideMapsProjectId = options.insideMapsProjectId ?? null;
    o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
    return o as FactoryResult<PlanPackageVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanPackageVersion"] = newPlanPackageVersion;

export interface PlanScheduleOptions {
  __typename?: "PlanSchedule";
  id?: PlanSchedule["id"];
  createdAt?: PlanSchedule["createdAt"];
  updatedAt?: PlanSchedule["updatedAt"];
  tasks?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
  parent?:
    | PlanScheduleParent
    | FactoryResult<PlanScheduleParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  planMilestones?: Array<FactoryInput<PlanMilestone, PlanMilestoneOptions>>;
  recalculatedAt?: PlanSchedule["recalculatedAt"];
  recalculatedBy?: FactoryInput<User, UserOptions> | null;
  targetStartDate?: PlanSchedule["targetStartDate"];
  targetEndDate?: PlanSchedule["targetEndDate"];
  currentBaselineDate?: PlanSchedule["currentBaselineDate"];
  targetCycleTimeInDays?: PlanSchedule["targetCycleTimeInDays"];
  targetCycleTimeInCalendarDays?: PlanSchedule["targetCycleTimeInCalendarDays"];
  targetCycleTimeInWorkingDays?: PlanSchedule["targetCycleTimeInWorkingDays"];
  communityTargetCycleTimeInDays?: PlanSchedule["communityTargetCycleTimeInDays"];
  cycleTimeInWorkingDays?: PlanSchedule["cycleTimeInWorkingDays"];
  cycleTimeInCalendarDays?: PlanSchedule["cycleTimeInCalendarDays"];
  verticalCompleteDate?: PlanSchedule["verticalCompleteDate"];
  readyToStartDate?: PlanSchedule["readyToStartDate"];
  preconReadyToStartDate?: PlanSchedule["preconReadyToStartDate"];
  targetEndDateProbability?: PlanSchedule["targetEndDateProbability"];
  schedulingExclusionDates?: Array<FactoryInput<SchedulingExclusionDate, SchedulingExclusionDateOptions>>;
  canSendTradePartnerAvailabilityRequestEmail?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  targetConstructionRtsDate?: PlanSchedule["targetConstructionRtsDate"];
  targetPreconRtsDate?: PlanSchedule["targetPreconRtsDate"];
  planMilestoneTargets?: Array<FactoryInput<PlanMilestoneTarget, PlanMilestoneTargetOptions>>;
  childVerticalCompleteInDays?: PlanSchedule["childVerticalCompleteInDays"];
}

export function newPlanSchedule(
  options?: PlanScheduleOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanSchedule>;
export function newPlanSchedule(
  options: PlanScheduleOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanSchedule> {
  const o = (options.__typename ? options : cache["PlanSchedule"] = {}) as PlanSchedule;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanSchedule";
    o.id = options.id ?? nextFactoryId("PlanSchedule");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tasks = (options.tasks ?? []).map((i) => maybeNew("PlanTask", i, cache, options.hasOwnProperty("tasks")));
    o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    o.planMilestones = (options.planMilestones ?? []).map((i) =>
      maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("planMilestones"))
    );
    o.recalculatedAt = options.recalculatedAt ?? null;
    o.recalculatedBy = maybeNewOrNull("User", options.recalculatedBy, cache);
    o.targetStartDate = options.targetStartDate ?? newDate();
    o.targetEndDate = options.targetEndDate ?? newDate();
    o.currentBaselineDate = options.currentBaselineDate ?? newDate();
    o.targetCycleTimeInDays = options.targetCycleTimeInDays ?? 0;
    o.targetCycleTimeInCalendarDays = options.targetCycleTimeInCalendarDays ?? 0;
    o.targetCycleTimeInWorkingDays = options.targetCycleTimeInWorkingDays ?? 0;
    o.communityTargetCycleTimeInDays = options.communityTargetCycleTimeInDays ?? 0;
    o.cycleTimeInWorkingDays = options.cycleTimeInWorkingDays ?? null;
    o.cycleTimeInCalendarDays = options.cycleTimeInCalendarDays ?? null;
    o.verticalCompleteDate = options.verticalCompleteDate ?? null;
    o.readyToStartDate = options.readyToStartDate ?? null;
    o.preconReadyToStartDate = options.preconReadyToStartDate ?? null;
    o.targetEndDateProbability = options.targetEndDateProbability ?? null;
    o.schedulingExclusionDates = (options.schedulingExclusionDates ?? []).map((i) =>
      maybeNew("SchedulingExclusionDate", i, cache, options.hasOwnProperty("schedulingExclusionDates"))
    );
    o.canSendTradePartnerAvailabilityRequestEmail = maybeNew(
      "PotentialOperation2",
      options.canSendTradePartnerAvailabilityRequestEmail,
      cache,
      options.hasOwnProperty("canSendTradePartnerAvailabilityRequestEmail"),
    );
    o.targetConstructionRtsDate = options.targetConstructionRtsDate ?? null;
    o.targetPreconRtsDate = options.targetPreconRtsDate ?? null;
    o.planMilestoneTargets = (options.planMilestoneTargets ?? []).map((i) =>
      maybeNew("PlanMilestoneTarget", i, cache, options.hasOwnProperty("planMilestoneTargets"))
    );
    o.childVerticalCompleteInDays = options.childVerticalCompleteInDays ?? null;
    return o as FactoryResult<PlanSchedule>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanSchedule"] = newPlanSchedule;

export interface SavePlanScheduleResultOptions {
  __typename?: "SavePlanScheduleResult";
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions>;
}

export function newSavePlanScheduleResult(
  options?: SavePlanScheduleResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePlanScheduleResult>;
export function newSavePlanScheduleResult(
  options: SavePlanScheduleResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePlanScheduleResult> {
  const o = (options.__typename ? options : cache["SavePlanScheduleResult"] = {}) as SavePlanScheduleResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePlanScheduleResult";
    o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
    return o as FactoryResult<SavePlanScheduleResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePlanScheduleResult"] = newSavePlanScheduleResult;

export interface DraftScheduleResultOptions {
  __typename?: "DraftScheduleResult";
  planTasks?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
  newlyCompletedPlanTasks?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
  tradeConfirmPlanTasks?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions>;
  bills?: Array<FactoryInput<Bill, BillOptions>> | null;
  planTaskDetail?: FactoryInput<PlanTask, PlanTaskOptions> | null;
}

export function newDraftScheduleResult(
  options?: DraftScheduleResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DraftScheduleResult>;
export function newDraftScheduleResult(
  options: DraftScheduleResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DraftScheduleResult> {
  const o = (options.__typename ? options : cache["DraftScheduleResult"] = {}) as DraftScheduleResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DraftScheduleResult";
    o.planTasks = (options.planTasks ?? []).map((i) =>
      maybeNew("PlanTask", i, cache, options.hasOwnProperty("planTasks"))
    );
    o.newlyCompletedPlanTasks = (options.newlyCompletedPlanTasks ?? []).map((i) =>
      maybeNew("PlanTask", i, cache, options.hasOwnProperty("newlyCompletedPlanTasks"))
    );
    o.tradeConfirmPlanTasks = (options.tradeConfirmPlanTasks ?? []).map((i) =>
      maybeNew("PlanTask", i, cache, options.hasOwnProperty("tradeConfirmPlanTasks"))
    );
    o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
    o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
    o.planTaskDetail = maybeNewOrNull("PlanTask", options.planTaskDetail, cache);
    return o as FactoryResult<DraftScheduleResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DraftScheduleResult"] = newDraftScheduleResult;

export interface PlanScheduleSnapshotsResultOptions {
  __typename?: "PlanScheduleSnapshotsResult";
  taskSnapshots?: Array<FactoryInput<TaskSnapshot, TaskSnapshotOptions>>;
  planMilestoneSnapshots?: Array<FactoryInput<PlanMilestoneSnapshot, PlanMilestoneSnapshotOptions>>;
}

export function newPlanScheduleSnapshotsResult(
  options?: PlanScheduleSnapshotsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanScheduleSnapshotsResult>;
export function newPlanScheduleSnapshotsResult(
  options: PlanScheduleSnapshotsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanScheduleSnapshotsResult> {
  const o = (options.__typename ? options : cache["PlanScheduleSnapshotsResult"] = {}) as PlanScheduleSnapshotsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanScheduleSnapshotsResult";
    o.taskSnapshots = (options.taskSnapshots ?? []).map((i) =>
      maybeNew("TaskSnapshot", i, cache, options.hasOwnProperty("taskSnapshots"))
    );
    o.planMilestoneSnapshots = (options.planMilestoneSnapshots ?? []).map((i) =>
      maybeNew("PlanMilestoneSnapshot", i, cache, options.hasOwnProperty("planMilestoneSnapshots"))
    );
    return o as FactoryResult<PlanScheduleSnapshotsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanScheduleSnapshotsResult"] = newPlanScheduleSnapshotsResult;

export interface ForceScalePlanMilestoneTargetsResultOptions {
  __typename?: "ForceScalePlanMilestoneTargetsResult";
  planSchedules?: Array<FactoryInput<PlanSchedule, PlanScheduleOptions>>;
}

export function newForceScalePlanMilestoneTargetsResult(
  options?: ForceScalePlanMilestoneTargetsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ForceScalePlanMilestoneTargetsResult>;
export function newForceScalePlanMilestoneTargetsResult(
  options: ForceScalePlanMilestoneTargetsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ForceScalePlanMilestoneTargetsResult> {
  const o =
    (options.__typename
      ? options
      : cache["ForceScalePlanMilestoneTargetsResult"] = {}) as ForceScalePlanMilestoneTargetsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ForceScalePlanMilestoneTargetsResult";
    o.planSchedules = (options.planSchedules ?? []).map((i) =>
      maybeNew("PlanSchedule", i, cache, options.hasOwnProperty("planSchedules"))
    );
    return o as FactoryResult<ForceScalePlanMilestoneTargetsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ForceScalePlanMilestoneTargetsResult"] = newForceScalePlanMilestoneTargetsResult;

export interface SavePlanTaskResultOptions {
  __typename?: "SavePlanTaskResult";
  planTask?: FactoryInput<PlanTask, PlanTaskOptions>;
}

export function newSavePlanTaskResult(
  options?: SavePlanTaskResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePlanTaskResult>;
export function newSavePlanTaskResult(
  options: SavePlanTaskResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePlanTaskResult> {
  const o = (options.__typename ? options : cache["SavePlanTaskResult"] = {}) as SavePlanTaskResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePlanTaskResult";
    o.planTask = maybeNew("PlanTask", options.planTask, cache, options.hasOwnProperty("planTask"));
    return o as FactoryResult<SavePlanTaskResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePlanTaskResult"] = newSavePlanTaskResult;

export interface PlanTasksResultOptions {
  __typename?: "PlanTasksResult";
  entities?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newPlanTasksResult(
  options?: PlanTasksResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanTasksResult>;
export function newPlanTasksResult(
  options: PlanTasksResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanTasksResult> {
  const o = (options.__typename ? options : cache["PlanTasksResult"] = {}) as PlanTasksResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanTasksResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("PlanTask", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<PlanTasksResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanTasksResult"] = newPlanTasksResult;

export interface SimulationProbabilityOptions {
  __typename?: "SimulationProbability";
  startDateBasisPoints?: SimulationProbability["startDateBasisPoints"];
  endDateBasisPoints?: SimulationProbability["endDateBasisPoints"];
  potentialStartDateBasisPoints?: Array<FactoryInput<PotentialDateBasisPoints, PotentialDateBasisPointsOptions>> | null;
  potentialEndDateBasisPoints?: Array<FactoryInput<PotentialDateBasisPoints, PotentialDateBasisPointsOptions>> | null;
}

export function newSimulationProbability(
  options?: SimulationProbabilityOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SimulationProbability>;
export function newSimulationProbability(
  options: SimulationProbabilityOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SimulationProbability> {
  const o = (options.__typename ? options : cache["SimulationProbability"] = {}) as SimulationProbability;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SimulationProbability";
    o.startDateBasisPoints = options.startDateBasisPoints ?? null;
    o.endDateBasisPoints = options.endDateBasisPoints ?? null;
    o.potentialStartDateBasisPoints = (options.potentialStartDateBasisPoints ?? []).map((i) =>
      maybeNew("PotentialDateBasisPoints", i, cache, options.hasOwnProperty("potentialStartDateBasisPoints"))
    );
    o.potentialEndDateBasisPoints = (options.potentialEndDateBasisPoints ?? []).map((i) =>
      maybeNew("PotentialDateBasisPoints", i, cache, options.hasOwnProperty("potentialEndDateBasisPoints"))
    );
    return o as FactoryResult<SimulationProbability>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SimulationProbability"] = newSimulationProbability;

export interface PotentialDateBasisPointsOptions {
  __typename?: "PotentialDateBasisPoints";
  date?: PotentialDateBasisPoints["date"];
  basisPoints?: PotentialDateBasisPoints["basisPoints"];
}

export function newPotentialDateBasisPoints(
  options?: PotentialDateBasisPointsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PotentialDateBasisPoints>;
export function newPotentialDateBasisPoints(
  options: PotentialDateBasisPointsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialDateBasisPoints> {
  const o = (options.__typename ? options : cache["PotentialDateBasisPoints"] = {}) as PotentialDateBasisPoints;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PotentialDateBasisPoints";
    o.date = options.date ?? newDate();
    o.basisPoints = options.basisPoints ?? 0;
    return o as FactoryResult<PotentialDateBasisPoints>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PotentialDateBasisPoints"] = newPotentialDateBasisPoints;

export interface BulkSavePlanTasksResultOptions {
  __typename?: "BulkSavePlanTasksResult";
  planTasks?: Array<FactoryInput<PlanTask, PlanTaskOptions>>;
}

export function newBulkSavePlanTasksResult(
  options?: BulkSavePlanTasksResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BulkSavePlanTasksResult>;
export function newBulkSavePlanTasksResult(
  options: BulkSavePlanTasksResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BulkSavePlanTasksResult> {
  const o = (options.__typename ? options : cache["BulkSavePlanTasksResult"] = {}) as BulkSavePlanTasksResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BulkSavePlanTasksResult";
    o.planTasks = (options.planTasks ?? []).map((i) =>
      maybeNew("PlanTask", i, cache, options.hasOwnProperty("planTasks"))
    );
    return o as FactoryResult<BulkSavePlanTasksResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BulkSavePlanTasksResult"] = newBulkSavePlanTasksResult;

export interface PlanTaskChecklistItemOptions {
  __typename?: "PlanTaskChecklistItem";
  id?: PlanTaskChecklistItem["id"];
  name?: PlanTaskChecklistItem["name"];
  completedAt?: PlanTaskChecklistItem["completedAt"];
  createdAt?: PlanTaskChecklistItem["createdAt"];
  updatedAt?: PlanTaskChecklistItem["updatedAt"];
  planTask?: FactoryInput<PlanTask, PlanTaskOptions>;
  completedBy?: FactoryInput<User, UserOptions> | null;
  globalItem?: FactoryInput<GlobalPlanTaskChecklistItem, GlobalPlanTaskChecklistItemOptions>;
}

export function newPlanTaskChecklistItem(
  options?: PlanTaskChecklistItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanTaskChecklistItem>;
export function newPlanTaskChecklistItem(
  options: PlanTaskChecklistItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PlanTaskChecklistItem> {
  const o = (options.__typename ? options : cache["PlanTaskChecklistItem"] = {}) as PlanTaskChecklistItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PlanTaskChecklistItem";
    o.id = options.id ?? nextFactoryId("PlanTaskChecklistItem");
    o.name = options.name ?? "name";
    o.completedAt = options.completedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.planTask = maybeNew("PlanTask", options.planTask, cache, options.hasOwnProperty("planTask"));
    o.completedBy = maybeNewOrNull("User", options.completedBy, cache);
    o.globalItem = maybeNew(
      "GlobalPlanTaskChecklistItem",
      options.globalItem,
      cache,
      options.hasOwnProperty("globalItem"),
    );
    return o as FactoryResult<PlanTaskChecklistItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PlanTaskChecklistItem"] = newPlanTaskChecklistItem;

export interface SavePlanTaskChecklistItemResultOptions {
  __typename?: "SavePlanTaskChecklistItemResult";
  planTaskChecklistItem?: FactoryInput<PlanTaskChecklistItem, PlanTaskChecklistItemOptions>;
}

export function newSavePlanTaskChecklistItemResult(
  options?: SavePlanTaskChecklistItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePlanTaskChecklistItemResult>;
export function newSavePlanTaskChecklistItemResult(
  options: SavePlanTaskChecklistItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePlanTaskChecklistItemResult> {
  const o =
    (options.__typename ? options : cache["SavePlanTaskChecklistItemResult"] = {}) as SavePlanTaskChecklistItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePlanTaskChecklistItemResult";
    o.planTaskChecklistItem = maybeNew(
      "PlanTaskChecklistItem",
      options.planTaskChecklistItem,
      cache,
      options.hasOwnProperty("planTaskChecklistItem"),
    );
    return o as FactoryResult<SavePlanTaskChecklistItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePlanTaskChecklistItemResult"] = newSavePlanTaskChecklistItemResult;

export interface PreconContractTypeOptions {
  __typename?: "PreconContractType";
  id?: PreconContractType["id"];
  name?: PreconContractType["name"];
  createdAt?: PreconContractType["createdAt"];
  updatedAt?: PreconContractType["updatedAt"];
  projects?: Array<FactoryInput<StandaloneProject, StandaloneProjectOptions>>;
  inviteHomeowners?: PreconContractType["inviteHomeowners"];
  needsWeeklyUpdate?: PreconContractType["needsWeeklyUpdate"];
}

export function newPreconContractType(
  options?: PreconContractTypeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PreconContractType>;
export function newPreconContractType(
  options: PreconContractTypeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PreconContractType> {
  const o = (options.__typename ? options : cache["PreconContractType"] = {}) as PreconContractType;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PreconContractType";
    o.id = options.id ?? nextFactoryId("PreconContractType");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.projects = (options.projects ?? []).map((i) =>
      maybeNew("StandaloneProject", i, cache, options.hasOwnProperty("projects"))
    );
    o.inviteHomeowners = options.inviteHomeowners ?? false;
    o.needsWeeklyUpdate = options.needsWeeklyUpdate ?? false;
    return o as FactoryResult<PreconContractType>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PreconContractType"] = newPreconContractType;

export interface SavePreconContractTypeResultOptions {
  __typename?: "SavePreconContractTypeResult";
  preconContractType?: FactoryInput<PreconContractType, PreconContractTypeOptions>;
}

export function newSavePreconContractTypeResult(
  options?: SavePreconContractTypeResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePreconContractTypeResult>;
export function newSavePreconContractTypeResult(
  options: SavePreconContractTypeResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePreconContractTypeResult> {
  const o = (options.__typename ? options : cache["SavePreconContractTypeResult"] = {}) as SavePreconContractTypeResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePreconContractTypeResult";
    o.preconContractType = maybeNew(
      "PreconContractType",
      options.preconContractType,
      cache,
      options.hasOwnProperty("preconContractType"),
    );
    return o as FactoryResult<SavePreconContractTypeResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePreconContractTypeResult"] = newSavePreconContractTypeResult;

export interface ProductOfferingOptions {
  __typename?: "ProductOffering";
  id?: ProductOffering["id"];
  name?: ProductOffering["name"];
  displayName?: ProductOffering["displayName"];
  description?: ProductOffering["description"];
  createdAt?: ProductOffering["createdAt"];
  updatedAt?: ProductOffering["updatedAt"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  code?: ProductOffering["code"];
  displayCode?: ProductOffering["displayCode"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  constructionDocumentCompletePercentage?: ProductOffering["constructionDocumentCompletePercentage"];
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  underwritingTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions> | null;
  maxProgramData?: FactoryInput<ProgramData, ProgramDataOptions>;
  minProgramData?: FactoryInput<ProgramData, ProgramDataOptions>;
  programData?: FactoryInput<ProgramData, ProgramDataOptions>;
  itemTemplates?: Array<FactoryInput<ItemTemplate, ItemTemplateOptions>>;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  userEvents?: Array<FactoryInput<UserEvent, UserEventOptions>>;
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  planPackageVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  programDatas?: Array<FactoryInput<ReadyPlanProgramData, ReadyPlanProgramDataOptions>>;
  copyInProgress?: ProductOffering["copyInProgress"];
  bidPackages?: Array<FactoryInput<BidPackage, BidPackageOptions>>;
  assets?: Array<FactoryInput<ReadyPlanAsset, ReadyPlanAssetOptions>>;
  lotTypes?: ProductOffering["lotTypes"];
  baseConfig?: FactoryInput<ProductOfferingConfig, ProductOfferingConfigOptions> | null;
  configs?: Array<FactoryInput<ProductOfferingConfig, ProductOfferingConfigOptions>>;
  projectConfigs?: Array<FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>>;
  bidOutPercentage?: ProductOffering["bidOutPercentage"];
  coverAsset?: FactoryInput<Asset, AssetOptions> | null;
  floorPlanAsset?: FactoryInput<Asset, AssetOptions> | null;
  floorPlanAssets?: Array<FactoryInput<ReadyPlanAsset, ReadyPlanAssetOptions>>;
  interiorDesignPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  interiorDesignPackageVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  exteriorDesignPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  exteriorDesignPackageVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  designPackageCombinations?: Array<FactoryInput<DesignPackageCombination, DesignPackageCombinationOptions>>;
  aggregateActive?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  aggregateDraft?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  aggregateLatest?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  aggregateCheckout?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  aggregateVersions?: Array<FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>>;
  version?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  availableUpdates?: Array<FactoryInput<ProductOfferingIncomingUpdate, ProductOfferingIncomingUpdateOptions>>;
  itemLocations?: Array<FactoryInput<Location, LocationOptions>>;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  canEditLineItems?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  contingencyMarkupPercentage?: ProductOffering["contingencyMarkupPercentage"];
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditOptions?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  publishToUnderwriting?: ProductOffering["publishToUnderwriting"];
  tourUrl?: ProductOffering["tourUrl"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  checkoutConfigs?: Array<FactoryInput<CheckoutConfig, CheckoutConfigOptions>>;
  showInCheckout?: ProductOffering["showInCheckout"];
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  rendering?: FactoryInput<Asset, AssetOptions> | null;
  interiorRenderings?: Array<FactoryInput<InteriorRoomRendering, InteriorRoomRenderingOptions>>;
  renderings?: Array<FactoryInput<RenderingAsset, RenderingAssetOptions>>;
  requiredOptions?: Array<FactoryInput<ReadyPlanRequiredOption, ReadyPlanRequiredOptionOptions>>;
  owner?: FactoryInput<InternalUser, InternalUserOptions> | null;
  cloneInProgress?: ProductOffering["cloneInProgress"];
  insideMapsMissingLocations?: ProductOffering["insideMapsMissingLocations"];
  promoteInProgress?: ProductOffering["promoteInProgress"];
  buildableLots?: Array<FactoryInput<Lot, LotOptions>>;
  insideMapsPacket?: ProductOffering["insideMapsPacket"];
  architectureFeePriceInCents?: ProductOffering["architectureFeePriceInCents"];
  preconServicesPriceInCents?: ProductOffering["preconServicesPriceInCents"];
  trackedJobs?: Array<FactoryInput<TrackedJob, TrackedJobOptions>>;
  activeElevationCount?: ProductOffering["activeElevationCount"];
  checkoutBlockingErrors?: ProductOffering["checkoutBlockingErrors"];
  costCodeBidSummaries?: Array<FactoryInput<CostCodeBidSummary, CostCodeBidSummaryOptions>>;
  startingConfigs?: Array<FactoryInput<ProductOfferingStartingConfig, ProductOfferingStartingConfigOptions>>;
  checkoutStartingConfig?: FactoryInput<ProductOfferingStartingConfig, ProductOfferingStartingConfigOptions> | null;
  startingSalesPriceInCents?: ProductOffering["startingSalesPriceInCents"];
  certificationStartedAt?: ProductOffering["certificationStartedAt"];
  certificationCompletedAt?: ProductOffering["certificationCompletedAt"];
}

export function newProductOffering(
  options?: ProductOfferingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOffering>;
export function newProductOffering(
  options: ProductOfferingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOffering> {
  const o = (options.__typename ? options : cache["ProductOffering"] = {}) as ProductOffering;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOffering";
    o.id = options.id ?? nextFactoryId("ProductOffering");
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.type = enumOrDetailOfReadyPlanType(options.type);
    o.code = options.code ?? null;
    o.displayCode = options.displayCode ?? null;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.constructionDocumentCompletePercentage = options.constructionDocumentCompletePercentage ?? 0;
    o.status = enumOrDetailOfReadyPlanStatus(options.status);
    o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.underwritingTemplate = maybeNewOrNull("ItemTemplate", options.underwritingTemplate, cache);
    o.maxProgramData = maybeNew("ProgramData", options.maxProgramData, cache, options.hasOwnProperty("maxProgramData"));
    o.minProgramData = maybeNew("ProgramData", options.minProgramData, cache, options.hasOwnProperty("minProgramData"));
    o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
    o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
      maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
    );
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.optionGroups = (options.optionGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
    );
    o.userEvents = (options.userEvents ?? []).map((i) =>
      maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
    );
    o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
    o.planPackageVersion = maybeNew(
      "ReadyPlanAggregateVersion",
      options.planPackageVersion,
      cache,
      options.hasOwnProperty("planPackageVersion"),
    );
    o.programDatas = (options.programDatas ?? []).map((i) =>
      maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
    );
    o.copyInProgress = options.copyInProgress ?? false;
    o.bidPackages = (options.bidPackages ?? []).map((i) =>
      maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
    );
    o.assets = (options.assets ?? []).map((i) =>
      maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets"))
    );
    o.lotTypes = options.lotTypes ?? [];
    o.baseConfig = maybeNewOrNull("ProductOfferingConfig", options.baseConfig, cache);
    o.configs = (options.configs ?? []).map((i) =>
      maybeNew("ProductOfferingConfig", i, cache, options.hasOwnProperty("configs"))
    );
    o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
    );
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.coverAsset = maybeNewOrNull("Asset", options.coverAsset, cache);
    o.floorPlanAsset = maybeNewOrNull("Asset", options.floorPlanAsset, cache);
    o.floorPlanAssets = (options.floorPlanAssets ?? []).map((i) =>
      maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("floorPlanAssets"))
    );
    o.interiorDesignPackage = maybeNew(
      "DesignPackage",
      options.interiorDesignPackage,
      cache,
      options.hasOwnProperty("interiorDesignPackage"),
    );
    o.interiorDesignPackageVersion = maybeNew(
      "ReadyPlanAggregateVersion",
      options.interiorDesignPackageVersion,
      cache,
      options.hasOwnProperty("interiorDesignPackageVersion"),
    );
    o.exteriorDesignPackage = maybeNew(
      "DesignPackage",
      options.exteriorDesignPackage,
      cache,
      options.hasOwnProperty("exteriorDesignPackage"),
    );
    o.exteriorDesignPackageVersion = maybeNew(
      "ReadyPlanAggregateVersion",
      options.exteriorDesignPackageVersion,
      cache,
      options.hasOwnProperty("exteriorDesignPackageVersion"),
    );
    o.designPackageCombinations = (options.designPackageCombinations ?? []).map((i) =>
      maybeNew("DesignPackageCombination", i, cache, options.hasOwnProperty("designPackageCombinations"))
    );
    o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
    o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
    o.aggregateLatest = maybeNew(
      "ReadyPlanAggregateVersion",
      options.aggregateLatest,
      cache,
      options.hasOwnProperty("aggregateLatest"),
    );
    o.aggregateCheckout = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateCheckout, cache);
    o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
      maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
    );
    o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
    o.availableUpdates = (options.availableUpdates ?? []).map((i) =>
      maybeNew("ProductOfferingIncomingUpdate", i, cache, options.hasOwnProperty("availableUpdates"))
    );
    o.itemLocations = (options.itemLocations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
    );
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.canEditLineItems = maybeNew(
      "PotentialOperation2",
      options.canEditLineItems,
      cache,
      options.hasOwnProperty("canEditLineItems"),
    );
    o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.canEditOptions = maybeNew(
      "PotentialOperation2",
      options.canEditOptions,
      cache,
      options.hasOwnProperty("canEditOptions"),
    );
    o.publishToUnderwriting = options.publishToUnderwriting ?? false;
    o.tourUrl = options.tourUrl ?? null;
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.checkoutConfigs = (options.checkoutConfigs ?? []).map((i) =>
      maybeNew("CheckoutConfig", i, cache, options.hasOwnProperty("checkoutConfigs"))
    );
    o.showInCheckout = options.showInCheckout ?? false;
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.rendering = maybeNewOrNull("Asset", options.rendering, cache);
    o.interiorRenderings = (options.interiorRenderings ?? []).map((i) =>
      maybeNew("InteriorRoomRendering", i, cache, options.hasOwnProperty("interiorRenderings"))
    );
    o.renderings = (options.renderings ?? []).map((i) =>
      maybeNew("RenderingAsset", i, cache, options.hasOwnProperty("renderings"))
    );
    o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
      maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
    );
    o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
    o.cloneInProgress = options.cloneInProgress ?? false;
    o.insideMapsMissingLocations = options.insideMapsMissingLocations ?? [];
    o.promoteInProgress = options.promoteInProgress ?? false;
    o.buildableLots = (options.buildableLots ?? []).map((i) =>
      maybeNew("Lot", i, cache, options.hasOwnProperty("buildableLots"))
    );
    o.insideMapsPacket = options.insideMapsPacket ?? null;
    o.architectureFeePriceInCents = options.architectureFeePriceInCents ?? null;
    o.preconServicesPriceInCents = options.preconServicesPriceInCents ?? null;
    o.trackedJobs = (options.trackedJobs ?? []).map((i) =>
      maybeNew("TrackedJob", i, cache, options.hasOwnProperty("trackedJobs"))
    );
    o.activeElevationCount = options.activeElevationCount ?? 0;
    o.checkoutBlockingErrors = options.checkoutBlockingErrors ?? [];
    o.costCodeBidSummaries = (options.costCodeBidSummaries ?? []).map((i) =>
      maybeNew("CostCodeBidSummary", i, cache, options.hasOwnProperty("costCodeBidSummaries"))
    );
    o.startingConfigs = (options.startingConfigs ?? []).map((i) =>
      maybeNew("ProductOfferingStartingConfig", i, cache, options.hasOwnProperty("startingConfigs"))
    );
    o.checkoutStartingConfig = maybeNewOrNull("ProductOfferingStartingConfig", options.checkoutStartingConfig, cache);
    o.startingSalesPriceInCents = options.startingSalesPriceInCents ?? null;
    o.certificationStartedAt = options.certificationStartedAt ?? null;
    o.certificationCompletedAt = options.certificationCompletedAt ?? null;
    return o as FactoryResult<ProductOffering>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOffering"] = newProductOffering;

export interface ProductOfferingsPageResultOptions {
  __typename?: "ProductOfferingsPageResult";
  entities?: Array<FactoryInput<ProductOffering, ProductOfferingOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newProductOfferingsPageResult(
  options?: ProductOfferingsPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingsPageResult>;
export function newProductOfferingsPageResult(
  options: ProductOfferingsPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOfferingsPageResult> {
  const o = (options.__typename ? options : cache["ProductOfferingsPageResult"] = {}) as ProductOfferingsPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOfferingsPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ProductOffering", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ProductOfferingsPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOfferingsPageResult"] = newProductOfferingsPageResult;

export interface SaveProductOfferingResultOptions {
  __typename?: "SaveProductOfferingResult";
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newSaveProductOfferingResult(
  options?: SaveProductOfferingResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProductOfferingResult>;
export function newSaveProductOfferingResult(
  options: SaveProductOfferingResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProductOfferingResult> {
  const o = (options.__typename ? options : cache["SaveProductOfferingResult"] = {}) as SaveProductOfferingResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProductOfferingResult";
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    return o as FactoryResult<SaveProductOfferingResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProductOfferingResult"] = newSaveProductOfferingResult;

export interface DesignPackageCombinationOptions {
  __typename?: "DesignPackageCombination";
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  bidOutPercentage?: DesignPackageCombination["bidOutPercentage"];
}

export function newDesignPackageCombination(
  options?: DesignPackageCombinationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackageCombination>;
export function newDesignPackageCombination(
  options: DesignPackageCombinationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DesignPackageCombination> {
  const o = (options.__typename ? options : cache["DesignPackageCombination"] = {}) as DesignPackageCombination;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DesignPackageCombination";
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    return o as FactoryResult<DesignPackageCombination>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DesignPackageCombination"] = newDesignPackageCombination;

export interface ReadyPlanOptionCostAndPriceDeltaOptions {
  __typename?: "ReadyPlanOptionCostAndPriceDelta";
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  totalCostInCents?: ReadyPlanOptionCostAndPriceDelta["totalCostInCents"];
  totalPriceInCents?: ReadyPlanOptionCostAndPriceDelta["totalPriceInCents"];
  preCutoffTotalPriceInCents?: ReadyPlanOptionCostAndPriceDelta["preCutoffTotalPriceInCents"];
  preCutoffDesiredMarginInBasisPoints?: ReadyPlanOptionCostAndPriceDelta["preCutoffDesiredMarginInBasisPoints"];
  postCutoffTotalPriceInCents?: ReadyPlanOptionCostAndPriceDelta["postCutoffTotalPriceInCents"];
  postCutoffDesiredMarginInBasisPoints?: ReadyPlanOptionCostAndPriceDelta["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: ReadyPlanOptionCostAndPriceDelta["selectionFeeInCents"];
  minimumPriceInCents?: ReadyPlanOptionCostAndPriceDelta["minimumPriceInCents"];
}

export function newReadyPlanOptionCostAndPriceDelta(
  options?: ReadyPlanOptionCostAndPriceDeltaOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionCostAndPriceDelta>;
export function newReadyPlanOptionCostAndPriceDelta(
  options: ReadyPlanOptionCostAndPriceDeltaOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOptionCostAndPriceDelta> {
  const o =
    (options.__typename ? options : cache["ReadyPlanOptionCostAndPriceDelta"] = {}) as ReadyPlanOptionCostAndPriceDelta;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOptionCostAndPriceDelta";
    o.readyPlanOption = maybeNew(
      "ReadyPlanOption",
      options.readyPlanOption,
      cache,
      options.hasOwnProperty("readyPlanOption"),
    );
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.preCutoffTotalPriceInCents = options.preCutoffTotalPriceInCents ?? 0;
    o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
    o.postCutoffTotalPriceInCents = options.postCutoffTotalPriceInCents ?? null;
    o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
    o.selectionFeeInCents = options.selectionFeeInCents ?? 0;
    o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
    return o as FactoryResult<ReadyPlanOptionCostAndPriceDelta>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOptionCostAndPriceDelta"] = newReadyPlanOptionCostAndPriceDelta;

export interface ComputeProductOfferingCostsAndPricesResponseOptions {
  __typename?: "ComputeProductOfferingCostsAndPricesResponse";
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  baseCostInCents?: ComputeProductOfferingCostsAndPricesResponse["baseCostInCents"];
  basePriceInCents?: ComputeProductOfferingCostsAndPricesResponse["basePriceInCents"];
  totalCostInCents?: ComputeProductOfferingCostsAndPricesResponse["totalCostInCents"];
  preCutoffTotalPriceInCents?: ComputeProductOfferingCostsAndPricesResponse["preCutoffTotalPriceInCents"];
  postCutoffTotalPriceInCents?: ComputeProductOfferingCostsAndPricesResponse["postCutoffTotalPriceInCents"];
  selectedOptions?: Array<FactoryInput<ReadyPlanOptionCostAndPriceDelta, ReadyPlanOptionCostAndPriceDeltaOptions>>;
  unselectedOptions?: Array<FactoryInput<ReadyPlanOptionCostAndPriceDelta, ReadyPlanOptionCostAndPriceDeltaOptions>>;
  allOptions?: Array<FactoryInput<ReadyPlanOptionCostAndPriceDelta, ReadyPlanOptionCostAndPriceDeltaOptions>>;
}

export function newComputeProductOfferingCostsAndPricesResponse(
  options?: ComputeProductOfferingCostsAndPricesResponseOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ComputeProductOfferingCostsAndPricesResponse>;
export function newComputeProductOfferingCostsAndPricesResponse(
  options: ComputeProductOfferingCostsAndPricesResponseOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ComputeProductOfferingCostsAndPricesResponse> {
  const o =
    (options.__typename
      ? options
      : cache["ComputeProductOfferingCostsAndPricesResponse"] = {}) as ComputeProductOfferingCostsAndPricesResponse;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ComputeProductOfferingCostsAndPricesResponse";
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    o.baseCostInCents = options.baseCostInCents ?? 0;
    o.basePriceInCents = options.basePriceInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.preCutoffTotalPriceInCents = options.preCutoffTotalPriceInCents ?? 0;
    o.postCutoffTotalPriceInCents = options.postCutoffTotalPriceInCents ?? 0;
    o.selectedOptions = (options.selectedOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOptionCostAndPriceDelta", i, cache, options.hasOwnProperty("selectedOptions"))
    );
    o.unselectedOptions = (options.unselectedOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOptionCostAndPriceDelta", i, cache, options.hasOwnProperty("unselectedOptions"))
    );
    o.allOptions = (options.allOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOptionCostAndPriceDelta", i, cache, options.hasOwnProperty("allOptions"))
    );
    return o as FactoryResult<ComputeProductOfferingCostsAndPricesResponse>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ComputeProductOfferingCostsAndPricesResponse"] = newComputeProductOfferingCostsAndPricesResponse;

export interface CalculateScopeChangeResultOptions {
  __typename?: "CalculateScopeChangeResult";
  added?: Array<FactoryInput<TakeoffLineItemVersion, TakeoffLineItemVersionOptions>>;
  removed?: Array<FactoryInput<TakeoffLineItemVersion, TakeoffLineItemVersionOptions>>;
}

export function newCalculateScopeChangeResult(
  options?: CalculateScopeChangeResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CalculateScopeChangeResult>;
export function newCalculateScopeChangeResult(
  options: CalculateScopeChangeResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CalculateScopeChangeResult> {
  const o = (options.__typename ? options : cache["CalculateScopeChangeResult"] = {}) as CalculateScopeChangeResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CalculateScopeChangeResult";
    o.added = (options.added ?? []).map((i) =>
      maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("added"))
    );
    o.removed = (options.removed ?? []).map((i) =>
      maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("removed"))
    );
    return o as FactoryResult<CalculateScopeChangeResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CalculateScopeChangeResult"] = newCalculateScopeChangeResult;

export interface InteriorRoomRenderingOptions {
  __typename?: "InteriorRoomRendering";
  roomName?: InteriorRoomRendering["roomName"];
  interiorScheme?: InteriorRoomRendering["interiorScheme"];
  asset?: FactoryInput<Asset, AssetOptions> | null;
}

export function newInteriorRoomRendering(
  options?: InteriorRoomRenderingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<InteriorRoomRendering>;
export function newInteriorRoomRendering(
  options: InteriorRoomRenderingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<InteriorRoomRendering> {
  const o = (options.__typename ? options : cache["InteriorRoomRendering"] = {}) as InteriorRoomRendering;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "InteriorRoomRendering";
    o.roomName = options.roomName ?? "roomName";
    o.interiorScheme = options.interiorScheme ?? "interiorScheme";
    o.asset = maybeNewOrNull("Asset", options.asset, cache);
    return o as FactoryResult<InteriorRoomRendering>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["InteriorRoomRendering"] = newInteriorRoomRendering;

export interface RenderingAssetOptions {
  __typename?: "RenderingAsset";
  type?: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType;
  asset?: FactoryInput<Asset, AssetOptions>;
}

export function newRenderingAsset(
  options?: RenderingAssetOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<RenderingAsset>;
export function newRenderingAsset(
  options: RenderingAssetOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<RenderingAsset> {
  const o = (options.__typename ? options : cache["RenderingAsset"] = {}) as RenderingAsset;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "RenderingAsset";
    o.type = enumOrDetailOfReadyPlanAssetType(options.type);
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    return o as FactoryResult<RenderingAsset>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["RenderingAsset"] = newRenderingAsset;

export interface ProductOfferingConfigOptions {
  __typename?: "ProductOfferingConfig";
  id?: ProductOfferingConfig["id"];
  name?: ProductOfferingConfig["name"];
  createdAt?: ProductOfferingConfig["createdAt"];
  updatedAt?: ProductOfferingConfig["updatedAt"];
  createdBy?: FactoryInput<User, UserOptions>;
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  baseConfigProductOffering?: FactoryInput<ProductOffering, ProductOfferingOptions> | null;
  archive?: ProductOfferingConfig["archive"];
  isBaseConfig?: ProductOfferingConfig["isBaseConfig"];
  programData?: FactoryInput<ProgramData, ProgramDataOptions>;
  totalCostInCents?: ProductOfferingConfig["totalCostInCents"];
  totalPriceInCents?: ProductOfferingConfig["totalPriceInCents"];
  hasCompleteCost?: ProductOfferingConfig["hasCompleteCost"];
  publishToUnderwriting?: ProductOfferingConfig["publishToUnderwriting"];
  salesPriceInCents?: ProductOfferingConfig["salesPriceInCents"];
  insideMapsTextureSwaps?: FactoryInput<InsideMapsTextureSwaps, InsideMapsTextureSwapsOptions> | null;
  exteriorOptionNames?: ProductOfferingConfig["exteriorOptionNames"];
  interiorOptionNames?: ProductOfferingConfig["interiorOptionNames"];
}

export function newProductOfferingConfig(
  options?: ProductOfferingConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingConfig>;
export function newProductOfferingConfig(
  options: ProductOfferingConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOfferingConfig> {
  const o = (options.__typename ? options : cache["ProductOfferingConfig"] = {}) as ProductOfferingConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOfferingConfig";
    o.id = options.id ?? nextFactoryId("ProductOfferingConfig");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    o.baseConfigProductOffering = maybeNewOrNull("ProductOffering", options.baseConfigProductOffering, cache);
    o.archive = options.archive ?? false;
    o.isBaseConfig = options.isBaseConfig ?? false;
    o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.hasCompleteCost = options.hasCompleteCost ?? false;
    o.publishToUnderwriting = options.publishToUnderwriting ?? false;
    o.salesPriceInCents = options.salesPriceInCents ?? null;
    o.insideMapsTextureSwaps = maybeNewOrNull("InsideMapsTextureSwaps", options.insideMapsTextureSwaps, cache);
    o.exteriorOptionNames = options.exteriorOptionNames ?? [];
    o.interiorOptionNames = options.interiorOptionNames ?? [];
    return o as FactoryResult<ProductOfferingConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOfferingConfig"] = newProductOfferingConfig;

export interface SaveProductOfferingConfigResultOptions {
  __typename?: "SaveProductOfferingConfigResult";
  productOfferingConfig?: FactoryInput<ProductOfferingConfig, ProductOfferingConfigOptions>;
}

export function newSaveProductOfferingConfigResult(
  options?: SaveProductOfferingConfigResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProductOfferingConfigResult>;
export function newSaveProductOfferingConfigResult(
  options: SaveProductOfferingConfigResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProductOfferingConfigResult> {
  const o =
    (options.__typename ? options : cache["SaveProductOfferingConfigResult"] = {}) as SaveProductOfferingConfigResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProductOfferingConfigResult";
    o.productOfferingConfig = maybeNew(
      "ProductOfferingConfig",
      options.productOfferingConfig,
      cache,
      options.hasOwnProperty("productOfferingConfig"),
    );
    return o as FactoryResult<SaveProductOfferingConfigResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProductOfferingConfigResult"] = newSaveProductOfferingConfigResult;

export interface ProductOfferingConfigsPageOptions {
  __typename?: "ProductOfferingConfigsPage";
  entities?: Array<FactoryInput<ProductOfferingConfig, ProductOfferingConfigOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newProductOfferingConfigsPage(
  options?: ProductOfferingConfigsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingConfigsPage>;
export function newProductOfferingConfigsPage(
  options: ProductOfferingConfigsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOfferingConfigsPage> {
  const o = (options.__typename ? options : cache["ProductOfferingConfigsPage"] = {}) as ProductOfferingConfigsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOfferingConfigsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ProductOfferingConfig", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ProductOfferingConfigsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOfferingConfigsPage"] = newProductOfferingConfigsPage;

export interface ComputeProductOfferingConfigCostsResultOptions {
  __typename?: "ComputeProductOfferingConfigCostsResult";
  configCosts?: Array<FactoryInput<ConfigCostsResult, ConfigCostsResultOptions>>;
}

export function newComputeProductOfferingConfigCostsResult(
  options?: ComputeProductOfferingConfigCostsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ComputeProductOfferingConfigCostsResult>;
export function newComputeProductOfferingConfigCostsResult(
  options: ComputeProductOfferingConfigCostsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ComputeProductOfferingConfigCostsResult> {
  const o =
    (options.__typename
      ? options
      : cache["ComputeProductOfferingConfigCostsResult"] = {}) as ComputeProductOfferingConfigCostsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ComputeProductOfferingConfigCostsResult";
    o.configCosts = (options.configCosts ?? []).map((i) =>
      maybeNew("ConfigCostsResult", i, cache, options.hasOwnProperty("configCosts"))
    );
    return o as FactoryResult<ComputeProductOfferingConfigCostsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ComputeProductOfferingConfigCostsResult"] = newComputeProductOfferingConfigCostsResult;

export interface ConfigCostsResultOptions {
  __typename?: "ConfigCostsResult";
  productOfferingConfig?: FactoryInput<ProductOfferingConfig, ProductOfferingConfigOptions>;
  computedBaseCost?: ConfigCostsResult["computedBaseCost"];
  baseHouseCostInCents?: ConfigCostsResult["baseHouseCostInCents"];
  baseHouseHasCompleteCost?: ConfigCostsResult["baseHouseHasCompleteCost"];
  computedOptionCosts?: Array<FactoryInput<ReadyPlanOptionConfigCosts, ReadyPlanOptionConfigCostsOptions>>;
}

export function newConfigCostsResult(
  options?: ConfigCostsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ConfigCostsResult>;
export function newConfigCostsResult(
  options: ConfigCostsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ConfigCostsResult> {
  const o = (options.__typename ? options : cache["ConfigCostsResult"] = {}) as ConfigCostsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ConfigCostsResult";
    o.productOfferingConfig = maybeNew(
      "ProductOfferingConfig",
      options.productOfferingConfig,
      cache,
      options.hasOwnProperty("productOfferingConfig"),
    );
    o.computedBaseCost = options.computedBaseCost ?? 0;
    o.baseHouseCostInCents = options.baseHouseCostInCents ?? 0;
    o.baseHouseHasCompleteCost = options.baseHouseHasCompleteCost ?? false;
    o.computedOptionCosts = (options.computedOptionCosts ?? []).map((i) =>
      maybeNew("ReadyPlanOptionConfigCosts", i, cache, options.hasOwnProperty("computedOptionCosts"))
    );
    return o as FactoryResult<ConfigCostsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ConfigCostsResult"] = newConfigCostsResult;

export interface ReadyPlanOptionConfigCostsOptions {
  __typename?: "ReadyPlanOptionConfigCosts";
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  totalCostInCents?: ReadyPlanOptionConfigCosts["totalCostInCents"];
  hasCompleteCost?: ReadyPlanOptionConfigCosts["hasCompleteCost"];
}

export function newReadyPlanOptionConfigCosts(
  options?: ReadyPlanOptionConfigCostsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionConfigCosts>;
export function newReadyPlanOptionConfigCosts(
  options: ReadyPlanOptionConfigCostsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOptionConfigCosts> {
  const o = (options.__typename ? options : cache["ReadyPlanOptionConfigCosts"] = {}) as ReadyPlanOptionConfigCosts;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOptionConfigCosts";
    o.readyPlanOption = maybeNew(
      "ReadyPlanOption",
      options.readyPlanOption,
      cache,
      options.hasOwnProperty("readyPlanOption"),
    );
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.hasCompleteCost = options.hasCompleteCost ?? false;
    return o as FactoryResult<ReadyPlanOptionConfigCosts>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOptionConfigCosts"] = newReadyPlanOptionConfigCosts;

export interface ProductOfferingIncomingUpdateOptions {
  __typename?: "ProductOfferingIncomingUpdate";
  id?: ProductOfferingIncomingUpdate["id"];
  accepted?: ProductOfferingIncomingUpdate["accepted"];
  createdAt?: ProductOfferingIncomingUpdate["createdAt"];
  updatedAt?: ProductOfferingIncomingUpdate["updatedAt"];
  offering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  forDesignPackageUpdate?: ProductOfferingIncomingUpdate["forDesignPackageUpdate"];
  forPlanPackageUpdate?: ProductOfferingIncomingUpdate["forPlanPackageUpdate"];
  source?:
    | ProductOfferingIncomingUpdateSource
    | FactoryResult<ProductOfferingIncomingUpdateSource>
    | DropOptions
    | RequireTypename<ReadyPlanAggregateVersionOptions>;
}

export function newProductOfferingIncomingUpdate(
  options?: ProductOfferingIncomingUpdateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingIncomingUpdate>;
export function newProductOfferingIncomingUpdate(
  options: ProductOfferingIncomingUpdateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOfferingIncomingUpdate> {
  const o =
    (options.__typename ? options : cache["ProductOfferingIncomingUpdate"] = {}) as ProductOfferingIncomingUpdate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOfferingIncomingUpdate";
    o.id = options.id ?? nextFactoryId("ProductOfferingIncomingUpdate");
    o.accepted = options.accepted ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.offering = maybeNew("ProductOffering", options.offering, cache, options.hasOwnProperty("offering"));
    o.forDesignPackageUpdate = options.forDesignPackageUpdate ?? false;
    o.forPlanPackageUpdate = options.forPlanPackageUpdate ?? false;
    o.source = maybeNew(options.source?.__typename ?? "Drop", options.source, cache);
    return o as FactoryResult<ProductOfferingIncomingUpdate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOfferingIncomingUpdate"] = newProductOfferingIncomingUpdate;

export interface ProductOfferingStartingConfigsPageOptions {
  __typename?: "ProductOfferingStartingConfigsPage";
  entities?: Array<FactoryInput<ProductOfferingStartingConfig, ProductOfferingStartingConfigOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newProductOfferingStartingConfigsPage(
  options?: ProductOfferingStartingConfigsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingStartingConfigsPage>;
export function newProductOfferingStartingConfigsPage(
  options: ProductOfferingStartingConfigsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOfferingStartingConfigsPage> {
  const o =
    (options.__typename
      ? options
      : cache["ProductOfferingStartingConfigsPage"] = {}) as ProductOfferingStartingConfigsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOfferingStartingConfigsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ProductOfferingStartingConfig", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ProductOfferingStartingConfigsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOfferingStartingConfigsPage"] = newProductOfferingStartingConfigsPage;

export interface ProductOfferingStartingConfigOptions {
  __typename?: "ProductOfferingStartingConfig";
  id?: ProductOfferingStartingConfig["id"];
  type?: ProductOfferingStartingConfigTypeDetailOptions | ProductOfferingStartingConfigType;
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
  salesPriceInCents?: ProductOfferingStartingConfig["salesPriceInCents"];
  pinnedOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  expandedOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  createdAt?: ProductOfferingStartingConfig["createdAt"];
  updatedAt?: ProductOfferingStartingConfig["updatedAt"];
}

export function newProductOfferingStartingConfig(
  options?: ProductOfferingStartingConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingStartingConfig>;
export function newProductOfferingStartingConfig(
  options: ProductOfferingStartingConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOfferingStartingConfig> {
  const o =
    (options.__typename ? options : cache["ProductOfferingStartingConfig"] = {}) as ProductOfferingStartingConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOfferingStartingConfig";
    o.id = options.id ?? nextFactoryId("ProductOfferingStartingConfig");
    o.type = enumOrDetailOfProductOfferingStartingConfigType(options.type);
    o.productOffering = maybeNew(
      "ProductOffering",
      options.productOffering,
      cache,
      options.hasOwnProperty("productOffering"),
    );
    o.salesPriceInCents = options.salesPriceInCents ?? null;
    o.pinnedOptions = (options.pinnedOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("pinnedOptions"))
    );
    o.expandedOptions = (options.expandedOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("expandedOptions"))
    );
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    return o as FactoryResult<ProductOfferingStartingConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOfferingStartingConfig"] = newProductOfferingStartingConfig;

export interface SaveProductOfferingStartingConfigResultOptions {
  __typename?: "SaveProductOfferingStartingConfigResult";
  productOfferingStartingConfig?: FactoryInput<ProductOfferingStartingConfig, ProductOfferingStartingConfigOptions>;
}

export function newSaveProductOfferingStartingConfigResult(
  options?: SaveProductOfferingStartingConfigResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProductOfferingStartingConfigResult>;
export function newSaveProductOfferingStartingConfigResult(
  options: SaveProductOfferingStartingConfigResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProductOfferingStartingConfigResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveProductOfferingStartingConfigResult"] = {}) as SaveProductOfferingStartingConfigResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProductOfferingStartingConfigResult";
    o.productOfferingStartingConfig = maybeNew(
      "ProductOfferingStartingConfig",
      options.productOfferingStartingConfig,
      cache,
      options.hasOwnProperty("productOfferingStartingConfig"),
    );
    return o as FactoryResult<SaveProductOfferingStartingConfigResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProductOfferingStartingConfigResult"] = newSaveProductOfferingStartingConfigResult;

export interface ProductOfferingVersionOptions {
  __typename?: "ProductOfferingVersion";
  id?: ProductOfferingVersion["id"];
  identity?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
  name?: ProductOfferingVersion["name"];
  code?: ProductOfferingVersion["code"];
  type?: ProductOfferingVersion["type"];
  lotTypes?: ProductOfferingVersion["lotTypes"] | null;
  exteriorDesignPackageVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  interiorDesignPackageVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  planPackageVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  contingencyMarkupPercentage?: ProductOfferingVersion["contingencyMarkupPercentage"];
  description?: ProductOfferingVersion["description"];
  markets?: Array<FactoryInput<Market, MarketOptions>>;
  owner?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newProductOfferingVersion(
  options?: ProductOfferingVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingVersion>;
export function newProductOfferingVersion(
  options: ProductOfferingVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductOfferingVersion> {
  const o = (options.__typename ? options : cache["ProductOfferingVersion"] = {}) as ProductOfferingVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductOfferingVersion";
    o.id = options.id ?? nextFactoryId("ProductOfferingVersion");
    o.identity = maybeNew("ReadyPlan", options.identity, cache, options.hasOwnProperty("identity"));
    o.name = options.name ?? "name";
    o.code = options.code ?? null;
    o.type = options.type ?? null;
    o.lotTypes = options.lotTypes ?? [];
    o.exteriorDesignPackageVersion = maybeNew(
      "ReadyPlanAggregateVersion",
      options.exteriorDesignPackageVersion,
      cache,
      options.hasOwnProperty("exteriorDesignPackageVersion"),
    );
    o.interiorDesignPackageVersion = maybeNew(
      "ReadyPlanAggregateVersion",
      options.interiorDesignPackageVersion,
      cache,
      options.hasOwnProperty("interiorDesignPackageVersion"),
    );
    o.planPackageVersion = maybeNew(
      "ReadyPlanAggregateVersion",
      options.planPackageVersion,
      cache,
      options.hasOwnProperty("planPackageVersion"),
    );
    o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
    o.description = options.description ?? null;
    o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
    o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
    return o as FactoryResult<ProductOfferingVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductOfferingVersion"] = newProductOfferingVersion;

export interface ProductTypeOptions {
  __typename?: "ProductType";
  id?: ProductType["id"];
  name?: ProductType["name"];
  createdAt?: ProductType["createdAt"];
  updatedAt?: ProductType["updatedAt"];
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
}

export function newProductType(
  options?: ProductTypeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductType>;
export function newProductType(
  options: ProductTypeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProductType> {
  const o = (options.__typename ? options : cache["ProductType"] = {}) as ProductType;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProductType";
    o.id = options.id ?? nextFactoryId("ProductType");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    return o as FactoryResult<ProductType>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProductType"] = newProductType;

export interface SaveProductTypeResultOptions {
  __typename?: "SaveProductTypeResult";
  productType?: FactoryInput<ProductType, ProductTypeOptions>;
}

export function newSaveProductTypeResult(
  options?: SaveProductTypeResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProductTypeResult>;
export function newSaveProductTypeResult(
  options: SaveProductTypeResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProductTypeResult> {
  const o = (options.__typename ? options : cache["SaveProductTypeResult"] = {}) as SaveProductTypeResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProductTypeResult";
    o.productType = maybeNew("ProductType", options.productType, cache, options.hasOwnProperty("productType"));
    return o as FactoryResult<SaveProductTypeResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProductTypeResult"] = newSaveProductTypeResult;

export interface ProgramDataOptions {
  __typename?: "ProgramData";
  id?: ProgramData["id"];
  createdAt?: ProgramData["createdAt"];
  updatedAt?: ProgramData["updatedAt"];
  stories?: ProgramData["stories"];
  bedrooms?: ProgramData["bedrooms"];
  closetsInPrimarySuite?: ProgramData["closetsInPrimarySuite"];
  fullBaths?: ProgramData["fullBaths"];
  halfBaths?: ProgramData["halfBaths"];
  depthInInches?: ProgramData["depthInInches"];
  depthInFeet?: ProgramData["depthInFeet"];
  widthInInches?: ProgramData["widthInInches"];
  widthInFeet?: ProgramData["widthInFeet"];
  minLotWidthInInches?: ProgramData["minLotWidthInInches"];
  minLotWidthInFeet?: ProgramData["minLotWidthInFeet"];
  minLotDepthInInches?: ProgramData["minLotDepthInInches"];
  minLotDepthInFeet?: ProgramData["minLotDepthInFeet"];
  minLotSizeInSqft?: ProgramData["minLotSizeInSqft"];
  garageAttached?: ProgramData["garageAttached"];
  garageDetached?: ProgramData["garageDetached"];
  garagePort?: ProgramData["garagePort"];
  garageConfiguration?: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | null;
  basementConfig?: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | null;
  sellableBasementSqft?: ProgramData["sellableBasementSqft"];
  permittableSqft?: ProgramData["permittableSqft"];
  sellableSqft?: ProgramData["sellableSqft"];
  netBuildableSqft?: ProgramData["netBuildableSqft"];
  grossBuildableSqft?: ProgramData["grossBuildableSqft"];
  aboveGroundSqft?: ProgramData["aboveGroundSqft"];
  belowGroundSqft?: ProgramData["belowGroundSqft"];
  sellableAboveGroundSqft?: ProgramData["sellableAboveGroundSqft"];
  sellableBelowGroundSqft?: ProgramData["sellableBelowGroundSqft"];
  unfinishedBelowGroundSqft?: ProgramData["unfinishedBelowGroundSqft"];
  grossBelowGroundSqft?: ProgramData["grossBelowGroundSqft"];
  imperviousSqft?: ProgramData["imperviousSqft"];
  windowColor?: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | null;
  firstFloorBedrooms?: ProgramData["firstFloorBedrooms"];
  diningRoom?: ProgramData["diningRoom"];
  casualDining?: ProgramData["casualDining"];
  mediaRooms?: ProgramData["mediaRooms"];
  loftGameFlexRooms?: ProgramData["loftGameFlexRooms"];
  offices?: ProgramData["offices"];
  workspaces?: ProgramData["workspaces"];
  primaryBedroom?: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | null;
  multiUseBedrooms?: ProgramData["multiUseBedrooms"];
  primarySuiteDown?: ProgramData["primarySuiteDown"];
  buildingHeightInFeet?: ProgramData["buildingHeightInFeet"];
  readyPlanProgramData?: FactoryInput<ReadyPlanProgramData, ReadyPlanProgramDataOptions> | null;
}

export function newProgramData(
  options?: ProgramDataOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProgramData>;
export function newProgramData(
  options: ProgramDataOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProgramData> {
  const o = (options.__typename ? options : cache["ProgramData"] = {}) as ProgramData;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProgramData";
    o.id = options.id ?? nextFactoryId("ProgramData");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.stories = options.stories ?? null;
    o.bedrooms = options.bedrooms ?? null;
    o.closetsInPrimarySuite = options.closetsInPrimarySuite ?? null;
    o.fullBaths = options.fullBaths ?? null;
    o.halfBaths = options.halfBaths ?? null;
    o.depthInInches = options.depthInInches ?? null;
    o.depthInFeet = options.depthInFeet ?? null;
    o.widthInInches = options.widthInInches ?? null;
    o.widthInFeet = options.widthInFeet ?? null;
    o.minLotWidthInInches = options.minLotWidthInInches ?? null;
    o.minLotWidthInFeet = options.minLotWidthInFeet ?? null;
    o.minLotDepthInInches = options.minLotDepthInInches ?? null;
    o.minLotDepthInFeet = options.minLotDepthInFeet ?? null;
    o.minLotSizeInSqft = options.minLotSizeInSqft ?? null;
    o.garageAttached = options.garageAttached ?? null;
    o.garageDetached = options.garageDetached ?? null;
    o.garagePort = options.garagePort ?? null;
    o.garageConfiguration = enumOrDetailOrNullOfProgramDataGarageConfig(options.garageConfiguration);
    o.basementConfig = enumOrDetailOrNullOfProgramDataBasementConfig(options.basementConfig);
    o.sellableBasementSqft = options.sellableBasementSqft ?? null;
    o.permittableSqft = options.permittableSqft ?? null;
    o.sellableSqft = options.sellableSqft ?? null;
    o.netBuildableSqft = options.netBuildableSqft ?? null;
    o.grossBuildableSqft = options.grossBuildableSqft ?? null;
    o.aboveGroundSqft = options.aboveGroundSqft ?? null;
    o.belowGroundSqft = options.belowGroundSqft ?? null;
    o.sellableAboveGroundSqft = options.sellableAboveGroundSqft ?? null;
    o.sellableBelowGroundSqft = options.sellableBelowGroundSqft ?? null;
    o.unfinishedBelowGroundSqft = options.unfinishedBelowGroundSqft ?? null;
    o.grossBelowGroundSqft = options.grossBelowGroundSqft ?? null;
    o.imperviousSqft = options.imperviousSqft ?? null;
    o.windowColor = enumOrDetailOrNullOfProgramDataWindowColor(options.windowColor);
    o.firstFloorBedrooms = options.firstFloorBedrooms ?? null;
    o.diningRoom = options.diningRoom ?? null;
    o.casualDining = options.casualDining ?? null;
    o.mediaRooms = options.mediaRooms ?? null;
    o.loftGameFlexRooms = options.loftGameFlexRooms ?? null;
    o.offices = options.offices ?? null;
    o.workspaces = options.workspaces ?? null;
    o.primaryBedroom = enumOrDetailOrNullOfProgramDataPrimaryBedroomConfig(options.primaryBedroom);
    o.multiUseBedrooms = options.multiUseBedrooms ?? null;
    o.primarySuiteDown = options.primarySuiteDown ?? null;
    o.buildingHeightInFeet = options.buildingHeightInFeet ?? null;
    o.readyPlanProgramData = maybeNewOrNull("ReadyPlanProgramData", options.readyPlanProgramData, cache);
    return o as FactoryResult<ProgramData>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProgramData"] = newProgramData;

export interface NewProgramDataOptions {
  __typename?: "NewProgramData";
  createdAt?: NewProgramData["createdAt"];
  updatedAt?: NewProgramData["updatedAt"];
  stories?: NewProgramData["stories"];
  bedrooms?: NewProgramData["bedrooms"];
  closetsInPrimarySuite?: NewProgramData["closetsInPrimarySuite"];
  fullBaths?: NewProgramData["fullBaths"];
  halfBaths?: NewProgramData["halfBaths"];
  depthInInches?: NewProgramData["depthInInches"];
  depthInFeet?: NewProgramData["depthInFeet"];
  widthInInches?: NewProgramData["widthInInches"];
  widthInFeet?: NewProgramData["widthInFeet"];
  minLotWidthInInches?: NewProgramData["minLotWidthInInches"];
  minLotWidthInFeet?: NewProgramData["minLotWidthInFeet"];
  minLotDepthInInches?: NewProgramData["minLotDepthInInches"];
  minLotDepthInFeet?: NewProgramData["minLotDepthInFeet"];
  minLotSizeInSqft?: NewProgramData["minLotSizeInSqft"];
  garageAttached?: NewProgramData["garageAttached"];
  garageDetached?: NewProgramData["garageDetached"];
  garagePort?: NewProgramData["garagePort"];
  garageConfiguration?: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | null;
  basementConfig?: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | null;
  sellableBasementSqft?: NewProgramData["sellableBasementSqft"];
  permittableSqft?: NewProgramData["permittableSqft"];
  sellableSqft?: NewProgramData["sellableSqft"];
  netBuildableSqft?: NewProgramData["netBuildableSqft"];
  grossBuildableSqft?: NewProgramData["grossBuildableSqft"];
  aboveGroundSqft?: NewProgramData["aboveGroundSqft"];
  belowGroundSqft?: NewProgramData["belowGroundSqft"];
  sellableAboveGroundSqft?: NewProgramData["sellableAboveGroundSqft"];
  sellableBelowGroundSqft?: NewProgramData["sellableBelowGroundSqft"];
  unfinishedBelowGroundSqft?: NewProgramData["unfinishedBelowGroundSqft"];
  grossBelowGroundSqft?: NewProgramData["grossBelowGroundSqft"];
  imperviousSqft?: NewProgramData["imperviousSqft"];
  windowColor?: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | null;
  firstFloorBedrooms?: NewProgramData["firstFloorBedrooms"];
  diningRoom?: NewProgramData["diningRoom"];
  casualDining?: NewProgramData["casualDining"];
  mediaRooms?: NewProgramData["mediaRooms"];
  loftGameFlexRooms?: NewProgramData["loftGameFlexRooms"];
  offices?: NewProgramData["offices"];
  workspaces?: NewProgramData["workspaces"];
  primaryBedroom?: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | null;
  multiUseBedrooms?: NewProgramData["multiUseBedrooms"];
  primarySuiteDown?: NewProgramData["primarySuiteDown"];
  buildingHeightInFeet?: NewProgramData["buildingHeightInFeet"];
}

export function newNewProgramData(
  options?: NewProgramDataOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<NewProgramData>;
export function newNewProgramData(
  options: NewProgramDataOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<NewProgramData> {
  const o = (options.__typename ? options : cache["NewProgramData"] = {}) as NewProgramData;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "NewProgramData";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.stories = options.stories ?? null;
    o.bedrooms = options.bedrooms ?? null;
    o.closetsInPrimarySuite = options.closetsInPrimarySuite ?? null;
    o.fullBaths = options.fullBaths ?? null;
    o.halfBaths = options.halfBaths ?? null;
    o.depthInInches = options.depthInInches ?? null;
    o.depthInFeet = options.depthInFeet ?? null;
    o.widthInInches = options.widthInInches ?? null;
    o.widthInFeet = options.widthInFeet ?? null;
    o.minLotWidthInInches = options.minLotWidthInInches ?? null;
    o.minLotWidthInFeet = options.minLotWidthInFeet ?? null;
    o.minLotDepthInInches = options.minLotDepthInInches ?? null;
    o.minLotDepthInFeet = options.minLotDepthInFeet ?? null;
    o.minLotSizeInSqft = options.minLotSizeInSqft ?? null;
    o.garageAttached = options.garageAttached ?? null;
    o.garageDetached = options.garageDetached ?? null;
    o.garagePort = options.garagePort ?? null;
    o.garageConfiguration = enumOrDetailOrNullOfProgramDataGarageConfig(options.garageConfiguration);
    o.basementConfig = enumOrDetailOrNullOfProgramDataBasementConfig(options.basementConfig);
    o.sellableBasementSqft = options.sellableBasementSqft ?? null;
    o.permittableSqft = options.permittableSqft ?? null;
    o.sellableSqft = options.sellableSqft ?? null;
    o.netBuildableSqft = options.netBuildableSqft ?? null;
    o.grossBuildableSqft = options.grossBuildableSqft ?? null;
    o.aboveGroundSqft = options.aboveGroundSqft ?? null;
    o.belowGroundSqft = options.belowGroundSqft ?? null;
    o.sellableAboveGroundSqft = options.sellableAboveGroundSqft ?? null;
    o.sellableBelowGroundSqft = options.sellableBelowGroundSqft ?? null;
    o.unfinishedBelowGroundSqft = options.unfinishedBelowGroundSqft ?? null;
    o.grossBelowGroundSqft = options.grossBelowGroundSqft ?? null;
    o.imperviousSqft = options.imperviousSqft ?? null;
    o.windowColor = enumOrDetailOrNullOfProgramDataWindowColor(options.windowColor);
    o.firstFloorBedrooms = options.firstFloorBedrooms ?? null;
    o.diningRoom = options.diningRoom ?? null;
    o.casualDining = options.casualDining ?? null;
    o.mediaRooms = options.mediaRooms ?? null;
    o.loftGameFlexRooms = options.loftGameFlexRooms ?? null;
    o.offices = options.offices ?? null;
    o.workspaces = options.workspaces ?? null;
    o.primaryBedroom = enumOrDetailOrNullOfProgramDataPrimaryBedroomConfig(options.primaryBedroom);
    o.multiUseBedrooms = options.multiUseBedrooms ?? null;
    o.primarySuiteDown = options.primarySuiteDown ?? null;
    o.buildingHeightInFeet = options.buildingHeightInFeet ?? null;
    return o as FactoryResult<NewProgramData>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["NewProgramData"] = newNewProgramData;

export interface ProjectJobLogInsightsOptions {
  __typename?: "ProjectJobLogInsights";
  delayFlagCount?: ProjectJobLogInsights["delayFlagCount"];
  popularFlagReason?: FactoryInput<ScheduleFlagReason, ScheduleFlagReasonOptions> | null;
  partnerWithMostDelays?: FactoryInput<TradePartner, TradePartnerOptions> | null;
  topJobLogCreator?: FactoryInput<InternalUser, InternalUserOptions> | null;
  notesToday?: ProjectJobLogInsights["notesToday"];
  weekJobLogs?: ProjectJobLogInsights["weekJobLogs"];
}

export function newProjectJobLogInsights(
  options?: ProjectJobLogInsightsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectJobLogInsights>;
export function newProjectJobLogInsights(
  options: ProjectJobLogInsightsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectJobLogInsights> {
  const o = (options.__typename ? options : cache["ProjectJobLogInsights"] = {}) as ProjectJobLogInsights;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectJobLogInsights";
    o.delayFlagCount = options.delayFlagCount ?? 0;
    o.popularFlagReason = maybeNewOrNull("ScheduleFlagReason", options.popularFlagReason, cache);
    o.partnerWithMostDelays = maybeNewOrNull("TradePartner", options.partnerWithMostDelays, cache);
    o.topJobLogCreator = maybeNewOrNull("InternalUser", options.topJobLogCreator, cache);
    o.notesToday = options.notesToday ?? 0;
    o.weekJobLogs = options.weekJobLogs ?? 0;
    return o as FactoryResult<ProjectJobLogInsights>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectJobLogInsights"] = newProjectJobLogInsights;

export interface ProjectDictionaryOptions {
  __typename?: "ProjectDictionary";
  clientContract?: ProjectDictionary["clientContract"];
  clientNoun?: ProjectDictionary["clientNoun"];
  initialBudget?: ProjectDictionary["initialBudget"];
  shortClientNoun?: ProjectDictionary["shortClientNoun"];
}

export function newProjectDictionary(
  options?: ProjectDictionaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectDictionary>;
export function newProjectDictionary(
  options: ProjectDictionaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectDictionary> {
  const o = (options.__typename ? options : cache["ProjectDictionary"] = {}) as ProjectDictionary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectDictionary";
    o.clientContract = options.clientContract ?? "clientContract";
    o.clientNoun = options.clientNoun ?? "clientNoun";
    o.initialBudget = options.initialBudget ?? "initialBudget";
    o.shortClientNoun = options.shortClientNoun ?? "shortClientNoun";
    return o as FactoryResult<ProjectDictionary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectDictionary"] = newProjectDictionary;

export interface SaveProjectResultOptions {
  __typename?: "SaveProjectResult";
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
}

export function newSaveProjectResult(
  options?: SaveProjectResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectResult>;
export function newSaveProjectResult(
  options: SaveProjectResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectResult> {
  const o = (options.__typename ? options : cache["SaveProjectResult"] = {}) as SaveProjectResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectResult";
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    return o as FactoryResult<SaveProjectResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectResult"] = newSaveProjectResult;

export interface ProgressSummaryOptions {
  __typename?: "ProgressSummary";
  inProgress?: ProgressSummary["inProgress"];
  notStarted?: ProgressSummary["notStarted"];
  completed?: ProgressSummary["completed"];
  total?: ProgressSummary["total"];
  status?: ProgressSummary["status"];
}

export function newProgressSummary(
  options?: ProgressSummaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProgressSummary>;
export function newProgressSummary(
  options: ProgressSummaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProgressSummary> {
  const o = (options.__typename ? options : cache["ProgressSummary"] = {}) as ProgressSummary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProgressSummary";
    o.inProgress = options.inProgress ?? 0;
    o.notStarted = options.notStarted ?? 0;
    o.completed = options.completed ?? 0;
    o.total = options.total ?? 0;
    o.status = options.status ?? ProgressSummaryStatus.InProgress;
    return o as FactoryResult<ProgressSummary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProgressSummary"] = newProgressSummary;

export interface ResyncPreconProjectItemCostResultOptions {
  __typename?: "ResyncPreconProjectItemCostResult";
  projects?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
}

export function newResyncPreconProjectItemCostResult(
  options?: ResyncPreconProjectItemCostResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ResyncPreconProjectItemCostResult>;
export function newResyncPreconProjectItemCostResult(
  options: ResyncPreconProjectItemCostResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ResyncPreconProjectItemCostResult> {
  const o =
    (options.__typename
      ? options
      : cache["ResyncPreconProjectItemCostResult"] = {}) as ResyncPreconProjectItemCostResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ResyncPreconProjectItemCostResult";
    o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    return o as FactoryResult<ResyncPreconProjectItemCostResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ResyncPreconProjectItemCostResult"] = newResyncPreconProjectItemCostResult;

export interface CloneProjectCostAllocationsResultOptions {
  __typename?: "CloneProjectCostAllocationsResult";
  source?: Project | FactoryResult<ProjectType> | ProjectOptions;
  targets?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
}

export function newCloneProjectCostAllocationsResult(
  options?: CloneProjectCostAllocationsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CloneProjectCostAllocationsResult>;
export function newCloneProjectCostAllocationsResult(
  options: CloneProjectCostAllocationsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CloneProjectCostAllocationsResult> {
  const o =
    (options.__typename
      ? options
      : cache["CloneProjectCostAllocationsResult"] = {}) as CloneProjectCostAllocationsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CloneProjectCostAllocationsResult";
    o.source = maybeNew("Project", options.source, cache, options.hasOwnProperty("source"));
    o.targets = (options.targets ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("targets")));
    return o as FactoryResult<CloneProjectCostAllocationsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CloneProjectCostAllocationsResult"] = newCloneProjectCostAllocationsResult;

export interface ProjectsPageResultOptions {
  __typename?: "ProjectsPageResult";
  entities?: Array<Project | FactoryResult<ProjectType> | ProjectOptions>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newProjectsPageResult(
  options?: ProjectsPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectsPageResult>;
export function newProjectsPageResult(
  options: ProjectsPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectsPageResult> {
  const o = (options.__typename ? options : cache["ProjectsPageResult"] = {}) as ProjectsPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectsPageResult";
    o.entities = (options.entities ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("entities")));
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ProjectsPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectsPageResult"] = newProjectsPageResult;

export interface EarnedValueCurveOptions {
  __typename?: "EarnedValueCurve";
  label?: EarnedValueCurve["label"];
  data?: Array<FactoryInput<EarnedValueDataPoint, EarnedValueDataPointOptions>>;
}

export function newEarnedValueCurve(
  options?: EarnedValueCurveOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<EarnedValueCurve>;
export function newEarnedValueCurve(
  options: EarnedValueCurveOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<EarnedValueCurve> {
  const o = (options.__typename ? options : cache["EarnedValueCurve"] = {}) as EarnedValueCurve;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "EarnedValueCurve";
    o.label = options.label ?? "label";
    o.data = (options.data ?? []).map((i) =>
      maybeNew("EarnedValueDataPoint", i, cache, options.hasOwnProperty("data"))
    );
    return o as FactoryResult<EarnedValueCurve>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["EarnedValueCurve"] = newEarnedValueCurve;

export interface EarnedValueDataPointOptions {
  __typename?: "EarnedValueDataPoint";
  date?: EarnedValueDataPoint["date"];
  value?: EarnedValueDataPoint["value"];
}

export function newEarnedValueDataPoint(
  options?: EarnedValueDataPointOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<EarnedValueDataPoint>;
export function newEarnedValueDataPoint(
  options: EarnedValueDataPointOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<EarnedValueDataPoint> {
  const o = (options.__typename ? options : cache["EarnedValueDataPoint"] = {}) as EarnedValueDataPoint;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "EarnedValueDataPoint";
    o.date = options.date ?? newDate();
    o.value = options.value ?? 0;
    return o as FactoryResult<EarnedValueDataPoint>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["EarnedValueDataPoint"] = newEarnedValueDataPoint;

export interface ProjectsToUpdateByTemplatesResultOptions {
  __typename?: "ProjectsToUpdateByTemplatesResult";
  projectsToUpdate?: Array<FactoryInput<ProjectToUpdate, ProjectToUpdateOptions>>;
}

export function newProjectsToUpdateByTemplatesResult(
  options?: ProjectsToUpdateByTemplatesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectsToUpdateByTemplatesResult>;
export function newProjectsToUpdateByTemplatesResult(
  options: ProjectsToUpdateByTemplatesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectsToUpdateByTemplatesResult> {
  const o =
    (options.__typename
      ? options
      : cache["ProjectsToUpdateByTemplatesResult"] = {}) as ProjectsToUpdateByTemplatesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectsToUpdateByTemplatesResult";
    o.projectsToUpdate = (options.projectsToUpdate ?? []).map((i) =>
      maybeNew("ProjectToUpdate", i, cache, options.hasOwnProperty("projectsToUpdate"))
    );
    return o as FactoryResult<ProjectsToUpdateByTemplatesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectsToUpdateByTemplatesResult"] = newProjectsToUpdateByTemplatesResult;

export interface ProjectToUpdateOptions {
  __typename?: "ProjectToUpdate";
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  optionsToUpdate?: Array<FactoryInput<OptionToUpdate, OptionToUpdateOptions>>;
  currentTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions> | null;
  proposedTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newProjectToUpdate(
  options?: ProjectToUpdateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectToUpdate>;
export function newProjectToUpdate(
  options: ProjectToUpdateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectToUpdate> {
  const o = (options.__typename ? options : cache["ProjectToUpdate"] = {}) as ProjectToUpdate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectToUpdate";
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.optionsToUpdate = (options.optionsToUpdate ?? []).map((i) =>
      maybeNew("OptionToUpdate", i, cache, options.hasOwnProperty("optionsToUpdate"))
    );
    o.currentTemplate = maybeNewOrNull("ItemTemplate", options.currentTemplate, cache);
    o.proposedTemplate = maybeNew(
      "ItemTemplate",
      options.proposedTemplate,
      cache,
      options.hasOwnProperty("proposedTemplate"),
    );
    return o as FactoryResult<ProjectToUpdate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectToUpdate"] = newProjectToUpdate;

export interface OptionToUpdateOptions {
  __typename?: "OptionToUpdate";
  affectedPOs?: Array<FactoryInput<Commitment, CommitmentOptions>>;
  affectedPOsCount?: OptionToUpdate["affectedPOsCount"];
  optionOrReadyPlan?: HasDisplayName | FactoryResult<HasDisplayNameType> | HasDisplayNameOptions;
}

export function newOptionToUpdate(
  options?: OptionToUpdateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<OptionToUpdate>;
export function newOptionToUpdate(
  options: OptionToUpdateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<OptionToUpdate> {
  const o = (options.__typename ? options : cache["OptionToUpdate"] = {}) as OptionToUpdate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "OptionToUpdate";
    o.affectedPOs = (options.affectedPOs ?? []).map((i) =>
      maybeNew("Commitment", i, cache, options.hasOwnProperty("affectedPOs"))
    );
    o.affectedPOsCount = options.affectedPOsCount ?? 0;
    o.optionOrReadyPlan = maybeNew(
      "HasDisplayName",
      options.optionOrReadyPlan,
      cache,
      options.hasOwnProperty("optionOrReadyPlan"),
    );
    return o as FactoryResult<OptionToUpdate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["OptionToUpdate"] = newOptionToUpdate;

export interface ProjectBudgetFinancialsOptions {
  __typename?: "ProjectBudgetFinancials";
  originalBudgetInCents?: ProjectBudgetFinancials["originalBudgetInCents"];
  currentBudgetInCents?: ProjectBudgetFinancials["currentBudgetInCents"];
  originalRevenueInCents?: ProjectBudgetFinancials["originalRevenueInCents"];
  currentRevenueInCents?: ProjectBudgetFinancials["currentRevenueInCents"];
}

export function newProjectBudgetFinancials(
  options?: ProjectBudgetFinancialsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectBudgetFinancials>;
export function newProjectBudgetFinancials(
  options: ProjectBudgetFinancialsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectBudgetFinancials> {
  const o = (options.__typename ? options : cache["ProjectBudgetFinancials"] = {}) as ProjectBudgetFinancials;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectBudgetFinancials";
    o.originalBudgetInCents = options.originalBudgetInCents ?? 0;
    o.currentBudgetInCents = options.currentBudgetInCents ?? 0;
    o.originalRevenueInCents = options.originalRevenueInCents ?? 0;
    o.currentRevenueInCents = options.currentRevenueInCents ?? 0;
    return o as FactoryResult<ProjectBudgetFinancials>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectBudgetFinancials"] = newProjectBudgetFinancials;

export interface ApplyInvoiceScheduleResultOptions {
  __typename?: "ApplyInvoiceScheduleResult";
  invoiceSchedule?: FactoryInput<InvoiceSchedule, InvoiceScheduleOptions> | null;
}

export function newApplyInvoiceScheduleResult(
  options?: ApplyInvoiceScheduleResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ApplyInvoiceScheduleResult>;
export function newApplyInvoiceScheduleResult(
  options: ApplyInvoiceScheduleResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ApplyInvoiceScheduleResult> {
  const o = (options.__typename ? options : cache["ApplyInvoiceScheduleResult"] = {}) as ApplyInvoiceScheduleResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ApplyInvoiceScheduleResult";
    o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
    return o as FactoryResult<ApplyInvoiceScheduleResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ApplyInvoiceScheduleResult"] = newApplyInvoiceScheduleResult;

export interface ExportProjectBillsResultOptions {
  __typename?: "ExportProjectBillsResult";
  googleDriveFolderId?: ExportProjectBillsResult["googleDriveFolderId"];
}

export function newExportProjectBillsResult(
  options?: ExportProjectBillsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ExportProjectBillsResult>;
export function newExportProjectBillsResult(
  options: ExportProjectBillsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ExportProjectBillsResult> {
  const o = (options.__typename ? options : cache["ExportProjectBillsResult"] = {}) as ExportProjectBillsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ExportProjectBillsResult";
    o.googleDriveFolderId = options.googleDriveFolderId ?? "googleDriveFolderId";
    return o as FactoryResult<ExportProjectBillsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ExportProjectBillsResult"] = newExportProjectBillsResult;

export interface OptionWithCutoffDateOptions {
  __typename?: "OptionWithCutoffDate";
  option?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  cutoffDate?: OptionWithCutoffDate["cutoffDate"];
}

export function newOptionWithCutoffDate(
  options?: OptionWithCutoffDateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<OptionWithCutoffDate>;
export function newOptionWithCutoffDate(
  options: OptionWithCutoffDateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<OptionWithCutoffDate> {
  const o = (options.__typename ? options : cache["OptionWithCutoffDate"] = {}) as OptionWithCutoffDate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "OptionWithCutoffDate";
    o.option = maybeNew("ReadyPlanOption", options.option, cache, options.hasOwnProperty("option"));
    o.cutoffDate = options.cutoffDate ?? null;
    return o as FactoryResult<OptionWithCutoffDate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["OptionWithCutoffDate"] = newOptionWithCutoffDate;

export interface ProjectCompletedTaskBudgetReviewOptions {
  __typename?: "ProjectCompletedTaskBudgetReview";
  bucket?: ProjectCompletedTaskBudgetReview["bucket"];
  costInCents?: ProjectCompletedTaskBudgetReview["costInCents"];
}

export function newProjectCompletedTaskBudgetReview(
  options?: ProjectCompletedTaskBudgetReviewOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCompletedTaskBudgetReview>;
export function newProjectCompletedTaskBudgetReview(
  options: ProjectCompletedTaskBudgetReviewOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectCompletedTaskBudgetReview> {
  const o =
    (options.__typename ? options : cache["ProjectCompletedTaskBudgetReview"] = {}) as ProjectCompletedTaskBudgetReview;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectCompletedTaskBudgetReview";
    o.bucket = options.bucket ?? "bucket";
    o.costInCents = options.costInCents ?? 0;
    return o as FactoryResult<ProjectCompletedTaskBudgetReview>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectCompletedTaskBudgetReview"] = newProjectCompletedTaskBudgetReview;

export interface ProjectDirectMarginGraphOptions {
  __typename?: "ProjectDirectMarginGraph";
  resolution?: ProjectDirectMarginGraph["resolution"];
  data?: Array<FactoryInput<ProjectDirectMarginGraphData, ProjectDirectMarginGraphDataOptions>>;
}

export function newProjectDirectMarginGraph(
  options?: ProjectDirectMarginGraphOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectDirectMarginGraph>;
export function newProjectDirectMarginGraph(
  options: ProjectDirectMarginGraphOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectDirectMarginGraph> {
  const o = (options.__typename ? options : cache["ProjectDirectMarginGraph"] = {}) as ProjectDirectMarginGraph;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectDirectMarginGraph";
    o.resolution = options.resolution ?? ProjectDirectMarginGraphResolution.Daily;
    o.data = (options.data ?? []).map((i) =>
      maybeNew("ProjectDirectMarginGraphData", i, cache, options.hasOwnProperty("data"))
    );
    return o as FactoryResult<ProjectDirectMarginGraph>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectDirectMarginGraph"] = newProjectDirectMarginGraph;

export interface ProjectDirectMarginGraphDataOptions {
  __typename?: "ProjectDirectMarginGraphData";
  date?: ProjectDirectMarginGraphData["date"];
  directMarginInBasisPoints?: ProjectDirectMarginGraphData["directMarginInBasisPoints"];
}

export function newProjectDirectMarginGraphData(
  options?: ProjectDirectMarginGraphDataOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectDirectMarginGraphData>;
export function newProjectDirectMarginGraphData(
  options: ProjectDirectMarginGraphDataOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectDirectMarginGraphData> {
  const o = (options.__typename ? options : cache["ProjectDirectMarginGraphData"] = {}) as ProjectDirectMarginGraphData;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectDirectMarginGraphData";
    o.date = options.date ?? newDate();
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    return o as FactoryResult<ProjectDirectMarginGraphData>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectDirectMarginGraphData"] = newProjectDirectMarginGraphData;

export interface ProjectChangeEventGraphsResultOptions {
  __typename?: "ProjectChangeEventGraphsResult";
  graphs?: Array<FactoryInput<ProjectChangeEventGraph, ProjectChangeEventGraphOptions>>;
}

export function newProjectChangeEventGraphsResult(
  options?: ProjectChangeEventGraphsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectChangeEventGraphsResult>;
export function newProjectChangeEventGraphsResult(
  options: ProjectChangeEventGraphsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectChangeEventGraphsResult> {
  const o =
    (options.__typename ? options : cache["ProjectChangeEventGraphsResult"] = {}) as ProjectChangeEventGraphsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectChangeEventGraphsResult";
    o.graphs = (options.graphs ?? []).map((i) =>
      maybeNew("ProjectChangeEventGraph", i, cache, options.hasOwnProperty("graphs"))
    );
    return o as FactoryResult<ProjectChangeEventGraphsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectChangeEventGraphsResult"] = newProjectChangeEventGraphsResult;

export interface ProjectChangeEventGraphOptions {
  __typename?: "ProjectChangeEventGraph";
  type?: ProjectChangeEventGraph["type"];
  data?: Array<FactoryInput<ProjectChangeEventGraphData, ProjectChangeEventGraphDataOptions>>;
}

export function newProjectChangeEventGraph(
  options?: ProjectChangeEventGraphOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectChangeEventGraph>;
export function newProjectChangeEventGraph(
  options: ProjectChangeEventGraphOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectChangeEventGraph> {
  const o = (options.__typename ? options : cache["ProjectChangeEventGraph"] = {}) as ProjectChangeEventGraph;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectChangeEventGraph";
    o.type = options.type ?? ProjectChangeEventGraphType.Reason;
    o.data = (options.data ?? []).map((i) =>
      maybeNew("ProjectChangeEventGraphData", i, cache, options.hasOwnProperty("data"))
    );
    return o as FactoryResult<ProjectChangeEventGraph>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectChangeEventGraph"] = newProjectChangeEventGraph;

export interface ProjectChangeEventGraphDataOptions {
  __typename?: "ProjectChangeEventGraphData";
  name?: ProjectChangeEventGraphData["name"];
  totalCostInCents?: ProjectChangeEventGraphData["totalCostInCents"];
  timesUsed?: ProjectChangeEventGraphData["timesUsed"];
}

export function newProjectChangeEventGraphData(
  options?: ProjectChangeEventGraphDataOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectChangeEventGraphData>;
export function newProjectChangeEventGraphData(
  options: ProjectChangeEventGraphDataOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectChangeEventGraphData> {
  const o = (options.__typename ? options : cache["ProjectChangeEventGraphData"] = {}) as ProjectChangeEventGraphData;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectChangeEventGraphData";
    o.name = options.name ?? "name";
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.timesUsed = options.timesUsed ?? null;
    return o as FactoryResult<ProjectChangeEventGraphData>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectChangeEventGraphData"] = newProjectChangeEventGraphData;

export interface CompanyInfoOptions {
  __typename?: "CompanyInfo";
  name?: CompanyInfo["name"];
  licenseNumber?: CompanyInfo["licenseNumber"];
  phoneNumber?: CompanyInfo["phoneNumber"];
  email?: CompanyInfo["email"];
  accountNumber?: CompanyInfo["accountNumber"];
  federalId?: CompanyInfo["federalId"];
}

export function newCompanyInfo(
  options?: CompanyInfoOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CompanyInfo>;
export function newCompanyInfo(
  options: CompanyInfoOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CompanyInfo> {
  const o = (options.__typename ? options : cache["CompanyInfo"] = {}) as CompanyInfo;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CompanyInfo";
    o.name = options.name ?? "name";
    o.licenseNumber = options.licenseNumber ?? "licenseNumber";
    o.phoneNumber = options.phoneNumber ?? "phoneNumber";
    o.email = options.email ?? "email";
    o.accountNumber = options.accountNumber ?? "accountNumber";
    o.federalId = options.federalId ?? "federalId";
    return o as FactoryResult<CompanyInfo>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CompanyInfo"] = newCompanyInfo;

export interface RelevantProjectBidPackageOptions {
  __typename?: "RelevantProjectBidPackage";
  id?: RelevantProjectBidPackage["id"];
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
  totalCostInCents?: RelevantProjectBidPackage["totalCostInCents"];
  preferredBidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
  existingCommitments?: Array<CommitmentLike | FactoryResult<CommitmentLikeType> | CommitmentLikeOptions>;
}

export function newRelevantProjectBidPackage(
  options?: RelevantProjectBidPackageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<RelevantProjectBidPackage>;
export function newRelevantProjectBidPackage(
  options: RelevantProjectBidPackageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<RelevantProjectBidPackage> {
  const o = (options.__typename ? options : cache["RelevantProjectBidPackage"] = {}) as RelevantProjectBidPackage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "RelevantProjectBidPackage";
    o.id = options.id ?? nextFactoryId("RelevantProjectBidPackage");
    o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.preferredBidContractRevision = maybeNew(
      "BidContractRevision",
      options.preferredBidContractRevision,
      cache,
      options.hasOwnProperty("preferredBidContractRevision"),
    );
    o.existingCommitments = (options.existingCommitments ?? []).map((i) =>
      maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("existingCommitments"))
    );
    return o as FactoryResult<RelevantProjectBidPackage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["RelevantProjectBidPackage"] = newRelevantProjectBidPackage;

export interface ProjectAllocationRuleOptions {
  __typename?: "ProjectAllocationRule";
  id?: ProjectAllocationRule["id"];
  isDefault?: ProjectAllocationRule["isDefault"];
  createdAt?: ProjectAllocationRule["createdAt"];
  updatedAt?: ProjectAllocationRule["updatedAt"];
  allocationStrategy?: AllocationStrategyDetailOptions | AllocationStrategy;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  costCodes?: Array<FactoryInput<CostCode, CostCodeOptions>>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newProjectAllocationRule(
  options?: ProjectAllocationRuleOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectAllocationRule>;
export function newProjectAllocationRule(
  options: ProjectAllocationRuleOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectAllocationRule> {
  const o = (options.__typename ? options : cache["ProjectAllocationRule"] = {}) as ProjectAllocationRule;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectAllocationRule";
    o.id = options.id ?? nextFactoryId("ProjectAllocationRule");
    o.isDefault = options.isDefault ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.allocationStrategy = enumOrDetailOfAllocationStrategy(options.allocationStrategy);
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.costCodes = (options.costCodes ?? []).map((i) =>
      maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
    );
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    return o as FactoryResult<ProjectAllocationRule>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectAllocationRule"] = newProjectAllocationRule;

export interface SaveProjectAllocationRuleResultOptions {
  __typename?: "SaveProjectAllocationRuleResult";
  projectAllocationRule?: FactoryInput<ProjectAllocationRule, ProjectAllocationRuleOptions>;
}

export function newSaveProjectAllocationRuleResult(
  options?: SaveProjectAllocationRuleResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectAllocationRuleResult>;
export function newSaveProjectAllocationRuleResult(
  options: SaveProjectAllocationRuleResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectAllocationRuleResult> {
  const o =
    (options.__typename ? options : cache["SaveProjectAllocationRuleResult"] = {}) as SaveProjectAllocationRuleResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectAllocationRuleResult";
    o.projectAllocationRule = maybeNew(
      "ProjectAllocationRule",
      options.projectAllocationRule,
      cache,
      options.hasOwnProperty("projectAllocationRule"),
    );
    return o as FactoryResult<SaveProjectAllocationRuleResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectAllocationRuleResult"] = newSaveProjectAllocationRuleResult;

export interface ProjectCollaboratorOptions {
  __typename?: "ProjectCollaborator";
  id?: ProjectCollaborator["id"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  collaborator?: FactoryInput<Client, ClientOptions>;
  role?: ProjectCollaborator["role"];
  roleDetail?: ProjectCollaboratorRoleDetailOptions | ProjectCollaboratorRole;
  inviteSent?: ProjectCollaborator["inviteSent"];
  inviteSentAt?: ProjectCollaborator["inviteSentAt"];
}

export function newProjectCollaborator(
  options?: ProjectCollaboratorOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCollaborator>;
export function newProjectCollaborator(
  options: ProjectCollaboratorOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectCollaborator> {
  const o = (options.__typename ? options : cache["ProjectCollaborator"] = {}) as ProjectCollaborator;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectCollaborator";
    o.id = options.id ?? nextFactoryId("ProjectCollaborator");
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.collaborator = maybeNew("Client", options.collaborator, cache, options.hasOwnProperty("collaborator"));
    o.role = options.role ?? ProjectCollaboratorRole.Homeowner;
    o.roleDetail = enumOrDetailOfProjectCollaboratorRole(options.roleDetail);
    o.inviteSent = options.inviteSent ?? null;
    o.inviteSentAt = options.inviteSentAt ?? null;
    return o as FactoryResult<ProjectCollaborator>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectCollaborator"] = newProjectCollaborator;

export interface SendInviteEmailResultOptions {
  __typename?: "SendInviteEmailResult";
  projectCollaborator?: FactoryInput<ProjectCollaborator, ProjectCollaboratorOptions>;
}

export function newSendInviteEmailResult(
  options?: SendInviteEmailResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SendInviteEmailResult>;
export function newSendInviteEmailResult(
  options: SendInviteEmailResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SendInviteEmailResult> {
  const o = (options.__typename ? options : cache["SendInviteEmailResult"] = {}) as SendInviteEmailResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SendInviteEmailResult";
    o.projectCollaborator = maybeNew(
      "ProjectCollaborator",
      options.projectCollaborator,
      cache,
      options.hasOwnProperty("projectCollaborator"),
    );
    return o as FactoryResult<SendInviteEmailResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SendInviteEmailResult"] = newSendInviteEmailResult;

export interface ProjectContactOptions {
  __typename?: "ProjectContact";
  id?: ProjectContact["id"];
  fullName?: ProjectContact["fullName"];
  phoneNumber?: ProjectContact["phoneNumber"];
  email?: ProjectContact["email"];
  createdAt?: ProjectContact["createdAt"];
  updatedAt?: ProjectContact["updatedAt"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  warrantyTickets?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
}

export function newProjectContact(
  options?: ProjectContactOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectContact>;
export function newProjectContact(
  options: ProjectContactOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectContact> {
  const o = (options.__typename ? options : cache["ProjectContact"] = {}) as ProjectContact;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectContact";
    o.id = options.id ?? nextFactoryId("ProjectContact");
    o.fullName = options.fullName ?? "fullName";
    o.phoneNumber = options.phoneNumber ?? "phoneNumber";
    o.email = options.email ?? "email";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
    );
    return o as FactoryResult<ProjectContact>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectContact"] = newProjectContact;

export interface SaveProjectContactResultOptions {
  __typename?: "SaveProjectContactResult";
  projectContact?: FactoryInput<ProjectContact, ProjectContactOptions>;
}

export function newSaveProjectContactResult(
  options?: SaveProjectContactResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectContactResult>;
export function newSaveProjectContactResult(
  options: SaveProjectContactResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectContactResult> {
  const o = (options.__typename ? options : cache["SaveProjectContactResult"] = {}) as SaveProjectContactResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectContactResult";
    o.projectContact = maybeNew(
      "ProjectContact",
      options.projectContact,
      cache,
      options.hasOwnProperty("projectContact"),
    );
    return o as FactoryResult<SaveProjectContactResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectContactResult"] = newSaveProjectContactResult;

export interface ProjectCostCodesPageResultOptions {
  __typename?: "ProjectCostCodesPageResult";
  entities?: Array<FactoryInput<ProjectCostCode, ProjectCostCodeOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newProjectCostCodesPageResult(
  options?: ProjectCostCodesPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCostCodesPageResult>;
export function newProjectCostCodesPageResult(
  options: ProjectCostCodesPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectCostCodesPageResult> {
  const o = (options.__typename ? options : cache["ProjectCostCodesPageResult"] = {}) as ProjectCostCodesPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectCostCodesPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ProjectCostCodesPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectCostCodesPageResult"] = newProjectCostCodesPageResult;

export interface ProjectDocumentAssociationOptions {
  __typename?: "ProjectDocumentAssociation";
  id?: ProjectDocumentAssociation["id"];
  createdAt?: ProjectDocumentAssociation["createdAt"];
  updatedAt?: ProjectDocumentAssociation["updatedAt"];
  document?: FactoryInput<Document, DocumentOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
}

export function newProjectDocumentAssociation(
  options?: ProjectDocumentAssociationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectDocumentAssociation>;
export function newProjectDocumentAssociation(
  options: ProjectDocumentAssociationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectDocumentAssociation> {
  const o = (options.__typename ? options : cache["ProjectDocumentAssociation"] = {}) as ProjectDocumentAssociation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectDocumentAssociation";
    o.id = options.id ?? nextFactoryId("ProjectDocumentAssociation");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    return o as FactoryResult<ProjectDocumentAssociation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectDocumentAssociation"] = newProjectDocumentAssociation;

export interface ProjectInvoiceSettingOptions {
  __typename?: "ProjectInvoiceSetting";
  id?: ProjectInvoiceSetting["id"];
  markupValuePercent?: ProjectInvoiceSetting["markupValuePercent"];
  insuranceCostInCents?: ProjectInvoiceSetting["insuranceCostInCents"];
  insuranceMarkupPercent?: ProjectInvoiceSetting["insuranceMarkupPercent"];
  requireWorkAuthorization?: ProjectInvoiceSetting["requireWorkAuthorization"];
  includesContractIncludesRetainage?: ProjectInvoiceSetting["includesContractIncludesRetainage"];
  retainageAmountPercent?: ProjectInvoiceSetting["retainageAmountPercent"];
  requireGFormat?: ProjectInvoiceSetting["requireGFormat"];
  requireTpCopiesBills?: ProjectInvoiceSetting["requireTpCopiesBills"];
  requireTpSummaryListBills?: ProjectInvoiceSetting["requireTpSummaryListBills"];
  requireTpConditionalLw?: ProjectInvoiceSetting["requireTpConditionalLw"];
  requireTpUnconditionalLw?: ProjectInvoiceSetting["requireTpUnconditionalLw"];
  requireHbConditionalLw?: ProjectInvoiceSetting["requireHbConditionalLw"];
  requireHbUnconditionalLw?: ProjectInvoiceSetting["requireHbUnconditionalLw"];
  createdAt?: ProjectInvoiceSetting["createdAt"];
  updatedAt?: ProjectInvoiceSetting["updatedAt"];
  markupApplicationMethod?: MarkupApplicationMethodDetailOptions | MarkupApplicationMethod | null;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
}

export function newProjectInvoiceSetting(
  options?: ProjectInvoiceSettingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectInvoiceSetting>;
export function newProjectInvoiceSetting(
  options: ProjectInvoiceSettingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectInvoiceSetting> {
  const o = (options.__typename ? options : cache["ProjectInvoiceSetting"] = {}) as ProjectInvoiceSetting;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectInvoiceSetting";
    o.id = options.id ?? nextFactoryId("ProjectInvoiceSetting");
    o.markupValuePercent = options.markupValuePercent ?? null;
    o.insuranceCostInCents = options.insuranceCostInCents ?? null;
    o.insuranceMarkupPercent = options.insuranceMarkupPercent ?? null;
    o.requireWorkAuthorization = options.requireWorkAuthorization ?? null;
    o.includesContractIncludesRetainage = options.includesContractIncludesRetainage ?? null;
    o.retainageAmountPercent = options.retainageAmountPercent ?? null;
    o.requireGFormat = options.requireGFormat ?? null;
    o.requireTpCopiesBills = options.requireTpCopiesBills ?? null;
    o.requireTpSummaryListBills = options.requireTpSummaryListBills ?? null;
    o.requireTpConditionalLw = options.requireTpConditionalLw ?? null;
    o.requireTpUnconditionalLw = options.requireTpUnconditionalLw ?? null;
    o.requireHbConditionalLw = options.requireHbConditionalLw ?? null;
    o.requireHbUnconditionalLw = options.requireHbUnconditionalLw ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.markupApplicationMethod = enumOrDetailOrNullOfMarkupApplicationMethod(options.markupApplicationMethod);
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    return o as FactoryResult<ProjectInvoiceSetting>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectInvoiceSetting"] = newProjectInvoiceSetting;

export interface SaveProjectInvoiceSettingResultOptions {
  __typename?: "SaveProjectInvoiceSettingResult";
  projectInvoiceSetting?: FactoryInput<ProjectInvoiceSetting, ProjectInvoiceSettingOptions>;
}

export function newSaveProjectInvoiceSettingResult(
  options?: SaveProjectInvoiceSettingResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectInvoiceSettingResult>;
export function newSaveProjectInvoiceSettingResult(
  options: SaveProjectInvoiceSettingResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectInvoiceSettingResult> {
  const o =
    (options.__typename ? options : cache["SaveProjectInvoiceSettingResult"] = {}) as SaveProjectInvoiceSettingResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectInvoiceSettingResult";
    o.projectInvoiceSetting = maybeNew(
      "ProjectInvoiceSetting",
      options.projectInvoiceSetting,
      cache,
      options.hasOwnProperty("projectInvoiceSetting"),
    );
    return o as FactoryResult<SaveProjectInvoiceSettingResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectInvoiceSettingResult"] = newSaveProjectInvoiceSettingResult;

export interface PotentialBidContractLineItemOptions {
  __typename?: "PotentialBidContractLineItem";
  bidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions>;
  bidContractLineItems?: Array<FactoryInput<BidContractLineItem, BidContractLineItemOptions>>;
  totalCostInCents?: PotentialBidContractLineItem["totalCostInCents"];
}

export function newPotentialBidContractLineItem(
  options?: PotentialBidContractLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PotentialBidContractLineItem>;
export function newPotentialBidContractLineItem(
  options: PotentialBidContractLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialBidContractLineItem> {
  const o = (options.__typename ? options : cache["PotentialBidContractLineItem"] = {}) as PotentialBidContractLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PotentialBidContractLineItem";
    o.bidContractLineItem = maybeNew(
      "BidContractLineItem",
      options.bidContractLineItem,
      cache,
      options.hasOwnProperty("bidContractLineItem"),
    );
    o.bidContractLineItems = (options.bidContractLineItems ?? []).map((i) =>
      maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("bidContractLineItems"))
    );
    o.totalCostInCents = options.totalCostInCents ?? 0;
    return o as FactoryResult<PotentialBidContractLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PotentialBidContractLineItem"] = newPotentialBidContractLineItem;

export interface ProjectItemScopeChangeOptions {
  __typename?: "ProjectItemScopeChange";
  quantity?: ProjectItemScopeChange["quantity"];
  costInCents?: ProjectItemScopeChange["costInCents"];
  priceInCents?: ProjectItemScopeChange["priceInCents"];
  tradePartnerNote?: ProjectItemScopeChange["tradePartnerNote"];
  specifications?: ProjectItemScopeChange["specifications"];
  shortName?: ProjectItemScopeChange["shortName"];
}

export function newProjectItemScopeChange(
  options?: ProjectItemScopeChangeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItemScopeChange>;
export function newProjectItemScopeChange(
  options: ProjectItemScopeChangeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectItemScopeChange> {
  const o = (options.__typename ? options : cache["ProjectItemScopeChange"] = {}) as ProjectItemScopeChange;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectItemScopeChange";
    o.quantity = options.quantity ?? null;
    o.costInCents = options.costInCents ?? 0;
    o.priceInCents = options.priceInCents ?? 0;
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.specifications = options.specifications ?? null;
    o.shortName = options.shortName ?? "shortName";
    return o as FactoryResult<ProjectItemScopeChange>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectItemScopeChange"] = newProjectItemScopeChange;

export interface BudgetPhaseRollupOptions {
  __typename?: "BudgetPhaseRollup";
  original?: BudgetPhaseRollup["original"];
  prebid?: BudgetPhaseRollup["prebid"];
  prebidChange?: BudgetPhaseRollup["prebidChange"];
  awarded?: BudgetPhaseRollup["awarded"];
  awardedChange?: BudgetPhaseRollup["awardedChange"];
  revised?: BudgetPhaseRollup["revised"];
  revisedChange?: BudgetPhaseRollup["revisedChange"];
}

export function newBudgetPhaseRollup(
  options?: BudgetPhaseRollupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BudgetPhaseRollup>;
export function newBudgetPhaseRollup(
  options: BudgetPhaseRollupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BudgetPhaseRollup> {
  const o = (options.__typename ? options : cache["BudgetPhaseRollup"] = {}) as BudgetPhaseRollup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BudgetPhaseRollup";
    o.original = options.original ?? 0;
    o.prebid = options.prebid ?? 0;
    o.prebidChange = options.prebidChange ?? 0;
    o.awarded = options.awarded ?? 0;
    o.awardedChange = options.awardedChange ?? 0;
    o.revised = options.revised ?? 0;
    o.revisedChange = options.revisedChange ?? 0;
    return o as FactoryResult<BudgetPhaseRollup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BudgetPhaseRollup"] = newBudgetPhaseRollup;

export interface DuplicateProjectItemsResultOptions {
  __typename?: "DuplicateProjectItemsResult";
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
}

export function newDuplicateProjectItemsResult(
  options?: DuplicateProjectItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DuplicateProjectItemsResult>;
export function newDuplicateProjectItemsResult(
  options: DuplicateProjectItemsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DuplicateProjectItemsResult> {
  const o = (options.__typename ? options : cache["DuplicateProjectItemsResult"] = {}) as DuplicateProjectItemsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DuplicateProjectItemsResult";
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    return o as FactoryResult<DuplicateProjectItemsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DuplicateProjectItemsResult"] = newDuplicateProjectItemsResult;

export interface SaveProjectItemsResultOptions {
  __typename?: "SaveProjectItemsResult";
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>> | null;
  userErrors?: Array<FactoryInput<UserError, UserErrorOptions>> | null;
}

export function newSaveProjectItemsResult(
  options?: SaveProjectItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectItemsResult>;
export function newSaveProjectItemsResult(
  options: SaveProjectItemsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectItemsResult> {
  const o = (options.__typename ? options : cache["SaveProjectItemsResult"] = {}) as SaveProjectItemsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectItemsResult";
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    o.userErrors = (options.userErrors ?? []).map((i) =>
      maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
    );
    return o as FactoryResult<SaveProjectItemsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectItemsResult"] = newSaveProjectItemsResult;

export interface CostLineItemOptions {
  __typename?: "CostLineItem";
  id?: CostLineItem["id"];
  amountInCents?: CostLineItem["amountInCents"];
  historicAmountInvoiced?: CostLineItem["historicAmountInvoiced"];
  costDate?: CostLineItem["costDate"];
  isTradePartnerCredit?: CostLineItem["isTradePartnerCredit"];
  entity?: CostLineItemEntity | FactoryResult<CostLineItemEntity> | BillOptions | RequireTypename<ExpenseOptions>;
  tradePartnerNumber?: CostLineItem["tradePartnerNumber"];
}

export function newCostLineItem(
  options?: CostLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostLineItem>;
export function newCostLineItem(
  options: CostLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CostLineItem> {
  const o = (options.__typename ? options : cache["CostLineItem"] = {}) as CostLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CostLineItem";
    o.id = options.id ?? nextFactoryId("CostLineItem");
    o.amountInCents = options.amountInCents ?? 0;
    o.historicAmountInvoiced = options.historicAmountInvoiced ?? 0;
    o.costDate = options.costDate ?? newDate();
    o.isTradePartnerCredit = options.isTradePartnerCredit ?? false;
    o.entity = maybeNew(options.entity?.__typename ?? "Bill", options.entity, cache);
    o.tradePartnerNumber = options.tradePartnerNumber ?? "tradePartnerNumber";
    return o as FactoryResult<CostLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CostLineItem"] = newCostLineItem;

export interface ProjectItemBudgetFinancialsOptions {
  __typename?: "ProjectItemBudgetFinancials";
  original?: ProjectItemBudgetFinancials["original"];
  awarded?: ProjectItemBudgetFinancials["awarded"];
  changeEvents?: ProjectItemBudgetFinancials["changeEvents"];
  nonChargeableChangeEvents?: ProjectItemBudgetFinancials["nonChargeableChangeEvents"];
  chargeableChangeEvents?: ProjectItemBudgetFinancials["chargeableChangeEvents"];
  proposedChangeEvents?: ProjectItemBudgetFinancials["proposedChangeEvents"];
  reallocations?: ProjectItemBudgetFinancials["reallocations"];
  revisedInternalBudget?: ProjectItemBudgetFinancials["revisedInternalBudget"];
  revisedExternalBudget?: ProjectItemBudgetFinancials["revisedExternalBudget"];
  committed?: ProjectItemBudgetFinancials["committed"];
  uncommitted?: ProjectItemBudgetFinancials["uncommitted"];
  tradeBilled?: ProjectItemBudgetFinancials["tradeBilled"];
  tradePaidToDate?: ProjectItemBudgetFinancials["tradePaidToDate"];
  unpaidCommitments?: ProjectItemBudgetFinancials["unpaidCommitments"];
  projected?: ProjectItemBudgetFinancials["projected"];
}

export function newProjectItemBudgetFinancials(
  options?: ProjectItemBudgetFinancialsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItemBudgetFinancials>;
export function newProjectItemBudgetFinancials(
  options: ProjectItemBudgetFinancialsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectItemBudgetFinancials> {
  const o = (options.__typename ? options : cache["ProjectItemBudgetFinancials"] = {}) as ProjectItemBudgetFinancials;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectItemBudgetFinancials";
    o.original = options.original ?? 0;
    o.awarded = options.awarded ?? 0;
    o.changeEvents = options.changeEvents ?? 0;
    o.nonChargeableChangeEvents = options.nonChargeableChangeEvents ?? 0;
    o.chargeableChangeEvents = options.chargeableChangeEvents ?? 0;
    o.proposedChangeEvents = options.proposedChangeEvents ?? 0;
    o.reallocations = options.reallocations ?? 0;
    o.revisedInternalBudget = options.revisedInternalBudget ?? 0;
    o.revisedExternalBudget = options.revisedExternalBudget ?? 0;
    o.committed = options.committed ?? 0;
    o.uncommitted = options.uncommitted ?? 0;
    o.tradeBilled = options.tradeBilled ?? 0;
    o.tradePaidToDate = options.tradePaidToDate ?? 0;
    o.unpaidCommitments = options.unpaidCommitments ?? 0;
    o.projected = options.projected ?? 0;
    return o as FactoryResult<ProjectItemBudgetFinancials>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectItemBudgetFinancials"] = newProjectItemBudgetFinancials;

export interface ProjectItemsPageOptions {
  __typename?: "ProjectItemsPage";
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newProjectItemsPage(
  options?: ProjectItemsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItemsPage>;
export function newProjectItemsPage(
  options: ProjectItemsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectItemsPage> {
  const o = (options.__typename ? options : cache["ProjectItemsPage"] = {}) as ProjectItemsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectItemsPage";
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ProjectItemsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectItemsPage"] = newProjectItemsPage;

export interface ProjectItemAllocationOptions {
  __typename?: "ProjectItemAllocation";
  id?: ProjectItemAllocation["id"];
  createdAt?: ProjectItemAllocation["createdAt"];
  updatedAt?: ProjectItemAllocation["updatedAt"];
  childProject?: Project | FactoryResult<ProjectType> | ProjectOptions;
  parentProjectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  commitmentLineItemAllocations?: Array<
    FactoryInput<CommitmentLineItemAllocation, CommitmentLineItemAllocationOptions>
  >;
  homeownerContractLineItemAllocations?: Array<
    FactoryInput<HomeownerContractLineItemAllocation, HomeownerContractLineItemAllocationOptions>
  >;
  changeEventLineItemAllocations?: Array<
    FactoryInput<ChangeEventLineItemAllocation, ChangeEventLineItemAllocationOptions>
  >;
  billLineItemAllocations?: Array<FactoryInput<BillLineItemAllocation, BillLineItemAllocationOptions>>;
  expenseAllocationAllocations?: Array<FactoryInput<ExpenseAllocationAllocation, ExpenseAllocationAllocationOptions>>;
  isActive?: ProjectItemAllocation["isActive"];
  revisedPriceInCents?: ProjectItemAllocation["revisedPriceInCents"];
  originalCostInCents?: ProjectItemAllocation["originalCostInCents"];
  startCostInCents?: ProjectItemAllocation["startCostInCents"];
  changeEventCostInCents?: ProjectItemAllocation["changeEventCostInCents"];
  revisedCostInCents?: ProjectItemAllocation["revisedCostInCents"];
  projectedCostInCents?: ProjectItemAllocation["projectedCostInCents"];
  committedCostInCents?: ProjectItemAllocation["committedCostInCents"];
  availableCostInCents?: ProjectItemAllocation["availableCostInCents"];
  billedCostInCents?: ProjectItemAllocation["billedCostInCents"];
  unbilledCostInCents?: ProjectItemAllocation["unbilledCostInCents"];
  revisedApprovedBudgetInCents?: ProjectItemAllocation["revisedApprovedBudgetInCents"];
}

export function newProjectItemAllocation(
  options?: ProjectItemAllocationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItemAllocation>;
export function newProjectItemAllocation(
  options: ProjectItemAllocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectItemAllocation> {
  const o = (options.__typename ? options : cache["ProjectItemAllocation"] = {}) as ProjectItemAllocation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectItemAllocation";
    o.id = options.id ?? nextFactoryId("ProjectItemAllocation");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.childProject = maybeNew("Project", options.childProject, cache, options.hasOwnProperty("childProject"));
    o.parentProjectItem = maybeNew(
      "ProjectItem",
      options.parentProjectItem,
      cache,
      options.hasOwnProperty("parentProjectItem"),
    );
    o.commitmentLineItemAllocations = (options.commitmentLineItemAllocations ?? []).map((i) =>
      maybeNew("CommitmentLineItemAllocation", i, cache, options.hasOwnProperty("commitmentLineItemAllocations"))
    );
    o.homeownerContractLineItemAllocations = (options.homeownerContractLineItemAllocations ?? []).map((i) =>
      maybeNew(
        "HomeownerContractLineItemAllocation",
        i,
        cache,
        options.hasOwnProperty("homeownerContractLineItemAllocations"),
      )
    );
    o.changeEventLineItemAllocations = (options.changeEventLineItemAllocations ?? []).map((i) =>
      maybeNew("ChangeEventLineItemAllocation", i, cache, options.hasOwnProperty("changeEventLineItemAllocations"))
    );
    o.billLineItemAllocations = (options.billLineItemAllocations ?? []).map((i) =>
      maybeNew("BillLineItemAllocation", i, cache, options.hasOwnProperty("billLineItemAllocations"))
    );
    o.expenseAllocationAllocations = (options.expenseAllocationAllocations ?? []).map((i) =>
      maybeNew("ExpenseAllocationAllocation", i, cache, options.hasOwnProperty("expenseAllocationAllocations"))
    );
    o.isActive = options.isActive ?? false;
    o.revisedPriceInCents = options.revisedPriceInCents ?? 0;
    o.originalCostInCents = options.originalCostInCents ?? 0;
    o.startCostInCents = options.startCostInCents ?? 0;
    o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
    o.revisedCostInCents = options.revisedCostInCents ?? 0;
    o.projectedCostInCents = options.projectedCostInCents ?? 0;
    o.committedCostInCents = options.committedCostInCents ?? 0;
    o.availableCostInCents = options.availableCostInCents ?? 0;
    o.billedCostInCents = options.billedCostInCents ?? 0;
    o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
    o.revisedApprovedBudgetInCents = options.revisedApprovedBudgetInCents ?? 0;
    return o as FactoryResult<ProjectItemAllocation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectItemAllocation"] = newProjectItemAllocation;

export interface ProjectLotDetailOptions {
  __typename?: "ProjectLotDetail";
  id?: ProjectLotDetail["id"];
  lotNumber?: ProjectLotDetail["lotNumber"];
  block?: ProjectLotDetail["block"];
  section?: ProjectLotDetail["section"];
  lotSquareFootage?: ProjectLotDetail["lotSquareFootage"];
  elevationCertificateDocumentRequired?: ProjectLotDetail["elevationCertificateDocumentRequired"];
  setBackFront?: ProjectLotDetail["setBackFront"];
  setBackRight?: ProjectLotDetail["setBackRight"];
  setBackLeft?: ProjectLotDetail["setBackLeft"];
  setBackRear?: ProjectLotDetail["setBackRear"];
  hoa?: ProjectLotDetail["hoa"];
  hoaSpecificModifications?: ProjectLotDetail["hoaSpecificModifications"];
  siteSpecificModifications?: ProjectLotDetail["siteSpecificModifications"];
  fireSprinklersRequired?: ProjectLotDetail["fireSprinklersRequired"];
  createdAt?: ProjectLotDetail["createdAt"];
  updatedAt?: ProjectLotDetail["updatedAt"];
  constructionType?: ConstructionTypeDetailOptions | ConstructionType | null;
  floodPlain?: FloodPlainDetailOptions | FloodPlain | null;
  foundationType?: FoundationTypeDetailOptions | FoundationType | null;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  userEvents?: Array<FactoryInput<UserEvent, UserEventOptions>>;
  floodZone?: FloodZoneDetailOptions | FloodZone | null;
  setBackFrontInFeet?: ProjectLotDetail["setBackFrontInFeet"];
  setBackLeftInFeet?: ProjectLotDetail["setBackLeftInFeet"];
  setBackRightInFeet?: ProjectLotDetail["setBackRightInFeet"];
  setBackRearInFeet?: ProjectLotDetail["setBackRearInFeet"];
}

export function newProjectLotDetail(
  options?: ProjectLotDetailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectLotDetail>;
export function newProjectLotDetail(
  options: ProjectLotDetailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectLotDetail> {
  const o = (options.__typename ? options : cache["ProjectLotDetail"] = {}) as ProjectLotDetail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectLotDetail";
    o.id = options.id ?? nextFactoryId("ProjectLotDetail");
    o.lotNumber = options.lotNumber ?? null;
    o.block = options.block ?? null;
    o.section = options.section ?? null;
    o.lotSquareFootage = options.lotSquareFootage ?? null;
    o.elevationCertificateDocumentRequired = options.elevationCertificateDocumentRequired ?? null;
    o.setBackFront = options.setBackFront ?? null;
    o.setBackRight = options.setBackRight ?? null;
    o.setBackLeft = options.setBackLeft ?? null;
    o.setBackRear = options.setBackRear ?? null;
    o.hoa = options.hoa ?? null;
    o.hoaSpecificModifications = options.hoaSpecificModifications ?? null;
    o.siteSpecificModifications = options.siteSpecificModifications ?? null;
    o.fireSprinklersRequired = options.fireSprinklersRequired ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.constructionType = enumOrDetailOrNullOfConstructionType(options.constructionType);
    o.floodPlain = enumOrDetailOrNullOfFloodPlain(options.floodPlain);
    o.foundationType = enumOrDetailOrNullOfFoundationType(options.foundationType);
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.userEvents = (options.userEvents ?? []).map((i) =>
      maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
    );
    o.floodZone = enumOrDetailOrNullOfFloodZone(options.floodZone);
    o.setBackFrontInFeet = options.setBackFrontInFeet ?? null;
    o.setBackLeftInFeet = options.setBackLeftInFeet ?? null;
    o.setBackRightInFeet = options.setBackRightInFeet ?? null;
    o.setBackRearInFeet = options.setBackRearInFeet ?? null;
    return o as FactoryResult<ProjectLotDetail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectLotDetail"] = newProjectLotDetail;

export interface SaveProjectLotDetailsResultOptions {
  __typename?: "SaveProjectLotDetailsResult";
  projectLotDetails?: Array<FactoryInput<ProjectLotDetail, ProjectLotDetailOptions>>;
}

export function newSaveProjectLotDetailsResult(
  options?: SaveProjectLotDetailsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectLotDetailsResult>;
export function newSaveProjectLotDetailsResult(
  options: SaveProjectLotDetailsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectLotDetailsResult> {
  const o = (options.__typename ? options : cache["SaveProjectLotDetailsResult"] = {}) as SaveProjectLotDetailsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectLotDetailsResult";
    o.projectLotDetails = (options.projectLotDetails ?? []).map((i) =>
      maybeNew("ProjectLotDetail", i, cache, options.hasOwnProperty("projectLotDetails"))
    );
    return o as FactoryResult<SaveProjectLotDetailsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectLotDetailsResult"] = newSaveProjectLotDetailsResult;

export interface ProjectReadyPlanConfigOptions {
  __typename?: "ProjectReadyPlanConfig";
  id?: ProjectReadyPlanConfig["id"];
  name?: ProjectReadyPlanConfig["name"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions | null;
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions> | null;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  createdAt?: ProjectReadyPlanConfig["createdAt"];
  updatedAt?: ProjectReadyPlanConfig["updatedAt"];
  orientation?: ProjectReadyPlanConfig["orientation"];
  orientationDetail?: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation;
  constructionStartDate?: ProjectReadyPlanConfig["constructionStartDate"];
  internalNote?: ProjectReadyPlanConfig["internalNote"];
  specOption?: FactoryInput<ProjectReadyPlanConfigOption, ProjectReadyPlanConfigOptionOptions> | null;
  elevationOption?: FactoryInput<ProjectReadyPlanConfigOption, ProjectReadyPlanConfigOptionOptions> | null;
  exteriorPaletteOption?: FactoryInput<ProjectReadyPlanConfigOption, ProjectReadyPlanConfigOptionOptions> | null;
  interiorOption?: FactoryInput<ProjectReadyPlanConfigOption, ProjectReadyPlanConfigOptionOptions> | null;
  options?: Array<FactoryInput<ProjectReadyPlanConfigOption, ProjectReadyPlanConfigOptionOptions>>;
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  supportedSpecOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  applied?: ProjectReadyPlanConfig["applied"];
  lastAppliedAt?: ProjectReadyPlanConfig["lastAppliedAt"];
  canApply?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canRelease?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  programData?: FactoryInput<ProgramData, ProgramDataOptions> | null;
  deliveryDate?: ProjectReadyPlanConfig["deliveryDate"];
  configurationUpdatedAt?: ProjectReadyPlanConfig["configurationUpdatedAt"];
  programDataMatchState?: ProgramDataMatchStateDetailOptions | ProgramDataMatchState;
  computedProgramData?: FactoryInput<ProgramData, ProgramDataOptions>;
  autoPopulateWithComputedProgramData?: ProjectReadyPlanConfig["autoPopulateWithComputedProgramData"];
  insideMapsRoomRenderings?: Array<FactoryInput<InsideMapsRoomRendering, InsideMapsRoomRenderingOptions>>;
  includedPriceInCents?: ProjectReadyPlanConfig["includedPriceInCents"];
  insideMapsTextureSwaps?: FactoryInput<InsideMapsTextureSwaps, InsideMapsTextureSwapsOptions> | null;
  includedOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  exteriorRendering?: FactoryInput<Asset, AssetOptions> | null;
  aggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  potentialOptionGroups?: Array<
    FactoryInput<ProjectReadyPlanConfigPotentialOptionGroup, ProjectReadyPlanConfigPotentialOptionGroupOptions>
  >;
  exteriorOptionNames?: ProjectReadyPlanConfig["exteriorOptionNames"];
  interiorOptionNames?: ProjectReadyPlanConfig["interiorOptionNames"];
}

export function newProjectReadyPlanConfig(
  options?: ProjectReadyPlanConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectReadyPlanConfig>;
export function newProjectReadyPlanConfig(
  options: ProjectReadyPlanConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectReadyPlanConfig> {
  const o = (options.__typename ? options : cache["ProjectReadyPlanConfig"] = {}) as ProjectReadyPlanConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectReadyPlanConfig";
    o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfig");
    o.name = options.name ?? null;
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
    o.productOffering = maybeNewOrNull("ProductOffering", options.productOffering, cache);
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.orientation = options.orientation ?? ProjectReadyPlanConfigOrientation.Left;
    o.orientationDetail = enumOrDetailOfProjectReadyPlanConfigOrientation(options.orientationDetail);
    o.constructionStartDate = options.constructionStartDate ?? null;
    o.internalNote = options.internalNote ?? null;
    o.specOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.specOption, cache);
    o.elevationOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.elevationOption, cache);
    o.exteriorPaletteOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.exteriorPaletteOption, cache);
    o.interiorOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.interiorOption, cache);
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfigOption", i, cache, options.hasOwnProperty("options"))
    );
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    o.supportedSpecOptions = (options.supportedSpecOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("supportedSpecOptions"))
    );
    o.applied = options.applied ?? false;
    o.lastAppliedAt = options.lastAppliedAt ?? null;
    o.canApply = maybeNew("PotentialOperation2", options.canApply, cache, options.hasOwnProperty("canApply"));
    o.canRelease = maybeNew("PotentialOperation2", options.canRelease, cache, options.hasOwnProperty("canRelease"));
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.programData = maybeNewOrNull("ProgramData", options.programData, cache);
    o.deliveryDate = options.deliveryDate ?? null;
    o.configurationUpdatedAt = options.configurationUpdatedAt ?? newDateTime();
    o.programDataMatchState = enumOrDetailOfProgramDataMatchState(options.programDataMatchState);
    o.computedProgramData = maybeNew(
      "ProgramData",
      options.computedProgramData,
      cache,
      options.hasOwnProperty("computedProgramData"),
    );
    o.autoPopulateWithComputedProgramData = options.autoPopulateWithComputedProgramData ?? false;
    o.insideMapsRoomRenderings = (options.insideMapsRoomRenderings ?? []).map((i) =>
      maybeNew("InsideMapsRoomRendering", i, cache, options.hasOwnProperty("insideMapsRoomRenderings"))
    );
    o.includedPriceInCents = options.includedPriceInCents ?? null;
    o.insideMapsTextureSwaps = maybeNewOrNull("InsideMapsTextureSwaps", options.insideMapsTextureSwaps, cache);
    o.includedOptions = (options.includedOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("includedOptions"))
    );
    o.exteriorRendering = maybeNewOrNull("Asset", options.exteriorRendering, cache);
    o.aggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateVersion, cache);
    o.potentialOptionGroups = (options.potentialOptionGroups ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfigPotentialOptionGroup", i, cache, options.hasOwnProperty("potentialOptionGroups"))
    );
    o.exteriorOptionNames = options.exteriorOptionNames ?? [];
    o.interiorOptionNames = options.interiorOptionNames ?? [];
    return o as FactoryResult<ProjectReadyPlanConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectReadyPlanConfig"] = newProjectReadyPlanConfig;

export interface ProjectReadyPlanConfigPotentialOptionGroupOptions {
  __typename?: "ProjectReadyPlanConfigPotentialOptionGroup";
  id?: ProjectReadyPlanConfigPotentialOptionGroup["id"];
  group?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>;
  options?: Array<FactoryInput<ProjectReadyPlanConfigPotentialOption, ProjectReadyPlanConfigPotentialOptionOptions>>;
  isEnabled?: ProjectReadyPlanConfigPotentialOptionGroup["isEnabled"];
  canBeSelected?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newProjectReadyPlanConfigPotentialOptionGroup(
  options?: ProjectReadyPlanConfigPotentialOptionGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectReadyPlanConfigPotentialOptionGroup>;
export function newProjectReadyPlanConfigPotentialOptionGroup(
  options: ProjectReadyPlanConfigPotentialOptionGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectReadyPlanConfigPotentialOptionGroup> {
  const o =
    (options.__typename
      ? options
      : cache["ProjectReadyPlanConfigPotentialOptionGroup"] = {}) as ProjectReadyPlanConfigPotentialOptionGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectReadyPlanConfigPotentialOptionGroup";
    o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfigPotentialOptionGroup");
    o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfigPotentialOption", i, cache, options.hasOwnProperty("options"))
    );
    o.isEnabled = options.isEnabled ?? false;
    o.canBeSelected = maybeNew(
      "PotentialOperation2",
      options.canBeSelected,
      cache,
      options.hasOwnProperty("canBeSelected"),
    );
    return o as FactoryResult<ProjectReadyPlanConfigPotentialOptionGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectReadyPlanConfigPotentialOptionGroup"] = newProjectReadyPlanConfigPotentialOptionGroup;

export interface ProjectReadyPlanConfigPotentialOptionOptions {
  __typename?: "ProjectReadyPlanConfigPotentialOption";
  id?: ProjectReadyPlanConfigPotentialOption["id"];
  option?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  isSelected?: ProjectReadyPlanConfigPotentialOption["isSelected"];
  isEnabled?: ProjectReadyPlanConfigPotentialOption["isEnabled"];
  canBeSelected?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  totalCostInCents?: ProjectReadyPlanConfigPotentialOption["totalCostInCents"];
  totalPriceInCents?: ProjectReadyPlanConfigPotentialOption["totalPriceInCents"];
}

export function newProjectReadyPlanConfigPotentialOption(
  options?: ProjectReadyPlanConfigPotentialOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectReadyPlanConfigPotentialOption>;
export function newProjectReadyPlanConfigPotentialOption(
  options: ProjectReadyPlanConfigPotentialOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectReadyPlanConfigPotentialOption> {
  const o =
    (options.__typename
      ? options
      : cache["ProjectReadyPlanConfigPotentialOption"] = {}) as ProjectReadyPlanConfigPotentialOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectReadyPlanConfigPotentialOption";
    o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfigPotentialOption");
    o.option = maybeNew("ReadyPlanOption", options.option, cache, options.hasOwnProperty("option"));
    o.isSelected = options.isSelected ?? false;
    o.isEnabled = options.isEnabled ?? false;
    o.canBeSelected = maybeNew(
      "PotentialOperation2",
      options.canBeSelected,
      cache,
      options.hasOwnProperty("canBeSelected"),
    );
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    return o as FactoryResult<ProjectReadyPlanConfigPotentialOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectReadyPlanConfigPotentialOption"] = newProjectReadyPlanConfigPotentialOption;

export interface SaveProjectReadyPlanConfigsResultOptions {
  __typename?: "SaveProjectReadyPlanConfigsResult";
  projectReadyPlanConfigs?: Array<FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>>;
}

export function newSaveProjectReadyPlanConfigsResult(
  options?: SaveProjectReadyPlanConfigsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectReadyPlanConfigsResult>;
export function newSaveProjectReadyPlanConfigsResult(
  options: SaveProjectReadyPlanConfigsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectReadyPlanConfigsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectReadyPlanConfigsResult"] = {}) as SaveProjectReadyPlanConfigsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectReadyPlanConfigsResult";
    o.projectReadyPlanConfigs = (options.projectReadyPlanConfigs ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectReadyPlanConfigs"))
    );
    return o as FactoryResult<SaveProjectReadyPlanConfigsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectReadyPlanConfigsResult"] = newSaveProjectReadyPlanConfigsResult;

export interface ApplyProjectReadyPlanConfigsResultOptions {
  __typename?: "ApplyProjectReadyPlanConfigsResult";
  projectReadyPlanConfigs?: Array<FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>>;
}

export function newApplyProjectReadyPlanConfigsResult(
  options?: ApplyProjectReadyPlanConfigsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ApplyProjectReadyPlanConfigsResult>;
export function newApplyProjectReadyPlanConfigsResult(
  options: ApplyProjectReadyPlanConfigsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ApplyProjectReadyPlanConfigsResult> {
  const o =
    (options.__typename
      ? options
      : cache["ApplyProjectReadyPlanConfigsResult"] = {}) as ApplyProjectReadyPlanConfigsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ApplyProjectReadyPlanConfigsResult";
    o.projectReadyPlanConfigs = (options.projectReadyPlanConfigs ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectReadyPlanConfigs"))
    );
    return o as FactoryResult<ApplyProjectReadyPlanConfigsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ApplyProjectReadyPlanConfigsResult"] = newApplyProjectReadyPlanConfigsResult;

export interface SaveProjectReadyPlanConfigOptionsResultOptions {
  __typename?: "SaveProjectReadyPlanConfigOptionsResult";
  projectReadyPlanConfigOptions?: Array<
    FactoryInput<ProjectReadyPlanConfigOption, ProjectReadyPlanConfigOptionOptions>
  >;
}

export function newSaveProjectReadyPlanConfigOptionsResult(
  options?: SaveProjectReadyPlanConfigOptionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectReadyPlanConfigOptionsResult>;
export function newSaveProjectReadyPlanConfigOptionsResult(
  options: SaveProjectReadyPlanConfigOptionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectReadyPlanConfigOptionsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectReadyPlanConfigOptionsResult"] = {}) as SaveProjectReadyPlanConfigOptionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectReadyPlanConfigOptionsResult";
    o.projectReadyPlanConfigOptions = (options.projectReadyPlanConfigOptions ?? []).map((i) =>
      maybeNew("ProjectReadyPlanConfigOption", i, cache, options.hasOwnProperty("projectReadyPlanConfigOptions"))
    );
    return o as FactoryResult<SaveProjectReadyPlanConfigOptionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectReadyPlanConfigOptionsResult"] = newSaveProjectReadyPlanConfigOptionsResult;

export interface ProjectReadyPlanConfigOptionOptions {
  __typename?: "ProjectReadyPlanConfigOption";
  id?: ProjectReadyPlanConfigOption["id"];
  createdAt?: ProjectReadyPlanConfigOption["createdAt"];
  updatedAt?: ProjectReadyPlanConfigOption["updatedAt"];
  projectRpConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>;
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  priceInCents?: ProjectReadyPlanConfigOption["priceInCents"];
}

export function newProjectReadyPlanConfigOption(
  options?: ProjectReadyPlanConfigOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectReadyPlanConfigOption>;
export function newProjectReadyPlanConfigOption(
  options: ProjectReadyPlanConfigOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectReadyPlanConfigOption> {
  const o = (options.__typename ? options : cache["ProjectReadyPlanConfigOption"] = {}) as ProjectReadyPlanConfigOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectReadyPlanConfigOption";
    o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfigOption");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.projectRpConfig = maybeNew(
      "ProjectReadyPlanConfig",
      options.projectRpConfig,
      cache,
      options.hasOwnProperty("projectRpConfig"),
    );
    o.readyPlanOption = maybeNew(
      "ReadyPlanOption",
      options.readyPlanOption,
      cache,
      options.hasOwnProperty("readyPlanOption"),
    );
    o.priceInCents = options.priceInCents ?? 0;
    return o as FactoryResult<ProjectReadyPlanConfigOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectReadyPlanConfigOption"] = newProjectReadyPlanConfigOption;

export interface ProjectSalesforceOpportunityOptions {
  __typename?: "ProjectSalesforceOpportunity";
  id?: ProjectSalesforceOpportunity["id"];
  salesforceOpportunityId?: ProjectSalesforceOpportunity["salesforceOpportunityId"];
  salesforceOpportunityRecordType?: ProjectSalesforceOpportunity["salesforceOpportunityRecordType"];
  active?: ProjectSalesforceOpportunity["active"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  createdAt?: ProjectSalesforceOpportunity["createdAt"];
  updatedAt?: ProjectSalesforceOpportunity["updatedAt"];
}

export function newProjectSalesforceOpportunity(
  options?: ProjectSalesforceOpportunityOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectSalesforceOpportunity>;
export function newProjectSalesforceOpportunity(
  options: ProjectSalesforceOpportunityOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectSalesforceOpportunity> {
  const o = (options.__typename ? options : cache["ProjectSalesforceOpportunity"] = {}) as ProjectSalesforceOpportunity;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectSalesforceOpportunity";
    o.id = options.id ?? nextFactoryId("ProjectSalesforceOpportunity");
    o.salesforceOpportunityId = options.salesforceOpportunityId ?? "salesforceOpportunityId";
    o.salesforceOpportunityRecordType = options.salesforceOpportunityRecordType ?? "salesforceOpportunityRecordType";
    o.active = options.active ?? false;
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    return o as FactoryResult<ProjectSalesforceOpportunity>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectSalesforceOpportunity"] = newProjectSalesforceOpportunity;

export interface ProjectSiteConditionOptions {
  __typename?: "ProjectSiteCondition";
  id?: ProjectSiteCondition["id"];
  expectedSlabPourDate?: ProjectSiteCondition["expectedSlabPourDate"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  drivewaySwing?: ProjectSiteCondition["drivewaySwing"];
  gasLocation?: ProjectSiteCondition["gasLocation"];
  electricLocation?: ProjectSiteCondition["electricLocation"];
  waterLocation?: ProjectSiteCondition["waterLocation"];
  curbGutterLinearFoot?: ProjectSiteCondition["curbGutterLinearFoot"];
  createdAt?: ProjectSiteCondition["createdAt"];
  updatedAt?: ProjectSiteCondition["updatedAt"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  additionalNotes?: ProjectSiteCondition["additionalNotes"];
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
}

export function newProjectSiteCondition(
  options?: ProjectSiteConditionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectSiteCondition>;
export function newProjectSiteCondition(
  options: ProjectSiteConditionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectSiteCondition> {
  const o = (options.__typename ? options : cache["ProjectSiteCondition"] = {}) as ProjectSiteCondition;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectSiteCondition";
    o.id = options.id ?? nextFactoryId("ProjectSiteCondition");
    o.expectedSlabPourDate = options.expectedSlabPourDate ?? null;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.drivewaySwing = options.drivewaySwing ?? null;
    o.gasLocation = options.gasLocation ?? null;
    o.electricLocation = options.electricLocation ?? null;
    o.waterLocation = options.waterLocation ?? null;
    o.curbGutterLinearFoot = options.curbGutterLinearFoot ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.additionalNotes = options.additionalNotes ?? null;
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    return o as FactoryResult<ProjectSiteCondition>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectSiteCondition"] = newProjectSiteCondition;

export interface SaveProjectSiteConditionResultOptions {
  __typename?: "SaveProjectSiteConditionResult";
  projectSiteCondition?: FactoryInput<ProjectSiteCondition, ProjectSiteConditionOptions>;
}

export function newSaveProjectSiteConditionResult(
  options?: SaveProjectSiteConditionResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectSiteConditionResult>;
export function newSaveProjectSiteConditionResult(
  options: SaveProjectSiteConditionResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectSiteConditionResult> {
  const o =
    (options.__typename ? options : cache["SaveProjectSiteConditionResult"] = {}) as SaveProjectSiteConditionResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectSiteConditionResult";
    o.projectSiteCondition = maybeNew(
      "ProjectSiteCondition",
      options.projectSiteCondition,
      cache,
      options.hasOwnProperty("projectSiteCondition"),
    );
    return o as FactoryResult<SaveProjectSiteConditionResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectSiteConditionResult"] = newSaveProjectSiteConditionResult;

export interface ProjectSiteSpecificInfoOptions {
  __typename?: "ProjectSiteSpecificInfo";
  id?: ProjectSiteSpecificInfo["id"];
  perSiteBudgetInCents?: ProjectSiteSpecificInfo["perSiteBudgetInCents"];
  notes?: ProjectSiteSpecificInfo["notes"];
  createdAt?: ProjectSiteSpecificInfo["createdAt"];
  updatedAt?: ProjectSiteSpecificInfo["updatedAt"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  siteSpecificInfo?: FactoryInput<SiteSpecificInfo, SiteSpecificInfoOptions>;
}

export function newProjectSiteSpecificInfo(
  options?: ProjectSiteSpecificInfoOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectSiteSpecificInfo>;
export function newProjectSiteSpecificInfo(
  options: ProjectSiteSpecificInfoOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectSiteSpecificInfo> {
  const o = (options.__typename ? options : cache["ProjectSiteSpecificInfo"] = {}) as ProjectSiteSpecificInfo;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectSiteSpecificInfo";
    o.id = options.id ?? nextFactoryId("ProjectSiteSpecificInfo");
    o.perSiteBudgetInCents = options.perSiteBudgetInCents ?? null;
    o.notes = options.notes ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.siteSpecificInfo = maybeNew(
      "SiteSpecificInfo",
      options.siteSpecificInfo,
      cache,
      options.hasOwnProperty("siteSpecificInfo"),
    );
    return o as FactoryResult<ProjectSiteSpecificInfo>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectSiteSpecificInfo"] = newProjectSiteSpecificInfo;

export interface SaveProjectSiteSpecificInfoResultOptions {
  __typename?: "SaveProjectSiteSpecificInfoResult";
  projectSiteSpecificInfo?: FactoryInput<ProjectSiteSpecificInfo, ProjectSiteSpecificInfoOptions>;
}

export function newSaveProjectSiteSpecificInfoResult(
  options?: SaveProjectSiteSpecificInfoResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectSiteSpecificInfoResult>;
export function newSaveProjectSiteSpecificInfoResult(
  options: SaveProjectSiteSpecificInfoResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectSiteSpecificInfoResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectSiteSpecificInfoResult"] = {}) as SaveProjectSiteSpecificInfoResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectSiteSpecificInfoResult";
    o.projectSiteSpecificInfo = maybeNew(
      "ProjectSiteSpecificInfo",
      options.projectSiteSpecificInfo,
      cache,
      options.hasOwnProperty("projectSiteSpecificInfo"),
    );
    return o as FactoryResult<SaveProjectSiteSpecificInfoResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectSiteSpecificInfoResult"] = newSaveProjectSiteSpecificInfoResult;

export interface ProjectSnapshotOptions {
  __typename?: "ProjectSnapshot";
  id?: ProjectSnapshot["id"];
  grossSalesPriceInCents?: ProjectSnapshot["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: ProjectSnapshot["closingCostsForDirectMarginInCents"];
  totalCostInCents?: ProjectSnapshot["totalCostInCents"];
  totalHardCostInCents?: ProjectSnapshot["totalHardCostInCents"];
  totalSoftCostInCents?: ProjectSnapshot["totalSoftCostInCents"];
  directMarginInBasisPoints?: ProjectSnapshot["directMarginInBasisPoints"];
  purchaseCostInCents?: ProjectSnapshot["purchaseCostInCents"];
  startDate?: ProjectSnapshot["startDate"];
  endDate?: ProjectSnapshot["endDate"];
}

export function newProjectSnapshot(
  options?: ProjectSnapshotOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectSnapshot>;
export function newProjectSnapshot(
  options: ProjectSnapshotOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectSnapshot> {
  const o = (options.__typename ? options : cache["ProjectSnapshot"] = {}) as ProjectSnapshot;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectSnapshot";
    o.id = options.id ?? nextFactoryId("ProjectSnapshot");
    o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
    o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
    o.totalCostInCents = options.totalCostInCents ?? null;
    o.totalHardCostInCents = options.totalHardCostInCents ?? null;
    o.totalSoftCostInCents = options.totalSoftCostInCents ?? null;
    o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
    o.purchaseCostInCents = options.purchaseCostInCents ?? null;
    o.startDate = options.startDate ?? newDate();
    o.endDate = options.endDate ?? null;
    return o as FactoryResult<ProjectSnapshot>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectSnapshot"] = newProjectSnapshot;

export interface StageProgressOptions {
  __typename?: "StageProgress";
  id?: StageProgress["id"];
  taskProgress?: FactoryInput<ProgressSummary, ProgressSummaryOptions>;
}

export function newStageProgress(
  options?: StageProgressOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<StageProgress>;
export function newStageProgress(
  options: StageProgressOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<StageProgress> {
  const o = (options.__typename ? options : cache["StageProgress"] = {}) as StageProgress;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "StageProgress";
    o.id = options.id ?? nextFactoryId("StageProgress");
    o.taskProgress = maybeNew("ProgressSummary", options.taskProgress, cache, options.hasOwnProperty("taskProgress"));
    return o as FactoryResult<StageProgress>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["StageProgress"] = newStageProgress;

export interface ProjectStageHomeownerFinancialsOptions {
  __typename?: "ProjectStageHomeownerFinancials";
  homeownerPriceInCents?: ProjectStageHomeownerFinancials["homeownerPriceInCents"];
  amountInvoicedInCents?: ProjectStageHomeownerFinancials["amountInvoicedInCents"];
  amountPaidInCents?: ProjectStageHomeownerFinancials["amountPaidInCents"];
  balanceInCents?: ProjectStageHomeownerFinancials["balanceInCents"];
  financialsLastUpdate?: ProjectStageHomeownerFinancials["financialsLastUpdate"];
}

export function newProjectStageHomeownerFinancials(
  options?: ProjectStageHomeownerFinancialsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStageHomeownerFinancials>;
export function newProjectStageHomeownerFinancials(
  options: ProjectStageHomeownerFinancialsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectStageHomeownerFinancials> {
  const o =
    (options.__typename ? options : cache["ProjectStageHomeownerFinancials"] = {}) as ProjectStageHomeownerFinancials;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectStageHomeownerFinancials";
    o.homeownerPriceInCents = options.homeownerPriceInCents ?? 0;
    o.amountInvoicedInCents = options.amountInvoicedInCents ?? 0;
    o.amountPaidInCents = options.amountPaidInCents ?? 0;
    o.balanceInCents = options.balanceInCents ?? 0;
    o.financialsLastUpdate = options.financialsLastUpdate ?? newDate();
    return o as FactoryResult<ProjectStageHomeownerFinancials>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectStageHomeownerFinancials"] = newProjectStageHomeownerFinancials;

export interface ProjectStageHocFinancialsOptions {
  __typename?: "ProjectStageHocFinancials";
  originalContractValueInCents?: ProjectStageHocFinancials["originalContractValueInCents"];
  originalBudgetedCostInCents?: ProjectStageHocFinancials["originalBudgetedCostInCents"];
  originalGrossMarginBasisPoints?: ProjectStageHocFinancials["originalGrossMarginBasisPoints"];
  valueInCents?: ProjectStageHocFinancials["valueInCents"];
  costInCents?: ProjectStageHocFinancials["costInCents"];
  grossMarginBasisPoints?: ProjectStageHocFinancials["grossMarginBasisPoints"];
  paidFromHomeownerInCents?: ProjectStageHocFinancials["paidFromHomeownerInCents"];
  paidToTradesInCents?: ProjectStageHocFinancials["paidToTradesInCents"];
  paidNetInCents?: ProjectStageHocFinancials["paidNetInCents"];
  marginErosionBasisPoints?: ProjectStageHocFinancials["marginErosionBasisPoints"];
}

export function newProjectStageHocFinancials(
  options?: ProjectStageHocFinancialsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStageHocFinancials>;
export function newProjectStageHocFinancials(
  options: ProjectStageHocFinancialsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectStageHocFinancials> {
  const o = (options.__typename ? options : cache["ProjectStageHocFinancials"] = {}) as ProjectStageHocFinancials;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectStageHocFinancials";
    o.originalContractValueInCents = options.originalContractValueInCents ?? 0;
    o.originalBudgetedCostInCents = options.originalBudgetedCostInCents ?? 0;
    o.originalGrossMarginBasisPoints = options.originalGrossMarginBasisPoints ?? 0;
    o.valueInCents = options.valueInCents ?? 0;
    o.costInCents = options.costInCents ?? 0;
    o.grossMarginBasisPoints = options.grossMarginBasisPoints ?? 0;
    o.paidFromHomeownerInCents = options.paidFromHomeownerInCents ?? 0;
    o.paidToTradesInCents = options.paidToTradesInCents ?? 0;
    o.paidNetInCents = options.paidNetInCents ?? 0;
    o.marginErosionBasisPoints = options.marginErosionBasisPoints ?? 0;
    return o as FactoryResult<ProjectStageHocFinancials>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectStageHocFinancials"] = newProjectStageHocFinancials;

export interface ProjectStageTemplateConfigOptions {
  __typename?: "ProjectStageTemplateConfig";
  id?: ProjectStageTemplateConfig["id"];
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  parent?: BaseItemParentVersion | FactoryResult<BaseItemParentVersionType> | BaseItemParentVersionOptions;
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  createdAt?: ProjectStageTemplateConfig["createdAt"];
  updatedAt?: ProjectStageTemplateConfig["updatedAt"];
  name?: ProjectStageTemplateConfig["name"];
  totalCostInCents?: ProjectStageTemplateConfig["totalCostInCents"];
  onlyChangedInVersion?: ProjectStageTemplateConfig["onlyChangedInVersion"];
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions> | null;
}

export function newProjectStageTemplateConfig(
  options?: ProjectStageTemplateConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStageTemplateConfig>;
export function newProjectStageTemplateConfig(
  options: ProjectStageTemplateConfigOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectStageTemplateConfig> {
  const o = (options.__typename ? options : cache["ProjectStageTemplateConfig"] = {}) as ProjectStageTemplateConfig;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectStageTemplateConfig";
    o.id = options.id ?? nextFactoryId("ProjectStageTemplateConfig");
    o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
    o.parent = maybeNew("BaseItemParentVersion", options.parent, cache, options.hasOwnProperty("parent"));
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.name = options.name ?? "name";
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.onlyChangedInVersion = options.onlyChangedInVersion ?? null;
    o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
    return o as FactoryResult<ProjectStageTemplateConfig>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectStageTemplateConfig"] = newProjectStageTemplateConfig;

export interface ProjectStatusChangeOptions {
  __typename?: "ProjectStatusChange";
  id?: ProjectStatusChange["id"];
  internalNote?: ProjectStatusChange["internalNote"];
  createdAt?: ProjectStatusChange["createdAt"];
  updatedAt?: ProjectStatusChange["updatedAt"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  reason?: FactoryInput<ProjectStatusChangeReason, ProjectStatusChangeReasonOptions> | null;
  date?: ProjectStatusChange["date"];
}

export function newProjectStatusChange(
  options?: ProjectStatusChangeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStatusChange>;
export function newProjectStatusChange(
  options: ProjectStatusChangeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectStatusChange> {
  const o = (options.__typename ? options : cache["ProjectStatusChange"] = {}) as ProjectStatusChange;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectStatusChange";
    o.id = options.id ?? nextFactoryId("ProjectStatusChange");
    o.internalNote = options.internalNote ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.reason = maybeNewOrNull("ProjectStatusChangeReason", options.reason, cache);
    o.date = options.date ?? null;
    return o as FactoryResult<ProjectStatusChange>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectStatusChange"] = newProjectStatusChange;

export interface ProjectStatusChangeReasonOptions {
  __typename?: "ProjectStatusChangeReason";
  id?: ProjectStatusChangeReason["id"];
  code?: ProjectStatusChangeReason["code"];
  name?: ProjectStatusChangeReason["name"];
  projectStatus?: ProjectStatusChangeReason["projectStatus"];
  projectStatusDetail?: ProjectStatusDetailOptions | ProjectStatus;
  projectStage?: ProjectStatusChangeReason["projectStage"];
  projectStageDetail?: StageDetailOptions | Stage;
}

export function newProjectStatusChangeReason(
  options?: ProjectStatusChangeReasonOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStatusChangeReason>;
export function newProjectStatusChangeReason(
  options: ProjectStatusChangeReasonOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectStatusChangeReason> {
  const o = (options.__typename ? options : cache["ProjectStatusChangeReason"] = {}) as ProjectStatusChangeReason;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectStatusChangeReason";
    o.id = options.id ?? nextFactoryId("ProjectStatusChangeReason");
    o.code = options.code ?? "code";
    o.name = options.name ?? "name";
    o.projectStatus = options.projectStatus ?? ProjectStatus.Active;
    o.projectStatusDetail = enumOrDetailOfProjectStatus(options.projectStatusDetail);
    o.projectStage = options.projectStage ?? Stage.PreConPlanning;
    o.projectStageDetail = enumOrDetailOfStage(options.projectStageDetail);
    return o as FactoryResult<ProjectStatusChangeReason>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectStatusChangeReason"] = newProjectStatusChangeReason;

export interface SaveProjectStatusChangeReasonsResultOptions {
  __typename?: "SaveProjectStatusChangeReasonsResult";
  projectStatusChangeReasons?: Array<FactoryInput<ProjectStatusChangeReason, ProjectStatusChangeReasonOptions>>;
  userErrors?: Array<Maybe<FactoryInput<UserError, UserErrorOptions>>>;
}

export function newSaveProjectStatusChangeReasonsResult(
  options?: SaveProjectStatusChangeReasonsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectStatusChangeReasonsResult>;
export function newSaveProjectStatusChangeReasonsResult(
  options: SaveProjectStatusChangeReasonsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveProjectStatusChangeReasonsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectStatusChangeReasonsResult"] = {}) as SaveProjectStatusChangeReasonsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveProjectStatusChangeReasonsResult";
    o.projectStatusChangeReasons = (options.projectStatusChangeReasons ?? []).map((i) =>
      maybeNew("ProjectStatusChangeReason", i, cache, options.hasOwnProperty("projectStatusChangeReasons"))
    );
    o.userErrors = (options.userErrors ?? []).map((i) => maybeNewOrNull("UserError", i, cache));
    return o as FactoryResult<SaveProjectStatusChangeReasonsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveProjectStatusChangeReasonsResult"] = newSaveProjectStatusChangeReasonsResult;

export interface ProjectTeamMemberOptions {
  __typename?: "ProjectTeamMember";
  user?: FactoryInput<InternalUser, InternalUserOptions> | null;
  role?: ProjectRoleDetailOptions | ProjectRole;
}

export function newProjectTeamMember(
  options?: ProjectTeamMemberOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectTeamMember>;
export function newProjectTeamMember(
  options: ProjectTeamMemberOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectTeamMember> {
  const o = (options.__typename ? options : cache["ProjectTeamMember"] = {}) as ProjectTeamMember;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectTeamMember";
    o.user = maybeNewOrNull("InternalUser", options.user, cache);
    o.role = enumOrDetailOfProjectRole(options.role);
    return o as FactoryResult<ProjectTeamMember>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectTeamMember"] = newProjectTeamMember;

export interface UpdateProjectRoleResultOptions {
  __typename?: "UpdateProjectRoleResult";
  teamMember?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>;
  tasks?: Array<FactoryInput<Task, TaskOptions>>;
}

export function newUpdateProjectRoleResult(
  options?: UpdateProjectRoleResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UpdateProjectRoleResult>;
export function newUpdateProjectRoleResult(
  options: UpdateProjectRoleResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UpdateProjectRoleResult> {
  const o = (options.__typename ? options : cache["UpdateProjectRoleResult"] = {}) as UpdateProjectRoleResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UpdateProjectRoleResult";
    o.teamMember = maybeNew("ProjectTeamMember", options.teamMember, cache, options.hasOwnProperty("teamMember"));
    o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
    return o as FactoryResult<UpdateProjectRoleResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UpdateProjectRoleResult"] = newUpdateProjectRoleResult;

export interface BulkUpdateProjectRoleResultOptions {
  __typename?: "BulkUpdateProjectRoleResult";
  teamMember?: FactoryInput<ProjectTeamMember, ProjectTeamMemberOptions>;
  tasks?: Array<FactoryInput<Task, TaskOptions>>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
}

export function newBulkUpdateProjectRoleResult(
  options?: BulkUpdateProjectRoleResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BulkUpdateProjectRoleResult>;
export function newBulkUpdateProjectRoleResult(
  options: BulkUpdateProjectRoleResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BulkUpdateProjectRoleResult> {
  const o = (options.__typename ? options : cache["BulkUpdateProjectRoleResult"] = {}) as BulkUpdateProjectRoleResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "BulkUpdateProjectRoleResult";
    o.teamMember = maybeNew("ProjectTeamMember", options.teamMember, cache, options.hasOwnProperty("teamMember"));
    o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    return o as FactoryResult<BulkUpdateProjectRoleResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["BulkUpdateProjectRoleResult"] = newBulkUpdateProjectRoleResult;

export interface ProjectUpdateOptions {
  __typename?: "ProjectUpdate";
  id?: ProjectUpdate["id"];
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  createdAt?: ProjectUpdate["createdAt"];
  eventTime?: ProjectUpdate["eventTime"];
  actionType?: ProjectUpdate["actionType"];
  actionTypeDetail?: ProjectUpdateActionTypeDetailOptions | ProjectUpdateActionType;
  schedulePhase?: FactoryInput<SchedulePhase, SchedulePhaseOptions> | null;
  document?: FactoryInput<Document, DocumentOptions> | null;
  scheduleSubPhase?: FactoryInput<ScheduleSubPhase, ScheduleSubPhaseOptions> | null;
  homeownerNote?: FactoryInput<HomeownerNote, HomeownerNoteOptions> | null;
}

export function newProjectUpdate(
  options?: ProjectUpdateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectUpdate>;
export function newProjectUpdate(
  options: ProjectUpdateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectUpdate> {
  const o = (options.__typename ? options : cache["ProjectUpdate"] = {}) as ProjectUpdate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProjectUpdate";
    o.id = options.id ?? nextFactoryId("ProjectUpdate");
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.eventTime = options.eventTime ?? newDateTime();
    o.actionType = options.actionType ?? ProjectUpdateActionType.ActivityComplete;
    o.actionTypeDetail = enumOrDetailOfProjectUpdateActionType(options.actionTypeDetail);
    o.schedulePhase = maybeNewOrNull("SchedulePhase", options.schedulePhase, cache);
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.scheduleSubPhase = maybeNewOrNull("ScheduleSubPhase", options.scheduleSubPhase, cache);
    o.homeownerNote = maybeNewOrNull("HomeownerNote", options.homeownerNote, cache);
    return o as FactoryResult<ProjectUpdate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProjectUpdate"] = newProjectUpdate;

export interface SavePunchlistItemTodosResultOptions {
  __typename?: "SavePunchlistItemTodosResult";
  punchlistItemTodos?: Array<FactoryInput<PunchlistItemTodo, PunchlistItemTodoOptions>>;
}

export function newSavePunchlistItemTodosResult(
  options?: SavePunchlistItemTodosResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePunchlistItemTodosResult>;
export function newSavePunchlistItemTodosResult(
  options: SavePunchlistItemTodosResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePunchlistItemTodosResult> {
  const o = (options.__typename ? options : cache["SavePunchlistItemTodosResult"] = {}) as SavePunchlistItemTodosResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePunchlistItemTodosResult";
    o.punchlistItemTodos = (options.punchlistItemTodos ?? []).map((i) =>
      maybeNew("PunchlistItemTodo", i, cache, options.hasOwnProperty("punchlistItemTodos"))
    );
    return o as FactoryResult<SavePunchlistItemTodosResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePunchlistItemTodosResult"] = newSavePunchlistItemTodosResult;

export interface SavePunchlistItemTodoResultOptions {
  __typename?: "SavePunchlistItemTodoResult";
  punchlistItemTodo?: FactoryInput<PunchlistItemTodo, PunchlistItemTodoOptions>;
}

export function newSavePunchlistItemTodoResult(
  options?: SavePunchlistItemTodoResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SavePunchlistItemTodoResult>;
export function newSavePunchlistItemTodoResult(
  options: SavePunchlistItemTodoResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SavePunchlistItemTodoResult> {
  const o = (options.__typename ? options : cache["SavePunchlistItemTodoResult"] = {}) as SavePunchlistItemTodoResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SavePunchlistItemTodoResult";
    o.punchlistItemTodo = maybeNew(
      "PunchlistItemTodo",
      options.punchlistItemTodo,
      cache,
      options.hasOwnProperty("punchlistItemTodo"),
    );
    return o as FactoryResult<SavePunchlistItemTodoResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SavePunchlistItemTodoResult"] = newSavePunchlistItemTodoResult;

export interface SendTradePartnerPunchlistEmailResultsOptions {
  __typename?: "SendTradePartnerPunchlistEmailResults";
  results?:
    | Array<
      | SendTradePartnerPunchlistEmailResult
      | FactoryResult<SendTradePartnerPunchlistEmailResult>
      | SendTradePartnerPunchlistEmailSuccessOptions
      | RequireTypename<SendTradePartnerPunchlistEmailFailureOptions>
    >
    | null;
}

export function newSendTradePartnerPunchlistEmailResults(
  options?: SendTradePartnerPunchlistEmailResultsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SendTradePartnerPunchlistEmailResults>;
export function newSendTradePartnerPunchlistEmailResults(
  options: SendTradePartnerPunchlistEmailResultsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SendTradePartnerPunchlistEmailResults> {
  const o =
    (options.__typename
      ? options
      : cache["SendTradePartnerPunchlistEmailResults"] = {}) as SendTradePartnerPunchlistEmailResults;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SendTradePartnerPunchlistEmailResults";
    o.results = (options.results ?? []).map((i) =>
      maybeNew(i?.__typename ?? "{SendTradePartnerPunchlistEmailSuccess", i, cache, options.hasOwnProperty("results"))
    );
    return o as FactoryResult<SendTradePartnerPunchlistEmailResults>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SendTradePartnerPunchlistEmailResults"] = newSendTradePartnerPunchlistEmailResults;

export interface SendTradePartnerPunchlistEmailSuccessOptions {
  __typename?: "SendTradePartnerPunchlistEmailSuccess";
  punchlistItemTodo?: FactoryInput<PunchlistItemTodo, PunchlistItemTodoOptions>;
  emails?: SendTradePartnerPunchlistEmailSuccess["emails"];
}

export function newSendTradePartnerPunchlistEmailSuccess(
  options?: SendTradePartnerPunchlistEmailSuccessOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SendTradePartnerPunchlistEmailSuccess>;
export function newSendTradePartnerPunchlistEmailSuccess(
  options: SendTradePartnerPunchlistEmailSuccessOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SendTradePartnerPunchlistEmailSuccess> {
  const o =
    (options.__typename
      ? options
      : cache["SendTradePartnerPunchlistEmailSuccess"] = {}) as SendTradePartnerPunchlistEmailSuccess;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SendTradePartnerPunchlistEmailSuccess";
    o.punchlistItemTodo = maybeNew(
      "PunchlistItemTodo",
      options.punchlistItemTodo,
      cache,
      options.hasOwnProperty("punchlistItemTodo"),
    );
    o.emails = options.emails ?? [];
    return o as FactoryResult<SendTradePartnerPunchlistEmailSuccess>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SendTradePartnerPunchlistEmailSuccess"] = newSendTradePartnerPunchlistEmailSuccess;

export interface SendTradePartnerPunchlistEmailFailureOptions {
  __typename?: "SendTradePartnerPunchlistEmailFailure";
  punchlistItemTodoId?: SendTradePartnerPunchlistEmailFailure["punchlistItemTodoId"];
  error?: SendTradePartnerPunchlistEmailFailure["error"];
}

export function newSendTradePartnerPunchlistEmailFailure(
  options?: SendTradePartnerPunchlistEmailFailureOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SendTradePartnerPunchlistEmailFailure>;
export function newSendTradePartnerPunchlistEmailFailure(
  options: SendTradePartnerPunchlistEmailFailureOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SendTradePartnerPunchlistEmailFailure> {
  const o =
    (options.__typename
      ? options
      : cache["SendTradePartnerPunchlistEmailFailure"] = {}) as SendTradePartnerPunchlistEmailFailure;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SendTradePartnerPunchlistEmailFailure";
    o.punchlistItemTodoId = options.punchlistItemTodoId ?? "punchlistItemTodoId";
    o.error = options.error ?? "error";
    return o as FactoryResult<SendTradePartnerPunchlistEmailFailure>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SendTradePartnerPunchlistEmailFailure"] = newSendTradePartnerPunchlistEmailFailure;

export interface SendPunchlistExportEmailResultsOptions {
  __typename?: "SendPunchlistExportEmailResults";
  results?:
    | Array<
      | SendPunchlistExportEmailResult
      | FactoryResult<SendPunchlistExportEmailResult>
      | SendPunchlistExportEmailSuccessOptions
      | RequireTypename<SendPunchlistExportEmailFailureOptions>
    >
    | null;
}

export function newSendPunchlistExportEmailResults(
  options?: SendPunchlistExportEmailResultsOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SendPunchlistExportEmailResults>;
export function newSendPunchlistExportEmailResults(
  options: SendPunchlistExportEmailResultsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SendPunchlistExportEmailResults> {
  const o =
    (options.__typename ? options : cache["SendPunchlistExportEmailResults"] = {}) as SendPunchlistExportEmailResults;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SendPunchlistExportEmailResults";
    o.results = (options.results ?? []).map((i) =>
      maybeNew(i?.__typename ?? "{SendPunchlistExportEmailSuccess", i, cache, options.hasOwnProperty("results"))
    );
    return o as FactoryResult<SendPunchlistExportEmailResults>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SendPunchlistExportEmailResults"] = newSendPunchlistExportEmailResults;

export interface SendPunchlistExportEmailSuccessOptions {
  __typename?: "SendPunchlistExportEmailSuccess";
  punchlistItemTodo?: FactoryInput<PunchlistItemTodo, PunchlistItemTodoOptions>;
}

export function newSendPunchlistExportEmailSuccess(
  options?: SendPunchlistExportEmailSuccessOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SendPunchlistExportEmailSuccess>;
export function newSendPunchlistExportEmailSuccess(
  options: SendPunchlistExportEmailSuccessOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SendPunchlistExportEmailSuccess> {
  const o =
    (options.__typename ? options : cache["SendPunchlistExportEmailSuccess"] = {}) as SendPunchlistExportEmailSuccess;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SendPunchlistExportEmailSuccess";
    o.punchlistItemTodo = maybeNew(
      "PunchlistItemTodo",
      options.punchlistItemTodo,
      cache,
      options.hasOwnProperty("punchlistItemTodo"),
    );
    return o as FactoryResult<SendPunchlistExportEmailSuccess>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SendPunchlistExportEmailSuccess"] = newSendPunchlistExportEmailSuccess;

export interface SendPunchlistExportEmailFailureOptions {
  __typename?: "SendPunchlistExportEmailFailure";
  punchlistItemTodoId?: SendPunchlistExportEmailFailure["punchlistItemTodoId"];
  error?: SendPunchlistExportEmailFailure["error"];
}

export function newSendPunchlistExportEmailFailure(
  options?: SendPunchlistExportEmailFailureOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SendPunchlistExportEmailFailure>;
export function newSendPunchlistExportEmailFailure(
  options: SendPunchlistExportEmailFailureOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SendPunchlistExportEmailFailure> {
  const o =
    (options.__typename ? options : cache["SendPunchlistExportEmailFailure"] = {}) as SendPunchlistExportEmailFailure;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SendPunchlistExportEmailFailure";
    o.punchlistItemTodoId = options.punchlistItemTodoId ?? "punchlistItemTodoId";
    o.error = options.error ?? "error";
    return o as FactoryResult<SendPunchlistExportEmailFailure>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SendPunchlistExportEmailFailure"] = newSendPunchlistExportEmailFailure;

export interface RegisterPushNotificationTokenResultOptions {
  __typename?: "RegisterPushNotificationTokenResult";
  pushNotificationToken?: FactoryInput<PushNotificationToken, PushNotificationTokenOptions>;
}

export function newRegisterPushNotificationTokenResult(
  options?: RegisterPushNotificationTokenResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<RegisterPushNotificationTokenResult>;
export function newRegisterPushNotificationTokenResult(
  options: RegisterPushNotificationTokenResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<RegisterPushNotificationTokenResult> {
  const o =
    (options.__typename
      ? options
      : cache["RegisterPushNotificationTokenResult"] = {}) as RegisterPushNotificationTokenResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "RegisterPushNotificationTokenResult";
    o.pushNotificationToken = maybeNew(
      "PushNotificationToken",
      options.pushNotificationToken,
      cache,
      options.hasOwnProperty("pushNotificationToken"),
    );
    return o as FactoryResult<RegisterPushNotificationTokenResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["RegisterPushNotificationTokenResult"] = newRegisterPushNotificationTokenResult;

export interface PushNotificationTokenOptions {
  __typename?: "PushNotificationToken";
  id?: PushNotificationToken["id"];
  token?: PushNotificationToken["token"];
  lastSeenAt?: PushNotificationToken["lastSeenAt"];
  createdAt?: PushNotificationToken["createdAt"];
  updatedAt?: PushNotificationToken["updatedAt"];
  platform?: PushNotificationPlatformDetailOptions | PushNotificationPlatform;
  user?: FactoryInput<User, UserOptions>;
  environment?: PushNotificationEnvironmentDetailOptions | PushNotificationEnvironment;
  snsEndpointArn?: PushNotificationToken["snsEndpointArn"];
}

export function newPushNotificationToken(
  options?: PushNotificationTokenOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PushNotificationToken>;
export function newPushNotificationToken(
  options: PushNotificationTokenOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PushNotificationToken> {
  const o = (options.__typename ? options : cache["PushNotificationToken"] = {}) as PushNotificationToken;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PushNotificationToken";
    o.id = options.id ?? nextFactoryId("PushNotificationToken");
    o.token = options.token ?? "token";
    o.lastSeenAt = options.lastSeenAt ?? newDateTime();
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.platform = enumOrDetailOfPushNotificationPlatform(options.platform);
    o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
    o.environment = enumOrDetailOfPushNotificationEnvironment(options.environment);
    o.snsEndpointArn = options.snsEndpointArn ?? null;
    return o as FactoryResult<PushNotificationToken>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PushNotificationToken"] = newPushNotificationToken;

export interface TriggerQaDatabaseResetResultOptions {
  __typename?: "TriggerQaDatabaseResetResult";
  triggered?: TriggerQaDatabaseResetResult["triggered"];
  message?: TriggerQaDatabaseResetResult["message"];
}

export function newTriggerQaDatabaseResetResult(
  options?: TriggerQaDatabaseResetResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TriggerQaDatabaseResetResult>;
export function newTriggerQaDatabaseResetResult(
  options: TriggerQaDatabaseResetResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TriggerQaDatabaseResetResult> {
  const o = (options.__typename ? options : cache["TriggerQaDatabaseResetResult"] = {}) as TriggerQaDatabaseResetResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TriggerQaDatabaseResetResult";
    o.triggered = options.triggered ?? false;
    o.message = options.message ?? "message";
    return o as FactoryResult<TriggerQaDatabaseResetResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TriggerQaDatabaseResetResult"] = newTriggerQaDatabaseResetResult;

export interface SaveReadyPlansResultOptions {
  __typename?: "SaveReadyPlansResult";
  readyPlans?: Array<FactoryInput<ReadyPlan, ReadyPlanOptions>>;
}

export function newSaveReadyPlansResult(
  options?: SaveReadyPlansResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlansResult>;
export function newSaveReadyPlansResult(
  options: SaveReadyPlansResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlansResult> {
  const o = (options.__typename ? options : cache["SaveReadyPlansResult"] = {}) as SaveReadyPlansResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlansResult";
    o.readyPlans = (options.readyPlans ?? []).map((i) =>
      maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("readyPlans"))
    );
    return o as FactoryResult<SaveReadyPlansResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlansResult"] = newSaveReadyPlansResult;

export interface SaveReadyPlanResultOptions {
  __typename?: "SaveReadyPlanResult";
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
}

export function newSaveReadyPlanResult(
  options?: SaveReadyPlanResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlanResult>;
export function newSaveReadyPlanResult(
  options: SaveReadyPlanResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlanResult> {
  const o = (options.__typename ? options : cache["SaveReadyPlanResult"] = {}) as SaveReadyPlanResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlanResult";
    o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    return o as FactoryResult<SaveReadyPlanResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlanResult"] = newSaveReadyPlanResult;

export interface ComputeReadyPlanCostResultOptions {
  __typename?: "ComputeReadyPlanCostResult";
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  includedOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  totalCostInCents?: ComputeReadyPlanCostResult["totalCostInCents"];
  softCostInCents?: ComputeReadyPlanCostResult["softCostInCents"];
  directHardCostInCents?: ComputeReadyPlanCostResult["directHardCostInCents"];
  indirectHardCostInCents?: ComputeReadyPlanCostResult["indirectHardCostInCents"];
  contingencyCostInCents?: ComputeReadyPlanCostResult["contingencyCostInCents"];
  contingencyComputed?: ComputeReadyPlanCostResult["contingencyComputed"];
  deltas?: Array<FactoryInput<ReadyPlanOptionCostDelta, ReadyPlanOptionCostDeltaOptions>>;
  protoProjectItems?: Array<FactoryInput<ProtoProjectItem, ProtoProjectItemOptions>>;
  configurationErrors?: ComputeReadyPlanCostResult["configurationErrors"];
}

export function newComputeReadyPlanCostResult(
  options?: ComputeReadyPlanCostResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ComputeReadyPlanCostResult>;
export function newComputeReadyPlanCostResult(
  options: ComputeReadyPlanCostResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ComputeReadyPlanCostResult> {
  const o = (options.__typename ? options : cache["ComputeReadyPlanCostResult"] = {}) as ComputeReadyPlanCostResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ComputeReadyPlanCostResult";
    o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    o.includedOptions = (options.includedOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("includedOptions"))
    );
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.softCostInCents = options.softCostInCents ?? 0;
    o.directHardCostInCents = options.directHardCostInCents ?? 0;
    o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
    o.contingencyCostInCents = options.contingencyCostInCents ?? 0;
    o.contingencyComputed = options.contingencyComputed ?? false;
    o.deltas = (options.deltas ?? []).map((i) =>
      maybeNew("ReadyPlanOptionCostDelta", i, cache, options.hasOwnProperty("deltas"))
    );
    o.protoProjectItems = (options.protoProjectItems ?? []).map((i) =>
      maybeNew("ProtoProjectItem", i, cache, options.hasOwnProperty("protoProjectItems"))
    );
    o.configurationErrors = options.configurationErrors ?? [];
    return o as FactoryResult<ComputeReadyPlanCostResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ComputeReadyPlanCostResult"] = newComputeReadyPlanCostResult;

export interface ReadyPlanOptionCostDeltaOptions {
  __typename?: "ReadyPlanOptionCostDelta";
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  totalCostInCents?: ReadyPlanOptionCostDelta["totalCostInCents"];
  softCostInCents?: ReadyPlanOptionCostDelta["softCostInCents"];
  directHardCostInCents?: ReadyPlanOptionCostDelta["directHardCostInCents"];
  indirectHardCostInCents?: ReadyPlanOptionCostDelta["indirectHardCostInCents"];
  contingencyCostInCents?: ReadyPlanOptionCostDelta["contingencyCostInCents"];
  contingencyComputed?: ReadyPlanOptionCostDelta["contingencyComputed"];
}

export function newReadyPlanOptionCostDelta(
  options?: ReadyPlanOptionCostDeltaOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionCostDelta>;
export function newReadyPlanOptionCostDelta(
  options: ReadyPlanOptionCostDeltaOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOptionCostDelta> {
  const o = (options.__typename ? options : cache["ReadyPlanOptionCostDelta"] = {}) as ReadyPlanOptionCostDelta;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOptionCostDelta";
    o.readyPlanOption = maybeNew(
      "ReadyPlanOption",
      options.readyPlanOption,
      cache,
      options.hasOwnProperty("readyPlanOption"),
    );
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.softCostInCents = options.softCostInCents ?? 0;
    o.directHardCostInCents = options.directHardCostInCents ?? 0;
    o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
    o.contingencyCostInCents = options.contingencyCostInCents ?? 0;
    o.contingencyComputed = options.contingencyComputed ?? false;
    return o as FactoryResult<ReadyPlanOptionCostDelta>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOptionCostDelta"] = newReadyPlanOptionCostDelta;

export interface ProtoProjectItemOptions {
  __typename?: "ProtoProjectItem";
  name?: ProtoProjectItem["name"];
  specifications?: ProtoProjectItem["specifications"];
  tradePartnerNote?: ProtoProjectItem["tradePartnerNote"];
  slot?: FactoryInput<ItemSlot, ItemSlotOptions>;
  item?: FactoryInput<Item, ItemOptions>;
  quantity?: ProtoProjectItem["quantity"];
  totalPriceInCents?: ProtoProjectItem["totalPriceInCents"];
  totalCostInCents?: ProtoProjectItem["totalCostInCents"];
  location?: FactoryInput<Location, LocationOptions>;
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  costType?: ProtoProjectItem["costType"];
  preferredPotentialBidContractLineItem?:
    | FactoryInput<PotentialBidContractLineItem, PotentialBidContractLineItemOptions>
    | null;
  itemTemplateItem?: BaseItemLike | FactoryResult<BaseItemLikeType> | BaseItemLikeOptions | null;
  modifyingTemplateItems?: Array<BaseItemLike | FactoryResult<BaseItemLikeType> | BaseItemLikeOptions>;
  bidItem?: FactoryInput<BidItem, BidItemOptions> | null;
}

export function newProtoProjectItem(
  options?: ProtoProjectItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProtoProjectItem>;
export function newProtoProjectItem(
  options: ProtoProjectItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProtoProjectItem> {
  const o = (options.__typename ? options : cache["ProtoProjectItem"] = {}) as ProtoProjectItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ProtoProjectItem";
    o.name = options.name ?? "name";
    o.specifications = options.specifications ?? null;
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.quantity = options.quantity ?? null;
    o.totalPriceInCents = options.totalPriceInCents ?? 0;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.costType = options.costType ?? CostType.Labor;
    o.preferredPotentialBidContractLineItem = maybeNewOrNull(
      "PotentialBidContractLineItem",
      options.preferredPotentialBidContractLineItem,
      cache,
    );
    o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
    o.modifyingTemplateItems = (options.modifyingTemplateItems ?? []).map((i) =>
      maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("modifyingTemplateItems"))
    );
    o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
    return o as FactoryResult<ProtoProjectItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ProtoProjectItem"] = newProtoProjectItem;

export interface ScopeGlobalOptionGroupsToReadyPlansResultOptions {
  __typename?: "ScopeGlobalOptionGroupsToReadyPlansResult";
  globalOptionGroups?: Array<FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions>>;
}

export function newScopeGlobalOptionGroupsToReadyPlansResult(
  options?: ScopeGlobalOptionGroupsToReadyPlansResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScopeGlobalOptionGroupsToReadyPlansResult>;
export function newScopeGlobalOptionGroupsToReadyPlansResult(
  options: ScopeGlobalOptionGroupsToReadyPlansResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScopeGlobalOptionGroupsToReadyPlansResult> {
  const o =
    (options.__typename
      ? options
      : cache["ScopeGlobalOptionGroupsToReadyPlansResult"] = {}) as ScopeGlobalOptionGroupsToReadyPlansResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScopeGlobalOptionGroupsToReadyPlansResult";
    o.globalOptionGroups = (options.globalOptionGroups ?? []).map((i) =>
      maybeNew("GlobalOptionGroup", i, cache, options.hasOwnProperty("globalOptionGroups"))
    );
    return o as FactoryResult<ScopeGlobalOptionGroupsToReadyPlansResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScopeGlobalOptionGroupsToReadyPlansResult"] = newScopeGlobalOptionGroupsToReadyPlansResult;

export interface GenerateReadyPlanVersionNotesResultOptions {
  __typename?: "GenerateReadyPlanVersionNotesResult";
  notes?: GenerateReadyPlanVersionNotesResult["notes"];
}

export function newGenerateReadyPlanVersionNotesResult(
  options?: GenerateReadyPlanVersionNotesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GenerateReadyPlanVersionNotesResult>;
export function newGenerateReadyPlanVersionNotesResult(
  options: GenerateReadyPlanVersionNotesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<GenerateReadyPlanVersionNotesResult> {
  const o =
    (options.__typename
      ? options
      : cache["GenerateReadyPlanVersionNotesResult"] = {}) as GenerateReadyPlanVersionNotesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "GenerateReadyPlanVersionNotesResult";
    o.notes = options.notes ?? "notes";
    return o as FactoryResult<GenerateReadyPlanVersionNotesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["GenerateReadyPlanVersionNotesResult"] = newGenerateReadyPlanVersionNotesResult;

export interface ReadyPlanAggregateVersionOptions {
  __typename?: "ReadyPlanAggregateVersion";
  id?: ReadyPlanAggregateVersion["id"];
  version?: ReadyPlanAggregateVersion["version"];
  name?: ReadyPlanAggregateVersion["name"];
  displayName?: ReadyPlanAggregateVersion["displayName"];
  displayVersion?: ReadyPlanAggregateVersion["displayVersion"];
  createdAt?: ReadyPlanAggregateVersion["createdAt"];
  updatedAt?: ReadyPlanAggregateVersion["updatedAt"];
  status?: AggregateVersionStatusDetailOptions | AggregateVersionStatus;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  optionGroupVersions?: Array<FactoryInput<ReadyPlanOptionGroupVersion, ReadyPlanOptionGroupVersionOptions>>;
  optionVersions?: Array<FactoryInput<ReadyPlanOptionVersion, ReadyPlanOptionVersionOptions>>;
  finalReadyPlanOptionVersions?: Array<FactoryInput<ReadyPlanOptionVersion, ReadyPlanOptionVersionOptions>>;
  versions?: Array<FactoryInput<ReadyPlanVersion, ReadyPlanVersionOptions>>;
  removedTliVersions?: Array<FactoryInput<TakeoffLineItemVersion, TakeoffLineItemVersionOptions>>;
  tliVersions?: Array<FactoryInput<TakeoffLineItemVersion, TakeoffLineItemVersionOptions>>;
  versionNotes?: ReadyPlanAggregateVersion["versionNotes"];
  designPackagePlanUpdates?: Array<FactoryInput<DesignPackagePlanUpdate, DesignPackagePlanUpdateOptions>>;
  productOfferingIncomingUpdates?: Array<
    FactoryInput<ProductOfferingIncomingUpdate, ProductOfferingIncomingUpdateOptions>
  >;
  programDataVersions?: Array<FactoryInput<ReadyPlanProgramDataVersion, ReadyPlanProgramDataVersionOptions>>;
  removedProgramDataVersions?: Array<FactoryInput<ReadyPlanProgramDataVersion, ReadyPlanProgramDataVersionOptions>>;
  assetVersions?: Array<FactoryInput<ReadyPlanAssetVersion, ReadyPlanAssetVersionOptions>>;
  designPackageSourceVersions?: Array<FactoryInput<DesignPackageSourceVersion, DesignPackageSourceVersionOptions>>;
  tliVersionsCount?: ReadyPlanAggregateVersion["tliVersionsCount"];
  tlivChangeSummary?: Array<FactoryInput<TlivChangeSummary, TlivChangeSummaryOptions>>;
  productTlivChangeSummary?: Array<FactoryInput<TlivChangeSummary, TlivChangeSummaryOptions>>;
  rplVersions?: Array<FactoryInput<ReadyPlanLocationVersion, ReadyPlanLocationVersionOptions>>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canPublish?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canPromote?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  acceptedDesignPackageUpdates?: Array<FactoryInput<DesignPackagePlanUpdate, DesignPackagePlanUpdateOptions>>;
  outgoingDesignPackageUpdates?: Array<FactoryInput<DesignPackagePlanUpdate, DesignPackagePlanUpdateOptions>>;
  incomingSlotsFulfilledByPublish?: Array<FactoryInput<PlanPackageIncomingSlot, PlanPackageIncomingSlotOptions>>;
  publishedAt?: ReadyPlanAggregateVersion["publishedAt"];
  finalReadyPlanRequiredOptionVersions?: Array<
    FactoryInput<ReadyPlanRequiredOptionVersion, ReadyPlanRequiredOptionVersionOptions>
  >;
  requiredOptionVersions?: Array<FactoryInput<ReadyPlanRequiredOptionVersion, ReadyPlanRequiredOptionVersionOptions>>;
  designNoteVersions?: Array<FactoryInput<ReadyPlanDesignNoteVersion, ReadyPlanDesignNoteVersionOptions>>;
  designPackageSources?: Array<FactoryInput<DesignPackageSource, DesignPackageSourceOptions>>;
  promotedAt?: ReadyPlanAggregateVersion["promotedAt"];
  promotedBy?: FactoryInput<User, UserOptions> | null;
  createdByPromotion?: ReadyPlanAggregateVersion["createdByPromotion"];
}

export function newReadyPlanAggregateVersion(
  options?: ReadyPlanAggregateVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanAggregateVersion>;
export function newReadyPlanAggregateVersion(
  options: ReadyPlanAggregateVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanAggregateVersion> {
  const o = (options.__typename ? options : cache["ReadyPlanAggregateVersion"] = {}) as ReadyPlanAggregateVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanAggregateVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanAggregateVersion");
    o.version = options.version ?? null;
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.displayVersion = options.displayVersion ?? "displayVersion";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = enumOrDetailOfAggregateVersionStatus(options.status);
    o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.optionGroupVersions = (options.optionGroupVersions ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroupVersion", i, cache, options.hasOwnProperty("optionGroupVersions"))
    );
    o.optionVersions = (options.optionVersions ?? []).map((i) =>
      maybeNew("ReadyPlanOptionVersion", i, cache, options.hasOwnProperty("optionVersions"))
    );
    o.finalReadyPlanOptionVersions = (options.finalReadyPlanOptionVersions ?? []).map((i) =>
      maybeNew("ReadyPlanOptionVersion", i, cache, options.hasOwnProperty("finalReadyPlanOptionVersions"))
    );
    o.versions = (options.versions ?? []).map((i) =>
      maybeNew("ReadyPlanVersion", i, cache, options.hasOwnProperty("versions"))
    );
    o.removedTliVersions = (options.removedTliVersions ?? []).map((i) =>
      maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("removedTliVersions"))
    );
    o.tliVersions = (options.tliVersions ?? []).map((i) =>
      maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("tliVersions"))
    );
    o.versionNotes = options.versionNotes ?? null;
    o.designPackagePlanUpdates = (options.designPackagePlanUpdates ?? []).map((i) =>
      maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("designPackagePlanUpdates"))
    );
    o.productOfferingIncomingUpdates = (options.productOfferingIncomingUpdates ?? []).map((i) =>
      maybeNew("ProductOfferingIncomingUpdate", i, cache, options.hasOwnProperty("productOfferingIncomingUpdates"))
    );
    o.programDataVersions = (options.programDataVersions ?? []).map((i) =>
      maybeNew("ReadyPlanProgramDataVersion", i, cache, options.hasOwnProperty("programDataVersions"))
    );
    o.removedProgramDataVersions = (options.removedProgramDataVersions ?? []).map((i) =>
      maybeNew("ReadyPlanProgramDataVersion", i, cache, options.hasOwnProperty("removedProgramDataVersions"))
    );
    o.assetVersions = (options.assetVersions ?? []).map((i) =>
      maybeNew("ReadyPlanAssetVersion", i, cache, options.hasOwnProperty("assetVersions"))
    );
    o.designPackageSourceVersions = (options.designPackageSourceVersions ?? []).map((i) =>
      maybeNew("DesignPackageSourceVersion", i, cache, options.hasOwnProperty("designPackageSourceVersions"))
    );
    o.tliVersionsCount = options.tliVersionsCount ?? 0;
    o.tlivChangeSummary = (options.tlivChangeSummary ?? []).map((i) =>
      maybeNew("TlivChangeSummary", i, cache, options.hasOwnProperty("tlivChangeSummary"))
    );
    o.productTlivChangeSummary = (options.productTlivChangeSummary ?? []).map((i) =>
      maybeNew("TlivChangeSummary", i, cache, options.hasOwnProperty("productTlivChangeSummary"))
    );
    o.rplVersions = (options.rplVersions ?? []).map((i) =>
      maybeNew("ReadyPlanLocationVersion", i, cache, options.hasOwnProperty("rplVersions"))
    );
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.canPublish = maybeNew("PotentialOperation2", options.canPublish, cache, options.hasOwnProperty("canPublish"));
    o.canPromote = maybeNew("PotentialOperation2", options.canPromote, cache, options.hasOwnProperty("canPromote"));
    o.acceptedDesignPackageUpdates = (options.acceptedDesignPackageUpdates ?? []).map((i) =>
      maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("acceptedDesignPackageUpdates"))
    );
    o.outgoingDesignPackageUpdates = (options.outgoingDesignPackageUpdates ?? []).map((i) =>
      maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("outgoingDesignPackageUpdates"))
    );
    o.incomingSlotsFulfilledByPublish = (options.incomingSlotsFulfilledByPublish ?? []).map((i) =>
      maybeNew("PlanPackageIncomingSlot", i, cache, options.hasOwnProperty("incomingSlotsFulfilledByPublish"))
    );
    o.publishedAt = options.publishedAt ?? null;
    o.finalReadyPlanRequiredOptionVersions = (options.finalReadyPlanRequiredOptionVersions ?? []).map((i) =>
      maybeNew(
        "ReadyPlanRequiredOptionVersion",
        i,
        cache,
        options.hasOwnProperty("finalReadyPlanRequiredOptionVersions"),
      )
    );
    o.requiredOptionVersions = (options.requiredOptionVersions ?? []).map((i) =>
      maybeNew("ReadyPlanRequiredOptionVersion", i, cache, options.hasOwnProperty("requiredOptionVersions"))
    );
    o.designNoteVersions = (options.designNoteVersions ?? []).map((i) =>
      maybeNew("ReadyPlanDesignNoteVersion", i, cache, options.hasOwnProperty("designNoteVersions"))
    );
    o.designPackageSources = (options.designPackageSources ?? []).map((i) =>
      maybeNew("DesignPackageSource", i, cache, options.hasOwnProperty("designPackageSources"))
    );
    o.promotedAt = options.promotedAt ?? null;
    o.promotedBy = maybeNewOrNull("User", options.promotedBy, cache);
    o.createdByPromotion = options.createdByPromotion ?? false;
    return o as FactoryResult<ReadyPlanAggregateVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanAggregateVersion"] = newReadyPlanAggregateVersion;

export interface TlivChangeSummaryOptions {
  __typename?: "TlivChangeSummary";
  changeType?: TlivChangeSummary["changeType"];
  total?: TlivChangeSummary["total"];
  byLocation?: Array<FactoryInput<TlivLocationCount, TlivLocationCountOptions>>;
}

export function newTlivChangeSummary(
  options?: TlivChangeSummaryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TlivChangeSummary>;
export function newTlivChangeSummary(
  options: TlivChangeSummaryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TlivChangeSummary> {
  const o = (options.__typename ? options : cache["TlivChangeSummary"] = {}) as TlivChangeSummary;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TlivChangeSummary";
    o.changeType = options.changeType ?? "changeType";
    o.total = options.total ?? 0;
    o.byLocation = (options.byLocation ?? []).map((i) =>
      maybeNew("TlivLocationCount", i, cache, options.hasOwnProperty("byLocation"))
    );
    return o as FactoryResult<TlivChangeSummary>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TlivChangeSummary"] = newTlivChangeSummary;

export interface TlivLocationCountOptions {
  __typename?: "TlivLocationCount";
  location?: FactoryInput<Location, LocationOptions>;
  count?: TlivLocationCount["count"];
}

export function newTlivLocationCount(
  options?: TlivLocationCountOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TlivLocationCount>;
export function newTlivLocationCount(
  options: TlivLocationCountOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TlivLocationCount> {
  const o = (options.__typename ? options : cache["TlivLocationCount"] = {}) as TlivLocationCount;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TlivLocationCount";
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.count = options.count ?? 0;
    return o as FactoryResult<TlivLocationCount>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TlivLocationCount"] = newTlivLocationCount;

export interface SaveReadyPlanAggregateVersionResultOptions {
  __typename?: "SaveReadyPlanAggregateVersionResult";
  readyPlanAggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
}

export function newSaveReadyPlanAggregateVersionResult(
  options?: SaveReadyPlanAggregateVersionResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlanAggregateVersionResult>;
export function newSaveReadyPlanAggregateVersionResult(
  options: SaveReadyPlanAggregateVersionResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlanAggregateVersionResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveReadyPlanAggregateVersionResult"] = {}) as SaveReadyPlanAggregateVersionResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlanAggregateVersionResult";
    o.readyPlanAggregateVersion = maybeNew(
      "ReadyPlanAggregateVersion",
      options.readyPlanAggregateVersion,
      cache,
      options.hasOwnProperty("readyPlanAggregateVersion"),
    );
    return o as FactoryResult<SaveReadyPlanAggregateVersionResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlanAggregateVersionResult"] = newSaveReadyPlanAggregateVersionResult;

export interface DeleteReadyPlanAggregateVersionResultOptions {
  __typename?: "DeleteReadyPlanAggregateVersionResult";
  latestReadyPlanAggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
}

export function newDeleteReadyPlanAggregateVersionResult(
  options?: DeleteReadyPlanAggregateVersionResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteReadyPlanAggregateVersionResult>;
export function newDeleteReadyPlanAggregateVersionResult(
  options: DeleteReadyPlanAggregateVersionResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteReadyPlanAggregateVersionResult> {
  const o =
    (options.__typename
      ? options
      : cache["DeleteReadyPlanAggregateVersionResult"] = {}) as DeleteReadyPlanAggregateVersionResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteReadyPlanAggregateVersionResult";
    o.latestReadyPlanAggregateVersion = maybeNewOrNull(
      "ReadyPlanAggregateVersion",
      options.latestReadyPlanAggregateVersion,
      cache,
    );
    return o as FactoryResult<DeleteReadyPlanAggregateVersionResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteReadyPlanAggregateVersionResult"] = newDeleteReadyPlanAggregateVersionResult;

export interface ReadyPlanAggregateVersionsPageResultOptions {
  __typename?: "ReadyPlanAggregateVersionsPageResult";
  entities?: Array<FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newReadyPlanAggregateVersionsPageResult(
  options?: ReadyPlanAggregateVersionsPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanAggregateVersionsPageResult>;
export function newReadyPlanAggregateVersionsPageResult(
  options: ReadyPlanAggregateVersionsPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanAggregateVersionsPageResult> {
  const o =
    (options.__typename
      ? options
      : cache["ReadyPlanAggregateVersionsPageResult"] = {}) as ReadyPlanAggregateVersionsPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanAggregateVersionsPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<ReadyPlanAggregateVersionsPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanAggregateVersionsPageResult"] = newReadyPlanAggregateVersionsPageResult;

export interface ReadyPlanAssetOptions {
  __typename?: "ReadyPlanAsset";
  id?: ReadyPlanAsset["id"];
  createdAt?: ReadyPlanAsset["createdAt"];
  updatedAt?: ReadyPlanAsset["updatedAt"];
  type?: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType;
  asset?: FactoryInput<Asset, AssetOptions>;
  parent?:
    | ReadyPlanAssetParent
    | FactoryResult<ReadyPlanAssetParent>
    | ReadyPlanOptions
    | RequireTypename<ReadyPlanLocationOptions>
    | RequireTypename<ReadyPlanOptionOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<DesignPackageOptions>
    | RequireTypename<ProductOfferingOptions>
    | null;
  isCoverPhoto?: ReadyPlanAsset["isCoverPhoto"];
  versions?: Array<FactoryInput<ReadyPlanAssetVersion, ReadyPlanAssetVersionOptions>>;
  active?: ReadyPlanAsset["active"];
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
}

export function newReadyPlanAsset(
  options?: ReadyPlanAssetOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanAsset>;
export function newReadyPlanAsset(
  options: ReadyPlanAssetOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanAsset> {
  const o = (options.__typename ? options : cache["ReadyPlanAsset"] = {}) as ReadyPlanAsset;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanAsset";
    o.id = options.id ?? nextFactoryId("ReadyPlanAsset");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.type = enumOrDetailOfReadyPlanAssetType(options.type);
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "ReadyPlan", options.parent, cache);
    o.isCoverPhoto = options.isCoverPhoto ?? false;
    o.versions = (options.versions ?? []).map((i) =>
      maybeNew("ReadyPlanAssetVersion", i, cache, options.hasOwnProperty("versions"))
    );
    o.active = options.active ?? false;
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    return o as FactoryResult<ReadyPlanAsset>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanAsset"] = newReadyPlanAsset;

export interface ReadyPlanAssetVersionOptions {
  __typename?: "ReadyPlanAssetVersion";
  id?: ReadyPlanAssetVersion["id"];
  active?: ReadyPlanAssetVersion["active"];
  createdAt?: ReadyPlanAssetVersion["createdAt"];
  updatedAt?: ReadyPlanAssetVersion["updatedAt"];
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  identity?: FactoryInput<ReadyPlanAsset, ReadyPlanAssetOptions>;
  asset?: FactoryInput<Asset, AssetOptions>;
}

export function newReadyPlanAssetVersion(
  options?: ReadyPlanAssetVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanAssetVersion>;
export function newReadyPlanAssetVersion(
  options: ReadyPlanAssetVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanAssetVersion> {
  const o = (options.__typename ? options : cache["ReadyPlanAssetVersion"] = {}) as ReadyPlanAssetVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanAssetVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanAssetVersion");
    o.active = options.active ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.identity = maybeNew("ReadyPlanAsset", options.identity, cache, options.hasOwnProperty("identity"));
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    return o as FactoryResult<ReadyPlanAssetVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanAssetVersion"] = newReadyPlanAssetVersion;

export interface ReadyPlanDesignNoteOptions {
  __typename?: "ReadyPlanDesignNote";
  id?: ReadyPlanDesignNote["id"];
  active?: ReadyPlanDesignNote["active"];
  content?: ReadyPlanDesignNote["content"];
  createdAt?: ReadyPlanDesignNote["createdAt"];
  updatedAt?: ReadyPlanDesignNote["updatedAt"];
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
  targetGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  targetCombinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
}

export function newReadyPlanDesignNote(
  options?: ReadyPlanDesignNoteOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanDesignNote>;
export function newReadyPlanDesignNote(
  options: ReadyPlanDesignNoteOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanDesignNote> {
  const o = (options.__typename ? options : cache["ReadyPlanDesignNote"] = {}) as ReadyPlanDesignNote;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanDesignNote";
    o.id = options.id ?? nextFactoryId("ReadyPlanDesignNote");
    o.active = options.active ?? false;
    o.content = options.content ?? "content";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.takeoffLineItem = maybeNew(
      "TakeoffLineItem",
      options.takeoffLineItem,
      cache,
      options.hasOwnProperty("takeoffLineItem"),
    );
    o.targetGroups = (options.targetGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
    );
    o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
    );
    return o as FactoryResult<ReadyPlanDesignNote>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanDesignNote"] = newReadyPlanDesignNote;

export interface SaveReadyPlanDesignNoteResultOptions {
  __typename?: "SaveReadyPlanDesignNoteResult";
  readyPlanDesignNote?: FactoryInput<ReadyPlanDesignNote, ReadyPlanDesignNoteOptions>;
}

export function newSaveReadyPlanDesignNoteResult(
  options?: SaveReadyPlanDesignNoteResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlanDesignNoteResult>;
export function newSaveReadyPlanDesignNoteResult(
  options: SaveReadyPlanDesignNoteResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlanDesignNoteResult> {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanDesignNoteResult"] = {}) as SaveReadyPlanDesignNoteResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlanDesignNoteResult";
    o.readyPlanDesignNote = maybeNew(
      "ReadyPlanDesignNote",
      options.readyPlanDesignNote,
      cache,
      options.hasOwnProperty("readyPlanDesignNote"),
    );
    return o as FactoryResult<SaveReadyPlanDesignNoteResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlanDesignNoteResult"] = newSaveReadyPlanDesignNoteResult;

export interface ReadyPlanDesignNoteVersionOptions {
  __typename?: "ReadyPlanDesignNoteVersion";
  id?: ReadyPlanDesignNoteVersion["id"];
  active?: ReadyPlanDesignNoteVersion["active"];
  content?: ReadyPlanDesignNoteVersion["content"];
  createdAt?: ReadyPlanDesignNoteVersion["createdAt"];
  updatedAt?: ReadyPlanDesignNoteVersion["updatedAt"];
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  identity?: FactoryInput<ReadyPlanDesignNote, ReadyPlanDesignNoteOptions>;
  targetGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  targetCombinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
}

export function newReadyPlanDesignNoteVersion(
  options?: ReadyPlanDesignNoteVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanDesignNoteVersion>;
export function newReadyPlanDesignNoteVersion(
  options: ReadyPlanDesignNoteVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanDesignNoteVersion> {
  const o = (options.__typename ? options : cache["ReadyPlanDesignNoteVersion"] = {}) as ReadyPlanDesignNoteVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanDesignNoteVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanDesignNoteVersion");
    o.active = options.active ?? false;
    o.content = options.content ?? "content";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.identity = maybeNew("ReadyPlanDesignNote", options.identity, cache, options.hasOwnProperty("identity"));
    o.targetGroups = (options.targetGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
    );
    o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
    );
    return o as FactoryResult<ReadyPlanDesignNoteVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanDesignNoteVersion"] = newReadyPlanDesignNoteVersion;

export interface ReadyPlanDesignPackageOptions {
  __typename?: "ReadyPlanDesignPackage";
  id?: ReadyPlanDesignPackage["id"];
  active?: ReadyPlanDesignPackage["active"];
  name?: ReadyPlanDesignPackage["name"];
  createdAt?: ReadyPlanDesignPackage["createdAt"];
  updatedAt?: ReadyPlanDesignPackage["updatedAt"];
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionDefaultsIfChildren?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionVersionDefaultsIfChildren?: Array<FactoryInput<ReadyPlanOptionVersion, ReadyPlanOptionVersionOptions>>;
}

export function newReadyPlanDesignPackage(
  options?: ReadyPlanDesignPackageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanDesignPackage>;
export function newReadyPlanDesignPackage(
  options: ReadyPlanDesignPackageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanDesignPackage> {
  const o = (options.__typename ? options : cache["ReadyPlanDesignPackage"] = {}) as ReadyPlanDesignPackage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanDesignPackage";
    o.id = options.id ?? nextFactoryId("ReadyPlanDesignPackage");
    o.active = options.active ?? false;
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.optionDefaultsIfChildren = (options.optionDefaultsIfChildren ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultsIfChildren"))
    );
    o.optionVersionDefaultsIfChildren = (options.optionVersionDefaultsIfChildren ?? []).map((i) =>
      maybeNew("ReadyPlanOptionVersion", i, cache, options.hasOwnProperty("optionVersionDefaultsIfChildren"))
    );
    return o as FactoryResult<ReadyPlanDesignPackage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanDesignPackage"] = newReadyPlanDesignPackage;

export interface ReadyPlanDesignPackageVersionOptions {
  __typename?: "ReadyPlanDesignPackageVersion";
  id?: ReadyPlanDesignPackageVersion["id"];
  active?: ReadyPlanDesignPackageVersion["active"];
  createdAt?: ReadyPlanDesignPackageVersion["createdAt"];
  updatedAt?: ReadyPlanDesignPackageVersion["updatedAt"];
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  identity?: FactoryInput<ReadyPlanDesignPackage, ReadyPlanDesignPackageOptions>;
}

export function newReadyPlanDesignPackageVersion(
  options?: ReadyPlanDesignPackageVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanDesignPackageVersion>;
export function newReadyPlanDesignPackageVersion(
  options: ReadyPlanDesignPackageVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanDesignPackageVersion> {
  const o =
    (options.__typename ? options : cache["ReadyPlanDesignPackageVersion"] = {}) as ReadyPlanDesignPackageVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanDesignPackageVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanDesignPackageVersion");
    o.active = options.active ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.identity = maybeNew("ReadyPlanDesignPackage", options.identity, cache, options.hasOwnProperty("identity"));
    return o as FactoryResult<ReadyPlanDesignPackageVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanDesignPackageVersion"] = newReadyPlanDesignPackageVersion;

export interface ReadyPlanDocumentVersionOptions {
  __typename?: "ReadyPlanDocumentVersion";
  id?: ReadyPlanDocumentVersion["id"];
  asset?: FactoryInput<Asset, AssetOptions>;
  identity?: FactoryInput<Document, DocumentOptions>;
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  active?: ReadyPlanDocumentVersion["active"];
  name?: ReadyPlanDocumentVersion["name"];
  uploaded?: ReadyPlanDocumentVersion["uploaded"];
  sizeInBytes?: ReadyPlanDocumentVersion["sizeInBytes"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  category?: DocumentCategoryDetailOptions | DocumentCategory;
}

export function newReadyPlanDocumentVersion(
  options?: ReadyPlanDocumentVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanDocumentVersion>;
export function newReadyPlanDocumentVersion(
  options: ReadyPlanDocumentVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanDocumentVersion> {
  const o = (options.__typename ? options : cache["ReadyPlanDocumentVersion"] = {}) as ReadyPlanDocumentVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanDocumentVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanDocumentVersion");
    o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
    o.identity = maybeNew("Document", options.identity, cache, options.hasOwnProperty("identity"));
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.active = options.active ?? false;
    o.name = options.name ?? "name";
    o.uploaded = options.uploaded ?? false;
    o.sizeInBytes = options.sizeInBytes ?? 0;
    o.documentType = enumOrDetailOfDocumentType(options.documentType);
    o.category = enumOrDetailOfDocumentCategory(options.category);
    return o as FactoryResult<ReadyPlanDocumentVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanDocumentVersion"] = newReadyPlanDocumentVersion;

export interface ReadyPlanLocationOptions {
  __typename?: "ReadyPlanLocation";
  id?: ReadyPlanLocation["id"];
  createdAt?: ReadyPlanLocation["createdAt"];
  updatedAt?: ReadyPlanLocation["updatedAt"];
  location?: FactoryInput<Location, LocationOptions>;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  roomNumber?: ReadyPlanLocation["roomNumber"];
  fullRoomNumber?: ReadyPlanLocation["fullRoomNumber"];
  level?: FactoryInput<Location, LocationOptions> | null;
  roomType?: FactoryInput<RoomType, RoomTypeOptions> | null;
  versions?: Array<FactoryInput<ReadyPlanLocationVersion, ReadyPlanLocationVersionOptions>>;
  active?: ReadyPlanLocation["active"];
  relatedTakeoffLineItemsCount?: ReadyPlanLocation["relatedTakeoffLineItemsCount"];
  readyPlanAssets?: Array<FactoryInput<ReadyPlanAsset, ReadyPlanAssetOptions>>;
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  designPackageLocations?: Array<FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>>;
  planLocations?: Array<FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>>;
  name?: ReadyPlanLocation["name"];
  isInsideMapsRoom?: ReadyPlanLocation["isInsideMapsRoom"];
  insideMapsRoomOrder?: ReadyPlanLocation["insideMapsRoomOrder"];
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  marketingName?: ReadyPlanLocation["marketingName"];
}

export function newReadyPlanLocation(
  options?: ReadyPlanLocationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanLocation>;
export function newReadyPlanLocation(
  options: ReadyPlanLocationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanLocation> {
  const o = (options.__typename ? options : cache["ReadyPlanLocation"] = {}) as ReadyPlanLocation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanLocation";
    o.id = options.id ?? nextFactoryId("ReadyPlanLocation");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.roomNumber = options.roomNumber ?? null;
    o.fullRoomNumber = options.fullRoomNumber ?? null;
    o.level = maybeNewOrNull("Location", options.level, cache);
    o.roomType = maybeNewOrNull("RoomType", options.roomType, cache);
    o.versions = (options.versions ?? []).map((i) =>
      maybeNew("ReadyPlanLocationVersion", i, cache, options.hasOwnProperty("versions"))
    );
    o.active = options.active ?? false;
    o.relatedTakeoffLineItemsCount = options.relatedTakeoffLineItemsCount ?? 0;
    o.readyPlanAssets = (options.readyPlanAssets ?? []).map((i) =>
      maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("readyPlanAssets"))
    );
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    o.designPackageLocations = (options.designPackageLocations ?? []).map((i) =>
      maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("designPackageLocations"))
    );
    o.planLocations = (options.planLocations ?? []).map((i) =>
      maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("planLocations"))
    );
    o.name = options.name ?? "name";
    o.isInsideMapsRoom = options.isInsideMapsRoom ?? null;
    o.insideMapsRoomOrder = options.insideMapsRoomOrder ?? null;
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.marketingName = options.marketingName ?? "marketingName";
    return o as FactoryResult<ReadyPlanLocation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanLocation"] = newReadyPlanLocation;

export interface SaveReadyPlanLocationBulkResultOptions {
  __typename?: "SaveReadyPlanLocationBulkResult";
  readyPlanLocations?: Array<FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>>;
  readyPlans?: Array<ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions>;
  affectedTlis?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
}

export function newSaveReadyPlanLocationBulkResult(
  options?: SaveReadyPlanLocationBulkResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlanLocationBulkResult>;
export function newSaveReadyPlanLocationBulkResult(
  options: SaveReadyPlanLocationBulkResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlanLocationBulkResult> {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanLocationBulkResult"] = {}) as SaveReadyPlanLocationBulkResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlanLocationBulkResult";
    o.readyPlanLocations = (options.readyPlanLocations ?? []).map((i) =>
      maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("readyPlanLocations"))
    );
    o.readyPlans = (options.readyPlans ?? []).map((i) =>
      maybeNew("ReadyPlanLike", i, cache, options.hasOwnProperty("readyPlans"))
    );
    o.affectedTlis = (options.affectedTlis ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("affectedTlis"))
    );
    return o as FactoryResult<SaveReadyPlanLocationBulkResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlanLocationBulkResult"] = newSaveReadyPlanLocationBulkResult;

export interface SaveDesignPackageLocationPlanMappingsResultOptions {
  __typename?: "SaveDesignPackageLocationPlanMappingsResult";
  readyPlanLocations?: Array<FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>>;
  affectedPlaceholders?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
}

export function newSaveDesignPackageLocationPlanMappingsResult(
  options?: SaveDesignPackageLocationPlanMappingsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveDesignPackageLocationPlanMappingsResult>;
export function newSaveDesignPackageLocationPlanMappingsResult(
  options: SaveDesignPackageLocationPlanMappingsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveDesignPackageLocationPlanMappingsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveDesignPackageLocationPlanMappingsResult"] = {}) as SaveDesignPackageLocationPlanMappingsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveDesignPackageLocationPlanMappingsResult";
    o.readyPlanLocations = (options.readyPlanLocations ?? []).map((i) =>
      maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("readyPlanLocations"))
    );
    o.affectedPlaceholders = (options.affectedPlaceholders ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("affectedPlaceholders"))
    );
    return o as FactoryResult<SaveDesignPackageLocationPlanMappingsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveDesignPackageLocationPlanMappingsResult"] = newSaveDesignPackageLocationPlanMappingsResult;

export interface CreateDesignPackageAlternateLocationResultOptions {
  __typename?: "CreateDesignPackageAlternateLocationResult";
  readyPlanLocation?: FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>;
}

export function newCreateDesignPackageAlternateLocationResult(
  options?: CreateDesignPackageAlternateLocationResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CreateDesignPackageAlternateLocationResult>;
export function newCreateDesignPackageAlternateLocationResult(
  options: CreateDesignPackageAlternateLocationResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CreateDesignPackageAlternateLocationResult> {
  const o =
    (options.__typename
      ? options
      : cache["CreateDesignPackageAlternateLocationResult"] = {}) as CreateDesignPackageAlternateLocationResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CreateDesignPackageAlternateLocationResult";
    o.readyPlanLocation = maybeNew(
      "ReadyPlanLocation",
      options.readyPlanLocation,
      cache,
      options.hasOwnProperty("readyPlanLocation"),
    );
    return o as FactoryResult<CreateDesignPackageAlternateLocationResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CreateDesignPackageAlternateLocationResult"] = newCreateDesignPackageAlternateLocationResult;

export interface ReadyPlanLocationVersionOptions {
  __typename?: "ReadyPlanLocationVersion";
  id?: ReadyPlanLocationVersion["id"];
  active?: ReadyPlanLocationVersion["active"];
  createdAt?: ReadyPlanLocationVersion["createdAt"];
  updatedAt?: ReadyPlanLocationVersion["updatedAt"];
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  identity?: FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>;
  roomNumber?: ReadyPlanLocationVersion["roomNumber"];
  location?: FactoryInput<Location, LocationOptions>;
  changeType?: ReadyPlanLocationVersion["changeType"];
  previous?: FactoryInput<ReadyPlanLocationVersion, ReadyPlanLocationVersionOptions> | null;
  fullRoomNumber?: ReadyPlanLocationVersion["fullRoomNumber"];
  planLocations?: Array<FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions>>;
}

export function newReadyPlanLocationVersion(
  options?: ReadyPlanLocationVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanLocationVersion>;
export function newReadyPlanLocationVersion(
  options: ReadyPlanLocationVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanLocationVersion> {
  const o = (options.__typename ? options : cache["ReadyPlanLocationVersion"] = {}) as ReadyPlanLocationVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanLocationVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanLocationVersion");
    o.active = options.active ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.identity = maybeNew("ReadyPlanLocation", options.identity, cache, options.hasOwnProperty("identity"));
    o.roomNumber = options.roomNumber ?? null;
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.changeType = options.changeType ?? "changeType";
    o.previous = maybeNewOrNull("ReadyPlanLocationVersion", options.previous, cache);
    o.fullRoomNumber = options.fullRoomNumber ?? null;
    o.planLocations = (options.planLocations ?? []).map((i) =>
      maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("planLocations"))
    );
    return o as FactoryResult<ReadyPlanLocationVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanLocationVersion"] = newReadyPlanLocationVersion;

export interface ReadyPlanOptionOptions {
  __typename?: "ReadyPlanOption";
  id?: ReadyPlanOption["id"];
  code?: ReadyPlanOption["code"];
  displayCode?: ReadyPlanOption["displayCode"];
  name?: ReadyPlanOption["name"];
  displayName?: ReadyPlanOption["displayName"];
  homeownerChoice?: ReadyPlanOption["homeownerChoice"];
  createdAt?: ReadyPlanOption["createdAt"];
  updatedAt?: ReadyPlanOption["updatedAt"];
  isChildOption?: ReadyPlanOption["isChildOption"];
  parentOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions> | null;
  isParentOption?: ReadyPlanOption["isParentOption"];
  childOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  globalOption?: FactoryInput<GlobalOption, GlobalOptionOptions>;
  type?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>;
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
  readyPlanLocation?: FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions> | null;
  location?: FactoryInput<Location, LocationOptions> | null;
  description?: ReadyPlanOption["description"];
  active?: ReadyPlanOption["active"];
  shortName?: ReadyPlanOption["shortName"];
  maybeShortName?: ReadyPlanOption["maybeShortName"];
  programData?: FactoryInput<ProgramData, ProgramDataOptions>;
  optionGroup?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>;
  userEvents?: Array<FactoryInput<UserEvent, UserEventOptions>>;
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  programDataModifiedBy?: Array<
    FactoryInput<ReadyPlanOptionProgramDataModification, ReadyPlanOptionProgramDataModificationOptions>
  >;
  modifiesProgramDataFor?: Array<
    FactoryInput<ReadyPlanOptionProgramDataModification, ReadyPlanOptionProgramDataModificationOptions>
  >;
  optionPrereqChildren?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionPrerequisites?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionConflictChildren?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionConflicts?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionDefaultChildren?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionDefaultsIf?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  optionRequiredIf?: Array<FactoryInput<ReadyPlanRequiredOption, ReadyPlanRequiredOptionOptions>>;
  personalizationTargetCombinations?: Array<
    FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>
  >;
  order?: ReadyPlanOption["order"];
  programDatas?: Array<FactoryInput<ReadyPlanProgramData, ReadyPlanProgramDataOptions>>;
  assets?: Array<FactoryInput<ReadyPlanAsset, ReadyPlanAssetOptions>>;
  bidOutPercentage?: ReadyPlanOption["bidOutPercentage"];
  latestVersion?: FactoryInput<ReadyPlanOptionVersion, ReadyPlanOptionVersionOptions> | null;
  draftVersion?: FactoryInput<ReadyPlanOptionVersion, ReadyPlanOptionVersionOptions> | null;
  publishToUnderwriting?: ReadyPlanOption["publishToUnderwriting"];
  optionImages?: Array<FactoryInput<Asset, AssetOptions>>;
  optionImage?: FactoryInput<Asset, AssetOptions> | null;
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  materialVariants?: Array<FactoryInput<MaterialVariant, MaterialVariantOptions>>;
  preCutoffDesiredMarginInBasisPoints?: ReadyPlanOption["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: ReadyPlanOption["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: ReadyPlanOption["selectionFeeInCents"];
  minimumPriceInCents?: ReadyPlanOption["minimumPriceInCents"];
  showInCheckout?: ReadyPlanOption["showInCheckout"];
  missingInsideMapsRendering?: ReadyPlanOption["missingInsideMapsRendering"];
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  packageOptionMaterial?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  isNewFromUpstream?: ReadyPlanOption["isNewFromUpstream"];
  isUpstreamInactive?: ReadyPlanOption["isUpstreamInactive"];
  checkoutOrder?: ReadyPlanOption["checkoutOrder"];
}

export function newReadyPlanOption(
  options?: ReadyPlanOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOption>;
export function newReadyPlanOption(
  options: ReadyPlanOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOption> {
  const o = (options.__typename ? options : cache["ReadyPlanOption"] = {}) as ReadyPlanOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOption";
    o.id = options.id ?? nextFactoryId("ReadyPlanOption");
    o.code = options.code ?? "code";
    o.displayCode = options.displayCode ?? "displayCode";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.homeownerChoice = options.homeownerChoice ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.isChildOption = options.isChildOption ?? false;
    o.parentOption = maybeNewOrNull("ReadyPlanOption", options.parentOption, cache);
    o.isParentOption = options.isParentOption ?? false;
    o.childOptions = (options.childOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("childOptions"))
    );
    o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
    o.type = maybeNew("GlobalOptionType", options.type, cache, options.hasOwnProperty("type"));
    o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.readyPlanLocation = maybeNewOrNull("ReadyPlanLocation", options.readyPlanLocation, cache);
    o.location = maybeNewOrNull("Location", options.location, cache);
    o.description = options.description ?? null;
    o.active = options.active ?? false;
    o.shortName = options.shortName ?? null;
    o.maybeShortName = options.maybeShortName ?? "maybeShortName";
    o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
    o.optionGroup = maybeNew("ReadyPlanOptionGroup", options.optionGroup, cache, options.hasOwnProperty("optionGroup"));
    o.userEvents = (options.userEvents ?? []).map((i) =>
      maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
    );
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.programDataModifiedBy = (options.programDataModifiedBy ?? []).map((i) =>
      maybeNew("ReadyPlanOptionProgramDataModification", i, cache, options.hasOwnProperty("programDataModifiedBy"))
    );
    o.modifiesProgramDataFor = (options.modifiesProgramDataFor ?? []).map((i) =>
      maybeNew("ReadyPlanOptionProgramDataModification", i, cache, options.hasOwnProperty("modifiesProgramDataFor"))
    );
    o.optionPrereqChildren = (options.optionPrereqChildren ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionPrereqChildren"))
    );
    o.optionPrerequisites = (options.optionPrerequisites ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionPrerequisites"))
    );
    o.optionConflictChildren = (options.optionConflictChildren ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionConflictChildren"))
    );
    o.optionConflicts = (options.optionConflicts ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionConflicts"))
    );
    o.optionDefaultChildren = (options.optionDefaultChildren ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultChildren"))
    );
    o.optionDefaultsIf = (options.optionDefaultsIf ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultsIf"))
    );
    o.optionRequiredIf = (options.optionRequiredIf ?? []).map((i) =>
      maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("optionRequiredIf"))
    );
    o.personalizationTargetCombinations = (options.personalizationTargetCombinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("personalizationTargetCombinations"))
    );
    o.order = options.order ?? 0;
    o.programDatas = (options.programDatas ?? []).map((i) =>
      maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
    );
    o.assets = (options.assets ?? []).map((i) =>
      maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets"))
    );
    o.bidOutPercentage = options.bidOutPercentage ?? 0;
    o.latestVersion = maybeNewOrNull("ReadyPlanOptionVersion", options.latestVersion, cache);
    o.draftVersion = maybeNewOrNull("ReadyPlanOptionVersion", options.draftVersion, cache);
    o.publishToUnderwriting = options.publishToUnderwriting ?? false;
    o.optionImages = (options.optionImages ?? []).map((i) =>
      maybeNew("Asset", i, cache, options.hasOwnProperty("optionImages"))
    );
    o.optionImage = maybeNewOrNull("Asset", options.optionImage, cache);
    o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
    o.materialVariants = (options.materialVariants ?? []).map((i) =>
      maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
    );
    o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
    o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
    o.selectionFeeInCents = options.selectionFeeInCents ?? null;
    o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
    o.showInCheckout = options.showInCheckout ?? false;
    o.missingInsideMapsRendering = options.missingInsideMapsRendering ?? false;
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.packageOptionMaterial = maybeNewOrNull("MaterialVariant", options.packageOptionMaterial, cache);
    o.isNewFromUpstream = options.isNewFromUpstream ?? false;
    o.isUpstreamInactive = options.isUpstreamInactive ?? false;
    o.checkoutOrder = options.checkoutOrder ?? null;
    return o as FactoryResult<ReadyPlanOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOption"] = newReadyPlanOption;

export interface SaveReadyPlanOptionsResultOptions {
  __typename?: "SaveReadyPlanOptionsResult";
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
}

export function newSaveReadyPlanOptionsResult(
  options?: SaveReadyPlanOptionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlanOptionsResult>;
export function newSaveReadyPlanOptionsResult(
  options: SaveReadyPlanOptionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlanOptionsResult> {
  const o = (options.__typename ? options : cache["SaveReadyPlanOptionsResult"] = {}) as SaveReadyPlanOptionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlanOptionsResult";
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    return o as FactoryResult<SaveReadyPlanOptionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlanOptionsResult"] = newSaveReadyPlanOptionsResult;

export interface MergeReadyPlanOptionsResultOptions {
  __typename?: "MergeReadyPlanOptionsResult";
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
}

export function newMergeReadyPlanOptionsResult(
  options?: MergeReadyPlanOptionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MergeReadyPlanOptionsResult>;
export function newMergeReadyPlanOptionsResult(
  options: MergeReadyPlanOptionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MergeReadyPlanOptionsResult> {
  const o = (options.__typename ? options : cache["MergeReadyPlanOptionsResult"] = {}) as MergeReadyPlanOptionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MergeReadyPlanOptionsResult";
    o.readyPlanOption = maybeNew(
      "ReadyPlanOption",
      options.readyPlanOption,
      cache,
      options.hasOwnProperty("readyPlanOption"),
    );
    return o as FactoryResult<MergeReadyPlanOptionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MergeReadyPlanOptionsResult"] = newMergeReadyPlanOptionsResult;

export interface ReadyPlanOptionGroupOptions {
  __typename?: "ReadyPlanOptionGroup";
  id?: ReadyPlanOptionGroup["id"];
  name?: ReadyPlanOptionGroup["name"];
  marketingDescription?: ReadyPlanOptionGroup["marketingDescription"];
  required?: ReadyPlanOptionGroup["required"];
  order?: ReadyPlanOptionGroup["order"];
  active?: ReadyPlanOptionGroup["active"];
  createdAt?: ReadyPlanOptionGroup["createdAt"];
  updatedAt?: ReadyPlanOptionGroup["updatedAt"];
  group?: FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions>;
  location?: FactoryInput<Location, LocationOptions> | null;
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  isSingleOptionGroup?: ReadyPlanOptionGroup["isSingleOptionGroup"];
  isMultiOptionGroup?: ReadyPlanOptionGroup["isMultiOptionGroup"];
  forDesignUpgrade?: ReadyPlanOptionGroup["forDesignUpgrade"];
  forDesignPackage?: ReadyPlanOptionGroup["forDesignPackage"];
  forDesignInterior?: ReadyPlanOptionGroup["forDesignInterior"];
  forDesignExterior?: ReadyPlanOptionGroup["forDesignExterior"];
  forDesignPackages?: ReadyPlanOptionGroup["forDesignPackages"];
  isPlanPackage?: ReadyPlanOptionGroup["isPlanPackage"];
  personalizationType?:
    | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
    | ReadyPlanOptionGroupPersonalizationType
    | null;
  groupByFeature?: ReadyPlanOptionGroup["groupByFeature"];
  personalizationPlaceholders?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  personalizationMaterialVariants?: Array<FactoryInput<MaterialVariant, MaterialVariantOptions>>;
  groupPrerequisites?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  groupPrereqChildren?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  levels?: ReadyPlanOptionGroup["levels"];
  personalizationTargetGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  readyPlanLocation?: FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions> | null;
  displayPackageOptionsAsSingleProduct?: ReadyPlanOptionGroup["displayPackageOptionsAsSingleProduct"];
  checkoutOrder?: ReadyPlanOptionGroup["checkoutOrder"];
  step?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  substepNumber?: ReadyPlanOptionGroup["substepNumber"];
  hasDynamicProducts?: ReadyPlanOptionGroup["hasDynamicProducts"];
  overrideStep?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  overrideSubstepNumber?: ReadyPlanOptionGroup["overrideSubstepNumber"];
  requiredWhen?: Array<FactoryInput<ReadyPlanOptionGroupRequiredWhen, ReadyPlanOptionGroupRequiredWhenOptions>> | null;
}

export function newReadyPlanOptionGroup(
  options?: ReadyPlanOptionGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionGroup>;
export function newReadyPlanOptionGroup(
  options: ReadyPlanOptionGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOptionGroup> {
  const o = (options.__typename ? options : cache["ReadyPlanOptionGroup"] = {}) as ReadyPlanOptionGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOptionGroup";
    o.id = options.id ?? nextFactoryId("ReadyPlanOptionGroup");
    o.name = options.name ?? "name";
    o.marketingDescription = options.marketingDescription ?? null;
    o.required = options.required ?? false;
    o.order = options.order ?? 0;
    o.active = options.active ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.group = maybeNew("GlobalOptionGroup", options.group, cache, options.hasOwnProperty("group"));
    o.location = maybeNewOrNull("Location", options.location, cache);
    o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.isSingleOptionGroup = options.isSingleOptionGroup ?? false;
    o.isMultiOptionGroup = options.isMultiOptionGroup ?? false;
    o.forDesignUpgrade = options.forDesignUpgrade ?? false;
    o.forDesignPackage = options.forDesignPackage ?? false;
    o.forDesignInterior = options.forDesignInterior ?? false;
    o.forDesignExterior = options.forDesignExterior ?? false;
    o.forDesignPackages = options.forDesignPackages ?? false;
    o.isPlanPackage = options.isPlanPackage ?? false;
    o.personalizationType = enumOrDetailOrNullOfReadyPlanOptionGroupPersonalizationType(options.personalizationType);
    o.groupByFeature = options.groupByFeature ?? false;
    o.personalizationPlaceholders = (options.personalizationPlaceholders ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("personalizationPlaceholders"))
    );
    o.personalizationMaterialVariants = (options.personalizationMaterialVariants ?? []).map((i) =>
      maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("personalizationMaterialVariants"))
    );
    o.groupPrerequisites = (options.groupPrerequisites ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("groupPrerequisites"))
    );
    o.groupPrereqChildren = (options.groupPrereqChildren ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("groupPrereqChildren"))
    );
    o.levels = options.levels ?? null;
    o.personalizationTargetGroups = (options.personalizationTargetGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("personalizationTargetGroups"))
    );
    o.readyPlanLocation = maybeNewOrNull("ReadyPlanLocation", options.readyPlanLocation, cache);
    o.displayPackageOptionsAsSingleProduct = options.displayPackageOptionsAsSingleProduct ?? null;
    o.checkoutOrder = options.checkoutOrder ?? null;
    o.step = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.step);
    o.substepNumber = options.substepNumber ?? null;
    o.hasDynamicProducts = options.hasDynamicProducts ?? false;
    o.overrideStep = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.overrideStep);
    o.overrideSubstepNumber = options.overrideSubstepNumber ?? null;
    o.requiredWhen = (options.requiredWhen ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroupRequiredWhen", i, cache, options.hasOwnProperty("requiredWhen"))
    );
    return o as FactoryResult<ReadyPlanOptionGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOptionGroup"] = newReadyPlanOptionGroup;

export interface ReadyPlanOptionGroupRequiredWhenOptions {
  __typename?: "ReadyPlanOptionGroupRequiredWhen";
  all?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  none?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
}

export function newReadyPlanOptionGroupRequiredWhen(
  options?: ReadyPlanOptionGroupRequiredWhenOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionGroupRequiredWhen>;
export function newReadyPlanOptionGroupRequiredWhen(
  options: ReadyPlanOptionGroupRequiredWhenOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOptionGroupRequiredWhen> {
  const o =
    (options.__typename ? options : cache["ReadyPlanOptionGroupRequiredWhen"] = {}) as ReadyPlanOptionGroupRequiredWhen;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOptionGroupRequiredWhen";
    o.all = (options.all ?? []).map((i) => maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("all")));
    o.none = (options.none ?? []).map((i) => maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("none")));
    return o as FactoryResult<ReadyPlanOptionGroupRequiredWhen>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOptionGroupRequiredWhen"] = newReadyPlanOptionGroupRequiredWhen;

export interface SaveReadyPlanOptionGroupResultOptions {
  __typename?: "SaveReadyPlanOptionGroupResult";
  optionGroup?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>;
}

export function newSaveReadyPlanOptionGroupResult(
  options?: SaveReadyPlanOptionGroupResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlanOptionGroupResult>;
export function newSaveReadyPlanOptionGroupResult(
  options: SaveReadyPlanOptionGroupResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlanOptionGroupResult> {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanOptionGroupResult"] = {}) as SaveReadyPlanOptionGroupResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlanOptionGroupResult";
    o.optionGroup = maybeNew("ReadyPlanOptionGroup", options.optionGroup, cache, options.hasOwnProperty("optionGroup"));
    return o as FactoryResult<SaveReadyPlanOptionGroupResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlanOptionGroupResult"] = newSaveReadyPlanOptionGroupResult;

export interface SaveReadyPlanOptionGroupsResultOptions {
  __typename?: "SaveReadyPlanOptionGroupsResult";
  entities?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
}

export function newSaveReadyPlanOptionGroupsResult(
  options?: SaveReadyPlanOptionGroupsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlanOptionGroupsResult>;
export function newSaveReadyPlanOptionGroupsResult(
  options: SaveReadyPlanOptionGroupsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlanOptionGroupsResult> {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanOptionGroupsResult"] = {}) as SaveReadyPlanOptionGroupsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlanOptionGroupsResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("entities"))
    );
    return o as FactoryResult<SaveReadyPlanOptionGroupsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlanOptionGroupsResult"] = newSaveReadyPlanOptionGroupsResult;

export interface ReadyPlanOptionGroupVersionOptions {
  __typename?: "ReadyPlanOptionGroupVersion";
  id?: ReadyPlanOptionGroupVersion["id"];
  identity?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  required?: ReadyPlanOptionGroupVersion["required"];
  order?: ReadyPlanOptionGroupVersion["order"];
  active?: ReadyPlanOptionGroupVersion["active"];
  name?: ReadyPlanOptionGroupVersion["name"];
  marketingDescription?: ReadyPlanOptionGroupVersion["marketingDescription"];
  levels?: ReadyPlanOptionGroupVersion["levels"];
  personalizationTargetGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  location?: FactoryInput<Location, LocationOptions> | null;
  readyPlanLocation?: FactoryInput<ReadyPlanLocation, ReadyPlanLocationOptions> | null;
  displayPackageOptionsAsSingleProduct?: ReadyPlanOptionGroupVersion["displayPackageOptionsAsSingleProduct"];
  substepNumber?: ReadyPlanOptionGroupVersion["substepNumber"];
  step?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  overrideStep?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  overrideSubstepNumber?: ReadyPlanOptionGroupVersion["overrideSubstepNumber"];
  checkoutOrder?: ReadyPlanOptionGroupVersion["checkoutOrder"];
  hasDynamicProducts?: ReadyPlanOptionGroupVersion["hasDynamicProducts"];
}

export function newReadyPlanOptionGroupVersion(
  options?: ReadyPlanOptionGroupVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionGroupVersion>;
export function newReadyPlanOptionGroupVersion(
  options: ReadyPlanOptionGroupVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOptionGroupVersion> {
  const o = (options.__typename ? options : cache["ReadyPlanOptionGroupVersion"] = {}) as ReadyPlanOptionGroupVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOptionGroupVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanOptionGroupVersion");
    o.identity = maybeNew("ReadyPlanOptionGroup", options.identity, cache, options.hasOwnProperty("identity"));
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.required = options.required ?? false;
    o.order = options.order ?? 0;
    o.active = options.active ?? false;
    o.name = options.name ?? "name";
    o.marketingDescription = options.marketingDescription ?? null;
    o.levels = options.levels ?? null;
    o.personalizationTargetGroups = (options.personalizationTargetGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("personalizationTargetGroups"))
    );
    o.location = maybeNewOrNull("Location", options.location, cache);
    o.readyPlanLocation = maybeNewOrNull("ReadyPlanLocation", options.readyPlanLocation, cache);
    o.displayPackageOptionsAsSingleProduct = options.displayPackageOptionsAsSingleProduct ?? null;
    o.substepNumber = options.substepNumber ?? null;
    o.step = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.step);
    o.overrideStep = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.overrideStep);
    o.overrideSubstepNumber = options.overrideSubstepNumber ?? null;
    o.checkoutOrder = options.checkoutOrder ?? null;
    o.hasDynamicProducts = options.hasDynamicProducts ?? false;
    return o as FactoryResult<ReadyPlanOptionGroupVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOptionGroupVersion"] = newReadyPlanOptionGroupVersion;

export interface ReadyPlanOptionProgramDataModificationOptions {
  __typename?: "ReadyPlanOptionProgramDataModification";
  id?: ReadyPlanOptionProgramDataModification["id"];
  createdAt?: ReadyPlanOptionProgramDataModification["createdAt"];
  updatedAt?: ReadyPlanOptionProgramDataModification["updatedAt"];
  programData?: FactoryInput<ProgramData, ProgramDataOptions>;
  modifiedOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  matchesOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  userEvents?: Array<FactoryInput<UserEvent, UserEventOptions>>;
  name?: ReadyPlanOptionProgramDataModification["name"];
}

export function newReadyPlanOptionProgramDataModification(
  options?: ReadyPlanOptionProgramDataModificationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionProgramDataModification>;
export function newReadyPlanOptionProgramDataModification(
  options: ReadyPlanOptionProgramDataModificationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOptionProgramDataModification> {
  const o =
    (options.__typename
      ? options
      : cache["ReadyPlanOptionProgramDataModification"] = {}) as ReadyPlanOptionProgramDataModification;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOptionProgramDataModification";
    o.id = options.id ?? nextFactoryId("ReadyPlanOptionProgramDataModification");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
    o.modifiedOption = maybeNew(
      "ReadyPlanOption",
      options.modifiedOption,
      cache,
      options.hasOwnProperty("modifiedOption"),
    );
    o.matchesOption = maybeNew(
      "ReadyPlanOption",
      options.matchesOption,
      cache,
      options.hasOwnProperty("matchesOption"),
    );
    o.userEvents = (options.userEvents ?? []).map((i) =>
      maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
    );
    o.name = options.name ?? "name";
    return o as FactoryResult<ReadyPlanOptionProgramDataModification>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOptionProgramDataModification"] = newReadyPlanOptionProgramDataModification;

export interface SaveReadyPlanOptionProgramDataModificationsResultOptions {
  __typename?: "SaveReadyPlanOptionProgramDataModificationsResult";
  entities?: Array<FactoryInput<ReadyPlanOptionProgramDataModification, ReadyPlanOptionProgramDataModificationOptions>>;
}

export function newSaveReadyPlanOptionProgramDataModificationsResult(
  options?: SaveReadyPlanOptionProgramDataModificationsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlanOptionProgramDataModificationsResult>;
export function newSaveReadyPlanOptionProgramDataModificationsResult(
  options: SaveReadyPlanOptionProgramDataModificationsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlanOptionProgramDataModificationsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveReadyPlanOptionProgramDataModificationsResult"] =
        {}) as SaveReadyPlanOptionProgramDataModificationsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlanOptionProgramDataModificationsResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("ReadyPlanOptionProgramDataModification", i, cache, options.hasOwnProperty("entities"))
    );
    return o as FactoryResult<SaveReadyPlanOptionProgramDataModificationsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlanOptionProgramDataModificationsResult"] = newSaveReadyPlanOptionProgramDataModificationsResult;

export interface DeleteReadyPlanOptionProgramDataModificationsResultOptions {
  __typename?: "DeleteReadyPlanOptionProgramDataModificationsResult";
  id?: DeleteReadyPlanOptionProgramDataModificationsResult["id"];
  modifiedOptionId?: DeleteReadyPlanOptionProgramDataModificationsResult["modifiedOptionId"];
}

export function newDeleteReadyPlanOptionProgramDataModificationsResult(
  options?: DeleteReadyPlanOptionProgramDataModificationsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteReadyPlanOptionProgramDataModificationsResult>;
export function newDeleteReadyPlanOptionProgramDataModificationsResult(
  options: DeleteReadyPlanOptionProgramDataModificationsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteReadyPlanOptionProgramDataModificationsResult> {
  const o =
    (options.__typename
      ? options
      : cache["DeleteReadyPlanOptionProgramDataModificationsResult"] =
        {}) as DeleteReadyPlanOptionProgramDataModificationsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteReadyPlanOptionProgramDataModificationsResult";
    o.id = options.id ?? nextFactoryId("DeleteReadyPlanOptionProgramDataModificationsResult");
    o.modifiedOptionId = options.modifiedOptionId ?? "modifiedOptionId";
    return o as FactoryResult<DeleteReadyPlanOptionProgramDataModificationsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteReadyPlanOptionProgramDataModificationsResult"] =
  newDeleteReadyPlanOptionProgramDataModificationsResult;

export interface ReadyPlanOptionVersionOptions {
  __typename?: "ReadyPlanOptionVersion";
  id?: ReadyPlanOptionVersion["id"];
  identity?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  active?: ReadyPlanOptionVersion["active"];
  createdAt?: ReadyPlanOptionVersion["createdAt"];
  updatedAt?: ReadyPlanOptionVersion["updatedAt"];
  customName?: ReadyPlanOptionVersion["customName"];
  displayCode?: ReadyPlanOptionVersion["displayCode"];
  isNewFromUpstream?: ReadyPlanOptionVersion["isNewFromUpstream"];
  isUpstreamInactive?: ReadyPlanOptionVersion["isUpstreamInactive"];
  isOfferingInactive?: ReadyPlanOptionVersion["isOfferingInactive"];
  optionConflicts?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>> | null;
  optionPrerequisites?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>> | null;
  optionDefaultsIf?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>> | null;
  publishToUnderwriting?: ReadyPlanOptionVersion["publishToUnderwriting"];
  location?: FactoryInput<Location, LocationOptions> | null;
  showInCheckout?: ReadyPlanOptionVersion["showInCheckout"];
  description?: ReadyPlanOptionVersion["description"];
  order?: ReadyPlanOptionVersion["order"];
  missingInsideMapsRendering?: ReadyPlanOptionVersion["missingInsideMapsRendering"];
}

export function newReadyPlanOptionVersion(
  options?: ReadyPlanOptionVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionVersion>;
export function newReadyPlanOptionVersion(
  options: ReadyPlanOptionVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanOptionVersion> {
  const o = (options.__typename ? options : cache["ReadyPlanOptionVersion"] = {}) as ReadyPlanOptionVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanOptionVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanOptionVersion");
    o.identity = maybeNew("ReadyPlanOption", options.identity, cache, options.hasOwnProperty("identity"));
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.active = options.active ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.customName = options.customName ?? null;
    o.displayCode = options.displayCode ?? null;
    o.isNewFromUpstream = options.isNewFromUpstream ?? false;
    o.isUpstreamInactive = options.isUpstreamInactive ?? false;
    o.isOfferingInactive = options.isOfferingInactive ?? null;
    o.optionConflicts = (options.optionConflicts ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionConflicts"))
    );
    o.optionPrerequisites = (options.optionPrerequisites ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionPrerequisites"))
    );
    o.optionDefaultsIf = (options.optionDefaultsIf ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultsIf"))
    );
    o.publishToUnderwriting = options.publishToUnderwriting ?? false;
    o.location = maybeNewOrNull("Location", options.location, cache);
    o.showInCheckout = options.showInCheckout ?? false;
    o.description = options.description ?? null;
    o.order = options.order ?? 0;
    o.missingInsideMapsRendering = options.missingInsideMapsRendering ?? false;
    return o as FactoryResult<ReadyPlanOptionVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanOptionVersion"] = newReadyPlanOptionVersion;

export interface ReadyPlanProgramDataOptions {
  __typename?: "ReadyPlanProgramData";
  id?: ReadyPlanProgramData["id"];
  createdAt?: ReadyPlanProgramData["createdAt"];
  updatedAt?: ReadyPlanProgramData["updatedAt"];
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
  readyPlanOptions?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  programData?: FactoryInput<ProgramData, ProgramDataOptions>;
  versions?: Array<FactoryInput<ReadyPlanProgramDataVersion, ReadyPlanProgramDataVersionOptions>>;
  active?: ReadyPlanProgramData["active"];
}

export function newReadyPlanProgramData(
  options?: ReadyPlanProgramDataOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanProgramData>;
export function newReadyPlanProgramData(
  options: ReadyPlanProgramDataOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanProgramData> {
  const o = (options.__typename ? options : cache["ReadyPlanProgramData"] = {}) as ReadyPlanProgramData;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanProgramData";
    o.id = options.id ?? nextFactoryId("ReadyPlanProgramData");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
    );
    o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
    o.versions = (options.versions ?? []).map((i) =>
      maybeNew("ReadyPlanProgramDataVersion", i, cache, options.hasOwnProperty("versions"))
    );
    o.active = options.active ?? false;
    return o as FactoryResult<ReadyPlanProgramData>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanProgramData"] = newReadyPlanProgramData;

export interface ReadyPlanProgramDataVersionOptions {
  __typename?: "ReadyPlanProgramDataVersion";
  id?: ReadyPlanProgramDataVersion["id"];
  active?: ReadyPlanProgramDataVersion["active"];
  createdAt?: ReadyPlanProgramDataVersion["createdAt"];
  updatedAt?: ReadyPlanProgramDataVersion["updatedAt"];
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  identity?: FactoryInput<ReadyPlanProgramData, ReadyPlanProgramDataOptions>;
  programData?: FactoryInput<ProgramData, ProgramDataOptions>;
}

export function newReadyPlanProgramDataVersion(
  options?: ReadyPlanProgramDataVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanProgramDataVersion>;
export function newReadyPlanProgramDataVersion(
  options: ReadyPlanProgramDataVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanProgramDataVersion> {
  const o = (options.__typename ? options : cache["ReadyPlanProgramDataVersion"] = {}) as ReadyPlanProgramDataVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanProgramDataVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanProgramDataVersion");
    o.active = options.active ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.identity = maybeNew("ReadyPlanProgramData", options.identity, cache, options.hasOwnProperty("identity"));
    o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
    return o as FactoryResult<ReadyPlanProgramDataVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanProgramDataVersion"] = newReadyPlanProgramDataVersion;

export interface ReadyPlanRequiredOptionOptions {
  __typename?: "ReadyPlanRequiredOption";
  id?: ReadyPlanRequiredOption["id"];
  createdAt?: ReadyPlanRequiredOption["createdAt"];
  updatedAt?: ReadyPlanRequiredOption["updatedAt"];
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  planAddOns?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  targetGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  targetCombinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
  active?: ReadyPlanRequiredOption["active"];
  usePersonalizationGroups?: ReadyPlanRequiredOption["usePersonalizationGroups"];
}

export function newReadyPlanRequiredOption(
  options?: ReadyPlanRequiredOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanRequiredOption>;
export function newReadyPlanRequiredOption(
  options: ReadyPlanRequiredOptionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanRequiredOption> {
  const o = (options.__typename ? options : cache["ReadyPlanRequiredOption"] = {}) as ReadyPlanRequiredOption;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanRequiredOption";
    o.id = options.id ?? nextFactoryId("ReadyPlanRequiredOption");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.planAddOns = (options.planAddOns ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("planAddOns"))
    );
    o.targetGroups = (options.targetGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
    );
    o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
    );
    o.active = options.active ?? false;
    o.usePersonalizationGroups = options.usePersonalizationGroups ?? false;
    return o as FactoryResult<ReadyPlanRequiredOption>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanRequiredOption"] = newReadyPlanRequiredOption;

export interface SaveReadyPlanRequiredOptionsResultOptions {
  __typename?: "SaveReadyPlanRequiredOptionsResult";
  readyPlanRequiredOptions?: Array<FactoryInput<ReadyPlanRequiredOption, ReadyPlanRequiredOptionOptions>>;
}

export function newSaveReadyPlanRequiredOptionsResult(
  options?: SaveReadyPlanRequiredOptionsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReadyPlanRequiredOptionsResult>;
export function newSaveReadyPlanRequiredOptionsResult(
  options: SaveReadyPlanRequiredOptionsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReadyPlanRequiredOptionsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveReadyPlanRequiredOptionsResult"] = {}) as SaveReadyPlanRequiredOptionsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReadyPlanRequiredOptionsResult";
    o.readyPlanRequiredOptions = (options.readyPlanRequiredOptions ?? []).map((i) =>
      maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("readyPlanRequiredOptions"))
    );
    return o as FactoryResult<SaveReadyPlanRequiredOptionsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReadyPlanRequiredOptionsResult"] = newSaveReadyPlanRequiredOptionsResult;

export interface ReadyPlanRequiredOptionVersionOptions {
  __typename?: "ReadyPlanRequiredOptionVersion";
  id?: ReadyPlanRequiredOptionVersion["id"];
  active?: ReadyPlanRequiredOptionVersion["active"];
  createdAt?: ReadyPlanRequiredOptionVersion["createdAt"];
  updatedAt?: ReadyPlanRequiredOptionVersion["updatedAt"];
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  identity?: FactoryInput<ReadyPlanRequiredOption, ReadyPlanRequiredOptionOptions>;
  targetGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  targetCombinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
}

export function newReadyPlanRequiredOptionVersion(
  options?: ReadyPlanRequiredOptionVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanRequiredOptionVersion>;
export function newReadyPlanRequiredOptionVersion(
  options: ReadyPlanRequiredOptionVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanRequiredOptionVersion> {
  const o =
    (options.__typename ? options : cache["ReadyPlanRequiredOptionVersion"] = {}) as ReadyPlanRequiredOptionVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanRequiredOptionVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanRequiredOptionVersion");
    o.active = options.active ?? false;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.identity = maybeNew("ReadyPlanRequiredOption", options.identity, cache, options.hasOwnProperty("identity"));
    o.targetGroups = (options.targetGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
    );
    o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
    );
    return o as FactoryResult<ReadyPlanRequiredOptionVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanRequiredOptionVersion"] = newReadyPlanRequiredOptionVersion;

export interface ReadyPlanVersionOptions {
  __typename?: "ReadyPlanVersion";
  id?: ReadyPlanVersion["id"];
  identity?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
  name?: ReadyPlanVersion["name"];
  code?: ReadyPlanVersion["code"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  lotTypes?: ReadyPlanVersion["lotTypes"];
  contingencyMarkupPercentage?: ReadyPlanVersion["contingencyMarkupPercentage"];
  description?: ReadyPlanVersion["description"];
  markets?: Array<FactoryInput<Market, MarketOptions>>;
  owner?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newReadyPlanVersion(
  options?: ReadyPlanVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanVersion>;
export function newReadyPlanVersion(
  options: ReadyPlanVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanVersion> {
  const o = (options.__typename ? options : cache["ReadyPlanVersion"] = {}) as ReadyPlanVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ReadyPlanVersion";
    o.id = options.id ?? nextFactoryId("ReadyPlanVersion");
    o.identity = maybeNew("ReadyPlan", options.identity, cache, options.hasOwnProperty("identity"));
    o.name = options.name ?? "name";
    o.code = options.code ?? null;
    o.type = enumOrDetailOfReadyPlanType(options.type);
    o.lotTypes = options.lotTypes ?? [];
    o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
    o.description = options.description ?? null;
    o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
    o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
    return o as FactoryResult<ReadyPlanVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ReadyPlanVersion"] = newReadyPlanVersion;

export interface SaveReferencesResultOptions {
  __typename?: "SaveReferencesResult";
  references?: Array<FactoryInput<Reference, ReferenceOptions>>;
}

export function newSaveReferencesResult(
  options?: SaveReferencesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveReferencesResult>;
export function newSaveReferencesResult(
  options: SaveReferencesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveReferencesResult> {
  const o = (options.__typename ? options : cache["SaveReferencesResult"] = {}) as SaveReferencesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveReferencesResult";
    o.references = (options.references ?? []).map((i) =>
      maybeNew("Reference", i, cache, options.hasOwnProperty("references"))
    );
    return o as FactoryResult<SaveReferencesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveReferencesResult"] = newSaveReferencesResult;

export interface ReferenceOptions {
  __typename?: "Reference";
  source?: Referencable | FactoryResult<ReferencableType> | ReferencableOptions;
  target?: Referencable | FactoryResult<ReferencableType> | ReferencableOptions;
}

export function newReference(options?: ReferenceOptions, factoryOptions?: FactoryOptions): FactoryResult<Reference>;
export function newReference(
  options: ReferenceOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Reference> {
  const o = (options.__typename ? options : cache["Reference"] = {}) as Reference;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Reference";
    o.source = maybeNew("Referencable", options.source, cache, options.hasOwnProperty("source"));
    o.target = maybeNew("Referencable", options.target, cache, options.hasOwnProperty("target"));
    return o as FactoryResult<Reference>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Reference"] = newReference;

export interface SaveRegionResultOptions {
  __typename?: "SaveRegionResult";
  region?: FactoryInput<Region, RegionOptions>;
}

export function newSaveRegionResult(
  options?: SaveRegionResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveRegionResult>;
export function newSaveRegionResult(
  options: SaveRegionResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveRegionResult> {
  const o = (options.__typename ? options : cache["SaveRegionResult"] = {}) as SaveRegionResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveRegionResult";
    o.region = maybeNew("Region", options.region, cache, options.hasOwnProperty("region"));
    return o as FactoryResult<SaveRegionResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveRegionResult"] = newSaveRegionResult;

export interface RequiredTaskDocumentOptions {
  __typename?: "RequiredTaskDocument";
  id?: RequiredTaskDocument["id"];
  name?: RequiredTaskDocument["name"];
  createdAt?: RequiredTaskDocument["createdAt"];
  updatedAt?: RequiredTaskDocument["updatedAt"];
  watchers?: RequiredTaskDocument["watchers"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  sampleAsset?: FactoryInput<Asset, AssetOptions> | null;
  task?: FactoryInput<Task, TaskOptions>;
  document?: FactoryInput<Document, DocumentOptions> | null;
  globalRequiredTaskDocument?: FactoryInput<GlobalRequiredTaskDocument, GlobalRequiredTaskDocumentOptions> | null;
}

export function newRequiredTaskDocument(
  options?: RequiredTaskDocumentOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<RequiredTaskDocument>;
export function newRequiredTaskDocument(
  options: RequiredTaskDocumentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<RequiredTaskDocument> {
  const o = (options.__typename ? options : cache["RequiredTaskDocument"] = {}) as RequiredTaskDocument;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "RequiredTaskDocument";
    o.id = options.id ?? nextFactoryId("RequiredTaskDocument");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.watchers = options.watchers ?? [];
    o.documentType = enumOrDetailOfDocumentType(options.documentType);
    o.sampleAsset = maybeNewOrNull("Asset", options.sampleAsset, cache);
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    o.document = maybeNewOrNull("Document", options.document, cache);
    o.globalRequiredTaskDocument = maybeNewOrNull(
      "GlobalRequiredTaskDocument",
      options.globalRequiredTaskDocument,
      cache,
    );
    return o as FactoryResult<RequiredTaskDocument>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["RequiredTaskDocument"] = newRequiredTaskDocument;

export interface SaveRequiredTaskDocumentResultOptions {
  __typename?: "SaveRequiredTaskDocumentResult";
  requiredTaskDocument?: FactoryInput<RequiredTaskDocument, RequiredTaskDocumentOptions>;
}

export function newSaveRequiredTaskDocumentResult(
  options?: SaveRequiredTaskDocumentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveRequiredTaskDocumentResult>;
export function newSaveRequiredTaskDocumentResult(
  options: SaveRequiredTaskDocumentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveRequiredTaskDocumentResult> {
  const o =
    (options.__typename ? options : cache["SaveRequiredTaskDocumentResult"] = {}) as SaveRequiredTaskDocumentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveRequiredTaskDocumentResult";
    o.requiredTaskDocument = maybeNew(
      "RequiredTaskDocument",
      options.requiredTaskDocument,
      cache,
      options.hasOwnProperty("requiredTaskDocument"),
    );
    return o as FactoryResult<SaveRequiredTaskDocumentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveRequiredTaskDocumentResult"] = newSaveRequiredTaskDocumentResult;

export interface DeleteRequiredTaskDocumentResultOptions {
  __typename?: "DeleteRequiredTaskDocumentResult";
  task?: FactoryInput<Task, TaskOptions>;
}

export function newDeleteRequiredTaskDocumentResult(
  options?: DeleteRequiredTaskDocumentResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteRequiredTaskDocumentResult>;
export function newDeleteRequiredTaskDocumentResult(
  options: DeleteRequiredTaskDocumentResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteRequiredTaskDocumentResult> {
  const o =
    (options.__typename ? options : cache["DeleteRequiredTaskDocumentResult"] = {}) as DeleteRequiredTaskDocumentResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteRequiredTaskDocumentResult";
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    return o as FactoryResult<DeleteRequiredTaskDocumentResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteRequiredTaskDocumentResult"] = newDeleteRequiredTaskDocumentResult;

export interface RoomTypeOptions {
  __typename?: "RoomType";
  id?: RoomType["id"];
  name?: RoomType["name"];
  createdAt?: RoomType["createdAt"];
  updatedAt?: RoomType["updatedAt"];
  locations?: Array<FactoryInput<Location, LocationOptions>>;
  canDesignPackageRemap?: RoomType["canDesignPackageRemap"];
}

export function newRoomType(options?: RoomTypeOptions, factoryOptions?: FactoryOptions): FactoryResult<RoomType>;
export function newRoomType(
  options: RoomTypeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<RoomType> {
  const o = (options.__typename ? options : cache["RoomType"] = {}) as RoomType;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "RoomType";
    o.id = options.id ?? nextFactoryId("RoomType");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.locations = (options.locations ?? []).map((i) =>
      maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
    );
    o.canDesignPackageRemap = options.canDesignPackageRemap ?? null;
    return o as FactoryResult<RoomType>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["RoomType"] = newRoomType;

export interface SaveRoomTypeResultOptions {
  __typename?: "SaveRoomTypeResult";
  roomType?: FactoryInput<RoomType, RoomTypeOptions>;
}

export function newSaveRoomTypeResult(
  options?: SaveRoomTypeResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveRoomTypeResult>;
export function newSaveRoomTypeResult(
  options: SaveRoomTypeResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveRoomTypeResult> {
  const o = (options.__typename ? options : cache["SaveRoomTypeResult"] = {}) as SaveRoomTypeResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveRoomTypeResult";
    o.roomType = maybeNew("RoomType", options.roomType, cache, options.hasOwnProperty("roomType"));
    return o as FactoryResult<SaveRoomTypeResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveRoomTypeResult"] = newSaveRoomTypeResult;

export interface TestMutationResultOptions {
  __typename?: "TestMutationResult";
  datetime?: TestMutationResult["datetime"];
  date?: TestMutationResult["date"];
}

export function newTestMutationResult(
  options?: TestMutationResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TestMutationResult>;
export function newTestMutationResult(
  options: TestMutationResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TestMutationResult> {
  const o = (options.__typename ? options : cache["TestMutationResult"] = {}) as TestMutationResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TestMutationResult";
    o.datetime = options.datetime ?? newDateTime();
    o.date = options.date ?? newDate();
    return o as FactoryResult<TestMutationResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TestMutationResult"] = newTestMutationResult;

export interface UserErrorOptions {
  __typename?: "UserError";
  message?: UserError["message"];
}

export function newUserError(options?: UserErrorOptions, factoryOptions?: FactoryOptions): FactoryResult<UserError>;
export function newUserError(
  options: UserErrorOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UserError> {
  const o = (options.__typename ? options : cache["UserError"] = {}) as UserError;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UserError";
    o.message = options.message ?? "message";
    return o as FactoryResult<UserError>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UserError"] = newUserError;

export interface EmptyResultOptions {
  __typename?: "EmptyResult";
  emptyResult?: EmptyResult["emptyResult"];
  dummyString?: EmptyResult["dummyString"];
}

export function newEmptyResult(
  options?: EmptyResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<EmptyResult>;
export function newEmptyResult(
  options: EmptyResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<EmptyResult> {
  const o = (options.__typename ? options : cache["EmptyResult"] = {}) as EmptyResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "EmptyResult";
    o.emptyResult = options.emptyResult ?? null;
    o.dummyString = options.dummyString ?? null;
    return o as FactoryResult<EmptyResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["EmptyResult"] = newEmptyResult;

export interface UrlOptions {
  __typename?: "Url";
  path?: Url["path"];
  url?: Url["url"];
}

export function newUrl(options?: UrlOptions, factoryOptions?: FactoryOptions): FactoryResult<Url>;
export function newUrl(
  options: UrlOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Url> {
  const o = (options.__typename ? options : cache["Url"] = {}) as Url;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Url";
    o.path = options.path ?? "path";
    o.url = options.url ?? "url";
    return o as FactoryResult<Url>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Url"] = newUrl;

export interface PotentialOperationOptions {
  __typename?: "PotentialOperation";
  shown?: PotentialOperation["shown"];
  hiddenReasons?: PotentialOperation["hiddenReasons"];
  enabled?: PotentialOperation["enabled"];
  disabledReasons?: PotentialOperation["disabledReasons"];
}

export function newPotentialOperation(
  options?: PotentialOperationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<PotentialOperation>;
export function newPotentialOperation(
  options: PotentialOperationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialOperation> {
  const o = (options.__typename ? options : cache["PotentialOperation"] = {}) as PotentialOperation;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PotentialOperation";
    o.shown = options.shown ?? false;
    o.hiddenReasons = options.hiddenReasons ?? [];
    o.enabled = options.enabled ?? false;
    o.disabledReasons = options.disabledReasons ?? [];
    return o as FactoryResult<PotentialOperation>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PotentialOperation"] = newPotentialOperation;

export interface PotentialOperation2Options {
  __typename?: "PotentialOperation2";
  allowed?: PotentialOperation2["allowed"];
  disabledReasons?: Array<FactoryInput<Reason, ReasonOptions>>;
}

export function newPotentialOperation2(
  options?: PotentialOperation2Options,
  factoryOptions?: FactoryOptions,
): FactoryResult<PotentialOperation2>;
export function newPotentialOperation2(
  options: PotentialOperation2Options = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialOperation2> {
  const o = (options.__typename ? options : cache["PotentialOperation2"] = {}) as PotentialOperation2;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "PotentialOperation2";
    o.allowed = options.allowed ?? false;
    o.disabledReasons = (options.disabledReasons ?? []).map((i) =>
      maybeNew("Reason", i, cache, options.hasOwnProperty("disabledReasons"))
    );
    return o as FactoryResult<PotentialOperation2>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["PotentialOperation2"] = newPotentialOperation2;

export interface ReasonOptions {
  __typename?: "Reason";
  message?: Reason["message"];
  entity?: HasBlueprintUrl | FactoryResult<HasBlueprintUrlType> | HasBlueprintUrlOptions | null;
}

export function newReason(options?: ReasonOptions, factoryOptions?: FactoryOptions): FactoryResult<Reason>;
export function newReason(
  options: ReasonOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Reason> {
  const o = (options.__typename ? options : cache["Reason"] = {}) as Reason;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Reason";
    o.message = options.message ?? "message";
    o.entity = maybeNewOrNull("HasBlueprintUrl", options.entity, cache);
    return o as FactoryResult<Reason>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Reason"] = newReason;

export interface ScheduleOptions {
  __typename?: "Schedule";
  id?: Schedule["id"];
  name?: Schedule["name"];
  interval?: FactoryInput<CalendarInterval, CalendarIntervalOptions> | null;
  baselineInterval?: FactoryInput<CalendarInterval, CalendarIntervalOptions> | null;
  createdAt?: Schedule["createdAt"];
  updatedAt?: Schedule["updatedAt"];
  status?: Schedule["status"];
  statusDetail?: ScheduleStatusDetailOptions | ScheduleStatus;
  stage?: Schedule["stage"];
  stageDetail?: StageDetailOptions | Stage;
  parent?:
    | ScheduleParent
    | FactoryResult<ScheduleParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  scheduleSetting?: FactoryInput<ScheduleSetting, ScheduleSettingOptions> | null;
  canPublishSchedule?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canCompleteSchedule?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  duration?: Schedule["duration"];
  baselineDuration?: Schedule["baselineDuration"];
  phases?: Array<FactoryInput<SchedulePhase, SchedulePhaseOptions>>;
  isLocked?: Schedule["isLocked"];
  flagCount?: Schedule["flagCount"];
  templateSchedule?: FactoryInput<Schedule, ScheduleOptions> | null;
  enableReviewReminders?: Schedule["enableReviewReminders"];
  reviewReminderDays?: Schedule["reviewReminderDays"];
  market?: FactoryInput<Market, MarketOptions> | null;
}

export function newSchedule(options?: ScheduleOptions, factoryOptions?: FactoryOptions): FactoryResult<Schedule>;
export function newSchedule(
  options: ScheduleOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Schedule> {
  const o = (options.__typename ? options : cache["Schedule"] = {}) as Schedule;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Schedule";
    o.id = options.id ?? nextFactoryId("Schedule");
    o.name = options.name ?? "name";
    o.interval = maybeNewOrNull("CalendarInterval", options.interval, cache);
    o.baselineInterval = maybeNewOrNull("CalendarInterval", options.baselineInterval, cache);
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = options.status ?? ScheduleStatus.Active;
    o.statusDetail = enumOrDetailOfScheduleStatus(options.statusDetail);
    o.stage = options.stage ?? Stage.PreConPlanning;
    o.stageDetail = enumOrDetailOfStage(options.stageDetail);
    o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    o.scheduleSetting = maybeNewOrNull("ScheduleSetting", options.scheduleSetting, cache);
    o.canPublishSchedule = maybeNew(
      "PotentialOperation2",
      options.canPublishSchedule,
      cache,
      options.hasOwnProperty("canPublishSchedule"),
    );
    o.canCompleteSchedule = maybeNew(
      "PotentialOperation2",
      options.canCompleteSchedule,
      cache,
      options.hasOwnProperty("canCompleteSchedule"),
    );
    o.duration = options.duration ?? null;
    o.baselineDuration = options.baselineDuration ?? null;
    o.phases = (options.phases ?? []).map((i) => maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("phases")));
    o.isLocked = options.isLocked ?? false;
    o.flagCount = options.flagCount ?? 0;
    o.templateSchedule = maybeNewOrNull("Schedule", options.templateSchedule, cache);
    o.enableReviewReminders = options.enableReviewReminders ?? false;
    o.reviewReminderDays = options.reviewReminderDays ?? [];
    o.market = maybeNewOrNull("Market", options.market, cache);
    return o as FactoryResult<Schedule>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Schedule"] = newSchedule;

export interface SchedulesResultOptions {
  __typename?: "SchedulesResult";
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
}

export function newSchedulesResult(
  options?: SchedulesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulesResult>;
export function newSchedulesResult(
  options: SchedulesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SchedulesResult> {
  const o = (options.__typename ? options : cache["SchedulesResult"] = {}) as SchedulesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SchedulesResult";
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    return o as FactoryResult<SchedulesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SchedulesResult"] = newSchedulesResult;

export interface SaveScheduleResultOptions {
  __typename?: "SaveScheduleResult";
  schedule?: FactoryInput<Schedule, ScheduleOptions>;
}

export function newSaveScheduleResult(
  options?: SaveScheduleResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleResult>;
export function newSaveScheduleResult(
  options: SaveScheduleResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScheduleResult> {
  const o = (options.__typename ? options : cache["SaveScheduleResult"] = {}) as SaveScheduleResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScheduleResult";
    o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
    return o as FactoryResult<SaveScheduleResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScheduleResult"] = newSaveScheduleResult;

export interface ResetScheduleBaselinesResultOptions {
  __typename?: "ResetScheduleBaselinesResult";
  projectIds?: ResetScheduleBaselinesResult["projectIds"];
}

export function newResetScheduleBaselinesResult(
  options?: ResetScheduleBaselinesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ResetScheduleBaselinesResult>;
export function newResetScheduleBaselinesResult(
  options: ResetScheduleBaselinesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ResetScheduleBaselinesResult> {
  const o = (options.__typename ? options : cache["ResetScheduleBaselinesResult"] = {}) as ResetScheduleBaselinesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ResetScheduleBaselinesResult";
    o.projectIds = options.projectIds ?? [];
    return o as FactoryResult<ResetScheduleBaselinesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ResetScheduleBaselinesResult"] = newResetScheduleBaselinesResult;

export interface ScheduleFlagOptions {
  __typename?: "ScheduleFlag";
  id?: ScheduleFlag["id"];
  durationInDays?: ScheduleFlag["durationInDays"];
  description?: ScheduleFlag["description"];
  createdAt?: ScheduleFlag["createdAt"];
  updatedAt?: ScheduleFlag["updatedAt"];
  reason?: FactoryInput<ScheduleFlagReason, ScheduleFlagReasonOptions> | null;
  scheduleTask?: FactoryInput<ScheduleTask, ScheduleTaskOptions> | null;
  task?: FactoryInput<Task, TaskOptions>;
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
}

export function newScheduleFlag(
  options?: ScheduleFlagOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleFlag>;
export function newScheduleFlag(
  options: ScheduleFlagOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleFlag> {
  const o = (options.__typename ? options : cache["ScheduleFlag"] = {}) as ScheduleFlag;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleFlag";
    o.id = options.id ?? nextFactoryId("ScheduleFlag");
    o.durationInDays = options.durationInDays ?? null;
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.reason = maybeNewOrNull("ScheduleFlagReason", options.reason, cache);
    o.scheduleTask = maybeNewOrNull("ScheduleTask", options.scheduleTask, cache);
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    return o as FactoryResult<ScheduleFlag>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleFlag"] = newScheduleFlag;

export interface SaveScheduleFlagResultOptions {
  __typename?: "SaveScheduleFlagResult";
  scheduleFlag?: FactoryInput<ScheduleFlag, ScheduleFlagOptions>;
}

export function newSaveScheduleFlagResult(
  options?: SaveScheduleFlagResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleFlagResult>;
export function newSaveScheduleFlagResult(
  options: SaveScheduleFlagResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScheduleFlagResult> {
  const o = (options.__typename ? options : cache["SaveScheduleFlagResult"] = {}) as SaveScheduleFlagResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScheduleFlagResult";
    o.scheduleFlag = maybeNew("ScheduleFlag", options.scheduleFlag, cache, options.hasOwnProperty("scheduleFlag"));
    return o as FactoryResult<SaveScheduleFlagResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScheduleFlagResult"] = newSaveScheduleFlagResult;

export interface DeleteScheduleFlagResultOptions {
  __typename?: "DeleteScheduleFlagResult";
  scheduleTask?: FactoryInput<ScheduleTask, ScheduleTaskOptions> | null;
  task?: FactoryInput<Task, TaskOptions>;
}

export function newDeleteScheduleFlagResult(
  options?: DeleteScheduleFlagResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteScheduleFlagResult>;
export function newDeleteScheduleFlagResult(
  options: DeleteScheduleFlagResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteScheduleFlagResult> {
  const o = (options.__typename ? options : cache["DeleteScheduleFlagResult"] = {}) as DeleteScheduleFlagResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteScheduleFlagResult";
    o.scheduleTask = maybeNewOrNull("ScheduleTask", options.scheduleTask, cache);
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    return o as FactoryResult<DeleteScheduleFlagResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteScheduleFlagResult"] = newDeleteScheduleFlagResult;

export interface ScheduleFlagImpactOptions {
  __typename?: "ScheduleFlagImpact";
  id?: ScheduleFlagImpact["id"];
  oldStartDate?: ScheduleFlagImpact["oldStartDate"];
  newStartDate?: ScheduleFlagImpact["newStartDate"];
  oldEndDate?: ScheduleFlagImpact["oldEndDate"];
  newEndDate?: ScheduleFlagImpact["newEndDate"];
  oldDurationInDays?: ScheduleFlagImpact["oldDurationInDays"];
  newDurationInDays?: ScheduleFlagImpact["newDurationInDays"];
  oldSlackInDays?: ScheduleFlagImpact["oldSlackInDays"];
  newSlackInDays?: ScheduleFlagImpact["newSlackInDays"];
  createdAt?: ScheduleFlagImpact["createdAt"];
  updatedAt?: ScheduleFlagImpact["updatedAt"];
  scheduleFlag?: FactoryInput<ScheduleFlag, ScheduleFlagOptions>;
  impacted?:
    | ScheduleFlagImpactImpacted
    | FactoryResult<ScheduleFlagImpactImpacted>
    | PlanMilestoneOptions
    | RequireTypename<TaskOptions>
    | null;
}

export function newScheduleFlagImpact(
  options?: ScheduleFlagImpactOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleFlagImpact>;
export function newScheduleFlagImpact(
  options: ScheduleFlagImpactOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleFlagImpact> {
  const o = (options.__typename ? options : cache["ScheduleFlagImpact"] = {}) as ScheduleFlagImpact;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleFlagImpact";
    o.id = options.id ?? nextFactoryId("ScheduleFlagImpact");
    o.oldStartDate = options.oldStartDate ?? null;
    o.newStartDate = options.newStartDate ?? newDate();
    o.oldEndDate = options.oldEndDate ?? null;
    o.newEndDate = options.newEndDate ?? newDate();
    o.oldDurationInDays = options.oldDurationInDays ?? null;
    o.newDurationInDays = options.newDurationInDays ?? 0;
    o.oldSlackInDays = options.oldSlackInDays ?? null;
    o.newSlackInDays = options.newSlackInDays ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.scheduleFlag = maybeNew("ScheduleFlag", options.scheduleFlag, cache, options.hasOwnProperty("scheduleFlag"));
    o.impacted = maybeNewOrNull(options.impacted?.__typename ?? "PlanMilestone", options.impacted, cache);
    return o as FactoryResult<ScheduleFlagImpact>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleFlagImpact"] = newScheduleFlagImpact;

export interface ScheduleFlagReasonOptions {
  __typename?: "ScheduleFlagReason";
  id?: ScheduleFlagReason["id"];
  createdAt?: ScheduleFlagReason["createdAt"];
  updatedAt?: ScheduleFlagReason["updatedAt"];
  scheduleFlagReasonType?: ScheduleFlagReasonTypeDetailOptions | ScheduleFlagReasonType;
  stages?: ScheduleFlagReason["stages"];
  scheduleFlags?: Array<FactoryInput<ScheduleFlag, ScheduleFlagOptions>>;
  title?: ScheduleFlagReason["title"];
  attachmentIsRequired?: ScheduleFlagReason["attachmentIsRequired"];
  descriptionIsRequired?: ScheduleFlagReason["descriptionIsRequired"];
}

export function newScheduleFlagReason(
  options?: ScheduleFlagReasonOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleFlagReason>;
export function newScheduleFlagReason(
  options: ScheduleFlagReasonOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleFlagReason> {
  const o = (options.__typename ? options : cache["ScheduleFlagReason"] = {}) as ScheduleFlagReason;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleFlagReason";
    o.id = options.id ?? nextFactoryId("ScheduleFlagReason");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.scheduleFlagReasonType = enumOrDetailOfScheduleFlagReasonType(options.scheduleFlagReasonType);
    o.stages = options.stages ?? [];
    o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
      maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
    );
    o.title = options.title ?? "title";
    o.attachmentIsRequired = options.attachmentIsRequired ?? false;
    o.descriptionIsRequired = options.descriptionIsRequired ?? false;
    return o as FactoryResult<ScheduleFlagReason>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleFlagReason"] = newScheduleFlagReason;

export interface SaveScheduleFlagReasonsResultOptions {
  __typename?: "SaveScheduleFlagReasonsResult";
  scheduleFlagReasons?: Array<FactoryInput<ScheduleFlagReason, ScheduleFlagReasonOptions>>;
}

export function newSaveScheduleFlagReasonsResult(
  options?: SaveScheduleFlagReasonsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleFlagReasonsResult>;
export function newSaveScheduleFlagReasonsResult(
  options: SaveScheduleFlagReasonsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScheduleFlagReasonsResult> {
  const o =
    (options.__typename ? options : cache["SaveScheduleFlagReasonsResult"] = {}) as SaveScheduleFlagReasonsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScheduleFlagReasonsResult";
    o.scheduleFlagReasons = (options.scheduleFlagReasons ?? []).map((i) =>
      maybeNew("ScheduleFlagReason", i, cache, options.hasOwnProperty("scheduleFlagReasons"))
    );
    return o as FactoryResult<SaveScheduleFlagReasonsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScheduleFlagReasonsResult"] = newSaveScheduleFlagReasonsResult;

export interface SchedulePhaseProgressOptions {
  __typename?: "SchedulePhaseProgress";
  scheduleSubPhaseProgress?: FactoryInput<ProgressSummary, ProgressSummaryOptions>;
  taskProgress?: FactoryInput<ProgressSummary, ProgressSummaryOptions>;
}

export function newSchedulePhaseProgress(
  options?: SchedulePhaseProgressOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhaseProgress>;
export function newSchedulePhaseProgress(
  options: SchedulePhaseProgressOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SchedulePhaseProgress> {
  const o = (options.__typename ? options : cache["SchedulePhaseProgress"] = {}) as SchedulePhaseProgress;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SchedulePhaseProgress";
    o.scheduleSubPhaseProgress = maybeNew(
      "ProgressSummary",
      options.scheduleSubPhaseProgress,
      cache,
      options.hasOwnProperty("scheduleSubPhaseProgress"),
    );
    o.taskProgress = maybeNew("ProgressSummary", options.taskProgress, cache, options.hasOwnProperty("taskProgress"));
    return o as FactoryResult<SchedulePhaseProgress>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SchedulePhaseProgress"] = newSchedulePhaseProgress;

export interface SaveSchedulePhasesResultOptions {
  __typename?: "SaveSchedulePhasesResult";
  schedulePhases?: Array<FactoryInput<SchedulePhase, SchedulePhaseOptions>>;
}

export function newSaveSchedulePhasesResult(
  options?: SaveSchedulePhasesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveSchedulePhasesResult>;
export function newSaveSchedulePhasesResult(
  options: SaveSchedulePhasesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveSchedulePhasesResult> {
  const o = (options.__typename ? options : cache["SaveSchedulePhasesResult"] = {}) as SaveSchedulePhasesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveSchedulePhasesResult";
    o.schedulePhases = (options.schedulePhases ?? []).map((i) =>
      maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("schedulePhases"))
    );
    return o as FactoryResult<SaveSchedulePhasesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveSchedulePhasesResult"] = newSaveSchedulePhasesResult;

export interface DeleteSchedulePhasesResultOptions {
  __typename?: "DeleteSchedulePhasesResult";
  impactedScheduleTasks?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  impactedScheduleSubPhases?: Array<FactoryInput<ScheduleSubPhase, ScheduleSubPhaseOptions>>;
  impactedSchedulePhases?: Array<FactoryInput<SchedulePhase, SchedulePhaseOptions>>;
  impactedSchedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  impacted?: Array<ScheduleEntity | FactoryResult<ScheduleEntityType> | ScheduleEntityOptions>;
}

export function newDeleteSchedulePhasesResult(
  options?: DeleteSchedulePhasesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteSchedulePhasesResult>;
export function newDeleteSchedulePhasesResult(
  options: DeleteSchedulePhasesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteSchedulePhasesResult> {
  const o = (options.__typename ? options : cache["DeleteSchedulePhasesResult"] = {}) as DeleteSchedulePhasesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteSchedulePhasesResult";
    o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
    );
    o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
      maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
    );
    o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
      maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
    );
    o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
    );
    o.impacted = (options.impacted ?? []).map((i) =>
      maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
    );
    return o as FactoryResult<DeleteSchedulePhasesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteSchedulePhasesResult"] = newDeleteSchedulePhasesResult;

export interface ScheduleSettingOptions {
  __typename?: "ScheduleSetting";
  id?: ScheduleSetting["id"];
  workingDays?: ScheduleSetting["workingDays"];
  createdAt?: ScheduleSetting["createdAt"];
  updatedAt?: ScheduleSetting["updatedAt"];
  schedule?: FactoryInput<Schedule, ScheduleOptions>;
  exceptions?: ScheduleSetting["exceptions"];
}

export function newScheduleSetting(
  options?: ScheduleSettingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSetting>;
export function newScheduleSetting(
  options: ScheduleSettingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleSetting> {
  const o = (options.__typename ? options : cache["ScheduleSetting"] = {}) as ScheduleSetting;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleSetting";
    o.id = options.id ?? nextFactoryId("ScheduleSetting");
    o.workingDays = options.workingDays ?? [];
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
    o.exceptions = options.exceptions ?? null;
    return o as FactoryResult<ScheduleSetting>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleSetting"] = newScheduleSetting;

export interface SaveScheduleSettingsResultOptions {
  __typename?: "SaveScheduleSettingsResult";
  scheduleSettings?: Array<FactoryInput<ScheduleSetting, ScheduleSettingOptions>>;
}

export function newSaveScheduleSettingsResult(
  options?: SaveScheduleSettingsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleSettingsResult>;
export function newSaveScheduleSettingsResult(
  options: SaveScheduleSettingsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScheduleSettingsResult> {
  const o = (options.__typename ? options : cache["SaveScheduleSettingsResult"] = {}) as SaveScheduleSettingsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScheduleSettingsResult";
    o.scheduleSettings = (options.scheduleSettings ?? []).map((i) =>
      maybeNew("ScheduleSetting", i, cache, options.hasOwnProperty("scheduleSettings"))
    );
    return o as FactoryResult<SaveScheduleSettingsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScheduleSettingsResult"] = newSaveScheduleSettingsResult;

export interface ScheduleSubPhaseProgressOptions {
  __typename?: "ScheduleSubPhaseProgress";
  taskProgress?: FactoryInput<ProgressSummary, ProgressSummaryOptions>;
}

export function newScheduleSubPhaseProgress(
  options?: ScheduleSubPhaseProgressOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhaseProgress>;
export function newScheduleSubPhaseProgress(
  options: ScheduleSubPhaseProgressOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleSubPhaseProgress> {
  const o = (options.__typename ? options : cache["ScheduleSubPhaseProgress"] = {}) as ScheduleSubPhaseProgress;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleSubPhaseProgress";
    o.taskProgress = maybeNew("ProgressSummary", options.taskProgress, cache, options.hasOwnProperty("taskProgress"));
    return o as FactoryResult<ScheduleSubPhaseProgress>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleSubPhaseProgress"] = newScheduleSubPhaseProgress;

export interface SaveScheduleSubPhasesResultOptions {
  __typename?: "SaveScheduleSubPhasesResult";
  scheduleSubPhases?: Array<FactoryInput<ScheduleSubPhase, ScheduleSubPhaseOptions>>;
}

export function newSaveScheduleSubPhasesResult(
  options?: SaveScheduleSubPhasesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleSubPhasesResult>;
export function newSaveScheduleSubPhasesResult(
  options: SaveScheduleSubPhasesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScheduleSubPhasesResult> {
  const o = (options.__typename ? options : cache["SaveScheduleSubPhasesResult"] = {}) as SaveScheduleSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScheduleSubPhasesResult";
    o.scheduleSubPhases = (options.scheduleSubPhases ?? []).map((i) =>
      maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("scheduleSubPhases"))
    );
    return o as FactoryResult<SaveScheduleSubPhasesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScheduleSubPhasesResult"] = newSaveScheduleSubPhasesResult;

export interface DeleteScheduleSubPhasesResultOptions {
  __typename?: "DeleteScheduleSubPhasesResult";
  impactedScheduleTasks?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  impactedScheduleSubPhases?: Array<FactoryInput<ScheduleSubPhase, ScheduleSubPhaseOptions>>;
  impactedSchedulePhases?: Array<FactoryInput<SchedulePhase, SchedulePhaseOptions>>;
  impactedSchedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  impacted?: Array<ScheduleEntity | FactoryResult<ScheduleEntityType> | ScheduleEntityOptions>;
}

export function newDeleteScheduleSubPhasesResult(
  options?: DeleteScheduleSubPhasesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteScheduleSubPhasesResult>;
export function newDeleteScheduleSubPhasesResult(
  options: DeleteScheduleSubPhasesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteScheduleSubPhasesResult> {
  const o =
    (options.__typename ? options : cache["DeleteScheduleSubPhasesResult"] = {}) as DeleteScheduleSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteScheduleSubPhasesResult";
    o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
    );
    o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
      maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
    );
    o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
      maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
    );
    o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
    );
    o.impacted = (options.impacted ?? []).map((i) =>
      maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
    );
    return o as FactoryResult<DeleteScheduleSubPhasesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteScheduleSubPhasesResult"] = newDeleteScheduleSubPhasesResult;

export interface MoveScheduleSubPhasesResultOptions {
  __typename?: "MoveScheduleSubPhasesResult";
  impactedScheduleTasks?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  impactedScheduleSubPhases?: Array<FactoryInput<ScheduleSubPhase, ScheduleSubPhaseOptions>>;
  impactedSchedulePhases?: Array<FactoryInput<SchedulePhase, SchedulePhaseOptions>>;
  impactedSchedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  impacted?: Array<ScheduleEntity | FactoryResult<ScheduleEntityType> | ScheduleEntityOptions>;
}

export function newMoveScheduleSubPhasesResult(
  options?: MoveScheduleSubPhasesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MoveScheduleSubPhasesResult>;
export function newMoveScheduleSubPhasesResult(
  options: MoveScheduleSubPhasesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MoveScheduleSubPhasesResult> {
  const o = (options.__typename ? options : cache["MoveScheduleSubPhasesResult"] = {}) as MoveScheduleSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MoveScheduleSubPhasesResult";
    o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
    );
    o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
      maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
    );
    o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
      maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
    );
    o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
    );
    o.impacted = (options.impacted ?? []).map((i) =>
      maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
    );
    return o as FactoryResult<MoveScheduleSubPhasesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MoveScheduleSubPhasesResult"] = newMoveScheduleSubPhasesResult;

export interface SaveScheduleTasksResultOptions {
  __typename?: "SaveScheduleTasksResult";
  scheduleTasks?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  impactedScheduleTasks?: Array<FactoryInput<ScheduleTask, ScheduleTaskOptions>>;
  impactedScheduleSubPhases?: Array<FactoryInput<ScheduleSubPhase, ScheduleSubPhaseOptions>>;
  impactedSchedulePhases?: Array<FactoryInput<SchedulePhase, SchedulePhaseOptions>>;
  impactedSchedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  impacted?: Array<ScheduleEntity | FactoryResult<ScheduleEntityType> | ScheduleEntityOptions>;
  resultingDelays?: Array<FactoryInput<ResultingDelay, ResultingDelayOptions>>;
  generatedInvoices?: Array<FactoryInput<Invoice, InvoiceOptions>>;
  generatedDepositBills?: Array<FactoryInput<Bill, BillOptions>>;
}

export function newSaveScheduleTasksResult(
  options?: SaveScheduleTasksResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleTasksResult>;
export function newSaveScheduleTasksResult(
  options: SaveScheduleTasksResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScheduleTasksResult> {
  const o = (options.__typename ? options : cache["SaveScheduleTasksResult"] = {}) as SaveScheduleTasksResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScheduleTasksResult";
    o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
    );
    o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
      maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
    );
    o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
      maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
    );
    o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
      maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
    );
    o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
    );
    o.impacted = (options.impacted ?? []).map((i) =>
      maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
    );
    o.resultingDelays = (options.resultingDelays ?? []).map((i) =>
      maybeNew("ResultingDelay", i, cache, options.hasOwnProperty("resultingDelays"))
    );
    o.generatedInvoices = (options.generatedInvoices ?? []).map((i) =>
      maybeNew("Invoice", i, cache, options.hasOwnProperty("generatedInvoices"))
    );
    o.generatedDepositBills = (options.generatedDepositBills ?? []).map((i) =>
      maybeNew("Bill", i, cache, options.hasOwnProperty("generatedDepositBills"))
    );
    return o as FactoryResult<SaveScheduleTasksResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScheduleTasksResult"] = newSaveScheduleTasksResult;

export interface ResultingDelayOptions {
  __typename?: "ResultingDelay";
  scheduleTask?: FactoryInput<ScheduleTask, ScheduleTaskOptions>;
  durationInDays?: ResultingDelay["durationInDays"];
  oldTaskStart?: ResultingDelay["oldTaskStart"];
  oldTaskEnd?: ResultingDelay["oldTaskEnd"];
}

export function newResultingDelay(
  options?: ResultingDelayOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ResultingDelay>;
export function newResultingDelay(
  options: ResultingDelayOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ResultingDelay> {
  const o = (options.__typename ? options : cache["ResultingDelay"] = {}) as ResultingDelay;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ResultingDelay";
    o.scheduleTask = maybeNew("ScheduleTask", options.scheduleTask, cache, options.hasOwnProperty("scheduleTask"));
    o.durationInDays = options.durationInDays ?? 0;
    o.oldTaskStart = options.oldTaskStart ?? newDate();
    o.oldTaskEnd = options.oldTaskEnd ?? newDate();
    return o as FactoryResult<ResultingDelay>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ResultingDelay"] = newResultingDelay;

export interface ScheduleTaskChecklistItemOptions {
  __typename?: "ScheduleTaskChecklistItem";
  id?: ScheduleTaskChecklistItem["id"];
  description?: ScheduleTaskChecklistItem["description"];
  completedAt?: ScheduleTaskChecklistItem["completedAt"];
  createdAt?: ScheduleTaskChecklistItem["createdAt"];
  updatedAt?: ScheduleTaskChecklistItem["updatedAt"];
  completedBy?: FactoryInput<InternalUser, InternalUserOptions> | null;
  isCompleted?: ScheduleTaskChecklistItem["isCompleted"];
  task?: FactoryInput<ScheduleTask, ScheduleTaskOptions>;
  templateChecklistItem?: FactoryInput<ScheduleTaskChecklistItem, ScheduleTaskChecklistItemOptions> | null;
  scheduleTaskChecklistItems?: Array<FactoryInput<ScheduleTaskChecklistItem, ScheduleTaskChecklistItemOptions>>;
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
}

export function newScheduleTaskChecklistItem(
  options?: ScheduleTaskChecklistItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTaskChecklistItem>;
export function newScheduleTaskChecklistItem(
  options: ScheduleTaskChecklistItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleTaskChecklistItem> {
  const o = (options.__typename ? options : cache["ScheduleTaskChecklistItem"] = {}) as ScheduleTaskChecklistItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleTaskChecklistItem";
    o.id = options.id ?? nextFactoryId("ScheduleTaskChecklistItem");
    o.description = options.description ?? "description";
    o.completedAt = options.completedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.completedBy = maybeNewOrNull("InternalUser", options.completedBy, cache);
    o.isCompleted = options.isCompleted ?? false;
    o.task = maybeNew("ScheduleTask", options.task, cache, options.hasOwnProperty("task"));
    o.templateChecklistItem = maybeNewOrNull("ScheduleTaskChecklistItem", options.templateChecklistItem, cache);
    o.scheduleTaskChecklistItems = (options.scheduleTaskChecklistItems ?? []).map((i) =>
      maybeNew("ScheduleTaskChecklistItem", i, cache, options.hasOwnProperty("scheduleTaskChecklistItems"))
    );
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    return o as FactoryResult<ScheduleTaskChecklistItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleTaskChecklistItem"] = newScheduleTaskChecklistItem;

export interface SaveScheduleTaskChecklistItemResultOptions {
  __typename?: "SaveScheduleTaskChecklistItemResult";
  scheduleTaskChecklistItem?: FactoryInput<ScheduleTaskChecklistItem, ScheduleTaskChecklistItemOptions>;
}

export function newSaveScheduleTaskChecklistItemResult(
  options?: SaveScheduleTaskChecklistItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleTaskChecklistItemResult>;
export function newSaveScheduleTaskChecklistItemResult(
  options: SaveScheduleTaskChecklistItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScheduleTaskChecklistItemResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveScheduleTaskChecklistItemResult"] = {}) as SaveScheduleTaskChecklistItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScheduleTaskChecklistItemResult";
    o.scheduleTaskChecklistItem = maybeNew(
      "ScheduleTaskChecklistItem",
      options.scheduleTaskChecklistItem,
      cache,
      options.hasOwnProperty("scheduleTaskChecklistItem"),
    );
    return o as FactoryResult<SaveScheduleTaskChecklistItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScheduleTaskChecklistItemResult"] = newSaveScheduleTaskChecklistItemResult;

export interface ScheduleTaskDependencyOptions {
  __typename?: "ScheduleTaskDependency";
  type?: ScheduleTaskDependency["type"];
  lagInDays?: ScheduleTaskDependency["lagInDays"];
  predecessor?: FactoryInput<ScheduleTask, ScheduleTaskOptions>;
  successor?: FactoryInput<ScheduleTask, ScheduleTaskOptions>;
  id?: ScheduleTaskDependency["id"];
}

export function newScheduleTaskDependency(
  options?: ScheduleTaskDependencyOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTaskDependency>;
export function newScheduleTaskDependency(
  options: ScheduleTaskDependencyOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleTaskDependency> {
  const o = (options.__typename ? options : cache["ScheduleTaskDependency"] = {}) as ScheduleTaskDependency;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleTaskDependency";
    o.type = options.type ?? TaskDependencyType.FinishStart;
    o.lagInDays = options.lagInDays ?? 0;
    o.predecessor = maybeNew("ScheduleTask", options.predecessor, cache, options.hasOwnProperty("predecessor"));
    o.successor = maybeNew("ScheduleTask", options.successor, cache, options.hasOwnProperty("successor"));
    o.id = options.id ?? nextFactoryId("ScheduleTaskDependency");
    return o as FactoryResult<ScheduleTaskDependency>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleTaskDependency"] = newScheduleTaskDependency;

export interface ScheduleTemplateOptions {
  __typename?: "ScheduleTemplate";
  id?: ScheduleTemplate["id"];
  name?: ScheduleTemplate["name"];
  createdAt?: ScheduleTemplate["createdAt"];
  updatedAt?: ScheduleTemplate["updatedAt"];
  status?: ScheduleTemplate["status"];
  statusDetail?: ScheduleTemplateStatusDetailOptions | ScheduleTemplateStatus;
  stage?: ScheduleTemplate["stage"];
  stageDetail?: StageDetailOptions | Stage;
  market?: FactoryInput<Market, MarketOptions> | null;
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
  developments?: Array<FactoryInput<Development, DevelopmentOptions>>;
  itemMappings?: Array<FactoryInput<ScheduleTemplateItemMapping, ScheduleTemplateItemMappingOptions>>;
}

export function newScheduleTemplate(
  options?: ScheduleTemplateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTemplate>;
export function newScheduleTemplate(
  options: ScheduleTemplateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleTemplate> {
  const o = (options.__typename ? options : cache["ScheduleTemplate"] = {}) as ScheduleTemplate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleTemplate";
    o.id = options.id ?? nextFactoryId("ScheduleTemplate");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = options.status ?? ScheduleTemplateStatus.Draft;
    o.statusDetail = enumOrDetailOfScheduleTemplateStatus(options.statusDetail);
    o.stage = options.stage ?? Stage.PreConPlanning;
    o.stageDetail = enumOrDetailOfStage(options.stageDetail);
    o.market = maybeNewOrNull("Market", options.market, cache);
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    o.developments = (options.developments ?? []).map((i) =>
      maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
    );
    o.itemMappings = (options.itemMappings ?? []).map((i) =>
      maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("itemMappings"))
    );
    return o as FactoryResult<ScheduleTemplate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleTemplate"] = newScheduleTemplate;

export interface SaveScheduleTemplatesResultOptions {
  __typename?: "SaveScheduleTemplatesResult";
  scheduleTemplates?: Array<FactoryInput<ScheduleTemplate, ScheduleTemplateOptions>>;
  userErrors?: Array<FactoryInput<UserError, UserErrorOptions>> | null;
}

export function newSaveScheduleTemplatesResult(
  options?: SaveScheduleTemplatesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleTemplatesResult>;
export function newSaveScheduleTemplatesResult(
  options: SaveScheduleTemplatesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScheduleTemplatesResult> {
  const o = (options.__typename ? options : cache["SaveScheduleTemplatesResult"] = {}) as SaveScheduleTemplatesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScheduleTemplatesResult";
    o.scheduleTemplates = (options.scheduleTemplates ?? []).map((i) =>
      maybeNew("ScheduleTemplate", i, cache, options.hasOwnProperty("scheduleTemplates"))
    );
    o.userErrors = (options.userErrors ?? []).map((i) =>
      maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
    );
    return o as FactoryResult<SaveScheduleTemplatesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScheduleTemplatesResult"] = newSaveScheduleTemplatesResult;

export interface DuplicateScheduleTemplateResultOptions {
  __typename?: "DuplicateScheduleTemplateResult";
  scheduleTemplate?: FactoryInput<ScheduleTemplate, ScheduleTemplateOptions> | null;
  userErrors?: Array<FactoryInput<UserError, UserErrorOptions>> | null;
}

export function newDuplicateScheduleTemplateResult(
  options?: DuplicateScheduleTemplateResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DuplicateScheduleTemplateResult>;
export function newDuplicateScheduleTemplateResult(
  options: DuplicateScheduleTemplateResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DuplicateScheduleTemplateResult> {
  const o =
    (options.__typename ? options : cache["DuplicateScheduleTemplateResult"] = {}) as DuplicateScheduleTemplateResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DuplicateScheduleTemplateResult";
    o.scheduleTemplate = maybeNewOrNull("ScheduleTemplate", options.scheduleTemplate, cache);
    o.userErrors = (options.userErrors ?? []).map((i) =>
      maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
    );
    return o as FactoryResult<DuplicateScheduleTemplateResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DuplicateScheduleTemplateResult"] = newDuplicateScheduleTemplateResult;

export interface ApplyScheduleTemplatesResultOptions {
  __typename?: "ApplyScheduleTemplatesResult";
  scheduleParents?: Array<
    | ScheduleParent
    | FactoryResult<ScheduleParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>
  >;
  schedules?: Array<FactoryInput<Schedule, ScheduleOptions>>;
}

export function newApplyScheduleTemplatesResult(
  options?: ApplyScheduleTemplatesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ApplyScheduleTemplatesResult>;
export function newApplyScheduleTemplatesResult(
  options: ApplyScheduleTemplatesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ApplyScheduleTemplatesResult> {
  const o = (options.__typename ? options : cache["ApplyScheduleTemplatesResult"] = {}) as ApplyScheduleTemplatesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ApplyScheduleTemplatesResult";
    o.scheduleParents = (options.scheduleParents ?? []).map((i) =>
      maybeNew(i?.__typename ?? "{StandaloneProject", i, cache, options.hasOwnProperty("scheduleParents"))
    );
    o.schedules = (options.schedules ?? []).map((i) =>
      maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
    );
    return o as FactoryResult<ApplyScheduleTemplatesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ApplyScheduleTemplatesResult"] = newApplyScheduleTemplatesResult;

export interface ScheduleTemplateItemMappingOptions {
  __typename?: "ScheduleTemplateItemMapping";
  id?: ScheduleTemplateItemMapping["id"];
  createdAt?: ScheduleTemplateItemMapping["createdAt"];
  updatedAt?: ScheduleTemplateItemMapping["updatedAt"];
  costType?: CostTypeDetailOptions | CostType;
  item?: FactoryInput<Item, ItemOptions>;
  location?: FactoryInput<Location, LocationOptions>;
  scheduleTemplate?: FactoryInput<ScheduleTemplate, ScheduleTemplateOptions>;
  task?: FactoryInput<Task, TaskOptions>;
}

export function newScheduleTemplateItemMapping(
  options?: ScheduleTemplateItemMappingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTemplateItemMapping>;
export function newScheduleTemplateItemMapping(
  options: ScheduleTemplateItemMappingOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleTemplateItemMapping> {
  const o = (options.__typename ? options : cache["ScheduleTemplateItemMapping"] = {}) as ScheduleTemplateItemMapping;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScheduleTemplateItemMapping";
    o.id = options.id ?? nextFactoryId("ScheduleTemplateItemMapping");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costType = enumOrDetailOfCostType(options.costType);
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.scheduleTemplate = maybeNew(
      "ScheduleTemplate",
      options.scheduleTemplate,
      cache,
      options.hasOwnProperty("scheduleTemplate"),
    );
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    return o as FactoryResult<ScheduleTemplateItemMapping>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScheduleTemplateItemMapping"] = newScheduleTemplateItemMapping;

export interface SaveScheduleTemplateItemMappingsResultOptions {
  __typename?: "SaveScheduleTemplateItemMappingsResult";
  scheduleTemplateItemMappings?: Array<FactoryInput<ScheduleTemplateItemMapping, ScheduleTemplateItemMappingOptions>>;
}

export function newSaveScheduleTemplateItemMappingsResult(
  options?: SaveScheduleTemplateItemMappingsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleTemplateItemMappingsResult>;
export function newSaveScheduleTemplateItemMappingsResult(
  options: SaveScheduleTemplateItemMappingsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScheduleTemplateItemMappingsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveScheduleTemplateItemMappingsResult"] = {}) as SaveScheduleTemplateItemMappingsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScheduleTemplateItemMappingsResult";
    o.scheduleTemplateItemMappings = (options.scheduleTemplateItemMappings ?? []).map((i) =>
      maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("scheduleTemplateItemMappings"))
    );
    return o as FactoryResult<SaveScheduleTemplateItemMappingsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScheduleTemplateItemMappingsResult"] = newSaveScheduleTemplateItemMappingsResult;

export interface SchedulingExclusionDateOptions {
  __typename?: "SchedulingExclusionDate";
  id?: SchedulingExclusionDate["id"];
  date?: SchedulingExclusionDate["date"];
  name?: SchedulingExclusionDate["name"];
  createdAt?: SchedulingExclusionDate["createdAt"];
  updatedAt?: SchedulingExclusionDate["updatedAt"];
  parent?:
    | SchedulingExclusionDateParent
    | FactoryResult<SchedulingExclusionDateParent>
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
}

export function newSchedulingExclusionDate(
  options?: SchedulingExclusionDateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulingExclusionDate>;
export function newSchedulingExclusionDate(
  options: SchedulingExclusionDateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SchedulingExclusionDate> {
  const o = (options.__typename ? options : cache["SchedulingExclusionDate"] = {}) as SchedulingExclusionDate;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SchedulingExclusionDate";
    o.id = options.id ?? nextFactoryId("SchedulingExclusionDate");
    o.date = options.date ?? newDate();
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
    return o as FactoryResult<SchedulingExclusionDate>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SchedulingExclusionDate"] = newSchedulingExclusionDate;

export interface ScopeChangeReasonOptions {
  __typename?: "ScopeChangeReason";
  id?: ScopeChangeReason["id"];
  name?: ScopeChangeReason["name"];
  createdAt?: ScopeChangeReason["createdAt"];
  updatedAt?: ScopeChangeReason["updatedAt"];
}

export function newScopeChangeReason(
  options?: ScopeChangeReasonOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScopeChangeReason>;
export function newScopeChangeReason(
  options: ScopeChangeReasonOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScopeChangeReason> {
  const o = (options.__typename ? options : cache["ScopeChangeReason"] = {}) as ScopeChangeReason;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ScopeChangeReason";
    o.id = options.id ?? nextFactoryId("ScopeChangeReason");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    return o as FactoryResult<ScopeChangeReason>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ScopeChangeReason"] = newScopeChangeReason;

export interface SaveScopeChangeReasonResultOptions {
  __typename?: "SaveScopeChangeReasonResult";
  scopeChangeReason?: FactoryInput<ScopeChangeReason, ScopeChangeReasonOptions>;
}

export function newSaveScopeChangeReasonResult(
  options?: SaveScopeChangeReasonResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScopeChangeReasonResult>;
export function newSaveScopeChangeReasonResult(
  options: SaveScopeChangeReasonResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveScopeChangeReasonResult> {
  const o = (options.__typename ? options : cache["SaveScopeChangeReasonResult"] = {}) as SaveScopeChangeReasonResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveScopeChangeReasonResult";
    o.scopeChangeReason = maybeNew(
      "ScopeChangeReason",
      options.scopeChangeReason,
      cache,
      options.hasOwnProperty("scopeChangeReason"),
    );
    return o as FactoryResult<SaveScopeChangeReasonResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveScopeChangeReasonResult"] = newSaveScopeChangeReasonResult;

export interface SiteSpecificInfoOptions {
  __typename?: "SiteSpecificInfo";
  id?: SiteSpecificInfo["id"];
  description?: SiteSpecificInfo["description"];
  createdAt?: SiteSpecificInfo["createdAt"];
  updatedAt?: SiteSpecificInfo["updatedAt"];
}

export function newSiteSpecificInfo(
  options?: SiteSpecificInfoOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SiteSpecificInfo>;
export function newSiteSpecificInfo(
  options: SiteSpecificInfoOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SiteSpecificInfo> {
  const o = (options.__typename ? options : cache["SiteSpecificInfo"] = {}) as SiteSpecificInfo;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SiteSpecificInfo";
    o.id = options.id ?? nextFactoryId("SiteSpecificInfo");
    o.description = options.description ?? "description";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    return o as FactoryResult<SiteSpecificInfo>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SiteSpecificInfo"] = newSiteSpecificInfo;

export interface SaveSiteSpecificInfoResultOptions {
  __typename?: "SaveSiteSpecificInfoResult";
  siteSpecificInfo?: FactoryInput<SiteSpecificInfo, SiteSpecificInfoOptions>;
}

export function newSaveSiteSpecificInfoResult(
  options?: SaveSiteSpecificInfoResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveSiteSpecificInfoResult>;
export function newSaveSiteSpecificInfoResult(
  options: SaveSiteSpecificInfoResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveSiteSpecificInfoResult> {
  const o = (options.__typename ? options : cache["SaveSiteSpecificInfoResult"] = {}) as SaveSiteSpecificInfoResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveSiteSpecificInfoResult";
    o.siteSpecificInfo = maybeNew(
      "SiteSpecificInfo",
      options.siteSpecificInfo,
      cache,
      options.hasOwnProperty("siteSpecificInfo"),
    );
    return o as FactoryResult<SaveSiteSpecificInfoResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveSiteSpecificInfoResult"] = newSaveSiteSpecificInfoResult;

export interface SaveStructureResultOptions {
  __typename?: "SaveStructureResult";
  structure?: FactoryInput<Structure, StructureOptions>;
}

export function newSaveStructureResult(
  options?: SaveStructureResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveStructureResult>;
export function newSaveStructureResult(
  options: SaveStructureResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveStructureResult> {
  const o = (options.__typename ? options : cache["SaveStructureResult"] = {}) as SaveStructureResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveStructureResult";
    o.structure = maybeNew("Structure", options.structure, cache, options.hasOwnProperty("structure"));
    return o as FactoryResult<SaveStructureResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveStructureResult"] = newSaveStructureResult;

export interface StructuresPageResultOptions {
  __typename?: "StructuresPageResult";
  entities?: Array<FactoryInput<Structure, StructureOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newStructuresPageResult(
  options?: StructuresPageResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<StructuresPageResult>;
export function newStructuresPageResult(
  options: StructuresPageResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<StructuresPageResult> {
  const o = (options.__typename ? options : cache["StructuresPageResult"] = {}) as StructuresPageResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "StructuresPageResult";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("Structure", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<StructuresPageResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["StructuresPageResult"] = newStructuresPageResult;

export interface SaveSubdivisionResultOptions {
  __typename?: "SaveSubdivisionResult";
  subdivision?: FactoryInput<Subdivision, SubdivisionOptions>;
}

export function newSaveSubdivisionResult(
  options?: SaveSubdivisionResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveSubdivisionResult>;
export function newSaveSubdivisionResult(
  options: SaveSubdivisionResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveSubdivisionResult> {
  const o = (options.__typename ? options : cache["SaveSubdivisionResult"] = {}) as SaveSubdivisionResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveSubdivisionResult";
    o.subdivision = maybeNew("Subdivision", options.subdivision, cache, options.hasOwnProperty("subdivision"));
    return o as FactoryResult<SaveSubdivisionResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveSubdivisionResult"] = newSaveSubdivisionResult;

export interface SubmarketOptions {
  __typename?: "Submarket";
  id?: Submarket["id"];
  name?: Submarket["name"];
  createdAt?: Submarket["createdAt"];
  updatedAt?: Submarket["updatedAt"];
  market?: FactoryInput<Market, MarketOptions>;
}

export function newSubmarket(options?: SubmarketOptions, factoryOptions?: FactoryOptions): FactoryResult<Submarket>;
export function newSubmarket(
  options: SubmarketOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<Submarket> {
  const o = (options.__typename ? options : cache["Submarket"] = {}) as Submarket;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "Submarket";
    o.id = options.id ?? nextFactoryId("Submarket");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    return o as FactoryResult<Submarket>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["Submarket"] = newSubmarket;

export interface SaveSubmarketResultOptions {
  __typename?: "SaveSubmarketResult";
  submarket?: FactoryInput<Submarket, SubmarketOptions>;
}

export function newSaveSubmarketResult(
  options?: SaveSubmarketResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveSubmarketResult>;
export function newSaveSubmarketResult(
  options: SaveSubmarketResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveSubmarketResult> {
  const o = (options.__typename ? options : cache["SaveSubmarketResult"] = {}) as SaveSubmarketResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveSubmarketResult";
    o.submarket = maybeNew("Submarket", options.submarket, cache, options.hasOwnProperty("submarket"));
    return o as FactoryResult<SaveSubmarketResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveSubmarketResult"] = newSaveSubmarketResult;

export interface CopyTakeoffLineItemsResultOptions {
  __typename?: "CopyTakeoffLineItemsResult";
  targetReadyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
  sourceReadyPlans?: Array<FactoryInput<ReadyPlan, ReadyPlanOptions>>;
  sourceItems?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  copiedItems?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
}

export function newCopyTakeoffLineItemsResult(
  options?: CopyTakeoffLineItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CopyTakeoffLineItemsResult>;
export function newCopyTakeoffLineItemsResult(
  options: CopyTakeoffLineItemsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CopyTakeoffLineItemsResult> {
  const o = (options.__typename ? options : cache["CopyTakeoffLineItemsResult"] = {}) as CopyTakeoffLineItemsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "CopyTakeoffLineItemsResult";
    o.targetReadyPlan = maybeNew(
      "ReadyPlan",
      options.targetReadyPlan,
      cache,
      options.hasOwnProperty("targetReadyPlan"),
    );
    o.sourceReadyPlans = (options.sourceReadyPlans ?? []).map((i) =>
      maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("sourceReadyPlans"))
    );
    o.sourceItems = (options.sourceItems ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("sourceItems"))
    );
    o.copiedItems = (options.copiedItems ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("copiedItems"))
    );
    return o as FactoryResult<CopyTakeoffLineItemsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["CopyTakeoffLineItemsResult"] = newCopyTakeoffLineItemsResult;

export interface TakeoffLineItemsPageOptions {
  __typename?: "TakeoffLineItemsPage";
  items?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
  groupTotals?: Array<FactoryInput<TakeoffLineItemGroupTotal, TakeoffLineItemGroupTotalOptions>>;
}

export function newTakeoffLineItemsPage(
  options?: TakeoffLineItemsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemsPage>;
export function newTakeoffLineItemsPage(
  options: TakeoffLineItemsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TakeoffLineItemsPage> {
  const o = (options.__typename ? options : cache["TakeoffLineItemsPage"] = {}) as TakeoffLineItemsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TakeoffLineItemsPage";
    o.items = (options.items ?? []).map((i) => maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("items")));
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    o.groupTotals = (options.groupTotals ?? []).map((i) =>
      maybeNew("TakeoffLineItemGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
    );
    return o as FactoryResult<TakeoffLineItemsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TakeoffLineItemsPage"] = newTakeoffLineItemsPage;

export interface TakeoffLineItemGroupTotalOptions {
  __typename?: "TakeoffLineItemGroupTotal";
  groupId?: TakeoffLineItemGroupTotal["groupId"];
  totalCostInCents?: TakeoffLineItemGroupTotal["totalCostInCents"];
  tlisInGroup?: TakeoffLineItemGroupTotal["tlisInGroup"];
  tliIdsInGroup?: TakeoffLineItemGroupTotal["tliIdsInGroup"];
  activeTliIdsInGroup?: TakeoffLineItemGroupTotal["activeTliIdsInGroup"];
  displayName?: TakeoffLineItemGroupTotal["displayName"];
  materialsInGroup?: TakeoffLineItemGroupTotal["materialsInGroup"];
  tasksInGroup?: TakeoffLineItemGroupTotal["tasksInGroup"];
}

export function newTakeoffLineItemGroupTotal(
  options?: TakeoffLineItemGroupTotalOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemGroupTotal>;
export function newTakeoffLineItemGroupTotal(
  options: TakeoffLineItemGroupTotalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TakeoffLineItemGroupTotal> {
  const o = (options.__typename ? options : cache["TakeoffLineItemGroupTotal"] = {}) as TakeoffLineItemGroupTotal;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TakeoffLineItemGroupTotal";
    o.groupId = options.groupId ?? "groupId";
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.tlisInGroup = options.tlisInGroup ?? 0;
    o.tliIdsInGroup = options.tliIdsInGroup ?? [];
    o.activeTliIdsInGroup = options.activeTliIdsInGroup ?? [];
    o.displayName = options.displayName ?? "displayName";
    o.materialsInGroup = options.materialsInGroup ?? 0;
    o.tasksInGroup = options.tasksInGroup ?? 0;
    return o as FactoryResult<TakeoffLineItemGroupTotal>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TakeoffLineItemGroupTotal"] = newTakeoffLineItemGroupTotal;

export interface TakeoffLineItemOptions {
  __typename?: "TakeoffLineItem";
  id?: TakeoffLineItem["id"];
  identityId?: TakeoffLineItem["identityId"];
  active?: TakeoffLineItem["active"];
  name?: TakeoffLineItem["name"];
  displayName?: TakeoffLineItem["displayName"];
  parent?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  customPlaceholderName?: TakeoffLineItem["customPlaceholderName"];
  quantity?: TakeoffLineItem["quantity"];
  totalCostInCents?: TakeoffLineItem["totalCostInCents"];
  unitCostInCents?: TakeoffLineItem["unitCostInCents"];
  isDisabledMaterialVariant?: TakeoffLineItem["isDisabledMaterialVariant"];
  tradePartnerNote?: TakeoffLineItem["tradePartnerNote"];
  internalNote?: TakeoffLineItem["internalNote"];
  specifications?: TakeoffLineItem["specifications"];
  createdAt?: TakeoffLineItem["createdAt"];
  updatedAt?: TakeoffLineItem["updatedAt"];
  costType?: TakeoffLineItem["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  costStatus?: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus;
  placeholder?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions> | null;
  preferredBidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  bidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  bidItemTemplateItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions> | null;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  drop?: FactoryInput<Drop, DropOptions> | null;
  item?: FactoryInput<Item, ItemOptions>;
  slot?: FactoryInput<ItemSlot, ItemSlotOptions>;
  location?: FactoryInput<Location, LocationOptions>;
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  task?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  products?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  rootAssemblyItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions> | null;
  assemblyRootItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions> | null;
  childItems?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  canEdit?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditLocation?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditOptions?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditQuantity?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canEditMaterial?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDuplicate?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDeleteFromDesignPackage?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canHaveActiveProductCards?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  dpSignature?: TakeoffLineItem["dpSignature"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  elevationIds?: TakeoffLineItem["elevationIds"];
  specOptionIds?: TakeoffLineItem["specOptionIds"];
  otherOptionIds?: TakeoffLineItem["otherOptionIds"];
  costEstimate?: FactoryInput<CostEstimate, CostEstimateOptions>;
  isPlaceholderMaterial?: TakeoffLineItem["isPlaceholderMaterial"];
  isProductMaterial?: TakeoffLineItem["isProductMaterial"];
  changeType?: TakeoffLineItem["changeType"];
  previous?: FactoryInput<TakeoffLineItemVersion, TakeoffLineItemVersionOptions> | null;
  planLines?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  personalizationOptionGroup?: FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions> | null;
  personalizationPlaceholderControlledSlots?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  personalizationShadowPlaceholder?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions> | null;
  personalizationIdpShadowPlaceholder?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions> | null;
  personalizationRpoShadowPlaceholder?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions> | null;
  designPackageType?: TakeoffLineItemDesignPackageTypeDetailOptions | TakeoffLineItemDesignPackageType | null;
  targetGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  targetCombinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
  missingCombinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
  designNotes?: Array<FactoryInput<ReadyPlanDesignNote, ReadyPlanDesignNoteOptions>>;
  packageDesignNotes?: TakeoffLineItem["packageDesignNotes"];
  targetPlan?: FactoryInput<PlanPackage, PlanPackageOptions> | null;
  personalizationSlotOrder?: TakeoffLineItem["personalizationSlotOrder"];
  isTaxExempt?: TakeoffLineItem["isTaxExempt"];
  taxableCostInCents?: TakeoffLineItem["taxableCostInCents"];
  taxInCents?: TakeoffLineItem["taxInCents"];
  planPackageIncomingSlots?: Array<FactoryInput<PlanPackageIncomingSlot, PlanPackageIncomingSlotOptions>>;
  managingBidPackage?: FactoryInput<BidPackage, BidPackageOptions> | null;
  action?: TakeoffLineItemActionDetailOptions | TakeoffLineItemAction;
  missingPlanPackages?: Array<FactoryInput<PlanPackage, PlanPackageOptions>>;
}

export function newTakeoffLineItem(
  options?: TakeoffLineItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItem>;
export function newTakeoffLineItem(
  options: TakeoffLineItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TakeoffLineItem> {
  const o = (options.__typename ? options : cache["TakeoffLineItem"] = {}) as TakeoffLineItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TakeoffLineItem";
    o.id = options.id ?? nextFactoryId("TakeoffLineItem");
    o.identityId = options.identityId ?? "identityId";
    o.active = options.active ?? false;
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.parent = maybeNew("ReadyPlanLike", options.parent, cache, options.hasOwnProperty("parent"));
    o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.customPlaceholderName = options.customPlaceholderName ?? null;
    o.quantity = options.quantity ?? null;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.unitCostInCents = options.unitCostInCents ?? 0;
    o.isDisabledMaterialVariant = options.isDisabledMaterialVariant ?? false;
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.internalNote = options.internalNote ?? null;
    o.specifications = options.specifications ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costType = options.costType ?? CostType.Labor;
    o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
    o.costStatus = enumOrDetailOfItemTemplateItemCostStatus(options.costStatus);
    o.placeholder = maybeNewOrNull("TakeoffLineItem", options.placeholder, cache);
    o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
    o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
    o.bidItemTemplateItem = maybeNewOrNull("TakeoffLineItem", options.bidItemTemplateItem, cache);
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.drop = maybeNewOrNull("Drop", options.drop, cache);
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
    o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.products = (options.products ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("products"))
    );
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.rootAssemblyItem = maybeNewOrNull("TakeoffLineItem", options.rootAssemblyItem, cache);
    o.assemblyRootItem = maybeNewOrNull("TakeoffLineItem", options.assemblyRootItem, cache);
    o.childItems = (options.childItems ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("childItems"))
    );
    o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
    o.canEditLocation = maybeNew(
      "PotentialOperation2",
      options.canEditLocation,
      cache,
      options.hasOwnProperty("canEditLocation"),
    );
    o.canEditOptions = maybeNew(
      "PotentialOperation2",
      options.canEditOptions,
      cache,
      options.hasOwnProperty("canEditOptions"),
    );
    o.canEditQuantity = maybeNew(
      "PotentialOperation2",
      options.canEditQuantity,
      cache,
      options.hasOwnProperty("canEditQuantity"),
    );
    o.canEditMaterial = maybeNew(
      "PotentialOperation2",
      options.canEditMaterial,
      cache,
      options.hasOwnProperty("canEditMaterial"),
    );
    o.canDuplicate = maybeNew(
      "PotentialOperation2",
      options.canDuplicate,
      cache,
      options.hasOwnProperty("canDuplicate"),
    );
    o.canDeleteFromDesignPackage = maybeNew(
      "PotentialOperation2",
      options.canDeleteFromDesignPackage,
      cache,
      options.hasOwnProperty("canDeleteFromDesignPackage"),
    );
    o.canHaveActiveProductCards = maybeNew(
      "PotentialOperation2",
      options.canHaveActiveProductCards,
      cache,
      options.hasOwnProperty("canHaveActiveProductCards"),
    );
    o.dpSignature = options.dpSignature ?? "dpSignature";
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.elevationIds = options.elevationIds ?? [];
    o.specOptionIds = options.specOptionIds ?? [];
    o.otherOptionIds = options.otherOptionIds ?? [];
    o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
    o.isPlaceholderMaterial = options.isPlaceholderMaterial ?? false;
    o.isProductMaterial = options.isProductMaterial ?? false;
    o.changeType = options.changeType ?? "changeType";
    o.previous = maybeNewOrNull("TakeoffLineItemVersion", options.previous, cache);
    o.planLines = (options.planLines ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("planLines"))
    );
    o.personalizationOptionGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.personalizationOptionGroup, cache);
    o.personalizationPlaceholderControlledSlots = (options.personalizationPlaceholderControlledSlots ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("personalizationPlaceholderControlledSlots"))
    );
    o.personalizationShadowPlaceholder = maybeNewOrNull(
      "TakeoffLineItem",
      options.personalizationShadowPlaceholder,
      cache,
    );
    o.personalizationIdpShadowPlaceholder = maybeNewOrNull(
      "TakeoffLineItem",
      options.personalizationIdpShadowPlaceholder,
      cache,
    );
    o.personalizationRpoShadowPlaceholder = maybeNewOrNull(
      "TakeoffLineItem",
      options.personalizationRpoShadowPlaceholder,
      cache,
    );
    o.designPackageType = enumOrDetailOrNullOfTakeoffLineItemDesignPackageType(options.designPackageType);
    o.targetGroups = (options.targetGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
    );
    o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
    );
    o.missingCombinations = (options.missingCombinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("missingCombinations"))
    );
    o.designNotes = (options.designNotes ?? []).map((i) =>
      maybeNew("ReadyPlanDesignNote", i, cache, options.hasOwnProperty("designNotes"))
    );
    o.packageDesignNotes = options.packageDesignNotes ?? null;
    o.targetPlan = maybeNewOrNull("PlanPackage", options.targetPlan, cache);
    o.personalizationSlotOrder = options.personalizationSlotOrder ?? null;
    o.isTaxExempt = options.isTaxExempt ?? false;
    o.taxableCostInCents = options.taxableCostInCents ?? 0;
    o.taxInCents = options.taxInCents ?? 0;
    o.planPackageIncomingSlots = (options.planPackageIncomingSlots ?? []).map((i) =>
      maybeNew("PlanPackageIncomingSlot", i, cache, options.hasOwnProperty("planPackageIncomingSlots"))
    );
    o.managingBidPackage = maybeNewOrNull("BidPackage", options.managingBidPackage, cache);
    o.action = enumOrDetailOfTakeoffLineItemAction(options.action);
    o.missingPlanPackages = (options.missingPlanPackages ?? []).map((i) =>
      maybeNew("PlanPackage", i, cache, options.hasOwnProperty("missingPlanPackages"))
    );
    return o as FactoryResult<TakeoffLineItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TakeoffLineItem"] = newTakeoffLineItem;

export interface SaveTakeoffLineItemResultOptions {
  __typename?: "SaveTakeoffLineItemResult";
  version?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  takeoffLineItems?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  autoAddedLaborLines?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  removed?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  deleted?: SaveTakeoffLineItemResult["deleted"];
  groupTotals?: Array<FactoryInput<TakeoffLineItemGroupTotal, TakeoffLineItemGroupTotalOptions>>;
}

export function newSaveTakeoffLineItemResult(
  options?: SaveTakeoffLineItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTakeoffLineItemResult>;
export function newSaveTakeoffLineItemResult(
  options: SaveTakeoffLineItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTakeoffLineItemResult> {
  const o = (options.__typename ? options : cache["SaveTakeoffLineItemResult"] = {}) as SaveTakeoffLineItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTakeoffLineItemResult";
    o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
    o.takeoffLineItems = (options.takeoffLineItems ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("takeoffLineItems"))
    );
    o.autoAddedLaborLines = (options.autoAddedLaborLines ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("autoAddedLaborLines"))
    );
    o.removed = (options.removed ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("removed"))
    );
    o.deleted = options.deleted ?? [];
    o.groupTotals = (options.groupTotals ?? []).map((i) =>
      maybeNew("TakeoffLineItemGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
    );
    return o as FactoryResult<SaveTakeoffLineItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTakeoffLineItemResult"] = newSaveTakeoffLineItemResult;

export interface TakeoffLineItemVersionOptions {
  __typename?: "TakeoffLineItemVersion";
  id?: TakeoffLineItemVersion["id"];
  identityId?: TakeoffLineItemVersion["identityId"];
  quantity?: TakeoffLineItemVersion["quantity"];
  createdAt?: TakeoffLineItemVersion["createdAt"];
  updatedAt?: TakeoffLineItemVersion["updatedAt"];
  specifications?: TakeoffLineItemVersion["specifications"];
  totalCostInCents?: TakeoffLineItemVersion["totalCostInCents"];
  unitCostInCents?: TakeoffLineItemVersion["unitCostInCents"];
  tradePartnerNote?: TakeoffLineItemVersion["tradePartnerNote"];
  internalNote?: TakeoffLineItemVersion["internalNote"];
  name?: TakeoffLineItemVersion["name"];
  displayName?: TakeoffLineItemVersion["displayName"];
  parent?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  readyPlan?: ReadyPlanLike | FactoryResult<ReadyPlanLikeType> | ReadyPlanLikeOptions;
  isDisabledMaterialVariant?: TakeoffLineItemVersion["isDisabledMaterialVariant"];
  placeholder?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions> | null;
  customPlaceholderName?: TakeoffLineItemVersion["customPlaceholderName"];
  costType?: TakeoffLineItemVersion["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  type?: TakeoffLineItemTypeDetailOptions | TakeoffLineItemType;
  preferredBidContractLineItem?: FactoryInput<BidContractLineItem, BidContractLineItemOptions> | null;
  bidItem?: FactoryInput<BidItem, BidItemOptions> | null;
  bidItemTemplateItem?: FactoryInput<TakeoffLineItemVersion, TakeoffLineItemVersionOptions> | null;
  item?: FactoryInput<Item, ItemOptions>;
  slot?: FactoryInput<ItemSlot, ItemSlotOptions>;
  location?: FactoryInput<Location, LocationOptions>;
  unitOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>;
  dpSignature?: TakeoffLineItemVersion["dpSignature"];
  canDeleteFromDesignPackage?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  options?: Array<FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>>;
  costStatus?: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus | null;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  drop?: FactoryInput<Drop, DropOptions> | null;
  task?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions> | null;
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions> | null;
  final?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions> | null;
  first?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  identity?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
  active?: TakeoffLineItemVersion["active"];
  blueprintUrl?: FactoryInput<Url, UrlOptions>;
  elevationIds?: TakeoffLineItemVersion["elevationIds"];
  specOptionIds?: TakeoffLineItemVersion["specOptionIds"];
  otherOptionIds?: TakeoffLineItemVersion["otherOptionIds"];
  costEstimate?: FactoryInput<CostEstimate, CostEstimateOptions>;
  changeType?: TakeoffLineItemVersion["changeType"];
  planLines?: Array<FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>>;
  targetGroups?: Array<FactoryInput<ReadyPlanOptionGroup, ReadyPlanOptionGroupOptions>>;
  targetCombinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
  missingCombinations?: Array<FactoryInput<DesignPackageOptionCombination, DesignPackageOptionCombinationOptions>>;
  packageDesignNotes?: TakeoffLineItemVersion["packageDesignNotes"];
  isTaxExempt?: TakeoffLineItemVersion["isTaxExempt"];
  taxableCostInCents?: TakeoffLineItemVersion["taxableCostInCents"];
  taxInCents?: TakeoffLineItemVersion["taxInCents"];
  action?: TakeoffLineItemActionDetailOptions | TakeoffLineItemAction;
}

export function newTakeoffLineItemVersion(
  options?: TakeoffLineItemVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemVersion>;
export function newTakeoffLineItemVersion(
  options: TakeoffLineItemVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TakeoffLineItemVersion> {
  const o = (options.__typename ? options : cache["TakeoffLineItemVersion"] = {}) as TakeoffLineItemVersion;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TakeoffLineItemVersion";
    o.id = options.id ?? nextFactoryId("TakeoffLineItemVersion");
    o.identityId = options.identityId ?? "identityId";
    o.quantity = options.quantity ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.specifications = options.specifications ?? null;
    o.totalCostInCents = options.totalCostInCents ?? 0;
    o.unitCostInCents = options.unitCostInCents ?? 0;
    o.tradePartnerNote = options.tradePartnerNote ?? null;
    o.internalNote = options.internalNote ?? null;
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.parent = maybeNew("ReadyPlanLike", options.parent, cache, options.hasOwnProperty("parent"));
    o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
    o.isDisabledMaterialVariant = options.isDisabledMaterialVariant ?? false;
    o.placeholder = maybeNewOrNull("TakeoffLineItem", options.placeholder, cache);
    o.customPlaceholderName = options.customPlaceholderName ?? null;
    o.costType = options.costType ?? CostType.Labor;
    o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
    o.type = enumOrDetailOfTakeoffLineItemType(options.type);
    o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
    o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
    o.bidItemTemplateItem = maybeNewOrNull("TakeoffLineItemVersion", options.bidItemTemplateItem, cache);
    o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
    o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
    o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
    o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
    o.dpSignature = options.dpSignature ?? "dpSignature";
    o.canDeleteFromDesignPackage = maybeNew(
      "PotentialOperation2",
      options.canDeleteFromDesignPackage,
      cache,
      options.hasOwnProperty("canDeleteFromDesignPackage"),
    );
    o.options = (options.options ?? []).map((i) =>
      maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
    );
    o.costStatus = enumOrDetailOrNullOfItemTemplateItemCostStatus(options.costStatus);
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.drop = maybeNewOrNull("Drop", options.drop, cache);
    o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
    o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
    o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
    o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
    o.identity = maybeNew("TakeoffLineItem", options.identity, cache, options.hasOwnProperty("identity"));
    o.active = options.active ?? false;
    o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
    o.elevationIds = options.elevationIds ?? [];
    o.specOptionIds = options.specOptionIds ?? [];
    o.otherOptionIds = options.otherOptionIds ?? [];
    o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
    o.changeType = options.changeType ?? "changeType";
    o.planLines = (options.planLines ?? []).map((i) =>
      maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("planLines"))
    );
    o.targetGroups = (options.targetGroups ?? []).map((i) =>
      maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
    );
    o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
    );
    o.missingCombinations = (options.missingCombinations ?? []).map((i) =>
      maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("missingCombinations"))
    );
    o.packageDesignNotes = options.packageDesignNotes ?? null;
    o.isTaxExempt = options.isTaxExempt ?? false;
    o.taxableCostInCents = options.taxableCostInCents ?? 0;
    o.taxInCents = options.taxInCents ?? 0;
    o.action = enumOrDetailOfTakeoffLineItemAction(options.action);
    return o as FactoryResult<TakeoffLineItemVersion>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TakeoffLineItemVersion"] = newTakeoffLineItemVersion;

export interface TaskPageOptions {
  __typename?: "TaskPage";
  tasks?: Array<FactoryInput<Task, TaskOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newTaskPage(options?: TaskPageOptions, factoryOptions?: FactoryOptions): FactoryResult<TaskPage>;
export function newTaskPage(
  options: TaskPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TaskPage> {
  const o = (options.__typename ? options : cache["TaskPage"] = {}) as TaskPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TaskPage";
    o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<TaskPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TaskPage"] = newTaskPage;

export interface TaskDependencyOptions {
  __typename?: "TaskDependency";
  type?: TaskDependency["type"];
  typeDetail?: TaskDependencyTypeDetailOptions | TaskDependencyType;
  lagInDays?: TaskDependency["lagInDays"];
  predecessor?: FactoryInput<Task, TaskOptions>;
  successor?: FactoryInput<Task, TaskOptions>;
}

export function newTaskDependency(
  options?: TaskDependencyOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TaskDependency>;
export function newTaskDependency(
  options: TaskDependencyOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TaskDependency> {
  const o = (options.__typename ? options : cache["TaskDependency"] = {}) as TaskDependency;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TaskDependency";
    o.type = options.type ?? TaskDependencyType.FinishStart;
    o.typeDetail = enumOrDetailOfTaskDependencyType(options.typeDetail);
    o.lagInDays = options.lagInDays ?? 0;
    o.predecessor = maybeNew("Task", options.predecessor, cache, options.hasOwnProperty("predecessor"));
    o.successor = maybeNew("Task", options.successor, cache, options.hasOwnProperty("successor"));
    return o as FactoryResult<TaskDependency>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TaskDependency"] = newTaskDependency;

export interface TaskSnapshotOptions {
  __typename?: "TaskSnapshot";
  id?: TaskSnapshot["id"];
  range?: TaskSnapshot["range"];
  startDate?: TaskSnapshot["startDate"];
  endDate?: TaskSnapshot["endDate"];
  durationInDays?: TaskSnapshot["durationInDays"];
  createdAt?: TaskSnapshot["createdAt"];
  updatedAt?: TaskSnapshot["updatedAt"];
  task?: FactoryInput<Task, TaskOptions>;
}

export function newTaskSnapshot(
  options?: TaskSnapshotOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TaskSnapshot>;
export function newTaskSnapshot(
  options: TaskSnapshotOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TaskSnapshot> {
  const o = (options.__typename ? options : cache["TaskSnapshot"] = {}) as TaskSnapshot;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TaskSnapshot";
    o.id = options.id ?? nextFactoryId("TaskSnapshot");
    o.range = options.range ?? "range";
    o.startDate = options.startDate ?? newDate();
    o.endDate = options.endDate ?? newDate();
    o.durationInDays = options.durationInDays ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    return o as FactoryResult<TaskSnapshot>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TaskSnapshot"] = newTaskSnapshot;

export interface TaskWorkDayOptions {
  __typename?: "TaskWorkDay";
  id?: TaskWorkDay["id"];
  workDay?: TaskWorkDay["workDay"];
  createdAt?: TaskWorkDay["createdAt"];
  updatedAt?: TaskWorkDay["updatedAt"];
  task?: FactoryInput<Task, TaskOptions>;
}

export function newTaskWorkDay(
  options?: TaskWorkDayOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TaskWorkDay>;
export function newTaskWorkDay(
  options: TaskWorkDayOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TaskWorkDay> {
  const o = (options.__typename ? options : cache["TaskWorkDay"] = {}) as TaskWorkDay;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TaskWorkDay";
    o.id = options.id ?? nextFactoryId("TaskWorkDay");
    o.workDay = options.workDay ?? newDate();
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
    return o as FactoryResult<TaskWorkDay>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TaskWorkDay"] = newTaskWorkDay;

export interface SaveTaskWorkDayResultOptions {
  __typename?: "SaveTaskWorkDayResult";
  taskWorkDay?: FactoryInput<TaskWorkDay, TaskWorkDayOptions>;
}

export function newSaveTaskWorkDayResult(
  options?: SaveTaskWorkDayResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTaskWorkDayResult>;
export function newSaveTaskWorkDayResult(
  options: SaveTaskWorkDayResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTaskWorkDayResult> {
  const o = (options.__typename ? options : cache["SaveTaskWorkDayResult"] = {}) as SaveTaskWorkDayResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTaskWorkDayResult";
    o.taskWorkDay = maybeNew("TaskWorkDay", options.taskWorkDay, cache, options.hasOwnProperty("taskWorkDay"));
    return o as FactoryResult<SaveTaskWorkDayResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTaskWorkDayResult"] = newSaveTaskWorkDayResult;

export interface SaveToDosResultOptions {
  __typename?: "SaveToDosResult";
  toDos?: Array<FactoryInput<ToDo, ToDoOptions>>;
}

export function newSaveToDosResult(
  options?: SaveToDosResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveToDosResult>;
export function newSaveToDosResult(
  options: SaveToDosResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveToDosResult> {
  const o = (options.__typename ? options : cache["SaveToDosResult"] = {}) as SaveToDosResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveToDosResult";
    o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
    return o as FactoryResult<SaveToDosResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveToDosResult"] = newSaveToDosResult;

export interface ToDoChecklistProgressOptions {
  __typename?: "ToDoChecklistProgress";
  total?: ToDoChecklistProgress["total"];
  completed?: ToDoChecklistProgress["completed"];
}

export function newToDoChecklistProgress(
  options?: ToDoChecklistProgressOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToDoChecklistProgress>;
export function newToDoChecklistProgress(
  options: ToDoChecklistProgressOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ToDoChecklistProgress> {
  const o = (options.__typename ? options : cache["ToDoChecklistProgress"] = {}) as ToDoChecklistProgress;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ToDoChecklistProgress";
    o.total = options.total ?? 0;
    o.completed = options.completed ?? 0;
    return o as FactoryResult<ToDoChecklistProgress>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ToDoChecklistProgress"] = newToDoChecklistProgress;

export interface ToDoChecklistItemOptions {
  __typename?: "ToDoChecklistItem";
  id?: ToDoChecklistItem["id"];
  description?: ToDoChecklistItem["description"];
  createdAt?: ToDoChecklistItem["createdAt"];
  updatedAt?: ToDoChecklistItem["updatedAt"];
  toDo?: FactoryInput<ToDo, ToDoOptions>;
  isComplete?: ToDoChecklistItem["isComplete"];
}

export function newToDoChecklistItem(
  options?: ToDoChecklistItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToDoChecklistItem>;
export function newToDoChecklistItem(
  options: ToDoChecklistItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ToDoChecklistItem> {
  const o = (options.__typename ? options : cache["ToDoChecklistItem"] = {}) as ToDoChecklistItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ToDoChecklistItem";
    o.id = options.id ?? nextFactoryId("ToDoChecklistItem");
    o.description = options.description ?? "description";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.toDo = maybeNew("ToDo", options.toDo, cache, options.hasOwnProperty("toDo"));
    o.isComplete = options.isComplete ?? false;
    return o as FactoryResult<ToDoChecklistItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ToDoChecklistItem"] = newToDoChecklistItem;

export interface SaveToDoChecklistItemResultOptions {
  __typename?: "SaveToDoChecklistItemResult";
  toDoChecklistItem?: FactoryInput<ToDoChecklistItem, ToDoChecklistItemOptions>;
}

export function newSaveToDoChecklistItemResult(
  options?: SaveToDoChecklistItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveToDoChecklistItemResult>;
export function newSaveToDoChecklistItemResult(
  options: SaveToDoChecklistItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveToDoChecklistItemResult> {
  const o = (options.__typename ? options : cache["SaveToDoChecklistItemResult"] = {}) as SaveToDoChecklistItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveToDoChecklistItemResult";
    o.toDoChecklistItem = maybeNew(
      "ToDoChecklistItem",
      options.toDoChecklistItem,
      cache,
      options.hasOwnProperty("toDoChecklistItem"),
    );
    return o as FactoryResult<SaveToDoChecklistItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveToDoChecklistItemResult"] = newSaveToDoChecklistItemResult;

export interface TrackedJobOptions {
  __typename?: "TrackedJob";
  id?: TrackedJob["id"];
  pollIntervalInMs?: TrackedJob["pollIntervalInMs"];
  progressCurrent?: TrackedJob["progressCurrent"];
  progressTotal?: TrackedJob["progressTotal"];
  progressMessage?: TrackedJob["progressMessage"];
  startedAt?: TrackedJob["startedAt"];
  completedAt?: TrackedJob["completedAt"];
  createdAt?: TrackedJob["createdAt"];
  updatedAt?: TrackedJob["updatedAt"];
  status?: TrackedJobStatusDetailOptions | TrackedJobStatus;
  user?: FactoryInput<User, UserOptions>;
  result?: TrackedJobResult | FactoryResult<TrackedJobResult> | AssetOptions | RequireTypename<BillOcrOptions> | null;
  parent?: TrackedJobParent | FactoryResult<TrackedJobParent> | ProductOfferingOptions | null;
}

export function newTrackedJob(options?: TrackedJobOptions, factoryOptions?: FactoryOptions): FactoryResult<TrackedJob>;
export function newTrackedJob(
  options: TrackedJobOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TrackedJob> {
  const o = (options.__typename ? options : cache["TrackedJob"] = {}) as TrackedJob;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TrackedJob";
    o.id = options.id ?? nextFactoryId("TrackedJob");
    o.pollIntervalInMs = options.pollIntervalInMs ?? 0;
    o.progressCurrent = options.progressCurrent ?? null;
    o.progressTotal = options.progressTotal ?? null;
    o.progressMessage = options.progressMessage ?? null;
    o.startedAt = options.startedAt ?? null;
    o.completedAt = options.completedAt ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = enumOrDetailOfTrackedJobStatus(options.status);
    o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
    o.result = maybeNewOrNull(options.result?.__typename ?? "Asset", options.result, cache);
    o.parent = maybeNewOrNull(options.parent?.__typename ?? "ProductOffering", options.parent, cache);
    return o as FactoryResult<TrackedJob>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TrackedJob"] = newTrackedJob;

export interface TradeCategoryOptions {
  __typename?: "TradeCategory";
  id?: TradeCategory["id"];
  number?: TradeCategory["number"];
  name?: TradeCategory["name"];
  displayName?: TradeCategory["displayName"];
  createdAt?: TradeCategory["createdAt"];
  updatedAt?: TradeCategory["updatedAt"];
  items?: Array<FactoryInput<Item, ItemOptions>>;
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  developmentCommitments?: Array<FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>>;
  leadTimes?: Array<FactoryInput<TradeCategoryLeadTime, TradeCategoryLeadTimeOptions>>;
}

export function newTradeCategory(
  options?: TradeCategoryOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradeCategory>;
export function newTradeCategory(
  options: TradeCategoryOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradeCategory> {
  const o = (options.__typename ? options : cache["TradeCategory"] = {}) as TradeCategory;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradeCategory";
    o.id = options.id ?? nextFactoryId("TradeCategory");
    o.number = options.number ?? "number";
    o.name = options.name ?? "name";
    o.displayName = options.displayName ?? "displayName";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    o.developmentCommitments = (options.developmentCommitments ?? []).map((i) =>
      maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("developmentCommitments"))
    );
    o.leadTimes = (options.leadTimes ?? []).map((i) =>
      maybeNew("TradeCategoryLeadTime", i, cache, options.hasOwnProperty("leadTimes"))
    );
    return o as FactoryResult<TradeCategory>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradeCategory"] = newTradeCategory;

export interface SaveTradeCategoryResultOptions {
  __typename?: "SaveTradeCategoryResult";
  tradeCategory?: FactoryInput<TradeCategory, TradeCategoryOptions>;
}

export function newSaveTradeCategoryResult(
  options?: SaveTradeCategoryResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradeCategoryResult>;
export function newSaveTradeCategoryResult(
  options: SaveTradeCategoryResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradeCategoryResult> {
  const o = (options.__typename ? options : cache["SaveTradeCategoryResult"] = {}) as SaveTradeCategoryResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradeCategoryResult";
    o.tradeCategory = maybeNew("TradeCategory", options.tradeCategory, cache, options.hasOwnProperty("tradeCategory"));
    return o as FactoryResult<SaveTradeCategoryResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradeCategoryResult"] = newSaveTradeCategoryResult;

export interface TradeCategoryLeadTimeDefaultOptions {
  __typename?: "TradeCategoryLeadTimeDefault";
  leadTimeInDays?: TradeCategoryLeadTimeDefault["leadTimeInDays"];
  market?: FactoryInput<Market, MarketOptions>;
  tradeCategory?: FactoryInput<TradeCategory, TradeCategoryOptions>;
  leadTimeFrequency?: TimeFrequencyDetailOptions | TimeFrequency;
}

export function newTradeCategoryLeadTimeDefault(
  options?: TradeCategoryLeadTimeDefaultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradeCategoryLeadTimeDefault>;
export function newTradeCategoryLeadTimeDefault(
  options: TradeCategoryLeadTimeDefaultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradeCategoryLeadTimeDefault> {
  const o = (options.__typename ? options : cache["TradeCategoryLeadTimeDefault"] = {}) as TradeCategoryLeadTimeDefault;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradeCategoryLeadTimeDefault";
    o.leadTimeInDays = options.leadTimeInDays ?? 0;
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.tradeCategory = maybeNew("TradeCategory", options.tradeCategory, cache, options.hasOwnProperty("tradeCategory"));
    o.leadTimeFrequency = enumOrDetailOfTimeFrequency(options.leadTimeFrequency);
    return o as FactoryResult<TradeCategoryLeadTimeDefault>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradeCategoryLeadTimeDefault"] = newTradeCategoryLeadTimeDefault;

export interface TradeCategoryLeadTimeOptions {
  __typename?: "TradeCategoryLeadTime";
  id?: TradeCategoryLeadTime["id"];
  leadTimeInDays?: TradeCategoryLeadTime["leadTimeInDays"];
  createdAt?: TradeCategoryLeadTime["createdAt"];
  updatedAt?: TradeCategoryLeadTime["updatedAt"];
  leadTimeFrequency?: TimeFrequencyDetailOptions | TimeFrequency;
  market?: FactoryInput<Market, MarketOptions>;
  tradeCategory?: FactoryInput<TradeCategory, TradeCategoryOptions>;
}

export function newTradeCategoryLeadTime(
  options?: TradeCategoryLeadTimeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradeCategoryLeadTime>;
export function newTradeCategoryLeadTime(
  options: TradeCategoryLeadTimeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradeCategoryLeadTime> {
  const o = (options.__typename ? options : cache["TradeCategoryLeadTime"] = {}) as TradeCategoryLeadTime;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradeCategoryLeadTime";
    o.id = options.id ?? nextFactoryId("TradeCategoryLeadTime");
    o.leadTimeInDays = options.leadTimeInDays ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.leadTimeFrequency = enumOrDetailOfTimeFrequency(options.leadTimeFrequency);
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.tradeCategory = maybeNew("TradeCategory", options.tradeCategory, cache, options.hasOwnProperty("tradeCategory"));
    return o as FactoryResult<TradeCategoryLeadTime>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradeCategoryLeadTime"] = newTradeCategoryLeadTime;

export interface SaveTradeCategoryLeadTimesResultOptions {
  __typename?: "SaveTradeCategoryLeadTimesResult";
  tradeCategoryLeadTimes?: Array<FactoryInput<TradeCategoryLeadTime, TradeCategoryLeadTimeOptions>>;
}

export function newSaveTradeCategoryLeadTimesResult(
  options?: SaveTradeCategoryLeadTimesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradeCategoryLeadTimesResult>;
export function newSaveTradeCategoryLeadTimesResult(
  options: SaveTradeCategoryLeadTimesResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradeCategoryLeadTimesResult> {
  const o =
    (options.__typename ? options : cache["SaveTradeCategoryLeadTimesResult"] = {}) as SaveTradeCategoryLeadTimesResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradeCategoryLeadTimesResult";
    o.tradeCategoryLeadTimes = (options.tradeCategoryLeadTimes ?? []).map((i) =>
      maybeNew("TradeCategoryLeadTime", i, cache, options.hasOwnProperty("tradeCategoryLeadTimes"))
    );
    return o as FactoryResult<SaveTradeCategoryLeadTimesResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradeCategoryLeadTimesResult"] = newSaveTradeCategoryLeadTimesResult;

export interface SaveTradePartnerResultOptions {
  __typename?: "SaveTradePartnerResult";
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
}

export function newSaveTradePartnerResult(
  options?: SaveTradePartnerResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradePartnerResult>;
export function newSaveTradePartnerResult(
  options: SaveTradePartnerResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradePartnerResult> {
  const o = (options.__typename ? options : cache["SaveTradePartnerResult"] = {}) as SaveTradePartnerResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradePartnerResult";
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    return o as FactoryResult<SaveTradePartnerResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradePartnerResult"] = newSaveTradePartnerResult;

export interface SaveTradePartnersResultOptions {
  __typename?: "SaveTradePartnersResult";
  tradePartners?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
}

export function newSaveTradePartnersResult(
  options?: SaveTradePartnersResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradePartnersResult>;
export function newSaveTradePartnersResult(
  options: SaveTradePartnersResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradePartnersResult> {
  const o = (options.__typename ? options : cache["SaveTradePartnersResult"] = {}) as SaveTradePartnersResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradePartnersResult";
    o.tradePartners = (options.tradePartners ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
    );
    return o as FactoryResult<SaveTradePartnersResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradePartnersResult"] = newSaveTradePartnersResult;

export interface TradePartnersPageOptions {
  __typename?: "TradePartnersPage";
  entities?: Array<FactoryInput<TradePartner, TradePartnerOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newTradePartnersPage(
  options?: TradePartnersPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnersPage>;
export function newTradePartnersPage(
  options: TradePartnersPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnersPage> {
  const o = (options.__typename ? options : cache["TradePartnersPage"] = {}) as TradePartnersPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnersPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("TradePartner", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<TradePartnersPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnersPage"] = newTradePartnersPage;

export interface TradePartnerAgreementOptions {
  __typename?: "TradePartnerAgreement";
  id?: TradePartnerAgreement["id"];
  isNationalAgreement?: TradePartnerAgreement["isNationalAgreement"];
  internalNote?: TradePartnerAgreement["internalNote"];
  createdAt?: TradePartnerAgreement["createdAt"];
  updatedAt?: TradePartnerAgreement["updatedAt"];
  costDivision?: FactoryInput<CostDivision, CostDivisionOptions>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
}

export function newTradePartnerAgreement(
  options?: TradePartnerAgreementOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAgreement>;
export function newTradePartnerAgreement(
  options: TradePartnerAgreementOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerAgreement> {
  const o = (options.__typename ? options : cache["TradePartnerAgreement"] = {}) as TradePartnerAgreement;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerAgreement";
    o.id = options.id ?? nextFactoryId("TradePartnerAgreement");
    o.isNationalAgreement = options.isNationalAgreement ?? false;
    o.internalNote = options.internalNote ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.costDivision = maybeNew("CostDivision", options.costDivision, cache, options.hasOwnProperty("costDivision"));
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    return o as FactoryResult<TradePartnerAgreement>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerAgreement"] = newTradePartnerAgreement;

export interface SaveTradePartnerAgreementResultOptions {
  __typename?: "SaveTradePartnerAgreementResult";
  tradePartnerAgreement?: FactoryInput<TradePartnerAgreement, TradePartnerAgreementOptions>;
}

export function newSaveTradePartnerAgreementResult(
  options?: SaveTradePartnerAgreementResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradePartnerAgreementResult>;
export function newSaveTradePartnerAgreementResult(
  options: SaveTradePartnerAgreementResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradePartnerAgreementResult> {
  const o =
    (options.__typename ? options : cache["SaveTradePartnerAgreementResult"] = {}) as SaveTradePartnerAgreementResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradePartnerAgreementResult";
    o.tradePartnerAgreement = maybeNew(
      "TradePartnerAgreement",
      options.tradePartnerAgreement,
      cache,
      options.hasOwnProperty("tradePartnerAgreement"),
    );
    return o as FactoryResult<SaveTradePartnerAgreementResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradePartnerAgreementResult"] = newSaveTradePartnerAgreementResult;

export interface DeleteTradePartnerAgreementResultOptions {
  __typename?: "DeleteTradePartnerAgreementResult";
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
}

export function newDeleteTradePartnerAgreementResult(
  options?: DeleteTradePartnerAgreementResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteTradePartnerAgreementResult>;
export function newDeleteTradePartnerAgreementResult(
  options: DeleteTradePartnerAgreementResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteTradePartnerAgreementResult> {
  const o =
    (options.__typename
      ? options
      : cache["DeleteTradePartnerAgreementResult"] = {}) as DeleteTradePartnerAgreementResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteTradePartnerAgreementResult";
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    return o as FactoryResult<DeleteTradePartnerAgreementResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteTradePartnerAgreementResult"] = newDeleteTradePartnerAgreementResult;

export interface TradePartnerAvailabilityRequestEmailPreviewOptions {
  __typename?: "TradePartnerAvailabilityRequestEmailPreview";
  subject?: TradePartnerAvailabilityRequestEmailPreview["subject"];
  message?: TradePartnerAvailabilityRequestEmailPreview["message"];
}

export function newTradePartnerAvailabilityRequestEmailPreview(
  options?: TradePartnerAvailabilityRequestEmailPreviewOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequestEmailPreview>;
export function newTradePartnerAvailabilityRequestEmailPreview(
  options: TradePartnerAvailabilityRequestEmailPreviewOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerAvailabilityRequestEmailPreview> {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestEmailPreview"] = {}) as TradePartnerAvailabilityRequestEmailPreview;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerAvailabilityRequestEmailPreview";
    o.subject = options.subject ?? "subject";
    o.message = options.message ?? "message";
    return o as FactoryResult<TradePartnerAvailabilityRequestEmailPreview>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerAvailabilityRequestEmailPreview"] = newTradePartnerAvailabilityRequestEmailPreview;

export interface SaveTradePartnerAvailabilityRequestResultOptions {
  __typename?: "SaveTradePartnerAvailabilityRequestResult";
  tradePartnerAvailabilityRequest?: FactoryInput<
    TradePartnerAvailabilityRequest,
    TradePartnerAvailabilityRequestOptions
  >;
}

export function newSaveTradePartnerAvailabilityRequestResult(
  options?: SaveTradePartnerAvailabilityRequestResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradePartnerAvailabilityRequestResult>;
export function newSaveTradePartnerAvailabilityRequestResult(
  options: SaveTradePartnerAvailabilityRequestResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradePartnerAvailabilityRequestResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerAvailabilityRequestResult"] = {}) as SaveTradePartnerAvailabilityRequestResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradePartnerAvailabilityRequestResult";
    o.tradePartnerAvailabilityRequest = maybeNew(
      "TradePartnerAvailabilityRequest",
      options.tradePartnerAvailabilityRequest,
      cache,
      options.hasOwnProperty("tradePartnerAvailabilityRequest"),
    );
    return o as FactoryResult<SaveTradePartnerAvailabilityRequestResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradePartnerAvailabilityRequestResult"] = newSaveTradePartnerAvailabilityRequestResult;

export interface SaveTradePartnerAvailabilityRequestsResultOptions {
  __typename?: "SaveTradePartnerAvailabilityRequestsResult";
  tradePartnerAvailabilityRequests?: Array<
    FactoryInput<TradePartnerAvailabilityRequest, TradePartnerAvailabilityRequestOptions>
  >;
}

export function newSaveTradePartnerAvailabilityRequestsResult(
  options?: SaveTradePartnerAvailabilityRequestsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradePartnerAvailabilityRequestsResult>;
export function newSaveTradePartnerAvailabilityRequestsResult(
  options: SaveTradePartnerAvailabilityRequestsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradePartnerAvailabilityRequestsResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerAvailabilityRequestsResult"] = {}) as SaveTradePartnerAvailabilityRequestsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradePartnerAvailabilityRequestsResult";
    o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
      maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
    );
    return o as FactoryResult<SaveTradePartnerAvailabilityRequestsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradePartnerAvailabilityRequestsResult"] = newSaveTradePartnerAvailabilityRequestsResult;

export interface TradePartnerAvailabilityRequestEmailOptions {
  __typename?: "TradePartnerAvailabilityRequestEmail";
  id?: TradePartnerAvailabilityRequestEmail["id"];
  subject?: TradePartnerAvailabilityRequestEmail["subject"];
  message?: TradePartnerAvailabilityRequestEmail["message"];
  additionalNotes?: TradePartnerAvailabilityRequestEmail["additionalNotes"];
  createdAt?: TradePartnerAvailabilityRequestEmail["createdAt"];
  updatedAt?: TradePartnerAvailabilityRequestEmail["updatedAt"];
  tradePartnerAvailabilityRequest?: FactoryInput<
    TradePartnerAvailabilityRequest,
    TradePartnerAvailabilityRequestOptions
  >;
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
}

export function newTradePartnerAvailabilityRequestEmail(
  options?: TradePartnerAvailabilityRequestEmailOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequestEmail>;
export function newTradePartnerAvailabilityRequestEmail(
  options: TradePartnerAvailabilityRequestEmailOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerAvailabilityRequestEmail> {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestEmail"] = {}) as TradePartnerAvailabilityRequestEmail;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerAvailabilityRequestEmail";
    o.id = options.id ?? nextFactoryId("TradePartnerAvailabilityRequestEmail");
    o.subject = options.subject ?? "subject";
    o.message = options.message ?? "message";
    o.additionalNotes = options.additionalNotes ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tradePartnerAvailabilityRequest = maybeNew(
      "TradePartnerAvailabilityRequest",
      options.tradePartnerAvailabilityRequest,
      cache,
      options.hasOwnProperty("tradePartnerAvailabilityRequest"),
    );
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    return o as FactoryResult<TradePartnerAvailabilityRequestEmail>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerAvailabilityRequestEmail"] = newTradePartnerAvailabilityRequestEmail;

export interface TradePartnerAvailabilityRequestTextMessageOptions {
  __typename?: "TradePartnerAvailabilityRequestTextMessage";
  id?: TradePartnerAvailabilityRequestTextMessage["id"];
  body?: TradePartnerAvailabilityRequestTextMessage["body"];
  createdAt?: TradePartnerAvailabilityRequestTextMessage["createdAt"];
  updatedAt?: TradePartnerAvailabilityRequestTextMessage["updatedAt"];
  tradePartnerAvailabilityRequest?: FactoryInput<
    TradePartnerAvailabilityRequest,
    TradePartnerAvailabilityRequestOptions
  >;
}

export function newTradePartnerAvailabilityRequestTextMessage(
  options?: TradePartnerAvailabilityRequestTextMessageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequestTextMessage>;
export function newTradePartnerAvailabilityRequestTextMessage(
  options: TradePartnerAvailabilityRequestTextMessageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerAvailabilityRequestTextMessage> {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestTextMessage"] = {}) as TradePartnerAvailabilityRequestTextMessage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerAvailabilityRequestTextMessage";
    o.id = options.id ?? nextFactoryId("TradePartnerAvailabilityRequestTextMessage");
    o.body = options.body ?? "body";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tradePartnerAvailabilityRequest = maybeNew(
      "TradePartnerAvailabilityRequest",
      options.tradePartnerAvailabilityRequest,
      cache,
      options.hasOwnProperty("tradePartnerAvailabilityRequest"),
    );
    return o as FactoryResult<TradePartnerAvailabilityRequestTextMessage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerAvailabilityRequestTextMessage"] = newTradePartnerAvailabilityRequestTextMessage;

export interface TradePartnerContactOptions {
  __typename?: "TradePartnerContact";
  id?: TradePartnerContact["id"];
  isPrimary?: TradePartnerContact["isPrimary"];
  isBillingSignatory?: TradePartnerContact["isBillingSignatory"];
  name?: TradePartnerContact["name"];
  email?: TradePartnerContact["email"];
  officePhone?: TradePartnerContact["officePhone"];
  mobilePhone?: TradePartnerContact["mobilePhone"];
  canDelete?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  canDeactivate?: FactoryInput<PotentialOperation2, PotentialOperation2Options>;
  createdAt?: TradePartnerContact["createdAt"];
  updatedAt?: TradePartnerContact["updatedAt"];
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  title?: TradePartnerContact["title"];
  maybeBillingSignatory?: TradePartnerContact["maybeBillingSignatory"];
  address?: FactoryInput<Address, AddressOptions> | null;
  markets?: Array<FactoryInput<Market, MarketOptions>>;
  tradePartnerMailingLists?: Array<FactoryInput<TradePartnerMailingList, TradePartnerMailingListOptions>>;
  mailingLists?: Array<FactoryInput<TradePartnerMailingList, TradePartnerMailingListOptions>>;
  tradePartnerUser?: FactoryInput<TradePartnerUser, TradePartnerUserOptions> | null;
  tradePartnerMarketContacts?: Array<FactoryInput<TradePartnerMarketContact, TradePartnerMarketContactOptions>>;
  canLoginToPortal?: TradePartnerContact["canLoginToPortal"];
  isActive?: TradePartnerContact["isActive"];
  isSmsEnabled?: TradePartnerContact["isSmsEnabled"];
}

export function newTradePartnerContact(
  options?: TradePartnerContactOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerContact>;
export function newTradePartnerContact(
  options: TradePartnerContactOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerContact> {
  const o = (options.__typename ? options : cache["TradePartnerContact"] = {}) as TradePartnerContact;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerContact";
    o.id = options.id ?? nextFactoryId("TradePartnerContact");
    o.isPrimary = options.isPrimary ?? false;
    o.isBillingSignatory = options.isBillingSignatory ?? false;
    o.name = options.name ?? "name";
    o.email = options.email ?? null;
    o.officePhone = options.officePhone ?? null;
    o.mobilePhone = options.mobilePhone ?? null;
    o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
    o.canDeactivate = maybeNew(
      "PotentialOperation2",
      options.canDeactivate,
      cache,
      options.hasOwnProperty("canDeactivate"),
    );
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.title = options.title ?? null;
    o.maybeBillingSignatory = options.maybeBillingSignatory ?? false;
    o.address = maybeNewOrNull("Address", options.address, cache);
    o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
    o.tradePartnerMailingLists = (options.tradePartnerMailingLists ?? []).map((i) =>
      maybeNew("TradePartnerMailingList", i, cache, options.hasOwnProperty("tradePartnerMailingLists"))
    );
    o.mailingLists = (options.mailingLists ?? []).map((i) =>
      maybeNew("TradePartnerMailingList", i, cache, options.hasOwnProperty("mailingLists"))
    );
    o.tradePartnerUser = maybeNewOrNull("TradePartnerUser", options.tradePartnerUser, cache);
    o.tradePartnerMarketContacts = (options.tradePartnerMarketContacts ?? []).map((i) =>
      maybeNew("TradePartnerMarketContact", i, cache, options.hasOwnProperty("tradePartnerMarketContacts"))
    );
    o.canLoginToPortal = options.canLoginToPortal ?? false;
    o.isActive = options.isActive ?? false;
    o.isSmsEnabled = options.isSmsEnabled ?? false;
    return o as FactoryResult<TradePartnerContact>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerContact"] = newTradePartnerContact;

export interface SaveTradePartnerContactResultOptions {
  __typename?: "SaveTradePartnerContactResult";
  tradePartnerContact?: FactoryInput<TradePartnerContact, TradePartnerContactOptions>;
}

export function newSaveTradePartnerContactResult(
  options?: SaveTradePartnerContactResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradePartnerContactResult>;
export function newSaveTradePartnerContactResult(
  options: SaveTradePartnerContactResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradePartnerContactResult> {
  const o =
    (options.__typename ? options : cache["SaveTradePartnerContactResult"] = {}) as SaveTradePartnerContactResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradePartnerContactResult";
    o.tradePartnerContact = maybeNew(
      "TradePartnerContact",
      options.tradePartnerContact,
      cache,
      options.hasOwnProperty("tradePartnerContact"),
    );
    return o as FactoryResult<SaveTradePartnerContactResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradePartnerContactResult"] = newSaveTradePartnerContactResult;

export interface DeleteTradePartnerContactResultOptions {
  __typename?: "DeleteTradePartnerContactResult";
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  tradePartnerContact?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
}

export function newDeleteTradePartnerContactResult(
  options?: DeleteTradePartnerContactResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteTradePartnerContactResult>;
export function newDeleteTradePartnerContactResult(
  options: DeleteTradePartnerContactResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteTradePartnerContactResult> {
  const o =
    (options.__typename ? options : cache["DeleteTradePartnerContactResult"] = {}) as DeleteTradePartnerContactResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteTradePartnerContactResult";
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.tradePartnerContact = maybeNewOrNull("TradePartnerContact", options.tradePartnerContact, cache);
    return o as FactoryResult<DeleteTradePartnerContactResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteTradePartnerContactResult"] = newDeleteTradePartnerContactResult;

export interface MarketContactWithRolesOptions {
  __typename?: "MarketContactWithRoles";
  contact?: FactoryInput<TradePartnerContact, TradePartnerContactOptions>;
  roles?: MarketContactWithRoles["roles"];
}

export function newMarketContactWithRoles(
  options?: MarketContactWithRolesOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MarketContactWithRoles>;
export function newMarketContactWithRoles(
  options: MarketContactWithRolesOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MarketContactWithRoles> {
  const o = (options.__typename ? options : cache["MarketContactWithRoles"] = {}) as MarketContactWithRoles;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "MarketContactWithRoles";
    o.contact = maybeNew("TradePartnerContact", options.contact, cache, options.hasOwnProperty("contact"));
    o.roles = options.roles ?? [];
    return o as FactoryResult<MarketContactWithRoles>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["MarketContactWithRoles"] = newMarketContactWithRoles;

export interface TradePartnerMailingListOptions {
  __typename?: "TradePartnerMailingList";
  id?: TradePartnerMailingList["id"];
  name?: TradePartnerMailingList["name"];
  createdAt?: TradePartnerMailingList["createdAt"];
  updatedAt?: TradePartnerMailingList["updatedAt"];
  tradePartnerContacts?: Array<FactoryInput<TradePartnerContact, TradePartnerContactOptions>>;
}

export function newTradePartnerMailingList(
  options?: TradePartnerMailingListOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerMailingList>;
export function newTradePartnerMailingList(
  options: TradePartnerMailingListOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerMailingList> {
  const o = (options.__typename ? options : cache["TradePartnerMailingList"] = {}) as TradePartnerMailingList;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerMailingList";
    o.id = options.id ?? nextFactoryId("TradePartnerMailingList");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tradePartnerContacts = (options.tradePartnerContacts ?? []).map((i) =>
      maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("tradePartnerContacts"))
    );
    return o as FactoryResult<TradePartnerMailingList>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerMailingList"] = newTradePartnerMailingList;

export interface TradePartnerMarketContactOptions {
  __typename?: "TradePartnerMarketContact";
  id?: TradePartnerMarketContact["id"];
  createdAt?: TradePartnerMarketContact["createdAt"];
  updatedAt?: TradePartnerMarketContact["updatedAt"];
  role?: TradePartnerMarketRoleDetailOptions | TradePartnerMarketRole;
  market?: FactoryInput<Market, MarketOptions>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  contact?: FactoryInput<TradePartnerContact, TradePartnerContactOptions>;
}

export function newTradePartnerMarketContact(
  options?: TradePartnerMarketContactOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerMarketContact>;
export function newTradePartnerMarketContact(
  options: TradePartnerMarketContactOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerMarketContact> {
  const o = (options.__typename ? options : cache["TradePartnerMarketContact"] = {}) as TradePartnerMarketContact;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerMarketContact";
    o.id = options.id ?? nextFactoryId("TradePartnerMarketContact");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.role = enumOrDetailOfTradePartnerMarketRole(options.role);
    o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.contact = maybeNew("TradePartnerContact", options.contact, cache, options.hasOwnProperty("contact"));
    return o as FactoryResult<TradePartnerMarketContact>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerMarketContact"] = newTradePartnerMarketContact;

export interface SaveTradePartnerMarketContactResultOptions {
  __typename?: "SaveTradePartnerMarketContactResult";
  tradePartnerMarketContact?: FactoryInput<TradePartnerMarketContact, TradePartnerMarketContactOptions>;
}

export function newSaveTradePartnerMarketContactResult(
  options?: SaveTradePartnerMarketContactResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradePartnerMarketContactResult>;
export function newSaveTradePartnerMarketContactResult(
  options: SaveTradePartnerMarketContactResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradePartnerMarketContactResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerMarketContactResult"] = {}) as SaveTradePartnerMarketContactResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradePartnerMarketContactResult";
    o.tradePartnerMarketContact = maybeNew(
      "TradePartnerMarketContact",
      options.tradePartnerMarketContact,
      cache,
      options.hasOwnProperty("tradePartnerMarketContact"),
    );
    return o as FactoryResult<SaveTradePartnerMarketContactResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradePartnerMarketContactResult"] = newSaveTradePartnerMarketContactResult;

export interface DeleteTradePartnerMarketContactResultOptions {
  __typename?: "DeleteTradePartnerMarketContactResult";
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
}

export function newDeleteTradePartnerMarketContactResult(
  options?: DeleteTradePartnerMarketContactResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteTradePartnerMarketContactResult>;
export function newDeleteTradePartnerMarketContactResult(
  options: DeleteTradePartnerMarketContactResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeleteTradePartnerMarketContactResult> {
  const o =
    (options.__typename
      ? options
      : cache["DeleteTradePartnerMarketContactResult"] = {}) as DeleteTradePartnerMarketContactResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeleteTradePartnerMarketContactResult";
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    return o as FactoryResult<DeleteTradePartnerMarketContactResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeleteTradePartnerMarketContactResult"] = newDeleteTradePartnerMarketContactResult;

export interface TradePartnerRequirementOptions {
  __typename?: "TradePartnerRequirement";
  id?: TradePartnerRequirement["id"];
  signedDate?: TradePartnerRequirement["signedDate"];
  expirationDate?: TradePartnerRequirement["expirationDate"];
  licenseNumber?: TradePartnerRequirement["licenseNumber"];
  coverageAmountInCents?: TradePartnerRequirement["coverageAmountInCents"];
  createdAt?: TradePartnerRequirement["createdAt"];
  updatedAt?: TradePartnerRequirement["updatedAt"];
  type?: TradePartnerRequirementTypeDetailOptions | TradePartnerRequirementType;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  status?: TradePartnerRequirementStatusDetailOptions | TradePartnerRequirementStatus;
  internalNote?: TradePartnerRequirement["internalNote"];
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
}

export function newTradePartnerRequirement(
  options?: TradePartnerRequirementOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerRequirement>;
export function newTradePartnerRequirement(
  options: TradePartnerRequirementOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerRequirement> {
  const o = (options.__typename ? options : cache["TradePartnerRequirement"] = {}) as TradePartnerRequirement;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerRequirement";
    o.id = options.id ?? nextFactoryId("TradePartnerRequirement");
    o.signedDate = options.signedDate ?? null;
    o.expirationDate = options.expirationDate ?? null;
    o.licenseNumber = options.licenseNumber ?? null;
    o.coverageAmountInCents = options.coverageAmountInCents ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.type = enumOrDetailOfTradePartnerRequirementType(options.type);
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.status = enumOrDetailOfTradePartnerRequirementStatus(options.status);
    o.internalNote = options.internalNote ?? null;
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    return o as FactoryResult<TradePartnerRequirement>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerRequirement"] = newTradePartnerRequirement;

export interface SaveTradePartnerRequirementResultOptions {
  __typename?: "SaveTradePartnerRequirementResult";
  tradePartnerRequirement?: FactoryInput<TradePartnerRequirement, TradePartnerRequirementOptions>;
}

export function newSaveTradePartnerRequirementResult(
  options?: SaveTradePartnerRequirementResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradePartnerRequirementResult>;
export function newSaveTradePartnerRequirementResult(
  options: SaveTradePartnerRequirementResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradePartnerRequirementResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerRequirementResult"] = {}) as SaveTradePartnerRequirementResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradePartnerRequirementResult";
    o.tradePartnerRequirement = maybeNew(
      "TradePartnerRequirement",
      options.tradePartnerRequirement,
      cache,
      options.hasOwnProperty("tradePartnerRequirement"),
    );
    return o as FactoryResult<SaveTradePartnerRequirementResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradePartnerRequirementResult"] = newSaveTradePartnerRequirementResult;

export interface TradePartnerReviewOptions {
  __typename?: "TradePartnerReview";
  id?: TradePartnerReview["id"];
  recommended?: TradePartnerReview["recommended"];
  score?: TradePartnerReview["score"];
  createdAt?: TradePartnerReview["createdAt"];
  internalUser?: FactoryInput<InternalUser, InternalUserOptions>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions;
  internalNote?: TradePartnerReview["internalNote"];
}

export function newTradePartnerReview(
  options?: TradePartnerReviewOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerReview>;
export function newTradePartnerReview(
  options: TradePartnerReviewOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerReview> {
  const o = (options.__typename ? options : cache["TradePartnerReview"] = {}) as TradePartnerReview;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerReview";
    o.id = options.id ?? nextFactoryId("TradePartnerReview");
    o.recommended = options.recommended ?? null;
    o.score = options.score ?? 0;
    o.createdAt = options.createdAt ?? newDateTime();
    o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
    o.internalNote = options.internalNote ?? null;
    return o as FactoryResult<TradePartnerReview>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerReview"] = newTradePartnerReview;

export interface SaveTradePartnerReviewResultOptions {
  __typename?: "SaveTradePartnerReviewResult";
  tradePartnerReview?: FactoryInput<TradePartnerReview, TradePartnerReviewOptions>;
}

export function newSaveTradePartnerReviewResult(
  options?: SaveTradePartnerReviewResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveTradePartnerReviewResult>;
export function newSaveTradePartnerReviewResult(
  options: SaveTradePartnerReviewResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveTradePartnerReviewResult> {
  const o = (options.__typename ? options : cache["SaveTradePartnerReviewResult"] = {}) as SaveTradePartnerReviewResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveTradePartnerReviewResult";
    o.tradePartnerReview = maybeNew(
      "TradePartnerReview",
      options.tradePartnerReview,
      cache,
      options.hasOwnProperty("tradePartnerReview"),
    );
    return o as FactoryResult<SaveTradePartnerReviewResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveTradePartnerReviewResult"] = newSaveTradePartnerReviewResult;

export interface TradePartnerUserOptions {
  __typename?: "TradePartnerUser";
  id?: TradePartnerUser["id"];
  user?: FactoryInput<User, UserOptions>;
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  name?: TradePartnerUser["name"];
  createdAt?: TradePartnerUser["createdAt"];
  updatedAt?: TradePartnerUser["updatedAt"];
  commentStreams?: Array<FactoryInput<CommentStream, CommentStreamOptions>>;
  tradePartnerContact?: FactoryInput<TradePartnerContact, TradePartnerContactOptions> | null;
  approvers?: Array<FactoryInput<Approver, ApproverOptions>>;
  lastActive?: TradePartnerUser["lastActive"];
  lastActiveAt?: TradePartnerUser["lastActiveAt"];
}

export function newTradePartnerUser(
  options?: TradePartnerUserOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerUser>;
export function newTradePartnerUser(
  options: TradePartnerUserOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradePartnerUser> {
  const o = (options.__typename ? options : cache["TradePartnerUser"] = {}) as TradePartnerUser;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "TradePartnerUser";
    o.id = options.id ?? nextFactoryId("TradePartnerUser");
    o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
    o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.commentStreams = (options.commentStreams ?? []).map((i) =>
      maybeNew("CommentStream", i, cache, options.hasOwnProperty("commentStreams"))
    );
    o.tradePartnerContact = maybeNewOrNull("TradePartnerContact", options.tradePartnerContact, cache);
    o.approvers = (options.approvers ?? []).map((i) =>
      maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
    );
    o.lastActive = options.lastActive ?? null;
    o.lastActiveAt = options.lastActiveAt ?? null;
    return o as FactoryResult<TradePartnerUser>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["TradePartnerUser"] = newTradePartnerUser;

export interface SaveUnitResultOptions {
  __typename?: "SaveUnitResult";
  unit?: FactoryInput<Unit, UnitOptions>;
}

export function newSaveUnitResult(
  options?: SaveUnitResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveUnitResult>;
export function newSaveUnitResult(
  options: SaveUnitResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveUnitResult> {
  const o = (options.__typename ? options : cache["SaveUnitResult"] = {}) as SaveUnitResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveUnitResult";
    o.unit = maybeNew("Unit", options.unit, cache, options.hasOwnProperty("unit"));
    return o as FactoryResult<SaveUnitResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveUnitResult"] = newSaveUnitResult;

export interface SaveUnitsOfMeasureResultOptions {
  __typename?: "SaveUnitsOfMeasureResult";
  unitsOfMeasure?: Array<FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>>;
}

export function newSaveUnitsOfMeasureResult(
  options?: SaveUnitsOfMeasureResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveUnitsOfMeasureResult>;
export function newSaveUnitsOfMeasureResult(
  options: SaveUnitsOfMeasureResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveUnitsOfMeasureResult> {
  const o = (options.__typename ? options : cache["SaveUnitsOfMeasureResult"] = {}) as SaveUnitsOfMeasureResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveUnitsOfMeasureResult";
    o.unitsOfMeasure = (options.unitsOfMeasure ?? []).map((i) =>
      maybeNew("UnitOfMeasure", i, cache, options.hasOwnProperty("unitsOfMeasure"))
    );
    return o as FactoryResult<SaveUnitsOfMeasureResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveUnitsOfMeasureResult"] = newSaveUnitsOfMeasureResult;

export interface UnitOfMeasureOptions {
  __typename?: "UnitOfMeasure";
  id?: UnitOfMeasure["id"];
  name?: UnitOfMeasure["name"];
  useQuantity?: UnitOfMeasure["useQuantity"];
  sageName?: UnitOfMeasure["sageName"];
  abbreviation?: UnitOfMeasure["abbreviation"];
  shortName?: UnitOfMeasure["shortName"];
  shouldMultiplySelectionFee?: UnitOfMeasure["shouldMultiplySelectionFee"];
}

export function newUnitOfMeasure(
  options?: UnitOfMeasureOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UnitOfMeasure>;
export function newUnitOfMeasure(
  options: UnitOfMeasureOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UnitOfMeasure> {
  const o = (options.__typename ? options : cache["UnitOfMeasure"] = {}) as UnitOfMeasure;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UnitOfMeasure";
    o.id = options.id ?? nextFactoryId("UnitOfMeasure");
    o.name = options.name ?? "name";
    o.useQuantity = options.useQuantity ?? false;
    o.sageName = options.sageName ?? null;
    o.abbreviation = options.abbreviation ?? "abbreviation";
    o.shortName = options.shortName ?? "shortName";
    o.shouldMultiplySelectionFee = options.shouldMultiplySelectionFee ?? false;
    return o as FactoryResult<UnitOfMeasure>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UnitOfMeasure"] = newUnitOfMeasure;

export interface UserOptions {
  __typename?: "User";
  id?: User["id"];
  userId?: User["userId"];
  userType?: User["userType"];
  name?: User["name"];
  email?: User["email"];
  avatarUrl?: User["avatarUrl"];
  avatar?: User["avatar"];
  internalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  type?: User["type"];
  typeDetail?: UserTypeDetailOptions | UserType;
  isActive?: User["isActive"];
  tradePartnerUser?: FactoryInput<TradePartnerUser, TradePartnerUserOptions> | null;
  tradePartnerUsers?: Array<FactoryInput<TradePartnerUser, TradePartnerUserOptions>>;
  zendeskJwt?: User["zendeskJwt"];
  userCommunicationPreference?: FactoryInput<UserCommunicationPreference, UserCommunicationPreferenceOptions> | null;
  isBeingImpersonated?: User["isBeingImpersonated"];
  hasCheckoutAccess?: User["hasCheckoutAccess"];
  pushNotificationTokens?: Array<FactoryInput<PushNotificationToken, PushNotificationTokenOptions>>;
}

export function newUser(options?: UserOptions, factoryOptions?: FactoryOptions): FactoryResult<User>;
export function newUser(
  options: UserOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<User> {
  const o = (options.__typename ? options : cache["User"] = {}) as User;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "User";
    o.id = options.id ?? nextFactoryId("User");
    o.userId = options.userId ?? "userId";
    o.userType = options.userType ?? UserType.Anonymous;
    o.name = options.name ?? "name";
    o.email = options.email ?? "email";
    o.avatarUrl = options.avatarUrl ?? "avatarUrl";
    o.avatar = options.avatar ?? "avatar";
    o.internalUser = maybeNewOrNull("InternalUser", options.internalUser, cache);
    o.type = options.type ?? UserType.Anonymous;
    o.typeDetail = enumOrDetailOfUserType(options.typeDetail);
    o.isActive = options.isActive ?? false;
    o.tradePartnerUser = maybeNewOrNull("TradePartnerUser", options.tradePartnerUser, cache);
    o.tradePartnerUsers = (options.tradePartnerUsers ?? []).map((i) =>
      maybeNew("TradePartnerUser", i, cache, options.hasOwnProperty("tradePartnerUsers"))
    );
    o.zendeskJwt = options.zendeskJwt ?? "zendeskJwt";
    o.userCommunicationPreference = maybeNewOrNull(
      "UserCommunicationPreference",
      options.userCommunicationPreference,
      cache,
    );
    o.isBeingImpersonated = options.isBeingImpersonated ?? false;
    o.hasCheckoutAccess = options.hasCheckoutAccess ?? false;
    o.pushNotificationTokens = (options.pushNotificationTokens ?? []).map((i) =>
      maybeNew("PushNotificationToken", i, cache, options.hasOwnProperty("pushNotificationTokens"))
    );
    return o as FactoryResult<User>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["User"] = newUser;

export interface SaveUserResultOptions {
  __typename?: "SaveUserResult";
  userErrors?: Array<FactoryInput<UserError, UserErrorOptions>>;
}

export function newSaveUserResult(
  options?: SaveUserResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveUserResult>;
export function newSaveUserResult(
  options: SaveUserResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveUserResult> {
  const o = (options.__typename ? options : cache["SaveUserResult"] = {}) as SaveUserResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveUserResult";
    o.userErrors = (options.userErrors ?? []).map((i) =>
      maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
    );
    return o as FactoryResult<SaveUserResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveUserResult"] = newSaveUserResult;

export interface DeactivateUserResultOptions {
  __typename?: "DeactivateUserResult";
  userErrors?: Array<FactoryInput<UserError, UserErrorOptions>>;
}

export function newDeactivateUserResult(
  options?: DeactivateUserResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeactivateUserResult>;
export function newDeactivateUserResult(
  options: DeactivateUserResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeactivateUserResult> {
  const o = (options.__typename ? options : cache["DeactivateUserResult"] = {}) as DeactivateUserResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeactivateUserResult";
    o.userErrors = (options.userErrors ?? []).map((i) =>
      maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
    );
    return o as FactoryResult<DeactivateUserResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeactivateUserResult"] = newDeactivateUserResult;

export interface ActivateUserResultOptions {
  __typename?: "ActivateUserResult";
  userErrors?: Array<FactoryInput<UserError, UserErrorOptions>>;
}

export function newActivateUserResult(
  options?: ActivateUserResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ActivateUserResult>;
export function newActivateUserResult(
  options: ActivateUserResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ActivateUserResult> {
  const o = (options.__typename ? options : cache["ActivateUserResult"] = {}) as ActivateUserResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ActivateUserResult";
    o.userErrors = (options.userErrors ?? []).map((i) =>
      maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
    );
    return o as FactoryResult<ActivateUserResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ActivateUserResult"] = newActivateUserResult;

export interface DeactivateUsersResultOptions {
  __typename?: "DeactivateUsersResult";
  users?: Array<FactoryInput<User, UserOptions>>;
}

export function newDeactivateUsersResult(
  options?: DeactivateUsersResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeactivateUsersResult>;
export function newDeactivateUsersResult(
  options: DeactivateUsersResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<DeactivateUsersResult> {
  const o = (options.__typename ? options : cache["DeactivateUsersResult"] = {}) as DeactivateUsersResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "DeactivateUsersResult";
    o.users = (options.users ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("users")));
    return o as FactoryResult<DeactivateUsersResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["DeactivateUsersResult"] = newDeactivateUsersResult;

export interface ActivateUsersResultOptions {
  __typename?: "ActivateUsersResult";
  users?: Array<FactoryInput<User, UserOptions>>;
}

export function newActivateUsersResult(
  options?: ActivateUsersResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ActivateUsersResult>;
export function newActivateUsersResult(
  options: ActivateUsersResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ActivateUsersResult> {
  const o = (options.__typename ? options : cache["ActivateUsersResult"] = {}) as ActivateUsersResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "ActivateUsersResult";
    o.users = (options.users ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("users")));
    return o as FactoryResult<ActivateUsersResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["ActivateUsersResult"] = newActivateUsersResult;

export interface UserCommunicationPreferenceOptions {
  __typename?: "UserCommunicationPreference";
  id?: UserCommunicationPreference["id"];
  user?: FactoryInput<User, UserOptions>;
  createdAt?: UserCommunicationPreference["createdAt"];
  updatedAt?: UserCommunicationPreference["updatedAt"];
  tpAvailabilityRequestPreference?: UserCommunicationPreference["tpAvailabilityRequestPreference"] | null;
  commentPreference?: UserCommunicationPreference["commentPreference"] | null;
}

export function newUserCommunicationPreference(
  options?: UserCommunicationPreferenceOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UserCommunicationPreference>;
export function newUserCommunicationPreference(
  options: UserCommunicationPreferenceOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UserCommunicationPreference> {
  const o = (options.__typename ? options : cache["UserCommunicationPreference"] = {}) as UserCommunicationPreference;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UserCommunicationPreference";
    o.id = options.id ?? nextFactoryId("UserCommunicationPreference");
    o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.tpAvailabilityRequestPreference = options.tpAvailabilityRequestPreference ?? [];
    o.commentPreference = options.commentPreference ?? [];
    return o as FactoryResult<UserCommunicationPreference>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UserCommunicationPreference"] = newUserCommunicationPreference;

export interface SaveUserCommunicationPreferenceResultOptions {
  __typename?: "SaveUserCommunicationPreferenceResult";
  userCommunicationPreference?: FactoryInput<UserCommunicationPreference, UserCommunicationPreferenceOptions>;
}

export function newSaveUserCommunicationPreferenceResult(
  options?: SaveUserCommunicationPreferenceResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveUserCommunicationPreferenceResult>;
export function newSaveUserCommunicationPreferenceResult(
  options: SaveUserCommunicationPreferenceResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveUserCommunicationPreferenceResult> {
  const o =
    (options.__typename
      ? options
      : cache["SaveUserCommunicationPreferenceResult"] = {}) as SaveUserCommunicationPreferenceResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveUserCommunicationPreferenceResult";
    o.userCommunicationPreference = maybeNew(
      "UserCommunicationPreference",
      options.userCommunicationPreference,
      cache,
      options.hasOwnProperty("userCommunicationPreference"),
    );
    return o as FactoryResult<SaveUserCommunicationPreferenceResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveUserCommunicationPreferenceResult"] = newSaveUserCommunicationPreferenceResult;

export interface UserEventOptions {
  __typename?: "UserEvent";
  id?: UserEvent["id"];
  parent?:
    | UserEventParent
    | FactoryResult<UserEventParent>
    | ApprovalOptions
    | RequireTypename<BillOptions>
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DocumentOptions>
    | RequireTypename<EstimateOptions>
    | RequireTypename<HomeownerContractChangeOrderOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<ItemTemplateOptions>
    | RequireTypename<JobLogOptions>
    | RequireTypename<JobLogImageOptions>
    | RequireTypename<JobLogNoteOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ProjectItemOptions>
    | RequireTypename<ProjectLotDetailOptions>
    | RequireTypename<ProjectReadyPlanConfigOptions>
    | RequireTypename<ReadyPlanOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<DesignPackageOptions>
    | RequireTypename<ProductOfferingOptions>
    | RequireTypename<ReadyPlanOptionOptions>
    | RequireTypename<ToDoOptions>
    | RequireTypename<ChangeRequestToDoOptions>
    | RequireTypename<PunchlistItemTodoOptions>
    | RequireTypename<TaskOptions>
    | RequireTypename<ScheduleTaskOptions>
    | RequireTypename<PlanTaskOptions>
    | RequireTypename<WarrantyTicketOptions>;
  parentTypeName?: UserEvent["parentTypeName"];
  createdAt?: UserEvent["createdAt"];
  createdBy?: FactoryInput<User, UserOptions>;
  createdFor?: FactoryInput<User, UserOptions> | null;
  type?: UserEvent["type"];
  typeDetail?: UserEventTypeDetailOptions | UserEventType;
  development?: FactoryInput<Development, DevelopmentOptions> | null;
  cohort?: FactoryInput<Cohort, CohortOptions> | null;
  project?: Project | FactoryResult<ProjectType> | ProjectOptions | null;
  notifiedAt?: UserEvent["notifiedAt"];
  comment?: FactoryInput<Comment, CommentOptions> | null;
  payload?: UserEvent["payload"];
  attachment?: FactoryInput<Attachment, AttachmentOptions> | null;
}

export function newUserEvent(options?: UserEventOptions, factoryOptions?: FactoryOptions): FactoryResult<UserEvent>;
export function newUserEvent(
  options: UserEventOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UserEvent> {
  const o = (options.__typename ? options : cache["UserEvent"] = {}) as UserEvent;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UserEvent";
    o.id = options.id ?? nextFactoryId("UserEvent");
    o.parent = maybeNew(options.parent?.__typename ?? "Approval", options.parent, cache);
    o.parentTypeName = options.parentTypeName ?? "parentTypeName";
    o.createdAt = options.createdAt ?? newDateTime();
    o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
    o.createdFor = maybeNewOrNull("User", options.createdFor, cache);
    o.type = options.type ?? UserEventType.Created;
    o.typeDetail = enumOrDetailOfUserEventType(options.typeDetail);
    o.development = maybeNewOrNull("Development", options.development, cache);
    o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
    o.project = maybeNewOrNull("Project", options.project, cache);
    o.notifiedAt = options.notifiedAt ?? null;
    o.comment = maybeNewOrNull("Comment", options.comment, cache);
    o.payload = options.payload ?? null;
    o.attachment = maybeNewOrNull("Attachment", options.attachment, cache);
    return o as FactoryResult<UserEvent>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UserEvent"] = newUserEvent;

export interface UserEventParentTypeOptions {
  __typename?: "UserEventParentType";
  id?: UserEventParentType["id"];
  name?: UserEventParentType["name"];
}

export function newUserEventParentType(
  options?: UserEventParentTypeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<UserEventParentType>;
export function newUserEventParentType(
  options: UserEventParentTypeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UserEventParentType> {
  const o = (options.__typename ? options : cache["UserEventParentType"] = {}) as UserEventParentType;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UserEventParentType";
    o.id = options.id ?? nextFactoryId("UserEventParentType");
    o.name = options.name ?? "name";
    return o as FactoryResult<UserEventParentType>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UserEventParentType"] = newUserEventParentType;

export interface UserGroupOptions {
  __typename?: "UserGroup";
  id?: UserGroup["id"];
  name?: UserGroup["name"];
  createdAt?: UserGroup["createdAt"];
  updatedAt?: UserGroup["updatedAt"];
  featureFlagTargets?: Array<FactoryInput<FeatureFlagTarget, FeatureFlagTargetOptions>>;
  users?: Array<FactoryInput<User, UserOptions>>;
}

export function newUserGroup(options?: UserGroupOptions, factoryOptions?: FactoryOptions): FactoryResult<UserGroup>;
export function newUserGroup(
  options: UserGroupOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<UserGroup> {
  const o = (options.__typename ? options : cache["UserGroup"] = {}) as UserGroup;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "UserGroup";
    o.id = options.id ?? nextFactoryId("UserGroup");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.featureFlagTargets = (options.featureFlagTargets ?? []).map((i) =>
      maybeNew("FeatureFlagTarget", i, cache, options.hasOwnProperty("featureFlagTargets"))
    );
    o.users = (options.users ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("users")));
    return o as FactoryResult<UserGroup>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["UserGroup"] = newUserGroup;

export interface SaveUserGroupResultOptions {
  __typename?: "SaveUserGroupResult";
  userGroup?: FactoryInput<UserGroup, UserGroupOptions>;
}

export function newSaveUserGroupResult(
  options?: SaveUserGroupResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveUserGroupResult>;
export function newSaveUserGroupResult(
  options: SaveUserGroupResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveUserGroupResult> {
  const o = (options.__typename ? options : cache["SaveUserGroupResult"] = {}) as SaveUserGroupResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveUserGroupResult";
    o.userGroup = maybeNew("UserGroup", options.userGroup, cache, options.hasOwnProperty("userGroup"));
    return o as FactoryResult<SaveUserGroupResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveUserGroupResult"] = newSaveUserGroupResult;

export interface SaveWarrantyTicketResultOptions {
  __typename?: "SaveWarrantyTicketResult";
  warrantyTicket?: FactoryInput<WarrantyTicket, WarrantyTicketOptions>;
}

export function newSaveWarrantyTicketResult(
  options?: SaveWarrantyTicketResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveWarrantyTicketResult>;
export function newSaveWarrantyTicketResult(
  options: SaveWarrantyTicketResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveWarrantyTicketResult> {
  const o = (options.__typename ? options : cache["SaveWarrantyTicketResult"] = {}) as SaveWarrantyTicketResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveWarrantyTicketResult";
    o.warrantyTicket = maybeNew(
      "WarrantyTicket",
      options.warrantyTicket,
      cache,
      options.hasOwnProperty("warrantyTicket"),
    );
    return o as FactoryResult<SaveWarrantyTicketResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveWarrantyTicketResult"] = newSaveWarrantyTicketResult;

export interface WarrantyTicketsPageOptions {
  __typename?: "WarrantyTicketsPage";
  entities?: Array<FactoryInput<WarrantyTicket, WarrantyTicketOptions>>;
  pageInfo?: FactoryInput<PageInfo, PageInfoOptions>;
}

export function newWarrantyTicketsPage(
  options?: WarrantyTicketsPageOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicketsPage>;
export function newWarrantyTicketsPage(
  options: WarrantyTicketsPageOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WarrantyTicketsPage> {
  const o = (options.__typename ? options : cache["WarrantyTicketsPage"] = {}) as WarrantyTicketsPage;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WarrantyTicketsPage";
    o.entities = (options.entities ?? []).map((i) =>
      maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("entities"))
    );
    o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
    return o as FactoryResult<WarrantyTicketsPage>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WarrantyTicketsPage"] = newWarrantyTicketsPage;

export interface WarrantyTicketAvailabilityOptions {
  __typename?: "WarrantyTicketAvailability";
  id?: WarrantyTicketAvailability["id"];
  createdAt?: WarrantyTicketAvailability["createdAt"];
  updatedAt?: WarrantyTicketAvailability["updatedAt"];
  dayOfWeek?: DayOfWeekDetailOptions | DayOfWeek;
  timeOfDay?: TimeOfDayDetailOptions | TimeOfDay;
  warrantyTicket?: FactoryInput<WarrantyTicket, WarrantyTicketOptions>;
}

export function newWarrantyTicketAvailability(
  options?: WarrantyTicketAvailabilityOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicketAvailability>;
export function newWarrantyTicketAvailability(
  options: WarrantyTicketAvailabilityOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WarrantyTicketAvailability> {
  const o = (options.__typename ? options : cache["WarrantyTicketAvailability"] = {}) as WarrantyTicketAvailability;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WarrantyTicketAvailability";
    o.id = options.id ?? nextFactoryId("WarrantyTicketAvailability");
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.dayOfWeek = enumOrDetailOfDayOfWeek(options.dayOfWeek);
    o.timeOfDay = enumOrDetailOfTimeOfDay(options.timeOfDay);
    o.warrantyTicket = maybeNew(
      "WarrantyTicket",
      options.warrantyTicket,
      cache,
      options.hasOwnProperty("warrantyTicket"),
    );
    return o as FactoryResult<WarrantyTicketAvailability>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WarrantyTicketAvailability"] = newWarrantyTicketAvailability;

export interface WarrantyTicketItemOptions {
  __typename?: "WarrantyTicketItem";
  id?: WarrantyTicketItem["id"];
  product?: WarrantyTicketItem["product"];
  description?: WarrantyTicketItem["description"];
  createdAt?: WarrantyTicketItem["createdAt"];
  updatedAt?: WarrantyTicketItem["updatedAt"];
  status?: WarrantyTicketItemStatusDetailOptions | WarrantyTicketItemStatus;
  warrantyTicket?: FactoryInput<WarrantyTicket, WarrantyTicketOptions>;
  attachments?: Array<FactoryInput<Attachment, AttachmentOptions>>;
  type?: WarrantyTicketItemTypeDetailOptions | WarrantyTicketItemType;
  homeownerVisible?: WarrantyTicketItem["homeownerVisible"];
  statusUpdatedAt?: WarrantyTicketItem["statusUpdatedAt"];
}

export function newWarrantyTicketItem(
  options?: WarrantyTicketItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicketItem>;
export function newWarrantyTicketItem(
  options: WarrantyTicketItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WarrantyTicketItem> {
  const o = (options.__typename ? options : cache["WarrantyTicketItem"] = {}) as WarrantyTicketItem;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WarrantyTicketItem";
    o.id = options.id ?? nextFactoryId("WarrantyTicketItem");
    o.product = options.product ?? null;
    o.description = options.description ?? null;
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.status = enumOrDetailOfWarrantyTicketItemStatus(options.status);
    o.warrantyTicket = maybeNew(
      "WarrantyTicket",
      options.warrantyTicket,
      cache,
      options.hasOwnProperty("warrantyTicket"),
    );
    o.attachments = (options.attachments ?? []).map((i) =>
      maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
    );
    o.type = enumOrDetailOfWarrantyTicketItemType(options.type);
    o.homeownerVisible = options.homeownerVisible ?? false;
    o.statusUpdatedAt = options.statusUpdatedAt ?? newDateTime();
    return o as FactoryResult<WarrantyTicketItem>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WarrantyTicketItem"] = newWarrantyTicketItem;

export interface SaveWarrantyTicketItemResultOptions {
  __typename?: "SaveWarrantyTicketItemResult";
  warrantyTicketItem?: FactoryInput<WarrantyTicketItem, WarrantyTicketItemOptions>;
}

export function newSaveWarrantyTicketItemResult(
  options?: SaveWarrantyTicketItemResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveWarrantyTicketItemResult>;
export function newSaveWarrantyTicketItemResult(
  options: SaveWarrantyTicketItemResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveWarrantyTicketItemResult> {
  const o = (options.__typename ? options : cache["SaveWarrantyTicketItemResult"] = {}) as SaveWarrantyTicketItemResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveWarrantyTicketItemResult";
    o.warrantyTicketItem = maybeNew(
      "WarrantyTicketItem",
      options.warrantyTicketItem,
      cache,
      options.hasOwnProperty("warrantyTicketItem"),
    );
    return o as FactoryResult<SaveWarrantyTicketItemResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveWarrantyTicketItemResult"] = newSaveWarrantyTicketItemResult;

export interface SaveWarrantyTicketItemsResultOptions {
  __typename?: "SaveWarrantyTicketItemsResult";
  warrantyTicketItems?: Array<FactoryInput<WarrantyTicketItem, WarrantyTicketItemOptions>>;
}

export function newSaveWarrantyTicketItemsResult(
  options?: SaveWarrantyTicketItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveWarrantyTicketItemsResult>;
export function newSaveWarrantyTicketItemsResult(
  options: SaveWarrantyTicketItemsResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveWarrantyTicketItemsResult> {
  const o =
    (options.__typename ? options : cache["SaveWarrantyTicketItemsResult"] = {}) as SaveWarrantyTicketItemsResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveWarrantyTicketItemsResult";
    o.warrantyTicketItems = (options.warrantyTicketItems ?? []).map((i) =>
      maybeNew("WarrantyTicketItem", i, cache, options.hasOwnProperty("warrantyTicketItems"))
    );
    return o as FactoryResult<SaveWarrantyTicketItemsResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveWarrantyTicketItemsResult"] = newSaveWarrantyTicketItemsResult;

export interface WorkAuthorizationOptions {
  __typename?: "WorkAuthorization";
  id?: WorkAuthorization["id"];
  name?: WorkAuthorization["name"];
  createdAt?: WorkAuthorization["createdAt"];
  updatedAt?: WorkAuthorization["updatedAt"];
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
  documents?: Array<FactoryInput<Document, DocumentOptions>>;
  projectItems?: Array<FactoryInput<ProjectItem, ProjectItemOptions>>;
}

export function newWorkAuthorization(
  options?: WorkAuthorizationOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<WorkAuthorization>;
export function newWorkAuthorization(
  options: WorkAuthorizationOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<WorkAuthorization> {
  const o = (options.__typename ? options : cache["WorkAuthorization"] = {}) as WorkAuthorization;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "WorkAuthorization";
    o.id = options.id ?? nextFactoryId("WorkAuthorization");
    o.name = options.name ?? "name";
    o.createdAt = options.createdAt ?? newDateTime();
    o.updatedAt = options.updatedAt ?? newDateTime();
    o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
    o.documents = (options.documents ?? []).map((i) =>
      maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
    );
    o.projectItems = (options.projectItems ?? []).map((i) =>
      maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
    );
    return o as FactoryResult<WorkAuthorization>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["WorkAuthorization"] = newWorkAuthorization;

export interface SaveWorkAuthorizationResultOptions {
  __typename?: "SaveWorkAuthorizationResult";
  workAuthorization?: FactoryInput<WorkAuthorization, WorkAuthorizationOptions>;
}

export function newSaveWorkAuthorizationResult(
  options?: SaveWorkAuthorizationResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveWorkAuthorizationResult>;
export function newSaveWorkAuthorizationResult(
  options: SaveWorkAuthorizationResultOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<SaveWorkAuthorizationResult> {
  const o = (options.__typename ? options : cache["SaveWorkAuthorizationResult"] = {}) as SaveWorkAuthorizationResult;
  (cache.all ??= new Set()).add(o);
  (cache.active ??= new Set()).add(o);
  try {
    o.__typename = "SaveWorkAuthorizationResult";
    o.workAuthorization = maybeNew(
      "WorkAuthorization",
      options.workAuthorization,
      cache,
      options.hasOwnProperty("workAuthorization"),
    );
    return o as FactoryResult<SaveWorkAuthorizationResult>;
  } finally {
    cache.active?.delete(o);
  }
}

factories["SaveWorkAuthorizationResult"] = newSaveWorkAuthorizationResult;

export type CanCollaborateOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type CanCollaborateType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type CanCollaborateTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newCanCollaborate(): FactoryResult<ScheduleTask>;
export function newCanCollaborate(
  options: ScheduleTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTask>;
export function newCanCollaborate(
  options: RequireTypename<ApprovalOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Approval>;
export function newCanCollaborate(
  options: RequireTypename<BidContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContract>;
export function newCanCollaborate(
  options: RequireTypename<BidItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidItem>;
export function newCanCollaborate(
  options: RequireTypename<BidPackageRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageRequest>;
export function newCanCollaborate(
  options: RequireTypename<BillOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Bill>;
export function newCanCollaborate(
  options: RequireTypename<ChangeEventOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEvent>;
export function newCanCollaborate(
  options: RequireTypename<ChangeRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequest>;
export function newCanCollaborate(
  options: RequireTypename<ChangeRequestToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestToDo>;
export function newCanCollaborate(
  options: RequireTypename<SchedulePhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newCanCollaborate(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newCanCollaborate(
  options: RequireTypename<TaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Task>;
export function newCanCollaborate(
  options: RequireTypename<PlanTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanTask>;
export function newCanCollaborate(
  options: RequireTypename<ToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToDo>;
export function newCanCollaborate(
  options: RequireTypename<InvoiceOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Invoice>;
export function newCanCollaborate(
  options: RequireTypename<StandaloneProjectOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newCanCollaborate(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newCanCollaborate(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newCanCollaborate(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newCanCollaborate(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newCanCollaborate(
  options: RequireTypename<LotOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Lot>;
export function newCanCollaborate(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newCanCollaborate(
  options: RequireTypename<UnitOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Unit>;
export function newCanCollaborate(
  options: RequireTypename<ProjectItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newCanCollaborate(
  options: RequireTypename<EstimateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Estimate>;
export function newCanCollaborate(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitment>;
export function newCanCollaborate(
  options: RequireTypename<CommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newCanCollaborate(
  options: RequireTypename<DocumentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Document>;
export function newCanCollaborate(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersion>;
export function newCanCollaborate(
  options: RequireTypename<JobLogNoteOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogNote>;
export function newCanCollaborate(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequest>;
export function newCanCollaborate(
  options: RequireTypename<PunchlistItemTodoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PunchlistItemTodo>;
export function newCanCollaborate(
  options: RequireTypename<WarrantyTicketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicket>;
export function newCanCollaborate(
  options: RequireTypename<HomeownerContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContract>;
export function newCanCollaborate(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractChangeOrder>;
export function newCanCollaborate(
  options: RequireTypename<ReadyPlanOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlan>;
export function newCanCollaborate(
  options: RequireTypename<PlanPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newCanCollaborate(
  options: RequireTypename<GlobalOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOption>;
export function newCanCollaborate(
  options: RequireTypename<ProjectCostCodeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCostCode>;
export function newCanCollaborate(
  options: CanCollaborateOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CanCollaborateType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["CanCollaborate"] = newCanCollaborate;

export type CommentableOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type CommentableType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type CommentableTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newCommentable(): FactoryResult<ScheduleTask>;
export function newCommentable(
  options: ScheduleTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTask>;
export function newCommentable(
  options: RequireTypename<ApprovalOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Approval>;
export function newCommentable(
  options: RequireTypename<BidContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContract>;
export function newCommentable(
  options: RequireTypename<BidItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidItem>;
export function newCommentable(
  options: RequireTypename<BidPackageRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageRequest>;
export function newCommentable(
  options: RequireTypename<BillOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Bill>;
export function newCommentable(
  options: RequireTypename<ChangeEventOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEvent>;
export function newCommentable(
  options: RequireTypename<ChangeRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequest>;
export function newCommentable(
  options: RequireTypename<ChangeRequestToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestToDo>;
export function newCommentable(
  options: RequireTypename<SchedulePhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newCommentable(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newCommentable(
  options: RequireTypename<TaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Task>;
export function newCommentable(
  options: RequireTypename<PlanTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanTask>;
export function newCommentable(
  options: RequireTypename<ToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToDo>;
export function newCommentable(
  options: RequireTypename<InvoiceOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Invoice>;
export function newCommentable(
  options: RequireTypename<StandaloneProjectOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newCommentable(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newCommentable(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newCommentable(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newCommentable(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newCommentable(
  options: RequireTypename<LotOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Lot>;
export function newCommentable(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newCommentable(
  options: RequireTypename<UnitOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Unit>;
export function newCommentable(
  options: RequireTypename<ProjectItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newCommentable(
  options: RequireTypename<EstimateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Estimate>;
export function newCommentable(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitment>;
export function newCommentable(
  options: RequireTypename<CommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newCommentable(
  options: RequireTypename<DocumentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Document>;
export function newCommentable(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersion>;
export function newCommentable(
  options: RequireTypename<JobLogNoteOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogNote>;
export function newCommentable(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequest>;
export function newCommentable(
  options: RequireTypename<PunchlistItemTodoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PunchlistItemTodo>;
export function newCommentable(
  options: RequireTypename<WarrantyTicketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicket>;
export function newCommentable(
  options: RequireTypename<HomeownerContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContract>;
export function newCommentable(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractChangeOrder>;
export function newCommentable(
  options: RequireTypename<ReadyPlanOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlan>;
export function newCommentable(
  options: RequireTypename<PlanPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newCommentable(
  options: RequireTypename<GlobalOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOption>;
export function newCommentable(
  options: RequireTypename<ProjectCostCodeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCostCode>;
export function newCommentable(
  options: CommentableOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommentableType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["Commentable"] = newCommentable;

export type ReferencableOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type ReferencableType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type ReferencableTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newReferencable(): FactoryResult<ScheduleTask>;
export function newReferencable(
  options: ScheduleTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTask>;
export function newReferencable(
  options: RequireTypename<ApprovalOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Approval>;
export function newReferencable(
  options: RequireTypename<BidContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContract>;
export function newReferencable(
  options: RequireTypename<BidItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidItem>;
export function newReferencable(
  options: RequireTypename<BidPackageRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageRequest>;
export function newReferencable(
  options: RequireTypename<BillOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Bill>;
export function newReferencable(
  options: RequireTypename<ChangeEventOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEvent>;
export function newReferencable(
  options: RequireTypename<ChangeRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequest>;
export function newReferencable(
  options: RequireTypename<ChangeRequestToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestToDo>;
export function newReferencable(
  options: RequireTypename<SchedulePhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newReferencable(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newReferencable(
  options: RequireTypename<TaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Task>;
export function newReferencable(
  options: RequireTypename<PlanTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanTask>;
export function newReferencable(
  options: RequireTypename<ToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToDo>;
export function newReferencable(
  options: RequireTypename<InvoiceOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Invoice>;
export function newReferencable(
  options: RequireTypename<StandaloneProjectOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newReferencable(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newReferencable(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newReferencable(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newReferencable(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newReferencable(
  options: RequireTypename<LotOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Lot>;
export function newReferencable(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newReferencable(
  options: RequireTypename<UnitOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Unit>;
export function newReferencable(
  options: RequireTypename<ProjectItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newReferencable(
  options: RequireTypename<EstimateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Estimate>;
export function newReferencable(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitment>;
export function newReferencable(
  options: RequireTypename<CommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newReferencable(
  options: RequireTypename<DocumentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Document>;
export function newReferencable(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersion>;
export function newReferencable(
  options: RequireTypename<JobLogNoteOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogNote>;
export function newReferencable(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequest>;
export function newReferencable(
  options: RequireTypename<PunchlistItemTodoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PunchlistItemTodo>;
export function newReferencable(
  options: RequireTypename<WarrantyTicketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicket>;
export function newReferencable(
  options: RequireTypename<HomeownerContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContract>;
export function newReferencable(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractChangeOrder>;
export function newReferencable(
  options: RequireTypename<ReadyPlanOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlan>;
export function newReferencable(
  options: RequireTypename<PlanPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newReferencable(
  options: RequireTypename<GlobalOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOption>;
export function newReferencable(
  options: RequireTypename<ProjectCostCodeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCostCode>;
export function newReferencable(
  options: ReferencableOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReferencableType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["Referencable"] = newReferencable;

export type FollowableOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type FollowableType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type FollowableTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newFollowable(): FactoryResult<ScheduleTask>;
export function newFollowable(
  options: ScheduleTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTask>;
export function newFollowable(
  options: RequireTypename<ApprovalOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Approval>;
export function newFollowable(
  options: RequireTypename<BidContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContract>;
export function newFollowable(
  options: RequireTypename<BidItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidItem>;
export function newFollowable(
  options: RequireTypename<BidPackageRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageRequest>;
export function newFollowable(
  options: RequireTypename<BillOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Bill>;
export function newFollowable(
  options: RequireTypename<ChangeEventOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEvent>;
export function newFollowable(
  options: RequireTypename<ChangeRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequest>;
export function newFollowable(
  options: RequireTypename<ChangeRequestToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestToDo>;
export function newFollowable(
  options: RequireTypename<SchedulePhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newFollowable(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newFollowable(
  options: RequireTypename<TaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Task>;
export function newFollowable(
  options: RequireTypename<PlanTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanTask>;
export function newFollowable(
  options: RequireTypename<ToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToDo>;
export function newFollowable(
  options: RequireTypename<InvoiceOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Invoice>;
export function newFollowable(
  options: RequireTypename<StandaloneProjectOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newFollowable(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newFollowable(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newFollowable(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newFollowable(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newFollowable(
  options: RequireTypename<LotOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Lot>;
export function newFollowable(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newFollowable(
  options: RequireTypename<UnitOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Unit>;
export function newFollowable(
  options: RequireTypename<ProjectItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newFollowable(
  options: RequireTypename<EstimateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Estimate>;
export function newFollowable(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitment>;
export function newFollowable(
  options: RequireTypename<CommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newFollowable(
  options: RequireTypename<DocumentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Document>;
export function newFollowable(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersion>;
export function newFollowable(
  options: RequireTypename<JobLogNoteOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogNote>;
export function newFollowable(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequest>;
export function newFollowable(
  options: RequireTypename<PunchlistItemTodoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PunchlistItemTodo>;
export function newFollowable(
  options: RequireTypename<WarrantyTicketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicket>;
export function newFollowable(
  options: RequireTypename<HomeownerContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContract>;
export function newFollowable(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractChangeOrder>;
export function newFollowable(
  options: RequireTypename<ReadyPlanOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlan>;
export function newFollowable(
  options: RequireTypename<PlanPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newFollowable(
  options: RequireTypename<GlobalOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOption>;
export function newFollowable(
  options: RequireTypename<ProjectCostCodeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCostCode>;
export function newFollowable(
  options: FollowableOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<FollowableType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["Followable"] = newFollowable;

export type EntityOptions =
  | ScheduleTaskOptions
  | RequireTypename<AssetOptions>
  | RequireTypename<TradePartnerOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<CommentOptions>
  | RequireTypename<ProjectStageOptions>
  | RequireTypename<CommitmentDrawOptions>
  | RequireTypename<FeatureFlagOptions>
  | RequireTypename<GlobalPlanTaskOptions>
  | RequireTypename<JobLogOptions>
  | RequireTypename<JobLogImageOptions>
  | RequireTypename<LocationOptions>
  | RequireTypename<MaterialListingOptions>
  | RequireTypename<MaterialVariantOptions>
  | RequireTypename<MobileSyncUpdateOptions>
  | RequireTypename<ReadyPlanLocationOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<ReadyPlanProgramDataOptions>
  | RequireTypename<ScheduleFlagOptions>
  | RequireTypename<ScheduleFlagReasonOptions>
  | RequireTypename<ScheduleTaskChecklistItemOptions>
  | RequireTypename<TaskWorkDayOptions>
  | RequireTypename<TradePartnerContactOptions>
  | RequireTypename<TradePartnerUserOptions>;

export type EntityType =
  | ScheduleTask
  | Asset
  | TradePartner
  | Bill
  | PlanTask
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | Commitment
  | Document
  | JobLogNote
  | PunchlistItemTodo
  | Comment
  | ProjectStage
  | CommitmentDraw
  | FeatureFlag
  | GlobalPlanTask
  | JobLog
  | JobLogImage
  | Location
  | MaterialListing
  | MaterialVariant
  | MobileSyncUpdate
  | ReadyPlanLocation
  | ReadyPlanOption
  | ReadyPlanProgramData
  | ScheduleFlag
  | ScheduleFlagReason
  | ScheduleTaskChecklistItem
  | TaskWorkDay
  | TradePartnerContact
  | TradePartnerUser;

export type EntityTypeName =
  | "ScheduleTask"
  | "Asset"
  | "TradePartner"
  | "Bill"
  | "PlanTask"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "Commitment"
  | "Document"
  | "JobLogNote"
  | "PunchlistItemTodo"
  | "Comment"
  | "ProjectStage"
  | "CommitmentDraw"
  | "FeatureFlag"
  | "GlobalPlanTask"
  | "JobLog"
  | "JobLogImage"
  | "Location"
  | "MaterialListing"
  | "MaterialVariant"
  | "MobileSyncUpdate"
  | "ReadyPlanLocation"
  | "ReadyPlanOption"
  | "ReadyPlanProgramData"
  | "ScheduleFlag"
  | "ScheduleFlagReason"
  | "ScheduleTaskChecklistItem"
  | "TaskWorkDay"
  | "TradePartnerContact"
  | "TradePartnerUser";

export function newEntity(): FactoryResult<ScheduleTask>;
export function newEntity(options: ScheduleTaskOptions, factoryOptions?: FactoryOptions): FactoryResult<ScheduleTask>;
export function newEntity(
  options: RequireTypename<AssetOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Asset>;
export function newEntity(
  options: RequireTypename<TradePartnerOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartner>;
export function newEntity(options: RequireTypename<BillOptions>, factoryOptions?: FactoryOptions): FactoryResult<Bill>;
export function newEntity(
  options: RequireTypename<PlanTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanTask>;
export function newEntity(
  options: RequireTypename<StandaloneProjectOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newEntity(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newEntity(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newEntity(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newEntity(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newEntity(options: RequireTypename<LotOptions>, factoryOptions?: FactoryOptions): FactoryResult<Lot>;
export function newEntity(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newEntity(options: RequireTypename<UnitOptions>, factoryOptions?: FactoryOptions): FactoryResult<Unit>;
export function newEntity(
  options: RequireTypename<CommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newEntity(
  options: RequireTypename<DocumentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Document>;
export function newEntity(
  options: RequireTypename<JobLogNoteOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogNote>;
export function newEntity(
  options: RequireTypename<PunchlistItemTodoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PunchlistItemTodo>;
export function newEntity(
  options: RequireTypename<CommentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Comment>;
export function newEntity(
  options: RequireTypename<ProjectStageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStage>;
export function newEntity(
  options: RequireTypename<CommitmentDrawOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentDraw>;
export function newEntity(
  options: RequireTypename<FeatureFlagOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<FeatureFlag>;
export function newEntity(
  options: RequireTypename<GlobalPlanTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanTask>;
export function newEntity(
  options: RequireTypename<JobLogOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLog>;
export function newEntity(
  options: RequireTypename<JobLogImageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogImage>;
export function newEntity(
  options: RequireTypename<LocationOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Location>;
export function newEntity(
  options: RequireTypename<MaterialListingOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialListing>;
export function newEntity(
  options: RequireTypename<MaterialVariantOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariant>;
export function newEntity(
  options: RequireTypename<MobileSyncUpdateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<MobileSyncUpdate>;
export function newEntity(
  options: RequireTypename<ReadyPlanLocationOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanLocation>;
export function newEntity(
  options: RequireTypename<ReadyPlanOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOption>;
export function newEntity(
  options: RequireTypename<ReadyPlanProgramDataOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanProgramData>;
export function newEntity(
  options: RequireTypename<ScheduleFlagOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleFlag>;
export function newEntity(
  options: RequireTypename<ScheduleFlagReasonOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleFlagReason>;
export function newEntity(
  options: RequireTypename<ScheduleTaskChecklistItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTaskChecklistItem>;
export function newEntity(
  options: RequireTypename<TaskWorkDayOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TaskWorkDay>;
export function newEntity(
  options: RequireTypename<TradePartnerContactOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerContact>;
export function newEntity(
  options: RequireTypename<TradePartnerUserOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerUser>;
export function newEntity(
  options: EntityOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<EntityType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["Entity"] = newEntity;

export type HasBlueprintUrlOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidContractRevisionOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<BusinessFunctionOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>
  | RequireTypename<CommitmentChangeOrderOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<DevelopmentOptions>
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<MaterialVariantOptions>
  | RequireTypename<ProductOfferingOptions>
  | RequireTypename<ProjectReadyPlanConfigOptions>
  | RequireTypename<ProjectSiteConditionOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>;

export type HasBlueprintUrlType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidContractRevision
  | BidItem
  | BidPackageRequest
  | Bill
  | BusinessFunction
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode
  | CommitmentChangeOrder
  | DesignPackage
  | Development
  | ItemTemplateItem
  | MaterialVariant
  | ProductOffering
  | ProjectReadyPlanConfig
  | ProjectSiteCondition
  | ReadyPlanOption
  | TakeoffLineItem
  | TakeoffLineItemVersion;

export type HasBlueprintUrlTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidContractRevision"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "BusinessFunction"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode"
  | "CommitmentChangeOrder"
  | "DesignPackage"
  | "Development"
  | "ItemTemplateItem"
  | "MaterialVariant"
  | "ProductOffering"
  | "ProjectReadyPlanConfig"
  | "ProjectSiteCondition"
  | "ReadyPlanOption"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion";

export function newHasBlueprintUrl(): FactoryResult<ScheduleTask>;
export function newHasBlueprintUrl(
  options: ScheduleTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTask>;
export function newHasBlueprintUrl(
  options: RequireTypename<ApprovalOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Approval>;
export function newHasBlueprintUrl(
  options: RequireTypename<BidContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContract>;
export function newHasBlueprintUrl(
  options: RequireTypename<BidContractRevisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractRevision>;
export function newHasBlueprintUrl(
  options: RequireTypename<BidItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidItem>;
export function newHasBlueprintUrl(
  options: RequireTypename<BidPackageRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageRequest>;
export function newHasBlueprintUrl(
  options: RequireTypename<BillOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Bill>;
export function newHasBlueprintUrl(
  options: RequireTypename<BusinessFunctionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BusinessFunction>;
export function newHasBlueprintUrl(
  options: RequireTypename<ChangeEventOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEvent>;
export function newHasBlueprintUrl(
  options: RequireTypename<ChangeRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequest>;
export function newHasBlueprintUrl(
  options: RequireTypename<ChangeRequestToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestToDo>;
export function newHasBlueprintUrl(
  options: RequireTypename<SchedulePhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newHasBlueprintUrl(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newHasBlueprintUrl(
  options: RequireTypename<TaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Task>;
export function newHasBlueprintUrl(
  options: RequireTypename<PlanTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanTask>;
export function newHasBlueprintUrl(
  options: RequireTypename<ToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ToDo>;
export function newHasBlueprintUrl(
  options: RequireTypename<InvoiceOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Invoice>;
export function newHasBlueprintUrl(
  options: RequireTypename<StandaloneProjectOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newHasBlueprintUrl(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newHasBlueprintUrl(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newHasBlueprintUrl(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newHasBlueprintUrl(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newHasBlueprintUrl(
  options: RequireTypename<LotOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Lot>;
export function newHasBlueprintUrl(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newHasBlueprintUrl(
  options: RequireTypename<UnitOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Unit>;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newHasBlueprintUrl(
  options: RequireTypename<EstimateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Estimate>;
export function newHasBlueprintUrl(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitment>;
export function newHasBlueprintUrl(
  options: RequireTypename<CommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newHasBlueprintUrl(
  options: RequireTypename<DocumentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Document>;
export function newHasBlueprintUrl(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersion>;
export function newHasBlueprintUrl(
  options: RequireTypename<JobLogNoteOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogNote>;
export function newHasBlueprintUrl(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequest>;
export function newHasBlueprintUrl(
  options: RequireTypename<PunchlistItemTodoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PunchlistItemTodo>;
export function newHasBlueprintUrl(
  options: RequireTypename<WarrantyTicketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicket>;
export function newHasBlueprintUrl(
  options: RequireTypename<HomeownerContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContract>;
export function newHasBlueprintUrl(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractChangeOrder>;
export function newHasBlueprintUrl(
  options: RequireTypename<ReadyPlanOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlan>;
export function newHasBlueprintUrl(
  options: RequireTypename<PlanPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newHasBlueprintUrl(
  options: RequireTypename<GlobalOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOption>;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectCostCodeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCostCode>;
export function newHasBlueprintUrl(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentChangeOrder>;
export function newHasBlueprintUrl(
  options: RequireTypename<DesignPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackage>;
export function newHasBlueprintUrl(
  options: RequireTypename<DevelopmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Development>;
export function newHasBlueprintUrl(
  options: RequireTypename<ItemTemplateItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItem>;
export function newHasBlueprintUrl(
  options: RequireTypename<MaterialVariantOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariant>;
export function newHasBlueprintUrl(
  options: RequireTypename<ProductOfferingOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOffering>;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectReadyPlanConfigOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectReadyPlanConfig>;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectSiteConditionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectSiteCondition>;
export function newHasBlueprintUrl(
  options: RequireTypename<ReadyPlanOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOption>;
export function newHasBlueprintUrl(
  options: RequireTypename<TakeoffLineItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItem>;
export function newHasBlueprintUrl(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemVersion>;
export function newHasBlueprintUrl(
  options: HasBlueprintUrlOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasBlueprintUrlType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasBlueprintUrl"] = newHasBlueprintUrl;

export type ScheduleEntityOptions =
  | ScheduleTaskOptions
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<ScheduleOptions>;

export type ScheduleEntityType = ScheduleTask | SchedulePhase | ScheduleSubPhase | Schedule;

export type ScheduleEntityTypeName = "ScheduleTask" | "SchedulePhase" | "ScheduleSubPhase" | "Schedule";

export function newScheduleEntity(): FactoryResult<ScheduleTask>;
export function newScheduleEntity(
  options: ScheduleTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTask>;
export function newScheduleEntity(
  options: RequireTypename<SchedulePhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newScheduleEntity(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newScheduleEntity(
  options: RequireTypename<ScheduleOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Schedule>;
export function newScheduleEntity(
  options: ScheduleEntityOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ScheduleEntityType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["ScheduleEntity"] = newScheduleEntity;

export type NamedOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidContractLineItemOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<TradePartnerOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<BusinessFunctionOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeEventLineItemOptions>
  | RequireTypename<ChangeEventReasonOptions>
  | RequireTypename<ChangeEventTemplateConfigOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestAssetOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<ClientOptions>
  | RequireTypename<CohortOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>
  | RequireTypename<CommitmentChangeOrderOptions>
  | RequireTypename<CostCodeOptions>
  | RequireTypename<CostDivisionOptions>
  | RequireTypename<CustomerOptions>
  | RequireTypename<CustomerOwnerEntityOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<DevelopmentOptions>
  | RequireTypename<GlobalOptionTagOptions>
  | RequireTypename<GlobalOptionTypeOptions>
  | RequireTypename<GlobalPlanConstraintItemOptions>
  | RequireTypename<GlobalPlanMilestoneOptions>
  | RequireTypename<GlobalPlanTaskOptions>
  | RequireTypename<GlobalTaskOptions>
  | RequireTypename<HomeownerContractDrawOptions>
  | RequireTypename<InternalUserOptions>
  | RequireTypename<InvoiceScheduleTemplateOptions>
  | RequireTypename<ItemOptions>
  | RequireTypename<ItemSlotOptions>
  | RequireTypename<ItemTemplateOptions>
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<LocationOptions>
  | RequireTypename<MaterialVariantTagOptions>
  | RequireTypename<PandaDocOptions>
  | RequireTypename<PandaDocRecipientOptions>
  | RequireTypename<PlanMilestoneOptions>
  | RequireTypename<ProductOfferingOptions>
  | RequireTypename<ProjectStageTemplateConfigOptions>
  | RequireTypename<ProjectStatusChangeReasonOptions>
  | RequireTypename<ReadyPlanAggregateVersionOptions>
  | RequireTypename<ReadyPlanLocationOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<ReadyPlanOptionProgramDataModificationOptions>
  | RequireTypename<ScheduleOptions>
  | RequireTypename<ScheduleTemplateOptions>
  | RequireTypename<SubmarketOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>
  | RequireTypename<TradeCategoryOptions>
  | RequireTypename<TradePartnerContactOptions>
  | RequireTypename<TradePartnerMailingListOptions>
  | RequireTypename<TradePartnerUserOptions>
  | RequireTypename<UnitOfMeasureOptions>
  | RequireTypename<UserOptions>;

export type NamedType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidContractLineItem
  | BidItem
  | BidPackage
  | BidPackageRequest
  | TradePartner
  | Bill
  | BusinessFunction
  | ChangeEvent
  | ChangeEventLineItem
  | ChangeEventReason
  | ChangeEventTemplateConfig
  | ChangeRequest
  | ChangeRequestAsset
  | ChangeRequestToDo
  | Client
  | Cohort
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode
  | CommitmentChangeOrder
  | CostCode
  | CostDivision
  | Customer
  | CustomerOwnerEntity
  | DesignPackage
  | Development
  | GlobalOptionTag
  | GlobalOptionType
  | GlobalPlanConstraintItem
  | GlobalPlanMilestone
  | GlobalPlanTask
  | GlobalTask
  | HomeownerContractDraw
  | InternalUser
  | InvoiceScheduleTemplate
  | Item
  | ItemSlot
  | ItemTemplate
  | ItemTemplateItem
  | Location
  | MaterialVariantTag
  | PandaDoc
  | PandaDocRecipient
  | PlanMilestone
  | ProductOffering
  | ProjectStageTemplateConfig
  | ProjectStatusChangeReason
  | ReadyPlanAggregateVersion
  | ReadyPlanLocation
  | ReadyPlanOption
  | ReadyPlanOptionProgramDataModification
  | Schedule
  | ScheduleTemplate
  | Submarket
  | TakeoffLineItem
  | TakeoffLineItemVersion
  | TradeCategory
  | TradePartnerContact
  | TradePartnerMailingList
  | TradePartnerUser
  | UnitOfMeasure
  | User;

export type NamedTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidContractLineItem"
  | "BidItem"
  | "BidPackage"
  | "BidPackageRequest"
  | "TradePartner"
  | "Bill"
  | "BusinessFunction"
  | "ChangeEvent"
  | "ChangeEventLineItem"
  | "ChangeEventReason"
  | "ChangeEventTemplateConfig"
  | "ChangeRequest"
  | "ChangeRequestAsset"
  | "ChangeRequestToDo"
  | "Client"
  | "Cohort"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode"
  | "CommitmentChangeOrder"
  | "CostCode"
  | "CostDivision"
  | "Customer"
  | "CustomerOwnerEntity"
  | "DesignPackage"
  | "Development"
  | "GlobalOptionTag"
  | "GlobalOptionType"
  | "GlobalPlanConstraintItem"
  | "GlobalPlanMilestone"
  | "GlobalPlanTask"
  | "GlobalTask"
  | "HomeownerContractDraw"
  | "InternalUser"
  | "InvoiceScheduleTemplate"
  | "Item"
  | "ItemSlot"
  | "ItemTemplate"
  | "ItemTemplateItem"
  | "Location"
  | "MaterialVariantTag"
  | "PandaDoc"
  | "PandaDocRecipient"
  | "PlanMilestone"
  | "ProductOffering"
  | "ProjectStageTemplateConfig"
  | "ProjectStatusChangeReason"
  | "ReadyPlanAggregateVersion"
  | "ReadyPlanLocation"
  | "ReadyPlanOption"
  | "ReadyPlanOptionProgramDataModification"
  | "Schedule"
  | "ScheduleTemplate"
  | "Submarket"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion"
  | "TradeCategory"
  | "TradePartnerContact"
  | "TradePartnerMailingList"
  | "TradePartnerUser"
  | "UnitOfMeasure"
  | "User";

export function newNamed(): FactoryResult<ScheduleTask>;
export function newNamed(options: ScheduleTaskOptions, factoryOptions?: FactoryOptions): FactoryResult<ScheduleTask>;
export function newNamed(
  options: RequireTypename<ApprovalOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Approval>;
export function newNamed(
  options: RequireTypename<BidContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContract>;
export function newNamed(
  options: RequireTypename<BidContractLineItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractLineItem>;
export function newNamed(
  options: RequireTypename<BidItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidItem>;
export function newNamed(
  options: RequireTypename<BidPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackage>;
export function newNamed(
  options: RequireTypename<BidPackageRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPackageRequest>;
export function newNamed(
  options: RequireTypename<TradePartnerOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartner>;
export function newNamed(options: RequireTypename<BillOptions>, factoryOptions?: FactoryOptions): FactoryResult<Bill>;
export function newNamed(
  options: RequireTypename<BusinessFunctionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BusinessFunction>;
export function newNamed(
  options: RequireTypename<ChangeEventOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEvent>;
export function newNamed(
  options: RequireTypename<ChangeEventLineItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventLineItem>;
export function newNamed(
  options: RequireTypename<ChangeEventReasonOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventReason>;
export function newNamed(
  options: RequireTypename<ChangeEventTemplateConfigOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventTemplateConfig>;
export function newNamed(
  options: RequireTypename<ChangeRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequest>;
export function newNamed(
  options: RequireTypename<ChangeRequestAssetOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestAsset>;
export function newNamed(
  options: RequireTypename<ChangeRequestToDoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeRequestToDo>;
export function newNamed(
  options: RequireTypename<ClientOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Client>;
export function newNamed(
  options: RequireTypename<CohortOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Cohort>;
export function newNamed(
  options: RequireTypename<SchedulePhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newNamed(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newNamed(options: RequireTypename<TaskOptions>, factoryOptions?: FactoryOptions): FactoryResult<Task>;
export function newNamed(
  options: RequireTypename<PlanTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanTask>;
export function newNamed(options: RequireTypename<ToDoOptions>, factoryOptions?: FactoryOptions): FactoryResult<ToDo>;
export function newNamed(
  options: RequireTypename<InvoiceOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Invoice>;
export function newNamed(
  options: RequireTypename<StandaloneProjectOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newNamed(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newNamed(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newNamed(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newNamed(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newNamed(options: RequireTypename<LotOptions>, factoryOptions?: FactoryOptions): FactoryResult<Lot>;
export function newNamed(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newNamed(options: RequireTypename<UnitOptions>, factoryOptions?: FactoryOptions): FactoryResult<Unit>;
export function newNamed(
  options: RequireTypename<ProjectItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newNamed(
  options: RequireTypename<EstimateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Estimate>;
export function newNamed(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitment>;
export function newNamed(
  options: RequireTypename<CommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newNamed(
  options: RequireTypename<DocumentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Document>;
export function newNamed(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersion>;
export function newNamed(
  options: RequireTypename<JobLogNoteOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<JobLogNote>;
export function newNamed(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerAvailabilityRequest>;
export function newNamed(
  options: RequireTypename<PunchlistItemTodoOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PunchlistItemTodo>;
export function newNamed(
  options: RequireTypename<WarrantyTicketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<WarrantyTicket>;
export function newNamed(
  options: RequireTypename<HomeownerContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContract>;
export function newNamed(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractChangeOrder>;
export function newNamed(
  options: RequireTypename<ReadyPlanOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlan>;
export function newNamed(
  options: RequireTypename<PlanPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newNamed(
  options: RequireTypename<GlobalOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOption>;
export function newNamed(
  options: RequireTypename<ProjectCostCodeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCostCode>;
export function newNamed(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentChangeOrder>;
export function newNamed(
  options: RequireTypename<CostCodeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCode>;
export function newNamed(
  options: RequireTypename<CostDivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostDivision>;
export function newNamed(
  options: RequireTypename<CustomerOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Customer>;
export function newNamed(
  options: RequireTypename<CustomerOwnerEntityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CustomerOwnerEntity>;
export function newNamed(
  options: RequireTypename<DesignPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackage>;
export function newNamed(
  options: RequireTypename<DevelopmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Development>;
export function newNamed(
  options: RequireTypename<GlobalOptionTagOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOptionTag>;
export function newNamed(
  options: RequireTypename<GlobalOptionTypeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalOptionType>;
export function newNamed(
  options: RequireTypename<GlobalPlanConstraintItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanConstraintItem>;
export function newNamed(
  options: RequireTypename<GlobalPlanMilestoneOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanMilestone>;
export function newNamed(
  options: RequireTypename<GlobalPlanTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanTask>;
export function newNamed(
  options: RequireTypename<GlobalTaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalTask>;
export function newNamed(
  options: RequireTypename<HomeownerContractDrawOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractDraw>;
export function newNamed(
  options: RequireTypename<InternalUserOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<InternalUser>;
export function newNamed(
  options: RequireTypename<InvoiceScheduleTemplateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<InvoiceScheduleTemplate>;
export function newNamed(options: RequireTypename<ItemOptions>, factoryOptions?: FactoryOptions): FactoryResult<Item>;
export function newNamed(
  options: RequireTypename<ItemSlotOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemSlot>;
export function newNamed(
  options: RequireTypename<ItemTemplateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplate>;
export function newNamed(
  options: RequireTypename<ItemTemplateItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItem>;
export function newNamed(
  options: RequireTypename<LocationOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Location>;
export function newNamed(
  options: RequireTypename<MaterialVariantTagOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialVariantTag>;
export function newNamed(
  options: RequireTypename<PandaDocOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PandaDoc>;
export function newNamed(
  options: RequireTypename<PandaDocRecipientOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PandaDocRecipient>;
export function newNamed(
  options: RequireTypename<PlanMilestoneOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanMilestone>;
export function newNamed(
  options: RequireTypename<ProductOfferingOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOffering>;
export function newNamed(
  options: RequireTypename<ProjectStageTemplateConfigOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStageTemplateConfig>;
export function newNamed(
  options: RequireTypename<ProjectStatusChangeReasonOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStatusChangeReason>;
export function newNamed(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanAggregateVersion>;
export function newNamed(
  options: RequireTypename<ReadyPlanLocationOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanLocation>;
export function newNamed(
  options: RequireTypename<ReadyPlanOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOption>;
export function newNamed(
  options: RequireTypename<ReadyPlanOptionProgramDataModificationOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionProgramDataModification>;
export function newNamed(
  options: RequireTypename<ScheduleOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Schedule>;
export function newNamed(
  options: RequireTypename<ScheduleTemplateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTemplate>;
export function newNamed(
  options: RequireTypename<SubmarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Submarket>;
export function newNamed(
  options: RequireTypename<TakeoffLineItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItem>;
export function newNamed(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemVersion>;
export function newNamed(
  options: RequireTypename<TradeCategoryOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradeCategory>;
export function newNamed(
  options: RequireTypename<TradePartnerContactOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerContact>;
export function newNamed(
  options: RequireTypename<TradePartnerMailingListOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerMailingList>;
export function newNamed(
  options: RequireTypename<TradePartnerUserOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradePartnerUser>;
export function newNamed(
  options: RequireTypename<UnitOfMeasureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<UnitOfMeasure>;
export function newNamed(options: RequireTypename<UserOptions>, factoryOptions?: FactoryOptions): FactoryResult<User>;
export function newNamed(
  options: NamedOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<NamedType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["Named"] = newNamed;

export type MaybeHasIntervalOptions =
  | ScheduleTaskOptions
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<ProjectStageOptions>
  | RequireTypename<ScheduleOptions>;

export type MaybeHasIntervalType = ScheduleTask | SchedulePhase | ScheduleSubPhase | Task | ProjectStage | Schedule;

export type MaybeHasIntervalTypeName =
  | "ScheduleTask"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "ProjectStage"
  | "Schedule";

export function newMaybeHasInterval(): FactoryResult<ScheduleTask>;
export function newMaybeHasInterval(
  options: ScheduleTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTask>;
export function newMaybeHasInterval(
  options: RequireTypename<SchedulePhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newMaybeHasInterval(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newMaybeHasInterval(
  options: RequireTypename<TaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Task>;
export function newMaybeHasInterval(
  options: RequireTypename<ProjectStageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStage>;
export function newMaybeHasInterval(
  options: RequireTypename<ScheduleOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Schedule>;
export function newMaybeHasInterval(
  options: MaybeHasIntervalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaybeHasIntervalType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasInterval"] = newMaybeHasInterval;

export type MaybeHasBaselineIntervalOptions =
  | ScheduleTaskOptions
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<ScheduleOptions>;

export type MaybeHasBaselineIntervalType = ScheduleTask | SchedulePhase | ScheduleSubPhase | Schedule;

export type MaybeHasBaselineIntervalTypeName = "ScheduleTask" | "SchedulePhase" | "ScheduleSubPhase" | "Schedule";

export function newMaybeHasBaselineInterval(): FactoryResult<ScheduleTask>;
export function newMaybeHasBaselineInterval(
  options: ScheduleTaskOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTask>;
export function newMaybeHasBaselineInterval(
  options: RequireTypename<SchedulePhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SchedulePhase>;
export function newMaybeHasBaselineInterval(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleSubPhase>;
export function newMaybeHasBaselineInterval(
  options: RequireTypename<ScheduleOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Schedule>;
export function newMaybeHasBaselineInterval(
  options: MaybeHasBaselineIntervalOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaybeHasBaselineIntervalType> {
  const { __typename = "ScheduleTask" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasBaselineInterval"] = newMaybeHasBaselineInterval;

export type HasPandaDocOptions =
  | BidContractRevisionOptions
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<CommitmentChangeOrderOptions>;

export type HasPandaDocType = BidContractRevision | DevelopmentCommitment | Commitment | CommitmentChangeOrder;

export type HasPandaDocTypeName =
  | "BidContractRevision"
  | "DevelopmentCommitment"
  | "Commitment"
  | "CommitmentChangeOrder";

export function newHasPandaDoc(): FactoryResult<BidContractRevision>;
export function newHasPandaDoc(
  options: BidContractRevisionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidContractRevision>;
export function newHasPandaDoc(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DevelopmentCommitment>;
export function newHasPandaDoc(
  options: RequireTypename<CommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newHasPandaDoc(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentChangeOrder>;
export function newHasPandaDoc(
  options: HasPandaDocOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasPandaDocType> {
  const { __typename = "BidContractRevision" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasPandaDoc"] = newHasPandaDoc;

export type HasDisplayNameOptions =
  | BidItemOptions
  | RequireTypename<BidPlanChildGroupOptions>
  | RequireTypename<BidPlanChildGroupLineOptions>
  | RequireTypename<BidPlanGroupOptions>
  | RequireTypename<ChangeEventLineItemOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<CommitmentChangeOrderOptions>
  | RequireTypename<CostCodeOptions>
  | RequireTypename<CostDivisionOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<ItemOptions>
  | RequireTypename<ItemTemplateOptions>
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<ProductOfferingOptions>
  | RequireTypename<ReadyPlanAggregateVersionOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>
  | RequireTypename<TradeCategoryOptions>;

export type HasDisplayNameType =
  | BidItem
  | BidPlanChildGroup
  | BidPlanChildGroupLine
  | BidPlanGroup
  | ChangeEventLineItem
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | ReadyPlan
  | PlanPackage
  | CommitmentChangeOrder
  | CostCode
  | CostDivision
  | DesignPackage
  | Item
  | ItemTemplate
  | ItemTemplateItem
  | ProductOffering
  | ReadyPlanAggregateVersion
  | ReadyPlanOption
  | TakeoffLineItem
  | TakeoffLineItemVersion
  | TradeCategory;

export type HasDisplayNameTypeName =
  | "BidItem"
  | "BidPlanChildGroup"
  | "BidPlanChildGroupLine"
  | "BidPlanGroup"
  | "ChangeEventLineItem"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "ReadyPlan"
  | "PlanPackage"
  | "CommitmentChangeOrder"
  | "CostCode"
  | "CostDivision"
  | "DesignPackage"
  | "Item"
  | "ItemTemplate"
  | "ItemTemplateItem"
  | "ProductOffering"
  | "ReadyPlanAggregateVersion"
  | "ReadyPlanOption"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion"
  | "TradeCategory";

export function newHasDisplayName(): FactoryResult<BidItem>;
export function newHasDisplayName(options: BidItemOptions, factoryOptions?: FactoryOptions): FactoryResult<BidItem>;
export function newHasDisplayName(
  options: RequireTypename<BidPlanChildGroupOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPlanChildGroup>;
export function newHasDisplayName(
  options: RequireTypename<BidPlanChildGroupLineOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPlanChildGroupLine>;
export function newHasDisplayName(
  options: RequireTypename<BidPlanGroupOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<BidPlanGroup>;
export function newHasDisplayName(
  options: RequireTypename<ChangeEventLineItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventLineItem>;
export function newHasDisplayName(
  options: RequireTypename<StandaloneProjectOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newHasDisplayName(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newHasDisplayName(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newHasDisplayName(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newHasDisplayName(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newHasDisplayName(
  options: RequireTypename<LotOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Lot>;
export function newHasDisplayName(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newHasDisplayName(
  options: RequireTypename<UnitOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Unit>;
export function newHasDisplayName(
  options: RequireTypename<ProjectItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newHasDisplayName(
  options: RequireTypename<CommitmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newHasDisplayName(
  options: RequireTypename<DocumentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Document>;
export function newHasDisplayName(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersion>;
export function newHasDisplayName(
  options: RequireTypename<ReadyPlanOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlan>;
export function newHasDisplayName(
  options: RequireTypename<PlanPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newHasDisplayName(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentChangeOrder>;
export function newHasDisplayName(
  options: RequireTypename<CostCodeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCode>;
export function newHasDisplayName(
  options: RequireTypename<CostDivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostDivision>;
export function newHasDisplayName(
  options: RequireTypename<DesignPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackage>;
export function newHasDisplayName(
  options: RequireTypename<ItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Item>;
export function newHasDisplayName(
  options: RequireTypename<ItemTemplateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplate>;
export function newHasDisplayName(
  options: RequireTypename<ItemTemplateItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItem>;
export function newHasDisplayName(
  options: RequireTypename<ProductOfferingOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOffering>;
export function newHasDisplayName(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanAggregateVersion>;
export function newHasDisplayName(
  options: RequireTypename<ReadyPlanOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOption>;
export function newHasDisplayName(
  options: RequireTypename<TakeoffLineItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItem>;
export function newHasDisplayName(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemVersion>;
export function newHasDisplayName(
  options: RequireTypename<TradeCategoryOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradeCategory>;
export function newHasDisplayName(
  options: HasDisplayNameOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasDisplayNameType> {
  const { __typename = "BidItem" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasDisplayName"] = newHasDisplayName;

export type MaybeHasProjectOptions =
  | BillOptions
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<ProjectStageOptions>
  | RequireTypename<ProjectCollaboratorOptions>
  | RequireTypename<ProjectUpdateOptions>;

export type MaybeHasProjectType =
  | Bill
  | ChangeEvent
  | Task
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | HomeownerContract
  | ProjectStage
  | ProjectCollaborator
  | ProjectUpdate;

export type MaybeHasProjectTypeName =
  | "Bill"
  | "ChangeEvent"
  | "Task"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "HomeownerContract"
  | "ProjectStage"
  | "ProjectCollaborator"
  | "ProjectUpdate";

export function newMaybeHasProject(): FactoryResult<Bill>;
export function newMaybeHasProject(options: BillOptions, factoryOptions?: FactoryOptions): FactoryResult<Bill>;
export function newMaybeHasProject(
  options: RequireTypename<ChangeEventOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEvent>;
export function newMaybeHasProject(
  options: RequireTypename<TaskOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Task>;
export function newMaybeHasProject(
  options: RequireTypename<InvoiceOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Invoice>;
export function newMaybeHasProject(
  options: RequireTypename<StandaloneProjectOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newMaybeHasProject(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newMaybeHasProject(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newMaybeHasProject(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newMaybeHasProject(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newMaybeHasProject(
  options: RequireTypename<LotOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Lot>;
export function newMaybeHasProject(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newMaybeHasProject(
  options: RequireTypename<UnitOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Unit>;
export function newMaybeHasProject(
  options: RequireTypename<ProjectItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newMaybeHasProject(
  options: RequireTypename<EstimateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Estimate>;
export function newMaybeHasProject(
  options: RequireTypename<HomeownerContractOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContract>;
export function newMaybeHasProject(
  options: RequireTypename<ProjectStageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStage>;
export function newMaybeHasProject(
  options: RequireTypename<ProjectCollaboratorOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectCollaborator>;
export function newMaybeHasProject(
  options: RequireTypename<ProjectUpdateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectUpdate>;
export function newMaybeHasProject(
  options: MaybeHasProjectOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaybeHasProjectType> {
  const { __typename = "Bill" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasProject"] = newMaybeHasProject;

export type ProjectStageTemplateConfigLikeOptions =
  | ChangeEventTemplateConfigOptions
  | RequireTypename<ProjectStageTemplateConfigOptions>;

export type ProjectStageTemplateConfigLikeType = ChangeEventTemplateConfig | ProjectStageTemplateConfig;

export type ProjectStageTemplateConfigLikeTypeName = "ChangeEventTemplateConfig" | "ProjectStageTemplateConfig";

export function newProjectStageTemplateConfigLike(): FactoryResult<ChangeEventTemplateConfig>;
export function newProjectStageTemplateConfigLike(
  options: ChangeEventTemplateConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ChangeEventTemplateConfig>;
export function newProjectStageTemplateConfigLike(
  options: RequireTypename<ProjectStageTemplateConfigOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectStageTemplateConfig>;
export function newProjectStageTemplateConfigLike(
  options: ProjectStageTemplateConfigLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectStageTemplateConfigLikeType> {
  const { __typename = "ChangeEventTemplateConfig" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["ProjectStageTemplateConfigLike"] = newProjectStageTemplateConfigLike;

export type HasCheckoutUrlOptions = CheckoutConfigOptions;

export type HasCheckoutUrlType = CheckoutConfig;

export type HasCheckoutUrlTypeName = "CheckoutConfig";

export function newHasCheckoutUrl(): FactoryResult<CheckoutConfig>;
export function newHasCheckoutUrl(
  options: CheckoutConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfig>;
export function newHasCheckoutUrl(
  options: HasCheckoutUrlOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasCheckoutUrlType> {
  const { __typename = "CheckoutConfig" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasCheckoutUrl"] = newHasCheckoutUrl;

export type ReadyPlanConfigLikeOptions =
  | CheckoutConfigOptions
  | RequireTypename<ProductOfferingConfigOptions>
  | RequireTypename<ProjectReadyPlanConfigOptions>;

export type ReadyPlanConfigLikeType = CheckoutConfig | ProductOfferingConfig | ProjectReadyPlanConfig;

export type ReadyPlanConfigLikeTypeName = "CheckoutConfig" | "ProductOfferingConfig" | "ProjectReadyPlanConfig";

export function newReadyPlanConfigLike(): FactoryResult<CheckoutConfig>;
export function newReadyPlanConfigLike(
  options: CheckoutConfigOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfig>;
export function newReadyPlanConfigLike(
  options: RequireTypename<ProductOfferingConfigOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOfferingConfig>;
export function newReadyPlanConfigLike(
  options: RequireTypename<ProjectReadyPlanConfigOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectReadyPlanConfig>;
export function newReadyPlanConfigLike(
  options: ReadyPlanConfigLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanConfigLikeType> {
  const { __typename = "CheckoutConfig" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["ReadyPlanConfigLike"] = newReadyPlanConfigLike;

export type PotentialOptionGroupLikeOptions =
  | CheckoutConfigOptionGroupOptions
  | RequireTypename<ProjectReadyPlanConfigPotentialOptionGroupOptions>;

export type PotentialOptionGroupLikeType = CheckoutConfigOptionGroup | ProjectReadyPlanConfigPotentialOptionGroup;

export type PotentialOptionGroupLikeTypeName =
  | "CheckoutConfigOptionGroup"
  | "ProjectReadyPlanConfigPotentialOptionGroup";

export function newPotentialOptionGroupLike(): FactoryResult<CheckoutConfigOptionGroup>;
export function newPotentialOptionGroupLike(
  options: CheckoutConfigOptionGroupOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigOptionGroup>;
export function newPotentialOptionGroupLike(
  options: RequireTypename<ProjectReadyPlanConfigPotentialOptionGroupOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectReadyPlanConfigPotentialOptionGroup>;
export function newPotentialOptionGroupLike(
  options: PotentialOptionGroupLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialOptionGroupLikeType> {
  const { __typename = "CheckoutConfigOptionGroup" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["PotentialOptionGroupLike"] = newPotentialOptionGroupLike;

export type PotentialOptionLikeOptions =
  | CheckoutConfigPotentialOptionOptions
  | RequireTypename<ProjectReadyPlanConfigPotentialOptionOptions>;

export type PotentialOptionLikeType = CheckoutConfigPotentialOption | ProjectReadyPlanConfigPotentialOption;

export type PotentialOptionLikeTypeName = "CheckoutConfigPotentialOption" | "ProjectReadyPlanConfigPotentialOption";

export function newPotentialOptionLike(): FactoryResult<CheckoutConfigPotentialOption>;
export function newPotentialOptionLike(
  options: CheckoutConfigPotentialOptionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CheckoutConfigPotentialOption>;
export function newPotentialOptionLike(
  options: RequireTypename<ProjectReadyPlanConfigPotentialOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectReadyPlanConfigPotentialOption>;
export function newPotentialOptionLike(
  options: PotentialOptionLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<PotentialOptionLikeType> {
  const { __typename = "CheckoutConfigPotentialOption" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["PotentialOptionLike"] = newPotentialOptionLike;

export type ProjectOptions =
  | StandaloneProjectOptions
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>;

export type ProjectType = StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type ProjectTypeName =
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit";

export function newProject(): FactoryResult<StandaloneProject>;
export function newProject(
  options: StandaloneProjectOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newProject(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newProject(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newProject(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newProject(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newProject(options: RequireTypename<LotOptions>, factoryOptions?: FactoryOptions): FactoryResult<Lot>;
export function newProject(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newProject(options: RequireTypename<UnitOptions>, factoryOptions?: FactoryOptions): FactoryResult<Unit>;
export function newProject(
  options: ProjectOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectType> {
  const { __typename = "StandaloneProject" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["Project"] = newProject;

export type HasSchedulesOptions =
  | StandaloneProjectOptions
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<DevelopmentOptions>
  | RequireTypename<ScheduleTemplateOptions>;

export type HasSchedulesType =
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | Development
  | ScheduleTemplate;

export type HasSchedulesTypeName =
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "Development"
  | "ScheduleTemplate";

export function newHasSchedules(): FactoryResult<StandaloneProject>;
export function newHasSchedules(
  options: StandaloneProjectOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newHasSchedules(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newHasSchedules(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newHasSchedules(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newHasSchedules(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newHasSchedules(
  options: RequireTypename<LotOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Lot>;
export function newHasSchedules(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newHasSchedules(
  options: RequireTypename<UnitOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Unit>;
export function newHasSchedules(
  options: RequireTypename<DevelopmentOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Development>;
export function newHasSchedules(
  options: RequireTypename<ScheduleTemplateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTemplate>;
export function newHasSchedules(
  options: HasSchedulesOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasSchedulesType> {
  const { __typename = "StandaloneProject" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasSchedules"] = newHasSchedules;

export type HasHopUrlOptions =
  | StandaloneProjectOptions
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>;

export type HasHopUrlType = StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type HasHopUrlTypeName =
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit";

export function newHasHopUrl(): FactoryResult<StandaloneProject>;
export function newHasHopUrl(
  options: StandaloneProjectOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newHasHopUrl(
  options: RequireTypename<RegionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Region>;
export function newHasHopUrl(
  options: RequireTypename<MarketOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Market>;
export function newHasHopUrl(
  options: RequireTypename<CommunityOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Community>;
export function newHasHopUrl(
  options: RequireTypename<SubdivisionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Subdivision>;
export function newHasHopUrl(options: RequireTypename<LotOptions>, factoryOptions?: FactoryOptions): FactoryResult<Lot>;
export function newHasHopUrl(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newHasHopUrl(
  options: RequireTypename<UnitOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Unit>;
export function newHasHopUrl(
  options: HasHopUrlOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasHopUrlType> {
  const { __typename = "StandaloneProject" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasHopUrl"] = newHasHopUrl;

export type MaybeHasPropcoUrlOptions = StandaloneProjectOptions | RequireTypename<StructureOptions>;

export type MaybeHasPropcoUrlType = StandaloneProject | Structure;

export type MaybeHasPropcoUrlTypeName = "StandaloneProject" | "Structure";

export function newMaybeHasPropcoUrl(): FactoryResult<StandaloneProject>;
export function newMaybeHasPropcoUrl(
  options: StandaloneProjectOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<StandaloneProject>;
export function newMaybeHasPropcoUrl(
  options: RequireTypename<StructureOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Structure>;
export function newMaybeHasPropcoUrl(
  options: MaybeHasPropcoUrlOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaybeHasPropcoUrlType> {
  const { __typename = "StandaloneProject" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasPropcoUrl"] = newMaybeHasPropcoUrl;

export type ProjectItemLikeOptions = ProjectItemOptions | RequireTypename<ProtoProjectItemOptions>;

export type ProjectItemLikeType = ProjectItem | ProtoProjectItem;

export type ProjectItemLikeTypeName = "ProjectItem" | "ProtoProjectItem";

export function newProjectItemLike(): FactoryResult<ProjectItem>;
export function newProjectItemLike(
  options: ProjectItemOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProjectItem>;
export function newProjectItemLike(
  options: RequireTypename<ProtoProjectItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProtoProjectItem>;
export function newProjectItemLike(
  options: ProjectItemLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProjectItemLikeType> {
  const { __typename = "ProjectItem" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["ProjectItemLike"] = newProjectItemLike;

export type CommitmentLikeOptions = CommitmentOptions | RequireTypename<CommitmentChangeOrderOptions>;

export type CommitmentLikeType = Commitment | CommitmentChangeOrder;

export type CommitmentLikeTypeName = "Commitment" | "CommitmentChangeOrder";

export function newCommitmentLike(): FactoryResult<Commitment>;
export function newCommitmentLike(
  options: CommitmentOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<Commitment>;
export function newCommitmentLike(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<CommitmentChangeOrder>;
export function newCommitmentLike(
  options: CommitmentLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<CommitmentLikeType> {
  const { __typename = "Commitment" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["CommitmentLike"] = newCommitmentLike;

export type BaseItemLikeOptions =
  | ItemTemplateItemVersionOptions
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>;

export type BaseItemLikeType = ItemTemplateItemVersion | ItemTemplateItem | TakeoffLineItem | TakeoffLineItemVersion;

export type BaseItemLikeTypeName =
  | "ItemTemplateItemVersion"
  | "ItemTemplateItem"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion";

export function newBaseItemLike(): FactoryResult<ItemTemplateItemVersion>;
export function newBaseItemLike(
  options: ItemTemplateItemVersionOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItemVersion>;
export function newBaseItemLike(
  options: RequireTypename<ItemTemplateItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplateItem>;
export function newBaseItemLike(
  options: RequireTypename<TakeoffLineItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItem>;
export function newBaseItemLike(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TakeoffLineItemVersion>;
export function newBaseItemLike(
  options: BaseItemLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BaseItemLikeType> {
  const { __typename = "ItemTemplateItemVersion" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["BaseItemLike"] = newBaseItemLike;

export type HomeownerContractLikeOptions =
  | HomeownerContractOptions
  | RequireTypename<HomeownerContractChangeOrderOptions>;

export type HomeownerContractLikeType = HomeownerContract | HomeownerContractChangeOrder;

export type HomeownerContractLikeTypeName = "HomeownerContract" | "HomeownerContractChangeOrder";

export function newHomeownerContractLike(): FactoryResult<HomeownerContract>;
export function newHomeownerContractLike(
  options: HomeownerContractOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContract>;
export function newHomeownerContractLike(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<HomeownerContractChangeOrder>;
export function newHomeownerContractLike(
  options: HomeownerContractLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HomeownerContractLikeType> {
  const { __typename = "HomeownerContract" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HomeownerContractLike"] = newHomeownerContractLike;

export type ReadyPlanLikeOptions =
  | ReadyPlanOptions
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<ProductOfferingOptions>;

export type ReadyPlanLikeType = ReadyPlan | PlanPackage | DesignPackage | ProductOffering;

export type ReadyPlanLikeTypeName = "ReadyPlan" | "PlanPackage" | "DesignPackage" | "ProductOffering";

export function newReadyPlanLike(): FactoryResult<ReadyPlan>;
export function newReadyPlanLike(options: ReadyPlanOptions, factoryOptions?: FactoryOptions): FactoryResult<ReadyPlan>;
export function newReadyPlanLike(
  options: RequireTypename<PlanPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newReadyPlanLike(
  options: RequireTypename<DesignPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackage>;
export function newReadyPlanLike(
  options: RequireTypename<ProductOfferingOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOffering>;
export function newReadyPlanLike(
  options: ReadyPlanLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanLikeType> {
  const { __typename = "ReadyPlan" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["ReadyPlanLike"] = newReadyPlanLike;

export type BaseItemParentOptions =
  | ReadyPlanOptions
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<ItemTemplateOptions>
  | RequireTypename<ProductOfferingOptions>;

export type BaseItemParentType = ReadyPlan | PlanPackage | DesignPackage | ItemTemplate | ProductOffering;

export type BaseItemParentTypeName = "ReadyPlan" | "PlanPackage" | "DesignPackage" | "ItemTemplate" | "ProductOffering";

export function newBaseItemParent(): FactoryResult<ReadyPlan>;
export function newBaseItemParent(options: ReadyPlanOptions, factoryOptions?: FactoryOptions): FactoryResult<ReadyPlan>;
export function newBaseItemParent(
  options: RequireTypename<PlanPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<PlanPackage>;
export function newBaseItemParent(
  options: RequireTypename<DesignPackageOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DesignPackage>;
export function newBaseItemParent(
  options: RequireTypename<ItemTemplateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplate>;
export function newBaseItemParent(
  options: RequireTypename<ProductOfferingOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProductOffering>;
export function newBaseItemParent(
  options: BaseItemParentOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BaseItemParentType> {
  const { __typename = "ReadyPlan" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["BaseItemParent"] = newBaseItemParent;

export type HasMaterialLeadTimeConfigDataOptions =
  | CostCodeOptions
  | RequireTypename<ItemOptions>
  | RequireTypename<MaterialListingOptions>;

export type HasMaterialLeadTimeConfigDataType = CostCode | Item | MaterialListing;

export type HasMaterialLeadTimeConfigDataTypeName = "CostCode" | "Item" | "MaterialListing";

export function newHasMaterialLeadTimeConfigData(): FactoryResult<CostCode>;
export function newHasMaterialLeadTimeConfigData(
  options: CostCodeOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<CostCode>;
export function newHasMaterialLeadTimeConfigData(
  options: RequireTypename<ItemOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<Item>;
export function newHasMaterialLeadTimeConfigData(
  options: RequireTypename<MaterialListingOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialListing>;
export function newHasMaterialLeadTimeConfigData(
  options: HasMaterialLeadTimeConfigDataOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasMaterialLeadTimeConfigDataType> {
  const { __typename = "CostCode" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasMaterialLeadTimeConfigData"] = newHasMaterialLeadTimeConfigData;

export type MaybeHasMarketOptions = DevelopmentOptions | RequireTypename<ScheduleTemplateOptions>;

export type MaybeHasMarketType = Development | ScheduleTemplate;

export type MaybeHasMarketTypeName = "Development" | "ScheduleTemplate";

export function newMaybeHasMarket(): FactoryResult<Development>;
export function newMaybeHasMarket(
  options: DevelopmentOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<Development>;
export function newMaybeHasMarket(
  options: RequireTypename<ScheduleTemplateOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ScheduleTemplate>;
export function newMaybeHasMarket(
  options: MaybeHasMarketOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<MaybeHasMarketType> {
  const { __typename = "Development" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasMarket"] = newMaybeHasMarket;

export type HasGlobalConstraintItemOptions = GlobalPlanAllowanceOptions | RequireTypename<GlobalPlanConstraintOptions>;

export type HasGlobalConstraintItemType = GlobalPlanAllowance | GlobalPlanConstraint;

export type HasGlobalConstraintItemTypeName = "GlobalPlanAllowance" | "GlobalPlanConstraint";

export function newHasGlobalConstraintItem(): FactoryResult<GlobalPlanAllowance>;
export function newHasGlobalConstraintItem(
  options: GlobalPlanAllowanceOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanAllowance>;
export function newHasGlobalConstraintItem(
  options: RequireTypename<GlobalPlanConstraintOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<GlobalPlanConstraint>;
export function newHasGlobalConstraintItem(
  options: HasGlobalConstraintItemOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasGlobalConstraintItemType> {
  const { __typename = "GlobalPlanAllowance" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasGlobalConstraintItem"] = newHasGlobalConstraintItem;

export type HasDisplayVersionOptions = ItemTemplateOptions | RequireTypename<ReadyPlanAggregateVersionOptions>;

export type HasDisplayVersionType = ItemTemplate | ReadyPlanAggregateVersion;

export type HasDisplayVersionTypeName = "ItemTemplate" | "ReadyPlanAggregateVersion";

export function newHasDisplayVersion(): FactoryResult<ItemTemplate>;
export function newHasDisplayVersion(
  options: ItemTemplateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplate>;
export function newHasDisplayVersion(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanAggregateVersion>;
export function newHasDisplayVersion(
  options: HasDisplayVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasDisplayVersionType> {
  const { __typename = "ItemTemplate" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasDisplayVersion"] = newHasDisplayVersion;

export type BaseItemParentVersionOptions = ItemTemplateOptions | RequireTypename<ReadyPlanAggregateVersionOptions>;

export type BaseItemParentVersionType = ItemTemplate | ReadyPlanAggregateVersion;

export type BaseItemParentVersionTypeName = "ItemTemplate" | "ReadyPlanAggregateVersion";

export function newBaseItemParentVersion(): FactoryResult<ItemTemplate>;
export function newBaseItemParentVersion(
  options: ItemTemplateOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ItemTemplate>;
export function newBaseItemParentVersion(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanAggregateVersion>;
export function newBaseItemParentVersion(
  options: BaseItemParentVersionOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<BaseItemParentVersionType> {
  const { __typename = "ItemTemplate" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["BaseItemParentVersion"] = newBaseItemParentVersion;

export type HasOptionPricingDataOptions = MaterialListingOptions | RequireTypename<ReadyPlanOptionOptions>;

export type HasOptionPricingDataType = MaterialListing | ReadyPlanOption;

export type HasOptionPricingDataTypeName = "MaterialListing" | "ReadyPlanOption";

export function newHasOptionPricingData(): FactoryResult<MaterialListing>;
export function newHasOptionPricingData(
  options: MaterialListingOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<MaterialListing>;
export function newHasOptionPricingData(
  options: RequireTypename<ReadyPlanOptionOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOption>;
export function newHasOptionPricingData(
  options: HasOptionPricingDataOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasOptionPricingDataType> {
  const { __typename = "MaterialListing" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasOptionPricingData"] = newHasOptionPricingData;

export type ProgramDataLikeOptions = ProgramDataOptions | RequireTypename<NewProgramDataOptions>;

export type ProgramDataLikeType = ProgramData | NewProgramData;

export type ProgramDataLikeTypeName = "ProgramData" | "NewProgramData";

export function newProgramDataLike(): FactoryResult<ProgramData>;
export function newProgramDataLike(
  options: ProgramDataOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ProgramData>;
export function newProgramDataLike(
  options: RequireTypename<NewProgramDataOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<NewProgramData>;
export function newProgramDataLike(
  options: ProgramDataLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ProgramDataLikeType> {
  const { __typename = "ProgramData" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["ProgramDataLike"] = newProgramDataLike;

export type HasUserErrorsOptions = SaveProjectItemsResultOptions;

export type HasUserErrorsType = SaveProjectItemsResult;

export type HasUserErrorsTypeName = "SaveProjectItemsResult";

export function newHasUserErrors(): FactoryResult<SaveProjectItemsResult>;
export function newHasUserErrors(
  options: SaveProjectItemsResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveProjectItemsResult>;
export function newHasUserErrors(
  options: HasUserErrorsOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasUserErrorsType> {
  const { __typename = "SaveProjectItemsResult" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasUserErrors"] = newHasUserErrors;

export type ReadyPlanCostDataOptions =
  | ComputeReadyPlanCostResultOptions
  | RequireTypename<ReadyPlanOptionCostDeltaOptions>;

export type ReadyPlanCostDataType = ComputeReadyPlanCostResult | ReadyPlanOptionCostDelta;

export type ReadyPlanCostDataTypeName = "ComputeReadyPlanCostResult" | "ReadyPlanOptionCostDelta";

export function newReadyPlanCostData(): FactoryResult<ComputeReadyPlanCostResult>;
export function newReadyPlanCostData(
  options: ComputeReadyPlanCostResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<ComputeReadyPlanCostResult>;
export function newReadyPlanCostData(
  options: RequireTypename<ReadyPlanOptionCostDeltaOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<ReadyPlanOptionCostDelta>;
export function newReadyPlanCostData(
  options: ReadyPlanCostDataOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<ReadyPlanCostDataType> {
  const { __typename = "ComputeReadyPlanCostResult" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["ReadyPlanCostData"] = newReadyPlanCostData;

export type HasScheduleImpactOptions =
  | DeleteSchedulePhasesResultOptions
  | RequireTypename<DeleteScheduleSubPhasesResultOptions>
  | RequireTypename<MoveScheduleSubPhasesResultOptions>
  | RequireTypename<SaveScheduleTasksResultOptions>;

export type HasScheduleImpactType =
  | DeleteSchedulePhasesResult
  | DeleteScheduleSubPhasesResult
  | MoveScheduleSubPhasesResult
  | SaveScheduleTasksResult;

export type HasScheduleImpactTypeName =
  | "DeleteSchedulePhasesResult"
  | "DeleteScheduleSubPhasesResult"
  | "MoveScheduleSubPhasesResult"
  | "SaveScheduleTasksResult";

export function newHasScheduleImpact(): FactoryResult<DeleteSchedulePhasesResult>;
export function newHasScheduleImpact(
  options: DeleteSchedulePhasesResultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteSchedulePhasesResult>;
export function newHasScheduleImpact(
  options: RequireTypename<DeleteScheduleSubPhasesResultOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<DeleteScheduleSubPhasesResult>;
export function newHasScheduleImpact(
  options: RequireTypename<MoveScheduleSubPhasesResultOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<MoveScheduleSubPhasesResult>;
export function newHasScheduleImpact(
  options: RequireTypename<SaveScheduleTasksResultOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<SaveScheduleTasksResult>;
export function newHasScheduleImpact(
  options: HasScheduleImpactOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<HasScheduleImpactType> {
  const { __typename = "DeleteSchedulePhasesResult" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["HasScheduleImpact"] = newHasScheduleImpact;

export type TradeCategoryLeadTimeLikeOptions =
  | TradeCategoryLeadTimeDefaultOptions
  | RequireTypename<TradeCategoryLeadTimeOptions>;

export type TradeCategoryLeadTimeLikeType = TradeCategoryLeadTimeDefault | TradeCategoryLeadTime;

export type TradeCategoryLeadTimeLikeTypeName = "TradeCategoryLeadTimeDefault" | "TradeCategoryLeadTime";

export function newTradeCategoryLeadTimeLike(): FactoryResult<TradeCategoryLeadTimeDefault>;
export function newTradeCategoryLeadTimeLike(
  options: TradeCategoryLeadTimeDefaultOptions,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradeCategoryLeadTimeDefault>;
export function newTradeCategoryLeadTimeLike(
  options: RequireTypename<TradeCategoryLeadTimeOptions>,
  factoryOptions?: FactoryOptions,
): FactoryResult<TradeCategoryLeadTime>;
export function newTradeCategoryLeadTimeLike(
  options: TradeCategoryLeadTimeLikeOptions = {},
  factoryOptions: FactoryOptions = {},
  cache: FactoryCache = newFactoryCache(factoryOptions),
): FactoryResult<TradeCategoryLeadTimeLikeType> {
  const { __typename = "TradeCategoryLeadTimeDefault" } = options ?? {};
  const shouldUseCache = Object.keys(options).length === 0;
  const cachedValue = shouldUseCache ? cache[__typename] : undefined;
  if (cachedValue !== undefined) {
    return reuseWouldCreateCycle(cache, cachedValue) ? undefined as any : cachedValue;
  }
  return maybeNew(__typename, options ?? {}, cache);
}

factories["TradeCategoryLeadTimeLike"] = newTradeCategoryLeadTimeLike;

const enumDetailNameOfTaskStatus = {
  NOT_STARTED: "Not started",
  IN_PROGRESS: "In progress",
  COMPLETE: "Complete",
  ON_HOLD: "On hold",
  DELAYED: "Delayed",
};

function enumOrDetailOfTaskStatus(enumOrDetail: TaskStatusDetailOptions | TaskStatus | undefined): TaskStatusDetail {
  if (enumOrDetail === undefined) {
    return newTaskStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskStatusDetail;
  } else {
    return newTaskStatusDetail({
      code: enumOrDetail as TaskStatus,
      name: enumDetailNameOfTaskStatus[enumOrDetail as TaskStatus],
    });
  }
}

function enumOrDetailOrNullOfTaskStatus(
  enumOrDetail: TaskStatusDetailOptions | TaskStatus | undefined | null,
): TaskStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerTaskStatus = {
  NEEDS_CONFIRMATION: "Needs confirmation",
  CONFIRMED: "Confirmed",
  UNAVAILABLE: "Unavailable",
  COMPLETED_JOB: "Completed job",
  NEEDS_RECONFIRMATION: "Needs reconfirmation",
  NOT_SENT: "Not sent",
};

function enumOrDetailOfTradePartnerTaskStatus(
  enumOrDetail: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus | undefined,
): TradePartnerTaskStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerTaskStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerTaskStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerTaskStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerTaskStatusDetail;
  } else {
    return newTradePartnerTaskStatusDetail({
      code: enumOrDetail as TradePartnerTaskStatus,
      name: enumDetailNameOfTradePartnerTaskStatus[enumOrDetail as TradePartnerTaskStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerTaskStatus(
  enumOrDetail: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus | undefined | null,
): TradePartnerTaskStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerTaskStatus(enumOrDetail);
}

const enumDetailNameOfTaskType = { SCHEDULE_TASK: "Schedule task", PLAN_TASK: "Plan task" };

function enumOrDetailOfTaskType(enumOrDetail: TaskTypeDetailOptions | TaskType | undefined): TaskTypeDetail {
  if (enumOrDetail === undefined) {
    return newTaskTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskTypeDetail;
  } else {
    return newTaskTypeDetail({
      code: enumOrDetail as TaskType,
      name: enumDetailNameOfTaskType[enumOrDetail as TaskType],
    });
  }
}

function enumOrDetailOrNullOfTaskType(
  enumOrDetail: TaskTypeDetailOptions | TaskType | undefined | null,
): TaskTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskType(enumOrDetail);
}

const enumDetailNameOfAiEntityProposalType = { CREATE: "Create", UPDATE: "Update", DELETE: "Delete" };

function enumOrDetailOfAiEntityProposalType(
  enumOrDetail: AiEntityProposalTypeDetailOptions | AiEntityProposalType | undefined,
): AiEntityProposalTypeDetail {
  if (enumOrDetail === undefined) {
    return newAiEntityProposalTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiEntityProposalTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiEntityProposalType[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiEntityProposalTypeDetail;
  } else {
    return newAiEntityProposalTypeDetail({
      code: enumOrDetail as AiEntityProposalType,
      name: enumDetailNameOfAiEntityProposalType[enumOrDetail as AiEntityProposalType],
    });
  }
}

function enumOrDetailOrNullOfAiEntityProposalType(
  enumOrDetail: AiEntityProposalTypeDetailOptions | AiEntityProposalType | undefined | null,
): AiEntityProposalTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiEntityProposalType(enumOrDetail);
}

const enumDetailNameOfAiEntityProposalEntityType = {
  MATERIAL_VARIANT: "Material variant",
  READY_PLAN_LOCATION: "Ready plan location",
  READY_PLAN_OPTION: "Ready plan option",
  READY_PLAN_PROGRAM_DATA: "Ready plan program data",
  MATERIAL_LISTING: "Material listing",
  ELEVATION: "Elevation",
};

function enumOrDetailOfAiEntityProposalEntityType(
  enumOrDetail: AiEntityProposalEntityTypeDetailOptions | AiEntityProposalEntityType | undefined,
): AiEntityProposalEntityTypeDetail {
  if (enumOrDetail === undefined) {
    return newAiEntityProposalEntityTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiEntityProposalEntityTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiEntityProposalEntityType[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiEntityProposalEntityTypeDetail;
  } else {
    return newAiEntityProposalEntityTypeDetail({
      code: enumOrDetail as AiEntityProposalEntityType,
      name: enumDetailNameOfAiEntityProposalEntityType[enumOrDetail as AiEntityProposalEntityType],
    });
  }
}

function enumOrDetailOrNullOfAiEntityProposalEntityType(
  enumOrDetail: AiEntityProposalEntityTypeDetailOptions | AiEntityProposalEntityType | undefined | null,
): AiEntityProposalEntityTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiEntityProposalEntityType(enumOrDetail);
}

const enumDetailNameOfAiFieldProposalStatus = { PENDING: "Pending", ACCEPTED: "Accepted", REJECTED: "Rejected" };

function enumOrDetailOfAiFieldProposalStatus(
  enumOrDetail: AiFieldProposalStatusDetailOptions | AiFieldProposalStatus | undefined,
): AiFieldProposalStatusDetail {
  if (enumOrDetail === undefined) {
    return newAiFieldProposalStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiFieldProposalStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiFieldProposalStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiFieldProposalStatusDetail;
  } else {
    return newAiFieldProposalStatusDetail({
      code: enumOrDetail as AiFieldProposalStatus,
      name: enumDetailNameOfAiFieldProposalStatus[enumOrDetail as AiFieldProposalStatus],
    });
  }
}

function enumOrDetailOrNullOfAiFieldProposalStatus(
  enumOrDetail: AiFieldProposalStatusDetailOptions | AiFieldProposalStatus | undefined | null,
): AiFieldProposalStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiFieldProposalStatus(enumOrDetail);
}

const enumDetailNameOfAiDataConfidence = { LOW: "Low", MEDIUM: "Medium", HIGH: "High" };

function enumOrDetailOfAiDataConfidence(
  enumOrDetail: AiDataConfidenceDetailOptions | AiDataConfidence | undefined,
): AiDataConfidenceDetail {
  if (enumOrDetail === undefined) {
    return newAiDataConfidenceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiDataConfidenceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiDataConfidence[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiDataConfidenceDetail;
  } else {
    return newAiDataConfidenceDetail({
      code: enumOrDetail as AiDataConfidence,
      name: enumDetailNameOfAiDataConfidence[enumOrDetail as AiDataConfidence],
    });
  }
}

function enumOrDetailOrNullOfAiDataConfidence(
  enumOrDetail: AiDataConfidenceDetailOptions | AiDataConfidence | undefined | null,
): AiDataConfidenceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiDataConfidence(enumOrDetail);
}

const enumDetailNameOfAiProposalType = {
  CONSTRUCTION_DOCUMENT_IMPORT: "Construction document import",
  MATERIAL_IMPORT: "Material import",
};

function enumOrDetailOfAiProposalType(
  enumOrDetail: AiProposalTypeDetailOptions | AiProposalType | undefined,
): AiProposalTypeDetail {
  if (enumOrDetail === undefined) {
    return newAiProposalTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiProposalTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiProposalType[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiProposalTypeDetail;
  } else {
    return newAiProposalTypeDetail({
      code: enumOrDetail as AiProposalType,
      name: enumDetailNameOfAiProposalType[enumOrDetail as AiProposalType],
    });
  }
}

function enumOrDetailOrNullOfAiProposalType(
  enumOrDetail: AiProposalTypeDetailOptions | AiProposalType | undefined | null,
): AiProposalTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiProposalType(enumOrDetail);
}

const enumDetailNameOfAiProposalStatus = { PENDING: "Pending", REVIEWING: "Reviewing", FAILED: "Failed" };

function enumOrDetailOfAiProposalStatus(
  enumOrDetail: AiProposalStatusDetailOptions | AiProposalStatus | undefined,
): AiProposalStatusDetail {
  if (enumOrDetail === undefined) {
    return newAiProposalStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiProposalStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiProposalStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiProposalStatusDetail;
  } else {
    return newAiProposalStatusDetail({
      code: enumOrDetail as AiProposalStatus,
      name: enumDetailNameOfAiProposalStatus[enumOrDetail as AiProposalStatus],
    });
  }
}

function enumOrDetailOrNullOfAiProposalStatus(
  enumOrDetail: AiProposalStatusDetailOptions | AiProposalStatus | undefined | null,
): AiProposalStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiProposalStatus(enumOrDetail);
}

const enumDetailNameOfApprovalStatus = {
  CHANGES_NEEDED: "Changes needed",
  REQUESTED: "Requested",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

function enumOrDetailOfApprovalStatus(
  enumOrDetail: ApprovalStatusDetailOptions | ApprovalStatus | undefined,
): ApprovalStatusDetail {
  if (enumOrDetail === undefined) {
    return newApprovalStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ApprovalStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfApprovalStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ApprovalStatusDetail;
  } else {
    return newApprovalStatusDetail({
      code: enumOrDetail as ApprovalStatus,
      name: enumDetailNameOfApprovalStatus[enumOrDetail as ApprovalStatus],
    });
  }
}

function enumOrDetailOrNullOfApprovalStatus(
  enumOrDetail: ApprovalStatusDetailOptions | ApprovalStatus | undefined | null,
): ApprovalStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfApprovalStatus(enumOrDetail);
}

const enumDetailNameOfApproverStatus = {
  PENDING: "Pending",
  ACTION_REQUIRED: "Action required",
  CHANGES_REQUESTED: "Changes requested",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

function enumOrDetailOfApproverStatus(
  enumOrDetail: ApproverStatusDetailOptions | ApproverStatus | undefined,
): ApproverStatusDetail {
  if (enumOrDetail === undefined) {
    return newApproverStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ApproverStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfApproverStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ApproverStatusDetail;
  } else {
    return newApproverStatusDetail({
      code: enumOrDetail as ApproverStatus,
      name: enumDetailNameOfApproverStatus[enumOrDetail as ApproverStatus],
    });
  }
}

function enumOrDetailOrNullOfApproverStatus(
  enumOrDetail: ApproverStatusDetailOptions | ApproverStatus | undefined | null,
): ApproverStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfApproverStatus(enumOrDetail);
}

const enumDetailNameOfBidContractType = {
  UNIT_BASED: "Unit based",
  ITEM_TEMPLATE_BASED: "Item template based",
  GROUPED_BY_PLAN_AND_OPTION: "Grouped by plan and option",
  USER_CREATED_GROUP_BASED: "User created group based",
  LEGACY_UNIT_AND_TEMPLATE_BASED: "Legacy unit and template based",
};

function enumOrDetailOfBidContractType(
  enumOrDetail: BidContractTypeDetailOptions | BidContractType | undefined,
): BidContractTypeDetail {
  if (enumOrDetail === undefined) {
    return newBidContractTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidContractTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidContractType[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidContractTypeDetail;
  } else {
    return newBidContractTypeDetail({
      code: enumOrDetail as BidContractType,
      name: enumDetailNameOfBidContractType[enumOrDetail as BidContractType],
    });
  }
}

function enumOrDetailOrNullOfBidContractType(
  enumOrDetail: BidContractTypeDetailOptions | BidContractType | undefined | null,
): BidContractTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidContractType(enumOrDetail);
}

const enumDetailNameOfInternalEstimateType = { PROVISIONAL: "Provisional", PROJECT: "Project" };

function enumOrDetailOfInternalEstimateType(
  enumOrDetail: InternalEstimateTypeDetailOptions | InternalEstimateType | undefined,
): InternalEstimateTypeDetail {
  if (enumOrDetail === undefined) {
    return newInternalEstimateTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InternalEstimateTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInternalEstimateType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InternalEstimateTypeDetail;
  } else {
    return newInternalEstimateTypeDetail({
      code: enumOrDetail as InternalEstimateType,
      name: enumDetailNameOfInternalEstimateType[enumOrDetail as InternalEstimateType],
    });
  }
}

function enumOrDetailOrNullOfInternalEstimateType(
  enumOrDetail: InternalEstimateTypeDetailOptions | InternalEstimateType | undefined | null,
): InternalEstimateTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInternalEstimateType(enumOrDetail);
}

const enumDetailNameOfBidContractRevisionStatus = {
  DRAFT: "Draft",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  SIGNED: "Signed",
  PARTIALLY_SIGNED: "Partially signed",
  ARCHIVED: "Archived",
};

function enumOrDetailOfBidContractRevisionStatus(
  enumOrDetail: BidContractRevisionStatusDetailOptions | BidContractRevisionStatus | undefined,
): BidContractRevisionStatusDetail {
  if (enumOrDetail === undefined) {
    return newBidContractRevisionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidContractRevisionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidContractRevisionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidContractRevisionStatusDetail;
  } else {
    return newBidContractRevisionStatusDetail({
      code: enumOrDetail as BidContractRevisionStatus,
      name: enumDetailNameOfBidContractRevisionStatus[enumOrDetail as BidContractRevisionStatus],
    });
  }
}

function enumOrDetailOrNullOfBidContractRevisionStatus(
  enumOrDetail: BidContractRevisionStatusDetailOptions | BidContractRevisionStatus | undefined | null,
): BidContractRevisionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidContractRevisionStatus(enumOrDetail);
}

const enumDetailNameOfCostType = {
  LABOR: "Labor",
  MATERIALS: "Materials",
  SUBCONTRACTOR: "Subcontractor",
  EQUIPMENT: "Equipment",
  OTHER: "Other",
};

function enumOrDetailOfCostType(enumOrDetail: CostTypeDetailOptions | CostType | undefined): CostTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostTypeDetail;
  } else {
    return newCostTypeDetail({
      code: enumOrDetail as CostType,
      name: enumDetailNameOfCostType[enumOrDetail as CostType],
    });
  }
}

function enumOrDetailOrNullOfCostType(
  enumOrDetail: CostTypeDetailOptions | CostType | undefined | null,
): CostTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostType(enumOrDetail);
}

const enumDetailNameOfBidPackageStatus = { DRAFT: "Draft", OPEN: "Open", RECEIVED: "Received", AWARDED: "Awarded" };

function enumOrDetailOfBidPackageStatus(
  enumOrDetail: BidPackageStatusDetailOptions | BidPackageStatus | undefined,
): BidPackageStatusDetail {
  if (enumOrDetail === undefined) {
    return newBidPackageStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidPackageStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidPackageStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidPackageStatusDetail;
  } else {
    return newBidPackageStatusDetail({
      code: enumOrDetail as BidPackageStatus,
      name: enumDetailNameOfBidPackageStatus[enumOrDetail as BidPackageStatus],
    });
  }
}

function enumOrDetailOrNullOfBidPackageStatus(
  enumOrDetail: BidPackageStatusDetailOptions | BidPackageStatus | undefined | null,
): BidPackageStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidPackageStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerOnboardingStatus = {
  IN_PROGRESS: "In progress",
  COMPLETE: "Complete",
  DO_NOT_USE: "Do not use",
  INACTIVE: "Inactive",
};

function enumOrDetailOfTradePartnerOnboardingStatus(
  enumOrDetail: TradePartnerOnboardingStatusDetailOptions | TradePartnerOnboardingStatus | undefined,
): TradePartnerOnboardingStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerOnboardingStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerOnboardingStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerOnboardingStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerOnboardingStatusDetail;
  } else {
    return newTradePartnerOnboardingStatusDetail({
      code: enumOrDetail as TradePartnerOnboardingStatus,
      name: enumDetailNameOfTradePartnerOnboardingStatus[enumOrDetail as TradePartnerOnboardingStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerOnboardingStatus(
  enumOrDetail: TradePartnerOnboardingStatusDetailOptions | TradePartnerOnboardingStatus | undefined | null,
): TradePartnerOnboardingStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerOnboardingStatus(enumOrDetail);
}

const enumDetailNameOfBillType = {
  STANDARD: "Standard",
  DEPOSIT: "Deposit",
  OVERHEAD: "Overhead",
  REPAIR_AND_MAINTENANCE: "Repair and maintenance",
  WARRANTY: "Warranty",
};

function enumOrDetailOfBillType(enumOrDetail: BillTypeDetailOptions | BillType | undefined): BillTypeDetail {
  if (enumOrDetail === undefined) {
    return newBillTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillType[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillTypeDetail;
  } else {
    return newBillTypeDetail({
      code: enumOrDetail as BillType,
      name: enumDetailNameOfBillType[enumOrDetail as BillType],
    });
  }
}

function enumOrDetailOrNullOfBillType(
  enumOrDetail: BillTypeDetailOptions | BillType | undefined | null,
): BillTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillType(enumOrDetail);
}

const enumDetailNameOfBillStatus = {
  DRAFT: "Draft",
  CHANGES_REQUESTED: "Changes requested",
  RELEASE_SCHEDULED: "Release scheduled",
  PENDING_APPROVAL: "Pending approval",
  READY_TO_PAY: "Ready to pay",
  REJECTED: "Rejected",
  PAID: "Paid",
  REVERSED: "Reversed",
  CANCELLED: "Cancelled",
  PENDING_CONDITIONAL_LIEN_WAIVER: "Pending conditional lien waiver",
  PENDING_UNCONDITIONAL_LIEN_WAIVER: "Pending unconditional lien waiver",
  UNRELEASED: "Unreleased",
  PARTIALLY_PAID: "Partially paid",
};

function enumOrDetailOfBillStatus(enumOrDetail: BillStatusDetailOptions | BillStatus | undefined): BillStatusDetail {
  if (enumOrDetail === undefined) {
    return newBillStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillStatusDetail;
  } else {
    return newBillStatusDetail({
      code: enumOrDetail as BillStatus,
      name: enumDetailNameOfBillStatus[enumOrDetail as BillStatus],
    });
  }
}

function enumOrDetailOrNullOfBillStatus(
  enumOrDetail: BillStatusDetailOptions | BillStatus | undefined | null,
): BillStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillStatus(enumOrDetail);
}

const enumDetailNameOfBillReviewReason = {
  MISSING_PO: "Missing po",
  UNSIGNED_PO: "Unsigned po",
  NEED_VPO: "Need vpo",
  INSUFFICIENT_BUDGET: "Insufficient budget",
  AUTO_PARSED: "Auto parsed",
  NEED_CLARIFICATION: "Need clarification",
};

function enumOrDetailOfBillReviewReason(
  enumOrDetail: BillReviewReasonDetailOptions | BillReviewReason | undefined,
): BillReviewReasonDetail {
  if (enumOrDetail === undefined) {
    return newBillReviewReasonDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillReviewReasonDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillReviewReason[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillReviewReasonDetail;
  } else {
    return newBillReviewReasonDetail({
      code: enumOrDetail as BillReviewReason,
      name: enumDetailNameOfBillReviewReason[enumOrDetail as BillReviewReason],
    });
  }
}

function enumOrDetailOrNullOfBillReviewReason(
  enumOrDetail: BillReviewReasonDetailOptions | BillReviewReason | undefined | null,
): BillReviewReasonDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillReviewReason(enumOrDetail);
}

const enumDetailNameOfBillSource = { MANUAL: "Manual", CLICK_TO_PAY: "Click to pay", AUTO_PARSED: "Auto parsed" };

function enumOrDetailOfBillSource(enumOrDetail: BillSourceDetailOptions | BillSource | undefined): BillSourceDetail {
  if (enumOrDetail === undefined) {
    return newBillSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillSourceDetail;
  } else {
    return newBillSourceDetail({
      code: enumOrDetail as BillSource,
      name: enumDetailNameOfBillSource[enumOrDetail as BillSource],
    });
  }
}

function enumOrDetailOrNullOfBillSource(
  enumOrDetail: BillSourceDetailOptions | BillSource | undefined | null,
): BillSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillSource(enumOrDetail);
}

const enumDetailNameOfBillGmailMessageResult = {
  NOT_FOUND: "Not found",
  NO_ATTACHMENTS: "No attachments",
  NO_PDFS: "No pdfs",
  PARSED: "Parsed",
  PARSING: "Parsing",
};

function enumOrDetailOfBillGmailMessageResult(
  enumOrDetail: BillGmailMessageResultDetailOptions | BillGmailMessageResult | undefined,
): BillGmailMessageResultDetail {
  if (enumOrDetail === undefined) {
    return newBillGmailMessageResultDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillGmailMessageResultDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillGmailMessageResult[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillGmailMessageResultDetail;
  } else {
    return newBillGmailMessageResultDetail({
      code: enumOrDetail as BillGmailMessageResult,
      name: enumDetailNameOfBillGmailMessageResult[enumOrDetail as BillGmailMessageResult],
    });
  }
}

function enumOrDetailOrNullOfBillGmailMessageResult(
  enumOrDetail: BillGmailMessageResultDetailOptions | BillGmailMessageResult | undefined | null,
): BillGmailMessageResultDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillGmailMessageResult(enumOrDetail);
}

const enumDetailNameOfProjectRole = {
  HEAD_OF_CONSTRUCTION: "Head of construction",
  ACCOUNT_EXECUTIVE: "Account executive",
  CON_OPS_PROJECT_MANAGER: "Con ops project manager",
  DESIGNER: "Designer",
  LEGAL: "Legal",
  AREA_MANAGER: "Area manager",
  ACCOUNTING: "Accounting",
  PURCHASING_ONE: "Purchasing one",
  CONSTRUCTION_COORDINATOR: "Construction coordinator",
  CX: "Cx",
  DESIGN_LEAD: "Design lead",
  HOMEBOUND_AUTHORIZED_SIGNATORY: "Homebound authorized signatory",
  A_AND_D_PROGRAM_MANAGER: "A and d program manager",
  WARRANTY_MANAGER: "Warranty manager",
  SUPERINTENDENT: "Superintendent",
  PRE_CON_PROJECT_MANAGER: "Pre con project manager",
  PRE_CON_LEAD: "Pre con lead",
  PURCHASING_TWO: "Purchasing two",
  HEAD_OF_ACCOUNTS_PAYABLE: "Head of accounts payable",
  AP_ACCOUNTANT: "Ap accountant",
  ARCHITECT_ASSOCIATE: "Architect associate",
  MARKET_LEAD: "Market lead",
  ARCHITECTURE_LEAD: "Architecture lead",
  OPTIONS_MANAGER: "Options manager",
  A_AND_D_OPERATIONS: "A and d operations",
  GRAPHIC_DESIGNER: "Graphic designer",
  PURCHASING_MANAGER: "Purchasing manager",
  SALES_LEAD: "Sales lead",
  RISK_MANAGER: "Risk manager",
  HEAD_OF_PURCHASING: "Head of purchasing",
  TRANSACTION_COORDINATOR: "Transaction coordinator",
  CON_OPS_PROJECT_MANAGER_TWO: "Con ops project manager two",
  SUPERINTENDENT_TWO: "Superintendent two",
  GENERAL_MANAGER: "General manager",
  UNDERWRITING_LEAD: "Underwriting lead",
  A_AND_D_STRATEGY: "A and d strategy",
  NATIONAL_NETWORK_MANAGER: "National network manager",
  PRODUCT_OPS: "Product ops",
  LW_INVOICE_SIGNATORY: "Lw invoice signatory",
  LAND_ACQUISITION_LEAD: "Land acquisition lead",
};

function enumOrDetailOfProjectRole(
  enumOrDetail: ProjectRoleDetailOptions | ProjectRole | undefined,
): ProjectRoleDetail {
  if (enumOrDetail === undefined) {
    return newProjectRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectRoleDetail;
  } else {
    return newProjectRoleDetail({
      code: enumOrDetail as ProjectRole,
      name: enumDetailNameOfProjectRole[enumOrDetail as ProjectRole],
    });
  }
}

function enumOrDetailOrNullOfProjectRole(
  enumOrDetail: ProjectRoleDetailOptions | ProjectRole | undefined | null,
): ProjectRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectRole(enumOrDetail);
}

const enumDetailNameOfBusinessFunctionType = {
  ARCHITECTURE: "Architecture",
  CONSTRUCTION: "Construction",
  DESIGN: "Design",
  MARKETING: "Marketing",
  PURCHASING: "Purchasing",
  ACCOUNTING: "Accounting",
  SALES: "Sales",
  WARRANTY: "Warranty",
  CUSTOMER_EXPERIENCE: "Customer experience",
  UNDERWRITING: "Underwriting",
  PRECON: "Precon",
  MARKET_LAUNCH: "Market launch",
  LAND_ACQUISITION: "Land acquisition",
  LEGAL: "Legal",
};

function enumOrDetailOfBusinessFunctionType(
  enumOrDetail: BusinessFunctionTypeDetailOptions | BusinessFunctionType | undefined,
): BusinessFunctionTypeDetail {
  if (enumOrDetail === undefined) {
    return newBusinessFunctionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BusinessFunctionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBusinessFunctionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as BusinessFunctionTypeDetail;
  } else {
    return newBusinessFunctionTypeDetail({
      code: enumOrDetail as BusinessFunctionType,
      name: enumDetailNameOfBusinessFunctionType[enumOrDetail as BusinessFunctionType],
    });
  }
}

function enumOrDetailOrNullOfBusinessFunctionType(
  enumOrDetail: BusinessFunctionTypeDetailOptions | BusinessFunctionType | undefined | null,
): BusinessFunctionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBusinessFunctionType(enumOrDetail);
}

const enumDetailNameOfChangeType = {
  NA: "Na",
  PROGRAM_CHANGE: "Program change",
  ARCHITECHTURAL_DESIGN: "Architechtural design",
  STRUCTURAL_DESIGN: "Structural design",
  MEP_DESIGN: "Mep design",
  ADD_REMOVE_MODIFY_PRODUCTS: "Add remove modify products",
  MODIFY_OPTIONS_PROGRAM: "Modify options program",
  NEW_DESIGN_PACKAGE: "New design package",
  UPDATE_EXISTING_DESIGN_PACKAGE: "Update existing design package",
  NEW_EXTERIOR_STYLE: "New exterior style",
  IMPLEMENTATION_ERROR: "Implementation error",
  PRODUCT_REFRESH: "Product refresh",
};

function enumOrDetailOfChangeType(enumOrDetail: ChangeTypeDetailOptions | ChangeType | undefined): ChangeTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeTypeDetail;
  } else {
    return newChangeTypeDetail({
      code: enumOrDetail as ChangeType,
      name: enumDetailNameOfChangeType[enumOrDetail as ChangeType],
    });
  }
}

function enumOrDetailOrNullOfChangeType(
  enumOrDetail: ChangeTypeDetailOptions | ChangeType | undefined | null,
): ChangeTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeType(enumOrDetail);
}

const enumDetailNameOfChangeEventStatus = {
  DRAFT: "Draft",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  PROPOSED: "Proposed",
  REQUESTED: "Requested",
  VOID: "Void",
  PENDING_SIGNATURE: "Pending signature",
};

function enumOrDetailOfChangeEventStatus(
  enumOrDetail: ChangeEventStatusDetailOptions | ChangeEventStatus | undefined,
): ChangeEventStatusDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventStatusDetail;
  } else {
    return newChangeEventStatusDetail({
      code: enumOrDetail as ChangeEventStatus,
      name: enumDetailNameOfChangeEventStatus[enumOrDetail as ChangeEventStatus],
    });
  }
}

function enumOrDetailOrNullOfChangeEventStatus(
  enumOrDetail: ChangeEventStatusDetailOptions | ChangeEventStatus | undefined | null,
): ChangeEventStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventStatus(enumOrDetail);
}

const enumDetailNameOfChangeEventBudgetPhase = { PREBID: "Prebid", AWARDED: "Awarded", REVISED: "Revised" };

function enumOrDetailOfChangeEventBudgetPhase(
  enumOrDetail: ChangeEventBudgetPhaseDetailOptions | ChangeEventBudgetPhase | undefined,
): ChangeEventBudgetPhaseDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventBudgetPhaseDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventBudgetPhaseDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventBudgetPhase[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventBudgetPhaseDetail;
  } else {
    return newChangeEventBudgetPhaseDetail({
      code: enumOrDetail as ChangeEventBudgetPhase,
      name: enumDetailNameOfChangeEventBudgetPhase[enumOrDetail as ChangeEventBudgetPhase],
    });
  }
}

function enumOrDetailOrNullOfChangeEventBudgetPhase(
  enumOrDetail: ChangeEventBudgetPhaseDetailOptions | ChangeEventBudgetPhase | undefined | null,
): ChangeEventBudgetPhaseDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventBudgetPhase(enumOrDetail);
}

const enumDetailNameOfChangeEventType = {
  INTERNAL: "Internal",
  EXTERNAL: "External",
  BUDGET_REALLOCATION: "Budget reallocation",
};

function enumOrDetailOfChangeEventType(
  enumOrDetail: ChangeEventTypeDetailOptions | ChangeEventType | undefined,
): ChangeEventTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventTypeDetail;
  } else {
    return newChangeEventTypeDetail({
      code: enumOrDetail as ChangeEventType,
      name: enumDetailNameOfChangeEventType[enumOrDetail as ChangeEventType],
    });
  }
}

function enumOrDetailOrNullOfChangeEventType(
  enumOrDetail: ChangeEventTypeDetailOptions | ChangeEventType | undefined | null,
): ChangeEventTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventType(enumOrDetail);
}

const enumDetailNameOfProjectReadyPlanConfigOrientation = { LEFT: "Left", RIGHT: "Right" };

function enumOrDetailOfProjectReadyPlanConfigOrientation(
  enumOrDetail: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation | undefined,
): ProjectReadyPlanConfigOrientationDetail {
  if (enumOrDetail === undefined) {
    return newProjectReadyPlanConfigOrientationDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectReadyPlanConfigOrientationDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectReadyPlanConfigOrientation[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectReadyPlanConfigOrientationDetail;
  } else {
    return newProjectReadyPlanConfigOrientationDetail({
      code: enumOrDetail as ProjectReadyPlanConfigOrientation,
      name: enumDetailNameOfProjectReadyPlanConfigOrientation[enumOrDetail as ProjectReadyPlanConfigOrientation],
    });
  }
}

function enumOrDetailOrNullOfProjectReadyPlanConfigOrientation(
  enumOrDetail: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation | undefined | null,
): ProjectReadyPlanConfigOrientationDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectReadyPlanConfigOrientation(enumOrDetail);
}

const enumDetailNameOfChangeEventWorkflow = {
  APPLY_INITIAL_CONFIGURATION: "Apply initial configuration",
  APPLY_PARTIAL_CONFIGURATION: "Apply partial configuration",
  ADD_ON_BOOK_OPTION: "Add on book option",
  CONFIGURATION_TRUE_UP: "Configuration true up",
  SWAP_PRODUCT: "Swap product",
  FULL_LINE_CUSTOM_OPTION: "Full line custom option",
};

function enumOrDetailOfChangeEventWorkflow(
  enumOrDetail: ChangeEventWorkflowDetailOptions | ChangeEventWorkflow | undefined,
): ChangeEventWorkflowDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventWorkflowDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventWorkflowDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventWorkflow[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventWorkflowDetail;
  } else {
    return newChangeEventWorkflowDetail({
      code: enumOrDetail as ChangeEventWorkflow,
      name: enumDetailNameOfChangeEventWorkflow[enumOrDetail as ChangeEventWorkflow],
    });
  }
}

function enumOrDetailOrNullOfChangeEventWorkflow(
  enumOrDetail: ChangeEventWorkflowDetailOptions | ChangeEventWorkflow | undefined | null,
): ChangeEventWorkflowDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventWorkflow(enumOrDetail);
}

const enumDetailNameOfCostConfidence = { LOW: "Low", HIGH: "High", HARD_BID: "Hard bid" };

function enumOrDetailOfCostConfidence(
  enumOrDetail: CostConfidenceDetailOptions | CostConfidence | undefined,
): CostConfidenceDetail {
  if (enumOrDetail === undefined) {
    return newCostConfidenceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostConfidenceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostConfidence[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostConfidenceDetail;
  } else {
    return newCostConfidenceDetail({
      code: enumOrDetail as CostConfidence,
      name: enumDetailNameOfCostConfidence[enumOrDetail as CostConfidence],
    });
  }
}

function enumOrDetailOrNullOfCostConfidence(
  enumOrDetail: CostConfidenceDetailOptions | CostConfidence | undefined | null,
): CostConfidenceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostConfidence(enumOrDetail);
}

const enumDetailNameOfChangeEventLineItemType = { ADD: "Add", MODIFY: "Modify", CUTOFF: "Cutoff", REMOVE: "Remove" };

function enumOrDetailOfChangeEventLineItemType(
  enumOrDetail: ChangeEventLineItemTypeDetailOptions | ChangeEventLineItemType | undefined,
): ChangeEventLineItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventLineItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventLineItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventLineItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventLineItemTypeDetail;
  } else {
    return newChangeEventLineItemTypeDetail({
      code: enumOrDetail as ChangeEventLineItemType,
      name: enumDetailNameOfChangeEventLineItemType[enumOrDetail as ChangeEventLineItemType],
    });
  }
}

function enumOrDetailOrNullOfChangeEventLineItemType(
  enumOrDetail: ChangeEventLineItemTypeDetailOptions | ChangeEventLineItemType | undefined | null,
): ChangeEventLineItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventLineItemType(enumOrDetail);
}

const enumDetailNameOfChangeRequestPriority = {
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  URGENT: "Urgent",
  EXPEDITED: "Expedited",
};

function enumOrDetailOfChangeRequestPriority(
  enumOrDetail: ChangeRequestPriorityDetailOptions | ChangeRequestPriority | undefined,
): ChangeRequestPriorityDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestPriorityDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestPriorityDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestPriority[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestPriorityDetail;
  } else {
    return newChangeRequestPriorityDetail({
      code: enumOrDetail as ChangeRequestPriority,
      name: enumDetailNameOfChangeRequestPriority[enumOrDetail as ChangeRequestPriority],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestPriority(
  enumOrDetail: ChangeRequestPriorityDetailOptions | ChangeRequestPriority | undefined | null,
): ChangeRequestPriorityDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestPriority(enumOrDetail);
}

const enumDetailNameOfChangeRequestSource = {
  NA: "Na",
  VALUE_ENGINEERING: "Value engineering",
  UP_SPECING: "Up specing",
  CUSTOMER_REQUEST_PERSONALIZATION: "Customer request personalization",
  FIELD_DIRECTIVE: "Field directive",
  FRAME_WALK_ADJUSTMENTS: "Frame walk adjustments",
  PROVIDER_UPDATE: "Provider update",
  INTERNAL_SALES_FEEDBACK: "Internal sales feedback",
  BOYL_CUSTOMER_REQUEST_PERSONALIZATION: "Boyl customer request personalization",
  PRODUCT_REFRESH: "Product refresh",
  INTERNAL_DESIGN_FEEDBACK: "Internal design feedback",
  FEE_BUILD_PROJECT_CHANGE: "Fee build project change",
};

function enumOrDetailOfChangeRequestSource(
  enumOrDetail: ChangeRequestSourceDetailOptions | ChangeRequestSource | undefined,
): ChangeRequestSourceDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestSourceDetail;
  } else {
    return newChangeRequestSourceDetail({
      code: enumOrDetail as ChangeRequestSource,
      name: enumDetailNameOfChangeRequestSource[enumOrDetail as ChangeRequestSource],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestSource(
  enumOrDetail: ChangeRequestSourceDetailOptions | ChangeRequestSource | undefined | null,
): ChangeRequestSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestSource(enumOrDetail);
}

const enumDetailNameOfChangeRequestStatus = {
  NEEDS_REVIEW: "Needs review",
  READY_FOR_REVIEW: "Ready for review",
  READY_FOR_APPROVAL: "Ready for approval",
  APPROVED: "Approved",
  DENIED: "Denied",
  COMPLETED: "Completed",
  REVERSED: "Reversed",
  BLOCKED: "Blocked",
};

function enumOrDetailOfChangeRequestStatus(
  enumOrDetail: ChangeRequestStatusDetailOptions | ChangeRequestStatus | undefined,
): ChangeRequestStatusDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestStatusDetail;
  } else {
    return newChangeRequestStatusDetail({
      code: enumOrDetail as ChangeRequestStatus,
      name: enumDetailNameOfChangeRequestStatus[enumOrDetail as ChangeRequestStatus],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestStatus(
  enumOrDetail: ChangeRequestStatusDetailOptions | ChangeRequestStatus | undefined | null,
): ChangeRequestStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestStatus(enumOrDetail);
}

const enumDetailNameOfChangeRequestAssetPlatform = {
  BLUEPRINT: "Blueprint",
  SALESFORCE: "Salesforce",
  UNDERWRITING_APP: "Underwriting app",
  MLS: "Mls",
  ZILLOW: "Zillow",
  GDRIVE: "Gdrive",
  FIGMA: "Figma",
  PHYSICAL_COLATERAL: "Physical colateral",
  GOOGLE_SLIDES: "Google slides",
  GOOGLE_SHEET: "Google sheet",
  CHECKOUT: "Checkout",
  AIRTABLE: "Airtable",
  HOMEBOUND_COM: "Homebound com",
  LYONELANE_COM: "Lyonelane com",
  AIR: "Air",
};

function enumOrDetailOfChangeRequestAssetPlatform(
  enumOrDetail: ChangeRequestAssetPlatformDetailOptions | ChangeRequestAssetPlatform | undefined,
): ChangeRequestAssetPlatformDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestAssetPlatformDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestAssetPlatformDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestAssetPlatform[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestAssetPlatformDetail;
  } else {
    return newChangeRequestAssetPlatformDetail({
      code: enumOrDetail as ChangeRequestAssetPlatform,
      name: enumDetailNameOfChangeRequestAssetPlatform[enumOrDetail as ChangeRequestAssetPlatform],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestAssetPlatform(
  enumOrDetail: ChangeRequestAssetPlatformDetailOptions | ChangeRequestAssetPlatform | undefined | null,
): ChangeRequestAssetPlatformDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestAssetPlatform(enumOrDetail);
}

const enumDetailNameOfSystemChangeRequestAsset = {
  PANDA_DOC: "Panda doc",
  UPDATE_CLIENT_AND_CONTRACT: "Update client and contract",
  CHANGE_EVENT: "Change event",
};

function enumOrDetailOfSystemChangeRequestAsset(
  enumOrDetail: SystemChangeRequestAssetDetailOptions | SystemChangeRequestAsset | undefined,
): SystemChangeRequestAssetDetail {
  if (enumOrDetail === undefined) {
    return newSystemChangeRequestAssetDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SystemChangeRequestAssetDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSystemChangeRequestAsset[enumOrDetail.code!],
      ...enumOrDetail,
    } as SystemChangeRequestAssetDetail;
  } else {
    return newSystemChangeRequestAssetDetail({
      code: enumOrDetail as SystemChangeRequestAsset,
      name: enumDetailNameOfSystemChangeRequestAsset[enumOrDetail as SystemChangeRequestAsset],
    });
  }
}

function enumOrDetailOrNullOfSystemChangeRequestAsset(
  enumOrDetail: SystemChangeRequestAssetDetailOptions | SystemChangeRequestAsset | undefined | null,
): SystemChangeRequestAssetDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSystemChangeRequestAsset(enumOrDetail);
}

const enumDetailNameOfToDoStatus = {
  BACKLOG: "Backlog",
  UP_NEXT: "Up next",
  IN_PROGRESS: "In progress",
  COMPLETE: "Complete",
};

function enumOrDetailOfToDoStatus(enumOrDetail: ToDoStatusDetailOptions | ToDoStatus | undefined): ToDoStatusDetail {
  if (enumOrDetail === undefined) {
    return newToDoStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ToDoStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfToDoStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ToDoStatusDetail;
  } else {
    return newToDoStatusDetail({
      code: enumOrDetail as ToDoStatus,
      name: enumDetailNameOfToDoStatus[enumOrDetail as ToDoStatus],
    });
  }
}

function enumOrDetailOrNullOfToDoStatus(
  enumOrDetail: ToDoStatusDetailOptions | ToDoStatus | undefined | null,
): ToDoStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfToDoStatus(enumOrDetail);
}

const enumDetailNameOfToDoType = {
  SUBMITTALS: "Submittals",
  JOB_LIST: "Job list",
  SK_ASI: "Sk asi",
  RFI_QUESTIONS: "Rfi questions",
  MEETING_NOTES: "Meeting notes",
  PURCHASING: "Purchasing",
  DESIGN: "Design",
  REVIEWS: "Reviews",
  FINANCE: "Finance",
  GENERAL: "General",
  PRODUCT_OPS: "Product ops",
  PUNCH_LIST: "Punch list",
  WARRANTY: "Warranty",
  INSPECTION: "Inspection",
  DELIVERY: "Delivery",
  PRODUCT_FEEDBACK: "Product feedback",
  SCHEDULE_REVIEW: "Schedule review",
};

function enumOrDetailOfToDoType(enumOrDetail: ToDoTypeDetailOptions | ToDoType | undefined): ToDoTypeDetail {
  if (enumOrDetail === undefined) {
    return newToDoTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ToDoTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfToDoType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ToDoTypeDetail;
  } else {
    return newToDoTypeDetail({
      code: enumOrDetail as ToDoType,
      name: enumDetailNameOfToDoType[enumOrDetail as ToDoType],
    });
  }
}

function enumOrDetailOrNullOfToDoType(
  enumOrDetail: ToDoTypeDetailOptions | ToDoType | undefined | null,
): ToDoTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfToDoType(enumOrDetail);
}

const enumDetailNameOfChangeRequestToDoType = {
  INITIAL_REVIEW: "Initial review",
  IMPACT_ESTIMATE: "Impact estimate",
  IMPLEMENTATION: "Implementation",
  IMPLEMENTATION_REVIEW: "Implementation review",
};

function enumOrDetailOfChangeRequestToDoType(
  enumOrDetail: ChangeRequestToDoTypeDetailOptions | ChangeRequestToDoType | undefined,
): ChangeRequestToDoTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestToDoTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestToDoTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestToDoType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestToDoTypeDetail;
  } else {
    return newChangeRequestToDoTypeDetail({
      code: enumOrDetail as ChangeRequestToDoType,
      name: enumDetailNameOfChangeRequestToDoType[enumOrDetail as ChangeRequestToDoType],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestToDoType(
  enumOrDetail: ChangeRequestToDoTypeDetailOptions | ChangeRequestToDoType | undefined | null,
): ChangeRequestToDoTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestToDoType(enumOrDetail);
}

const enumDetailNameOfScopeMode = {
  NONE: "None",
  RELEASE_TO_TRADES: "Release to trades",
  FULL: "Full",
  BUDGET_SAFE: "Budget safe",
};

function enumOrDetailOfScopeMode(enumOrDetail: ScopeModeDetailOptions | ScopeMode | undefined): ScopeModeDetail {
  if (enumOrDetail === undefined) {
    return newScopeModeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScopeModeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScopeMode[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScopeModeDetail;
  } else {
    return newScopeModeDetail({
      code: enumOrDetail as ScopeMode,
      name: enumDetailNameOfScopeMode[enumOrDetail as ScopeMode],
    });
  }
}

function enumOrDetailOrNullOfScopeMode(
  enumOrDetail: ScopeModeDetailOptions | ScopeMode | undefined | null,
): ScopeModeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScopeMode(enumOrDetail);
}

const enumDetailNameOfTaskDeadlineType = { CUTOFF: "Cutoff", KEY_MILESTONE: "Key milestone" };

function enumOrDetailOfTaskDeadlineType(
  enumOrDetail: TaskDeadlineTypeDetailOptions | TaskDeadlineType | undefined,
): TaskDeadlineTypeDetail {
  if (enumOrDetail === undefined) {
    return newTaskDeadlineTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskDeadlineTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskDeadlineType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskDeadlineTypeDetail;
  } else {
    return newTaskDeadlineTypeDetail({
      code: enumOrDetail as TaskDeadlineType,
      name: enumDetailNameOfTaskDeadlineType[enumOrDetail as TaskDeadlineType],
    });
  }
}

function enumOrDetailOrNullOfTaskDeadlineType(
  enumOrDetail: TaskDeadlineTypeDetailOptions | TaskDeadlineType | undefined | null,
): TaskDeadlineTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskDeadlineType(enumOrDetail);
}

const enumDetailNameOfInvoiceStatus = {
  DRAFT: "Draft",
  REQUESTED: "Requested",
  CHANGES_REQUESTED: "Changes requested",
  APPROVED: "Approved",
  PAID: "Paid",
  REJECTED: "Rejected",
  VOID: "Void",
};

function enumOrDetailOfInvoiceStatus(
  enumOrDetail: InvoiceStatusDetailOptions | InvoiceStatus | undefined,
): InvoiceStatusDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceStatusDetail;
  } else {
    return newInvoiceStatusDetail({
      code: enumOrDetail as InvoiceStatus,
      name: enumDetailNameOfInvoiceStatus[enumOrDetail as InvoiceStatus],
    });
  }
}

function enumOrDetailOrNullOfInvoiceStatus(
  enumOrDetail: InvoiceStatusDetailOptions | InvoiceStatus | undefined | null,
): InvoiceStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceStatus(enumOrDetail);
}

const enumDetailNameOfInvoiceType = {
  PERCENTAGE_OF_COMPLETION: "Percentage of completion",
  DOWN_PAYMENT: "Down payment",
  STANDARD: "Standard",
  WARRANTY_TRUE_UP: "Warranty true up",
};

function enumOrDetailOfInvoiceType(
  enumOrDetail: InvoiceTypeDetailOptions | InvoiceType | undefined,
): InvoiceTypeDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceTypeDetail;
  } else {
    return newInvoiceTypeDetail({
      code: enumOrDetail as InvoiceType,
      name: enumDetailNameOfInvoiceType[enumOrDetail as InvoiceType],
    });
  }
}

function enumOrDetailOrNullOfInvoiceType(
  enumOrDetail: InvoiceTypeDetailOptions | InvoiceType | undefined | null,
): InvoiceTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceType(enumOrDetail);
}

const enumDetailNameOfInvoiceSource = { AUTO: "Auto", MANUAL: "Manual" };

function enumOrDetailOfInvoiceSource(
  enumOrDetail: InvoiceSourceDetailOptions | InvoiceSource | undefined,
): InvoiceSourceDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceSourceDetail;
  } else {
    return newInvoiceSourceDetail({
      code: enumOrDetail as InvoiceSource,
      name: enumDetailNameOfInvoiceSource[enumOrDetail as InvoiceSource],
    });
  }
}

function enumOrDetailOrNullOfInvoiceSource(
  enumOrDetail: InvoiceSourceDetailOptions | InvoiceSource | undefined | null,
): InvoiceSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceSource(enumOrDetail);
}

const enumDetailNameOfStage = {
  PRE_CON_PLANNING: "Pre con planning",
  PRE_CON_EXECUTION: "Pre con execution",
  CONSTRUCTION: "Construction",
  DEVELOPMENT: "Development",
};

function enumOrDetailOfStage(enumOrDetail: StageDetailOptions | Stage | undefined): StageDetail {
  if (enumOrDetail === undefined) {
    return newStageDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "StageDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfStage[enumOrDetail.code!],
      ...enumOrDetail,
    } as StageDetail;
  } else {
    return newStageDetail({ code: enumOrDetail as Stage, name: enumDetailNameOfStage[enumOrDetail as Stage] });
  }
}

function enumOrDetailOrNullOfStage(enumOrDetail: StageDetailOptions | Stage | undefined | null): StageDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfStage(enumOrDetail);
}

const enumDetailNameOfProjectStatus = {
  ACTIVE: "Active",
  COMPLETED: "Completed",
  DISQUALIFIED: "Disqualified",
  HOLD: "Hold",
  UNDER_WARRANTY: "Under warranty",
};

function enumOrDetailOfProjectStatus(
  enumOrDetail: ProjectStatusDetailOptions | ProjectStatus | undefined,
): ProjectStatusDetail {
  if (enumOrDetail === undefined) {
    return newProjectStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectStatusDetail;
  } else {
    return newProjectStatusDetail({
      code: enumOrDetail as ProjectStatus,
      name: enumDetailNameOfProjectStatus[enumOrDetail as ProjectStatus],
    });
  }
}

function enumOrDetailOrNullOfProjectStatus(
  enumOrDetail: ProjectStatusDetailOptions | ProjectStatus | undefined | null,
): ProjectStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectStatus(enumOrDetail);
}

const enumDetailNameOfLotType = { BOYL: "Boyl", BOOL: "Bool", HBL: "Hbl", BTR: "Btr", FEE: "Fee" };

function enumOrDetailOfLotType(enumOrDetail: LotTypeDetailOptions | LotType | undefined): LotTypeDetail {
  if (enumOrDetail === undefined) {
    return newLotTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotTypeDetail;
  } else {
    return newLotTypeDetail({ code: enumOrDetail as LotType, name: enumDetailNameOfLotType[enumOrDetail as LotType] });
  }
}

function enumOrDetailOrNullOfLotType(
  enumOrDetail: LotTypeDetailOptions | LotType | undefined | null,
): LotTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotType(enumOrDetail);
}

const enumDetailNameOfCommunityType = { INFILL: "Infill", SUBURBAN: "Suburban" };

function enumOrDetailOfCommunityType(
  enumOrDetail: CommunityTypeDetailOptions | CommunityType | undefined,
): CommunityTypeDetail {
  if (enumOrDetail === undefined) {
    return newCommunityTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommunityTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommunityType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommunityTypeDetail;
  } else {
    return newCommunityTypeDetail({
      code: enumOrDetail as CommunityType,
      name: enumDetailNameOfCommunityType[enumOrDetail as CommunityType],
    });
  }
}

function enumOrDetailOrNullOfCommunityType(
  enumOrDetail: CommunityTypeDetailOptions | CommunityType | undefined | null,
): CommunityTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommunityType(enumOrDetail);
}

const enumDetailNameOfReadyPlanType = { SFH: "Sfh", ADU: "Adu", MFU: "Mfu" };

function enumOrDetailOfReadyPlanType(
  enumOrDetail: ReadyPlanTypeDetailOptions | ReadyPlanType | undefined,
): ReadyPlanTypeDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanTypeDetail;
  } else {
    return newReadyPlanTypeDetail({
      code: enumOrDetail as ReadyPlanType,
      name: enumDetailNameOfReadyPlanType[enumOrDetail as ReadyPlanType],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanType(
  enumOrDetail: ReadyPlanTypeDetailOptions | ReadyPlanType | undefined | null,
): ReadyPlanTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanType(enumOrDetail);
}

const enumDetailNameOfSuburbanAssetCategory = {
  INVENTORY: "Inventory",
  MODEL_HOME: "Model home",
  BUILD_TO_ORDER: "Build to order",
};

function enumOrDetailOfSuburbanAssetCategory(
  enumOrDetail: SuburbanAssetCategoryDetailOptions | SuburbanAssetCategory | undefined,
): SuburbanAssetCategoryDetail {
  if (enumOrDetail === undefined) {
    return newSuburbanAssetCategoryDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SuburbanAssetCategoryDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSuburbanAssetCategory[enumOrDetail.code!],
      ...enumOrDetail,
    } as SuburbanAssetCategoryDetail;
  } else {
    return newSuburbanAssetCategoryDetail({
      code: enumOrDetail as SuburbanAssetCategory,
      name: enumDetailNameOfSuburbanAssetCategory[enumOrDetail as SuburbanAssetCategory],
    });
  }
}

function enumOrDetailOrNullOfSuburbanAssetCategory(
  enumOrDetail: SuburbanAssetCategoryDetailOptions | SuburbanAssetCategory | undefined | null,
): SuburbanAssetCategoryDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSuburbanAssetCategory(enumOrDetail);
}

const enumDetailNameOfLotSalesStatus = {
  NOT_AVAILABLE: "Not available",
  AVAILABLE: "Available",
  MODEL_HOME: "Model home",
  RESERVED: "Reserved",
  SOLD: "Sold",
};

function enumOrDetailOfLotSalesStatus(
  enumOrDetail: LotSalesStatusDetailOptions | LotSalesStatus | undefined,
): LotSalesStatusDetail {
  if (enumOrDetail === undefined) {
    return newLotSalesStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotSalesStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotSalesStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotSalesStatusDetail;
  } else {
    return newLotSalesStatusDetail({
      code: enumOrDetail as LotSalesStatus,
      name: enumDetailNameOfLotSalesStatus[enumOrDetail as LotSalesStatus],
    });
  }
}

function enumOrDetailOrNullOfLotSalesStatus(
  enumOrDetail: LotSalesStatusDetailOptions | LotSalesStatus | undefined | null,
): LotSalesStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotSalesStatus(enumOrDetail);
}

const enumDetailNameOfBuyoutStatus = {
  NOT_BOUGHT_OUT: "Not bought out",
  BOUGHT_OUT: "Bought out",
  PARTIALLY_BOUGHT_OUT: "Partially bought out",
};

function enumOrDetailOfBuyoutStatus(
  enumOrDetail: BuyoutStatusDetailOptions | BuyoutStatus | undefined,
): BuyoutStatusDetail {
  if (enumOrDetail === undefined) {
    return newBuyoutStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BuyoutStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBuyoutStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BuyoutStatusDetail;
  } else {
    return newBuyoutStatusDetail({
      code: enumOrDetail as BuyoutStatus,
      name: enumDetailNameOfBuyoutStatus[enumOrDetail as BuyoutStatus],
    });
  }
}

function enumOrDetailOrNullOfBuyoutStatus(
  enumOrDetail: BuyoutStatusDetailOptions | BuyoutStatus | undefined | null,
): BuyoutStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBuyoutStatus(enumOrDetail);
}

const enumDetailNameOfEstimateStatus = { DRAFT: "Draft", ACCEPTED: "Accepted", REJECTED: "Rejected" };

function enumOrDetailOfEstimateStatus(
  enumOrDetail: EstimateStatusDetailOptions | EstimateStatus | undefined,
): EstimateStatusDetail {
  if (enumOrDetail === undefined) {
    return newEstimateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "EstimateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfEstimateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as EstimateStatusDetail;
  } else {
    return newEstimateStatusDetail({
      code: enumOrDetail as EstimateStatus,
      name: enumDetailNameOfEstimateStatus[enumOrDetail as EstimateStatus],
    });
  }
}

function enumOrDetailOrNullOfEstimateStatus(
  enumOrDetail: EstimateStatusDetailOptions | EstimateStatus | undefined | null,
): EstimateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfEstimateStatus(enumOrDetail);
}

const enumDetailNameOfEstimateType = { PRELIMINARY: "Preliminary", FINAL: "Final" };

function enumOrDetailOfEstimateType(
  enumOrDetail: EstimateTypeDetailOptions | EstimateType | undefined,
): EstimateTypeDetail {
  if (enumOrDetail === undefined) {
    return newEstimateTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "EstimateTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfEstimateType[enumOrDetail.code!],
      ...enumOrDetail,
    } as EstimateTypeDetail;
  } else {
    return newEstimateTypeDetail({
      code: enumOrDetail as EstimateType,
      name: enumDetailNameOfEstimateType[enumOrDetail as EstimateType],
    });
  }
}

function enumOrDetailOrNullOfEstimateType(
  enumOrDetail: EstimateTypeDetailOptions | EstimateType | undefined | null,
): EstimateTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfEstimateType(enumOrDetail);
}

const enumDetailNameOfCommitmentStatus = {
  DRAFT: "Draft",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  SIGNED: "Signed",
  VOIDED: "Voided",
  PARTIALLY_SIGNED: "Partially signed",
};

function enumOrDetailOfCommitmentStatus(
  enumOrDetail: CommitmentStatusDetailOptions | CommitmentStatus | undefined,
): CommitmentStatusDetail {
  if (enumOrDetail === undefined) {
    return newCommitmentStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommitmentStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommitmentStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommitmentStatusDetail;
  } else {
    return newCommitmentStatusDetail({
      code: enumOrDetail as CommitmentStatus,
      name: enumDetailNameOfCommitmentStatus[enumOrDetail as CommitmentStatus],
    });
  }
}

function enumOrDetailOrNullOfCommitmentStatus(
  enumOrDetail: CommitmentStatusDetailOptions | CommitmentStatus | undefined | null,
): CommitmentStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommitmentStatus(enumOrDetail);
}

const enumDetailNameOfDevelopmentCommitmentType = {
  MATERIALS: "Materials",
  LABOR: "Labor",
  LABOR_AND_MATERIALS: "Labor and materials",
};

function enumOrDetailOfDevelopmentCommitmentType(
  enumOrDetail: DevelopmentCommitmentTypeDetailOptions | DevelopmentCommitmentType | undefined,
): DevelopmentCommitmentTypeDetail {
  if (enumOrDetail === undefined) {
    return newDevelopmentCommitmentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DevelopmentCommitmentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDevelopmentCommitmentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as DevelopmentCommitmentTypeDetail;
  } else {
    return newDevelopmentCommitmentTypeDetail({
      code: enumOrDetail as DevelopmentCommitmentType,
      name: enumDetailNameOfDevelopmentCommitmentType[enumOrDetail as DevelopmentCommitmentType],
    });
  }
}

function enumOrDetailOrNullOfDevelopmentCommitmentType(
  enumOrDetail: DevelopmentCommitmentTypeDetailOptions | DevelopmentCommitmentType | undefined | null,
): DevelopmentCommitmentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDevelopmentCommitmentType(enumOrDetail);
}

const enumDetailNameOfCommitmentType = { PURCHASE_ORDER: "Purchase order", SUBCONTRACT: "Subcontract" };

function enumOrDetailOfCommitmentType(
  enumOrDetail: CommitmentTypeDetailOptions | CommitmentType | undefined,
): CommitmentTypeDetail {
  if (enumOrDetail === undefined) {
    return newCommitmentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommitmentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommitmentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommitmentTypeDetail;
  } else {
    return newCommitmentTypeDetail({
      code: enumOrDetail as CommitmentType,
      name: enumDetailNameOfCommitmentType[enumOrDetail as CommitmentType],
    });
  }
}

function enumOrDetailOrNullOfCommitmentType(
  enumOrDetail: CommitmentTypeDetailOptions | CommitmentType | undefined | null,
): CommitmentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommitmentType(enumOrDetail);
}

const enumDetailNameOfDocumentType = {
  PRECON_AGREEMENT: "Precon agreement",
  CONSTRUCTION_AGREEMENT: "Construction agreement",
  PURCHASE_ORDER: "Purchase order",
  SUBCONTRACT: "Subcontract",
  PRECON_AGREEMENT_CHANGE_ORDER: "Precon agreement change order",
  CONSTRUCTION_AGREEMENT_CHANGE_ORDER: "Construction agreement change order",
  PURCHASE_ORDER_CHANGE_ORDER: "Purchase order change order",
  SUBCONTRACT_CHANGE_ORDER: "Subcontract change order",
  BILL: "Bill",
  INVOICE: "Invoice",
  MEETING_NOTE: "Meeting note",
  INSURANCE: "Insurance",
  SALES: "Sales",
  ARCHITECTURE_AND_ENGINEERING: "Architecture and engineering",
  SITE_REPORT: "Site report",
  CORRESPONDENCE: "Correspondence",
  GENERAL: "General",
  PERMITTING: "Permitting",
  APPROVED_PLAN: "Approved plan",
  PHOTO: "Photo",
  DESIGN_STUDIO: "Design studio",
  DEVELOPMENT_COMMITMENT: "Development commitment",
  BID_CONTRACT: "Bid contract",
  EXPENSE: "Expense",
  WORK_AUTHORIZATION: "Work authorization",
  PRICE_AGREEMENT_CHANGE_ORDER: "Price agreement change order",
  PRICE_AGREEMENT_BID_CONTRACT_REVISION: "Price agreement bid contract revision",
  PRICE_AGREEMENT_DEVELOPMENT_COMMITMENT: "Price agreement development commitment",
  PRICE_AGREEMENT_COMMITMENT: "Price agreement commitment",
  PLAN: "Plan",
  DRAWING: "Drawing",
  FINISH_SCHEDULE: "Finish schedule",
  BOUNDARY_SURVEYS: "Boundary surveys",
  TOPO_SURVEYS: "Topo surveys",
  GEOTECH_REPORT_SOILS_REPORT: "Geotech report soils report",
  ELEVATION_CERTIFICATE: "Elevation certificate",
  MISCELLANEOUS_GENERAL: "Miscellaneous general",
  LEGAL: "Legal",
  CERTIFICATE_OF_OCCUPANCY: "Certificate of occupancy",
  FLOOD_INSURANCE_POLICY: "Flood insurance policy",
  PRE_BUILD_APPRAISAL: "Pre build appraisal",
  PURCHASE_AGREEMENT: "Purchase agreement",
  PURCHASE_AGREEMENT_AMENDMENT_LOT_ACQ: "Purchase agreement amendment lot acq",
  SETTLEMENT_STATEMENT_PRELIMINARY: "Settlement statement preliminary",
  SETTLEMENT_STATEMENT_FINAL: "Settlement statement final",
  DEED: "Deed",
  RECORDED_DEED: "Recorded deed",
  TITLE_INSURANCE_POLICY: "Title insurance policy",
  PROPERTY_SURVEY: "Property survey",
  EARNEST_MONEY_RECEIPT_LOT_ACQ: "Earnest money receipt lot acq",
  BUILDING_PERMIT: "Building permit",
  DEMO_PERMIT: "Demo permit",
  RETAINING_WALL_PERMIT: "Retaining wall permit",
  WATER_PERMIT: "Water permit",
  GRADING_PERMIT: "Grading permit",
  POOL_PERMIT: "Pool permit",
  VPO: "Vpo",
  PURCHASE_AGREEMENT_FINAL: "Purchase agreement final",
  PURCHASE_AGREEMENT_COUNTER_OFFER: "Purchase agreement counter offer",
  PURCHASE_AGREEMENT_AMENDMENT_SALES: "Purchase agreement amendment sales",
  PURCHASE_AGREEMENT_ADDENDUM: "Purchase agreement addendum",
  EARNEST_MONEY_RECEIPT_SALES: "Earnest money receipt sales",
  DISCLOSURES: "Disclosures",
  MISCELLANEOUS_SALES: "Miscellaneous sales",
  APPRAISAL_PRECON: "Appraisal precon",
  APPRAISAL_POST_COO: "Appraisal post coo",
  INSURANCE_HAZARD: "Insurance hazard",
  INSURANCE_BUILDERS_RISK: "Insurance builders risk",
  HOMEOWNER_ORIENTATION: "Homeowner orientation",
  LIEN_WAIVER: "Lien waiver",
  CHANGE_EVENT: "Change event",
  THIRD_PARTY_INSPECTION: "Third party inspection",
  CITY_INSPECTION: "City inspection",
  WARRANTY: "Warranty",
  RENDERING: "Rendering",
};

function enumOrDetailOfDocumentType(
  enumOrDetail: DocumentTypeDetailOptions | DocumentType | undefined,
): DocumentTypeDetail {
  if (enumOrDetail === undefined) {
    return newDocumentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentTypeDetail;
  } else {
    return newDocumentTypeDetail({
      code: enumOrDetail as DocumentType,
      name: enumDetailNameOfDocumentType[enumOrDetail as DocumentType],
    });
  }
}

function enumOrDetailOrNullOfDocumentType(
  enumOrDetail: DocumentTypeDetailOptions | DocumentType | undefined | null,
): DocumentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentType(enumOrDetail);
}

const enumDetailNameOfDocumentCategory = {
  CONTRACTUAL: "Contractual",
  PERMITS: "Permits",
  DESIGN: "Design",
  PROCUREMENT: "Procurement",
  ACCOUNTING: "Accounting",
  SALES_MARKETING: "Sales marketing",
  WARRANTY: "Warranty",
  ENGINEERING: "Engineering",
  GENERAL: "General",
  LOT_ACQUISITION: "Lot acquisition",
  VALUATION: "Valuation",
  INSURANCE: "Insurance",
  ASSET_MANAGEMENT: "Asset management",
};

function enumOrDetailOfDocumentCategory(
  enumOrDetail: DocumentCategoryDetailOptions | DocumentCategory | undefined,
): DocumentCategoryDetail {
  if (enumOrDetail === undefined) {
    return newDocumentCategoryDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentCategoryDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentCategory[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentCategoryDetail;
  } else {
    return newDocumentCategoryDetail({
      code: enumOrDetail as DocumentCategory,
      name: enumDetailNameOfDocumentCategory[enumOrDetail as DocumentCategory],
    });
  }
}

function enumOrDetailOrNullOfDocumentCategory(
  enumOrDetail: DocumentCategoryDetailOptions | DocumentCategory | undefined | null,
): DocumentCategoryDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentCategory(enumOrDetail);
}

const enumDetailNameOfScopeChangeType = {
  NONE: "None",
  ADD: "Add",
  REPLACE: "Replace",
  MINOR: "Minor",
  MAJOR: "Major",
  REMOVED: "Removed",
  SYSTEM: "System",
};

function enumOrDetailOfScopeChangeType(
  enumOrDetail: ScopeChangeTypeDetailOptions | ScopeChangeType | undefined,
): ScopeChangeTypeDetail {
  if (enumOrDetail === undefined) {
    return newScopeChangeTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScopeChangeTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScopeChangeType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScopeChangeTypeDetail;
  } else {
    return newScopeChangeTypeDetail({
      code: enumOrDetail as ScopeChangeType,
      name: enumDetailNameOfScopeChangeType[enumOrDetail as ScopeChangeType],
    });
  }
}

function enumOrDetailOrNullOfScopeChangeType(
  enumOrDetail: ScopeChangeTypeDetailOptions | ScopeChangeType | undefined | null,
): ScopeChangeTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScopeChangeType(enumOrDetail);
}

const enumDetailNameOfJobLogNoteType = {
  DELAY: "Delay",
  DELIVERY: "Delivery",
  INCIDENT: "Incident",
  INJURY: "Injury",
  INSPECTION: "Inspection",
  ISSUE: "Issue",
  HOLIDAY: "Holiday",
  REQUEST_FOR_INFORMATION: "Request for information",
  TRADE_PARTNER_WORK: "Trade partner work",
  UPCOMING_ACTIVITY: "Upcoming activity",
  VISITOR: "Visitor",
  WARRANTY: "Warranty",
  WEATHER: "Weather",
  OTHER: "Other",
  CLIENT_COMMUNICATION: "Client communication",
  INTERNAL: "Internal",
  PRE_CON: "Pre con",
  AI_SUMMARY: "Ai summary",
};

function enumOrDetailOfJobLogNoteType(
  enumOrDetail: JobLogNoteTypeDetailOptions | JobLogNoteType | undefined,
): JobLogNoteTypeDetail {
  if (enumOrDetail === undefined) {
    return newJobLogNoteTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "JobLogNoteTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfJobLogNoteType[enumOrDetail.code!],
      ...enumOrDetail,
    } as JobLogNoteTypeDetail;
  } else {
    return newJobLogNoteTypeDetail({
      code: enumOrDetail as JobLogNoteType,
      name: enumDetailNameOfJobLogNoteType[enumOrDetail as JobLogNoteType],
    });
  }
}

function enumOrDetailOrNullOfJobLogNoteType(
  enumOrDetail: JobLogNoteTypeDetailOptions | JobLogNoteType | undefined | null,
): JobLogNoteTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfJobLogNoteType(enumOrDetail);
}

const enumDetailNameOfClientPlatform = { WEB: "Web", MOBILE: "Mobile" };

function enumOrDetailOfClientPlatform(
  enumOrDetail: ClientPlatformDetailOptions | ClientPlatform | undefined,
): ClientPlatformDetail {
  if (enumOrDetail === undefined) {
    return newClientPlatformDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ClientPlatformDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfClientPlatform[enumOrDetail.code!],
      ...enumOrDetail,
    } as ClientPlatformDetail;
  } else {
    return newClientPlatformDetail({
      code: enumOrDetail as ClientPlatform,
      name: enumDetailNameOfClientPlatform[enumOrDetail as ClientPlatform],
    });
  }
}

function enumOrDetailOrNullOfClientPlatform(
  enumOrDetail: ClientPlatformDetailOptions | ClientPlatform | undefined | null,
): ClientPlatformDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfClientPlatform(enumOrDetail);
}

const enumDetailNameOfTradePartnerAvailabilityRequestStatus = {
  WAITING: "Waiting",
  RESCHEDULE_NEEDED: "Reschedule needed",
  CONFIRMED: "Confirmed",
  CANCELED: "Canceled",
};

function enumOrDetailOfTradePartnerAvailabilityRequestStatus(
  enumOrDetail: TradePartnerAvailabilityRequestStatusDetailOptions | TradePartnerAvailabilityRequestStatus | undefined,
): TradePartnerAvailabilityRequestStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerAvailabilityRequestStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerAvailabilityRequestStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerAvailabilityRequestStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerAvailabilityRequestStatusDetail;
  } else {
    return newTradePartnerAvailabilityRequestStatusDetail({
      code: enumOrDetail as TradePartnerAvailabilityRequestStatus,
      name:
        enumDetailNameOfTradePartnerAvailabilityRequestStatus[enumOrDetail as TradePartnerAvailabilityRequestStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerAvailabilityRequestStatus(
  enumOrDetail:
    | TradePartnerAvailabilityRequestStatusDetailOptions
    | TradePartnerAvailabilityRequestStatus
    | undefined
    | null,
): TradePartnerAvailabilityRequestStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerAvailabilityRequestStatus(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketType = {
  ITEMS_OF_CONTINUANCE: "Items of continuance",
  THIRTY_DAY: "Thirty day",
  ONE_YEAR: "One year",
  TWO_YEAR: "Two year",
  TEN_YEAR: "Ten year",
};

function enumOrDetailOfWarrantyTicketType(
  enumOrDetail: WarrantyTicketTypeDetailOptions | WarrantyTicketType | undefined,
): WarrantyTicketTypeDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketTypeDetail;
  } else {
    return newWarrantyTicketTypeDetail({
      code: enumOrDetail as WarrantyTicketType,
      name: enumDetailNameOfWarrantyTicketType[enumOrDetail as WarrantyTicketType],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketType(
  enumOrDetail: WarrantyTicketTypeDetailOptions | WarrantyTicketType | undefined | null,
): WarrantyTicketTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketType(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketStatus = {
  NOT_STARTED: "Not started",
  IN_PROGRESS: "In progress",
  CLOSED: "Closed",
};

function enumOrDetailOfWarrantyTicketStatus(
  enumOrDetail: WarrantyTicketStatusDetailOptions | WarrantyTicketStatus | undefined,
): WarrantyTicketStatusDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketStatusDetail;
  } else {
    return newWarrantyTicketStatusDetail({
      code: enumOrDetail as WarrantyTicketStatus,
      name: enumDetailNameOfWarrantyTicketStatus[enumOrDetail as WarrantyTicketStatus],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketStatus(
  enumOrDetail: WarrantyTicketStatusDetailOptions | WarrantyTicketStatus | undefined | null,
): WarrantyTicketStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketStatus(enumOrDetail);
}

const enumDetailNameOfContractType = {
  FIXED: "Fixed",
  COST_PLUS: "Cost plus",
  BUDGET_REALLOCATION: "Budget reallocation",
};

function enumOrDetailOfContractType(
  enumOrDetail: ContractTypeDetailOptions | ContractType | undefined,
): ContractTypeDetail {
  if (enumOrDetail === undefined) {
    return newContractTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ContractTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfContractType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ContractTypeDetail;
  } else {
    return newContractTypeDetail({
      code: enumOrDetail as ContractType,
      name: enumDetailNameOfContractType[enumOrDetail as ContractType],
    });
  }
}

function enumOrDetailOrNullOfContractType(
  enumOrDetail: ContractTypeDetailOptions | ContractType | undefined | null,
): ContractTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfContractType(enumOrDetail);
}

const enumDetailNameOfReadyPlanStatus = { DRAFT: "Draft", ARCHIVED: "Archived", ACTIVE: "Active" };

function enumOrDetailOfReadyPlanStatus(
  enumOrDetail: ReadyPlanStatusDetailOptions | ReadyPlanStatus | undefined,
): ReadyPlanStatusDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanStatusDetail;
  } else {
    return newReadyPlanStatusDetail({
      code: enumOrDetail as ReadyPlanStatus,
      name: enumDetailNameOfReadyPlanStatus[enumOrDetail as ReadyPlanStatus],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanStatus(
  enumOrDetail: ReadyPlanStatusDetailOptions | ReadyPlanStatus | undefined | null,
): ReadyPlanStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanStatus(enumOrDetail);
}

const enumDetailNameOfGlobalOptionStatus = {
  ACTIVE: "Active",
  ARCHIVED: "Archived",
  PENDING_APPROVAL: "Pending approval",
};

function enumOrDetailOfGlobalOptionStatus(
  enumOrDetail: GlobalOptionStatusDetailOptions | GlobalOptionStatus | undefined,
): GlobalOptionStatusDetail {
  if (enumOrDetail === undefined) {
    return newGlobalOptionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "GlobalOptionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfGlobalOptionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as GlobalOptionStatusDetail;
  } else {
    return newGlobalOptionStatusDetail({
      code: enumOrDetail as GlobalOptionStatus,
      name: enumDetailNameOfGlobalOptionStatus[enumOrDetail as GlobalOptionStatus],
    });
  }
}

function enumOrDetailOrNullOfGlobalOptionStatus(
  enumOrDetail: GlobalOptionStatusDetailOptions | GlobalOptionStatus | undefined | null,
): GlobalOptionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfGlobalOptionStatus(enumOrDetail);
}

const enumDetailNameOfCommentStreamVisibility = { INTERNAL: "Internal", HOMEOWNER: "Homeowner", TRADES: "Trades" };

function enumOrDetailOfCommentStreamVisibility(
  enumOrDetail: CommentStreamVisibilityDetailOptions | CommentStreamVisibility | undefined,
): CommentStreamVisibilityDetail {
  if (enumOrDetail === undefined) {
    return newCommentStreamVisibilityDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommentStreamVisibilityDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommentStreamVisibility[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommentStreamVisibilityDetail;
  } else {
    return newCommentStreamVisibilityDetail({
      code: enumOrDetail as CommentStreamVisibility,
      name: enumDetailNameOfCommentStreamVisibility[enumOrDetail as CommentStreamVisibility],
    });
  }
}

function enumOrDetailOrNullOfCommentStreamVisibility(
  enumOrDetail: CommentStreamVisibilityDetailOptions | CommentStreamVisibility | undefined | null,
): CommentStreamVisibilityDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommentStreamVisibility(enumOrDetail);
}

const enumDetailNameOfProjectStageStatus = { ACTIVE: "Active", COMPLETED: "Completed", DRAFT: "Draft" };

function enumOrDetailOfProjectStageStatus(
  enumOrDetail: ProjectStageStatusDetailOptions | ProjectStageStatus | undefined,
): ProjectStageStatusDetail {
  if (enumOrDetail === undefined) {
    return newProjectStageStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectStageStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectStageStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectStageStatusDetail;
  } else {
    return newProjectStageStatusDetail({
      code: enumOrDetail as ProjectStageStatus,
      name: enumDetailNameOfProjectStageStatus[enumOrDetail as ProjectStageStatus],
    });
  }
}

function enumOrDetailOrNullOfProjectStageStatus(
  enumOrDetail: ProjectStageStatusDetailOptions | ProjectStageStatus | undefined | null,
): ProjectStageStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectStageStatus(enumOrDetail);
}

const enumDetailNameOfCostCodeBidSummaryStatus = {
  MISSING: "Missing",
  IN_PROGRESS: "In progress",
  INCOMPLETE: "Incomplete",
  COMPLETE: "Complete",
};

function enumOrDetailOfCostCodeBidSummaryStatus(
  enumOrDetail: CostCodeBidSummaryStatusDetailOptions | CostCodeBidSummaryStatus | undefined,
): CostCodeBidSummaryStatusDetail {
  if (enumOrDetail === undefined) {
    return newCostCodeBidSummaryStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostCodeBidSummaryStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostCodeBidSummaryStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostCodeBidSummaryStatusDetail;
  } else {
    return newCostCodeBidSummaryStatusDetail({
      code: enumOrDetail as CostCodeBidSummaryStatus,
      name: enumDetailNameOfCostCodeBidSummaryStatus[enumOrDetail as CostCodeBidSummaryStatus],
    });
  }
}

function enumOrDetailOrNullOfCostCodeBidSummaryStatus(
  enumOrDetail: CostCodeBidSummaryStatusDetailOptions | CostCodeBidSummaryStatus | undefined | null,
): CostCodeBidSummaryStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostCodeBidSummaryStatus(enumOrDetail);
}

const enumDetailNameOfCostCodeBidSummaryFlag = {
  MISSING_BID: "Missing bid",
  MISSING_REQUIRED_BID: "Missing required bid",
  MISSING_COSTS: "Missing costs",
  MISSING_OPTIONS: "Missing options",
  COST_MISSING_SCOPE: "Cost missing scope",
  MISSING_TRADE: "Missing trade",
  EXCLUDED_MATERIAL: "Excluded material",
  EXCLUDED_TASKS: "Excluded tasks",
};

function enumOrDetailOfCostCodeBidSummaryFlag(
  enumOrDetail: CostCodeBidSummaryFlagDetailOptions | CostCodeBidSummaryFlag | undefined,
): CostCodeBidSummaryFlagDetail {
  if (enumOrDetail === undefined) {
    return newCostCodeBidSummaryFlagDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostCodeBidSummaryFlagDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostCodeBidSummaryFlag[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostCodeBidSummaryFlagDetail;
  } else {
    return newCostCodeBidSummaryFlagDetail({
      code: enumOrDetail as CostCodeBidSummaryFlag,
      name: enumDetailNameOfCostCodeBidSummaryFlag[enumOrDetail as CostCodeBidSummaryFlag],
    });
  }
}

function enumOrDetailOrNullOfCostCodeBidSummaryFlag(
  enumOrDetail: CostCodeBidSummaryFlagDetailOptions | CostCodeBidSummaryFlag | undefined | null,
): CostCodeBidSummaryFlagDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostCodeBidSummaryFlag(enumOrDetail);
}

const enumDetailNameOfCostClassificationType = { SOFT: "Soft", HARD: "Hard" };

function enumOrDetailOfCostClassificationType(
  enumOrDetail: CostClassificationTypeDetailOptions | CostClassificationType | undefined,
): CostClassificationTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostClassificationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostClassificationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostClassificationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostClassificationTypeDetail;
  } else {
    return newCostClassificationTypeDetail({
      code: enumOrDetail as CostClassificationType,
      name: enumDetailNameOfCostClassificationType[enumOrDetail as CostClassificationType],
    });
  }
}

function enumOrDetailOrNullOfCostClassificationType(
  enumOrDetail: CostClassificationTypeDetailOptions | CostClassificationType | undefined | null,
): CostClassificationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostClassificationType(enumOrDetail);
}

const enumDetailNameOfCostSubClassificationType = { INDIRECT: "Indirect", DIRECT: "Direct" };

function enumOrDetailOfCostSubClassificationType(
  enumOrDetail: CostSubClassificationTypeDetailOptions | CostSubClassificationType | undefined,
): CostSubClassificationTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostSubClassificationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostSubClassificationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostSubClassificationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostSubClassificationTypeDetail;
  } else {
    return newCostSubClassificationTypeDetail({
      code: enumOrDetail as CostSubClassificationType,
      name: enumDetailNameOfCostSubClassificationType[enumOrDetail as CostSubClassificationType],
    });
  }
}

function enumOrDetailOrNullOfCostSubClassificationType(
  enumOrDetail: CostSubClassificationTypeDetailOptions | CostSubClassificationType | undefined | null,
): CostSubClassificationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostSubClassificationType(enumOrDetail);
}

const enumDetailNameOfCostCodeInvoiceCategory = {
  PRE_CON: "Pre con",
  FOUNDATION: "Foundation",
  FRAMING: "Framing",
  HARDSCAPE: "Hardscape",
  INSULATION_DRYWALL: "Insulation drywall",
  INTERIOR_FINISHES: "Interior finishes",
  ROOFING: "Roofing",
  ROUGH_IN: "Rough in",
  SIDING: "Siding",
  SUBSTANTIAL_COMPLETION: "Substantial completion",
  ARCHITECTURE_PLAN: "Architecture plan",
  ARCHITECTURE_FEE: "Architecture fee",
  EXTERIOR: "Exterior",
  MECHANICAL_SYSTEMS: "Mechanical systems",
  GENERAL_CONDITIONS: "General conditions",
  CONTINGENCY: "Contingency",
  HOLD_BACK: "Hold back",
  DEPOSIT: "Deposit",
};

function enumOrDetailOfCostCodeInvoiceCategory(
  enumOrDetail: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | undefined,
): CostCodeInvoiceCategoryDetail {
  if (enumOrDetail === undefined) {
    return newCostCodeInvoiceCategoryDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostCodeInvoiceCategoryDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostCodeInvoiceCategory[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostCodeInvoiceCategoryDetail;
  } else {
    return newCostCodeInvoiceCategoryDetail({
      code: enumOrDetail as CostCodeInvoiceCategory,
      name: enumDetailNameOfCostCodeInvoiceCategory[enumOrDetail as CostCodeInvoiceCategory],
    });
  }
}

function enumOrDetailOrNullOfCostCodeInvoiceCategory(
  enumOrDetail: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | undefined | null,
): CostCodeInvoiceCategoryDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostCodeInvoiceCategory(enumOrDetail);
}

const enumDetailNameOfSelectionCutoff = {
  CUTOFF_1: "Cutoff 1",
  CUTOFF_2A: "Cutoff 2 a",
  CUTOFF_2B: "Cutoff 2 b",
  CUTOFF_3: "Cutoff 3",
};

function enumOrDetailOfSelectionCutoff(
  enumOrDetail: SelectionCutoffDetailOptions | SelectionCutoff | undefined,
): SelectionCutoffDetail {
  if (enumOrDetail === undefined) {
    return newSelectionCutoffDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SelectionCutoffDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSelectionCutoff[enumOrDetail.code!],
      ...enumOrDetail,
    } as SelectionCutoffDetail;
  } else {
    return newSelectionCutoffDetail({
      code: enumOrDetail as SelectionCutoff,
      name: enumDetailNameOfSelectionCutoff[enumOrDetail as SelectionCutoff],
    });
  }
}

function enumOrDetailOrNullOfSelectionCutoff(
  enumOrDetail: SelectionCutoffDetailOptions | SelectionCutoff | undefined | null,
): SelectionCutoffDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSelectionCutoff(enumOrDetail);
}

const enumDetailNameOfDesignPackageLocation = { INTERIOR: "Interior", EXTERIOR: "Exterior" };

function enumOrDetailOfDesignPackageLocation(
  enumOrDetail: DesignPackageLocationDetailOptions | DesignPackageLocation | undefined,
): DesignPackageLocationDetail {
  if (enumOrDetail === undefined) {
    return newDesignPackageLocationDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DesignPackageLocationDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDesignPackageLocation[enumOrDetail.code!],
      ...enumOrDetail,
    } as DesignPackageLocationDetail;
  } else {
    return newDesignPackageLocationDetail({
      code: enumOrDetail as DesignPackageLocation,
      name: enumDetailNameOfDesignPackageLocation[enumOrDetail as DesignPackageLocation],
    });
  }
}

function enumOrDetailOrNullOfDesignPackageLocation(
  enumOrDetail: DesignPackageLocationDetailOptions | DesignPackageLocation | undefined | null,
): DesignPackageLocationDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDesignPackageLocation(enumOrDetail);
}

const enumDetailNameOfActivityPlanningState = {
  DRAFT: "Draft",
  READY_FOR_REVIEW: "Ready for review",
  IN_REVIEW: "In review",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

function enumOrDetailOfActivityPlanningState(
  enumOrDetail: ActivityPlanningStateDetailOptions | ActivityPlanningState | undefined,
): ActivityPlanningStateDetail {
  if (enumOrDetail === undefined) {
    return newActivityPlanningStateDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ActivityPlanningStateDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfActivityPlanningState[enumOrDetail.code!],
      ...enumOrDetail,
    } as ActivityPlanningStateDetail;
  } else {
    return newActivityPlanningStateDetail({
      code: enumOrDetail as ActivityPlanningState,
      name: enumDetailNameOfActivityPlanningState[enumOrDetail as ActivityPlanningState],
    });
  }
}

function enumOrDetailOrNullOfActivityPlanningState(
  enumOrDetail: ActivityPlanningStateDetailOptions | ActivityPlanningState | undefined | null,
): ActivityPlanningStateDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfActivityPlanningState(enumOrDetail);
}

const enumDetailNameOfActivityResponsibility = {
  HOMEBOUND: "Homebound",
  OWNERS_CONSULTANT: "Owners consultant",
  NOT_APPLICABLE: "Not applicable",
};

function enumOrDetailOfActivityResponsibility(
  enumOrDetail: ActivityResponsibilityDetailOptions | ActivityResponsibility | undefined,
): ActivityResponsibilityDetail {
  if (enumOrDetail === undefined) {
    return newActivityResponsibilityDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ActivityResponsibilityDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfActivityResponsibility[enumOrDetail.code!],
      ...enumOrDetail,
    } as ActivityResponsibilityDetail;
  } else {
    return newActivityResponsibilityDetail({
      code: enumOrDetail as ActivityResponsibility,
      name: enumDetailNameOfActivityResponsibility[enumOrDetail as ActivityResponsibility],
    });
  }
}

function enumOrDetailOrNullOfActivityResponsibility(
  enumOrDetail: ActivityResponsibilityDetailOptions | ActivityResponsibility | undefined | null,
): ActivityResponsibilityDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfActivityResponsibility(enumOrDetail);
}

const enumDetailNameOfActivityType = {
  PRECON_PLANNING: "Precon planning",
  PRECON_CONSTRUCTION_DOC: "Precon construction doc",
};

function enumOrDetailOfActivityType(
  enumOrDetail: ActivityTypeDetailOptions | ActivityType | undefined,
): ActivityTypeDetail {
  if (enumOrDetail === undefined) {
    return newActivityTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ActivityTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfActivityType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ActivityTypeDetail;
  } else {
    return newActivityTypeDetail({
      code: enumOrDetail as ActivityType,
      name: enumDetailNameOfActivityType[enumOrDetail as ActivityType],
    });
  }
}

function enumOrDetailOrNullOfActivityType(
  enumOrDetail: ActivityTypeDetailOptions | ActivityType | undefined | null,
): ActivityTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfActivityType(enumOrDetail);
}

const enumDetailNameOfAggregateVersionStatus = { DRAFT: "Draft", ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfAggregateVersionStatus(
  enumOrDetail: AggregateVersionStatusDetailOptions | AggregateVersionStatus | undefined,
): AggregateVersionStatusDetail {
  if (enumOrDetail === undefined) {
    return newAggregateVersionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AggregateVersionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAggregateVersionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as AggregateVersionStatusDetail;
  } else {
    return newAggregateVersionStatusDetail({
      code: enumOrDetail as AggregateVersionStatus,
      name: enumDetailNameOfAggregateVersionStatus[enumOrDetail as AggregateVersionStatus],
    });
  }
}

function enumOrDetailOrNullOfAggregateVersionStatus(
  enumOrDetail: AggregateVersionStatusDetailOptions | AggregateVersionStatus | undefined | null,
): AggregateVersionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAggregateVersionStatus(enumOrDetail);
}

const enumDetailNameOfAllocationStrategy = {
  SIZE_BASED: "Size based",
  EQUAL_SHARE: "Equal share",
  MARKET_VALUE: "Market value",
};

function enumOrDetailOfAllocationStrategy(
  enumOrDetail: AllocationStrategyDetailOptions | AllocationStrategy | undefined,
): AllocationStrategyDetail {
  if (enumOrDetail === undefined) {
    return newAllocationStrategyDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AllocationStrategyDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAllocationStrategy[enumOrDetail.code!],
      ...enumOrDetail,
    } as AllocationStrategyDetail;
  } else {
    return newAllocationStrategyDetail({
      code: enumOrDetail as AllocationStrategy,
      name: enumDetailNameOfAllocationStrategy[enumOrDetail as AllocationStrategy],
    });
  }
}

function enumOrDetailOrNullOfAllocationStrategy(
  enumOrDetail: AllocationStrategyDetailOptions | AllocationStrategy | undefined | null,
): AllocationStrategyDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAllocationStrategy(enumOrDetail);
}

const enumDetailNameOfBillGmailAttachmentResult = {
  NOT_PDF: "Not pdf",
  MISSING_PO: "Missing po",
  MISSING_TRADE: "Missing trade",
  MISSING_PROJECT: "Missing project",
  MISSING_INVOICE_NUMBER: "Missing invoice number",
  DUPLICATE: "Duplicate",
  CLICK_TO_PAY: "Click to pay",
  BILL_CREATED: "Bill created",
  MISSING_CONSTRUCTION_STAGE: "Missing construction stage",
  PROCESSING_ERROR: "Processing error",
  NOT_AN_INVOICE: "Not an invoice",
};

function enumOrDetailOfBillGmailAttachmentResult(
  enumOrDetail: BillGmailAttachmentResultDetailOptions | BillGmailAttachmentResult | undefined,
): BillGmailAttachmentResultDetail {
  if (enumOrDetail === undefined) {
    return newBillGmailAttachmentResultDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillGmailAttachmentResultDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillGmailAttachmentResult[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillGmailAttachmentResultDetail;
  } else {
    return newBillGmailAttachmentResultDetail({
      code: enumOrDetail as BillGmailAttachmentResult,
      name: enumDetailNameOfBillGmailAttachmentResult[enumOrDetail as BillGmailAttachmentResult],
    });
  }
}

function enumOrDetailOrNullOfBillGmailAttachmentResult(
  enumOrDetail: BillGmailAttachmentResultDetailOptions | BillGmailAttachmentResult | undefined | null,
): BillGmailAttachmentResultDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillGmailAttachmentResult(enumOrDetail);
}

const enumDetailNameOfChangeRequestAssetScope = { PROJECT: "Project", DEVELOPMENT: "Development" };

function enumOrDetailOfChangeRequestAssetScope(
  enumOrDetail: ChangeRequestAssetScopeDetailOptions | ChangeRequestAssetScope | undefined,
): ChangeRequestAssetScopeDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestAssetScopeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestAssetScopeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestAssetScope[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestAssetScopeDetail;
  } else {
    return newChangeRequestAssetScopeDetail({
      code: enumOrDetail as ChangeRequestAssetScope,
      name: enumDetailNameOfChangeRequestAssetScope[enumOrDetail as ChangeRequestAssetScope],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestAssetScope(
  enumOrDetail: ChangeRequestAssetScopeDetailOptions | ChangeRequestAssetScope | undefined | null,
): ChangeRequestAssetScopeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestAssetScope(enumOrDetail);
}

const enumDetailNameOfCheckoutConfigOptionGroupStep = {
  EXTERIOR_ELEVATION: "Exterior elevation",
  EXTERIOR_DESIGN_PACKAGE: "Exterior design package",
  OPTIONS_STRUCTURAL: "Options structural",
  OPTIONS_ADDON: "Options addon",
  INTERIOR_DESIGN_PACKAGE: "Interior design package",
  INTERIOR_PERSONALIZATION: "Interior personalization",
  ADU: "Adu",
};

function enumOrDetailOfCheckoutConfigOptionGroupStep(
  enumOrDetail: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | undefined,
): CheckoutConfigOptionGroupStepDetail {
  if (enumOrDetail === undefined) {
    return newCheckoutConfigOptionGroupStepDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CheckoutConfigOptionGroupStepDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCheckoutConfigOptionGroupStep[enumOrDetail.code!],
      ...enumOrDetail,
    } as CheckoutConfigOptionGroupStepDetail;
  } else {
    return newCheckoutConfigOptionGroupStepDetail({
      code: enumOrDetail as CheckoutConfigOptionGroupStep,
      name: enumDetailNameOfCheckoutConfigOptionGroupStep[enumOrDetail as CheckoutConfigOptionGroupStep],
    });
  }
}

function enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(
  enumOrDetail: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | undefined | null,
): CheckoutConfigOptionGroupStepDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCheckoutConfigOptionGroupStep(enumOrDetail);
}

const enumDetailNameOfCheckoutConfigStatus = { DRAFT: "Draft", RESERVED: "Reserved", EXPIRED: "Expired" };

function enumOrDetailOfCheckoutConfigStatus(
  enumOrDetail: CheckoutConfigStatusDetailOptions | CheckoutConfigStatus | undefined,
): CheckoutConfigStatusDetail {
  if (enumOrDetail === undefined) {
    return newCheckoutConfigStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CheckoutConfigStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCheckoutConfigStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as CheckoutConfigStatusDetail;
  } else {
    return newCheckoutConfigStatusDetail({
      code: enumOrDetail as CheckoutConfigStatus,
      name: enumDetailNameOfCheckoutConfigStatus[enumOrDetail as CheckoutConfigStatus],
    });
  }
}

function enumOrDetailOrNullOfCheckoutConfigStatus(
  enumOrDetail: CheckoutConfigStatusDetailOptions | CheckoutConfigStatus | undefined | null,
): CheckoutConfigStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCheckoutConfigStatus(enumOrDetail);
}

const enumDetailNameOfCommunicationChannel = { EMAIL: "Email", TEXT: "Text" };

function enumOrDetailOfCommunicationChannel(
  enumOrDetail: CommunicationChannelDetailOptions | CommunicationChannel | undefined,
): CommunicationChannelDetail {
  if (enumOrDetail === undefined) {
    return newCommunicationChannelDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommunicationChannelDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommunicationChannel[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommunicationChannelDetail;
  } else {
    return newCommunicationChannelDetail({
      code: enumOrDetail as CommunicationChannel,
      name: enumDetailNameOfCommunicationChannel[enumOrDetail as CommunicationChannel],
    });
  }
}

function enumOrDetailOrNullOfCommunicationChannel(
  enumOrDetail: CommunicationChannelDetailOptions | CommunicationChannel | undefined | null,
): CommunicationChannelDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommunicationChannel(enumOrDetail);
}

const enumDetailNameOfConstructionType = { TYPE_III: "Type iii", TYPE_IV: "Type iv", TYPE_V: "Type v" };

function enumOrDetailOfConstructionType(
  enumOrDetail: ConstructionTypeDetailOptions | ConstructionType | undefined,
): ConstructionTypeDetail {
  if (enumOrDetail === undefined) {
    return newConstructionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ConstructionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfConstructionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ConstructionTypeDetail;
  } else {
    return newConstructionTypeDetail({
      code: enumOrDetail as ConstructionType,
      name: enumDetailNameOfConstructionType[enumOrDetail as ConstructionType],
    });
  }
}

function enumOrDetailOrNullOfConstructionType(
  enumOrDetail: ConstructionTypeDetailOptions | ConstructionType | undefined | null,
): ConstructionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfConstructionType(enumOrDetail);
}

const enumDetailNameOfDayOfWeek = {
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
};

function enumOrDetailOfDayOfWeek(enumOrDetail: DayOfWeekDetailOptions | DayOfWeek | undefined): DayOfWeekDetail {
  if (enumOrDetail === undefined) {
    return newDayOfWeekDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DayOfWeekDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDayOfWeek[enumOrDetail.code!],
      ...enumOrDetail,
    } as DayOfWeekDetail;
  } else {
    return newDayOfWeekDetail({
      code: enumOrDetail as DayOfWeek,
      name: enumDetailNameOfDayOfWeek[enumOrDetail as DayOfWeek],
    });
  }
}

function enumOrDetailOrNullOfDayOfWeek(
  enumOrDetail: DayOfWeekDetailOptions | DayOfWeek | undefined | null,
): DayOfWeekDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDayOfWeek(enumOrDetail);
}

const enumDetailNameOfDocumentAttachmentPlace = { PURCHASE_ORDER: "Purchase order", BID_CONTRACT: "Bid contract" };

function enumOrDetailOfDocumentAttachmentPlace(
  enumOrDetail: DocumentAttachmentPlaceDetailOptions | DocumentAttachmentPlace | undefined,
): DocumentAttachmentPlaceDetail {
  if (enumOrDetail === undefined) {
    return newDocumentAttachmentPlaceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentAttachmentPlaceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentAttachmentPlace[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentAttachmentPlaceDetail;
  } else {
    return newDocumentAttachmentPlaceDetail({
      code: enumOrDetail as DocumentAttachmentPlace,
      name: enumDetailNameOfDocumentAttachmentPlace[enumOrDetail as DocumentAttachmentPlace],
    });
  }
}

function enumOrDetailOrNullOfDocumentAttachmentPlace(
  enumOrDetail: DocumentAttachmentPlaceDetailOptions | DocumentAttachmentPlace | undefined | null,
): DocumentAttachmentPlaceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentAttachmentPlace(enumOrDetail);
}

const enumDetailNameOfErpAccrualType = {
  TASK_COMPLETION: "Task completion",
  TASK_ALLOCATION_CHANGE: "Task allocation change",
  TASK_REVERSAL: "Task reversal",
  PURCHASE_ORDER_SIGNED: "Purchase order signed",
  PURCHASE_ORDER_VOID: "Purchase order void",
  CHANGE_ORDER_VOID: "Change order void",
  CHANGE_ORDER_SIGNED: "Change order signed",
  DEPOSIT_BILL_PAYMENT: "Deposit bill payment",
  DEPOSIT_BILL_PAYMENT_VOID: "Deposit bill payment void",
  AP_BILL_APPROVAL: "Ap bill approval",
  AP_BILL_REVERSAL: "Ap bill reversal",
  OVERHEAD_BILL_APPROVAL: "Overhead bill approval",
  OVERHEAD_BILL_REVERSAL: "Overhead bill reversal",
  EOM_ACCRUAL: "Eom accrual",
  BILL_LINE_ITEM_ALLOCATION: "Bill line item allocation",
  BILL_LINE_ITEM_ALLOCATION_REVERSAL: "Bill line item allocation reversal",
  EOM_ACCRUAL_REVERSAL: "Eom accrual reversal",
  EXPENSE_COST_ALLOCATION: "Expense cost allocation",
  EXPENSE_COST_ALLOCATION_REVERSAL: "Expense cost allocation reversal",
};

function enumOrDetailOfErpAccrualType(
  enumOrDetail: ErpAccrualTypeDetailOptions | ErpAccrualType | undefined,
): ErpAccrualTypeDetail {
  if (enumOrDetail === undefined) {
    return newErpAccrualTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpAccrualTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpAccrualType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpAccrualTypeDetail;
  } else {
    return newErpAccrualTypeDetail({
      code: enumOrDetail as ErpAccrualType,
      name: enumDetailNameOfErpAccrualType[enumOrDetail as ErpAccrualType],
    });
  }
}

function enumOrDetailOrNullOfErpAccrualType(
  enumOrDetail: ErpAccrualTypeDetailOptions | ErpAccrualType | undefined | null,
): ErpAccrualTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpAccrualType(enumOrDetail);
}

const enumDetailNameOfErpRevenueLineItemSourceEvent = {
  CONTRACT_PRICE_CHANGE: "Contract price change",
  CONTRACT_PRICE_CHANGE_VOID: "Contract price change void",
  DIRECT_EXPENSE: "Direct expense",
  DIRECT_EXPENSE_VOID: "Direct expense void",
  COST_ACCRUAL: "Cost accrual",
  INITIAL_BALANCE: "Initial balance",
  OVERHEAD_BILL_APPROVAL: "Overhead bill approval",
  OVERHEAD_BILL_REVERSAL: "Overhead bill reversal",
  BUDGET_CHANGE: "Budget change",
  BUDGET_CHANGE_VOID: "Budget change void",
};

function enumOrDetailOfErpRevenueLineItemSourceEvent(
  enumOrDetail: ErpRevenueLineItemSourceEventDetailOptions | ErpRevenueLineItemSourceEvent | undefined,
): ErpRevenueLineItemSourceEventDetail {
  if (enumOrDetail === undefined) {
    return newErpRevenueLineItemSourceEventDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpRevenueLineItemSourceEventDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpRevenueLineItemSourceEvent[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpRevenueLineItemSourceEventDetail;
  } else {
    return newErpRevenueLineItemSourceEventDetail({
      code: enumOrDetail as ErpRevenueLineItemSourceEvent,
      name: enumDetailNameOfErpRevenueLineItemSourceEvent[enumOrDetail as ErpRevenueLineItemSourceEvent],
    });
  }
}

function enumOrDetailOrNullOfErpRevenueLineItemSourceEvent(
  enumOrDetail: ErpRevenueLineItemSourceEventDetailOptions | ErpRevenueLineItemSourceEvent | undefined | null,
): ErpRevenueLineItemSourceEventDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpRevenueLineItemSourceEvent(enumOrDetail);
}

const enumDetailNameOfErpTransactionGroupEvent = {
  TASK_COMPLETION: "Task completion",
  DEPOSIT_BILL: "Deposit bill",
  AP_BILL_APPROVAL: "Ap bill approval",
  EOM_ACCRUAL: "Eom accrual",
  REVENUE_RECOGNITION: "Revenue recognition",
  REVENUE_EOM_ACCRUAL: "Revenue eom accrual",
  COST_ALLOCATION: "Cost allocation",
};

function enumOrDetailOfErpTransactionGroupEvent(
  enumOrDetail: ErpTransactionGroupEventDetailOptions | ErpTransactionGroupEvent | undefined,
): ErpTransactionGroupEventDetail {
  if (enumOrDetail === undefined) {
    return newErpTransactionGroupEventDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpTransactionGroupEventDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpTransactionGroupEvent[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpTransactionGroupEventDetail;
  } else {
    return newErpTransactionGroupEventDetail({
      code: enumOrDetail as ErpTransactionGroupEvent,
      name: enumDetailNameOfErpTransactionGroupEvent[enumOrDetail as ErpTransactionGroupEvent],
    });
  }
}

function enumOrDetailOrNullOfErpTransactionGroupEvent(
  enumOrDetail: ErpTransactionGroupEventDetailOptions | ErpTransactionGroupEvent | undefined | null,
): ErpTransactionGroupEventDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpTransactionGroupEvent(enumOrDetail);
}

const enumDetailNameOfErpTransactionGroupStatus = { PENDING: "Pending", SUCCESS: "Success", DRAFT: "Draft" };

function enumOrDetailOfErpTransactionGroupStatus(
  enumOrDetail: ErpTransactionGroupStatusDetailOptions | ErpTransactionGroupStatus | undefined,
): ErpTransactionGroupStatusDetail {
  if (enumOrDetail === undefined) {
    return newErpTransactionGroupStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpTransactionGroupStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpTransactionGroupStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpTransactionGroupStatusDetail;
  } else {
    return newErpTransactionGroupStatusDetail({
      code: enumOrDetail as ErpTransactionGroupStatus,
      name: enumDetailNameOfErpTransactionGroupStatus[enumOrDetail as ErpTransactionGroupStatus],
    });
  }
}

function enumOrDetailOrNullOfErpTransactionGroupStatus(
  enumOrDetail: ErpTransactionGroupStatusDetailOptions | ErpTransactionGroupStatus | undefined | null,
): ErpTransactionGroupStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpTransactionGroupStatus(enumOrDetail);
}

const enumDetailNameOfErpTransactionStatus = { PENDING: "Pending", MISMATCHING: "Mismatching", SYNCED: "Synced" };

function enumOrDetailOfErpTransactionStatus(
  enumOrDetail: ErpTransactionStatusDetailOptions | ErpTransactionStatus | undefined,
): ErpTransactionStatusDetail {
  if (enumOrDetail === undefined) {
    return newErpTransactionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpTransactionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpTransactionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpTransactionStatusDetail;
  } else {
    return newErpTransactionStatusDetail({
      code: enumOrDetail as ErpTransactionStatus,
      name: enumDetailNameOfErpTransactionStatus[enumOrDetail as ErpTransactionStatus],
    });
  }
}

function enumOrDetailOrNullOfErpTransactionStatus(
  enumOrDetail: ErpTransactionStatusDetailOptions | ErpTransactionStatus | undefined | null,
): ErpTransactionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpTransactionStatus(enumOrDetail);
}

const enumDetailNameOfFeatureFlagStatus = { ACTIVE: "Active", RELEASED: "Released", ARCHIVED: "Archived" };

function enumOrDetailOfFeatureFlagStatus(
  enumOrDetail: FeatureFlagStatusDetailOptions | FeatureFlagStatus | undefined,
): FeatureFlagStatusDetail {
  if (enumOrDetail === undefined) {
    return newFeatureFlagStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FeatureFlagStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFeatureFlagStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as FeatureFlagStatusDetail;
  } else {
    return newFeatureFlagStatusDetail({
      code: enumOrDetail as FeatureFlagStatus,
      name: enumDetailNameOfFeatureFlagStatus[enumOrDetail as FeatureFlagStatus],
    });
  }
}

function enumOrDetailOrNullOfFeatureFlagStatus(
  enumOrDetail: FeatureFlagStatusDetailOptions | FeatureFlagStatus | undefined | null,
): FeatureFlagStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFeatureFlagStatus(enumOrDetail);
}

const enumDetailNameOfFeatureFlagType = {
  TEST_FEATURE: "Test feature",
  TRADE_PARTNER_COMMUNICATIONS_SMS: "Trade partner communications sms",
  CHANGE_REQUEST_MVP: "Change request mvp",
  DIGITAL_BUILDING_EXPERIMENTS: "Digital building experiments",
  TRADE_PORTAL_ACCESS: "Trade portal access",
  MATERIAL_CATALOG: "Material catalog",
  DYNAMIC_SCHEDULES: "Dynamic schedules",
  COST_ACCRUALS: "Cost accruals",
  PRODUCT_CONFIG: "Product config",
  MOBILE_PUNCHLIST_POLLING: "Mobile punchlist polling",
  DYNAMIC_SCHEDULES_TRADE_COMMS: "Dynamic schedules trade comms",
  REVENUE_RECOGNITION: "Revenue recognition",
  MOBILE_PROJECT_GEOFENCE: "Mobile project geofence",
  OPTIONS_CATALOG_V2: "Options catalog v2",
  DESIGN_PACKAGE_PERSONALIZATION: "Design package personalization",
  PRODUCTION_WARNING_BANNER: "Production warning banner",
  MOBILE_LEADERBOARD: "Mobile leaderboard",
  MOBILE_SCHEDULE_SIM_DRAFT_MODE: "Mobile schedule sim draft mode",
  MOBILE_AI_CHATBOT_V2: "Mobile ai chatbot v2",
  VIDEO_SIGHTLINE_ANALYSIS: "Video sightline analysis",
  MOBILE_INCREMENTAL_SYNC: "Mobile incremental sync",
  DESIGNER_MODIFIED_SLOTS: "Designer modified slots",
  PREFER_LEGACY_PROJECTS: "Prefer legacy projects",
  BID_PACKAGES_V2: "Bid packages v2",
  BLUEPRINT_ADMIN: "Blueprint admin",
  MOBILE_NAVIGATION_V2: "Mobile navigation v2",
  COST_CODES_ADMIN: "Cost codes admin",
  ITEM_CODES_ADMIN: "Item codes admin",
  FEATURE_TYPES_ADMIN: "Feature types admin",
  TASK_CATALOG_ADMIN: "Task catalog admin",
  SCHEDULE_MILESTONE_TARGETS: "Schedule milestone targets",
  TAKEOFF_REMOVALS: "Takeoff removals",
  MOBILE_UPLOAD_OBSERVABILITY: "Mobile upload observability",
  GUIDED_CHANGE_EVENT: "Guided change event",
  MOBILE_SMART_ACTION_INBOX: "Mobile smart action inbox",
  FINISH_SCHEDULES_V2: "Finish schedules v2",
  PLAN_PACKAGES_V2: "Plan packages v2",
  MOBILE_SCHEDULES_V2: "Mobile schedules v2",
  PLAN_PACKAGES_AI: "Plan packages ai",
  MATERIAL_IMPORT_AI: "Material import ai",
  FINISH_SCHEDULE_ADMIN: "Finish schedule admin",
};

function enumOrDetailOfFeatureFlagType(
  enumOrDetail: FeatureFlagTypeDetailOptions | FeatureFlagType | undefined,
): FeatureFlagTypeDetail {
  if (enumOrDetail === undefined) {
    return newFeatureFlagTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FeatureFlagTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFeatureFlagType[enumOrDetail.code!],
      ...enumOrDetail,
    } as FeatureFlagTypeDetail;
  } else {
    return newFeatureFlagTypeDetail({
      code: enumOrDetail as FeatureFlagType,
      name: enumDetailNameOfFeatureFlagType[enumOrDetail as FeatureFlagType],
    });
  }
}

function enumOrDetailOrNullOfFeatureFlagType(
  enumOrDetail: FeatureFlagTypeDetailOptions | FeatureFlagType | undefined | null,
): FeatureFlagTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFeatureFlagType(enumOrDetail);
}

const enumDetailNameOfFinishScheduleColumnType = { CORE: "Core", ATTRIBUTE: "Attribute" };

function enumOrDetailOfFinishScheduleColumnType(
  enumOrDetail: FinishScheduleColumnTypeDetailOptions | FinishScheduleColumnType | undefined,
): FinishScheduleColumnTypeDetail {
  if (enumOrDetail === undefined) {
    return newFinishScheduleColumnTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FinishScheduleColumnTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFinishScheduleColumnType[enumOrDetail.code!],
      ...enumOrDetail,
    } as FinishScheduleColumnTypeDetail;
  } else {
    return newFinishScheduleColumnTypeDetail({
      code: enumOrDetail as FinishScheduleColumnType,
      name: enumDetailNameOfFinishScheduleColumnType[enumOrDetail as FinishScheduleColumnType],
    });
  }
}

function enumOrDetailOrNullOfFinishScheduleColumnType(
  enumOrDetail: FinishScheduleColumnTypeDetailOptions | FinishScheduleColumnType | undefined | null,
): FinishScheduleColumnTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFinishScheduleColumnType(enumOrDetail);
}

const enumDetailNameOfFinishScheduleCoreColumn = {
  LOCATION: "Location",
  IMAGE: "Image",
  ITEM: "Item",
  BRAND: "Brand",
  PRODUCT: "Product",
  TRADE: "Trade",
  NOTES: "Notes",
  LINK: "Link",
  DIMENSIONS: "Dimensions",
};

function enumOrDetailOfFinishScheduleCoreColumn(
  enumOrDetail: FinishScheduleCoreColumnDetailOptions | FinishScheduleCoreColumn | undefined,
): FinishScheduleCoreColumnDetail {
  if (enumOrDetail === undefined) {
    return newFinishScheduleCoreColumnDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FinishScheduleCoreColumnDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFinishScheduleCoreColumn[enumOrDetail.code!],
      ...enumOrDetail,
    } as FinishScheduleCoreColumnDetail;
  } else {
    return newFinishScheduleCoreColumnDetail({
      code: enumOrDetail as FinishScheduleCoreColumn,
      name: enumDetailNameOfFinishScheduleCoreColumn[enumOrDetail as FinishScheduleCoreColumn],
    });
  }
}

function enumOrDetailOrNullOfFinishScheduleCoreColumn(
  enumOrDetail: FinishScheduleCoreColumnDetailOptions | FinishScheduleCoreColumn | undefined | null,
): FinishScheduleCoreColumnDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFinishScheduleCoreColumn(enumOrDetail);
}

const enumDetailNameOfFloodPlain = { FP_0: "Fp 0", FP_100: "Fp 100", FP_500: "Fp 500" };

function enumOrDetailOfFloodPlain(enumOrDetail: FloodPlainDetailOptions | FloodPlain | undefined): FloodPlainDetail {
  if (enumOrDetail === undefined) {
    return newFloodPlainDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FloodPlainDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFloodPlain[enumOrDetail.code!],
      ...enumOrDetail,
    } as FloodPlainDetail;
  } else {
    return newFloodPlainDetail({
      code: enumOrDetail as FloodPlain,
      name: enumDetailNameOfFloodPlain[enumOrDetail as FloodPlain],
    });
  }
}

function enumOrDetailOrNullOfFloodPlain(
  enumOrDetail: FloodPlainDetailOptions | FloodPlain | undefined | null,
): FloodPlainDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFloodPlain(enumOrDetail);
}

const enumDetailNameOfFloodZone = { FZ_NONE: "Fz none", FZ_AE: "Fz ae", FZ_COASTAL_A: "Fz coastal a", FZ_VE: "Fz ve" };

function enumOrDetailOfFloodZone(enumOrDetail: FloodZoneDetailOptions | FloodZone | undefined): FloodZoneDetail {
  if (enumOrDetail === undefined) {
    return newFloodZoneDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FloodZoneDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFloodZone[enumOrDetail.code!],
      ...enumOrDetail,
    } as FloodZoneDetail;
  } else {
    return newFloodZoneDetail({
      code: enumOrDetail as FloodZone,
      name: enumDetailNameOfFloodZone[enumOrDetail as FloodZone],
    });
  }
}

function enumOrDetailOrNullOfFloodZone(
  enumOrDetail: FloodZoneDetailOptions | FloodZone | undefined | null,
): FloodZoneDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFloodZone(enumOrDetail);
}

const enumDetailNameOfFoundationType = { SLAB: "Slab", ELEVATED: "Elevated", PIERS: "Piers" };

function enumOrDetailOfFoundationType(
  enumOrDetail: FoundationTypeDetailOptions | FoundationType | undefined,
): FoundationTypeDetail {
  if (enumOrDetail === undefined) {
    return newFoundationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FoundationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFoundationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as FoundationTypeDetail;
  } else {
    return newFoundationTypeDetail({
      code: enumOrDetail as FoundationType,
      name: enumDetailNameOfFoundationType[enumOrDetail as FoundationType],
    });
  }
}

function enumOrDetailOrNullOfFoundationType(
  enumOrDetail: FoundationTypeDetailOptions | FoundationType | undefined | null,
): FoundationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFoundationType(enumOrDetail);
}

const enumDetailNameOfGlobalOptionTypeStatus = { ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfGlobalOptionTypeStatus(
  enumOrDetail: GlobalOptionTypeStatusDetailOptions | GlobalOptionTypeStatus | undefined,
): GlobalOptionTypeStatusDetail {
  if (enumOrDetail === undefined) {
    return newGlobalOptionTypeStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "GlobalOptionTypeStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfGlobalOptionTypeStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as GlobalOptionTypeStatusDetail;
  } else {
    return newGlobalOptionTypeStatusDetail({
      code: enumOrDetail as GlobalOptionTypeStatus,
      name: enumDetailNameOfGlobalOptionTypeStatus[enumOrDetail as GlobalOptionTypeStatus],
    });
  }
}

function enumOrDetailOrNullOfGlobalOptionTypeStatus(
  enumOrDetail: GlobalOptionTypeStatusDetailOptions | GlobalOptionTypeStatus | undefined | null,
): GlobalOptionTypeStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfGlobalOptionTypeStatus(enumOrDetail);
}

const enumDetailNameOfGlobalPlanMilestoneType = {
  CONSTRUCTION: "Construction",
  PRECONSTRUCTION: "Preconstruction",
  COMMUNITY: "Community",
  SALES: "Sales",
};

function enumOrDetailOfGlobalPlanMilestoneType(
  enumOrDetail: GlobalPlanMilestoneTypeDetailOptions | GlobalPlanMilestoneType | undefined,
): GlobalPlanMilestoneTypeDetail {
  if (enumOrDetail === undefined) {
    return newGlobalPlanMilestoneTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "GlobalPlanMilestoneTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfGlobalPlanMilestoneType[enumOrDetail.code!],
      ...enumOrDetail,
    } as GlobalPlanMilestoneTypeDetail;
  } else {
    return newGlobalPlanMilestoneTypeDetail({
      code: enumOrDetail as GlobalPlanMilestoneType,
      name: enumDetailNameOfGlobalPlanMilestoneType[enumOrDetail as GlobalPlanMilestoneType],
    });
  }
}

function enumOrDetailOrNullOfGlobalPlanMilestoneType(
  enumOrDetail: GlobalPlanMilestoneTypeDetailOptions | GlobalPlanMilestoneType | undefined | null,
): GlobalPlanMilestoneTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfGlobalPlanMilestoneType(enumOrDetail);
}

const enumDetailNameOfInboxItemStatus = { READ: "Read", UNREAD: "Unread", ARCHIVED: "Archived" };

function enumOrDetailOfInboxItemStatus(
  enumOrDetail: InboxItemStatusDetailOptions | InboxItemStatus | undefined,
): InboxItemStatusDetail {
  if (enumOrDetail === undefined) {
    return newInboxItemStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InboxItemStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInboxItemStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as InboxItemStatusDetail;
  } else {
    return newInboxItemStatusDetail({
      code: enumOrDetail as InboxItemStatus,
      name: enumDetailNameOfInboxItemStatus[enumOrDetail as InboxItemStatus],
    });
  }
}

function enumOrDetailOrNullOfInboxItemStatus(
  enumOrDetail: InboxItemStatusDetailOptions | InboxItemStatus | undefined | null,
): InboxItemStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInboxItemStatus(enumOrDetail);
}

const enumDetailNameOfInvoiceDocumentSource = { QUICKBOOKS: "Quickbooks", INTACCT: "Intacct", BLUEPRINT: "Blueprint" };

function enumOrDetailOfInvoiceDocumentSource(
  enumOrDetail: InvoiceDocumentSourceDetailOptions | InvoiceDocumentSource | undefined,
): InvoiceDocumentSourceDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceDocumentSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceDocumentSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceDocumentSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceDocumentSourceDetail;
  } else {
    return newInvoiceDocumentSourceDetail({
      code: enumOrDetail as InvoiceDocumentSource,
      name: enumDetailNameOfInvoiceDocumentSource[enumOrDetail as InvoiceDocumentSource],
    });
  }
}

function enumOrDetailOrNullOfInvoiceDocumentSource(
  enumOrDetail: InvoiceDocumentSourceDetailOptions | InvoiceDocumentSource | undefined | null,
): InvoiceDocumentSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceDocumentSource(enumOrDetail);
}

const enumDetailNameOfInvoiceScheduleAmountType = {
  COST: "Cost",
  MARGIN: "Margin",
  COST_AND_MARGIN: "Cost and margin",
};

function enumOrDetailOfInvoiceScheduleAmountType(
  enumOrDetail: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType | undefined,
): InvoiceScheduleAmountTypeDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceScheduleAmountTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceScheduleAmountTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceScheduleAmountType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceScheduleAmountTypeDetail;
  } else {
    return newInvoiceScheduleAmountTypeDetail({
      code: enumOrDetail as InvoiceScheduleAmountType,
      name: enumDetailNameOfInvoiceScheduleAmountType[enumOrDetail as InvoiceScheduleAmountType],
    });
  }
}

function enumOrDetailOrNullOfInvoiceScheduleAmountType(
  enumOrDetail: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType | undefined | null,
): InvoiceScheduleAmountTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceScheduleAmountType(enumOrDetail);
}

const enumDetailNameOfInvoiceScheduleItemFrequency = { ONCE: "Once", MONTHLY: "Monthly", DYNAMIC: "Dynamic" };

function enumOrDetailOfInvoiceScheduleItemFrequency(
  enumOrDetail: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency | undefined,
): InvoiceScheduleItemFrequencyDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceScheduleItemFrequencyDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceScheduleItemFrequencyDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceScheduleItemFrequency[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceScheduleItemFrequencyDetail;
  } else {
    return newInvoiceScheduleItemFrequencyDetail({
      code: enumOrDetail as InvoiceScheduleItemFrequency,
      name: enumDetailNameOfInvoiceScheduleItemFrequency[enumOrDetail as InvoiceScheduleItemFrequency],
    });
  }
}

function enumOrDetailOrNullOfInvoiceScheduleItemFrequency(
  enumOrDetail: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency | undefined | null,
): InvoiceScheduleItemFrequencyDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceScheduleItemFrequency(enumOrDetail);
}

const enumDetailNameOfInvoiceScheduleTriggerType = {
  DATE: "Date",
  TASK: "Task",
  COST: "Cost",
  NONE: "None",
  END_OF_MONTH: "End of month",
  PERCENTAGE_OF_COMPLETION: "Percentage of completion",
};

function enumOrDetailOfInvoiceScheduleTriggerType(
  enumOrDetail: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType | undefined,
): InvoiceScheduleTriggerTypeDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceScheduleTriggerTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceScheduleTriggerTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceScheduleTriggerType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceScheduleTriggerTypeDetail;
  } else {
    return newInvoiceScheduleTriggerTypeDetail({
      code: enumOrDetail as InvoiceScheduleTriggerType,
      name: enumDetailNameOfInvoiceScheduleTriggerType[enumOrDetail as InvoiceScheduleTriggerType],
    });
  }
}

function enumOrDetailOrNullOfInvoiceScheduleTriggerType(
  enumOrDetail: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType | undefined | null,
): InvoiceScheduleTriggerTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceScheduleTriggerType(enumOrDetail);
}

const enumDetailNameOfItemStatus = { DRAFT: "Draft", ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfItemStatus(enumOrDetail: ItemStatusDetailOptions | ItemStatus | undefined): ItemStatusDetail {
  if (enumOrDetail === undefined) {
    return newItemStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ItemStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfItemStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ItemStatusDetail;
  } else {
    return newItemStatusDetail({
      code: enumOrDetail as ItemStatus,
      name: enumDetailNameOfItemStatus[enumOrDetail as ItemStatus],
    });
  }
}

function enumOrDetailOrNullOfItemStatus(
  enumOrDetail: ItemStatusDetailOptions | ItemStatus | undefined | null,
): ItemStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfItemStatus(enumOrDetail);
}

const enumDetailNameOfItemTemplateItemCostStatus = {
  INTERNAL_ESTIMATE: "Internal estimate",
  CONTRACTED: "Contracted",
  NO_COST_SOURCE: "No cost source",
};

function enumOrDetailOfItemTemplateItemCostStatus(
  enumOrDetail: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus | undefined,
): ItemTemplateItemCostStatusDetail {
  if (enumOrDetail === undefined) {
    return newItemTemplateItemCostStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ItemTemplateItemCostStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfItemTemplateItemCostStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ItemTemplateItemCostStatusDetail;
  } else {
    return newItemTemplateItemCostStatusDetail({
      code: enumOrDetail as ItemTemplateItemCostStatus,
      name: enumDetailNameOfItemTemplateItemCostStatus[enumOrDetail as ItemTemplateItemCostStatus],
    });
  }
}

function enumOrDetailOrNullOfItemTemplateItemCostStatus(
  enumOrDetail: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus | undefined | null,
): ItemTemplateItemCostStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfItemTemplateItemCostStatus(enumOrDetail);
}

const enumDetailNameOfItemTemplateStatus = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  ARCHIVED: "Archived",
  SYSTEM_DRAFT: "System draft",
};

function enumOrDetailOfItemTemplateStatus(
  enumOrDetail: ItemTemplateStatusDetailOptions | ItemTemplateStatus | undefined,
): ItemTemplateStatusDetail {
  if (enumOrDetail === undefined) {
    return newItemTemplateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ItemTemplateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfItemTemplateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ItemTemplateStatusDetail;
  } else {
    return newItemTemplateStatusDetail({
      code: enumOrDetail as ItemTemplateStatus,
      name: enumDetailNameOfItemTemplateStatus[enumOrDetail as ItemTemplateStatus],
    });
  }
}

function enumOrDetailOrNullOfItemTemplateStatus(
  enumOrDetail: ItemTemplateStatusDetailOptions | ItemTemplateStatus | undefined | null,
): ItemTemplateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfItemTemplateStatus(enumOrDetail);
}

const enumDetailNameOfJobLogFlag = {
  CHANGE_ORDER_DELAY: "Change order delay",
  CLIENT_DELAY: "Client delay",
  CONSULTANT_DELAY: "Consultant delay",
  DESIGN_DELAY: "Design delay",
  GROUND_WET: "Ground wet",
  HEALTH_DELAY: "Health delay",
  MATERIALS_DELAY: "Materials delay",
  QUALITY_CONTROL_DELAY: "Quality control delay",
  TRADE_PARTNER_DELAY: "Trade partner delay",
  WEATHER_DELAY: "Weather delay",
  DELIVERY_DELAY: "Delivery delay",
  INSPECTION_DELAY: "Inspection delay",
  INTERNAL_DELAY: "Internal delay",
};

function enumOrDetailOfJobLogFlag(enumOrDetail: JobLogFlagDetailOptions | JobLogFlag | undefined): JobLogFlagDetail {
  if (enumOrDetail === undefined) {
    return newJobLogFlagDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "JobLogFlagDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfJobLogFlag[enumOrDetail.code!],
      ...enumOrDetail,
    } as JobLogFlagDetail;
  } else {
    return newJobLogFlagDetail({
      code: enumOrDetail as JobLogFlag,
      name: enumDetailNameOfJobLogFlag[enumOrDetail as JobLogFlag],
    });
  }
}

function enumOrDetailOrNullOfJobLogFlag(
  enumOrDetail: JobLogFlagDetailOptions | JobLogFlag | undefined | null,
): JobLogFlagDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfJobLogFlag(enumOrDetail);
}

const enumDetailNameOfLienWaiverCondition = { UNCONDITIONAL: "Unconditional", CONDITIONAL: "Conditional" };

function enumOrDetailOfLienWaiverCondition(
  enumOrDetail: LienWaiverConditionDetailOptions | LienWaiverCondition | undefined,
): LienWaiverConditionDetail {
  if (enumOrDetail === undefined) {
    return newLienWaiverConditionDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LienWaiverConditionDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLienWaiverCondition[enumOrDetail.code!],
      ...enumOrDetail,
    } as LienWaiverConditionDetail;
  } else {
    return newLienWaiverConditionDetail({
      code: enumOrDetail as LienWaiverCondition,
      name: enumDetailNameOfLienWaiverCondition[enumOrDetail as LienWaiverCondition],
    });
  }
}

function enumOrDetailOrNullOfLienWaiverCondition(
  enumOrDetail: LienWaiverConditionDetailOptions | LienWaiverCondition | undefined | null,
): LienWaiverConditionDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLienWaiverCondition(enumOrDetail);
}

const enumDetailNameOfLienWaiverStatus = {
  DRAFT: "Draft",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  PARTIALLY_SIGNED: "Partially signed",
  SIGNED: "Signed",
  PENDING: "Pending",
};

function enumOrDetailOfLienWaiverStatus(
  enumOrDetail: LienWaiverStatusDetailOptions | LienWaiverStatus | undefined,
): LienWaiverStatusDetail {
  if (enumOrDetail === undefined) {
    return newLienWaiverStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LienWaiverStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLienWaiverStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as LienWaiverStatusDetail;
  } else {
    return newLienWaiverStatusDetail({
      code: enumOrDetail as LienWaiverStatus,
      name: enumDetailNameOfLienWaiverStatus[enumOrDetail as LienWaiverStatus],
    });
  }
}

function enumOrDetailOrNullOfLienWaiverStatus(
  enumOrDetail: LienWaiverStatusDetailOptions | LienWaiverStatus | undefined | null,
): LienWaiverStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLienWaiverStatus(enumOrDetail);
}

const enumDetailNameOfLienWaiverType = { PROGRESS: "Progress", FINAL: "Final" };

function enumOrDetailOfLienWaiverType(
  enumOrDetail: LienWaiverTypeDetailOptions | LienWaiverType | undefined,
): LienWaiverTypeDetail {
  if (enumOrDetail === undefined) {
    return newLienWaiverTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LienWaiverTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLienWaiverType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LienWaiverTypeDetail;
  } else {
    return newLienWaiverTypeDetail({
      code: enumOrDetail as LienWaiverType,
      name: enumDetailNameOfLienWaiverType[enumOrDetail as LienWaiverType],
    });
  }
}

function enumOrDetailOrNullOfLienWaiverType(
  enumOrDetail: LienWaiverTypeDetailOptions | LienWaiverType | undefined | null,
): LienWaiverTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLienWaiverType(enumOrDetail);
}

const enumDetailNameOfLocationType = {
  GROUP: "Group",
  LEVEL: "Level",
  ROOM: "Room",
  FEATURE: "Feature",
  SCOPE: "Scope",
};

function enumOrDetailOfLocationType(
  enumOrDetail: LocationTypeDetailOptions | LocationType | undefined,
): LocationTypeDetail {
  if (enumOrDetail === undefined) {
    return newLocationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LocationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLocationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LocationTypeDetail;
  } else {
    return newLocationTypeDetail({
      code: enumOrDetail as LocationType,
      name: enumDetailNameOfLocationType[enumOrDetail as LocationType],
    });
  }
}

function enumOrDetailOrNullOfLocationType(
  enumOrDetail: LocationTypeDetailOptions | LocationType | undefined | null,
): LocationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLocationType(enumOrDetail);
}

const enumDetailNameOfMarkupApplicationMethod = { PER_LINE_ITEM: "Per line item", PER_TOTAL_COST: "Per total cost" };

function enumOrDetailOfMarkupApplicationMethod(
  enumOrDetail: MarkupApplicationMethodDetailOptions | MarkupApplicationMethod | undefined,
): MarkupApplicationMethodDetail {
  if (enumOrDetail === undefined) {
    return newMarkupApplicationMethodDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MarkupApplicationMethodDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMarkupApplicationMethod[enumOrDetail.code!],
      ...enumOrDetail,
    } as MarkupApplicationMethodDetail;
  } else {
    return newMarkupApplicationMethodDetail({
      code: enumOrDetail as MarkupApplicationMethod,
      name: enumDetailNameOfMarkupApplicationMethod[enumOrDetail as MarkupApplicationMethod],
    });
  }
}

function enumOrDetailOrNullOfMarkupApplicationMethod(
  enumOrDetail: MarkupApplicationMethodDetailOptions | MarkupApplicationMethod | undefined | null,
): MarkupApplicationMethodDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMarkupApplicationMethod(enumOrDetail);
}

const enumDetailNameOfMaterialAttributeDimensionType = { NUMBER: "Number", SELECT: "Select", BOOLEAN: "Boolean" };

function enumOrDetailOfMaterialAttributeDimensionType(
  enumOrDetail: MaterialAttributeDimensionTypeDetailOptions | MaterialAttributeDimensionType | undefined,
): MaterialAttributeDimensionTypeDetail {
  if (enumOrDetail === undefined) {
    return newMaterialAttributeDimensionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MaterialAttributeDimensionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMaterialAttributeDimensionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MaterialAttributeDimensionTypeDetail;
  } else {
    return newMaterialAttributeDimensionTypeDetail({
      code: enumOrDetail as MaterialAttributeDimensionType,
      name: enumDetailNameOfMaterialAttributeDimensionType[enumOrDetail as MaterialAttributeDimensionType],
    });
  }
}

function enumOrDetailOrNullOfMaterialAttributeDimensionType(
  enumOrDetail: MaterialAttributeDimensionTypeDetailOptions | MaterialAttributeDimensionType | undefined | null,
): MaterialAttributeDimensionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMaterialAttributeDimensionType(enumOrDetail);
}

const enumDetailNameOfMaterialAttributeValueType = {
  EXACT: "Exact",
  GREATER_THAN: "Greater than",
  LESS_THAN: "Less than",
  BETWEEN: "Between",
};

function enumOrDetailOfMaterialAttributeValueType(
  enumOrDetail: MaterialAttributeValueTypeDetailOptions | MaterialAttributeValueType | undefined,
): MaterialAttributeValueTypeDetail {
  if (enumOrDetail === undefined) {
    return newMaterialAttributeValueTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MaterialAttributeValueTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMaterialAttributeValueType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MaterialAttributeValueTypeDetail;
  } else {
    return newMaterialAttributeValueTypeDetail({
      code: enumOrDetail as MaterialAttributeValueType,
      name: enumDetailNameOfMaterialAttributeValueType[enumOrDetail as MaterialAttributeValueType],
    });
  }
}

function enumOrDetailOrNullOfMaterialAttributeValueType(
  enumOrDetail: MaterialAttributeValueTypeDetailOptions | MaterialAttributeValueType | undefined | null,
): MaterialAttributeValueTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMaterialAttributeValueType(enumOrDetail);
}

const enumDetailNameOfMaterialType = { PLACEHOLDER: "Placeholder", PRODUCT: "Product", CONSTRUCTION: "Construction" };

function enumOrDetailOfMaterialType(
  enumOrDetail: MaterialTypeDetailOptions | MaterialType | undefined,
): MaterialTypeDetail {
  if (enumOrDetail === undefined) {
    return newMaterialTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MaterialTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMaterialType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MaterialTypeDetail;
  } else {
    return newMaterialTypeDetail({
      code: enumOrDetail as MaterialType,
      name: enumDetailNameOfMaterialType[enumOrDetail as MaterialType],
    });
  }
}

function enumOrDetailOrNullOfMaterialType(
  enumOrDetail: MaterialTypeDetailOptions | MaterialType | undefined | null,
): MaterialTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMaterialType(enumOrDetail);
}

const enumDetailNameOfMobileSyncUpdateType = { CREATED: "Created", UPDATED: "Updated", DELETED: "Deleted" };

function enumOrDetailOfMobileSyncUpdateType(
  enumOrDetail: MobileSyncUpdateTypeDetailOptions | MobileSyncUpdateType | undefined,
): MobileSyncUpdateTypeDetail {
  if (enumOrDetail === undefined) {
    return newMobileSyncUpdateTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MobileSyncUpdateTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMobileSyncUpdateType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MobileSyncUpdateTypeDetail;
  } else {
    return newMobileSyncUpdateTypeDetail({
      code: enumOrDetail as MobileSyncUpdateType,
      name: enumDetailNameOfMobileSyncUpdateType[enumOrDetail as MobileSyncUpdateType],
    });
  }
}

function enumOrDetailOrNullOfMobileSyncUpdateType(
  enumOrDetail: MobileSyncUpdateTypeDetailOptions | MobileSyncUpdateType | undefined | null,
): MobileSyncUpdateTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMobileSyncUpdateType(enumOrDetail);
}

const enumDetailNameOfPandaDocRole = {
  USER: "User",
  TRADE_PARTNER: "Trade partner",
  HEAD_OF_CONSTRUCTION: "Head of construction",
  PROJECT_MANAGER: "Project manager",
  HOMEBOUND_AUTHORIZED_SIGNATORY: "Homebound authorized signatory",
  AREA_MANAGER: "Area manager",
  LEAD_ESTIMATOR: "Lead estimator",
  HOMEOWNER: "Homeowner",
  SIGNATORY: "Signatory",
};

function enumOrDetailOfPandaDocRole(
  enumOrDetail: PandaDocRoleDetailOptions | PandaDocRole | undefined,
): PandaDocRoleDetail {
  if (enumOrDetail === undefined) {
    return newPandaDocRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PandaDocRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPandaDocRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as PandaDocRoleDetail;
  } else {
    return newPandaDocRoleDetail({
      code: enumOrDetail as PandaDocRole,
      name: enumDetailNameOfPandaDocRole[enumOrDetail as PandaDocRole],
    });
  }
}

function enumOrDetailOrNullOfPandaDocRole(
  enumOrDetail: PandaDocRoleDetailOptions | PandaDocRole | undefined | null,
): PandaDocRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPandaDocRole(enumOrDetail);
}

const enumDetailNameOfPandaDocStatus = {
  PENDING: "Pending",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  VIEWED: "Viewed",
  WAITING_APPROVAL: "Waiting approval",
  REJECTED: "Rejected",
  APPROVED: "Approved",
  WAITING_PAY: "Waiting pay",
  PAID: "Paid",
  COMPLETED: "Completed",
  VOIDED: "Voided",
  DECLINED: "Declined",
  AWAITING_DELETE: "Awaiting delete",
  UPLOAD_FAILED: "Upload failed",
  PARTIALLY_SIGNED: "Partially signed",
  DRAFT: "Draft",
};

function enumOrDetailOfPandaDocStatus(
  enumOrDetail: PandaDocStatusDetailOptions | PandaDocStatus | undefined,
): PandaDocStatusDetail {
  if (enumOrDetail === undefined) {
    return newPandaDocStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PandaDocStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPandaDocStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as PandaDocStatusDetail;
  } else {
    return newPandaDocStatusDetail({
      code: enumOrDetail as PandaDocStatus,
      name: enumDetailNameOfPandaDocStatus[enumOrDetail as PandaDocStatus],
    });
  }
}

function enumOrDetailOrNullOfPandaDocStatus(
  enumOrDetail: PandaDocStatusDetailOptions | PandaDocStatus | undefined | null,
): PandaDocStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPandaDocStatus(enumOrDetail);
}

const enumDetailNameOfPandaDocWorkspace = {
  HOMEBOUND: "Homebound",
  HOMEBOUND_FINANCE: "Homebound finance",
  HOMEBOUND_CALIFORNIA: "Homebound california",
};

function enumOrDetailOfPandaDocWorkspace(
  enumOrDetail: PandaDocWorkspaceDetailOptions | PandaDocWorkspace | undefined,
): PandaDocWorkspaceDetail {
  if (enumOrDetail === undefined) {
    return newPandaDocWorkspaceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PandaDocWorkspaceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPandaDocWorkspace[enumOrDetail.code!],
      ...enumOrDetail,
    } as PandaDocWorkspaceDetail;
  } else {
    return newPandaDocWorkspaceDetail({
      code: enumOrDetail as PandaDocWorkspace,
      name: enumDetailNameOfPandaDocWorkspace[enumOrDetail as PandaDocWorkspace],
    });
  }
}

function enumOrDetailOrNullOfPandaDocWorkspace(
  enumOrDetail: PandaDocWorkspaceDetailOptions | PandaDocWorkspace | undefined | null,
): PandaDocWorkspaceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPandaDocWorkspace(enumOrDetail);
}

const enumDetailNameOfPaymentTermDueFrom = {
  FROM_INVOICE_BILL_DATE: "From invoice bill date",
  OF_THE_MONTH_OF_INVOICE_BILL_DATE: "Of the month of invoice bill date",
  OF_NEXT_MONTH_FROM_INVOICE_BILL_DATE: "Of next month from invoice bill date",
  OF_2ND_MONTH_FROM_INVOICE_BILL_DATE: "Of 2 nd month from invoice bill date",
  OF_3RD_MONTH_FROM_INVOICE_BILL_DATE: "Of 3 rd month from invoice bill date",
  OF_4TH_MONTH_FROM_INVOICE_BILL_DATE: "Of 4 th month from invoice bill date",
  OF_5TH_MONTH_FROM_INVOICE_BILL_DATE: "Of 5 th month from invoice bill date",
  OF_6TH_MONTH_FROM_INVOICE_BILL_DATE: "Of 6 th month from invoice bill date",
};

function enumOrDetailOfPaymentTermDueFrom(
  enumOrDetail: PaymentTermDueFromDetailOptions | PaymentTermDueFrom | undefined,
): PaymentTermDueFromDetail {
  if (enumOrDetail === undefined) {
    return newPaymentTermDueFromDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PaymentTermDueFromDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPaymentTermDueFrom[enumOrDetail.code!],
      ...enumOrDetail,
    } as PaymentTermDueFromDetail;
  } else {
    return newPaymentTermDueFromDetail({
      code: enumOrDetail as PaymentTermDueFrom,
      name: enumDetailNameOfPaymentTermDueFrom[enumOrDetail as PaymentTermDueFrom],
    });
  }
}

function enumOrDetailOrNullOfPaymentTermDueFrom(
  enumOrDetail: PaymentTermDueFromDetailOptions | PaymentTermDueFrom | undefined | null,
): PaymentTermDueFromDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPaymentTermDueFrom(enumOrDetail);
}

const enumDetailNameOfPermit = {
  ZONING: "Zoning",
  STRUCTURAL: "Structural",
  ELECTRICAL: "Electrical",
  PLUMBING: "Plumbing",
  HVAC: "Hvac",
};

function enumOrDetailOfPermit(enumOrDetail: PermitDetailOptions | Permit | undefined): PermitDetail {
  if (enumOrDetail === undefined) {
    return newPermitDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PermitDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPermit[enumOrDetail.code!],
      ...enumOrDetail,
    } as PermitDetail;
  } else {
    return newPermitDetail({ code: enumOrDetail as Permit, name: enumDetailNameOfPermit[enumOrDetail as Permit] });
  }
}

function enumOrDetailOrNullOfPermit(
  enumOrDetail: PermitDetailOptions | Permit | undefined | null,
): PermitDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPermit(enumOrDetail);
}

const enumDetailNameOfPlanPackageIncomingSlotStatus = {
  PENDING: "Pending",
  REJECTED: "Rejected",
  FULFILLED: "Fulfilled",
};

function enumOrDetailOfPlanPackageIncomingSlotStatus(
  enumOrDetail: PlanPackageIncomingSlotStatusDetailOptions | PlanPackageIncomingSlotStatus | undefined,
): PlanPackageIncomingSlotStatusDetail {
  if (enumOrDetail === undefined) {
    return newPlanPackageIncomingSlotStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PlanPackageIncomingSlotStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPlanPackageIncomingSlotStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as PlanPackageIncomingSlotStatusDetail;
  } else {
    return newPlanPackageIncomingSlotStatusDetail({
      code: enumOrDetail as PlanPackageIncomingSlotStatus,
      name: enumDetailNameOfPlanPackageIncomingSlotStatus[enumOrDetail as PlanPackageIncomingSlotStatus],
    });
  }
}

function enumOrDetailOrNullOfPlanPackageIncomingSlotStatus(
  enumOrDetail: PlanPackageIncomingSlotStatusDetailOptions | PlanPackageIncomingSlotStatus | undefined | null,
): PlanPackageIncomingSlotStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPlanPackageIncomingSlotStatus(enumOrDetail);
}

const enumDetailNameOfProductOfferingStartingConfigType = { CHECKOUT: "Checkout", UNDERWRITING: "Underwriting" };

function enumOrDetailOfProductOfferingStartingConfigType(
  enumOrDetail: ProductOfferingStartingConfigTypeDetailOptions | ProductOfferingStartingConfigType | undefined,
): ProductOfferingStartingConfigTypeDetail {
  if (enumOrDetail === undefined) {
    return newProductOfferingStartingConfigTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProductOfferingStartingConfigTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProductOfferingStartingConfigType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProductOfferingStartingConfigTypeDetail;
  } else {
    return newProductOfferingStartingConfigTypeDetail({
      code: enumOrDetail as ProductOfferingStartingConfigType,
      name: enumDetailNameOfProductOfferingStartingConfigType[enumOrDetail as ProductOfferingStartingConfigType],
    });
  }
}

function enumOrDetailOrNullOfProductOfferingStartingConfigType(
  enumOrDetail: ProductOfferingStartingConfigTypeDetailOptions | ProductOfferingStartingConfigType | undefined | null,
): ProductOfferingStartingConfigTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProductOfferingStartingConfigType(enumOrDetail);
}

const enumDetailNameOfProgramDataBasementConfig = {
  NO: "No",
  PARTIAL_UNFINISHED: "Partial unfinished",
  FULL_FINISHED: "Full finished",
  FULL_UNFINISHED: "Full unfinished",
  WALKOUT_UNFINISHED: "Walkout unfinished",
  WALKOUT_FINISHED: "Walkout finished",
  GARDEN_LEVEL_UNFINISHED: "Garden level unfinished",
  GARDEN_LEVEL_FINISHED: "Garden level finished",
};

function enumOrDetailOfProgramDataBasementConfig(
  enumOrDetail: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | undefined,
): ProgramDataBasementConfigDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataBasementConfigDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataBasementConfigDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataBasementConfig[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataBasementConfigDetail;
  } else {
    return newProgramDataBasementConfigDetail({
      code: enumOrDetail as ProgramDataBasementConfig,
      name: enumDetailNameOfProgramDataBasementConfig[enumOrDetail as ProgramDataBasementConfig],
    });
  }
}

function enumOrDetailOrNullOfProgramDataBasementConfig(
  enumOrDetail: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | undefined | null,
): ProgramDataBasementConfigDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataBasementConfig(enumOrDetail);
}

const enumDetailNameOfProgramDataGarageConfig = {
  FRONT_LOAD: "Front load",
  ALLEY_LOAD: "Alley load",
  SIDE_LOAD: "Side load",
  SPLIT_LOAD: "Split load",
};

function enumOrDetailOfProgramDataGarageConfig(
  enumOrDetail: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | undefined,
): ProgramDataGarageConfigDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataGarageConfigDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataGarageConfigDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataGarageConfig[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataGarageConfigDetail;
  } else {
    return newProgramDataGarageConfigDetail({
      code: enumOrDetail as ProgramDataGarageConfig,
      name: enumDetailNameOfProgramDataGarageConfig[enumOrDetail as ProgramDataGarageConfig],
    });
  }
}

function enumOrDetailOrNullOfProgramDataGarageConfig(
  enumOrDetail: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | undefined | null,
): ProgramDataGarageConfigDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataGarageConfig(enumOrDetail);
}

const enumDetailNameOfProgramDataMatchState = {
  MATCHES: "Matches",
  DEVIATION_PENDING_REVIEW: "Deviation pending review",
  DEVIATION_ACKNOWLEDGED: "Deviation acknowledged",
};

function enumOrDetailOfProgramDataMatchState(
  enumOrDetail: ProgramDataMatchStateDetailOptions | ProgramDataMatchState | undefined,
): ProgramDataMatchStateDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataMatchStateDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataMatchStateDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataMatchState[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataMatchStateDetail;
  } else {
    return newProgramDataMatchStateDetail({
      code: enumOrDetail as ProgramDataMatchState,
      name: enumDetailNameOfProgramDataMatchState[enumOrDetail as ProgramDataMatchState],
    });
  }
}

function enumOrDetailOrNullOfProgramDataMatchState(
  enumOrDetail: ProgramDataMatchStateDetailOptions | ProgramDataMatchState | undefined | null,
): ProgramDataMatchStateDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataMatchState(enumOrDetail);
}

const enumDetailNameOfProgramDataPrimaryBedroomConfig = { UP: "Up", DOWN: "Down" };

function enumOrDetailOfProgramDataPrimaryBedroomConfig(
  enumOrDetail: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | undefined,
): ProgramDataPrimaryBedroomConfigDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataPrimaryBedroomConfigDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataPrimaryBedroomConfigDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataPrimaryBedroomConfig[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataPrimaryBedroomConfigDetail;
  } else {
    return newProgramDataPrimaryBedroomConfigDetail({
      code: enumOrDetail as ProgramDataPrimaryBedroomConfig,
      name: enumDetailNameOfProgramDataPrimaryBedroomConfig[enumOrDetail as ProgramDataPrimaryBedroomConfig],
    });
  }
}

function enumOrDetailOrNullOfProgramDataPrimaryBedroomConfig(
  enumOrDetail: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | undefined | null,
): ProgramDataPrimaryBedroomConfigDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataPrimaryBedroomConfig(enumOrDetail);
}

const enumDetailNameOfProgramDataWindowColor = { WHITE: "White", BLACK: "Black" };

function enumOrDetailOfProgramDataWindowColor(
  enumOrDetail: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | undefined,
): ProgramDataWindowColorDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataWindowColorDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataWindowColorDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataWindowColor[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataWindowColorDetail;
  } else {
    return newProgramDataWindowColorDetail({
      code: enumOrDetail as ProgramDataWindowColor,
      name: enumDetailNameOfProgramDataWindowColor[enumOrDetail as ProgramDataWindowColor],
    });
  }
}

function enumOrDetailOrNullOfProgramDataWindowColor(
  enumOrDetail: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | undefined | null,
): ProgramDataWindowColorDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataWindowColor(enumOrDetail);
}

const enumDetailNameOfProjectCollaboratorRole = {
  HOMEOWNER: "Homeowner",
  FAMILY: "Family",
  DESIGNER: "Designer",
  LEGAL: "Legal",
  OTHER: "Other",
};

function enumOrDetailOfProjectCollaboratorRole(
  enumOrDetail: ProjectCollaboratorRoleDetailOptions | ProjectCollaboratorRole | undefined,
): ProjectCollaboratorRoleDetail {
  if (enumOrDetail === undefined) {
    return newProjectCollaboratorRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectCollaboratorRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectCollaboratorRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectCollaboratorRoleDetail;
  } else {
    return newProjectCollaboratorRoleDetail({
      code: enumOrDetail as ProjectCollaboratorRole,
      name: enumDetailNameOfProjectCollaboratorRole[enumOrDetail as ProjectCollaboratorRole],
    });
  }
}

function enumOrDetailOrNullOfProjectCollaboratorRole(
  enumOrDetail: ProjectCollaboratorRoleDetailOptions | ProjectCollaboratorRole | undefined | null,
): ProjectCollaboratorRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectCollaboratorRole(enumOrDetail);
}

const enumDetailNameOfProjectFeature = {
  SELECTIONS_V1: "Selections v1",
  HOP_HIDE_FINANCIALS: "Hop hide financials",
  HOP_VIZ_WALKTHROUGH: "Hop viz walkthrough",
  BP_PROJECT_SETTINGS: "Bp project settings",
  HIDE_ALL_HOP_PRICING: "Hide all hop pricing",
  HOP_PRICING_MSRP_NO_HB: "Hop pricing msrp no hb",
  HOP_PRICING_HB_NO_MSRP: "Hop pricing hb no msrp",
  HOP_SELECTIONS_INCLUDED_UPGRADE_PRICING: "Hop selections included upgrade pricing",
  SCHEDULES_V2: "Schedules v2",
  SCHEDULES_V2_GANTT: "Schedules v2 gantt",
  SCHEDULES_CALENDAR: "Schedules calendar",
  HOP_HIDE_PRECON_FINANCIALS: "Hop hide precon financials",
  DELAY_FLAGS: "Delay flags",
  HOMEOWNER_NOTES: "Homeowner notes",
  HOMEOWNER_JOURNEY_V2: "Homeowner journey v2",
  PRODUCT_CONFIG_PLAN: "Product config plan",
  CHANGE_EVENT_SIGNATURES: "Change event signatures",
};

function enumOrDetailOfProjectFeature(
  enumOrDetail: ProjectFeatureDetailOptions | ProjectFeature | undefined,
): ProjectFeatureDetail {
  if (enumOrDetail === undefined) {
    return newProjectFeatureDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectFeatureDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectFeature[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectFeatureDetail;
  } else {
    return newProjectFeatureDetail({
      code: enumOrDetail as ProjectFeature,
      name: enumDetailNameOfProjectFeature[enumOrDetail as ProjectFeature],
    });
  }
}

function enumOrDetailOrNullOfProjectFeature(
  enumOrDetail: ProjectFeatureDetailOptions | ProjectFeature | undefined | null,
): ProjectFeatureDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectFeature(enumOrDetail);
}

const enumDetailNameOfProjectUpdateActionType = {
  ACTIVITY_COMPLETE: "Activity complete",
  UNIT_COMPLETE: "Unit complete",
  DOCUMENT_AVAILABLE: "Document available",
  NEW_HOMEOWNER_NOTE: "New homeowner note",
};

function enumOrDetailOfProjectUpdateActionType(
  enumOrDetail: ProjectUpdateActionTypeDetailOptions | ProjectUpdateActionType | undefined,
): ProjectUpdateActionTypeDetail {
  if (enumOrDetail === undefined) {
    return newProjectUpdateActionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectUpdateActionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectUpdateActionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectUpdateActionTypeDetail;
  } else {
    return newProjectUpdateActionTypeDetail({
      code: enumOrDetail as ProjectUpdateActionType,
      name: enumDetailNameOfProjectUpdateActionType[enumOrDetail as ProjectUpdateActionType],
    });
  }
}

function enumOrDetailOrNullOfProjectUpdateActionType(
  enumOrDetail: ProjectUpdateActionTypeDetailOptions | ProjectUpdateActionType | undefined | null,
): ProjectUpdateActionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectUpdateActionType(enumOrDetail);
}

const enumDetailNameOfPushNotificationEnvironment = { SANDBOX: "Sandbox", PRODUCTION: "Production" };

function enumOrDetailOfPushNotificationEnvironment(
  enumOrDetail: PushNotificationEnvironmentDetailOptions | PushNotificationEnvironment | undefined,
): PushNotificationEnvironmentDetail {
  if (enumOrDetail === undefined) {
    return newPushNotificationEnvironmentDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PushNotificationEnvironmentDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPushNotificationEnvironment[enumOrDetail.code!],
      ...enumOrDetail,
    } as PushNotificationEnvironmentDetail;
  } else {
    return newPushNotificationEnvironmentDetail({
      code: enumOrDetail as PushNotificationEnvironment,
      name: enumDetailNameOfPushNotificationEnvironment[enumOrDetail as PushNotificationEnvironment],
    });
  }
}

function enumOrDetailOrNullOfPushNotificationEnvironment(
  enumOrDetail: PushNotificationEnvironmentDetailOptions | PushNotificationEnvironment | undefined | null,
): PushNotificationEnvironmentDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPushNotificationEnvironment(enumOrDetail);
}

const enumDetailNameOfPushNotificationPlatform = { IOS: "Ios", ANDROID: "Android", WEB: "Web" };

function enumOrDetailOfPushNotificationPlatform(
  enumOrDetail: PushNotificationPlatformDetailOptions | PushNotificationPlatform | undefined,
): PushNotificationPlatformDetail {
  if (enumOrDetail === undefined) {
    return newPushNotificationPlatformDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PushNotificationPlatformDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPushNotificationPlatform[enumOrDetail.code!],
      ...enumOrDetail,
    } as PushNotificationPlatformDetail;
  } else {
    return newPushNotificationPlatformDetail({
      code: enumOrDetail as PushNotificationPlatform,
      name: enumDetailNameOfPushNotificationPlatform[enumOrDetail as PushNotificationPlatform],
    });
  }
}

function enumOrDetailOrNullOfPushNotificationPlatform(
  enumOrDetail: PushNotificationPlatformDetailOptions | PushNotificationPlatform | undefined | null,
): PushNotificationPlatformDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPushNotificationPlatform(enumOrDetail);
}

const enumDetailNameOfReadyPlanAssetType = {
  COVER_PHOTO: "Cover photo",
  PREVIEW: "Preview",
  FLOOR_PLAN: "Floor plan",
  MOOD_BOARD: "Mood board",
  GROUND_BASEMENT_FLOOR_PLAN: "Ground basement floor plan",
  FIRST_FLOOR_PLAN: "First floor plan",
  SECOND_FLOOR_PLAN: "Second floor plan",
  ADU_FIRST_FLOOR_PLAN: "Adu first floor plan",
  ADU_SECOND_FLOOR_PLAN: "Adu second floor plan",
  ADU_EXTERIOR: "Adu exterior",
  ADU_KITCHEN: "Adu kitchen",
  ADU_LIVING: "Adu living",
  ADU_BATHROOM: "Adu bathroom",
  ADU_BEDROOM: "Adu bedroom",
};

function enumOrDetailOfReadyPlanAssetType(
  enumOrDetail: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType | undefined,
): ReadyPlanAssetTypeDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanAssetTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanAssetTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanAssetType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanAssetTypeDetail;
  } else {
    return newReadyPlanAssetTypeDetail({
      code: enumOrDetail as ReadyPlanAssetType,
      name: enumDetailNameOfReadyPlanAssetType[enumOrDetail as ReadyPlanAssetType],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanAssetType(
  enumOrDetail: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType | undefined | null,
): ReadyPlanAssetTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanAssetType(enumOrDetail);
}

const enumDetailNameOfReadyPlanOptionGroupPersonalizationType = {
  SINGLE_PRODUCT: "Single product",
  LINKED_PRODUCT: "Linked product",
  PACKAGE: "Package",
};

function enumOrDetailOfReadyPlanOptionGroupPersonalizationType(
  enumOrDetail:
    | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
    | ReadyPlanOptionGroupPersonalizationType
    | undefined,
): ReadyPlanOptionGroupPersonalizationTypeDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanOptionGroupPersonalizationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanOptionGroupPersonalizationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanOptionGroupPersonalizationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanOptionGroupPersonalizationTypeDetail;
  } else {
    return newReadyPlanOptionGroupPersonalizationTypeDetail({
      code: enumOrDetail as ReadyPlanOptionGroupPersonalizationType,
      name:
        enumDetailNameOfReadyPlanOptionGroupPersonalizationType[
          enumOrDetail as ReadyPlanOptionGroupPersonalizationType
        ],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanOptionGroupPersonalizationType(
  enumOrDetail:
    | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
    | ReadyPlanOptionGroupPersonalizationType
    | undefined
    | null,
): ReadyPlanOptionGroupPersonalizationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanOptionGroupPersonalizationType(enumOrDetail);
}

const enumDetailNameOfScheduleFlagReasonType = {
  CLIENT: "Client",
  INTERNAL: "Internal",
  EXTERNAL: "External",
  PERMITTING: "Permitting",
  FIELD: "Field",
  INSPECTION: "Inspection",
  MATERIAL_SUPPLY: "Material supply",
  OTHER: "Other",
  TRADE_PARTNER: "Trade partner",
  WEATHER: "Weather",
};

function enumOrDetailOfScheduleFlagReasonType(
  enumOrDetail: ScheduleFlagReasonTypeDetailOptions | ScheduleFlagReasonType | undefined,
): ScheduleFlagReasonTypeDetail {
  if (enumOrDetail === undefined) {
    return newScheduleFlagReasonTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScheduleFlagReasonTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScheduleFlagReasonType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScheduleFlagReasonTypeDetail;
  } else {
    return newScheduleFlagReasonTypeDetail({
      code: enumOrDetail as ScheduleFlagReasonType,
      name: enumDetailNameOfScheduleFlagReasonType[enumOrDetail as ScheduleFlagReasonType],
    });
  }
}

function enumOrDetailOrNullOfScheduleFlagReasonType(
  enumOrDetail: ScheduleFlagReasonTypeDetailOptions | ScheduleFlagReasonType | undefined | null,
): ScheduleFlagReasonTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScheduleFlagReasonType(enumOrDetail);
}

const enumDetailNameOfScheduleStatus = { ACTIVE: "Active", COMPLETED: "Completed", DRAFT: "Draft" };

function enumOrDetailOfScheduleStatus(
  enumOrDetail: ScheduleStatusDetailOptions | ScheduleStatus | undefined,
): ScheduleStatusDetail {
  if (enumOrDetail === undefined) {
    return newScheduleStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScheduleStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScheduleStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScheduleStatusDetail;
  } else {
    return newScheduleStatusDetail({
      code: enumOrDetail as ScheduleStatus,
      name: enumDetailNameOfScheduleStatus[enumOrDetail as ScheduleStatus],
    });
  }
}

function enumOrDetailOrNullOfScheduleStatus(
  enumOrDetail: ScheduleStatusDetailOptions | ScheduleStatus | undefined | null,
): ScheduleStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScheduleStatus(enumOrDetail);
}

const enumDetailNameOfScheduleTemplateStatus = { DRAFT: "Draft", PUBLISHED: "Published", ARCHIVED: "Archived" };

function enumOrDetailOfScheduleTemplateStatus(
  enumOrDetail: ScheduleTemplateStatusDetailOptions | ScheduleTemplateStatus | undefined,
): ScheduleTemplateStatusDetail {
  if (enumOrDetail === undefined) {
    return newScheduleTemplateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScheduleTemplateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScheduleTemplateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScheduleTemplateStatusDetail;
  } else {
    return newScheduleTemplateStatusDetail({
      code: enumOrDetail as ScheduleTemplateStatus,
      name: enumDetailNameOfScheduleTemplateStatus[enumOrDetail as ScheduleTemplateStatus],
    });
  }
}

function enumOrDetailOrNullOfScheduleTemplateStatus(
  enumOrDetail: ScheduleTemplateStatusDetailOptions | ScheduleTemplateStatus | undefined | null,
): ScheduleTemplateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScheduleTemplateStatus(enumOrDetail);
}

const enumDetailNameOfSystemPlanMilestone = {
  MOBILIZATION_START: "Mobilization start",
  VERTICAL_COMPLETE: "Vertical complete",
  PRE_MOBILIZATION_COMPLETE: "Pre mobilization complete",
  CUSTOMER_CONTRACT_SIGNED: "Customer contract signed",
  BUILDING_PERMIT_ISSUED: "Building permit issued",
  FINAL_PUNCH_OUT: "Final punch out",
  MOBILIZATION_COMPLETE: "Mobilization complete",
  DELIVERY_COMPLETE: "Delivery complete",
  BUILDING_PERMIT_SUBMITTED: "Building permit submitted",
  FRAMING_COMPLETE: "Framing complete",
  DRYWALL_COMPLETE: "Drywall complete",
  SALES_READY: "Sales ready",
  BUYER_WALKTHROUGH: "Buyer walkthrough",
  PRECON_READY_TO_START: "Precon ready to start",
};

function enumOrDetailOfSystemPlanMilestone(
  enumOrDetail: SystemPlanMilestoneDetailOptions | SystemPlanMilestone | undefined,
): SystemPlanMilestoneDetail {
  if (enumOrDetail === undefined) {
    return newSystemPlanMilestoneDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SystemPlanMilestoneDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSystemPlanMilestone[enumOrDetail.code!],
      ...enumOrDetail,
    } as SystemPlanMilestoneDetail;
  } else {
    return newSystemPlanMilestoneDetail({
      code: enumOrDetail as SystemPlanMilestone,
      name: enumDetailNameOfSystemPlanMilestone[enumOrDetail as SystemPlanMilestone],
    });
  }
}

function enumOrDetailOrNullOfSystemPlanMilestone(
  enumOrDetail: SystemPlanMilestoneDetailOptions | SystemPlanMilestone | undefined | null,
): SystemPlanMilestoneDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSystemPlanMilestone(enumOrDetail);
}

const enumDetailNameOfSystemTask = {
  CONSTRUCTION_RTS: "Construction rts",
  FRAMING_COMPLETE: "Framing complete",
  DRYWALL_COMPLETE: "Drywall complete",
  DELIVERY_COMPLETE: "Delivery complete",
  VERTICAL_COMPLETE: "Vertical complete",
  ACQUIRED: "Acquired",
  PERMIT_SUBMITTED: "Permit submitted",
  PERMIT_RECEIVED: "Permit received",
  MLS_DATE: "Mls date",
  SALES_READY: "Sales ready",
  BUYER_WALKTHROUGH: "Buyer walkthrough",
  PUNCH_LIST: "Punch list",
  BUILDING_FINAL_INSPECTION: "Building final inspection",
};

function enumOrDetailOfSystemTask(enumOrDetail: SystemTaskDetailOptions | SystemTask | undefined): SystemTaskDetail {
  if (enumOrDetail === undefined) {
    return newSystemTaskDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SystemTaskDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSystemTask[enumOrDetail.code!],
      ...enumOrDetail,
    } as SystemTaskDetail;
  } else {
    return newSystemTaskDetail({
      code: enumOrDetail as SystemTask,
      name: enumDetailNameOfSystemTask[enumOrDetail as SystemTask],
    });
  }
}

function enumOrDetailOrNullOfSystemTask(
  enumOrDetail: SystemTaskDetailOptions | SystemTask | undefined | null,
): SystemTaskDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSystemTask(enumOrDetail);
}

const enumDetailNameOfTakeoffLineItemAction = { ADD: "Add", REMOVE: "Remove" };

function enumOrDetailOfTakeoffLineItemAction(
  enumOrDetail: TakeoffLineItemActionDetailOptions | TakeoffLineItemAction | undefined,
): TakeoffLineItemActionDetail {
  if (enumOrDetail === undefined) {
    return newTakeoffLineItemActionDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TakeoffLineItemActionDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTakeoffLineItemAction[enumOrDetail.code!],
      ...enumOrDetail,
    } as TakeoffLineItemActionDetail;
  } else {
    return newTakeoffLineItemActionDetail({
      code: enumOrDetail as TakeoffLineItemAction,
      name: enumDetailNameOfTakeoffLineItemAction[enumOrDetail as TakeoffLineItemAction],
    });
  }
}

function enumOrDetailOrNullOfTakeoffLineItemAction(
  enumOrDetail: TakeoffLineItemActionDetailOptions | TakeoffLineItemAction | undefined | null,
): TakeoffLineItemActionDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTakeoffLineItemAction(enumOrDetail);
}

const enumDetailNameOfTakeoffLineItemDesignPackageType = {
  REGULAR_PLACEHOLDER: "Regular placeholder",
  REGULAR_PRODUCT_CARD: "Regular product card",
  IDP_SHADOW_PLACEHOLDER: "Idp shadow placeholder",
  IDP_SHADOW_PRODUCT_CARD: "Idp shadow product card",
  RPO_SHADOW_PLACEHOLDER: "Rpo shadow placeholder",
  RPO_SHADOW_PRODUCT_CARD: "Rpo shadow product card",
};

function enumOrDetailOfTakeoffLineItemDesignPackageType(
  enumOrDetail: TakeoffLineItemDesignPackageTypeDetailOptions | TakeoffLineItemDesignPackageType | undefined,
): TakeoffLineItemDesignPackageTypeDetail {
  if (enumOrDetail === undefined) {
    return newTakeoffLineItemDesignPackageTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TakeoffLineItemDesignPackageTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTakeoffLineItemDesignPackageType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TakeoffLineItemDesignPackageTypeDetail;
  } else {
    return newTakeoffLineItemDesignPackageTypeDetail({
      code: enumOrDetail as TakeoffLineItemDesignPackageType,
      name: enumDetailNameOfTakeoffLineItemDesignPackageType[enumOrDetail as TakeoffLineItemDesignPackageType],
    });
  }
}

function enumOrDetailOrNullOfTakeoffLineItemDesignPackageType(
  enumOrDetail: TakeoffLineItemDesignPackageTypeDetailOptions | TakeoffLineItemDesignPackageType | undefined | null,
): TakeoffLineItemDesignPackageTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTakeoffLineItemDesignPackageType(enumOrDetail);
}

const enumDetailNameOfTakeoffLineItemType = { ITI: "Iti", TLIV: "Tliv", PCI: "Pci" };

function enumOrDetailOfTakeoffLineItemType(
  enumOrDetail: TakeoffLineItemTypeDetailOptions | TakeoffLineItemType | undefined,
): TakeoffLineItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newTakeoffLineItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TakeoffLineItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTakeoffLineItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TakeoffLineItemTypeDetail;
  } else {
    return newTakeoffLineItemTypeDetail({
      code: enumOrDetail as TakeoffLineItemType,
      name: enumDetailNameOfTakeoffLineItemType[enumOrDetail as TakeoffLineItemType],
    });
  }
}

function enumOrDetailOrNullOfTakeoffLineItemType(
  enumOrDetail: TakeoffLineItemTypeDetailOptions | TakeoffLineItemType | undefined | null,
): TakeoffLineItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTakeoffLineItemType(enumOrDetail);
}

const enumDetailNameOfTaskDependencyType = {
  FINISH_START: "Finish start",
  START_START: "Start start",
  START_FINISH: "Start finish",
  FINISH_FINISH: "Finish finish",
};

function enumOrDetailOfTaskDependencyType(
  enumOrDetail: TaskDependencyTypeDetailOptions | TaskDependencyType | undefined,
): TaskDependencyTypeDetail {
  if (enumOrDetail === undefined) {
    return newTaskDependencyTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskDependencyTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskDependencyType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskDependencyTypeDetail;
  } else {
    return newTaskDependencyTypeDetail({
      code: enumOrDetail as TaskDependencyType,
      name: enumDetailNameOfTaskDependencyType[enumOrDetail as TaskDependencyType],
    });
  }
}

function enumOrDetailOrNullOfTaskDependencyType(
  enumOrDetail: TaskDependencyTypeDetailOptions | TaskDependencyType | undefined | null,
): TaskDependencyTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskDependencyType(enumOrDetail);
}

const enumDetailNameOfTimeFrequency = { DAYS: "Days", WEEKS: "Weeks", MONTHS: "Months" };

function enumOrDetailOfTimeFrequency(
  enumOrDetail: TimeFrequencyDetailOptions | TimeFrequency | undefined,
): TimeFrequencyDetail {
  if (enumOrDetail === undefined) {
    return newTimeFrequencyDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TimeFrequencyDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTimeFrequency[enumOrDetail.code!],
      ...enumOrDetail,
    } as TimeFrequencyDetail;
  } else {
    return newTimeFrequencyDetail({
      code: enumOrDetail as TimeFrequency,
      name: enumDetailNameOfTimeFrequency[enumOrDetail as TimeFrequency],
    });
  }
}

function enumOrDetailOrNullOfTimeFrequency(
  enumOrDetail: TimeFrequencyDetailOptions | TimeFrequency | undefined | null,
): TimeFrequencyDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTimeFrequency(enumOrDetail);
}

const enumDetailNameOfTimeOfDay = { MORNING: "Morning", AFTERNOON: "Afternoon", EVENING: "Evening" };

function enumOrDetailOfTimeOfDay(enumOrDetail: TimeOfDayDetailOptions | TimeOfDay | undefined): TimeOfDayDetail {
  if (enumOrDetail === undefined) {
    return newTimeOfDayDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TimeOfDayDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTimeOfDay[enumOrDetail.code!],
      ...enumOrDetail,
    } as TimeOfDayDetail;
  } else {
    return newTimeOfDayDetail({
      code: enumOrDetail as TimeOfDay,
      name: enumDetailNameOfTimeOfDay[enumOrDetail as TimeOfDay],
    });
  }
}

function enumOrDetailOrNullOfTimeOfDay(
  enumOrDetail: TimeOfDayDetailOptions | TimeOfDay | undefined | null,
): TimeOfDayDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTimeOfDay(enumOrDetail);
}

const enumDetailNameOfTrackedJobStatus = {
  PENDING: "Pending",
  RUNNING: "Running",
  COMPLETED: "Completed",
  FAILED: "Failed",
};

function enumOrDetailOfTrackedJobStatus(
  enumOrDetail: TrackedJobStatusDetailOptions | TrackedJobStatus | undefined,
): TrackedJobStatusDetail {
  if (enumOrDetail === undefined) {
    return newTrackedJobStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TrackedJobStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTrackedJobStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TrackedJobStatusDetail;
  } else {
    return newTrackedJobStatusDetail({
      code: enumOrDetail as TrackedJobStatus,
      name: enumDetailNameOfTrackedJobStatus[enumOrDetail as TrackedJobStatus],
    });
  }
}

function enumOrDetailOrNullOfTrackedJobStatus(
  enumOrDetail: TrackedJobStatusDetailOptions | TrackedJobStatus | undefined | null,
): TrackedJobStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTrackedJobStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerMarketRole = {
  BILL_APPROVER: "Bill approver",
  CONTRACT_SIGNATORY: "Contract signatory",
  PO_SIGNATORY: "Po signatory",
  PO_RECIPIENT_1: "Po recipient 1",
  PO_RECIPIENT_2: "Po recipient 2",
  ESTIMATING: "Estimating",
  SCHEDULING: "Scheduling",
  LW_SIGNATORY: "Lw signatory",
  SCHEDULING_RECIPIENT_2: "Scheduling recipient 2",
};

function enumOrDetailOfTradePartnerMarketRole(
  enumOrDetail: TradePartnerMarketRoleDetailOptions | TradePartnerMarketRole | undefined,
): TradePartnerMarketRoleDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerMarketRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerMarketRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerMarketRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerMarketRoleDetail;
  } else {
    return newTradePartnerMarketRoleDetail({
      code: enumOrDetail as TradePartnerMarketRole,
      name: enumDetailNameOfTradePartnerMarketRole[enumOrDetail as TradePartnerMarketRole],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerMarketRole(
  enumOrDetail: TradePartnerMarketRoleDetailOptions | TradePartnerMarketRole | undefined | null,
): TradePartnerMarketRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerMarketRole(enumOrDetail);
}

const enumDetailNameOfTradePartnerRequirementStatus = {
  MEETS: "Meets",
  DOES_NOT_MEET: "Does not meet",
  NA: "Na",
  WAIVER: "Waiver",
};

function enumOrDetailOfTradePartnerRequirementStatus(
  enumOrDetail: TradePartnerRequirementStatusDetailOptions | TradePartnerRequirementStatus | undefined,
): TradePartnerRequirementStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerRequirementStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerRequirementStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerRequirementStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerRequirementStatusDetail;
  } else {
    return newTradePartnerRequirementStatusDetail({
      code: enumOrDetail as TradePartnerRequirementStatus,
      name: enumDetailNameOfTradePartnerRequirementStatus[enumOrDetail as TradePartnerRequirementStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerRequirementStatus(
  enumOrDetail: TradePartnerRequirementStatusDetailOptions | TradePartnerRequirementStatus | undefined | null,
): TradePartnerRequirementStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerRequirementStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerRequirementType = {
  W9: "W9",
  WORKERS_COMP: "Workers comp",
  MSA: "Msa",
  GENERAL_LIABILITY: "General liability",
  PROFESSIONAL_LIABILITY: "Professional liability",
  INDUSTRY_LICENSE: "Industry license",
  AUTOMOBILE_LIABILITY: "Automobile liability",
  UMBRELLA_LIABILITY: "Umbrella liability",
  TRADE_SPECIFIC_AGREEMENT: "Trade specific agreement",
  APPLIANCES: "Appliances",
  CABINETS_AND_CABINET_HARDWARE: "Cabinets and cabinet hardware",
  CMU_WALLS: "Cmu walls",
  CONCRETE: "Concrete",
  COUNTERTOPS: "Countertops",
  DRYWALL: "Drywall",
  ELECTRICAL: "Electrical",
  EXTERIOR_SHEATING_FINISH_WINDOWS_EXT_DOORS_WATERPROOFING: "Exterior sheating finish windows ext doors waterproofing",
  FENCES_AND_GATES: "Fences and gates",
  FIREPLACE_INSTALL: "Fireplace install",
  FIRE_SUPRESSION: "Fire supression",
  FLOORING_AND_WALL_SURFACES: "Flooring and wall surfaces",
  FRAMING: "Framing",
  GARAGE_DOORS: "Garage doors",
  GENERAL_CONDITIONS: "General conditions",
  GUTTERS: "Gutters",
  HVAC: "Hvac",
  INSULATION: "Insulation",
  INTERIOR_MILLWORK_DOORS_HARDWARE: "Interior millwork doors hardware",
  LOW_VOLTAGE: "Low voltage",
  MASONRY_WALL_CLADDING: "Masonry wall cladding",
  MIRROR_AND_SHOWER_ECLOSURES: "Mirror and shower eclosures",
  PAINT: "Paint",
  PLANTING_AND_IRRIGATION: "Planting and irrigation",
  PLUMBING: "Plumbing",
  PROGRESSINVE_CLEANUP: "Progressinve cleanup",
  ROOFING: "Roofing",
  SITEWORK: "Sitework",
  SOLAR_PANELS: "Solar panels",
  STAIR_RAILINGS: "Stair railings",
  STUCCO_AND_THIN_VENNER: "Stucco and thin venner",
  SWPP_AND_EROSION_CONTROL: "Swpp and erosion control",
  TERMITE: "Termite",
  WASTE_REMOVAL: "Waste removal",
};

function enumOrDetailOfTradePartnerRequirementType(
  enumOrDetail: TradePartnerRequirementTypeDetailOptions | TradePartnerRequirementType | undefined,
): TradePartnerRequirementTypeDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerRequirementTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerRequirementTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerRequirementType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerRequirementTypeDetail;
  } else {
    return newTradePartnerRequirementTypeDetail({
      code: enumOrDetail as TradePartnerRequirementType,
      name: enumDetailNameOfTradePartnerRequirementType[enumOrDetail as TradePartnerRequirementType],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerRequirementType(
  enumOrDetail: TradePartnerRequirementTypeDetailOptions | TradePartnerRequirementType | undefined | null,
): TradePartnerRequirementTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerRequirementType(enumOrDetail);
}

const enumDetailNameOfUserEventType = {
  CREATED: "Created",
  UPDATED: "Updated",
  ASSIGNED: "Assigned",
  SCHEDULE_CHANGE: "Schedule change",
  COMPLETED: "Completed",
  TAGGED: "Tagged",
  FINALIZED: "Finalized",
  APPROVED: "Approved",
  COMMENTED: "Commented",
  ATTACHED: "Attached",
  PROJECT_COHORT_CHANGE: "Project cohort change",
  LOT_RELEASE: "Lot release",
  PRPC_APPLIED: "Prpc applied",
  PRPC_RESET: "Prpc reset",
  FLAGGED: "Flagged",
  REQUESTED_CHANGES: "Requested changes",
  REJECTED: "Rejected",
  ITEM_ADDED: "Item added",
  ITEM_REMOVED: "Item removed",
  PUBLISHED: "Published",
};

function enumOrDetailOfUserEventType(
  enumOrDetail: UserEventTypeDetailOptions | UserEventType | undefined,
): UserEventTypeDetail {
  if (enumOrDetail === undefined) {
    return newUserEventTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "UserEventTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfUserEventType[enumOrDetail.code!],
      ...enumOrDetail,
    } as UserEventTypeDetail;
  } else {
    return newUserEventTypeDetail({
      code: enumOrDetail as UserEventType,
      name: enumDetailNameOfUserEventType[enumOrDetail as UserEventType],
    });
  }
}

function enumOrDetailOrNullOfUserEventType(
  enumOrDetail: UserEventTypeDetailOptions | UserEventType | undefined | null,
): UserEventTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfUserEventType(enumOrDetail);
}

const enumDetailNameOfUserType = {
  ANONYMOUS: "Anonymous",
  SYSTEM: "System",
  INTERNAL: "Internal",
  HOMEOWNER: "Homeowner",
  TRADE_PARTNER: "Trade partner",
};

function enumOrDetailOfUserType(enumOrDetail: UserTypeDetailOptions | UserType | undefined): UserTypeDetail {
  if (enumOrDetail === undefined) {
    return newUserTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "UserTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfUserType[enumOrDetail.code!],
      ...enumOrDetail,
    } as UserTypeDetail;
  } else {
    return newUserTypeDetail({
      code: enumOrDetail as UserType,
      name: enumDetailNameOfUserType[enumOrDetail as UserType],
    });
  }
}

function enumOrDetailOrNullOfUserType(
  enumOrDetail: UserTypeDetailOptions | UserType | undefined | null,
): UserTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfUserType(enumOrDetail);
}

const enumDetailNameOfVerificationMethod = {
  VISUAL_INPUT: "Visual input",
  CLOSE_UP_VISUAL_INPUT: "Close up visual input",
  DOCUMENT_UPLOAD: "Document upload",
  IN_PERSON_INSPECTION: "In person inspection",
};

function enumOrDetailOfVerificationMethod(
  enumOrDetail: VerificationMethodDetailOptions | VerificationMethod | undefined,
): VerificationMethodDetail {
  if (enumOrDetail === undefined) {
    return newVerificationMethodDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "VerificationMethodDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfVerificationMethod[enumOrDetail.code!],
      ...enumOrDetail,
    } as VerificationMethodDetail;
  } else {
    return newVerificationMethodDetail({
      code: enumOrDetail as VerificationMethod,
      name: enumDetailNameOfVerificationMethod[enumOrDetail as VerificationMethod],
    });
  }
}

function enumOrDetailOrNullOfVerificationMethod(
  enumOrDetail: VerificationMethodDetailOptions | VerificationMethod | undefined | null,
): VerificationMethodDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfVerificationMethod(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketItemStatus = {
  SUBMITTED: "Submitted",
  REJECTED: "Rejected",
  ACCEPTED: "Accepted",
  ON_HOLD: "On hold",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  MATERIALS_ORDERED: "Materials ordered",
  IN_PROGRESS: "In progress",
  TRADE_CONTACTED: "Trade contacted",
  PENDING_INFO_FROM_HOMEOWNER: "Pending info from homeowner",
};

function enumOrDetailOfWarrantyTicketItemStatus(
  enumOrDetail: WarrantyTicketItemStatusDetailOptions | WarrantyTicketItemStatus | undefined,
): WarrantyTicketItemStatusDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketItemStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketItemStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketItemStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketItemStatusDetail;
  } else {
    return newWarrantyTicketItemStatusDetail({
      code: enumOrDetail as WarrantyTicketItemStatus,
      name: enumDetailNameOfWarrantyTicketItemStatus[enumOrDetail as WarrantyTicketItemStatus],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketItemStatus(
  enumOrDetail: WarrantyTicketItemStatusDetailOptions | WarrantyTicketItemStatus | undefined | null,
): WarrantyTicketItemStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketItemStatus(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketItemType = {
  MECHANICAL: "Mechanical",
  ELECTRICAL: "Electrical",
  PLUMBING: "Plumbing",
  MISC_INTERIOR: "Misc interior",
  MISC_EXTERIOR: "Misc exterior",
};

function enumOrDetailOfWarrantyTicketItemType(
  enumOrDetail: WarrantyTicketItemTypeDetailOptions | WarrantyTicketItemType | undefined,
): WarrantyTicketItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketItemTypeDetail;
  } else {
    return newWarrantyTicketItemTypeDetail({
      code: enumOrDetail as WarrantyTicketItemType,
      name: enumDetailNameOfWarrantyTicketItemType[enumOrDetail as WarrantyTicketItemType],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketItemType(
  enumOrDetail: WarrantyTicketItemTypeDetailOptions | WarrantyTicketItemType | undefined | null,
): WarrantyTicketItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketItemType(enumOrDetail);
}

const enumDetailNameOfWarrantyTrueUpType = {
  TIME_OF_SALE: "Time of sale",
  SALE_PLUS_30: "Sale plus 30",
  SALE_PLUS_60: "Sale plus 60",
  FINAL: "Final",
};

function enumOrDetailOfWarrantyTrueUpType(
  enumOrDetail: WarrantyTrueUpTypeDetailOptions | WarrantyTrueUpType | undefined,
): WarrantyTrueUpTypeDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTrueUpTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTrueUpTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTrueUpType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTrueUpTypeDetail;
  } else {
    return newWarrantyTrueUpTypeDetail({
      code: enumOrDetail as WarrantyTrueUpType,
      name: enumDetailNameOfWarrantyTrueUpType[enumOrDetail as WarrantyTrueUpType],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTrueUpType(
  enumOrDetail: WarrantyTrueUpTypeDetailOptions | WarrantyTrueUpType | undefined | null,
): WarrantyTrueUpTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTrueUpType(enumOrDetail);
}

const enumDetailNameOfWeatherType = {
  CLEAR_DAY: "Clear day",
  PARTLY_CLOUDY_DAY: "Partly cloudy day",
  CLOUDY: "Cloudy",
  WIND: "Wind",
  FOG: "Fog",
  SHOWERS_DAY: "Showers day",
  RAIN: "Rain",
  THUNDER_SHOWERS_DAY: "Thunder showers day",
  THUNDER_DAY: "Thunder day",
  SNOW_SHOWERS_DAY: "Snow showers day",
  SNOW: "Snow",
  SLEET: "Sleet",
  HAIL: "Hail",
  HAZE: "Haze",
  ICE: "Ice",
  SMOKE: "Smoke",
  DUST: "Dust",
};

function enumOrDetailOfWeatherType(
  enumOrDetail: WeatherTypeDetailOptions | WeatherType | undefined,
): WeatherTypeDetail {
  if (enumOrDetail === undefined) {
    return newWeatherTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WeatherTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWeatherType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WeatherTypeDetail;
  } else {
    return newWeatherTypeDetail({
      code: enumOrDetail as WeatherType,
      name: enumDetailNameOfWeatherType[enumOrDetail as WeatherType],
    });
  }
}

function enumOrDetailOrNullOfWeatherType(
  enumOrDetail: WeatherTypeDetailOptions | WeatherType | undefined | null,
): WeatherTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWeatherType(enumOrDetail);
}

const taggedIds: Record<string, string> = {
  "Community": "p",
  "CostConfigurationSummary": "ccs",
  "DesignPackage": "rp",
  "Development": "dev",
  "GlobalOptionType": "gotype",
  "Invoice": "inv",
  "Lot": "p",
  "PlanPackage": "rp",
  "Product": "pr",
  "ProductOffering": "rp",
  "Subdivision": "p",
  "StandaloneProject": "p",
  "Structure": "p",
  "Unit": "p",
};
let nextFactoryIds: Record<string, number> = {};

export function resetFactoryIds() {
  nextFactoryIds = {};
}

function nextFactoryId(objectName: string): string {
  const nextId = nextFactoryIds[objectName] || 1;
  nextFactoryIds[objectName] = nextId + 1;
  const tag = taggedIds[objectName] ?? objectName.replace(/[a-z]/g, "").toLowerCase();
  return tag + ":" + nextId;
}

function newFactoryCache(factoryOptions: FactoryOptions = {}): FactoryCache {
  return { avoidCycles: factoryOptions.avoidCycles === true };
}

function reuseWouldCreateCycle(cache: FactoryCache, value: object): boolean {
  return cache.avoidCycles === true && cache.active?.has(value) === true;
}

function maybeNew(
  type: string,
  value: { __typename?: string } | object | undefined,
  cache: FactoryCache,
  isSet: boolean = false,
): any {
  if (value === undefined) {
    if (isSet) {
      return undefined;
    }
    const cachedValue = cache[type];
    if (cachedValue !== undefined) {
      return reuseWouldCreateCycle(cache, cachedValue) ? undefined : cachedValue;
    }
    return factories[type]({}, undefined, cache);
  } else if ("__typename" in value && value.__typename) {
    if (cache.all?.has(value)) {
      return reuseWouldCreateCycle(cache, value) ? undefined : value;
    }
    return factories[value.__typename](value, undefined, cache);
  } else {
    return factories[type](value, undefined, cache);
  }
}

function maybeNewOrNull(
  type: string,
  value: { __typename?: string } | object | undefined | null,
  cache: FactoryCache,
): any {
  if (!value) {
    return null;
  } else if ("__typename" in value && value.__typename) {
    if (cache.all?.has(value)) {
      return reuseWouldCreateCycle(cache, value) ? undefined : value;
    }
    return factories[value.__typename](value, undefined, cache);
  } else {
    return factories[type](value, undefined, cache);
  }
}

import {
  AllocateProjectItemsTaskModalDocument,
  AllocateProjectItemsTaskModalQuery,
  AllocateProjectItemsTaskModalQueryVariables,
} from "../components/AllocateItemsTaskModal.generated";
import {
  MyTasksTestDocument,
  MyTasksTestQuery,
  MyTasksTestQueryVariables,
} from "../components/QueryTable.stories.generated";
import {
  CurrentUserZenDeskJwtDocument,
  CurrentUserZenDeskJwtQuery,
  CurrentUserZenDeskJwtQueryVariables,
} from "../components/ZendeskWidget.generated";
import {
  CreateChangeEventApproval_ImpactedPosTableDocument,
  CreateChangeEventApproval_ImpactedPosTableQuery,
  CreateChangeEventApproval_ImpactedPosTableQueryVariables,
  OpenManyChangeEventApprovalsDocument,
  OpenManyChangeEventApprovalsMutation,
  OpenManyChangeEventApprovalsMutationVariables,
  SubmitChangesForApprovalStep_ChangeBreakdownTableDocument,
  SubmitChangesForApprovalStep_ChangeBreakdownTableQuery,
  SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables,
  ToggleCommitmentReleaseDocument,
  ToggleCommitmentReleaseMutation,
  ToggleCommitmentReleaseMutationVariables,
} from "../components/approvals/SubmitChangeEventApprovalStepView.generated";
import {
  UseGlobalOptionTagsFilterDocument,
  UseGlobalOptionTagsFilterQuery,
  UseGlobalOptionTagsFilterQueryVariables,
} from "../components/autoPopulateFilters/useGlobalOptionTagsFilter.generated";
import {
  UseRoomTypeFilterDocument,
  UseRoomTypeFilterQuery,
  UseRoomTypeFilterQueryVariables,
} from "../components/autoPopulateFilters/useRoomTypeFilter.generated";
import {
  BidItemSelectDocument,
  BidItemSelectQuery,
  BidItemSelectQueryVariables,
} from "../components/autoPopulateSelects/BidItemSelect.generated";
import {
  ChangeEventReasonsDocument,
  ChangeEventReasonsQuery,
  ChangeEventReasonsQueryVariables,
} from "../components/autoPopulateSelects/ChangeEventReasonsSelectField.generated";
import {
  CostCodeSelectDocument,
  CostCodeSelectQuery,
  CostCodeSelectQueryVariables,
} from "../components/autoPopulateSelects/CostCodeSelectField.generated";
import {
  CostSourceSelectDocument,
  CostSourceSelectQuery,
  CostSourceSelectQueryVariables,
} from "../components/autoPopulateSelects/CostSourceSelectField.generated";
import {
  GlobalPlanTaskSelectDocument,
  GlobalPlanTaskSelectQuery,
  GlobalPlanTaskSelectQueryVariables,
} from "../components/autoPopulateSelects/GlobalPlanTaskSelectField.generated";
import {
  ItemsSelectDocument,
  ItemsSelectQuery,
  ItemsSelectQueryVariables,
} from "../components/autoPopulateSelects/ItemsSelectField.generated";
import {
  LocationsDocument,
  LocationsQuery,
  LocationsQueryVariables,
} from "../components/autoPopulateSelects/LocationsSelectField.generated";
import {
  MadTypesDocument,
  MadTypesQuery,
  MadTypesQueryVariables,
} from "../components/autoPopulateSelects/MADTypeBoundSelectField.generated";
import {
  ProjectAutocompleteDocument,
  ProjectAutocompleteQuery,
  ProjectAutocompleteQueryVariables,
} from "../components/autoPopulateSelects/ProjectAutocompleteField.generated";
import {
  TradePartnerAutocompleteDocument,
  TradePartnerAutocompleteQuery,
  TradePartnerAutocompleteQueryVariables,
} from "../components/autoPopulateSelects/TradePartnerAutocompleteField.generated";
import {
  TradePartnersSelectDocument,
  TradePartnersSelectQuery,
  TradePartnersSelectQueryVariables,
} from "../components/autoPopulateSelects/TradePartnerSelectField.generated";
import {
  UnitsOfMeasureDocument,
  UnitsOfMeasureQuery,
  UnitsOfMeasureQueryVariables,
} from "../components/autoPopulateSelects/UnitsOfMeasureSelectField.generated";
import {
  GlobalOptionTypesDocument,
  GlobalOptionTypesQuery,
  GlobalOptionTypesQueryVariables,
} from "../components/autoPopulateSelects/useGlobalOptionTypes.generated";
import {
  BidContractPlanPricing_ReadyPlanOptionsDocument,
  BidContractPlanPricing_ReadyPlanOptionsQuery,
  BidContractPlanPricing_ReadyPlanOptionsQueryVariables,
  BidContractPlanPricing_RevisionDocument,
  BidContractPlanPricing_RevisionQuery,
  BidContractPlanPricing_RevisionQueryVariables,
  BidContractPlanPricing_ScopeLinesDocument,
  BidContractPlanPricing_ScopeLinesQuery,
  BidContractPlanPricing_ScopeLinesQueryVariables,
} from "../components/bid-contracts/BidContractPlanPricingPage.generated";
import {
  BidContractPlanPricingPageV2Document,
  BidContractPlanPricingPageV2Query,
  BidContractPlanPricingPageV2QueryVariables,
} from "../components/bid-contracts/BidContractPlanPricingPageV2.generated";
import {
  BidContractPurchaseOrdersPageDocument,
  BidContractPurchaseOrdersPageQuery,
  BidContractPurchaseOrdersPageQueryVariables,
} from "../components/bid-contracts/BidContractPurchaseOrdersPage.generated";
import {
  BidContractRevisionUnitPricingDocument,
  BidContractRevisionUnitPricingQuery,
  BidContractRevisionUnitPricingQueryVariables,
  SaveBidContractUnitPricingDocument,
  SaveBidContractUnitPricingMutation,
  SaveBidContractUnitPricingMutationVariables,
} from "../components/bid-contracts/BidContractUnitPricingPage.generated";
import {
  BidContractsTableV2Document,
  BidContractsTableV2Query,
  BidContractsTableV2QueryVariables,
} from "../components/bid-contracts/BidContractsTableV2.generated";
import {
  BidItemsModalDocument,
  BidItemsModalQuery,
  BidItemsModalQueryVariables,
} from "../components/bid-contracts/BidItemsModal.generated";
import {
  BusinessFunctionDetailsDocument,
  BusinessFunctionDetailsQuery,
  BusinessFunctionDetailsQueryVariables,
  BusinessFunctionsDocument,
  BusinessFunctionsQuery,
  BusinessFunctionsQueryVariables,
  ProjectRolesForBusinessFunctionDocument,
  ProjectRolesForBusinessFunctionQuery,
  ProjectRolesForBusinessFunctionQueryVariables,
  SaveBusinessFunctionDocument,
  SaveBusinessFunctionMutation,
  SaveBusinessFunctionMutationVariables,
} from "../components/change-log/BusinessFunctionsPage.generated";
import {
  ChangeLogMetadataDocument,
  ChangeLogMetadataQuery,
  ChangeLogMetadataQueryVariables,
  ChangeLogProjectFilterMetadataDocument,
  ChangeLogProjectFilterMetadataQuery,
  ChangeLogProjectFilterMetadataQueryVariables,
} from "../components/change-log/ChangeLog.generated";
import {
  ChangeLogRightPaneContentDetailsDocument,
  ChangeLogRightPaneContentDetailsQuery,
  ChangeLogRightPaneContentDetailsQueryVariables,
} from "../components/change-log/ChangeLogRightPaneContent.generated";
import {
  ChangeLogTableDocument,
  ChangeLogTableQuery,
  ChangeLogTableQueryVariables,
} from "../components/change-log/ChangeLogTable.generated";
import {
  ChangeTypesDocument,
  ChangeTypesQuery,
  ChangeTypesQueryVariables,
} from "../components/change-log/ChangeTypesPage.generated";
import {
  ChangeRequestDetailsDocument,
  ChangeRequestDetailsQuery,
  ChangeRequestDetailsQueryVariables,
  CreateChangeRequestMetadataDocument,
  CreateChangeRequestMetadataQuery,
  CreateChangeRequestMetadataQueryVariables,
  SaveChangeRequestDocument,
  SaveChangeRequestMutation,
  SaveChangeRequestMutationVariables,
  SaveChangeRequestsDocument,
  SaveChangeRequestsMutation,
  SaveChangeRequestsMutationVariables,
} from "../components/change-log/CreateChangeRequestDrawer.generated";
import {
  BusinessFunctionAssetsDocument,
  BusinessFunctionAssetsQuery,
  BusinessFunctionAssetsQueryVariables,
  SaveChangeRequestAssetsDocument,
  SaveChangeRequestAssetsMutation,
  SaveChangeRequestAssetsMutationVariables,
} from "../components/change-log/components/BusinessFunctionAssets.generated";
import {
  ChangeRequestGroupModalDocument,
  ChangeRequestGroupModalQuery,
  ChangeRequestGroupModalQueryVariables,
  DeleteChangeRequestGroupDocument,
  DeleteChangeRequestGroupMutation,
  DeleteChangeRequestGroupMutationVariables,
  SaveChangeRequestGroupDocument,
  SaveChangeRequestGroupMutation,
  SaveChangeRequestGroupMutationVariables,
} from "../components/change-log/components/ChangeRequestGroupModal.generated";
import {
  ChangeRequestGroupsForModalDocument,
  ChangeRequestGroupsForModalQuery,
  ChangeRequestGroupsForModalQueryVariables,
  ChangeRequestsDependencyModalDocument,
  ChangeRequestsDependencyModalQuery,
  ChangeRequestsDependencyModalQueryVariables,
  SaveChangeRequestDependencyBlockersDocument,
  SaveChangeRequestDependencyBlockersMutation,
  SaveChangeRequestDependencyBlockersMutationVariables,
  SaveChangeRequestDependencyBlockingDocument,
  SaveChangeRequestDependencyBlockingMutation,
  SaveChangeRequestDependencyBlockingMutationVariables,
  SaveChangeRequestRelatedToDocument,
  SaveChangeRequestRelatedToMutation,
  SaveChangeRequestRelatedToMutationVariables,
} from "../components/change-log/components/DependencyModal.generated";
import {
  ChangeRequestHistoryDocument,
  ChangeRequestHistoryQuery,
  ChangeRequestHistoryQueryVariables,
} from "../components/change-log/components/HistoryTab.generated";
import {
  CommentFeedTradePartnersDocument,
  CommentFeedTradePartnersQuery,
  CommentFeedTradePartnersQueryVariables,
  DeleteCommentDocument,
  DeleteCommentMutation,
  DeleteCommentMutationVariables,
  MarkCommentStreamAsReadDocument,
  MarkCommentStreamAsReadMutation,
  MarkCommentStreamAsReadMutationVariables,
  SaveCommentDocument,
  SaveCommentMutation,
  SaveCommentMutationVariables,
  SaveFollowersDocument,
  SaveFollowersMutation,
  SaveFollowersMutationVariables,
} from "../components/comments/CommentFeed.generated";
import {
  GetCommentsDocument,
  GetCommentsQuery,
  GetCommentsQueryVariables,
} from "../components/comments/CommentsSuperDrawer.generated";
import {
  CommunicationChannelsDocument,
  CommunicationChannelsQuery,
  CommunicationChannelsQueryVariables,
  SaveUserCommunicationPreferenceDocument,
  SaveUserCommunicationPreferenceMutation,
  SaveUserCommunicationPreferenceMutationVariables,
  UserCommunicationPreferencesDocument,
  UserCommunicationPreferencesQuery,
  UserCommunicationPreferencesQueryVariables,
} from "../components/communication-preferences/UserCommunicationPreferences.generated";
import {
  BillDetailPane_AdditionalCommitmentsDocument,
  BillDetailPane_AdditionalCommitmentsQuery,
  BillDetailPane_AdditionalCommitmentsQueryVariables,
  BillDetailPane_NewBillCommitmentLikeDataDocument,
  BillDetailPane_NewBillCommitmentLikeDataQuery,
  BillDetailPane_NewBillCommitmentLikeDataQueryVariables,
  BillDetailPane_SaveApprovalDocument,
  BillDetailPane_SaveApprovalMutation,
  BillDetailPane_SaveApprovalMutationVariables,
  BillDetailPaneDocument,
  BillDetailPaneQuery,
  BillDetailPaneQueryVariables,
  BillPaneDetail_SaveBillDocumentDocument,
  BillPaneDetail_SaveBillDocumentMutation,
  BillPaneDetail_SaveBillDocumentMutationVariables,
} from "../components/detailPane/bill/BillDetailPane.generated";
import {
  DropModalMetadataDocument,
  DropModalMetadataQuery,
  DropModalMetadataQueryVariables,
  SaveDropDocument,
  SaveDropMutation,
  SaveDropMutationVariables,
} from "../components/drops/DropModal.generated";
import {
  DeleteDropDocument,
  DeleteDropMutation,
  DeleteDropMutationVariables,
  DropsPageDocument,
  DropsPageQuery,
  DropsPageQueryVariables,
} from "../components/drops/DropsPage.generated";
import {
  PotentialInvoicesToCreditDocument,
  PotentialInvoicesToCreditQuery,
  PotentialInvoicesToCreditQueryVariables,
} from "../components/formFields/InvoiceNumber.generated";
import {
  LocationPathField_GetFeatureTypesDocument,
  LocationPathField_GetFeatureTypesQuery,
  LocationPathField_GetFeatureTypesQueryVariables,
  LocationPathField_GetLocationsDocument,
  LocationPathField_GetLocationsQuery,
  LocationPathField_GetLocationsQueryVariables,
} from "../components/locationPathField/LocationPathField.generated";
import {
  UpdateProjectCoverImageDocument,
  UpdateProjectCoverImageMutation,
  UpdateProjectCoverImageMutationVariables,
} from "../components/navigation/CoverImage.generated";
import {
  DeleteToDoDocument,
  DeleteToDoMutation,
  DeleteToDoMutationVariables,
  SaveToDosDocument,
  SaveToDosMutation,
  SaveToDosMutationVariables,
  ToDoModalDataDocument,
  ToDoModalDataQuery,
  ToDoModalDataQueryVariables,
  ToDoModalDocument,
  ToDoModalQuery,
  ToDoModalQueryVariables,
} from "../components/to-dos/ToDoModal.generated";
import {
  ToDosDocument,
  ToDosQuery,
  ToDosQueryVariables,
  ToDoStatusesDocument,
  ToDoStatusesQuery,
  ToDoStatusesQueryVariables,
  ToDoTypesDocument,
  ToDoTypesQuery,
  ToDoTypesQueryVariables,
} from "../components/to-dos/ToDosBoard.generated";
import {
  CreateAssetDocument,
  CreateAssetMutation,
  CreateAssetMutationVariables,
  CreateDocumentPendingUploadDocument,
  CreateDocumentPendingUploadMutation,
  CreateDocumentPendingUploadMutationVariables,
  MarkDocumentAsUploadedDocument,
  MarkDocumentAsUploadedMutation,
  MarkDocumentAsUploadedMutationVariables,
} from "../components/uploader/DocumentUploader.generated";
import {
  CreateAssetUploadUrlDocument,
  CreateAssetUploadUrlMutation,
  CreateAssetUploadUrlMutationVariables,
} from "../components/uploader/UppyUploader.generated";
import {
  DevelopmentFeatureFlagsDocument,
  DevelopmentFeatureFlagsQuery,
  DevelopmentFeatureFlagsQueryVariables,
  ProjectFeatureFlagsDocument,
  ProjectFeatureFlagsQuery,
  ProjectFeatureFlagsQueryVariables,
  UserFeatureFlagsDocument,
  UserFeatureFlagsQuery,
  UserFeatureFlagsQueryVariables,
} from "../contexts/FeatureFlags/FeatureFlagContext.generated";
import {
  MaterialTypesDocument,
  MaterialTypesQuery,
  MaterialTypesQueryVariables,
} from "../hooks/enums/useMaterialTypes.generated";
import {
  MarketFilterMetadataDocument,
  MarketFilterMetadataQuery,
  MarketFilterMetadataQueryVariables,
} from "../hooks/filters/markets/useMarketFilter.generated";
import {
  ProjectCommunityFilterMetadataDocument,
  ProjectCommunityFilterMetadataQuery,
  ProjectCommunityFilterMetadataQueryVariables,
} from "../hooks/filters/projectCommunity/useProjectCommunityFilter.generated";
import {
  ReadyPlanStatusFilterMetadataDocument,
  ReadyPlanStatusFilterMetadataQuery,
  ReadyPlanStatusFilterMetadataQueryVariables,
} from "../hooks/filters/readyPlanStatus/useReadyPlanStatusFilter.generated";
import {
  InternalUsersDocument,
  InternalUsersQuery,
  InternalUsersQueryVariables,
} from "../hooks/useInternalUsers.generated";
import {
  UseLocationsTreeDocument,
  UseLocationsTreeQuery,
  UseLocationsTreeQueryVariables,
} from "../hooks/useLocationsTree.generated";
import {
  ProjectLocationsTreeDocument,
  ProjectLocationsTreeQuery,
  ProjectLocationsTreeQueryVariables,
} from "../hooks/useProjectLocationsTree.generated";
import {
  TrackedJobsPollDocument,
  TrackedJobsPollQuery,
  TrackedJobsPollQueryVariables,
} from "../hooks/useTrackedJobs.generated";
import {
  CompleteStageDocument,
  CompleteStageMutation,
  CompleteStageMutationVariables,
} from "../mutations/completeStage.generated";
import {
  SaveProjectStageDocument,
  SaveProjectStageMutation,
  SaveProjectStageMutationVariables,
} from "../mutations/saveProjectStage.generated";
import {
  CostConfidencesDocument,
  CostConfidencesQuery,
  CostConfidencesQueryVariables,
} from "../queries/CostConfidence.generated";
import {
  CurrentInternalUserDocument,
  CurrentInternalUserQuery,
  CurrentInternalUserQueryVariables,
  StopInternalUserImpersonationDocument,
  StopInternalUserImpersonationMutation,
  StopInternalUserImpersonationMutationVariables,
} from "../queries/user.generated";
import {
  ToggleProjectFeatureDocument,
  ToggleProjectFeatureMutation,
  ToggleProjectFeatureMutationVariables,
} from "../routes/admin/components/ProjectFeaturesCell.generated";
import {
  SetProjectStatusDocument,
  SetProjectStatusMutation,
  SetProjectStatusMutationVariables,
} from "../routes/admin/components/ProjectStatusCell.generated";
import {
  CostCodeHistoryDocument,
  CostCodeHistoryQuery,
  CostCodeHistoryQueryVariables,
} from "../routes/admin/costCodes/CostCodeHistoryTab.generated";
import {
  CostCodeMaterialLeadTimesTabDocument,
  CostCodeMaterialLeadTimesTabQuery,
  CostCodeMaterialLeadTimesTabQueryVariables,
} from "../routes/admin/costCodes/CostCodeMaterialLeadTimesTab.generated";
import {
  CostCodeOverviewTabDocument,
  CostCodeOverviewTabMetadataDocument,
  CostCodeOverviewTabMetadataQuery,
  CostCodeOverviewTabMetadataQueryVariables,
  CostCodeOverviewTabQuery,
  CostCodeOverviewTabQueryVariables,
  SaveCostCodesDocument,
  SaveCostCodesMutation,
  SaveCostCodesMutationVariables,
} from "../routes/admin/costCodes/CostCodeOverviewTab.generated";
import {
  CostCodesDocument,
  CostCodesQuery,
  CostCodesQueryVariables,
  DeleteCostCodeDocument,
  DeleteCostCodeMutation,
  DeleteCostCodeMutationVariables,
} from "../routes/admin/costCodes/CostCodes.generated";
import {
  ItemsDrawerDocument,
  ItemsDrawerQuery,
  ItemsDrawerQueryVariables,
} from "../routes/admin/costCodes/ItemsDrawer.generated";
import {
  FeatureFlagsDocument,
  FeatureFlagsMetadataDocument,
  FeatureFlagsMetadataQuery,
  FeatureFlagsMetadataQueryVariables,
  FeatureFlagsQuery,
  FeatureFlagsQueryVariables,
  SaveFeatureFlagDocument,
  SaveFeatureFlagMutation,
  SaveFeatureFlagMutationVariables,
} from "../routes/admin/featureFlags/FeatureFlags.generated";
import {
  DeleteFeatureTypeDocument,
  DeleteFeatureTypeMutation,
  DeleteFeatureTypeMutationVariables,
  FeatureTypes_RoomTypesDocument,
  FeatureTypes_RoomTypesQuery,
  FeatureTypes_RoomTypesQueryVariables,
  FeatureTypesDocument,
  FeatureTypesQuery,
  FeatureTypesQueryVariables,
  SaveFeatureTypeDocument,
  SaveFeatureTypeMutation,
  SaveFeatureTypeMutationVariables,
} from "../routes/admin/featureTypes/FeatureTypes.generated";
import {
  FinishScheduleCostCodesDocument,
  FinishScheduleCostCodesQuery,
  FinishScheduleCostCodesQueryVariables,
  SaveFinishScheduleCostCodesDocument,
  SaveFinishScheduleCostCodesMutation,
  SaveFinishScheduleCostCodesMutationVariables,
  SaveFinishScheduleItemsDocument,
  SaveFinishScheduleItemsMutation,
  SaveFinishScheduleItemsMutationVariables,
} from "../routes/admin/finishSchedule/FinishScheduleAdmin.generated";
import {
  FinishScheduleCostCodeDocument,
  FinishScheduleCostCodeQuery,
  FinishScheduleCostCodeQueryVariables,
  SaveFinishScheduleCostCodeDocument,
  SaveFinishScheduleCostCodeMutation,
  SaveFinishScheduleCostCodeMutationVariables,
} from "../routes/admin/finishSchedule/FinishScheduleCostCodeDetails.generated";
import {
  TriggerQaDatabaseResetDocument,
  TriggerQaDatabaseResetMutation,
  TriggerQaDatabaseResetMutationVariables,
} from "../routes/admin/infrastructure/Infrastructure.generated";
import {
  AdminItemsDrawerDocument,
  AdminItemsDrawerQuery,
  AdminItemsDrawerQueryVariables,
  SaveItemDimensionsDocument,
  SaveItemDimensionsMutation,
  SaveItemDimensionsMutationVariables,
} from "../routes/admin/items/AdminItemsDrawer.generated";
import {
  ItemEditorHistoryDocument,
  ItemEditorHistoryQuery,
  ItemEditorHistoryQueryVariables,
} from "../routes/admin/items/ItemEditorHistoryTab.generated";
import {
  ItemEditorTabMetadataDocument,
  ItemEditorTabMetadataQuery,
  ItemEditorTabMetadataQueryVariables,
} from "../routes/admin/items/ItemEditorTab.generated";
import {
  ItemsDocument,
  ItemsPageMetadataDocument,
  ItemsPageMetadataQuery,
  ItemsPageMetadataQueryVariables,
  ItemsQuery,
  ItemsQueryVariables,
  SaveItemDocument,
  SaveItemMutation,
  SaveItemMutationVariables,
} from "../routes/admin/items/ItemsPage.generated";
import {
  MaterialLeadTimesEditorTabDocument,
  MaterialLeadTimesEditorTabMetadataDocument,
  MaterialLeadTimesEditorTabMetadataQuery,
  MaterialLeadTimesEditorTabMetadataQueryVariables,
  MaterialLeadTimesEditorTabQuery,
  MaterialLeadTimesEditorTabQueryVariables,
} from "../routes/admin/items/MaterialLeadTimesEditorTab.generated";
import {
  AdminLocationsPageDocument,
  AdminLocationsPageQuery,
  AdminLocationsPageQueryVariables,
} from "../routes/admin/locations/LocationsPage.generated";
import {
  AdminLocationDrawerDocument,
  AdminLocationDrawerQuery,
  AdminLocationDrawerQueryVariables,
  SaveAdminLocationDrawerDocument,
  SaveAdminLocationDrawerMutation,
  SaveAdminLocationDrawerMutationVariables,
} from "../routes/admin/locations/components/LocationDrawer.generated";
import {
  AdminProjectsFilterDataDocument,
  AdminProjectsFilterDataQuery,
  AdminProjectsFilterDataQueryVariables,
  ProjectsDocument,
  ProjectsQuery,
  ProjectsQueryVariables,
  SetProjectIsTestDocument,
  SetProjectIsTestMutation,
  SetProjectIsTestMutationVariables,
  SetQbCustomerIdDocument,
  SetQbCustomerIdMutation,
  SetQbCustomerIdMutationVariables,
} from "../routes/admin/projects/Admin.generated";
import {
  RemoveUserGroupDocument,
  RemoveUserGroupMutation,
  RemoveUserGroupMutationVariables,
  SaveUserGroupDocument,
  SaveUserGroupMutation,
  SaveUserGroupMutationVariables,
  UserGroupsDocument,
  UserGroupsMetadataDocument,
  UserGroupsMetadataQuery,
  UserGroupsMetadataQueryVariables,
  UserGroupsQuery,
  UserGroupsQueryVariables,
} from "../routes/admin/userGroups/UserGroups.generated";
import {
  ActivateUsersDocument,
  ActivateUsersMutation,
  ActivateUsersMutationVariables,
  DeactivateUsersDocument,
  DeactivateUsersMutation,
  DeactivateUsersMutationVariables,
  StartInternalUserImpersonationDocument,
  StartInternalUserImpersonationMutation,
  StartInternalUserImpersonationMutationVariables,
  UsersPageDocument,
  UsersPageQuery,
  UsersPageQueryVariables,
} from "../routes/admin/users/UsersPage.generated";
import {
  BidPackageDetailPageDocument,
  BidPackageDetailPageQuery,
  BidPackageDetailPageQueryVariables,
  BidPackageVersionDetailPageDocument,
  BidPackageVersionDetailPageQuery,
  BidPackageVersionDetailPageQueryVariables,
  SaveBidPackageRequestDocument,
  SaveBidPackageRequestMutation,
  SaveBidPackageRequestMutationVariables,
} from "../routes/bids/BidPackageDetailPage.generated";
import {
  BidPackageGroupsDocument,
  BidPackageGroupsQuery,
  BidPackageGroupsQueryVariables,
  BidPackagesPageMetadataDocument,
  BidPackagesPageMetadataQuery,
  BidPackagesPageMetadataQueryVariables,
  DeleteBidPackageDocument,
  DeleteBidPackageMutation,
  DeleteBidPackageMutationVariables,
} from "../routes/bids/BidPackagesPage.generated";
import {
  EnterUnitBasedBidPage_SaveBidContractRevisionDocument,
  EnterUnitBasedBidPage_SaveBidContractRevisionMutation,
  EnterUnitBasedBidPage_SaveBidContractRevisionMutationVariables,
  EnterUnitBasedBidPageDocument,
  EnterUnitBasedBidPageQuery,
  EnterUnitBasedBidPageQueryVariables,
} from "../routes/bids/EnterUnitBasedBidPage.generated";
import {
  AddBidPackagePage_OriginatingProjectDocument,
  AddBidPackagePage_OriginatingProjectQuery,
  AddBidPackagePage_OriginatingProjectQueryVariables,
  AddBidPackagePageDocument,
  AddBidPackagePageQuery,
  AddBidPackagePageQueryVariables,
  OverlappingBidPackagesDocument,
  OverlappingBidPackagesQuery,
  OverlappingBidPackagesQueryVariables,
  SaveBidPackagesDocument,
  SaveBidPackagesMutation,
  SaveBidPackagesMutationVariables,
} from "../routes/bids/add-bid-package/AddBidPackagePage.generated";
import {
  BidPackageDetailsStepDocument,
  BidPackageDetailsStepQuery,
  BidPackageDetailsStepQueryVariables,
} from "../routes/bids/add-bid-package/components/1.BidPackageDetailsStep.generated";
import {
  ReviewUnitBidScopeStep_BidPackageGroupDocument,
  ReviewUnitBidScopeStep_BidPackageGroupQuery,
  ReviewUnitBidScopeStep_BidPackageGroupQueryVariables,
} from "../routes/bids/add-bid-package/components/2.ReviewUnitBidScopeStep.generated";
import {
  SelectBiddersStepDocument,
  SelectBiddersStepQuery,
  SelectBiddersStepQueryVariables,
} from "../routes/bids/add-bid-package/components/3.SelectBiddersStep.generated";
import {
  ReviewAndSendStepDocument,
  ReviewAndSendStepQuery,
  ReviewAndSendStepQueryVariables,
} from "../routes/bids/add-bid-package/components/5.ReviewAndSendStep.generated";
import {
  BidMetaDocument,
  BidMetaQuery,
  BidMetaQueryVariables,
  BidPackageLineItemModalDocument,
  BidPackageLineItemModalQuery,
  BidPackageLineItemModalQueryVariables,
  EditBidMetaDocument,
  EditBidMetaQuery,
  EditBidMetaQueryVariables,
} from "../routes/bids/add-bid-package/components/BidPackageLineItemModal.generated";
import {
  BidProjectFieldsDocument,
  BidProjectFieldsQuery,
  BidProjectFieldsQueryVariables,
} from "../routes/bids/add-bid-package/components/BidProjectFields.generated";
import {
  BidPackagesPageV2CostCodeSummaryDocument,
  BidPackagesPageV2CostCodeSummaryQuery,
  BidPackagesPageV2CostCodeSummaryQueryVariables,
  BidPackagesPageV2Document,
  BidPackagesPageV2MetadataDocument,
  BidPackagesPageV2MetadataQuery,
  BidPackagesPageV2MetadataQueryVariables,
  BidPackagesPageV2Query,
  BidPackagesPageV2QueryVariables,
  SaveBiddingCycleDocument,
  SaveBiddingCycleMutation,
  SaveBiddingCycleMutationVariables,
} from "../routes/bids/bid-packages-v2/BidPackagesPageV2.generated";
import {
  AddTradePartnerModalDocument,
  AddTradePartnerModalQuery,
  AddTradePartnerModalQueryVariables,
} from "../routes/bids/components/AddTradePartnerModal.generated";
import {
  AwardBidModalDocument,
  AwardBidModalQuery,
  AwardBidModalQueryVariables,
  SaveBidPackageAwardsDocument,
  SaveBidPackageAwardsMutation,
  SaveBidPackageAwardsMutationVariables,
} from "../routes/bids/components/AwardBidModal.generated";
import {
  ReviseBidPackageCostsDocument,
  ReviseBidPackageCostsMutation,
  ReviseBidPackageCostsMutationVariables,
} from "../routes/bids/components/BidPackageHeader.generated";
import {
  AcceptBidPackageUpdatesDocument,
  AcceptBidPackageUpdatesMutation,
  AcceptBidPackageUpdatesMutationVariables,
  BidUpdatesAvailable_BidPackageDocument,
  BidUpdatesAvailable_BidPackageQuery,
  BidUpdatesAvailable_BidPackageQueryVariables,
} from "../routes/bids/components/BidUpdatesAvailable.generated";
import {
  BillTermsTab_BasePlanGlobalPlanTasksDocument,
  BillTermsTab_BasePlanGlobalPlanTasksQuery,
  BillTermsTab_BasePlanGlobalPlanTasksQueryVariables,
  BillTermsTab_SaveBidContractRevisionDocument,
  BillTermsTab_SaveBidContractRevisionMutation,
  BillTermsTab_SaveBidContractRevisionMutationVariables,
} from "../routes/bids/components/BillTermsTab.generated";
import {
  EditBidPackageDetailsStepDocument,
  EditBidPackageDetailsStepQuery,
  EditBidPackageDetailsStepQueryVariables,
  SaveBidPackageDocument,
  SaveBidPackageMutation,
  SaveBidPackageMutationVariables,
} from "../routes/bids/components/EditBidPackageModal.generated";
import {
  PlanBasedBidsTable_AggregateVersionsDocument,
  PlanBasedBidsTable_AggregateVersionsQuery,
  PlanBasedBidsTable_AggregateVersionsQueryVariables,
  PlanBasedBidsTable_ReadyPlanOptionsDocument,
  PlanBasedBidsTable_ReadyPlanOptionsQuery,
  PlanBasedBidsTable_ReadyPlanOptionsQueryVariables,
  PlanBasedBidsTable_ScopeLinesDocument,
  PlanBasedBidsTable_ScopeLinesQuery,
  PlanBasedBidsTable_ScopeLinesQueryVariables,
} from "../routes/bids/components/PlanBasedBidsTable.generated";
import {
  AddProrationBidContractDocument,
  AddProrationBidContractMutation,
  AddProrationBidContractMutationVariables,
  AddProrationBidContractRevisionDocument,
  AddProrationBidContractRevisionMutation,
  AddProrationBidContractRevisionMutationVariables,
  EditProratedBidRevisionDocument,
  EditProratedBidRevisionQuery,
  EditProratedBidRevisionQueryVariables,
  SaveProrationTradeLineItemsDocument,
  SaveProrationTradeLineItemsMutation,
  SaveProrationTradeLineItemsMutationVariables,
} from "../routes/bids/components/ProrateBidModal.generated";
import {
  ReviewBidPackageIncomingUpdatesDocument,
  ReviewBidPackageIncomingUpdatesMutation,
  ReviewBidPackageIncomingUpdatesMutationVariables,
} from "../routes/bids/components/ReviewBidPackageIncomingUpdates.generated";
import {
  UnitBasedBidsTableDocument,
  UnitBasedBidsTableQuery,
  UnitBasedBidsTableQueryVariables,
} from "../routes/bids/components/UnitBasedBidsTable.generated";
import {
  AllConfigurationsDimensionsDocument,
  AllConfigurationsDimensionsQuery,
  AllConfigurationsDimensionsQueryVariables,
  AllConfigurationsDocument,
  AllConfigurationsQuery,
  AllConfigurationsQueryVariables,
} from "../routes/bids/cost-analysis/AllConfigurationsTab.generated";
import {
  CostAnalysisPageDocument,
  CostAnalysisPageQuery,
  CostAnalysisPageQueryVariables,
} from "../routes/bids/cost-analysis/CostAnalysisPage.generated";
import {
  EnterPlanBasedBidPage_SaveBidContractDocument,
  EnterPlanBasedBidPage_SaveBidContractMutation,
  EnterPlanBasedBidPage_SaveBidContractMutationVariables,
  EnterPlanBasedBidPageDocument,
  EnterPlanBasedBidPageQuery,
  EnterPlanBasedBidPageQueryVariables,
} from "../routes/bids/plan-based-bid-package/EnterPlanBasedBidPage.generated";
import {
  PlanBasedBidPackagePage_OriginatingProjectDocument,
  PlanBasedBidPackagePage_OriginatingProjectQuery,
  PlanBasedBidPackagePage_OriginatingProjectQueryVariables,
  PlanBasedBidPackagePageDocument,
  PlanBasedBidPackagePageQuery,
  PlanBasedBidPackagePageQueryVariables,
  PreviewSavePlanBasedBidPackageDocument,
  PreviewSavePlanBasedBidPackageQuery,
  PreviewSavePlanBasedBidPackageQueryVariables,
  SavePlanBasedBidPackagesDocument,
  SavePlanBasedBidPackagesMutation,
  SavePlanBasedBidPackagesMutationVariables,
} from "../routes/bids/plan-based-bid-package/PlanBasedBidPackagePage.generated";
import {
  PlanBasedBidPackageDetailsStep_CommunitiesDocument,
  PlanBasedBidPackageDetailsStep_CommunitiesQuery,
  PlanBasedBidPackageDetailsStep_CommunitiesQueryVariables,
  PlanBasedBidPackageDetailsStep_ProductOfferingsDocument,
  PlanBasedBidPackageDetailsStep_ProductOfferingsQuery,
  PlanBasedBidPackageDetailsStep_ProductOfferingsQueryVariables,
  PlanBasedBidPackageDetailsStepDocument,
  PlanBasedBidPackageDetailsStepQuery,
  PlanBasedBidPackageDetailsStepQueryVariables,
} from "../routes/bids/plan-based-bid-package/components/1.PlanBasedBidPackageDetailsStep.generated";
import {
  ConfigureBidGroupsStepDocument,
  ConfigureBidGroupsStepQuery,
  ConfigureBidGroupsStepQueryVariables,
} from "../routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import {
  PlanBasedBidPackageReviewAndDownloadStepDocument,
  PlanBasedBidPackageReviewAndDownloadStepQuery,
  PlanBasedBidPackageReviewAndDownloadStepQueryVariables,
} from "../routes/bids/plan-based-bid-package/components/3.ReviewAndDownloadStep.generated";
import {
  CopyCostsModal_CopyPlanBasedBidCostsDocument,
  CopyCostsModal_CopyPlanBasedBidCostsMutation,
  CopyCostsModal_CopyPlanBasedBidCostsMutationVariables,
  CopyCostsModal_SaveBidContractDocument,
  CopyCostsModal_SaveBidContractMutation,
  CopyCostsModal_SaveBidContractMutationVariables,
} from "../routes/bids/plan-based-bid-package/components/CopyCostsModal.generated";
import {
  PlanBasedBidsTableV2_BidPlanChildGroupsDocument,
  PlanBasedBidsTableV2_BidPlanChildGroupsQuery,
  PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables,
  PlanBasedBidsTableV2_RevisionLinesDocument,
  PlanBasedBidsTableV2_RevisionLinesQuery,
  PlanBasedBidsTableV2_RevisionLinesQueryVariables,
} from "../routes/bids/plan-based-bid-package/components/PlanBasedBidsTableV2.generated";
import {
  UploadBidV2ModalDocument,
  UploadBidV2ModalQuery,
  UploadBidV2ModalQueryVariables,
} from "../routes/bids/plan-based-bid-package/components/UploadBidV2Modal.generated";
import {
  FinancesPageSharedDocument,
  FinancesPageSharedQuery,
  FinancesPageSharedQueryVariables,
} from "../routes/billing/FinancesPage.generated";
import {
  CreateInvoiceTermsMetadataDocument,
  CreateInvoiceTermsMetadataQuery,
  CreateInvoiceTermsMetadataQueryVariables,
} from "../routes/billing/invoice-terms/components/CreateInvoiceTermsModal.generated";
import {
  InvoiceTermsFormDocument,
  InvoiceTermsFormMetadataDocument,
  InvoiceTermsFormMetadataQuery,
  InvoiceTermsFormMetadataQueryVariables,
  InvoiceTermsFormQuery,
  InvoiceTermsFormQueryVariables,
  SaveInvoiceTermsDocument,
  SaveInvoiceTermsMutation,
  SaveInvoiceTermsMutationVariables,
} from "../routes/billing/invoice-terms/components/InvoiceTermsForm.generated";
import {
  InvoiceTermsDocument,
  InvoiceTermsQuery,
  InvoiceTermsQueryVariables,
} from "../routes/billing/invoice-terms/components/InvoiceTermsTable.generated";
import {
  BillEditor_BillDocument,
  BillEditor_BillOcrDocument,
  BillEditor_BillOcrQuery,
  BillEditor_BillOcrQueryVariables,
  BillEditor_BillQuery,
  BillEditor_BillQueryVariables,
  BillEditor_CalculateDueDateDocument,
  BillEditor_CalculateDueDateQuery,
  BillEditor_CalculateDueDateQueryVariables,
  BillEditor_CommitmentLikesDocument,
  BillEditor_CommitmentLikesQuery,
  BillEditor_CommitmentLikesQueryVariables,
  BillEditor_CommitmentsDocument,
  BillEditor_CommitmentsQuery,
  BillEditor_CommitmentsQueryVariables,
  BillEditor_CreateCommitmentDocument,
  BillEditor_CreateCommitmentMutation,
  BillEditor_CreateCommitmentMutationVariables,
  BillEditor_ProjectItemDocument,
  BillEditor_ProjectItemQuery,
  BillEditor_ProjectItemQueryVariables,
  BillEditor_ProjectItemsDocument,
  BillEditor_ProjectItemsQuery,
  BillEditor_ProjectItemsQueryVariables,
  BillEditor_ReviewReasonsDetailsDocument,
  BillEditor_ReviewReasonsDetailsQuery,
  BillEditor_ReviewReasonsDetailsQueryVariables,
  BillEditor_RunBillParserDocument,
  BillEditor_RunBillParserMutation,
  BillEditor_RunBillParserMutationVariables,
  BillEditor_SaveBillDocument,
  BillEditor_SaveBillMutation,
  BillEditor_SaveBillMutationVariables,
  BillEditor_SaveChangeEventDocument,
  BillEditor_SaveChangeEventMutation,
  BillEditor_SaveChangeEventMutationVariables,
} from "../routes/bills/BillEditor.generated";
import {
  BillDocument,
  BillIntacctSyncErrorDocument,
  BillIntacctSyncErrorQuery,
  BillIntacctSyncErrorQueryVariables,
  BillPage_BillIntacctSyncErrorDocument,
  BillPage_BillIntacctSyncErrorQuery,
  BillPage_BillIntacctSyncErrorQueryVariables,
  BillPage_CommitmentIdByChangeOrderDocument,
  BillPage_CommitmentIdByChangeOrderQuery,
  BillPage_CommitmentIdByChangeOrderQueryVariables,
  BillPage_DeleteBillDocument,
  BillPage_DeleteBillMutation,
  BillPage_DeleteBillMutationVariables,
  BillPage_NewBillChangeOrderDataDocument,
  BillPage_NewBillChangeOrderDataQuery,
  BillPage_NewBillChangeOrderDataQueryVariables,
  BillPage_NewBillCommitmentDataDocument,
  BillPage_NewBillCommitmentDataQuery,
  BillPage_NewBillCommitmentDataQueryVariables,
  BillPage_SaveApproverDocument,
  BillPage_SaveApproverMutation,
  BillPage_SaveApproverMutationVariables,
  BillPage_SaveBillDocument,
  BillPage_SaveBillMutation,
  BillPage_SaveBillMutationVariables,
  BillPage_SyncBillToIntacctDocument,
  BillPage_SyncBillToIntacctMutation,
  BillPage_SyncBillToIntacctMutationVariables,
  BillPageDocument,
  BillPageQuery,
  BillPageQueryVariables,
  BillQuery,
  BillQueryVariables,
  DeleteBillDocument,
  DeleteBillMutation,
  DeleteBillMutationVariables,
  SaveBillDocument,
  SaveBillMutation,
  SaveBillMutationVariables,
  SyncBillToIntacctDocument,
  SyncBillToIntacctMutation,
  SyncBillToIntacctMutationVariables,
} from "../routes/bills/BillPage.generated";
import {
  BillsChartsDocument,
  BillsChartsQuery,
  BillsChartsQueryVariables,
} from "../routes/bills/BillsCharts.generated";
import { BillsDocument, BillsQuery, BillsQueryVariables } from "../routes/bills/BillsPage.generated";
import {
  OtherBillCellDocument,
  OtherBillCellQuery,
  OtherBillCellQueryVariables,
} from "../routes/bills/components/OtherBillCell.generated";
import {
  SaveLienWaiverDocumentDocument,
  SaveLienWaiverDocumentMutation,
  SaveLienWaiverDocumentMutationVariables,
} from "../routes/bills/components/UploadLienWaiver.generated";
import {
  ApprovalSuperDrawer_SaveApprovalDocument,
  ApprovalSuperDrawer_SaveApprovalMutation,
  ApprovalSuperDrawer_SaveApprovalMutationVariables,
  ApprovalSuperDrawerDocument,
  ApprovalSuperDrawerQuery,
  ApprovalSuperDrawerQueryVariables,
} from "../routes/components/Approval/ApprovalSuperDrawer.generated";
import {
  ApprovalChangeEventDocument,
  ApprovalChangeEventQuery,
  ApprovalChangeEventQueryVariables,
  SaveApprovalChangeEventDocument,
  SaveApprovalChangeEventMutation,
  SaveApprovalChangeEventMutationVariables,
} from "../routes/components/Approval/changeEvents/ApprovalChangeEvent.generated";
import {
  ApprovalChangeEventBreakDownTabDocument,
  ApprovalChangeEventBreakDownTabQuery,
  ApprovalChangeEventBreakDownTabQueryVariables,
} from "../routes/components/Approval/changeEvents/ApprovalChangeEventBreakDown.generated";
import {
  ApprovalChangeEventImpactedPosTableTabDocument,
  ApprovalChangeEventImpactedPosTableTabQuery,
  ApprovalChangeEventImpactedPosTableTabQueryVariables,
} from "../routes/components/Approval/changeEvents/ApprovalChangeEventImpactedPosTable.generated";
import {
  BulkAddItemCostCodesDocument,
  BulkAddItemCostCodesQuery,
  BulkAddItemCostCodesQueryVariables,
} from "../routes/components/BulkAddItemCostCodesModal.generated";
import {
  BulkAddProjectItemsDocument,
  BulkAddProjectItemsQuery,
  BulkAddProjectItemsQueryVariables,
} from "../routes/components/BulkAddProjectItemsModal.generated";
import {
  DeleteDevelopmentCommitmentDocument,
  DeleteDevelopmentCommitmentMutation,
  DeleteDevelopmentCommitmentMutationVariables,
  DevelopmentCommitmentDocument,
  DevelopmentCommitmentQuery,
  DevelopmentCommitmentQueryVariables,
  SavePandaDocDocument,
  SavePandaDocMutation,
  SavePandaDocMutationVariables,
} from "../routes/development-commitments/DevelopmentCommitmentPage.generated";
import {
  DevelopmentCommitmentsPageDocument,
  DevelopmentCommitmentsPageMetaDataDocument,
  DevelopmentCommitmentsPageMetaDataQuery,
  DevelopmentCommitmentsPageMetaDataQueryVariables,
  DevelopmentCommitmentsPageQuery,
  DevelopmentCommitmentsPageQueryVariables,
} from "../routes/development-commitments/DevelopmentCommitmentsPage.generated";
import {
  AddCommitmentPotentialLineItemsDocument,
  AddCommitmentPotentialLineItemsQuery,
  AddCommitmentPotentialLineItemsQueryVariables,
  UpdateDevelopmentCommitmentDocument,
  UpdateDevelopmentCommitmentMutation,
  UpdateDevelopmentCommitmentMutationVariables,
} from "../routes/development-commitments/components/AddItemsModal.generated";
import {
  CreateCommitmentDataDocument,
  CreateCommitmentDataQuery,
  CreateCommitmentDataQueryVariables,
  CreateCommitmentPotentialLineItemsDocument,
  CreateCommitmentPotentialLineItemsQuery,
  CreateCommitmentPotentialLineItemsQueryVariables,
  CreateDevelopmentCommitmentDocument,
  CreateDevelopmentCommitmentMutation,
  CreateDevelopmentCommitmentMutationVariables,
} from "../routes/development-commitments/components/CreateCommitmentModal.generated";
import {
  DevelopmentCommitmentHistoryTabDocument,
  DevelopmentCommitmentHistoryTabQuery,
  DevelopmentCommitmentHistoryTabQueryVariables,
} from "../routes/development-commitments/components/HistoryTab.generated";
import {
  DeleteCommitmentLineItemsDocument,
  DeleteCommitmentLineItemsMutation,
  DeleteCommitmentLineItemsMutationVariables,
  DevelopmentCommitmentLineItemsDocument,
  DevelopmentCommitmentLineItemsQuery,
  DevelopmentCommitmentLineItemsQueryVariables,
  SaveCommitmentLineItemsDocument,
  SaveCommitmentLineItemsMutation,
  SaveCommitmentLineItemsMutationVariables,
} from "../routes/development-commitments/components/LineItemsTab.generated";
import {
  DevelopmentCommitmentOverviewTabDocument,
  DevelopmentCommitmentOverviewTabQuery,
  DevelopmentCommitmentOverviewTabQueryVariables,
  SaveDevelopmentCommitmentDocument,
  SaveDevelopmentCommitmentMutation,
  SaveDevelopmentCommitmentMutationVariables,
} from "../routes/development-commitments/components/OverviewTab.generated";
import {
  DeleteDevelopmentCommitmentProjectsAndCommitmentsDocument,
  DeleteDevelopmentCommitmentProjectsAndCommitmentsMutation,
  DeleteDevelopmentCommitmentProjectsAndCommitmentsMutationVariables,
  DevelopmentCommitmentV2ProjectsTabDocument,
  DevelopmentCommitmentV2ProjectsTabQuery,
  DevelopmentCommitmentV2ProjectsTabQueryVariables,
} from "../routes/development-commitments/components/ProjectsTab.generated";
import {
  DevelopmentCommitmentScheduleAndScopeTabDocument,
  DevelopmentCommitmentScheduleAndScopeTabQuery,
  DevelopmentCommitmentScheduleAndScopeTabQueryVariables,
} from "../routes/development-commitments/components/ScheduleAndScopeTab.generated";
import {
  DevelopmentAllLotsDocument,
  DevelopmentAllLotsQuery,
  DevelopmentAllLotsQueryVariables,
} from "../routes/developments/DevelopmentAllLots.generated";
import {
  DevelopmentDetailDocument,
  DevelopmentDetailQuery,
  DevelopmentDetailQueryVariables,
  DevelopmentsDocument,
  DevelopmentsPageMetadataDocument,
  DevelopmentsPageMetadataQuery,
  DevelopmentsPageMetadataQueryVariables,
  DevelopmentsQuery,
  DevelopmentsQueryVariables,
  SaveDevelopmentsDocument,
  SaveDevelopmentsMutation,
  SaveDevelopmentsMutationVariables,
} from "../routes/developments/Developments.generated";
import {
  AssignElevationListDocument,
  AssignElevationListQuery,
  AssignElevationListQueryVariables,
  SaveElevationAssignmentDocument,
  SaveElevationAssignmentMutation,
  SaveElevationAssignmentMutationVariables,
} from "../routes/developments/components/AssignElevationsModalButton.generated";
import {
  ItemTemplateCostUpdatesDocument,
  ItemTemplateCostUpdatesQuery,
  ItemTemplateCostUpdatesQueryVariables,
} from "../routes/developments/components/DevelopmentContractHeader.generated";
import {
  SavePriceAgreementDocumentDocument,
  SavePriceAgreementDocumentMutation,
  SavePriceAgreementDocumentMutationVariables,
} from "../routes/developments/components/UploadPriceAgreement.generated";
import {
  CohortDetailsForFormDocument,
  CohortDetailsForFormQuery,
  CohortDetailsForFormQueryVariables,
  PopulateCohortFormOptionsDocument,
  PopulateCohortFormOptionsQuery,
  PopulateCohortFormOptionsQueryVariables,
  SaveCohortsDocument,
  SaveCohortsMutation,
  SaveCohortsMutationVariables,
} from "../routes/developments/components/cohorts/CreateOrUpdateCohortModal.generated";
import {
  AssignWorkToBidContractsDocument,
  AssignWorkToBidContractsMutation,
  AssignWorkToBidContractsMutationVariables,
  ManageProjectsBudgetsStepDocument,
  ManageProjectsBudgetsStepQuery,
  ManageProjectsBudgetsStepQueryVariables,
} from "../routes/developments/components/upload/manageProjectsBudgetStep/ManageProjectsBudgetsPage.generated";
import {
  DevelopmentScheduleItemMappingPageDocument,
  DevelopmentScheduleItemMappingPageQuery,
  DevelopmentScheduleItemMappingPageQueryVariables,
} from "../routes/developments/cost-mapping/DevelopmentScheduleCostMappingPage.generated";
import {
  CostMappingScheduleTasksDocument,
  CostMappingScheduleTasksQuery,
  CostMappingScheduleTasksQueryVariables,
  SaveMapItemsStepDocument,
  SaveMapItemsStepMutation,
  SaveMapItemsStepMutationVariables,
} from "../routes/developments/cost-mapping/mapping-steps/MapItemsStep.generated";
import {
  LotSummaryChartsDocument,
  LotSummaryChartsQuery,
  LotSummaryChartsQueryVariables,
} from "../routes/developments/lot-summary/LotSummaryCharts.generated";
import {
  LotSummaryMetaDataDocument,
  LotSummaryMetaDataQuery,
  LotSummaryMetaDataQueryVariables,
  SubscribeToSequenceSheetDocument,
  SubscribeToSequenceSheetMutation,
  SubscribeToSequenceSheetMutationVariables,
} from "../routes/developments/lot-summary/LotSummaryPage.generated";
import {
  AssignWorkToBidContractDocument,
  AssignWorkToBidContractMutation,
  AssignWorkToBidContractMutationVariables,
  ConfirmTrades_ProjectItemsDocument,
  ConfirmTrades_ProjectItemsQuery,
  ConfirmTrades_ProjectItemsQueryVariables,
  ConfirmTradesStepDocument,
  ConfirmTradesStepQuery,
  ConfirmTradesStepQueryVariables,
  UnassignWorkFromBidContractDocument,
  UnassignWorkFromBidContractMutation,
  UnassignWorkFromBidContractMutationVariables,
} from "../routes/developments/lot-summary/lot-release/ConfirmTradesStep.generated";
import {
  AssignBidPackageWorkToBidContractDocument,
  AssignBidPackageWorkToBidContractMutation,
  AssignBidPackageWorkToBidContractMutationVariables,
  ConfirmTradesStepV2Document,
  ConfirmTradesStepV2Query,
  ConfirmTradesStepV2QueryVariables,
} from "../routes/developments/lot-summary/lot-release/ConfirmTradesStepV2.generated";
import {
  ReleaseToTradesPageDocument,
  ReleaseToTradesPageQuery,
  ReleaseToTradesPageQueryVariables,
} from "../routes/developments/lot-summary/lot-release/ReleaseToTradesPage.generated";
import {
  ApplyProjectReadyPlanConfigsDocument,
  ApplyProjectReadyPlanConfigsMutation,
  ApplyProjectReadyPlanConfigsMutationVariables,
  ReleaseToTradesTabDocument,
  ReleaseToTradesTabQuery,
  ReleaseToTradesTabQueryVariables,
} from "../routes/developments/lot-summary/lot-release/ReleaseToTradesTab.generated";
import {
  ReviewOrdersStepDocument,
  ReviewOrdersStepQuery,
  ReviewOrdersStepQueryVariables,
  ReviewOrdersStepReleaseCommitmentsDocument,
  ReviewOrdersStepReleaseCommitmentsMutation,
  ReviewOrdersStepReleaseCommitmentsMutationVariables,
} from "../routes/developments/lot-summary/lot-release/ReviewOrdersStep.generated";
import {
  LotSummaryDocument,
  LotSummaryQuery,
  LotSummaryQueryVariables,
} from "../routes/developments/lot-summary/lot-release/components/LotSummary.generated";
import {
  LotCheckFormDrawerDocument,
  LotCheckFormDrawerMetadataDocument,
  LotCheckFormDrawerMetadataQuery,
  LotCheckFormDrawerMetadataQueryVariables,
  LotCheckFormDrawerQuery,
  LotCheckFormDrawerQueryVariables,
  SaveProjectSiteConditionsDocument,
  SaveProjectSiteConditionsMutation,
  SaveProjectSiteConditionsMutationVariables,
  SendProjectSiteConditionsNotificationDocument,
  SendProjectSiteConditionsNotificationMutation,
  SendProjectSiteConditionsNotificationMutationVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/lot-check-form/LotCheckFormDrawer.generated";
import {
  LotCheckTableMetadataDocument,
  LotCheckTableMetadataQuery,
  LotCheckTableMetadataQueryVariables,
  SaveProjectSiteSpecificInfoDocument,
  SaveProjectSiteSpecificInfoMutation,
  SaveProjectSiteSpecificInfoMutationVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/lot-check-form/LotCheckTable.generated";
import {
  ComputedProgramDataPreviewDocument,
  ComputedProgramDataPreviewQuery,
  ComputedProgramDataPreviewQueryVariables,
  LotDetailDrawerDocument,
  LotDetailDrawerQuery,
  LotDetailDrawerQueryVariables,
  SaveProjectLotDetailDocument,
  SaveProjectLotDetailMutation,
  SaveProjectLotDetailMutationVariables,
  SaveProjectReadyPlanConfigDocument,
  SaveProjectReadyPlanConfigMutation,
  SaveProjectReadyPlanConfigMutationVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/lot-detail/LotDetailDrawer.generated";
import {
  CohortDevelopmentsDocument,
  CohortDevelopmentsQuery,
  CohortDevelopmentsQueryVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/move-project-button-menu/MoveProjectButtonMenu.generated";
import {
  UpdateProjectCohortDocument,
  UpdateProjectCohortMutation,
  UpdateProjectCohortMutationVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/move-project-modal/MoveProjectModal.generated";
import {
  LotSequenceSheetTableDocument,
  LotSequenceSheetTableMetadataDocument,
  LotSequenceSheetTableMetadataQuery,
  LotSequenceSheetTableMetadataQueryVariables,
  LotSequenceSheetTableQuery,
  LotSequenceSheetTableQueryVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/sequence-sheet-table/LotSequenceSheetTable.generated";
import {
  ReleasePOsStepDocument,
  ReleasePOsStepQuery,
  ReleasePOsStepQueryVariables,
  UpdateCommitmentAutoReleaseStatusDocument,
  UpdateCommitmentAutoReleaseStatusMutation,
  UpdateCommitmentAutoReleaseStatusMutationVariables,
} from "../routes/developments/manage-pos-wizard/ReleasePOsStep.generated";
import {
  VoidPOsStepDocument,
  VoidPOsStepQuery,
  VoidPOsStepQueryVariables,
} from "../routes/developments/manage-pos-wizard/VoidPOsStep.generated";
import {
  ReadyPlansListDocument,
  ReadyPlansListQuery,
  ReadyPlansListQueryVariables,
} from "../routes/developments/plan-and-options/PlanAndOptionsPage.generated";
import {
  AddOptionsMetadataDocument,
  AddOptionsMetadataQuery,
  AddOptionsMetadataQueryVariables,
  AddOptionsPageDocument,
  AddOptionsPageQuery,
  AddOptionsPageQueryVariables,
  DeleteReadyPlanOptionProgramDataModificationDocument,
  DeleteReadyPlanOptionProgramDataModificationMutation,
  DeleteReadyPlanOptionProgramDataModificationMutationVariables,
  ReadyPlanOptionsListDocument,
  ReadyPlanOptionsListQuery,
  ReadyPlanOptionsListQueryVariables,
  ReadyPlanPageMetadataDocument,
  ReadyPlanPageMetadataQuery,
  ReadyPlanPageMetadataQueryVariables,
  SaveReadyPlanDocument,
  SaveReadyPlanMutation,
  SaveReadyPlanMutationVariables,
  SaveReadyPlanOptionProgramDataModificationDocument,
  SaveReadyPlanOptionProgramDataModificationMutation,
  SaveReadyPlanOptionProgramDataModificationMutationVariables,
  SaveReadyPlanOptionsDocument,
  SaveReadyPlanOptionsModalDocument,
  SaveReadyPlanOptionsModalMutation,
  SaveReadyPlanOptionsModalMutationVariables,
  SaveReadyPlanOptionsMutation,
  SaveReadyPlanOptionsMutationVariables,
} from "../routes/developments/plan-and-options/PlanDetailsPage.generated";
import {
  SaveReadyPlansDocument,
  SaveReadyPlansMutation,
  SaveReadyPlansMutationVariables,
} from "../routes/developments/plan-and-options/components/CreateReadyPlanModalButton.generated";
import {
  PlanDetailsStepDocument,
  PlanDetailsStepMetadataDocument,
  PlanDetailsStepMetadataQuery,
  PlanDetailsStepMetadataQueryVariables,
  PlanDetailsStepQuery,
  PlanDetailsStepQueryVariables,
  SavePlanDetailsDocument,
  SavePlanDetailsMutation,
  SavePlanDetailsMutationVariables,
} from "../routes/developments/plan-and-options/options/1.PlanDetailsStep.generated";
import {
  SaveReadyPlanOptionGroupsDocument,
  SaveReadyPlanOptionGroupsMutation,
  SaveReadyPlanOptionGroupsMutationVariables,
} from "../routes/developments/plan-and-options/options/3.ConfigureOptionsStep.generated";
import {
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDocument,
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation,
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationVariables,
  ChooseOptionsStepBodyV1Document,
  ChooseOptionsStepBodyV1Query,
  ChooseOptionsStepBodyV1QueryVariables,
} from "../routes/developments/plan-and-options/options/components/ChooseOptionsStepBodyV1.generated";
import {
  EditOptionsHeaderDocument,
  EditOptionsHeaderQuery,
  EditOptionsHeaderQueryVariables,
} from "../routes/developments/plan-and-options/options/components/EditOptionsHeader.generated";
import {
  BidContractRevisionLineItemsPageDocument,
  BidContractRevisionLineItemsPageQuery,
  BidContractRevisionLineItemsPageQueryVariables,
  DeleteBidContractLineItemsDocument,
  DeleteBidContractLineItemsMutation,
  DeleteBidContractLineItemsMutationVariables,
  SaveBidContractLineItemDocument,
  SaveBidContractLineItemMutation,
  SaveBidContractLineItemMutationVariables,
  SaveBidContractLineItemsDocument,
  SaveBidContractLineItemsMutation,
  SaveBidContractLineItemsMutationVariables,
} from "../routes/developments/procurement/DevelopmentContractLineItemsPage.generated";
import {
  BidContractRevisionOverviewDocument,
  BidContractRevisionOverviewQuery,
  BidContractRevisionOverviewQueryVariables,
} from "../routes/developments/procurement/DevelopmentContractOverviewPage.generated";
import {
  BidContractDocument,
  BidContractQuery,
  BidContractQueryVariables,
  BidContractRevisionDocument,
  BidContractRevisionQuery,
  BidContractRevisionQueryVariables,
  DeleteBidContractRevisionDocument,
  DeleteBidContractRevisionMutation,
  DeleteBidContractRevisionMutationVariables,
  InternallySignBidContractRevisionDocument,
  InternallySignBidContractRevisionMutation,
  InternallySignBidContractRevisionMutationVariables,
  SaveBidContractDocument,
  SaveBidContractMutation,
  SaveBidContractMutationVariables,
  SaveBidContractRevisionDocument,
  SaveBidContractRevisionMutation,
  SaveBidContractRevisionMutationVariables,
} from "../routes/developments/procurement/DevelopmentContractPage.generated";
import {
  DevelopmentContractDocument,
  DevelopmentContractQuery,
  DevelopmentContractQueryVariables,
} from "../routes/developments/procurement/DevelopmentContractsTable.generated";
import {
  DevelopmentProcurementDocument,
  DevelopmentProcurementQuery,
  DevelopmentProcurementQueryVariables,
} from "../routes/developments/procurement/DevelopmentProcurementPage.generated";
import {
  CreateBidContractDocument,
  CreateBidContractMutation,
  CreateBidContractMutationVariables,
  DevelopmentTradePartnersDocument,
  DevelopmentTradePartnersQuery,
  DevelopmentTradePartnersQueryVariables,
} from "../routes/developments/procurement/components/CreateDevelopmentContractButton.generated";
import {
  DevelopmentTemplateItemsModalDocument,
  DevelopmentTemplateItemsModalMetadataDocument,
  DevelopmentTemplateItemsModalMetadataQuery,
  DevelopmentTemplateItemsModalMetadataQueryVariables,
  DevelopmentTemplateItemsModalQuery,
  DevelopmentTemplateItemsModalQueryVariables,
} from "../routes/developments/procurement/components/DevelopmentTemplateItemsModal.generated";
import {
  RecentlyActivatedItemTemplatesDocument,
  RecentlyActivatedItemTemplatesQuery,
  RecentlyActivatedItemTemplatesQueryVariables,
} from "../routes/developments/procurement/components/GenerateNewBidRequestNotice.generated";
import {
  ComputeProductOfferingConfigCostsDocument,
  ComputeProductOfferingConfigCostsQuery,
  ComputeProductOfferingConfigCostsQueryVariables,
} from "../routes/developments/product-offering-configs/ProductOfferingConfigsComparePage.generated";
import {
  ProductOfferingCardDocument,
  ProductOfferingCardQuery,
  ProductOfferingCardQueryVariables,
} from "../routes/developments/product-offering-configs/components/compare-product-configs/ProductOfferingCard.generated";
import {
  FilteredProjectsTableDocument,
  FilteredProjectsTableQuery,
  FilteredProjectsTableQueryVariables,
} from "../routes/developments/product-offerings/FilteredProjectsTable.generated";
import {
  ProductOfferingApplyToProjectDocument,
  ProductOfferingApplyToProjectMutation,
  ProductOfferingApplyToProjectMutationVariables,
} from "../routes/developments/product-offerings/ProductOfferingApplyToProjectsPage.generated";
import {
  ProductOfferingCheckoutStartingConfig_CalculatedConfigDocument,
  ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery,
  ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables,
  ProductOfferingCheckoutStartingConfig_SaveDocument,
  ProductOfferingCheckoutStartingConfig_SaveMutation,
  ProductOfferingCheckoutStartingConfig_SaveMutationVariables,
  ProductOfferingCheckoutStartingConfigPageDocument,
  ProductOfferingCheckoutStartingConfigPageQuery,
  ProductOfferingCheckoutStartingConfigPageQueryVariables,
} from "../routes/developments/product-offerings/ProductOfferingCheckoutStartingConfigPage.generated";
import {
  ProductOfferingCostCalculatorMetaDocument,
  ProductOfferingCostCalculatorMetaQuery,
  ProductOfferingCostCalculatorMetaQueryVariables,
  ProductOfferingCostCalculatorPage_CheckoutConfigDocument,
  ProductOfferingCostCalculatorPage_CheckoutConfigQuery,
  ProductOfferingCostCalculatorPage_CheckoutConfigQueryVariables,
  ProductOfferingCostCalculatorPage_ComputeDocument,
  ProductOfferingCostCalculatorPage_ComputeQuery,
  ProductOfferingCostCalculatorPage_ComputeQueryVariables,
} from "../routes/developments/product-offerings/ProductOfferingCostCalculatorPage.generated";
import {
  ProductOffering_InsideMapsPacketDocument,
  ProductOffering_InsideMapsPacketQuery,
  ProductOffering_InsideMapsPacketQueryVariables,
  ProductOffering_PromoteToCheckoutDocument,
  ProductOffering_PromoteToCheckoutMutation,
  ProductOffering_PromoteToCheckoutMutationVariables,
  ProductOffering_RunCheckoutPricingReportDocument,
  ProductOffering_RunCheckoutPricingReportMutation,
  ProductOffering_RunCheckoutPricingReportMutationVariables,
  ProductOffering_SaveProductOfferingDocument,
  ProductOffering_SaveProductOfferingMutation,
  ProductOffering_SaveProductOfferingMutationVariables,
  ProductOfferingPageDocument,
  ProductOfferingPageQuery,
  ProductOfferingPageQueryVariables,
} from "../routes/developments/product-offerings/ProductOfferingPage.generated";
import {
  ProductOfferingScopeMetaDocument,
  ProductOfferingScopeMetaQuery,
  ProductOfferingScopeMetaQueryVariables,
  ProductOfferingScopePageDocument,
  ProductOfferingScopePageQuery,
  ProductOfferingScopePageQueryVariables,
} from "../routes/developments/product-offerings/ProductOfferingScopePage.generated";
import {
  ProductOfferingScopePageSideBarDocument,
  ProductOfferingScopePageSideBarQuery,
  ProductOfferingScopePageSideBarQueryVariables,
} from "../routes/developments/product-offerings/ProductOfferingScopePageSideBar.generated";
import {
  TestGroupDependenciesLineItemsDocument,
  TestGroupDependenciesLineItemsQuery,
  TestGroupDependenciesLineItemsQueryVariables,
} from "../routes/developments/product-offerings/components/TestGroupDependenciesModal.generated";
import {
  AcceptProductOfferingUpdatesDocument,
  AcceptProductOfferingUpdatesMutation,
  AcceptProductOfferingUpdatesMutationVariables,
  PofAvailableUpdatesDocument,
  PofAvailableUpdatesQuery,
  PofAvailableUpdatesQueryVariables,
} from "../routes/developments/product-offerings/components/UpdatesAvailable.generated";
import {
  ProductOfferingVersionHistoryDocument,
  ProductOfferingVersionHistoryQuery,
  ProductOfferingVersionHistoryQueryVariables,
  ProductOfferingVersionTlivDetailsDocument,
  ProductOfferingVersionTlivDetailsQuery,
  ProductOfferingVersionTlivDetailsQueryVariables,
} from "../routes/developments/product-offerings/version-history/ProductOfferingVersionHistory.generated";
import {
  DevelopmentPurchaseOrderDocument,
  DevelopmentPurchaseOrderFiltersDocument,
  DevelopmentPurchaseOrderFiltersQuery,
  DevelopmentPurchaseOrderFiltersQueryVariables,
  DevelopmentPurchaseOrderQuery,
  DevelopmentPurchaseOrderQueryVariables,
  SaveCommitmentsDocument,
  SaveCommitmentsMutation,
  SaveCommitmentsMutationVariables,
} from "../routes/developments/purchase-orders/PurchaseOrdersPage.generated";
import {
  ReassignPurchaseOrdersDocument,
  ReassignPurchaseOrdersQuery,
  ReassignPurchaseOrdersQueryVariables,
  SaveReassignPurchaseOrdersDocument,
  SaveReassignPurchaseOrdersMutation,
  SaveReassignPurchaseOrdersMutationVariables,
} from "../routes/developments/reassign-purchase-orders/ReassignPurchaseOrdersPage.generated";
import {
  TaskLookaheadDocument,
  TaskLookaheadQuery,
  TaskLookaheadQueryVariables,
  TaskLookaheadRightPaneDocument,
  TaskLookaheadRightPaneQuery,
  TaskLookaheadRightPaneQueryVariables,
} from "../routes/developments/reports/task-lookahead/TaskLookaheadPage.generated";
import {
  CompletedMilestonesByProjectDocument,
  CompletedMilestonesByProjectQuery,
  CompletedMilestonesByProjectQueryVariables,
  DevelopmentBulkScheduleDocument,
  DevelopmentBulkScheduleProjectsDocument,
  DevelopmentBulkScheduleProjectsQuery,
  DevelopmentBulkScheduleProjectsQueryVariables,
  DevelopmentBulkScheduleQuery,
  DevelopmentBulkScheduleQueryVariables,
  DevelopmentBulkScheduleSaveScheduleTaskDocument,
  DevelopmentBulkScheduleSaveScheduleTaskMutation,
  DevelopmentBulkScheduleSaveScheduleTaskMutationVariables,
  ScheduleTasksByPhasesDocument,
  ScheduleTasksByPhasesQuery,
  ScheduleTasksByPhasesQueryVariables,
} from "../routes/developments/schedule/DevelopmentBulkSchedulePage.generated";
import {
  PhaseTaskListPaneDocument,
  PhaseTaskListPaneQuery,
  PhaseTaskListPaneQueryVariables,
} from "../routes/developments/schedule/components/PhaseTaskListPane.generated";
import {
  StandaloneTaskDetailPaneDocument,
  StandaloneTaskDetailPaneQuery,
  StandaloneTaskDetailPaneQueryVariables,
} from "../routes/developments/schedule/components/StandaloneTaskDetailPane.generated";
import {
  DevelopmentScheduleDocument,
  DevelopmentScheduleQuery,
  DevelopmentScheduleQueryVariables,
} from "../routes/developments/schedule/development-level-schedule/DevelopmentSchedulePage.generated";
import {
  DevelopmentHolidayCard_AllProjectsDocument,
  DevelopmentHolidayCard_AllProjectsQuery,
  DevelopmentHolidayCard_AllProjectsQueryVariables,
} from "../routes/developments/settings/components/DevelopmentHolidayCard.generated";
import {
  DevelopmentTeamMembersDocument,
  DevelopmentTeamMembersQuery,
  DevelopmentTeamMembersQueryVariables,
  UpdateDevelopmentProjectRoleDocument,
  UpdateDevelopmentProjectRoleMutation,
  UpdateDevelopmentProjectRoleMutationVariables,
} from "../routes/developments/team-members/DevelopmentTeamMembers.generated";
import {
  CreateNewItemTemplateVersionsDocument,
  CreateNewItemTemplateVersionsMutation,
  CreateNewItemTemplateVersionsMutationVariables,
  DeleteItemTemplatesDocument,
  DeleteItemTemplatesMutation,
  DeleteItemTemplatesMutationVariables,
  DevelopmentScopeTemplatePageDocument,
  DevelopmentScopeTemplatePageQuery,
  DevelopmentScopeTemplatePageQueryVariables,
} from "../routes/developments/templates/DevelopmentScopeTemplatePage.generated";
import {
  DevelopmentScopeTemplatesDocument,
  DevelopmentScopeTemplatesMetadataDocument,
  DevelopmentScopeTemplatesMetadataQuery,
  DevelopmentScopeTemplatesMetadataQueryVariables,
  DevelopmentScopeTemplatesQuery,
  DevelopmentScopeTemplatesQueryVariables,
} from "../routes/developments/templates/DevelopmentScopeTemplates.generated";
import {
  ScopeTemplateCostCalculatorPage_ComputeDocument,
  ScopeTemplateCostCalculatorPage_ComputeQuery,
  ScopeTemplateCostCalculatorPage_ComputeQueryVariables,
  ScopeTemplateCostCalculatorPageDocument,
  ScopeTemplateCostCalculatorPageQuery,
  ScopeTemplateCostCalculatorPageQueryVariables,
} from "../routes/developments/templates/ScopeTemplateCostCalculatorPage.generated";
import {
  SaveItemTemplatesDocument,
  SaveItemTemplatesMutation,
  SaveItemTemplatesMutationVariables,
  ScopeReasonCodesDocument,
  ScopeReasonCodesQuery,
  ScopeReasonCodesQueryVariables,
} from "../routes/developments/templates/components/AddItemTemplatesReasonCodesModal.generated";
import {
  AddScopeTemplateItemsDocument,
  AddScopeTemplateItemsQuery,
  AddScopeTemplateItemsQueryVariables,
} from "../routes/developments/templates/components/AddScopeTemplateItems.generated";
import {
  ArchiveItemTemplateVersionsDocument,
  ArchiveItemTemplateVersionsMutation,
  ArchiveItemTemplateVersionsMutationVariables,
} from "../routes/developments/templates/components/ArchiveItemTemplatesModal.generated";
import {
  CopyItemTemplateDocument,
  CopyItemTemplateMutation,
  CopyItemTemplateMutationVariables,
  CopyLineItemsModalDocument,
  CopyLineItemsModalQuery,
  CopyLineItemsModalQueryVariables,
} from "../routes/developments/templates/components/CopyLineItemsModalButton.generated";
import {
  SaveItemTemplateHeaderDocument,
  SaveItemTemplateHeaderMutation,
  SaveItemTemplateHeaderMutationVariables,
  SaveScopeTemplateHeader_ReadyPlanDocument,
  SaveScopeTemplateHeader_ReadyPlanMutation,
  SaveScopeTemplateHeader_ReadyPlanMutationVariables,
} from "../routes/developments/templates/components/ScopeTemplateHeader.generated";
import {
  ScopeTemplateApplyStepApplyToProjectDocument,
  ScopeTemplateApplyStepApplyToProjectMutation,
  ScopeTemplateApplyStepApplyToProjectMutationVariables,
  ScopeTemplatesApplyStepDocument,
  ScopeTemplatesApplyStepMetadataDocument,
  ScopeTemplatesApplyStepMetadataQuery,
  ScopeTemplatesApplyStepMetadataQueryVariables,
  ScopeTemplatesApplyStepQuery,
  ScopeTemplatesApplyStepQueryVariables,
} from "../routes/developments/templates/review-and-publish/components/ApplyToProjectsStep.generated";
import {
  ActivateTemplateVersionsReviewStepDocument,
  ActivateTemplateVersionsReviewStepMutation,
  ActivateTemplateVersionsReviewStepMutationVariables,
  SaveScopeChangeReasonReviewStepDocument,
  SaveScopeChangeReasonReviewStepMutation,
  SaveScopeChangeReasonReviewStepMutationVariables,
  ScopeTemplateItemsReviewStepTableDocument,
  ScopeTemplateItemsReviewStepTableQuery,
  ScopeTemplateItemsReviewStepTableQueryVariables,
  ScopeTemplatesReviewStepDocument,
  ScopeTemplatesReviewStepQuery,
  ScopeTemplatesReviewStepQueryVariables,
  ScopeTemplatesReviewStepTableDocument,
  ScopeTemplatesReviewStepTableQuery,
  ScopeTemplatesReviewStepTableQueryVariables,
} from "../routes/developments/templates/review-and-publish/components/ReviewStep.generated";
import {
  ExpenseAdminTeamMemberProjectsDocument,
  ExpenseAdminTeamMemberProjectsQuery,
  ExpenseAdminTeamMemberProjectsQueryVariables,
} from "../routes/expenses/ExpensesAdmin.generated";
import {
  CommentStreamDocument,
  CommentStreamQuery,
  CommentStreamQueryVariables,
  InboxPageMetaDocument,
  InboxPageMetaQuery,
  InboxPageMetaQueryVariables,
  UserRelevantCommentStreamsDocument,
  UserRelevantCommentStreamsQuery,
  UserRelevantCommentStreamsQueryVariables,
} from "../routes/inbox/InboxPage.generated";
import {
  CommentableInboxDocument,
  CommentableInboxQuery,
  CommentableInboxQueryVariables,
} from "../routes/inbox/components/CommentableInbox.generated";
import {
  InboxBellDocument,
  InboxBellQuery,
  InboxBellQueryVariables,
} from "../routes/inbox/components/InboxBell.generated";
import {
  CommentStreamCommentsDocument,
  CommentStreamCommentsQuery,
  CommentStreamCommentsQueryVariables,
} from "../routes/inbox/components/InboxCommentStream.generated";
import {
  InvoicesPageDocument,
  InvoicesPageQuery,
  InvoicesPageQueryVariables,
} from "../routes/invoices/InvoicesPage.generated";
import {
  GlobalSearchModalDocument,
  GlobalSearchModalQuery,
  GlobalSearchModalQueryVariables,
} from "../routes/layout/global-nav/GlobalSearchModal.generated";
import {
  TemplatesDocument,
  TemplatesQuery,
  TemplatesQueryVariables,
} from "../routes/libraries/TemplatesPage.generated";
import {
  CopyDesignPackage_CopyDesignPackageDocument,
  CopyDesignPackage_CopyDesignPackageMutation,
  CopyDesignPackage_CopyDesignPackageMutationVariables,
  CopyDesignPackage_ReadyPlanLikeDocument,
  CopyDesignPackage_ReadyPlanLikeQuery,
  CopyDesignPackage_ReadyPlanLikeQueryVariables,
} from "../routes/libraries/design-catalog/CopyDesignPackageModal.generated";
import {
  DesignCatalogsTableDocument,
  DesignCatalogsTableQuery,
  DesignCatalogsTableQueryVariables,
} from "../routes/libraries/design-catalog/DesignCatalogsPage.generated";
import {
  CompareModeDesignPackageDocument,
  CompareModeDesignPackageQuery,
  CompareModeDesignPackageQueryVariables,
  CompareModeDesignPackageTlisDocument,
  CompareModeDesignPackageTlisQuery,
  CompareModeDesignPackageTlisQueryVariables,
} from "../routes/libraries/design-catalog/compare-mode/DesignPackageCompareMode.generated";
import {
  AddSlotModal_PotentialPlaceholdersDocument,
  AddSlotModal_PotentialPlaceholdersQuery,
  AddSlotModal_PotentialPlaceholdersQueryVariables,
  AddSlotModal_SelectedPlaceholdersDocument,
  AddSlotModal_SelectedPlaceholdersQuery,
  AddSlotModal_SelectedPlaceholdersQueryVariables,
} from "../routes/libraries/design-catalog/components/AddSlotModal.generated";
import {
  PlaceholderProductSearch_PossibleMaterialsDocument,
  PlaceholderProductSearch_PossibleMaterialsQuery,
  PlaceholderProductSearch_PossibleMaterialsQueryVariables,
  PlaceholderProductSearch_RequirementsTliDocument,
  PlaceholderProductSearch_RequirementsTliQuery,
  PlaceholderProductSearch_RequirementsTliQueryVariables,
} from "../routes/libraries/design-catalog/components/PlaceholderProductSearch.generated";
import {
  DesignPackageConfiguratorDocument,
  DesignPackageConfiguratorQuery,
  DesignPackageConfiguratorQueryVariables,
  SaveDesignPackageCycleDocument,
  SaveDesignPackageCycleMutation,
  SaveDesignPackageCycleMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/DesignPackageConfigurator.generated";
import {
  DesignPackageProductCardPage_MaterialVariantDocument,
  DesignPackageProductCardPage_MaterialVariantQuery,
  DesignPackageProductCardPage_MaterialVariantQueryVariables,
  DesignPackageProductCardPage_OptionCombinationsDocument,
  DesignPackageProductCardPage_OptionCombinationsQuery,
  DesignPackageProductCardPage_OptionCombinationsQueryVariables,
  DesignPackageProductCardPage_ProductTliDocument,
  DesignPackageProductCardPage_ProductTliQuery,
  DesignPackageProductCardPage_ProductTliQueryVariables,
  DesignPackageProductCardPage_SaveTakeoffLineItemDocument,
  DesignPackageProductCardPage_SaveTakeoffLineItemMutation,
  DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/DesignPackageProductCardPage.generated";
import {
  AddProductTliPlaceholderDocument,
  AddProductTliPlaceholderQuery,
  AddProductTliPlaceholderQueryVariables,
  DesignPackageAddProductMetadataDocument,
  DesignPackageAddProductMetadataQuery,
  DesignPackageAddProductMetadataQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/AddProductPage.generated";
import {
  AddToOptionModal_PotentialOptionsDocument,
  AddToOptionModal_PotentialOptionsQuery,
  AddToOptionModal_PotentialOptionsQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/AddToOptionModal.generated";
import {
  CopyDesignPackageCardsDocument,
  CopyDesignPackageCardsModalDocument,
  CopyDesignPackageCardsModalQuery,
  CopyDesignPackageCardsModalQueryVariables,
  CopyDesignPackageCardsMutation,
  CopyDesignPackageCardsMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/CopyDesignPackageCardsModal.generated";
import {
  SaveDesignPackageDocument,
  SaveDesignPackageMutation,
  SaveDesignPackageMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageButtonMenu.generated";
import {
  DeleteAltenratesConfirmationModalDocument,
  DeleteAltenratesConfirmationModalQuery,
  DeleteAltenratesConfirmationModalQueryVariables,
  DeleteDpAlternateRplDocument,
  DeleteDpAlternateRplMutation,
  DeleteDpAlternateRplMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageDeleteAlternatesConfirmationModal.generated";
import {
  DesignPackageDesignNotePane_MetadataDocument,
  DesignPackageDesignNotePane_MetadataQuery,
  DesignPackageDesignNotePane_MetadataQueryVariables,
  DesignPackageDesignNotePaneDocument,
  DesignPackageDesignNotePaneQuery,
  DesignPackageDesignNotePaneQueryVariables,
  SaveReadyPlanDesignNoteDocument,
  SaveReadyPlanDesignNoteMutation,
  SaveReadyPlanDesignNoteMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageDesignNotePane.generated";
import {
  DesignPackageItemSlotEditor_DeleteTliDocument,
  DesignPackageItemSlotEditor_DeleteTliMutation,
  DesignPackageItemSlotEditor_DeleteTliMutationVariables,
  DesignPackageItemSlotEditorDocument,
  DesignPackageItemSlotEditorQuery,
  DesignPackageItemSlotEditorQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageItemSlotEditor.generated";
import {
  DesignPackagePruneSlotsModal_DataDocument,
  DesignPackagePruneSlotsModal_DataQuery,
  DesignPackagePruneSlotsModal_DataQueryVariables,
  DesignPackagePruneSlotsModal_SaveDraftDocument,
  DesignPackagePruneSlotsModal_SaveDraftMutation,
  DesignPackagePruneSlotsModal_SaveDraftMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackagePruneSlotsModal.generated";
import {
  DesignPackageRequiredOptionsPage_AddOnsDocument,
  DesignPackageRequiredOptionsPage_AddOnsQuery,
  DesignPackageRequiredOptionsPage_AddOnsQueryVariables,
  DesignPackageRequiredOptionsPage_CombinationsDocument,
  DesignPackageRequiredOptionsPage_CombinationsQuery,
  DesignPackageRequiredOptionsPage_CombinationsQueryVariables,
  DesignPackageRequiredOptionsPageDocument,
  DesignPackageRequiredOptionsPageQuery,
  DesignPackageRequiredOptionsPageQueryVariables,
  SaveDesignPackageRequiredOptionsDocument,
  SaveDesignPackageRequiredOptionsMutation,
  SaveDesignPackageRequiredOptionsMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageRequiredOptionsPage.generated";
import {
  DesignPackageRoomAlternatesDrawerDocument,
  DesignPackageRoomAlternatesDrawerQuery,
  DesignPackageRoomAlternatesDrawerQueryVariables,
  SaveDpRplAlternateLocationsDocument,
  SaveDpRplAlternateLocationsMutation,
  SaveDpRplAlternateLocationsMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageRoomAlternatesDrawer.generated";
import {
  CreateAlternateLocationDocument,
  CreateAlternateLocationMutation,
  CreateAlternateLocationMutationVariables,
  DesignPackageSlotsDocument,
  DesignPackageSlotsQuery,
  DesignPackageSlotsQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageSlotsLeftNav.generated";
import {
  AcceptDesignUpdatesDocument,
  AcceptDesignUpdatesMutation,
  AcceptDesignUpdatesMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignUpdatesAvailableButton.generated";
import {
  RequestPlanPackageSlotsModal_CreateIncomingSlotsDocument,
  RequestPlanPackageSlotsModal_CreateIncomingSlotsMutation,
  RequestPlanPackageSlotsModal_CreateIncomingSlotsMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/RequestPlanPackageSlotsModal.generated";
import {
  AddNewDesignPackageSlotModal_CreateSlotDocument,
  AddNewDesignPackageSlotModal_CreateSlotMutation,
  AddNewDesignPackageSlotModal_CreateSlotMutationVariables,
  AddNewDesignPackageSlotModal_MaterialAttributeDimensionsDocument,
  AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery,
  AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables,
  AddNewDesignPackageSlotModalDocument,
  AddNewDesignPackageSlotModalQuery,
  AddNewDesignPackageSlotModalQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/routes/new/AddNewDesignPackageSlotModal.generated";
import {
  ProductSearchPage_CurrentMaterialDocument,
  ProductSearchPage_CurrentMaterialQuery,
  ProductSearchPage_CurrentMaterialQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/routes/search/ProductSearchPage.generated";
import {
  FinishScheduleDesignPackageDocument,
  FinishScheduleDesignPackageMetadataDocument,
  FinishScheduleDesignPackageMetadataQuery,
  FinishScheduleDesignPackageMetadataQueryVariables,
  FinishScheduleDesignPackageQuery,
  FinishScheduleDesignPackageQueryVariables,
  FinishScheduleDesignPackageTlisDocument,
  FinishScheduleDesignPackageTlisQuery,
  FinishScheduleDesignPackageTlisQueryVariables,
} from "../routes/libraries/design-catalog/finish-schedules/FinishSchedule.generated";
import {
  EditDesignPackageDocument,
  EditDesignPackageQuery,
  EditDesignPackageQueryVariables,
  MakeNewDesignPackageDocument,
  MakeNewDesignPackageMutation,
  MakeNewDesignPackageMutationVariables,
  NewDesignPackage_GlobalOptionGroupsDocument,
  NewDesignPackage_GlobalOptionGroupsQuery,
  NewDesignPackage_GlobalOptionGroupsQueryVariables,
  NewDesignPackagePlanPackagesDocument,
  NewDesignPackagePlanPackagesQuery,
  NewDesignPackagePlanPackagesQueryVariables,
  PreselectOptionsFromPlanPackagesDocument,
  PreselectOptionsFromPlanPackagesQuery,
  PreselectOptionsFromPlanPackagesQueryVariables,
} from "../routes/libraries/design-catalog/new-design-catalog-wizard/NewDesignPackage.generated";
import {
  DeactivatePersonalizationGroupDocument,
  DeactivatePersonalizationGroupMutation,
  DeactivatePersonalizationGroupMutationVariables,
  DesignPackagePersonalizationGroupsPageDocument,
  DesignPackagePersonalizationGroupsPageQuery,
  DesignPackagePersonalizationGroupsPageQueryVariables,
} from "../routes/libraries/design-catalog/personalization-groups/DesignPackagePersonalizationGroupsPage.generated";
import {
  EditPersonalizationOptionWizard_CombinationsDocument,
  EditPersonalizationOptionWizard_CombinationsQuery,
  EditPersonalizationOptionWizard_CombinationsQueryVariables,
  EditPersonalizationOptionWizard_MaterialVariantDocument,
  EditPersonalizationOptionWizard_MaterialVariantQuery,
  EditPersonalizationOptionWizard_MaterialVariantQueryVariables,
  EditPersonalizationOptionWizardDocument,
  EditPersonalizationOptionWizardQuery,
  EditPersonalizationOptionWizardQueryVariables,
  SavePersonalizationRpogWizardDocument,
  SavePersonalizationRpogWizardMutation,
  SavePersonalizationRpogWizardMutationVariables,
} from "../routes/libraries/design-catalog/personalization-option/EditPersonalizationOptionWizard.generated";
import {
  DesignPackageVersionHistoryDocument,
  DesignPackageVersionHistoryQuery,
  DesignPackageVersionHistoryQueryVariables,
} from "../routes/libraries/design-catalog/version-history/DesignPackageVersionHistoryPage.generated";
import {
  GlobalOptionFormDocument,
  GlobalOptionFormQuery,
  GlobalOptionFormQueryVariables,
  GlobalOptionFormTypesDocument,
  GlobalOptionFormTypesQuery,
  GlobalOptionFormTypesQueryVariables,
  SaveGlobalOptionFormDocument,
  SaveGlobalOptionFormMutation,
  SaveGlobalOptionFormMutationVariables,
} from "../routes/libraries/global-options-v2/GlobalOptionForm.generated";
import {
  GlobalOptionsPageV2Document,
  GlobalOptionsPageV2MetadataDocument,
  GlobalOptionsPageV2MetadataQuery,
  GlobalOptionsPageV2MetadataQueryVariables,
  GlobalOptionsPageV2Query,
  GlobalOptionsPageV2QueryVariables,
  SaveGlobalOptionsPageV2Document,
  SaveGlobalOptionsPageV2Mutation,
  SaveGlobalOptionsPageV2MutationVariables,
} from "../routes/libraries/global-options-v2/GlobalOptionsPageV2.generated";
import {
  GlobalOptionDrawerDocument,
  GlobalOptionDrawerQuery,
  GlobalOptionDrawerQueryVariables,
  OptionDrawerMetadataDocument,
  OptionDrawerMetadataQuery,
  OptionDrawerMetadataQueryVariables,
  SaveGlobalOptionGroupDocument,
  SaveGlobalOptionGroupMutation,
  SaveGlobalOptionGroupMutationVariables,
  SaveGlobalOptionsDrawerDocument,
  SaveGlobalOptionsDrawerMutation,
  SaveGlobalOptionsDrawerMutationVariables,
} from "../routes/libraries/global-options/GlobalOptionDrawer.generated";
import {
  GlobalOptionsDocument,
  GlobalOptionsIdsDocument,
  GlobalOptionsIdsQuery,
  GlobalOptionsIdsQueryVariables,
  GlobalOptionsPageMetadataDocument,
  GlobalOptionsPageMetadataQuery,
  GlobalOptionsPageMetadataQueryVariables,
  GlobalOptionsQuery,
  GlobalOptionsQueryVariables,
  SaveGlobalOptionsDocument,
  SaveGlobalOptionsMutation,
  SaveGlobalOptionsMutationVariables,
} from "../routes/libraries/global-options/GlobalOptions.generated";
import {
  BidItemPageDocument,
  BidItemPageOptionsDocument,
  BidItemPageOptionsQuery,
  BidItemPageOptionsQueryVariables,
  BidItemPageQuery,
  BidItemPageQueryVariables,
  SaveBidItemDocument,
  SaveBidItemMutation,
  SaveBidItemMutationVariables,
} from "../routes/libraries/item-catalog/BidItemPage.generated";
import {
  ItemCatalogDocument,
  ItemCatalogQuery,
  ItemCatalogQueryVariables,
} from "../routes/libraries/item-catalog/ItemCatalogPage.generated";
import {
  BidItemSuperDrawerDetailsDocument,
  BidItemSuperDrawerDetailsQuery,
  BidItemSuperDrawerDetailsQueryVariables,
} from "../routes/libraries/item-catalog/components/BidItemSuperDrawer.generated";
import {
  BidItemAttributesDocument,
  BidItemAttributesQuery,
  BidItemAttributesQueryVariables,
} from "../routes/libraries/item-catalog/components/ItemCatalogFilter.generated";
import {
  BidItemCostHistoryDocument,
  BidItemCostHistoryQuery,
  BidItemCostHistoryQueryVariables,
} from "../routes/libraries/item-catalog/components/tabs/BidItemCostHistoryTab.generated";
import {
  BidEstimateModalOptionsDocument,
  BidEstimateModalOptionsQuery,
  BidEstimateModalOptionsQueryVariables,
  SaveBidItemEstimateDocument,
  SaveBidItemEstimateMutation,
  SaveBidItemEstimateMutationVariables,
} from "../routes/libraries/material-catalog/BidEstimateModal.generated";
import {
  MaterialCatalogListingsDocument,
  MaterialCatalogListingsQuery,
  MaterialCatalogListingsQueryVariables,
  MaterialCatalogMetadataDocument,
  MaterialCatalogMetadataQuery,
  MaterialCatalogMetadataQueryVariables,
  SaveMaterialBrandDocument,
  SaveMaterialBrandMutation,
  SaveMaterialBrandMutationVariables,
  SaveMaterialVariantDocument,
  SaveMaterialVariantMutation,
  SaveMaterialVariantMutationVariables,
  SaveMavDocument,
  SaveMavMutation,
  SaveMavMutationVariables,
} from "../routes/libraries/material-catalog/MaterialCatalog.generated";
import {
  MaterialCostPageDocument,
  MaterialCostPageQuery,
  MaterialCostPageQueryVariables,
} from "../routes/libraries/material-catalog/MaterialCostPage.generated";
import {
  MaterialAssemblyForm_AssemblyComponentsDocument,
  MaterialAssemblyForm_AssemblyComponentsQuery,
  MaterialAssemblyForm_AssemblyComponentsQueryVariables,
  MaterialAssemblyForm_ItemsDocument,
  MaterialAssemblyForm_ItemsQuery,
  MaterialAssemblyForm_ItemsQueryVariables,
  MaterialAssemblyForm_MaterialVariantsDocument,
  MaterialAssemblyForm_MaterialVariantsQuery,
  MaterialAssemblyForm_MaterialVariantsQueryVariables,
} from "../routes/libraries/material-catalog/components/material-assembly-form/MaterialAssemblyForm.generated";
import {
  DeleteMaterialVariantDocument,
  DeleteMaterialVariantMutation,
  DeleteMaterialVariantMutationVariables,
  SaveMaterialListingDocument,
  SaveMaterialListingMutation,
  SaveMaterialListingMutationVariables,
} from "../routes/libraries/material-catalog/components/materialListingDetail.generated";
import {
  MergeHistoryModalDocument,
  MergeHistoryModalQuery,
  MergeHistoryModalQueryVariables,
} from "../routes/libraries/material-catalog/components/merge-history-modal/MergeHistoryModal.generated";
import {
  TakeoffsUsageModalDocument,
  TakeoffsUsageModalQuery,
  TakeoffsUsageModalQueryVariables,
} from "../routes/libraries/material-catalog/components/takeoffs-usage-modal/TakeoffsUsageModal.generated";
import {
  DeleteItemPlanTaskMappingDocument,
  DeleteItemPlanTaskMappingMutation,
  DeleteItemPlanTaskMappingMutationVariables,
  InstallTasksPageDocument,
  InstallTasksPageQuery,
  InstallTasksPageQueryVariables,
  ItemPlanTaskMappingsDocument,
  ItemPlanTaskMappingsQuery,
  ItemPlanTaskMappingsQueryVariables,
  SaveItemPlanTaskMappingDocument,
  SaveItemPlanTaskMappingMutation,
  SaveItemPlanTaskMappingMutationVariables,
} from "../routes/libraries/material-catalog/install-tasks/InstallTasksPage.generated";
import {
  CreateMaterialImportAiProposalDocument,
  CreateMaterialImportAiProposalMutation,
  CreateMaterialImportAiProposalMutationVariables,
  MaterialImportAiProposalDocument,
  MaterialImportAiProposalQuery,
  MaterialImportAiProposalQueryVariables,
} from "../routes/libraries/material-catalog/material-import/MaterialImportPage.generated";
import {
  MaterialListingIdForVariantDocument,
  MaterialListingIdForVariantQuery,
  MaterialListingIdForVariantQueryVariables,
  MaterialListingPageDocument,
  MaterialListingPageQuery,
  MaterialListingPageQueryVariables,
} from "../routes/libraries/material-catalog/material-listing-page/MaterialListingPage.generated";
import {
  MaterialListingHistoryDocument,
  MaterialListingHistoryQuery,
  MaterialListingHistoryQueryVariables,
} from "../routes/libraries/material-catalog/material-listing-page/components/MaterialListingHistoryPane.generated";
import {
  MergeMaterialVariants_MetadataDocument,
  MergeMaterialVariants_MetadataQuery,
  MergeMaterialVariants_MetadataQueryVariables,
  MergeMaterialVariants_PreviewDisplayNameDocument,
  MergeMaterialVariants_PreviewDisplayNameQuery,
  MergeMaterialVariants_PreviewDisplayNameQueryVariables,
  MergeMaterialVariants_SearchDocument,
  MergeMaterialVariants_SearchQuery,
  MergeMaterialVariants_SearchQueryVariables,
  MergeMaterialVariants_SelectionDocument,
  MergeMaterialVariants_SelectionQuery,
  MergeMaterialVariants_SelectionQueryVariables,
  MergeMaterialVariantsDocument,
  MergeMaterialVariantsMutation,
  MergeMaterialVariantsMutationVariables,
} from "../routes/libraries/material-catalog/merge-variants/MergeMaterialVariants.generated";
import {
  MaterialCatalogFilterDimensionsDocument,
  MaterialCatalogFilterDimensionsQuery,
  MaterialCatalogFilterDimensionsQueryVariables,
  MaterialCatalogFilterMetadataDocument,
  MaterialCatalogFilterMetadataQuery,
  MaterialCatalogFilterMetadataQueryVariables,
} from "../routes/libraries/material-catalog/useMaterialCatalogFilter.generated";
import {
  MilestoneCatalogFormDocument,
  MilestoneCatalogFormDropdownDocument,
  MilestoneCatalogFormDropdownQuery,
  MilestoneCatalogFormDropdownQueryVariables,
  MilestoneCatalogFormQuery,
  MilestoneCatalogFormQueryVariables,
  SaveGlobalPlanMilestonesDocument,
  SaveGlobalPlanMilestonesMutation,
  SaveGlobalPlanMilestonesMutationVariables,
} from "../routes/libraries/milestone-catalog/MilestoneCatalogForm.generated";
import {
  MilestoneCatalogPageDocument,
  MilestoneCatalogPageMetaDataDocument,
  MilestoneCatalogPageMetaDataQuery,
  MilestoneCatalogPageMetaDataQueryVariables,
  MilestoneCatalogPageQuery,
  MilestoneCatalogPageQueryVariables,
} from "../routes/libraries/milestone-catalog/MilestoneCatalogPage.generated";
import {
  BusinessFunctionTypeDocument,
  BusinessFunctionTypeQuery,
  BusinessFunctionTypeQueryVariables,
  SaveGlobalPlanMilestoneGroupDocument,
  SaveGlobalPlanMilestoneGroupMutation,
  SaveGlobalPlanMilestoneGroupMutationVariables,
} from "../routes/libraries/milestone-catalog/components/AddGlobalPlanMilestoneGroupModal.generated";
import {
  PlanPackagePageV2MetadataDocument,
  PlanPackagePageV2MetadataQuery,
  PlanPackagePageV2MetadataQueryVariables,
} from "../routes/libraries/plan-package-v2/PlanPackagePageV2.generated";
import {
  PlanPackageCheckoutV2Document,
  PlanPackageCheckoutV2Query,
  PlanPackageCheckoutV2QueryVariables,
  SavePlanPackageCheckoutRoomsV2Document,
  SavePlanPackageCheckoutRoomsV2Mutation,
  SavePlanPackageCheckoutRoomsV2MutationVariables,
  SavePlanPackageCheckoutV2Document,
  SavePlanPackageCheckoutV2Mutation,
  SavePlanPackageCheckoutV2MutationVariables,
} from "../routes/libraries/plan-package-v2/components/CheckoutTab.generated";
import {
  ElevationCatalogV2Document,
  ElevationCatalogV2Query,
  ElevationCatalogV2QueryVariables,
  PlanPackageElevationsV2Document,
  PlanPackageElevationsV2Query,
  PlanPackageElevationsV2QueryVariables,
  SavePlanPackageElevationDocument,
  SavePlanPackageElevationMutation,
  SavePlanPackageElevationMutationVariables,
} from "../routes/libraries/plan-package-v2/components/ElevationsTab.generated";
import {
  PlanPackageLocationsV2Document,
  PlanPackageLocationsV2Query,
  PlanPackageLocationsV2QueryVariables,
  SavePlanPackageLocationsV2Document,
  SavePlanPackageLocationsV2Mutation,
  SavePlanPackageLocationsV2MutationVariables,
} from "../routes/libraries/plan-package-v2/components/LocationsTab.generated";
import {
  PlanPackageOptionsV2Document,
  PlanPackageOptionsV2Query,
  PlanPackageOptionsV2QueryVariables,
  SavePlanPackageOptionsV2Document,
  SavePlanPackageOptionsV2Mutation,
  SavePlanPackageOptionsV2MutationVariables,
} from "../routes/libraries/plan-package-v2/components/OptionsTab.generated";
import {
  PlanPackageOverviewV2Document,
  PlanPackageOverviewV2Query,
  PlanPackageOverviewV2QueryVariables,
} from "../routes/libraries/plan-package-v2/components/OverviewTab.generated";
import {
  PlanPackageProgramDataV2Document,
  PlanPackageProgramDataV2Query,
  PlanPackageProgramDataV2QueryVariables,
  SavePlanPackageProgramDataV2Document,
  SavePlanPackageProgramDataV2Mutation,
  SavePlanPackageProgramDataV2MutationVariables,
} from "../routes/libraries/plan-package-v2/components/ProgramDataTab.generated";
import {
  AddOptionsModalV2_GlobalOptionsDocument,
  AddOptionsModalV2_GlobalOptionsQuery,
  AddOptionsModalV2_GlobalOptionsQueryVariables,
  AddOptionsModalV2Document,
  AddOptionsModalV2Query,
  AddOptionsModalV2QueryVariables,
} from "../routes/libraries/plan-package-v2/components/options/AddOptionsModal.generated";
import {
  CreatePlanPackageAiProposalDocument,
  CreatePlanPackageAiProposalMutation,
  CreatePlanPackageAiProposalMutationVariables,
  PlanPackageAiProposalStatusDocument,
  PlanPackageAiProposalStatusQuery,
  PlanPackageAiProposalStatusQueryVariables,
} from "../routes/libraries/plan-package-v2/components/overview/PlanPackageDocumentImportPanel.generated";
import {
  CreatePlanPackageDocument,
  CreatePlanPackageMutation,
  CreatePlanPackageMutationVariables,
} from "../routes/libraries/plan-package-v2/create/CreatePlanPackagePage.generated";
import {
  PlanPackageVersionHistoryDocument,
  PlanPackageVersionHistoryQuery,
  PlanPackageVersionHistoryQueryVariables,
} from "../routes/libraries/plan-package-v2/version-history/PlanPackageVersionHistoryPage.generated";
import {
  CopyPlanPackageDocument,
  CopyPlanPackageMutation,
  CopyPlanPackageMutationVariables,
  PlanPackagePageMetadataDocument,
  PlanPackagePageMetadataQuery,
  PlanPackagePageMetadataQueryVariables,
  SavePlanPackageDocument,
  SavePlanPackageMutation,
  SavePlanPackageMutationVariables,
} from "../routes/libraries/plan-package/details/PlanPackagePage.generated";
import {
  ConfirmDiscardDraftVersionModal_ConfirmActionDocument,
  ConfirmDiscardDraftVersionModal_ConfirmActionMutation,
  ConfirmDiscardDraftVersionModal_ConfirmActionMutationVariables,
} from "../routes/libraries/plan-package/details/components/ConfirmDiscardDraftVersionModal.generated";
import {
  GenerateReadyPlanVersionNotesDocument,
  GenerateReadyPlanVersionNotesQuery,
  GenerateReadyPlanVersionNotesQueryVariables,
} from "../routes/libraries/plan-package/details/components/GenerateReadyPlanVersionNotes.generated";
import {
  PublishAggregateVersionModal_IncomingSlotsDocument,
  PublishAggregateVersionModal_IncomingSlotsQuery,
  PublishAggregateVersionModal_IncomingSlotsQueryVariables,
  SaveReadyPlanAggregateVersionDocument,
  SaveReadyPlanAggregateVersionMutation,
  SaveReadyPlanAggregateVersionMutationVariables,
} from "../routes/libraries/plan-package/details/components/PublishAggregateVersionModal.generated";
import {
  PlanPackageOverviewDocument,
  PlanPackageOverviewQuery,
  PlanPackageOverviewQueryVariables,
  PlanSummaryAndOptionsDocument,
  PlanSummaryAndOptionsQuery,
  PlanSummaryAndOptionsQueryVariables,
} from "../routes/libraries/plan-package/details/plan-overview/OverviewTab.generated";
import {
  ElevationDetailsDocument,
  ElevationDetailsQuery,
  ElevationDetailsQueryVariables,
} from "../routes/libraries/plan-package/details/plan-overview/components/ElevationDetails.generated";
import {
  PlanPackageRecentActivityDocument,
  PlanPackageRecentActivityQuery,
  PlanPackageRecentActivityQueryVariables,
} from "../routes/libraries/plan-package/details/plan-overview/components/PlanPackageRecentActivity.generated";
import {
  PlanPackagesDocument,
  PlanPackagesQuery,
  PlanPackagesQueryVariables,
} from "../routes/libraries/plan-package/list/PlanPackagesPage.generated";
import {
  PlanPackageDetailsStepDocument,
  PlanPackageDetailsStepQuery,
  PlanPackageDetailsStepQueryVariables,
  SavePlanPackageDetailsDocument,
  SavePlanPackageDetailsMutation,
  SavePlanPackageDetailsMutationVariables,
} from "../routes/libraries/plan-package/stepper/1.PlanDetailsStep.generated";
import {
  BulkSaveRplsDocument,
  BulkSaveRplsMutation,
  BulkSaveRplsMutationVariables,
  PlanPackageLocationStepDocument,
  PlanPackageLocationStepQuery,
  PlanPackageLocationStepQueryVariables,
  RoomTypeDocument,
  RoomTypeQuery,
  RoomTypeQueryVariables,
} from "../routes/libraries/plan-package/stepper/2.1.LocationStep.generated";
import {
  SaveElevationsDocument,
  SaveElevationsMutation,
  SaveElevationsMutationVariables,
  SaveReadyPlanOptionGroupDocument,
  SaveReadyPlanOptionGroupMutation,
  SaveReadyPlanOptionGroupMutationVariables,
} from "../routes/libraries/plan-package/stepper/2.ElevationsStep.generated";
import {
  PlanPackage_AddOptionsPageDocument,
  PlanPackage_AddOptionsPageQuery,
  PlanPackage_AddOptionsPageQueryVariables,
  PlanPackage_SaveReadyPlanOptionsDocument,
  PlanPackage_SaveReadyPlanOptionsMutation,
  PlanPackage_SaveReadyPlanOptionsMutationVariables,
} from "../routes/libraries/plan-package/stepper/4.ConfigureOptionsStep.generated";
import {
  ProgramDataStepMetadataDocument,
  ProgramDataStepMetadataQuery,
  ProgramDataStepMetadataQueryVariables,
} from "../routes/libraries/plan-package/stepper/5.ProgramDataStep.generated";
import {
  ChooseOptionsStepBody_GlobalOptionsDocument,
  ChooseOptionsStepBody_GlobalOptionsQuery,
  ChooseOptionsStepBody_GlobalOptionsQueryVariables,
  ChooseOptionsStepBody_PlanPackageDocument,
  ChooseOptionsStepBody_PlanPackageQuery,
  ChooseOptionsStepBody_PlanPackageQueryVariables,
} from "../routes/libraries/plan-package/stepper/components/ChooseOptionsStepBody.generated";
import {
  PlanPackageEditorHeaderDocument,
  PlanPackageEditorHeaderQuery,
  PlanPackageEditorHeaderQueryVariables,
} from "../routes/libraries/plan-package/stepper/components/PlanPackageEditorHeader.generated";
import {
  PlanPackageTakeoffPageDocument,
  PlanPackageTakeoffPageQuery,
  PlanPackageTakeoffPageQueryVariables,
  SavePlanPackageTakeoffsCycleDocument,
  SavePlanPackageTakeoffsCycleMutation,
  SavePlanPackageTakeoffsCycleMutationVariables,
} from "../routes/libraries/plan-package/takeoffs/PlanPackageTakeoffPage.generated";
import {
  PlanPackageTakeoffSideBarDocument,
  PlanPackageTakeoffSideBarQuery,
  PlanPackageTakeoffSideBarQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/PlanPackageTakeoffSideBar.generated";
import {
  TakeoffsStore_CopyTakeoffLineItemsDocument,
  TakeoffsStore_CopyTakeoffLineItemsMutation,
  TakeoffsStore_CopyTakeoffLineItemsMutationVariables,
  TakeoffsStore_SaveTakeoffLineItemsDocument,
  TakeoffsStore_SaveTakeoffLineItemsMutation,
  TakeoffsStore_SaveTakeoffLineItemsMutationVariables,
} from "../routes/libraries/plan-package/takeoffs/TakeoffsManagerContext.generated";
import {
  AddEditItemModal_GetItemsDocument,
  AddEditItemModal_GetItemsQuery,
  AddEditItemModal_GetItemsQueryVariables,
  AddEditItemModal_GetMaterialVariantsDocument,
  AddEditItemModal_GetMaterialVariantsQuery,
  AddEditItemModal_GetMaterialVariantsQueryVariables,
  AddEditItemModal_GetReadyPlanDocument,
  AddEditItemModal_GetReadyPlanQuery,
  AddEditItemModal_GetReadyPlanQueryVariables,
  AddEditItemModal_GetTliDocument,
  AddEditItemModal_GetTliQuery,
  AddEditItemModal_GetTliQueryVariables,
  AddEditItemModal_GlobalPlanTasksDocument,
  AddEditItemModal_GlobalPlanTasksQuery,
  AddEditItemModal_GlobalPlanTasksQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/AddItems/AddEditItemModal.generated";
import {
  AddEditPlaceholderItemModal_GetItemsDocument,
  AddEditPlaceholderItemModal_GetItemsQuery,
  AddEditPlaceholderItemModal_GetItemsQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/AddItems/AddEditPlaceholderItemModal.generated";
import {
  AddItemsFromExistingPlanModalDocument,
  AddItemsFromExistingPlanModalQuery,
  AddItemsFromExistingPlanModalQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/AddItemsFromExistingPlanModal.generated";
import {
  BulkEditModal_GetTlisDocument,
  BulkEditModal_GetTlisQuery,
  BulkEditModal_GetTlisQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/BulkEditModal.generated";
import {
  BulkTaskAllocationModal_GlobalPlanTasksDocument,
  BulkTaskAllocationModal_GlobalPlanTasksQuery,
  BulkTaskAllocationModal_GlobalPlanTasksQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/BulkTaskAllocationModal/BulkTaskAllocationModal.generated";
import {
  DuplicateItemsConfirmationModal_GetTlisDocument,
  DuplicateItemsConfirmationModal_GetTlisQuery,
  DuplicateItemsConfirmationModal_GetTlisQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/DuplicateItemsConfirmationModal.generated";
import {
  ReviewSlotRequests_AcceptSlotDocument,
  ReviewSlotRequests_AcceptSlotMutation,
  ReviewSlotRequests_AcceptSlotMutationVariables,
  ReviewSlotRequests_RejectSlotDocument,
  ReviewSlotRequests_RejectSlotMutation,
  ReviewSlotRequests_RejectSlotMutationVariables,
  ReviewSlotRequestsDocument,
  ReviewSlotRequestsQuery,
  ReviewSlotRequestsQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/SlotReview/ReviewSlotRequests.generated";
import {
  PlanPackageTakeoffTableDocument,
  PlanPackageTakeoffTableQuery,
  PlanPackageTakeoffTableQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/TakeoffsTable/PlanPackageTakeoffTable.generated";
import {
  TakeoffUploader_ValidateTlisDocument,
  TakeoffUploader_ValidateTlisQuery,
  TakeoffUploader_ValidateTlisQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/useTakeoffUploader.generated";
import {
  AddProductOfferingConfig_ComputeDocument,
  AddProductOfferingConfig_ComputeQuery,
  AddProductOfferingConfig_ComputeQueryVariables,
  AddProductOfferingConfig_ProgramDataDocument,
  AddProductOfferingConfig_ProgramDataQuery,
  AddProductOfferingConfig_ProgramDataQueryVariables,
  AddProductOfferingConfigMetaDocument,
  AddProductOfferingConfigMetaQuery,
  AddProductOfferingConfigMetaQueryVariables,
  CreateProjectFromConfigMetaDocument,
  CreateProjectFromConfigMetaQuery,
  CreateProjectFromConfigMetaQueryVariables,
  CreateProjectFromProductOfferingConfigDocument,
  CreateProjectFromProductOfferingConfigMutation,
  CreateProjectFromProductOfferingConfigMutationVariables,
  EditProductOfferingConfigDocument,
  EditProductOfferingConfigQuery,
  EditProductOfferingConfigQueryVariables,
  SaveProductOfferingConfigDocument,
  SaveProductOfferingConfigMutation,
  SaveProductOfferingConfigMutationVariables,
} from "../routes/libraries/product-offering-configs/AddProductOfferingConfigPage.generated";
import {
  ProductOfferingConfigsDocument,
  ProductOfferingConfigsPageMetadataDocument,
  ProductOfferingConfigsPageMetadataQuery,
  ProductOfferingConfigsPageMetadataQueryVariables,
  ProductOfferingConfigsQuery,
  ProductOfferingConfigsQueryVariables,
} from "../routes/libraries/product-offering-configs/ProductOfferingConfigsPage.generated";
import {
  GlobalProductOfferingsMetaDataDocument,
  GlobalProductOfferingsMetaDataQuery,
  GlobalProductOfferingsMetaDataQueryVariables,
  GlobalProductOfferingsPageDocument,
  GlobalProductOfferingsPageQuery,
  GlobalProductOfferingsPageQueryVariables,
} from "../routes/libraries/product-offerings/GlobalProductOfferings.generated";
import {
  OfferingDetailsStep_CommunitiesDocument,
  OfferingDetailsStep_CommunitiesQuery,
  OfferingDetailsStep_CommunitiesQueryVariables,
  OfferingDetailsStep_DevelopmentsDocument,
  OfferingDetailsStep_DevelopmentsQuery,
  OfferingDetailsStep_DevelopmentsQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/1.OfferingDetailsStep.generated";
import {
  PlanPackageStepDocument,
  PlanPackageStepQuery,
  PlanPackageStepQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/2.PlanPackageStep.generated";
import {
  DesignPackagesStepDocument,
  DesignPackagesStepQuery,
  DesignPackagesStepQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/3.DesignPackagesStep.generated";
import {
  OptionsStepDocument,
  OptionsStepQuery,
  OptionsStepQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/4.OptionsStep.generated";
import {
  ReviewStep_SaveProductOfferingDocument,
  ReviewStep_SaveProductOfferingMutation,
  ReviewStep_SaveProductOfferingMutationVariables,
  ReviewStepDocument,
  ReviewStepQuery,
  ReviewStepQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/5.ReviewStep.generated";
import {
  CheckoutPricingTraceGroupDetailDocument,
  CheckoutPricingTraceGroupDetailQuery,
  CheckoutPricingTraceGroupDetailQueryVariables,
  CheckoutPricingTracePage_OverviewDocument,
  CheckoutPricingTracePage_OverviewQuery,
  CheckoutPricingTracePage_OverviewQueryVariables,
} from "../routes/libraries/product-offerings/checkout-pricing-trace/CheckoutPricingTracePage.generated";
import {
  EditProductOfferingPageDocument,
  EditProductOfferingPageQuery,
  EditProductOfferingPageQueryVariables,
} from "../routes/libraries/product-offerings/edit-product-offering/EditProductOfferingPage.generated";
import {
  DevelopmentsByMarketDocument,
  DevelopmentsByMarketQuery,
  DevelopmentsByMarketQueryVariables,
} from "../routes/libraries/schedules/CreateOrUpdateScheduleTemplateModal.generated";
import {
  DuplicateScheduleTemplateDocument,
  DuplicateScheduleTemplateMutation,
  DuplicateScheduleTemplateMutationVariables,
  SaveScheduleTemplatesDocument,
  SaveScheduleTemplatesMutation,
  SaveScheduleTemplatesMutationVariables,
  ScheduleTemplateDetailDocument,
  ScheduleTemplateDetailQuery,
  ScheduleTemplateDetailQueryVariables,
  ScheduleTemplateEditPageDocument,
  ScheduleTemplateEditPageQuery,
  ScheduleTemplateEditPageQueryVariables,
  ScheduleTemplateMetadataDocument,
  ScheduleTemplateMetadataQuery,
  ScheduleTemplateMetadataQueryVariables,
  ScheduleTemplatesDocument,
  ScheduleTemplatesPageMetadataDocument,
  ScheduleTemplatesPageMetadataQuery,
  ScheduleTemplatesPageMetadataQueryVariables,
  ScheduleTemplatesQuery,
  ScheduleTemplatesQueryVariables,
} from "../routes/libraries/schedules/ScheduleTemplatesPage.generated";
import {
  ConstraintAndAllowanceCatalogPageDocument,
  ConstraintAndAllowanceCatalogPageQuery,
  ConstraintAndAllowanceCatalogPageQueryVariables,
  DeleteGlobalPlanConstraintItemDocument,
  DeleteGlobalPlanConstraintItemMutation,
  DeleteGlobalPlanConstraintItemMutationVariables,
} from "../routes/libraries/task-catalog/ConstraintItemCatalogPage.generated";
import {
  TaskCatalogLaborCostsPageDocument,
  TaskCatalogLaborCostsPageQuery,
  TaskCatalogLaborCostsPageQueryVariables,
} from "../routes/libraries/task-catalog/TaskCatalogLaborCostsPage.generated";
import {
  TaskCatalogPageMetadataDocument,
  TaskCatalogPageMetadataQuery,
  TaskCatalogPageMetadataQueryVariables,
} from "../routes/libraries/task-catalog/TaskCatalogPage.generated";
import {
  TaskCatalogTableDocument,
  TaskCatalogTableMetadataDocument,
  TaskCatalogTableMetadataQuery,
  TaskCatalogTableMetadataQueryVariables,
  TaskCatalogTableQuery,
  TaskCatalogTableQueryVariables,
} from "../routes/libraries/task-catalog/TaskCatalogTable.generated";
import {
  SaveGlobalPlanConstraintItemDocument,
  SaveGlobalPlanConstraintItemMutation,
  SaveGlobalPlanConstraintItemMutationVariables,
} from "../routes/libraries/task-catalog/components/AddConstraintItemModal.generated";
import {
  SaveGlobalPlanTagDocument,
  SaveGlobalPlanTagMutation,
  SaveGlobalPlanTagMutationVariables,
} from "../routes/libraries/task-catalog/components/AddGlobalPlanTagModal.generated";
import {
  AddStageModalDocument,
  AddStageModalMutation,
  AddStageModalMutationVariables,
} from "../routes/libraries/task-catalog/components/AddStageModal.generated";
import {
  BulkGlobalPlanTagsDocument,
  BulkGlobalPlanTagsModalDocument,
  BulkGlobalPlanTagsModalQuery,
  BulkGlobalPlanTagsModalQueryVariables,
  BulkGlobalPlanTagsMutation,
  BulkGlobalPlanTagsMutationVariables,
} from "../routes/libraries/task-catalog/components/BulkGlobalPlanTagsModal.generated";
import {
  CatalogTaskIdsDocument,
  CatalogTaskIdsQuery,
  CatalogTaskIdsQueryVariables,
  MermaidDocument,
  MermaidQuery,
  MermaidQueryVariables,
} from "../routes/libraries/task-catalog/components/MermaidLinkModal.generated";
import {
  SaveGlobalPlanTaskDocument,
  SaveGlobalPlanTaskMutation,
  SaveGlobalPlanTaskMutationVariables,
  TaskCatalogFormDocument,
  TaskCatalogFormDocumentsDocument,
  TaskCatalogFormDocumentsQuery,
  TaskCatalogFormDocumentsQueryVariables,
  TaskCatalogFormDropdownDocument,
  TaskCatalogFormDropdownQuery,
  TaskCatalogFormDropdownQueryVariables,
  TaskCatalogFormParentDropdownDocument,
  TaskCatalogFormParentDropdownQuery,
  TaskCatalogFormParentDropdownQueryVariables,
  TaskCatalogFormQuery,
  TaskCatalogFormQueryVariables,
  TaskCatalogFormSchedulingDropdownDocument,
  TaskCatalogFormSchedulingDropdownQuery,
  TaskCatalogFormSchedulingDropdownQueryVariables,
  TaskCatalogFormVerificationDropdownDocument,
  TaskCatalogFormVerificationDropdownQuery,
  TaskCatalogFormVerificationDropdownQueryVariables,
} from "../routes/libraries/task-catalog/components/TaskCatalogForm.generated";
import {
  LienWaiversPageDocument,
  LienWaiversPageQuery,
  LienWaiversPageQueryVariables,
  SaveLienWaiverDocument,
  SaveLienWaiverMutation,
  SaveLienWaiverMutationVariables,
} from "../routes/lien-waivers/LienWaiversPage.generated";
import {
  UserEventsDocument,
  UserEventsQuery,
  UserEventsQueryVariables,
} from "../routes/my-blueprint/activity-feed/ActivityFeedPage.generated";
import {
  BillPdfDocument,
  BillPdfQuery,
  BillPdfQueryVariables,
  BillPdfTradePartnerContactDocument,
  BillPdfTradePartnerContactQuery,
  BillPdfTradePartnerContactQueryVariables,
} from "../routes/pdfs/BillPdf/BillPdf.generated";
import {
  CommitmentChangeOrderPdfDocument,
  CommitmentChangeOrderPdfQuery,
  CommitmentChangeOrderPdfQueryVariables,
  CommitmentPdfDocument,
  CommitmentPdfQuery,
  CommitmentPdfQueryVariables,
} from "../routes/pdfs/CommitmentOrChangeOrderPdf/CommitmentOrChangeOrderPdf.generated";
import {
  PaymentScheduleTaskOptionsDocument,
  PaymentScheduleTaskOptionsQuery,
  PaymentScheduleTaskOptionsQueryVariables,
} from "../routes/pdfs/CommitmentOrChangeOrderPdf/components/PaymentScheduleTable.generated";
import {
  DevelopmentCommitmentPdfDocument,
  DevelopmentCommitmentPdfQuery,
  DevelopmentCommitmentPdfQueryVariables,
} from "../routes/pdfs/DevelopmentCommitmentPdf/DevelopmentCommitmentPdf.generated";
import {
  DevelopmentContractPdfDocument,
  DevelopmentContractPdfQuery,
  DevelopmentContractPdfQueryVariables,
} from "../routes/pdfs/DevelopmentContractPdf/DevelopmentContractPdf.generated";
import {
  EstimateExportPageDocument,
  EstimateExportPageQuery,
  EstimateExportPageQueryVariables,
} from "../routes/pdfs/EstimateExportPage.generated";
import {
  FinishScheduleVisualModePdfDocument,
  FinishScheduleVisualModePdfQuery,
  FinishScheduleVisualModePdfQueryVariables,
} from "../routes/pdfs/FinishSchedulePdf/FinishScheduleVisualModePdf.generated";
import {
  HomeownerChangeOrderDocument,
  HomeownerChangeOrderQuery,
  HomeownerChangeOrderQueryVariables,
} from "../routes/pdfs/HomeownerChangeOrderPdf.generated";
import {
  InvoicePandaDocPdfDocument,
  InvoicePandaDocPdfQuery,
  InvoicePandaDocPdfQueryVariables,
} from "../routes/pdfs/InvoicePdf/InvoicePandaDocPdf.generated";
import {
  LienWaiverLastPaidBillDocument,
  LienWaiverLastPaidBillQuery,
  LienWaiverLastPaidBillQueryVariables,
  LienWaiverPdfDocument,
  LienWaiverPdfQuery,
  LienWaiverPdfQueryVariables,
} from "../routes/pdfs/LienWaiverPdf/LienWaiverPdf.generated";
import {
  PdfProjectItemsDocument,
  PdfProjectItemsQuery,
  PdfProjectItemsQueryVariables,
} from "../routes/pdfs/PdfProjectItems.generated";
import {
  ProjectFinishSchedulePdfMetadataDocument,
  ProjectFinishSchedulePdfMetadataQuery,
  ProjectFinishSchedulePdfMetadataQueryVariables,
} from "../routes/pdfs/ProjectFinishSchedulePdf/ProjectFinishSchedulePdf.generated";
import {
  ProjectFinishScheduleVisualModePdfDocument,
  ProjectFinishScheduleVisualModePdfQuery,
  ProjectFinishScheduleVisualModePdfQueryVariables,
} from "../routes/pdfs/ProjectFinishSchedulePdf/ProjectFinishScheduleVisualModePdf.generated";
import {
  ScheduleExportPageDocument,
  ScheduleExportPageQuery,
  ScheduleExportPageQueryVariables,
} from "../routes/pdfs/ScheduleExportPdf/ScheduleExportPdf.generated";
import { ToDosPdfDocument, ToDosPdfQuery, ToDosPdfQueryVariables } from "../routes/pdfs/ToDosPdf/ToDosPdf.generated";
import {
  TradeScopeOfWorkDocument,
  TradeScopeOfWorkQuery,
  TradeScopeOfWorkQueryVariables,
} from "../routes/pdfs/TradeScopeOfWorkPdf.generated";
import {
  TradeSpecificAgreementDocument,
  TradeSpecificAgreementQuery,
  TradeSpecificAgreementQueryVariables,
} from "../routes/pdfs/TradeSpecificAgreement/TradeSpecificAgreement.generated";
import {
  TradesPunchlistPdfDocument,
  TradesPunchlistPdfQuery,
  TradesPunchlistPdfQueryVariables,
} from "../routes/pdfs/TradesPuchlistPdf/TradesPunchlistPdf.generated";
import {
  LotSequenceSheetPdfDocument,
  LotSequenceSheetPdfQuery,
  LotSequenceSheetPdfQueryVariables,
} from "../routes/pdfs/lot-sequence-sheet/LotSequenceSheetPdf.generated";
import {
  LotSummaryDetailsPdfDocument,
  LotSummaryDetailsPdfQuery,
  LotSummaryDetailsPdfQueryVariables,
} from "../routes/pdfs/lot-summary-details/LotSummaryDetailsPdf.generated";
import {
  AssignedToDosDocument,
  AssignedToDosQuery,
  AssignedToDosQueryVariables,
  PersonalDashboardsPageDocument,
  PersonalDashboardsPageQuery,
  PersonalDashboardsPageQueryVariables,
  TeamMembersProjectsDocument,
  TeamMembersProjectsQuery,
  TeamMembersProjectsQueryVariables,
} from "../routes/personal-dashboard/PersonalDashboard.generated";
import {
  ApprovalSummaryHeaderDocument,
  ApprovalSummaryHeaderQuery,
  ApprovalSummaryHeaderQueryVariables,
} from "../routes/personal-dashboard/components/ApprovalSummaryHeader.generated";
import {
  BillsSummaryHeaderDocument,
  BillsSummaryHeaderQuery,
  BillsSummaryHeaderQueryVariables,
} from "../routes/personal-dashboard/components/BillsSummaryHeader.generated";
import {
  DashboardCommentsDocument,
  DashboardCommentsQuery,
  DashboardCommentsQueryVariables,
} from "../routes/personal-dashboard/components/DashboardCommentsWidget.generated";
import {
  ProjectsWidgetFinancialsTabDocument,
  ProjectsWidgetFinancialsTableDocument,
  ProjectsWidgetFinancialsTableQuery,
  ProjectsWidgetFinancialsTableQueryVariables,
  ProjectsWidgetFinancialsTabQuery,
  ProjectsWidgetFinancialsTabQueryVariables,
} from "../routes/personal-dashboard/components/ProjectsWidgetFinancials.generated";
import {
  ProjectsWidgetScheduleTabDocument,
  ProjectsWidgetScheduleTabQuery,
  ProjectsWidgetScheduleTabQueryVariables,
} from "../routes/personal-dashboard/components/ProjectsWidgetSchedule.generated";
import {
  SchedulingModalDocument,
  SchedulingModalQuery,
  SchedulingModalQueryVariables,
} from "../routes/personal-dashboard/components/SchedulingModal.generated";
import {
  TasksSummaryHeaderDocument,
  TasksSummaryHeaderQuery,
  TasksSummaryHeaderQueryVariables,
} from "../routes/personal-dashboard/components/TasksSummaryHeader.generated";
import {
  SaveTradePartnerAvailabilityRequestDocument,
  SaveTradePartnerAvailabilityRequestMutation,
  SaveTradePartnerAvailabilityRequestMutationVariables,
} from "../routes/personal-dashboard/components/TradePartnerAvailabilityRequestDetailPane.generated";
import {
  ActionItemsApprovalsDocument,
  ActionItemsApprovalsQuery,
  ActionItemsApprovalsQueryVariables,
  ActionItemsBillsPendingReviewDocument,
  ActionItemsBillsPendingReviewQuery,
  ActionItemsBillsPendingReviewQueryVariables,
  ActionItemsDeferredBillsDocument,
  ActionItemsDeferredBillsQuery,
  ActionItemsDeferredBillsQueryVariables,
  ActionItemsDelayFlagsDocument,
  ActionItemsDelayFlagsQuery,
  ActionItemsDelayFlagsQueryVariables,
  ActionItemsSchedulingDocument,
  ActionItemsSchedulingQuery,
  ActionItemsSchedulingQueryVariables,
  ActionItemsStaleTasksDocument,
  ActionItemsStaleTasksQuery,
  ActionItemsStaleTasksQueryVariables,
} from "../routes/personal-dashboard/pages/action-items/ActionItemsPage.generated";
import {
  ApprovalsDashboardDocument,
  ApprovalsDashboardQuery,
  ApprovalsDashboardQueryVariables,
  CreatePandaDocSessionDocument,
  CreatePandaDocSessionMutation,
  CreatePandaDocSessionMutationVariables,
  UpdateApproversDocument,
  UpdateApproversMutation,
  UpdateApproversMutationVariables,
} from "../routes/personal-dashboard/pages/approvals-dashboard/ApprovalsDashboard.generated";
import {
  ToDosPageDataDocument,
  ToDosPageDataQuery,
  ToDosPageDataQueryVariables,
} from "../routes/personal-dashboard/pages/to-dos/ToDosPage.generated";
import {
  SaveUpcomingPlanTaskDocument,
  SaveUpcomingPlanTaskMutation,
  SaveUpcomingPlanTaskMutationVariables,
  UpcomingTasksDocument,
  UpcomingTasksQuery,
  UpcomingTasksQueryVariables,
} from "../routes/personal-dashboard/pages/upcoming/UpcomingPage.generated";
import {
  CurrentUserDocument,
  CurrentUserQuery,
  CurrentUserQueryVariables,
} from "../routes/profile/UserProfile.generated";
import {
  ProjectHeaderDocument,
  ProjectHeaderQuery,
  ProjectHeaderQueryVariables,
} from "../routes/projects/ProjectHeader.generated";
import {
  ProjectLayoutDocument,
  ProjectLayoutQuery,
  ProjectLayoutQueryVariables,
} from "../routes/projects/ProjectLayout.generated";
import {
  ProjectsPageMetadataDocument,
  ProjectsPageMetadataQuery,
  ProjectsPageMetadataQueryVariables,
  ProjectsPageProjectsDocument,
  ProjectsPageProjectsQuery,
  ProjectsPageProjectsQueryVariables,
} from "../routes/projects/ProjectsPage.generated";
import {
  SubmitApprovalDocument,
  SubmitApprovalMutation,
  SubmitApprovalMutationVariables,
} from "../routes/projects/approvals/Approvals.generated";
import {
  ProjectBidContractOverviewPageDocument,
  ProjectBidContractOverviewPageQuery,
  ProjectBidContractOverviewPageQueryVariables,
} from "../routes/projects/bid-contracts/ProjectBidContractOverviewPage.generated";
import {
  ProjectBidContractsPageDocument,
  ProjectBidContractsPageQuery,
  ProjectBidContractsPageQueryVariables,
} from "../routes/projects/bid-contracts/ProjectBidContractsPage.generated";
import {
  BudgetSummaryDocument,
  BudgetSummaryQuery,
  BudgetSummaryQueryVariables,
} from "../routes/projects/budget/BudgetPage.generated";
import {
  HierarchyBudgetPage_RollupViewDocument,
  HierarchyBudgetPage_RollupViewQuery,
  HierarchyBudgetPage_RollupViewQueryVariables,
  HierarchyBudgetPage_SharedCostsDocument,
  HierarchyBudgetPage_SharedCostsQuery,
  HierarchyBudgetPage_SharedCostsQueryVariables,
  HierarchyBudgetPageDocument,
  HierarchyBudgetPageQuery,
  HierarchyBudgetPageQueryVariables,
} from "../routes/projects/budget/HierarchyBudgetPage.generated";
import {
  BudgetActivityTabMetaDocument,
  BudgetActivityTabMetaQuery,
  BudgetActivityTabMetaQueryVariables,
  BudgetSuperDrawerDocument,
  BudgetSuperDrawerQuery,
  BudgetSuperDrawerQueryVariables,
} from "../routes/projects/budget/components/BudgetSuperDrawer.generated";
import {
  BudgetOverviewTabDocument,
  BudgetOverviewTabQuery,
  BudgetOverviewTabQueryVariables,
} from "../routes/projects/budget/components/reports/BudgetOverviewTab.generated";
import {
  CommittedAtStartTab_CommitmentsByProjectCostCodeDocument,
  CommittedAtStartTab_CommitmentsByProjectCostCodeQuery,
  CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables,
  CommittedAtStartTabDocument,
  CommittedAtStartTabQuery,
  CommittedAtStartTabQueryVariables,
} from "../routes/projects/budget/components/reports/CommittedAtStartTab.generated";
import {
  DirectMarginTabDocument,
  DirectMarginTabQuery,
  DirectMarginTabQueryVariables,
} from "../routes/projects/budget/components/reports/DirectMarginTab.generated";
import {
  VarianceTabDocument,
  VarianceTabQuery,
  VarianceTabQueryVariables,
} from "../routes/projects/budget/components/reports/VarianceTab.generated";
import {
  CompletedTaskBudgetReviewWidgetDocument,
  CompletedTaskBudgetReviewWidgetQuery,
  CompletedTaskBudgetReviewWidgetQueryVariables,
} from "../routes/projects/budget/components/reports/widgets/CompletedTaskBudgetReviewWidget.generated";
import {
  CeliSpecOverviewTabDocument,
  CeliSpecOverviewTabQuery,
  CeliSpecOverviewTabQueryVariables,
  CeliSpecOverviewTabSaveCeliDocument,
  CeliSpecOverviewTabSaveCeliMutation,
  CeliSpecOverviewTabSaveCeliMutationVariables,
} from "../routes/projects/change-events/CeliSpecOverviewTab.generated";
import {
  ChangeEventAssociationsDocument,
  ChangeEventAssociationsQuery,
  ChangeEventAssociationsQueryVariables,
} from "../routes/projects/change-events/ChangeEventAssociationsTable.generated";
import {
  CommitmentsForChangeEventDocument,
  CommitmentsForChangeEventQuery,
  CommitmentsForChangeEventQueryVariables,
} from "../routes/projects/change-events/ChangeEventCommitmentsTab.generated";
import {
  ChangeEventEstimatesTabDocument,
  ChangeEventEstimatesTabQuery,
  ChangeEventEstimatesTabQueryVariables,
} from "../routes/projects/change-events/ChangeEventEstimatesTab.generated";
import {
  ChangeEventHistoryDocument,
  ChangeEventHistoryQuery,
  ChangeEventHistoryQueryVariables,
} from "../routes/projects/change-events/ChangeEventHistoryTab.generated";
import {
  AddChangeEventLineItemsTabDocument,
  AddChangeEventLineItemsTabMutation,
  AddChangeEventLineItemsTabMutationVariables,
  ApplyItemTemplateToChangeEventLineItemsTabDocument,
  ApplyItemTemplateToChangeEventLineItemsTabMutation,
  ApplyItemTemplateToChangeEventLineItemsTabMutationVariables,
  ChangeEventLineItemsTabDocument,
  ChangeEventLineItemsTabQuery,
  ChangeEventLineItemsTabQueryVariables,
  CreateChangeEventLineItemsTabDocument,
  CreateChangeEventLineItemsTabMutation,
  CreateChangeEventLineItemsTabMutationVariables,
  DeleteChangeEventLineItemsTabDocument,
  DeleteChangeEventLineItemsTabMutation,
  DeleteChangeEventLineItemsTabMutationVariables,
  SaveChangeEventLineItemsTabDocument,
  SaveChangeEventLineItemsTabMutation,
  SaveChangeEventLineItemsTabMutationVariables,
} from "../routes/projects/change-events/ChangeEventLineItemsTab.generated";
import {
  ChangeEventOverviewTabDocument,
  ChangeEventOverviewTabQuery,
  ChangeEventOverviewTabQueryVariables,
  SaveChangeEventOverviewTabDocument,
  SaveChangeEventOverviewTabMutation,
  SaveChangeEventOverviewTabMutationVariables,
} from "../routes/projects/change-events/ChangeEventOverviewTab.generated";
import {
  ChangeEventPageDocument,
  ChangeEventPageQuery,
  ChangeEventPageQueryVariables,
  DeleteChangeEventDocument,
  DeleteChangeEventMutation,
  DeleteChangeEventMutationVariables,
} from "../routes/projects/change-events/ChangeEventPage.generated";
import {
  ChangeEventRposTabDocument,
  ChangeEventRposTabQuery,
  ChangeEventRposTabQueryVariables,
  SaveChangeEventRposDocument,
  SaveChangeEventRposMutation,
  SaveChangeEventRposMutationVariables,
} from "../routes/projects/change-events/ChangeEventRposTab.generated";
import {
  ChangeEventsForProjectStageDocument,
  ChangeEventsForProjectStageQuery,
  ChangeEventsForProjectStageQueryVariables,
} from "../routes/projects/change-events/ChangeEventsPage.generated";
import {
  AcceptChangeEventModalDocument,
  AcceptChangeEventModalQuery,
  AcceptChangeEventModalQueryVariables,
} from "../routes/projects/change-events/components/AcceptChangeEventModal.generated";
import {
  ApplyTemplateChangeEventModalDocument,
  ApplyTemplateChangeEventModalQuery,
  ApplyTemplateChangeEventModalQueryVariables,
  ApplyTemplatePlanChangeEventModalDocument,
  ApplyTemplatePlanChangeEventModalQuery,
  ApplyTemplatePlanChangeEventModalQueryVariables,
} from "../routes/projects/change-events/components/ApplyTemplateModal.generated";
import {
  ChangeEventLineItemTradePartnerSelectDocument,
  ChangeEventLineItemTradePartnerSelectQuery,
  ChangeEventLineItemTradePartnerSelectQueryVariables,
} from "../routes/projects/change-events/components/ChangeEventLineItemTradePartnerSelect.generated";
import {
  CreateCeModalDocument,
  CreateCeModalQuery,
  CreateCeModalQueryVariables,
  CreateCeModalSaveCeDocument,
  CreateCeModalSaveCeMutation,
  CreateCeModalSaveCeMutationVariables,
} from "../routes/projects/change-events/components/CreateChangeEventModal.generated";
import {
  CreateGuidedChangeEventModal_ChangeEventDocument,
  CreateGuidedChangeEventModal_ChangeEventQuery,
  CreateGuidedChangeEventModal_ChangeEventQueryVariables,
  CreateGuidedChangeEventModalDocument,
  CreateGuidedChangeEventModalQuery,
  CreateGuidedChangeEventModalQueryVariables,
} from "../routes/projects/change-events/components/CreateGuidedChangeEventModal.generated";
import {
  SaveChangeEventLineItemsDocument,
  SaveChangeEventLineItemsMutation,
  SaveChangeEventLineItemsMutationVariables,
} from "../routes/projects/change-events/components/EraseChangeEventPricesModal.generated";
import {
  CreateChangeEventLineItemsFromCommittedDocument,
  CreateChangeEventLineItemsFromCommittedMutation,
  CreateChangeEventLineItemsFromCommittedMutationVariables,
} from "../routes/projects/change-events/components/ImportFromCommittedModal.generated";
import {
  ZeroChangeEventBudgetChangesDocument,
  ZeroChangeEventBudgetChangesMutation,
  ZeroChangeEventBudgetChangesMutationVariables,
} from "../routes/projects/change-events/components/ZeroBudgetChangesModal.generated";
import {
  GuidedChangeEventPage_ChangeEventDocument,
  GuidedChangeEventPage_ChangeEventQuery,
  GuidedChangeEventPage_ChangeEventQueryVariables,
  GuidedChangeEventPage_ProjectDocument,
  GuidedChangeEventPage_ProjectQuery,
  GuidedChangeEventPage_ProjectQueryVariables,
} from "../routes/projects/change-events/guided/GuidedChangeEventPage.generated";
import {
  SelectOptionStepDocument,
  SelectOptionStepQuery,
  SelectOptionStepQueryVariables,
} from "../routes/projects/change-events/guided/workflows/addOnBookOption/1.SelectOptionStep.generated";
import {
  SelectConfigurationStep_SelectedConfigDocument,
  SelectConfigurationStep_SelectedConfigQuery,
  SelectConfigurationStep_SelectedConfigQueryVariables,
  SelectConfigurationStepDocument,
  SelectConfigurationStepQuery,
  SelectConfigurationStepQueryVariables,
} from "../routes/projects/change-events/guided/workflows/applyConfiguration/1.SelectConfigurationStep.generated";
import {
  ReviewConfigurationStepDocument,
  ReviewConfigurationStepQuery,
  ReviewConfigurationStepQueryVariables,
} from "../routes/projects/change-events/guided/workflows/applyConfiguration/2.ReviewConfigurationStep.generated";
import {
  ReviewImpactProjectDocument,
  ReviewImpactProjectQuery,
  ReviewImpactProjectQueryVariables,
  ReviewProjectImpactChangeEventDocument,
  ReviewProjectImpactChangeEventQuery,
  ReviewProjectImpactChangeEventQueryVariables,
  ReviewProjectImpactCheckoutConfigDocument,
  ReviewProjectImpactCheckoutConfigQuery,
  ReviewProjectImpactCheckoutConfigQueryVariables,
  ReviewProjectImpactComputeCostDocument,
  ReviewProjectImpactComputeCostQuery,
  ReviewProjectImpactComputeCostQueryVariables,
} from "../routes/projects/change-events/guided/workflows/applyConfiguration/3.ReviewImpactStep.generated";
import {
  SelectConfiguration_PotentialConfigsDocument,
  SelectConfiguration_PotentialConfigsQuery,
  SelectConfiguration_PotentialConfigsQueryVariables,
  SelectConfiguration_SelectedConfigDocument,
  SelectConfiguration_SelectedConfigQuery,
  SelectConfiguration_SelectedConfigQueryVariables,
} from "../routes/projects/change-events/guided/workflows/applyConfiguration/components/SelectConfigurationModal.generated";
import {
  ApplyInitialConfigurationGateDocument,
  ApplyInitialConfigurationGateQuery,
  ApplyInitialConfigurationGateQueryVariables,
} from "../routes/projects/change-events/guided/workflows/applyConfiguration/initial/components/ApplyInitialConfigurationGate.generated";
import {
  ApplyConfigurationDirectly_ReadyPlanConfigDocument,
  ApplyConfigurationDirectly_ReadyPlanConfigQuery,
  ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables,
  ApplyConfigurationDirectlyDocument,
  ApplyConfigurationDirectlyMutation,
  ApplyConfigurationDirectlyMutationVariables,
} from "../routes/projects/change-events/guided/workflows/applyConfiguration/useApplyConfigurationDirectly.generated";
import {
  ReviewStepChangeEventDocument,
  ReviewStepChangeEventQuery,
  ReviewStepChangeEventQueryVariables,
} from "../routes/projects/change-events/guided/workflows/sharedSteps/ReviewStep.generated";
import {
  SaveGuidedChangeEventDocument,
  SaveGuidedChangeEventMutation,
  SaveGuidedChangeEventMutationVariables,
} from "../routes/projects/change-events/guided/workflows/sharedSteps/useGuidedChangeEventActions.generated";
import {
  ReviewStep_SaveChangeEventDocument,
  ReviewStep_SaveChangeEventMutation,
  ReviewStep_SaveChangeEventMutationVariables,
} from "../routes/projects/change-events/guided/workflows/sharedSteps/useReviewStepActions.generated";
import {
  SelectProductToReplaceMaterialVariantDocument,
  SelectProductToReplaceMaterialVariantQuery,
  SelectProductToReplaceMaterialVariantQueryVariables,
  SelectProductToReplaceProjectItemDocument,
  SelectProductToReplaceProjectItemQuery,
  SelectProductToReplaceProjectItemQueryVariables,
} from "../routes/projects/change-events/guided/workflows/swapProductCatalog/1.SelectProductToReplaceStep.generated";
import {
  ReviewImpactChangeEventDocument,
  ReviewImpactChangeEventQuery,
  ReviewImpactChangeEventQueryVariables,
  ReviewImpactProjectItemCountDocument,
  ReviewImpactProjectItemCountQuery,
  ReviewImpactProjectItemCountQueryVariables,
} from "../routes/projects/change-events/guided/workflows/swapProductCatalog/2.ReviewImpactStep.generated";
import {
  ChooseReplacementPossibleMaterialsDocument,
  ChooseReplacementPossibleMaterialsQuery,
  ChooseReplacementPossibleMaterialsQueryVariables,
  ChooseReplacementProjectItemDetailsDocument,
  ChooseReplacementProjectItemDetailsQuery,
  ChooseReplacementProjectItemDetailsQueryVariables,
} from "../routes/projects/change-events/guided/workflows/swapProductCatalog/components/ChooseReplacementModal.generated";
import {
  DefineReplacement_SaveMaterialListingDocument,
  DefineReplacement_SaveMaterialListingMutation,
  DefineReplacement_SaveMaterialListingMutationVariables,
  DefineReplacementMaterialVariantDocument,
  DefineReplacementMaterialVariantQuery,
  DefineReplacementMaterialVariantQueryVariables,
  DefineReplacementMetadataDocument,
  DefineReplacementMetadataQuery,
  DefineReplacementMetadataQueryVariables,
} from "../routes/projects/change-events/guided/workflows/swapProductCatalog/components/DefineReplacementModal.generated";
import {
  PurchaseOrderCleanupChangeEventDocument,
  PurchaseOrderCleanupChangeEventQuery,
  PurchaseOrderCleanupChangeEventQueryVariables,
} from "../routes/projects/change-events/guided/workflows/swapProductCatalog/components/PurchaseOrderCleanupModal.generated";
import {
  SelectProductModalMetadataDocument,
  SelectProductModalMetadataQuery,
  SelectProductModalMetadataQueryVariables,
  SelectProductModalProjectItemsDocument,
  SelectProductModalProjectItemsQuery,
  SelectProductModalProjectItemsQueryVariables,
} from "../routes/projects/change-events/guided/workflows/swapProductCatalog/components/SelectProductModal.generated";
import {
  CommitmentChangeOrderPageDocument,
  CommitmentChangeOrderPageQuery,
  CommitmentChangeOrderPageQueryVariables,
  DeleteCommitmentChangeOrderDocument,
  DeleteCommitmentChangeOrderMutation,
  DeleteCommitmentChangeOrderMutationVariables,
  SaveCommitmentChangeOrderDocument,
  SaveCommitmentChangeOrderMutation,
  SaveCommitmentChangeOrderMutationVariables,
} from "../routes/projects/commitments/CommitmentChangeOrderPage.generated";
import {
  CommitmentHistoryDocument,
  CommitmentHistoryQuery,
  CommitmentHistoryQueryVariables,
  CommitmentWithProjectItemsDocument,
  CommitmentWithProjectItemsQuery,
  CommitmentWithProjectItemsQueryVariables,
  DeleteCommitmentDocument,
  DeleteCommitmentMutation,
  DeleteCommitmentMutationVariables,
  NewCommitmentWithProjectItemsDataDocument,
  NewCommitmentWithProjectItemsDataQuery,
  NewCommitmentWithProjectItemsDataQueryVariables,
  ReleaseBidCommitmentsDocument,
  ReleaseBidCommitmentsMutation,
  ReleaseBidCommitmentsMutationVariables,
  SaveCommitmentDocument,
  SaveCommitmentMutation,
  SaveCommitmentMutationVariables,
} from "../routes/projects/commitments/CommitmentPage.generated";
import {
  CommitmentsPageDocument,
  CommitmentsPageMetadataDocument,
  CommitmentsPageMetadataQuery,
  CommitmentsPageMetadataQueryVariables,
  CommitmentsPageQuery,
  CommitmentsPageQueryVariables,
} from "../routes/projects/commitments/CommitmentsPage.generated";
import {
  AddDepositModalDocument,
  AddDepositModalQuery,
  AddDepositModalQueryVariables,
} from "../routes/projects/commitments/components/AddDepositModal.generated";
import {
  CommitmentOverviewCommentDrawerDocument,
  CommitmentOverviewCommentDrawerQuery,
  CommitmentOverviewCommentDrawerQueryVariables,
} from "../routes/projects/commitments/components/CommitmentOverviewCommentDrawer.generated";
import {
  DeleteUploadedPandaDocDocument,
  DeleteUploadedPandaDocMutation,
  DeleteUploadedPandaDocMutationVariables,
} from "../routes/projects/commitments/components/DeletePandaDocModal.generated";
import {
  CreateNewCommitmentDataDocument,
  CreateNewCommitmentDataQuery,
  CreateNewCommitmentDataQueryVariables,
  SaveNewCommitmentDocument,
  SaveNewCommitmentMutation,
  SaveNewCommitmentMutationVariables,
} from "../routes/projects/commitments/components/NewCommitmentModal.generated";
import {
  SaveOwnerPandaDocDocument,
  SaveOwnerPandaDocMutation,
  SaveOwnerPandaDocMutationVariables,
} from "../routes/projects/commitments/components/PandaDocModalContent.generated";
import {
  PaymentScheduleTabDocument,
  PaymentScheduleTabQuery,
  PaymentScheduleTabQueryVariables,
} from "../routes/projects/commitments/components/PaymentScheduleTab.generated";
import {
  PlanBasedLineItemsTabDocument,
  PlanBasedLineItemsTabQuery,
  PlanBasedLineItemsTabQueryVariables,
} from "../routes/projects/commitments/components/PlanBasedLineItemsTab.generated";
import {
  AddLaborItemModal_EffectiveLocationsDocument,
  AddLaborItemModal_EffectiveLocationsQuery,
  AddLaborItemModal_EffectiveLocationsQueryVariables,
  AddLaborItemModal_GlobalPlanTasksDocument,
  AddLaborItemModal_GlobalPlanTasksQuery,
  AddLaborItemModal_GlobalPlanTasksQueryVariables,
} from "../routes/projects/components/AddLaborItemModal.generated";
import {
  AddMaterialItemModalMetadataDocument,
  AddMaterialItemModalMetadataQuery,
  AddMaterialItemModalMetadataQueryVariables,
} from "../routes/projects/components/AddMaterialItemModal.generated";
import {
  LotConfigurationDetailsDocument,
  LotConfigurationDetailsQuery,
  LotConfigurationDetailsQueryVariables,
} from "../routes/projects/components/LotConfigurationDetailsStaticField.generated";
import {
  RedirectToActiveStageDocument,
  RedirectToActiveStageQuery,
  RedirectToActiveStageQueryVariables,
} from "../routes/projects/components/RedirectToActiveStage.generated";
import {
  HierarchyDashboardPage_FilterOptionsDocument,
  HierarchyDashboardPage_FilterOptionsQuery,
  HierarchyDashboardPage_FilterOptionsQueryVariables,
  HierarchyDashboardPage_ProjectsDocument,
  HierarchyDashboardPage_ProjectsQuery,
  HierarchyDashboardPage_ProjectsQueryVariables,
} from "../routes/projects/dashboard/HierarchyDashboardPage.generated";
import {
  ActivityTabDataDocument,
  ActivityTabDataQuery,
  ActivityTabDataQueryVariables,
} from "../routes/projects/dashboard/components/ActivityTab.generated";
import {
  ProjectDashboardTabDocument,
  ProjectDashboardTabQuery,
  ProjectDashboardTabQueryVariables,
  SaveProjectDashboardDocument,
  SaveProjectDashboardMutation,
  SaveProjectDashboardMutationVariables,
} from "../routes/projects/dashboard/components/DashboardTab.generated";
import {
  UserProjectDocumentsDocument,
  UserProjectDocumentsQuery,
  UserProjectDocumentsQueryVariables,
} from "../routes/projects/dashboard/components/DocumentsTile/DocumentsTile.generated";
import {
  ProjectDashboardFinancialsDocument,
  ProjectDashboardFinancialsQuery,
  ProjectDashboardFinancialsQueryVariables,
} from "../routes/projects/dashboard/components/Financials/ProjectDashboardFinancials.generated";
import {
  HomeownerNotesTileDocument,
  HomeownerNotesTileQuery,
  HomeownerNotesTileQueryVariables,
} from "../routes/projects/dashboard/components/HomeownerNotesTile/HomeownerNotesTile.generated";
import {
  JobLogsTileDocument,
  JobLogsTileQuery,
  JobLogsTileQueryVariables,
} from "../routes/projects/dashboard/components/JobLogsTile/JobLogsTile.generated";
import {
  PhotosTileDocument,
  PhotosTileQuery,
  PhotosTileQueryVariables,
} from "../routes/projects/dashboard/components/PhotosTile/PhotosTile.generated";
import {
  PreConExpectationsTabDocument,
  PreConExpectationsTabQuery,
  PreConExpectationsTabQueryVariables,
} from "../routes/projects/dashboard/components/PreConExpectationsTab.generated";
import {
  ProjectInfoTileDocument,
  ProjectInfoTileQuery,
  ProjectInfoTileQueryVariables,
} from "../routes/projects/dashboard/components/ProjectInfoTile/ProjectInfoTile.generated";
import {
  RecentActivityRailDocument,
  RecentActivityRailQuery,
  RecentActivityRailQueryVariables,
} from "../routes/projects/dashboard/components/RecentActivityRail/RecentActivityRail.generated";
import {
  ProjectScheduleTileDocument,
  ProjectScheduleTileQuery,
  ProjectScheduleTileQueryVariables,
} from "../routes/projects/dashboard/components/ScheduleTile/ScheduleTile.generated";
import {
  TeamMembersTileInternalUsersDocument,
  TeamMembersTileInternalUsersQuery,
  TeamMembersTileInternalUsersQueryVariables,
  TeamMembersTileTradePartnersDocument,
  TeamMembersTileTradePartnersQuery,
  TeamMembersTileTradePartnersQueryVariables,
} from "../routes/projects/dashboard/components/TeamMembersTile/TeamMembersTile.generated";
import {
  ProjectToDosTileDocument,
  ProjectToDosTileQuery,
  ProjectToDosTileQueryVariables,
} from "../routes/projects/dashboard/components/ToDosTile/ProjectToDosTile.generated";
import {
  DeleteDocumentsDocument,
  DeleteDocumentsMutation,
  DeleteDocumentsMutationVariables,
  DocumentCategoriesDocument,
  DocumentCategoriesQuery,
  DocumentCategoriesQueryVariables,
  DocumentEditorDocument,
  DocumentEditorQuery,
  DocumentEditorQueryVariables,
  DocumentsAssetDocument,
  DocumentsAssetQuery,
  DocumentsAssetQueryVariables,
  DocumentsForParentDocument,
  DocumentsForParentQuery,
  DocumentsForParentQueryVariables,
  DocumentsPageDocument,
  DocumentsPageMetadataDocument,
  DocumentsPageMetadataQuery,
  DocumentsPageMetadataQueryVariables,
  DocumentsPageQuery,
  DocumentsPageQueryVariables,
  SaveDocumentsDocument,
  SaveDocumentsMutation,
  SaveDocumentsMutationVariables,
  ScheduleTasksForDocumentParentDocument,
  ScheduleTasksForDocumentParentQuery,
  ScheduleTasksForDocumentParentQueryVariables,
  ToggleDocumentAsFavoritedDocument,
  ToggleDocumentAsFavoritedMutation,
  ToggleDocumentAsFavoritedMutationVariables,
} from "../routes/projects/documents/DocumentsPage.generated";
import {
  DraftScheduleSidePaneDocument,
  DraftScheduleSidePaneQuery,
  DraftScheduleSidePaneQueryVariables,
  DynamicScheduleSidePaneDocument,
  DynamicScheduleSidePaneQuery,
  DynamicScheduleSidePaneQueryVariables,
} from "../routes/projects/dynamic-schedules/components/DynamicScheduleSidePane.generated";
import {
  SaveTradePartnerAvailabilityRequestsDocument,
  SaveTradePartnerAvailabilityRequestsMutation,
  SaveTradePartnerAvailabilityRequestsMutationVariables,
  SendSingleTradePartnerAvailabilityRequestEmailDocument,
  SendSingleTradePartnerAvailabilityRequestEmailQuery,
  SendSingleTradePartnerAvailabilityRequestEmailQueryVariables,
  SendTradePartnerAvailabilityRequestEmailDocument,
  SendTradePartnerAvailabilityRequestEmailQuery,
  SendTradePartnerAvailabilityRequestEmailQueryVariables,
} from "../routes/projects/dynamic-schedules/components/SendTradePartnerAvailabilityRequestEmail.generated";
import {
  PlanTaskBillModal_ProtoBillsDocument,
  PlanTaskBillModal_ProtoBillsQuery,
  PlanTaskBillModal_ProtoBillsQueryVariables,
} from "../routes/projects/dynamic-schedules/components/bill-modal/PlanTaskBillModal.generated";
import {
  DynamicSchedulesSnapshotsDocument,
  DynamicSchedulesSnapshotsQuery,
  DynamicSchedulesSnapshotsQueryVariables,
} from "../routes/projects/dynamic-schedules/components/useScheduleSnapshots.generated";
import {
  PublishDraftScheduleStepperDocument,
  PublishDraftScheduleStepperQuery,
  PublishDraftScheduleStepperQueryVariables,
} from "../routes/projects/dynamic-schedules/draft-mode/PublishDraftScheduleStepper.generated";
import {
  DraftCatalogTasksDocument,
  DraftCatalogTasksQuery,
  DraftCatalogTasksQueryVariables,
  DraftPlanScheduleDocument,
  DraftPlanScheduleQuery,
  DraftPlanScheduleQueryVariables,
  SaveDraftPlanScheduleDocument,
  SaveDraftPlanScheduleMutation,
  SaveDraftPlanScheduleMutationVariables,
  ScheduleDraftModeScheduleFlagReasonsDocument,
  ScheduleDraftModeScheduleFlagReasonsQuery,
  ScheduleDraftModeScheduleFlagReasonsQueryVariables,
} from "../routes/projects/dynamic-schedules/draft-mode/ScheduleDraftMode.generated";
import {
  TradeConfirmPublishStepDocument,
  TradeConfirmPublishStepQuery,
  TradeConfirmPublishStepQueryVariables,
} from "../routes/projects/dynamic-schedules/draft-mode/TradeConfirmPublishStep.generated";
import {
  PlanMilestoneDetailsPageDocument,
  PlanMilestoneDetailsPageQuery,
  PlanMilestoneDetailsPageQueryVariables,
} from "../routes/projects/dynamic-schedules/milestone-view/MilestoneDetailsPage.generated";
import {
  TaskTradePartnerContentMetadataDocument,
  TaskTradePartnerContentMetadataQuery,
  TaskTradePartnerContentMetadataQueryVariables,
} from "../routes/projects/dynamic-schedules/task-details/SchedulingCard.generated";
import {
  DeletePlanTaskChecklistItemDocument,
  DeletePlanTaskChecklistItemMutation,
  DeletePlanTaskChecklistItemMutationVariables,
  PlanTaskDetailsDocumentsDocument,
  PlanTaskDetailsDocumentsQuery,
  PlanTaskDetailsDocumentsQueryVariables,
  PlanTaskDetailsPageDocument,
  PlanTaskDetailsPageQuery,
  PlanTaskDetailsPageQueryVariables,
  SavePlanTaskChecklistItemDocument,
  SavePlanTaskChecklistItemMutation,
  SavePlanTaskChecklistItemMutationVariables,
  SavePlanTaskDocument,
  SavePlanTaskMutation,
  SavePlanTaskMutationVariables,
  SaveRequiredTaskDocumentOnPlanTaskDocument,
  SaveRequiredTaskDocumentOnPlanTaskMutation,
  SaveRequiredTaskDocumentOnPlanTaskMutationVariables,
} from "../routes/projects/dynamic-schedules/task-details/TaskDetailsPage.generated";
import {
  PlanTaskMaterialsPageDocument,
  PlanTaskMaterialsPageQuery,
  PlanTaskMaterialsPageQueryVariables,
} from "../routes/projects/dynamic-schedules/task-details/TaskMaterialsPage.generated";
import {
  CreateEstimateDocument,
  CreateEstimateMutation,
  CreateEstimateMutationVariables,
  CreateEstimateStagesDocument,
  CreateEstimateStagesQuery,
  CreateEstimateStagesQueryVariables,
} from "../routes/projects/estimates/CreateEstimateModal.generated";
import {
  EstimateHistoryDocument,
  EstimateHistoryQuery,
  EstimateHistoryQueryVariables,
} from "../routes/projects/estimates/EstimateHistoryTab.generated";
import {
  EstimateLineItemTabDocument,
  EstimateLineItemTabQuery,
  EstimateLineItemTabQueryVariables,
} from "../routes/projects/estimates/EstimateLineItemsTab.generated";
import {
  EstimatePageDocument,
  EstimatePageQuery,
  EstimatePageQueryVariables,
  SaveEstimateDocument,
  SaveEstimateMutation,
  SaveEstimateMutationVariables,
} from "../routes/projects/estimates/EstimatePage.generated";
import {
  ProjectEstimatesPageDocument,
  ProjectEstimatesPageQuery,
  ProjectEstimatesPageQueryVariables,
} from "../routes/projects/estimates/ProjectEstimatesPage.generated";
import {
  ExpensesPageMetadataDocument,
  ExpensesPageMetadataQuery,
  ExpensesPageMetadataQueryVariables,
} from "../routes/projects/expenses/ExpensesPage.generated";
import {
  ChangeEventFormContentDocument,
  ChangeEventFormContentQuery,
  ChangeEventFormContentQueryVariables,
  SaveChangeEventExpenseLineItemDocument,
  SaveChangeEventExpenseLineItemMutation,
  SaveChangeEventExpenseLineItemMutationVariables,
} from "../routes/projects/expenses/components/ChangeEventForm.generated";
import {
  ConvertExpenseToBillDocument,
  ConvertExpenseToBillMutation,
  ConvertExpenseToBillMutationVariables,
  ExpensesTableByProjectIdDocument,
  ExpensesTableByProjectIdQuery,
  ExpensesTableByProjectIdQueryVariables,
  SaveDocumentsToExpenseDocument,
  SaveDocumentsToExpenseMutation,
  SaveDocumentsToExpenseMutationVariables,
  SaveExpenseAllocationsDocument,
  SaveExpenseAllocationsMutation,
  SaveExpenseAllocationsMutationVariables,
  SaveExpenseDocument,
  SaveExpenseMutation,
  SaveExpenseMutationVariables,
  SaveExpenseTableDocumentDocument,
  SaveExpenseTableDocumentMutation,
  SaveExpenseTableDocumentMutationVariables,
} from "../routes/projects/expenses/components/ExpensesTable.generated";
import {
  ProjectFinishScheduleDocument,
  ProjectFinishScheduleMetadataDocument,
  ProjectFinishScheduleMetadataQuery,
  ProjectFinishScheduleMetadataQueryVariables,
  ProjectFinishScheduleQuery,
  ProjectFinishScheduleQueryVariables,
} from "../routes/projects/finish-schedule/ProjectFinishSchedulePage.generated";
import {
  HomeownerContractLikeScheduleDocument,
  HomeownerContractLikeScheduleQuery,
  HomeownerContractLikeScheduleQueryVariables,
  SaveHomeownerContractChangeOrderDrawsDocument,
  SaveHomeownerContractChangeOrderDrawsMutation,
  SaveHomeownerContractChangeOrderDrawsMutationVariables,
  SaveHomeownerContractDrawsDocument,
  SaveHomeownerContractDrawsMutation,
  SaveHomeownerContractDrawsMutationVariables,
} from "../routes/projects/homeowner-contracts/DrawScheduleTab.generated";
import {
  HomeownerContractChangeOrder2Document,
  HomeownerContractChangeOrder2Query,
  HomeownerContractChangeOrder2QueryVariables,
  SaveHomeownerContractChangeOrderDocument,
  SaveHomeownerContractChangeOrderMutation,
  SaveHomeownerContractChangeOrderMutationVariables,
} from "../routes/projects/homeowner-contracts/HomeownerContractChangeOrderPage.generated";
import {
  HomeownerContractDocument,
  HomeownerContractQuery,
  HomeownerContractQueryVariables,
  SaveHomeownerContractDocument,
  SaveHomeownerContractMutation,
  SaveHomeownerContractMutationVariables,
} from "../routes/projects/homeowner-contracts/HomeownerContractPage.generated";
import {
  GeneratePocInvoiceDocument,
  GeneratePocInvoiceMutation,
  GeneratePocInvoiceMutationVariables,
  InvoiceScheduleDocument,
  InvoiceScheduleQuery,
  InvoiceScheduleQueryVariables,
} from "../routes/projects/homeowner-contracts/InvoiceScheduleTab.generated";
import {
  HomeownerContractSummariesDocument,
  HomeownerContractSummariesQuery,
  HomeownerContractSummariesQueryVariables,
} from "../routes/projects/homeowner-contracts/components/HomeownerContractsTable.generated";
import {
  HomeownerNotesForProjectDocument,
  HomeownerNotesForProjectQuery,
  HomeownerNotesForProjectQueryVariables,
} from "../routes/projects/homeowner-notes/HomeownerNotesPage.generated";
import {
  ProjectItemBillDetailsDocument,
  ProjectItemBillDetailsQuery,
  ProjectItemBillDetailsQueryVariables,
} from "../routes/projects/invoices/BillsModal.generated";
import {
  DeleteInvoiceDocument,
  DeleteInvoiceMutation,
  DeleteInvoiceMutationVariables,
  InvoiceEditDocument,
  InvoiceEditQuery,
  InvoiceEditQueryVariables,
  SaveInvoiceDocument,
  SaveInvoiceMutation,
  SaveInvoiceMutationVariables,
} from "../routes/projects/invoices/InvoiceEditor.generated";
import {
  InvoicePageStatusDocument,
  InvoicePageStatusQuery,
  InvoicePageStatusQueryVariables,
} from "../routes/projects/invoices/InvoicePage.generated";
import {
  InvoiceProjectStageModalDetailsDocument,
  InvoiceProjectStageModalDetailsQuery,
  InvoiceProjectStageModalDetailsQueryVariables,
} from "../routes/projects/invoices/InvoiceProjectStageModal.generated";
import {
  ProjectInvoicesPageDocument,
  ProjectInvoicesPageQuery,
  ProjectInvoicesPageQueryVariables,
} from "../routes/projects/invoices/ProjectInvoicesPage.generated";
import {
  InvoiceCreatePageDocument,
  InvoiceCreatePageQuery,
  InvoiceCreatePageQueryVariables,
  InvoiceIntacctSyncErrorDocument,
  InvoiceIntacctSyncErrorQuery,
  InvoiceIntacctSyncErrorQueryVariables,
  InvoiceProjectDataDocument,
  InvoiceProjectDataQuery,
  InvoiceProjectDataQueryVariables,
  SaveInvoiceCreatePageDocument,
  SaveInvoiceCreatePageMutation,
  SaveInvoiceCreatePageMutationVariables,
  SyncInvoiceToIntacctDocument,
  SyncInvoiceToIntacctMutation,
  SyncInvoiceToIntacctMutationVariables,
} from "../routes/projects/invoices/invoice-v2/InvoiceCreatePage.generated";
import {
  ConfirmDrawProjectStageDocument,
  ConfirmDrawProjectStageQuery,
  ConfirmDrawProjectStageQueryVariables,
} from "../routes/projects/invoices/invoice-v2/invoice-steps/ConfirmDrawAmount.generated";
import {
  ConfirmLineItemsDataDocument,
  ConfirmLineItemsDataQuery,
  ConfirmLineItemsDataQueryVariables,
} from "../routes/projects/invoices/invoice-v2/invoice-steps/ConfirmLineItems.generated";
import {
  SelectFixedItemsDataDocument,
  SelectFixedItemsDataQuery,
  SelectFixedItemsDataQueryVariables,
} from "../routes/projects/invoices/invoice-v2/invoice-steps/SelectFixedItems.generated";
import {
  ProjectItemsDocument,
  ProjectItemsQuery,
  ProjectItemsQueryVariables,
  SaveProjectItemDocument,
  SaveProjectItemMutation,
  SaveProjectItemMutationVariables,
} from "../routes/projects/items/ProjectItems.generated";
import {
  JobLogNoteHistoryTabDocument,
  JobLogNoteHistoryTabQuery,
  JobLogNoteHistoryTabQueryVariables,
} from "../routes/projects/job-logs/JobLogNoteRightPaneContent.generated";
import {
  DeleteJobLogImageDocument,
  DeleteJobLogImageMutation,
  DeleteJobLogImageMutationVariables,
  DeleteJobLogNoteDocument,
  DeleteJobLogNoteMutation,
  DeleteJobLogNoteMutationVariables,
  DuplicateJobLogsDocument,
  DuplicateJobLogsMutation,
  DuplicateJobLogsMutationVariables,
  JobLogDocument,
  JobLogQuery,
  JobLogQueryVariables,
  JobLogsDevelopmentProjectsDocument,
  JobLogsDevelopmentProjectsQuery,
  JobLogsDevelopmentProjectsQueryVariables,
  JobLogsDocument,
  JobLogsFilterDataDocument,
  JobLogsFilterDataQuery,
  JobLogsFilterDataQueryVariables,
  JobLogsForDatePickerDocument,
  JobLogsForDatePickerQuery,
  JobLogsForDatePickerQueryVariables,
  JobLogsForGivenDateAndProjectsForCopyDocument,
  JobLogsForGivenDateAndProjectsForCopyQuery,
  JobLogsForGivenDateAndProjectsForCopyQueryVariables,
  JobLogsProjectEditabilityDocument,
  JobLogsProjectEditabilityQuery,
  JobLogsProjectEditabilityQueryVariables,
  JobLogsQuery,
  JobLogsQueryVariables,
  SaveJobLogDocument,
  SaveJobLogImageDocument,
  SaveJobLogImageMutation,
  SaveJobLogImageMutationVariables,
  SaveJobLogMutation,
  SaveJobLogMutationVariables,
  SaveJobLogNoteDocument,
  SaveJobLogNoteMutation,
  SaveJobLogNoteMutationVariables,
  ScheduleFlagsOnJobLogNoteDocument,
  ScheduleFlagsOnJobLogNoteQuery,
  ScheduleFlagsOnJobLogNoteQueryVariables,
  ScheduleTasksForJobLogsDocument,
  ScheduleTasksForJobLogsQuery,
  ScheduleTasksForJobLogsQueryVariables,
  ScheduleTasksOnJobLogNoteDocument,
  ScheduleTasksOnJobLogNoteQuery,
  ScheduleTasksOnJobLogNoteQueryVariables,
} from "../routes/projects/job-logs/JobLogsPage.generated";
import {
  DeleteHomeownerNoteDocument,
  DeleteHomeownerNoteMutation,
  DeleteHomeownerNoteMutationVariables,
  EditHomeownerNoteDocument,
  EditHomeownerNoteQuery,
  EditHomeownerNoteQueryVariables,
  SaveHomeownerNoteDocument,
  SaveHomeownerNoteMutation,
  SaveHomeownerNoteMutationVariables,
  ScheduleTasksForHomeownerNoteDocument,
  ScheduleTasksForHomeownerNoteQuery,
  ScheduleTasksForHomeownerNoteQueryVariables,
} from "../routes/projects/job-logs/components/HomeownerNoteRightPane.generated";
import {
  ProjectLotSummaryPageDocument,
  ProjectLotSummaryPageQuery,
  ProjectLotSummaryPageQueryVariables,
  StructureLotSummaryPageDocument,
  StructureLotSummaryPageQuery,
  StructureLotSummaryPageQueryVariables,
} from "../routes/projects/lot-summary/ProjectLotSummaryPage.generated";
import {
  AppliableProductOfferingConfigsApplyWithoutChangesDocument,
  AppliableProductOfferingConfigsApplyWithoutChangesMutation,
  AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables,
  AppliableProductOfferingConfigsDocument,
  AppliableProductOfferingConfigsQuery,
  AppliableProductOfferingConfigsQueryVariables,
  ApplicableProductOfferingConfigsPageStructureMetadataDocument,
  ApplicableProductOfferingConfigsPageStructureMetadataQuery,
  ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables,
} from "../routes/projects/product-offering-configs-apply/AppliableProductOfferingConfigsPage.generated";
import {
  ApplyProductOfferingConfig_ComputeDocument,
  ApplyProductOfferingConfig_ComputeQuery,
  ApplyProductOfferingConfig_ComputeQueryVariables,
  ApplyProductOfferingConfig_SelectedDocument,
  ApplyProductOfferingConfig_SelectedQuery,
  ApplyProductOfferingConfig_SelectedQueryVariables,
  ApplyProductOfferingConfigMetaDocument,
  ApplyProductOfferingConfigMetaQuery,
  ApplyProductOfferingConfigMetaQueryVariables,
  ApplyProductOfferingConfigPageMetaDocument,
  ApplyProductOfferingConfigPageMetaQuery,
  ApplyProductOfferingConfigPageMetaQueryVariables,
  ApplyProductOfferingConfigsDocument,
  ApplyProductOfferingConfigsMutation,
  ApplyProductOfferingConfigsMutationVariables,
  CreateProductOfferingConfigChangeEventDocument,
  CreateProductOfferingConfigChangeEventMutation,
  CreateProductOfferingConfigChangeEventMutationVariables,
} from "../routes/projects/product-offering-configs-apply/ApplyProductOfferingConfigPage.generated";
import {
  AvailableGlobalPhasesDocument,
  AvailableGlobalPhasesQuery,
  AvailableGlobalPhasesQueryVariables,
  ProjectSchedulePageV2Document,
  ProjectSchedulePageV2Query,
  ProjectSchedulePageV2QueryVariables,
  SaveScheduleStatusDocument,
  SaveScheduleStatusMutation,
  SaveScheduleStatusMutationVariables,
  SaveScheduleTasksDocument,
  SaveScheduleTasksMutation,
  SaveScheduleTasksMutationVariables,
  ScheduleParentGlobalMilestoneTasksDocument,
  ScheduleParentGlobalMilestoneTasksQuery,
  ScheduleParentGlobalMilestoneTasksQueryVariables,
  TaskStatusesDocument,
  TaskStatusesQuery,
  TaskStatusesQueryVariables,
} from "../routes/projects/schedule-v2/ProjectSchedulePageV2.generated";
import {
  ApplyScheduleTemplatesDocument,
  ApplyScheduleTemplatesMutation,
  ApplyScheduleTemplatesMutationVariables,
  ProjectScheduleTableTasksDocument,
  ProjectScheduleTableTasksQuery,
  ProjectScheduleTableTasksQueryVariables,
  SchedulePhasesDocument,
  SchedulePhasesQuery,
  SchedulePhasesQueryVariables,
} from "../routes/projects/schedule-v2/ProjectScheduleTableV2.generated";
import {
  ScheduleCalendarTasksDocument,
  ScheduleCalendarTasksQuery,
  ScheduleCalendarTasksQueryVariables,
} from "../routes/projects/schedule-v2/calendar/ScheduleCalendar.generated";
import {
  GlobalTasksHeaderDataDocument,
  GlobalTasksHeaderDataQuery,
  GlobalTasksHeaderDataQueryVariables,
} from "../routes/projects/schedule-v2/components/CondensedScheduleHeaderData.generated";
import {
  TaskBillModalContextDocument,
  TaskBillModalContextQuery,
  TaskBillModalContextQueryVariables,
} from "../routes/projects/schedule-v2/contexts/TaskBillModalContext.generated";
import {
  ScheduleHistoryTabDocument,
  ScheduleHistoryTabQuery,
  ScheduleHistoryTabQueryVariables,
} from "../routes/projects/schedule-v2/detail-pane/HistoryTab.generated";
import {
  DeleteRequiredTaskDocumentDocument,
  DeleteRequiredTaskDocumentMutation,
  DeleteRequiredTaskDocumentMutationVariables,
  DeleteScheduleTaskChecklistItemDocument,
  DeleteScheduleTaskChecklistItemMutation,
  DeleteScheduleTaskChecklistItemMutationVariables,
  ProjectRoleDetailsDocument,
  ProjectRoleDetailsQuery,
  ProjectRoleDetailsQueryVariables,
  SaveRequiredTaskDocumentDocument,
  SaveRequiredTaskDocumentMutation,
  SaveRequiredTaskDocumentMutationVariables,
  SaveScheduleTaskChecklistItemDocument,
  SaveScheduleTaskChecklistItemMutation,
  SaveScheduleTaskChecklistItemMutationVariables,
  SaveTaskDocumentsDocument,
  SaveTaskDocumentsMutation,
  SaveTaskDocumentsMutationVariables,
  TaskDetailPaneDocument,
  TaskDetailPaneDropdownOptionsDocument,
  TaskDetailPaneDropdownOptionsQuery,
  TaskDetailPaneDropdownOptionsQueryVariables,
  TaskDetailPaneQuery,
  TaskDetailPaneQueryVariables,
} from "../routes/projects/schedule-v2/detail-pane/TaskDetailPane.generated";
import {
  DeleteScheduleFlagDocument,
  DeleteScheduleFlagMutation,
  DeleteScheduleFlagMutationVariables,
  SaveScheduleFlagDocument,
  SaveScheduleFlagMutation,
  SaveScheduleFlagMutationVariables,
  ScheduleFlagReasonsDocument,
  ScheduleFlagReasonsQuery,
  ScheduleFlagReasonsQueryVariables,
} from "../routes/projects/schedule-v2/detail-pane/scheduleFlags/ScheduleFlags.generated";
import {
  TaskBillModal_ProtoBillsDocument,
  TaskBillModal_ProtoBillsQuery,
  TaskBillModal_ProtoBillsQueryVariables,
  TaskBillModal_SaveBillsDocument,
  TaskBillModal_SaveBillsMutation,
  TaskBillModal_SaveBillsMutationVariables,
} from "../routes/projects/schedule-v2/detail-pane/taskBills/TaskBillModal.generated";
import {
  SaveGanttScheduleTasksDocument,
  SaveGanttScheduleTasksMutation,
  SaveGanttScheduleTasksMutationVariables,
  ScheduleGanttDocument,
  ScheduleGanttQuery,
  ScheduleGanttQueryVariables,
} from "../routes/projects/schedule-v2/gantt/ScheduleGantt.generated";
import {
  AddScheduleTaskDocument,
  AddScheduleTaskQuery,
  AddScheduleTaskQueryVariables,
  ScheduleTaskPhasesDocument,
  ScheduleTaskPhasesQuery,
  ScheduleTaskPhasesQueryVariables,
} from "../routes/projects/schedule-v2/table/AddScheduleTaskPane.generated";
import {
  SaveScheduleSubPhasesDocument,
  SaveScheduleSubPhasesMutation,
  SaveScheduleSubPhasesMutationVariables,
} from "../routes/projects/schedule-v2/table/AddSubPhasePane.generated";
import {
  DeleteSchedulePhaseDocument,
  DeleteSchedulePhaseMutation,
  DeleteSchedulePhaseMutationVariables,
  DeleteScheduleSubPhaseDocument,
  DeleteScheduleSubPhaseMutation,
  DeleteScheduleSubPhaseMutationVariables,
} from "../routes/projects/schedule-v2/table/MoreOptionsMenuCell.generated";
import {
  SetDateViaPredecessorModalDocument,
  SetDateViaPredecessorModalQuery,
  SetDateViaPredecessorModalQueryVariables,
} from "../routes/projects/schedule-v2/table/SetDateViaPredecessor.generated";
import {
  AddItemModalDocument,
  AddItemModalQuery,
  AddItemModalQueryVariables,
} from "../routes/projects/selections/AddProjectItemModal.generated";
import {
  ApplyTemplateModalDocument,
  ApplyTemplateModalPlanDocument,
  ApplyTemplateModalPlanQuery,
  ApplyTemplateModalPlanQueryVariables,
  ApplyTemplateModalQuery,
  ApplyTemplateModalQueryVariables,
} from "../routes/projects/selections/ApplyTemplateModal.generated";
import {
  ImportProjectItemsModalMetadataDocument,
  ImportProjectItemsModalMetadataQuery,
  ImportProjectItemsModalMetadataQueryVariables,
} from "../routes/projects/selections/ImportProjectItemsModal.generated";
import {
  OverviewTabDeleteProjectItemDocument,
  OverviewTabDeleteProjectItemMutation,
  OverviewTabDeleteProjectItemMutationVariables,
  OverviewTabDocument,
  OverviewTabQuery,
  OverviewTabQueryVariables,
  OverviewTabSaveProjectItemDocument,
  OverviewTabSaveProjectItemMutation,
  OverviewTabSaveProjectItemMutationVariables,
  OverviewTabScheduleTasksDocument,
  OverviewTabScheduleTasksQuery,
  OverviewTabScheduleTasksQueryVariables,
} from "../routes/projects/selections/OverviewTab.generated";
import {
  ProjectItemCommitmentTabDocument,
  ProjectItemCommitmentTabQuery,
  ProjectItemCommitmentTabQueryVariables,
} from "../routes/projects/selections/ProjectItemCommitmentsTable.generated";
import {
  ProjectItemHistoryDocument,
  ProjectItemHistoryQuery,
  ProjectItemHistoryQueryVariables,
} from "../routes/projects/selections/ProjectItemHistoryTab.generated";
import {
  DeleteProjectItemDocument,
  DeleteProjectItemMutation,
  DeleteProjectItemMutationVariables,
  SaveProjectItemDetailsDocument,
  SaveProjectItemDetailsMutation,
  SaveProjectItemDetailsMutationVariables,
  SpecTabDocument,
  SpecTabQuery,
  SpecTabQueryVariables,
} from "../routes/projects/selections/SpecTab.generated";
import {
  AddProjectItemDocument,
  AddProjectItemMutation,
  AddProjectItemMutationVariables,
  ApplyItemTemplateDocument,
  ApplyItemTemplateMutation,
  ApplyItemTemplateMutationVariables,
  DeleteProjectItemsDocument,
  DeleteProjectItemsMutation,
  DeleteProjectItemsMutationVariables,
  DuplicateProjectItemsDocument,
  DuplicateProjectItemsMutation,
  DuplicateProjectItemsMutationVariables,
  SaveProjectItemsDocument,
  SaveProjectItemsMutation,
  SaveProjectItemsMutationVariables,
  SpecsAndSelectionItemsDocument,
  SpecsAndSelectionItemsQuery,
  SpecsAndSelectionItemsQueryVariables,
} from "../routes/projects/selections/SpecsAndSelectionsPage.generated";
import {
  CreateCommitmentModalProjectItemDocument,
  CreateCommitmentModalProjectItemQuery,
  CreateCommitmentModalProjectItemQueryVariables,
} from "../routes/projects/selections/bulkActions/CreateCommitmentModal.generated";
import {
  CheckoutSettingsTab_CommunityDocument,
  CheckoutSettingsTab_CommunityQuery,
  CheckoutSettingsTab_CommunityQueryVariables,
  CheckoutSettingsTab_LotDocument,
  CheckoutSettingsTab_LotQuery,
  CheckoutSettingsTab_LotQueryVariables,
  CheckoutSettingsTab_ProductOfferingOptionsDocument,
  CheckoutSettingsTab_ProductOfferingOptionsQuery,
  CheckoutSettingsTab_ProductOfferingOptionsQueryVariables,
  CheckoutSettingsTab_StructureDocument,
  CheckoutSettingsTab_StructureQuery,
  CheckoutSettingsTab_StructureQueryVariables,
  SaveCommunitySettingsDocument,
  SaveCommunitySettingsMutation,
  SaveCommunitySettingsMutationVariables,
  SaveLotSettingsDocument,
  SaveLotSettingsMutation,
  SaveLotSettingsMutationVariables,
  SaveStructureSettingsDocument,
  SaveStructureSettingsMutation,
  SaveStructureSettingsMutationVariables,
} from "../routes/projects/settings/CheckoutSettingsTab.generated";
import {
  CommunityStageOrderDocument,
  CommunityStageOrderQuery,
  CommunityStageOrderQueryVariables,
  SaveGlobalPlanStageVariantsDocument,
  SaveGlobalPlanStageVariantsMutation,
  SaveGlobalPlanStageVariantsMutationVariables,
} from "../routes/projects/settings/CommunityStageOrder.generated";
import {
  CopyMilestoneTargetsModal_CommunitiesDocument,
  CopyMilestoneTargetsModal_CommunitiesQuery,
  CopyMilestoneTargetsModal_CommunitiesQueryVariables,
  CopyMilestoneTargetsModal_SourceScheduleDocument,
  CopyMilestoneTargetsModal_SourceScheduleQuery,
  CopyMilestoneTargetsModal_SourceScheduleQueryVariables,
} from "../routes/projects/settings/CopyMilestoneTargetsModal.generated";
import {
  SaveProjectCollaboratorDocument,
  SaveProjectCollaboratorMutation,
  SaveProjectCollaboratorMutationVariables,
} from "../routes/projects/settings/CreateHomeownerModal.generated";
import {
  DeleteProjectCollaboratorDocument,
  DeleteProjectCollaboratorMutation,
  DeleteProjectCollaboratorMutationVariables,
  HomeownersTabDocument,
  HomeownersTabQuery,
  HomeownersTabQueryVariables,
  SendInviteEmailDocument,
  SendInviteEmailMutation,
  SendInviteEmailMutationVariables,
} from "../routes/projects/settings/HomeownersTab.generated";
import {
  OverallTabDocument,
  OverallTabQuery,
  OverallTabQueryVariables,
  ProjectStatusChangeReasonsDocument,
  ProjectStatusChangeReasonsQuery,
  ProjectStatusChangeReasonsQueryVariables,
  SaveProjectOverallTabDocument,
  SaveProjectOverallTabMutation,
  SaveProjectOverallTabMutationVariables,
} from "../routes/projects/settings/OverallTab.generated";
import {
  PlanScheduleTabDocument,
  PlanScheduleTabQuery,
  PlanScheduleTabQueryVariables,
  SavePlanScheduleSettingsDocument,
  SavePlanScheduleSettingsMutation,
  SavePlanScheduleSettingsMutationVariables,
  SaveScheduleRemindersDocument,
  SaveScheduleRemindersMutation,
  SaveScheduleRemindersMutationVariables,
  SaveScheduleSettingsDocument,
  SaveScheduleSettingsMutation,
  SaveScheduleSettingsMutationVariables,
  ScheduleTabDocument,
  ScheduleTabQuery,
  ScheduleTabQueryVariables,
} from "../routes/projects/settings/ScheduleTab.generated";
import {
  SaveProjectSetUpTabDocument,
  SaveProjectSetUpTabMutation,
  SaveProjectSetUpTabMutationVariables,
  SaveStructureSetUpTabDocument,
  SaveStructureSetUpTabMutation,
  SaveStructureSetUpTabMutationVariables,
  SetUpTabDocument,
  SetUpTabQuery,
  SetUpTabQueryVariables,
} from "../routes/projects/settings/SetUpTab.generated";
import {
  AvailableAssigneesDocument,
  AvailableAssigneesQuery,
  AvailableAssigneesQueryVariables,
  TeamMembersDocument,
  TeamMembersQuery,
  TeamMembersQueryVariables,
  UpdateProjectRoleDocument,
  UpdateProjectRoleMutation,
  UpdateProjectRoleMutationVariables,
} from "../routes/projects/settings/TeamMembersTab.generated";
import {
  AddItemsFromExistingTemplateDocument,
  AddItemsFromExistingTemplateQuery,
  AddItemsFromExistingTemplateQueryVariables,
} from "../routes/settings/itemTemplates/AddItemsFromExistingItemTemplateModal.generated";
import {
  ItemTemplateImportModalDocument,
  ItemTemplateImportModalQuery,
  ItemTemplateImportModalQueryVariables,
} from "../routes/settings/itemTemplates/ImportItemTemplateItemsModal.generated";
import {
  ItemTemplateItemDetailDocument,
  ItemTemplateItemDetailQuery,
  ItemTemplateItemDetailQueryVariables,
} from "../routes/settings/itemTemplates/ItemTemplateItemDetail.generated";
import {
  ItemTemplateItemVersionsPage_GroupsDocument,
  ItemTemplateItemVersionsPage_GroupsQuery,
  ItemTemplateItemVersionsPage_GroupsQueryVariables,
  ItemTemplateItemVersionsPageDocument,
  ItemTemplateItemVersionsPageQuery,
  ItemTemplateItemVersionsPageQueryVariables,
  ItemTemplateLineItemsTabDocument,
  ItemTemplateLineItemsTabQuery,
  ItemTemplateLineItemsTabQueryVariables,
} from "../routes/settings/itemTemplates/ItemTemplateLineItemsTab.generated";
import {
  ItemTemplatesDocument,
  ItemTemplatesQuery,
  ItemTemplatesQueryVariables,
} from "../routes/settings/itemTemplates/ItemTemplates.generated";
import {
  ItemTemplateAnomaliesContextDocument,
  ItemTemplateAnomaliesContextQuery,
  ItemTemplateAnomaliesContextQueryVariables,
} from "../routes/settings/itemTemplates/anomalies/ItemTemplateAnomaliesContext.generated";
import {
  ItApi_CopyItemTemplateItemsDocument,
  ItApi_CopyItemTemplateItemsMutation,
  ItApi_CopyItemTemplateItemsMutationVariables,
  ItApi_SaveItemTemplateItemVersionsDocument,
  ItApi_SaveItemTemplateItemVersionsMutation,
  ItApi_SaveItemTemplateItemVersionsMutationVariables,
} from "../routes/settings/itemTemplates/api/ItemTemplateApi.generated";
import {
  GetTradeCategoriesDocument,
  GetTradeCategoriesQuery,
  GetTradeCategoriesQueryVariables,
  GetTradeCategoryDocument,
  GetTradeCategoryQuery,
  GetTradeCategoryQueryVariables,
  SaveTradeCategoryDocument,
  SaveTradeCategoryMutation,
  SaveTradeCategoryMutationVariables,
} from "../routes/trade-categories/TradeCategories.generated";
import {
  TradePartnerCommitmentsDocument,
  TradePartnerCommitmentsMetadataDocument,
  TradePartnerCommitmentsMetadataQuery,
  TradePartnerCommitmentsMetadataQueryVariables,
  TradePartnerCommitmentsQuery,
  TradePartnerCommitmentsQueryVariables,
} from "../routes/trade-partners/TradePartnerCommitmentsTab.generated";
import {
  SaveTradePartnerContactUserDocument,
  SaveTradePartnerContactUserMutation,
  SaveTradePartnerContactUserMutationVariables,
} from "../routes/trade-partners/TradePartnerContactCommunicationPreferences.generated";
import {
  DeleteTradePartnerContactDocument,
  DeleteTradePartnerContactMutation,
  DeleteTradePartnerContactMutationVariables,
  SaveTradePartnerContactDocument,
  SaveTradePartnerContactMutation,
  SaveTradePartnerContactMutationVariables,
  SaveTradePartnerMarketContactDocument,
  SaveTradePartnerMarketContactMutation,
  SaveTradePartnerMarketContactMutationVariables,
  TradePartnerContactsDocument,
  TradePartnerContactsQuery,
  TradePartnerContactsQueryVariables,
} from "../routes/trade-partners/TradePartnerContactsTab.generated";
import {
  TradePartnerDetailsTabDocument,
  TradePartnerDetailsTabQuery,
  TradePartnerDetailsTabQueryVariables,
} from "../routes/trade-partners/TradePartnerDetailsTab.generated";
import {
  TradePartnerDevelopmentContractsDocument,
  TradePartnerDevelopmentContractsQuery,
  TradePartnerDevelopmentContractsQueryVariables,
} from "../routes/trade-partners/TradePartnerDevelopmentContractsTab.generated";
import {
  DeleteTradePartnerDocument,
  DeleteTradePartnerMutation,
  DeleteTradePartnerMutationVariables,
  SaveTradePartnerDocument,
  SaveTradePartnerMutation,
  SaveTradePartnerMutationVariables,
  TradePartnerPageDocument,
  TradePartnerPageQuery,
  TradePartnerPageQueryVariables,
} from "../routes/trade-partners/TradePartnerPage.generated";
import {
  SaveTradePartnerRequirementDocument,
  SaveTradePartnerRequirementMutation,
  SaveTradePartnerRequirementMutationVariables,
  TradePartnerRequirementsDocument,
  TradePartnerRequirementsQuery,
  TradePartnerRequirementsQueryVariables,
} from "../routes/trade-partners/TradePartnerRequirementsTab.generated";
import {
  TradePartnersDocument,
  TradePartnersMetadataDocument,
  TradePartnersMetadataQuery,
  TradePartnersMetadataQueryVariables,
  TradePartnersPageDocument,
  TradePartnersPageQuery,
  TradePartnersPageQueryVariables,
  TradePartnersQuery,
  TradePartnersQueryVariables,
} from "../routes/trade-partners/TradePartnersPage.generated";
import {
  TradePartnerContactsRolesPanelMetadataDocument,
  TradePartnerContactsRolesPanelMetadataQuery,
  TradePartnerContactsRolesPanelMetadataQueryVariables,
} from "../routes/trade-partners/components/TradePartnerContactsRolesPanel.generated";
import {
  SaveTradePartnerReviewDocument,
  SaveTradePartnerReviewMutation,
  SaveTradePartnerReviewMutationVariables,
  TradePartnerReviewsDocument,
  TradePartnerReviewsQuery,
  TradePartnerReviewsQueryVariables,
} from "../routes/trade-partners/components/TradePartnerReviewsTab.generated";
import {
  PaymentTermsDocument,
  PaymentTermsQuery,
  PaymentTermsQueryVariables,
  SavePaymentTermDocument,
  SavePaymentTermMutation,
  SavePaymentTermMutationVariables,
} from "../routes/trade-partners/payment-terms/PaymentTermsPage.generated";
import {
  SaveTradeCategoryLeadTimesDocument,
  SaveTradeCategoryLeadTimesMutation,
  SaveTradeCategoryLeadTimesMutationVariables,
  TradeCategoryLeadTimesDocument,
  TradeCategoryLeadTimesMetaDataDocument,
  TradeCategoryLeadTimesMetaDataQuery,
  TradeCategoryLeadTimesMetaDataQueryVariables,
  TradeCategoryLeadTimesQuery,
  TradeCategoryLeadTimesQueryVariables,
} from "../routes/trade-partners/trade-category-lead-times/TradeCategoryLeadTimesPage.generated";
import {
  SaveWarrantyTicketDocument,
  SaveWarrantyTicketItemsDocument,
  SaveWarrantyTicketItemsMutation,
  SaveWarrantyTicketItemsMutationVariables,
  SaveWarrantyTicketMutation,
  SaveWarrantyTicketMutationVariables,
  WarrantyTicketFiltersDocument,
  WarrantyTicketFiltersQuery,
  WarrantyTicketFiltersQueryVariables,
  WarrantyTicketsDocument,
  WarrantyTicketsQuery,
  WarrantyTicketsQueryVariables,
} from "../routes/warranty/WarrantyPage.generated";
import {
  DeleteWarrantyTicketDocument,
  DeleteWarrantyTicketMutation,
  DeleteWarrantyTicketMutationVariables,
} from "../routes/warranty/WarrantySummaryView.generated";
import {
  DeleteWarrantyTicketItemDocument,
  DeleteWarrantyTicketItemMutation,
  DeleteWarrantyTicketItemMutationVariables,
  SaveWarrantyTicketPageDocument,
  SaveWarrantyTicketPageMutation,
  SaveWarrantyTicketPageMutationVariables,
  WarrantyTicketDocument,
  WarrantyTicketEnumsDocument,
  WarrantyTicketEnumsQuery,
  WarrantyTicketEnumsQueryVariables,
  WarrantyTicketQuery,
  WarrantyTicketQueryVariables,
} from "../routes/warranty/WarrantyTicketPage.generated";
import {
  WarrantyModalProjectsDocument,
  WarrantyModalProjectsQuery,
  WarrantyModalProjectsQueryVariables,
  WarrantyModalTicketTypesAndDevelopmentsDocument,
  WarrantyModalTicketTypesAndDevelopmentsQuery,
  WarrantyModalTicketTypesAndDevelopmentsQueryVariables,
} from "../routes/warranty/components/CreateWarrantyTicketModal.generated";
import {
  ProjectContactsDocument,
  ProjectContactsQuery,
  ProjectContactsQueryVariables,
  SaveProjectContactWarrantyDocument,
  SaveProjectContactWarrantyMutation,
  SaveProjectContactWarrantyMutationVariables,
} from "../routes/warranty/components/WarrantyContactSection.generated";

interface AllocateProjectItemsTaskModalDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newAllocateProjectItemsTaskModalData(
  data: AllocateProjectItemsTaskModalDataOptions,
): AllocateProjectItemsTaskModalQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newAllocateProjectItemsTaskModalResponse(
  variables: AllocateProjectItemsTaskModalQueryVariables,
  data: AllocateProjectItemsTaskModalDataOptions | Error,
): MockedResponse<AllocateProjectItemsTaskModalQueryVariables, AllocateProjectItemsTaskModalQuery> {
  return {
    request: { query: AllocateProjectItemsTaskModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAllocateProjectItemsTaskModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MyTasksTestDataOptions {
  tasks2?: FactoryInput<TaskPage, TaskPageOptions>;
}

export function newMyTasksTestData(data: MyTasksTestDataOptions): MyTasksTestQuery {
  return { __typename: "Query" as const, tasks2: maybeNew("TaskPage", data["tasks2"] || undefined, {}) } as any;
}

export function newMyTasksTestResponse(
  variables: MyTasksTestQueryVariables,
  data: MyTasksTestDataOptions | Error,
): MockedResponse<MyTasksTestQueryVariables, MyTasksTestQuery> {
  return {
    request: { query: MyTasksTestDocument, variables },
    result: { data: data instanceof Error ? undefined : newMyTasksTestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CurrentUserZenDeskJwtDataOptions {
  currentUser?: FactoryInput<User, UserOptions> | null;
}

export function newCurrentUserZenDeskJwtData(data: CurrentUserZenDeskJwtDataOptions): CurrentUserZenDeskJwtQuery {
  return {
    __typename: "Query" as const,
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newCurrentUserZenDeskJwtResponse(
  data: CurrentUserZenDeskJwtDataOptions | Error,
): MockedResponse<CurrentUserZenDeskJwtQueryVariables, CurrentUserZenDeskJwtQuery> {
  return {
    request: { query: CurrentUserZenDeskJwtDocument },
    result: { data: data instanceof Error ? undefined : newCurrentUserZenDeskJwtData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InternalUsersDataOptions {
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newInternalUsersData(data: InternalUsersDataOptions): InternalUsersQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newInternalUsersResponse(
  data: InternalUsersDataOptions | Error,
): MockedResponse<InternalUsersQueryVariables, InternalUsersQuery> {
  return {
    request: { query: InternalUsersDocument },
    result: { data: data instanceof Error ? undefined : newInternalUsersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UseLocationsTreeDataOptions {
  locations?: FactoryInput<Location, LocationOptions>[];
}

export function newUseLocationsTreeData(data: UseLocationsTreeDataOptions): UseLocationsTreeQuery {
  return {
    __typename: "Query" as const,
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newUseLocationsTreeResponse(
  variables: UseLocationsTreeQueryVariables,
  data: UseLocationsTreeDataOptions | Error,
): MockedResponse<UseLocationsTreeQueryVariables, UseLocationsTreeQuery> {
  return {
    request: { query: UseLocationsTreeDocument, variables },
    result: { data: data instanceof Error ? undefined : newUseLocationsTreeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TrackedJobsPollDataOptions {
  trackedJobs?: FactoryInput<TrackedJob, TrackedJobOptions>[];
}

export function newTrackedJobsPollData(data: TrackedJobsPollDataOptions): TrackedJobsPollQuery {
  return {
    __typename: "Query" as const,
    trackedJobs: data["trackedJobs"]?.map((d) => maybeNew("TrackedJob", d, {})) || [],
  } as any;
}

export function newTrackedJobsPollResponse(
  variables: TrackedJobsPollQueryVariables,
  data: TrackedJobsPollDataOptions | Error,
): MockedResponse<TrackedJobsPollQueryVariables, TrackedJobsPollQuery> {
  return {
    request: { query: TrackedJobsPollDocument, variables },
    result: { data: data instanceof Error ? undefined : newTrackedJobsPollData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectLocationsTreeDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectLocationsTreeData(data: ProjectLocationsTreeDataOptions): ProjectLocationsTreeQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectLocationsTreeResponse(
  variables: ProjectLocationsTreeQueryVariables,
  data: ProjectLocationsTreeDataOptions | Error,
): MockedResponse<ProjectLocationsTreeQueryVariables, ProjectLocationsTreeQuery> {
  return {
    request: { query: ProjectLocationsTreeDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectLocationsTreeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectStageDataOptions {
  saveProjectStage?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newSaveProjectStageData(data: SaveProjectStageDataOptions): SaveProjectStageMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectStage: maybeNew("EmptyResult", data["saveProjectStage"] || undefined, {}),
  } as any;
}

export function newSaveProjectStageResponse(
  variables: SaveProjectStageMutationVariables,
  data: SaveProjectStageDataOptions | Error,
): MockedResponse<SaveProjectStageMutationVariables, SaveProjectStageMutation> {
  return {
    request: { query: SaveProjectStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompleteStageDataOptions {
  completeStage?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newCompleteStageData(data: CompleteStageDataOptions): CompleteStageMutation {
  return {
    __typename: "Mutation" as const,
    completeStage: maybeNew("EmptyResult", data["completeStage"] || undefined, {}),
  } as any;
}

export function newCompleteStageResponse(
  variables: CompleteStageMutationVariables,
  data: CompleteStageDataOptions | Error,
): MockedResponse<CompleteStageMutationVariables, CompleteStageMutation> {
  return {
    request: { query: CompleteStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompleteStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostConfidencesDataOptions {
  costConfidences?: FactoryInput<CostConfidenceDetail, CostConfidenceDetailOptions>[];
}

export function newCostConfidencesData(data: CostConfidencesDataOptions): CostConfidencesQuery {
  return {
    __typename: "Query" as const,
    costConfidences: data["costConfidences"]?.map((d) => maybeNew("CostConfidenceDetail", d, {})) || [],
  } as any;
}

export function newCostConfidencesResponse(
  data: CostConfidencesDataOptions | Error,
): MockedResponse<CostConfidencesQueryVariables, CostConfidencesQuery> {
  return {
    request: { query: CostConfidencesDocument },
    result: { data: data instanceof Error ? undefined : newCostConfidencesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CurrentInternalUserDataOptions {
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newCurrentInternalUserData(data: CurrentInternalUserDataOptions): CurrentInternalUserQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newCurrentInternalUserResponse(
  data: CurrentInternalUserDataOptions | Error,
): MockedResponse<CurrentInternalUserQueryVariables, CurrentInternalUserQuery> {
  return {
    request: { query: CurrentInternalUserDocument },
    result: { data: data instanceof Error ? undefined : newCurrentInternalUserData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface StopInternalUserImpersonationDataOptions {
  saveInternalUser?: FactoryInput<SaveInternalUserResult, SaveInternalUserResultOptions>;
}

export function newStopInternalUserImpersonationData(
  data: StopInternalUserImpersonationDataOptions,
): StopInternalUserImpersonationMutation {
  return {
    __typename: "Mutation" as const,
    saveInternalUser: maybeNew("SaveInternalUserResult", data["saveInternalUser"] || undefined, {}),
  } as any;
}

export function newStopInternalUserImpersonationResponse(
  data: StopInternalUserImpersonationDataOptions | Error,
): MockedResponse<StopInternalUserImpersonationMutationVariables, StopInternalUserImpersonationMutation> {
  return {
    request: { query: StopInternalUserImpersonationDocument },
    result: { data: data instanceof Error ? undefined : newStopInternalUserImpersonationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserFeatureFlagsDataOptions {
  userFeatureFlags?: FactoryInput<FeatureFlag, FeatureFlagOptions>[];
}

export function newUserFeatureFlagsData(data: UserFeatureFlagsDataOptions): UserFeatureFlagsQuery {
  return {
    __typename: "Query" as const,
    userFeatureFlags: data["userFeatureFlags"]?.map((d) => maybeNew("FeatureFlag", d, {})) || [],
  } as any;
}

export function newUserFeatureFlagsResponse(
  data: UserFeatureFlagsDataOptions | Error,
): MockedResponse<UserFeatureFlagsQueryVariables, UserFeatureFlagsQuery> {
  return {
    request: { query: UserFeatureFlagsDocument },
    result: { data: data instanceof Error ? undefined : newUserFeatureFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFeatureFlagsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectFeatureFlagsData(data: ProjectFeatureFlagsDataOptions): ProjectFeatureFlagsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectFeatureFlagsResponse(
  variables: ProjectFeatureFlagsQueryVariables,
  data: ProjectFeatureFlagsDataOptions | Error,
): MockedResponse<ProjectFeatureFlagsQueryVariables, ProjectFeatureFlagsQuery> {
  return {
    request: { query: ProjectFeatureFlagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFeatureFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentFeatureFlagsDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newDevelopmentFeatureFlagsData(data: DevelopmentFeatureFlagsDataOptions): DevelopmentFeatureFlagsQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentFeatureFlagsResponse(
  variables: DevelopmentFeatureFlagsQueryVariables,
  data: DevelopmentFeatureFlagsDataOptions | Error,
): MockedResponse<DevelopmentFeatureFlagsQueryVariables, DevelopmentFeatureFlagsQuery> {
  return {
    request: { query: DevelopmentFeatureFlagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentFeatureFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SubmitChangesForApprovalStep_ChangeBreakdownTableDataOptions {
  changeEvents?: FactoryInput<ChangeEvent, ChangeEventOptions>[];
}

export function newSubmitChangesForApprovalStep_ChangeBreakdownTableData(
  data: SubmitChangesForApprovalStep_ChangeBreakdownTableDataOptions,
): SubmitChangesForApprovalStep_ChangeBreakdownTableQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => maybeNew("ChangeEvent", d, {})) || [],
  } as any;
}

export function newSubmitChangesForApprovalStep_ChangeBreakdownTableResponse(
  variables: SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables,
  data: SubmitChangesForApprovalStep_ChangeBreakdownTableDataOptions | Error,
): MockedResponse<
  SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables,
  SubmitChangesForApprovalStep_ChangeBreakdownTableQuery
> {
  return {
    request: { query: SubmitChangesForApprovalStep_ChangeBreakdownTableDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newSubmitChangesForApprovalStep_ChangeBreakdownTableData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToggleCommitmentReleaseDataOptions {
  saveCommitment?: FactoryInput<SaveCommitmentResult, SaveCommitmentResultOptions>;
}

export function newToggleCommitmentReleaseData(
  data: ToggleCommitmentReleaseDataOptions,
): ToggleCommitmentReleaseMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitment: maybeNew("SaveCommitmentResult", data["saveCommitment"] || undefined, {}),
  } as any;
}

export function newToggleCommitmentReleaseResponse(
  variables: ToggleCommitmentReleaseMutationVariables,
  data: ToggleCommitmentReleaseDataOptions | Error,
): MockedResponse<ToggleCommitmentReleaseMutationVariables, ToggleCommitmentReleaseMutation> {
  return {
    request: { query: ToggleCommitmentReleaseDocument, variables },
    result: { data: data instanceof Error ? undefined : newToggleCommitmentReleaseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OpenManyChangeEventApprovalsDataOptions {
  saveChangeEvents?: FactoryInput<SaveChangeEventsResult, SaveChangeEventsResultOptions>;
  saveApprovals?: FactoryInput<SaveApprovalsResult, SaveApprovalsResultOptions>;
}

export function newOpenManyChangeEventApprovalsData(
  data: OpenManyChangeEventApprovalsDataOptions,
): OpenManyChangeEventApprovalsMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvents: maybeNew("SaveChangeEventsResult", data["saveChangeEvents"] || undefined, {}),
    saveApprovals: maybeNew("SaveApprovalsResult", data["saveApprovals"] || undefined, {}),
  } as any;
}

export function newOpenManyChangeEventApprovalsResponse(
  variables: OpenManyChangeEventApprovalsMutationVariables,
  data: OpenManyChangeEventApprovalsDataOptions | Error,
): MockedResponse<OpenManyChangeEventApprovalsMutationVariables, OpenManyChangeEventApprovalsMutation> {
  return {
    request: { query: OpenManyChangeEventApprovalsDocument, variables },
    result: { data: data instanceof Error ? undefined : newOpenManyChangeEventApprovalsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateChangeEventApproval_ImpactedPosTableDataOptions {
  changeEvents?: FactoryInput<ChangeEvent, ChangeEventOptions>[];
}

export function newCreateChangeEventApproval_ImpactedPosTableData(
  data: CreateChangeEventApproval_ImpactedPosTableDataOptions,
): CreateChangeEventApproval_ImpactedPosTableQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => maybeNew("ChangeEvent", d, {})) || [],
  } as any;
}

export function newCreateChangeEventApproval_ImpactedPosTableResponse(
  variables: CreateChangeEventApproval_ImpactedPosTableQueryVariables,
  data: CreateChangeEventApproval_ImpactedPosTableDataOptions | Error,
): MockedResponse<
  CreateChangeEventApproval_ImpactedPosTableQueryVariables,
  CreateChangeEventApproval_ImpactedPosTableQuery
> {
  return {
    request: { query: CreateChangeEventApproval_ImpactedPosTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateChangeEventApproval_ImpactedPosTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UseGlobalOptionTagsFilterDataOptions {
  globalOptionTags?: FactoryInput<GlobalOptionTag, GlobalOptionTagOptions>[];
}

export function newUseGlobalOptionTagsFilterData(
  data: UseGlobalOptionTagsFilterDataOptions,
): UseGlobalOptionTagsFilterQuery {
  return {
    __typename: "Query" as const,
    globalOptionTags: data["globalOptionTags"]?.map((d) => maybeNew("GlobalOptionTag", d, {})) || [],
  } as any;
}

export function newUseGlobalOptionTagsFilterResponse(
  variables: UseGlobalOptionTagsFilterQueryVariables,
  data: UseGlobalOptionTagsFilterDataOptions | Error,
): MockedResponse<UseGlobalOptionTagsFilterQueryVariables, UseGlobalOptionTagsFilterQuery> {
  return {
    request: { query: UseGlobalOptionTagsFilterDocument, variables },
    result: { data: data instanceof Error ? undefined : newUseGlobalOptionTagsFilterData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UseRoomTypeFilterDataOptions {
  roomTypes?: FactoryInput<RoomType, RoomTypeOptions>[];
}

export function newUseRoomTypeFilterData(data: UseRoomTypeFilterDataOptions): UseRoomTypeFilterQuery {
  return {
    __typename: "Query" as const,
    roomTypes: data["roomTypes"]?.map((d) => maybeNew("RoomType", d, {})) || [],
  } as any;
}

export function newUseRoomTypeFilterResponse(
  data: UseRoomTypeFilterDataOptions | Error,
): MockedResponse<UseRoomTypeFilterQueryVariables, UseRoomTypeFilterQuery> {
  return {
    request: { query: UseRoomTypeFilterDocument },
    result: { data: data instanceof Error ? undefined : newUseRoomTypeFilterData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventReasonsDataOptions {
  changeEventReasons?: FactoryInput<ChangeEventReason, ChangeEventReasonOptions>[];
}

export function newChangeEventReasonsData(data: ChangeEventReasonsDataOptions): ChangeEventReasonsQuery {
  return {
    __typename: "Query" as const,
    changeEventReasons: data["changeEventReasons"]?.map((d) => maybeNew("ChangeEventReason", d, {})) || [],
  } as any;
}

export function newChangeEventReasonsResponse(
  data: ChangeEventReasonsDataOptions | Error,
): MockedResponse<ChangeEventReasonsQueryVariables, ChangeEventReasonsQuery> {
  return {
    request: { query: ChangeEventReasonsDocument },
    result: { data: data instanceof Error ? undefined : newChangeEventReasonsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeSelectDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newCostCodeSelectData(data: CostCodeSelectDataOptions): CostCodeSelectQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newCostCodeSelectResponse(
  variables: CostCodeSelectQueryVariables,
  data: CostCodeSelectDataOptions | Error,
): MockedResponse<CostCodeSelectQueryVariables, CostCodeSelectQuery> {
  return {
    request: { query: CostCodeSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodeSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemSelectDataOptions {
  potentialBidItems?: FactoryInput<BidItem, BidItemOptions>[];
}

export function newBidItemSelectData(data: BidItemSelectDataOptions): BidItemSelectQuery {
  return {
    __typename: "Query" as const,
    potentialBidItems: data["potentialBidItems"]?.map((d) => maybeNew("BidItem", d, {})) || [],
  } as any;
}

export function newBidItemSelectResponse(
  variables: BidItemSelectQueryVariables,
  data: BidItemSelectDataOptions | Error,
): MockedResponse<BidItemSelectQueryVariables, BidItemSelectQuery> {
  return {
    request: { query: BidItemSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidItemSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostSourceSelectDataOptions {
  bidContractLineItems?: FactoryInput<BidContractLineItem, BidContractLineItemOptions>[];
}

export function newCostSourceSelectData(data: CostSourceSelectDataOptions): CostSourceSelectQuery {
  return {
    __typename: "Query" as const,
    bidContractLineItems: data["bidContractLineItems"]?.map((d) => maybeNew("BidContractLineItem", d, {})) || [],
  } as any;
}

export function newCostSourceSelectResponse(
  variables: CostSourceSelectQueryVariables,
  data: CostSourceSelectDataOptions | Error,
): MockedResponse<CostSourceSelectQueryVariables, CostSourceSelectQuery> {
  return {
    request: { query: CostSourceSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostSourceSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalPlanTaskSelectDataOptions {
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
}

export function newGlobalPlanTaskSelectData(data: GlobalPlanTaskSelectDataOptions): GlobalPlanTaskSelectQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newGlobalPlanTaskSelectResponse(
  variables: GlobalPlanTaskSelectQueryVariables,
  data: GlobalPlanTaskSelectDataOptions | Error,
): MockedResponse<GlobalPlanTaskSelectQueryVariables, GlobalPlanTaskSelectQuery> {
  return {
    request: { query: GlobalPlanTaskSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalPlanTaskSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemsSelectDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newItemsSelectData(data: ItemsSelectDataOptions): ItemsSelectQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [] } as any;
}

export function newItemsSelectResponse(
  variables: ItemsSelectQueryVariables,
  data: ItemsSelectDataOptions | Error,
): MockedResponse<ItemsSelectQueryVariables, ItemsSelectQuery> {
  return {
    request: { query: ItemsSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemsSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MadTypesDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newMadTypesData(data: MadTypesDataOptions): MadTypesQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newMadTypesResponse(
  data: MadTypesDataOptions | Error,
): MockedResponse<MadTypesQueryVariables, MadTypesQuery> {
  return {
    request: { query: MadTypesDocument },
    result: { data: data instanceof Error ? undefined : newMadTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectAutocompleteDataOptions {
  projectsPage?: FactoryInput<ProjectsPageResult, ProjectsPageResultOptions>;
}

export function newProjectAutocompleteData(data: ProjectAutocompleteDataOptions): ProjectAutocompleteQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newProjectAutocompleteResponse(
  variables: ProjectAutocompleteQueryVariables,
  data: ProjectAutocompleteDataOptions | Error,
): MockedResponse<ProjectAutocompleteQueryVariables, ProjectAutocompleteQuery> {
  return {
    request: { query: ProjectAutocompleteDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectAutocompleteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LocationsDataOptions {
  locations?: FactoryInput<Location, LocationOptions>[];
}

export function newLocationsData(data: LocationsDataOptions): LocationsQuery {
  return {
    __typename: "Query" as const,
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newLocationsResponse(
  variables: LocationsQueryVariables,
  data: LocationsDataOptions | Error,
): MockedResponse<LocationsQueryVariables, LocationsQuery> {
  return {
    request: { query: LocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerAutocompleteDataOptions {
  tradePartnersPage?: FactoryInput<TradePartnersPage, TradePartnersPageOptions>;
}

export function newTradePartnerAutocompleteData(
  data: TradePartnerAutocompleteDataOptions,
): TradePartnerAutocompleteQuery {
  return {
    __typename: "Query" as const,
    tradePartnersPage: maybeNew("TradePartnersPage", data["tradePartnersPage"] || undefined, {}),
  } as any;
}

export function newTradePartnerAutocompleteResponse(
  variables: TradePartnerAutocompleteQueryVariables,
  data: TradePartnerAutocompleteDataOptions | Error,
): MockedResponse<TradePartnerAutocompleteQueryVariables, TradePartnerAutocompleteQuery> {
  return {
    request: { query: TradePartnerAutocompleteDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerAutocompleteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnersSelectDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newTradePartnersSelectData(data: TradePartnersSelectDataOptions): TradePartnersSelectQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newTradePartnersSelectResponse(
  variables: TradePartnersSelectQueryVariables,
  data: TradePartnersSelectDataOptions | Error,
): MockedResponse<TradePartnersSelectQueryVariables, TradePartnersSelectQuery> {
  return {
    request: { query: TradePartnersSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnersSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UnitsOfMeasureDataOptions {
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
}

export function newUnitsOfMeasureData(data: UnitsOfMeasureDataOptions): UnitsOfMeasureQuery {
  return {
    __typename: "Query" as const,
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
  } as any;
}

export function newUnitsOfMeasureResponse(
  data: UnitsOfMeasureDataOptions | Error,
): MockedResponse<UnitsOfMeasureQueryVariables, UnitsOfMeasureQuery> {
  return {
    request: { query: UnitsOfMeasureDocument },
    result: { data: data instanceof Error ? undefined : newUnitsOfMeasureData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractPlanPricing_RevisionDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newBidContractPlanPricing_RevisionData(
  data: BidContractPlanPricing_RevisionDataOptions,
): BidContractPlanPricing_RevisionQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractPlanPricing_RevisionResponse(
  variables: BidContractPlanPricing_RevisionQueryVariables,
  data: BidContractPlanPricing_RevisionDataOptions | Error,
): MockedResponse<BidContractPlanPricing_RevisionQueryVariables, BidContractPlanPricing_RevisionQuery> {
  return {
    request: { query: BidContractPlanPricing_RevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractPlanPricing_RevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractPlanPricing_ScopeLinesDataOptions {
  bidPackageVersionScopeLines?: FactoryInput<BidPackageScopeLine, BidPackageScopeLineOptions>[];
}

export function newBidContractPlanPricing_ScopeLinesData(
  data: BidContractPlanPricing_ScopeLinesDataOptions,
): BidContractPlanPricing_ScopeLinesQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersionScopeLines:
      data["bidPackageVersionScopeLines"]?.map((d) => maybeNew("BidPackageScopeLine", d, {})) || [],
  } as any;
}

export function newBidContractPlanPricing_ScopeLinesResponse(
  variables: BidContractPlanPricing_ScopeLinesQueryVariables,
  data: BidContractPlanPricing_ScopeLinesDataOptions | Error,
): MockedResponse<BidContractPlanPricing_ScopeLinesQueryVariables, BidContractPlanPricing_ScopeLinesQuery> {
  return {
    request: { query: BidContractPlanPricing_ScopeLinesDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractPlanPricing_ScopeLinesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractPlanPricing_ReadyPlanOptionsDataOptions {
  readyPlanOptions?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>[];
}

export function newBidContractPlanPricing_ReadyPlanOptionsData(
  data: BidContractPlanPricing_ReadyPlanOptionsDataOptions,
): BidContractPlanPricing_ReadyPlanOptionsQuery {
  return {
    __typename: "Query" as const,
    readyPlanOptions: data["readyPlanOptions"]?.map((d) => maybeNew("ReadyPlanOption", d, {})) || [],
  } as any;
}

export function newBidContractPlanPricing_ReadyPlanOptionsResponse(
  variables: BidContractPlanPricing_ReadyPlanOptionsQueryVariables,
  data: BidContractPlanPricing_ReadyPlanOptionsDataOptions | Error,
): MockedResponse<BidContractPlanPricing_ReadyPlanOptionsQueryVariables, BidContractPlanPricing_ReadyPlanOptionsQuery> {
  return {
    request: { query: BidContractPlanPricing_ReadyPlanOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractPlanPricing_ReadyPlanOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionTypesDataOptions {
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
}

export function newGlobalOptionTypesData(data: GlobalOptionTypesDataOptions): GlobalOptionTypesQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
  } as any;
}

export function newGlobalOptionTypesResponse(
  variables: GlobalOptionTypesQueryVariables,
  data: GlobalOptionTypesDataOptions | Error,
): MockedResponse<GlobalOptionTypesQueryVariables, GlobalOptionTypesQuery> {
  return {
    request: { query: GlobalOptionTypesDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractPlanPricingPageV2DataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newBidContractPlanPricingPageV2Data(
  data: BidContractPlanPricingPageV2DataOptions,
): BidContractPlanPricingPageV2Query {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractPlanPricingPageV2Response(
  variables: BidContractPlanPricingPageV2QueryVariables,
  data: BidContractPlanPricingPageV2DataOptions | Error,
): MockedResponse<BidContractPlanPricingPageV2QueryVariables, BidContractPlanPricingPageV2Query> {
  return {
    request: { query: BidContractPlanPricingPageV2Document, variables },
    result: { data: data instanceof Error ? undefined : newBidContractPlanPricingPageV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractPurchaseOrdersPageDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newBidContractPurchaseOrdersPageData(
  data: BidContractPurchaseOrdersPageDataOptions,
): BidContractPurchaseOrdersPageQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractPurchaseOrdersPageResponse(
  variables: BidContractPurchaseOrdersPageQueryVariables,
  data: BidContractPurchaseOrdersPageDataOptions | Error,
): MockedResponse<BidContractPurchaseOrdersPageQueryVariables, BidContractPurchaseOrdersPageQuery> {
  return {
    request: { query: BidContractPurchaseOrdersPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractPurchaseOrdersPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractRevisionUnitPricingDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newBidContractRevisionUnitPricingData(
  data: BidContractRevisionUnitPricingDataOptions,
): BidContractRevisionUnitPricingQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractRevisionUnitPricingResponse(
  variables: BidContractRevisionUnitPricingQueryVariables,
  data: BidContractRevisionUnitPricingDataOptions | Error,
): MockedResponse<BidContractRevisionUnitPricingQueryVariables, BidContractRevisionUnitPricingQuery> {
  return {
    request: { query: BidContractRevisionUnitPricingDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractRevisionUnitPricingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractUnitPricingDataOptions {
  saveBidContractLineItems?: FactoryInput<SaveBidContractLineItemsResult, SaveBidContractLineItemsResultOptions>;
}

export function newSaveBidContractUnitPricingData(
  data: SaveBidContractUnitPricingDataOptions,
): SaveBidContractUnitPricingMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractLineItems: maybeNew(
      "SaveBidContractLineItemsResult",
      data["saveBidContractLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveBidContractUnitPricingResponse(
  variables: SaveBidContractUnitPricingMutationVariables,
  data: SaveBidContractUnitPricingDataOptions | Error,
): MockedResponse<SaveBidContractUnitPricingMutationVariables, SaveBidContractUnitPricingMutation> {
  return {
    request: { query: SaveBidContractUnitPricingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractUnitPricingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractsTableV2DataOptions {
  bidContractsPage?: FactoryInput<BidContractsPage, BidContractsPageOptions>;
}

export function newBidContractsTableV2Data(data: BidContractsTableV2DataOptions): BidContractsTableV2Query {
  return {
    __typename: "Query" as const,
    bidContractsPage: maybeNew("BidContractsPage", data["bidContractsPage"] || undefined, {}),
  } as any;
}

export function newBidContractsTableV2Response(
  variables: BidContractsTableV2QueryVariables,
  data: BidContractsTableV2DataOptions | Error,
): MockedResponse<BidContractsTableV2QueryVariables, BidContractsTableV2Query> {
  return {
    request: { query: BidContractsTableV2Document, variables },
    result: { data: data instanceof Error ? undefined : newBidContractsTableV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemsModalDataOptions {
  bidItemsPage?: FactoryInput<BidItemsPage, BidItemsPageOptions>;
}

export function newBidItemsModalData(data: BidItemsModalDataOptions): BidItemsModalQuery {
  return {
    __typename: "Query" as const,
    bidItemsPage: maybeNew("BidItemsPage", data["bidItemsPage"] || undefined, {}),
  } as any;
}

export function newBidItemsModalResponse(
  variables: BidItemsModalQueryVariables,
  data: BidItemsModalDataOptions | Error,
): MockedResponse<BidItemsModalQueryVariables, BidItemsModalQuery> {
  return {
    request: { query: BidItemsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidItemsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BusinessFunctionsDataOptions {
  businessFunctions?: FactoryInput<BusinessFunction, BusinessFunctionOptions>[];
}

export function newBusinessFunctionsData(data: BusinessFunctionsDataOptions): BusinessFunctionsQuery {
  return {
    __typename: "Query" as const,
    businessFunctions: data["businessFunctions"]?.map((d) => maybeNew("BusinessFunction", d, {})) || [],
  } as any;
}

export function newBusinessFunctionsResponse(
  data: BusinessFunctionsDataOptions | Error,
): MockedResponse<BusinessFunctionsQueryVariables, BusinessFunctionsQuery> {
  return {
    request: { query: BusinessFunctionsDocument },
    result: { data: data instanceof Error ? undefined : newBusinessFunctionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BusinessFunctionDetailsDataOptions {
  businessFunction?: FactoryInput<BusinessFunction, BusinessFunctionOptions>;
}

export function newBusinessFunctionDetailsData(data: BusinessFunctionDetailsDataOptions): BusinessFunctionDetailsQuery {
  return {
    __typename: "Query" as const,
    businessFunction: maybeNew("BusinessFunction", data["businessFunction"] || undefined, {}),
  } as any;
}

export function newBusinessFunctionDetailsResponse(
  variables: BusinessFunctionDetailsQueryVariables,
  data: BusinessFunctionDetailsDataOptions | Error,
): MockedResponse<BusinessFunctionDetailsQueryVariables, BusinessFunctionDetailsQuery> {
  return {
    request: { query: BusinessFunctionDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBusinessFunctionDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectRolesForBusinessFunctionDataOptions {
  projectRolesForBusinessFunctionType?: FactoryInput<ProjectRoleDetail, ProjectRoleDetailOptions>[];
}

export function newProjectRolesForBusinessFunctionData(
  data: ProjectRolesForBusinessFunctionDataOptions,
): ProjectRolesForBusinessFunctionQuery {
  return {
    __typename: "Query" as const,
    projectRolesForBusinessFunctionType:
      data["projectRolesForBusinessFunctionType"]?.map((d) => maybeNew("ProjectRoleDetail", d, {})) || [],
  } as any;
}

export function newProjectRolesForBusinessFunctionResponse(
  variables: ProjectRolesForBusinessFunctionQueryVariables,
  data: ProjectRolesForBusinessFunctionDataOptions | Error,
): MockedResponse<ProjectRolesForBusinessFunctionQueryVariables, ProjectRolesForBusinessFunctionQuery> {
  return {
    request: { query: ProjectRolesForBusinessFunctionDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectRolesForBusinessFunctionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBusinessFunctionDataOptions {
  saveBusinessFunction?: FactoryInput<SaveBusinessFunctionResult, SaveBusinessFunctionResultOptions>;
}

export function newSaveBusinessFunctionData(data: SaveBusinessFunctionDataOptions): SaveBusinessFunctionMutation {
  return {
    __typename: "Mutation" as const,
    saveBusinessFunction: maybeNew("SaveBusinessFunctionResult", data["saveBusinessFunction"] || undefined, {}),
  } as any;
}

export function newSaveBusinessFunctionResponse(
  variables: SaveBusinessFunctionMutationVariables,
  data: SaveBusinessFunctionDataOptions | Error,
): MockedResponse<SaveBusinessFunctionMutationVariables, SaveBusinessFunctionMutation> {
  return {
    request: { query: SaveBusinessFunctionDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBusinessFunctionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeLogMetadataDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
  changeRequestGroups?: FactoryInput<ChangeRequestGroup, ChangeRequestGroupOptions>[];
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newChangeLogMetadataData(data: ChangeLogMetadataDataOptions): ChangeLogMetadataQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
    changeRequestGroups: data["changeRequestGroups"]?.map((d) => maybeNew("ChangeRequestGroup", d, {})) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newChangeLogMetadataResponse(
  data: ChangeLogMetadataDataOptions | Error,
): MockedResponse<ChangeLogMetadataQueryVariables, ChangeLogMetadataQuery> {
  return {
    request: { query: ChangeLogMetadataDocument },
    result: { data: data instanceof Error ? undefined : newChangeLogMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeLogProjectFilterMetadataDataOptions {
  projectsPage?: FactoryInput<ProjectsPageResult, ProjectsPageResultOptions>;
}

export function newChangeLogProjectFilterMetadataData(
  data: ChangeLogProjectFilterMetadataDataOptions,
): ChangeLogProjectFilterMetadataQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newChangeLogProjectFilterMetadataResponse(
  variables: ChangeLogProjectFilterMetadataQueryVariables,
  data: ChangeLogProjectFilterMetadataDataOptions | Error,
): MockedResponse<ChangeLogProjectFilterMetadataQueryVariables, ChangeLogProjectFilterMetadataQuery> {
  return {
    request: { query: ChangeLogProjectFilterMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeLogProjectFilterMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeLogRightPaneContentDetailsDataOptions {
  changeRequest?: FactoryInput<ChangeRequest, ChangeRequestOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
  regions?: FactoryInput<Region, RegionOptions>[];
  changeRequestAssets?: FactoryInput<ChangeRequestAssetsPageResult, ChangeRequestAssetsPageResultOptions>;
}

export function newChangeLogRightPaneContentDetailsData(
  data: ChangeLogRightPaneContentDetailsDataOptions,
): ChangeLogRightPaneContentDetailsQuery {
  return {
    __typename: "Query" as const,
    changeRequest: maybeNew("ChangeRequest", data["changeRequest"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    regions: data["regions"]?.map((d) => maybeNew("Region", d, {})) || [],
    changeRequestAssets: maybeNew("ChangeRequestAssetsPageResult", data["changeRequestAssets"] || undefined, {}),
  } as any;
}

export function newChangeLogRightPaneContentDetailsResponse(
  variables: ChangeLogRightPaneContentDetailsQueryVariables,
  data: ChangeLogRightPaneContentDetailsDataOptions | Error,
): MockedResponse<ChangeLogRightPaneContentDetailsQueryVariables, ChangeLogRightPaneContentDetailsQuery> {
  return {
    request: { query: ChangeLogRightPaneContentDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeLogRightPaneContentDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeLogTableDataOptions {
  changeRequests?: FactoryInput<ChangeRequestsPageResult, ChangeRequestsPageResultOptions>;
}

export function newChangeLogTableData(data: ChangeLogTableDataOptions): ChangeLogTableQuery {
  return {
    __typename: "Query" as const,
    changeRequests: maybeNew("ChangeRequestsPageResult", data["changeRequests"] || undefined, {}),
  } as any;
}

export function newChangeLogTableResponse(
  variables: ChangeLogTableQueryVariables,
  data: ChangeLogTableDataOptions | Error,
): MockedResponse<ChangeLogTableQueryVariables, ChangeLogTableQuery> {
  return {
    request: { query: ChangeLogTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeLogTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeTypesDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newChangeTypesData(data: ChangeTypesDataOptions): ChangeTypesQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newChangeTypesResponse(
  data: ChangeTypesDataOptions | Error,
): MockedResponse<ChangeTypesQueryVariables, ChangeTypesQuery> {
  return {
    request: { query: ChangeTypesDocument },
    result: { data: data instanceof Error ? undefined : newChangeTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommentDataOptions {
  saveComment?: FactoryInput<SaveCommentResult, SaveCommentResultOptions>;
}

export function newSaveCommentData(data: SaveCommentDataOptions): SaveCommentMutation {
  return {
    __typename: "Mutation" as const,
    saveComment: maybeNew("SaveCommentResult", data["saveComment"] || undefined, {}),
  } as any;
}

export function newSaveCommentResponse(
  variables: SaveCommentMutationVariables,
  data: SaveCommentDataOptions | Error,
): MockedResponse<SaveCommentMutationVariables, SaveCommentMutation> {
  return {
    request: { query: SaveCommentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCommentDataOptions {
  deleteComment?: FactoryInput<DeleteCommentResult, DeleteCommentResultOptions>;
}

export function newDeleteCommentData(data: DeleteCommentDataOptions): DeleteCommentMutation {
  return {
    __typename: "Mutation" as const,
    deleteComment: maybeNew("DeleteCommentResult", data["deleteComment"] || undefined, {}),
  } as any;
}

export function newDeleteCommentResponse(
  variables: DeleteCommentMutationVariables,
  data: DeleteCommentDataOptions | Error,
): MockedResponse<DeleteCommentMutationVariables, DeleteCommentMutation> {
  return {
    request: { query: DeleteCommentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCommentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFollowersDataOptions {
  saveFollowers?: FactoryInput<SaveFollowersResult, SaveFollowersResultOptions>;
}

export function newSaveFollowersData(data: SaveFollowersDataOptions): SaveFollowersMutation {
  return {
    __typename: "Mutation" as const,
    saveFollowers: maybeNew("SaveFollowersResult", data["saveFollowers"] || undefined, {}),
  } as any;
}

export function newSaveFollowersResponse(
  variables: SaveFollowersMutationVariables,
  data: SaveFollowersDataOptions | Error,
): MockedResponse<SaveFollowersMutationVariables, SaveFollowersMutation> {
  return {
    request: { query: SaveFollowersDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFollowersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MarkCommentStreamAsReadDataOptions {
  markCommentStreamAsRead?: FactoryInput<CommentStream, CommentStreamOptions> | null;
}

export function newMarkCommentStreamAsReadData(
  data: MarkCommentStreamAsReadDataOptions,
): MarkCommentStreamAsReadMutation {
  return {
    __typename: "Mutation" as const,
    markCommentStreamAsRead: maybeNewOrNull("CommentStream", data["markCommentStreamAsRead"] || undefined, {}),
  } as any;
}

export function newMarkCommentStreamAsReadResponse(
  variables: MarkCommentStreamAsReadMutationVariables,
  data: MarkCommentStreamAsReadDataOptions | Error,
): MockedResponse<MarkCommentStreamAsReadMutationVariables, MarkCommentStreamAsReadMutation> {
  return {
    request: { query: MarkCommentStreamAsReadDocument, variables },
    result: { data: data instanceof Error ? undefined : newMarkCommentStreamAsReadData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommentFeedTradePartnersDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newCommentFeedTradePartnersData(
  data: CommentFeedTradePartnersDataOptions,
): CommentFeedTradePartnersQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newCommentFeedTradePartnersResponse(
  variables: CommentFeedTradePartnersQueryVariables,
  data: CommentFeedTradePartnersDataOptions | Error,
): MockedResponse<CommentFeedTradePartnersQueryVariables, CommentFeedTradePartnersQuery> {
  return {
    request: { query: CommentFeedTradePartnersDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommentFeedTradePartnersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateChangeRequestMetadataDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
  regions?: FactoryInput<Region, RegionOptions>[];
  changeRequestAssets?: FactoryInput<ChangeRequestAssetsPageResult, ChangeRequestAssetsPageResultOptions>;
  changeRequestGroups?: FactoryInput<ChangeRequestGroup, ChangeRequestGroupOptions>[];
}

export function newCreateChangeRequestMetadataData(
  data: CreateChangeRequestMetadataDataOptions,
): CreateChangeRequestMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    regions: data["regions"]?.map((d) => maybeNew("Region", d, {})) || [],
    changeRequestAssets: maybeNew("ChangeRequestAssetsPageResult", data["changeRequestAssets"] || undefined, {}),
    changeRequestGroups: data["changeRequestGroups"]?.map((d) => maybeNew("ChangeRequestGroup", d, {})) || [],
  } as any;
}

export function newCreateChangeRequestMetadataResponse(
  data: CreateChangeRequestMetadataDataOptions | Error,
): MockedResponse<CreateChangeRequestMetadataQueryVariables, CreateChangeRequestMetadataQuery> {
  return {
    request: { query: CreateChangeRequestMetadataDocument },
    result: { data: data instanceof Error ? undefined : newCreateChangeRequestMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestDetailsDataOptions {
  changeRequest?: FactoryInput<ChangeRequest, ChangeRequestOptions>;
}

export function newChangeRequestDetailsData(data: ChangeRequestDetailsDataOptions): ChangeRequestDetailsQuery {
  return {
    __typename: "Query" as const,
    changeRequest: maybeNew("ChangeRequest", data["changeRequest"] || undefined, {}),
  } as any;
}

export function newChangeRequestDetailsResponse(
  variables: ChangeRequestDetailsQueryVariables,
  data: ChangeRequestDetailsDataOptions | Error,
): MockedResponse<ChangeRequestDetailsQueryVariables, ChangeRequestDetailsQuery> {
  return {
    request: { query: ChangeRequestDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeRequestDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestDataOptions {
  saveChangeRequest?: FactoryInput<SaveChangeRequestResult, SaveChangeRequestResultOptions>;
}

export function newSaveChangeRequestData(data: SaveChangeRequestDataOptions): SaveChangeRequestMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequest: maybeNew("SaveChangeRequestResult", data["saveChangeRequest"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestResponse(
  variables: SaveChangeRequestMutationVariables,
  data: SaveChangeRequestDataOptions | Error,
): MockedResponse<SaveChangeRequestMutationVariables, SaveChangeRequestMutation> {
  return {
    request: { query: SaveChangeRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestsDataOptions {
  saveChangeRequests?: FactoryInput<SaveChangeRequestsResult, SaveChangeRequestsResultOptions>;
}

export function newSaveChangeRequestsData(data: SaveChangeRequestsDataOptions): SaveChangeRequestsMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequests: maybeNew("SaveChangeRequestsResult", data["saveChangeRequests"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestsResponse(
  variables: SaveChangeRequestsMutationVariables,
  data: SaveChangeRequestsDataOptions | Error,
): MockedResponse<SaveChangeRequestsMutationVariables, SaveChangeRequestsMutation> {
  return {
    request: { query: SaveChangeRequestsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GetCommentsDataOptions {
  commentable?: FactoryInput<Commentable, CommentableOptions>;
}

export function newGetCommentsData(data: GetCommentsDataOptions): GetCommentsQuery {
  return {
    __typename: "Query" as const,
    commentable: maybeNew("Commentable", data["commentable"] || undefined, {}),
  } as any;
}

export function newGetCommentsResponse(
  variables: GetCommentsQueryVariables,
  data: GetCommentsDataOptions | Error,
): MockedResponse<GetCommentsQueryVariables, GetCommentsQuery> {
  return {
    request: { query: GetCommentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newGetCommentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DropsPageDataOptions {
  drops?: FactoryInput<Drop, DropOptions>[];
}

export function newDropsPageData(data: DropsPageDataOptions): DropsPageQuery {
  return { __typename: "Query" as const, drops: data["drops"]?.map((d) => maybeNew("Drop", d, {})) || [] } as any;
}

export function newDropsPageResponse(
  variables: DropsPageQueryVariables,
  data: DropsPageDataOptions | Error,
): MockedResponse<DropsPageQueryVariables, DropsPageQuery> {
  return {
    request: { query: DropsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDropsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDropDataOptions {
  deleteDrop?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteDropData(data: DeleteDropDataOptions): DeleteDropMutation {
  return {
    __typename: "Mutation" as const,
    deleteDrop: maybeNew("EmptyResult", data["deleteDrop"] || undefined, {}),
  } as any;
}

export function newDeleteDropResponse(
  variables: DeleteDropMutationVariables,
  data: DeleteDropDataOptions | Error,
): MockedResponse<DeleteDropMutationVariables, DeleteDropMutation> {
  return {
    request: { query: DeleteDropDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteDropData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DropModalMetadataDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
  project?: FactoryInput<Project, ProjectOptions>;
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newDropModalMetadataData(data: DropModalMetadataDataOptions): DropModalMetadataQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
    project: maybeNew("Project", data["project"] || undefined, {}),
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDropModalMetadataResponse(
  variables: DropModalMetadataQueryVariables,
  data: DropModalMetadataDataOptions | Error,
): MockedResponse<DropModalMetadataQueryVariables, DropModalMetadataQuery> {
  return {
    request: { query: DropModalMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDropModalMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDropDataOptions {
  saveDrop?: FactoryInput<SaveDropResult, SaveDropResultOptions>;
}

export function newSaveDropData(data: SaveDropDataOptions): SaveDropMutation {
  return {
    __typename: "Mutation" as const,
    saveDrop: maybeNew("SaveDropResult", data["saveDrop"] || undefined, {}),
  } as any;
}

export function newSaveDropResponse(
  variables: SaveDropMutationVariables,
  data: SaveDropDataOptions | Error,
): MockedResponse<SaveDropMutationVariables, SaveDropMutation> {
  return {
    request: { query: SaveDropDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDropData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PotentialInvoicesToCreditDataOptions {
  invoices?: FactoryInput<Invoice, InvoiceOptions>[];
}

export function newPotentialInvoicesToCreditData(
  data: PotentialInvoicesToCreditDataOptions,
): PotentialInvoicesToCreditQuery {
  return {
    __typename: "Query" as const,
    invoices: data["invoices"]?.map((d) => maybeNew("Invoice", d, {})) || [],
  } as any;
}

export function newPotentialInvoicesToCreditResponse(
  variables: PotentialInvoicesToCreditQueryVariables,
  data: PotentialInvoicesToCreditDataOptions | Error,
): MockedResponse<PotentialInvoicesToCreditQueryVariables, PotentialInvoicesToCreditQuery> {
  return {
    request: { query: PotentialInvoicesToCreditDocument, variables },
    result: { data: data instanceof Error ? undefined : newPotentialInvoicesToCreditData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommunicationChannelsDataOptions {
  communicationChannels?: FactoryInput<CommunicationChannelDetail, CommunicationChannelDetailOptions>[];
}

export function newCommunicationChannelsData(data: CommunicationChannelsDataOptions): CommunicationChannelsQuery {
  return {
    __typename: "Query" as const,
    communicationChannels: data["communicationChannels"]?.map((d) => maybeNew("CommunicationChannelDetail", d, {})) ||
      [],
  } as any;
}

export function newCommunicationChannelsResponse(
  data: CommunicationChannelsDataOptions | Error,
): MockedResponse<CommunicationChannelsQueryVariables, CommunicationChannelsQuery> {
  return {
    request: { query: CommunicationChannelsDocument },
    result: { data: data instanceof Error ? undefined : newCommunicationChannelsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserCommunicationPreferencesDataOptions {
  userCommunicationPreferences?: FactoryInput<UserCommunicationPreference, UserCommunicationPreferenceOptions> | null;
}

export function newUserCommunicationPreferencesData(
  data: UserCommunicationPreferencesDataOptions,
): UserCommunicationPreferencesQuery {
  return {
    __typename: "Query" as const,
    userCommunicationPreferences: maybeNewOrNull(
      "UserCommunicationPreference",
      data["userCommunicationPreferences"] || undefined,
      {},
    ),
  } as any;
}

export function newUserCommunicationPreferencesResponse(
  variables: UserCommunicationPreferencesQueryVariables,
  data: UserCommunicationPreferencesDataOptions | Error,
): MockedResponse<UserCommunicationPreferencesQueryVariables, UserCommunicationPreferencesQuery> {
  return {
    request: { query: UserCommunicationPreferencesDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserCommunicationPreferencesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveUserCommunicationPreferenceDataOptions {
  saveUserCommunicationPreference?: FactoryInput<
    SaveUserCommunicationPreferenceResult,
    SaveUserCommunicationPreferenceResultOptions
  >;
}

export function newSaveUserCommunicationPreferenceData(
  data: SaveUserCommunicationPreferenceDataOptions,
): SaveUserCommunicationPreferenceMutation {
  return {
    __typename: "Mutation" as const,
    saveUserCommunicationPreference: maybeNew(
      "SaveUserCommunicationPreferenceResult",
      data["saveUserCommunicationPreference"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveUserCommunicationPreferenceResponse(
  variables: SaveUserCommunicationPreferenceMutationVariables,
  data: SaveUserCommunicationPreferenceDataOptions | Error,
): MockedResponse<SaveUserCommunicationPreferenceMutationVariables, SaveUserCommunicationPreferenceMutation> {
  return {
    request: { query: SaveUserCommunicationPreferenceDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveUserCommunicationPreferenceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LocationPathField_GetLocationsDataOptions {
  locations?: FactoryInput<Location, LocationOptions>[];
}

export function newLocationPathField_GetLocationsData(
  data: LocationPathField_GetLocationsDataOptions,
): LocationPathField_GetLocationsQuery {
  return {
    __typename: "Query" as const,
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newLocationPathField_GetLocationsResponse(
  variables: LocationPathField_GetLocationsQueryVariables,
  data: LocationPathField_GetLocationsDataOptions | Error,
): MockedResponse<LocationPathField_GetLocationsQueryVariables, LocationPathField_GetLocationsQuery> {
  return {
    request: { query: LocationPathField_GetLocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLocationPathField_GetLocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LocationPathField_GetFeatureTypesDataOptions {
  featureTypes?: FactoryInput<FeatureType, FeatureTypeOptions>[];
}

export function newLocationPathField_GetFeatureTypesData(
  data: LocationPathField_GetFeatureTypesDataOptions,
): LocationPathField_GetFeatureTypesQuery {
  return {
    __typename: "Query" as const,
    featureTypes: data["featureTypes"]?.map((d) => maybeNew("FeatureType", d, {})) || [],
  } as any;
}

export function newLocationPathField_GetFeatureTypesResponse(
  variables: LocationPathField_GetFeatureTypesQueryVariables,
  data: LocationPathField_GetFeatureTypesDataOptions | Error,
): MockedResponse<LocationPathField_GetFeatureTypesQueryVariables, LocationPathField_GetFeatureTypesQuery> {
  return {
    request: { query: LocationPathField_GetFeatureTypesDocument, variables },
    result: { data: data instanceof Error ? undefined : newLocationPathField_GetFeatureTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateProjectCoverImageDataOptions {
  saveProject?: FactoryInput<SaveProjectResult, SaveProjectResultOptions>;
}

export function newUpdateProjectCoverImageData(
  data: UpdateProjectCoverImageDataOptions,
): UpdateProjectCoverImageMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newUpdateProjectCoverImageResponse(
  variables: UpdateProjectCoverImageMutationVariables,
  data: UpdateProjectCoverImageDataOptions | Error,
): MockedResponse<UpdateProjectCoverImageMutationVariables, UpdateProjectCoverImageMutation> {
  return {
    request: { query: UpdateProjectCoverImageDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateProjectCoverImageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDoModalDataOptions {
  toDos?: FactoryInput<ToDo, ToDoOptions>[];
}

export function newToDoModalData(data: ToDoModalDataOptions): ToDoModalQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => maybeNew("ToDo", d, {})) || [] } as any;
}

export function newToDoModalResponse(
  variables: ToDoModalQueryVariables,
  data: ToDoModalDataOptions | Error,
): MockedResponse<ToDoModalQueryVariables, ToDoModalQuery> {
  return {
    request: { query: ToDoModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newToDoModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDoModalDataDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newToDoModalDataData(data: ToDoModalDataDataOptions): ToDoModalDataQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newToDoModalDataResponse(
  data: ToDoModalDataDataOptions | Error,
): MockedResponse<ToDoModalDataQueryVariables, ToDoModalDataQuery> {
  return {
    request: { query: ToDoModalDataDocument },
    result: { data: data instanceof Error ? undefined : newToDoModalDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveToDosDataOptions {
  saveToDos?: FactoryInput<SaveToDosResult, SaveToDosResultOptions>;
}

export function newSaveToDosData(data: SaveToDosDataOptions): SaveToDosMutation {
  return {
    __typename: "Mutation" as const,
    saveToDos: maybeNew("SaveToDosResult", data["saveToDos"] || undefined, {}),
  } as any;
}

export function newSaveToDosResponse(
  variables: SaveToDosMutationVariables,
  data: SaveToDosDataOptions | Error,
): MockedResponse<SaveToDosMutationVariables, SaveToDosMutation> {
  return {
    request: { query: SaveToDosDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveToDosData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteToDoDataOptions {
  deleteToDo?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteToDoData(data: DeleteToDoDataOptions): DeleteToDoMutation {
  return {
    __typename: "Mutation" as const,
    deleteToDo: maybeNew("EmptyResult", data["deleteToDo"] || undefined, {}),
  } as any;
}

export function newDeleteToDoResponse(
  variables: DeleteToDoMutationVariables,
  data: DeleteToDoDataOptions | Error,
): MockedResponse<DeleteToDoMutationVariables, DeleteToDoMutation> {
  return {
    request: { query: DeleteToDoDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteToDoData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDosDataOptions {
  toDos?: FactoryInput<ToDo, ToDoOptions>[];
}

export function newToDosData(data: ToDosDataOptions): ToDosQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => maybeNew("ToDo", d, {})) || [] } as any;
}

export function newToDosResponse(
  variables: ToDosQueryVariables,
  data: ToDosDataOptions | Error,
): MockedResponse<ToDosQueryVariables, ToDosQuery> {
  return {
    request: { query: ToDosDocument, variables },
    result: { data: data instanceof Error ? undefined : newToDosData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDoStatusesDataOptions {
  toDoStatuses?: FactoryInput<ToDoStatusDetail, ToDoStatusDetailOptions>[];
}

export function newToDoStatusesData(data: ToDoStatusesDataOptions): ToDoStatusesQuery {
  return {
    __typename: "Query" as const,
    toDoStatuses: data["toDoStatuses"]?.map((d) => maybeNew("ToDoStatusDetail", d, {})) || [],
  } as any;
}

export function newToDoStatusesResponse(
  data: ToDoStatusesDataOptions | Error,
): MockedResponse<ToDoStatusesQueryVariables, ToDoStatusesQuery> {
  return {
    request: { query: ToDoStatusesDocument },
    result: { data: data instanceof Error ? undefined : newToDoStatusesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDoTypesDataOptions {
  toDoTypes?: FactoryInput<ToDoTypeDetail, ToDoTypeDetailOptions>[];
}

export function newToDoTypesData(data: ToDoTypesDataOptions): ToDoTypesQuery {
  return {
    __typename: "Query" as const,
    toDoTypes: data["toDoTypes"]?.map((d) => maybeNew("ToDoTypeDetail", d, {})) || [],
  } as any;
}

export function newToDoTypesResponse(
  data: ToDoTypesDataOptions | Error,
): MockedResponse<ToDoTypesQueryVariables, ToDoTypesQuery> {
  return {
    request: { query: ToDoTypesDocument },
    result: { data: data instanceof Error ? undefined : newToDoTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateAssetUploadUrlDataOptions {
  createAssetUploadUrl?: FactoryInput<CreateAssetUploadUrlResult, CreateAssetUploadUrlResultOptions>;
}

export function newCreateAssetUploadUrlData(data: CreateAssetUploadUrlDataOptions): CreateAssetUploadUrlMutation {
  return {
    __typename: "Mutation" as const,
    createAssetUploadUrl: maybeNew("CreateAssetUploadUrlResult", data["createAssetUploadUrl"] || undefined, {}),
  } as any;
}

export function newCreateAssetUploadUrlResponse(
  variables: CreateAssetUploadUrlMutationVariables,
  data: CreateAssetUploadUrlDataOptions | Error,
): MockedResponse<CreateAssetUploadUrlMutationVariables, CreateAssetUploadUrlMutation> {
  return {
    request: { query: CreateAssetUploadUrlDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateAssetUploadUrlData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialTypesDataOptions {
  materialTypes?: FactoryInput<MaterialTypeDetail, MaterialTypeDetailOptions>[];
}

export function newMaterialTypesData(data: MaterialTypesDataOptions): MaterialTypesQuery {
  return {
    __typename: "Query" as const,
    materialTypes: data["materialTypes"]?.map((d) => maybeNew("MaterialTypeDetail", d, {})) || [],
  } as any;
}

export function newMaterialTypesResponse(
  data: MaterialTypesDataOptions | Error,
): MockedResponse<MaterialTypesQueryVariables, MaterialTypesQuery> {
  return {
    request: { query: MaterialTypesDocument },
    result: { data: data instanceof Error ? undefined : newMaterialTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateDocumentPendingUploadDataOptions {
  createDocumentPendingUpload?: FactoryInput<
    CreateDocumentPendingUploadResult,
    CreateDocumentPendingUploadResultOptions
  >;
}

export function newCreateDocumentPendingUploadData(
  data: CreateDocumentPendingUploadDataOptions,
): CreateDocumentPendingUploadMutation {
  return {
    __typename: "Mutation" as const,
    createDocumentPendingUpload: maybeNew(
      "CreateDocumentPendingUploadResult",
      data["createDocumentPendingUpload"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateDocumentPendingUploadResponse(
  variables: CreateDocumentPendingUploadMutationVariables,
  data: CreateDocumentPendingUploadDataOptions | Error,
): MockedResponse<CreateDocumentPendingUploadMutationVariables, CreateDocumentPendingUploadMutation> {
  return {
    request: { query: CreateDocumentPendingUploadDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateDocumentPendingUploadData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MarkDocumentAsUploadedDataOptions {
  markDocumentAsUploaded?: FactoryInput<MarkDocumentAsUploadedResult, MarkDocumentAsUploadedResultOptions>;
}

export function newMarkDocumentAsUploadedData(data: MarkDocumentAsUploadedDataOptions): MarkDocumentAsUploadedMutation {
  return {
    __typename: "Mutation" as const,
    markDocumentAsUploaded: maybeNew("MarkDocumentAsUploadedResult", data["markDocumentAsUploaded"] || undefined, {}),
  } as any;
}

export function newMarkDocumentAsUploadedResponse(
  variables: MarkDocumentAsUploadedMutationVariables,
  data: MarkDocumentAsUploadedDataOptions | Error,
): MockedResponse<MarkDocumentAsUploadedMutationVariables, MarkDocumentAsUploadedMutation> {
  return {
    request: { query: MarkDocumentAsUploadedDocument, variables },
    result: { data: data instanceof Error ? undefined : newMarkDocumentAsUploadedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateAssetDataOptions {
  createAsset?: FactoryInput<CreateAssetResult, CreateAssetResultOptions>;
}

export function newCreateAssetData(data: CreateAssetDataOptions): CreateAssetMutation {
  return {
    __typename: "Mutation" as const,
    createAsset: maybeNew("CreateAssetResult", data["createAsset"] || undefined, {}),
  } as any;
}

export function newCreateAssetResponse(
  variables: CreateAssetMutationVariables,
  data: CreateAssetDataOptions | Error,
): MockedResponse<CreateAssetMutationVariables, CreateAssetMutation> {
  return {
    request: { query: CreateAssetDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateAssetData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinancesPageSharedDataOptions {
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
  projects?: FactoryInput<Project, ProjectOptions>[];
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
  customerOwnerEntities?: FactoryInput<CustomerOwnerEntity, CustomerOwnerEntityOptions>[];
}

export function newFinancesPageSharedData(data: FinancesPageSharedDataOptions): FinancesPageSharedQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    customerOwnerEntities: data["customerOwnerEntities"]?.map((d) => maybeNew("CustomerOwnerEntity", d, {})) || [],
  } as any;
}

export function newFinancesPageSharedResponse(
  data: FinancesPageSharedDataOptions | Error,
): MockedResponse<FinancesPageSharedQueryVariables, FinancesPageSharedQuery> {
  return {
    request: { query: FinancesPageSharedDocument },
    result: { data: data instanceof Error ? undefined : newFinancesPageSharedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageDetailPageDataOptions {
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newBidPackageDetailPageData(data: BidPackageDetailPageDataOptions): BidPackageDetailPageQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newBidPackageDetailPageResponse(
  variables: BidPackageDetailPageQueryVariables,
  data: BidPackageDetailPageDataOptions | Error,
): MockedResponse<BidPackageDetailPageQueryVariables, BidPackageDetailPageQuery> {
  return {
    request: { query: BidPackageDetailPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackageDetailPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageVersionDetailPageDataOptions {
  bidPackageVersion?: FactoryInput<BidPackageVersion, BidPackageVersionOptions>;
}

export function newBidPackageVersionDetailPageData(
  data: BidPackageVersionDetailPageDataOptions,
): BidPackageVersionDetailPageQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
  } as any;
}

export function newBidPackageVersionDetailPageResponse(
  variables: BidPackageVersionDetailPageQueryVariables,
  data: BidPackageVersionDetailPageDataOptions | Error,
): MockedResponse<BidPackageVersionDetailPageQueryVariables, BidPackageVersionDetailPageQuery> {
  return {
    request: { query: BidPackageVersionDetailPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackageVersionDetailPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidPackageRequestDataOptions {
  saveBidPackageRequest?: FactoryInput<SaveBidPackageRequestResult, SaveBidPackageRequestResultOptions>;
}

export function newSaveBidPackageRequestData(data: SaveBidPackageRequestDataOptions): SaveBidPackageRequestMutation {
  return {
    __typename: "Mutation" as const,
    saveBidPackageRequest: maybeNew("SaveBidPackageRequestResult", data["saveBidPackageRequest"] || undefined, {}),
  } as any;
}

export function newSaveBidPackageRequestResponse(
  variables: SaveBidPackageRequestMutationVariables,
  data: SaveBidPackageRequestDataOptions | Error,
): MockedResponse<SaveBidPackageRequestMutationVariables, SaveBidPackageRequestMutation> {
  return {
    request: { query: SaveBidPackageRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidPackageRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackagesPageMetadataDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newBidPackagesPageMetadataData(data: BidPackagesPageMetadataDataOptions): BidPackagesPageMetadataQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newBidPackagesPageMetadataResponse(
  data: BidPackagesPageMetadataDataOptions | Error,
): MockedResponse<BidPackagesPageMetadataQueryVariables, BidPackagesPageMetadataQuery> {
  return {
    request: { query: BidPackagesPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newBidPackagesPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageGroupsDataOptions {
  bidPackageGroups?: FactoryInput<BidPackageGroupsPageResult, BidPackageGroupsPageResultOptions>;
}

export function newBidPackageGroupsData(data: BidPackageGroupsDataOptions): BidPackageGroupsQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroups: maybeNew("BidPackageGroupsPageResult", data["bidPackageGroups"] || undefined, {}),
  } as any;
}

export function newBidPackageGroupsResponse(
  variables: BidPackageGroupsQueryVariables,
  data: BidPackageGroupsDataOptions | Error,
): MockedResponse<BidPackageGroupsQueryVariables, BidPackageGroupsQuery> {
  return {
    request: { query: BidPackageGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackageGroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteBidPackageDataOptions {
  deleteBidPackage?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteBidPackageData(data: DeleteBidPackageDataOptions): DeleteBidPackageMutation {
  return {
    __typename: "Mutation" as const,
    deleteBidPackage: maybeNew("EmptyResult", data["deleteBidPackage"] || undefined, {}),
  } as any;
}

export function newDeleteBidPackageResponse(
  variables: DeleteBidPackageMutationVariables,
  data: DeleteBidPackageDataOptions | Error,
): MockedResponse<DeleteBidPackageMutationVariables, DeleteBidPackageMutation> {
  return {
    request: { query: DeleteBidPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteBidPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_SaveBillDataOptions {
  saveBill?: FactoryInput<SaveBillResult, SaveBillResultOptions>;
}

export function newBillEditor_SaveBillData(data: BillEditor_SaveBillDataOptions): BillEditor_SaveBillMutation {
  return {
    __typename: "Mutation" as const,
    saveBill: maybeNew("SaveBillResult", data["saveBill"] || undefined, {}),
  } as any;
}

export function newBillEditor_SaveBillResponse(
  variables: BillEditor_SaveBillMutationVariables,
  data: BillEditor_SaveBillDataOptions | Error,
): MockedResponse<BillEditor_SaveBillMutationVariables, BillEditor_SaveBillMutation> {
  return {
    request: { query: BillEditor_SaveBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_SaveBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_RunBillParserDataOptions {
  runBillParser?: FactoryInput<RunBillParserResult, RunBillParserResultOptions>;
}

export function newBillEditor_RunBillParserData(
  data: BillEditor_RunBillParserDataOptions,
): BillEditor_RunBillParserMutation {
  return {
    __typename: "Mutation" as const,
    runBillParser: maybeNew("RunBillParserResult", data["runBillParser"] || undefined, {}),
  } as any;
}

export function newBillEditor_RunBillParserResponse(
  variables: BillEditor_RunBillParserMutationVariables,
  data: BillEditor_RunBillParserDataOptions | Error,
): MockedResponse<BillEditor_RunBillParserMutationVariables, BillEditor_RunBillParserMutation> {
  return {
    request: { query: BillEditor_RunBillParserDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_RunBillParserData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_BillOcrDataOptions {
  billOcr?: FactoryInput<BillOcr, BillOcrOptions> | null;
}

export function newBillEditor_BillOcrData(data: BillEditor_BillOcrDataOptions): BillEditor_BillOcrQuery {
  return { __typename: "Query" as const, billOcr: maybeNewOrNull("BillOcr", data["billOcr"] || undefined, {}) } as any;
}

export function newBillEditor_BillOcrResponse(
  variables: BillEditor_BillOcrQueryVariables,
  data: BillEditor_BillOcrDataOptions | Error,
): MockedResponse<BillEditor_BillOcrQueryVariables, BillEditor_BillOcrQuery> {
  return {
    request: { query: BillEditor_BillOcrDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_BillOcrData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_SaveChangeEventDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newBillEditor_SaveChangeEventData(
  data: BillEditor_SaveChangeEventDataOptions,
): BillEditor_SaveChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newBillEditor_SaveChangeEventResponse(
  variables: BillEditor_SaveChangeEventMutationVariables,
  data: BillEditor_SaveChangeEventDataOptions | Error,
): MockedResponse<BillEditor_SaveChangeEventMutationVariables, BillEditor_SaveChangeEventMutation> {
  return {
    request: { query: BillEditor_SaveChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_SaveChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_CreateCommitmentDataOptions {
  createCommitmentFromBill?: FactoryInput<CreateCommitmentFromBillResult, CreateCommitmentFromBillResultOptions>;
}

export function newBillEditor_CreateCommitmentData(
  data: BillEditor_CreateCommitmentDataOptions,
): BillEditor_CreateCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    createCommitmentFromBill: maybeNew(
      "CreateCommitmentFromBillResult",
      data["createCommitmentFromBill"] || undefined,
      {},
    ),
  } as any;
}

export function newBillEditor_CreateCommitmentResponse(
  variables: BillEditor_CreateCommitmentMutationVariables,
  data: BillEditor_CreateCommitmentDataOptions | Error,
): MockedResponse<BillEditor_CreateCommitmentMutationVariables, BillEditor_CreateCommitmentMutation> {
  return {
    request: { query: BillEditor_CreateCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_CreateCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_CommitmentsDataOptions {
  commitments?: FactoryInput<Commitment, CommitmentOptions>[];
}

export function newBillEditor_CommitmentsData(data: BillEditor_CommitmentsDataOptions): BillEditor_CommitmentsQuery {
  return {
    __typename: "Query" as const,
    commitments: data["commitments"]?.map((d) => maybeNew("Commitment", d, {})) || [],
  } as any;
}

export function newBillEditor_CommitmentsResponse(
  variables: BillEditor_CommitmentsQueryVariables,
  data: BillEditor_CommitmentsDataOptions | Error,
): MockedResponse<BillEditor_CommitmentsQueryVariables, BillEditor_CommitmentsQuery> {
  return {
    request: { query: BillEditor_CommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_CommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_ProjectItemsDataOptions {
  projectItems?: FactoryInput<ProjectItem, ProjectItemOptions>[];
}

export function newBillEditor_ProjectItemsData(data: BillEditor_ProjectItemsDataOptions): BillEditor_ProjectItemsQuery {
  return {
    __typename: "Query" as const,
    projectItems: data["projectItems"]?.map((d) => maybeNew("ProjectItem", d, {})) || [],
  } as any;
}

export function newBillEditor_ProjectItemsResponse(
  variables: BillEditor_ProjectItemsQueryVariables,
  data: BillEditor_ProjectItemsDataOptions | Error,
): MockedResponse<BillEditor_ProjectItemsQueryVariables, BillEditor_ProjectItemsQuery> {
  return {
    request: { query: BillEditor_ProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_ProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_CommitmentLikesDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
  commitmentChangeOrder?: FactoryInput<CommitmentChangeOrder, CommitmentChangeOrderOptions>;
}

export function newBillEditor_CommitmentLikesData(
  data: BillEditor_CommitmentLikesDataOptions,
): BillEditor_CommitmentLikesQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newBillEditor_CommitmentLikesResponse(
  variables: BillEditor_CommitmentLikesQueryVariables,
  data: BillEditor_CommitmentLikesDataOptions | Error,
): MockedResponse<BillEditor_CommitmentLikesQueryVariables, BillEditor_CommitmentLikesQuery> {
  return {
    request: { query: BillEditor_CommitmentLikesDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_CommitmentLikesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_BillDataOptions {
  bill?: FactoryInput<Bill, BillOptions>;
}

export function newBillEditor_BillData(data: BillEditor_BillDataOptions): BillEditor_BillQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillEditor_BillResponse(
  variables: BillEditor_BillQueryVariables,
  data: BillEditor_BillDataOptions | Error,
): MockedResponse<BillEditor_BillQueryVariables, BillEditor_BillQuery> {
  return {
    request: { query: BillEditor_BillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_BillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_ReviewReasonsDetailsDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newBillEditor_ReviewReasonsDetailsData(
  data: BillEditor_ReviewReasonsDetailsDataOptions,
): BillEditor_ReviewReasonsDetailsQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newBillEditor_ReviewReasonsDetailsResponse(
  data: BillEditor_ReviewReasonsDetailsDataOptions | Error,
): MockedResponse<BillEditor_ReviewReasonsDetailsQueryVariables, BillEditor_ReviewReasonsDetailsQuery> {
  return {
    request: { query: BillEditor_ReviewReasonsDetailsDocument },
    result: { data: data instanceof Error ? undefined : newBillEditor_ReviewReasonsDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_CalculateDueDateDataOptions {
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
}

export function newBillEditor_CalculateDueDateData(
  data: BillEditor_CalculateDueDateDataOptions,
): BillEditor_CalculateDueDateQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
  } as any;
}

export function newBillEditor_CalculateDueDateResponse(
  variables: BillEditor_CalculateDueDateQueryVariables,
  data: BillEditor_CalculateDueDateDataOptions | Error,
): MockedResponse<BillEditor_CalculateDueDateQueryVariables, BillEditor_CalculateDueDateQuery> {
  return {
    request: { query: BillEditor_CalculateDueDateDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_CalculateDueDateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_ProjectItemDataOptions {
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
}

export function newBillEditor_ProjectItemData(data: BillEditor_ProjectItemDataOptions): BillEditor_ProjectItemQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newBillEditor_ProjectItemResponse(
  variables: BillEditor_ProjectItemQueryVariables,
  data: BillEditor_ProjectItemDataOptions | Error,
): MockedResponse<BillEditor_ProjectItemQueryVariables, BillEditor_ProjectItemQuery> {
  return {
    request: { query: BillEditor_ProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_ProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EnterUnitBasedBidPageDataOptions {
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newEnterUnitBasedBidPageData(data: EnterUnitBasedBidPageDataOptions): EnterUnitBasedBidPageQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newEnterUnitBasedBidPageResponse(
  variables: EnterUnitBasedBidPageQueryVariables,
  data: EnterUnitBasedBidPageDataOptions | Error,
): MockedResponse<EnterUnitBasedBidPageQueryVariables, EnterUnitBasedBidPageQuery> {
  return {
    request: { query: EnterUnitBasedBidPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEnterUnitBasedBidPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EnterUnitBasedBidPage_SaveBidContractRevisionDataOptions {
  saveBidContractRevision?: FactoryInput<SaveBidContractRevisionResult, SaveBidContractRevisionResultOptions>;
}

export function newEnterUnitBasedBidPage_SaveBidContractRevisionData(
  data: EnterUnitBasedBidPage_SaveBidContractRevisionDataOptions,
): EnterUnitBasedBidPage_SaveBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractRevision: maybeNew(
      "SaveBidContractRevisionResult",
      data["saveBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newEnterUnitBasedBidPage_SaveBidContractRevisionResponse(
  variables: EnterUnitBasedBidPage_SaveBidContractRevisionMutationVariables,
  data: EnterUnitBasedBidPage_SaveBidContractRevisionDataOptions | Error,
): MockedResponse<
  EnterUnitBasedBidPage_SaveBidContractRevisionMutationVariables,
  EnterUnitBasedBidPage_SaveBidContractRevisionMutation
> {
  return {
    request: { query: EnterUnitBasedBidPage_SaveBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newEnterUnitBasedBidPage_SaveBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDataOptions {
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  bill?: FactoryInput<Bill, BillOptions>;
}

export function newBillData(data: BillDataOptions): BillQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    bill: maybeNew("Bill", data["bill"] || undefined, {}),
  } as any;
}

export function newBillResponse(
  variables: BillQueryVariables,
  data: BillDataOptions | Error,
): MockedResponse<BillQueryVariables, BillQuery> {
  return {
    request: { query: BillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPageDataOptions {
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  bill?: FactoryInput<Bill, BillOptions>;
}

export function newBillPageData(data: BillPageDataOptions): BillPageQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    bill: maybeNew("Bill", data["bill"] || undefined, {}),
  } as any;
}

export function newBillPageResponse(
  variables: BillPageQueryVariables,
  data: BillPageDataOptions | Error,
): MockedResponse<BillPageQueryVariables, BillPageQuery> {
  return {
    request: { query: BillPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_BillIntacctSyncErrorDataOptions {
  bill?: FactoryInput<Bill, BillOptions>;
}

export function newBillPage_BillIntacctSyncErrorData(
  data: BillPage_BillIntacctSyncErrorDataOptions,
): BillPage_BillIntacctSyncErrorQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillPage_BillIntacctSyncErrorResponse(
  variables: BillPage_BillIntacctSyncErrorQueryVariables,
  data: BillPage_BillIntacctSyncErrorDataOptions | Error,
): MockedResponse<BillPage_BillIntacctSyncErrorQueryVariables, BillPage_BillIntacctSyncErrorQuery> {
  return {
    request: { query: BillPage_BillIntacctSyncErrorDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_BillIntacctSyncErrorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_NewBillCommitmentDataDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
}

export function newBillPage_NewBillCommitmentDataData(
  data: BillPage_NewBillCommitmentDataDataOptions,
): BillPage_NewBillCommitmentDataQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newBillPage_NewBillCommitmentDataResponse(
  variables: BillPage_NewBillCommitmentDataQueryVariables,
  data: BillPage_NewBillCommitmentDataDataOptions | Error,
): MockedResponse<BillPage_NewBillCommitmentDataQueryVariables, BillPage_NewBillCommitmentDataQuery> {
  return {
    request: { query: BillPage_NewBillCommitmentDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_NewBillCommitmentDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_NewBillChangeOrderDataDataOptions {
  commitmentChangeOrder?: FactoryInput<CommitmentChangeOrder, CommitmentChangeOrderOptions>;
}

export function newBillPage_NewBillChangeOrderDataData(
  data: BillPage_NewBillChangeOrderDataDataOptions,
): BillPage_NewBillChangeOrderDataQuery {
  return {
    __typename: "Query" as const,
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newBillPage_NewBillChangeOrderDataResponse(
  variables: BillPage_NewBillChangeOrderDataQueryVariables,
  data: BillPage_NewBillChangeOrderDataDataOptions | Error,
): MockedResponse<BillPage_NewBillChangeOrderDataQueryVariables, BillPage_NewBillChangeOrderDataQuery> {
  return {
    request: { query: BillPage_NewBillChangeOrderDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_NewBillChangeOrderDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_CommitmentIdByChangeOrderDataOptions {
  commitmentChangeOrder?: FactoryInput<CommitmentChangeOrder, CommitmentChangeOrderOptions>;
}

export function newBillPage_CommitmentIdByChangeOrderData(
  data: BillPage_CommitmentIdByChangeOrderDataOptions,
): BillPage_CommitmentIdByChangeOrderQuery {
  return {
    __typename: "Query" as const,
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newBillPage_CommitmentIdByChangeOrderResponse(
  variables: BillPage_CommitmentIdByChangeOrderQueryVariables,
  data: BillPage_CommitmentIdByChangeOrderDataOptions | Error,
): MockedResponse<BillPage_CommitmentIdByChangeOrderQueryVariables, BillPage_CommitmentIdByChangeOrderQuery> {
  return {
    request: { query: BillPage_CommitmentIdByChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_CommitmentIdByChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillIntacctSyncErrorDataOptions {
  bill?: FactoryInput<Bill, BillOptions>;
}

export function newBillIntacctSyncErrorData(data: BillIntacctSyncErrorDataOptions): BillIntacctSyncErrorQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillIntacctSyncErrorResponse(
  variables: BillIntacctSyncErrorQueryVariables,
  data: BillIntacctSyncErrorDataOptions | Error,
): MockedResponse<BillIntacctSyncErrorQueryVariables, BillIntacctSyncErrorQuery> {
  return {
    request: { query: BillIntacctSyncErrorDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillIntacctSyncErrorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_SaveBillDataOptions {
  saveBill?: FactoryInput<SaveBillResult, SaveBillResultOptions>;
}

export function newBillPage_SaveBillData(data: BillPage_SaveBillDataOptions): BillPage_SaveBillMutation {
  return {
    __typename: "Mutation" as const,
    saveBill: maybeNew("SaveBillResult", data["saveBill"] || undefined, {}),
  } as any;
}

export function newBillPage_SaveBillResponse(
  variables: BillPage_SaveBillMutationVariables,
  data: BillPage_SaveBillDataOptions | Error,
): MockedResponse<BillPage_SaveBillMutationVariables, BillPage_SaveBillMutation> {
  return {
    request: { query: BillPage_SaveBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_SaveBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_DeleteBillDataOptions {
  deleteBill?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newBillPage_DeleteBillData(data: BillPage_DeleteBillDataOptions): BillPage_DeleteBillMutation {
  return {
    __typename: "Mutation" as const,
    deleteBill: maybeNew("EmptyResult", data["deleteBill"] || undefined, {}),
  } as any;
}

export function newBillPage_DeleteBillResponse(
  variables: BillPage_DeleteBillMutationVariables,
  data: BillPage_DeleteBillDataOptions | Error,
): MockedResponse<BillPage_DeleteBillMutationVariables, BillPage_DeleteBillMutation> {
  return {
    request: { query: BillPage_DeleteBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_DeleteBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_SyncBillToIntacctDataOptions {
  syncBillToIntacct?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newBillPage_SyncBillToIntacctData(
  data: BillPage_SyncBillToIntacctDataOptions,
): BillPage_SyncBillToIntacctMutation {
  return {
    __typename: "Mutation" as const,
    syncBillToIntacct: maybeNew("EmptyResult", data["syncBillToIntacct"] || undefined, {}),
  } as any;
}

export function newBillPage_SyncBillToIntacctResponse(
  variables: BillPage_SyncBillToIntacctMutationVariables,
  data: BillPage_SyncBillToIntacctDataOptions | Error,
): MockedResponse<BillPage_SyncBillToIntacctMutationVariables, BillPage_SyncBillToIntacctMutation> {
  return {
    request: { query: BillPage_SyncBillToIntacctDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_SyncBillToIntacctData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_SaveApproverDataOptions {
  saveApprover?: FactoryInput<SaveApproverResult, SaveApproverResultOptions>;
}

export function newBillPage_SaveApproverData(data: BillPage_SaveApproverDataOptions): BillPage_SaveApproverMutation {
  return {
    __typename: "Mutation" as const,
    saveApprover: maybeNew("SaveApproverResult", data["saveApprover"] || undefined, {}),
  } as any;
}

export function newBillPage_SaveApproverResponse(
  variables: BillPage_SaveApproverMutationVariables,
  data: BillPage_SaveApproverDataOptions | Error,
): MockedResponse<BillPage_SaveApproverMutationVariables, BillPage_SaveApproverMutation> {
  return {
    request: { query: BillPage_SaveApproverDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_SaveApproverData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBillDataOptions {
  saveBill?: FactoryInput<SaveBillResult, SaveBillResultOptions>;
}

export function newSaveBillData(data: SaveBillDataOptions): SaveBillMutation {
  return {
    __typename: "Mutation" as const,
    saveBill: maybeNew("SaveBillResult", data["saveBill"] || undefined, {}),
  } as any;
}

export function newSaveBillResponse(
  variables: SaveBillMutationVariables,
  data: SaveBillDataOptions | Error,
): MockedResponse<SaveBillMutationVariables, SaveBillMutation> {
  return {
    request: { query: SaveBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteBillDataOptions {
  deleteBill?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteBillData(data: DeleteBillDataOptions): DeleteBillMutation {
  return {
    __typename: "Mutation" as const,
    deleteBill: maybeNew("EmptyResult", data["deleteBill"] || undefined, {}),
  } as any;
}

export function newDeleteBillResponse(
  variables: DeleteBillMutationVariables,
  data: DeleteBillDataOptions | Error,
): MockedResponse<DeleteBillMutationVariables, DeleteBillMutation> {
  return {
    request: { query: DeleteBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SyncBillToIntacctDataOptions {
  syncBillToIntacct?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newSyncBillToIntacctData(data: SyncBillToIntacctDataOptions): SyncBillToIntacctMutation {
  return {
    __typename: "Mutation" as const,
    syncBillToIntacct: maybeNew("EmptyResult", data["syncBillToIntacct"] || undefined, {}),
  } as any;
}

export function newSyncBillToIntacctResponse(
  variables: SyncBillToIntacctMutationVariables,
  data: SyncBillToIntacctDataOptions | Error,
): MockedResponse<SyncBillToIntacctMutationVariables, SyncBillToIntacctMutation> {
  return {
    request: { query: SyncBillToIntacctDocument, variables },
    result: { data: data instanceof Error ? undefined : newSyncBillToIntacctData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillsDataOptions {
  billsPage?: FactoryInput<BillsPage, BillsPageOptions>;
  projects?: FactoryInput<Project, ProjectOptions>[];
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newBillsData(data: BillsDataOptions): BillsQuery {
  return {
    __typename: "Query" as const,
    billsPage: maybeNew("BillsPage", data["billsPage"] || undefined, {}),
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newBillsResponse(
  variables: BillsQueryVariables,
  data: BillsDataOptions | Error,
): MockedResponse<BillsQueryVariables, BillsQuery> {
  return {
    request: { query: BillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillsChartsDataOptions {
  billMetrics?: FactoryInput<BillMetricsResult, BillMetricsResultOptions> | null;
}

export function newBillsChartsData(data: BillsChartsDataOptions): BillsChartsQuery {
  return {
    __typename: "Query" as const,
    billMetrics: maybeNewOrNull("BillMetricsResult", data["billMetrics"] || undefined, {}),
  } as any;
}

export function newBillsChartsResponse(
  variables: BillsChartsQueryVariables,
  data: BillsChartsDataOptions | Error,
): MockedResponse<BillsChartsQueryVariables, BillsChartsQuery> {
  return {
    request: { query: BillsChartsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillsChartsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkAddItemCostCodesDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newBulkAddItemCostCodesData(data: BulkAddItemCostCodesDataOptions): BulkAddItemCostCodesQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [] } as any;
}

export function newBulkAddItemCostCodesResponse(
  data: BulkAddItemCostCodesDataOptions | Error,
): MockedResponse<BulkAddItemCostCodesQueryVariables, BulkAddItemCostCodesQuery> {
  return {
    request: { query: BulkAddItemCostCodesDocument },
    result: { data: data instanceof Error ? undefined : newBulkAddItemCostCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkAddProjectItemsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newBulkAddProjectItemsData(data: BulkAddProjectItemsDataOptions): BulkAddProjectItemsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newBulkAddProjectItemsResponse(
  variables: BulkAddProjectItemsQueryVariables,
  data: BulkAddProjectItemsDataOptions | Error,
): MockedResponse<BulkAddProjectItemsQueryVariables, BulkAddProjectItemsQuery> {
  return {
    request: { query: BulkAddProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkAddProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentDataOptions {
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>;
}

export function newDevelopmentCommitmentData(data: DevelopmentCommitmentDataOptions): DevelopmentCommitmentQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentResponse(
  variables: DevelopmentCommitmentQueryVariables,
  data: DevelopmentCommitmentDataOptions | Error,
): MockedResponse<DevelopmentCommitmentQueryVariables, DevelopmentCommitmentQuery> {
  return {
    request: { query: DevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePandaDocDataOptions {
  savePandaDoc?: FactoryInput<SavePandaDocResult, SavePandaDocResultOptions>;
}

export function newSavePandaDocData(data: SavePandaDocDataOptions): SavePandaDocMutation {
  return {
    __typename: "Mutation" as const,
    savePandaDoc: maybeNew("SavePandaDocResult", data["savePandaDoc"] || undefined, {}),
  } as any;
}

export function newSavePandaDocResponse(
  variables: SavePandaDocMutationVariables,
  data: SavePandaDocDataOptions | Error,
): MockedResponse<SavePandaDocMutationVariables, SavePandaDocMutation> {
  return {
    request: { query: SavePandaDocDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePandaDocData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDevelopmentCommitmentDataOptions {
  deleteDevelopmentCommitment?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteDevelopmentCommitmentData(
  data: DeleteDevelopmentCommitmentDataOptions,
): DeleteDevelopmentCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    deleteDevelopmentCommitment: maybeNew("EmptyResult", data["deleteDevelopmentCommitment"] || undefined, {}),
  } as any;
}

export function newDeleteDevelopmentCommitmentResponse(
  variables: DeleteDevelopmentCommitmentMutationVariables,
  data: DeleteDevelopmentCommitmentDataOptions | Error,
): MockedResponse<DeleteDevelopmentCommitmentMutationVariables, DeleteDevelopmentCommitmentMutation> {
  return {
    request: { query: DeleteDevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentsPageMetaDataDataOptions {
  commitmentStatuses?: FactoryInput<CommitmentStatusDetail, CommitmentStatusDetailOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newDevelopmentCommitmentsPageMetaDataData(
  data: DevelopmentCommitmentsPageMetaDataDataOptions,
): DevelopmentCommitmentsPageMetaDataQuery {
  return {
    __typename: "Query" as const,
    commitmentStatuses: data["commitmentStatuses"]?.map((d) => maybeNew("CommitmentStatusDetail", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
  } as any;
}

export function newDevelopmentCommitmentsPageMetaDataResponse(
  data: DevelopmentCommitmentsPageMetaDataDataOptions | Error,
): MockedResponse<DevelopmentCommitmentsPageMetaDataQueryVariables, DevelopmentCommitmentsPageMetaDataQuery> {
  return {
    request: { query: DevelopmentCommitmentsPageMetaDataDocument },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentsPageMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentsPageDataOptions {
  developmentCommitmentsPage?: FactoryInput<DevelopmentCommitmentsPage, DevelopmentCommitmentsPageOptions>;
}

export function newDevelopmentCommitmentsPageData(
  data: DevelopmentCommitmentsPageDataOptions,
): DevelopmentCommitmentsPageQuery {
  return {
    __typename: "Query" as const,
    developmentCommitmentsPage: maybeNew(
      "DevelopmentCommitmentsPage",
      data["developmentCommitmentsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newDevelopmentCommitmentsPageResponse(
  variables: DevelopmentCommitmentsPageQueryVariables,
  data: DevelopmentCommitmentsPageDataOptions | Error,
): MockedResponse<DevelopmentCommitmentsPageQueryVariables, DevelopmentCommitmentsPageQuery> {
  return {
    request: { query: DevelopmentCommitmentsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentAllLotsDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
}

export function newDevelopmentAllLotsData(data: DevelopmentAllLotsDataOptions): DevelopmentAllLotsQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
  } as any;
}

export function newDevelopmentAllLotsResponse(
  variables: DevelopmentAllLotsQueryVariables,
  data: DevelopmentAllLotsDataOptions | Error,
): MockedResponse<DevelopmentAllLotsQueryVariables, DevelopmentAllLotsQuery> {
  return {
    request: { query: DevelopmentAllLotsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentAllLotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentsPageMetadataDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newDevelopmentsPageMetadataData(
  data: DevelopmentsPageMetadataDataOptions,
): DevelopmentsPageMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [] } as any;
}

export function newDevelopmentsPageMetadataResponse(
  data: DevelopmentsPageMetadataDataOptions | Error,
): MockedResponse<DevelopmentsPageMetadataQueryVariables, DevelopmentsPageMetadataQuery> {
  return {
    request: { query: DevelopmentsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newDevelopmentsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentsDataOptions {
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newDevelopmentsData(data: DevelopmentsDataOptions): DevelopmentsQuery {
  return {
    __typename: "Query" as const,
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newDevelopmentsResponse(
  variables: DevelopmentsQueryVariables,
  data: DevelopmentsDataOptions | Error,
): MockedResponse<DevelopmentsQueryVariables, DevelopmentsQuery> {
  return {
    request: { query: DevelopmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentDetailDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
  schedules?: FactoryInput<Schedule, ScheduleOptions>[];
}

export function newDevelopmentDetailData(data: DevelopmentDetailDataOptions): DevelopmentDetailQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
    schedules: data["schedules"]?.map((d) => maybeNew("Schedule", d, {})) || [],
  } as any;
}

export function newDevelopmentDetailResponse(
  variables: DevelopmentDetailQueryVariables,
  data: DevelopmentDetailDataOptions | Error,
): MockedResponse<DevelopmentDetailQueryVariables, DevelopmentDetailQuery> {
  return {
    request: { query: DevelopmentDetailDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDevelopmentsDataOptions {
  saveDevelopments?: FactoryInput<SaveDevelopmentsResult, SaveDevelopmentsResultOptions>;
}

export function newSaveDevelopmentsData(data: SaveDevelopmentsDataOptions): SaveDevelopmentsMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopments: maybeNew("SaveDevelopmentsResult", data["saveDevelopments"] || undefined, {}),
  } as any;
}

export function newSaveDevelopmentsResponse(
  variables: SaveDevelopmentsMutationVariables,
  data: SaveDevelopmentsDataOptions | Error,
): MockedResponse<SaveDevelopmentsMutationVariables, SaveDevelopmentsMutation> {
  return {
    request: { query: SaveDevelopmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ExpenseAdminTeamMemberProjectsDataOptions {
  myTeamMemberProjects?: FactoryInput<Project, ProjectOptions>[];
}

export function newExpenseAdminTeamMemberProjectsData(
  data: ExpenseAdminTeamMemberProjectsDataOptions,
): ExpenseAdminTeamMemberProjectsQuery {
  return {
    __typename: "Query" as const,
    myTeamMemberProjects: data["myTeamMemberProjects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newExpenseAdminTeamMemberProjectsResponse(
  data: ExpenseAdminTeamMemberProjectsDataOptions | Error,
): MockedResponse<ExpenseAdminTeamMemberProjectsQueryVariables, ExpenseAdminTeamMemberProjectsQuery> {
  return {
    request: { query: ExpenseAdminTeamMemberProjectsDocument },
    result: { data: data instanceof Error ? undefined : newExpenseAdminTeamMemberProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InboxPageMetaDataOptions {
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newInboxPageMetaData(data: InboxPageMetaDataOptions): InboxPageMetaQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newInboxPageMetaResponse(
  data: InboxPageMetaDataOptions | Error,
): MockedResponse<InboxPageMetaQueryVariables, InboxPageMetaQuery> {
  return {
    request: { query: InboxPageMetaDocument },
    result: { data: data instanceof Error ? undefined : newInboxPageMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommentStreamDataOptions {
  commentStream?: FactoryInput<CommentStream, CommentStreamOptions> | null;
}

export function newCommentStreamData(data: CommentStreamDataOptions): CommentStreamQuery {
  return {
    __typename: "Query" as const,
    commentStream: maybeNewOrNull("CommentStream", data["commentStream"] || undefined, {}),
  } as any;
}

export function newCommentStreamResponse(
  variables: CommentStreamQueryVariables,
  data: CommentStreamDataOptions | Error,
): MockedResponse<CommentStreamQueryVariables, CommentStreamQuery> {
  return {
    request: { query: CommentStreamDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommentStreamData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserRelevantCommentStreamsDataOptions {
  userRelevantCommentStreamsPaged?: FactoryInput<
    UserRelevantCommentStreamsResult,
    UserRelevantCommentStreamsResultOptions
  >;
}

export function newUserRelevantCommentStreamsData(
  data: UserRelevantCommentStreamsDataOptions,
): UserRelevantCommentStreamsQuery {
  return {
    __typename: "Query" as const,
    userRelevantCommentStreamsPaged: maybeNew(
      "UserRelevantCommentStreamsResult",
      data["userRelevantCommentStreamsPaged"] || undefined,
      {},
    ),
  } as any;
}

export function newUserRelevantCommentStreamsResponse(
  variables: UserRelevantCommentStreamsQueryVariables,
  data: UserRelevantCommentStreamsDataOptions | Error,
): MockedResponse<UserRelevantCommentStreamsQueryVariables, UserRelevantCommentStreamsQuery> {
  return {
    request: { query: UserRelevantCommentStreamsDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserRelevantCommentStreamsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoicesPageDataOptions {
  invoicesPage?: FactoryInput<InvoicesPage, InvoicesPageOptions>;
}

export function newInvoicesPageData(data: InvoicesPageDataOptions): InvoicesPageQuery {
  return {
    __typename: "Query" as const,
    invoicesPage: maybeNew("InvoicesPage", data["invoicesPage"] || undefined, {}),
  } as any;
}

export function newInvoicesPageResponse(
  variables: InvoicesPageQueryVariables,
  data: InvoicesPageDataOptions | Error,
): MockedResponse<InvoicesPageQueryVariables, InvoicesPageQuery> {
  return {
    request: { query: InvoicesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoicesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TemplatesDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newTemplatesData(data: TemplatesDataOptions): TemplatesQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newTemplatesResponse(
  data: TemplatesDataOptions | Error,
): MockedResponse<TemplatesQueryVariables, TemplatesQuery> {
  return {
    request: { query: TemplatesDocument },
    result: { data: data instanceof Error ? undefined : newTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LienWaiversPageDataOptions {
  lienWaiversPage?: FactoryInput<LienWaiversPage, LienWaiversPageOptions>;
}

export function newLienWaiversPageData(data: LienWaiversPageDataOptions): LienWaiversPageQuery {
  return {
    __typename: "Query" as const,
    lienWaiversPage: maybeNew("LienWaiversPage", data["lienWaiversPage"] || undefined, {}),
  } as any;
}

export function newLienWaiversPageResponse(
  variables: LienWaiversPageQueryVariables,
  data: LienWaiversPageDataOptions | Error,
): MockedResponse<LienWaiversPageQueryVariables, LienWaiversPageQuery> {
  return {
    request: { query: LienWaiversPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newLienWaiversPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLienWaiverDataOptions {
  saveLienWaiver?: FactoryInput<SaveLienWaiverResult, SaveLienWaiverResultOptions>;
}

export function newSaveLienWaiverData(data: SaveLienWaiverDataOptions): SaveLienWaiverMutation {
  return {
    __typename: "Mutation" as const,
    saveLienWaiver: maybeNew("SaveLienWaiverResult", data["saveLienWaiver"] || undefined, {}),
  } as any;
}

export function newSaveLienWaiverResponse(
  variables: SaveLienWaiverMutationVariables,
  data: SaveLienWaiverDataOptions | Error,
): MockedResponse<SaveLienWaiverMutationVariables, SaveLienWaiverMutation> {
  return {
    request: { query: SaveLienWaiverDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLienWaiverData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EstimateExportPageDataOptions {
  projectEstimate?: FactoryInput<Estimate, EstimateOptions>;
}

export function newEstimateExportPageData(data: EstimateExportPageDataOptions): EstimateExportPageQuery {
  return {
    __typename: "Query" as const,
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
  } as any;
}

export function newEstimateExportPageResponse(
  variables: EstimateExportPageQueryVariables,
  data: EstimateExportPageDataOptions | Error,
): MockedResponse<EstimateExportPageQueryVariables, EstimateExportPageQuery> {
  return {
    request: { query: EstimateExportPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEstimateExportPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerChangeOrderDataOptions {
  projectEstimate?: FactoryInput<Estimate, EstimateOptions>;
}

export function newHomeownerChangeOrderData(data: HomeownerChangeOrderDataOptions): HomeownerChangeOrderQuery {
  return {
    __typename: "Query" as const,
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
  } as any;
}

export function newHomeownerChangeOrderResponse(
  variables: HomeownerChangeOrderQueryVariables,
  data: HomeownerChangeOrderDataOptions | Error,
): MockedResponse<HomeownerChangeOrderQueryVariables, HomeownerChangeOrderQuery> {
  return {
    request: { query: HomeownerChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PdfProjectItemsDataOptions {
  projectItems?: FactoryInput<ProjectItem, ProjectItemOptions>[];
}

export function newPdfProjectItemsData(data: PdfProjectItemsDataOptions): PdfProjectItemsQuery {
  return {
    __typename: "Query" as const,
    projectItems: data["projectItems"]?.map((d) => maybeNew("ProjectItem", d, {})) || [],
  } as any;
}

export function newPdfProjectItemsResponse(
  variables: PdfProjectItemsQueryVariables,
  data: PdfProjectItemsDataOptions | Error,
): MockedResponse<PdfProjectItemsQueryVariables, PdfProjectItemsQuery> {
  return {
    request: { query: PdfProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPdfProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeScopeOfWorkDataOptions {
  changeEventLineItems?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>[];
}

export function newTradeScopeOfWorkData(data: TradeScopeOfWorkDataOptions): TradeScopeOfWorkQuery {
  return {
    __typename: "Query" as const,
    changeEventLineItems: data["changeEventLineItems"]?.map((d) => maybeNew("ChangeEventLineItem", d, {})) || [],
  } as any;
}

export function newTradeScopeOfWorkResponse(
  variables: TradeScopeOfWorkQueryVariables,
  data: TradeScopeOfWorkDataOptions | Error,
): MockedResponse<TradeScopeOfWorkQueryVariables, TradeScopeOfWorkQuery> {
  return {
    request: { query: TradeScopeOfWorkDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradeScopeOfWorkData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CurrentUserDataOptions {
  currentUser?: FactoryInput<User, UserOptions> | null;
}

export function newCurrentUserData(data: CurrentUserDataOptions): CurrentUserQuery {
  return {
    __typename: "Query" as const,
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newCurrentUserResponse(
  data: CurrentUserDataOptions | Error,
): MockedResponse<CurrentUserQueryVariables, CurrentUserQuery> {
  return {
    request: { query: CurrentUserDocument },
    result: { data: data instanceof Error ? undefined : newCurrentUserData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PersonalDashboardsPageDataOptions {
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
  userEventParentTypes?: FactoryInput<UserEventParentType, UserEventParentTypeOptions>[];
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newPersonalDashboardsPageData(data: PersonalDashboardsPageDataOptions): PersonalDashboardsPageQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    userEventParentTypes: data["userEventParentTypes"]?.map((d) => maybeNew("UserEventParentType", d, {})) || [],
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newPersonalDashboardsPageResponse(
  data: PersonalDashboardsPageDataOptions | Error,
): MockedResponse<PersonalDashboardsPageQueryVariables, PersonalDashboardsPageQuery> {
  return {
    request: { query: PersonalDashboardsPageDocument },
    result: { data: data instanceof Error ? undefined : newPersonalDashboardsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AssignedToDosDataOptions {
  toDos?: FactoryInput<ToDo, ToDoOptions>[];
}

export function newAssignedToDosData(data: AssignedToDosDataOptions): AssignedToDosQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => maybeNew("ToDo", d, {})) || [] } as any;
}

export function newAssignedToDosResponse(
  variables: AssignedToDosQueryVariables,
  data: AssignedToDosDataOptions | Error,
): MockedResponse<AssignedToDosQueryVariables, AssignedToDosQuery> {
  return {
    request: { query: AssignedToDosDocument, variables },
    result: { data: data instanceof Error ? undefined : newAssignedToDosData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TeamMembersProjectsDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newTeamMembersProjectsData(data: TeamMembersProjectsDataOptions): TeamMembersProjectsQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newTeamMembersProjectsResponse(
  variables: TeamMembersProjectsQueryVariables,
  data: TeamMembersProjectsDataOptions | Error,
): MockedResponse<TeamMembersProjectsQueryVariables, TeamMembersProjectsQuery> {
  return {
    request: { query: TeamMembersProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTeamMembersProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectHeaderDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectHeaderData(data: ProjectHeaderDataOptions): ProjectHeaderQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectHeaderResponse(
  variables: ProjectHeaderQueryVariables,
  data: ProjectHeaderDataOptions | Error,
): MockedResponse<ProjectHeaderQueryVariables, ProjectHeaderQuery> {
  return {
    request: { query: ProjectHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectLayoutDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectLayoutData(data: ProjectLayoutDataOptions): ProjectLayoutQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectLayoutResponse(
  variables: ProjectLayoutQueryVariables,
  data: ProjectLayoutDataOptions | Error,
): MockedResponse<ProjectLayoutQueryVariables, ProjectLayoutQuery> {
  return {
    request: { query: ProjectLayoutDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectLayoutData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsPageMetadataDataOptions {
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
  communities?: FactoryInput<Project, ProjectOptions>[];
}

export function newProjectsPageMetadataData(data: ProjectsPageMetadataDataOptions): ProjectsPageMetadataQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
    communities: data["communities"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newProjectsPageMetadataResponse(
  data: ProjectsPageMetadataDataOptions | Error,
): MockedResponse<ProjectsPageMetadataQueryVariables, ProjectsPageMetadataQuery> {
  return {
    request: { query: ProjectsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newProjectsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsPageProjectsDataOptions {
  projectsPage?: FactoryInput<ProjectsPageResult, ProjectsPageResultOptions>;
}

export function newProjectsPageProjectsData(data: ProjectsPageProjectsDataOptions): ProjectsPageProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newProjectsPageProjectsResponse(
  variables: ProjectsPageProjectsQueryVariables,
  data: ProjectsPageProjectsDataOptions | Error,
): MockedResponse<ProjectsPageProjectsQueryVariables, ProjectsPageProjectsQuery> {
  return {
    request: { query: ProjectsPageProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsPageProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GetTradeCategoriesDataOptions {
  tradeCategories?: FactoryInput<TradeCategory, TradeCategoryOptions>[];
}

export function newGetTradeCategoriesData(data: GetTradeCategoriesDataOptions): GetTradeCategoriesQuery {
  return {
    __typename: "Query" as const,
    tradeCategories: data["tradeCategories"]?.map((d) => maybeNew("TradeCategory", d, {})) || [],
  } as any;
}

export function newGetTradeCategoriesResponse(
  data: GetTradeCategoriesDataOptions | Error,
): MockedResponse<GetTradeCategoriesQueryVariables, GetTradeCategoriesQuery> {
  return {
    request: { query: GetTradeCategoriesDocument },
    result: { data: data instanceof Error ? undefined : newGetTradeCategoriesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GetTradeCategoryDataOptions {
  tradeCategory?: FactoryInput<TradeCategory, TradeCategoryOptions>;
}

export function newGetTradeCategoryData(data: GetTradeCategoryDataOptions): GetTradeCategoryQuery {
  return {
    __typename: "Query" as const,
    tradeCategory: maybeNew("TradeCategory", data["tradeCategory"] || undefined, {}),
  } as any;
}

export function newGetTradeCategoryResponse(
  variables: GetTradeCategoryQueryVariables,
  data: GetTradeCategoryDataOptions | Error,
): MockedResponse<GetTradeCategoryQueryVariables, GetTradeCategoryQuery> {
  return {
    request: { query: GetTradeCategoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newGetTradeCategoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradeCategoryDataOptions {
  saveTradeCategory?: FactoryInput<SaveTradeCategoryResult, SaveTradeCategoryResultOptions>;
}

export function newSaveTradeCategoryData(data: SaveTradeCategoryDataOptions): SaveTradeCategoryMutation {
  return {
    __typename: "Mutation" as const,
    saveTradeCategory: maybeNew("SaveTradeCategoryResult", data["saveTradeCategory"] || undefined, {}),
  } as any;
}

export function newSaveTradeCategoryResponse(
  variables: SaveTradeCategoryMutationVariables,
  data: SaveTradeCategoryDataOptions | Error,
): MockedResponse<SaveTradeCategoryMutationVariables, SaveTradeCategoryMutation> {
  return {
    request: { query: SaveTradeCategoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradeCategoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerCommitmentsDataOptions {
  commitmentsPage?: FactoryInput<CommitmentsPage, CommitmentsPageOptions>;
}

export function newTradePartnerCommitmentsData(data: TradePartnerCommitmentsDataOptions): TradePartnerCommitmentsQuery {
  return {
    __typename: "Query" as const,
    commitmentsPage: maybeNew("CommitmentsPage", data["commitmentsPage"] || undefined, {}),
  } as any;
}

export function newTradePartnerCommitmentsResponse(
  variables: TradePartnerCommitmentsQueryVariables,
  data: TradePartnerCommitmentsDataOptions | Error,
): MockedResponse<TradePartnerCommitmentsQueryVariables, TradePartnerCommitmentsQuery> {
  return {
    request: { query: TradePartnerCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerCommitmentsMetadataDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
  projects?: FactoryInput<Project, ProjectOptions>[];
  commitmentStatuses?: FactoryInput<CommitmentStatusDetail, CommitmentStatusDetailOptions>[];
}

export function newTradePartnerCommitmentsMetadataData(
  data: TradePartnerCommitmentsMetadataDataOptions,
): TradePartnerCommitmentsMetadataQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    commitmentStatuses: data["commitmentStatuses"]?.map((d) => maybeNew("CommitmentStatusDetail", d, {})) || [],
  } as any;
}

export function newTradePartnerCommitmentsMetadataResponse(
  variables: TradePartnerCommitmentsMetadataQueryVariables,
  data: TradePartnerCommitmentsMetadataDataOptions | Error,
): MockedResponse<TradePartnerCommitmentsMetadataQueryVariables, TradePartnerCommitmentsMetadataQuery> {
  return {
    request: { query: TradePartnerCommitmentsMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerCommitmentsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerContactsDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newTradePartnerContactsData(data: TradePartnerContactsDataOptions): TradePartnerContactsQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
  } as any;
}

export function newTradePartnerContactsResponse(
  variables: TradePartnerContactsQueryVariables,
  data: TradePartnerContactsDataOptions | Error,
): MockedResponse<TradePartnerContactsQueryVariables, TradePartnerContactsQuery> {
  return {
    request: { query: TradePartnerContactsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerContactsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerContactDataOptions {
  saveTradePartnerContact?: FactoryInput<SaveTradePartnerContactResult, SaveTradePartnerContactResultOptions>;
}

export function newSaveTradePartnerContactData(
  data: SaveTradePartnerContactDataOptions,
): SaveTradePartnerContactMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerContact: maybeNew(
      "SaveTradePartnerContactResult",
      data["saveTradePartnerContact"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerContactResponse(
  variables: SaveTradePartnerContactMutationVariables,
  data: SaveTradePartnerContactDataOptions | Error,
): MockedResponse<SaveTradePartnerContactMutationVariables, SaveTradePartnerContactMutation> {
  return {
    request: { query: SaveTradePartnerContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteTradePartnerContactDataOptions {
  deleteTradePartnerContact?: FactoryInput<DeleteTradePartnerContactResult, DeleteTradePartnerContactResultOptions>;
}

export function newDeleteTradePartnerContactData(
  data: DeleteTradePartnerContactDataOptions,
): DeleteTradePartnerContactMutation {
  return {
    __typename: "Mutation" as const,
    deleteTradePartnerContact: maybeNew(
      "DeleteTradePartnerContactResult",
      data["deleteTradePartnerContact"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteTradePartnerContactResponse(
  variables: DeleteTradePartnerContactMutationVariables,
  data: DeleteTradePartnerContactDataOptions | Error,
): MockedResponse<DeleteTradePartnerContactMutationVariables, DeleteTradePartnerContactMutation> {
  return {
    request: { query: DeleteTradePartnerContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteTradePartnerContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerMarketContactDataOptions {
  saveTradePartnerMarketContact?: FactoryInput<
    SaveTradePartnerMarketContactResult,
    SaveTradePartnerMarketContactResultOptions
  >;
}

export function newSaveTradePartnerMarketContactData(
  data: SaveTradePartnerMarketContactDataOptions,
): SaveTradePartnerMarketContactMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerMarketContact: maybeNew(
      "SaveTradePartnerMarketContactResult",
      data["saveTradePartnerMarketContact"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerMarketContactResponse(
  variables: SaveTradePartnerMarketContactMutationVariables,
  data: SaveTradePartnerMarketContactDataOptions | Error,
): MockedResponse<SaveTradePartnerMarketContactMutationVariables, SaveTradePartnerMarketContactMutation> {
  return {
    request: { query: SaveTradePartnerMarketContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerMarketContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerContactUserDataOptions {
  saveTradePartnerContact?: FactoryInput<SaveTradePartnerContactResult, SaveTradePartnerContactResultOptions>;
}

export function newSaveTradePartnerContactUserData(
  data: SaveTradePartnerContactUserDataOptions,
): SaveTradePartnerContactUserMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerContact: maybeNew(
      "SaveTradePartnerContactResult",
      data["saveTradePartnerContact"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerContactUserResponse(
  variables: SaveTradePartnerContactUserMutationVariables,
  data: SaveTradePartnerContactUserDataOptions | Error,
): MockedResponse<SaveTradePartnerContactUserMutationVariables, SaveTradePartnerContactUserMutation> {
  return {
    request: { query: SaveTradePartnerContactUserDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerContactUserData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerDetailsTabDataOptions {
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  markets?: FactoryInput<Market, MarketOptions>[];
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  tradeCategories?: FactoryInput<TradeCategory, TradeCategoryOptions>[];
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
  paymentTerms?: FactoryInput<PaymentTerm, PaymentTermOptions>[];
}

export function newTradePartnerDetailsTabData(data: TradePartnerDetailsTabDataOptions): TradePartnerDetailsTabQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    tradeCategories: data["tradeCategories"]?.map((d) => maybeNew("TradeCategory", d, {})) || [],
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
    paymentTerms: data["paymentTerms"]?.map((d) => maybeNew("PaymentTerm", d, {})) || [],
  } as any;
}

export function newTradePartnerDetailsTabResponse(
  variables: TradePartnerDetailsTabQueryVariables,
  data: TradePartnerDetailsTabDataOptions | Error,
): MockedResponse<TradePartnerDetailsTabQueryVariables, TradePartnerDetailsTabQuery> {
  return {
    request: { query: TradePartnerDetailsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerDetailsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerDevelopmentContractsDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newTradePartnerDevelopmentContractsData(
  data: TradePartnerDevelopmentContractsDataOptions,
): TradePartnerDevelopmentContractsQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newTradePartnerDevelopmentContractsResponse(
  variables: TradePartnerDevelopmentContractsQueryVariables,
  data: TradePartnerDevelopmentContractsDataOptions | Error,
): MockedResponse<TradePartnerDevelopmentContractsQueryVariables, TradePartnerDevelopmentContractsQuery> {
  return {
    request: { query: TradePartnerDevelopmentContractsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerDevelopmentContractsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerPageDataOptions {
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
}

export function newTradePartnerPageData(data: TradePartnerPageDataOptions): TradePartnerPageQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
  } as any;
}

export function newTradePartnerPageResponse(
  variables: TradePartnerPageQueryVariables,
  data: TradePartnerPageDataOptions | Error,
): MockedResponse<TradePartnerPageQueryVariables, TradePartnerPageQuery> {
  return {
    request: { query: TradePartnerPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerDataOptions {
  saveTradePartner?: FactoryInput<SaveTradePartnerResult, SaveTradePartnerResultOptions>;
}

export function newSaveTradePartnerData(data: SaveTradePartnerDataOptions): SaveTradePartnerMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartner: maybeNew("SaveTradePartnerResult", data["saveTradePartner"] || undefined, {}),
  } as any;
}

export function newSaveTradePartnerResponse(
  variables: SaveTradePartnerMutationVariables,
  data: SaveTradePartnerDataOptions | Error,
): MockedResponse<SaveTradePartnerMutationVariables, SaveTradePartnerMutation> {
  return {
    request: { query: SaveTradePartnerDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteTradePartnerDataOptions {
  deleteTradePartner?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteTradePartnerData(data: DeleteTradePartnerDataOptions): DeleteTradePartnerMutation {
  return {
    __typename: "Mutation" as const,
    deleteTradePartner: maybeNew("EmptyResult", data["deleteTradePartner"] || undefined, {}),
  } as any;
}

export function newDeleteTradePartnerResponse(
  variables: DeleteTradePartnerMutationVariables,
  data: DeleteTradePartnerDataOptions | Error,
): MockedResponse<DeleteTradePartnerMutationVariables, DeleteTradePartnerMutation> {
  return {
    request: { query: DeleteTradePartnerDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteTradePartnerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyTicketFiltersDataOptions {
  warrantyTicketItemStatusesDetail?: FactoryInput<
    WarrantyTicketItemStatusDetail,
    WarrantyTicketItemStatusDetailOptions
  >[];
  warrantyTicketStatusesDetail?: FactoryInput<WarrantyTicketStatusDetail, WarrantyTicketStatusDetailOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newWarrantyTicketFiltersData(data: WarrantyTicketFiltersDataOptions): WarrantyTicketFiltersQuery {
  return {
    __typename: "Query" as const,
    warrantyTicketItemStatusesDetail:
      data["warrantyTicketItemStatusesDetail"]?.map((d) => maybeNew("WarrantyTicketItemStatusDetail", d, {})) || [],
    warrantyTicketStatusesDetail:
      data["warrantyTicketStatusesDetail"]?.map((d) => maybeNew("WarrantyTicketStatusDetail", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newWarrantyTicketFiltersResponse(
  data: WarrantyTicketFiltersDataOptions | Error,
): MockedResponse<WarrantyTicketFiltersQueryVariables, WarrantyTicketFiltersQuery> {
  return {
    request: { query: WarrantyTicketFiltersDocument },
    result: { data: data instanceof Error ? undefined : newWarrantyTicketFiltersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyTicketsDataOptions {
  warrantyTicketsPage?: FactoryInput<WarrantyTicketsPage, WarrantyTicketsPageOptions>;
}

export function newWarrantyTicketsData(data: WarrantyTicketsDataOptions): WarrantyTicketsQuery {
  return {
    __typename: "Query" as const,
    warrantyTicketsPage: maybeNew("WarrantyTicketsPage", data["warrantyTicketsPage"] || undefined, {}),
  } as any;
}

export function newWarrantyTicketsResponse(
  variables: WarrantyTicketsQueryVariables,
  data: WarrantyTicketsDataOptions | Error,
): MockedResponse<WarrantyTicketsQueryVariables, WarrantyTicketsQuery> {
  return {
    request: { query: WarrantyTicketsDocument, variables },
    result: { data: data instanceof Error ? undefined : newWarrantyTicketsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveWarrantyTicketDataOptions {
  saveWarrantyTicket?: FactoryInput<SaveWarrantyTicketResult, SaveWarrantyTicketResultOptions>;
}

export function newSaveWarrantyTicketData(data: SaveWarrantyTicketDataOptions): SaveWarrantyTicketMutation {
  return {
    __typename: "Mutation" as const,
    saveWarrantyTicket: maybeNew("SaveWarrantyTicketResult", data["saveWarrantyTicket"] || undefined, {}),
  } as any;
}

export function newSaveWarrantyTicketResponse(
  variables: SaveWarrantyTicketMutationVariables,
  data: SaveWarrantyTicketDataOptions | Error,
): MockedResponse<SaveWarrantyTicketMutationVariables, SaveWarrantyTicketMutation> {
  return {
    request: { query: SaveWarrantyTicketDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveWarrantyTicketData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveWarrantyTicketItemsDataOptions {
  saveWarrantyTicketItems?: FactoryInput<SaveWarrantyTicketItemsResult, SaveWarrantyTicketItemsResultOptions>;
}

export function newSaveWarrantyTicketItemsData(
  data: SaveWarrantyTicketItemsDataOptions,
): SaveWarrantyTicketItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveWarrantyTicketItems: maybeNew(
      "SaveWarrantyTicketItemsResult",
      data["saveWarrantyTicketItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveWarrantyTicketItemsResponse(
  variables: SaveWarrantyTicketItemsMutationVariables,
  data: SaveWarrantyTicketItemsDataOptions | Error,
): MockedResponse<SaveWarrantyTicketItemsMutationVariables, SaveWarrantyTicketItemsMutation> {
  return {
    request: { query: SaveWarrantyTicketItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveWarrantyTicketItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerRequirementsDataOptions {
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  tradePartnerRequirementTypes?: FactoryInput<
    TradePartnerRequirementTypeDetail,
    TradePartnerRequirementTypeDetailOptions
  >[];
  tradePartnerRequirementStatuses?: FactoryInput<
    TradePartnerRequirementStatusDetail,
    TradePartnerRequirementStatusDetailOptions
  >[];
}

export function newTradePartnerRequirementsData(
  data: TradePartnerRequirementsDataOptions,
): TradePartnerRequirementsQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
    tradePartnerRequirementTypes:
      data["tradePartnerRequirementTypes"]?.map((d) => maybeNew("TradePartnerRequirementTypeDetail", d, {})) || [],
    tradePartnerRequirementStatuses:
      data["tradePartnerRequirementStatuses"]?.map((d) => maybeNew("TradePartnerRequirementStatusDetail", d, {})) || [],
  } as any;
}

export function newTradePartnerRequirementsResponse(
  variables: TradePartnerRequirementsQueryVariables,
  data: TradePartnerRequirementsDataOptions | Error,
): MockedResponse<TradePartnerRequirementsQueryVariables, TradePartnerRequirementsQuery> {
  return {
    request: { query: TradePartnerRequirementsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerRequirementsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerRequirementDataOptions {
  saveTradePartnerRequirement?: FactoryInput<
    SaveTradePartnerRequirementResult,
    SaveTradePartnerRequirementResultOptions
  >;
}

export function newSaveTradePartnerRequirementData(
  data: SaveTradePartnerRequirementDataOptions,
): SaveTradePartnerRequirementMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerRequirement: maybeNew(
      "SaveTradePartnerRequirementResult",
      data["saveTradePartnerRequirement"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerRequirementResponse(
  variables: SaveTradePartnerRequirementMutationVariables,
  data: SaveTradePartnerRequirementDataOptions | Error,
): MockedResponse<SaveTradePartnerRequirementMutationVariables, SaveTradePartnerRequirementMutation> {
  return {
    request: { query: SaveTradePartnerRequirementDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerRequirementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnersMetadataDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
  tradeCategories?: FactoryInput<TradeCategory, TradeCategoryOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
}

export function newTradePartnersMetadataData(data: TradePartnersMetadataDataOptions): TradePartnersMetadataQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    tradeCategories: data["tradeCategories"]?.map((d) => maybeNew("TradeCategory", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
  } as any;
}

export function newTradePartnersMetadataResponse(
  data: TradePartnersMetadataDataOptions | Error,
): MockedResponse<TradePartnersMetadataQueryVariables, TradePartnersMetadataQuery> {
  return {
    request: { query: TradePartnersMetadataDocument },
    result: { data: data instanceof Error ? undefined : newTradePartnersMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnersDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newTradePartnersData(data: TradePartnersDataOptions): TradePartnersQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newTradePartnersResponse(
  variables: TradePartnersQueryVariables,
  data: TradePartnersDataOptions | Error,
): MockedResponse<TradePartnersQueryVariables, TradePartnersQuery> {
  return {
    request: { query: TradePartnersDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnersPageDataOptions {
  tradePartnersPage?: FactoryInput<TradePartnersPage, TradePartnersPageOptions>;
}

export function newTradePartnersPageData(data: TradePartnersPageDataOptions): TradePartnersPageQuery {
  return {
    __typename: "Query" as const,
    tradePartnersPage: maybeNew("TradePartnersPage", data["tradePartnersPage"] || undefined, {}),
  } as any;
}

export function newTradePartnersPageResponse(
  variables: TradePartnersPageQueryVariables,
  data: TradePartnersPageDataOptions | Error,
): MockedResponse<TradePartnersPageQueryVariables, TradePartnersPageQuery> {
  return {
    request: { query: TradePartnersPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnersPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteWarrantyTicketDataOptions {
  deleteWarrantyTicket?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteWarrantyTicketData(data: DeleteWarrantyTicketDataOptions): DeleteWarrantyTicketMutation {
  return {
    __typename: "Mutation" as const,
    deleteWarrantyTicket: maybeNew("EmptyResult", data["deleteWarrantyTicket"] || undefined, {}),
  } as any;
}

export function newDeleteWarrantyTicketResponse(
  variables: DeleteWarrantyTicketMutationVariables,
  data: DeleteWarrantyTicketDataOptions | Error,
): MockedResponse<DeleteWarrantyTicketMutationVariables, DeleteWarrantyTicketMutation> {
  return {
    request: { query: DeleteWarrantyTicketDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteWarrantyTicketData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyTicketDataOptions {
  warrantyTicket?: FactoryInput<WarrantyTicket, WarrantyTicketOptions>;
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newWarrantyTicketData(data: WarrantyTicketDataOptions): WarrantyTicketQuery {
  return {
    __typename: "Query" as const,
    warrantyTicket: maybeNew("WarrantyTicket", data["warrantyTicket"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newWarrantyTicketResponse(
  variables: WarrantyTicketQueryVariables,
  data: WarrantyTicketDataOptions | Error,
): MockedResponse<WarrantyTicketQueryVariables, WarrantyTicketQuery> {
  return {
    request: { query: WarrantyTicketDocument, variables },
    result: { data: data instanceof Error ? undefined : newWarrantyTicketData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyTicketEnumsDataOptions {
  warrantyTicketItemStatusesDetail?: FactoryInput<
    WarrantyTicketItemStatusDetail,
    WarrantyTicketItemStatusDetailOptions
  >[];
  warrantyTicketItemTypesDetail?: FactoryInput<WarrantyTicketItemTypeDetail, WarrantyTicketItemTypeDetailOptions>[];
  warrantyTicketTypesDetail?: FactoryInput<WarrantyTicketTypeDetail, WarrantyTicketTypeDetailOptions>[];
}

export function newWarrantyTicketEnumsData(data: WarrantyTicketEnumsDataOptions): WarrantyTicketEnumsQuery {
  return {
    __typename: "Query" as const,
    warrantyTicketItemStatusesDetail:
      data["warrantyTicketItemStatusesDetail"]?.map((d) => maybeNew("WarrantyTicketItemStatusDetail", d, {})) || [],
    warrantyTicketItemTypesDetail:
      data["warrantyTicketItemTypesDetail"]?.map((d) => maybeNew("WarrantyTicketItemTypeDetail", d, {})) || [],
    warrantyTicketTypesDetail:
      data["warrantyTicketTypesDetail"]?.map((d) => maybeNew("WarrantyTicketTypeDetail", d, {})) || [],
  } as any;
}

export function newWarrantyTicketEnumsResponse(
  data: WarrantyTicketEnumsDataOptions | Error,
): MockedResponse<WarrantyTicketEnumsQueryVariables, WarrantyTicketEnumsQuery> {
  return {
    request: { query: WarrantyTicketEnumsDocument },
    result: { data: data instanceof Error ? undefined : newWarrantyTicketEnumsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveWarrantyTicketPageDataOptions {
  saveWarrantyTicket?: FactoryInput<SaveWarrantyTicketResult, SaveWarrantyTicketResultOptions>;
}

export function newSaveWarrantyTicketPageData(data: SaveWarrantyTicketPageDataOptions): SaveWarrantyTicketPageMutation {
  return {
    __typename: "Mutation" as const,
    saveWarrantyTicket: maybeNew("SaveWarrantyTicketResult", data["saveWarrantyTicket"] || undefined, {}),
  } as any;
}

export function newSaveWarrantyTicketPageResponse(
  variables: SaveWarrantyTicketPageMutationVariables,
  data: SaveWarrantyTicketPageDataOptions | Error,
): MockedResponse<SaveWarrantyTicketPageMutationVariables, SaveWarrantyTicketPageMutation> {
  return {
    request: { query: SaveWarrantyTicketPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveWarrantyTicketPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteWarrantyTicketItemDataOptions {
  deleteWarrantyTicketItem?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteWarrantyTicketItemData(
  data: DeleteWarrantyTicketItemDataOptions,
): DeleteWarrantyTicketItemMutation {
  return {
    __typename: "Mutation" as const,
    deleteWarrantyTicketItem: maybeNew("EmptyResult", data["deleteWarrantyTicketItem"] || undefined, {}),
  } as any;
}

export function newDeleteWarrantyTicketItemResponse(
  variables: DeleteWarrantyTicketItemMutationVariables,
  data: DeleteWarrantyTicketItemDataOptions | Error,
): MockedResponse<DeleteWarrantyTicketItemMutationVariables, DeleteWarrantyTicketItemMutation> {
  return {
    request: { query: DeleteWarrantyTicketItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteWarrantyTicketItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BusinessFunctionAssetsDataOptions {
  changeRequestAssets?: FactoryInput<ChangeRequestAssetsPageResult, ChangeRequestAssetsPageResultOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newBusinessFunctionAssetsData(data: BusinessFunctionAssetsDataOptions): BusinessFunctionAssetsQuery {
  return {
    __typename: "Query" as const,
    changeRequestAssets: maybeNew("ChangeRequestAssetsPageResult", data["changeRequestAssets"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newBusinessFunctionAssetsResponse(
  variables: BusinessFunctionAssetsQueryVariables,
  data: BusinessFunctionAssetsDataOptions | Error,
): MockedResponse<BusinessFunctionAssetsQueryVariables, BusinessFunctionAssetsQuery> {
  return {
    request: { query: BusinessFunctionAssetsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBusinessFunctionAssetsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestAssetsDataOptions {
  saveChangeRequestAssets?: FactoryInput<SaveChangeRequestAssetsResult, SaveChangeRequestAssetsResultOptions>;
}

export function newSaveChangeRequestAssetsData(
  data: SaveChangeRequestAssetsDataOptions,
): SaveChangeRequestAssetsMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequestAssets: maybeNew(
      "SaveChangeRequestAssetsResult",
      data["saveChangeRequestAssets"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveChangeRequestAssetsResponse(
  variables: SaveChangeRequestAssetsMutationVariables,
  data: SaveChangeRequestAssetsDataOptions | Error,
): MockedResponse<SaveChangeRequestAssetsMutationVariables, SaveChangeRequestAssetsMutation> {
  return {
    request: { query: SaveChangeRequestAssetsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestAssetsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestGroupModalDataOptions {
  changeRequestGroup?: FactoryInput<ChangeRequestGroup, ChangeRequestGroupOptions>;
}

export function newChangeRequestGroupModalData(data: ChangeRequestGroupModalDataOptions): ChangeRequestGroupModalQuery {
  return {
    __typename: "Query" as const,
    changeRequestGroup: maybeNew("ChangeRequestGroup", data["changeRequestGroup"] || undefined, {}),
  } as any;
}

export function newChangeRequestGroupModalResponse(
  variables: ChangeRequestGroupModalQueryVariables,
  data: ChangeRequestGroupModalDataOptions | Error,
): MockedResponse<ChangeRequestGroupModalQueryVariables, ChangeRequestGroupModalQuery> {
  return {
    request: { query: ChangeRequestGroupModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeRequestGroupModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestGroupDataOptions {
  saveChangeRequestGroup?: FactoryInput<SaveChangeRequestGroupResult, SaveChangeRequestGroupResultOptions>;
}

export function newSaveChangeRequestGroupData(data: SaveChangeRequestGroupDataOptions): SaveChangeRequestGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequestGroup: maybeNew("SaveChangeRequestGroupResult", data["saveChangeRequestGroup"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestGroupResponse(
  variables: SaveChangeRequestGroupMutationVariables,
  data: SaveChangeRequestGroupDataOptions | Error,
): MockedResponse<SaveChangeRequestGroupMutationVariables, SaveChangeRequestGroupMutation> {
  return {
    request: { query: SaveChangeRequestGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteChangeRequestGroupDataOptions {
  deleteChangeRequestGroup?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteChangeRequestGroupData(
  data: DeleteChangeRequestGroupDataOptions,
): DeleteChangeRequestGroupMutation {
  return {
    __typename: "Mutation" as const,
    deleteChangeRequestGroup: maybeNew("EmptyResult", data["deleteChangeRequestGroup"] || undefined, {}),
  } as any;
}

export function newDeleteChangeRequestGroupResponse(
  variables: DeleteChangeRequestGroupMutationVariables,
  data: DeleteChangeRequestGroupDataOptions | Error,
): MockedResponse<DeleteChangeRequestGroupMutationVariables, DeleteChangeRequestGroupMutation> {
  return {
    request: { query: DeleteChangeRequestGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteChangeRequestGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestsDependencyModalDataOptions {
  changeRequest?: FactoryInput<ChangeRequest, ChangeRequestOptions>;
  availableDependencyChangeRequests?: FactoryInput<ChangeRequest, ChangeRequestOptions>[];
}

export function newChangeRequestsDependencyModalData(
  data: ChangeRequestsDependencyModalDataOptions,
): ChangeRequestsDependencyModalQuery {
  return {
    __typename: "Query" as const,
    changeRequest: maybeNew("ChangeRequest", data["changeRequest"] || undefined, {}),
    availableDependencyChangeRequests:
      data["availableDependencyChangeRequests"]?.map((d) => maybeNew("ChangeRequest", d, {})) || [],
  } as any;
}

export function newChangeRequestsDependencyModalResponse(
  variables: ChangeRequestsDependencyModalQueryVariables,
  data: ChangeRequestsDependencyModalDataOptions | Error,
): MockedResponse<ChangeRequestsDependencyModalQueryVariables, ChangeRequestsDependencyModalQuery> {
  return {
    request: { query: ChangeRequestsDependencyModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeRequestsDependencyModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestGroupsForModalDataOptions {
  changeRequestGroups?: FactoryInput<ChangeRequestGroup, ChangeRequestGroupOptions>[];
}

export function newChangeRequestGroupsForModalData(
  data: ChangeRequestGroupsForModalDataOptions,
): ChangeRequestGroupsForModalQuery {
  return {
    __typename: "Query" as const,
    changeRequestGroups: data["changeRequestGroups"]?.map((d) => maybeNew("ChangeRequestGroup", d, {})) || [],
  } as any;
}

export function newChangeRequestGroupsForModalResponse(
  data: ChangeRequestGroupsForModalDataOptions | Error,
): MockedResponse<ChangeRequestGroupsForModalQueryVariables, ChangeRequestGroupsForModalQuery> {
  return {
    request: { query: ChangeRequestGroupsForModalDocument },
    result: { data: data instanceof Error ? undefined : newChangeRequestGroupsForModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestDependencyBlockingDataOptions {
  saveChangeRequest?: FactoryInput<SaveChangeRequestResult, SaveChangeRequestResultOptions>;
}

export function newSaveChangeRequestDependencyBlockingData(
  data: SaveChangeRequestDependencyBlockingDataOptions,
): SaveChangeRequestDependencyBlockingMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequest: maybeNew("SaveChangeRequestResult", data["saveChangeRequest"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestDependencyBlockingResponse(
  variables: SaveChangeRequestDependencyBlockingMutationVariables,
  data: SaveChangeRequestDependencyBlockingDataOptions | Error,
): MockedResponse<SaveChangeRequestDependencyBlockingMutationVariables, SaveChangeRequestDependencyBlockingMutation> {
  return {
    request: { query: SaveChangeRequestDependencyBlockingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestDependencyBlockingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestDependencyBlockersDataOptions {
  saveChangeRequest?: FactoryInput<SaveChangeRequestResult, SaveChangeRequestResultOptions>;
}

export function newSaveChangeRequestDependencyBlockersData(
  data: SaveChangeRequestDependencyBlockersDataOptions,
): SaveChangeRequestDependencyBlockersMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequest: maybeNew("SaveChangeRequestResult", data["saveChangeRequest"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestDependencyBlockersResponse(
  variables: SaveChangeRequestDependencyBlockersMutationVariables,
  data: SaveChangeRequestDependencyBlockersDataOptions | Error,
): MockedResponse<SaveChangeRequestDependencyBlockersMutationVariables, SaveChangeRequestDependencyBlockersMutation> {
  return {
    request: { query: SaveChangeRequestDependencyBlockersDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestDependencyBlockersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestRelatedToDataOptions {
  saveChangeRequest?: FactoryInput<SaveChangeRequestResult, SaveChangeRequestResultOptions>;
  saveChangeRequestGroups?: FactoryInput<SaveChangeRequestGroupsResult, SaveChangeRequestGroupsResultOptions>;
}

export function newSaveChangeRequestRelatedToData(
  data: SaveChangeRequestRelatedToDataOptions,
): SaveChangeRequestRelatedToMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequest: maybeNew("SaveChangeRequestResult", data["saveChangeRequest"] || undefined, {}),
    saveChangeRequestGroups: maybeNew(
      "SaveChangeRequestGroupsResult",
      data["saveChangeRequestGroups"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveChangeRequestRelatedToResponse(
  variables: SaveChangeRequestRelatedToMutationVariables,
  data: SaveChangeRequestRelatedToDataOptions | Error,
): MockedResponse<SaveChangeRequestRelatedToMutationVariables, SaveChangeRequestRelatedToMutation> {
  return {
    request: { query: SaveChangeRequestRelatedToDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestRelatedToData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestHistoryDataOptions {
  changeRequest?: FactoryInput<ChangeRequest, ChangeRequestOptions>;
}

export function newChangeRequestHistoryData(data: ChangeRequestHistoryDataOptions): ChangeRequestHistoryQuery {
  return {
    __typename: "Query" as const,
    changeRequest: maybeNew("ChangeRequest", data["changeRequest"] || undefined, {}),
  } as any;
}

export function newChangeRequestHistoryResponse(
  variables: ChangeRequestHistoryQueryVariables,
  data: ChangeRequestHistoryDataOptions | Error,
): MockedResponse<ChangeRequestHistoryQueryVariables, ChangeRequestHistoryQuery> {
  return {
    request: { query: ChangeRequestHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeRequestHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDetailPaneDataOptions {
  bill?: FactoryInput<Bill, BillOptions>;
}

export function newBillDetailPaneData(data: BillDetailPaneDataOptions): BillDetailPaneQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillDetailPaneResponse(
  variables: BillDetailPaneQueryVariables,
  data: BillDetailPaneDataOptions | Error,
): MockedResponse<BillDetailPaneQueryVariables, BillDetailPaneQuery> {
  return {
    request: { query: BillDetailPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillDetailPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDetailPane_NewBillCommitmentLikeDataDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
  commitmentChangeOrder?: FactoryInput<CommitmentChangeOrder, CommitmentChangeOrderOptions>;
}

export function newBillDetailPane_NewBillCommitmentLikeDataData(
  data: BillDetailPane_NewBillCommitmentLikeDataDataOptions,
): BillDetailPane_NewBillCommitmentLikeDataQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newBillDetailPane_NewBillCommitmentLikeDataResponse(
  variables: BillDetailPane_NewBillCommitmentLikeDataQueryVariables,
  data: BillDetailPane_NewBillCommitmentLikeDataDataOptions | Error,
): MockedResponse<
  BillDetailPane_NewBillCommitmentLikeDataQueryVariables,
  BillDetailPane_NewBillCommitmentLikeDataQuery
> {
  return {
    request: { query: BillDetailPane_NewBillCommitmentLikeDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillDetailPane_NewBillCommitmentLikeDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDetailPane_AdditionalCommitmentsDataOptions {
  commitments?: FactoryInput<Commitment, CommitmentOptions>[];
}

export function newBillDetailPane_AdditionalCommitmentsData(
  data: BillDetailPane_AdditionalCommitmentsDataOptions,
): BillDetailPane_AdditionalCommitmentsQuery {
  return {
    __typename: "Query" as const,
    commitments: data["commitments"]?.map((d) => maybeNew("Commitment", d, {})) || [],
  } as any;
}

export function newBillDetailPane_AdditionalCommitmentsResponse(
  variables: BillDetailPane_AdditionalCommitmentsQueryVariables,
  data: BillDetailPane_AdditionalCommitmentsDataOptions | Error,
): MockedResponse<BillDetailPane_AdditionalCommitmentsQueryVariables, BillDetailPane_AdditionalCommitmentsQuery> {
  return {
    request: { query: BillDetailPane_AdditionalCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillDetailPane_AdditionalCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPaneDetail_SaveBillDocumentDataOptions {
  saveDocuments?: FactoryInput<SaveDocumentsResult, SaveDocumentsResultOptions>;
}

export function newBillPaneDetail_SaveBillDocumentData(
  data: BillPaneDetail_SaveBillDocumentDataOptions,
): BillPaneDetail_SaveBillDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newBillPaneDetail_SaveBillDocumentResponse(
  variables: BillPaneDetail_SaveBillDocumentMutationVariables,
  data: BillPaneDetail_SaveBillDocumentDataOptions | Error,
): MockedResponse<BillPaneDetail_SaveBillDocumentMutationVariables, BillPaneDetail_SaveBillDocumentMutation> {
  return {
    request: { query: BillPaneDetail_SaveBillDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPaneDetail_SaveBillDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDetailPane_SaveApprovalDataOptions {
  saveApproval?: FactoryInput<SaveApprovalResult, SaveApprovalResultOptions>;
}

export function newBillDetailPane_SaveApprovalData(
  data: BillDetailPane_SaveApprovalDataOptions,
): BillDetailPane_SaveApprovalMutation {
  return {
    __typename: "Mutation" as const,
    saveApproval: maybeNew("SaveApprovalResult", data["saveApproval"] || undefined, {}),
  } as any;
}

export function newBillDetailPane_SaveApprovalResponse(
  variables: BillDetailPane_SaveApprovalMutationVariables,
  data: BillDetailPane_SaveApprovalDataOptions | Error,
): MockedResponse<BillDetailPane_SaveApprovalMutationVariables, BillDetailPane_SaveApprovalMutation> {
  return {
    request: { query: BillDetailPane_SaveApprovalDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillDetailPane_SaveApprovalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MarketFilterMetadataDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newMarketFilterMetadataData(data: MarketFilterMetadataDataOptions): MarketFilterMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [] } as any;
}

export function newMarketFilterMetadataResponse(
  data: MarketFilterMetadataDataOptions | Error,
): MockedResponse<MarketFilterMetadataQueryVariables, MarketFilterMetadataQuery> {
  return {
    request: { query: MarketFilterMetadataDocument },
    result: { data: data instanceof Error ? undefined : newMarketFilterMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToggleProjectFeatureDataOptions {
  toggleProjectFeature?: FactoryInput<SaveProjectResult, SaveProjectResultOptions>;
}

export function newToggleProjectFeatureData(data: ToggleProjectFeatureDataOptions): ToggleProjectFeatureMutation {
  return {
    __typename: "Mutation" as const,
    toggleProjectFeature: maybeNew("SaveProjectResult", data["toggleProjectFeature"] || undefined, {}),
  } as any;
}

export function newToggleProjectFeatureResponse(
  variables: ToggleProjectFeatureMutationVariables,
  data: ToggleProjectFeatureDataOptions | Error,
): MockedResponse<ToggleProjectFeatureMutationVariables, ToggleProjectFeatureMutation> {
  return {
    request: { query: ToggleProjectFeatureDocument, variables },
    result: { data: data instanceof Error ? undefined : newToggleProjectFeatureData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReadyPlanStatusFilterMetadataDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newReadyPlanStatusFilterMetadataData(
  data: ReadyPlanStatusFilterMetadataDataOptions,
): ReadyPlanStatusFilterMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newReadyPlanStatusFilterMetadataResponse(
  data: ReadyPlanStatusFilterMetadataDataOptions | Error,
): MockedResponse<ReadyPlanStatusFilterMetadataQueryVariables, ReadyPlanStatusFilterMetadataQuery> {
  return {
    request: { query: ReadyPlanStatusFilterMetadataDocument },
    result: { data: data instanceof Error ? undefined : newReadyPlanStatusFilterMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectCommunityFilterMetadataDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newProjectCommunityFilterMetadataData(
  data: ProjectCommunityFilterMetadataDataOptions,
): ProjectCommunityFilterMetadataQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newProjectCommunityFilterMetadataResponse(
  data: ProjectCommunityFilterMetadataDataOptions | Error,
): MockedResponse<ProjectCommunityFilterMetadataQueryVariables, ProjectCommunityFilterMetadataQuery> {
  return {
    request: { query: ProjectCommunityFilterMetadataDocument },
    result: { data: data instanceof Error ? undefined : newProjectCommunityFilterMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeMaterialLeadTimesTabDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newCostCodeMaterialLeadTimesTabData(
  data: CostCodeMaterialLeadTimesTabDataOptions,
): CostCodeMaterialLeadTimesTabQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newCostCodeMaterialLeadTimesTabResponse(
  variables: CostCodeMaterialLeadTimesTabQueryVariables,
  data: CostCodeMaterialLeadTimesTabDataOptions | Error,
): MockedResponse<CostCodeMaterialLeadTimesTabQueryVariables, CostCodeMaterialLeadTimesTabQuery> {
  return {
    request: { query: CostCodeMaterialLeadTimesTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodeMaterialLeadTimesTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeHistoryDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newCostCodeHistoryData(data: CostCodeHistoryDataOptions): CostCodeHistoryQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newCostCodeHistoryResponse(
  variables: CostCodeHistoryQueryVariables,
  data: CostCodeHistoryDataOptions | Error,
): MockedResponse<CostCodeHistoryQueryVariables, CostCodeHistoryQuery> {
  return {
    request: { query: CostCodeHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodeHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetProjectStatusDataOptions {
  saveProject?: FactoryInput<SaveProjectResult, SaveProjectResultOptions>;
}

export function newSetProjectStatusData(data: SetProjectStatusDataOptions): SetProjectStatusMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSetProjectStatusResponse(
  variables: SetProjectStatusMutationVariables,
  data: SetProjectStatusDataOptions | Error,
): MockedResponse<SetProjectStatusMutationVariables, SetProjectStatusMutation> {
  return {
    request: { query: SetProjectStatusDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetProjectStatusData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeOverviewTabDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newCostCodeOverviewTabData(data: CostCodeOverviewTabDataOptions): CostCodeOverviewTabQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newCostCodeOverviewTabResponse(
  variables: CostCodeOverviewTabQueryVariables,
  data: CostCodeOverviewTabDataOptions | Error,
): MockedResponse<CostCodeOverviewTabQueryVariables, CostCodeOverviewTabQuery> {
  return {
    request: { query: CostCodeOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodeOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeOverviewTabMetadataDataOptions {
  costDivisions?: FactoryInput<CostDivision, CostDivisionOptions>[];
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newCostCodeOverviewTabMetadataData(
  data: CostCodeOverviewTabMetadataDataOptions,
): CostCodeOverviewTabMetadataQuery {
  return {
    __typename: "Query" as const,
    costDivisions: data["costDivisions"]?.map((d) => maybeNew("CostDivision", d, {})) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newCostCodeOverviewTabMetadataResponse(
  data: CostCodeOverviewTabMetadataDataOptions | Error,
): MockedResponse<CostCodeOverviewTabMetadataQueryVariables, CostCodeOverviewTabMetadataQuery> {
  return {
    request: { query: CostCodeOverviewTabMetadataDocument },
    result: { data: data instanceof Error ? undefined : newCostCodeOverviewTabMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCostCodesDataOptions {
  saveCostCodes?: FactoryInput<SaveCostCodesResult, SaveCostCodesResultOptions>;
}

export function newSaveCostCodesData(data: SaveCostCodesDataOptions): SaveCostCodesMutation {
  return {
    __typename: "Mutation" as const,
    saveCostCodes: maybeNew("SaveCostCodesResult", data["saveCostCodes"] || undefined, {}),
  } as any;
}

export function newSaveCostCodesResponse(
  variables: SaveCostCodesMutationVariables,
  data: SaveCostCodesDataOptions | Error,
): MockedResponse<SaveCostCodesMutationVariables, SaveCostCodesMutation> {
  return {
    request: { query: SaveCostCodesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCostCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemsDrawerDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newItemsDrawerData(data: ItemsDrawerDataOptions): ItemsDrawerQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [] } as any;
}

export function newItemsDrawerResponse(
  variables: ItemsDrawerQueryVariables,
  data: ItemsDrawerDataOptions | Error,
): MockedResponse<ItemsDrawerQueryVariables, ItemsDrawerQuery> {
  return {
    request: { query: ItemsDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemsDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FeatureTypesDataOptions {
  featureTypes?: FactoryInput<FeatureType, FeatureTypeOptions>[];
}

export function newFeatureTypesData(data: FeatureTypesDataOptions): FeatureTypesQuery {
  return {
    __typename: "Query" as const,
    featureTypes: data["featureTypes"]?.map((d) => maybeNew("FeatureType", d, {})) || [],
  } as any;
}

export function newFeatureTypesResponse(
  variables: FeatureTypesQueryVariables,
  data: FeatureTypesDataOptions | Error,
): MockedResponse<FeatureTypesQueryVariables, FeatureTypesQuery> {
  return {
    request: { query: FeatureTypesDocument, variables },
    result: { data: data instanceof Error ? undefined : newFeatureTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FeatureTypes_RoomTypesDataOptions {
  roomTypes?: FactoryInput<RoomType, RoomTypeOptions>[];
}

export function newFeatureTypes_RoomTypesData(data: FeatureTypes_RoomTypesDataOptions): FeatureTypes_RoomTypesQuery {
  return {
    __typename: "Query" as const,
    roomTypes: data["roomTypes"]?.map((d) => maybeNew("RoomType", d, {})) || [],
  } as any;
}

export function newFeatureTypes_RoomTypesResponse(
  data: FeatureTypes_RoomTypesDataOptions | Error,
): MockedResponse<FeatureTypes_RoomTypesQueryVariables, FeatureTypes_RoomTypesQuery> {
  return {
    request: { query: FeatureTypes_RoomTypesDocument },
    result: { data: data instanceof Error ? undefined : newFeatureTypes_RoomTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFeatureTypeDataOptions {
  saveFeatureType?: FactoryInput<SaveFeatureTypeResult, SaveFeatureTypeResultOptions>;
}

export function newSaveFeatureTypeData(data: SaveFeatureTypeDataOptions): SaveFeatureTypeMutation {
  return {
    __typename: "Mutation" as const,
    saveFeatureType: maybeNew("SaveFeatureTypeResult", data["saveFeatureType"] || undefined, {}),
  } as any;
}

export function newSaveFeatureTypeResponse(
  variables: SaveFeatureTypeMutationVariables,
  data: SaveFeatureTypeDataOptions | Error,
): MockedResponse<SaveFeatureTypeMutationVariables, SaveFeatureTypeMutation> {
  return {
    request: { query: SaveFeatureTypeDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFeatureTypeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteFeatureTypeDataOptions {
  deleteFeatureType?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteFeatureTypeData(data: DeleteFeatureTypeDataOptions): DeleteFeatureTypeMutation {
  return {
    __typename: "Mutation" as const,
    deleteFeatureType: maybeNew("EmptyResult", data["deleteFeatureType"] || undefined, {}),
  } as any;
}

export function newDeleteFeatureTypeResponse(
  variables: DeleteFeatureTypeMutationVariables,
  data: DeleteFeatureTypeDataOptions | Error,
): MockedResponse<DeleteFeatureTypeMutationVariables, DeleteFeatureTypeMutation> {
  return {
    request: { query: DeleteFeatureTypeDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteFeatureTypeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FeatureFlagsDataOptions {
  featureFlags?: FactoryInput<FeatureFlag, FeatureFlagOptions>[];
}

export function newFeatureFlagsData(data: FeatureFlagsDataOptions): FeatureFlagsQuery {
  return {
    __typename: "Query" as const,
    featureFlags: data["featureFlags"]?.map((d) => maybeNew("FeatureFlag", d, {})) || [],
  } as any;
}

export function newFeatureFlagsResponse(
  variables: FeatureFlagsQueryVariables,
  data: FeatureFlagsDataOptions | Error,
): MockedResponse<FeatureFlagsQueryVariables, FeatureFlagsQuery> {
  return {
    request: { query: FeatureFlagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newFeatureFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FeatureFlagsMetadataDataOptions {
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  userGroups?: FactoryInput<UserGroup, UserGroupOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
  projects?: FactoryInput<Project, ProjectOptions>[];
  availableFeatureFlagTypes?: FactoryInput<FeatureFlagTypeDetail, FeatureFlagTypeDetailOptions>[];
}

export function newFeatureFlagsMetadataData(data: FeatureFlagsMetadataDataOptions): FeatureFlagsMetadataQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    userGroups: data["userGroups"]?.map((d) => maybeNew("UserGroup", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    availableFeatureFlagTypes:
      data["availableFeatureFlagTypes"]?.map((d) => maybeNew("FeatureFlagTypeDetail", d, {})) || [],
  } as any;
}

export function newFeatureFlagsMetadataResponse(
  variables: FeatureFlagsMetadataQueryVariables,
  data: FeatureFlagsMetadataDataOptions | Error,
): MockedResponse<FeatureFlagsMetadataQueryVariables, FeatureFlagsMetadataQuery> {
  return {
    request: { query: FeatureFlagsMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newFeatureFlagsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFeatureFlagDataOptions {
  saveFeatureFlag?: FactoryInput<SaveFeatureFlagResult, SaveFeatureFlagResultOptions>;
}

export function newSaveFeatureFlagData(data: SaveFeatureFlagDataOptions): SaveFeatureFlagMutation {
  return {
    __typename: "Mutation" as const,
    saveFeatureFlag: maybeNew("SaveFeatureFlagResult", data["saveFeatureFlag"] || undefined, {}),
  } as any;
}

export function newSaveFeatureFlagResponse(
  variables: SaveFeatureFlagMutationVariables,
  data: SaveFeatureFlagDataOptions | Error,
): MockedResponse<SaveFeatureFlagMutationVariables, SaveFeatureFlagMutation> {
  return {
    request: { query: SaveFeatureFlagDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFeatureFlagData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodesDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newCostCodesData(data: CostCodesDataOptions): CostCodesQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newCostCodesResponse(
  variables: CostCodesQueryVariables,
  data: CostCodesDataOptions | Error,
): MockedResponse<CostCodesQueryVariables, CostCodesQuery> {
  return {
    request: { query: CostCodesDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCostCodeDataOptions {
  deleteCostCode?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteCostCodeData(data: DeleteCostCodeDataOptions): DeleteCostCodeMutation {
  return {
    __typename: "Mutation" as const,
    deleteCostCode: maybeNew("EmptyResult", data["deleteCostCode"] || undefined, {}),
  } as any;
}

export function newDeleteCostCodeResponse(
  variables: DeleteCostCodeMutationVariables,
  data: DeleteCostCodeDataOptions | Error,
): MockedResponse<DeleteCostCodeMutationVariables, DeleteCostCodeMutation> {
  return {
    request: { query: DeleteCostCodeDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCostCodeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleCostCodesDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newFinishScheduleCostCodesData(data: FinishScheduleCostCodesDataOptions): FinishScheduleCostCodesQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newFinishScheduleCostCodesResponse(
  variables: FinishScheduleCostCodesQueryVariables,
  data: FinishScheduleCostCodesDataOptions | Error,
): MockedResponse<FinishScheduleCostCodesQueryVariables, FinishScheduleCostCodesQuery> {
  return {
    request: { query: FinishScheduleCostCodesDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleCostCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFinishScheduleCostCodesDataOptions {
  saveCostCodes?: FactoryInput<SaveCostCodesResult, SaveCostCodesResultOptions>;
}

export function newSaveFinishScheduleCostCodesData(
  data: SaveFinishScheduleCostCodesDataOptions,
): SaveFinishScheduleCostCodesMutation {
  return {
    __typename: "Mutation" as const,
    saveCostCodes: maybeNew("SaveCostCodesResult", data["saveCostCodes"] || undefined, {}),
  } as any;
}

export function newSaveFinishScheduleCostCodesResponse(
  variables: SaveFinishScheduleCostCodesMutationVariables,
  data: SaveFinishScheduleCostCodesDataOptions | Error,
): MockedResponse<SaveFinishScheduleCostCodesMutationVariables, SaveFinishScheduleCostCodesMutation> {
  return {
    request: { query: SaveFinishScheduleCostCodesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFinishScheduleCostCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFinishScheduleItemsDataOptions {
  saveItems?: FactoryInput<Item, ItemOptions>[];
}

export function newSaveFinishScheduleItemsData(
  data: SaveFinishScheduleItemsDataOptions,
): SaveFinishScheduleItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveItems: data["saveItems"]?.map((d) => maybeNew("Item", d, {})) || [],
  } as any;
}

export function newSaveFinishScheduleItemsResponse(
  variables: SaveFinishScheduleItemsMutationVariables,
  data: SaveFinishScheduleItemsDataOptions | Error,
): MockedResponse<SaveFinishScheduleItemsMutationVariables, SaveFinishScheduleItemsMutation> {
  return {
    request: { query: SaveFinishScheduleItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFinishScheduleItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleCostCodeDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newFinishScheduleCostCodeData(data: FinishScheduleCostCodeDataOptions): FinishScheduleCostCodeQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newFinishScheduleCostCodeResponse(
  variables: FinishScheduleCostCodeQueryVariables,
  data: FinishScheduleCostCodeDataOptions | Error,
): MockedResponse<FinishScheduleCostCodeQueryVariables, FinishScheduleCostCodeQuery> {
  return {
    request: { query: FinishScheduleCostCodeDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleCostCodeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFinishScheduleCostCodeDataOptions {
  saveCostCodes?: FactoryInput<SaveCostCodesResult, SaveCostCodesResultOptions>;
}

export function newSaveFinishScheduleCostCodeData(
  data: SaveFinishScheduleCostCodeDataOptions,
): SaveFinishScheduleCostCodeMutation {
  return {
    __typename: "Mutation" as const,
    saveCostCodes: maybeNew("SaveCostCodesResult", data["saveCostCodes"] || undefined, {}),
  } as any;
}

export function newSaveFinishScheduleCostCodeResponse(
  variables: SaveFinishScheduleCostCodeMutationVariables,
  data: SaveFinishScheduleCostCodeDataOptions | Error,
): MockedResponse<SaveFinishScheduleCostCodeMutationVariables, SaveFinishScheduleCostCodeMutation> {
  return {
    request: { query: SaveFinishScheduleCostCodeDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFinishScheduleCostCodeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AdminItemsDrawerDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
  allItems?: FactoryInput<Item, ItemOptions>[];
}

export function newAdminItemsDrawerData(data: AdminItemsDrawerDataOptions): AdminItemsDrawerQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    allItems: data["allItems"]?.map((d) => maybeNew("Item", d, {})) || [],
  } as any;
}

export function newAdminItemsDrawerResponse(
  variables: AdminItemsDrawerQueryVariables,
  data: AdminItemsDrawerDataOptions | Error,
): MockedResponse<AdminItemsDrawerQueryVariables, AdminItemsDrawerQuery> {
  return {
    request: { query: AdminItemsDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newAdminItemsDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemDimensionsDataOptions {
  saveItems?: FactoryInput<Item, ItemOptions>[];
}

export function newSaveItemDimensionsData(data: SaveItemDimensionsDataOptions): SaveItemDimensionsMutation {
  return {
    __typename: "Mutation" as const,
    saveItems: data["saveItems"]?.map((d) => maybeNew("Item", d, {})) || [],
  } as any;
}

export function newSaveItemDimensionsResponse(
  variables: SaveItemDimensionsMutationVariables,
  data: SaveItemDimensionsDataOptions | Error,
): MockedResponse<SaveItemDimensionsMutationVariables, SaveItemDimensionsMutation> {
  return {
    request: { query: SaveItemDimensionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemDimensionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemEditorTabMetadataDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newItemEditorTabMetadataData(data: ItemEditorTabMetadataDataOptions): ItemEditorTabMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newItemEditorTabMetadataResponse(
  data: ItemEditorTabMetadataDataOptions | Error,
): MockedResponse<ItemEditorTabMetadataQueryVariables, ItemEditorTabMetadataQuery> {
  return {
    request: { query: ItemEditorTabMetadataDocument },
    result: { data: data instanceof Error ? undefined : newItemEditorTabMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemEditorHistoryDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newItemEditorHistoryData(data: ItemEditorHistoryDataOptions): ItemEditorHistoryQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [] } as any;
}

export function newItemEditorHistoryResponse(
  variables: ItemEditorHistoryQueryVariables,
  data: ItemEditorHistoryDataOptions | Error,
): MockedResponse<ItemEditorHistoryQueryVariables, ItemEditorHistoryQuery> {
  return {
    request: { query: ItemEditorHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemEditorHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemsPageMetadataDataOptions {
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newItemsPageMetadataData(data: ItemsPageMetadataDataOptions): ItemsPageMetadataQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newItemsPageMetadataResponse(
  data: ItemsPageMetadataDataOptions | Error,
): MockedResponse<ItemsPageMetadataQueryVariables, ItemsPageMetadataQuery> {
  return {
    request: { query: ItemsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newItemsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemsDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
}

export function newItemsData(data: ItemsDataOptions): ItemsQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
  } as any;
}

export function newItemsResponse(
  variables: ItemsQueryVariables,
  data: ItemsDataOptions | Error,
): MockedResponse<ItemsQueryVariables, ItemsQuery> {
  return {
    request: { query: ItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemDataOptions {
  saveItems?: FactoryInput<Item, ItemOptions>[];
}

export function newSaveItemData(data: SaveItemDataOptions): SaveItemMutation {
  return {
    __typename: "Mutation" as const,
    saveItems: data["saveItems"]?.map((d) => maybeNew("Item", d, {})) || [],
  } as any;
}

export function newSaveItemResponse(
  variables: SaveItemMutationVariables,
  data: SaveItemDataOptions | Error,
): MockedResponse<SaveItemMutationVariables, SaveItemMutation> {
  return {
    request: { query: SaveItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TriggerQaDatabaseResetDataOptions {
  triggerQaDatabaseReset?: FactoryInput<TriggerQaDatabaseResetResult, TriggerQaDatabaseResetResultOptions>;
}

export function newTriggerQaDatabaseResetData(data: TriggerQaDatabaseResetDataOptions): TriggerQaDatabaseResetMutation {
  return {
    __typename: "Mutation" as const,
    triggerQaDatabaseReset: maybeNew("TriggerQaDatabaseResetResult", data["triggerQaDatabaseReset"] || undefined, {}),
  } as any;
}

export function newTriggerQaDatabaseResetResponse(
  data: TriggerQaDatabaseResetDataOptions | Error,
): MockedResponse<TriggerQaDatabaseResetMutationVariables, TriggerQaDatabaseResetMutation> {
  return {
    request: { query: TriggerQaDatabaseResetDocument },
    result: { data: data instanceof Error ? undefined : newTriggerQaDatabaseResetData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialLeadTimesEditorTabMetadataDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newMaterialLeadTimesEditorTabMetadataData(
  data: MaterialLeadTimesEditorTabMetadataDataOptions,
): MaterialLeadTimesEditorTabMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [] } as any;
}

export function newMaterialLeadTimesEditorTabMetadataResponse(
  data: MaterialLeadTimesEditorTabMetadataDataOptions | Error,
): MockedResponse<MaterialLeadTimesEditorTabMetadataQueryVariables, MaterialLeadTimesEditorTabMetadataQuery> {
  return {
    request: { query: MaterialLeadTimesEditorTabMetadataDocument },
    result: { data: data instanceof Error ? undefined : newMaterialLeadTimesEditorTabMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialLeadTimesEditorTabDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newMaterialLeadTimesEditorTabData(
  data: MaterialLeadTimesEditorTabDataOptions,
): MaterialLeadTimesEditorTabQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [] } as any;
}

export function newMaterialLeadTimesEditorTabResponse(
  variables: MaterialLeadTimesEditorTabQueryVariables,
  data: MaterialLeadTimesEditorTabDataOptions | Error,
): MockedResponse<MaterialLeadTimesEditorTabQueryVariables, MaterialLeadTimesEditorTabQuery> {
  return {
    request: { query: MaterialLeadTimesEditorTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialLeadTimesEditorTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AdminLocationsPageDataOptions {
  locations?: FactoryInput<Location, LocationOptions>[];
}

export function newAdminLocationsPageData(data: AdminLocationsPageDataOptions): AdminLocationsPageQuery {
  return {
    __typename: "Query" as const,
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newAdminLocationsPageResponse(
  variables: AdminLocationsPageQueryVariables,
  data: AdminLocationsPageDataOptions | Error,
): MockedResponse<AdminLocationsPageQueryVariables, AdminLocationsPageQuery> {
  return {
    request: { query: AdminLocationsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newAdminLocationsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsDataOptions {
  projectsPage?: FactoryInput<ProjectsPageResult, ProjectsPageResultOptions>;
}

export function newProjectsData(data: ProjectsDataOptions): ProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newProjectsResponse(
  variables: ProjectsQueryVariables,
  data: ProjectsDataOptions | Error,
): MockedResponse<ProjectsQueryVariables, ProjectsQuery> {
  return {
    request: { query: ProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AdminProjectsFilterDataDataOptions {
  projectFeatures?: FactoryInput<ProjectFeatureDetail, ProjectFeatureDetailOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newAdminProjectsFilterDataData(data: AdminProjectsFilterDataDataOptions): AdminProjectsFilterDataQuery {
  return {
    __typename: "Query" as const,
    projectFeatures: data["projectFeatures"]?.map((d) => maybeNew("ProjectFeatureDetail", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newAdminProjectsFilterDataResponse(
  data: AdminProjectsFilterDataDataOptions | Error,
): MockedResponse<AdminProjectsFilterDataQueryVariables, AdminProjectsFilterDataQuery> {
  return {
    request: { query: AdminProjectsFilterDataDocument },
    result: { data: data instanceof Error ? undefined : newAdminProjectsFilterDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetProjectIsTestDataOptions {
  saveProject?: FactoryInput<SaveProjectResult, SaveProjectResultOptions>;
}

export function newSetProjectIsTestData(data: SetProjectIsTestDataOptions): SetProjectIsTestMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSetProjectIsTestResponse(
  variables: SetProjectIsTestMutationVariables,
  data: SetProjectIsTestDataOptions | Error,
): MockedResponse<SetProjectIsTestMutationVariables, SetProjectIsTestMutation> {
  return {
    request: { query: SetProjectIsTestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetProjectIsTestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetQbCustomerIdDataOptions {
  saveProject?: FactoryInput<SaveProjectResult, SaveProjectResultOptions>;
}

export function newSetQbCustomerIdData(data: SetQbCustomerIdDataOptions): SetQbCustomerIdMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSetQbCustomerIdResponse(
  variables: SetQbCustomerIdMutationVariables,
  data: SetQbCustomerIdDataOptions | Error,
): MockedResponse<SetQbCustomerIdMutationVariables, SetQbCustomerIdMutation> {
  return {
    request: { query: SetQbCustomerIdDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetQbCustomerIdData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserGroupsDataOptions {
  userGroups?: FactoryInput<UserGroup, UserGroupOptions>[];
}

export function newUserGroupsData(data: UserGroupsDataOptions): UserGroupsQuery {
  return {
    __typename: "Query" as const,
    userGroups: data["userGroups"]?.map((d) => maybeNew("UserGroup", d, {})) || [],
  } as any;
}

export function newUserGroupsResponse(
  variables: UserGroupsQueryVariables,
  data: UserGroupsDataOptions | Error,
): MockedResponse<UserGroupsQueryVariables, UserGroupsQuery> {
  return {
    request: { query: UserGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserGroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserGroupsMetadataDataOptions {
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newUserGroupsMetadataData(data: UserGroupsMetadataDataOptions): UserGroupsMetadataQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newUserGroupsMetadataResponse(
  data: UserGroupsMetadataDataOptions | Error,
): MockedResponse<UserGroupsMetadataQueryVariables, UserGroupsMetadataQuery> {
  return {
    request: { query: UserGroupsMetadataDocument },
    result: { data: data instanceof Error ? undefined : newUserGroupsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveUserGroupDataOptions {
  saveUserGroup?: FactoryInput<SaveUserGroupResult, SaveUserGroupResultOptions>;
}

export function newSaveUserGroupData(data: SaveUserGroupDataOptions): SaveUserGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveUserGroup: maybeNew("SaveUserGroupResult", data["saveUserGroup"] || undefined, {}),
  } as any;
}

export function newSaveUserGroupResponse(
  variables: SaveUserGroupMutationVariables,
  data: SaveUserGroupDataOptions | Error,
): MockedResponse<SaveUserGroupMutationVariables, SaveUserGroupMutation> {
  return {
    request: { query: SaveUserGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveUserGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RemoveUserGroupDataOptions {
  removeUserGroup?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newRemoveUserGroupData(data: RemoveUserGroupDataOptions): RemoveUserGroupMutation {
  return {
    __typename: "Mutation" as const,
    removeUserGroup: maybeNew("EmptyResult", data["removeUserGroup"] || undefined, {}),
  } as any;
}

export function newRemoveUserGroupResponse(
  variables: RemoveUserGroupMutationVariables,
  data: RemoveUserGroupDataOptions | Error,
): MockedResponse<RemoveUserGroupMutationVariables, RemoveUserGroupMutation> {
  return {
    request: { query: RemoveUserGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newRemoveUserGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UsersPageDataOptions {
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newUsersPageData(data: UsersPageDataOptions): UsersPageQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newUsersPageResponse(
  data: UsersPageDataOptions | Error,
): MockedResponse<UsersPageQueryVariables, UsersPageQuery> {
  return {
    request: { query: UsersPageDocument },
    result: { data: data instanceof Error ? undefined : newUsersPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActivateUsersDataOptions {
  activateUsers?: FactoryInput<ActivateUsersResult, ActivateUsersResultOptions>;
}

export function newActivateUsersData(data: ActivateUsersDataOptions): ActivateUsersMutation {
  return {
    __typename: "Mutation" as const,
    activateUsers: maybeNew("ActivateUsersResult", data["activateUsers"] || undefined, {}),
  } as any;
}

export function newActivateUsersResponse(
  variables: ActivateUsersMutationVariables,
  data: ActivateUsersDataOptions | Error,
): MockedResponse<ActivateUsersMutationVariables, ActivateUsersMutation> {
  return {
    request: { query: ActivateUsersDocument, variables },
    result: { data: data instanceof Error ? undefined : newActivateUsersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeactivateUsersDataOptions {
  deactivateUsers?: FactoryInput<DeactivateUsersResult, DeactivateUsersResultOptions>;
}

export function newDeactivateUsersData(data: DeactivateUsersDataOptions): DeactivateUsersMutation {
  return {
    __typename: "Mutation" as const,
    deactivateUsers: maybeNew("DeactivateUsersResult", data["deactivateUsers"] || undefined, {}),
  } as any;
}

export function newDeactivateUsersResponse(
  variables: DeactivateUsersMutationVariables,
  data: DeactivateUsersDataOptions | Error,
): MockedResponse<DeactivateUsersMutationVariables, DeactivateUsersMutation> {
  return {
    request: { query: DeactivateUsersDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeactivateUsersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface StartInternalUserImpersonationDataOptions {
  saveInternalUser?: FactoryInput<SaveInternalUserResult, SaveInternalUserResultOptions>;
}

export function newStartInternalUserImpersonationData(
  data: StartInternalUserImpersonationDataOptions,
): StartInternalUserImpersonationMutation {
  return {
    __typename: "Mutation" as const,
    saveInternalUser: maybeNew("SaveInternalUserResult", data["saveInternalUser"] || undefined, {}),
  } as any;
}

export function newStartInternalUserImpersonationResponse(
  variables: StartInternalUserImpersonationMutationVariables,
  data: StartInternalUserImpersonationDataOptions | Error,
): MockedResponse<StartInternalUserImpersonationMutationVariables, StartInternalUserImpersonationMutation> {
  return {
    request: { query: StartInternalUserImpersonationDocument, variables },
    result: { data: data instanceof Error ? undefined : newStartInternalUserImpersonationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddBidPackagePage_OriginatingProjectDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newAddBidPackagePage_OriginatingProjectData(
  data: AddBidPackagePage_OriginatingProjectDataOptions,
): AddBidPackagePage_OriginatingProjectQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newAddBidPackagePage_OriginatingProjectResponse(
  variables: AddBidPackagePage_OriginatingProjectQueryVariables,
  data: AddBidPackagePage_OriginatingProjectDataOptions | Error,
): MockedResponse<AddBidPackagePage_OriginatingProjectQueryVariables, AddBidPackagePage_OriginatingProjectQuery> {
  return {
    request: { query: AddBidPackagePage_OriginatingProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddBidPackagePage_OriginatingProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddBidPackagePageDataOptions {
  bidPackageGroup?: FactoryInput<BidPackageGroup, BidPackageGroupOptions>;
}

export function newAddBidPackagePageData(data: AddBidPackagePageDataOptions): AddBidPackagePageQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroup: maybeNew("BidPackageGroup", data["bidPackageGroup"] || undefined, {}),
  } as any;
}

export function newAddBidPackagePageResponse(
  variables: AddBidPackagePageQueryVariables,
  data: AddBidPackagePageDataOptions | Error,
): MockedResponse<AddBidPackagePageQueryVariables, AddBidPackagePageQuery> {
  return {
    request: { query: AddBidPackagePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddBidPackagePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverlappingBidPackagesDataOptions {
  overlappingBidPackages?: FactoryInput<OverlappingBidPackagesResult, OverlappingBidPackagesResultOptions>;
}

export function newOverlappingBidPackagesData(data: OverlappingBidPackagesDataOptions): OverlappingBidPackagesQuery {
  return {
    __typename: "Query" as const,
    overlappingBidPackages: maybeNew("OverlappingBidPackagesResult", data["overlappingBidPackages"] || undefined, {}),
  } as any;
}

export function newOverlappingBidPackagesResponse(
  variables: OverlappingBidPackagesQueryVariables,
  data: OverlappingBidPackagesDataOptions | Error,
): MockedResponse<OverlappingBidPackagesQueryVariables, OverlappingBidPackagesQuery> {
  return {
    request: { query: OverlappingBidPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverlappingBidPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidPackagesDataOptions {
  saveBidPackages?: FactoryInput<SaveBidPackagesResult, SaveBidPackagesResultOptions>;
}

export function newSaveBidPackagesData(data: SaveBidPackagesDataOptions): SaveBidPackagesMutation {
  return {
    __typename: "Mutation" as const,
    saveBidPackages: maybeNew("SaveBidPackagesResult", data["saveBidPackages"] || undefined, {}),
  } as any;
}

export function newSaveBidPackagesResponse(
  variables: SaveBidPackagesMutationVariables,
  data: SaveBidPackagesDataOptions | Error,
): MockedResponse<SaveBidPackagesMutationVariables, SaveBidPackagesMutation> {
  return {
    request: { query: SaveBidPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackagesPageV2MetadataDataOptions {
  community?: FactoryInput<Community, CommunityOptions>;
  bidPackages?: FactoryInput<BidPackagesPageResult, BidPackagesPageResultOptions>;
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newBidPackagesPageV2MetadataData(
  data: BidPackagesPageV2MetadataDataOptions,
): BidPackagesPageV2MetadataQuery {
  return {
    __typename: "Query" as const,
    community: maybeNew("Community", data["community"] || undefined, {}),
    bidPackages: maybeNew("BidPackagesPageResult", data["bidPackages"] || undefined, {}),
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newBidPackagesPageV2MetadataResponse(
  variables: BidPackagesPageV2MetadataQueryVariables,
  data: BidPackagesPageV2MetadataDataOptions | Error,
): MockedResponse<BidPackagesPageV2MetadataQueryVariables, BidPackagesPageV2MetadataQuery> {
  return {
    request: { query: BidPackagesPageV2MetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackagesPageV2MetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBiddingCycleDataOptions {
  saveCommunity?: FactoryInput<SaveCommunityResult, SaveCommunityResultOptions>;
}

export function newSaveBiddingCycleData(data: SaveBiddingCycleDataOptions): SaveBiddingCycleMutation {
  return {
    __typename: "Mutation" as const,
    saveCommunity: maybeNew("SaveCommunityResult", data["saveCommunity"] || undefined, {}),
  } as any;
}

export function newSaveBiddingCycleResponse(
  variables: SaveBiddingCycleMutationVariables,
  data: SaveBiddingCycleDataOptions | Error,
): MockedResponse<SaveBiddingCycleMutationVariables, SaveBiddingCycleMutation> {
  return {
    request: { query: SaveBiddingCycleDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBiddingCycleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackagesPageV2DataOptions {
  costCodeBidSummaries?: FactoryInput<CostCodeBidSummariesPageResult, CostCodeBidSummariesPageResultOptions>;
}

export function newBidPackagesPageV2Data(data: BidPackagesPageV2DataOptions): BidPackagesPageV2Query {
  return {
    __typename: "Query" as const,
    costCodeBidSummaries: maybeNew("CostCodeBidSummariesPageResult", data["costCodeBidSummaries"] || undefined, {}),
  } as any;
}

export function newBidPackagesPageV2Response(
  variables: BidPackagesPageV2QueryVariables,
  data: BidPackagesPageV2DataOptions | Error,
): MockedResponse<BidPackagesPageV2QueryVariables, BidPackagesPageV2Query> {
  return {
    request: { query: BidPackagesPageV2Document, variables },
    result: { data: data instanceof Error ? undefined : newBidPackagesPageV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackagesPageV2CostCodeSummaryDataOptions {
  community?: FactoryInput<Community, CommunityOptions>;
}

export function newBidPackagesPageV2CostCodeSummaryData(
  data: BidPackagesPageV2CostCodeSummaryDataOptions,
): BidPackagesPageV2CostCodeSummaryQuery {
  return { __typename: "Query" as const, community: maybeNew("Community", data["community"] || undefined, {}) } as any;
}

export function newBidPackagesPageV2CostCodeSummaryResponse(
  variables: BidPackagesPageV2CostCodeSummaryQueryVariables,
  data: BidPackagesPageV2CostCodeSummaryDataOptions | Error,
): MockedResponse<BidPackagesPageV2CostCodeSummaryQueryVariables, BidPackagesPageV2CostCodeSummaryQuery> {
  return {
    request: { query: BidPackagesPageV2CostCodeSummaryDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackagesPageV2CostCodeSummaryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AwardBidModalDataOptions {
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newAwardBidModalData(data: AwardBidModalDataOptions): AwardBidModalQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newAwardBidModalResponse(
  variables: AwardBidModalQueryVariables,
  data: AwardBidModalDataOptions | Error,
): MockedResponse<AwardBidModalQueryVariables, AwardBidModalQuery> {
  return {
    request: { query: AwardBidModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAwardBidModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidPackageAwardsDataOptions {
  saveBidPackageAwards?: FactoryInput<SaveBidPackageAwardsResult, SaveBidPackageAwardsResultOptions>;
}

export function newSaveBidPackageAwardsData(data: SaveBidPackageAwardsDataOptions): SaveBidPackageAwardsMutation {
  return {
    __typename: "Mutation" as const,
    saveBidPackageAwards: maybeNew("SaveBidPackageAwardsResult", data["saveBidPackageAwards"] || undefined, {}),
  } as any;
}

export function newSaveBidPackageAwardsResponse(
  variables: SaveBidPackageAwardsMutationVariables,
  data: SaveBidPackageAwardsDataOptions | Error,
): MockedResponse<SaveBidPackageAwardsMutationVariables, SaveBidPackageAwardsMutation> {
  return {
    request: { query: SaveBidPackageAwardsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidPackageAwardsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddTradePartnerModalDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newAddTradePartnerModalData(data: AddTradePartnerModalDataOptions): AddTradePartnerModalQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newAddTradePartnerModalResponse(
  variables: AddTradePartnerModalQueryVariables,
  data: AddTradePartnerModalDataOptions | Error,
): MockedResponse<AddTradePartnerModalQueryVariables, AddTradePartnerModalQuery> {
  return {
    request: { query: AddTradePartnerModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddTradePartnerModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AcceptBidPackageUpdatesDataOptions {
  acceptBidPackageIncomingUpdates?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newAcceptBidPackageUpdatesData(
  data: AcceptBidPackageUpdatesDataOptions,
): AcceptBidPackageUpdatesMutation {
  return {
    __typename: "Mutation" as const,
    acceptBidPackageIncomingUpdates: maybeNew("BidPackage", data["acceptBidPackageIncomingUpdates"] || undefined, {}),
  } as any;
}

export function newAcceptBidPackageUpdatesResponse(
  variables: AcceptBidPackageUpdatesMutationVariables,
  data: AcceptBidPackageUpdatesDataOptions | Error,
): MockedResponse<AcceptBidPackageUpdatesMutationVariables, AcceptBidPackageUpdatesMutation> {
  return {
    request: { query: AcceptBidPackageUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAcceptBidPackageUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidUpdatesAvailable_BidPackageDataOptions {
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newBidUpdatesAvailable_BidPackageData(
  data: BidUpdatesAvailable_BidPackageDataOptions,
): BidUpdatesAvailable_BidPackageQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newBidUpdatesAvailable_BidPackageResponse(
  variables: BidUpdatesAvailable_BidPackageQueryVariables,
  data: BidUpdatesAvailable_BidPackageDataOptions | Error,
): MockedResponse<BidUpdatesAvailable_BidPackageQueryVariables, BidUpdatesAvailable_BidPackageQuery> {
  return {
    request: { query: BidUpdatesAvailable_BidPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidUpdatesAvailable_BidPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviseBidPackageCostsDataOptions {
  reviseBidPackageCosts?: FactoryInput<ReviseBidPackageCostsResult, ReviseBidPackageCostsResultOptions>;
}

export function newReviseBidPackageCostsData(data: ReviseBidPackageCostsDataOptions): ReviseBidPackageCostsMutation {
  return {
    __typename: "Mutation" as const,
    reviseBidPackageCosts: maybeNew("ReviseBidPackageCostsResult", data["reviseBidPackageCosts"] || undefined, {}),
  } as any;
}

export function newReviseBidPackageCostsResponse(
  variables: ReviseBidPackageCostsMutationVariables,
  data: ReviseBidPackageCostsDataOptions | Error,
): MockedResponse<ReviseBidPackageCostsMutationVariables, ReviseBidPackageCostsMutation> {
  return {
    request: { query: ReviseBidPackageCostsDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviseBidPackageCostsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillTermsTab_SaveBidContractRevisionDataOptions {
  saveBidContractRevision?: FactoryInput<SaveBidContractRevisionResult, SaveBidContractRevisionResultOptions>;
}

export function newBillTermsTab_SaveBidContractRevisionData(
  data: BillTermsTab_SaveBidContractRevisionDataOptions,
): BillTermsTab_SaveBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractRevision: maybeNew(
      "SaveBidContractRevisionResult",
      data["saveBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newBillTermsTab_SaveBidContractRevisionResponse(
  variables: BillTermsTab_SaveBidContractRevisionMutationVariables,
  data: BillTermsTab_SaveBidContractRevisionDataOptions | Error,
): MockedResponse<BillTermsTab_SaveBidContractRevisionMutationVariables, BillTermsTab_SaveBidContractRevisionMutation> {
  return {
    request: { query: BillTermsTab_SaveBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillTermsTab_SaveBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillTermsTab_BasePlanGlobalPlanTasksDataOptions {
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newBillTermsTab_BasePlanGlobalPlanTasksData(
  data: BillTermsTab_BasePlanGlobalPlanTasksDataOptions,
): BillTermsTab_BasePlanGlobalPlanTasksQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newBillTermsTab_BasePlanGlobalPlanTasksResponse(
  variables: BillTermsTab_BasePlanGlobalPlanTasksQueryVariables,
  data: BillTermsTab_BasePlanGlobalPlanTasksDataOptions | Error,
): MockedResponse<BillTermsTab_BasePlanGlobalPlanTasksQueryVariables, BillTermsTab_BasePlanGlobalPlanTasksQuery> {
  return {
    request: { query: BillTermsTab_BasePlanGlobalPlanTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillTermsTab_BasePlanGlobalPlanTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditBidPackageDetailsStepDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newEditBidPackageDetailsStepData(
  data: EditBidPackageDetailsStepDataOptions,
): EditBidPackageDetailsStepQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newEditBidPackageDetailsStepResponse(
  data: EditBidPackageDetailsStepDataOptions | Error,
): MockedResponse<EditBidPackageDetailsStepQueryVariables, EditBidPackageDetailsStepQuery> {
  return {
    request: { query: EditBidPackageDetailsStepDocument },
    result: { data: data instanceof Error ? undefined : newEditBidPackageDetailsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidPackageDataOptions {
  saveBidPackage?: FactoryInput<SaveBidPackageResult, SaveBidPackageResultOptions>;
}

export function newSaveBidPackageData(data: SaveBidPackageDataOptions): SaveBidPackageMutation {
  return {
    __typename: "Mutation" as const,
    saveBidPackage: maybeNew("SaveBidPackageResult", data["saveBidPackage"] || undefined, {}),
  } as any;
}

export function newSaveBidPackageResponse(
  variables: SaveBidPackageMutationVariables,
  data: SaveBidPackageDataOptions | Error,
): MockedResponse<SaveBidPackageMutationVariables, SaveBidPackageMutation> {
  return {
    request: { query: SaveBidPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidsTable_AggregateVersionsDataOptions {
  bidPackageVersion?: FactoryInput<BidPackageVersion, BidPackageVersionOptions>;
}

export function newPlanBasedBidsTable_AggregateVersionsData(
  data: PlanBasedBidsTable_AggregateVersionsDataOptions,
): PlanBasedBidsTable_AggregateVersionsQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
  } as any;
}

export function newPlanBasedBidsTable_AggregateVersionsResponse(
  variables: PlanBasedBidsTable_AggregateVersionsQueryVariables,
  data: PlanBasedBidsTable_AggregateVersionsDataOptions | Error,
): MockedResponse<PlanBasedBidsTable_AggregateVersionsQueryVariables, PlanBasedBidsTable_AggregateVersionsQuery> {
  return {
    request: { query: PlanBasedBidsTable_AggregateVersionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidsTable_AggregateVersionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidsTable_ScopeLinesDataOptions {
  bidPackageVersion?: FactoryInput<BidPackageVersion, BidPackageVersionOptions>;
  bidPackageVersionScopeLines?: FactoryInput<BidPackageScopeLine, BidPackageScopeLineOptions>[];
}

export function newPlanBasedBidsTable_ScopeLinesData(
  data: PlanBasedBidsTable_ScopeLinesDataOptions,
): PlanBasedBidsTable_ScopeLinesQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
    bidPackageVersionScopeLines:
      data["bidPackageVersionScopeLines"]?.map((d) => maybeNew("BidPackageScopeLine", d, {})) || [],
  } as any;
}

export function newPlanBasedBidsTable_ScopeLinesResponse(
  variables: PlanBasedBidsTable_ScopeLinesQueryVariables,
  data: PlanBasedBidsTable_ScopeLinesDataOptions | Error,
): MockedResponse<PlanBasedBidsTable_ScopeLinesQueryVariables, PlanBasedBidsTable_ScopeLinesQuery> {
  return {
    request: { query: PlanBasedBidsTable_ScopeLinesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidsTable_ScopeLinesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidsTable_ReadyPlanOptionsDataOptions {
  readyPlanOptions?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>[];
}

export function newPlanBasedBidsTable_ReadyPlanOptionsData(
  data: PlanBasedBidsTable_ReadyPlanOptionsDataOptions,
): PlanBasedBidsTable_ReadyPlanOptionsQuery {
  return {
    __typename: "Query" as const,
    readyPlanOptions: data["readyPlanOptions"]?.map((d) => maybeNew("ReadyPlanOption", d, {})) || [],
  } as any;
}

export function newPlanBasedBidsTable_ReadyPlanOptionsResponse(
  variables: PlanBasedBidsTable_ReadyPlanOptionsQueryVariables,
  data: PlanBasedBidsTable_ReadyPlanOptionsDataOptions | Error,
): MockedResponse<PlanBasedBidsTable_ReadyPlanOptionsQueryVariables, PlanBasedBidsTable_ReadyPlanOptionsQuery> {
  return {
    request: { query: PlanBasedBidsTable_ReadyPlanOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidsTable_ReadyPlanOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProrationBidContractRevisionDataOptions {
  saveBidContractRevision?: FactoryInput<SaveBidContractRevisionResult, SaveBidContractRevisionResultOptions>;
}

export function newAddProrationBidContractRevisionData(
  data: AddProrationBidContractRevisionDataOptions,
): AddProrationBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractRevision: maybeNew(
      "SaveBidContractRevisionResult",
      data["saveBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newAddProrationBidContractRevisionResponse(
  variables: AddProrationBidContractRevisionMutationVariables,
  data: AddProrationBidContractRevisionDataOptions | Error,
): MockedResponse<AddProrationBidContractRevisionMutationVariables, AddProrationBidContractRevisionMutation> {
  return {
    request: { query: AddProrationBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProrationBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProrationBidContractDataOptions {
  saveBidContract?: FactoryInput<SaveBidContractResult, SaveBidContractResultOptions>;
}

export function newAddProrationBidContractData(
  data: AddProrationBidContractDataOptions,
): AddProrationBidContractMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContract: maybeNew("SaveBidContractResult", data["saveBidContract"] || undefined, {}),
  } as any;
}

export function newAddProrationBidContractResponse(
  variables: AddProrationBidContractMutationVariables,
  data: AddProrationBidContractDataOptions | Error,
): MockedResponse<AddProrationBidContractMutationVariables, AddProrationBidContractMutation> {
  return {
    request: { query: AddProrationBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProrationBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProrationTradeLineItemsDataOptions {
  saveBidContractTradeLineItems?: FactoryInput<
    SaveBidContractTradeLineItemsResult,
    SaveBidContractTradeLineItemsResultOptions
  >;
}

export function newSaveProrationTradeLineItemsData(
  data: SaveProrationTradeLineItemsDataOptions,
): SaveProrationTradeLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractTradeLineItems: maybeNew(
      "SaveBidContractTradeLineItemsResult",
      data["saveBidContractTradeLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProrationTradeLineItemsResponse(
  variables: SaveProrationTradeLineItemsMutationVariables,
  data: SaveProrationTradeLineItemsDataOptions | Error,
): MockedResponse<SaveProrationTradeLineItemsMutationVariables, SaveProrationTradeLineItemsMutation> {
  return {
    request: { query: SaveProrationTradeLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProrationTradeLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditProratedBidRevisionDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newEditProratedBidRevisionData(data: EditProratedBidRevisionDataOptions): EditProratedBidRevisionQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newEditProratedBidRevisionResponse(
  variables: EditProratedBidRevisionQueryVariables,
  data: EditProratedBidRevisionDataOptions | Error,
): MockedResponse<EditProratedBidRevisionQueryVariables, EditProratedBidRevisionQuery> {
  return {
    request: { query: EditProratedBidRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditProratedBidRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewBidPackageIncomingUpdatesDataOptions {
  reviewBidPackageIncomingUpdates?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newReviewBidPackageIncomingUpdatesData(
  data: ReviewBidPackageIncomingUpdatesDataOptions,
): ReviewBidPackageIncomingUpdatesMutation {
  return {
    __typename: "Mutation" as const,
    reviewBidPackageIncomingUpdates: maybeNew("BidPackage", data["reviewBidPackageIncomingUpdates"] || undefined, {}),
  } as any;
}

export function newReviewBidPackageIncomingUpdatesResponse(
  variables: ReviewBidPackageIncomingUpdatesMutationVariables,
  data: ReviewBidPackageIncomingUpdatesDataOptions | Error,
): MockedResponse<ReviewBidPackageIncomingUpdatesMutationVariables, ReviewBidPackageIncomingUpdatesMutation> {
  return {
    request: { query: ReviewBidPackageIncomingUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewBidPackageIncomingUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UnitBasedBidsTableDataOptions {
  bidPackageVersion?: FactoryInput<BidPackageVersion, BidPackageVersionOptions>;
}

export function newUnitBasedBidsTableData(data: UnitBasedBidsTableDataOptions): UnitBasedBidsTableQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
  } as any;
}

export function newUnitBasedBidsTableResponse(
  variables: UnitBasedBidsTableQueryVariables,
  data: UnitBasedBidsTableDataOptions | Error,
): MockedResponse<UnitBasedBidsTableQueryVariables, UnitBasedBidsTableQuery> {
  return {
    request: { query: UnitBasedBidsTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newUnitBasedBidsTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AllConfigurationsDimensionsDataOptions {
  potentialBidPlanDimensions?: FactoryInput<PotentialBidPlanDimensionResult, PotentialBidPlanDimensionResultOptions>[];
}

export function newAllConfigurationsDimensionsData(
  data: AllConfigurationsDimensionsDataOptions,
): AllConfigurationsDimensionsQuery {
  return {
    __typename: "Query" as const,
    potentialBidPlanDimensions:
      data["potentialBidPlanDimensions"]?.map((d) => maybeNew("PotentialBidPlanDimensionResult", d, {})) || [],
  } as any;
}

export function newAllConfigurationsDimensionsResponse(
  variables: AllConfigurationsDimensionsQueryVariables,
  data: AllConfigurationsDimensionsDataOptions | Error,
): MockedResponse<AllConfigurationsDimensionsQueryVariables, AllConfigurationsDimensionsQuery> {
  return {
    request: { query: AllConfigurationsDimensionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAllConfigurationsDimensionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AllConfigurationsDataOptions {
  costConfigurationSummaries?: FactoryInput<CostConfigurationSummariesPage, CostConfigurationSummariesPageOptions>;
}

export function newAllConfigurationsData(data: AllConfigurationsDataOptions): AllConfigurationsQuery {
  return {
    __typename: "Query" as const,
    costConfigurationSummaries: maybeNew(
      "CostConfigurationSummariesPage",
      data["costConfigurationSummaries"] || undefined,
      {},
    ),
  } as any;
}

export function newAllConfigurationsResponse(
  variables: AllConfigurationsQueryVariables,
  data: AllConfigurationsDataOptions | Error,
): MockedResponse<AllConfigurationsQueryVariables, AllConfigurationsQuery> {
  return {
    request: { query: AllConfigurationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAllConfigurationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostAnalysisPageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newCostAnalysisPageData(data: CostAnalysisPageDataOptions): CostAnalysisPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newCostAnalysisPageResponse(
  variables: CostAnalysisPageQueryVariables,
  data: CostAnalysisPageDataOptions | Error,
): MockedResponse<CostAnalysisPageQueryVariables, CostAnalysisPageQuery> {
  return {
    request: { query: CostAnalysisPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostAnalysisPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EnterPlanBasedBidPageDataOptions {
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newEnterPlanBasedBidPageData(data: EnterPlanBasedBidPageDataOptions): EnterPlanBasedBidPageQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newEnterPlanBasedBidPageResponse(
  variables: EnterPlanBasedBidPageQueryVariables,
  data: EnterPlanBasedBidPageDataOptions | Error,
): MockedResponse<EnterPlanBasedBidPageQueryVariables, EnterPlanBasedBidPageQuery> {
  return {
    request: { query: EnterPlanBasedBidPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEnterPlanBasedBidPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EnterPlanBasedBidPage_SaveBidContractDataOptions {
  saveBidContract?: FactoryInput<SaveBidContractResult, SaveBidContractResultOptions>;
}

export function newEnterPlanBasedBidPage_SaveBidContractData(
  data: EnterPlanBasedBidPage_SaveBidContractDataOptions,
): EnterPlanBasedBidPage_SaveBidContractMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContract: maybeNew("SaveBidContractResult", data["saveBidContract"] || undefined, {}),
  } as any;
}

export function newEnterPlanBasedBidPage_SaveBidContractResponse(
  variables: EnterPlanBasedBidPage_SaveBidContractMutationVariables,
  data: EnterPlanBasedBidPage_SaveBidContractDataOptions | Error,
): MockedResponse<
  EnterPlanBasedBidPage_SaveBidContractMutationVariables,
  EnterPlanBasedBidPage_SaveBidContractMutation
> {
  return {
    request: { query: EnterPlanBasedBidPage_SaveBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newEnterPlanBasedBidPage_SaveBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidPackagePage_OriginatingProjectDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newPlanBasedBidPackagePage_OriginatingProjectData(
  data: PlanBasedBidPackagePage_OriginatingProjectDataOptions,
): PlanBasedBidPackagePage_OriginatingProjectQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newPlanBasedBidPackagePage_OriginatingProjectResponse(
  variables: PlanBasedBidPackagePage_OriginatingProjectQueryVariables,
  data: PlanBasedBidPackagePage_OriginatingProjectDataOptions | Error,
): MockedResponse<
  PlanBasedBidPackagePage_OriginatingProjectQueryVariables,
  PlanBasedBidPackagePage_OriginatingProjectQuery
> {
  return {
    request: { query: PlanBasedBidPackagePage_OriginatingProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidPackagePage_OriginatingProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidPackagePageDataOptions {
  bidPackageGroup?: FactoryInput<BidPackageGroup, BidPackageGroupOptions>;
}

export function newPlanBasedBidPackagePageData(data: PlanBasedBidPackagePageDataOptions): PlanBasedBidPackagePageQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroup: maybeNew("BidPackageGroup", data["bidPackageGroup"] || undefined, {}),
  } as any;
}

export function newPlanBasedBidPackagePageResponse(
  variables: PlanBasedBidPackagePageQueryVariables,
  data: PlanBasedBidPackagePageDataOptions | Error,
): MockedResponse<PlanBasedBidPackagePageQueryVariables, PlanBasedBidPackagePageQuery> {
  return {
    request: { query: PlanBasedBidPackagePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidPackagePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanBasedBidPackagesDataOptions {
  saveBidPackages?: FactoryInput<SaveBidPackagesResult, SaveBidPackagesResultOptions>;
}

export function newSavePlanBasedBidPackagesData(
  data: SavePlanBasedBidPackagesDataOptions,
): SavePlanBasedBidPackagesMutation {
  return {
    __typename: "Mutation" as const,
    saveBidPackages: maybeNew("SaveBidPackagesResult", data["saveBidPackages"] || undefined, {}),
  } as any;
}

export function newSavePlanBasedBidPackagesResponse(
  variables: SavePlanBasedBidPackagesMutationVariables,
  data: SavePlanBasedBidPackagesDataOptions | Error,
): MockedResponse<SavePlanBasedBidPackagesMutationVariables, SavePlanBasedBidPackagesMutation> {
  return {
    request: { query: SavePlanBasedBidPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanBasedBidPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PreviewSavePlanBasedBidPackageDataOptions {
  previewSaveBidPackage?: FactoryInput<PreviewSaveBidPackageResult, PreviewSaveBidPackageResultOptions>;
}

export function newPreviewSavePlanBasedBidPackageData(
  data: PreviewSavePlanBasedBidPackageDataOptions,
): PreviewSavePlanBasedBidPackageQuery {
  return {
    __typename: "Query" as const,
    previewSaveBidPackage: maybeNew("PreviewSaveBidPackageResult", data["previewSaveBidPackage"] || undefined, {}),
  } as any;
}

export function newPreviewSavePlanBasedBidPackageResponse(
  variables: PreviewSavePlanBasedBidPackageQueryVariables,
  data: PreviewSavePlanBasedBidPackageDataOptions | Error,
): MockedResponse<PreviewSavePlanBasedBidPackageQueryVariables, PreviewSavePlanBasedBidPackageQuery> {
  return {
    request: { query: PreviewSavePlanBasedBidPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPreviewSavePlanBasedBidPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OtherBillCellDataOptions {
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
}

export function newOtherBillCellData(data: OtherBillCellDataOptions): OtherBillCellQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newOtherBillCellResponse(
  variables: OtherBillCellQueryVariables,
  data: OtherBillCellDataOptions | Error,
): MockedResponse<OtherBillCellQueryVariables, OtherBillCellQuery> {
  return {
    request: { query: OtherBillCellDocument, variables },
    result: { data: data instanceof Error ? undefined : newOtherBillCellData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLienWaiverDocumentDataOptions {
  saveDocuments?: FactoryInput<SaveDocumentsResult, SaveDocumentsResultOptions>;
}

export function newSaveLienWaiverDocumentData(data: SaveLienWaiverDocumentDataOptions): SaveLienWaiverDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveLienWaiverDocumentResponse(
  variables: SaveLienWaiverDocumentMutationVariables,
  data: SaveLienWaiverDocumentDataOptions | Error,
): MockedResponse<SaveLienWaiverDocumentMutationVariables, SaveLienWaiverDocumentMutation> {
  return {
    request: { query: SaveLienWaiverDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLienWaiverDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalSuperDrawerDataOptions {
  approval?: FactoryInput<Approval, ApprovalOptions>;
  currentUser?: FactoryInput<User, UserOptions> | null;
}

export function newApprovalSuperDrawerData(data: ApprovalSuperDrawerDataOptions): ApprovalSuperDrawerQuery {
  return {
    __typename: "Query" as const,
    approval: maybeNew("Approval", data["approval"] || undefined, {}),
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newApprovalSuperDrawerResponse(
  variables: ApprovalSuperDrawerQueryVariables,
  data: ApprovalSuperDrawerDataOptions | Error,
): MockedResponse<ApprovalSuperDrawerQueryVariables, ApprovalSuperDrawerQuery> {
  return {
    request: { query: ApprovalSuperDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalSuperDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalSuperDrawer_SaveApprovalDataOptions {
  saveApproval?: FactoryInput<SaveApprovalResult, SaveApprovalResultOptions>;
}

export function newApprovalSuperDrawer_SaveApprovalData(
  data: ApprovalSuperDrawer_SaveApprovalDataOptions,
): ApprovalSuperDrawer_SaveApprovalMutation {
  return {
    __typename: "Mutation" as const,
    saveApproval: maybeNew("SaveApprovalResult", data["saveApproval"] || undefined, {}),
  } as any;
}

export function newApprovalSuperDrawer_SaveApprovalResponse(
  variables: ApprovalSuperDrawer_SaveApprovalMutationVariables,
  data: ApprovalSuperDrawer_SaveApprovalDataOptions | Error,
): MockedResponse<ApprovalSuperDrawer_SaveApprovalMutationVariables, ApprovalSuperDrawer_SaveApprovalMutation> {
  return {
    request: { query: ApprovalSuperDrawer_SaveApprovalDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalSuperDrawer_SaveApprovalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddCommitmentPotentialLineItemsDataOptions {
  developmentCommitmentPotentialLineItems?: FactoryInput<
    DevelopmentCommitmentPotentialLineItem,
    DevelopmentCommitmentPotentialLineItemOptions
  >[];
}

export function newAddCommitmentPotentialLineItemsData(
  data: AddCommitmentPotentialLineItemsDataOptions,
): AddCommitmentPotentialLineItemsQuery {
  return {
    __typename: "Query" as const,
    developmentCommitmentPotentialLineItems: data["developmentCommitmentPotentialLineItems"]?.map((d) =>
      maybeNew("DevelopmentCommitmentPotentialLineItem", d, {})
    ) || [],
  } as any;
}

export function newAddCommitmentPotentialLineItemsResponse(
  variables: AddCommitmentPotentialLineItemsQueryVariables,
  data: AddCommitmentPotentialLineItemsDataOptions | Error,
): MockedResponse<AddCommitmentPotentialLineItemsQueryVariables, AddCommitmentPotentialLineItemsQuery> {
  return {
    request: { query: AddCommitmentPotentialLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddCommitmentPotentialLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateDevelopmentCommitmentDataOptions {
  saveDevelopmentCommitment?: FactoryInput<SaveDevelopmentCommitmentResult, SaveDevelopmentCommitmentResultOptions>;
}

export function newUpdateDevelopmentCommitmentData(
  data: UpdateDevelopmentCommitmentDataOptions,
): UpdateDevelopmentCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentCommitment: maybeNew(
      "SaveDevelopmentCommitmentResult",
      data["saveDevelopmentCommitment"] || undefined,
      {},
    ),
  } as any;
}

export function newUpdateDevelopmentCommitmentResponse(
  variables: UpdateDevelopmentCommitmentMutationVariables,
  data: UpdateDevelopmentCommitmentDataOptions | Error,
): MockedResponse<UpdateDevelopmentCommitmentMutationVariables, UpdateDevelopmentCommitmentMutation> {
  return {
    request: { query: UpdateDevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCommitmentDataDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
  stages?: FactoryInput<StageDetail, StageDetailOptions>[];
  projects?: FactoryInput<Project, ProjectOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newCreateCommitmentDataData(data: CreateCommitmentDataDataOptions): CreateCommitmentDataQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
    stages: data["stages"]?.map((d) => maybeNew("StageDetail", d, {})) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newCreateCommitmentDataResponse(
  data: CreateCommitmentDataDataOptions | Error,
): MockedResponse<CreateCommitmentDataQueryVariables, CreateCommitmentDataQuery> {
  return {
    request: { query: CreateCommitmentDataDocument },
    result: { data: data instanceof Error ? undefined : newCreateCommitmentDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCommitmentPotentialLineItemsDataOptions {
  developmentCommitmentPotentialLineItems?: FactoryInput<
    DevelopmentCommitmentPotentialLineItem,
    DevelopmentCommitmentPotentialLineItemOptions
  >[];
}

export function newCreateCommitmentPotentialLineItemsData(
  data: CreateCommitmentPotentialLineItemsDataOptions,
): CreateCommitmentPotentialLineItemsQuery {
  return {
    __typename: "Query" as const,
    developmentCommitmentPotentialLineItems: data["developmentCommitmentPotentialLineItems"]?.map((d) =>
      maybeNew("DevelopmentCommitmentPotentialLineItem", d, {})
    ) || [],
  } as any;
}

export function newCreateCommitmentPotentialLineItemsResponse(
  variables: CreateCommitmentPotentialLineItemsQueryVariables,
  data: CreateCommitmentPotentialLineItemsDataOptions | Error,
): MockedResponse<CreateCommitmentPotentialLineItemsQueryVariables, CreateCommitmentPotentialLineItemsQuery> {
  return {
    request: { query: CreateCommitmentPotentialLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCommitmentPotentialLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateDevelopmentCommitmentDataOptions {
  saveDevelopmentCommitment?: FactoryInput<SaveDevelopmentCommitmentResult, SaveDevelopmentCommitmentResultOptions>;
}

export function newCreateDevelopmentCommitmentData(
  data: CreateDevelopmentCommitmentDataOptions,
): CreateDevelopmentCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentCommitment: maybeNew(
      "SaveDevelopmentCommitmentResult",
      data["saveDevelopmentCommitment"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateDevelopmentCommitmentResponse(
  variables: CreateDevelopmentCommitmentMutationVariables,
  data: CreateDevelopmentCommitmentDataOptions | Error,
): MockedResponse<CreateDevelopmentCommitmentMutationVariables, CreateDevelopmentCommitmentMutation> {
  return {
    request: { query: CreateDevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentHistoryTabDataOptions {
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>;
}

export function newDevelopmentCommitmentHistoryTabData(
  data: DevelopmentCommitmentHistoryTabDataOptions,
): DevelopmentCommitmentHistoryTabQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentHistoryTabResponse(
  variables: DevelopmentCommitmentHistoryTabQueryVariables,
  data: DevelopmentCommitmentHistoryTabDataOptions | Error,
): MockedResponse<DevelopmentCommitmentHistoryTabQueryVariables, DevelopmentCommitmentHistoryTabQuery> {
  return {
    request: { query: DevelopmentCommitmentHistoryTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentHistoryTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentOverviewTabDataOptions {
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>;
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newDevelopmentCommitmentOverviewTabData(
  data: DevelopmentCommitmentOverviewTabDataOptions,
): DevelopmentCommitmentOverviewTabQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newDevelopmentCommitmentOverviewTabResponse(
  variables: DevelopmentCommitmentOverviewTabQueryVariables,
  data: DevelopmentCommitmentOverviewTabDataOptions | Error,
): MockedResponse<DevelopmentCommitmentOverviewTabQueryVariables, DevelopmentCommitmentOverviewTabQuery> {
  return {
    request: { query: DevelopmentCommitmentOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDevelopmentCommitmentDataOptions {
  saveDevelopmentCommitment?: FactoryInput<SaveDevelopmentCommitmentResult, SaveDevelopmentCommitmentResultOptions>;
}

export function newSaveDevelopmentCommitmentData(
  data: SaveDevelopmentCommitmentDataOptions,
): SaveDevelopmentCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentCommitment: maybeNew(
      "SaveDevelopmentCommitmentResult",
      data["saveDevelopmentCommitment"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveDevelopmentCommitmentResponse(
  variables: SaveDevelopmentCommitmentMutationVariables,
  data: SaveDevelopmentCommitmentDataOptions | Error,
): MockedResponse<SaveDevelopmentCommitmentMutationVariables, SaveDevelopmentCommitmentMutation> {
  return {
    request: { query: SaveDevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentV2ProjectsTabDataOptions {
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>;
}

export function newDevelopmentCommitmentV2ProjectsTabData(
  data: DevelopmentCommitmentV2ProjectsTabDataOptions,
): DevelopmentCommitmentV2ProjectsTabQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentV2ProjectsTabResponse(
  variables: DevelopmentCommitmentV2ProjectsTabQueryVariables,
  data: DevelopmentCommitmentV2ProjectsTabDataOptions | Error,
): MockedResponse<DevelopmentCommitmentV2ProjectsTabQueryVariables, DevelopmentCommitmentV2ProjectsTabQuery> {
  return {
    request: { query: DevelopmentCommitmentV2ProjectsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentV2ProjectsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDevelopmentCommitmentProjectsAndCommitmentsDataOptions {
  deleteDevelopmentCommitmentProjectsAndCommitments?: FactoryInput<
    DeleteDevelopmentCommitmentProjectsAndCommitmentsResult,
    DeleteDevelopmentCommitmentProjectsAndCommitmentsResultOptions
  >;
}

export function newDeleteDevelopmentCommitmentProjectsAndCommitmentsData(
  data: DeleteDevelopmentCommitmentProjectsAndCommitmentsDataOptions,
): DeleteDevelopmentCommitmentProjectsAndCommitmentsMutation {
  return {
    __typename: "Mutation" as const,
    deleteDevelopmentCommitmentProjectsAndCommitments: maybeNew(
      "DeleteDevelopmentCommitmentProjectsAndCommitmentsResult",
      data["deleteDevelopmentCommitmentProjectsAndCommitments"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteDevelopmentCommitmentProjectsAndCommitmentsResponse(
  variables: DeleteDevelopmentCommitmentProjectsAndCommitmentsMutationVariables,
  data: DeleteDevelopmentCommitmentProjectsAndCommitmentsDataOptions | Error,
): MockedResponse<
  DeleteDevelopmentCommitmentProjectsAndCommitmentsMutationVariables,
  DeleteDevelopmentCommitmentProjectsAndCommitmentsMutation
> {
  return {
    request: { query: DeleteDevelopmentCommitmentProjectsAndCommitmentsDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newDeleteDevelopmentCommitmentProjectsAndCommitmentsData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentLineItemsDataOptions {
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>;
}

export function newDevelopmentCommitmentLineItemsData(
  data: DevelopmentCommitmentLineItemsDataOptions,
): DevelopmentCommitmentLineItemsQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentLineItemsResponse(
  variables: DevelopmentCommitmentLineItemsQueryVariables,
  data: DevelopmentCommitmentLineItemsDataOptions | Error,
): MockedResponse<DevelopmentCommitmentLineItemsQueryVariables, DevelopmentCommitmentLineItemsQuery> {
  return {
    request: { query: DevelopmentCommitmentLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCommitmentLineItemsDataOptions {
  deleteCommitmentLineItems?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteCommitmentLineItemsData(
  data: DeleteCommitmentLineItemsDataOptions,
): DeleteCommitmentLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    deleteCommitmentLineItems: maybeNew("EmptyResult", data["deleteCommitmentLineItems"] || undefined, {}),
  } as any;
}

export function newDeleteCommitmentLineItemsResponse(
  variables: DeleteCommitmentLineItemsMutationVariables,
  data: DeleteCommitmentLineItemsDataOptions | Error,
): MockedResponse<DeleteCommitmentLineItemsMutationVariables, DeleteCommitmentLineItemsMutation> {
  return {
    request: { query: DeleteCommitmentLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCommitmentLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentLineItemsDataOptions {
  saveCommitment?: FactoryInput<SaveCommitmentResult, SaveCommitmentResultOptions>;
}

export function newSaveCommitmentLineItemsData(
  data: SaveCommitmentLineItemsDataOptions,
): SaveCommitmentLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitment: maybeNew("SaveCommitmentResult", data["saveCommitment"] || undefined, {}),
  } as any;
}

export function newSaveCommitmentLineItemsResponse(
  variables: SaveCommitmentLineItemsMutationVariables,
  data: SaveCommitmentLineItemsDataOptions | Error,
): MockedResponse<SaveCommitmentLineItemsMutationVariables, SaveCommitmentLineItemsMutation> {
  return {
    request: { query: SaveCommitmentLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentScheduleAndScopeTabDataOptions {
  developmentCommitment?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>;
}

export function newDevelopmentCommitmentScheduleAndScopeTabData(
  data: DevelopmentCommitmentScheduleAndScopeTabDataOptions,
): DevelopmentCommitmentScheduleAndScopeTabQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentScheduleAndScopeTabResponse(
  variables: DevelopmentCommitmentScheduleAndScopeTabQueryVariables,
  data: DevelopmentCommitmentScheduleAndScopeTabDataOptions | Error,
): MockedResponse<
  DevelopmentCommitmentScheduleAndScopeTabQueryVariables,
  DevelopmentCommitmentScheduleAndScopeTabQuery
> {
  return {
    request: { query: DevelopmentCommitmentScheduleAndScopeTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentScheduleAndScopeTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AssignElevationListDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newAssignElevationListData(data: AssignElevationListDataOptions): AssignElevationListQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newAssignElevationListResponse(
  variables: AssignElevationListQueryVariables,
  data: AssignElevationListDataOptions | Error,
): MockedResponse<AssignElevationListQueryVariables, AssignElevationListQuery> {
  return {
    request: { query: AssignElevationListDocument, variables },
    result: { data: data instanceof Error ? undefined : newAssignElevationListData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveElevationAssignmentDataOptions {
  saveDevelopmentOptions?: FactoryInput<SaveDevelopmentOptionsResult, SaveDevelopmentOptionsResultOptions>;
}

export function newSaveElevationAssignmentData(
  data: SaveElevationAssignmentDataOptions,
): SaveElevationAssignmentMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentOptions: maybeNew("SaveDevelopmentOptionsResult", data["saveDevelopmentOptions"] || undefined, {}),
  } as any;
}

export function newSaveElevationAssignmentResponse(
  variables: SaveElevationAssignmentMutationVariables,
  data: SaveElevationAssignmentDataOptions | Error,
): MockedResponse<SaveElevationAssignmentMutationVariables, SaveElevationAssignmentMutation> {
  return {
    request: { query: SaveElevationAssignmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveElevationAssignmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateCostUpdatesDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newItemTemplateCostUpdatesData(data: ItemTemplateCostUpdatesDataOptions): ItemTemplateCostUpdatesQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newItemTemplateCostUpdatesResponse(
  variables: ItemTemplateCostUpdatesQueryVariables,
  data: ItemTemplateCostUpdatesDataOptions | Error,
): MockedResponse<ItemTemplateCostUpdatesQueryVariables, ItemTemplateCostUpdatesQuery> {
  return {
    request: { query: ItemTemplateCostUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateCostUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScheduleItemMappingPageDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newDevelopmentScheduleItemMappingPageData(
  data: DevelopmentScheduleItemMappingPageDataOptions,
): DevelopmentScheduleItemMappingPageQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentScheduleItemMappingPageResponse(
  variables: DevelopmentScheduleItemMappingPageQueryVariables,
  data: DevelopmentScheduleItemMappingPageDataOptions | Error,
): MockedResponse<DevelopmentScheduleItemMappingPageQueryVariables, DevelopmentScheduleItemMappingPageQuery> {
  return {
    request: { query: DevelopmentScheduleItemMappingPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScheduleItemMappingPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePriceAgreementDocumentDataOptions {
  saveDocuments?: FactoryInput<SaveDocumentsResult, SaveDocumentsResultOptions>;
}

export function newSavePriceAgreementDocumentData(
  data: SavePriceAgreementDocumentDataOptions,
): SavePriceAgreementDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSavePriceAgreementDocumentResponse(
  variables: SavePriceAgreementDocumentMutationVariables,
  data: SavePriceAgreementDocumentDataOptions | Error,
): MockedResponse<SavePriceAgreementDocumentMutationVariables, SavePriceAgreementDocumentMutation> {
  return {
    request: { query: SavePriceAgreementDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePriceAgreementDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSummaryChartsDataOptions {
  developmentLotSummaryCharts?:
    | FactoryInput<DevelopmentLotSummaryChartsResult, DevelopmentLotSummaryChartsResultOptions>
    | null;
}

export function newLotSummaryChartsData(data: LotSummaryChartsDataOptions): LotSummaryChartsQuery {
  return {
    __typename: "Query" as const,
    developmentLotSummaryCharts: maybeNewOrNull(
      "DevelopmentLotSummaryChartsResult",
      data["developmentLotSummaryCharts"] || undefined,
      {},
    ),
  } as any;
}

export function newLotSummaryChartsResponse(
  variables: LotSummaryChartsQueryVariables,
  data: LotSummaryChartsDataOptions | Error,
): MockedResponse<LotSummaryChartsQueryVariables, LotSummaryChartsQuery> {
  return {
    request: { query: LotSummaryChartsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSummaryChartsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReleasePOsStepDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newReleasePOsStepData(data: ReleasePOsStepDataOptions): ReleasePOsStepQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newReleasePOsStepResponse(
  variables: ReleasePOsStepQueryVariables,
  data: ReleasePOsStepDataOptions | Error,
): MockedResponse<ReleasePOsStepQueryVariables, ReleasePOsStepQuery> {
  return {
    request: { query: ReleasePOsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newReleasePOsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateCommitmentAutoReleaseStatusDataOptions {
  saveCommitments?: FactoryInput<SaveCommitmentsResult, SaveCommitmentsResultOptions>;
  releaseBidCommitments?: FactoryInput<CommitmentLike, CommitmentLikeOptions>[];
}

export function newUpdateCommitmentAutoReleaseStatusData(
  data: UpdateCommitmentAutoReleaseStatusDataOptions,
): UpdateCommitmentAutoReleaseStatusMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitments: maybeNew("SaveCommitmentsResult", data["saveCommitments"] || undefined, {}),
    releaseBidCommitments: data["releaseBidCommitments"]?.map((d) => maybeNew("CommitmentLike", d, {})) || [],
  } as any;
}

export function newUpdateCommitmentAutoReleaseStatusResponse(
  variables: UpdateCommitmentAutoReleaseStatusMutationVariables,
  data: UpdateCommitmentAutoReleaseStatusDataOptions | Error,
): MockedResponse<UpdateCommitmentAutoReleaseStatusMutationVariables, UpdateCommitmentAutoReleaseStatusMutation> {
  return {
    request: { query: UpdateCommitmentAutoReleaseStatusDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateCommitmentAutoReleaseStatusData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReadyPlansListDataOptions {
  readyPlans?: FactoryInput<ReadyPlan, ReadyPlanOptions>[];
}

export function newReadyPlansListData(data: ReadyPlansListDataOptions): ReadyPlansListQuery {
  return {
    __typename: "Query" as const,
    readyPlans: data["readyPlans"]?.map((d) => maybeNew("ReadyPlan", d, {})) || [],
  } as any;
}

export function newReadyPlansListResponse(
  variables: ReadyPlansListQueryVariables,
  data: ReadyPlansListDataOptions | Error,
): MockedResponse<ReadyPlansListQueryVariables, ReadyPlansListQuery> {
  return {
    request: { query: ReadyPlansListDocument, variables },
    result: { data: data instanceof Error ? undefined : newReadyPlansListData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReadyPlanPageMetadataDataOptions {
  readyPlans?: FactoryInput<ReadyPlan, ReadyPlanOptions>[];
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  globalOptionTags?: FactoryInput<GlobalOptionTag, GlobalOptionTagOptions>[];
  readyPlanStatuses?: FactoryInput<ReadyPlanStatusDetail, ReadyPlanStatusDetailOptions>[];
  currentUser?: FactoryInput<User, UserOptions> | null;
}

export function newReadyPlanPageMetadataData(data: ReadyPlanPageMetadataDataOptions): ReadyPlanPageMetadataQuery {
  return {
    __typename: "Query" as const,
    readyPlans: data["readyPlans"]?.map((d) => maybeNew("ReadyPlan", d, {})) || [],
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    globalOptionTags: data["globalOptionTags"]?.map((d) => maybeNew("GlobalOptionTag", d, {})) || [],
    readyPlanStatuses: data["readyPlanStatuses"]?.map((d) => maybeNew("ReadyPlanStatusDetail", d, {})) || [],
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newReadyPlanPageMetadataResponse(
  variables: ReadyPlanPageMetadataQueryVariables,
  data: ReadyPlanPageMetadataDataOptions | Error,
): MockedResponse<ReadyPlanPageMetadataQueryVariables, ReadyPlanPageMetadataQuery> {
  return {
    request: { query: ReadyPlanPageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newReadyPlanPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReadyPlanOptionsListDataOptions {
  readyPlanOptions?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>[];
}

export function newReadyPlanOptionsListData(data: ReadyPlanOptionsListDataOptions): ReadyPlanOptionsListQuery {
  return {
    __typename: "Query" as const,
    readyPlanOptions: data["readyPlanOptions"]?.map((d) => maybeNew("ReadyPlanOption", d, {})) || [],
  } as any;
}

export function newReadyPlanOptionsListResponse(
  variables: ReadyPlanOptionsListQueryVariables,
  data: ReadyPlanOptionsListDataOptions | Error,
): MockedResponse<ReadyPlanOptionsListQueryVariables, ReadyPlanOptionsListQuery> {
  return {
    request: { query: ReadyPlanOptionsListDocument, variables },
    result: { data: data instanceof Error ? undefined : newReadyPlanOptionsListData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanDataOptions {
  saveReadyPlan?: FactoryInput<SaveReadyPlanResult, SaveReadyPlanResultOptions>;
}

export function newSaveReadyPlanData(data: SaveReadyPlanDataOptions): SaveReadyPlanMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlan: maybeNew("SaveReadyPlanResult", data["saveReadyPlan"] || undefined, {}),
  } as any;
}

export function newSaveReadyPlanResponse(
  variables: SaveReadyPlanMutationVariables,
  data: SaveReadyPlanDataOptions | Error,
): MockedResponse<SaveReadyPlanMutationVariables, SaveReadyPlanMutation> {
  return {
    request: { query: SaveReadyPlanDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionsModalDataOptions {
  saveReadyPlanOptions?: FactoryInput<SaveReadyPlanOptionsResult, SaveReadyPlanOptionsResultOptions>;
}

export function newSaveReadyPlanOptionsModalData(
  data: SaveReadyPlanOptionsModalDataOptions,
): SaveReadyPlanOptionsModalMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptions: maybeNew("SaveReadyPlanOptionsResult", data["saveReadyPlanOptions"] || undefined, {}),
  } as any;
}

export function newSaveReadyPlanOptionsModalResponse(
  variables: SaveReadyPlanOptionsModalMutationVariables,
  data: SaveReadyPlanOptionsModalDataOptions | Error,
): MockedResponse<SaveReadyPlanOptionsModalMutationVariables, SaveReadyPlanOptionsModalMutation> {
  return {
    request: { query: SaveReadyPlanOptionsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddOptionsPageDataOptions {
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
}

export function newAddOptionsPageData(data: AddOptionsPageDataOptions): AddOptionsPageQuery {
  return {
    __typename: "Query" as const,
    readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}),
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
  } as any;
}

export function newAddOptionsPageResponse(
  variables: AddOptionsPageQueryVariables,
  data: AddOptionsPageDataOptions | Error,
): MockedResponse<AddOptionsPageQueryVariables, AddOptionsPageQuery> {
  return {
    request: { query: AddOptionsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddOptionsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddOptionsMetadataDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newAddOptionsMetadataData(data: AddOptionsMetadataDataOptions): AddOptionsMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newAddOptionsMetadataResponse(
  data: AddOptionsMetadataDataOptions | Error,
): MockedResponse<AddOptionsMetadataQueryVariables, AddOptionsMetadataQuery> {
  return {
    request: { query: AddOptionsMetadataDocument },
    result: { data: data instanceof Error ? undefined : newAddOptionsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionsDataOptions {
  saveReadyPlanOptions?: FactoryInput<SaveReadyPlanOptionsResult, SaveReadyPlanOptionsResultOptions>;
}

export function newSaveReadyPlanOptionsData(data: SaveReadyPlanOptionsDataOptions): SaveReadyPlanOptionsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptions: maybeNew("SaveReadyPlanOptionsResult", data["saveReadyPlanOptions"] || undefined, {}),
  } as any;
}

export function newSaveReadyPlanOptionsResponse(
  variables: SaveReadyPlanOptionsMutationVariables,
  data: SaveReadyPlanOptionsDataOptions | Error,
): MockedResponse<SaveReadyPlanOptionsMutationVariables, SaveReadyPlanOptionsMutation> {
  return {
    request: { query: SaveReadyPlanOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionProgramDataModificationDataOptions {
  saveReadyPlanOptionProgramDataModifications?: FactoryInput<
    SaveReadyPlanOptionProgramDataModificationsResult,
    SaveReadyPlanOptionProgramDataModificationsResultOptions
  >;
}

export function newSaveReadyPlanOptionProgramDataModificationData(
  data: SaveReadyPlanOptionProgramDataModificationDataOptions,
): SaveReadyPlanOptionProgramDataModificationMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptionProgramDataModifications: maybeNew(
      "SaveReadyPlanOptionProgramDataModificationsResult",
      data["saveReadyPlanOptionProgramDataModifications"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanOptionProgramDataModificationResponse(
  variables: SaveReadyPlanOptionProgramDataModificationMutationVariables,
  data: SaveReadyPlanOptionProgramDataModificationDataOptions | Error,
): MockedResponse<
  SaveReadyPlanOptionProgramDataModificationMutationVariables,
  SaveReadyPlanOptionProgramDataModificationMutation
> {
  return {
    request: { query: SaveReadyPlanOptionProgramDataModificationDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionProgramDataModificationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteReadyPlanOptionProgramDataModificationDataOptions {
  deleteReadyPlanOptionProgramDataModifications?: FactoryInput<
    DeleteReadyPlanOptionProgramDataModificationsResult,
    DeleteReadyPlanOptionProgramDataModificationsResultOptions
  >[];
}

export function newDeleteReadyPlanOptionProgramDataModificationData(
  data: DeleteReadyPlanOptionProgramDataModificationDataOptions,
): DeleteReadyPlanOptionProgramDataModificationMutation {
  return {
    __typename: "Mutation" as const,
    deleteReadyPlanOptionProgramDataModifications: data["deleteReadyPlanOptionProgramDataModifications"]?.map((d) =>
      maybeNew("DeleteReadyPlanOptionProgramDataModificationsResult", d, {})
    ) || [],
  } as any;
}

export function newDeleteReadyPlanOptionProgramDataModificationResponse(
  variables: DeleteReadyPlanOptionProgramDataModificationMutationVariables,
  data: DeleteReadyPlanOptionProgramDataModificationDataOptions | Error,
): MockedResponse<
  DeleteReadyPlanOptionProgramDataModificationMutationVariables,
  DeleteReadyPlanOptionProgramDataModificationMutation
> {
  return {
    request: { query: DeleteReadyPlanOptionProgramDataModificationDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteReadyPlanOptionProgramDataModificationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSummaryMetaDataDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newLotSummaryMetaDataData(data: LotSummaryMetaDataDataOptions): LotSummaryMetaDataQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newLotSummaryMetaDataResponse(
  variables: LotSummaryMetaDataQueryVariables,
  data: LotSummaryMetaDataDataOptions | Error,
): MockedResponse<LotSummaryMetaDataQueryVariables, LotSummaryMetaDataQuery> {
  return {
    request: { query: LotSummaryMetaDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSummaryMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SubscribeToSequenceSheetDataOptions {
  followSequenceSheet?: FactoryInput<FollowSequenceSheetResult, FollowSequenceSheetResultOptions>;
}

export function newSubscribeToSequenceSheetData(
  data: SubscribeToSequenceSheetDataOptions,
): SubscribeToSequenceSheetMutation {
  return {
    __typename: "Mutation" as const,
    followSequenceSheet: maybeNew("FollowSequenceSheetResult", data["followSequenceSheet"] || undefined, {}),
  } as any;
}

export function newSubscribeToSequenceSheetResponse(
  variables: SubscribeToSequenceSheetMutationVariables,
  data: SubscribeToSequenceSheetDataOptions | Error,
): MockedResponse<SubscribeToSequenceSheetMutationVariables, SubscribeToSequenceSheetMutation> {
  return {
    request: { query: SubscribeToSequenceSheetDocument, variables },
    result: { data: data instanceof Error ? undefined : newSubscribeToSequenceSheetData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractRevisionOverviewDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newBidContractRevisionOverviewData(
  data: BidContractRevisionOverviewDataOptions,
): BidContractRevisionOverviewQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractRevisionOverviewResponse(
  variables: BidContractRevisionOverviewQueryVariables,
  data: BidContractRevisionOverviewDataOptions | Error,
): MockedResponse<BidContractRevisionOverviewQueryVariables, BidContractRevisionOverviewQuery> {
  return {
    request: { query: BidContractRevisionOverviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractRevisionOverviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractRevisionLineItemsPageDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newBidContractRevisionLineItemsPageData(
  data: BidContractRevisionLineItemsPageDataOptions,
): BidContractRevisionLineItemsPageQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractRevisionLineItemsPageResponse(
  variables: BidContractRevisionLineItemsPageQueryVariables,
  data: BidContractRevisionLineItemsPageDataOptions | Error,
): MockedResponse<BidContractRevisionLineItemsPageQueryVariables, BidContractRevisionLineItemsPageQuery> {
  return {
    request: { query: BidContractRevisionLineItemsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractRevisionLineItemsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractLineItemDataOptions {
  saveBidContractLineItem?: FactoryInput<SaveBidContractLineItemResult, SaveBidContractLineItemResultOptions>;
}

export function newSaveBidContractLineItemData(
  data: SaveBidContractLineItemDataOptions,
): SaveBidContractLineItemMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractLineItem: maybeNew(
      "SaveBidContractLineItemResult",
      data["saveBidContractLineItem"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveBidContractLineItemResponse(
  variables: SaveBidContractLineItemMutationVariables,
  data: SaveBidContractLineItemDataOptions | Error,
): MockedResponse<SaveBidContractLineItemMutationVariables, SaveBidContractLineItemMutation> {
  return {
    request: { query: SaveBidContractLineItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractLineItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteBidContractLineItemsDataOptions {
  deleteBidContractLineItems?: FactoryInput<DeleteBidContractLineItemResult, DeleteBidContractLineItemResultOptions>;
}

export function newDeleteBidContractLineItemsData(
  data: DeleteBidContractLineItemsDataOptions,
): DeleteBidContractLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    deleteBidContractLineItems: maybeNew(
      "DeleteBidContractLineItemResult",
      data["deleteBidContractLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteBidContractLineItemsResponse(
  variables: DeleteBidContractLineItemsMutationVariables,
  data: DeleteBidContractLineItemsDataOptions | Error,
): MockedResponse<DeleteBidContractLineItemsMutationVariables, DeleteBidContractLineItemsMutation> {
  return {
    request: { query: DeleteBidContractLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteBidContractLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractLineItemsDataOptions {
  saveBidContractLineItems?: FactoryInput<SaveBidContractLineItemsResult, SaveBidContractLineItemsResultOptions>;
}

export function newSaveBidContractLineItemsData(
  data: SaveBidContractLineItemsDataOptions,
): SaveBidContractLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractLineItems: maybeNew(
      "SaveBidContractLineItemsResult",
      data["saveBidContractLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveBidContractLineItemsResponse(
  variables: SaveBidContractLineItemsMutationVariables,
  data: SaveBidContractLineItemsDataOptions | Error,
): MockedResponse<SaveBidContractLineItemsMutationVariables, SaveBidContractLineItemsMutation> {
  return {
    request: { query: SaveBidContractLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface VoidPOsStepDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newVoidPOsStepData(data: VoidPOsStepDataOptions): VoidPOsStepQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newVoidPOsStepResponse(
  variables: VoidPOsStepQueryVariables,
  data: VoidPOsStepDataOptions | Error,
): MockedResponse<VoidPOsStepQueryVariables, VoidPOsStepQuery> {
  return {
    request: { query: VoidPOsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newVoidPOsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractDataOptions {
  bidContract?: FactoryInput<BidContract, BidContractOptions>;
}

export function newBidContractData(data: BidContractDataOptions): BidContractQuery {
  return {
    __typename: "Query" as const,
    bidContract: maybeNew("BidContract", data["bidContract"] || undefined, {}),
  } as any;
}

export function newBidContractResponse(
  variables: BidContractQueryVariables,
  data: BidContractDataOptions | Error,
): MockedResponse<BidContractQueryVariables, BidContractQuery> {
  return {
    request: { query: BidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractDataOptions {
  saveBidContract?: FactoryInput<SaveBidContractResult, SaveBidContractResultOptions>;
}

export function newSaveBidContractData(data: SaveBidContractDataOptions): SaveBidContractMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContract: maybeNew("SaveBidContractResult", data["saveBidContract"] || undefined, {}),
  } as any;
}

export function newSaveBidContractResponse(
  variables: SaveBidContractMutationVariables,
  data: SaveBidContractDataOptions | Error,
): MockedResponse<SaveBidContractMutationVariables, SaveBidContractMutation> {
  return {
    request: { query: SaveBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractRevisionDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newBidContractRevisionData(data: BidContractRevisionDataOptions): BidContractRevisionQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractRevisionResponse(
  variables: BidContractRevisionQueryVariables,
  data: BidContractRevisionDataOptions | Error,
): MockedResponse<BidContractRevisionQueryVariables, BidContractRevisionQuery> {
  return {
    request: { query: BidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractRevisionDataOptions {
  saveBidContractRevision?: FactoryInput<SaveBidContractRevisionResult, SaveBidContractRevisionResultOptions>;
}

export function newSaveBidContractRevisionData(
  data: SaveBidContractRevisionDataOptions,
): SaveBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractRevision: maybeNew(
      "SaveBidContractRevisionResult",
      data["saveBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveBidContractRevisionResponse(
  variables: SaveBidContractRevisionMutationVariables,
  data: SaveBidContractRevisionDataOptions | Error,
): MockedResponse<SaveBidContractRevisionMutationVariables, SaveBidContractRevisionMutation> {
  return {
    request: { query: SaveBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InternallySignBidContractRevisionDataOptions {
  internallySignBidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newInternallySignBidContractRevisionData(
  data: InternallySignBidContractRevisionDataOptions,
): InternallySignBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    internallySignBidContractRevision: maybeNew(
      "BidContractRevision",
      data["internallySignBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newInternallySignBidContractRevisionResponse(
  variables: InternallySignBidContractRevisionMutationVariables,
  data: InternallySignBidContractRevisionDataOptions | Error,
): MockedResponse<InternallySignBidContractRevisionMutationVariables, InternallySignBidContractRevisionMutation> {
  return {
    request: { query: InternallySignBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newInternallySignBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteBidContractRevisionDataOptions {
  deleteBidContractRevision?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteBidContractRevisionData(
  data: DeleteBidContractRevisionDataOptions,
): DeleteBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    deleteBidContractRevision: maybeNew("EmptyResult", data["deleteBidContractRevision"] || undefined, {}),
  } as any;
}

export function newDeleteBidContractRevisionResponse(
  variables: DeleteBidContractRevisionMutationVariables,
  data: DeleteBidContractRevisionDataOptions | Error,
): MockedResponse<DeleteBidContractRevisionMutationVariables, DeleteBidContractRevisionMutation> {
  return {
    request: { query: DeleteBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentContractDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newDevelopmentContractData(data: DevelopmentContractDataOptions): DevelopmentContractQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentContractResponse(
  variables: DevelopmentContractQueryVariables,
  data: DevelopmentContractDataOptions | Error,
): MockedResponse<DevelopmentContractQueryVariables, DevelopmentContractQuery> {
  return {
    request: { query: DevelopmentContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentProcurementDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newDevelopmentProcurementData(data: DevelopmentProcurementDataOptions): DevelopmentProcurementQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentProcurementResponse(
  variables: DevelopmentProcurementQueryVariables,
  data: DevelopmentProcurementDataOptions | Error,
): MockedResponse<DevelopmentProcurementQueryVariables, DevelopmentProcurementQuery> {
  return {
    request: { query: DevelopmentProcurementDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentProcurementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ComputeProductOfferingConfigCostsDataOptions {
  computeProductOfferingConfigCosts?: FactoryInput<
    ComputeProductOfferingConfigCostsResult,
    ComputeProductOfferingConfigCostsResultOptions
  >;
}

export function newComputeProductOfferingConfigCostsData(
  data: ComputeProductOfferingConfigCostsDataOptions,
): ComputeProductOfferingConfigCostsQuery {
  return {
    __typename: "Query" as const,
    computeProductOfferingConfigCosts: maybeNew(
      "ComputeProductOfferingConfigCostsResult",
      data["computeProductOfferingConfigCosts"] || undefined,
      {},
    ),
  } as any;
}

export function newComputeProductOfferingConfigCostsResponse(
  variables: ComputeProductOfferingConfigCostsQueryVariables,
  data: ComputeProductOfferingConfigCostsDataOptions | Error,
): MockedResponse<ComputeProductOfferingConfigCostsQueryVariables, ComputeProductOfferingConfigCostsQuery> {
  return {
    request: { query: ComputeProductOfferingConfigCostsDocument, variables },
    result: { data: data instanceof Error ? undefined : newComputeProductOfferingConfigCostsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingCheckoutStartingConfigPageDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newProductOfferingCheckoutStartingConfigPageData(
  data: ProductOfferingCheckoutStartingConfigPageDataOptions,
): ProductOfferingCheckoutStartingConfigPageQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOfferingCheckoutStartingConfigPageResponse(
  variables: ProductOfferingCheckoutStartingConfigPageQueryVariables,
  data: ProductOfferingCheckoutStartingConfigPageDataOptions | Error,
): MockedResponse<
  ProductOfferingCheckoutStartingConfigPageQueryVariables,
  ProductOfferingCheckoutStartingConfigPageQuery
> {
  return {
    request: { query: ProductOfferingCheckoutStartingConfigPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingCheckoutStartingConfigPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingCheckoutStartingConfig_CalculatedConfigDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newProductOfferingCheckoutStartingConfig_CalculatedConfigData(
  data: ProductOfferingCheckoutStartingConfig_CalculatedConfigDataOptions,
): ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOfferingCheckoutStartingConfig_CalculatedConfigResponse(
  variables: ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables,
  data: ProductOfferingCheckoutStartingConfig_CalculatedConfigDataOptions | Error,
): MockedResponse<
  ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables,
  ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery
> {
  return {
    request: { query: ProductOfferingCheckoutStartingConfig_CalculatedConfigDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newProductOfferingCheckoutStartingConfig_CalculatedConfigData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingCheckoutStartingConfig_SaveDataOptions {
  saveProductOfferingStartingConfig?: FactoryInput<
    SaveProductOfferingStartingConfigResult,
    SaveProductOfferingStartingConfigResultOptions
  >;
}

export function newProductOfferingCheckoutStartingConfig_SaveData(
  data: ProductOfferingCheckoutStartingConfig_SaveDataOptions,
): ProductOfferingCheckoutStartingConfig_SaveMutation {
  return {
    __typename: "Mutation" as const,
    saveProductOfferingStartingConfig: maybeNew(
      "SaveProductOfferingStartingConfigResult",
      data["saveProductOfferingStartingConfig"] || undefined,
      {},
    ),
  } as any;
}

export function newProductOfferingCheckoutStartingConfig_SaveResponse(
  variables: ProductOfferingCheckoutStartingConfig_SaveMutationVariables,
  data: ProductOfferingCheckoutStartingConfig_SaveDataOptions | Error,
): MockedResponse<
  ProductOfferingCheckoutStartingConfig_SaveMutationVariables,
  ProductOfferingCheckoutStartingConfig_SaveMutation
> {
  return {
    request: { query: ProductOfferingCheckoutStartingConfig_SaveDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingCheckoutStartingConfig_SaveData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FilteredProjectsTableDataOptions {
  projectsPage?: FactoryInput<ProjectsPageResult, ProjectsPageResultOptions>;
}

export function newFilteredProjectsTableData(data: FilteredProjectsTableDataOptions): FilteredProjectsTableQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newFilteredProjectsTableResponse(
  variables: FilteredProjectsTableQueryVariables,
  data: FilteredProjectsTableDataOptions | Error,
): MockedResponse<FilteredProjectsTableQueryVariables, FilteredProjectsTableQuery> {
  return {
    request: { query: FilteredProjectsTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newFilteredProjectsTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingApplyToProjectDataOptions {
  applyProjectReadyPlanConfigs?: FactoryInput<
    ApplyProjectReadyPlanConfigsResult,
    ApplyProjectReadyPlanConfigsResultOptions
  >;
}

export function newProductOfferingApplyToProjectData(
  data: ProductOfferingApplyToProjectDataOptions,
): ProductOfferingApplyToProjectMutation {
  return {
    __typename: "Mutation" as const,
    applyProjectReadyPlanConfigs: maybeNew(
      "ApplyProjectReadyPlanConfigsResult",
      data["applyProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newProductOfferingApplyToProjectResponse(
  variables: ProductOfferingApplyToProjectMutationVariables,
  data: ProductOfferingApplyToProjectDataOptions | Error,
): MockedResponse<ProductOfferingApplyToProjectMutationVariables, ProductOfferingApplyToProjectMutation> {
  return {
    request: { query: ProductOfferingApplyToProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingApplyToProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingCostCalculatorMetaDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newProductOfferingCostCalculatorMetaData(
  data: ProductOfferingCostCalculatorMetaDataOptions,
): ProductOfferingCostCalculatorMetaQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOfferingCostCalculatorMetaResponse(
  variables: ProductOfferingCostCalculatorMetaQueryVariables,
  data: ProductOfferingCostCalculatorMetaDataOptions | Error,
): MockedResponse<ProductOfferingCostCalculatorMetaQueryVariables, ProductOfferingCostCalculatorMetaQuery> {
  return {
    request: { query: ProductOfferingCostCalculatorMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingCostCalculatorMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingCostCalculatorPage_ComputeDataOptions {
  computeReadyPlanCost?: FactoryInput<ComputeReadyPlanCostResult, ComputeReadyPlanCostResultOptions>;
}

export function newProductOfferingCostCalculatorPage_ComputeData(
  data: ProductOfferingCostCalculatorPage_ComputeDataOptions,
): ProductOfferingCostCalculatorPage_ComputeQuery {
  return {
    __typename: "Query" as const,
    computeReadyPlanCost: maybeNew("ComputeReadyPlanCostResult", data["computeReadyPlanCost"] || undefined, {}),
  } as any;
}

export function newProductOfferingCostCalculatorPage_ComputeResponse(
  variables: ProductOfferingCostCalculatorPage_ComputeQueryVariables,
  data: ProductOfferingCostCalculatorPage_ComputeDataOptions | Error,
): MockedResponse<
  ProductOfferingCostCalculatorPage_ComputeQueryVariables,
  ProductOfferingCostCalculatorPage_ComputeQuery
> {
  return {
    request: { query: ProductOfferingCostCalculatorPage_ComputeDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingCostCalculatorPage_ComputeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingCostCalculatorPage_CheckoutConfigDataOptions {
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions>;
}

export function newProductOfferingCostCalculatorPage_CheckoutConfigData(
  data: ProductOfferingCostCalculatorPage_CheckoutConfigDataOptions,
): ProductOfferingCostCalculatorPage_CheckoutConfigQuery {
  return {
    __typename: "Query" as const,
    checkoutConfig: maybeNew("CheckoutConfig", data["checkoutConfig"] || undefined, {}),
  } as any;
}

export function newProductOfferingCostCalculatorPage_CheckoutConfigResponse(
  variables: ProductOfferingCostCalculatorPage_CheckoutConfigQueryVariables,
  data: ProductOfferingCostCalculatorPage_CheckoutConfigDataOptions | Error,
): MockedResponse<
  ProductOfferingCostCalculatorPage_CheckoutConfigQueryVariables,
  ProductOfferingCostCalculatorPage_CheckoutConfigQuery
> {
  return {
    request: { query: ProductOfferingCostCalculatorPage_CheckoutConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingCostCalculatorPage_CheckoutConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingPageDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newProductOfferingPageData(data: ProductOfferingPageDataOptions): ProductOfferingPageQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOfferingPageResponse(
  variables: ProductOfferingPageQueryVariables,
  data: ProductOfferingPageDataOptions | Error,
): MockedResponse<ProductOfferingPageQueryVariables, ProductOfferingPageQuery> {
  return {
    request: { query: ProductOfferingPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOffering_SaveProductOfferingDataOptions {
  saveProductOffering?: FactoryInput<SaveProductOfferingResult, SaveProductOfferingResultOptions>;
}

export function newProductOffering_SaveProductOfferingData(
  data: ProductOffering_SaveProductOfferingDataOptions,
): ProductOffering_SaveProductOfferingMutation {
  return {
    __typename: "Mutation" as const,
    saveProductOffering: maybeNew("SaveProductOfferingResult", data["saveProductOffering"] || undefined, {}),
  } as any;
}

export function newProductOffering_SaveProductOfferingResponse(
  variables: ProductOffering_SaveProductOfferingMutationVariables,
  data: ProductOffering_SaveProductOfferingDataOptions | Error,
): MockedResponse<ProductOffering_SaveProductOfferingMutationVariables, ProductOffering_SaveProductOfferingMutation> {
  return {
    request: { query: ProductOffering_SaveProductOfferingDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOffering_SaveProductOfferingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOffering_PromoteToCheckoutDataOptions {
  promoteToCheckout?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newProductOffering_PromoteToCheckoutData(
  data: ProductOffering_PromoteToCheckoutDataOptions,
): ProductOffering_PromoteToCheckoutMutation {
  return {
    __typename: "Mutation" as const,
    promoteToCheckout: maybeNew("EmptyResult", data["promoteToCheckout"] || undefined, {}),
  } as any;
}

export function newProductOffering_PromoteToCheckoutResponse(
  variables: ProductOffering_PromoteToCheckoutMutationVariables,
  data: ProductOffering_PromoteToCheckoutDataOptions | Error,
): MockedResponse<ProductOffering_PromoteToCheckoutMutationVariables, ProductOffering_PromoteToCheckoutMutation> {
  return {
    request: { query: ProductOffering_PromoteToCheckoutDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOffering_PromoteToCheckoutData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOffering_RunCheckoutPricingReportDataOptions {
  runCheckoutPricingReport?: FactoryInput<RunCheckoutPricingReportResult, RunCheckoutPricingReportResultOptions>;
}

export function newProductOffering_RunCheckoutPricingReportData(
  data: ProductOffering_RunCheckoutPricingReportDataOptions,
): ProductOffering_RunCheckoutPricingReportMutation {
  return {
    __typename: "Mutation" as const,
    runCheckoutPricingReport: maybeNew(
      "RunCheckoutPricingReportResult",
      data["runCheckoutPricingReport"] || undefined,
      {},
    ),
  } as any;
}

export function newProductOffering_RunCheckoutPricingReportResponse(
  variables: ProductOffering_RunCheckoutPricingReportMutationVariables,
  data: ProductOffering_RunCheckoutPricingReportDataOptions | Error,
): MockedResponse<
  ProductOffering_RunCheckoutPricingReportMutationVariables,
  ProductOffering_RunCheckoutPricingReportMutation
> {
  return {
    request: { query: ProductOffering_RunCheckoutPricingReportDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOffering_RunCheckoutPricingReportData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOffering_InsideMapsPacketDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newProductOffering_InsideMapsPacketData(
  data: ProductOffering_InsideMapsPacketDataOptions,
): ProductOffering_InsideMapsPacketQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOffering_InsideMapsPacketResponse(
  variables: ProductOffering_InsideMapsPacketQueryVariables,
  data: ProductOffering_InsideMapsPacketDataOptions | Error,
): MockedResponse<ProductOffering_InsideMapsPacketQueryVariables, ProductOffering_InsideMapsPacketQuery> {
  return {
    request: { query: ProductOffering_InsideMapsPacketDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOffering_InsideMapsPacketData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingScopePageSideBarDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newProductOfferingScopePageSideBarData(
  data: ProductOfferingScopePageSideBarDataOptions,
): ProductOfferingScopePageSideBarQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOfferingScopePageSideBarResponse(
  variables: ProductOfferingScopePageSideBarQueryVariables,
  data: ProductOfferingScopePageSideBarDataOptions | Error,
): MockedResponse<ProductOfferingScopePageSideBarQueryVariables, ProductOfferingScopePageSideBarQuery> {
  return {
    request: { query: ProductOfferingScopePageSideBarDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingScopePageSideBarData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingScopeMetaDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newProductOfferingScopeMetaData(
  data: ProductOfferingScopeMetaDataOptions,
): ProductOfferingScopeMetaQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOfferingScopeMetaResponse(
  variables: ProductOfferingScopeMetaQueryVariables,
  data: ProductOfferingScopeMetaDataOptions | Error,
): MockedResponse<ProductOfferingScopeMetaQueryVariables, ProductOfferingScopeMetaQuery> {
  return {
    request: { query: ProductOfferingScopeMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingScopeMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingScopePageDataOptions {
  takeoffLineItemsPage?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newProductOfferingScopePageData(
  data: ProductOfferingScopePageDataOptions,
): ProductOfferingScopePageQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newProductOfferingScopePageResponse(
  variables: ProductOfferingScopePageQueryVariables,
  data: ProductOfferingScopePageDataOptions | Error,
): MockedResponse<ProductOfferingScopePageQueryVariables, ProductOfferingScopePageQuery> {
  return {
    request: { query: ProductOfferingScopePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingScopePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentPurchaseOrderDataOptions {
  commitmentsPage?: FactoryInput<CommitmentsPage, CommitmentsPageOptions>;
}

export function newDevelopmentPurchaseOrderData(
  data: DevelopmentPurchaseOrderDataOptions,
): DevelopmentPurchaseOrderQuery {
  return {
    __typename: "Query" as const,
    commitmentsPage: maybeNew("CommitmentsPage", data["commitmentsPage"] || undefined, {}),
  } as any;
}

export function newDevelopmentPurchaseOrderResponse(
  variables: DevelopmentPurchaseOrderQueryVariables,
  data: DevelopmentPurchaseOrderDataOptions | Error,
): MockedResponse<DevelopmentPurchaseOrderQueryVariables, DevelopmentPurchaseOrderQuery> {
  return {
    request: { query: DevelopmentPurchaseOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentPurchaseOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentPurchaseOrderFiltersDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newDevelopmentPurchaseOrderFiltersData(
  data: DevelopmentPurchaseOrderFiltersDataOptions,
): DevelopmentPurchaseOrderFiltersQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentPurchaseOrderFiltersResponse(
  variables: DevelopmentPurchaseOrderFiltersQueryVariables,
  data: DevelopmentPurchaseOrderFiltersDataOptions | Error,
): MockedResponse<DevelopmentPurchaseOrderFiltersQueryVariables, DevelopmentPurchaseOrderFiltersQuery> {
  return {
    request: { query: DevelopmentPurchaseOrderFiltersDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentPurchaseOrderFiltersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentsDataOptions {
  saveCommitments?: FactoryInput<SaveCommitmentsResult, SaveCommitmentsResultOptions>;
}

export function newSaveCommitmentsData(data: SaveCommitmentsDataOptions): SaveCommitmentsMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitments: maybeNew("SaveCommitmentsResult", data["saveCommitments"] || undefined, {}),
  } as any;
}

export function newSaveCommitmentsResponse(
  variables: SaveCommitmentsMutationVariables,
  data: SaveCommitmentsDataOptions | Error,
): MockedResponse<SaveCommitmentsMutationVariables, SaveCommitmentsMutation> {
  return {
    request: { query: SaveCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReassignPurchaseOrdersDataOptions {
  commitments?: FactoryInput<Commitment, CommitmentOptions>[];
}

export function newReassignPurchaseOrdersData(data: ReassignPurchaseOrdersDataOptions): ReassignPurchaseOrdersQuery {
  return {
    __typename: "Query" as const,
    commitments: data["commitments"]?.map((d) => maybeNew("Commitment", d, {})) || [],
  } as any;
}

export function newReassignPurchaseOrdersResponse(
  variables: ReassignPurchaseOrdersQueryVariables,
  data: ReassignPurchaseOrdersDataOptions | Error,
): MockedResponse<ReassignPurchaseOrdersQueryVariables, ReassignPurchaseOrdersQuery> {
  return {
    request: { query: ReassignPurchaseOrdersDocument, variables },
    result: { data: data instanceof Error ? undefined : newReassignPurchaseOrdersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReassignPurchaseOrdersDataOptions {
  saveBidToCommitments?: FactoryInput<SaveCommitmentsResult, SaveCommitmentsResultOptions>;
}

export function newSaveReassignPurchaseOrdersData(
  data: SaveReassignPurchaseOrdersDataOptions,
): SaveReassignPurchaseOrdersMutation {
  return {
    __typename: "Mutation" as const,
    saveBidToCommitments: maybeNew("SaveCommitmentsResult", data["saveBidToCommitments"] || undefined, {}),
  } as any;
}

export function newSaveReassignPurchaseOrdersResponse(
  variables: SaveReassignPurchaseOrdersMutationVariables,
  data: SaveReassignPurchaseOrdersDataOptions | Error,
): MockedResponse<SaveReassignPurchaseOrdersMutationVariables, SaveReassignPurchaseOrdersMutation> {
  return {
    request: { query: SaveReassignPurchaseOrdersDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReassignPurchaseOrdersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentBulkScheduleDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
  globalPhases?: FactoryInput<GlobalPhase, GlobalPhaseOptions>[];
  projects?: FactoryInput<Project, ProjectOptions>[];
  taskStatuses?: FactoryInput<TaskStatusDetail, TaskStatusDetailOptions>[];
}

export function newDevelopmentBulkScheduleData(data: DevelopmentBulkScheduleDataOptions): DevelopmentBulkScheduleQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    globalPhases: data["globalPhases"]?.map((d) => maybeNew("GlobalPhase", d, {})) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    taskStatuses: data["taskStatuses"]?.map((d) => maybeNew("TaskStatusDetail", d, {})) || [],
  } as any;
}

export function newDevelopmentBulkScheduleResponse(
  variables: DevelopmentBulkScheduleQueryVariables,
  data: DevelopmentBulkScheduleDataOptions | Error,
): MockedResponse<DevelopmentBulkScheduleQueryVariables, DevelopmentBulkScheduleQuery> {
  return {
    request: { query: DevelopmentBulkScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentBulkScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentBulkScheduleProjectsDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
  globalPhases?: FactoryInput<GlobalPhase, GlobalPhaseOptions>[];
}

export function newDevelopmentBulkScheduleProjectsData(
  data: DevelopmentBulkScheduleProjectsDataOptions,
): DevelopmentBulkScheduleProjectsQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    globalPhases: data["globalPhases"]?.map((d) => maybeNew("GlobalPhase", d, {})) || [],
  } as any;
}

export function newDevelopmentBulkScheduleProjectsResponse(
  variables: DevelopmentBulkScheduleProjectsQueryVariables,
  data: DevelopmentBulkScheduleProjectsDataOptions | Error,
): MockedResponse<DevelopmentBulkScheduleProjectsQueryVariables, DevelopmentBulkScheduleProjectsQuery> {
  return {
    request: { query: DevelopmentBulkScheduleProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentBulkScheduleProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksByPhasesDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newScheduleTasksByPhasesData(data: ScheduleTasksByPhasesDataOptions): ScheduleTasksByPhasesQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newScheduleTasksByPhasesResponse(
  variables: ScheduleTasksByPhasesQueryVariables,
  data: ScheduleTasksByPhasesDataOptions | Error,
): MockedResponse<ScheduleTasksByPhasesQueryVariables, ScheduleTasksByPhasesQuery> {
  return {
    request: { query: ScheduleTasksByPhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksByPhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentBulkScheduleSaveScheduleTaskDataOptions {
  saveScheduleTasks?: FactoryInput<SaveScheduleTasksResult, SaveScheduleTasksResultOptions>;
}

export function newDevelopmentBulkScheduleSaveScheduleTaskData(
  data: DevelopmentBulkScheduleSaveScheduleTaskDataOptions,
): DevelopmentBulkScheduleSaveScheduleTaskMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTasks: maybeNew("SaveScheduleTasksResult", data["saveScheduleTasks"] || undefined, {}),
  } as any;
}

export function newDevelopmentBulkScheduleSaveScheduleTaskResponse(
  variables: DevelopmentBulkScheduleSaveScheduleTaskMutationVariables,
  data: DevelopmentBulkScheduleSaveScheduleTaskDataOptions | Error,
): MockedResponse<
  DevelopmentBulkScheduleSaveScheduleTaskMutationVariables,
  DevelopmentBulkScheduleSaveScheduleTaskMutation
> {
  return {
    request: { query: DevelopmentBulkScheduleSaveScheduleTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentBulkScheduleSaveScheduleTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompletedMilestonesByProjectDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newCompletedMilestonesByProjectData(
  data: CompletedMilestonesByProjectDataOptions,
): CompletedMilestonesByProjectQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newCompletedMilestonesByProjectResponse(
  variables: CompletedMilestonesByProjectQueryVariables,
  data: CompletedMilestonesByProjectDataOptions | Error,
): MockedResponse<CompletedMilestonesByProjectQueryVariables, CompletedMilestonesByProjectQuery> {
  return {
    request: { query: CompletedMilestonesByProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompletedMilestonesByProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentTeamMembersDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
  projectRoleDetails?: FactoryInput<ProjectRoleDetail, ProjectRoleDetailOptions>[];
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newDevelopmentTeamMembersData(data: DevelopmentTeamMembersDataOptions): DevelopmentTeamMembersQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    projectRoleDetails: data["projectRoleDetails"]?.map((d) => maybeNew("ProjectRoleDetail", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newDevelopmentTeamMembersResponse(
  variables: DevelopmentTeamMembersQueryVariables,
  data: DevelopmentTeamMembersDataOptions | Error,
): MockedResponse<DevelopmentTeamMembersQueryVariables, DevelopmentTeamMembersQuery> {
  return {
    request: { query: DevelopmentTeamMembersDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentTeamMembersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateDevelopmentProjectRoleDataOptions {
  saveDevelopmentTeamMember?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newUpdateDevelopmentProjectRoleData(
  data: UpdateDevelopmentProjectRoleDataOptions,
): UpdateDevelopmentProjectRoleMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentTeamMember: maybeNew("EmptyResult", data["saveDevelopmentTeamMember"] || undefined, {}),
  } as any;
}

export function newUpdateDevelopmentProjectRoleResponse(
  variables: UpdateDevelopmentProjectRoleMutationVariables,
  data: UpdateDevelopmentProjectRoleDataOptions | Error,
): MockedResponse<UpdateDevelopmentProjectRoleMutationVariables, UpdateDevelopmentProjectRoleMutation> {
  return {
    request: { query: UpdateDevelopmentProjectRoleDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateDevelopmentProjectRoleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScopeTemplatePageDataOptions {
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newDevelopmentScopeTemplatePageData(
  data: DevelopmentScopeTemplatePageDataOptions,
): DevelopmentScopeTemplatePageQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newDevelopmentScopeTemplatePageResponse(
  variables: DevelopmentScopeTemplatePageQueryVariables,
  data: DevelopmentScopeTemplatePageDataOptions | Error,
): MockedResponse<DevelopmentScopeTemplatePageQueryVariables, DevelopmentScopeTemplatePageQuery> {
  return {
    request: { query: DevelopmentScopeTemplatePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScopeTemplatePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateNewItemTemplateVersionsDataOptions {
  createNewItemTemplateVersions?: FactoryInput<
    CreateNewItemTemplateVersionsResult,
    CreateNewItemTemplateVersionsResultOptions
  >;
}

export function newCreateNewItemTemplateVersionsData(
  data: CreateNewItemTemplateVersionsDataOptions,
): CreateNewItemTemplateVersionsMutation {
  return {
    __typename: "Mutation" as const,
    createNewItemTemplateVersions: maybeNew(
      "CreateNewItemTemplateVersionsResult",
      data["createNewItemTemplateVersions"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateNewItemTemplateVersionsResponse(
  variables: CreateNewItemTemplateVersionsMutationVariables,
  data: CreateNewItemTemplateVersionsDataOptions | Error,
): MockedResponse<CreateNewItemTemplateVersionsMutationVariables, CreateNewItemTemplateVersionsMutation> {
  return {
    request: { query: CreateNewItemTemplateVersionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateNewItemTemplateVersionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteItemTemplatesDataOptions {
  deleteItemTemplates?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteItemTemplatesData(data: DeleteItemTemplatesDataOptions): DeleteItemTemplatesMutation {
  return {
    __typename: "Mutation" as const,
    deleteItemTemplates: maybeNew("EmptyResult", data["deleteItemTemplates"] || undefined, {}),
  } as any;
}

export function newDeleteItemTemplatesResponse(
  variables: DeleteItemTemplatesMutationVariables,
  data: DeleteItemTemplatesDataOptions | Error,
): MockedResponse<DeleteItemTemplatesMutationVariables, DeleteItemTemplatesMutation> {
  return {
    request: { query: DeleteItemTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteItemTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InboxBellDataOptions {
  userRelevantCommentStreams?: FactoryInput<CommentStream, CommentStreamOptions>[];
}

export function newInboxBellData(data: InboxBellDataOptions): InboxBellQuery {
  return {
    __typename: "Query" as const,
    userRelevantCommentStreams: data["userRelevantCommentStreams"]?.map((d) => maybeNew("CommentStream", d, {})) || [],
  } as any;
}

export function newInboxBellResponse(
  variables: InboxBellQueryVariables,
  data: InboxBellDataOptions | Error,
): MockedResponse<InboxBellQueryVariables, InboxBellQuery> {
  return {
    request: { query: InboxBellDocument, variables },
    result: { data: data instanceof Error ? undefined : newInboxBellData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScopeTemplatesMetadataDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newDevelopmentScopeTemplatesMetadataData(
  data: DevelopmentScopeTemplatesMetadataDataOptions,
): DevelopmentScopeTemplatesMetadataQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentScopeTemplatesMetadataResponse(
  variables: DevelopmentScopeTemplatesMetadataQueryVariables,
  data: DevelopmentScopeTemplatesMetadataDataOptions | Error,
): MockedResponse<DevelopmentScopeTemplatesMetadataQueryVariables, DevelopmentScopeTemplatesMetadataQuery> {
  return {
    request: { query: DevelopmentScopeTemplatesMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScopeTemplatesMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScopeTemplatesDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newDevelopmentScopeTemplatesData(
  data: DevelopmentScopeTemplatesDataOptions,
): DevelopmentScopeTemplatesQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newDevelopmentScopeTemplatesResponse(
  variables: DevelopmentScopeTemplatesQueryVariables,
  data: DevelopmentScopeTemplatesDataOptions | Error,
): MockedResponse<DevelopmentScopeTemplatesQueryVariables, DevelopmentScopeTemplatesQuery> {
  return {
    request: { query: DevelopmentScopeTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScopeTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplateCostCalculatorPageDataOptions {
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newScopeTemplateCostCalculatorPageData(
  data: ScopeTemplateCostCalculatorPageDataOptions,
): ScopeTemplateCostCalculatorPageQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newScopeTemplateCostCalculatorPageResponse(
  variables: ScopeTemplateCostCalculatorPageQueryVariables,
  data: ScopeTemplateCostCalculatorPageDataOptions | Error,
): MockedResponse<ScopeTemplateCostCalculatorPageQueryVariables, ScopeTemplateCostCalculatorPageQuery> {
  return {
    request: { query: ScopeTemplateCostCalculatorPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplateCostCalculatorPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplateCostCalculatorPage_ComputeDataOptions {
  computeReadyPlanCost?: FactoryInput<ComputeReadyPlanCostResult, ComputeReadyPlanCostResultOptions>;
  computeProgramData?: FactoryInput<NewProgramData, NewProgramDataOptions>;
}

export function newScopeTemplateCostCalculatorPage_ComputeData(
  data: ScopeTemplateCostCalculatorPage_ComputeDataOptions,
): ScopeTemplateCostCalculatorPage_ComputeQuery {
  return {
    __typename: "Query" as const,
    computeReadyPlanCost: maybeNew("ComputeReadyPlanCostResult", data["computeReadyPlanCost"] || undefined, {}),
    computeProgramData: maybeNew("NewProgramData", data["computeProgramData"] || undefined, {}),
  } as any;
}

export function newScopeTemplateCostCalculatorPage_ComputeResponse(
  variables: ScopeTemplateCostCalculatorPage_ComputeQueryVariables,
  data: ScopeTemplateCostCalculatorPage_ComputeDataOptions | Error,
): MockedResponse<ScopeTemplateCostCalculatorPage_ComputeQueryVariables, ScopeTemplateCostCalculatorPage_ComputeQuery> {
  return {
    request: { query: ScopeTemplateCostCalculatorPage_ComputeDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplateCostCalculatorPage_ComputeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommentableInboxDataOptions {
  commentable?: FactoryInput<Commentable, CommentableOptions>;
}

export function newCommentableInboxData(data: CommentableInboxDataOptions): CommentableInboxQuery {
  return {
    __typename: "Query" as const,
    commentable: maybeNew("Commentable", data["commentable"] || undefined, {}),
  } as any;
}

export function newCommentableInboxResponse(
  variables: CommentableInboxQueryVariables,
  data: CommentableInboxDataOptions | Error,
): MockedResponse<CommentableInboxQueryVariables, CommentableInboxQuery> {
  return {
    request: { query: CommentableInboxDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommentableInboxData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommentStreamCommentsDataOptions {
  commentStream?: FactoryInput<CommentStream, CommentStreamOptions> | null;
}

export function newCommentStreamCommentsData(data: CommentStreamCommentsDataOptions): CommentStreamCommentsQuery {
  return {
    __typename: "Query" as const,
    commentStream: maybeNewOrNull("CommentStream", data["commentStream"] || undefined, {}),
  } as any;
}

export function newCommentStreamCommentsResponse(
  variables: CommentStreamCommentsQueryVariables,
  data: CommentStreamCommentsDataOptions | Error,
): MockedResponse<CommentStreamCommentsQueryVariables, CommentStreamCommentsQuery> {
  return {
    request: { query: CommentStreamCommentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommentStreamCommentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyDesignPackage_ReadyPlanLikeDataOptions {
  readyPlanLike2?: FactoryInput<ReadyPlanLike, ReadyPlanLikeOptions>;
}

export function newCopyDesignPackage_ReadyPlanLikeData(
  data: CopyDesignPackage_ReadyPlanLikeDataOptions,
): CopyDesignPackage_ReadyPlanLikeQuery {
  return {
    __typename: "Query" as const,
    readyPlanLike2: maybeNew("ReadyPlanLike", data["readyPlanLike2"] || undefined, {}),
  } as any;
}

export function newCopyDesignPackage_ReadyPlanLikeResponse(
  variables: CopyDesignPackage_ReadyPlanLikeQueryVariables,
  data: CopyDesignPackage_ReadyPlanLikeDataOptions | Error,
): MockedResponse<CopyDesignPackage_ReadyPlanLikeQueryVariables, CopyDesignPackage_ReadyPlanLikeQuery> {
  return {
    request: { query: CopyDesignPackage_ReadyPlanLikeDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyDesignPackage_ReadyPlanLikeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyDesignPackage_CopyDesignPackageDataOptions {
  copyDesignPackage?: FactoryInput<SaveDesignPackageResult, SaveDesignPackageResultOptions>;
}

export function newCopyDesignPackage_CopyDesignPackageData(
  data: CopyDesignPackage_CopyDesignPackageDataOptions,
): CopyDesignPackage_CopyDesignPackageMutation {
  return {
    __typename: "Mutation" as const,
    copyDesignPackage: maybeNew("SaveDesignPackageResult", data["copyDesignPackage"] || undefined, {}),
  } as any;
}

export function newCopyDesignPackage_CopyDesignPackageResponse(
  variables: CopyDesignPackage_CopyDesignPackageMutationVariables,
  data: CopyDesignPackage_CopyDesignPackageDataOptions | Error,
): MockedResponse<CopyDesignPackage_CopyDesignPackageMutationVariables, CopyDesignPackage_CopyDesignPackageMutation> {
  return {
    request: { query: CopyDesignPackage_CopyDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyDesignPackage_CopyDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalSearchModalDataOptions {
  globalSearch?: FactoryInput<GlobalSearchResult, GlobalSearchResultOptions>[];
}

export function newGlobalSearchModalData(data: GlobalSearchModalDataOptions): GlobalSearchModalQuery {
  return {
    __typename: "Query" as const,
    globalSearch: data["globalSearch"]?.map((d) => maybeNew("GlobalSearchResult", d, {})) || [],
  } as any;
}

export function newGlobalSearchModalResponse(
  variables: GlobalSearchModalQueryVariables,
  data: GlobalSearchModalDataOptions | Error,
): MockedResponse<GlobalSearchModalQueryVariables, GlobalSearchModalQuery> {
  return {
    request: { query: GlobalSearchModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalSearchModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignCatalogsTableDataOptions {
  designPackages?: FactoryInput<DesignPackagesPageResult, DesignPackagesPageResultOptions>;
}

export function newDesignCatalogsTableData(data: DesignCatalogsTableDataOptions): DesignCatalogsTableQuery {
  return {
    __typename: "Query" as const,
    designPackages: maybeNew("DesignPackagesPageResult", data["designPackages"] || undefined, {}),
  } as any;
}

export function newDesignCatalogsTableResponse(
  variables: DesignCatalogsTableQueryVariables,
  data: DesignCatalogsTableDataOptions | Error,
): MockedResponse<DesignCatalogsTableQueryVariables, DesignCatalogsTableQuery> {
  return {
    request: { query: DesignCatalogsTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignCatalogsTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OptionDrawerMetadataDataOptions {
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
  globalOptionGroups?: FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions>[];
}

export function newOptionDrawerMetadataData(data: OptionDrawerMetadataDataOptions): OptionDrawerMetadataQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
    globalOptionGroups: data["globalOptionGroups"]?.map((d) => maybeNew("GlobalOptionGroup", d, {})) || [],
  } as any;
}

export function newOptionDrawerMetadataResponse(
  data: OptionDrawerMetadataDataOptions | Error,
): MockedResponse<OptionDrawerMetadataQueryVariables, OptionDrawerMetadataQuery> {
  return {
    request: { query: OptionDrawerMetadataDocument },
    result: { data: data instanceof Error ? undefined : newOptionDrawerMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionDrawerDataOptions {
  globalOption?: FactoryInput<GlobalOption, GlobalOptionOptions>;
}

export function newGlobalOptionDrawerData(data: GlobalOptionDrawerDataOptions): GlobalOptionDrawerQuery {
  return {
    __typename: "Query" as const,
    globalOption: maybeNew("GlobalOption", data["globalOption"] || undefined, {}),
  } as any;
}

export function newGlobalOptionDrawerResponse(
  variables: GlobalOptionDrawerQueryVariables,
  data: GlobalOptionDrawerDataOptions | Error,
): MockedResponse<GlobalOptionDrawerQueryVariables, GlobalOptionDrawerQuery> {
  return {
    request: { query: GlobalOptionDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionsDrawerDataOptions {
  saveGlobalOptions?: FactoryInput<SaveGlobalOptionsResult, SaveGlobalOptionsResultOptions>;
}

export function newSaveGlobalOptionsDrawerData(
  data: SaveGlobalOptionsDrawerDataOptions,
): SaveGlobalOptionsDrawerMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptions: maybeNew("SaveGlobalOptionsResult", data["saveGlobalOptions"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionsDrawerResponse(
  variables: SaveGlobalOptionsDrawerMutationVariables,
  data: SaveGlobalOptionsDrawerDataOptions | Error,
): MockedResponse<SaveGlobalOptionsDrawerMutationVariables, SaveGlobalOptionsDrawerMutation> {
  return {
    request: { query: SaveGlobalOptionsDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionsDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionGroupDataOptions {
  saveGlobalOptionGroup?: FactoryInput<SaveGlobalOptionGroupResult, SaveGlobalOptionGroupResultOptions>;
}

export function newSaveGlobalOptionGroupData(data: SaveGlobalOptionGroupDataOptions): SaveGlobalOptionGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptionGroup: maybeNew("SaveGlobalOptionGroupResult", data["saveGlobalOptionGroup"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionGroupResponse(
  variables: SaveGlobalOptionGroupMutationVariables,
  data: SaveGlobalOptionGroupDataOptions | Error,
): MockedResponse<SaveGlobalOptionGroupMutationVariables, SaveGlobalOptionGroupMutation> {
  return {
    request: { query: SaveGlobalOptionGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsPageMetadataDataOptions {
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newGlobalOptionsPageMetadataData(
  data: GlobalOptionsPageMetadataDataOptions,
): GlobalOptionsPageMetadataQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newGlobalOptionsPageMetadataResponse(
  data: GlobalOptionsPageMetadataDataOptions | Error,
): MockedResponse<GlobalOptionsPageMetadataQueryVariables, GlobalOptionsPageMetadataQuery> {
  return {
    request: { query: GlobalOptionsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsDataOptions {
  globalOptions?: FactoryInput<GlobalOption, GlobalOptionOptions>[];
}

export function newGlobalOptionsData(data: GlobalOptionsDataOptions): GlobalOptionsQuery {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => maybeNew("GlobalOption", d, {})) || [],
  } as any;
}

export function newGlobalOptionsResponse(
  variables: GlobalOptionsQueryVariables,
  data: GlobalOptionsDataOptions | Error,
): MockedResponse<GlobalOptionsQueryVariables, GlobalOptionsQuery> {
  return {
    request: { query: GlobalOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsIdsDataOptions {
  globalOptions?: FactoryInput<GlobalOption, GlobalOptionOptions>[];
}

export function newGlobalOptionsIdsData(data: GlobalOptionsIdsDataOptions): GlobalOptionsIdsQuery {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => maybeNew("GlobalOption", d, {})) || [],
  } as any;
}

export function newGlobalOptionsIdsResponse(
  data: GlobalOptionsIdsDataOptions | Error,
): MockedResponse<GlobalOptionsIdsQueryVariables, GlobalOptionsIdsQuery> {
  return {
    request: { query: GlobalOptionsIdsDocument },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsIdsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionsDataOptions {
  saveGlobalOptions?: FactoryInput<SaveGlobalOptionsResult, SaveGlobalOptionsResultOptions>;
}

export function newSaveGlobalOptionsData(data: SaveGlobalOptionsDataOptions): SaveGlobalOptionsMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptions: maybeNew("SaveGlobalOptionsResult", data["saveGlobalOptions"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionsResponse(
  variables: SaveGlobalOptionsMutationVariables,
  data: SaveGlobalOptionsDataOptions | Error,
): MockedResponse<SaveGlobalOptionsMutationVariables, SaveGlobalOptionsMutation> {
  return {
    request: { query: SaveGlobalOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionFormDataOptions {
  globalOption?: FactoryInput<GlobalOption, GlobalOptionOptions>;
}

export function newGlobalOptionFormData(data: GlobalOptionFormDataOptions): GlobalOptionFormQuery {
  return {
    __typename: "Query" as const,
    globalOption: maybeNew("GlobalOption", data["globalOption"] || undefined, {}),
  } as any;
}

export function newGlobalOptionFormResponse(
  variables: GlobalOptionFormQueryVariables,
  data: GlobalOptionFormDataOptions | Error,
): MockedResponse<GlobalOptionFormQueryVariables, GlobalOptionFormQuery> {
  return {
    request: { query: GlobalOptionFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionFormTypesDataOptions {
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newGlobalOptionFormTypesData(data: GlobalOptionFormTypesDataOptions): GlobalOptionFormTypesQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
  } as any;
}

export function newGlobalOptionFormTypesResponse(
  data: GlobalOptionFormTypesDataOptions | Error,
): MockedResponse<GlobalOptionFormTypesQueryVariables, GlobalOptionFormTypesQuery> {
  return {
    request: { query: GlobalOptionFormTypesDocument },
    result: { data: data instanceof Error ? undefined : newGlobalOptionFormTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionFormDataOptions {
  saveGlobalOptions?: FactoryInput<SaveGlobalOptionsResult, SaveGlobalOptionsResultOptions>;
}

export function newSaveGlobalOptionFormData(data: SaveGlobalOptionFormDataOptions): SaveGlobalOptionFormMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptions: maybeNew("SaveGlobalOptionsResult", data["saveGlobalOptions"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionFormResponse(
  variables: SaveGlobalOptionFormMutationVariables,
  data: SaveGlobalOptionFormDataOptions | Error,
): MockedResponse<SaveGlobalOptionFormMutationVariables, SaveGlobalOptionFormMutation> {
  return {
    request: { query: SaveGlobalOptionFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemPageDataOptions {
  bidItems?: FactoryInput<BidItem, BidItemOptions>[];
}

export function newBidItemPageData(data: BidItemPageDataOptions): BidItemPageQuery {
  return {
    __typename: "Query" as const,
    bidItems: data["bidItems"]?.map((d) => maybeNew("BidItem", d, {})) || [],
  } as any;
}

export function newBidItemPageResponse(
  data: BidItemPageDataOptions | Error,
): MockedResponse<BidItemPageQueryVariables, BidItemPageQuery> {
  return {
    request: { query: BidItemPageDocument },
    result: { data: data instanceof Error ? undefined : newBidItemPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemPageOptionsDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
  costTypes?: FactoryInput<CostTypeDetail, CostTypeDetailOptions>[];
}

export function newBidItemPageOptionsData(data: BidItemPageOptionsDataOptions): BidItemPageOptionsQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
    costTypes: data["costTypes"]?.map((d) => maybeNew("CostTypeDetail", d, {})) || [],
  } as any;
}

export function newBidItemPageOptionsResponse(
  data: BidItemPageOptionsDataOptions | Error,
): MockedResponse<BidItemPageOptionsQueryVariables, BidItemPageOptionsQuery> {
  return {
    request: { query: BidItemPageOptionsDocument },
    result: { data: data instanceof Error ? undefined : newBidItemPageOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidItemDataOptions {
  saveBidItem?: FactoryInput<SaveBidItemResult, SaveBidItemResultOptions>;
}

export function newSaveBidItemData(data: SaveBidItemDataOptions): SaveBidItemMutation {
  return {
    __typename: "Mutation" as const,
    saveBidItem: maybeNew("SaveBidItemResult", data["saveBidItem"] || undefined, {}),
  } as any;
}

export function newSaveBidItemResponse(
  variables: SaveBidItemMutationVariables,
  data: SaveBidItemDataOptions | Error,
): MockedResponse<SaveBidItemMutationVariables, SaveBidItemMutation> {
  return {
    request: { query: SaveBidItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsPageV2MetadataDataOptions {
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
}

export function newGlobalOptionsPageV2MetadataData(
  data: GlobalOptionsPageV2MetadataDataOptions,
): GlobalOptionsPageV2MetadataQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
  } as any;
}

export function newGlobalOptionsPageV2MetadataResponse(
  data: GlobalOptionsPageV2MetadataDataOptions | Error,
): MockedResponse<GlobalOptionsPageV2MetadataQueryVariables, GlobalOptionsPageV2MetadataQuery> {
  return {
    request: { query: GlobalOptionsPageV2MetadataDocument },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsPageV2MetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsPageV2DataOptions {
  globalOptions?: FactoryInput<GlobalOption, GlobalOptionOptions>[];
}

export function newGlobalOptionsPageV2Data(data: GlobalOptionsPageV2DataOptions): GlobalOptionsPageV2Query {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => maybeNew("GlobalOption", d, {})) || [],
  } as any;
}

export function newGlobalOptionsPageV2Response(
  variables: GlobalOptionsPageV2QueryVariables,
  data: GlobalOptionsPageV2DataOptions | Error,
): MockedResponse<GlobalOptionsPageV2QueryVariables, GlobalOptionsPageV2Query> {
  return {
    request: { query: GlobalOptionsPageV2Document, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsPageV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionsPageV2DataOptions {
  saveGlobalOptions?: FactoryInput<SaveGlobalOptionsResult, SaveGlobalOptionsResultOptions>;
}

export function newSaveGlobalOptionsPageV2Data(
  data: SaveGlobalOptionsPageV2DataOptions,
): SaveGlobalOptionsPageV2Mutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptions: maybeNew("SaveGlobalOptionsResult", data["saveGlobalOptions"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionsPageV2Response(
  variables: SaveGlobalOptionsPageV2MutationVariables,
  data: SaveGlobalOptionsPageV2DataOptions | Error,
): MockedResponse<SaveGlobalOptionsPageV2MutationVariables, SaveGlobalOptionsPageV2Mutation> {
  return {
    request: { query: SaveGlobalOptionsPageV2Document, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionsPageV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidItemEstimateDataOptions {
  saveBidItemEstimate?: FactoryInput<SaveBidItemEstimateResult, SaveBidItemEstimateResultOptions>;
}

export function newSaveBidItemEstimateData(data: SaveBidItemEstimateDataOptions): SaveBidItemEstimateMutation {
  return {
    __typename: "Mutation" as const,
    saveBidItemEstimate: maybeNew("SaveBidItemEstimateResult", data["saveBidItemEstimate"] || undefined, {}),
  } as any;
}

export function newSaveBidItemEstimateResponse(
  variables: SaveBidItemEstimateMutationVariables,
  data: SaveBidItemEstimateDataOptions | Error,
): MockedResponse<SaveBidItemEstimateMutationVariables, SaveBidItemEstimateMutation> {
  return {
    request: { query: SaveBidItemEstimateDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidItemEstimateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidEstimateModalOptionsDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
}

export function newBidEstimateModalOptionsData(data: BidEstimateModalOptionsDataOptions): BidEstimateModalOptionsQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
  } as any;
}

export function newBidEstimateModalOptionsResponse(
  data: BidEstimateModalOptionsDataOptions | Error,
): MockedResponse<BidEstimateModalOptionsQueryVariables, BidEstimateModalOptionsQuery> {
  return {
    request: { query: BidEstimateModalOptionsDocument },
    result: { data: data instanceof Error ? undefined : newBidEstimateModalOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialCatalogListingsDataOptions {
  materialListings?: FactoryInput<MaterialListingsPage, MaterialListingsPageOptions>;
}

export function newMaterialCatalogListingsData(data: MaterialCatalogListingsDataOptions): MaterialCatalogListingsQuery {
  return {
    __typename: "Query" as const,
    materialListings: maybeNew("MaterialListingsPage", data["materialListings"] || undefined, {}),
  } as any;
}

export function newMaterialCatalogListingsResponse(
  variables: MaterialCatalogListingsQueryVariables,
  data: MaterialCatalogListingsDataOptions | Error,
): MockedResponse<MaterialCatalogListingsQueryVariables, MaterialCatalogListingsQuery> {
  return {
    request: { query: MaterialCatalogListingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialCatalogListingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialCatalogMetadataDataOptions {
  materialBrands?: FactoryInput<MaterialBrand, MaterialBrandOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
  materialVariantTags?: FactoryInput<MaterialVariantTag, MaterialVariantTagOptions>[];
}

export function newMaterialCatalogMetadataData(data: MaterialCatalogMetadataDataOptions): MaterialCatalogMetadataQuery {
  return {
    __typename: "Query" as const,
    materialBrands: data["materialBrands"]?.map((d) => maybeNew("MaterialBrand", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    materialVariantTags: data["materialVariantTags"]?.map((d) => maybeNew("MaterialVariantTag", d, {})) || [],
  } as any;
}

export function newMaterialCatalogMetadataResponse(
  data: MaterialCatalogMetadataDataOptions | Error,
): MockedResponse<MaterialCatalogMetadataQueryVariables, MaterialCatalogMetadataQuery> {
  return {
    request: { query: MaterialCatalogMetadataDocument },
    result: { data: data instanceof Error ? undefined : newMaterialCatalogMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMaterialVariantDataOptions {
  saveMaterialVariant?: FactoryInput<SaveMaterialVariantResult, SaveMaterialVariantResultOptions>;
}

export function newSaveMaterialVariantData(data: SaveMaterialVariantDataOptions): SaveMaterialVariantMutation {
  return {
    __typename: "Mutation" as const,
    saveMaterialVariant: maybeNew("SaveMaterialVariantResult", data["saveMaterialVariant"] || undefined, {}),
  } as any;
}

export function newSaveMaterialVariantResponse(
  variables: SaveMaterialVariantMutationVariables,
  data: SaveMaterialVariantDataOptions | Error,
): MockedResponse<SaveMaterialVariantMutationVariables, SaveMaterialVariantMutation> {
  return {
    request: { query: SaveMaterialVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMaterialVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMavDataOptions {
  saveMaterialAttributeValue?: FactoryInput<SaveMaterialAttributeValueResult, SaveMaterialAttributeValueResultOptions>;
}

export function newSaveMavData(data: SaveMavDataOptions): SaveMavMutation {
  return {
    __typename: "Mutation" as const,
    saveMaterialAttributeValue: maybeNew(
      "SaveMaterialAttributeValueResult",
      data["saveMaterialAttributeValue"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveMavResponse(
  variables: SaveMavMutationVariables,
  data: SaveMavDataOptions | Error,
): MockedResponse<SaveMavMutationVariables, SaveMavMutation> {
  return {
    request: { query: SaveMavDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMavData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMaterialBrandDataOptions {
  saveMaterialBrand?: FactoryInput<SaveMaterialBrandResult, SaveMaterialBrandResultOptions>;
}

export function newSaveMaterialBrandData(data: SaveMaterialBrandDataOptions): SaveMaterialBrandMutation {
  return {
    __typename: "Mutation" as const,
    saveMaterialBrand: maybeNew("SaveMaterialBrandResult", data["saveMaterialBrand"] || undefined, {}),
  } as any;
}

export function newSaveMaterialBrandResponse(
  variables: SaveMaterialBrandMutationVariables,
  data: SaveMaterialBrandDataOptions | Error,
): MockedResponse<SaveMaterialBrandMutationVariables, SaveMaterialBrandMutation> {
  return {
    request: { query: SaveMaterialBrandDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMaterialBrandData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialCostPageDataOptions {
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  materialVariantCostSources?: FactoryInput<MaterialVariantCostSourcesPage, MaterialVariantCostSourcesPageOptions>;
}

export function newMaterialCostPageData(data: MaterialCostPageDataOptions): MaterialCostPageQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
    materialVariantCostSources: maybeNew(
      "MaterialVariantCostSourcesPage",
      data["materialVariantCostSources"] || undefined,
      {},
    ),
  } as any;
}

export function newMaterialCostPageResponse(
  variables: MaterialCostPageQueryVariables,
  data: MaterialCostPageDataOptions | Error,
): MockedResponse<MaterialCostPageQueryVariables, MaterialCostPageQuery> {
  return {
    request: { query: MaterialCostPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialCostPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemCatalogDataOptions {
  bidItemsPage?: FactoryInput<BidItemsPage, BidItemsPageOptions>;
}

export function newItemCatalogData(data: ItemCatalogDataOptions): ItemCatalogQuery {
  return {
    __typename: "Query" as const,
    bidItemsPage: maybeNew("BidItemsPage", data["bidItemsPage"] || undefined, {}),
  } as any;
}

export function newItemCatalogResponse(
  variables: ItemCatalogQueryVariables,
  data: ItemCatalogDataOptions | Error,
): MockedResponse<ItemCatalogQueryVariables, ItemCatalogQuery> {
  return {
    request: { query: ItemCatalogDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemCatalogData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialCatalogFilterMetadataDataOptions {
  materialBrands?: FactoryInput<MaterialBrand, MaterialBrandOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
  materialVariantTags?: FactoryInput<MaterialVariantTag, MaterialVariantTagOptions>[];
}

export function newMaterialCatalogFilterMetadataData(
  data: MaterialCatalogFilterMetadataDataOptions,
): MaterialCatalogFilterMetadataQuery {
  return {
    __typename: "Query" as const,
    materialBrands: data["materialBrands"]?.map((d) => maybeNew("MaterialBrand", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    materialVariantTags: data["materialVariantTags"]?.map((d) => maybeNew("MaterialVariantTag", d, {})) || [],
  } as any;
}

export function newMaterialCatalogFilterMetadataResponse(
  data: MaterialCatalogFilterMetadataDataOptions | Error,
): MockedResponse<MaterialCatalogFilterMetadataQueryVariables, MaterialCatalogFilterMetadataQuery> {
  return {
    request: { query: MaterialCatalogFilterMetadataDocument },
    result: { data: data instanceof Error ? undefined : newMaterialCatalogFilterMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialCatalogFilterDimensionsDataOptions {
  materialAttributeDimensions?: FactoryInput<MaterialAttributeDimension, MaterialAttributeDimensionOptions>[];
}

export function newMaterialCatalogFilterDimensionsData(
  data: MaterialCatalogFilterDimensionsDataOptions,
): MaterialCatalogFilterDimensionsQuery {
  return {
    __typename: "Query" as const,
    materialAttributeDimensions:
      data["materialAttributeDimensions"]?.map((d) => maybeNew("MaterialAttributeDimension", d, {})) || [],
  } as any;
}

export function newMaterialCatalogFilterDimensionsResponse(
  variables: MaterialCatalogFilterDimensionsQueryVariables,
  data: MaterialCatalogFilterDimensionsDataOptions | Error,
): MockedResponse<MaterialCatalogFilterDimensionsQueryVariables, MaterialCatalogFilterDimensionsQuery> {
  return {
    request: { query: MaterialCatalogFilterDimensionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialCatalogFilterDimensionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MilestoneCatalogFormDataOptions {
  globalPlanMilestone?: FactoryInput<GlobalPlanMilestone, GlobalPlanMilestoneOptions>;
}

export function newMilestoneCatalogFormData(data: MilestoneCatalogFormDataOptions): MilestoneCatalogFormQuery {
  return {
    __typename: "Query" as const,
    globalPlanMilestone: maybeNew("GlobalPlanMilestone", data["globalPlanMilestone"] || undefined, {}),
  } as any;
}

export function newMilestoneCatalogFormResponse(
  variables: MilestoneCatalogFormQueryVariables,
  data: MilestoneCatalogFormDataOptions | Error,
): MockedResponse<MilestoneCatalogFormQueryVariables, MilestoneCatalogFormQuery> {
  return {
    request: { query: MilestoneCatalogFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newMilestoneCatalogFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MilestoneCatalogFormDropdownDataOptions {
  globalPlanMilestoneGroups?: FactoryInput<GlobalPlanMilestoneGroup, GlobalPlanMilestoneGroupOptions>[];
  globalPlanConstraintItems?: FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>[];
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newMilestoneCatalogFormDropdownData(
  data: MilestoneCatalogFormDropdownDataOptions,
): MilestoneCatalogFormDropdownQuery {
  return {
    __typename: "Query" as const,
    globalPlanMilestoneGroups:
      data["globalPlanMilestoneGroups"]?.map((d) => maybeNew("GlobalPlanMilestoneGroup", d, {})) || [],
    globalPlanConstraintItems:
      data["globalPlanConstraintItems"]?.map((d) => maybeNew("GlobalPlanConstraintItem", d, {})) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newMilestoneCatalogFormDropdownResponse(
  data: MilestoneCatalogFormDropdownDataOptions | Error,
): MockedResponse<MilestoneCatalogFormDropdownQueryVariables, MilestoneCatalogFormDropdownQuery> {
  return {
    request: { query: MilestoneCatalogFormDropdownDocument },
    result: { data: data instanceof Error ? undefined : newMilestoneCatalogFormDropdownData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanMilestonesDataOptions {
  saveGlobalPlanMilestones?: FactoryInput<SaveGlobalPlanMilestonesResult, SaveGlobalPlanMilestonesResultOptions>;
}

export function newSaveGlobalPlanMilestonesData(
  data: SaveGlobalPlanMilestonesDataOptions,
): SaveGlobalPlanMilestonesMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanMilestones: maybeNew(
      "SaveGlobalPlanMilestonesResult",
      data["saveGlobalPlanMilestones"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveGlobalPlanMilestonesResponse(
  variables: SaveGlobalPlanMilestonesMutationVariables,
  data: SaveGlobalPlanMilestonesDataOptions | Error,
): MockedResponse<SaveGlobalPlanMilestonesMutationVariables, SaveGlobalPlanMilestonesMutation> {
  return {
    request: { query: SaveGlobalPlanMilestonesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanMilestonesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackagePageV2MetadataDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackagePageV2MetadataData(
  data: PlanPackagePageV2MetadataDataOptions,
): PlanPackagePageV2MetadataQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackagePageV2MetadataResponse(
  variables: PlanPackagePageV2MetadataQueryVariables,
  data: PlanPackagePageV2MetadataDataOptions | Error,
): MockedResponse<PlanPackagePageV2MetadataQueryVariables, PlanPackagePageV2MetadataQuery> {
  return {
    request: { query: PlanPackagePageV2MetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackagePageV2MetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MilestoneCatalogPageMetaDataDataOptions {
  globalPlanMilestoneGroups?: FactoryInput<GlobalPlanMilestoneGroup, GlobalPlanMilestoneGroupOptions>[];
}

export function newMilestoneCatalogPageMetaDataData(
  data: MilestoneCatalogPageMetaDataDataOptions,
): MilestoneCatalogPageMetaDataQuery {
  return {
    __typename: "Query" as const,
    globalPlanMilestoneGroups:
      data["globalPlanMilestoneGroups"]?.map((d) => maybeNew("GlobalPlanMilestoneGroup", d, {})) || [],
  } as any;
}

export function newMilestoneCatalogPageMetaDataResponse(
  data: MilestoneCatalogPageMetaDataDataOptions | Error,
): MockedResponse<MilestoneCatalogPageMetaDataQueryVariables, MilestoneCatalogPageMetaDataQuery> {
  return {
    request: { query: MilestoneCatalogPageMetaDataDocument },
    result: { data: data instanceof Error ? undefined : newMilestoneCatalogPageMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MilestoneCatalogPageDataOptions {
  globalPlanMilestones?: FactoryInput<GlobalPlanMilestonesPageResult, GlobalPlanMilestonesPageResultOptions>;
}

export function newMilestoneCatalogPageData(data: MilestoneCatalogPageDataOptions): MilestoneCatalogPageQuery {
  return {
    __typename: "Query" as const,
    globalPlanMilestones: maybeNew("GlobalPlanMilestonesPageResult", data["globalPlanMilestones"] || undefined, {}),
  } as any;
}

export function newMilestoneCatalogPageResponse(
  variables: MilestoneCatalogPageQueryVariables,
  data: MilestoneCatalogPageDataOptions | Error,
): MockedResponse<MilestoneCatalogPageQueryVariables, MilestoneCatalogPageQuery> {
  return {
    request: { query: MilestoneCatalogPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newMilestoneCatalogPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditProductOfferingConfigDataOptions {
  productOfferingConfig?: FactoryInput<ProductOfferingConfig, ProductOfferingConfigOptions>;
}

export function newEditProductOfferingConfigData(
  data: EditProductOfferingConfigDataOptions,
): EditProductOfferingConfigQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfig: maybeNew("ProductOfferingConfig", data["productOfferingConfig"] || undefined, {}),
  } as any;
}

export function newEditProductOfferingConfigResponse(
  variables: EditProductOfferingConfigQueryVariables,
  data: EditProductOfferingConfigDataOptions | Error,
): MockedResponse<EditProductOfferingConfigQueryVariables, EditProductOfferingConfigQuery> {
  return {
    request: { query: EditProductOfferingConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditProductOfferingConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProductOfferingConfigMetaDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newAddProductOfferingConfigMetaData(
  data: AddProductOfferingConfigMetaDataOptions,
): AddProductOfferingConfigMetaQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newAddProductOfferingConfigMetaResponse(
  variables: AddProductOfferingConfigMetaQueryVariables,
  data: AddProductOfferingConfigMetaDataOptions | Error,
): MockedResponse<AddProductOfferingConfigMetaQueryVariables, AddProductOfferingConfigMetaQuery> {
  return {
    request: { query: AddProductOfferingConfigMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProductOfferingConfigMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProductOfferingConfig_ComputeDataOptions {
  computeReadyPlanCost?: FactoryInput<ComputeReadyPlanCostResult, ComputeReadyPlanCostResultOptions>;
}

export function newAddProductOfferingConfig_ComputeData(
  data: AddProductOfferingConfig_ComputeDataOptions,
): AddProductOfferingConfig_ComputeQuery {
  return {
    __typename: "Query" as const,
    computeReadyPlanCost: maybeNew("ComputeReadyPlanCostResult", data["computeReadyPlanCost"] || undefined, {}),
  } as any;
}

export function newAddProductOfferingConfig_ComputeResponse(
  variables: AddProductOfferingConfig_ComputeQueryVariables,
  data: AddProductOfferingConfig_ComputeDataOptions | Error,
): MockedResponse<AddProductOfferingConfig_ComputeQueryVariables, AddProductOfferingConfig_ComputeQuery> {
  return {
    request: { query: AddProductOfferingConfig_ComputeDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProductOfferingConfig_ComputeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProductOfferingConfig_ProgramDataDataOptions {
  computeProgramData?: FactoryInput<NewProgramData, NewProgramDataOptions>;
}

export function newAddProductOfferingConfig_ProgramDataData(
  data: AddProductOfferingConfig_ProgramDataDataOptions,
): AddProductOfferingConfig_ProgramDataQuery {
  return {
    __typename: "Query" as const,
    computeProgramData: maybeNew("NewProgramData", data["computeProgramData"] || undefined, {}),
  } as any;
}

export function newAddProductOfferingConfig_ProgramDataResponse(
  variables: AddProductOfferingConfig_ProgramDataQueryVariables,
  data: AddProductOfferingConfig_ProgramDataDataOptions | Error,
): MockedResponse<AddProductOfferingConfig_ProgramDataQueryVariables, AddProductOfferingConfig_ProgramDataQuery> {
  return {
    request: { query: AddProductOfferingConfig_ProgramDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProductOfferingConfig_ProgramDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateProjectFromConfigMetaDataOptions {
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
  project?: FactoryInput<Project, ProjectOptions>;
  productOfferingConfig?: FactoryInput<ProductOfferingConfig, ProductOfferingConfigOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
  projectsPage?: FactoryInput<ProjectsPageResult, ProjectsPageResultOptions>;
}

export function newCreateProjectFromConfigMetaData(
  data: CreateProjectFromConfigMetaDataOptions,
): CreateProjectFromConfigMetaQuery {
  return {
    __typename: "Query" as const,
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
    productOfferingConfig: maybeNew("ProductOfferingConfig", data["productOfferingConfig"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newCreateProjectFromConfigMetaResponse(
  variables: CreateProjectFromConfigMetaQueryVariables,
  data: CreateProjectFromConfigMetaDataOptions | Error,
): MockedResponse<CreateProjectFromConfigMetaQueryVariables, CreateProjectFromConfigMetaQuery> {
  return {
    request: { query: CreateProjectFromConfigMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateProjectFromConfigMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateProjectFromProductOfferingConfigDataOptions {
  createProjectFromReadyPlan?: FactoryInput<SaveProjectResult, SaveProjectResultOptions>;
}

export function newCreateProjectFromProductOfferingConfigData(
  data: CreateProjectFromProductOfferingConfigDataOptions,
): CreateProjectFromProductOfferingConfigMutation {
  return {
    __typename: "Mutation" as const,
    createProjectFromReadyPlan: maybeNew("SaveProjectResult", data["createProjectFromReadyPlan"] || undefined, {}),
  } as any;
}

export function newCreateProjectFromProductOfferingConfigResponse(
  variables: CreateProjectFromProductOfferingConfigMutationVariables,
  data: CreateProjectFromProductOfferingConfigDataOptions | Error,
): MockedResponse<
  CreateProjectFromProductOfferingConfigMutationVariables,
  CreateProjectFromProductOfferingConfigMutation
> {
  return {
    request: { query: CreateProjectFromProductOfferingConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateProjectFromProductOfferingConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProductOfferingConfigDataOptions {
  saveProductOfferingConfig?: FactoryInput<SaveProductOfferingConfigResult, SaveProductOfferingConfigResultOptions>;
}

export function newSaveProductOfferingConfigData(
  data: SaveProductOfferingConfigDataOptions,
): SaveProductOfferingConfigMutation {
  return {
    __typename: "Mutation" as const,
    saveProductOfferingConfig: maybeNew(
      "SaveProductOfferingConfigResult",
      data["saveProductOfferingConfig"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProductOfferingConfigResponse(
  variables: SaveProductOfferingConfigMutationVariables,
  data: SaveProductOfferingConfigDataOptions | Error,
): MockedResponse<SaveProductOfferingConfigMutationVariables, SaveProductOfferingConfigMutation> {
  return {
    request: { query: SaveProductOfferingConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProductOfferingConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingConfigsPageMetadataDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newProductOfferingConfigsPageMetadataData(
  data: ProductOfferingConfigsPageMetadataDataOptions,
): ProductOfferingConfigsPageMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [] } as any;
}

export function newProductOfferingConfigsPageMetadataResponse(
  data: ProductOfferingConfigsPageMetadataDataOptions | Error,
): MockedResponse<ProductOfferingConfigsPageMetadataQueryVariables, ProductOfferingConfigsPageMetadataQuery> {
  return {
    request: { query: ProductOfferingConfigsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newProductOfferingConfigsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingConfigsDataOptions {
  productOfferingConfigs?: FactoryInput<ProductOfferingConfigsPage, ProductOfferingConfigsPageOptions>;
}

export function newProductOfferingConfigsData(data: ProductOfferingConfigsDataOptions): ProductOfferingConfigsQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfigs: maybeNew("ProductOfferingConfigsPage", data["productOfferingConfigs"] || undefined, {}),
  } as any;
}

export function newProductOfferingConfigsResponse(
  variables: ProductOfferingConfigsQueryVariables,
  data: ProductOfferingConfigsDataOptions | Error,
): MockedResponse<ProductOfferingConfigsQueryVariables, ProductOfferingConfigsQuery> {
  return {
    request: { query: ProductOfferingConfigsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingConfigsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalProductOfferingsMetaDataDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newGlobalProductOfferingsMetaDataData(
  data: GlobalProductOfferingsMetaDataDataOptions,
): GlobalProductOfferingsMetaDataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [] } as any;
}

export function newGlobalProductOfferingsMetaDataResponse(
  data: GlobalProductOfferingsMetaDataDataOptions | Error,
): MockedResponse<GlobalProductOfferingsMetaDataQueryVariables, GlobalProductOfferingsMetaDataQuery> {
  return {
    request: { query: GlobalProductOfferingsMetaDataDocument },
    result: { data: data instanceof Error ? undefined : newGlobalProductOfferingsMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalProductOfferingsPageDataOptions {
  productOfferings?: FactoryInput<ProductOfferingsPageResult, ProductOfferingsPageResultOptions>;
}

export function newGlobalProductOfferingsPageData(
  data: GlobalProductOfferingsPageDataOptions,
): GlobalProductOfferingsPageQuery {
  return {
    __typename: "Query" as const,
    productOfferings: maybeNew("ProductOfferingsPageResult", data["productOfferings"] || undefined, {}),
  } as any;
}

export function newGlobalProductOfferingsPageResponse(
  variables: GlobalProductOfferingsPageQueryVariables,
  data: GlobalProductOfferingsPageDataOptions | Error,
): MockedResponse<GlobalProductOfferingsPageQueryVariables, GlobalProductOfferingsPageQuery> {
  return {
    request: { query: GlobalProductOfferingsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalProductOfferingsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplatesPageMetadataDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newScheduleTemplatesPageMetadataData(
  data: ScheduleTemplatesPageMetadataDataOptions,
): ScheduleTemplatesPageMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [] } as any;
}

export function newScheduleTemplatesPageMetadataResponse(
  data: ScheduleTemplatesPageMetadataDataOptions | Error,
): MockedResponse<ScheduleTemplatesPageMetadataQueryVariables, ScheduleTemplatesPageMetadataQuery> {
  return {
    request: { query: ScheduleTemplatesPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newScheduleTemplatesPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplateMetadataDataOptions {
  schedules?: FactoryInput<Schedule, ScheduleOptions>[];
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newScheduleTemplateMetadataData(
  data: ScheduleTemplateMetadataDataOptions,
): ScheduleTemplateMetadataQuery {
  return {
    __typename: "Query" as const,
    schedules: data["schedules"]?.map((d) => maybeNew("Schedule", d, {})) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newScheduleTemplateMetadataResponse(
  variables: ScheduleTemplateMetadataQueryVariables,
  data: ScheduleTemplateMetadataDataOptions | Error,
): MockedResponse<ScheduleTemplateMetadataQueryVariables, ScheduleTemplateMetadataQuery> {
  return {
    request: { query: ScheduleTemplateMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTemplateMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplatesDataOptions {
  scheduleTemplates?: FactoryInput<ScheduleTemplate, ScheduleTemplateOptions>[];
}

export function newScheduleTemplatesData(data: ScheduleTemplatesDataOptions): ScheduleTemplatesQuery {
  return {
    __typename: "Query" as const,
    scheduleTemplates: data["scheduleTemplates"]?.map((d) => maybeNew("ScheduleTemplate", d, {})) || [],
  } as any;
}

export function newScheduleTemplatesResponse(
  variables: ScheduleTemplatesQueryVariables,
  data: ScheduleTemplatesDataOptions | Error,
): MockedResponse<ScheduleTemplatesQueryVariables, ScheduleTemplatesQuery> {
  return {
    request: { query: ScheduleTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplateDetailDataOptions {
  scheduleTemplate?: FactoryInput<ScheduleTemplate, ScheduleTemplateOptions>;
}

export function newScheduleTemplateDetailData(data: ScheduleTemplateDetailDataOptions): ScheduleTemplateDetailQuery {
  return {
    __typename: "Query" as const,
    scheduleTemplate: maybeNew("ScheduleTemplate", data["scheduleTemplate"] || undefined, {}),
  } as any;
}

export function newScheduleTemplateDetailResponse(
  variables: ScheduleTemplateDetailQueryVariables,
  data: ScheduleTemplateDetailDataOptions | Error,
): MockedResponse<ScheduleTemplateDetailQueryVariables, ScheduleTemplateDetailQuery> {
  return {
    request: { query: ScheduleTemplateDetailDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTemplateDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplateEditPageDataOptions {
  scheduleTemplate?: FactoryInput<ScheduleTemplate, ScheduleTemplateOptions>;
  schedules?: FactoryInput<Schedule, ScheduleOptions>[];
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
  projectRoleDetails?: FactoryInput<ProjectRoleDetail, ProjectRoleDetailOptions>[];
}

export function newScheduleTemplateEditPageData(
  data: ScheduleTemplateEditPageDataOptions,
): ScheduleTemplateEditPageQuery {
  return {
    __typename: "Query" as const,
    scheduleTemplate: maybeNew("ScheduleTemplate", data["scheduleTemplate"] || undefined, {}),
    schedules: data["schedules"]?.map((d) => maybeNew("Schedule", d, {})) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
    projectRoleDetails: data["projectRoleDetails"]?.map((d) => maybeNew("ProjectRoleDetail", d, {})) || [],
  } as any;
}

export function newScheduleTemplateEditPageResponse(
  variables: ScheduleTemplateEditPageQueryVariables,
  data: ScheduleTemplateEditPageDataOptions | Error,
): MockedResponse<ScheduleTemplateEditPageQueryVariables, ScheduleTemplateEditPageQuery> {
  return {
    request: { query: ScheduleTemplateEditPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTemplateEditPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleTemplatesDataOptions {
  saveScheduleTemplates?: FactoryInput<SaveScheduleTemplatesResult, SaveScheduleTemplatesResultOptions>;
}

export function newSaveScheduleTemplatesData(data: SaveScheduleTemplatesDataOptions): SaveScheduleTemplatesMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTemplates: maybeNew("SaveScheduleTemplatesResult", data["saveScheduleTemplates"] || undefined, {}),
  } as any;
}

export function newSaveScheduleTemplatesResponse(
  variables: SaveScheduleTemplatesMutationVariables,
  data: SaveScheduleTemplatesDataOptions | Error,
): MockedResponse<SaveScheduleTemplatesMutationVariables, SaveScheduleTemplatesMutation> {
  return {
    request: { query: SaveScheduleTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DuplicateScheduleTemplateDataOptions {
  duplicateScheduleTemplate?: FactoryInput<DuplicateScheduleTemplateResult, DuplicateScheduleTemplateResultOptions>;
}

export function newDuplicateScheduleTemplateData(
  data: DuplicateScheduleTemplateDataOptions,
): DuplicateScheduleTemplateMutation {
  return {
    __typename: "Mutation" as const,
    duplicateScheduleTemplate: maybeNew(
      "DuplicateScheduleTemplateResult",
      data["duplicateScheduleTemplate"] || undefined,
      {},
    ),
  } as any;
}

export function newDuplicateScheduleTemplateResponse(
  variables: DuplicateScheduleTemplateMutationVariables,
  data: DuplicateScheduleTemplateDataOptions | Error,
): MockedResponse<DuplicateScheduleTemplateMutationVariables, DuplicateScheduleTemplateMutation> {
  return {
    request: { query: DuplicateScheduleTemplateDocument, variables },
    result: { data: data instanceof Error ? undefined : newDuplicateScheduleTemplateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentsByMarketDataOptions {
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newDevelopmentsByMarketData(data: DevelopmentsByMarketDataOptions): DevelopmentsByMarketQuery {
  return {
    __typename: "Query" as const,
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newDevelopmentsByMarketResponse(
  variables: DevelopmentsByMarketQueryVariables,
  data: DevelopmentsByMarketDataOptions | Error,
): MockedResponse<DevelopmentsByMarketQueryVariables, DevelopmentsByMarketQuery> {
  return {
    request: { query: DevelopmentsByMarketDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentsByMarketData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConstraintAndAllowanceCatalogPageDataOptions {
  globalPlanConstraintItems?: FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>[];
}

export function newConstraintAndAllowanceCatalogPageData(
  data: ConstraintAndAllowanceCatalogPageDataOptions,
): ConstraintAndAllowanceCatalogPageQuery {
  return {
    __typename: "Query" as const,
    globalPlanConstraintItems:
      data["globalPlanConstraintItems"]?.map((d) => maybeNew("GlobalPlanConstraintItem", d, {})) || [],
  } as any;
}

export function newConstraintAndAllowanceCatalogPageResponse(
  data: ConstraintAndAllowanceCatalogPageDataOptions | Error,
): MockedResponse<ConstraintAndAllowanceCatalogPageQueryVariables, ConstraintAndAllowanceCatalogPageQuery> {
  return {
    request: { query: ConstraintAndAllowanceCatalogPageDocument },
    result: { data: data instanceof Error ? undefined : newConstraintAndAllowanceCatalogPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteGlobalPlanConstraintItemDataOptions {
  deleteGlobalPlanConstraintItem?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteGlobalPlanConstraintItemData(
  data: DeleteGlobalPlanConstraintItemDataOptions,
): DeleteGlobalPlanConstraintItemMutation {
  return {
    __typename: "Mutation" as const,
    deleteGlobalPlanConstraintItem: maybeNew("EmptyResult", data["deleteGlobalPlanConstraintItem"] || undefined, {}),
  } as any;
}

export function newDeleteGlobalPlanConstraintItemResponse(
  variables: DeleteGlobalPlanConstraintItemMutationVariables,
  data: DeleteGlobalPlanConstraintItemDataOptions | Error,
): MockedResponse<DeleteGlobalPlanConstraintItemMutationVariables, DeleteGlobalPlanConstraintItemMutation> {
  return {
    request: { query: DeleteGlobalPlanConstraintItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteGlobalPlanConstraintItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogLaborCostsPageDataOptions {
  bidItemEstimates?: FactoryInput<BidItemEstimatesPageResult, BidItemEstimatesPageResultOptions>;
}

export function newTaskCatalogLaborCostsPageData(
  data: TaskCatalogLaborCostsPageDataOptions,
): TaskCatalogLaborCostsPageQuery {
  return {
    __typename: "Query" as const,
    bidItemEstimates: maybeNew("BidItemEstimatesPageResult", data["bidItemEstimates"] || undefined, {}),
  } as any;
}

export function newTaskCatalogLaborCostsPageResponse(
  variables: TaskCatalogLaborCostsPageQueryVariables,
  data: TaskCatalogLaborCostsPageDataOptions | Error,
): MockedResponse<TaskCatalogLaborCostsPageQueryVariables, TaskCatalogLaborCostsPageQuery> {
  return {
    request: { query: TaskCatalogLaborCostsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskCatalogLaborCostsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogTableMetadataDataOptions {
  globalPlanTags?: FactoryInput<GlobalPlanTag, GlobalPlanTagOptions>[];
}

export function newTaskCatalogTableMetadataData(
  data: TaskCatalogTableMetadataDataOptions,
): TaskCatalogTableMetadataQuery {
  return {
    __typename: "Query" as const,
    globalPlanTags: data["globalPlanTags"]?.map((d) => maybeNew("GlobalPlanTag", d, {})) || [],
  } as any;
}

export function newTaskCatalogTableMetadataResponse(
  data: TaskCatalogTableMetadataDataOptions | Error,
): MockedResponse<TaskCatalogTableMetadataQueryVariables, TaskCatalogTableMetadataQuery> {
  return {
    request: { query: TaskCatalogTableMetadataDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogTableMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogTableDataOptions {
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
}

export function newTaskCatalogTableData(data: TaskCatalogTableDataOptions): TaskCatalogTableQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newTaskCatalogTableResponse(
  variables: TaskCatalogTableQueryVariables,
  data: TaskCatalogTableDataOptions | Error,
): MockedResponse<TaskCatalogTableQueryVariables, TaskCatalogTableQuery> {
  return {
    request: { query: TaskCatalogTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskCatalogTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogPageMetadataDataOptions {
  regions?: FactoryInput<Region, RegionOptions>[];
  globalPlanTags?: FactoryInput<GlobalPlanTag, GlobalPlanTagOptions>[];
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newTaskCatalogPageMetadataData(data: TaskCatalogPageMetadataDataOptions): TaskCatalogPageMetadataQuery {
  return {
    __typename: "Query" as const,
    regions: data["regions"]?.map((d) => maybeNew("Region", d, {})) || [],
    globalPlanTags: data["globalPlanTags"]?.map((d) => maybeNew("GlobalPlanTag", d, {})) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newTaskCatalogPageMetadataResponse(
  data: TaskCatalogPageMetadataDataOptions | Error,
): MockedResponse<TaskCatalogPageMetadataQueryVariables, TaskCatalogPageMetadataQuery> {
  return {
    request: { query: TaskCatalogPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPdfDataOptions {
  bill?: FactoryInput<Bill, BillOptions>;
}

export function newBillPdfData(data: BillPdfDataOptions): BillPdfQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillPdfResponse(
  variables: BillPdfQueryVariables,
  data: BillPdfDataOptions | Error,
): MockedResponse<BillPdfQueryVariables, BillPdfQuery> {
  return {
    request: { query: BillPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPdfTradePartnerContactDataOptions {
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
}

export function newBillPdfTradePartnerContactData(
  data: BillPdfTradePartnerContactDataOptions,
): BillPdfTradePartnerContactQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
  } as any;
}

export function newBillPdfTradePartnerContactResponse(
  variables: BillPdfTradePartnerContactQueryVariables,
  data: BillPdfTradePartnerContactDataOptions | Error,
): MockedResponse<BillPdfTradePartnerContactQueryVariables, BillPdfTradePartnerContactQuery> {
  return {
    request: { query: BillPdfTradePartnerContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPdfTradePartnerContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserEventsDataOptions {
  userEvents?: FactoryInput<UserEvent, UserEventOptions>[];
}

export function newUserEventsData(data: UserEventsDataOptions): UserEventsQuery {
  return {
    __typename: "Query" as const,
    userEvents: data["userEvents"]?.map((d) => maybeNew("UserEvent", d, {})) || [],
  } as any;
}

export function newUserEventsResponse(
  variables: UserEventsQueryVariables,
  data: UserEventsDataOptions | Error,
): MockedResponse<UserEventsQueryVariables, UserEventsQuery> {
  return {
    request: { query: UserEventsDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserEventsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentPdfDataOptions {
  developmentCommitments?: FactoryInput<DevelopmentCommitment, DevelopmentCommitmentOptions>[];
}

export function newDevelopmentCommitmentPdfData(
  data: DevelopmentCommitmentPdfDataOptions,
): DevelopmentCommitmentPdfQuery {
  return {
    __typename: "Query" as const,
    developmentCommitments: data["developmentCommitments"]?.map((d) => maybeNew("DevelopmentCommitment", d, {})) || [],
  } as any;
}

export function newDevelopmentCommitmentPdfResponse(
  variables: DevelopmentCommitmentPdfQueryVariables,
  data: DevelopmentCommitmentPdfDataOptions | Error,
): MockedResponse<DevelopmentCommitmentPdfQueryVariables, DevelopmentCommitmentPdfQuery> {
  return {
    request: { query: DevelopmentCommitmentPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentPdfDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
}

export function newCommitmentPdfData(data: CommitmentPdfDataOptions): CommitmentPdfQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newCommitmentPdfResponse(
  variables: CommitmentPdfQueryVariables,
  data: CommitmentPdfDataOptions | Error,
): MockedResponse<CommitmentPdfQueryVariables, CommitmentPdfQuery> {
  return {
    request: { query: CommitmentPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentChangeOrderPdfDataOptions {
  commitmentChangeOrder?: FactoryInput<CommitmentChangeOrder, CommitmentChangeOrderOptions>;
}

export function newCommitmentChangeOrderPdfData(
  data: CommitmentChangeOrderPdfDataOptions,
): CommitmentChangeOrderPdfQuery {
  return {
    __typename: "Query" as const,
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newCommitmentChangeOrderPdfResponse(
  variables: CommitmentChangeOrderPdfQueryVariables,
  data: CommitmentChangeOrderPdfDataOptions | Error,
): MockedResponse<CommitmentChangeOrderPdfQueryVariables, CommitmentChangeOrderPdfQuery> {
  return {
    request: { query: CommitmentChangeOrderPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentChangeOrderPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentContractPdfDataOptions {
  bidContract?: FactoryInput<BidContract, BidContractOptions>;
}

export function newDevelopmentContractPdfData(data: DevelopmentContractPdfDataOptions): DevelopmentContractPdfQuery {
  return {
    __typename: "Query" as const,
    bidContract: maybeNew("BidContract", data["bidContract"] || undefined, {}),
  } as any;
}

export function newDevelopmentContractPdfResponse(
  variables: DevelopmentContractPdfQueryVariables,
  data: DevelopmentContractPdfDataOptions | Error,
): MockedResponse<DevelopmentContractPdfQueryVariables, DevelopmentContractPdfQuery> {
  return {
    request: { query: DevelopmentContractPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentContractPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleVisualModePdfDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  readyPlanAggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
  designPackageFinishSchedule?: FactoryInput<
    DesignPackageFinishSchedulePageResult,
    DesignPackageFinishSchedulePageResultOptions
  >;
  locations?: FactoryInput<Location, LocationOptions>[];
}

export function newFinishScheduleVisualModePdfData(
  data: FinishScheduleVisualModePdfDataOptions,
): FinishScheduleVisualModePdfQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
    readyPlanAggregateVersion: maybeNew(
      "ReadyPlanAggregateVersion",
      data["readyPlanAggregateVersion"] || undefined,
      {},
    ),
    designPackageFinishSchedule: maybeNew(
      "DesignPackageFinishSchedulePageResult",
      data["designPackageFinishSchedule"] || undefined,
      {},
    ),
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newFinishScheduleVisualModePdfResponse(
  variables: FinishScheduleVisualModePdfQueryVariables,
  data: FinishScheduleVisualModePdfDataOptions | Error,
): MockedResponse<FinishScheduleVisualModePdfQueryVariables, FinishScheduleVisualModePdfQuery> {
  return {
    request: { query: FinishScheduleVisualModePdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleVisualModePdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoicePandaDocPdfDataOptions {
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
}

export function newInvoicePandaDocPdfData(data: InvoicePandaDocPdfDataOptions): InvoicePandaDocPdfQuery {
  return { __typename: "Query" as const, invoice: maybeNew("Invoice", data["invoice"] || undefined, {}) } as any;
}

export function newInvoicePandaDocPdfResponse(
  variables: InvoicePandaDocPdfQueryVariables,
  data: InvoicePandaDocPdfDataOptions | Error,
): MockedResponse<InvoicePandaDocPdfQueryVariables, InvoicePandaDocPdfQuery> {
  return {
    request: { query: InvoicePandaDocPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoicePandaDocPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LienWaiverPdfDataOptions {
  lienWaiver?: FactoryInput<LienWaiver, LienWaiverOptions>;
}

export function newLienWaiverPdfData(data: LienWaiverPdfDataOptions): LienWaiverPdfQuery {
  return {
    __typename: "Query" as const,
    lienWaiver: maybeNew("LienWaiver", data["lienWaiver"] || undefined, {}),
  } as any;
}

export function newLienWaiverPdfResponse(
  variables: LienWaiverPdfQueryVariables,
  data: LienWaiverPdfDataOptions | Error,
): MockedResponse<LienWaiverPdfQueryVariables, LienWaiverPdfQuery> {
  return {
    request: { query: LienWaiverPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newLienWaiverPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LienWaiverLastPaidBillDataOptions {
  billsPage?: FactoryInput<BillsPage, BillsPageOptions>;
}

export function newLienWaiverLastPaidBillData(data: LienWaiverLastPaidBillDataOptions): LienWaiverLastPaidBillQuery {
  return { __typename: "Query" as const, billsPage: maybeNew("BillsPage", data["billsPage"] || undefined, {}) } as any;
}

export function newLienWaiverLastPaidBillResponse(
  variables: LienWaiverLastPaidBillQueryVariables,
  data: LienWaiverLastPaidBillDataOptions | Error,
): MockedResponse<LienWaiverLastPaidBillQueryVariables, LienWaiverLastPaidBillQuery> {
  return {
    request: { query: LienWaiverLastPaidBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newLienWaiverLastPaidBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFinishSchedulePdfMetadataDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
}

export function newProjectFinishSchedulePdfMetadataData(
  data: ProjectFinishSchedulePdfMetadataDataOptions,
): ProjectFinishSchedulePdfMetadataQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newProjectFinishSchedulePdfMetadataResponse(
  variables: ProjectFinishSchedulePdfMetadataQueryVariables,
  data: ProjectFinishSchedulePdfMetadataDataOptions | Error,
): MockedResponse<ProjectFinishSchedulePdfMetadataQueryVariables, ProjectFinishSchedulePdfMetadataQuery> {
  return {
    request: { query: ProjectFinishSchedulePdfMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFinishSchedulePdfMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleExportPageDataOptions {
  schedules?: FactoryInput<Schedule, ScheduleOptions>[];
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newScheduleExportPageData(data: ScheduleExportPageDataOptions): ScheduleExportPageQuery {
  return {
    __typename: "Query" as const,
    schedules: data["schedules"]?.map((d) => maybeNew("Schedule", d, {})) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newScheduleExportPageResponse(
  variables: ScheduleExportPageQueryVariables,
  data: ScheduleExportPageDataOptions | Error,
): MockedResponse<ScheduleExportPageQueryVariables, ScheduleExportPageQuery> {
  return {
    request: { query: ScheduleExportPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleExportPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFinishScheduleVisualModePdfDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectFinishScheduleVisualModePdfData(
  data: ProjectFinishScheduleVisualModePdfDataOptions,
): ProjectFinishScheduleVisualModePdfQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectFinishScheduleVisualModePdfResponse(
  variables: ProjectFinishScheduleVisualModePdfQueryVariables,
  data: ProjectFinishScheduleVisualModePdfDataOptions | Error,
): MockedResponse<ProjectFinishScheduleVisualModePdfQueryVariables, ProjectFinishScheduleVisualModePdfQuery> {
  return {
    request: { query: ProjectFinishScheduleVisualModePdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFinishScheduleVisualModePdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDosPdfDataOptions {
  toDos?: FactoryInput<ToDo, ToDoOptions>[];
}

export function newToDosPdfData(data: ToDosPdfDataOptions): ToDosPdfQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => maybeNew("ToDo", d, {})) || [] } as any;
}

export function newToDosPdfResponse(
  variables: ToDosPdfQueryVariables,
  data: ToDosPdfDataOptions | Error,
): MockedResponse<ToDosPdfQueryVariables, ToDosPdfQuery> {
  return {
    request: { query: ToDosPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newToDosPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeSpecificAgreementDataOptions {
  costDivisions?: FactoryInput<CostDivision, CostDivisionOptions>[];
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
}

export function newTradeSpecificAgreementData(data: TradeSpecificAgreementDataOptions): TradeSpecificAgreementQuery {
  return {
    __typename: "Query" as const,
    costDivisions: data["costDivisions"]?.map((d) => maybeNew("CostDivision", d, {})) || [],
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
  } as any;
}

export function newTradeSpecificAgreementResponse(
  variables: TradeSpecificAgreementQueryVariables,
  data: TradeSpecificAgreementDataOptions | Error,
): MockedResponse<TradeSpecificAgreementQueryVariables, TradeSpecificAgreementQuery> {
  return {
    request: { query: TradeSpecificAgreementDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradeSpecificAgreementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSequenceSheetPdfDataOptions {
  projectReadyPlanConfigs?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>[];
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newLotSequenceSheetPdfData(data: LotSequenceSheetPdfDataOptions): LotSequenceSheetPdfQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfigs: data["projectReadyPlanConfigs"]?.map((d) => maybeNew("ProjectReadyPlanConfig", d, {})) ||
      [],
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newLotSequenceSheetPdfResponse(
  variables: LotSequenceSheetPdfQueryVariables,
  data: LotSequenceSheetPdfDataOptions | Error,
): MockedResponse<LotSequenceSheetPdfQueryVariables, LotSequenceSheetPdfQuery> {
  return {
    request: { query: LotSequenceSheetPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSequenceSheetPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSummaryDetailsPdfDataOptions {
  projectReadyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>;
}

export function newLotSummaryDetailsPdfData(data: LotSummaryDetailsPdfDataOptions): LotSummaryDetailsPdfQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfig: maybeNew("ProjectReadyPlanConfig", data["projectReadyPlanConfig"] || undefined, {}),
  } as any;
}

export function newLotSummaryDetailsPdfResponse(
  variables: LotSummaryDetailsPdfQueryVariables,
  data: LotSummaryDetailsPdfDataOptions | Error,
): MockedResponse<LotSummaryDetailsPdfQueryVariables, LotSummaryDetailsPdfQuery> {
  return {
    request: { query: LotSummaryDetailsPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSummaryDetailsPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradesPunchlistPdfDataOptions {
  punchlistItemTodos?: FactoryInput<PunchlistItemTodo, PunchlistItemTodoOptions>[];
}

export function newTradesPunchlistPdfData(data: TradesPunchlistPdfDataOptions): TradesPunchlistPdfQuery {
  return {
    __typename: "Query" as const,
    punchlistItemTodos: data["punchlistItemTodos"]?.map((d) => maybeNew("PunchlistItemTodo", d, {})) || [],
  } as any;
}

export function newTradesPunchlistPdfResponse(
  variables: TradesPunchlistPdfQueryVariables,
  data: TradesPunchlistPdfDataOptions | Error,
): MockedResponse<TradesPunchlistPdfQueryVariables, TradesPunchlistPdfQuery> {
  return {
    request: { query: TradesPunchlistPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradesPunchlistPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalSummaryHeaderDataOptions {
  waitinOnMe?: FactoryInput<ApprovalPage, ApprovalPageOptions> | null;
  myApprovals?: FactoryInput<ApprovalPage, ApprovalPageOptions> | null;
}

export function newApprovalSummaryHeaderData(data: ApprovalSummaryHeaderDataOptions): ApprovalSummaryHeaderQuery {
  return {
    __typename: "Query" as const,
    waitinOnMe: maybeNewOrNull("ApprovalPage", data["waitinOnMe"] || undefined, {}),
    myApprovals: maybeNewOrNull("ApprovalPage", data["myApprovals"] || undefined, {}),
  } as any;
}

export function newApprovalSummaryHeaderResponse(
  variables: ApprovalSummaryHeaderQueryVariables,
  data: ApprovalSummaryHeaderDataOptions | Error,
): MockedResponse<ApprovalSummaryHeaderQueryVariables, ApprovalSummaryHeaderQuery> {
  return {
    request: { query: ApprovalSummaryHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalSummaryHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DashboardCommentsDataOptions {
  userRelevantCommentStreamsPaged?: FactoryInput<
    UserRelevantCommentStreamsResult,
    UserRelevantCommentStreamsResultOptions
  >;
}

export function newDashboardCommentsData(data: DashboardCommentsDataOptions): DashboardCommentsQuery {
  return {
    __typename: "Query" as const,
    userRelevantCommentStreamsPaged: maybeNew(
      "UserRelevantCommentStreamsResult",
      data["userRelevantCommentStreamsPaged"] || undefined,
      {},
    ),
  } as any;
}

export function newDashboardCommentsResponse(
  variables: DashboardCommentsQueryVariables,
  data: DashboardCommentsDataOptions | Error,
): MockedResponse<DashboardCommentsQueryVariables, DashboardCommentsQuery> {
  return {
    request: { query: DashboardCommentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDashboardCommentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsWidgetFinancialsTabDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newProjectsWidgetFinancialsTabData(
  data: ProjectsWidgetFinancialsTabDataOptions,
): ProjectsWidgetFinancialsTabQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newProjectsWidgetFinancialsTabResponse(
  variables: ProjectsWidgetFinancialsTabQueryVariables,
  data: ProjectsWidgetFinancialsTabDataOptions | Error,
): MockedResponse<ProjectsWidgetFinancialsTabQueryVariables, ProjectsWidgetFinancialsTabQuery> {
  return {
    request: { query: ProjectsWidgetFinancialsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsWidgetFinancialsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsWidgetFinancialsTableDataOptions {
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
}

export function newProjectsWidgetFinancialsTableData(
  data: ProjectsWidgetFinancialsTableDataOptions,
): ProjectsWidgetFinancialsTableQuery {
  return {
    __typename: "Query" as const,
    projectStage: maybeNew("ProjectStage", data["projectStage"] || undefined, {}),
  } as any;
}

export function newProjectsWidgetFinancialsTableResponse(
  variables: ProjectsWidgetFinancialsTableQueryVariables,
  data: ProjectsWidgetFinancialsTableDataOptions | Error,
): MockedResponse<ProjectsWidgetFinancialsTableQueryVariables, ProjectsWidgetFinancialsTableQuery> {
  return {
    request: { query: ProjectsWidgetFinancialsTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsWidgetFinancialsTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SchedulingModalDataOptions {
  tasks?: FactoryInput<Task, TaskOptions>[];
}

export function newSchedulingModalData(data: SchedulingModalDataOptions): SchedulingModalQuery {
  return { __typename: "Query" as const, tasks: data["tasks"]?.map((d) => maybeNew("Task", d, {})) || [] } as any;
}

export function newSchedulingModalResponse(
  variables: SchedulingModalQueryVariables,
  data: SchedulingModalDataOptions | Error,
): MockedResponse<SchedulingModalQueryVariables, SchedulingModalQuery> {
  return {
    request: { query: SchedulingModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newSchedulingModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsWidgetScheduleTabDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newProjectsWidgetScheduleTabData(
  data: ProjectsWidgetScheduleTabDataOptions,
): ProjectsWidgetScheduleTabQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newProjectsWidgetScheduleTabResponse(
  variables: ProjectsWidgetScheduleTabQueryVariables,
  data: ProjectsWidgetScheduleTabDataOptions | Error,
): MockedResponse<ProjectsWidgetScheduleTabQueryVariables, ProjectsWidgetScheduleTabQuery> {
  return {
    request: { query: ProjectsWidgetScheduleTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsWidgetScheduleTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TasksSummaryHeaderDataOptions {
  tasks?: FactoryInput<Task, TaskOptions>[];
}

export function newTasksSummaryHeaderData(data: TasksSummaryHeaderDataOptions): TasksSummaryHeaderQuery {
  return { __typename: "Query" as const, tasks: data["tasks"]?.map((d) => maybeNew("Task", d, {})) || [] } as any;
}

export function newTasksSummaryHeaderResponse(
  variables: TasksSummaryHeaderQueryVariables,
  data: TasksSummaryHeaderDataOptions | Error,
): MockedResponse<TasksSummaryHeaderQueryVariables, TasksSummaryHeaderQuery> {
  return {
    request: { query: TasksSummaryHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newTasksSummaryHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillsSummaryHeaderDataOptions {
  unreleasedClickToPayBills?: FactoryInput<Bill, BillOptions>[];
  pendingReviewBills?: FactoryInput<Bill, BillOptions>[];
}

export function newBillsSummaryHeaderData(data: BillsSummaryHeaderDataOptions): BillsSummaryHeaderQuery {
  return {
    __typename: "Query" as const,
    unreleasedClickToPayBills: data["unreleasedClickToPayBills"]?.map((d) => maybeNew("Bill", d, {})) || [],
    pendingReviewBills: data["pendingReviewBills"]?.map((d) => maybeNew("Bill", d, {})) || [],
  } as any;
}

export function newBillsSummaryHeaderResponse(
  variables: BillsSummaryHeaderQueryVariables,
  data: BillsSummaryHeaderDataOptions | Error,
): MockedResponse<BillsSummaryHeaderQueryVariables, BillsSummaryHeaderQuery> {
  return {
    request: { query: BillsSummaryHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillsSummaryHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SubmitApprovalDataOptions {
  saveApproval?: FactoryInput<SaveApprovalResult, SaveApprovalResultOptions>;
}

export function newSubmitApprovalData(data: SubmitApprovalDataOptions): SubmitApprovalMutation {
  return {
    __typename: "Mutation" as const,
    saveApproval: maybeNew("SaveApprovalResult", data["saveApproval"] || undefined, {}),
  } as any;
}

export function newSubmitApprovalResponse(
  variables: SubmitApprovalMutationVariables,
  data: SubmitApprovalDataOptions | Error,
): MockedResponse<SubmitApprovalMutationVariables, SubmitApprovalMutation> {
  return {
    request: { query: SubmitApprovalDocument, variables },
    result: { data: data instanceof Error ? undefined : newSubmitApprovalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerAvailabilityRequestDataOptions {
  saveTradePartnerAvailabilityRequest?: FactoryInput<
    SaveTradePartnerAvailabilityRequestResult,
    SaveTradePartnerAvailabilityRequestResultOptions
  >;
}

export function newSaveTradePartnerAvailabilityRequestData(
  data: SaveTradePartnerAvailabilityRequestDataOptions,
): SaveTradePartnerAvailabilityRequestMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerAvailabilityRequest: maybeNew(
      "SaveTradePartnerAvailabilityRequestResult",
      data["saveTradePartnerAvailabilityRequest"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerAvailabilityRequestResponse(
  variables: SaveTradePartnerAvailabilityRequestMutationVariables,
  data: SaveTradePartnerAvailabilityRequestDataOptions | Error,
): MockedResponse<SaveTradePartnerAvailabilityRequestMutationVariables, SaveTradePartnerAvailabilityRequestMutation> {
  return {
    request: { query: SaveTradePartnerAvailabilityRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerAvailabilityRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectBidContractOverviewPageDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newProjectBidContractOverviewPageData(
  data: ProjectBidContractOverviewPageDataOptions,
): ProjectBidContractOverviewPageQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newProjectBidContractOverviewPageResponse(
  variables: ProjectBidContractOverviewPageQueryVariables,
  data: ProjectBidContractOverviewPageDataOptions | Error,
): MockedResponse<ProjectBidContractOverviewPageQueryVariables, ProjectBidContractOverviewPageQuery> {
  return {
    request: { query: ProjectBidContractOverviewPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectBidContractOverviewPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BudgetSummaryDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newBudgetSummaryData(data: BudgetSummaryDataOptions): BudgetSummaryQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newBudgetSummaryResponse(
  variables: BudgetSummaryQueryVariables,
  data: BudgetSummaryDataOptions | Error,
): MockedResponse<BudgetSummaryQueryVariables, BudgetSummaryQuery> {
  return {
    request: { query: BudgetSummaryDocument, variables },
    result: { data: data instanceof Error ? undefined : newBudgetSummaryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CeliSpecOverviewTabDataOptions {
  changeEventLineItems?: FactoryInput<ChangeEventLineItem, ChangeEventLineItemOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
}

export function newCeliSpecOverviewTabData(data: CeliSpecOverviewTabDataOptions): CeliSpecOverviewTabQuery {
  return {
    __typename: "Query" as const,
    changeEventLineItems: data["changeEventLineItems"]?.map((d) => maybeNew("ChangeEventLineItem", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
  } as any;
}

export function newCeliSpecOverviewTabResponse(
  variables: CeliSpecOverviewTabQueryVariables,
  data: CeliSpecOverviewTabDataOptions | Error,
): MockedResponse<CeliSpecOverviewTabQueryVariables, CeliSpecOverviewTabQuery> {
  return {
    request: { query: CeliSpecOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCeliSpecOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CeliSpecOverviewTabSaveCeliDataOptions {
  saveChangeEventLineItems?: FactoryInput<SaveChangeEventLineItemsResult, SaveChangeEventLineItemsResultOptions>;
}

export function newCeliSpecOverviewTabSaveCeliData(
  data: CeliSpecOverviewTabSaveCeliDataOptions,
): CeliSpecOverviewTabSaveCeliMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newCeliSpecOverviewTabSaveCeliResponse(
  variables: CeliSpecOverviewTabSaveCeliMutationVariables,
  data: CeliSpecOverviewTabSaveCeliDataOptions | Error,
): MockedResponse<CeliSpecOverviewTabSaveCeliMutationVariables, CeliSpecOverviewTabSaveCeliMutation> {
  return {
    request: { query: CeliSpecOverviewTabSaveCeliDocument, variables },
    result: { data: data instanceof Error ? undefined : newCeliSpecOverviewTabSaveCeliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyBudgetPageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newHierarchyBudgetPageData(data: HierarchyBudgetPageDataOptions): HierarchyBudgetPageQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newHierarchyBudgetPageResponse(
  variables: HierarchyBudgetPageQueryVariables,
  data: HierarchyBudgetPageDataOptions | Error,
): MockedResponse<HierarchyBudgetPageQueryVariables, HierarchyBudgetPageQuery> {
  return {
    request: { query: HierarchyBudgetPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyBudgetPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyBudgetPage_RollupViewDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newHierarchyBudgetPage_RollupViewData(
  data: HierarchyBudgetPage_RollupViewDataOptions,
): HierarchyBudgetPage_RollupViewQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newHierarchyBudgetPage_RollupViewResponse(
  variables: HierarchyBudgetPage_RollupViewQueryVariables,
  data: HierarchyBudgetPage_RollupViewDataOptions | Error,
): MockedResponse<HierarchyBudgetPage_RollupViewQueryVariables, HierarchyBudgetPage_RollupViewQuery> {
  return {
    request: { query: HierarchyBudgetPage_RollupViewDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyBudgetPage_RollupViewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyBudgetPage_SharedCostsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newHierarchyBudgetPage_SharedCostsData(
  data: HierarchyBudgetPage_SharedCostsDataOptions,
): HierarchyBudgetPage_SharedCostsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newHierarchyBudgetPage_SharedCostsResponse(
  variables: HierarchyBudgetPage_SharedCostsQueryVariables,
  data: HierarchyBudgetPage_SharedCostsDataOptions | Error,
): MockedResponse<HierarchyBudgetPage_SharedCostsQueryVariables, HierarchyBudgetPage_SharedCostsQuery> {
  return {
    request: { query: HierarchyBudgetPage_SharedCostsDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyBudgetPage_SharedCostsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventAssociationsDataOptions {
  changeEvents?: FactoryInput<ChangeEvent, ChangeEventOptions>[];
}

export function newChangeEventAssociationsData(data: ChangeEventAssociationsDataOptions): ChangeEventAssociationsQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => maybeNew("ChangeEvent", d, {})) || [],
  } as any;
}

export function newChangeEventAssociationsResponse(
  variables: ChangeEventAssociationsQueryVariables,
  data: ChangeEventAssociationsDataOptions | Error,
): MockedResponse<ChangeEventAssociationsQueryVariables, ChangeEventAssociationsQuery> {
  return {
    request: { query: ChangeEventAssociationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventAssociationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectBidContractsPageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectBidContractsPageData(data: ProjectBidContractsPageDataOptions): ProjectBidContractsPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectBidContractsPageResponse(
  variables: ProjectBidContractsPageQueryVariables,
  data: ProjectBidContractsPageDataOptions | Error,
): MockedResponse<ProjectBidContractsPageQueryVariables, ProjectBidContractsPageQuery> {
  return {
    request: { query: ProjectBidContractsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectBidContractsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventEstimatesTabDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newChangeEventEstimatesTabData(data: ChangeEventEstimatesTabDataOptions): ChangeEventEstimatesTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newChangeEventEstimatesTabResponse(
  variables: ChangeEventEstimatesTabQueryVariables,
  data: ChangeEventEstimatesTabDataOptions | Error,
): MockedResponse<ChangeEventEstimatesTabQueryVariables, ChangeEventEstimatesTabQuery> {
  return {
    request: { query: ChangeEventEstimatesTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventEstimatesTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventHistoryDataOptions {
  changeEvents?: FactoryInput<ChangeEvent, ChangeEventOptions>[];
}

export function newChangeEventHistoryData(data: ChangeEventHistoryDataOptions): ChangeEventHistoryQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => maybeNew("ChangeEvent", d, {})) || [],
  } as any;
}

export function newChangeEventHistoryResponse(
  variables: ChangeEventHistoryQueryVariables,
  data: ChangeEventHistoryDataOptions | Error,
): MockedResponse<ChangeEventHistoryQueryVariables, ChangeEventHistoryQuery> {
  return {
    request: { query: ChangeEventHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventLineItemsTabDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newChangeEventLineItemsTabData(data: ChangeEventLineItemsTabDataOptions): ChangeEventLineItemsTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
  } as any;
}

export function newChangeEventLineItemsTabResponse(
  variables: ChangeEventLineItemsTabQueryVariables,
  data: ChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<ChangeEventLineItemsTabQueryVariables, ChangeEventLineItemsTabQuery> {
  return {
    request: { query: ChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventLineItemsTabDataOptions {
  saveChangeEventLineItems?: FactoryInput<SaveChangeEventLineItemsResult, SaveChangeEventLineItemsResultOptions>;
}

export function newSaveChangeEventLineItemsTabData(
  data: SaveChangeEventLineItemsTabDataOptions,
): SaveChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveChangeEventLineItemsTabResponse(
  variables: SaveChangeEventLineItemsTabMutationVariables,
  data: SaveChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<SaveChangeEventLineItemsTabMutationVariables, SaveChangeEventLineItemsTabMutation> {
  return {
    request: { query: SaveChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateChangeEventLineItemsTabDataOptions {
  saveChangeEventLineItems?: FactoryInput<SaveChangeEventLineItemsResult, SaveChangeEventLineItemsResultOptions>;
}

export function newCreateChangeEventLineItemsTabData(
  data: CreateChangeEventLineItemsTabDataOptions,
): CreateChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateChangeEventLineItemsTabResponse(
  variables: CreateChangeEventLineItemsTabMutationVariables,
  data: CreateChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<CreateChangeEventLineItemsTabMutationVariables, CreateChangeEventLineItemsTabMutation> {
  return {
    request: { query: CreateChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteChangeEventLineItemsTabDataOptions {
  deleteChangeEventLineItems?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteChangeEventLineItemsTabData(
  data: DeleteChangeEventLineItemsTabDataOptions,
): DeleteChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    deleteChangeEventLineItems: maybeNew("EmptyResult", data["deleteChangeEventLineItems"] || undefined, {}),
  } as any;
}

export function newDeleteChangeEventLineItemsTabResponse(
  variables: DeleteChangeEventLineItemsTabMutationVariables,
  data: DeleteChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<DeleteChangeEventLineItemsTabMutationVariables, DeleteChangeEventLineItemsTabMutation> {
  return {
    request: { query: DeleteChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddChangeEventLineItemsTabDataOptions {
  saveChangeEventLineItems?: FactoryInput<SaveChangeEventLineItemsResult, SaveChangeEventLineItemsResultOptions>;
}

export function newAddChangeEventLineItemsTabData(
  data: AddChangeEventLineItemsTabDataOptions,
): AddChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newAddChangeEventLineItemsTabResponse(
  variables: AddChangeEventLineItemsTabMutationVariables,
  data: AddChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<AddChangeEventLineItemsTabMutationVariables, AddChangeEventLineItemsTabMutation> {
  return {
    request: { query: AddChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyItemTemplateToChangeEventLineItemsTabDataOptions {
  applyItemTemplateToChangeEvent?: FactoryInput<
    ApplyItemTemplateToChangeEventResult,
    ApplyItemTemplateToChangeEventResultOptions
  >;
}

export function newApplyItemTemplateToChangeEventLineItemsTabData(
  data: ApplyItemTemplateToChangeEventLineItemsTabDataOptions,
): ApplyItemTemplateToChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    applyItemTemplateToChangeEvent: maybeNew(
      "ApplyItemTemplateToChangeEventResult",
      data["applyItemTemplateToChangeEvent"] || undefined,
      {},
    ),
  } as any;
}

export function newApplyItemTemplateToChangeEventLineItemsTabResponse(
  variables: ApplyItemTemplateToChangeEventLineItemsTabMutationVariables,
  data: ApplyItemTemplateToChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<
  ApplyItemTemplateToChangeEventLineItemsTabMutationVariables,
  ApplyItemTemplateToChangeEventLineItemsTabMutation
> {
  return {
    request: { query: ApplyItemTemplateToChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyItemTemplateToChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentsForChangeEventDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newCommitmentsForChangeEventData(
  data: CommitmentsForChangeEventDataOptions,
): CommitmentsForChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newCommitmentsForChangeEventResponse(
  variables: CommitmentsForChangeEventQueryVariables,
  data: CommitmentsForChangeEventDataOptions | Error,
): MockedResponse<CommitmentsForChangeEventQueryVariables, CommitmentsForChangeEventQuery> {
  return {
    request: { query: CommitmentsForChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentsForChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventPageDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newChangeEventPageData(data: ChangeEventPageDataOptions): ChangeEventPageQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newChangeEventPageResponse(
  variables: ChangeEventPageQueryVariables,
  data: ChangeEventPageDataOptions | Error,
): MockedResponse<ChangeEventPageQueryVariables, ChangeEventPageQuery> {
  return {
    request: { query: ChangeEventPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteChangeEventDataOptions {
  deleteChangeEvent?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteChangeEventData(data: DeleteChangeEventDataOptions): DeleteChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    deleteChangeEvent: maybeNew("EmptyResult", data["deleteChangeEvent"] || undefined, {}),
  } as any;
}

export function newDeleteChangeEventResponse(
  variables: DeleteChangeEventMutationVariables,
  data: DeleteChangeEventDataOptions | Error,
): MockedResponse<DeleteChangeEventMutationVariables, DeleteChangeEventMutation> {
  return {
    request: { query: DeleteChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventOverviewTabDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
  changeEventReasons?: FactoryInput<ChangeEventReason, ChangeEventReasonOptions>[];
  changeEventBudgetPhases?: FactoryInput<ChangeEventBudgetPhaseDetail, ChangeEventBudgetPhaseDetailOptions>[];
}

export function newChangeEventOverviewTabData(data: ChangeEventOverviewTabDataOptions): ChangeEventOverviewTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => maybeNew("ChangeEventReason", d, {})) || [],
    changeEventBudgetPhases:
      data["changeEventBudgetPhases"]?.map((d) => maybeNew("ChangeEventBudgetPhaseDetail", d, {})) || [],
  } as any;
}

export function newChangeEventOverviewTabResponse(
  variables: ChangeEventOverviewTabQueryVariables,
  data: ChangeEventOverviewTabDataOptions | Error,
): MockedResponse<ChangeEventOverviewTabQueryVariables, ChangeEventOverviewTabQuery> {
  return {
    request: { query: ChangeEventOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventOverviewTabDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newSaveChangeEventOverviewTabData(
  data: SaveChangeEventOverviewTabDataOptions,
): SaveChangeEventOverviewTabMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newSaveChangeEventOverviewTabResponse(
  variables: SaveChangeEventOverviewTabMutationVariables,
  data: SaveChangeEventOverviewTabDataOptions | Error,
): MockedResponse<SaveChangeEventOverviewTabMutationVariables, SaveChangeEventOverviewTabMutation> {
  return {
    request: { query: SaveChangeEventOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventRposTabDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newChangeEventRposTabData(data: ChangeEventRposTabDataOptions): ChangeEventRposTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newChangeEventRposTabResponse(
  variables: ChangeEventRposTabQueryVariables,
  data: ChangeEventRposTabDataOptions | Error,
): MockedResponse<ChangeEventRposTabQueryVariables, ChangeEventRposTabQuery> {
  return {
    request: { query: ChangeEventRposTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventRposTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventRposDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newSaveChangeEventRposData(data: SaveChangeEventRposDataOptions): SaveChangeEventRposMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newSaveChangeEventRposResponse(
  variables: SaveChangeEventRposMutationVariables,
  data: SaveChangeEventRposDataOptions | Error,
): MockedResponse<SaveChangeEventRposMutationVariables, SaveChangeEventRposMutation> {
  return {
    request: { query: SaveChangeEventRposDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventRposData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventsForProjectStageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newChangeEventsForProjectStageData(
  data: ChangeEventsForProjectStageDataOptions,
): ChangeEventsForProjectStageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newChangeEventsForProjectStageResponse(
  variables: ChangeEventsForProjectStageQueryVariables,
  data: ChangeEventsForProjectStageDataOptions | Error,
): MockedResponse<ChangeEventsForProjectStageQueryVariables, ChangeEventsForProjectStageQuery> {
  return {
    request: { query: ChangeEventsForProjectStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventsForProjectStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentsPageMetadataDataOptions {
  commitments?: FactoryInput<Commitment, CommitmentOptions>[];
  commitmentStatuses?: FactoryInput<CommitmentStatusDetail, CommitmentStatusDetailOptions>[];
}

export function newCommitmentsPageMetadataData(data: CommitmentsPageMetadataDataOptions): CommitmentsPageMetadataQuery {
  return {
    __typename: "Query" as const,
    commitments: data["commitments"]?.map((d) => maybeNew("Commitment", d, {})) || [],
    commitmentStatuses: data["commitmentStatuses"]?.map((d) => maybeNew("CommitmentStatusDetail", d, {})) || [],
  } as any;
}

export function newCommitmentsPageMetadataResponse(
  variables: CommitmentsPageMetadataQueryVariables,
  data: CommitmentsPageMetadataDataOptions | Error,
): MockedResponse<CommitmentsPageMetadataQueryVariables, CommitmentsPageMetadataQuery> {
  return {
    request: { query: CommitmentsPageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentsPageDataOptions {
  commitments?: FactoryInput<Commitment, CommitmentOptions>[];
}

export function newCommitmentsPageData(data: CommitmentsPageDataOptions): CommitmentsPageQuery {
  return {
    __typename: "Query" as const,
    commitments: data["commitments"]?.map((d) => maybeNew("Commitment", d, {})) || [],
  } as any;
}

export function newCommitmentsPageResponse(
  variables: CommitmentsPageQueryVariables,
  data: CommitmentsPageDataOptions | Error,
): MockedResponse<CommitmentsPageQueryVariables, CommitmentsPageQuery> {
  return {
    request: { query: CommitmentsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentWithProjectItemsDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newCommitmentWithProjectItemsData(
  data: CommitmentWithProjectItemsDataOptions,
): CommitmentWithProjectItemsQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newCommitmentWithProjectItemsResponse(
  variables: CommitmentWithProjectItemsQueryVariables,
  data: CommitmentWithProjectItemsDataOptions | Error,
): MockedResponse<CommitmentWithProjectItemsQueryVariables, CommitmentWithProjectItemsQuery> {
  return {
    request: { query: CommitmentWithProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentWithProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface NewCommitmentWithProjectItemsDataDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
  projectItems?: FactoryInput<ProjectItem, ProjectItemOptions>[];
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newNewCommitmentWithProjectItemsDataData(
  data: NewCommitmentWithProjectItemsDataDataOptions,
): NewCommitmentWithProjectItemsDataQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
    projectItems: data["projectItems"]?.map((d) => maybeNew("ProjectItem", d, {})) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newNewCommitmentWithProjectItemsDataResponse(
  variables: NewCommitmentWithProjectItemsDataQueryVariables,
  data: NewCommitmentWithProjectItemsDataDataOptions | Error,
): MockedResponse<NewCommitmentWithProjectItemsDataQueryVariables, NewCommitmentWithProjectItemsDataQuery> {
  return {
    request: { query: NewCommitmentWithProjectItemsDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newNewCommitmentWithProjectItemsDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentDataOptions {
  saveCommitment?: FactoryInput<SaveCommitmentResult, SaveCommitmentResultOptions>;
}

export function newSaveCommitmentData(data: SaveCommitmentDataOptions): SaveCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitment: maybeNew("SaveCommitmentResult", data["saveCommitment"] || undefined, {}),
  } as any;
}

export function newSaveCommitmentResponse(
  variables: SaveCommitmentMutationVariables,
  data: SaveCommitmentDataOptions | Error,
): MockedResponse<SaveCommitmentMutationVariables, SaveCommitmentMutation> {
  return {
    request: { query: SaveCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCommitmentDataOptions {
  deleteCommitment?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteCommitmentData(data: DeleteCommitmentDataOptions): DeleteCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    deleteCommitment: maybeNew("EmptyResult", data["deleteCommitment"] || undefined, {}),
  } as any;
}

export function newDeleteCommitmentResponse(
  variables: DeleteCommitmentMutationVariables,
  data: DeleteCommitmentDataOptions | Error,
): MockedResponse<DeleteCommitmentMutationVariables, DeleteCommitmentMutation> {
  return {
    request: { query: DeleteCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReleaseBidCommitmentsDataOptions {
  releaseBidCommitments?: FactoryInput<CommitmentLike, CommitmentLikeOptions>[];
}

export function newReleaseBidCommitmentsData(data: ReleaseBidCommitmentsDataOptions): ReleaseBidCommitmentsMutation {
  return {
    __typename: "Mutation" as const,
    releaseBidCommitments: data["releaseBidCommitments"]?.map((d) => maybeNew("CommitmentLike", d, {})) || [],
  } as any;
}

export function newReleaseBidCommitmentsResponse(
  variables: ReleaseBidCommitmentsMutationVariables,
  data: ReleaseBidCommitmentsDataOptions | Error,
): MockedResponse<ReleaseBidCommitmentsMutationVariables, ReleaseBidCommitmentsMutation> {
  return {
    request: { query: ReleaseBidCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newReleaseBidCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentHistoryDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
}

export function newCommitmentHistoryData(data: CommitmentHistoryDataOptions): CommitmentHistoryQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newCommitmentHistoryResponse(
  variables: CommitmentHistoryQueryVariables,
  data: CommitmentHistoryDataOptions | Error,
): MockedResponse<CommitmentHistoryQueryVariables, CommitmentHistoryQuery> {
  return {
    request: { query: CommitmentHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentChangeOrderPageDataOptions {
  commitmentChangeOrder?: FactoryInput<CommitmentChangeOrder, CommitmentChangeOrderOptions>;
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
  projectItems?: FactoryInput<ProjectItem, ProjectItemOptions>[];
}

export function newCommitmentChangeOrderPageData(
  data: CommitmentChangeOrderPageDataOptions,
): CommitmentChangeOrderPageQuery {
  return {
    __typename: "Query" as const,
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    projectItems: data["projectItems"]?.map((d) => maybeNew("ProjectItem", d, {})) || [],
  } as any;
}

export function newCommitmentChangeOrderPageResponse(
  variables: CommitmentChangeOrderPageQueryVariables,
  data: CommitmentChangeOrderPageDataOptions | Error,
): MockedResponse<CommitmentChangeOrderPageQueryVariables, CommitmentChangeOrderPageQuery> {
  return {
    request: { query: CommitmentChangeOrderPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentChangeOrderPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentChangeOrderDataOptions {
  saveCommitmentChangeOrder?: FactoryInput<SaveCommitmentChangeOrderResult, SaveCommitmentChangeOrderResultOptions>;
}

export function newSaveCommitmentChangeOrderData(
  data: SaveCommitmentChangeOrderDataOptions,
): SaveCommitmentChangeOrderMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitmentChangeOrder: maybeNew(
      "SaveCommitmentChangeOrderResult",
      data["saveCommitmentChangeOrder"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveCommitmentChangeOrderResponse(
  variables: SaveCommitmentChangeOrderMutationVariables,
  data: SaveCommitmentChangeOrderDataOptions | Error,
): MockedResponse<SaveCommitmentChangeOrderMutationVariables, SaveCommitmentChangeOrderMutation> {
  return {
    request: { query: SaveCommitmentChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCommitmentChangeOrderDataOptions {
  deleteCommitmentChangeOrder?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteCommitmentChangeOrderData(
  data: DeleteCommitmentChangeOrderDataOptions,
): DeleteCommitmentChangeOrderMutation {
  return {
    __typename: "Mutation" as const,
    deleteCommitmentChangeOrder: maybeNew("EmptyResult", data["deleteCommitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newDeleteCommitmentChangeOrderResponse(
  variables: DeleteCommitmentChangeOrderMutationVariables,
  data: DeleteCommitmentChangeOrderDataOptions | Error,
): MockedResponse<DeleteCommitmentChangeOrderMutationVariables, DeleteCommitmentChangeOrderMutation> {
  return {
    request: { query: DeleteCommitmentChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCommitmentChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddLaborItemModal_GlobalPlanTasksDataOptions {
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
}

export function newAddLaborItemModal_GlobalPlanTasksData(
  data: AddLaborItemModal_GlobalPlanTasksDataOptions,
): AddLaborItemModal_GlobalPlanTasksQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newAddLaborItemModal_GlobalPlanTasksResponse(
  variables: AddLaborItemModal_GlobalPlanTasksQueryVariables,
  data: AddLaborItemModal_GlobalPlanTasksDataOptions | Error,
): MockedResponse<AddLaborItemModal_GlobalPlanTasksQueryVariables, AddLaborItemModal_GlobalPlanTasksQuery> {
  return {
    request: { query: AddLaborItemModal_GlobalPlanTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddLaborItemModal_GlobalPlanTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddLaborItemModal_EffectiveLocationsDataOptions {
  locations?: FactoryInput<Location, LocationOptions>[];
}

export function newAddLaborItemModal_EffectiveLocationsData(
  data: AddLaborItemModal_EffectiveLocationsDataOptions,
): AddLaborItemModal_EffectiveLocationsQuery {
  return {
    __typename: "Query" as const,
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newAddLaborItemModal_EffectiveLocationsResponse(
  variables: AddLaborItemModal_EffectiveLocationsQueryVariables,
  data: AddLaborItemModal_EffectiveLocationsDataOptions | Error,
): MockedResponse<AddLaborItemModal_EffectiveLocationsQueryVariables, AddLaborItemModal_EffectiveLocationsQuery> {
  return {
    request: { query: AddLaborItemModal_EffectiveLocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddLaborItemModal_EffectiveLocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddMaterialItemModalMetadataDataOptions {
  locations?: FactoryInput<Location, LocationOptions>[];
}

export function newAddMaterialItemModalMetadataData(
  data: AddMaterialItemModalMetadataDataOptions,
): AddMaterialItemModalMetadataQuery {
  return {
    __typename: "Query" as const,
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newAddMaterialItemModalMetadataResponse(
  variables: AddMaterialItemModalMetadataQueryVariables,
  data: AddMaterialItemModalMetadataDataOptions | Error,
): MockedResponse<AddMaterialItemModalMetadataQueryVariables, AddMaterialItemModalMetadataQuery> {
  return {
    request: { query: AddMaterialItemModalMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddMaterialItemModalMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RedirectToActiveStageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newRedirectToActiveStageData(data: RedirectToActiveStageDataOptions): RedirectToActiveStageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newRedirectToActiveStageResponse(
  variables: RedirectToActiveStageQueryVariables,
  data: RedirectToActiveStageDataOptions | Error,
): MockedResponse<RedirectToActiveStageQueryVariables, RedirectToActiveStageQuery> {
  return {
    request: { query: RedirectToActiveStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newRedirectToActiveStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotConfigurationDetailsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
}

export function newLotConfigurationDetailsData(data: LotConfigurationDetailsDataOptions): LotConfigurationDetailsQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
  } as any;
}

export function newLotConfigurationDetailsResponse(
  variables: LotConfigurationDetailsQueryVariables,
  data: LotConfigurationDetailsDataOptions | Error,
): MockedResponse<LotConfigurationDetailsQueryVariables, LotConfigurationDetailsQuery> {
  return {
    request: { query: LotConfigurationDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotConfigurationDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyDashboardPage_ProjectsDataOptions {
  projectsPage?: FactoryInput<ProjectsPageResult, ProjectsPageResultOptions>;
}

export function newHierarchyDashboardPage_ProjectsData(
  data: HierarchyDashboardPage_ProjectsDataOptions,
): HierarchyDashboardPage_ProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newHierarchyDashboardPage_ProjectsResponse(
  variables: HierarchyDashboardPage_ProjectsQueryVariables,
  data: HierarchyDashboardPage_ProjectsDataOptions | Error,
): MockedResponse<HierarchyDashboardPage_ProjectsQueryVariables, HierarchyDashboardPage_ProjectsQuery> {
  return {
    request: { query: HierarchyDashboardPage_ProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyDashboardPage_ProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyDashboardPage_FilterOptionsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newHierarchyDashboardPage_FilterOptionsData(
  data: HierarchyDashboardPage_FilterOptionsDataOptions,
): HierarchyDashboardPage_FilterOptionsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newHierarchyDashboardPage_FilterOptionsResponse(
  variables: HierarchyDashboardPage_FilterOptionsQueryVariables,
  data: HierarchyDashboardPage_FilterOptionsDataOptions | Error,
): MockedResponse<HierarchyDashboardPage_FilterOptionsQueryVariables, HierarchyDashboardPage_FilterOptionsQuery> {
  return {
    request: { query: HierarchyDashboardPage_FilterOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyDashboardPage_FilterOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentsPageMetadataDataOptions {
  documentTypes?: FactoryInput<DocumentTypeDetail, DocumentTypeDetailOptions>[];
  documentCategories?: FactoryInput<DocumentCategoryDetail, DocumentCategoryDetailOptions>[];
  development?: FactoryInput<Development, DevelopmentOptions>;
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newDocumentsPageMetadataData(data: DocumentsPageMetadataDataOptions): DocumentsPageMetadataQuery {
  return {
    __typename: "Query" as const,
    documentTypes: data["documentTypes"]?.map((d) => maybeNew("DocumentTypeDetail", d, {})) || [],
    documentCategories: data["documentCategories"]?.map((d) => maybeNew("DocumentCategoryDetail", d, {})) || [],
    development: maybeNew("Development", data["development"] || undefined, {}),
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newDocumentsPageMetadataResponse(
  variables: DocumentsPageMetadataQueryVariables,
  data: DocumentsPageMetadataDataOptions | Error,
): MockedResponse<DocumentsPageMetadataQueryVariables, DocumentsPageMetadataQuery> {
  return {
    request: { query: DocumentsPageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentsPageDataOptions {
  documents?: FactoryInput<DocumentsPageResult, DocumentsPageResultOptions>;
}

export function newDocumentsPageData(data: DocumentsPageDataOptions): DocumentsPageQuery {
  return {
    __typename: "Query" as const,
    documents: maybeNew("DocumentsPageResult", data["documents"] || undefined, {}),
  } as any;
}

export function newDocumentsPageResponse(
  variables: DocumentsPageQueryVariables,
  data: DocumentsPageDataOptions | Error,
): MockedResponse<DocumentsPageQueryVariables, DocumentsPageQuery> {
  return {
    request: { query: DocumentsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentsAssetDataOptions {
  documents?: FactoryInput<Document, DocumentOptions>[];
}

export function newDocumentsAssetData(data: DocumentsAssetDataOptions): DocumentsAssetQuery {
  return {
    __typename: "Query" as const,
    documents: data["documents"]?.map((d) => maybeNew("Document", d, {})) || [],
  } as any;
}

export function newDocumentsAssetResponse(
  variables: DocumentsAssetQueryVariables,
  data: DocumentsAssetDataOptions | Error,
): MockedResponse<DocumentsAssetQueryVariables, DocumentsAssetQuery> {
  return {
    request: { query: DocumentsAssetDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentsAssetData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksForDocumentParentDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newScheduleTasksForDocumentParentData(
  data: ScheduleTasksForDocumentParentDataOptions,
): ScheduleTasksForDocumentParentQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newScheduleTasksForDocumentParentResponse(
  variables: ScheduleTasksForDocumentParentQueryVariables,
  data: ScheduleTasksForDocumentParentDataOptions | Error,
): MockedResponse<ScheduleTasksForDocumentParentQueryVariables, ScheduleTasksForDocumentParentQuery> {
  return {
    request: { query: ScheduleTasksForDocumentParentDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksForDocumentParentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentEditorDataOptions {
  document?: FactoryInput<Document, DocumentOptions>;
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newDocumentEditorData(data: DocumentEditorDataOptions): DocumentEditorQuery {
  return {
    __typename: "Query" as const,
    document: maybeNew("Document", data["document"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newDocumentEditorResponse(
  variables: DocumentEditorQueryVariables,
  data: DocumentEditorDataOptions | Error,
): MockedResponse<DocumentEditorQueryVariables, DocumentEditorQuery> {
  return {
    request: { query: DocumentEditorDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentEditorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentsForParentDataOptions {
  documents?: FactoryInput<Document, DocumentOptions>[];
}

export function newDocumentsForParentData(data: DocumentsForParentDataOptions): DocumentsForParentQuery {
  return {
    __typename: "Query" as const,
    documents: data["documents"]?.map((d) => maybeNew("Document", d, {})) || [],
  } as any;
}

export function newDocumentsForParentResponse(
  variables: DocumentsForParentQueryVariables,
  data: DocumentsForParentDataOptions | Error,
): MockedResponse<DocumentsForParentQueryVariables, DocumentsForParentQuery> {
  return {
    request: { query: DocumentsForParentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentsForParentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentCategoriesDataOptions {
  documentCategories?: FactoryInput<DocumentCategoryDetail, DocumentCategoryDetailOptions>[];
}

export function newDocumentCategoriesData(data: DocumentCategoriesDataOptions): DocumentCategoriesQuery {
  return {
    __typename: "Query" as const,
    documentCategories: data["documentCategories"]?.map((d) => maybeNew("DocumentCategoryDetail", d, {})) || [],
  } as any;
}

export function newDocumentCategoriesResponse(
  data: DocumentCategoriesDataOptions | Error,
): MockedResponse<DocumentCategoriesQueryVariables, DocumentCategoriesQuery> {
  return {
    request: { query: DocumentCategoriesDocument },
    result: { data: data instanceof Error ? undefined : newDocumentCategoriesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDocumentsDataOptions {
  saveDocuments?: FactoryInput<SaveDocumentsResult, SaveDocumentsResultOptions>;
}

export function newSaveDocumentsData(data: SaveDocumentsDataOptions): SaveDocumentsMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveDocumentsResponse(
  variables: SaveDocumentsMutationVariables,
  data: SaveDocumentsDataOptions | Error,
): MockedResponse<SaveDocumentsMutationVariables, SaveDocumentsMutation> {
  return {
    request: { query: SaveDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToggleDocumentAsFavoritedDataOptions {
  toggleDocumentAsFavorited?: FactoryInput<ToggleDocumentAsFavoritedResult, ToggleDocumentAsFavoritedResultOptions>;
}

export function newToggleDocumentAsFavoritedData(
  data: ToggleDocumentAsFavoritedDataOptions,
): ToggleDocumentAsFavoritedMutation {
  return {
    __typename: "Mutation" as const,
    toggleDocumentAsFavorited: maybeNew(
      "ToggleDocumentAsFavoritedResult",
      data["toggleDocumentAsFavorited"] || undefined,
      {},
    ),
  } as any;
}

export function newToggleDocumentAsFavoritedResponse(
  variables: ToggleDocumentAsFavoritedMutationVariables,
  data: ToggleDocumentAsFavoritedDataOptions | Error,
): MockedResponse<ToggleDocumentAsFavoritedMutationVariables, ToggleDocumentAsFavoritedMutation> {
  return {
    request: { query: ToggleDocumentAsFavoritedDocument, variables },
    result: { data: data instanceof Error ? undefined : newToggleDocumentAsFavoritedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDocumentsDataOptions {
  deleteDocuments?: FactoryInput<DeleteDocumentsResult, DeleteDocumentsResultOptions>;
}

export function newDeleteDocumentsData(data: DeleteDocumentsDataOptions): DeleteDocumentsMutation {
  return {
    __typename: "Mutation" as const,
    deleteDocuments: maybeNew("DeleteDocumentsResult", data["deleteDocuments"] || undefined, {}),
  } as any;
}

export function newDeleteDocumentsResponse(
  variables: DeleteDocumentsMutationVariables,
  data: DeleteDocumentsDataOptions | Error,
): MockedResponse<DeleteDocumentsMutationVariables, DeleteDocumentsMutation> {
  return {
    request: { query: DeleteDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateEstimateStagesDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newCreateEstimateStagesData(data: CreateEstimateStagesDataOptions): CreateEstimateStagesQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newCreateEstimateStagesResponse(
  variables: CreateEstimateStagesQueryVariables,
  data: CreateEstimateStagesDataOptions | Error,
): MockedResponse<CreateEstimateStagesQueryVariables, CreateEstimateStagesQuery> {
  return {
    request: { query: CreateEstimateStagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateEstimateStagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateEstimateDataOptions {
  saveEstimate?: FactoryInput<SaveEstimateResult, SaveEstimateResultOptions>;
}

export function newCreateEstimateData(data: CreateEstimateDataOptions): CreateEstimateMutation {
  return {
    __typename: "Mutation" as const,
    saveEstimate: maybeNew("SaveEstimateResult", data["saveEstimate"] || undefined, {}),
  } as any;
}

export function newCreateEstimateResponse(
  variables: CreateEstimateMutationVariables,
  data: CreateEstimateDataOptions | Error,
): MockedResponse<CreateEstimateMutationVariables, CreateEstimateMutation> {
  return {
    request: { query: CreateEstimateDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateEstimateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EstimateHistoryDataOptions {
  projectEstimate?: FactoryInput<Estimate, EstimateOptions>;
}

export function newEstimateHistoryData(data: EstimateHistoryDataOptions): EstimateHistoryQuery {
  return {
    __typename: "Query" as const,
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
  } as any;
}

export function newEstimateHistoryResponse(
  variables: EstimateHistoryQueryVariables,
  data: EstimateHistoryDataOptions | Error,
): MockedResponse<EstimateHistoryQueryVariables, EstimateHistoryQuery> {
  return {
    request: { query: EstimateHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newEstimateHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EstimateLineItemTabDataOptions {
  projectEstimate?: FactoryInput<Estimate, EstimateOptions>;
  costConfidences?: FactoryInput<CostConfidenceDetail, CostConfidenceDetailOptions>[];
}

export function newEstimateLineItemTabData(data: EstimateLineItemTabDataOptions): EstimateLineItemTabQuery {
  return {
    __typename: "Query" as const,
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
    costConfidences: data["costConfidences"]?.map((d) => maybeNew("CostConfidenceDetail", d, {})) || [],
  } as any;
}

export function newEstimateLineItemTabResponse(
  variables: EstimateLineItemTabQueryVariables,
  data: EstimateLineItemTabDataOptions | Error,
): MockedResponse<EstimateLineItemTabQueryVariables, EstimateLineItemTabQuery> {
  return {
    request: { query: EstimateLineItemTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newEstimateLineItemTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EstimatePageDataOptions {
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  projectEstimate?: FactoryInput<Estimate, EstimateOptions>;
}

export function newEstimatePageData(data: EstimatePageDataOptions): EstimatePageQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
  } as any;
}

export function newEstimatePageResponse(
  variables: EstimatePageQueryVariables,
  data: EstimatePageDataOptions | Error,
): MockedResponse<EstimatePageQueryVariables, EstimatePageQuery> {
  return {
    request: { query: EstimatePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEstimatePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveEstimateDataOptions {
  saveEstimate?: FactoryInput<SaveEstimateResult, SaveEstimateResultOptions>;
}

export function newSaveEstimateData(data: SaveEstimateDataOptions): SaveEstimateMutation {
  return {
    __typename: "Mutation" as const,
    saveEstimate: maybeNew("SaveEstimateResult", data["saveEstimate"] || undefined, {}),
  } as any;
}

export function newSaveEstimateResponse(
  variables: SaveEstimateMutationVariables,
  data: SaveEstimateDataOptions | Error,
): MockedResponse<SaveEstimateMutationVariables, SaveEstimateMutation> {
  return {
    request: { query: SaveEstimateDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveEstimateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectEstimatesPageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectEstimatesPageData(data: ProjectEstimatesPageDataOptions): ProjectEstimatesPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectEstimatesPageResponse(
  variables: ProjectEstimatesPageQueryVariables,
  data: ProjectEstimatesPageDataOptions | Error,
): MockedResponse<ProjectEstimatesPageQueryVariables, ProjectEstimatesPageQuery> {
  return {
    request: { query: ProjectEstimatesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectEstimatesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFinishScheduleDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectFinishScheduleData(data: ProjectFinishScheduleDataOptions): ProjectFinishScheduleQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectFinishScheduleResponse(
  variables: ProjectFinishScheduleQueryVariables,
  data: ProjectFinishScheduleDataOptions | Error,
): MockedResponse<ProjectFinishScheduleQueryVariables, ProjectFinishScheduleQuery> {
  return {
    request: { query: ProjectFinishScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFinishScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFinishScheduleMetadataDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectFinishScheduleMetadataData(
  data: ProjectFinishScheduleMetadataDataOptions,
): ProjectFinishScheduleMetadataQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectFinishScheduleMetadataResponse(
  variables: ProjectFinishScheduleMetadataQueryVariables,
  data: ProjectFinishScheduleMetadataDataOptions | Error,
): MockedResponse<ProjectFinishScheduleMetadataQueryVariables, ProjectFinishScheduleMetadataQuery> {
  return {
    request: { query: ProjectFinishScheduleMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFinishScheduleMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ExpensesPageMetadataDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newExpensesPageMetadataData(data: ExpensesPageMetadataDataOptions): ExpensesPageMetadataQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newExpensesPageMetadataResponse(
  variables: ExpensesPageMetadataQueryVariables,
  data: ExpensesPageMetadataDataOptions | Error,
): MockedResponse<ExpensesPageMetadataQueryVariables, ExpensesPageMetadataQuery> {
  return {
    request: { query: ExpensesPageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newExpensesPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerContractLikeScheduleDataOptions {
  homeownerContract?: FactoryInput<HomeownerContract, HomeownerContractOptions>;
  homeownerContractChangeOrder?: FactoryInput<HomeownerContractChangeOrder, HomeownerContractChangeOrderOptions>;
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newHomeownerContractLikeScheduleData(
  data: HomeownerContractLikeScheduleDataOptions,
): HomeownerContractLikeScheduleQuery {
  return {
    __typename: "Query" as const,
    homeownerContract: maybeNew("HomeownerContract", data["homeownerContract"] || undefined, {}),
    homeownerContractChangeOrder: maybeNew(
      "HomeownerContractChangeOrder",
      data["homeownerContractChangeOrder"] || undefined,
      {},
    ),
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newHomeownerContractLikeScheduleResponse(
  variables: HomeownerContractLikeScheduleQueryVariables,
  data: HomeownerContractLikeScheduleDataOptions | Error,
): MockedResponse<HomeownerContractLikeScheduleQueryVariables, HomeownerContractLikeScheduleQuery> {
  return {
    request: { query: HomeownerContractLikeScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerContractLikeScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerContractDrawsDataOptions {
  saveHomeownerContract?: FactoryInput<SaveHomeownerContractResult, SaveHomeownerContractResultOptions>;
}

export function newSaveHomeownerContractDrawsData(
  data: SaveHomeownerContractDrawsDataOptions,
): SaveHomeownerContractDrawsMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerContract: maybeNew("SaveHomeownerContractResult", data["saveHomeownerContract"] || undefined, {}),
  } as any;
}

export function newSaveHomeownerContractDrawsResponse(
  variables: SaveHomeownerContractDrawsMutationVariables,
  data: SaveHomeownerContractDrawsDataOptions | Error,
): MockedResponse<SaveHomeownerContractDrawsMutationVariables, SaveHomeownerContractDrawsMutation> {
  return {
    request: { query: SaveHomeownerContractDrawsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerContractDrawsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerContractChangeOrderDrawsDataOptions {
  saveHomeownerContractChangeOrder?: FactoryInput<
    SaveHomeownerContractChangeOrderResult,
    SaveHomeownerContractChangeOrderResultOptions
  >;
}

export function newSaveHomeownerContractChangeOrderDrawsData(
  data: SaveHomeownerContractChangeOrderDrawsDataOptions,
): SaveHomeownerContractChangeOrderDrawsMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerContractChangeOrder: maybeNew(
      "SaveHomeownerContractChangeOrderResult",
      data["saveHomeownerContractChangeOrder"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveHomeownerContractChangeOrderDrawsResponse(
  variables: SaveHomeownerContractChangeOrderDrawsMutationVariables,
  data: SaveHomeownerContractChangeOrderDrawsDataOptions | Error,
): MockedResponse<
  SaveHomeownerContractChangeOrderDrawsMutationVariables,
  SaveHomeownerContractChangeOrderDrawsMutation
> {
  return {
    request: { query: SaveHomeownerContractChangeOrderDrawsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerContractChangeOrderDrawsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerContractDataOptions {
  homeownerContract?: FactoryInput<HomeownerContract, HomeownerContractOptions>;
}

export function newHomeownerContractData(data: HomeownerContractDataOptions): HomeownerContractQuery {
  return {
    __typename: "Query" as const,
    homeownerContract: maybeNew("HomeownerContract", data["homeownerContract"] || undefined, {}),
  } as any;
}

export function newHomeownerContractResponse(
  variables: HomeownerContractQueryVariables,
  data: HomeownerContractDataOptions | Error,
): MockedResponse<HomeownerContractQueryVariables, HomeownerContractQuery> {
  return {
    request: { query: HomeownerContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerContractDataOptions {
  saveHomeownerContract?: FactoryInput<SaveHomeownerContractResult, SaveHomeownerContractResultOptions>;
}

export function newSaveHomeownerContractData(data: SaveHomeownerContractDataOptions): SaveHomeownerContractMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerContract: maybeNew("SaveHomeownerContractResult", data["saveHomeownerContract"] || undefined, {}),
  } as any;
}

export function newSaveHomeownerContractResponse(
  variables: SaveHomeownerContractMutationVariables,
  data: SaveHomeownerContractDataOptions | Error,
): MockedResponse<SaveHomeownerContractMutationVariables, SaveHomeownerContractMutation> {
  return {
    request: { query: SaveHomeownerContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerContractChangeOrder2DataOptions {
  homeownerContractChangeOrder?: FactoryInput<HomeownerContractChangeOrder, HomeownerContractChangeOrderOptions>;
}

export function newHomeownerContractChangeOrder2Data(
  data: HomeownerContractChangeOrder2DataOptions,
): HomeownerContractChangeOrder2Query {
  return {
    __typename: "Query" as const,
    homeownerContractChangeOrder: maybeNew(
      "HomeownerContractChangeOrder",
      data["homeownerContractChangeOrder"] || undefined,
      {},
    ),
  } as any;
}

export function newHomeownerContractChangeOrder2Response(
  variables: HomeownerContractChangeOrder2QueryVariables,
  data: HomeownerContractChangeOrder2DataOptions | Error,
): MockedResponse<HomeownerContractChangeOrder2QueryVariables, HomeownerContractChangeOrder2Query> {
  return {
    request: { query: HomeownerContractChangeOrder2Document, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerContractChangeOrder2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerContractChangeOrderDataOptions {
  saveHomeownerContractChangeOrder?: FactoryInput<
    SaveHomeownerContractChangeOrderResult,
    SaveHomeownerContractChangeOrderResultOptions
  >;
}

export function newSaveHomeownerContractChangeOrderData(
  data: SaveHomeownerContractChangeOrderDataOptions,
): SaveHomeownerContractChangeOrderMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerContractChangeOrder: maybeNew(
      "SaveHomeownerContractChangeOrderResult",
      data["saveHomeownerContractChangeOrder"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveHomeownerContractChangeOrderResponse(
  variables: SaveHomeownerContractChangeOrderMutationVariables,
  data: SaveHomeownerContractChangeOrderDataOptions | Error,
): MockedResponse<SaveHomeownerContractChangeOrderMutationVariables, SaveHomeownerContractChangeOrderMutation> {
  return {
    request: { query: SaveHomeownerContractChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerContractChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceScheduleDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newInvoiceScheduleData(data: InvoiceScheduleDataOptions): InvoiceScheduleQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newInvoiceScheduleResponse(
  variables: InvoiceScheduleQueryVariables,
  data: InvoiceScheduleDataOptions | Error,
): MockedResponse<InvoiceScheduleQueryVariables, InvoiceScheduleQuery> {
  return {
    request: { query: InvoiceScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GeneratePocInvoiceDataOptions {
  saveInvoice?: FactoryInput<SaveInvoiceResult, SaveInvoiceResultOptions>;
}

export function newGeneratePocInvoiceData(data: GeneratePocInvoiceDataOptions): GeneratePocInvoiceMutation {
  return {
    __typename: "Mutation" as const,
    saveInvoice: maybeNew("SaveInvoiceResult", data["saveInvoice"] || undefined, {}),
  } as any;
}

export function newGeneratePocInvoiceResponse(
  variables: GeneratePocInvoiceMutationVariables,
  data: GeneratePocInvoiceDataOptions | Error,
): MockedResponse<GeneratePocInvoiceMutationVariables, GeneratePocInvoiceMutation> {
  return {
    request: { query: GeneratePocInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newGeneratePocInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectItemBillDetailsDataOptions {
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
}

export function newProjectItemBillDetailsData(data: ProjectItemBillDetailsDataOptions): ProjectItemBillDetailsQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newProjectItemBillDetailsResponse(
  variables: ProjectItemBillDetailsQueryVariables,
  data: ProjectItemBillDetailsDataOptions | Error,
): MockedResponse<ProjectItemBillDetailsQueryVariables, ProjectItemBillDetailsQuery> {
  return {
    request: { query: ProjectItemBillDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectItemBillDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerNotesForProjectDataOptions {
  homeownerNotes?: FactoryInput<HomeownerNote, HomeownerNoteOptions>[];
}

export function newHomeownerNotesForProjectData(
  data: HomeownerNotesForProjectDataOptions,
): HomeownerNotesForProjectQuery {
  return {
    __typename: "Query" as const,
    homeownerNotes: data["homeownerNotes"]?.map((d) => maybeNew("HomeownerNote", d, {})) || [],
  } as any;
}

export function newHomeownerNotesForProjectResponse(
  variables: HomeownerNotesForProjectQueryVariables,
  data: HomeownerNotesForProjectDataOptions | Error,
): MockedResponse<HomeownerNotesForProjectQueryVariables, HomeownerNotesForProjectQuery> {
  return {
    request: { query: HomeownerNotesForProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerNotesForProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceEditDataOptions {
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newInvoiceEditData(data: InvoiceEditDataOptions): InvoiceEditQuery {
  return {
    __typename: "Query" as const,
    invoice: maybeNew("Invoice", data["invoice"] || undefined, {}),
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newInvoiceEditResponse(
  variables: InvoiceEditQueryVariables,
  data: InvoiceEditDataOptions | Error,
): MockedResponse<InvoiceEditQueryVariables, InvoiceEditQuery> {
  return {
    request: { query: InvoiceEditDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceEditData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveInvoiceDataOptions {
  saveInvoice?: FactoryInput<SaveInvoiceResult, SaveInvoiceResultOptions>;
}

export function newSaveInvoiceData(data: SaveInvoiceDataOptions): SaveInvoiceMutation {
  return {
    __typename: "Mutation" as const,
    saveInvoice: maybeNew("SaveInvoiceResult", data["saveInvoice"] || undefined, {}),
  } as any;
}

export function newSaveInvoiceResponse(
  variables: SaveInvoiceMutationVariables,
  data: SaveInvoiceDataOptions | Error,
): MockedResponse<SaveInvoiceMutationVariables, SaveInvoiceMutation> {
  return {
    request: { query: SaveInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteInvoiceDataOptions {
  deleteInvoice?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteInvoiceData(data: DeleteInvoiceDataOptions): DeleteInvoiceMutation {
  return {
    __typename: "Mutation" as const,
    deleteInvoice: maybeNew("EmptyResult", data["deleteInvoice"] || undefined, {}),
  } as any;
}

export function newDeleteInvoiceResponse(
  variables: DeleteInvoiceMutationVariables,
  data: DeleteInvoiceDataOptions | Error,
): MockedResponse<DeleteInvoiceMutationVariables, DeleteInvoiceMutation> {
  return {
    request: { query: DeleteInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceProjectStageModalDetailsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newInvoiceProjectStageModalDetailsData(
  data: InvoiceProjectStageModalDetailsDataOptions,
): InvoiceProjectStageModalDetailsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newInvoiceProjectStageModalDetailsResponse(
  variables: InvoiceProjectStageModalDetailsQueryVariables,
  data: InvoiceProjectStageModalDetailsDataOptions | Error,
): MockedResponse<InvoiceProjectStageModalDetailsQueryVariables, InvoiceProjectStageModalDetailsQuery> {
  return {
    request: { query: InvoiceProjectStageModalDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceProjectStageModalDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectInvoicesPageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectInvoicesPageData(data: ProjectInvoicesPageDataOptions): ProjectInvoicesPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectInvoicesPageResponse(
  variables: ProjectInvoicesPageQueryVariables,
  data: ProjectInvoicesPageDataOptions | Error,
): MockedResponse<ProjectInvoicesPageQueryVariables, ProjectInvoicesPageQuery> {
  return {
    request: { query: ProjectInvoicesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectInvoicesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoicePageStatusDataOptions {
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
}

export function newInvoicePageStatusData(data: InvoicePageStatusDataOptions): InvoicePageStatusQuery {
  return { __typename: "Query" as const, invoice: maybeNew("Invoice", data["invoice"] || undefined, {}) } as any;
}

export function newInvoicePageStatusResponse(
  variables: InvoicePageStatusQueryVariables,
  data: InvoicePageStatusDataOptions | Error,
): MockedResponse<InvoicePageStatusQueryVariables, InvoicePageStatusQuery> {
  return {
    request: { query: InvoicePageStatusDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoicePageStatusData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectItemsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newProjectItemsData(data: ProjectItemsDataOptions): ProjectItemsQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
  } as any;
}

export function newProjectItemsResponse(
  variables: ProjectItemsQueryVariables,
  data: ProjectItemsDataOptions | Error,
): MockedResponse<ProjectItemsQueryVariables, ProjectItemsQuery> {
  return {
    request: { query: ProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectItemDataOptions {
  saveProjectItems?: FactoryInput<SaveProjectItemsResult, SaveProjectItemsResultOptions>;
}

export function newSaveProjectItemData(data: SaveProjectItemDataOptions): SaveProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newSaveProjectItemResponse(
  variables: SaveProjectItemMutationVariables,
  data: SaveProjectItemDataOptions | Error,
): MockedResponse<SaveProjectItemMutationVariables, SaveProjectItemMutation> {
  return {
    request: { query: SaveProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogNoteHistoryTabDataOptions {
  jobLogNote?: FactoryInput<JobLogNote, JobLogNoteOptions>;
}

export function newJobLogNoteHistoryTabData(data: JobLogNoteHistoryTabDataOptions): JobLogNoteHistoryTabQuery {
  return {
    __typename: "Query" as const,
    jobLogNote: maybeNew("JobLogNote", data["jobLogNote"] || undefined, {}),
  } as any;
}

export function newJobLogNoteHistoryTabResponse(
  variables: JobLogNoteHistoryTabQueryVariables,
  data: JobLogNoteHistoryTabDataOptions | Error,
): MockedResponse<JobLogNoteHistoryTabQueryVariables, JobLogNoteHistoryTabQuery> {
  return {
    request: { query: JobLogNoteHistoryTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogNoteHistoryTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogDataOptions {
  jobLog?: FactoryInput<JobLog, JobLogOptions>;
}

export function newJobLogData(data: JobLogDataOptions): JobLogQuery {
  return { __typename: "Query" as const, jobLog: maybeNew("JobLog", data["jobLog"] || undefined, {}) } as any;
}

export function newJobLogResponse(
  variables: JobLogQueryVariables,
  data: JobLogDataOptions | Error,
): MockedResponse<JobLogQueryVariables, JobLogQuery> {
  return {
    request: { query: JobLogDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsDataOptions {
  jobLogsPage?: FactoryInput<JobLogsPageResult, JobLogsPageResultOptions>;
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newJobLogsData(data: JobLogsDataOptions): JobLogsQuery {
  return {
    __typename: "Query" as const,
    jobLogsPage: maybeNew("JobLogsPageResult", data["jobLogsPage"] || undefined, {}),
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newJobLogsResponse(
  variables: JobLogsQueryVariables,
  data: JobLogsDataOptions | Error,
): MockedResponse<JobLogsQueryVariables, JobLogsQuery> {
  return {
    request: { query: JobLogsDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsForDatePickerDataOptions {
  jobLogs?: FactoryInput<JobLog, JobLogOptions>[];
}

export function newJobLogsForDatePickerData(data: JobLogsForDatePickerDataOptions): JobLogsForDatePickerQuery {
  return { __typename: "Query" as const, jobLogs: data["jobLogs"]?.map((d) => maybeNew("JobLog", d, {})) || [] } as any;
}

export function newJobLogsForDatePickerResponse(
  variables: JobLogsForDatePickerQueryVariables,
  data: JobLogsForDatePickerDataOptions | Error,
): MockedResponse<JobLogsForDatePickerQueryVariables, JobLogsForDatePickerQuery> {
  return {
    request: { query: JobLogsForDatePickerDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsForDatePickerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsFilterDataDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newJobLogsFilterDataData(data: JobLogsFilterDataDataOptions): JobLogsFilterDataQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newJobLogsFilterDataResponse(
  variables: JobLogsFilterDataQueryVariables,
  data: JobLogsFilterDataDataOptions | Error,
): MockedResponse<JobLogsFilterDataQueryVariables, JobLogsFilterDataQuery> {
  return {
    request: { query: JobLogsFilterDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsFilterDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsForGivenDateAndProjectsForCopyDataOptions {
  jobLogs?: FactoryInput<JobLog, JobLogOptions>[];
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newJobLogsForGivenDateAndProjectsForCopyData(
  data: JobLogsForGivenDateAndProjectsForCopyDataOptions,
): JobLogsForGivenDateAndProjectsForCopyQuery {
  return {
    __typename: "Query" as const,
    jobLogs: data["jobLogs"]?.map((d) => maybeNew("JobLog", d, {})) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newJobLogsForGivenDateAndProjectsForCopyResponse(
  variables: JobLogsForGivenDateAndProjectsForCopyQueryVariables,
  data: JobLogsForGivenDateAndProjectsForCopyDataOptions | Error,
): MockedResponse<JobLogsForGivenDateAndProjectsForCopyQueryVariables, JobLogsForGivenDateAndProjectsForCopyQuery> {
  return {
    request: { query: JobLogsForGivenDateAndProjectsForCopyDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsForGivenDateAndProjectsForCopyData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsDevelopmentProjectsDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newJobLogsDevelopmentProjectsData(
  data: JobLogsDevelopmentProjectsDataOptions,
): JobLogsDevelopmentProjectsQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newJobLogsDevelopmentProjectsResponse(
  variables: JobLogsDevelopmentProjectsQueryVariables,
  data: JobLogsDevelopmentProjectsDataOptions | Error,
): MockedResponse<JobLogsDevelopmentProjectsQueryVariables, JobLogsDevelopmentProjectsQuery> {
  return {
    request: { query: JobLogsDevelopmentProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsDevelopmentProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksForJobLogsDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newScheduleTasksForJobLogsData(data: ScheduleTasksForJobLogsDataOptions): ScheduleTasksForJobLogsQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newScheduleTasksForJobLogsResponse(
  variables: ScheduleTasksForJobLogsQueryVariables,
  data: ScheduleTasksForJobLogsDataOptions | Error,
): MockedResponse<ScheduleTasksForJobLogsQueryVariables, ScheduleTasksForJobLogsQuery> {
  return {
    request: { query: ScheduleTasksForJobLogsDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksForJobLogsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksOnJobLogNoteDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newScheduleTasksOnJobLogNoteData(
  data: ScheduleTasksOnJobLogNoteDataOptions,
): ScheduleTasksOnJobLogNoteQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newScheduleTasksOnJobLogNoteResponse(
  variables: ScheduleTasksOnJobLogNoteQueryVariables,
  data: ScheduleTasksOnJobLogNoteDataOptions | Error,
): MockedResponse<ScheduleTasksOnJobLogNoteQueryVariables, ScheduleTasksOnJobLogNoteQuery> {
  return {
    request: { query: ScheduleTasksOnJobLogNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksOnJobLogNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleFlagsOnJobLogNoteDataOptions {
  scheduleFlags?: FactoryInput<ScheduleFlag, ScheduleFlagOptions>[];
}

export function newScheduleFlagsOnJobLogNoteData(
  data: ScheduleFlagsOnJobLogNoteDataOptions,
): ScheduleFlagsOnJobLogNoteQuery {
  return {
    __typename: "Query" as const,
    scheduleFlags: data["scheduleFlags"]?.map((d) => maybeNew("ScheduleFlag", d, {})) || [],
  } as any;
}

export function newScheduleFlagsOnJobLogNoteResponse(
  variables: ScheduleFlagsOnJobLogNoteQueryVariables,
  data: ScheduleFlagsOnJobLogNoteDataOptions | Error,
): MockedResponse<ScheduleFlagsOnJobLogNoteQueryVariables, ScheduleFlagsOnJobLogNoteQuery> {
  return {
    request: { query: ScheduleFlagsOnJobLogNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleFlagsOnJobLogNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsProjectEditabilityDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newJobLogsProjectEditabilityData(
  data: JobLogsProjectEditabilityDataOptions,
): JobLogsProjectEditabilityQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newJobLogsProjectEditabilityResponse(
  variables: JobLogsProjectEditabilityQueryVariables,
  data: JobLogsProjectEditabilityDataOptions | Error,
): MockedResponse<JobLogsProjectEditabilityQueryVariables, JobLogsProjectEditabilityQuery> {
  return {
    request: { query: JobLogsProjectEditabilityDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsProjectEditabilityData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveJobLogDataOptions {
  saveJobLog?: FactoryInput<SaveJobLogResult, SaveJobLogResultOptions>;
}

export function newSaveJobLogData(data: SaveJobLogDataOptions): SaveJobLogMutation {
  return {
    __typename: "Mutation" as const,
    saveJobLog: maybeNew("SaveJobLogResult", data["saveJobLog"] || undefined, {}),
  } as any;
}

export function newSaveJobLogResponse(
  variables: SaveJobLogMutationVariables,
  data: SaveJobLogDataOptions | Error,
): MockedResponse<SaveJobLogMutationVariables, SaveJobLogMutation> {
  return {
    request: { query: SaveJobLogDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveJobLogData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveJobLogNoteDataOptions {
  saveJobLogNote?: FactoryInput<SaveJobLogNoteResult, SaveJobLogNoteResultOptions>;
}

export function newSaveJobLogNoteData(data: SaveJobLogNoteDataOptions): SaveJobLogNoteMutation {
  return {
    __typename: "Mutation" as const,
    saveJobLogNote: maybeNew("SaveJobLogNoteResult", data["saveJobLogNote"] || undefined, {}),
  } as any;
}

export function newSaveJobLogNoteResponse(
  variables: SaveJobLogNoteMutationVariables,
  data: SaveJobLogNoteDataOptions | Error,
): MockedResponse<SaveJobLogNoteMutationVariables, SaveJobLogNoteMutation> {
  return {
    request: { query: SaveJobLogNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveJobLogNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteJobLogNoteDataOptions {
  deleteJobLogNote?: FactoryInput<DeleteJobLogNoteResult, DeleteJobLogNoteResultOptions>;
}

export function newDeleteJobLogNoteData(data: DeleteJobLogNoteDataOptions): DeleteJobLogNoteMutation {
  return {
    __typename: "Mutation" as const,
    deleteJobLogNote: maybeNew("DeleteJobLogNoteResult", data["deleteJobLogNote"] || undefined, {}),
  } as any;
}

export function newDeleteJobLogNoteResponse(
  variables: DeleteJobLogNoteMutationVariables,
  data: DeleteJobLogNoteDataOptions | Error,
): MockedResponse<DeleteJobLogNoteMutationVariables, DeleteJobLogNoteMutation> {
  return {
    request: { query: DeleteJobLogNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteJobLogNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveJobLogImageDataOptions {
  saveJobLogImage?: FactoryInput<SaveJobLogImageResult, SaveJobLogImageResultOptions>;
}

export function newSaveJobLogImageData(data: SaveJobLogImageDataOptions): SaveJobLogImageMutation {
  return {
    __typename: "Mutation" as const,
    saveJobLogImage: maybeNew("SaveJobLogImageResult", data["saveJobLogImage"] || undefined, {}),
  } as any;
}

export function newSaveJobLogImageResponse(
  variables: SaveJobLogImageMutationVariables,
  data: SaveJobLogImageDataOptions | Error,
): MockedResponse<SaveJobLogImageMutationVariables, SaveJobLogImageMutation> {
  return {
    request: { query: SaveJobLogImageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveJobLogImageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteJobLogImageDataOptions {
  deleteJobLogImage?: FactoryInput<DeleteJobLogImageResult, DeleteJobLogImageResultOptions>;
}

export function newDeleteJobLogImageData(data: DeleteJobLogImageDataOptions): DeleteJobLogImageMutation {
  return {
    __typename: "Mutation" as const,
    deleteJobLogImage: maybeNew("DeleteJobLogImageResult", data["deleteJobLogImage"] || undefined, {}),
  } as any;
}

export function newDeleteJobLogImageResponse(
  variables: DeleteJobLogImageMutationVariables,
  data: DeleteJobLogImageDataOptions | Error,
): MockedResponse<DeleteJobLogImageMutationVariables, DeleteJobLogImageMutation> {
  return {
    request: { query: DeleteJobLogImageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteJobLogImageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DuplicateJobLogsDataOptions {
  duplicateJobLogs?: FactoryInput<DuplicateJobLogsResult, DuplicateJobLogsResultOptions>;
}

export function newDuplicateJobLogsData(data: DuplicateJobLogsDataOptions): DuplicateJobLogsMutation {
  return {
    __typename: "Mutation" as const,
    duplicateJobLogs: maybeNew("DuplicateJobLogsResult", data["duplicateJobLogs"] || undefined, {}),
  } as any;
}

export function newDuplicateJobLogsResponse(
  variables: DuplicateJobLogsMutationVariables,
  data: DuplicateJobLogsDataOptions | Error,
): MockedResponse<DuplicateJobLogsMutationVariables, DuplicateJobLogsMutation> {
  return {
    request: { query: DuplicateJobLogsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDuplicateJobLogsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfigPageMetaDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  changeEventReasons?: FactoryInput<ChangeEventReason, ChangeEventReasonOptions>[];
}

export function newApplyProductOfferingConfigPageMetaData(
  data: ApplyProductOfferingConfigPageMetaDataOptions,
): ApplyProductOfferingConfigPageMetaQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => maybeNew("ChangeEventReason", d, {})) || [],
  } as any;
}

export function newApplyProductOfferingConfigPageMetaResponse(
  variables: ApplyProductOfferingConfigPageMetaQueryVariables,
  data: ApplyProductOfferingConfigPageMetaDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfigPageMetaQueryVariables, ApplyProductOfferingConfigPageMetaQuery> {
  return {
    request: { query: ApplyProductOfferingConfigPageMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfigPageMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfig_SelectedDataOptions {
  productOfferingConfig?: FactoryInput<ProductOfferingConfig, ProductOfferingConfigOptions>;
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions>;
  projectReadyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>;
}

export function newApplyProductOfferingConfig_SelectedData(
  data: ApplyProductOfferingConfig_SelectedDataOptions,
): ApplyProductOfferingConfig_SelectedQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfig: maybeNew("ProductOfferingConfig", data["productOfferingConfig"] || undefined, {}),
    checkoutConfig: maybeNew("CheckoutConfig", data["checkoutConfig"] || undefined, {}),
    projectReadyPlanConfig: maybeNew("ProjectReadyPlanConfig", data["projectReadyPlanConfig"] || undefined, {}),
  } as any;
}

export function newApplyProductOfferingConfig_SelectedResponse(
  variables: ApplyProductOfferingConfig_SelectedQueryVariables,
  data: ApplyProductOfferingConfig_SelectedDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfig_SelectedQueryVariables, ApplyProductOfferingConfig_SelectedQuery> {
  return {
    request: { query: ApplyProductOfferingConfig_SelectedDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfig_SelectedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfig_ComputeDataOptions {
  computeReadyPlanCost?: FactoryInput<ComputeReadyPlanCostResult, ComputeReadyPlanCostResultOptions>;
}

export function newApplyProductOfferingConfig_ComputeData(
  data: ApplyProductOfferingConfig_ComputeDataOptions,
): ApplyProductOfferingConfig_ComputeQuery {
  return {
    __typename: "Query" as const,
    computeReadyPlanCost: maybeNew("ComputeReadyPlanCostResult", data["computeReadyPlanCost"] || undefined, {}),
  } as any;
}

export function newApplyProductOfferingConfig_ComputeResponse(
  variables: ApplyProductOfferingConfig_ComputeQueryVariables,
  data: ApplyProductOfferingConfig_ComputeDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfig_ComputeQueryVariables, ApplyProductOfferingConfig_ComputeQuery> {
  return {
    request: { query: ApplyProductOfferingConfig_ComputeDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfig_ComputeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfigMetaDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newApplyProductOfferingConfigMetaData(
  data: ApplyProductOfferingConfigMetaDataOptions,
): ApplyProductOfferingConfigMetaQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newApplyProductOfferingConfigMetaResponse(
  variables: ApplyProductOfferingConfigMetaQueryVariables,
  data: ApplyProductOfferingConfigMetaDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfigMetaQueryVariables, ApplyProductOfferingConfigMetaQuery> {
  return {
    request: { query: ApplyProductOfferingConfigMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfigMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfigsDataOptions {
  saveProjectReadyPlanConfigs?: FactoryInput<
    SaveProjectReadyPlanConfigsResult,
    SaveProjectReadyPlanConfigsResultOptions
  >;
}

export function newApplyProductOfferingConfigsData(
  data: ApplyProductOfferingConfigsDataOptions,
): ApplyProductOfferingConfigsMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectReadyPlanConfigs: maybeNew(
      "SaveProjectReadyPlanConfigsResult",
      data["saveProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newApplyProductOfferingConfigsResponse(
  variables: ApplyProductOfferingConfigsMutationVariables,
  data: ApplyProductOfferingConfigsDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfigsMutationVariables, ApplyProductOfferingConfigsMutation> {
  return {
    request: { query: ApplyProductOfferingConfigsDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfigsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateProductOfferingConfigChangeEventDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newCreateProductOfferingConfigChangeEventData(
  data: CreateProductOfferingConfigChangeEventDataOptions,
): CreateProductOfferingConfigChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newCreateProductOfferingConfigChangeEventResponse(
  variables: CreateProductOfferingConfigChangeEventMutationVariables,
  data: CreateProductOfferingConfigChangeEventDataOptions | Error,
): MockedResponse<
  CreateProductOfferingConfigChangeEventMutationVariables,
  CreateProductOfferingConfigChangeEventMutation
> {
  return {
    request: { query: CreateProductOfferingConfigChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateProductOfferingConfigChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectLotSummaryPageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectLotSummaryPageData(data: ProjectLotSummaryPageDataOptions): ProjectLotSummaryPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectLotSummaryPageResponse(
  variables: ProjectLotSummaryPageQueryVariables,
  data: ProjectLotSummaryPageDataOptions | Error,
): MockedResponse<ProjectLotSummaryPageQueryVariables, ProjectLotSummaryPageQuery> {
  return {
    request: { query: ProjectLotSummaryPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectLotSummaryPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface StructureLotSummaryPageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newStructureLotSummaryPageData(data: StructureLotSummaryPageDataOptions): StructureLotSummaryPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newStructureLotSummaryPageResponse(
  variables: StructureLotSummaryPageQueryVariables,
  data: StructureLotSummaryPageDataOptions | Error,
): MockedResponse<StructureLotSummaryPageQueryVariables, StructureLotSummaryPageQuery> {
  return {
    request: { query: StructureLotSummaryPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newStructureLotSummaryPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectSchedulePageV2DataOptions {
  schedules?: FactoryInput<Schedule, ScheduleOptions>[];
  project?: FactoryInput<Project, ProjectOptions>;
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newProjectSchedulePageV2Data(data: ProjectSchedulePageV2DataOptions): ProjectSchedulePageV2Query {
  return {
    __typename: "Query" as const,
    schedules: data["schedules"]?.map((d) => maybeNew("Schedule", d, {})) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newProjectSchedulePageV2Response(
  variables: ProjectSchedulePageV2QueryVariables,
  data: ProjectSchedulePageV2DataOptions | Error,
): MockedResponse<ProjectSchedulePageV2QueryVariables, ProjectSchedulePageV2Query> {
  return {
    request: { query: ProjectSchedulePageV2Document, variables },
    result: { data: data instanceof Error ? undefined : newProjectSchedulePageV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskStatusesDataOptions {
  taskStatuses?: FactoryInput<TaskStatusDetail, TaskStatusDetailOptions>[];
}

export function newTaskStatusesData(data: TaskStatusesDataOptions): TaskStatusesQuery {
  return {
    __typename: "Query" as const,
    taskStatuses: data["taskStatuses"]?.map((d) => maybeNew("TaskStatusDetail", d, {})) || [],
  } as any;
}

export function newTaskStatusesResponse(
  data: TaskStatusesDataOptions | Error,
): MockedResponse<TaskStatusesQueryVariables, TaskStatusesQuery> {
  return {
    request: { query: TaskStatusesDocument },
    result: { data: data instanceof Error ? undefined : newTaskStatusesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AvailableGlobalPhasesDataOptions {
  globalPhases?: FactoryInput<GlobalPhase, GlobalPhaseOptions>[];
  schedulePhases?: FactoryInput<SchedulePhase, SchedulePhaseOptions>[];
}

export function newAvailableGlobalPhasesData(data: AvailableGlobalPhasesDataOptions): AvailableGlobalPhasesQuery {
  return {
    __typename: "Query" as const,
    globalPhases: data["globalPhases"]?.map((d) => maybeNew("GlobalPhase", d, {})) || [],
    schedulePhases: data["schedulePhases"]?.map((d) => maybeNew("SchedulePhase", d, {})) || [],
  } as any;
}

export function newAvailableGlobalPhasesResponse(
  variables: AvailableGlobalPhasesQueryVariables,
  data: AvailableGlobalPhasesDataOptions | Error,
): MockedResponse<AvailableGlobalPhasesQueryVariables, AvailableGlobalPhasesQuery> {
  return {
    request: { query: AvailableGlobalPhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAvailableGlobalPhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleParentGlobalMilestoneTasksDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
  schedules?: FactoryInput<Schedule, ScheduleOptions>[];
}

export function newScheduleParentGlobalMilestoneTasksData(
  data: ScheduleParentGlobalMilestoneTasksDataOptions,
): ScheduleParentGlobalMilestoneTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
    schedules: data["schedules"]?.map((d) => maybeNew("Schedule", d, {})) || [],
  } as any;
}

export function newScheduleParentGlobalMilestoneTasksResponse(
  variables: ScheduleParentGlobalMilestoneTasksQueryVariables,
  data: ScheduleParentGlobalMilestoneTasksDataOptions | Error,
): MockedResponse<ScheduleParentGlobalMilestoneTasksQueryVariables, ScheduleParentGlobalMilestoneTasksQuery> {
  return {
    request: { query: ScheduleParentGlobalMilestoneTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleParentGlobalMilestoneTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleTasksDataOptions {
  saveScheduleTasks?: FactoryInput<SaveScheduleTasksResult, SaveScheduleTasksResultOptions>;
}

export function newSaveScheduleTasksData(data: SaveScheduleTasksDataOptions): SaveScheduleTasksMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTasks: maybeNew("SaveScheduleTasksResult", data["saveScheduleTasks"] || undefined, {}),
  } as any;
}

export function newSaveScheduleTasksResponse(
  variables: SaveScheduleTasksMutationVariables,
  data: SaveScheduleTasksDataOptions | Error,
): MockedResponse<SaveScheduleTasksMutationVariables, SaveScheduleTasksMutation> {
  return {
    request: { query: SaveScheduleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleStatusDataOptions {
  saveSchedule?: FactoryInput<SaveScheduleResult, SaveScheduleResultOptions>;
}

export function newSaveScheduleStatusData(data: SaveScheduleStatusDataOptions): SaveScheduleStatusMutation {
  return {
    __typename: "Mutation" as const,
    saveSchedule: maybeNew("SaveScheduleResult", data["saveSchedule"] || undefined, {}),
  } as any;
}

export function newSaveScheduleStatusResponse(
  variables: SaveScheduleStatusMutationVariables,
  data: SaveScheduleStatusDataOptions | Error,
): MockedResponse<SaveScheduleStatusMutationVariables, SaveScheduleStatusMutation> {
  return {
    request: { query: SaveScheduleStatusDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleStatusData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplicableProductOfferingConfigsPageStructureMetadataDataOptions {
  structure?: FactoryInput<Structure, StructureOptions>;
  changeEventReasons?: FactoryInput<ChangeEventReason, ChangeEventReasonOptions>[];
}

export function newApplicableProductOfferingConfigsPageStructureMetadataData(
  data: ApplicableProductOfferingConfigsPageStructureMetadataDataOptions,
): ApplicableProductOfferingConfigsPageStructureMetadataQuery {
  return {
    __typename: "Query" as const,
    structure: maybeNew("Structure", data["structure"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => maybeNew("ChangeEventReason", d, {})) || [],
  } as any;
}

export function newApplicableProductOfferingConfigsPageStructureMetadataResponse(
  variables: ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables,
  data: ApplicableProductOfferingConfigsPageStructureMetadataDataOptions | Error,
): MockedResponse<
  ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables,
  ApplicableProductOfferingConfigsPageStructureMetadataQuery
> {
  return {
    request: { query: ApplicableProductOfferingConfigsPageStructureMetadataDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newApplicableProductOfferingConfigsPageStructureMetadataData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface AppliableProductOfferingConfigsDataOptions {
  productOfferingConfigs?: FactoryInput<ProductOfferingConfigsPage, ProductOfferingConfigsPageOptions>;
  checkoutConfigs?: FactoryInput<CheckoutConfigsPage, CheckoutConfigsPageOptions>;
}

export function newAppliableProductOfferingConfigsData(
  data: AppliableProductOfferingConfigsDataOptions,
): AppliableProductOfferingConfigsQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfigs: maybeNew("ProductOfferingConfigsPage", data["productOfferingConfigs"] || undefined, {}),
    checkoutConfigs: maybeNew("CheckoutConfigsPage", data["checkoutConfigs"] || undefined, {}),
  } as any;
}

export function newAppliableProductOfferingConfigsResponse(
  variables: AppliableProductOfferingConfigsQueryVariables,
  data: AppliableProductOfferingConfigsDataOptions | Error,
): MockedResponse<AppliableProductOfferingConfigsQueryVariables, AppliableProductOfferingConfigsQuery> {
  return {
    request: { query: AppliableProductOfferingConfigsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAppliableProductOfferingConfigsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AppliableProductOfferingConfigsApplyWithoutChangesDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newAppliableProductOfferingConfigsApplyWithoutChangesData(
  data: AppliableProductOfferingConfigsApplyWithoutChangesDataOptions,
): AppliableProductOfferingConfigsApplyWithoutChangesMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newAppliableProductOfferingConfigsApplyWithoutChangesResponse(
  variables: AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables,
  data: AppliableProductOfferingConfigsApplyWithoutChangesDataOptions | Error,
): MockedResponse<
  AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables,
  AppliableProductOfferingConfigsApplyWithoutChangesMutation
> {
  return {
    request: { query: AppliableProductOfferingConfigsApplyWithoutChangesDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newAppliableProductOfferingConfigsApplyWithoutChangesData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddItemModalDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newAddItemModalData(data: AddItemModalDataOptions): AddItemModalQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [] } as any;
}

export function newAddItemModalResponse(
  data: AddItemModalDataOptions | Error,
): MockedResponse<AddItemModalQueryVariables, AddItemModalQuery> {
  return {
    request: { query: AddItemModalDocument },
    result: { data: data instanceof Error ? undefined : newAddItemModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyTemplateModalDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newApplyTemplateModalData(data: ApplyTemplateModalDataOptions): ApplyTemplateModalQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newApplyTemplateModalResponse(
  variables: ApplyTemplateModalQueryVariables,
  data: ApplyTemplateModalDataOptions | Error,
): MockedResponse<ApplyTemplateModalQueryVariables, ApplyTemplateModalQuery> {
  return {
    request: { query: ApplyTemplateModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyTemplateModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyTemplateModalPlanDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newApplyTemplateModalPlanData(data: ApplyTemplateModalPlanDataOptions): ApplyTemplateModalPlanQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newApplyTemplateModalPlanResponse(
  variables: ApplyTemplateModalPlanQueryVariables,
  data: ApplyTemplateModalPlanDataOptions | Error,
): MockedResponse<ApplyTemplateModalPlanQueryVariables, ApplyTemplateModalPlanQuery> {
  return {
    request: { query: ApplyTemplateModalPlanDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyTemplateModalPlanData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ImportProjectItemsModalMetadataDataOptions {
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newImportProjectItemsModalMetadataData(
  data: ImportProjectItemsModalMetadataDataOptions,
): ImportProjectItemsModalMetadataQuery {
  return {
    __typename: "Query" as const,
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
  } as any;
}

export function newImportProjectItemsModalMetadataResponse(
  data: ImportProjectItemsModalMetadataDataOptions | Error,
): MockedResponse<ImportProjectItemsModalMetadataQueryVariables, ImportProjectItemsModalMetadataQuery> {
  return {
    request: { query: ImportProjectItemsModalMetadataDocument },
    result: { data: data instanceof Error ? undefined : newImportProjectItemsModalMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectScheduleTableTasksDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newProjectScheduleTableTasksData(
  data: ProjectScheduleTableTasksDataOptions,
): ProjectScheduleTableTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newProjectScheduleTableTasksResponse(
  variables: ProjectScheduleTableTasksQueryVariables,
  data: ProjectScheduleTableTasksDataOptions | Error,
): MockedResponse<ProjectScheduleTableTasksQueryVariables, ProjectScheduleTableTasksQuery> {
  return {
    request: { query: ProjectScheduleTableTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectScheduleTableTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SchedulePhasesDataOptions {
  schedulePhases?: FactoryInput<SchedulePhase, SchedulePhaseOptions>[];
  globalPhases?: FactoryInput<GlobalPhase, GlobalPhaseOptions>[];
}

export function newSchedulePhasesData(data: SchedulePhasesDataOptions): SchedulePhasesQuery {
  return {
    __typename: "Query" as const,
    schedulePhases: data["schedulePhases"]?.map((d) => maybeNew("SchedulePhase", d, {})) || [],
    globalPhases: data["globalPhases"]?.map((d) => maybeNew("GlobalPhase", d, {})) || [],
  } as any;
}

export function newSchedulePhasesResponse(
  variables: SchedulePhasesQueryVariables,
  data: SchedulePhasesDataOptions | Error,
): MockedResponse<SchedulePhasesQueryVariables, SchedulePhasesQuery> {
  return {
    request: { query: SchedulePhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSchedulePhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyScheduleTemplatesDataOptions {
  applyScheduleTemplates?: FactoryInput<ApplyScheduleTemplatesResult, ApplyScheduleTemplatesResultOptions>;
}

export function newApplyScheduleTemplatesData(data: ApplyScheduleTemplatesDataOptions): ApplyScheduleTemplatesMutation {
  return {
    __typename: "Mutation" as const,
    applyScheduleTemplates: maybeNew("ApplyScheduleTemplatesResult", data["applyScheduleTemplates"] || undefined, {}),
  } as any;
}

export function newApplyScheduleTemplatesResponse(
  variables: ApplyScheduleTemplatesMutationVariables,
  data: ApplyScheduleTemplatesDataOptions | Error,
): MockedResponse<ApplyScheduleTemplatesMutationVariables, ApplyScheduleTemplatesMutation> {
  return {
    request: { query: ApplyScheduleTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyScheduleTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverviewTabDataOptions {
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  locations?: FactoryInput<Location, LocationOptions>[];
}

export function newOverviewTabData(data: OverviewTabDataOptions): OverviewTabQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newOverviewTabResponse(
  variables: OverviewTabQueryVariables,
  data: OverviewTabDataOptions | Error,
): MockedResponse<OverviewTabQueryVariables, OverviewTabQuery> {
  return {
    request: { query: OverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverviewTabScheduleTasksDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newOverviewTabScheduleTasksData(
  data: OverviewTabScheduleTasksDataOptions,
): OverviewTabScheduleTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newOverviewTabScheduleTasksResponse(
  variables: OverviewTabScheduleTasksQueryVariables,
  data: OverviewTabScheduleTasksDataOptions | Error,
): MockedResponse<OverviewTabScheduleTasksQueryVariables, OverviewTabScheduleTasksQuery> {
  return {
    request: { query: OverviewTabScheduleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverviewTabScheduleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverviewTabSaveProjectItemDataOptions {
  saveProjectItems?: FactoryInput<SaveProjectItemsResult, SaveProjectItemsResultOptions>;
}

export function newOverviewTabSaveProjectItemData(
  data: OverviewTabSaveProjectItemDataOptions,
): OverviewTabSaveProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newOverviewTabSaveProjectItemResponse(
  variables: OverviewTabSaveProjectItemMutationVariables,
  data: OverviewTabSaveProjectItemDataOptions | Error,
): MockedResponse<OverviewTabSaveProjectItemMutationVariables, OverviewTabSaveProjectItemMutation> {
  return {
    request: { query: OverviewTabSaveProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverviewTabSaveProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverviewTabDeleteProjectItemDataOptions {
  deleteProjectItem?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newOverviewTabDeleteProjectItemData(
  data: OverviewTabDeleteProjectItemDataOptions,
): OverviewTabDeleteProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    deleteProjectItem: maybeNew("EmptyResult", data["deleteProjectItem"] || undefined, {}),
  } as any;
}

export function newOverviewTabDeleteProjectItemResponse(
  variables: OverviewTabDeleteProjectItemMutationVariables,
  data: OverviewTabDeleteProjectItemDataOptions | Error,
): MockedResponse<OverviewTabDeleteProjectItemMutationVariables, OverviewTabDeleteProjectItemMutation> {
  return {
    request: { query: OverviewTabDeleteProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverviewTabDeleteProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectItemHistoryDataOptions {
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
}

export function newProjectItemHistoryData(data: ProjectItemHistoryDataOptions): ProjectItemHistoryQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newProjectItemHistoryResponse(
  variables: ProjectItemHistoryQueryVariables,
  data: ProjectItemHistoryDataOptions | Error,
): MockedResponse<ProjectItemHistoryQueryVariables, ProjectItemHistoryQuery> {
  return {
    request: { query: ProjectItemHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectItemHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectItemCommitmentTabDataOptions {
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
}

export function newProjectItemCommitmentTabData(
  data: ProjectItemCommitmentTabDataOptions,
): ProjectItemCommitmentTabQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newProjectItemCommitmentTabResponse(
  variables: ProjectItemCommitmentTabQueryVariables,
  data: ProjectItemCommitmentTabDataOptions | Error,
): MockedResponse<ProjectItemCommitmentTabQueryVariables, ProjectItemCommitmentTabQuery> {
  return {
    request: { query: ProjectItemCommitmentTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectItemCommitmentTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteProjectItemDataOptions {
  deleteProjectItem?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteProjectItemData(data: DeleteProjectItemDataOptions): DeleteProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    deleteProjectItem: maybeNew("EmptyResult", data["deleteProjectItem"] || undefined, {}),
  } as any;
}

export function newDeleteProjectItemResponse(
  variables: DeleteProjectItemMutationVariables,
  data: DeleteProjectItemDataOptions | Error,
): MockedResponse<DeleteProjectItemMutationVariables, DeleteProjectItemMutation> {
  return {
    request: { query: DeleteProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SpecTabDataOptions {
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  locations?: FactoryInput<Location, LocationOptions>[];
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
  costConfidences?: FactoryInput<CostConfidenceDetail, CostConfidenceDetailOptions>[];
}

export function newSpecTabData(data: SpecTabDataOptions): SpecTabQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
    costConfidences: data["costConfidences"]?.map((d) => maybeNew("CostConfidenceDetail", d, {})) || [],
  } as any;
}

export function newSpecTabResponse(
  variables: SpecTabQueryVariables,
  data: SpecTabDataOptions | Error,
): MockedResponse<SpecTabQueryVariables, SpecTabQuery> {
  return {
    request: { query: SpecTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSpecTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectItemDetailsDataOptions {
  saveProjectItems?: FactoryInput<SaveProjectItemsResult, SaveProjectItemsResultOptions>;
}

export function newSaveProjectItemDetailsData(data: SaveProjectItemDetailsDataOptions): SaveProjectItemDetailsMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newSaveProjectItemDetailsResponse(
  variables: SaveProjectItemDetailsMutationVariables,
  data: SaveProjectItemDetailsDataOptions | Error,
): MockedResponse<SaveProjectItemDetailsMutationVariables, SaveProjectItemDetailsMutation> {
  return {
    request: { query: SaveProjectItemDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectItemDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SpecsAndSelectionItemsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
  costConfidences?: FactoryInput<CostConfidenceDetail, CostConfidenceDetailOptions>[];
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newSpecsAndSelectionItemsData(data: SpecsAndSelectionItemsDataOptions): SpecsAndSelectionItemsQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
    costConfidences: data["costConfidences"]?.map((d) => maybeNew("CostConfidenceDetail", d, {})) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newSpecsAndSelectionItemsResponse(
  variables: SpecsAndSelectionItemsQueryVariables,
  data: SpecsAndSelectionItemsDataOptions | Error,
): MockedResponse<SpecsAndSelectionItemsQueryVariables, SpecsAndSelectionItemsQuery> {
  return {
    request: { query: SpecsAndSelectionItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSpecsAndSelectionItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteProjectItemsDataOptions {
  deleteProjectItems?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteProjectItemsData(data: DeleteProjectItemsDataOptions): DeleteProjectItemsMutation {
  return {
    __typename: "Mutation" as const,
    deleteProjectItems: maybeNew("EmptyResult", data["deleteProjectItems"] || undefined, {}),
  } as any;
}

export function newDeleteProjectItemsResponse(
  variables: DeleteProjectItemsMutationVariables,
  data: DeleteProjectItemsDataOptions | Error,
): MockedResponse<DeleteProjectItemsMutationVariables, DeleteProjectItemsMutation> {
  return {
    request: { query: DeleteProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectItemsDataOptions {
  saveProjectItems?: FactoryInput<SaveProjectItemsResult, SaveProjectItemsResultOptions>;
}

export function newSaveProjectItemsData(data: SaveProjectItemsDataOptions): SaveProjectItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newSaveProjectItemsResponse(
  variables: SaveProjectItemsMutationVariables,
  data: SaveProjectItemsDataOptions | Error,
): MockedResponse<SaveProjectItemsMutationVariables, SaveProjectItemsMutation> {
  return {
    request: { query: SaveProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DuplicateProjectItemsDataOptions {
  duplicateProjectItems?: FactoryInput<DuplicateProjectItemsResult, DuplicateProjectItemsResultOptions>;
}

export function newDuplicateProjectItemsData(data: DuplicateProjectItemsDataOptions): DuplicateProjectItemsMutation {
  return {
    __typename: "Mutation" as const,
    duplicateProjectItems: maybeNew("DuplicateProjectItemsResult", data["duplicateProjectItems"] || undefined, {}),
  } as any;
}

export function newDuplicateProjectItemsResponse(
  variables: DuplicateProjectItemsMutationVariables,
  data: DuplicateProjectItemsDataOptions | Error,
): MockedResponse<DuplicateProjectItemsMutationVariables, DuplicateProjectItemsMutation> {
  return {
    request: { query: DuplicateProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDuplicateProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyItemTemplateDataOptions {
  applyItemTemplate?: FactoryInput<ApplyItemTemplateResult, ApplyItemTemplateResultOptions>;
}

export function newApplyItemTemplateData(data: ApplyItemTemplateDataOptions): ApplyItemTemplateMutation {
  return {
    __typename: "Mutation" as const,
    applyItemTemplate: maybeNew("ApplyItemTemplateResult", data["applyItemTemplate"] || undefined, {}),
  } as any;
}

export function newApplyItemTemplateResponse(
  variables: ApplyItemTemplateMutationVariables,
  data: ApplyItemTemplateDataOptions | Error,
): MockedResponse<ApplyItemTemplateMutationVariables, ApplyItemTemplateMutation> {
  return {
    request: { query: ApplyItemTemplateDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyItemTemplateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProjectItemDataOptions {
  saveProjectItems?: FactoryInput<SaveProjectItemsResult, SaveProjectItemsResultOptions>;
}

export function newAddProjectItemData(data: AddProjectItemDataOptions): AddProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newAddProjectItemResponse(
  variables: AddProjectItemMutationVariables,
  data: AddProjectItemDataOptions | Error,
): MockedResponse<AddProjectItemMutationVariables, AddProjectItemMutation> {
  return {
    request: { query: AddProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommunityStageOrderDataOptions {
  community?: FactoryInput<Community, CommunityOptions>;
  globalPlanStages?: FactoryInput<GlobalPlanStage, GlobalPlanStageOptions>[];
}

export function newCommunityStageOrderData(data: CommunityStageOrderDataOptions): CommunityStageOrderQuery {
  return {
    __typename: "Query" as const,
    community: maybeNew("Community", data["community"] || undefined, {}),
    globalPlanStages: data["globalPlanStages"]?.map((d) => maybeNew("GlobalPlanStage", d, {})) || [],
  } as any;
}

export function newCommunityStageOrderResponse(
  variables: CommunityStageOrderQueryVariables,
  data: CommunityStageOrderDataOptions | Error,
): MockedResponse<CommunityStageOrderQueryVariables, CommunityStageOrderQuery> {
  return {
    request: { query: CommunityStageOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommunityStageOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanStageVariantsDataOptions {
  saveGlobalPlanStageVariants?: FactoryInput<
    SaveGlobalPlanStageVariantsResult,
    SaveGlobalPlanStageVariantsResultOptions
  >;
}

export function newSaveGlobalPlanStageVariantsData(
  data: SaveGlobalPlanStageVariantsDataOptions,
): SaveGlobalPlanStageVariantsMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanStageVariants: maybeNew(
      "SaveGlobalPlanStageVariantsResult",
      data["saveGlobalPlanStageVariants"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveGlobalPlanStageVariantsResponse(
  variables: SaveGlobalPlanStageVariantsMutationVariables,
  data: SaveGlobalPlanStageVariantsDataOptions | Error,
): MockedResponse<SaveGlobalPlanStageVariantsMutationVariables, SaveGlobalPlanStageVariantsMutation> {
  return {
    request: { query: SaveGlobalPlanStageVariantsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanStageVariantsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutSettingsTab_CommunityDataOptions {
  community?: FactoryInput<Community, CommunityOptions>;
}

export function newCheckoutSettingsTab_CommunityData(
  data: CheckoutSettingsTab_CommunityDataOptions,
): CheckoutSettingsTab_CommunityQuery {
  return { __typename: "Query" as const, community: maybeNew("Community", data["community"] || undefined, {}) } as any;
}

export function newCheckoutSettingsTab_CommunityResponse(
  variables: CheckoutSettingsTab_CommunityQueryVariables,
  data: CheckoutSettingsTab_CommunityDataOptions | Error,
): MockedResponse<CheckoutSettingsTab_CommunityQueryVariables, CheckoutSettingsTab_CommunityQuery> {
  return {
    request: { query: CheckoutSettingsTab_CommunityDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutSettingsTab_CommunityData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommunitySettingsDataOptions {
  saveCommunity?: FactoryInput<SaveCommunityResult, SaveCommunityResultOptions>;
}

export function newSaveCommunitySettingsData(data: SaveCommunitySettingsDataOptions): SaveCommunitySettingsMutation {
  return {
    __typename: "Mutation" as const,
    saveCommunity: maybeNew("SaveCommunityResult", data["saveCommunity"] || undefined, {}),
  } as any;
}

export function newSaveCommunitySettingsResponse(
  variables: SaveCommunitySettingsMutationVariables,
  data: SaveCommunitySettingsDataOptions | Error,
): MockedResponse<SaveCommunitySettingsMutationVariables, SaveCommunitySettingsMutation> {
  return {
    request: { query: SaveCommunitySettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommunitySettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutSettingsTab_StructureDataOptions {
  structure?: FactoryInput<Structure, StructureOptions>;
}

export function newCheckoutSettingsTab_StructureData(
  data: CheckoutSettingsTab_StructureDataOptions,
): CheckoutSettingsTab_StructureQuery {
  return { __typename: "Query" as const, structure: maybeNew("Structure", data["structure"] || undefined, {}) } as any;
}

export function newCheckoutSettingsTab_StructureResponse(
  variables: CheckoutSettingsTab_StructureQueryVariables,
  data: CheckoutSettingsTab_StructureDataOptions | Error,
): MockedResponse<CheckoutSettingsTab_StructureQueryVariables, CheckoutSettingsTab_StructureQuery> {
  return {
    request: { query: CheckoutSettingsTab_StructureDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutSettingsTab_StructureData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutSettingsTab_ProductOfferingOptionsDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newCheckoutSettingsTab_ProductOfferingOptionsData(
  data: CheckoutSettingsTab_ProductOfferingOptionsDataOptions,
): CheckoutSettingsTab_ProductOfferingOptionsQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newCheckoutSettingsTab_ProductOfferingOptionsResponse(
  variables: CheckoutSettingsTab_ProductOfferingOptionsQueryVariables,
  data: CheckoutSettingsTab_ProductOfferingOptionsDataOptions | Error,
): MockedResponse<
  CheckoutSettingsTab_ProductOfferingOptionsQueryVariables,
  CheckoutSettingsTab_ProductOfferingOptionsQuery
> {
  return {
    request: { query: CheckoutSettingsTab_ProductOfferingOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutSettingsTab_ProductOfferingOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveStructureSettingsDataOptions {
  saveStructure?: FactoryInput<SaveStructureResult, SaveStructureResultOptions>;
}

export function newSaveStructureSettingsData(data: SaveStructureSettingsDataOptions): SaveStructureSettingsMutation {
  return {
    __typename: "Mutation" as const,
    saveStructure: maybeNew("SaveStructureResult", data["saveStructure"] || undefined, {}),
  } as any;
}

export function newSaveStructureSettingsResponse(
  variables: SaveStructureSettingsMutationVariables,
  data: SaveStructureSettingsDataOptions | Error,
): MockedResponse<SaveStructureSettingsMutationVariables, SaveStructureSettingsMutation> {
  return {
    request: { query: SaveStructureSettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveStructureSettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutSettingsTab_LotDataOptions {
  lot?: FactoryInput<Lot, LotOptions>;
}

export function newCheckoutSettingsTab_LotData(data: CheckoutSettingsTab_LotDataOptions): CheckoutSettingsTab_LotQuery {
  return { __typename: "Query" as const, lot: maybeNew("Lot", data["lot"] || undefined, {}) } as any;
}

export function newCheckoutSettingsTab_LotResponse(
  variables: CheckoutSettingsTab_LotQueryVariables,
  data: CheckoutSettingsTab_LotDataOptions | Error,
): MockedResponse<CheckoutSettingsTab_LotQueryVariables, CheckoutSettingsTab_LotQuery> {
  return {
    request: { query: CheckoutSettingsTab_LotDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutSettingsTab_LotData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotSettingsDataOptions {
  saveLot?: FactoryInput<SaveLotResult, SaveLotResultOptions>;
}

export function newSaveLotSettingsData(data: SaveLotSettingsDataOptions): SaveLotSettingsMutation {
  return {
    __typename: "Mutation" as const,
    saveLot: maybeNew("SaveLotResult", data["saveLot"] || undefined, {}),
  } as any;
}

export function newSaveLotSettingsResponse(
  variables: SaveLotSettingsMutationVariables,
  data: SaveLotSettingsDataOptions | Error,
): MockedResponse<SaveLotSettingsMutationVariables, SaveLotSettingsMutation> {
  return {
    request: { query: SaveLotSettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotSettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyMilestoneTargetsModal_CommunitiesDataOptions {
  communities?: FactoryInput<CommunitiesPageResult, CommunitiesPageResultOptions>;
}

export function newCopyMilestoneTargetsModal_CommunitiesData(
  data: CopyMilestoneTargetsModal_CommunitiesDataOptions,
): CopyMilestoneTargetsModal_CommunitiesQuery {
  return {
    __typename: "Query" as const,
    communities: maybeNew("CommunitiesPageResult", data["communities"] || undefined, {}),
  } as any;
}

export function newCopyMilestoneTargetsModal_CommunitiesResponse(
  data: CopyMilestoneTargetsModal_CommunitiesDataOptions | Error,
): MockedResponse<CopyMilestoneTargetsModal_CommunitiesQueryVariables, CopyMilestoneTargetsModal_CommunitiesQuery> {
  return {
    request: { query: CopyMilestoneTargetsModal_CommunitiesDocument },
    result: { data: data instanceof Error ? undefined : newCopyMilestoneTargetsModal_CommunitiesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyMilestoneTargetsModal_SourceScheduleDataOptions {
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions>;
}

export function newCopyMilestoneTargetsModal_SourceScheduleData(
  data: CopyMilestoneTargetsModal_SourceScheduleDataOptions,
): CopyMilestoneTargetsModal_SourceScheduleQuery {
  return {
    __typename: "Query" as const,
    planSchedule: maybeNew("PlanSchedule", data["planSchedule"] || undefined, {}),
  } as any;
}

export function newCopyMilestoneTargetsModal_SourceScheduleResponse(
  variables: CopyMilestoneTargetsModal_SourceScheduleQueryVariables,
  data: CopyMilestoneTargetsModal_SourceScheduleDataOptions | Error,
): MockedResponse<
  CopyMilestoneTargetsModal_SourceScheduleQueryVariables,
  CopyMilestoneTargetsModal_SourceScheduleQuery
> {
  return {
    request: { query: CopyMilestoneTargetsModal_SourceScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyMilestoneTargetsModal_SourceScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownersTabDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newHomeownersTabData(data: HomeownersTabDataOptions): HomeownersTabQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newHomeownersTabResponse(
  variables: HomeownersTabQueryVariables,
  data: HomeownersTabDataOptions | Error,
): MockedResponse<HomeownersTabQueryVariables, HomeownersTabQuery> {
  return {
    request: { query: HomeownersTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownersTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendInviteEmailDataOptions {
  sendInviteEmail?: FactoryInput<SendInviteEmailResult, SendInviteEmailResultOptions>;
}

export function newSendInviteEmailData(data: SendInviteEmailDataOptions): SendInviteEmailMutation {
  return {
    __typename: "Mutation" as const,
    sendInviteEmail: maybeNew("SendInviteEmailResult", data["sendInviteEmail"] || undefined, {}),
  } as any;
}

export function newSendInviteEmailResponse(
  variables: SendInviteEmailMutationVariables,
  data: SendInviteEmailDataOptions | Error,
): MockedResponse<SendInviteEmailMutationVariables, SendInviteEmailMutation> {
  return {
    request: { query: SendInviteEmailDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendInviteEmailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteProjectCollaboratorDataOptions {
  deleteProjectCollaborator?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteProjectCollaboratorData(
  data: DeleteProjectCollaboratorDataOptions,
): DeleteProjectCollaboratorMutation {
  return {
    __typename: "Mutation" as const,
    deleteProjectCollaborator: maybeNew("EmptyResult", data["deleteProjectCollaborator"] || undefined, {}),
  } as any;
}

export function newDeleteProjectCollaboratorResponse(
  variables: DeleteProjectCollaboratorMutationVariables,
  data: DeleteProjectCollaboratorDataOptions | Error,
): MockedResponse<DeleteProjectCollaboratorMutationVariables, DeleteProjectCollaboratorMutation> {
  return {
    request: { query: DeleteProjectCollaboratorDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteProjectCollaboratorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectCollaboratorDataOptions {
  saveProjectCollaborator?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newSaveProjectCollaboratorData(
  data: SaveProjectCollaboratorDataOptions,
): SaveProjectCollaboratorMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectCollaborator: maybeNew("EmptyResult", data["saveProjectCollaborator"] || undefined, {}),
  } as any;
}

export function newSaveProjectCollaboratorResponse(
  variables: SaveProjectCollaboratorMutationVariables,
  data: SaveProjectCollaboratorDataOptions | Error,
): MockedResponse<SaveProjectCollaboratorMutationVariables, SaveProjectCollaboratorMutation> {
  return {
    request: { query: SaveProjectCollaboratorDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectCollaboratorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetUpTabDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  productTypes?: FactoryInput<ProductType, ProductTypeOptions>[];
  lotRatings?: FactoryInput<LotRating, LotRatingOptions>[];
  preconContractTypes?: FactoryInput<PreconContractType, PreconContractTypeOptions>[];
  readyPlans?: FactoryInput<ReadyPlan, ReadyPlanOptions>[];
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newSetUpTabData(data: SetUpTabDataOptions): SetUpTabQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    productTypes: data["productTypes"]?.map((d) => maybeNew("ProductType", d, {})) || [],
    lotRatings: data["lotRatings"]?.map((d) => maybeNew("LotRating", d, {})) || [],
    preconContractTypes: data["preconContractTypes"]?.map((d) => maybeNew("PreconContractType", d, {})) || [],
    readyPlans: data["readyPlans"]?.map((d) => maybeNew("ReadyPlan", d, {})) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newSetUpTabResponse(
  variables: SetUpTabQueryVariables,
  data: SetUpTabDataOptions | Error,
): MockedResponse<SetUpTabQueryVariables, SetUpTabQuery> {
  return {
    request: { query: SetUpTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetUpTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectSetUpTabDataOptions {
  saveProject?: FactoryInput<SaveProjectResult, SaveProjectResultOptions>;
}

export function newSaveProjectSetUpTabData(data: SaveProjectSetUpTabDataOptions): SaveProjectSetUpTabMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSaveProjectSetUpTabResponse(
  variables: SaveProjectSetUpTabMutationVariables,
  data: SaveProjectSetUpTabDataOptions | Error,
): MockedResponse<SaveProjectSetUpTabMutationVariables, SaveProjectSetUpTabMutation> {
  return {
    request: { query: SaveProjectSetUpTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectSetUpTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveStructureSetUpTabDataOptions {
  saveStructure?: FactoryInput<SaveStructureResult, SaveStructureResultOptions>;
}

export function newSaveStructureSetUpTabData(data: SaveStructureSetUpTabDataOptions): SaveStructureSetUpTabMutation {
  return {
    __typename: "Mutation" as const,
    saveStructure: maybeNew("SaveStructureResult", data["saveStructure"] || undefined, {}),
  } as any;
}

export function newSaveStructureSetUpTabResponse(
  variables: SaveStructureSetUpTabMutationVariables,
  data: SaveStructureSetUpTabDataOptions | Error,
): MockedResponse<SaveStructureSetUpTabMutationVariables, SaveStructureSetUpTabMutation> {
  return {
    request: { query: SaveStructureSetUpTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveStructureSetUpTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectOverallTabDataOptions {
  saveProject?: FactoryInput<SaveProjectResult, SaveProjectResultOptions>;
}

export function newSaveProjectOverallTabData(data: SaveProjectOverallTabDataOptions): SaveProjectOverallTabMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSaveProjectOverallTabResponse(
  variables: SaveProjectOverallTabMutationVariables,
  data: SaveProjectOverallTabDataOptions | Error,
): MockedResponse<SaveProjectOverallTabMutationVariables, SaveProjectOverallTabMutation> {
  return {
    request: { query: SaveProjectOverallTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectOverallTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectStatusChangeReasonsDataOptions {
  projectStatusChangeReasons?: FactoryInput<ProjectStatusChangeReason, ProjectStatusChangeReasonOptions>[];
}

export function newProjectStatusChangeReasonsData(
  data: ProjectStatusChangeReasonsDataOptions,
): ProjectStatusChangeReasonsQuery {
  return {
    __typename: "Query" as const,
    projectStatusChangeReasons:
      data["projectStatusChangeReasons"]?.map((d) => maybeNew("ProjectStatusChangeReason", d, {})) || [],
  } as any;
}

export function newProjectStatusChangeReasonsResponse(
  variables: ProjectStatusChangeReasonsQueryVariables,
  data: ProjectStatusChangeReasonsDataOptions | Error,
): MockedResponse<ProjectStatusChangeReasonsQueryVariables, ProjectStatusChangeReasonsQuery> {
  return {
    request: { query: ProjectStatusChangeReasonsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectStatusChangeReasonsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverallTabDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  stages?: FactoryInput<StageDetail, StageDetailOptions>[];
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
}

export function newOverallTabData(data: OverallTabDataOptions): OverallTabQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    stages: data["stages"]?.map((d) => maybeNew("StageDetail", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
  } as any;
}

export function newOverallTabResponse(
  variables: OverallTabQueryVariables,
  data: OverallTabDataOptions | Error,
): MockedResponse<OverallTabQueryVariables, OverallTabQuery> {
  return {
    request: { query: OverallTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverallTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTabDataOptions {
  schedules?: FactoryInput<Schedule, ScheduleOptions>[];
}

export function newScheduleTabData(data: ScheduleTabDataOptions): ScheduleTabQuery {
  return {
    __typename: "Query" as const,
    schedules: data["schedules"]?.map((d) => maybeNew("Schedule", d, {})) || [],
  } as any;
}

export function newScheduleTabResponse(
  variables: ScheduleTabQueryVariables,
  data: ScheduleTabDataOptions | Error,
): MockedResponse<ScheduleTabQueryVariables, ScheduleTabQuery> {
  return {
    request: { query: ScheduleTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanScheduleTabDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  globalPlanMilestones?: FactoryInput<GlobalPlanMilestonesPageResult, GlobalPlanMilestonesPageResultOptions>;
}

export function newPlanScheduleTabData(data: PlanScheduleTabDataOptions): PlanScheduleTabQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    globalPlanMilestones: maybeNew("GlobalPlanMilestonesPageResult", data["globalPlanMilestones"] || undefined, {}),
  } as any;
}

export function newPlanScheduleTabResponse(
  variables: PlanScheduleTabQueryVariables,
  data: PlanScheduleTabDataOptions | Error,
): MockedResponse<PlanScheduleTabQueryVariables, PlanScheduleTabQuery> {
  return {
    request: { query: PlanScheduleTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanScheduleTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleSettingsDataOptions {
  saveScheduleSettings?: FactoryInput<SaveScheduleSettingsResult, SaveScheduleSettingsResultOptions>;
}

export function newSaveScheduleSettingsData(data: SaveScheduleSettingsDataOptions): SaveScheduleSettingsMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleSettings: maybeNew("SaveScheduleSettingsResult", data["saveScheduleSettings"] || undefined, {}),
  } as any;
}

export function newSaveScheduleSettingsResponse(
  variables: SaveScheduleSettingsMutationVariables,
  data: SaveScheduleSettingsDataOptions | Error,
): MockedResponse<SaveScheduleSettingsMutationVariables, SaveScheduleSettingsMutation> {
  return {
    request: { query: SaveScheduleSettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleSettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanScheduleSettingsDataOptions {
  savePlanSchedule?: FactoryInput<SavePlanScheduleResult, SavePlanScheduleResultOptions>;
}

export function newSavePlanScheduleSettingsData(
  data: SavePlanScheduleSettingsDataOptions,
): SavePlanScheduleSettingsMutation {
  return {
    __typename: "Mutation" as const,
    savePlanSchedule: maybeNew("SavePlanScheduleResult", data["savePlanSchedule"] || undefined, {}),
  } as any;
}

export function newSavePlanScheduleSettingsResponse(
  variables: SavePlanScheduleSettingsMutationVariables,
  data: SavePlanScheduleSettingsDataOptions | Error,
): MockedResponse<SavePlanScheduleSettingsMutationVariables, SavePlanScheduleSettingsMutation> {
  return {
    request: { query: SavePlanScheduleSettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanScheduleSettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleRemindersDataOptions {
  saveSchedule?: FactoryInput<SaveScheduleResult, SaveScheduleResultOptions>;
}

export function newSaveScheduleRemindersData(data: SaveScheduleRemindersDataOptions): SaveScheduleRemindersMutation {
  return {
    __typename: "Mutation" as const,
    saveSchedule: maybeNew("SaveScheduleResult", data["saveSchedule"] || undefined, {}),
  } as any;
}

export function newSaveScheduleRemindersResponse(
  variables: SaveScheduleRemindersMutationVariables,
  data: SaveScheduleRemindersDataOptions | Error,
): MockedResponse<SaveScheduleRemindersMutationVariables, SaveScheduleRemindersMutation> {
  return {
    request: { query: SaveScheduleRemindersDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleRemindersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TeamMembersDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newTeamMembersData(data: TeamMembersDataOptions): TeamMembersQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newTeamMembersResponse(
  variables: TeamMembersQueryVariables,
  data: TeamMembersDataOptions | Error,
): MockedResponse<TeamMembersQueryVariables, TeamMembersQuery> {
  return {
    request: { query: TeamMembersDocument, variables },
    result: { data: data instanceof Error ? undefined : newTeamMembersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AvailableAssigneesDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newAvailableAssigneesData(data: AvailableAssigneesDataOptions): AvailableAssigneesQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newAvailableAssigneesResponse(
  variables: AvailableAssigneesQueryVariables,
  data: AvailableAssigneesDataOptions | Error,
): MockedResponse<AvailableAssigneesQueryVariables, AvailableAssigneesQuery> {
  return {
    request: { query: AvailableAssigneesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAvailableAssigneesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateProjectRoleDataOptions {
  updateProjectRole?: FactoryInput<UpdateProjectRoleResult, UpdateProjectRoleResultOptions>;
}

export function newUpdateProjectRoleData(data: UpdateProjectRoleDataOptions): UpdateProjectRoleMutation {
  return {
    __typename: "Mutation" as const,
    updateProjectRole: maybeNew("UpdateProjectRoleResult", data["updateProjectRole"] || undefined, {}),
  } as any;
}

export function newUpdateProjectRoleResponse(
  variables: UpdateProjectRoleMutationVariables,
  data: UpdateProjectRoleDataOptions | Error,
): MockedResponse<UpdateProjectRoleMutationVariables, UpdateProjectRoleMutation> {
  return {
    request: { query: UpdateProjectRoleDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateProjectRoleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddItemsFromExistingTemplateDataOptions {
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newAddItemsFromExistingTemplateData(
  data: AddItemsFromExistingTemplateDataOptions,
): AddItemsFromExistingTemplateQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newAddItemsFromExistingTemplateResponse(
  variables: AddItemsFromExistingTemplateQueryVariables,
  data: AddItemsFromExistingTemplateDataOptions | Error,
): MockedResponse<AddItemsFromExistingTemplateQueryVariables, AddItemsFromExistingTemplateQuery> {
  return {
    request: { query: AddItemsFromExistingTemplateDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddItemsFromExistingTemplateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateLineItemsTabDataOptions {
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newItemTemplateLineItemsTabData(
  data: ItemTemplateLineItemsTabDataOptions,
): ItemTemplateLineItemsTabQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newItemTemplateLineItemsTabResponse(
  variables: ItemTemplateLineItemsTabQueryVariables,
  data: ItemTemplateLineItemsTabDataOptions | Error,
): MockedResponse<ItemTemplateLineItemsTabQueryVariables, ItemTemplateLineItemsTabQuery> {
  return {
    request: { query: ItemTemplateLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateItemVersionsPage_GroupsDataOptions {
  itemTemplateItemVersionsPage?: FactoryInput<ItemTemplateItemVersionsPage, ItemTemplateItemVersionsPageOptions>;
}

export function newItemTemplateItemVersionsPage_GroupsData(
  data: ItemTemplateItemVersionsPage_GroupsDataOptions,
): ItemTemplateItemVersionsPage_GroupsQuery {
  return {
    __typename: "Query" as const,
    itemTemplateItemVersionsPage: maybeNew(
      "ItemTemplateItemVersionsPage",
      data["itemTemplateItemVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newItemTemplateItemVersionsPage_GroupsResponse(
  variables: ItemTemplateItemVersionsPage_GroupsQueryVariables,
  data: ItemTemplateItemVersionsPage_GroupsDataOptions | Error,
): MockedResponse<ItemTemplateItemVersionsPage_GroupsQueryVariables, ItemTemplateItemVersionsPage_GroupsQuery> {
  return {
    request: { query: ItemTemplateItemVersionsPage_GroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateItemVersionsPage_GroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateItemVersionsPageDataOptions {
  itemTemplateItemVersionsPage?: FactoryInput<ItemTemplateItemVersionsPage, ItemTemplateItemVersionsPageOptions>;
}

export function newItemTemplateItemVersionsPageData(
  data: ItemTemplateItemVersionsPageDataOptions,
): ItemTemplateItemVersionsPageQuery {
  return {
    __typename: "Query" as const,
    itemTemplateItemVersionsPage: maybeNew(
      "ItemTemplateItemVersionsPage",
      data["itemTemplateItemVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newItemTemplateItemVersionsPageResponse(
  variables: ItemTemplateItemVersionsPageQueryVariables,
  data: ItemTemplateItemVersionsPageDataOptions | Error,
): MockedResponse<ItemTemplateItemVersionsPageQueryVariables, ItemTemplateItemVersionsPageQuery> {
  return {
    request: { query: ItemTemplateItemVersionsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateItemVersionsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateItemDetailDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
}

export function newItemTemplateItemDetailData(data: ItemTemplateItemDetailDataOptions): ItemTemplateItemDetailQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
  } as any;
}

export function newItemTemplateItemDetailResponse(
  data: ItemTemplateItemDetailDataOptions | Error,
): MockedResponse<ItemTemplateItemDetailQueryVariables, ItemTemplateItemDetailQuery> {
  return {
    request: { query: ItemTemplateItemDetailDocument },
    result: { data: data instanceof Error ? undefined : newItemTemplateItemDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateImportModalDataOptions {
  costTypes?: FactoryInput<CostTypeDetail, CostTypeDetailOptions>[];
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newItemTemplateImportModalData(data: ItemTemplateImportModalDataOptions): ItemTemplateImportModalQuery {
  return {
    __typename: "Query" as const,
    costTypes: data["costTypes"]?.map((d) => maybeNew("CostTypeDetail", d, {})) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newItemTemplateImportModalResponse(
  variables: ItemTemplateImportModalQueryVariables,
  data: ItemTemplateImportModalDataOptions | Error,
): MockedResponse<ItemTemplateImportModalQueryVariables, ItemTemplateImportModalQuery> {
  return {
    request: { query: ItemTemplateImportModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateImportModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplatesDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newItemTemplatesData(data: ItemTemplatesDataOptions): ItemTemplatesQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newItemTemplatesResponse(
  variables: ItemTemplatesQueryVariables,
  data: ItemTemplatesDataOptions | Error,
): MockedResponse<ItemTemplatesQueryVariables, ItemTemplatesQuery> {
  return {
    request: { query: ItemTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerReviewsDataOptions {
  tradePartner?: FactoryInput<TradePartner, TradePartnerOptions>;
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newTradePartnerReviewsData(data: TradePartnerReviewsDataOptions): TradePartnerReviewsQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newTradePartnerReviewsResponse(
  variables: TradePartnerReviewsQueryVariables,
  data: TradePartnerReviewsDataOptions | Error,
): MockedResponse<TradePartnerReviewsQueryVariables, TradePartnerReviewsQuery> {
  return {
    request: { query: TradePartnerReviewsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerReviewsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerReviewDataOptions {
  saveTradePartnerReview?: FactoryInput<SaveTradePartnerReviewResult, SaveTradePartnerReviewResultOptions>;
}

export function newSaveTradePartnerReviewData(data: SaveTradePartnerReviewDataOptions): SaveTradePartnerReviewMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerReview: maybeNew("SaveTradePartnerReviewResult", data["saveTradePartnerReview"] || undefined, {}),
  } as any;
}

export function newSaveTradePartnerReviewResponse(
  variables: SaveTradePartnerReviewMutationVariables,
  data: SaveTradePartnerReviewDataOptions | Error,
): MockedResponse<SaveTradePartnerReviewMutationVariables, SaveTradePartnerReviewMutation> {
  return {
    request: { query: SaveTradePartnerReviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerReviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerContactsRolesPanelMetadataDataOptions {
  tradePartnerMarketRoles?: FactoryInput<TradePartnerMarketRoleDetail, TradePartnerMarketRoleDetailOptions>[];
}

export function newTradePartnerContactsRolesPanelMetadataData(
  data: TradePartnerContactsRolesPanelMetadataDataOptions,
): TradePartnerContactsRolesPanelMetadataQuery {
  return {
    __typename: "Query" as const,
    tradePartnerMarketRoles:
      data["tradePartnerMarketRoles"]?.map((d) => maybeNew("TradePartnerMarketRoleDetail", d, {})) || [],
  } as any;
}

export function newTradePartnerContactsRolesPanelMetadataResponse(
  data: TradePartnerContactsRolesPanelMetadataDataOptions | Error,
): MockedResponse<TradePartnerContactsRolesPanelMetadataQueryVariables, TradePartnerContactsRolesPanelMetadataQuery> {
  return {
    request: { query: TradePartnerContactsRolesPanelMetadataDocument },
    result: { data: data instanceof Error ? undefined : newTradePartnerContactsRolesPanelMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeCategoryLeadTimesDataOptions {
  tradeCategoryLeadTimes?: FactoryInput<TradeCategoryLeadTimeLike, TradeCategoryLeadTimeLikeOptions>[];
}

export function newTradeCategoryLeadTimesData(data: TradeCategoryLeadTimesDataOptions): TradeCategoryLeadTimesQuery {
  return {
    __typename: "Query" as const,
    tradeCategoryLeadTimes: data["tradeCategoryLeadTimes"]?.map((d) => maybeNew("TradeCategoryLeadTimeLike", d, {})) ||
      [],
  } as any;
}

export function newTradeCategoryLeadTimesResponse(
  variables: TradeCategoryLeadTimesQueryVariables,
  data: TradeCategoryLeadTimesDataOptions | Error,
): MockedResponse<TradeCategoryLeadTimesQueryVariables, TradeCategoryLeadTimesQuery> {
  return {
    request: { query: TradeCategoryLeadTimesDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradeCategoryLeadTimesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeCategoryLeadTimesMetaDataDataOptions {
  tradeCategories?: FactoryInput<TradeCategory, TradeCategoryOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
}

export function newTradeCategoryLeadTimesMetaDataData(
  data: TradeCategoryLeadTimesMetaDataDataOptions,
): TradeCategoryLeadTimesMetaDataQuery {
  return {
    __typename: "Query" as const,
    tradeCategories: data["tradeCategories"]?.map((d) => maybeNew("TradeCategory", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
  } as any;
}

export function newTradeCategoryLeadTimesMetaDataResponse(
  data: TradeCategoryLeadTimesMetaDataDataOptions | Error,
): MockedResponse<TradeCategoryLeadTimesMetaDataQueryVariables, TradeCategoryLeadTimesMetaDataQuery> {
  return {
    request: { query: TradeCategoryLeadTimesMetaDataDocument },
    result: { data: data instanceof Error ? undefined : newTradeCategoryLeadTimesMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradeCategoryLeadTimesDataOptions {
  saveTradeCategoryLeadTimes?: FactoryInput<SaveTradeCategoryLeadTimesResult, SaveTradeCategoryLeadTimesResultOptions>;
}

export function newSaveTradeCategoryLeadTimesData(
  data: SaveTradeCategoryLeadTimesDataOptions,
): SaveTradeCategoryLeadTimesMutation {
  return {
    __typename: "Mutation" as const,
    saveTradeCategoryLeadTimes: maybeNew(
      "SaveTradeCategoryLeadTimesResult",
      data["saveTradeCategoryLeadTimes"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradeCategoryLeadTimesResponse(
  variables: SaveTradeCategoryLeadTimesMutationVariables,
  data: SaveTradeCategoryLeadTimesDataOptions | Error,
): MockedResponse<SaveTradeCategoryLeadTimesMutationVariables, SaveTradeCategoryLeadTimesMutation> {
  return {
    request: { query: SaveTradeCategoryLeadTimesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradeCategoryLeadTimesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyModalTicketTypesAndDevelopmentsDataOptions {
  warrantyTicketTypesDetail?: FactoryInput<WarrantyTicketTypeDetail, WarrantyTicketTypeDetailOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newWarrantyModalTicketTypesAndDevelopmentsData(
  data: WarrantyModalTicketTypesAndDevelopmentsDataOptions,
): WarrantyModalTicketTypesAndDevelopmentsQuery {
  return {
    __typename: "Query" as const,
    warrantyTicketTypesDetail:
      data["warrantyTicketTypesDetail"]?.map((d) => maybeNew("WarrantyTicketTypeDetail", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newWarrantyModalTicketTypesAndDevelopmentsResponse(
  data: WarrantyModalTicketTypesAndDevelopmentsDataOptions | Error,
): MockedResponse<WarrantyModalTicketTypesAndDevelopmentsQueryVariables, WarrantyModalTicketTypesAndDevelopmentsQuery> {
  return {
    request: { query: WarrantyModalTicketTypesAndDevelopmentsDocument },
    result: { data: data instanceof Error ? undefined : newWarrantyModalTicketTypesAndDevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyModalProjectsDataOptions {
  projectsPage?: FactoryInput<ProjectsPageResult, ProjectsPageResultOptions>;
}

export function newWarrantyModalProjectsData(data: WarrantyModalProjectsDataOptions): WarrantyModalProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newWarrantyModalProjectsResponse(
  variables: WarrantyModalProjectsQueryVariables,
  data: WarrantyModalProjectsDataOptions | Error,
): MockedResponse<WarrantyModalProjectsQueryVariables, WarrantyModalProjectsQuery> {
  return {
    request: { query: WarrantyModalProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newWarrantyModalProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PaymentTermsDataOptions {
  paymentTerms?: FactoryInput<PaymentTerm, PaymentTermOptions>[];
  paymentTermDueFromDetails?: FactoryInput<PaymentTermDueFromDetail, PaymentTermDueFromDetailOptions>[];
}

export function newPaymentTermsData(data: PaymentTermsDataOptions): PaymentTermsQuery {
  return {
    __typename: "Query" as const,
    paymentTerms: data["paymentTerms"]?.map((d) => maybeNew("PaymentTerm", d, {})) || [],
    paymentTermDueFromDetails:
      data["paymentTermDueFromDetails"]?.map((d) => maybeNew("PaymentTermDueFromDetail", d, {})) || [],
  } as any;
}

export function newPaymentTermsResponse(
  data: PaymentTermsDataOptions | Error,
): MockedResponse<PaymentTermsQueryVariables, PaymentTermsQuery> {
  return {
    request: { query: PaymentTermsDocument },
    result: { data: data instanceof Error ? undefined : newPaymentTermsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePaymentTermDataOptions {
  savePaymentTerm?: FactoryInput<SavePaymentTermResult, SavePaymentTermResultOptions>;
}

export function newSavePaymentTermData(data: SavePaymentTermDataOptions): SavePaymentTermMutation {
  return {
    __typename: "Mutation" as const,
    savePaymentTerm: maybeNew("SavePaymentTermResult", data["savePaymentTerm"] || undefined, {}),
  } as any;
}

export function newSavePaymentTermResponse(
  variables: SavePaymentTermMutationVariables,
  data: SavePaymentTermDataOptions | Error,
): MockedResponse<SavePaymentTermMutationVariables, SavePaymentTermMutation> {
  return {
    request: { query: SavePaymentTermDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePaymentTermData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectContactsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectContactsData(data: ProjectContactsDataOptions): ProjectContactsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectContactsResponse(
  variables: ProjectContactsQueryVariables,
  data: ProjectContactsDataOptions | Error,
): MockedResponse<ProjectContactsQueryVariables, ProjectContactsQuery> {
  return {
    request: { query: ProjectContactsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectContactsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectContactWarrantyDataOptions {
  saveProjectContact?: FactoryInput<SaveProjectContactResult, SaveProjectContactResultOptions>;
}

export function newSaveProjectContactWarrantyData(
  data: SaveProjectContactWarrantyDataOptions,
): SaveProjectContactWarrantyMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectContact: maybeNew("SaveProjectContactResult", data["saveProjectContact"] || undefined, {}),
  } as any;
}

export function newSaveProjectContactWarrantyResponse(
  variables: SaveProjectContactWarrantyMutationVariables,
  data: SaveProjectContactWarrantyDataOptions | Error,
): MockedResponse<SaveProjectContactWarrantyMutationVariables, SaveProjectContactWarrantyMutation> {
  return {
    request: { query: SaveProjectContactWarrantyDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectContactWarrantyData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateInvoiceTermsMetadataDataOptions {
  customers?: FactoryInput<Customer, CustomerOptions>[];
  regions?: FactoryInput<Region, RegionOptions>[];
}

export function newCreateInvoiceTermsMetadataData(
  data: CreateInvoiceTermsMetadataDataOptions,
): CreateInvoiceTermsMetadataQuery {
  return {
    __typename: "Query" as const,
    customers: data["customers"]?.map((d) => maybeNew("Customer", d, {})) || [],
    regions: data["regions"]?.map((d) => maybeNew("Region", d, {})) || [],
  } as any;
}

export function newCreateInvoiceTermsMetadataResponse(
  data: CreateInvoiceTermsMetadataDataOptions | Error,
): MockedResponse<CreateInvoiceTermsMetadataQueryVariables, CreateInvoiceTermsMetadataQuery> {
  return {
    request: { query: CreateInvoiceTermsMetadataDocument },
    result: { data: data instanceof Error ? undefined : newCreateInvoiceTermsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AdminLocationDrawerDataOptions {
  location?: FactoryInput<Location, LocationOptions>;
}

export function newAdminLocationDrawerData(data: AdminLocationDrawerDataOptions): AdminLocationDrawerQuery {
  return { __typename: "Query" as const, location: maybeNew("Location", data["location"] || undefined, {}) } as any;
}

export function newAdminLocationDrawerResponse(
  variables: AdminLocationDrawerQueryVariables,
  data: AdminLocationDrawerDataOptions | Error,
): MockedResponse<AdminLocationDrawerQueryVariables, AdminLocationDrawerQuery> {
  return {
    request: { query: AdminLocationDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newAdminLocationDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveAdminLocationDrawerDataOptions {
  saveLocations?: FactoryInput<SaveLocationsResult, SaveLocationsResultOptions>;
}

export function newSaveAdminLocationDrawerData(
  data: SaveAdminLocationDrawerDataOptions,
): SaveAdminLocationDrawerMutation {
  return {
    __typename: "Mutation" as const,
    saveLocations: maybeNew("SaveLocationsResult", data["saveLocations"] || undefined, {}),
  } as any;
}

export function newSaveAdminLocationDrawerResponse(
  variables: SaveAdminLocationDrawerMutationVariables,
  data: SaveAdminLocationDrawerDataOptions | Error,
): MockedResponse<SaveAdminLocationDrawerMutationVariables, SaveAdminLocationDrawerMutation> {
  return {
    request: { query: SaveAdminLocationDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveAdminLocationDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceTermsDataOptions {
  invoiceScheduleTemplates?: FactoryInput<InvoiceScheduleTemplate, InvoiceScheduleTemplateOptions>[];
}

export function newInvoiceTermsData(data: InvoiceTermsDataOptions): InvoiceTermsQuery {
  return {
    __typename: "Query" as const,
    invoiceScheduleTemplates:
      data["invoiceScheduleTemplates"]?.map((d) => maybeNew("InvoiceScheduleTemplate", d, {})) || [],
  } as any;
}

export function newInvoiceTermsResponse(
  data: InvoiceTermsDataOptions | Error,
): MockedResponse<InvoiceTermsQueryVariables, InvoiceTermsQuery> {
  return {
    request: { query: InvoiceTermsDocument },
    result: { data: data instanceof Error ? undefined : newInvoiceTermsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageDetailsStepDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newBidPackageDetailsStepData(data: BidPackageDetailsStepDataOptions): BidPackageDetailsStepQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newBidPackageDetailsStepResponse(
  data: BidPackageDetailsStepDataOptions | Error,
): MockedResponse<BidPackageDetailsStepQueryVariables, BidPackageDetailsStepQuery> {
  return {
    request: { query: BidPackageDetailsStepDocument },
    result: { data: data instanceof Error ? undefined : newBidPackageDetailsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectBiddersStepDataOptions {
  bidPackageGroup?: FactoryInput<BidPackageGroup, BidPackageGroupOptions>;
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newSelectBiddersStepData(data: SelectBiddersStepDataOptions): SelectBiddersStepQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroup: maybeNew("BidPackageGroup", data["bidPackageGroup"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newSelectBiddersStepResponse(
  variables: SelectBiddersStepQueryVariables,
  data: SelectBiddersStepDataOptions | Error,
): MockedResponse<SelectBiddersStepQueryVariables, SelectBiddersStepQuery> {
  return {
    request: { query: SelectBiddersStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectBiddersStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceTermsFormMetadataDataOptions {
  customers?: FactoryInput<Customer, CustomerOptions>[];
  regions?: FactoryInput<Region, RegionOptions>[];
  globalPlanMilestones?: FactoryInput<GlobalPlanMilestonesPageResult, GlobalPlanMilestonesPageResultOptions>;
}

export function newInvoiceTermsFormMetadataData(
  data: InvoiceTermsFormMetadataDataOptions,
): InvoiceTermsFormMetadataQuery {
  return {
    __typename: "Query" as const,
    customers: data["customers"]?.map((d) => maybeNew("Customer", d, {})) || [],
    regions: data["regions"]?.map((d) => maybeNew("Region", d, {})) || [],
    globalPlanMilestones: maybeNew("GlobalPlanMilestonesPageResult", data["globalPlanMilestones"] || undefined, {}),
  } as any;
}

export function newInvoiceTermsFormMetadataResponse(
  variables: InvoiceTermsFormMetadataQueryVariables,
  data: InvoiceTermsFormMetadataDataOptions | Error,
): MockedResponse<InvoiceTermsFormMetadataQueryVariables, InvoiceTermsFormMetadataQuery> {
  return {
    request: { query: InvoiceTermsFormMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceTermsFormMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceTermsFormDataOptions {
  invoiceScheduleTemplate?: FactoryInput<InvoiceScheduleTemplate, InvoiceScheduleTemplateOptions>;
}

export function newInvoiceTermsFormData(data: InvoiceTermsFormDataOptions): InvoiceTermsFormQuery {
  return {
    __typename: "Query" as const,
    invoiceScheduleTemplate: maybeNew("InvoiceScheduleTemplate", data["invoiceScheduleTemplate"] || undefined, {}),
  } as any;
}

export function newInvoiceTermsFormResponse(
  variables: InvoiceTermsFormQueryVariables,
  data: InvoiceTermsFormDataOptions | Error,
): MockedResponse<InvoiceTermsFormQueryVariables, InvoiceTermsFormQuery> {
  return {
    request: { query: InvoiceTermsFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceTermsFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveInvoiceTermsDataOptions {
  saveInvoiceScheduleTemplate?: FactoryInput<
    SaveInvoiceScheduleTemplateResult,
    SaveInvoiceScheduleTemplateResultOptions
  >;
}

export function newSaveInvoiceTermsData(data: SaveInvoiceTermsDataOptions): SaveInvoiceTermsMutation {
  return {
    __typename: "Mutation" as const,
    saveInvoiceScheduleTemplate: maybeNew(
      "SaveInvoiceScheduleTemplateResult",
      data["saveInvoiceScheduleTemplate"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveInvoiceTermsResponse(
  variables: SaveInvoiceTermsMutationVariables,
  data: SaveInvoiceTermsDataOptions | Error,
): MockedResponse<SaveInvoiceTermsMutationVariables, SaveInvoiceTermsMutation> {
  return {
    request: { query: SaveInvoiceTermsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveInvoiceTermsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewAndSendStepDataOptions {
  bidPackageGroup?: FactoryInput<BidPackageGroup, BidPackageGroupOptions>;
}

export function newReviewAndSendStepData(data: ReviewAndSendStepDataOptions): ReviewAndSendStepQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroup: maybeNew("BidPackageGroup", data["bidPackageGroup"] || undefined, {}),
  } as any;
}

export function newReviewAndSendStepResponse(
  variables: ReviewAndSendStepQueryVariables,
  data: ReviewAndSendStepDataOptions | Error,
): MockedResponse<ReviewAndSendStepQueryVariables, ReviewAndSendStepQuery> {
  return {
    request: { query: ReviewAndSendStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewAndSendStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewUnitBidScopeStep_BidPackageGroupDataOptions {
  bidPackageGroup?: FactoryInput<BidPackageGroup, BidPackageGroupOptions>;
}

export function newReviewUnitBidScopeStep_BidPackageGroupData(
  data: ReviewUnitBidScopeStep_BidPackageGroupDataOptions,
): ReviewUnitBidScopeStep_BidPackageGroupQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroup: maybeNew("BidPackageGroup", data["bidPackageGroup"] || undefined, {}),
  } as any;
}

export function newReviewUnitBidScopeStep_BidPackageGroupResponse(
  variables: ReviewUnitBidScopeStep_BidPackageGroupQueryVariables,
  data: ReviewUnitBidScopeStep_BidPackageGroupDataOptions | Error,
): MockedResponse<ReviewUnitBidScopeStep_BidPackageGroupQueryVariables, ReviewUnitBidScopeStep_BidPackageGroupQuery> {
  return {
    request: { query: ReviewUnitBidScopeStep_BidPackageGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewUnitBidScopeStep_BidPackageGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidMetaDataOptions {
  costTypes?: FactoryInput<CostTypeDetail, CostTypeDetailOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
  materialVariantTags?: FactoryInput<MaterialVariantTag, MaterialVariantTagOptions>[];
}

export function newBidMetaData(data: BidMetaDataOptions): BidMetaQuery {
  return {
    __typename: "Query" as const,
    costTypes: data["costTypes"]?.map((d) => maybeNew("CostTypeDetail", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    materialVariantTags: data["materialVariantTags"]?.map((d) => maybeNew("MaterialVariantTag", d, {})) || [],
  } as any;
}

export function newBidMetaResponse(
  variables: BidMetaQueryVariables,
  data: BidMetaDataOptions | Error,
): MockedResponse<BidMetaQueryVariables, BidMetaQuery> {
  return {
    request: { query: BidMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditBidMetaDataOptions {
  costTypes?: FactoryInput<CostTypeDetail, CostTypeDetailOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
  materialVariantTags?: FactoryInput<MaterialVariantTag, MaterialVariantTagOptions>[];
  bidPackageVersion?: FactoryInput<BidPackageVersion, BidPackageVersionOptions>;
}

export function newEditBidMetaData(data: EditBidMetaDataOptions): EditBidMetaQuery {
  return {
    __typename: "Query" as const,
    costTypes: data["costTypes"]?.map((d) => maybeNew("CostTypeDetail", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    materialVariantTags: data["materialVariantTags"]?.map((d) => maybeNew("MaterialVariantTag", d, {})) || [],
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
  } as any;
}

export function newEditBidMetaResponse(
  variables: EditBidMetaQueryVariables,
  data: EditBidMetaDataOptions | Error,
): MockedResponse<EditBidMetaQueryVariables, EditBidMetaQuery> {
  return {
    request: { query: EditBidMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditBidMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageLineItemModalDataOptions {
  potentialBidItemsPage?: FactoryInput<BidItemsPage, BidItemsPageOptions>;
}

export function newBidPackageLineItemModalData(data: BidPackageLineItemModalDataOptions): BidPackageLineItemModalQuery {
  return {
    __typename: "Query" as const,
    potentialBidItemsPage: maybeNew("BidItemsPage", data["potentialBidItemsPage"] || undefined, {}),
  } as any;
}

export function newBidPackageLineItemModalResponse(
  variables: BidPackageLineItemModalQueryVariables,
  data: BidPackageLineItemModalDataOptions | Error,
): MockedResponse<BidPackageLineItemModalQueryVariables, BidPackageLineItemModalQuery> {
  return {
    request: { query: BidPackageLineItemModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackageLineItemModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidProjectFieldsDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newBidProjectFieldsData(data: BidProjectFieldsDataOptions): BidProjectFieldsQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newBidProjectFieldsResponse(
  variables: BidProjectFieldsQueryVariables,
  data: BidProjectFieldsDataOptions | Error,
): MockedResponse<BidProjectFieldsQueryVariables, BidProjectFieldsQuery> {
  return {
    request: { query: BidProjectFieldsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidProjectFieldsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidPackageDetailsStepDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
  costCodes?: FactoryInput<CostCode, CostCodeOptions>[];
}

export function newPlanBasedBidPackageDetailsStepData(
  data: PlanBasedBidPackageDetailsStepDataOptions,
): PlanBasedBidPackageDetailsStepQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    costCodes: data["costCodes"]?.map((d) => maybeNew("CostCode", d, {})) || [],
  } as any;
}

export function newPlanBasedBidPackageDetailsStepResponse(
  data: PlanBasedBidPackageDetailsStepDataOptions | Error,
): MockedResponse<PlanBasedBidPackageDetailsStepQueryVariables, PlanBasedBidPackageDetailsStepQuery> {
  return {
    request: { query: PlanBasedBidPackageDetailsStepDocument },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidPackageDetailsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidPackageDetailsStep_ProductOfferingsDataOptions {
  productOfferings?: FactoryInput<ProductOfferingsPageResult, ProductOfferingsPageResultOptions>;
}

export function newPlanBasedBidPackageDetailsStep_ProductOfferingsData(
  data: PlanBasedBidPackageDetailsStep_ProductOfferingsDataOptions,
): PlanBasedBidPackageDetailsStep_ProductOfferingsQuery {
  return {
    __typename: "Query" as const,
    productOfferings: maybeNew("ProductOfferingsPageResult", data["productOfferings"] || undefined, {}),
  } as any;
}

export function newPlanBasedBidPackageDetailsStep_ProductOfferingsResponse(
  variables: PlanBasedBidPackageDetailsStep_ProductOfferingsQueryVariables,
  data: PlanBasedBidPackageDetailsStep_ProductOfferingsDataOptions | Error,
): MockedResponse<
  PlanBasedBidPackageDetailsStep_ProductOfferingsQueryVariables,
  PlanBasedBidPackageDetailsStep_ProductOfferingsQuery
> {
  return {
    request: { query: PlanBasedBidPackageDetailsStep_ProductOfferingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidPackageDetailsStep_ProductOfferingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidPackageDetailsStep_CommunitiesDataOptions {
  communities?: FactoryInput<CommunitiesPageResult, CommunitiesPageResultOptions>;
}

export function newPlanBasedBidPackageDetailsStep_CommunitiesData(
  data: PlanBasedBidPackageDetailsStep_CommunitiesDataOptions,
): PlanBasedBidPackageDetailsStep_CommunitiesQuery {
  return {
    __typename: "Query" as const,
    communities: maybeNew("CommunitiesPageResult", data["communities"] || undefined, {}),
  } as any;
}

export function newPlanBasedBidPackageDetailsStep_CommunitiesResponse(
  variables: PlanBasedBidPackageDetailsStep_CommunitiesQueryVariables,
  data: PlanBasedBidPackageDetailsStep_CommunitiesDataOptions | Error,
): MockedResponse<
  PlanBasedBidPackageDetailsStep_CommunitiesQueryVariables,
  PlanBasedBidPackageDetailsStep_CommunitiesQuery
> {
  return {
    request: { query: PlanBasedBidPackageDetailsStep_CommunitiesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidPackageDetailsStep_CommunitiesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfigureBidGroupsStepDataOptions {
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
  potentialBidPlanDimensions?: FactoryInput<PotentialBidPlanDimensionResult, PotentialBidPlanDimensionResultOptions>[];
}

export function newConfigureBidGroupsStepData(data: ConfigureBidGroupsStepDataOptions): ConfigureBidGroupsStepQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
    potentialBidPlanDimensions:
      data["potentialBidPlanDimensions"]?.map((d) => maybeNew("PotentialBidPlanDimensionResult", d, {})) || [],
  } as any;
}

export function newConfigureBidGroupsStepResponse(
  variables: ConfigureBidGroupsStepQueryVariables,
  data: ConfigureBidGroupsStepDataOptions | Error,
): MockedResponse<ConfigureBidGroupsStepQueryVariables, ConfigureBidGroupsStepQuery> {
  return {
    request: { query: ConfigureBidGroupsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfigureBidGroupsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidPackageReviewAndDownloadStepDataOptions {
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newPlanBasedBidPackageReviewAndDownloadStepData(
  data: PlanBasedBidPackageReviewAndDownloadStepDataOptions,
): PlanBasedBidPackageReviewAndDownloadStepQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newPlanBasedBidPackageReviewAndDownloadStepResponse(
  variables: PlanBasedBidPackageReviewAndDownloadStepQueryVariables,
  data: PlanBasedBidPackageReviewAndDownloadStepDataOptions | Error,
): MockedResponse<
  PlanBasedBidPackageReviewAndDownloadStepQueryVariables,
  PlanBasedBidPackageReviewAndDownloadStepQuery
> {
  return {
    request: { query: PlanBasedBidPackageReviewAndDownloadStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidPackageReviewAndDownloadStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyCostsModal_SaveBidContractDataOptions {
  saveBidContract?: FactoryInput<SaveBidContractResult, SaveBidContractResultOptions>;
}

export function newCopyCostsModal_SaveBidContractData(
  data: CopyCostsModal_SaveBidContractDataOptions,
): CopyCostsModal_SaveBidContractMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContract: maybeNew("SaveBidContractResult", data["saveBidContract"] || undefined, {}),
  } as any;
}

export function newCopyCostsModal_SaveBidContractResponse(
  variables: CopyCostsModal_SaveBidContractMutationVariables,
  data: CopyCostsModal_SaveBidContractDataOptions | Error,
): MockedResponse<CopyCostsModal_SaveBidContractMutationVariables, CopyCostsModal_SaveBidContractMutation> {
  return {
    request: { query: CopyCostsModal_SaveBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyCostsModal_SaveBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyCostsModal_CopyPlanBasedBidCostsDataOptions {
  copyPlanBasedBidCosts?: FactoryInput<CopyPlanBasedBidCostsResult, CopyPlanBasedBidCostsResultOptions>;
}

export function newCopyCostsModal_CopyPlanBasedBidCostsData(
  data: CopyCostsModal_CopyPlanBasedBidCostsDataOptions,
): CopyCostsModal_CopyPlanBasedBidCostsMutation {
  return {
    __typename: "Mutation" as const,
    copyPlanBasedBidCosts: maybeNew("CopyPlanBasedBidCostsResult", data["copyPlanBasedBidCosts"] || undefined, {}),
  } as any;
}

export function newCopyCostsModal_CopyPlanBasedBidCostsResponse(
  variables: CopyCostsModal_CopyPlanBasedBidCostsMutationVariables,
  data: CopyCostsModal_CopyPlanBasedBidCostsDataOptions | Error,
): MockedResponse<CopyCostsModal_CopyPlanBasedBidCostsMutationVariables, CopyCostsModal_CopyPlanBasedBidCostsMutation> {
  return {
    request: { query: CopyCostsModal_CopyPlanBasedBidCostsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyCostsModal_CopyPlanBasedBidCostsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidsTableV2_BidPlanChildGroupsDataOptions {
  bidPackage?: FactoryInput<BidPackage, BidPackageOptions>;
}

export function newPlanBasedBidsTableV2_BidPlanChildGroupsData(
  data: PlanBasedBidsTableV2_BidPlanChildGroupsDataOptions,
): PlanBasedBidsTableV2_BidPlanChildGroupsQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newPlanBasedBidsTableV2_BidPlanChildGroupsResponse(
  variables: PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables,
  data: PlanBasedBidsTableV2_BidPlanChildGroupsDataOptions | Error,
): MockedResponse<PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables, PlanBasedBidsTableV2_BidPlanChildGroupsQuery> {
  return {
    request: { query: PlanBasedBidsTableV2_BidPlanChildGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidsTableV2_BidPlanChildGroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidsTableV2_RevisionLinesDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newPlanBasedBidsTableV2_RevisionLinesData(
  data: PlanBasedBidsTableV2_RevisionLinesDataOptions,
): PlanBasedBidsTableV2_RevisionLinesQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newPlanBasedBidsTableV2_RevisionLinesResponse(
  variables: PlanBasedBidsTableV2_RevisionLinesQueryVariables,
  data: PlanBasedBidsTableV2_RevisionLinesDataOptions | Error,
): MockedResponse<PlanBasedBidsTableV2_RevisionLinesQueryVariables, PlanBasedBidsTableV2_RevisionLinesQuery> {
  return {
    request: { query: PlanBasedBidsTableV2_RevisionLinesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidsTableV2_RevisionLinesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UploadBidV2ModalDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newUploadBidV2ModalData(data: UploadBidV2ModalDataOptions): UploadBidV2ModalQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newUploadBidV2ModalResponse(
  variables: UploadBidV2ModalQueryVariables,
  data: UploadBidV2ModalDataOptions | Error,
): MockedResponse<UploadBidV2ModalQueryVariables, UploadBidV2ModalQuery> {
  return {
    request: { query: UploadBidV2ModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newUploadBidV2ModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalChangeEventDataOptions {
  changeEvents?: FactoryInput<ChangeEvent, ChangeEventOptions>[];
}

export function newApprovalChangeEventData(data: ApprovalChangeEventDataOptions): ApprovalChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => maybeNew("ChangeEvent", d, {})) || [],
  } as any;
}

export function newApprovalChangeEventResponse(
  variables: ApprovalChangeEventQueryVariables,
  data: ApprovalChangeEventDataOptions | Error,
): MockedResponse<ApprovalChangeEventQueryVariables, ApprovalChangeEventQuery> {
  return {
    request: { query: ApprovalChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveApprovalChangeEventDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newSaveApprovalChangeEventData(
  data: SaveApprovalChangeEventDataOptions,
): SaveApprovalChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newSaveApprovalChangeEventResponse(
  variables: SaveApprovalChangeEventMutationVariables,
  data: SaveApprovalChangeEventDataOptions | Error,
): MockedResponse<SaveApprovalChangeEventMutationVariables, SaveApprovalChangeEventMutation> {
  return {
    request: { query: SaveApprovalChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveApprovalChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalChangeEventBreakDownTabDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newApprovalChangeEventBreakDownTabData(
  data: ApprovalChangeEventBreakDownTabDataOptions,
): ApprovalChangeEventBreakDownTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newApprovalChangeEventBreakDownTabResponse(
  variables: ApprovalChangeEventBreakDownTabQueryVariables,
  data: ApprovalChangeEventBreakDownTabDataOptions | Error,
): MockedResponse<ApprovalChangeEventBreakDownTabQueryVariables, ApprovalChangeEventBreakDownTabQuery> {
  return {
    request: { query: ApprovalChangeEventBreakDownTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalChangeEventBreakDownTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalChangeEventImpactedPosTableTabDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newApprovalChangeEventImpactedPosTableTabData(
  data: ApprovalChangeEventImpactedPosTableTabDataOptions,
): ApprovalChangeEventImpactedPosTableTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newApprovalChangeEventImpactedPosTableTabResponse(
  variables: ApprovalChangeEventImpactedPosTableTabQueryVariables,
  data: ApprovalChangeEventImpactedPosTableTabDataOptions | Error,
): MockedResponse<ApprovalChangeEventImpactedPosTableTabQueryVariables, ApprovalChangeEventImpactedPosTableTabQuery> {
  return {
    request: { query: ApprovalChangeEventImpactedPosTableTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalChangeEventImpactedPosTableTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CohortDetailsForFormDataOptions {
  cohort?: FactoryInput<Cohort, CohortOptions>;
}

export function newCohortDetailsForFormData(data: CohortDetailsForFormDataOptions): CohortDetailsForFormQuery {
  return { __typename: "Query" as const, cohort: maybeNew("Cohort", data["cohort"] || undefined, {}) } as any;
}

export function newCohortDetailsForFormResponse(
  variables: CohortDetailsForFormQueryVariables,
  data: CohortDetailsForFormDataOptions | Error,
): MockedResponse<CohortDetailsForFormQueryVariables, CohortDetailsForFormQuery> {
  return {
    request: { query: CohortDetailsForFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newCohortDetailsForFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PopulateCohortFormOptionsDataOptions {
  markets?: FactoryInput<Market, MarketOptions>[];
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newPopulateCohortFormOptionsData(
  data: PopulateCohortFormOptionsDataOptions,
): PopulateCohortFormOptionsQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newPopulateCohortFormOptionsResponse(
  data: PopulateCohortFormOptionsDataOptions | Error,
): MockedResponse<PopulateCohortFormOptionsQueryVariables, PopulateCohortFormOptionsQuery> {
  return {
    request: { query: PopulateCohortFormOptionsDocument },
    result: { data: data instanceof Error ? undefined : newPopulateCohortFormOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCohortsDataOptions {
  saveCohorts?: FactoryInput<SaveCohortsResult, SaveCohortsResultOptions>;
}

export function newSaveCohortsData(data: SaveCohortsDataOptions): SaveCohortsMutation {
  return {
    __typename: "Mutation" as const,
    saveCohorts: maybeNew("SaveCohortsResult", data["saveCohorts"] || undefined, {}),
  } as any;
}

export function newSaveCohortsResponse(
  variables: SaveCohortsMutationVariables,
  data: SaveCohortsDataOptions | Error,
): MockedResponse<SaveCohortsMutationVariables, SaveCohortsMutation> {
  return {
    request: { query: SaveCohortsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCohortsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmTradesStepV2DataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  relevantProjectBidPackages?: FactoryInput<RelevantProjectBidPackage, RelevantProjectBidPackageOptions>[];
}

export function newConfirmTradesStepV2Data(data: ConfirmTradesStepV2DataOptions): ConfirmTradesStepV2Query {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    relevantProjectBidPackages:
      data["relevantProjectBidPackages"]?.map((d) => maybeNew("RelevantProjectBidPackage", d, {})) || [],
  } as any;
}

export function newConfirmTradesStepV2Response(
  variables: ConfirmTradesStepV2QueryVariables,
  data: ConfirmTradesStepV2DataOptions | Error,
): MockedResponse<ConfirmTradesStepV2QueryVariables, ConfirmTradesStepV2Query> {
  return {
    request: { query: ConfirmTradesStepV2Document, variables },
    result: { data: data instanceof Error ? undefined : newConfirmTradesStepV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AssignBidPackageWorkToBidContractDataOptions {
  assignBidPackageWorkToBidContract?: FactoryInput<Commitment, CommitmentOptions>[];
}

export function newAssignBidPackageWorkToBidContractData(
  data: AssignBidPackageWorkToBidContractDataOptions,
): AssignBidPackageWorkToBidContractMutation {
  return {
    __typename: "Mutation" as const,
    assignBidPackageWorkToBidContract:
      data["assignBidPackageWorkToBidContract"]?.map((d) => maybeNew("Commitment", d, {})) || [],
  } as any;
}

export function newAssignBidPackageWorkToBidContractResponse(
  variables: AssignBidPackageWorkToBidContractMutationVariables,
  data: AssignBidPackageWorkToBidContractDataOptions | Error,
): MockedResponse<AssignBidPackageWorkToBidContractMutationVariables, AssignBidPackageWorkToBidContractMutation> {
  return {
    request: { query: AssignBidPackageWorkToBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newAssignBidPackageWorkToBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMapItemsStepDataOptions {
  saveScheduleTemplateItemMappings?: FactoryInput<
    SaveScheduleTemplateItemMappingsResult,
    SaveScheduleTemplateItemMappingsResultOptions
  >;
}

export function newSaveMapItemsStepData(data: SaveMapItemsStepDataOptions): SaveMapItemsStepMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTemplateItemMappings: maybeNew(
      "SaveScheduleTemplateItemMappingsResult",
      data["saveScheduleTemplateItemMappings"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveMapItemsStepResponse(
  variables: SaveMapItemsStepMutationVariables,
  data: SaveMapItemsStepDataOptions | Error,
): MockedResponse<SaveMapItemsStepMutationVariables, SaveMapItemsStepMutation> {
  return {
    request: { query: SaveMapItemsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMapItemsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostMappingScheduleTasksDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newCostMappingScheduleTasksData(
  data: CostMappingScheduleTasksDataOptions,
): CostMappingScheduleTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newCostMappingScheduleTasksResponse(
  variables: CostMappingScheduleTasksQueryVariables,
  data: CostMappingScheduleTasksDataOptions | Error,
): MockedResponse<CostMappingScheduleTasksQueryVariables, CostMappingScheduleTasksQuery> {
  return {
    request: { query: CostMappingScheduleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostMappingScheduleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmTradesStepDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newConfirmTradesStepData(data: ConfirmTradesStepDataOptions): ConfirmTradesStepQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newConfirmTradesStepResponse(
  variables: ConfirmTradesStepQueryVariables,
  data: ConfirmTradesStepDataOptions | Error,
): MockedResponse<ConfirmTradesStepQueryVariables, ConfirmTradesStepQuery> {
  return {
    request: { query: ConfirmTradesStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmTradesStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmTrades_ProjectItemsDataOptions {
  projectItemsPage?: FactoryInput<ProjectItemsPage, ProjectItemsPageOptions>;
}

export function newConfirmTrades_ProjectItemsData(
  data: ConfirmTrades_ProjectItemsDataOptions,
): ConfirmTrades_ProjectItemsQuery {
  return {
    __typename: "Query" as const,
    projectItemsPage: maybeNew("ProjectItemsPage", data["projectItemsPage"] || undefined, {}),
  } as any;
}

export function newConfirmTrades_ProjectItemsResponse(
  variables: ConfirmTrades_ProjectItemsQueryVariables,
  data: ConfirmTrades_ProjectItemsDataOptions | Error,
): MockedResponse<ConfirmTrades_ProjectItemsQueryVariables, ConfirmTrades_ProjectItemsQuery> {
  return {
    request: { query: ConfirmTrades_ProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmTrades_ProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AssignWorkToBidContractDataOptions {
  assignWorkToBidContract?: FactoryInput<ChangeEvent, ChangeEventOptions>[];
}

export function newAssignWorkToBidContractData(
  data: AssignWorkToBidContractDataOptions,
): AssignWorkToBidContractMutation {
  return {
    __typename: "Mutation" as const,
    assignWorkToBidContract: data["assignWorkToBidContract"]?.map((d) => maybeNew("ChangeEvent", d, {})) || [],
  } as any;
}

export function newAssignWorkToBidContractResponse(
  variables: AssignWorkToBidContractMutationVariables,
  data: AssignWorkToBidContractDataOptions | Error,
): MockedResponse<AssignWorkToBidContractMutationVariables, AssignWorkToBidContractMutation> {
  return {
    request: { query: AssignWorkToBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newAssignWorkToBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UnassignWorkFromBidContractDataOptions {
  unassignWorkFromBidContract?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newUnassignWorkFromBidContractData(
  data: UnassignWorkFromBidContractDataOptions,
): UnassignWorkFromBidContractMutation {
  return {
    __typename: "Mutation" as const,
    unassignWorkFromBidContract: maybeNew("EmptyResult", data["unassignWorkFromBidContract"] || undefined, {}),
  } as any;
}

export function newUnassignWorkFromBidContractResponse(
  variables: UnassignWorkFromBidContractMutationVariables,
  data: UnassignWorkFromBidContractDataOptions | Error,
): MockedResponse<UnassignWorkFromBidContractMutationVariables, UnassignWorkFromBidContractMutation> {
  return {
    request: { query: UnassignWorkFromBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newUnassignWorkFromBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReleaseToTradesPageDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newReleaseToTradesPageData(data: ReleaseToTradesPageDataOptions): ReleaseToTradesPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newReleaseToTradesPageResponse(
  variables: ReleaseToTradesPageQueryVariables,
  data: ReleaseToTradesPageDataOptions | Error,
): MockedResponse<ReleaseToTradesPageQueryVariables, ReleaseToTradesPageQuery> {
  return {
    request: { query: ReleaseToTradesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newReleaseToTradesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewOrdersStepDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newReviewOrdersStepData(data: ReviewOrdersStepDataOptions): ReviewOrdersStepQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newReviewOrdersStepResponse(
  variables: ReviewOrdersStepQueryVariables,
  data: ReviewOrdersStepDataOptions | Error,
): MockedResponse<ReviewOrdersStepQueryVariables, ReviewOrdersStepQuery> {
  return {
    request: { query: ReviewOrdersStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewOrdersStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewOrdersStepReleaseCommitmentsDataOptions {
  releaseBidCommitments?: FactoryInput<CommitmentLike, CommitmentLikeOptions>[];
}

export function newReviewOrdersStepReleaseCommitmentsData(
  data: ReviewOrdersStepReleaseCommitmentsDataOptions,
): ReviewOrdersStepReleaseCommitmentsMutation {
  return {
    __typename: "Mutation" as const,
    releaseBidCommitments: data["releaseBidCommitments"]?.map((d) => maybeNew("CommitmentLike", d, {})) || [],
  } as any;
}

export function newReviewOrdersStepReleaseCommitmentsResponse(
  variables: ReviewOrdersStepReleaseCommitmentsMutationVariables,
  data: ReviewOrdersStepReleaseCommitmentsDataOptions | Error,
): MockedResponse<ReviewOrdersStepReleaseCommitmentsMutationVariables, ReviewOrdersStepReleaseCommitmentsMutation> {
  return {
    request: { query: ReviewOrdersStepReleaseCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewOrdersStepReleaseCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReleaseToTradesTabDataOptions {
  projectReadyPlanConfigs?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>[];
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
}

export function newReleaseToTradesTabData(data: ReleaseToTradesTabDataOptions): ReleaseToTradesTabQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfigs: data["projectReadyPlanConfigs"]?.map((d) => maybeNew("ProjectReadyPlanConfig", d, {})) ||
      [],
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
  } as any;
}

export function newReleaseToTradesTabResponse(
  variables: ReleaseToTradesTabQueryVariables,
  data: ReleaseToTradesTabDataOptions | Error,
): MockedResponse<ReleaseToTradesTabQueryVariables, ReleaseToTradesTabQuery> {
  return {
    request: { query: ReleaseToTradesTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newReleaseToTradesTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProjectReadyPlanConfigsDataOptions {
  applyProjectReadyPlanConfigs?: FactoryInput<
    ApplyProjectReadyPlanConfigsResult,
    ApplyProjectReadyPlanConfigsResultOptions
  >;
}

export function newApplyProjectReadyPlanConfigsData(
  data: ApplyProjectReadyPlanConfigsDataOptions,
): ApplyProjectReadyPlanConfigsMutation {
  return {
    __typename: "Mutation" as const,
    applyProjectReadyPlanConfigs: maybeNew(
      "ApplyProjectReadyPlanConfigsResult",
      data["applyProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newApplyProjectReadyPlanConfigsResponse(
  variables: ApplyProjectReadyPlanConfigsMutationVariables,
  data: ApplyProjectReadyPlanConfigsDataOptions | Error,
): MockedResponse<ApplyProjectReadyPlanConfigsMutationVariables, ApplyProjectReadyPlanConfigsMutation> {
  return {
    request: { query: ApplyProjectReadyPlanConfigsDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProjectReadyPlanConfigsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanDetailsStepMetadataDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newPlanDetailsStepMetadataData(data: PlanDetailsStepMetadataDataOptions): PlanDetailsStepMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newPlanDetailsStepMetadataResponse(
  data: PlanDetailsStepMetadataDataOptions | Error,
): MockedResponse<PlanDetailsStepMetadataQueryVariables, PlanDetailsStepMetadataQuery> {
  return {
    request: { query: PlanDetailsStepMetadataDocument },
    result: { data: data instanceof Error ? undefined : newPlanDetailsStepMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanDetailsStepDataOptions {
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
}

export function newPlanDetailsStepData(data: PlanDetailsStepDataOptions): PlanDetailsStepQuery {
  return { __typename: "Query" as const, readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}) } as any;
}

export function newPlanDetailsStepResponse(
  variables: PlanDetailsStepQueryVariables,
  data: PlanDetailsStepDataOptions | Error,
): MockedResponse<PlanDetailsStepQueryVariables, PlanDetailsStepQuery> {
  return {
    request: { query: PlanDetailsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanDetailsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanDetailsDataOptions {
  saveReadyPlan?: FactoryInput<SaveReadyPlanResult, SaveReadyPlanResultOptions>;
}

export function newSavePlanDetailsData(data: SavePlanDetailsDataOptions): SavePlanDetailsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlan: maybeNew("SaveReadyPlanResult", data["saveReadyPlan"] || undefined, {}),
  } as any;
}

export function newSavePlanDetailsResponse(
  variables: SavePlanDetailsMutationVariables,
  data: SavePlanDetailsDataOptions | Error,
): MockedResponse<SavePlanDetailsMutationVariables, SavePlanDetailsMutation> {
  return {
    request: { query: SavePlanDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionGroupsDataOptions {
  saveReadyPlanOptionGroups?: FactoryInput<SaveReadyPlanOptionGroupsResult, SaveReadyPlanOptionGroupsResultOptions>;
}

export function newSaveReadyPlanOptionGroupsData(
  data: SaveReadyPlanOptionGroupsDataOptions,
): SaveReadyPlanOptionGroupsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptionGroups: maybeNew(
      "SaveReadyPlanOptionGroupsResult",
      data["saveReadyPlanOptionGroups"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanOptionGroupsResponse(
  variables: SaveReadyPlanOptionGroupsMutationVariables,
  data: SaveReadyPlanOptionGroupsDataOptions | Error,
): MockedResponse<SaveReadyPlanOptionGroupsMutationVariables, SaveReadyPlanOptionGroupsMutation> {
  return {
    request: { query: SaveReadyPlanOptionGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionGroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlansDataOptions {
  saveReadyPlans?: FactoryInput<SaveReadyPlansResult, SaveReadyPlansResultOptions>;
}

export function newSaveReadyPlansData(data: SaveReadyPlansDataOptions): SaveReadyPlansMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlans: maybeNew("SaveReadyPlansResult", data["saveReadyPlans"] || undefined, {}),
  } as any;
}

export function newSaveReadyPlansResponse(
  variables: SaveReadyPlansMutationVariables,
  data: SaveReadyPlansDataOptions | Error,
): MockedResponse<SaveReadyPlansMutationVariables, SaveReadyPlansMutation> {
  return {
    request: { query: SaveReadyPlansDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlansData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateBidContractDataOptions {
  saveBidContract?: FactoryInput<SaveBidContractResult, SaveBidContractResultOptions>;
}

export function newCreateBidContractData(data: CreateBidContractDataOptions): CreateBidContractMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContract: maybeNew("SaveBidContractResult", data["saveBidContract"] || undefined, {}),
  } as any;
}

export function newCreateBidContractResponse(
  variables: CreateBidContractMutationVariables,
  data: CreateBidContractDataOptions | Error,
): MockedResponse<CreateBidContractMutationVariables, CreateBidContractMutation> {
  return {
    request: { query: CreateBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentTradePartnersDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newDevelopmentTradePartnersData(
  data: DevelopmentTradePartnersDataOptions,
): DevelopmentTradePartnersQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentTradePartnersResponse(
  variables: DevelopmentTradePartnersQueryVariables,
  data: DevelopmentTradePartnersDataOptions | Error,
): MockedResponse<DevelopmentTradePartnersQueryVariables, DevelopmentTradePartnersQuery> {
  return {
    request: { query: DevelopmentTradePartnersDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentTradePartnersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RecentlyActivatedItemTemplatesDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newRecentlyActivatedItemTemplatesData(
  data: RecentlyActivatedItemTemplatesDataOptions,
): RecentlyActivatedItemTemplatesQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newRecentlyActivatedItemTemplatesResponse(
  variables: RecentlyActivatedItemTemplatesQueryVariables,
  data: RecentlyActivatedItemTemplatesDataOptions | Error,
): MockedResponse<RecentlyActivatedItemTemplatesQueryVariables, RecentlyActivatedItemTemplatesQuery> {
  return {
    request: { query: RecentlyActivatedItemTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newRecentlyActivatedItemTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentTemplateItemsModalDataOptions {
  bidContractItems?: FactoryInput<BidContractPotentialItem, BidContractPotentialItemOptions>[];
}

export function newDevelopmentTemplateItemsModalData(
  data: DevelopmentTemplateItemsModalDataOptions,
): DevelopmentTemplateItemsModalQuery {
  return {
    __typename: "Query" as const,
    bidContractItems: data["bidContractItems"]?.map((d) => maybeNew("BidContractPotentialItem", d, {})) || [],
  } as any;
}

export function newDevelopmentTemplateItemsModalResponse(
  variables: DevelopmentTemplateItemsModalQueryVariables,
  data: DevelopmentTemplateItemsModalDataOptions | Error,
): MockedResponse<DevelopmentTemplateItemsModalQueryVariables, DevelopmentTemplateItemsModalQuery> {
  return {
    request: { query: DevelopmentTemplateItemsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentTemplateItemsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentTemplateItemsModalMetadataDataOptions {
  readyPlans?: FactoryInput<ReadyPlan, ReadyPlanOptions>[];
  bidContractItems?: FactoryInput<BidContractPotentialItem, BidContractPotentialItemOptions>[];
}

export function newDevelopmentTemplateItemsModalMetadataData(
  data: DevelopmentTemplateItemsModalMetadataDataOptions,
): DevelopmentTemplateItemsModalMetadataQuery {
  return {
    __typename: "Query" as const,
    readyPlans: data["readyPlans"]?.map((d) => maybeNew("ReadyPlan", d, {})) || [],
    bidContractItems: data["bidContractItems"]?.map((d) => maybeNew("BidContractPotentialItem", d, {})) || [],
  } as any;
}

export function newDevelopmentTemplateItemsModalMetadataResponse(
  variables: DevelopmentTemplateItemsModalMetadataQueryVariables,
  data: DevelopmentTemplateItemsModalMetadataDataOptions | Error,
): MockedResponse<DevelopmentTemplateItemsModalMetadataQueryVariables, DevelopmentTemplateItemsModalMetadataQuery> {
  return {
    request: { query: DevelopmentTemplateItemsModalMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentTemplateItemsModalMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TestGroupDependenciesLineItemsDataOptions {
  testGroupDependenciesLineItems?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>[];
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
}

export function newTestGroupDependenciesLineItemsData(
  data: TestGroupDependenciesLineItemsDataOptions,
): TestGroupDependenciesLineItemsQuery {
  return {
    __typename: "Query" as const,
    testGroupDependenciesLineItems:
      data["testGroupDependenciesLineItems"]?.map((d) => maybeNew("TakeoffLineItem", d, {})) || [],
    readyPlanOption: maybeNew("ReadyPlanOption", data["readyPlanOption"] || undefined, {}),
  } as any;
}

export function newTestGroupDependenciesLineItemsResponse(
  variables: TestGroupDependenciesLineItemsQueryVariables,
  data: TestGroupDependenciesLineItemsDataOptions | Error,
): MockedResponse<TestGroupDependenciesLineItemsQueryVariables, TestGroupDependenciesLineItemsQuery> {
  return {
    request: { query: TestGroupDependenciesLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTestGroupDependenciesLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PofAvailableUpdatesDataOptions {
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newPofAvailableUpdatesData(data: PofAvailableUpdatesDataOptions): PofAvailableUpdatesQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newPofAvailableUpdatesResponse(
  variables: PofAvailableUpdatesQueryVariables,
  data: PofAvailableUpdatesDataOptions | Error,
): MockedResponse<PofAvailableUpdatesQueryVariables, PofAvailableUpdatesQuery> {
  return {
    request: { query: PofAvailableUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPofAvailableUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AcceptProductOfferingUpdatesDataOptions {
  acceptProductOfferingUpdates?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newAcceptProductOfferingUpdatesData(
  data: AcceptProductOfferingUpdatesDataOptions,
): AcceptProductOfferingUpdatesMutation {
  return {
    __typename: "Mutation" as const,
    acceptProductOfferingUpdates: maybeNew("ProductOffering", data["acceptProductOfferingUpdates"] || undefined, {}),
  } as any;
}

export function newAcceptProductOfferingUpdatesResponse(
  variables: AcceptProductOfferingUpdatesMutationVariables,
  data: AcceptProductOfferingUpdatesDataOptions | Error,
): MockedResponse<AcceptProductOfferingUpdatesMutationVariables, AcceptProductOfferingUpdatesMutation> {
  return {
    request: { query: AcceptProductOfferingUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAcceptProductOfferingUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskLookaheadDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
}

export function newTaskLookaheadData(data: TaskLookaheadDataOptions): TaskLookaheadQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
  } as any;
}

export function newTaskLookaheadResponse(
  variables: TaskLookaheadQueryVariables,
  data: TaskLookaheadDataOptions | Error,
): MockedResponse<TaskLookaheadQueryVariables, TaskLookaheadQuery> {
  return {
    request: { query: TaskLookaheadDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskLookaheadData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskLookaheadRightPaneDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newTaskLookaheadRightPaneData(data: TaskLookaheadRightPaneDataOptions): TaskLookaheadRightPaneQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newTaskLookaheadRightPaneResponse(
  variables: TaskLookaheadRightPaneQueryVariables,
  data: TaskLookaheadRightPaneDataOptions | Error,
): MockedResponse<TaskLookaheadRightPaneQueryVariables, TaskLookaheadRightPaneQuery> {
  return {
    request: { query: TaskLookaheadRightPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskLookaheadRightPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingVersionHistoryDataOptions {
  readyPlanAggregateVersionsPage?: FactoryInput<
    ReadyPlanAggregateVersionsPageResult,
    ReadyPlanAggregateVersionsPageResultOptions
  >;
}

export function newProductOfferingVersionHistoryData(
  data: ProductOfferingVersionHistoryDataOptions,
): ProductOfferingVersionHistoryQuery {
  return {
    __typename: "Query" as const,
    readyPlanAggregateVersionsPage: maybeNew(
      "ReadyPlanAggregateVersionsPageResult",
      data["readyPlanAggregateVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newProductOfferingVersionHistoryResponse(
  variables: ProductOfferingVersionHistoryQueryVariables,
  data: ProductOfferingVersionHistoryDataOptions | Error,
): MockedResponse<ProductOfferingVersionHistoryQueryVariables, ProductOfferingVersionHistoryQuery> {
  return {
    request: { query: ProductOfferingVersionHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingVersionHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingVersionTlivDetailsDataOptions {
  readyPlanAggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
}

export function newProductOfferingVersionTlivDetailsData(
  data: ProductOfferingVersionTlivDetailsDataOptions,
): ProductOfferingVersionTlivDetailsQuery {
  return {
    __typename: "Query" as const,
    readyPlanAggregateVersion: maybeNew(
      "ReadyPlanAggregateVersion",
      data["readyPlanAggregateVersion"] || undefined,
      {},
    ),
  } as any;
}

export function newProductOfferingVersionTlivDetailsResponse(
  variables: ProductOfferingVersionTlivDetailsQueryVariables,
  data: ProductOfferingVersionTlivDetailsDataOptions | Error,
): MockedResponse<ProductOfferingVersionTlivDetailsQueryVariables, ProductOfferingVersionTlivDetailsQuery> {
  return {
    request: { query: ProductOfferingVersionTlivDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingVersionTlivDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PhaseTaskListPaneDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newPhaseTaskListPaneData(data: PhaseTaskListPaneDataOptions): PhaseTaskListPaneQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newPhaseTaskListPaneResponse(
  variables: PhaseTaskListPaneQueryVariables,
  data: PhaseTaskListPaneDataOptions | Error,
): MockedResponse<PhaseTaskListPaneQueryVariables, PhaseTaskListPaneQuery> {
  return {
    request: { query: PhaseTaskListPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newPhaseTaskListPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface StandaloneTaskDetailPaneDataOptions {
  schedule?: FactoryInput<Schedule, ScheduleOptions>;
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newStandaloneTaskDetailPaneData(
  data: StandaloneTaskDetailPaneDataOptions,
): StandaloneTaskDetailPaneQuery {
  return {
    __typename: "Query" as const,
    schedule: maybeNew("Schedule", data["schedule"] || undefined, {}),
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newStandaloneTaskDetailPaneResponse(
  variables: StandaloneTaskDetailPaneQueryVariables,
  data: StandaloneTaskDetailPaneDataOptions | Error,
): MockedResponse<StandaloneTaskDetailPaneQueryVariables, StandaloneTaskDetailPaneQuery> {
  return {
    request: { query: StandaloneTaskDetailPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newStandaloneTaskDetailPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeReasonCodesDataOptions {
  scopeChangeReasons?: FactoryInput<ScopeChangeReason, ScopeChangeReasonOptions>[];
}

export function newScopeReasonCodesData(data: ScopeReasonCodesDataOptions): ScopeReasonCodesQuery {
  return {
    __typename: "Query" as const,
    scopeChangeReasons: data["scopeChangeReasons"]?.map((d) => maybeNew("ScopeChangeReason", d, {})) || [],
  } as any;
}

export function newScopeReasonCodesResponse(
  data: ScopeReasonCodesDataOptions | Error,
): MockedResponse<ScopeReasonCodesQueryVariables, ScopeReasonCodesQuery> {
  return {
    request: { query: ScopeReasonCodesDocument },
    result: { data: data instanceof Error ? undefined : newScopeReasonCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemTemplatesDataOptions {
  saveItemTemplates?: FactoryInput<SaveItemTemplatesResult, SaveItemTemplatesResultOptions>;
}

export function newSaveItemTemplatesData(data: SaveItemTemplatesDataOptions): SaveItemTemplatesMutation {
  return {
    __typename: "Mutation" as const,
    saveItemTemplates: maybeNew("SaveItemTemplatesResult", data["saveItemTemplates"] || undefined, {}),
  } as any;
}

export function newSaveItemTemplatesResponse(
  variables: SaveItemTemplatesMutationVariables,
  data: SaveItemTemplatesDataOptions | Error,
): MockedResponse<SaveItemTemplatesMutationVariables, SaveItemTemplatesMutation> {
  return {
    request: { query: SaveItemTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScheduleDataOptions {
  development?: FactoryInput<Development, DevelopmentOptions>;
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
  taskStatuses?: FactoryInput<TaskStatusDetail, TaskStatusDetailOptions>[];
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newDevelopmentScheduleData(data: DevelopmentScheduleDataOptions): DevelopmentScheduleQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
    taskStatuses: data["taskStatuses"]?.map((d) => maybeNew("TaskStatusDetail", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newDevelopmentScheduleResponse(
  variables: DevelopmentScheduleQueryVariables,
  data: DevelopmentScheduleDataOptions | Error,
): MockedResponse<DevelopmentScheduleQueryVariables, DevelopmentScheduleQuery> {
  return {
    request: { query: DevelopmentScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ArchiveItemTemplateVersionsDataOptions {
  archiveItemTemplateVersions?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newArchiveItemTemplateVersionsData(
  data: ArchiveItemTemplateVersionsDataOptions,
): ArchiveItemTemplateVersionsMutation {
  return {
    __typename: "Mutation" as const,
    archiveItemTemplateVersions: maybeNew("EmptyResult", data["archiveItemTemplateVersions"] || undefined, {}),
  } as any;
}

export function newArchiveItemTemplateVersionsResponse(
  variables: ArchiveItemTemplateVersionsMutationVariables,
  data: ArchiveItemTemplateVersionsDataOptions | Error,
): MockedResponse<ArchiveItemTemplateVersionsMutationVariables, ArchiveItemTemplateVersionsMutation> {
  return {
    request: { query: ArchiveItemTemplateVersionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newArchiveItemTemplateVersionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddScopeTemplateItemsDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  costTypes?: FactoryInput<CostTypeDetail, CostTypeDetailOptions>[];
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newAddScopeTemplateItemsData(data: AddScopeTemplateItemsDataOptions): AddScopeTemplateItemsQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    costTypes: data["costTypes"]?.map((d) => maybeNew("CostTypeDetail", d, {})) || [],
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newAddScopeTemplateItemsResponse(
  variables: AddScopeTemplateItemsQueryVariables,
  data: AddScopeTemplateItemsDataOptions | Error,
): MockedResponse<AddScopeTemplateItemsQueryVariables, AddScopeTemplateItemsQuery> {
  return {
    request: { query: AddScopeTemplateItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddScopeTemplateItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentHolidayCard_AllProjectsDataOptions {
  projectsPage?: FactoryInput<ProjectsPageResult, ProjectsPageResultOptions>;
}

export function newDevelopmentHolidayCard_AllProjectsData(
  data: DevelopmentHolidayCard_AllProjectsDataOptions,
): DevelopmentHolidayCard_AllProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newDevelopmentHolidayCard_AllProjectsResponse(
  variables: DevelopmentHolidayCard_AllProjectsQueryVariables,
  data: DevelopmentHolidayCard_AllProjectsDataOptions | Error,
): MockedResponse<DevelopmentHolidayCard_AllProjectsQueryVariables, DevelopmentHolidayCard_AllProjectsQuery> {
  return {
    request: { query: DevelopmentHolidayCard_AllProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentHolidayCard_AllProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyLineItemsModalDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newCopyLineItemsModalData(data: CopyLineItemsModalDataOptions): CopyLineItemsModalQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newCopyLineItemsModalResponse(
  variables: CopyLineItemsModalQueryVariables,
  data: CopyLineItemsModalDataOptions | Error,
): MockedResponse<CopyLineItemsModalQueryVariables, CopyLineItemsModalQuery> {
  return {
    request: { query: CopyLineItemsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyLineItemsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyItemTemplateDataOptions {
  cloneItemTemplate?: FactoryInput<CloneItemTemplateResult, CloneItemTemplateResultOptions>;
}

export function newCopyItemTemplateData(data: CopyItemTemplateDataOptions): CopyItemTemplateMutation {
  return {
    __typename: "Mutation" as const,
    cloneItemTemplate: maybeNew("CloneItemTemplateResult", data["cloneItemTemplate"] || undefined, {}),
  } as any;
}

export function newCopyItemTemplateResponse(
  variables: CopyItemTemplateMutationVariables,
  data: CopyItemTemplateDataOptions | Error,
): MockedResponse<CopyItemTemplateMutationVariables, CopyItemTemplateMutation> {
  return {
    request: { query: CopyItemTemplateDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyItemTemplateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemTemplateHeaderDataOptions {
  saveItemTemplate?: FactoryInput<SaveItemTemplateResult, SaveItemTemplateResultOptions>;
}

export function newSaveItemTemplateHeaderData(data: SaveItemTemplateHeaderDataOptions): SaveItemTemplateHeaderMutation {
  return {
    __typename: "Mutation" as const,
    saveItemTemplate: maybeNew("SaveItemTemplateResult", data["saveItemTemplate"] || undefined, {}),
  } as any;
}

export function newSaveItemTemplateHeaderResponse(
  variables: SaveItemTemplateHeaderMutationVariables,
  data: SaveItemTemplateHeaderDataOptions | Error,
): MockedResponse<SaveItemTemplateHeaderMutationVariables, SaveItemTemplateHeaderMutation> {
  return {
    request: { query: SaveItemTemplateHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemTemplateHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScopeTemplateHeader_ReadyPlanDataOptions {
  saveReadyPlan?: FactoryInput<SaveReadyPlanResult, SaveReadyPlanResultOptions>;
}

export function newSaveScopeTemplateHeader_ReadyPlanData(
  data: SaveScopeTemplateHeader_ReadyPlanDataOptions,
): SaveScopeTemplateHeader_ReadyPlanMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlan: maybeNew("SaveReadyPlanResult", data["saveReadyPlan"] || undefined, {}),
  } as any;
}

export function newSaveScopeTemplateHeader_ReadyPlanResponse(
  variables: SaveScopeTemplateHeader_ReadyPlanMutationVariables,
  data: SaveScopeTemplateHeader_ReadyPlanDataOptions | Error,
): MockedResponse<SaveScopeTemplateHeader_ReadyPlanMutationVariables, SaveScopeTemplateHeader_ReadyPlanMutation> {
  return {
    request: { query: SaveScopeTemplateHeader_ReadyPlanDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScopeTemplateHeader_ReadyPlanData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompareModeDesignPackageDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newCompareModeDesignPackageData(
  data: CompareModeDesignPackageDataOptions,
): CompareModeDesignPackageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newCompareModeDesignPackageResponse(
  variables: CompareModeDesignPackageQueryVariables,
  data: CompareModeDesignPackageDataOptions | Error,
): MockedResponse<CompareModeDesignPackageQueryVariables, CompareModeDesignPackageQuery> {
  return {
    request: { query: CompareModeDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompareModeDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompareModeDesignPackageTlisDataOptions {
  designPackageFinishSchedule?: FactoryInput<
    DesignPackageFinishSchedulePageResult,
    DesignPackageFinishSchedulePageResultOptions
  >;
}

export function newCompareModeDesignPackageTlisData(
  data: CompareModeDesignPackageTlisDataOptions,
): CompareModeDesignPackageTlisQuery {
  return {
    __typename: "Query" as const,
    designPackageFinishSchedule: maybeNew(
      "DesignPackageFinishSchedulePageResult",
      data["designPackageFinishSchedule"] || undefined,
      {},
    ),
  } as any;
}

export function newCompareModeDesignPackageTlisResponse(
  variables: CompareModeDesignPackageTlisQueryVariables,
  data: CompareModeDesignPackageTlisDataOptions | Error,
): MockedResponse<CompareModeDesignPackageTlisQueryVariables, CompareModeDesignPackageTlisQuery> {
  return {
    request: { query: CompareModeDesignPackageTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompareModeDesignPackageTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddSlotModal_PotentialPlaceholdersDataOptions {
  takeoffLineItemsPage?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newAddSlotModal_PotentialPlaceholdersData(
  data: AddSlotModal_PotentialPlaceholdersDataOptions,
): AddSlotModal_PotentialPlaceholdersQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newAddSlotModal_PotentialPlaceholdersResponse(
  variables: AddSlotModal_PotentialPlaceholdersQueryVariables,
  data: AddSlotModal_PotentialPlaceholdersDataOptions | Error,
): MockedResponse<AddSlotModal_PotentialPlaceholdersQueryVariables, AddSlotModal_PotentialPlaceholdersQuery> {
  return {
    request: { query: AddSlotModal_PotentialPlaceholdersDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddSlotModal_PotentialPlaceholdersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddSlotModal_SelectedPlaceholdersDataOptions {
  takeoffLineItemsPage?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newAddSlotModal_SelectedPlaceholdersData(
  data: AddSlotModal_SelectedPlaceholdersDataOptions,
): AddSlotModal_SelectedPlaceholdersQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newAddSlotModal_SelectedPlaceholdersResponse(
  variables: AddSlotModal_SelectedPlaceholdersQueryVariables,
  data: AddSlotModal_SelectedPlaceholdersDataOptions | Error,
): MockedResponse<AddSlotModal_SelectedPlaceholdersQueryVariables, AddSlotModal_SelectedPlaceholdersQuery> {
  return {
    request: { query: AddSlotModal_SelectedPlaceholdersDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddSlotModal_SelectedPlaceholdersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlaceholderProductSearch_RequirementsTliDataOptions {
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
}

export function newPlaceholderProductSearch_RequirementsTliData(
  data: PlaceholderProductSearch_RequirementsTliDataOptions,
): PlaceholderProductSearch_RequirementsTliQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newPlaceholderProductSearch_RequirementsTliResponse(
  variables: PlaceholderProductSearch_RequirementsTliQueryVariables,
  data: PlaceholderProductSearch_RequirementsTliDataOptions | Error,
): MockedResponse<
  PlaceholderProductSearch_RequirementsTliQueryVariables,
  PlaceholderProductSearch_RequirementsTliQuery
> {
  return {
    request: { query: PlaceholderProductSearch_RequirementsTliDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlaceholderProductSearch_RequirementsTliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlaceholderProductSearch_PossibleMaterialsDataOptions {
  materialVariantsForPlaceholderTli?: FactoryInput<MaterialVariant, MaterialVariantOptions>[];
}

export function newPlaceholderProductSearch_PossibleMaterialsData(
  data: PlaceholderProductSearch_PossibleMaterialsDataOptions,
): PlaceholderProductSearch_PossibleMaterialsQuery {
  return {
    __typename: "Query" as const,
    materialVariantsForPlaceholderTli:
      data["materialVariantsForPlaceholderTli"]?.map((d) => maybeNew("MaterialVariant", d, {})) || [],
  } as any;
}

export function newPlaceholderProductSearch_PossibleMaterialsResponse(
  variables: PlaceholderProductSearch_PossibleMaterialsQueryVariables,
  data: PlaceholderProductSearch_PossibleMaterialsDataOptions | Error,
): MockedResponse<
  PlaceholderProductSearch_PossibleMaterialsQueryVariables,
  PlaceholderProductSearch_PossibleMaterialsQuery
> {
  return {
    request: { query: PlaceholderProductSearch_PossibleMaterialsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlaceholderProductSearch_PossibleMaterialsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageConfiguratorDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newDesignPackageConfiguratorData(
  data: DesignPackageConfiguratorDataOptions,
): DesignPackageConfiguratorQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageConfiguratorResponse(
  variables: DesignPackageConfiguratorQueryVariables,
  data: DesignPackageConfiguratorDataOptions | Error,
): MockedResponse<DesignPackageConfiguratorQueryVariables, DesignPackageConfiguratorQuery> {
  return {
    request: { query: DesignPackageConfiguratorDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageConfiguratorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDesignPackageCycleDataOptions {
  saveDesignPackage?: FactoryInput<SaveDesignPackageResult, SaveDesignPackageResultOptions>;
}

export function newSaveDesignPackageCycleData(data: SaveDesignPackageCycleDataOptions): SaveDesignPackageCycleMutation {
  return {
    __typename: "Mutation" as const,
    saveDesignPackage: maybeNew("SaveDesignPackageResult", data["saveDesignPackage"] || undefined, {}),
  } as any;
}

export function newSaveDesignPackageCycleResponse(
  variables: SaveDesignPackageCycleMutationVariables,
  data: SaveDesignPackageCycleDataOptions | Error,
): MockedResponse<SaveDesignPackageCycleMutationVariables, SaveDesignPackageCycleMutation> {
  return {
    request: { query: SaveDesignPackageCycleDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDesignPackageCycleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageProductCardPage_MaterialVariantDataOptions {
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
}

export function newDesignPackageProductCardPage_MaterialVariantData(
  data: DesignPackageProductCardPage_MaterialVariantDataOptions,
): DesignPackageProductCardPage_MaterialVariantQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newDesignPackageProductCardPage_MaterialVariantResponse(
  variables: DesignPackageProductCardPage_MaterialVariantQueryVariables,
  data: DesignPackageProductCardPage_MaterialVariantDataOptions | Error,
): MockedResponse<
  DesignPackageProductCardPage_MaterialVariantQueryVariables,
  DesignPackageProductCardPage_MaterialVariantQuery
> {
  return {
    request: { query: DesignPackageProductCardPage_MaterialVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageProductCardPage_MaterialVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageProductCardPage_ProductTliDataOptions {
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
}

export function newDesignPackageProductCardPage_ProductTliData(
  data: DesignPackageProductCardPage_ProductTliDataOptions,
): DesignPackageProductCardPage_ProductTliQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newDesignPackageProductCardPage_ProductTliResponse(
  variables: DesignPackageProductCardPage_ProductTliQueryVariables,
  data: DesignPackageProductCardPage_ProductTliDataOptions | Error,
): MockedResponse<DesignPackageProductCardPage_ProductTliQueryVariables, DesignPackageProductCardPage_ProductTliQuery> {
  return {
    request: { query: DesignPackageProductCardPage_ProductTliDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageProductCardPage_ProductTliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageProductCardPage_OptionCombinationsDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  placeholderCombinations?: FactoryInput<PlaceholderCombinationsResult, PlaceholderCombinationsResultOptions>[];
}

export function newDesignPackageProductCardPage_OptionCombinationsData(
  data: DesignPackageProductCardPage_OptionCombinationsDataOptions,
): DesignPackageProductCardPage_OptionCombinationsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
    placeholderCombinations:
      data["placeholderCombinations"]?.map((d) => maybeNew("PlaceholderCombinationsResult", d, {})) || [],
  } as any;
}

export function newDesignPackageProductCardPage_OptionCombinationsResponse(
  variables: DesignPackageProductCardPage_OptionCombinationsQueryVariables,
  data: DesignPackageProductCardPage_OptionCombinationsDataOptions | Error,
): MockedResponse<
  DesignPackageProductCardPage_OptionCombinationsQueryVariables,
  DesignPackageProductCardPage_OptionCombinationsQuery
> {
  return {
    request: { query: DesignPackageProductCardPage_OptionCombinationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageProductCardPage_OptionCombinationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageProductCardPage_SaveTakeoffLineItemDataOptions {
  saveTakeoffLineItems?: FactoryInput<SaveTakeoffLineItemResult, SaveTakeoffLineItemResultOptions>;
}

export function newDesignPackageProductCardPage_SaveTakeoffLineItemData(
  data: DesignPackageProductCardPage_SaveTakeoffLineItemDataOptions,
): DesignPackageProductCardPage_SaveTakeoffLineItemMutation {
  return {
    __typename: "Mutation" as const,
    saveTakeoffLineItems: maybeNew("SaveTakeoffLineItemResult", data["saveTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newDesignPackageProductCardPage_SaveTakeoffLineItemResponse(
  variables: DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables,
  data: DesignPackageProductCardPage_SaveTakeoffLineItemDataOptions | Error,
): MockedResponse<
  DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables,
  DesignPackageProductCardPage_SaveTakeoffLineItemMutation
> {
  return {
    request: { query: DesignPackageProductCardPage_SaveTakeoffLineItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageProductCardPage_SaveTakeoffLineItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleDesignPackageDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newFinishScheduleDesignPackageData(
  data: FinishScheduleDesignPackageDataOptions,
): FinishScheduleDesignPackageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newFinishScheduleDesignPackageResponse(
  variables: FinishScheduleDesignPackageQueryVariables,
  data: FinishScheduleDesignPackageDataOptions | Error,
): MockedResponse<FinishScheduleDesignPackageQueryVariables, FinishScheduleDesignPackageQuery> {
  return {
    request: { query: FinishScheduleDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleDesignPackageTlisDataOptions {
  designPackageFinishSchedule?: FactoryInput<
    DesignPackageFinishSchedulePageResult,
    DesignPackageFinishSchedulePageResultOptions
  >;
}

export function newFinishScheduleDesignPackageTlisData(
  data: FinishScheduleDesignPackageTlisDataOptions,
): FinishScheduleDesignPackageTlisQuery {
  return {
    __typename: "Query" as const,
    designPackageFinishSchedule: maybeNew(
      "DesignPackageFinishSchedulePageResult",
      data["designPackageFinishSchedule"] || undefined,
      {},
    ),
  } as any;
}

export function newFinishScheduleDesignPackageTlisResponse(
  variables: FinishScheduleDesignPackageTlisQueryVariables,
  data: FinishScheduleDesignPackageTlisDataOptions | Error,
): MockedResponse<FinishScheduleDesignPackageTlisQueryVariables, FinishScheduleDesignPackageTlisQuery> {
  return {
    request: { query: FinishScheduleDesignPackageTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleDesignPackageTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleDesignPackageMetadataDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newFinishScheduleDesignPackageMetadataData(
  data: FinishScheduleDesignPackageMetadataDataOptions,
): FinishScheduleDesignPackageMetadataQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newFinishScheduleDesignPackageMetadataResponse(
  variables: FinishScheduleDesignPackageMetadataQueryVariables,
  data: FinishScheduleDesignPackageMetadataDataOptions | Error,
): MockedResponse<FinishScheduleDesignPackageMetadataQueryVariables, FinishScheduleDesignPackageMetadataQuery> {
  return {
    request: { query: FinishScheduleDesignPackageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleDesignPackageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackagePersonalizationGroupsPageDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newDesignPackagePersonalizationGroupsPageData(
  data: DesignPackagePersonalizationGroupsPageDataOptions,
): DesignPackagePersonalizationGroupsPageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newDesignPackagePersonalizationGroupsPageResponse(
  variables: DesignPackagePersonalizationGroupsPageQueryVariables,
  data: DesignPackagePersonalizationGroupsPageDataOptions | Error,
): MockedResponse<DesignPackagePersonalizationGroupsPageQueryVariables, DesignPackagePersonalizationGroupsPageQuery> {
  return {
    request: { query: DesignPackagePersonalizationGroupsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackagePersonalizationGroupsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeactivatePersonalizationGroupDataOptions {
  savePersonalizationOptionGroup?: FactoryInput<
    SavePersonalizationOptionGroupResult,
    SavePersonalizationOptionGroupResultOptions
  >;
}

export function newDeactivatePersonalizationGroupData(
  data: DeactivatePersonalizationGroupDataOptions,
): DeactivatePersonalizationGroupMutation {
  return {
    __typename: "Mutation" as const,
    savePersonalizationOptionGroup: maybeNew(
      "SavePersonalizationOptionGroupResult",
      data["savePersonalizationOptionGroup"] || undefined,
      {},
    ),
  } as any;
}

export function newDeactivatePersonalizationGroupResponse(
  variables: DeactivatePersonalizationGroupMutationVariables,
  data: DeactivatePersonalizationGroupDataOptions | Error,
): MockedResponse<DeactivatePersonalizationGroupMutationVariables, DeactivatePersonalizationGroupMutation> {
  return {
    request: { query: DeactivatePersonalizationGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeactivatePersonalizationGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MakeNewDesignPackageDataOptions {
  saveDesignPackage?: FactoryInput<SaveDesignPackageResult, SaveDesignPackageResultOptions>;
}

export function newMakeNewDesignPackageData(data: MakeNewDesignPackageDataOptions): MakeNewDesignPackageMutation {
  return {
    __typename: "Mutation" as const,
    saveDesignPackage: maybeNew("SaveDesignPackageResult", data["saveDesignPackage"] || undefined, {}),
  } as any;
}

export function newMakeNewDesignPackageResponse(
  variables: MakeNewDesignPackageMutationVariables,
  data: MakeNewDesignPackageDataOptions | Error,
): MockedResponse<MakeNewDesignPackageMutationVariables, MakeNewDesignPackageMutation> {
  return {
    request: { query: MakeNewDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newMakeNewDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface NewDesignPackagePlanPackagesDataOptions {
  planPackages?: FactoryInput<PlanPackagesPageResult, PlanPackagesPageResultOptions>;
}

export function newNewDesignPackagePlanPackagesData(
  data: NewDesignPackagePlanPackagesDataOptions,
): NewDesignPackagePlanPackagesQuery {
  return {
    __typename: "Query" as const,
    planPackages: maybeNew("PlanPackagesPageResult", data["planPackages"] || undefined, {}),
  } as any;
}

export function newNewDesignPackagePlanPackagesResponse(
  variables: NewDesignPackagePlanPackagesQueryVariables,
  data: NewDesignPackagePlanPackagesDataOptions | Error,
): MockedResponse<NewDesignPackagePlanPackagesQueryVariables, NewDesignPackagePlanPackagesQuery> {
  return {
    request: { query: NewDesignPackagePlanPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newNewDesignPackagePlanPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface NewDesignPackage_GlobalOptionGroupsDataOptions {
  scopedGroups?: FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions>[];
  sharedGroups?: FactoryInput<GlobalOptionGroup, GlobalOptionGroupOptions>[];
  types?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
}

export function newNewDesignPackage_GlobalOptionGroupsData(
  data: NewDesignPackage_GlobalOptionGroupsDataOptions,
): NewDesignPackage_GlobalOptionGroupsQuery {
  return {
    __typename: "Query" as const,
    scopedGroups: data["scopedGroups"]?.map((d) => maybeNew("GlobalOptionGroup", d, {})) || [],
    sharedGroups: data["sharedGroups"]?.map((d) => maybeNew("GlobalOptionGroup", d, {})) || [],
    types: data["types"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
  } as any;
}

export function newNewDesignPackage_GlobalOptionGroupsResponse(
  variables: NewDesignPackage_GlobalOptionGroupsQueryVariables,
  data: NewDesignPackage_GlobalOptionGroupsDataOptions | Error,
): MockedResponse<NewDesignPackage_GlobalOptionGroupsQueryVariables, NewDesignPackage_GlobalOptionGroupsQuery> {
  return {
    request: { query: NewDesignPackage_GlobalOptionGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newNewDesignPackage_GlobalOptionGroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditDesignPackageDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newEditDesignPackageData(data: EditDesignPackageDataOptions): EditDesignPackageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newEditDesignPackageResponse(
  variables: EditDesignPackageQueryVariables,
  data: EditDesignPackageDataOptions | Error,
): MockedResponse<EditDesignPackageQueryVariables, EditDesignPackageQuery> {
  return {
    request: { query: EditDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PreselectOptionsFromPlanPackagesDataOptions {
  planPackages?: FactoryInput<PlanPackagesPageResult, PlanPackagesPageResultOptions>;
}

export function newPreselectOptionsFromPlanPackagesData(
  data: PreselectOptionsFromPlanPackagesDataOptions,
): PreselectOptionsFromPlanPackagesQuery {
  return {
    __typename: "Query" as const,
    planPackages: maybeNew("PlanPackagesPageResult", data["planPackages"] || undefined, {}),
  } as any;
}

export function newPreselectOptionsFromPlanPackagesResponse(
  variables: PreselectOptionsFromPlanPackagesQueryVariables,
  data: PreselectOptionsFromPlanPackagesDataOptions | Error,
): MockedResponse<PreselectOptionsFromPlanPackagesQueryVariables, PreselectOptionsFromPlanPackagesQuery> {
  return {
    request: { query: PreselectOptionsFromPlanPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPreselectOptionsFromPlanPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditPersonalizationOptionWizardDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
}

export function newEditPersonalizationOptionWizardData(
  data: EditPersonalizationOptionWizardDataOptions,
): EditPersonalizationOptionWizardQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
    readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}),
  } as any;
}

export function newEditPersonalizationOptionWizardResponse(
  variables: EditPersonalizationOptionWizardQueryVariables,
  data: EditPersonalizationOptionWizardDataOptions | Error,
): MockedResponse<EditPersonalizationOptionWizardQueryVariables, EditPersonalizationOptionWizardQuery> {
  return {
    request: { query: EditPersonalizationOptionWizardDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditPersonalizationOptionWizardData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditPersonalizationOptionWizard_MaterialVariantDataOptions {
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
}

export function newEditPersonalizationOptionWizard_MaterialVariantData(
  data: EditPersonalizationOptionWizard_MaterialVariantDataOptions,
): EditPersonalizationOptionWizard_MaterialVariantQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
  } as any;
}

export function newEditPersonalizationOptionWizard_MaterialVariantResponse(
  variables: EditPersonalizationOptionWizard_MaterialVariantQueryVariables,
  data: EditPersonalizationOptionWizard_MaterialVariantDataOptions | Error,
): MockedResponse<
  EditPersonalizationOptionWizard_MaterialVariantQueryVariables,
  EditPersonalizationOptionWizard_MaterialVariantQuery
> {
  return {
    request: { query: EditPersonalizationOptionWizard_MaterialVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditPersonalizationOptionWizard_MaterialVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditPersonalizationOptionWizard_CombinationsDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newEditPersonalizationOptionWizard_CombinationsData(
  data: EditPersonalizationOptionWizard_CombinationsDataOptions,
): EditPersonalizationOptionWizard_CombinationsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newEditPersonalizationOptionWizard_CombinationsResponse(
  variables: EditPersonalizationOptionWizard_CombinationsQueryVariables,
  data: EditPersonalizationOptionWizard_CombinationsDataOptions | Error,
): MockedResponse<
  EditPersonalizationOptionWizard_CombinationsQueryVariables,
  EditPersonalizationOptionWizard_CombinationsQuery
> {
  return {
    request: { query: EditPersonalizationOptionWizard_CombinationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditPersonalizationOptionWizard_CombinationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePersonalizationRpogWizardDataOptions {
  savePersonalizationOptionGroup?: FactoryInput<
    SavePersonalizationOptionGroupResult,
    SavePersonalizationOptionGroupResultOptions
  >;
}

export function newSavePersonalizationRpogWizardData(
  data: SavePersonalizationRpogWizardDataOptions,
): SavePersonalizationRpogWizardMutation {
  return {
    __typename: "Mutation" as const,
    savePersonalizationOptionGroup: maybeNew(
      "SavePersonalizationOptionGroupResult",
      data["savePersonalizationOptionGroup"] || undefined,
      {},
    ),
  } as any;
}

export function newSavePersonalizationRpogWizardResponse(
  variables: SavePersonalizationRpogWizardMutationVariables,
  data: SavePersonalizationRpogWizardDataOptions | Error,
): MockedResponse<SavePersonalizationRpogWizardMutationVariables, SavePersonalizationRpogWizardMutation> {
  return {
    request: { query: SavePersonalizationRpogWizardDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePersonalizationRpogWizardData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageVersionHistoryDataOptions {
  readyPlanAggregateVersionsPage?: FactoryInput<
    ReadyPlanAggregateVersionsPageResult,
    ReadyPlanAggregateVersionsPageResultOptions
  >;
}

export function newDesignPackageVersionHistoryData(
  data: DesignPackageVersionHistoryDataOptions,
): DesignPackageVersionHistoryQuery {
  return {
    __typename: "Query" as const,
    readyPlanAggregateVersionsPage: maybeNew(
      "ReadyPlanAggregateVersionsPageResult",
      data["readyPlanAggregateVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newDesignPackageVersionHistoryResponse(
  variables: DesignPackageVersionHistoryQueryVariables,
  data: DesignPackageVersionHistoryDataOptions | Error,
): MockedResponse<DesignPackageVersionHistoryQueryVariables, DesignPackageVersionHistoryQuery> {
  return {
    request: { query: DesignPackageVersionHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageVersionHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMaterialListingDataOptions {
  saveMaterialListing?: FactoryInput<MaterialListing, MaterialListingOptions>;
}

export function newSaveMaterialListingData(data: SaveMaterialListingDataOptions): SaveMaterialListingMutation {
  return {
    __typename: "Mutation" as const,
    saveMaterialListing: maybeNew("MaterialListing", data["saveMaterialListing"] || undefined, {}),
  } as any;
}

export function newSaveMaterialListingResponse(
  variables: SaveMaterialListingMutationVariables,
  data: SaveMaterialListingDataOptions | Error,
): MockedResponse<SaveMaterialListingMutationVariables, SaveMaterialListingMutation> {
  return {
    request: { query: SaveMaterialListingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMaterialListingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteMaterialVariantDataOptions {
  deleteMaterialVariant?: FactoryInput<DeleteMaterialVariantResult, DeleteMaterialVariantResultOptions>;
}

export function newDeleteMaterialVariantData(data: DeleteMaterialVariantDataOptions): DeleteMaterialVariantMutation {
  return {
    __typename: "Mutation" as const,
    deleteMaterialVariant: maybeNew("DeleteMaterialVariantResult", data["deleteMaterialVariant"] || undefined, {}),
  } as any;
}

export function newDeleteMaterialVariantResponse(
  variables: DeleteMaterialVariantMutationVariables,
  data: DeleteMaterialVariantDataOptions | Error,
): MockedResponse<DeleteMaterialVariantMutationVariables, DeleteMaterialVariantMutation> {
  return {
    request: { query: DeleteMaterialVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteMaterialVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemAttributesDataOptions {
  costTypes?: FactoryInput<CostTypeDetail, CostTypeDetailOptions>[];
}

export function newBidItemAttributesData(data: BidItemAttributesDataOptions): BidItemAttributesQuery {
  return {
    __typename: "Query" as const,
    costTypes: data["costTypes"]?.map((d) => maybeNew("CostTypeDetail", d, {})) || [],
  } as any;
}

export function newBidItemAttributesResponse(
  data: BidItemAttributesDataOptions | Error,
): MockedResponse<BidItemAttributesQueryVariables, BidItemAttributesQuery> {
  return {
    request: { query: BidItemAttributesDocument },
    result: { data: data instanceof Error ? undefined : newBidItemAttributesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemSuperDrawerDetailsDataOptions {
  bidItems?: FactoryInput<BidItem, BidItemOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
  costTypes?: FactoryInput<CostTypeDetail, CostTypeDetailOptions>[];
}

export function newBidItemSuperDrawerDetailsData(
  data: BidItemSuperDrawerDetailsDataOptions,
): BidItemSuperDrawerDetailsQuery {
  return {
    __typename: "Query" as const,
    bidItems: data["bidItems"]?.map((d) => maybeNew("BidItem", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
    costTypes: data["costTypes"]?.map((d) => maybeNew("CostTypeDetail", d, {})) || [],
  } as any;
}

export function newBidItemSuperDrawerDetailsResponse(
  variables: BidItemSuperDrawerDetailsQueryVariables,
  data: BidItemSuperDrawerDetailsDataOptions | Error,
): MockedResponse<BidItemSuperDrawerDetailsQueryVariables, BidItemSuperDrawerDetailsQuery> {
  return {
    request: { query: BidItemSuperDrawerDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidItemSuperDrawerDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialListingIdForVariantDataOptions {
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
}

export function newMaterialListingIdForVariantData(
  data: MaterialListingIdForVariantDataOptions,
): MaterialListingIdForVariantQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
  } as any;
}

export function newMaterialListingIdForVariantResponse(
  variables: MaterialListingIdForVariantQueryVariables,
  data: MaterialListingIdForVariantDataOptions | Error,
): MockedResponse<MaterialListingIdForVariantQueryVariables, MaterialListingIdForVariantQuery> {
  return {
    request: { query: MaterialListingIdForVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialListingIdForVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialListingPageDataOptions {
  materialListings?: FactoryInput<MaterialListingsPage, MaterialListingsPageOptions>;
}

export function newMaterialListingPageData(data: MaterialListingPageDataOptions): MaterialListingPageQuery {
  return {
    __typename: "Query" as const,
    materialListings: maybeNew("MaterialListingsPage", data["materialListings"] || undefined, {}),
  } as any;
}

export function newMaterialListingPageResponse(
  variables: MaterialListingPageQueryVariables,
  data: MaterialListingPageDataOptions | Error,
): MockedResponse<MaterialListingPageQueryVariables, MaterialListingPageQuery> {
  return {
    request: { query: MaterialListingPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialListingPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateMaterialImportAiProposalDataOptions {
  createMaterialImportAiProposal?: FactoryInput<MaterialImportAiProposal, MaterialImportAiProposalOptions>;
}

export function newCreateMaterialImportAiProposalData(
  data: CreateMaterialImportAiProposalDataOptions,
): CreateMaterialImportAiProposalMutation {
  return {
    __typename: "Mutation" as const,
    createMaterialImportAiProposal: maybeNew(
      "MaterialImportAiProposal",
      data["createMaterialImportAiProposal"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateMaterialImportAiProposalResponse(
  variables: CreateMaterialImportAiProposalMutationVariables,
  data: CreateMaterialImportAiProposalDataOptions | Error,
): MockedResponse<CreateMaterialImportAiProposalMutationVariables, CreateMaterialImportAiProposalMutation> {
  return {
    request: { query: CreateMaterialImportAiProposalDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateMaterialImportAiProposalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialImportAiProposalDataOptions {
  materialImportAiProposal?: FactoryInput<MaterialImportAiProposal, MaterialImportAiProposalOptions>;
}

export function newMaterialImportAiProposalData(
  data: MaterialImportAiProposalDataOptions,
): MaterialImportAiProposalQuery {
  return {
    __typename: "Query" as const,
    materialImportAiProposal: maybeNew("MaterialImportAiProposal", data["materialImportAiProposal"] || undefined, {}),
  } as any;
}

export function newMaterialImportAiProposalResponse(
  variables: MaterialImportAiProposalQueryVariables,
  data: MaterialImportAiProposalDataOptions | Error,
): MockedResponse<MaterialImportAiProposalQueryVariables, MaterialImportAiProposalQuery> {
  return {
    request: { query: MaterialImportAiProposalDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialImportAiProposalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MergeMaterialVariants_SearchDataOptions {
  materialVariants?: FactoryInput<MaterialVariantsPage, MaterialVariantsPageOptions>;
}

export function newMergeMaterialVariants_SearchData(
  data: MergeMaterialVariants_SearchDataOptions,
): MergeMaterialVariants_SearchQuery {
  return {
    __typename: "Query" as const,
    materialVariants: maybeNew("MaterialVariantsPage", data["materialVariants"] || undefined, {}),
  } as any;
}

export function newMergeMaterialVariants_SearchResponse(
  variables: MergeMaterialVariants_SearchQueryVariables,
  data: MergeMaterialVariants_SearchDataOptions | Error,
): MockedResponse<MergeMaterialVariants_SearchQueryVariables, MergeMaterialVariants_SearchQuery> {
  return {
    request: { query: MergeMaterialVariants_SearchDocument, variables },
    result: { data: data instanceof Error ? undefined : newMergeMaterialVariants_SearchData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MergeMaterialVariants_SelectionDataOptions {
  materialVariants?: FactoryInput<MaterialVariantsPage, MaterialVariantsPageOptions>;
}

export function newMergeMaterialVariants_SelectionData(
  data: MergeMaterialVariants_SelectionDataOptions,
): MergeMaterialVariants_SelectionQuery {
  return {
    __typename: "Query" as const,
    materialVariants: maybeNew("MaterialVariantsPage", data["materialVariants"] || undefined, {}),
  } as any;
}

export function newMergeMaterialVariants_SelectionResponse(
  variables: MergeMaterialVariants_SelectionQueryVariables,
  data: MergeMaterialVariants_SelectionDataOptions | Error,
): MockedResponse<MergeMaterialVariants_SelectionQueryVariables, MergeMaterialVariants_SelectionQuery> {
  return {
    request: { query: MergeMaterialVariants_SelectionDocument, variables },
    result: { data: data instanceof Error ? undefined : newMergeMaterialVariants_SelectionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MergeMaterialVariants_MetadataDataOptions {
  materialBrands?: FactoryInput<MaterialBrand, MaterialBrandOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
  materialVariantTags?: FactoryInput<MaterialVariantTag, MaterialVariantTagOptions>[];
}

export function newMergeMaterialVariants_MetadataData(
  data: MergeMaterialVariants_MetadataDataOptions,
): MergeMaterialVariants_MetadataQuery {
  return {
    __typename: "Query" as const,
    materialBrands: data["materialBrands"]?.map((d) => maybeNew("MaterialBrand", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    materialVariantTags: data["materialVariantTags"]?.map((d) => maybeNew("MaterialVariantTag", d, {})) || [],
  } as any;
}

export function newMergeMaterialVariants_MetadataResponse(
  data: MergeMaterialVariants_MetadataDataOptions | Error,
): MockedResponse<MergeMaterialVariants_MetadataQueryVariables, MergeMaterialVariants_MetadataQuery> {
  return {
    request: { query: MergeMaterialVariants_MetadataDocument },
    result: { data: data instanceof Error ? undefined : newMergeMaterialVariants_MetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MergeMaterialVariantsDataOptions {
  mergeMaterialVariants?: FactoryInput<MergeMaterialVariantsResult, MergeMaterialVariantsResultOptions>;
}

export function newMergeMaterialVariantsData(data: MergeMaterialVariantsDataOptions): MergeMaterialVariantsMutation {
  return {
    __typename: "Mutation" as const,
    mergeMaterialVariants: maybeNew("MergeMaterialVariantsResult", data["mergeMaterialVariants"] || undefined, {}),
  } as any;
}

export function newMergeMaterialVariantsResponse(
  variables: MergeMaterialVariantsMutationVariables,
  data: MergeMaterialVariantsDataOptions | Error,
): MockedResponse<MergeMaterialVariantsMutationVariables, MergeMaterialVariantsMutation> {
  return {
    request: { query: MergeMaterialVariantsDocument, variables },
    result: { data: data instanceof Error ? undefined : newMergeMaterialVariantsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MergeMaterialVariants_PreviewDisplayNameDataOptions {
  previewMaterialVariantDisplayName?: FactoryInput<String, StringOptions>;
}

export function newMergeMaterialVariants_PreviewDisplayNameData(
  data: MergeMaterialVariants_PreviewDisplayNameDataOptions,
): MergeMaterialVariants_PreviewDisplayNameQuery {
  return {
    __typename: "Query" as const,
    previewMaterialVariantDisplayName: maybeNew("String", data["previewMaterialVariantDisplayName"] || undefined, {}),
  } as any;
}

export function newMergeMaterialVariants_PreviewDisplayNameResponse(
  variables: MergeMaterialVariants_PreviewDisplayNameQueryVariables,
  data: MergeMaterialVariants_PreviewDisplayNameDataOptions | Error,
): MockedResponse<
  MergeMaterialVariants_PreviewDisplayNameQueryVariables,
  MergeMaterialVariants_PreviewDisplayNameQuery
> {
  return {
    request: { query: MergeMaterialVariants_PreviewDisplayNameDocument, variables },
    result: { data: data instanceof Error ? undefined : newMergeMaterialVariants_PreviewDisplayNameData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InstallTasksPageDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
}

export function newInstallTasksPageData(data: InstallTasksPageDataOptions): InstallTasksPageQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newInstallTasksPageResponse(
  data: InstallTasksPageDataOptions | Error,
): MockedResponse<InstallTasksPageQueryVariables, InstallTasksPageQuery> {
  return {
    request: { query: InstallTasksPageDocument },
    result: { data: data instanceof Error ? undefined : newInstallTasksPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemPlanTaskMappingsDataOptions {
  itemPlanTaskMappingPage?: FactoryInput<ItemPlanTaskMappingPage, ItemPlanTaskMappingPageOptions>;
}

export function newItemPlanTaskMappingsData(data: ItemPlanTaskMappingsDataOptions): ItemPlanTaskMappingsQuery {
  return {
    __typename: "Query" as const,
    itemPlanTaskMappingPage: maybeNew("ItemPlanTaskMappingPage", data["itemPlanTaskMappingPage"] || undefined, {}),
  } as any;
}

export function newItemPlanTaskMappingsResponse(
  variables: ItemPlanTaskMappingsQueryVariables,
  data: ItemPlanTaskMappingsDataOptions | Error,
): MockedResponse<ItemPlanTaskMappingsQueryVariables, ItemPlanTaskMappingsQuery> {
  return {
    request: { query: ItemPlanTaskMappingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemPlanTaskMappingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemPlanTaskMappingDataOptions {
  saveItemPlanTaskMapping?: FactoryInput<SaveItemPlanTaskMappingResult, SaveItemPlanTaskMappingResultOptions>;
}

export function newSaveItemPlanTaskMappingData(
  data: SaveItemPlanTaskMappingDataOptions,
): SaveItemPlanTaskMappingMutation {
  return {
    __typename: "Mutation" as const,
    saveItemPlanTaskMapping: maybeNew(
      "SaveItemPlanTaskMappingResult",
      data["saveItemPlanTaskMapping"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveItemPlanTaskMappingResponse(
  variables: SaveItemPlanTaskMappingMutationVariables,
  data: SaveItemPlanTaskMappingDataOptions | Error,
): MockedResponse<SaveItemPlanTaskMappingMutationVariables, SaveItemPlanTaskMappingMutation> {
  return {
    request: { query: SaveItemPlanTaskMappingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemPlanTaskMappingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteItemPlanTaskMappingDataOptions {
  deleteItemPlanTaskMapping?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteItemPlanTaskMappingData(
  data: DeleteItemPlanTaskMappingDataOptions,
): DeleteItemPlanTaskMappingMutation {
  return {
    __typename: "Mutation" as const,
    deleteItemPlanTaskMapping: maybeNew("EmptyResult", data["deleteItemPlanTaskMapping"] || undefined, {}),
  } as any;
}

export function newDeleteItemPlanTaskMappingResponse(
  variables: DeleteItemPlanTaskMappingMutationVariables,
  data: DeleteItemPlanTaskMappingDataOptions | Error,
): MockedResponse<DeleteItemPlanTaskMappingMutationVariables, DeleteItemPlanTaskMappingMutation> {
  return {
    request: { query: DeleteItemPlanTaskMappingDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteItemPlanTaskMappingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BusinessFunctionTypeDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newBusinessFunctionTypeData(data: BusinessFunctionTypeDataOptions): BusinessFunctionTypeQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newBusinessFunctionTypeResponse(
  data: BusinessFunctionTypeDataOptions | Error,
): MockedResponse<BusinessFunctionTypeQueryVariables, BusinessFunctionTypeQuery> {
  return {
    request: { query: BusinessFunctionTypeDocument },
    result: { data: data instanceof Error ? undefined : newBusinessFunctionTypeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanMilestoneGroupDataOptions {
  saveGlobalPlanMilestoneGroup?: FactoryInput<
    SaveGlobalPlanMilestoneGroupResult,
    SaveGlobalPlanMilestoneGroupResultOptions
  >;
}

export function newSaveGlobalPlanMilestoneGroupData(
  data: SaveGlobalPlanMilestoneGroupDataOptions,
): SaveGlobalPlanMilestoneGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanMilestoneGroup: maybeNew(
      "SaveGlobalPlanMilestoneGroupResult",
      data["saveGlobalPlanMilestoneGroup"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveGlobalPlanMilestoneGroupResponse(
  variables: SaveGlobalPlanMilestoneGroupMutationVariables,
  data: SaveGlobalPlanMilestoneGroupDataOptions | Error,
): MockedResponse<SaveGlobalPlanMilestoneGroupMutationVariables, SaveGlobalPlanMilestoneGroupMutation> {
  return {
    request: { query: SaveGlobalPlanMilestoneGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanMilestoneGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackagePageMetadataDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
  locations?: FactoryInput<Location, LocationOptions>[];
  globalOptionTags?: FactoryInput<GlobalOptionTag, GlobalOptionTagOptions>[];
  readyPlanStatuses?: FactoryInput<ReadyPlanStatusDetail, ReadyPlanStatusDetailOptions>[];
  currentUser?: FactoryInput<User, UserOptions> | null;
}

export function newPlanPackagePageMetadataData(data: PlanPackagePageMetadataDataOptions): PlanPackagePageMetadataQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
    locations: data["locations"]?.map((d) => maybeNew("Location", d, {})) || [],
    globalOptionTags: data["globalOptionTags"]?.map((d) => maybeNew("GlobalOptionTag", d, {})) || [],
    readyPlanStatuses: data["readyPlanStatuses"]?.map((d) => maybeNew("ReadyPlanStatusDetail", d, {})) || [],
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newPlanPackagePageMetadataResponse(
  variables: PlanPackagePageMetadataQueryVariables,
  data: PlanPackagePageMetadataDataOptions | Error,
): MockedResponse<PlanPackagePageMetadataQueryVariables, PlanPackagePageMetadataQuery> {
  return {
    request: { query: PlanPackagePageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackagePageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageDataOptions {
  savePlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newSavePlanPackageData(data: SavePlanPackageDataOptions): SavePlanPackageMutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newSavePlanPackageResponse(
  variables: SavePlanPackageMutationVariables,
  data: SavePlanPackageDataOptions | Error,
): MockedResponse<SavePlanPackageMutationVariables, SavePlanPackageMutation> {
  return {
    request: { query: SavePlanPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyPlanPackageDataOptions {
  copyPlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newCopyPlanPackageData(data: CopyPlanPackageDataOptions): CopyPlanPackageMutation {
  return {
    __typename: "Mutation" as const,
    copyPlanPackage: maybeNew("SavePlanPackageResult", data["copyPlanPackage"] || undefined, {}),
  } as any;
}

export function newCopyPlanPackageResponse(
  variables: CopyPlanPackageMutationVariables,
  data: CopyPlanPackageDataOptions | Error,
): MockedResponse<CopyPlanPackageMutationVariables, CopyPlanPackageMutation> {
  return {
    request: { query: CopyPlanPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyPlanPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageDetailsStepDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackageDetailsStepData(data: PlanPackageDetailsStepDataOptions): PlanPackageDetailsStepQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageDetailsStepResponse(
  variables: PlanPackageDetailsStepQueryVariables,
  data: PlanPackageDetailsStepDataOptions | Error,
): MockedResponse<PlanPackageDetailsStepQueryVariables, PlanPackageDetailsStepQuery> {
  return {
    request: { query: PlanPackageDetailsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageDetailsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageDetailsDataOptions {
  savePlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newSavePlanPackageDetailsData(data: SavePlanPackageDetailsDataOptions): SavePlanPackageDetailsMutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newSavePlanPackageDetailsResponse(
  variables: SavePlanPackageDetailsMutationVariables,
  data: SavePlanPackageDetailsDataOptions | Error,
): MockedResponse<SavePlanPackageDetailsMutationVariables, SavePlanPackageDetailsMutation> {
  return {
    request: { query: SavePlanPackageDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageLocationStepDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  levels?: FactoryInput<Location, LocationOptions>[];
}

export function newPlanPackageLocationStepData(data: PlanPackageLocationStepDataOptions): PlanPackageLocationStepQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    levels: data["levels"]?.map((d) => maybeNew("Location", d, {})) || [],
  } as any;
}

export function newPlanPackageLocationStepResponse(
  variables: PlanPackageLocationStepQueryVariables,
  data: PlanPackageLocationStepDataOptions | Error,
): MockedResponse<PlanPackageLocationStepQueryVariables, PlanPackageLocationStepQuery> {
  return {
    request: { query: PlanPackageLocationStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageLocationStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkSaveRplsDataOptions {
  saveReadyPlanLocations?: FactoryInput<SaveReadyPlanLocationBulkResult, SaveReadyPlanLocationBulkResultOptions>;
}

export function newBulkSaveRplsData(data: BulkSaveRplsDataOptions): BulkSaveRplsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanLocations: maybeNew(
      "SaveReadyPlanLocationBulkResult",
      data["saveReadyPlanLocations"] || undefined,
      {},
    ),
  } as any;
}

export function newBulkSaveRplsResponse(
  variables: BulkSaveRplsMutationVariables,
  data: BulkSaveRplsDataOptions | Error,
): MockedResponse<BulkSaveRplsMutationVariables, BulkSaveRplsMutation> {
  return {
    request: { query: BulkSaveRplsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkSaveRplsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RoomTypeDataOptions {
  roomTypes?: FactoryInput<RoomType, RoomTypeOptions>[];
}

export function newRoomTypeData(data: RoomTypeDataOptions): RoomTypeQuery {
  return {
    __typename: "Query" as const,
    roomTypes: data["roomTypes"]?.map((d) => maybeNew("RoomType", d, {})) || [],
  } as any;
}

export function newRoomTypeResponse(
  data: RoomTypeDataOptions | Error,
): MockedResponse<RoomTypeQueryVariables, RoomTypeQuery> {
  return {
    request: { query: RoomTypeDocument },
    result: { data: data instanceof Error ? undefined : newRoomTypeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackagesDataOptions {
  planPackages?: FactoryInput<PlanPackagesPageResult, PlanPackagesPageResultOptions>;
}

export function newPlanPackagesData(data: PlanPackagesDataOptions): PlanPackagesQuery {
  return {
    __typename: "Query" as const,
    planPackages: maybeNew("PlanPackagesPageResult", data["planPackages"] || undefined, {}),
  } as any;
}

export function newPlanPackagesResponse(
  variables: PlanPackagesQueryVariables,
  data: PlanPackagesDataOptions | Error,
): MockedResponse<PlanPackagesQueryVariables, PlanPackagesQuery> {
  return {
    request: { query: PlanPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackage_AddOptionsPageDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackage_AddOptionsPageData(
  data: PlanPackage_AddOptionsPageDataOptions,
): PlanPackage_AddOptionsPageQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackage_AddOptionsPageResponse(
  variables: PlanPackage_AddOptionsPageQueryVariables,
  data: PlanPackage_AddOptionsPageDataOptions | Error,
): MockedResponse<PlanPackage_AddOptionsPageQueryVariables, PlanPackage_AddOptionsPageQuery> {
  return {
    request: { query: PlanPackage_AddOptionsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackage_AddOptionsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackage_SaveReadyPlanOptionsDataOptions {
  savePlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newPlanPackage_SaveReadyPlanOptionsData(
  data: PlanPackage_SaveReadyPlanOptionsDataOptions,
): PlanPackage_SaveReadyPlanOptionsMutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackage_SaveReadyPlanOptionsResponse(
  variables: PlanPackage_SaveReadyPlanOptionsMutationVariables,
  data: PlanPackage_SaveReadyPlanOptionsDataOptions | Error,
): MockedResponse<PlanPackage_SaveReadyPlanOptionsMutationVariables, PlanPackage_SaveReadyPlanOptionsMutation> {
  return {
    request: { query: PlanPackage_SaveReadyPlanOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackage_SaveReadyPlanOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveElevationsDataOptions {
  saveReadyPlanOptions?: FactoryInput<SaveReadyPlanOptionsResult, SaveReadyPlanOptionsResultOptions>;
}

export function newSaveElevationsData(data: SaveElevationsDataOptions): SaveElevationsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptions: maybeNew("SaveReadyPlanOptionsResult", data["saveReadyPlanOptions"] || undefined, {}),
  } as any;
}

export function newSaveElevationsResponse(
  variables: SaveElevationsMutationVariables,
  data: SaveElevationsDataOptions | Error,
): MockedResponse<SaveElevationsMutationVariables, SaveElevationsMutation> {
  return {
    request: { query: SaveElevationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveElevationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionGroupDataOptions {
  saveReadyPlanOptionGroup?: FactoryInput<SaveReadyPlanOptionGroupResult, SaveReadyPlanOptionGroupResultOptions>;
}

export function newSaveReadyPlanOptionGroupData(
  data: SaveReadyPlanOptionGroupDataOptions,
): SaveReadyPlanOptionGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptionGroup: maybeNew(
      "SaveReadyPlanOptionGroupResult",
      data["saveReadyPlanOptionGroup"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanOptionGroupResponse(
  variables: SaveReadyPlanOptionGroupMutationVariables,
  data: SaveReadyPlanOptionGroupDataOptions | Error,
): MockedResponse<SaveReadyPlanOptionGroupMutationVariables, SaveReadyPlanOptionGroupMutation> {
  return {
    request: { query: SaveReadyPlanOptionGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProgramDataStepMetadataDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newProgramDataStepMetadataData(data: ProgramDataStepMetadataDataOptions): ProgramDataStepMetadataQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newProgramDataStepMetadataResponse(
  variables: ProgramDataStepMetadataQueryVariables,
  data: ProgramDataStepMetadataDataOptions | Error,
): MockedResponse<ProgramDataStepMetadataQueryVariables, ProgramDataStepMetadataQuery> {
  return {
    request: { query: ProgramDataStepMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newProgramDataStepMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageTakeoffPageDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackageTakeoffPageData(data: PlanPackageTakeoffPageDataOptions): PlanPackageTakeoffPageQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageTakeoffPageResponse(
  variables: PlanPackageTakeoffPageQueryVariables,
  data: PlanPackageTakeoffPageDataOptions | Error,
): MockedResponse<PlanPackageTakeoffPageQueryVariables, PlanPackageTakeoffPageQuery> {
  return {
    request: { query: PlanPackageTakeoffPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageTakeoffPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageTakeoffsCycleDataOptions {
  savePlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newSavePlanPackageTakeoffsCycleData(
  data: SavePlanPackageTakeoffsCycleDataOptions,
): SavePlanPackageTakeoffsCycleMutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newSavePlanPackageTakeoffsCycleResponse(
  variables: SavePlanPackageTakeoffsCycleMutationVariables,
  data: SavePlanPackageTakeoffsCycleDataOptions | Error,
): MockedResponse<SavePlanPackageTakeoffsCycleMutationVariables, SavePlanPackageTakeoffsCycleMutation> {
  return {
    request: { query: SavePlanPackageTakeoffsCycleDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageTakeoffsCycleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageTakeoffSideBarDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackageTakeoffSideBarData(
  data: PlanPackageTakeoffSideBarDataOptions,
): PlanPackageTakeoffSideBarQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageTakeoffSideBarResponse(
  variables: PlanPackageTakeoffSideBarQueryVariables,
  data: PlanPackageTakeoffSideBarDataOptions | Error,
): MockedResponse<PlanPackageTakeoffSideBarQueryVariables, PlanPackageTakeoffSideBarQuery> {
  return {
    request: { query: PlanPackageTakeoffSideBarDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageTakeoffSideBarData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TakeoffsStore_SaveTakeoffLineItemsDataOptions {
  saveTakeoffLineItems?: FactoryInput<SaveTakeoffLineItemResult, SaveTakeoffLineItemResultOptions>;
}

export function newTakeoffsStore_SaveTakeoffLineItemsData(
  data: TakeoffsStore_SaveTakeoffLineItemsDataOptions,
): TakeoffsStore_SaveTakeoffLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveTakeoffLineItems: maybeNew("SaveTakeoffLineItemResult", data["saveTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newTakeoffsStore_SaveTakeoffLineItemsResponse(
  variables: TakeoffsStore_SaveTakeoffLineItemsMutationVariables,
  data: TakeoffsStore_SaveTakeoffLineItemsDataOptions | Error,
): MockedResponse<TakeoffsStore_SaveTakeoffLineItemsMutationVariables, TakeoffsStore_SaveTakeoffLineItemsMutation> {
  return {
    request: { query: TakeoffsStore_SaveTakeoffLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTakeoffsStore_SaveTakeoffLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TakeoffsStore_CopyTakeoffLineItemsDataOptions {
  copyTakeoffLineItems?: FactoryInput<CopyTakeoffLineItemsResult, CopyTakeoffLineItemsResultOptions>;
}

export function newTakeoffsStore_CopyTakeoffLineItemsData(
  data: TakeoffsStore_CopyTakeoffLineItemsDataOptions,
): TakeoffsStore_CopyTakeoffLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    copyTakeoffLineItems: maybeNew("CopyTakeoffLineItemsResult", data["copyTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newTakeoffsStore_CopyTakeoffLineItemsResponse(
  variables: TakeoffsStore_CopyTakeoffLineItemsMutationVariables,
  data: TakeoffsStore_CopyTakeoffLineItemsDataOptions | Error,
): MockedResponse<TakeoffsStore_CopyTakeoffLineItemsMutationVariables, TakeoffsStore_CopyTakeoffLineItemsMutation> {
  return {
    request: { query: TakeoffsStore_CopyTakeoffLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTakeoffsStore_CopyTakeoffLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageCheckoutV2DataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackageCheckoutV2Data(data: PlanPackageCheckoutV2DataOptions): PlanPackageCheckoutV2Query {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageCheckoutV2Response(
  variables: PlanPackageCheckoutV2QueryVariables,
  data: PlanPackageCheckoutV2DataOptions | Error,
): MockedResponse<PlanPackageCheckoutV2QueryVariables, PlanPackageCheckoutV2Query> {
  return {
    request: { query: PlanPackageCheckoutV2Document, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageCheckoutV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageCheckoutV2DataOptions {
  savePlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newSavePlanPackageCheckoutV2Data(
  data: SavePlanPackageCheckoutV2DataOptions,
): SavePlanPackageCheckoutV2Mutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newSavePlanPackageCheckoutV2Response(
  variables: SavePlanPackageCheckoutV2MutationVariables,
  data: SavePlanPackageCheckoutV2DataOptions | Error,
): MockedResponse<SavePlanPackageCheckoutV2MutationVariables, SavePlanPackageCheckoutV2Mutation> {
  return {
    request: { query: SavePlanPackageCheckoutV2Document, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageCheckoutV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageCheckoutRoomsV2DataOptions {
  saveReadyPlanLocations?: FactoryInput<SaveReadyPlanLocationBulkResult, SaveReadyPlanLocationBulkResultOptions>;
}

export function newSavePlanPackageCheckoutRoomsV2Data(
  data: SavePlanPackageCheckoutRoomsV2DataOptions,
): SavePlanPackageCheckoutRoomsV2Mutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanLocations: maybeNew(
      "SaveReadyPlanLocationBulkResult",
      data["saveReadyPlanLocations"] || undefined,
      {},
    ),
  } as any;
}

export function newSavePlanPackageCheckoutRoomsV2Response(
  variables: SavePlanPackageCheckoutRoomsV2MutationVariables,
  data: SavePlanPackageCheckoutRoomsV2DataOptions | Error,
): MockedResponse<SavePlanPackageCheckoutRoomsV2MutationVariables, SavePlanPackageCheckoutRoomsV2Mutation> {
  return {
    request: { query: SavePlanPackageCheckoutRoomsV2Document, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageCheckoutRoomsV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageLocationsV2DataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  levels?: FactoryInput<Location, LocationOptions>[];
  roomTypes?: FactoryInput<RoomType, RoomTypeOptions>[];
}

export function newPlanPackageLocationsV2Data(data: PlanPackageLocationsV2DataOptions): PlanPackageLocationsV2Query {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    levels: data["levels"]?.map((d) => maybeNew("Location", d, {})) || [],
    roomTypes: data["roomTypes"]?.map((d) => maybeNew("RoomType", d, {})) || [],
  } as any;
}

export function newPlanPackageLocationsV2Response(
  variables: PlanPackageLocationsV2QueryVariables,
  data: PlanPackageLocationsV2DataOptions | Error,
): MockedResponse<PlanPackageLocationsV2QueryVariables, PlanPackageLocationsV2Query> {
  return {
    request: { query: PlanPackageLocationsV2Document, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageLocationsV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageLocationsV2DataOptions {
  saveReadyPlanLocations?: FactoryInput<SaveReadyPlanLocationBulkResult, SaveReadyPlanLocationBulkResultOptions>;
}

export function newSavePlanPackageLocationsV2Data(
  data: SavePlanPackageLocationsV2DataOptions,
): SavePlanPackageLocationsV2Mutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanLocations: maybeNew(
      "SaveReadyPlanLocationBulkResult",
      data["saveReadyPlanLocations"] || undefined,
      {},
    ),
  } as any;
}

export function newSavePlanPackageLocationsV2Response(
  variables: SavePlanPackageLocationsV2MutationVariables,
  data: SavePlanPackageLocationsV2DataOptions | Error,
): MockedResponse<SavePlanPackageLocationsV2MutationVariables, SavePlanPackageLocationsV2Mutation> {
  return {
    request: { query: SavePlanPackageLocationsV2Document, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageLocationsV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageOptionsV2DataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newPlanPackageOptionsV2Data(data: PlanPackageOptionsV2DataOptions): PlanPackageOptionsV2Query {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newPlanPackageOptionsV2Response(
  variables: PlanPackageOptionsV2QueryVariables,
  data: PlanPackageOptionsV2DataOptions | Error,
): MockedResponse<PlanPackageOptionsV2QueryVariables, PlanPackageOptionsV2Query> {
  return {
    request: { query: PlanPackageOptionsV2Document, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageOptionsV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageOptionsV2DataOptions {
  savePlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newSavePlanPackageOptionsV2Data(
  data: SavePlanPackageOptionsV2DataOptions,
): SavePlanPackageOptionsV2Mutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newSavePlanPackageOptionsV2Response(
  variables: SavePlanPackageOptionsV2MutationVariables,
  data: SavePlanPackageOptionsV2DataOptions | Error,
): MockedResponse<SavePlanPackageOptionsV2MutationVariables, SavePlanPackageOptionsV2Mutation> {
  return {
    request: { query: SavePlanPackageOptionsV2Document, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageOptionsV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageElevationsV2DataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackageElevationsV2Data(data: PlanPackageElevationsV2DataOptions): PlanPackageElevationsV2Query {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageElevationsV2Response(
  variables: PlanPackageElevationsV2QueryVariables,
  data: PlanPackageElevationsV2DataOptions | Error,
): MockedResponse<PlanPackageElevationsV2QueryVariables, PlanPackageElevationsV2Query> {
  return {
    request: { query: PlanPackageElevationsV2Document, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageElevationsV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ElevationCatalogV2DataOptions {
  globalOptions?: FactoryInput<GlobalOption, GlobalOptionOptions>[];
}

export function newElevationCatalogV2Data(data: ElevationCatalogV2DataOptions): ElevationCatalogV2Query {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => maybeNew("GlobalOption", d, {})) || [],
  } as any;
}

export function newElevationCatalogV2Response(
  data: ElevationCatalogV2DataOptions | Error,
): MockedResponse<ElevationCatalogV2QueryVariables, ElevationCatalogV2Query> {
  return {
    request: { query: ElevationCatalogV2Document },
    result: { data: data instanceof Error ? undefined : newElevationCatalogV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageElevationDataOptions {
  savePlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newSavePlanPackageElevationData(
  data: SavePlanPackageElevationDataOptions,
): SavePlanPackageElevationMutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newSavePlanPackageElevationResponse(
  variables: SavePlanPackageElevationMutationVariables,
  data: SavePlanPackageElevationDataOptions | Error,
): MockedResponse<SavePlanPackageElevationMutationVariables, SavePlanPackageElevationMutation> {
  return {
    request: { query: SavePlanPackageElevationDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageElevationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageOverviewV2DataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackageOverviewV2Data(data: PlanPackageOverviewV2DataOptions): PlanPackageOverviewV2Query {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageOverviewV2Response(
  variables: PlanPackageOverviewV2QueryVariables,
  data: PlanPackageOverviewV2DataOptions | Error,
): MockedResponse<PlanPackageOverviewV2QueryVariables, PlanPackageOverviewV2Query> {
  return {
    request: { query: PlanPackageOverviewV2Document, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageOverviewV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreatePlanPackageDataOptions {
  savePlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newCreatePlanPackageData(data: CreatePlanPackageDataOptions): CreatePlanPackageMutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newCreatePlanPackageResponse(
  variables: CreatePlanPackageMutationVariables,
  data: CreatePlanPackageDataOptions | Error,
): MockedResponse<CreatePlanPackageMutationVariables, CreatePlanPackageMutation> {
  return {
    request: { query: CreatePlanPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreatePlanPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageProgramDataV2DataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newPlanPackageProgramDataV2Data(
  data: PlanPackageProgramDataV2DataOptions,
): PlanPackageProgramDataV2Query {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newPlanPackageProgramDataV2Response(
  variables: PlanPackageProgramDataV2QueryVariables,
  data: PlanPackageProgramDataV2DataOptions | Error,
): MockedResponse<PlanPackageProgramDataV2QueryVariables, PlanPackageProgramDataV2Query> {
  return {
    request: { query: PlanPackageProgramDataV2Document, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageProgramDataV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageProgramDataV2DataOptions {
  savePlanPackage?: FactoryInput<SavePlanPackageResult, SavePlanPackageResultOptions>;
}

export function newSavePlanPackageProgramDataV2Data(
  data: SavePlanPackageProgramDataV2DataOptions,
): SavePlanPackageProgramDataV2Mutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newSavePlanPackageProgramDataV2Response(
  variables: SavePlanPackageProgramDataV2MutationVariables,
  data: SavePlanPackageProgramDataV2DataOptions | Error,
): MockedResponse<SavePlanPackageProgramDataV2MutationVariables, SavePlanPackageProgramDataV2Mutation> {
  return {
    request: { query: SavePlanPackageProgramDataV2Document, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageProgramDataV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageVersionHistoryDataOptions {
  readyPlanAggregateVersionsPage?: FactoryInput<
    ReadyPlanAggregateVersionsPageResult,
    ReadyPlanAggregateVersionsPageResultOptions
  >;
}

export function newPlanPackageVersionHistoryData(
  data: PlanPackageVersionHistoryDataOptions,
): PlanPackageVersionHistoryQuery {
  return {
    __typename: "Query" as const,
    readyPlanAggregateVersionsPage: maybeNew(
      "ReadyPlanAggregateVersionsPageResult",
      data["readyPlanAggregateVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newPlanPackageVersionHistoryResponse(
  variables: PlanPackageVersionHistoryQueryVariables,
  data: PlanPackageVersionHistoryDataOptions | Error,
): MockedResponse<PlanPackageVersionHistoryQueryVariables, PlanPackageVersionHistoryQuery> {
  return {
    request: { query: PlanPackageVersionHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageVersionHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutPricingTracePage_OverviewDataOptions {
  checkoutPricingTrace?: FactoryInput<CheckoutPricingTrace, CheckoutPricingTraceOptions>;
}

export function newCheckoutPricingTracePage_OverviewData(
  data: CheckoutPricingTracePage_OverviewDataOptions,
): CheckoutPricingTracePage_OverviewQuery {
  return {
    __typename: "Query" as const,
    checkoutPricingTrace: maybeNew("CheckoutPricingTrace", data["checkoutPricingTrace"] || undefined, {}),
  } as any;
}

export function newCheckoutPricingTracePage_OverviewResponse(
  variables: CheckoutPricingTracePage_OverviewQueryVariables,
  data: CheckoutPricingTracePage_OverviewDataOptions | Error,
): MockedResponse<CheckoutPricingTracePage_OverviewQueryVariables, CheckoutPricingTracePage_OverviewQuery> {
  return {
    request: { query: CheckoutPricingTracePage_OverviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutPricingTracePage_OverviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutPricingTraceGroupDetailDataOptions {
  calculateScopeChange?: FactoryInput<CalculateScopeChangeResult, CalculateScopeChangeResultOptions>;
}

export function newCheckoutPricingTraceGroupDetailData(
  data: CheckoutPricingTraceGroupDetailDataOptions,
): CheckoutPricingTraceGroupDetailQuery {
  return {
    __typename: "Query" as const,
    calculateScopeChange: maybeNew("CalculateScopeChangeResult", data["calculateScopeChange"] || undefined, {}),
  } as any;
}

export function newCheckoutPricingTraceGroupDetailResponse(
  variables: CheckoutPricingTraceGroupDetailQueryVariables,
  data: CheckoutPricingTraceGroupDetailDataOptions | Error,
): MockedResponse<CheckoutPricingTraceGroupDetailQueryVariables, CheckoutPricingTraceGroupDetailQuery> {
  return {
    request: { query: CheckoutPricingTraceGroupDetailDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutPricingTraceGroupDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditProductOfferingPageDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
  productOffering?: FactoryInput<ProductOffering, ProductOfferingOptions>;
}

export function newEditProductOfferingPageData(data: EditProductOfferingPageDataOptions): EditProductOfferingPageQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newEditProductOfferingPageResponse(
  variables: EditProductOfferingPageQueryVariables,
  data: EditProductOfferingPageDataOptions | Error,
): MockedResponse<EditProductOfferingPageQueryVariables, EditProductOfferingPageQuery> {
  return {
    request: { query: EditProductOfferingPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditProductOfferingPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkGlobalPlanTagsModalDataOptions {
  globalPlanTags?: FactoryInput<GlobalPlanTag, GlobalPlanTagOptions>[];
}

export function newBulkGlobalPlanTagsModalData(data: BulkGlobalPlanTagsModalDataOptions): BulkGlobalPlanTagsModalQuery {
  return {
    __typename: "Query" as const,
    globalPlanTags: data["globalPlanTags"]?.map((d) => maybeNew("GlobalPlanTag", d, {})) || [],
  } as any;
}

export function newBulkGlobalPlanTagsModalResponse(
  data: BulkGlobalPlanTagsModalDataOptions | Error,
): MockedResponse<BulkGlobalPlanTagsModalQueryVariables, BulkGlobalPlanTagsModalQuery> {
  return {
    request: { query: BulkGlobalPlanTagsModalDocument },
    result: { data: data instanceof Error ? undefined : newBulkGlobalPlanTagsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkGlobalPlanTagsDataOptions {
  bulkSaveGlobalPlanTags?: FactoryInput<BulkSaveGlobalPlanTagsResult, BulkSaveGlobalPlanTagsResultOptions>;
}

export function newBulkGlobalPlanTagsData(data: BulkGlobalPlanTagsDataOptions): BulkGlobalPlanTagsMutation {
  return {
    __typename: "Mutation" as const,
    bulkSaveGlobalPlanTags: maybeNew("BulkSaveGlobalPlanTagsResult", data["bulkSaveGlobalPlanTags"] || undefined, {}),
  } as any;
}

export function newBulkGlobalPlanTagsResponse(
  variables: BulkGlobalPlanTagsMutationVariables,
  data: BulkGlobalPlanTagsDataOptions | Error,
): MockedResponse<BulkGlobalPlanTagsMutationVariables, BulkGlobalPlanTagsMutation> {
  return {
    request: { query: BulkGlobalPlanTagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkGlobalPlanTagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanConstraintItemDataOptions {
  saveGlobalPlanConstraintItem?: FactoryInput<
    SaveGlobalPlanConstraintItemResult,
    SaveGlobalPlanConstraintItemResultOptions
  >;
}

export function newSaveGlobalPlanConstraintItemData(
  data: SaveGlobalPlanConstraintItemDataOptions,
): SaveGlobalPlanConstraintItemMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanConstraintItem: maybeNew(
      "SaveGlobalPlanConstraintItemResult",
      data["saveGlobalPlanConstraintItem"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveGlobalPlanConstraintItemResponse(
  variables: SaveGlobalPlanConstraintItemMutationVariables,
  data: SaveGlobalPlanConstraintItemDataOptions | Error,
): MockedResponse<SaveGlobalPlanConstraintItemMutationVariables, SaveGlobalPlanConstraintItemMutation> {
  return {
    request: { query: SaveGlobalPlanConstraintItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanConstraintItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanTagDataOptions {
  saveGlobalPlanTag?: FactoryInput<SaveGlobalPlanTagResult, SaveGlobalPlanTagResultOptions>;
}

export function newSaveGlobalPlanTagData(data: SaveGlobalPlanTagDataOptions): SaveGlobalPlanTagMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanTag: maybeNew("SaveGlobalPlanTagResult", data["saveGlobalPlanTag"] || undefined, {}),
  } as any;
}

export function newSaveGlobalPlanTagResponse(
  variables: SaveGlobalPlanTagMutationVariables,
  data: SaveGlobalPlanTagDataOptions | Error,
): MockedResponse<SaveGlobalPlanTagMutationVariables, SaveGlobalPlanTagMutation> {
  return {
    request: { query: SaveGlobalPlanTagDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanTagData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormDataOptions {
  globalPlanTask?: FactoryInput<GlobalPlanTask, GlobalPlanTaskOptions>;
}

export function newTaskCatalogFormData(data: TaskCatalogFormDataOptions): TaskCatalogFormQuery {
  return {
    __typename: "Query" as const,
    globalPlanTask: maybeNew("GlobalPlanTask", data["globalPlanTask"] || undefined, {}),
  } as any;
}

export function newTaskCatalogFormResponse(
  variables: TaskCatalogFormQueryVariables,
  data: TaskCatalogFormDataOptions | Error,
): MockedResponse<TaskCatalogFormQueryVariables, TaskCatalogFormQuery> {
  return {
    request: { query: TaskCatalogFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormDropdownDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
  tradeCategories?: FactoryInput<TradeCategory, TradeCategoryOptions>[];
  globalPlanTags?: FactoryInput<GlobalPlanTag, GlobalPlanTagOptions>[];
  regions?: FactoryInput<Region, RegionOptions>[];
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newTaskCatalogFormDropdownData(data: TaskCatalogFormDropdownDataOptions): TaskCatalogFormDropdownQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    tradeCategories: data["tradeCategories"]?.map((d) => maybeNew("TradeCategory", d, {})) || [],
    globalPlanTags: data["globalPlanTags"]?.map((d) => maybeNew("GlobalPlanTag", d, {})) || [],
    regions: data["regions"]?.map((d) => maybeNew("Region", d, {})) || [],
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
  } as any;
}

export function newTaskCatalogFormDropdownResponse(
  data: TaskCatalogFormDropdownDataOptions | Error,
): MockedResponse<TaskCatalogFormDropdownQueryVariables, TaskCatalogFormDropdownQuery> {
  return {
    request: { query: TaskCatalogFormDropdownDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormDropdownData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormParentDropdownDataOptions {
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
}

export function newTaskCatalogFormParentDropdownData(
  data: TaskCatalogFormParentDropdownDataOptions,
): TaskCatalogFormParentDropdownQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newTaskCatalogFormParentDropdownResponse(
  variables: TaskCatalogFormParentDropdownQueryVariables,
  data: TaskCatalogFormParentDropdownDataOptions | Error,
): MockedResponse<TaskCatalogFormParentDropdownQueryVariables, TaskCatalogFormParentDropdownQuery> {
  return {
    request: { query: TaskCatalogFormParentDropdownDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormParentDropdownData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormSchedulingDropdownDataOptions {
  globalPlanConstraintItems?: FactoryInput<GlobalPlanConstraintItem, GlobalPlanConstraintItemOptions>[];
  globalPlanStages?: FactoryInput<GlobalPlanStage, GlobalPlanStageOptions>[];
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newTaskCatalogFormSchedulingDropdownData(
  data: TaskCatalogFormSchedulingDropdownDataOptions,
): TaskCatalogFormSchedulingDropdownQuery {
  return {
    __typename: "Query" as const,
    globalPlanConstraintItems:
      data["globalPlanConstraintItems"]?.map((d) => maybeNew("GlobalPlanConstraintItem", d, {})) || [],
    globalPlanStages: data["globalPlanStages"]?.map((d) => maybeNew("GlobalPlanStage", d, {})) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newTaskCatalogFormSchedulingDropdownResponse(
  data: TaskCatalogFormSchedulingDropdownDataOptions | Error,
): MockedResponse<TaskCatalogFormSchedulingDropdownQueryVariables, TaskCatalogFormSchedulingDropdownQuery> {
  return {
    request: { query: TaskCatalogFormSchedulingDropdownDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormSchedulingDropdownData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormDocumentsDataOptions {
  documentTypes?: FactoryInput<DocumentTypeDetail, DocumentTypeDetailOptions>[];
}

export function newTaskCatalogFormDocumentsData(
  data: TaskCatalogFormDocumentsDataOptions,
): TaskCatalogFormDocumentsQuery {
  return {
    __typename: "Query" as const,
    documentTypes: data["documentTypes"]?.map((d) => maybeNew("DocumentTypeDetail", d, {})) || [],
  } as any;
}

export function newTaskCatalogFormDocumentsResponse(
  data: TaskCatalogFormDocumentsDataOptions | Error,
): MockedResponse<TaskCatalogFormDocumentsQueryVariables, TaskCatalogFormDocumentsQuery> {
  return {
    request: { query: TaskCatalogFormDocumentsDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormVerificationDropdownDataOptions {
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newTaskCatalogFormVerificationDropdownData(
  data: TaskCatalogFormVerificationDropdownDataOptions,
): TaskCatalogFormVerificationDropdownQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newTaskCatalogFormVerificationDropdownResponse(
  data: TaskCatalogFormVerificationDropdownDataOptions | Error,
): MockedResponse<TaskCatalogFormVerificationDropdownQueryVariables, TaskCatalogFormVerificationDropdownQuery> {
  return {
    request: { query: TaskCatalogFormVerificationDropdownDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormVerificationDropdownData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanTaskDataOptions {
  saveGlobalPlanTask?: FactoryInput<SaveGlobalPlanTaskResult, SaveGlobalPlanTaskResultOptions>;
}

export function newSaveGlobalPlanTaskData(data: SaveGlobalPlanTaskDataOptions): SaveGlobalPlanTaskMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanTask: maybeNew("SaveGlobalPlanTaskResult", data["saveGlobalPlanTask"] || undefined, {}),
  } as any;
}

export function newSaveGlobalPlanTaskResponse(
  variables: SaveGlobalPlanTaskMutationVariables,
  data: SaveGlobalPlanTaskDataOptions | Error,
): MockedResponse<SaveGlobalPlanTaskMutationVariables, SaveGlobalPlanTaskMutation> {
  return {
    request: { query: SaveGlobalPlanTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddStageModalDataOptions {
  saveGlobalPlanStage?: FactoryInput<SaveGlobalPlanStageResult, SaveGlobalPlanStageResultOptions>;
}

export function newAddStageModalData(data: AddStageModalDataOptions): AddStageModalMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanStage: maybeNew("SaveGlobalPlanStageResult", data["saveGlobalPlanStage"] || undefined, {}),
  } as any;
}

export function newAddStageModalResponse(
  variables: AddStageModalMutationVariables,
  data: AddStageModalDataOptions | Error,
): MockedResponse<AddStageModalMutationVariables, AddStageModalMutation> {
  return {
    request: { query: AddStageModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddStageModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MermaidDataOptions {
  mermaid?: FactoryInput<MermaidResult, MermaidResultOptions>;
}

export function newMermaidData(data: MermaidDataOptions): MermaidQuery {
  return { __typename: "Query" as const, mermaid: maybeNew("MermaidResult", data["mermaid"] || undefined, {}) } as any;
}

export function newMermaidResponse(
  variables: MermaidQueryVariables,
  data: MermaidDataOptions | Error,
): MockedResponse<MermaidQueryVariables, MermaidQuery> {
  return {
    request: { query: MermaidDocument, variables },
    result: { data: data instanceof Error ? undefined : newMermaidData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CatalogTaskIdsDataOptions {
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
}

export function newCatalogTaskIdsData(data: CatalogTaskIdsDataOptions): CatalogTaskIdsQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newCatalogTaskIdsResponse(
  data: CatalogTaskIdsDataOptions | Error,
): MockedResponse<CatalogTaskIdsQueryVariables, CatalogTaskIdsQuery> {
  return {
    request: { query: CatalogTaskIdsDocument },
    result: { data: data instanceof Error ? undefined : newCatalogTaskIdsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PaymentScheduleTaskOptionsDataOptions {
  planTasks?: FactoryInput<PlanTasksResult, PlanTasksResultOptions>;
}

export function newPaymentScheduleTaskOptionsData(
  data: PaymentScheduleTaskOptionsDataOptions,
): PaymentScheduleTaskOptionsQuery {
  return {
    __typename: "Query" as const,
    planTasks: maybeNew("PlanTasksResult", data["planTasks"] || undefined, {}),
  } as any;
}

export function newPaymentScheduleTaskOptionsResponse(
  variables: PaymentScheduleTaskOptionsQueryVariables,
  data: PaymentScheduleTaskOptionsDataOptions | Error,
): MockedResponse<PaymentScheduleTaskOptionsQueryVariables, PaymentScheduleTaskOptionsQuery> {
  return {
    request: { query: PaymentScheduleTaskOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPaymentScheduleTaskOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalsDashboardDataOptions {
  approvals?: FactoryInput<ApprovalPage, ApprovalPageOptions> | null;
}

export function newApprovalsDashboardData(data: ApprovalsDashboardDataOptions): ApprovalsDashboardQuery {
  return {
    __typename: "Query" as const,
    approvals: maybeNewOrNull("ApprovalPage", data["approvals"] || undefined, {}),
  } as any;
}

export function newApprovalsDashboardResponse(
  variables: ApprovalsDashboardQueryVariables,
  data: ApprovalsDashboardDataOptions | Error,
): MockedResponse<ApprovalsDashboardQueryVariables, ApprovalsDashboardQuery> {
  return {
    request: { query: ApprovalsDashboardDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalsDashboardData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateApproversDataOptions {
  saveApprovers?: FactoryInput<SaveApproversResult, SaveApproversResultOptions>;
}

export function newUpdateApproversData(data: UpdateApproversDataOptions): UpdateApproversMutation {
  return {
    __typename: "Mutation" as const,
    saveApprovers: maybeNew("SaveApproversResult", data["saveApprovers"] || undefined, {}),
  } as any;
}

export function newUpdateApproversResponse(
  variables: UpdateApproversMutationVariables,
  data: UpdateApproversDataOptions | Error,
): MockedResponse<UpdateApproversMutationVariables, UpdateApproversMutation> {
  return {
    request: { query: UpdateApproversDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateApproversData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreatePandaDocSessionDataOptions {
  createPandaDocSession?: FactoryInput<PandaDocSession, PandaDocSessionOptions>;
}

export function newCreatePandaDocSessionData(data: CreatePandaDocSessionDataOptions): CreatePandaDocSessionMutation {
  return {
    __typename: "Mutation" as const,
    createPandaDocSession: maybeNew("PandaDocSession", data["createPandaDocSession"] || undefined, {}),
  } as any;
}

export function newCreatePandaDocSessionResponse(
  variables: CreatePandaDocSessionMutationVariables,
  data: CreatePandaDocSessionDataOptions | Error,
): MockedResponse<CreatePandaDocSessionMutationVariables, CreatePandaDocSessionMutation> {
  return {
    request: { query: CreatePandaDocSessionDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreatePandaDocSessionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDosPageDataDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
  markets?: FactoryInput<Market, MarketOptions>[];
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newToDosPageDataData(data: ToDosPageDataDataOptions): ToDosPageDataQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
    markets: data["markets"]?.map((d) => maybeNew("Market", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newToDosPageDataResponse(
  variables: ToDosPageDataQueryVariables,
  data: ToDosPageDataDataOptions | Error,
): MockedResponse<ToDosPageDataQueryVariables, ToDosPageDataQuery> {
  return {
    request: { query: ToDosPageDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newToDosPageDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsDelayFlagsDataOptions {
  scheduleFlags?: FactoryInput<ScheduleFlag, ScheduleFlagOptions>[];
}

export function newActionItemsDelayFlagsData(data: ActionItemsDelayFlagsDataOptions): ActionItemsDelayFlagsQuery {
  return {
    __typename: "Query" as const,
    scheduleFlags: data["scheduleFlags"]?.map((d) => maybeNew("ScheduleFlag", d, {})) || [],
  } as any;
}

export function newActionItemsDelayFlagsResponse(
  variables: ActionItemsDelayFlagsQueryVariables,
  data: ActionItemsDelayFlagsDataOptions | Error,
): MockedResponse<ActionItemsDelayFlagsQueryVariables, ActionItemsDelayFlagsQuery> {
  return {
    request: { query: ActionItemsDelayFlagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsDelayFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsSchedulingDataOptions {
  tasks?: FactoryInput<Task, TaskOptions>[];
}

export function newActionItemsSchedulingData(data: ActionItemsSchedulingDataOptions): ActionItemsSchedulingQuery {
  return { __typename: "Query" as const, tasks: data["tasks"]?.map((d) => maybeNew("Task", d, {})) || [] } as any;
}

export function newActionItemsSchedulingResponse(
  variables: ActionItemsSchedulingQueryVariables,
  data: ActionItemsSchedulingDataOptions | Error,
): MockedResponse<ActionItemsSchedulingQueryVariables, ActionItemsSchedulingQuery> {
  return {
    request: { query: ActionItemsSchedulingDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsSchedulingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsDeferredBillsDataOptions {
  bills?: FactoryInput<Bill, BillOptions>[];
}

export function newActionItemsDeferredBillsData(
  data: ActionItemsDeferredBillsDataOptions,
): ActionItemsDeferredBillsQuery {
  return { __typename: "Query" as const, bills: data["bills"]?.map((d) => maybeNew("Bill", d, {})) || [] } as any;
}

export function newActionItemsDeferredBillsResponse(
  variables: ActionItemsDeferredBillsQueryVariables,
  data: ActionItemsDeferredBillsDataOptions | Error,
): MockedResponse<ActionItemsDeferredBillsQueryVariables, ActionItemsDeferredBillsQuery> {
  return {
    request: { query: ActionItemsDeferredBillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsDeferredBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsApprovalsDataOptions {
  approvals?: FactoryInput<ApprovalPage, ApprovalPageOptions> | null;
}

export function newActionItemsApprovalsData(data: ActionItemsApprovalsDataOptions): ActionItemsApprovalsQuery {
  return {
    __typename: "Query" as const,
    approvals: maybeNewOrNull("ApprovalPage", data["approvals"] || undefined, {}),
  } as any;
}

export function newActionItemsApprovalsResponse(
  variables: ActionItemsApprovalsQueryVariables,
  data: ActionItemsApprovalsDataOptions | Error,
): MockedResponse<ActionItemsApprovalsQueryVariables, ActionItemsApprovalsQuery> {
  return {
    request: { query: ActionItemsApprovalsDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsApprovalsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsBillsPendingReviewDataOptions {
  bills?: FactoryInput<Bill, BillOptions>[];
}

export function newActionItemsBillsPendingReviewData(
  data: ActionItemsBillsPendingReviewDataOptions,
): ActionItemsBillsPendingReviewQuery {
  return { __typename: "Query" as const, bills: data["bills"]?.map((d) => maybeNew("Bill", d, {})) || [] } as any;
}

export function newActionItemsBillsPendingReviewResponse(
  variables: ActionItemsBillsPendingReviewQueryVariables,
  data: ActionItemsBillsPendingReviewDataOptions | Error,
): MockedResponse<ActionItemsBillsPendingReviewQueryVariables, ActionItemsBillsPendingReviewQuery> {
  return {
    request: { query: ActionItemsBillsPendingReviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsBillsPendingReviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsStaleTasksDataOptions {
  tasks?: FactoryInput<Task, TaskOptions>[];
}

export function newActionItemsStaleTasksData(data: ActionItemsStaleTasksDataOptions): ActionItemsStaleTasksQuery {
  return { __typename: "Query" as const, tasks: data["tasks"]?.map((d) => maybeNew("Task", d, {})) || [] } as any;
}

export function newActionItemsStaleTasksResponse(
  variables: ActionItemsStaleTasksQueryVariables,
  data: ActionItemsStaleTasksDataOptions | Error,
): MockedResponse<ActionItemsStaleTasksQueryVariables, ActionItemsStaleTasksQuery> {
  return {
    request: { query: ActionItemsStaleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsStaleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpcomingTasksDataOptions {
  tasks?: FactoryInput<Task, TaskOptions>[];
  taskStatuses?: FactoryInput<TaskStatusDetail, TaskStatusDetailOptions>[];
}

export function newUpcomingTasksData(data: UpcomingTasksDataOptions): UpcomingTasksQuery {
  return {
    __typename: "Query" as const,
    tasks: data["tasks"]?.map((d) => maybeNew("Task", d, {})) || [],
    taskStatuses: data["taskStatuses"]?.map((d) => maybeNew("TaskStatusDetail", d, {})) || [],
  } as any;
}

export function newUpcomingTasksResponse(
  variables: UpcomingTasksQueryVariables,
  data: UpcomingTasksDataOptions | Error,
): MockedResponse<UpcomingTasksQueryVariables, UpcomingTasksQuery> {
  return {
    request: { query: UpcomingTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpcomingTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveUpcomingPlanTaskDataOptions {
  savePlanTask?: FactoryInput<SavePlanTaskResult, SavePlanTaskResultOptions>;
}

export function newSaveUpcomingPlanTaskData(data: SaveUpcomingPlanTaskDataOptions): SaveUpcomingPlanTaskMutation {
  return {
    __typename: "Mutation" as const,
    savePlanTask: maybeNew("SavePlanTaskResult", data["savePlanTask"] || undefined, {}),
  } as any;
}

export function newSaveUpcomingPlanTaskResponse(
  variables: SaveUpcomingPlanTaskMutationVariables,
  data: SaveUpcomingPlanTaskDataOptions | Error,
): MockedResponse<SaveUpcomingPlanTaskMutationVariables, SaveUpcomingPlanTaskMutation> {
  return {
    request: { query: SaveUpcomingPlanTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveUpcomingPlanTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BudgetSuperDrawerDataOptions {
  projectItems?: FactoryInput<ProjectItem, ProjectItemOptions>[];
}

export function newBudgetSuperDrawerData(data: BudgetSuperDrawerDataOptions): BudgetSuperDrawerQuery {
  return {
    __typename: "Query" as const,
    projectItems: data["projectItems"]?.map((d) => maybeNew("ProjectItem", d, {})) || [],
  } as any;
}

export function newBudgetSuperDrawerResponse(
  variables: BudgetSuperDrawerQueryVariables,
  data: BudgetSuperDrawerDataOptions | Error,
): MockedResponse<BudgetSuperDrawerQueryVariables, BudgetSuperDrawerQuery> {
  return {
    request: { query: BudgetSuperDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newBudgetSuperDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BudgetActivityTabMetaDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
  userEventParentTypes?: FactoryInput<UserEventParentType, UserEventParentTypeOptions>[];
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  currentUser?: FactoryInput<User, UserOptions> | null;
}

export function newBudgetActivityTabMetaData(data: BudgetActivityTabMetaDataOptions): BudgetActivityTabMetaQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    userEventParentTypes: data["userEventParentTypes"]?.map((d) => maybeNew("UserEventParentType", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newBudgetActivityTabMetaResponse(
  variables: BudgetActivityTabMetaQueryVariables,
  data: BudgetActivityTabMetaDataOptions | Error,
): MockedResponse<BudgetActivityTabMetaQueryVariables, BudgetActivityTabMetaQuery> {
  return {
    request: { query: BudgetActivityTabMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newBudgetActivityTabMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AcceptChangeEventModalDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newAcceptChangeEventModalData(data: AcceptChangeEventModalDataOptions): AcceptChangeEventModalQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newAcceptChangeEventModalResponse(
  variables: AcceptChangeEventModalQueryVariables,
  data: AcceptChangeEventModalDataOptions | Error,
): MockedResponse<AcceptChangeEventModalQueryVariables, AcceptChangeEventModalQuery> {
  return {
    request: { query: AcceptChangeEventModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAcceptChangeEventModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyTemplateChangeEventModalDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newApplyTemplateChangeEventModalData(
  data: ApplyTemplateChangeEventModalDataOptions,
): ApplyTemplateChangeEventModalQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newApplyTemplateChangeEventModalResponse(
  variables: ApplyTemplateChangeEventModalQueryVariables,
  data: ApplyTemplateChangeEventModalDataOptions | Error,
): MockedResponse<ApplyTemplateChangeEventModalQueryVariables, ApplyTemplateChangeEventModalQuery> {
  return {
    request: { query: ApplyTemplateChangeEventModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyTemplateChangeEventModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyTemplatePlanChangeEventModalDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newApplyTemplatePlanChangeEventModalData(
  data: ApplyTemplatePlanChangeEventModalDataOptions,
): ApplyTemplatePlanChangeEventModalQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newApplyTemplatePlanChangeEventModalResponse(
  variables: ApplyTemplatePlanChangeEventModalQueryVariables,
  data: ApplyTemplatePlanChangeEventModalDataOptions | Error,
): MockedResponse<ApplyTemplatePlanChangeEventModalQueryVariables, ApplyTemplatePlanChangeEventModalQuery> {
  return {
    request: { query: ApplyTemplatePlanChangeEventModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyTemplatePlanChangeEventModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateGuidedChangeEventModalDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newCreateGuidedChangeEventModalData(
  data: CreateGuidedChangeEventModalDataOptions,
): CreateGuidedChangeEventModalQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newCreateGuidedChangeEventModalResponse(
  variables: CreateGuidedChangeEventModalQueryVariables,
  data: CreateGuidedChangeEventModalDataOptions | Error,
): MockedResponse<CreateGuidedChangeEventModalQueryVariables, CreateGuidedChangeEventModalQuery> {
  return {
    request: { query: CreateGuidedChangeEventModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateGuidedChangeEventModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateGuidedChangeEventModal_ChangeEventDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newCreateGuidedChangeEventModal_ChangeEventData(
  data: CreateGuidedChangeEventModal_ChangeEventDataOptions,
): CreateGuidedChangeEventModal_ChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newCreateGuidedChangeEventModal_ChangeEventResponse(
  variables: CreateGuidedChangeEventModal_ChangeEventQueryVariables,
  data: CreateGuidedChangeEventModal_ChangeEventDataOptions | Error,
): MockedResponse<
  CreateGuidedChangeEventModal_ChangeEventQueryVariables,
  CreateGuidedChangeEventModal_ChangeEventQuery
> {
  return {
    request: { query: CreateGuidedChangeEventModal_ChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateGuidedChangeEventModal_ChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventLineItemTradePartnerSelectDataOptions {
  bidContractLineItems?: FactoryInput<BidContractLineItem, BidContractLineItemOptions>[];
}

export function newChangeEventLineItemTradePartnerSelectData(
  data: ChangeEventLineItemTradePartnerSelectDataOptions,
): ChangeEventLineItemTradePartnerSelectQuery {
  return {
    __typename: "Query" as const,
    bidContractLineItems: data["bidContractLineItems"]?.map((d) => maybeNew("BidContractLineItem", d, {})) || [],
  } as any;
}

export function newChangeEventLineItemTradePartnerSelectResponse(
  variables: ChangeEventLineItemTradePartnerSelectQueryVariables,
  data: ChangeEventLineItemTradePartnerSelectDataOptions | Error,
): MockedResponse<ChangeEventLineItemTradePartnerSelectQueryVariables, ChangeEventLineItemTradePartnerSelectQuery> {
  return {
    request: { query: ChangeEventLineItemTradePartnerSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventLineItemTradePartnerSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCeModalDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  changeEventReasons?: FactoryInput<ChangeEventReason, ChangeEventReasonOptions>[];
  changeEventBudgetPhases?: FactoryInput<ChangeEventBudgetPhaseDetail, ChangeEventBudgetPhaseDetailOptions>[];
}

export function newCreateCeModalData(data: CreateCeModalDataOptions): CreateCeModalQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => maybeNew("ChangeEventReason", d, {})) || [],
    changeEventBudgetPhases:
      data["changeEventBudgetPhases"]?.map((d) => maybeNew("ChangeEventBudgetPhaseDetail", d, {})) || [],
  } as any;
}

export function newCreateCeModalResponse(
  variables: CreateCeModalQueryVariables,
  data: CreateCeModalDataOptions | Error,
): MockedResponse<CreateCeModalQueryVariables, CreateCeModalQuery> {
  return {
    request: { query: CreateCeModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCeModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCeModalSaveCeDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newCreateCeModalSaveCeData(data: CreateCeModalSaveCeDataOptions): CreateCeModalSaveCeMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newCreateCeModalSaveCeResponse(
  variables: CreateCeModalSaveCeMutationVariables,
  data: CreateCeModalSaveCeDataOptions | Error,
): MockedResponse<CreateCeModalSaveCeMutationVariables, CreateCeModalSaveCeMutation> {
  return {
    request: { query: CreateCeModalSaveCeDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCeModalSaveCeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateChangeEventLineItemsFromCommittedDataOptions {
  createChangeEventLineItemsFromCommitted?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newCreateChangeEventLineItemsFromCommittedData(
  data: CreateChangeEventLineItemsFromCommittedDataOptions,
): CreateChangeEventLineItemsFromCommittedMutation {
  return {
    __typename: "Mutation" as const,
    createChangeEventLineItemsFromCommitted: maybeNew(
      "SaveChangeEventResult",
      data["createChangeEventLineItemsFromCommitted"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateChangeEventLineItemsFromCommittedResponse(
  variables: CreateChangeEventLineItemsFromCommittedMutationVariables,
  data: CreateChangeEventLineItemsFromCommittedDataOptions | Error,
): MockedResponse<
  CreateChangeEventLineItemsFromCommittedMutationVariables,
  CreateChangeEventLineItemsFromCommittedMutation
> {
  return {
    request: { query: CreateChangeEventLineItemsFromCommittedDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateChangeEventLineItemsFromCommittedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventLineItemsDataOptions {
  saveChangeEventLineItems?: FactoryInput<SaveChangeEventLineItemsResult, SaveChangeEventLineItemsResultOptions>;
}

export function newSaveChangeEventLineItemsData(
  data: SaveChangeEventLineItemsDataOptions,
): SaveChangeEventLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveChangeEventLineItemsResponse(
  variables: SaveChangeEventLineItemsMutationVariables,
  data: SaveChangeEventLineItemsDataOptions | Error,
): MockedResponse<SaveChangeEventLineItemsMutationVariables, SaveChangeEventLineItemsMutation> {
  return {
    request: { query: SaveChangeEventLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ZeroChangeEventBudgetChangesDataOptions {
  saveChangeEventLineItems?: FactoryInput<SaveChangeEventLineItemsResult, SaveChangeEventLineItemsResultOptions>;
}

export function newZeroChangeEventBudgetChangesData(
  data: ZeroChangeEventBudgetChangesDataOptions,
): ZeroChangeEventBudgetChangesMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newZeroChangeEventBudgetChangesResponse(
  variables: ZeroChangeEventBudgetChangesMutationVariables,
  data: ZeroChangeEventBudgetChangesDataOptions | Error,
): MockedResponse<ZeroChangeEventBudgetChangesMutationVariables, ZeroChangeEventBudgetChangesMutation> {
  return {
    request: { query: ZeroChangeEventBudgetChangesDocument, variables },
    result: { data: data instanceof Error ? undefined : newZeroChangeEventBudgetChangesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GuidedChangeEventPage_ChangeEventDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newGuidedChangeEventPage_ChangeEventData(
  data: GuidedChangeEventPage_ChangeEventDataOptions,
): GuidedChangeEventPage_ChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newGuidedChangeEventPage_ChangeEventResponse(
  variables: GuidedChangeEventPage_ChangeEventQueryVariables,
  data: GuidedChangeEventPage_ChangeEventDataOptions | Error,
): MockedResponse<GuidedChangeEventPage_ChangeEventQueryVariables, GuidedChangeEventPage_ChangeEventQuery> {
  return {
    request: { query: GuidedChangeEventPage_ChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newGuidedChangeEventPage_ChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GuidedChangeEventPage_ProjectDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newGuidedChangeEventPage_ProjectData(
  data: GuidedChangeEventPage_ProjectDataOptions,
): GuidedChangeEventPage_ProjectQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newGuidedChangeEventPage_ProjectResponse(
  variables: GuidedChangeEventPage_ProjectQueryVariables,
  data: GuidedChangeEventPage_ProjectDataOptions | Error,
): MockedResponse<GuidedChangeEventPage_ProjectQueryVariables, GuidedChangeEventPage_ProjectQuery> {
  return {
    request: { query: GuidedChangeEventPage_ProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newGuidedChangeEventPage_ProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddDepositModalDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
  tasks?: FactoryInput<Task, TaskOptions>[];
}

export function newAddDepositModalData(data: AddDepositModalDataOptions): AddDepositModalQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    tasks: data["tasks"]?.map((d) => maybeNew("Task", d, {})) || [],
  } as any;
}

export function newAddDepositModalResponse(
  variables: AddDepositModalQueryVariables,
  data: AddDepositModalDataOptions | Error,
): MockedResponse<AddDepositModalQueryVariables, AddDepositModalQuery> {
  return {
    request: { query: AddDepositModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddDepositModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateNewCommitmentDataDataOptions {
  tradeCategories?: FactoryInput<TradeCategory, TradeCategoryOptions>[];
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newCreateNewCommitmentDataData(data: CreateNewCommitmentDataDataOptions): CreateNewCommitmentDataQuery {
  return {
    __typename: "Query" as const,
    tradeCategories: data["tradeCategories"]?.map((d) => maybeNew("TradeCategory", d, {})) || [],
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newCreateNewCommitmentDataResponse(
  variables: CreateNewCommitmentDataQueryVariables,
  data: CreateNewCommitmentDataDataOptions | Error,
): MockedResponse<CreateNewCommitmentDataQueryVariables, CreateNewCommitmentDataQuery> {
  return {
    request: { query: CreateNewCommitmentDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateNewCommitmentDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveNewCommitmentDataOptions {
  saveCommitment?: FactoryInput<SaveCommitmentResult, SaveCommitmentResultOptions>;
}

export function newSaveNewCommitmentData(data: SaveNewCommitmentDataOptions): SaveNewCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitment: maybeNew("SaveCommitmentResult", data["saveCommitment"] || undefined, {}),
  } as any;
}

export function newSaveNewCommitmentResponse(
  variables: SaveNewCommitmentMutationVariables,
  data: SaveNewCommitmentDataOptions | Error,
): MockedResponse<SaveNewCommitmentMutationVariables, SaveNewCommitmentMutation> {
  return {
    request: { query: SaveNewCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveNewCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentOverviewCommentDrawerDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
}

export function newCommitmentOverviewCommentDrawerData(
  data: CommitmentOverviewCommentDrawerDataOptions,
): CommitmentOverviewCommentDrawerQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newCommitmentOverviewCommentDrawerResponse(
  variables: CommitmentOverviewCommentDrawerQueryVariables,
  data: CommitmentOverviewCommentDrawerDataOptions | Error,
): MockedResponse<CommitmentOverviewCommentDrawerQueryVariables, CommitmentOverviewCommentDrawerQuery> {
  return {
    request: { query: CommitmentOverviewCommentDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentOverviewCommentDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteUploadedPandaDocDataOptions {
  deletePandaDoc?: FactoryInput<DeletePandaDocResult, DeletePandaDocResultOptions>;
}

export function newDeleteUploadedPandaDocData(data: DeleteUploadedPandaDocDataOptions): DeleteUploadedPandaDocMutation {
  return {
    __typename: "Mutation" as const,
    deletePandaDoc: maybeNew("DeletePandaDocResult", data["deletePandaDoc"] || undefined, {}),
  } as any;
}

export function newDeleteUploadedPandaDocResponse(
  variables: DeleteUploadedPandaDocMutationVariables,
  data: DeleteUploadedPandaDocDataOptions | Error,
): MockedResponse<DeleteUploadedPandaDocMutationVariables, DeleteUploadedPandaDocMutation> {
  return {
    request: { query: DeleteUploadedPandaDocDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteUploadedPandaDocData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PaymentScheduleTabDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
}

export function newPaymentScheduleTabData(data: PaymentScheduleTabDataOptions): PaymentScheduleTabQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newPaymentScheduleTabResponse(
  variables: PaymentScheduleTabQueryVariables,
  data: PaymentScheduleTabDataOptions | Error,
): MockedResponse<PaymentScheduleTabQueryVariables, PaymentScheduleTabQuery> {
  return {
    request: { query: PaymentScheduleTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPaymentScheduleTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveOwnerPandaDocDataOptions {
  savePandaDoc?: FactoryInput<SavePandaDocResult, SavePandaDocResultOptions>;
}

export function newSaveOwnerPandaDocData(data: SaveOwnerPandaDocDataOptions): SaveOwnerPandaDocMutation {
  return {
    __typename: "Mutation" as const,
    savePandaDoc: maybeNew("SavePandaDocResult", data["savePandaDoc"] || undefined, {}),
  } as any;
}

export function newSaveOwnerPandaDocResponse(
  variables: SaveOwnerPandaDocMutationVariables,
  data: SaveOwnerPandaDocDataOptions | Error,
): MockedResponse<SaveOwnerPandaDocMutationVariables, SaveOwnerPandaDocMutation> {
  return {
    request: { query: SaveOwnerPandaDocDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveOwnerPandaDocData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedLineItemsTabDataOptions {
  commitment?: FactoryInput<Commitment, CommitmentOptions>;
}

export function newPlanBasedLineItemsTabData(data: PlanBasedLineItemsTabDataOptions): PlanBasedLineItemsTabQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newPlanBasedLineItemsTabResponse(
  variables: PlanBasedLineItemsTabQueryVariables,
  data: PlanBasedLineItemsTabDataOptions | Error,
): MockedResponse<PlanBasedLineItemsTabQueryVariables, PlanBasedLineItemsTabQuery> {
  return {
    request: { query: PlanBasedLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectDashboardTabDataOptions {
  currentInternalUser?: FactoryInput<InternalUser, InternalUserOptions> | null;
}

export function newProjectDashboardTabData(data: ProjectDashboardTabDataOptions): ProjectDashboardTabQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newProjectDashboardTabResponse(
  data: ProjectDashboardTabDataOptions | Error,
): MockedResponse<ProjectDashboardTabQueryVariables, ProjectDashboardTabQuery> {
  return {
    request: { query: ProjectDashboardTabDocument },
    result: { data: data instanceof Error ? undefined : newProjectDashboardTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectDashboardDataOptions {
  saveInternalUser?: FactoryInput<SaveInternalUserResult, SaveInternalUserResultOptions>;
}

export function newSaveProjectDashboardData(data: SaveProjectDashboardDataOptions): SaveProjectDashboardMutation {
  return {
    __typename: "Mutation" as const,
    saveInternalUser: maybeNew("SaveInternalUserResult", data["saveInternalUser"] || undefined, {}),
  } as any;
}

export function newSaveProjectDashboardResponse(
  variables: SaveProjectDashboardMutationVariables,
  data: SaveProjectDashboardDataOptions | Error,
): MockedResponse<SaveProjectDashboardMutationVariables, SaveProjectDashboardMutation> {
  return {
    request: { query: SaveProjectDashboardDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectDashboardData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActivityTabDataDataOptions {
  currentUser?: FactoryInput<User, UserOptions> | null;
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  userEventParentTypes?: FactoryInput<UserEventParentType, UserEventParentTypeOptions>[];
}

export function newActivityTabDataData(data: ActivityTabDataDataOptions): ActivityTabDataQuery {
  return {
    __typename: "Query" as const,
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    userEventParentTypes: data["userEventParentTypes"]?.map((d) => maybeNew("UserEventParentType", d, {})) || [],
  } as any;
}

export function newActivityTabDataResponse(
  data: ActivityTabDataDataOptions | Error,
): MockedResponse<ActivityTabDataQueryVariables, ActivityTabDataQuery> {
  return {
    request: { query: ActivityTabDataDocument },
    result: { data: data instanceof Error ? undefined : newActivityTabDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PreConExpectationsTabDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newPreConExpectationsTabData(data: PreConExpectationsTabDataOptions): PreConExpectationsTabQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newPreConExpectationsTabResponse(
  variables: PreConExpectationsTabQueryVariables,
  data: PreConExpectationsTabDataOptions | Error,
): MockedResponse<PreConExpectationsTabQueryVariables, PreConExpectationsTabQuery> {
  return {
    request: { query: PreConExpectationsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPreConExpectationsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DynamicScheduleSidePaneDataOptions {
  planTask?: FactoryInput<PlanTask, PlanTaskOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newDynamicScheduleSidePaneData(data: DynamicScheduleSidePaneDataOptions): DynamicScheduleSidePaneQuery {
  return {
    __typename: "Query" as const,
    planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newDynamicScheduleSidePaneResponse(
  variables: DynamicScheduleSidePaneQueryVariables,
  data: DynamicScheduleSidePaneDataOptions | Error,
): MockedResponse<DynamicScheduleSidePaneQueryVariables, DynamicScheduleSidePaneQuery> {
  return {
    request: { query: DynamicScheduleSidePaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newDynamicScheduleSidePaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DraftScheduleSidePaneDataOptions {
  draftPlanSchedule?: FactoryInput<DraftScheduleResult, DraftScheduleResultOptions>;
}

export function newDraftScheduleSidePaneData(data: DraftScheduleSidePaneDataOptions): DraftScheduleSidePaneQuery {
  return {
    __typename: "Query" as const,
    draftPlanSchedule: maybeNew("DraftScheduleResult", data["draftPlanSchedule"] || undefined, {}),
  } as any;
}

export function newDraftScheduleSidePaneResponse(
  variables: DraftScheduleSidePaneQueryVariables,
  data: DraftScheduleSidePaneDataOptions | Error,
): MockedResponse<DraftScheduleSidePaneQueryVariables, DraftScheduleSidePaneQuery> {
  return {
    request: { query: DraftScheduleSidePaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newDraftScheduleSidePaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DynamicSchedulesSnapshotsDataOptions {
  planScheduleSnapshots?: FactoryInput<PlanScheduleSnapshotsResult, PlanScheduleSnapshotsResultOptions>;
}

export function newDynamicSchedulesSnapshotsData(
  data: DynamicSchedulesSnapshotsDataOptions,
): DynamicSchedulesSnapshotsQuery {
  return {
    __typename: "Query" as const,
    planScheduleSnapshots: maybeNew("PlanScheduleSnapshotsResult", data["planScheduleSnapshots"] || undefined, {}),
  } as any;
}

export function newDynamicSchedulesSnapshotsResponse(
  variables: DynamicSchedulesSnapshotsQueryVariables,
  data: DynamicSchedulesSnapshotsDataOptions | Error,
): MockedResponse<DynamicSchedulesSnapshotsQueryVariables, DynamicSchedulesSnapshotsQuery> {
  return {
    request: { query: DynamicSchedulesSnapshotsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDynamicSchedulesSnapshotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PublishDraftScheduleStepperDataOptions {
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions>;
}

export function newPublishDraftScheduleStepperData(
  data: PublishDraftScheduleStepperDataOptions,
): PublishDraftScheduleStepperQuery {
  return {
    __typename: "Query" as const,
    planSchedule: maybeNew("PlanSchedule", data["planSchedule"] || undefined, {}),
  } as any;
}

export function newPublishDraftScheduleStepperResponse(
  variables: PublishDraftScheduleStepperQueryVariables,
  data: PublishDraftScheduleStepperDataOptions | Error,
): MockedResponse<PublishDraftScheduleStepperQueryVariables, PublishDraftScheduleStepperQuery> {
  return {
    request: { query: PublishDraftScheduleStepperDocument, variables },
    result: { data: data instanceof Error ? undefined : newPublishDraftScheduleStepperData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DraftPlanScheduleDataOptions {
  draftPlanSchedule?: FactoryInput<DraftScheduleResult, DraftScheduleResultOptions>;
  globalPlanStages?: FactoryInput<GlobalPlanStage, GlobalPlanStageOptions>[];
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newDraftPlanScheduleData(data: DraftPlanScheduleDataOptions): DraftPlanScheduleQuery {
  return {
    __typename: "Query" as const,
    draftPlanSchedule: maybeNew("DraftScheduleResult", data["draftPlanSchedule"] || undefined, {}),
    globalPlanStages: data["globalPlanStages"]?.map((d) => maybeNew("GlobalPlanStage", d, {})) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newDraftPlanScheduleResponse(
  variables: DraftPlanScheduleQueryVariables,
  data: DraftPlanScheduleDataOptions | Error,
): MockedResponse<DraftPlanScheduleQueryVariables, DraftPlanScheduleQuery> {
  return {
    request: { query: DraftPlanScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newDraftPlanScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleDraftModeScheduleFlagReasonsDataOptions {
  scheduleFlagReasons?: FactoryInput<ScheduleFlagReason, ScheduleFlagReasonOptions>[];
}

export function newScheduleDraftModeScheduleFlagReasonsData(
  data: ScheduleDraftModeScheduleFlagReasonsDataOptions,
): ScheduleDraftModeScheduleFlagReasonsQuery {
  return {
    __typename: "Query" as const,
    scheduleFlagReasons: data["scheduleFlagReasons"]?.map((d) => maybeNew("ScheduleFlagReason", d, {})) || [],
  } as any;
}

export function newScheduleDraftModeScheduleFlagReasonsResponse(
  data: ScheduleDraftModeScheduleFlagReasonsDataOptions | Error,
): MockedResponse<ScheduleDraftModeScheduleFlagReasonsQueryVariables, ScheduleDraftModeScheduleFlagReasonsQuery> {
  return {
    request: { query: ScheduleDraftModeScheduleFlagReasonsDocument },
    result: { data: data instanceof Error ? undefined : newScheduleDraftModeScheduleFlagReasonsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DraftCatalogTasksDataOptions {
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
  project?: FactoryInput<Project, ProjectOptions>;
  globalPlanTags?: FactoryInput<GlobalPlanTag, GlobalPlanTagOptions>[];
}

export function newDraftCatalogTasksData(data: DraftCatalogTasksDataOptions): DraftCatalogTasksQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
    project: maybeNew("Project", data["project"] || undefined, {}),
    globalPlanTags: data["globalPlanTags"]?.map((d) => maybeNew("GlobalPlanTag", d, {})) || [],
  } as any;
}

export function newDraftCatalogTasksResponse(
  variables: DraftCatalogTasksQueryVariables,
  data: DraftCatalogTasksDataOptions | Error,
): MockedResponse<DraftCatalogTasksQueryVariables, DraftCatalogTasksQuery> {
  return {
    request: { query: DraftCatalogTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newDraftCatalogTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDraftPlanScheduleDataOptions {
  saveDraftSchedule?: FactoryInput<DraftScheduleResult, DraftScheduleResultOptions>;
}

export function newSaveDraftPlanScheduleData(data: SaveDraftPlanScheduleDataOptions): SaveDraftPlanScheduleMutation {
  return {
    __typename: "Mutation" as const,
    saveDraftSchedule: maybeNew("DraftScheduleResult", data["saveDraftSchedule"] || undefined, {}),
  } as any;
}

export function newSaveDraftPlanScheduleResponse(
  variables: SaveDraftPlanScheduleMutationVariables,
  data: SaveDraftPlanScheduleDataOptions | Error,
): MockedResponse<SaveDraftPlanScheduleMutationVariables, SaveDraftPlanScheduleMutation> {
  return {
    request: { query: SaveDraftPlanScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDraftPlanScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendTradePartnerAvailabilityRequestEmailDataOptions {
  planTasks?: FactoryInput<PlanTasksResult, PlanTasksResultOptions>;
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions>;
}

export function newSendTradePartnerAvailabilityRequestEmailData(
  data: SendTradePartnerAvailabilityRequestEmailDataOptions,
): SendTradePartnerAvailabilityRequestEmailQuery {
  return {
    __typename: "Query" as const,
    planTasks: maybeNew("PlanTasksResult", data["planTasks"] || undefined, {}),
    planSchedule: maybeNew("PlanSchedule", data["planSchedule"] || undefined, {}),
  } as any;
}

export function newSendTradePartnerAvailabilityRequestEmailResponse(
  variables: SendTradePartnerAvailabilityRequestEmailQueryVariables,
  data: SendTradePartnerAvailabilityRequestEmailDataOptions | Error,
): MockedResponse<
  SendTradePartnerAvailabilityRequestEmailQueryVariables,
  SendTradePartnerAvailabilityRequestEmailQuery
> {
  return {
    request: { query: SendTradePartnerAvailabilityRequestEmailDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendTradePartnerAvailabilityRequestEmailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendSingleTradePartnerAvailabilityRequestEmailDataOptions {
  planTask?: FactoryInput<PlanTask, PlanTaskOptions>;
  planSchedule?: FactoryInput<PlanSchedule, PlanScheduleOptions>;
}

export function newSendSingleTradePartnerAvailabilityRequestEmailData(
  data: SendSingleTradePartnerAvailabilityRequestEmailDataOptions,
): SendSingleTradePartnerAvailabilityRequestEmailQuery {
  return {
    __typename: "Query" as const,
    planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}),
    planSchedule: maybeNew("PlanSchedule", data["planSchedule"] || undefined, {}),
  } as any;
}

export function newSendSingleTradePartnerAvailabilityRequestEmailResponse(
  variables: SendSingleTradePartnerAvailabilityRequestEmailQueryVariables,
  data: SendSingleTradePartnerAvailabilityRequestEmailDataOptions | Error,
): MockedResponse<
  SendSingleTradePartnerAvailabilityRequestEmailQueryVariables,
  SendSingleTradePartnerAvailabilityRequestEmailQuery
> {
  return {
    request: { query: SendSingleTradePartnerAvailabilityRequestEmailDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendSingleTradePartnerAvailabilityRequestEmailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerAvailabilityRequestsDataOptions {
  saveTradePartnerAvailabilityRequests?: FactoryInput<
    SaveTradePartnerAvailabilityRequestsResult,
    SaveTradePartnerAvailabilityRequestsResultOptions
  >;
}

export function newSaveTradePartnerAvailabilityRequestsData(
  data: SaveTradePartnerAvailabilityRequestsDataOptions,
): SaveTradePartnerAvailabilityRequestsMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerAvailabilityRequests: maybeNew(
      "SaveTradePartnerAvailabilityRequestsResult",
      data["saveTradePartnerAvailabilityRequests"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerAvailabilityRequestsResponse(
  variables: SaveTradePartnerAvailabilityRequestsMutationVariables,
  data: SaveTradePartnerAvailabilityRequestsDataOptions | Error,
): MockedResponse<SaveTradePartnerAvailabilityRequestsMutationVariables, SaveTradePartnerAvailabilityRequestsMutation> {
  return {
    request: { query: SaveTradePartnerAvailabilityRequestsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerAvailabilityRequestsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeConfirmPublishStepDataOptions {
  draftPlanSchedule?: FactoryInput<DraftScheduleResult, DraftScheduleResultOptions>;
}

export function newTradeConfirmPublishStepData(data: TradeConfirmPublishStepDataOptions): TradeConfirmPublishStepQuery {
  return {
    __typename: "Query" as const,
    draftPlanSchedule: maybeNew("DraftScheduleResult", data["draftPlanSchedule"] || undefined, {}),
  } as any;
}

export function newTradeConfirmPublishStepResponse(
  variables: TradeConfirmPublishStepQueryVariables,
  data: TradeConfirmPublishStepDataOptions | Error,
): MockedResponse<TradeConfirmPublishStepQueryVariables, TradeConfirmPublishStepQuery> {
  return {
    request: { query: TradeConfirmPublishStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradeConfirmPublishStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanMilestoneDetailsPageDataOptions {
  planMilestone?: FactoryInput<PlanMilestone, PlanMilestoneOptions>;
}

export function newPlanMilestoneDetailsPageData(
  data: PlanMilestoneDetailsPageDataOptions,
): PlanMilestoneDetailsPageQuery {
  return {
    __typename: "Query" as const,
    planMilestone: maybeNew("PlanMilestone", data["planMilestone"] || undefined, {}),
  } as any;
}

export function newPlanMilestoneDetailsPageResponse(
  variables: PlanMilestoneDetailsPageQueryVariables,
  data: PlanMilestoneDetailsPageDataOptions | Error,
): MockedResponse<PlanMilestoneDetailsPageQueryVariables, PlanMilestoneDetailsPageQuery> {
  return {
    request: { query: PlanMilestoneDetailsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanMilestoneDetailsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskTradePartnerContentMetadataDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newTaskTradePartnerContentMetadataData(
  data: TaskTradePartnerContentMetadataDataOptions,
): TaskTradePartnerContentMetadataQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newTaskTradePartnerContentMetadataResponse(
  variables: TaskTradePartnerContentMetadataQueryVariables,
  data: TaskTradePartnerContentMetadataDataOptions | Error,
): MockedResponse<TaskTradePartnerContentMetadataQueryVariables, TaskTradePartnerContentMetadataQuery> {
  return {
    request: { query: TaskTradePartnerContentMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskTradePartnerContentMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanTaskMaterialsPageDataOptions {
  planTask?: FactoryInput<PlanTask, PlanTaskOptions>;
}

export function newPlanTaskMaterialsPageData(data: PlanTaskMaterialsPageDataOptions): PlanTaskMaterialsPageQuery {
  return { __typename: "Query" as const, planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}) } as any;
}

export function newPlanTaskMaterialsPageResponse(
  variables: PlanTaskMaterialsPageQueryVariables,
  data: PlanTaskMaterialsPageDataOptions | Error,
): MockedResponse<PlanTaskMaterialsPageQueryVariables, PlanTaskMaterialsPageQuery> {
  return {
    request: { query: PlanTaskMaterialsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanTaskMaterialsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventExpenseLineItemDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newSaveChangeEventExpenseLineItemData(
  data: SaveChangeEventExpenseLineItemDataOptions,
): SaveChangeEventExpenseLineItemMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newSaveChangeEventExpenseLineItemResponse(
  variables: SaveChangeEventExpenseLineItemMutationVariables,
  data: SaveChangeEventExpenseLineItemDataOptions | Error,
): MockedResponse<SaveChangeEventExpenseLineItemMutationVariables, SaveChangeEventExpenseLineItemMutation> {
  return {
    request: { query: SaveChangeEventExpenseLineItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventExpenseLineItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventFormContentDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
  unitsOfMeasure?: FactoryInput<UnitOfMeasure, UnitOfMeasureOptions>[];
  project?: FactoryInput<Project, ProjectOptions>;
  changeEventReasons?: FactoryInput<ChangeEventReason, ChangeEventReasonOptions>[];
}

export function newChangeEventFormContentData(data: ChangeEventFormContentDataOptions): ChangeEventFormContentQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => maybeNew("UnitOfMeasure", d, {})) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => maybeNew("ChangeEventReason", d, {})) || [],
  } as any;
}

export function newChangeEventFormContentResponse(
  variables: ChangeEventFormContentQueryVariables,
  data: ChangeEventFormContentDataOptions | Error,
): MockedResponse<ChangeEventFormContentQueryVariables, ChangeEventFormContentQuery> {
  return {
    request: { query: ChangeEventFormContentDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventFormContentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanTaskDetailsPageDataOptions {
  planTask?: FactoryInput<PlanTask, PlanTaskOptions>;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newPlanTaskDetailsPageData(data: PlanTaskDetailsPageDataOptions): PlanTaskDetailsPageQuery {
  return {
    __typename: "Query" as const,
    planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newPlanTaskDetailsPageResponse(
  variables: PlanTaskDetailsPageQueryVariables,
  data: PlanTaskDetailsPageDataOptions | Error,
): MockedResponse<PlanTaskDetailsPageQueryVariables, PlanTaskDetailsPageQuery> {
  return {
    request: { query: PlanTaskDetailsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanTaskDetailsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanTaskDetailsDocumentsDataOptions {
  documents?: FactoryInput<Document, DocumentOptions>[];
  documentTypes?: FactoryInput<DocumentTypeDetail, DocumentTypeDetailOptions>[];
}

export function newPlanTaskDetailsDocumentsData(
  data: PlanTaskDetailsDocumentsDataOptions,
): PlanTaskDetailsDocumentsQuery {
  return {
    __typename: "Query" as const,
    documents: data["documents"]?.map((d) => maybeNew("Document", d, {})) || [],
    documentTypes: data["documentTypes"]?.map((d) => maybeNew("DocumentTypeDetail", d, {})) || [],
  } as any;
}

export function newPlanTaskDetailsDocumentsResponse(
  variables: PlanTaskDetailsDocumentsQueryVariables,
  data: PlanTaskDetailsDocumentsDataOptions | Error,
): MockedResponse<PlanTaskDetailsDocumentsQueryVariables, PlanTaskDetailsDocumentsQuery> {
  return {
    request: { query: PlanTaskDetailsDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanTaskDetailsDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanTaskChecklistItemDataOptions {
  savePlanTaskChecklistItem?: FactoryInput<SavePlanTaskChecklistItemResult, SavePlanTaskChecklistItemResultOptions>;
}

export function newSavePlanTaskChecklistItemData(
  data: SavePlanTaskChecklistItemDataOptions,
): SavePlanTaskChecklistItemMutation {
  return {
    __typename: "Mutation" as const,
    savePlanTaskChecklistItem: maybeNew(
      "SavePlanTaskChecklistItemResult",
      data["savePlanTaskChecklistItem"] || undefined,
      {},
    ),
  } as any;
}

export function newSavePlanTaskChecklistItemResponse(
  variables: SavePlanTaskChecklistItemMutationVariables,
  data: SavePlanTaskChecklistItemDataOptions | Error,
): MockedResponse<SavePlanTaskChecklistItemMutationVariables, SavePlanTaskChecklistItemMutation> {
  return {
    request: { query: SavePlanTaskChecklistItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanTaskChecklistItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeletePlanTaskChecklistItemDataOptions {
  deletePlanTaskChecklistItem?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeletePlanTaskChecklistItemData(
  data: DeletePlanTaskChecklistItemDataOptions,
): DeletePlanTaskChecklistItemMutation {
  return {
    __typename: "Mutation" as const,
    deletePlanTaskChecklistItem: maybeNew("EmptyResult", data["deletePlanTaskChecklistItem"] || undefined, {}),
  } as any;
}

export function newDeletePlanTaskChecklistItemResponse(
  variables: DeletePlanTaskChecklistItemMutationVariables,
  data: DeletePlanTaskChecklistItemDataOptions | Error,
): MockedResponse<DeletePlanTaskChecklistItemMutationVariables, DeletePlanTaskChecklistItemMutation> {
  return {
    request: { query: DeletePlanTaskChecklistItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeletePlanTaskChecklistItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanTaskDataOptions {
  savePlanTask?: FactoryInput<SavePlanTaskResult, SavePlanTaskResultOptions>;
}

export function newSavePlanTaskData(data: SavePlanTaskDataOptions): SavePlanTaskMutation {
  return {
    __typename: "Mutation" as const,
    savePlanTask: maybeNew("SavePlanTaskResult", data["savePlanTask"] || undefined, {}),
  } as any;
}

export function newSavePlanTaskResponse(
  variables: SavePlanTaskMutationVariables,
  data: SavePlanTaskDataOptions | Error,
): MockedResponse<SavePlanTaskMutationVariables, SavePlanTaskMutation> {
  return {
    request: { query: SavePlanTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveRequiredTaskDocumentOnPlanTaskDataOptions {
  saveRequiredTaskDocument?: FactoryInput<SaveRequiredTaskDocumentResult, SaveRequiredTaskDocumentResultOptions>;
}

export function newSaveRequiredTaskDocumentOnPlanTaskData(
  data: SaveRequiredTaskDocumentOnPlanTaskDataOptions,
): SaveRequiredTaskDocumentOnPlanTaskMutation {
  return {
    __typename: "Mutation" as const,
    saveRequiredTaskDocument: maybeNew(
      "SaveRequiredTaskDocumentResult",
      data["saveRequiredTaskDocument"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveRequiredTaskDocumentOnPlanTaskResponse(
  variables: SaveRequiredTaskDocumentOnPlanTaskMutationVariables,
  data: SaveRequiredTaskDocumentOnPlanTaskDataOptions | Error,
): MockedResponse<SaveRequiredTaskDocumentOnPlanTaskMutationVariables, SaveRequiredTaskDocumentOnPlanTaskMutation> {
  return {
    request: { query: SaveRequiredTaskDocumentOnPlanTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveRequiredTaskDocumentOnPlanTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ExpensesTableByProjectIdDataOptions {
  expensesPage?: FactoryInput<ExpensesPage, ExpensesPageOptions>;
}

export function newExpensesTableByProjectIdData(
  data: ExpensesTableByProjectIdDataOptions,
): ExpensesTableByProjectIdQuery {
  return {
    __typename: "Query" as const,
    expensesPage: maybeNew("ExpensesPage", data["expensesPage"] || undefined, {}),
  } as any;
}

export function newExpensesTableByProjectIdResponse(
  variables: ExpensesTableByProjectIdQueryVariables,
  data: ExpensesTableByProjectIdDataOptions | Error,
): MockedResponse<ExpensesTableByProjectIdQueryVariables, ExpensesTableByProjectIdQuery> {
  return {
    request: { query: ExpensesTableByProjectIdDocument, variables },
    result: { data: data instanceof Error ? undefined : newExpensesTableByProjectIdData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDocumentsToExpenseDataOptions {
  saveExpenses?: FactoryInput<SaveExpensesResult, SaveExpensesResultOptions>;
}

export function newSaveDocumentsToExpenseData(data: SaveDocumentsToExpenseDataOptions): SaveDocumentsToExpenseMutation {
  return {
    __typename: "Mutation" as const,
    saveExpenses: maybeNew("SaveExpensesResult", data["saveExpenses"] || undefined, {}),
  } as any;
}

export function newSaveDocumentsToExpenseResponse(
  variables: SaveDocumentsToExpenseMutationVariables,
  data: SaveDocumentsToExpenseDataOptions | Error,
): MockedResponse<SaveDocumentsToExpenseMutationVariables, SaveDocumentsToExpenseMutation> {
  return {
    request: { query: SaveDocumentsToExpenseDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDocumentsToExpenseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveExpenseTableDocumentDataOptions {
  saveDocuments?: FactoryInput<SaveDocumentsResult, SaveDocumentsResultOptions>;
}

export function newSaveExpenseTableDocumentData(
  data: SaveExpenseTableDocumentDataOptions,
): SaveExpenseTableDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveExpenseTableDocumentResponse(
  variables: SaveExpenseTableDocumentMutationVariables,
  data: SaveExpenseTableDocumentDataOptions | Error,
): MockedResponse<SaveExpenseTableDocumentMutationVariables, SaveExpenseTableDocumentMutation> {
  return {
    request: { query: SaveExpenseTableDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveExpenseTableDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveExpenseDataOptions {
  saveExpenses?: FactoryInput<SaveExpensesResult, SaveExpensesResultOptions>;
}

export function newSaveExpenseData(data: SaveExpenseDataOptions): SaveExpenseMutation {
  return {
    __typename: "Mutation" as const,
    saveExpenses: maybeNew("SaveExpensesResult", data["saveExpenses"] || undefined, {}),
  } as any;
}

export function newSaveExpenseResponse(
  variables: SaveExpenseMutationVariables,
  data: SaveExpenseDataOptions | Error,
): MockedResponse<SaveExpenseMutationVariables, SaveExpenseMutation> {
  return {
    request: { query: SaveExpenseDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveExpenseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveExpenseAllocationsDataOptions {
  saveExpenseAllocations?: FactoryInput<SaveExpenseAllocationsResult, SaveExpenseAllocationsResultOptions>;
}

export function newSaveExpenseAllocationsData(data: SaveExpenseAllocationsDataOptions): SaveExpenseAllocationsMutation {
  return {
    __typename: "Mutation" as const,
    saveExpenseAllocations: maybeNew("SaveExpenseAllocationsResult", data["saveExpenseAllocations"] || undefined, {}),
  } as any;
}

export function newSaveExpenseAllocationsResponse(
  variables: SaveExpenseAllocationsMutationVariables,
  data: SaveExpenseAllocationsDataOptions | Error,
): MockedResponse<SaveExpenseAllocationsMutationVariables, SaveExpenseAllocationsMutation> {
  return {
    request: { query: SaveExpenseAllocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveExpenseAllocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConvertExpenseToBillDataOptions {
  convertExpenseToBill?: FactoryInput<ConvertExpenseToBillResult, ConvertExpenseToBillResultOptions>;
}

export function newConvertExpenseToBillData(data: ConvertExpenseToBillDataOptions): ConvertExpenseToBillMutation {
  return {
    __typename: "Mutation" as const,
    convertExpenseToBill: maybeNew("ConvertExpenseToBillResult", data["convertExpenseToBill"] || undefined, {}),
  } as any;
}

export function newConvertExpenseToBillResponse(
  variables: ConvertExpenseToBillMutationVariables,
  data: ConvertExpenseToBillDataOptions | Error,
): MockedResponse<ConvertExpenseToBillMutationVariables, ConvertExpenseToBillMutation> {
  return {
    request: { query: ConvertExpenseToBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newConvertExpenseToBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerContractSummariesDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newHomeownerContractSummariesData(
  data: HomeownerContractSummariesDataOptions,
): HomeownerContractSummariesQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newHomeownerContractSummariesResponse(
  variables: HomeownerContractSummariesQueryVariables,
  data: HomeownerContractSummariesDataOptions | Error,
): MockedResponse<HomeownerContractSummariesQueryVariables, HomeownerContractSummariesQuery> {
  return {
    request: { query: HomeownerContractSummariesDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerContractSummariesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveInvoiceCreatePageDataOptions {
  saveInvoice?: FactoryInput<SaveInvoiceResult, SaveInvoiceResultOptions>;
}

export function newSaveInvoiceCreatePageData(data: SaveInvoiceCreatePageDataOptions): SaveInvoiceCreatePageMutation {
  return {
    __typename: "Mutation" as const,
    saveInvoice: maybeNew("SaveInvoiceResult", data["saveInvoice"] || undefined, {}),
  } as any;
}

export function newSaveInvoiceCreatePageResponse(
  variables: SaveInvoiceCreatePageMutationVariables,
  data: SaveInvoiceCreatePageDataOptions | Error,
): MockedResponse<SaveInvoiceCreatePageMutationVariables, SaveInvoiceCreatePageMutation> {
  return {
    request: { query: SaveInvoiceCreatePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveInvoiceCreatePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceCreatePageDataOptions {
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
}

export function newInvoiceCreatePageData(data: InvoiceCreatePageDataOptions): InvoiceCreatePageQuery {
  return { __typename: "Query" as const, invoice: maybeNew("Invoice", data["invoice"] || undefined, {}) } as any;
}

export function newInvoiceCreatePageResponse(
  variables: InvoiceCreatePageQueryVariables,
  data: InvoiceCreatePageDataOptions | Error,
): MockedResponse<InvoiceCreatePageQueryVariables, InvoiceCreatePageQuery> {
  return {
    request: { query: InvoiceCreatePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceCreatePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceProjectDataDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newInvoiceProjectDataData(data: InvoiceProjectDataDataOptions): InvoiceProjectDataQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newInvoiceProjectDataResponse(
  variables: InvoiceProjectDataQueryVariables,
  data: InvoiceProjectDataDataOptions | Error,
): MockedResponse<InvoiceProjectDataQueryVariables, InvoiceProjectDataQuery> {
  return {
    request: { query: InvoiceProjectDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceProjectDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceIntacctSyncErrorDataOptions {
  invoice?: FactoryInput<Invoice, InvoiceOptions>;
}

export function newInvoiceIntacctSyncErrorData(data: InvoiceIntacctSyncErrorDataOptions): InvoiceIntacctSyncErrorQuery {
  return { __typename: "Query" as const, invoice: maybeNew("Invoice", data["invoice"] || undefined, {}) } as any;
}

export function newInvoiceIntacctSyncErrorResponse(
  variables: InvoiceIntacctSyncErrorQueryVariables,
  data: InvoiceIntacctSyncErrorDataOptions | Error,
): MockedResponse<InvoiceIntacctSyncErrorQueryVariables, InvoiceIntacctSyncErrorQuery> {
  return {
    request: { query: InvoiceIntacctSyncErrorDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceIntacctSyncErrorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SyncInvoiceToIntacctDataOptions {
  syncInvoiceToIntacct?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newSyncInvoiceToIntacctData(data: SyncInvoiceToIntacctDataOptions): SyncInvoiceToIntacctMutation {
  return {
    __typename: "Mutation" as const,
    syncInvoiceToIntacct: maybeNew("EmptyResult", data["syncInvoiceToIntacct"] || undefined, {}),
  } as any;
}

export function newSyncInvoiceToIntacctResponse(
  variables: SyncInvoiceToIntacctMutationVariables,
  data: SyncInvoiceToIntacctDataOptions | Error,
): MockedResponse<SyncInvoiceToIntacctMutationVariables, SyncInvoiceToIntacctMutation> {
  return {
    request: { query: SyncInvoiceToIntacctDocument, variables },
    result: { data: data instanceof Error ? undefined : newSyncInvoiceToIntacctData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerNoteDataOptions {
  saveHomeownerNote?: FactoryInput<SaveHomeownerNoteResult, SaveHomeownerNoteResultOptions>;
}

export function newSaveHomeownerNoteData(data: SaveHomeownerNoteDataOptions): SaveHomeownerNoteMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerNote: maybeNew("SaveHomeownerNoteResult", data["saveHomeownerNote"] || undefined, {}),
  } as any;
}

export function newSaveHomeownerNoteResponse(
  variables: SaveHomeownerNoteMutationVariables,
  data: SaveHomeownerNoteDataOptions | Error,
): MockedResponse<SaveHomeownerNoteMutationVariables, SaveHomeownerNoteMutation> {
  return {
    request: { query: SaveHomeownerNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteHomeownerNoteDataOptions {
  deleteHomeownerNote?: FactoryInput<EmptyResult, EmptyResultOptions> | null;
}

export function newDeleteHomeownerNoteData(data: DeleteHomeownerNoteDataOptions): DeleteHomeownerNoteMutation {
  return {
    __typename: "Mutation" as const,
    deleteHomeownerNote: maybeNewOrNull("EmptyResult", data["deleteHomeownerNote"] || undefined, {}),
  } as any;
}

export function newDeleteHomeownerNoteResponse(
  variables: DeleteHomeownerNoteMutationVariables,
  data: DeleteHomeownerNoteDataOptions | Error,
): MockedResponse<DeleteHomeownerNoteMutationVariables, DeleteHomeownerNoteMutation> {
  return {
    request: { query: DeleteHomeownerNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteHomeownerNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditHomeownerNoteDataOptions {
  homeownerNote?: FactoryInput<HomeownerNote, HomeownerNoteOptions>;
}

export function newEditHomeownerNoteData(data: EditHomeownerNoteDataOptions): EditHomeownerNoteQuery {
  return {
    __typename: "Query" as const,
    homeownerNote: maybeNew("HomeownerNote", data["homeownerNote"] || undefined, {}),
  } as any;
}

export function newEditHomeownerNoteResponse(
  variables: EditHomeownerNoteQueryVariables,
  data: EditHomeownerNoteDataOptions | Error,
): MockedResponse<EditHomeownerNoteQueryVariables, EditHomeownerNoteQuery> {
  return {
    request: { query: EditHomeownerNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditHomeownerNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksForHomeownerNoteDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newScheduleTasksForHomeownerNoteData(
  data: ScheduleTasksForHomeownerNoteDataOptions,
): ScheduleTasksForHomeownerNoteQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newScheduleTasksForHomeownerNoteResponse(
  variables: ScheduleTasksForHomeownerNoteQueryVariables,
  data: ScheduleTasksForHomeownerNoteDataOptions | Error,
): MockedResponse<ScheduleTasksForHomeownerNoteQueryVariables, ScheduleTasksForHomeownerNoteQuery> {
  return {
    request: { query: ScheduleTasksForHomeownerNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksForHomeownerNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalTasksHeaderDataDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
  schedule?: FactoryInput<Schedule, ScheduleOptions>;
}

export function newGlobalTasksHeaderDataData(data: GlobalTasksHeaderDataDataOptions): GlobalTasksHeaderDataQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
    schedule: maybeNew("Schedule", data["schedule"] || undefined, {}),
  } as any;
}

export function newGlobalTasksHeaderDataResponse(
  variables: GlobalTasksHeaderDataQueryVariables,
  data: GlobalTasksHeaderDataDataOptions | Error,
): MockedResponse<GlobalTasksHeaderDataQueryVariables, GlobalTasksHeaderDataQuery> {
  return {
    request: { query: GlobalTasksHeaderDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalTasksHeaderDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleCalendarTasksDataOptions {
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newScheduleCalendarTasksData(data: ScheduleCalendarTasksDataOptions): ScheduleCalendarTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newScheduleCalendarTasksResponse(
  variables: ScheduleCalendarTasksQueryVariables,
  data: ScheduleCalendarTasksDataOptions | Error,
): MockedResponse<ScheduleCalendarTasksQueryVariables, ScheduleCalendarTasksQuery> {
  return {
    request: { query: ScheduleCalendarTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleCalendarTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskDetailPaneDataOptions {
  scheduleTask?: FactoryInput<ScheduleTask, ScheduleTaskOptions>;
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
  documents?: FactoryInput<Document, DocumentOptions>[];
}

export function newTaskDetailPaneData(data: TaskDetailPaneDataOptions): TaskDetailPaneQuery {
  return {
    __typename: "Query" as const,
    scheduleTask: maybeNew("ScheduleTask", data["scheduleTask"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
    documents: data["documents"]?.map((d) => maybeNew("Document", d, {})) || [],
  } as any;
}

export function newTaskDetailPaneResponse(
  variables: TaskDetailPaneQueryVariables,
  data: TaskDetailPaneDataOptions | Error,
): MockedResponse<TaskDetailPaneQueryVariables, TaskDetailPaneQuery> {
  return {
    request: { query: TaskDetailPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskDetailPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskDetailPaneDropdownOptionsDataOptions {
  taskStatuses?: FactoryInput<TaskStatusDetail, TaskStatusDetailOptions>[];
  documentTypes?: FactoryInput<DocumentTypeDetail, DocumentTypeDetailOptions>[];
}

export function newTaskDetailPaneDropdownOptionsData(
  data: TaskDetailPaneDropdownOptionsDataOptions,
): TaskDetailPaneDropdownOptionsQuery {
  return {
    __typename: "Query" as const,
    taskStatuses: data["taskStatuses"]?.map((d) => maybeNew("TaskStatusDetail", d, {})) || [],
    documentTypes: data["documentTypes"]?.map((d) => maybeNew("DocumentTypeDetail", d, {})) || [],
  } as any;
}

export function newTaskDetailPaneDropdownOptionsResponse(
  data: TaskDetailPaneDropdownOptionsDataOptions | Error,
): MockedResponse<TaskDetailPaneDropdownOptionsQueryVariables, TaskDetailPaneDropdownOptionsQuery> {
  return {
    request: { query: TaskDetailPaneDropdownOptionsDocument },
    result: { data: data instanceof Error ? undefined : newTaskDetailPaneDropdownOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTaskDocumentsDataOptions {
  saveDocuments?: FactoryInput<SaveDocumentsResult, SaveDocumentsResultOptions>;
}

export function newSaveTaskDocumentsData(data: SaveTaskDocumentsDataOptions): SaveTaskDocumentsMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveTaskDocumentsResponse(
  variables: SaveTaskDocumentsMutationVariables,
  data: SaveTaskDocumentsDataOptions | Error,
): MockedResponse<SaveTaskDocumentsMutationVariables, SaveTaskDocumentsMutation> {
  return {
    request: { query: SaveTaskDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTaskDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveRequiredTaskDocumentDataOptions {
  saveRequiredTaskDocument?: FactoryInput<SaveRequiredTaskDocumentResult, SaveRequiredTaskDocumentResultOptions>;
}

export function newSaveRequiredTaskDocumentData(
  data: SaveRequiredTaskDocumentDataOptions,
): SaveRequiredTaskDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveRequiredTaskDocument: maybeNew(
      "SaveRequiredTaskDocumentResult",
      data["saveRequiredTaskDocument"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveRequiredTaskDocumentResponse(
  variables: SaveRequiredTaskDocumentMutationVariables,
  data: SaveRequiredTaskDocumentDataOptions | Error,
): MockedResponse<SaveRequiredTaskDocumentMutationVariables, SaveRequiredTaskDocumentMutation> {
  return {
    request: { query: SaveRequiredTaskDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveRequiredTaskDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteRequiredTaskDocumentDataOptions {
  deleteRequireTaskDocument?: FactoryInput<DeleteRequiredTaskDocumentResult, DeleteRequiredTaskDocumentResultOptions>;
}

export function newDeleteRequiredTaskDocumentData(
  data: DeleteRequiredTaskDocumentDataOptions,
): DeleteRequiredTaskDocumentMutation {
  return {
    __typename: "Mutation" as const,
    deleteRequireTaskDocument: maybeNew(
      "DeleteRequiredTaskDocumentResult",
      data["deleteRequireTaskDocument"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteRequiredTaskDocumentResponse(
  variables: DeleteRequiredTaskDocumentMutationVariables,
  data: DeleteRequiredTaskDocumentDataOptions | Error,
): MockedResponse<DeleteRequiredTaskDocumentMutationVariables, DeleteRequiredTaskDocumentMutation> {
  return {
    request: { query: DeleteRequiredTaskDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteRequiredTaskDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectRoleDetailsDataOptions {
  projectRoleDetails?: FactoryInput<ProjectRoleDetail, ProjectRoleDetailOptions>[];
}

export function newProjectRoleDetailsData(data: ProjectRoleDetailsDataOptions): ProjectRoleDetailsQuery {
  return {
    __typename: "Query" as const,
    projectRoleDetails: data["projectRoleDetails"]?.map((d) => maybeNew("ProjectRoleDetail", d, {})) || [],
  } as any;
}

export function newProjectRoleDetailsResponse(
  data: ProjectRoleDetailsDataOptions | Error,
): MockedResponse<ProjectRoleDetailsQueryVariables, ProjectRoleDetailsQuery> {
  return {
    request: { query: ProjectRoleDetailsDocument },
    result: { data: data instanceof Error ? undefined : newProjectRoleDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteScheduleTaskChecklistItemDataOptions {
  deleteScheduleTaskChecklistItem?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newDeleteScheduleTaskChecklistItemData(
  data: DeleteScheduleTaskChecklistItemDataOptions,
): DeleteScheduleTaskChecklistItemMutation {
  return {
    __typename: "Mutation" as const,
    deleteScheduleTaskChecklistItem: maybeNew("EmptyResult", data["deleteScheduleTaskChecklistItem"] || undefined, {}),
  } as any;
}

export function newDeleteScheduleTaskChecklistItemResponse(
  variables: DeleteScheduleTaskChecklistItemMutationVariables,
  data: DeleteScheduleTaskChecklistItemDataOptions | Error,
): MockedResponse<DeleteScheduleTaskChecklistItemMutationVariables, DeleteScheduleTaskChecklistItemMutation> {
  return {
    request: { query: DeleteScheduleTaskChecklistItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteScheduleTaskChecklistItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleTaskChecklistItemDataOptions {
  saveScheduleTaskChecklistItem?: FactoryInput<
    SaveScheduleTaskChecklistItemResult,
    SaveScheduleTaskChecklistItemResultOptions
  >;
}

export function newSaveScheduleTaskChecklistItemData(
  data: SaveScheduleTaskChecklistItemDataOptions,
): SaveScheduleTaskChecklistItemMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTaskChecklistItem: maybeNew(
      "SaveScheduleTaskChecklistItemResult",
      data["saveScheduleTaskChecklistItem"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveScheduleTaskChecklistItemResponse(
  variables: SaveScheduleTaskChecklistItemMutationVariables,
  data: SaveScheduleTaskChecklistItemDataOptions | Error,
): MockedResponse<SaveScheduleTaskChecklistItemMutationVariables, SaveScheduleTaskChecklistItemMutation> {
  return {
    request: { query: SaveScheduleTaskChecklistItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleTaskChecklistItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskBillModalContextDataOptions {
  task?: FactoryInput<Task, TaskOptions>;
}

export function newTaskBillModalContextData(data: TaskBillModalContextDataOptions): TaskBillModalContextQuery {
  return { __typename: "Query" as const, task: maybeNew("Task", data["task"] || undefined, {}) } as any;
}

export function newTaskBillModalContextResponse(
  variables: TaskBillModalContextQueryVariables,
  data: TaskBillModalContextDataOptions | Error,
): MockedResponse<TaskBillModalContextQueryVariables, TaskBillModalContextQuery> {
  return {
    request: { query: TaskBillModalContextDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskBillModalContextData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleHistoryTabDataOptions {
  scheduleTask?: FactoryInput<ScheduleTask, ScheduleTaskOptions>;
}

export function newScheduleHistoryTabData(data: ScheduleHistoryTabDataOptions): ScheduleHistoryTabQuery {
  return {
    __typename: "Query" as const,
    scheduleTask: maybeNew("ScheduleTask", data["scheduleTask"] || undefined, {}),
  } as any;
}

export function newScheduleHistoryTabResponse(
  variables: ScheduleHistoryTabQueryVariables,
  data: ScheduleHistoryTabDataOptions | Error,
): MockedResponse<ScheduleHistoryTabQueryVariables, ScheduleHistoryTabQuery> {
  return {
    request: { query: ScheduleHistoryTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleHistoryTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleSubPhasesDataOptions {
  saveScheduleSubPhases?: FactoryInput<SaveScheduleSubPhasesResult, SaveScheduleSubPhasesResultOptions>;
}

export function newSaveScheduleSubPhasesData(data: SaveScheduleSubPhasesDataOptions): SaveScheduleSubPhasesMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleSubPhases: maybeNew("SaveScheduleSubPhasesResult", data["saveScheduleSubPhases"] || undefined, {}),
  } as any;
}

export function newSaveScheduleSubPhasesResponse(
  variables: SaveScheduleSubPhasesMutationVariables,
  data: SaveScheduleSubPhasesDataOptions | Error,
): MockedResponse<SaveScheduleSubPhasesMutationVariables, SaveScheduleSubPhasesMutation> {
  return {
    request: { query: SaveScheduleSubPhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleSubPhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleGanttDataOptions {
  schedule?: FactoryInput<Schedule, ScheduleOptions>;
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
  schedulePhases?: FactoryInput<SchedulePhase, SchedulePhaseOptions>[];
}

export function newScheduleGanttData(data: ScheduleGanttDataOptions): ScheduleGanttQuery {
  return {
    __typename: "Query" as const,
    schedule: maybeNew("Schedule", data["schedule"] || undefined, {}),
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
    schedulePhases: data["schedulePhases"]?.map((d) => maybeNew("SchedulePhase", d, {})) || [],
  } as any;
}

export function newScheduleGanttResponse(
  variables: ScheduleGanttQueryVariables,
  data: ScheduleGanttDataOptions | Error,
): MockedResponse<ScheduleGanttQueryVariables, ScheduleGanttQuery> {
  return {
    request: { query: ScheduleGanttDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleGanttData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGanttScheduleTasksDataOptions {
  saveScheduleTasks?: FactoryInput<SaveScheduleTasksResult, SaveScheduleTasksResultOptions>;
}

export function newSaveGanttScheduleTasksData(data: SaveGanttScheduleTasksDataOptions): SaveGanttScheduleTasksMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTasks: maybeNew("SaveScheduleTasksResult", data["saveScheduleTasks"] || undefined, {}),
  } as any;
}

export function newSaveGanttScheduleTasksResponse(
  variables: SaveGanttScheduleTasksMutationVariables,
  data: SaveGanttScheduleTasksDataOptions | Error,
): MockedResponse<SaveGanttScheduleTasksMutationVariables, SaveGanttScheduleTasksMutation> {
  return {
    request: { query: SaveGanttScheduleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGanttScheduleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddScheduleTaskDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
}

export function newAddScheduleTaskData(data: AddScheduleTaskDataOptions): AddScheduleTaskQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
  } as any;
}

export function newAddScheduleTaskResponse(
  variables: AddScheduleTaskQueryVariables,
  data: AddScheduleTaskDataOptions | Error,
): MockedResponse<AddScheduleTaskQueryVariables, AddScheduleTaskQuery> {
  return {
    request: { query: AddScheduleTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddScheduleTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTaskPhasesDataOptions {
  schedule?: FactoryInput<Schedule, ScheduleOptions>;
}

export function newScheduleTaskPhasesData(data: ScheduleTaskPhasesDataOptions): ScheduleTaskPhasesQuery {
  return { __typename: "Query" as const, schedule: maybeNew("Schedule", data["schedule"] || undefined, {}) } as any;
}

export function newScheduleTaskPhasesResponse(
  variables: ScheduleTaskPhasesQueryVariables,
  data: ScheduleTaskPhasesDataOptions | Error,
): MockedResponse<ScheduleTaskPhasesQueryVariables, ScheduleTaskPhasesQuery> {
  return {
    request: { query: ScheduleTaskPhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTaskPhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteScheduleSubPhaseDataOptions {
  deleteScheduleSubPhases?: FactoryInput<DeleteScheduleSubPhasesResult, DeleteScheduleSubPhasesResultOptions>;
}

export function newDeleteScheduleSubPhaseData(data: DeleteScheduleSubPhaseDataOptions): DeleteScheduleSubPhaseMutation {
  return {
    __typename: "Mutation" as const,
    deleteScheduleSubPhases: maybeNew(
      "DeleteScheduleSubPhasesResult",
      data["deleteScheduleSubPhases"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteScheduleSubPhaseResponse(
  variables: DeleteScheduleSubPhaseMutationVariables,
  data: DeleteScheduleSubPhaseDataOptions | Error,
): MockedResponse<DeleteScheduleSubPhaseMutationVariables, DeleteScheduleSubPhaseMutation> {
  return {
    request: { query: DeleteScheduleSubPhaseDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteScheduleSubPhaseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteSchedulePhaseDataOptions {
  deleteSchedulePhases?: FactoryInput<DeleteSchedulePhasesResult, DeleteSchedulePhasesResultOptions>;
}

export function newDeleteSchedulePhaseData(data: DeleteSchedulePhaseDataOptions): DeleteSchedulePhaseMutation {
  return {
    __typename: "Mutation" as const,
    deleteSchedulePhases: maybeNew("DeleteSchedulePhasesResult", data["deleteSchedulePhases"] || undefined, {}),
  } as any;
}

export function newDeleteSchedulePhaseResponse(
  variables: DeleteSchedulePhaseMutationVariables,
  data: DeleteSchedulePhaseDataOptions | Error,
): MockedResponse<DeleteSchedulePhaseMutationVariables, DeleteSchedulePhaseMutation> {
  return {
    request: { query: DeleteSchedulePhaseDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteSchedulePhaseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetDateViaPredecessorModalDataOptions {
  scheduleTask?: FactoryInput<ScheduleTask, ScheduleTaskOptions>;
}

export function newSetDateViaPredecessorModalData(
  data: SetDateViaPredecessorModalDataOptions,
): SetDateViaPredecessorModalQuery {
  return {
    __typename: "Query" as const,
    scheduleTask: maybeNew("ScheduleTask", data["scheduleTask"] || undefined, {}),
  } as any;
}

export function newSetDateViaPredecessorModalResponse(
  variables: SetDateViaPredecessorModalQueryVariables,
  data: SetDateViaPredecessorModalDataOptions | Error,
): MockedResponse<SetDateViaPredecessorModalQueryVariables, SetDateViaPredecessorModalQuery> {
  return {
    request: { query: SetDateViaPredecessorModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetDateViaPredecessorModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCommitmentModalProjectItemDataOptions {
  projectItems?: FactoryInput<ProjectItem, ProjectItemOptions>[];
}

export function newCreateCommitmentModalProjectItemData(
  data: CreateCommitmentModalProjectItemDataOptions,
): CreateCommitmentModalProjectItemQuery {
  return {
    __typename: "Query" as const,
    projectItems: data["projectItems"]?.map((d) => maybeNew("ProjectItem", d, {})) || [],
  } as any;
}

export function newCreateCommitmentModalProjectItemResponse(
  variables: CreateCommitmentModalProjectItemQueryVariables,
  data: CreateCommitmentModalProjectItemDataOptions | Error,
): MockedResponse<CreateCommitmentModalProjectItemQueryVariables, CreateCommitmentModalProjectItemQuery> {
  return {
    request: { query: CreateCommitmentModalProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCommitmentModalProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItApi_SaveItemTemplateItemVersionsDataOptions {
  saveItemTemplateItemVersions?: FactoryInput<
    SaveItemTemplateItemVersionsResult,
    SaveItemTemplateItemVersionsResultOptions
  >;
}

export function newItApi_SaveItemTemplateItemVersionsData(
  data: ItApi_SaveItemTemplateItemVersionsDataOptions,
): ItApi_SaveItemTemplateItemVersionsMutation {
  return {
    __typename: "Mutation" as const,
    saveItemTemplateItemVersions: maybeNew(
      "SaveItemTemplateItemVersionsResult",
      data["saveItemTemplateItemVersions"] || undefined,
      {},
    ),
  } as any;
}

export function newItApi_SaveItemTemplateItemVersionsResponse(
  variables: ItApi_SaveItemTemplateItemVersionsMutationVariables,
  data: ItApi_SaveItemTemplateItemVersionsDataOptions | Error,
): MockedResponse<ItApi_SaveItemTemplateItemVersionsMutationVariables, ItApi_SaveItemTemplateItemVersionsMutation> {
  return {
    request: { query: ItApi_SaveItemTemplateItemVersionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItApi_SaveItemTemplateItemVersionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItApi_CopyItemTemplateItemsDataOptions {
  copyItemTemplateItems?: FactoryInput<CopyItemTemplateItemsResult, CopyItemTemplateItemsResultOptions>;
}

export function newItApi_CopyItemTemplateItemsData(
  data: ItApi_CopyItemTemplateItemsDataOptions,
): ItApi_CopyItemTemplateItemsMutation {
  return {
    __typename: "Mutation" as const,
    copyItemTemplateItems: maybeNew("CopyItemTemplateItemsResult", data["copyItemTemplateItems"] || undefined, {}),
  } as any;
}

export function newItApi_CopyItemTemplateItemsResponse(
  variables: ItApi_CopyItemTemplateItemsMutationVariables,
  data: ItApi_CopyItemTemplateItemsDataOptions | Error,
): MockedResponse<ItApi_CopyItemTemplateItemsMutationVariables, ItApi_CopyItemTemplateItemsMutation> {
  return {
    request: { query: ItApi_CopyItemTemplateItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItApi_CopyItemTemplateItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateAnomaliesContextDataOptions {
  itemTemplate?: FactoryInput<ItemTemplate, ItemTemplateOptions>;
}

export function newItemTemplateAnomaliesContextData(
  data: ItemTemplateAnomaliesContextDataOptions,
): ItemTemplateAnomaliesContextQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newItemTemplateAnomaliesContextResponse(
  variables: ItemTemplateAnomaliesContextQueryVariables,
  data: ItemTemplateAnomaliesContextDataOptions | Error,
): MockedResponse<ItemTemplateAnomaliesContextQueryVariables, ItemTemplateAnomaliesContextQuery> {
  return {
    request: { query: ItemTemplateAnomaliesContextDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateAnomaliesContextData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ManageProjectsBudgetsStepDataOptions {
  bidContractRevision?: FactoryInput<BidContractRevision, BidContractRevisionOptions>;
}

export function newManageProjectsBudgetsStepData(
  data: ManageProjectsBudgetsStepDataOptions,
): ManageProjectsBudgetsStepQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newManageProjectsBudgetsStepResponse(
  variables: ManageProjectsBudgetsStepQueryVariables,
  data: ManageProjectsBudgetsStepDataOptions | Error,
): MockedResponse<ManageProjectsBudgetsStepQueryVariables, ManageProjectsBudgetsStepQuery> {
  return {
    request: { query: ManageProjectsBudgetsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newManageProjectsBudgetsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AssignWorkToBidContractsDataOptions {
  assignWorkToBidContract?: FactoryInput<ChangeEvent, ChangeEventOptions>[];
}

export function newAssignWorkToBidContractsData(
  data: AssignWorkToBidContractsDataOptions,
): AssignWorkToBidContractsMutation {
  return {
    __typename: "Mutation" as const,
    assignWorkToBidContract: data["assignWorkToBidContract"]?.map((d) => maybeNew("ChangeEvent", d, {})) || [],
  } as any;
}

export function newAssignWorkToBidContractsResponse(
  variables: AssignWorkToBidContractsMutationVariables,
  data: AssignWorkToBidContractsDataOptions | Error,
): MockedResponse<AssignWorkToBidContractsMutationVariables, AssignWorkToBidContractsMutation> {
  return {
    request: { query: AssignWorkToBidContractsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAssignWorkToBidContractsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSummaryDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newLotSummaryData(data: LotSummaryDataOptions): LotSummaryQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newLotSummaryResponse(
  variables: LotSummaryQueryVariables,
  data: LotSummaryDataOptions | Error,
): MockedResponse<LotSummaryQueryVariables, LotSummaryQuery> {
  return {
    request: { query: LotSummaryDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSummaryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditOptionsHeaderDataOptions {
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
}

export function newEditOptionsHeaderData(data: EditOptionsHeaderDataOptions): EditOptionsHeaderQuery {
  return { __typename: "Query" as const, readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}) } as any;
}

export function newEditOptionsHeaderResponse(
  variables: EditOptionsHeaderQueryVariables,
  data: EditOptionsHeaderDataOptions | Error,
): MockedResponse<EditOptionsHeaderQueryVariables, EditOptionsHeaderQuery> {
  return {
    request: { query: EditOptionsHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditOptionsHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseOptionsStepBodyV1DataOptions {
  readyPlanLike2?: FactoryInput<ReadyPlanLike, ReadyPlanLikeOptions>;
  globalOptions?: FactoryInput<GlobalOption, GlobalOptionOptions>[];
}

export function newChooseOptionsStepBodyV1Data(data: ChooseOptionsStepBodyV1DataOptions): ChooseOptionsStepBodyV1Query {
  return {
    __typename: "Query" as const,
    readyPlanLike2: maybeNew("ReadyPlanLike", data["readyPlanLike2"] || undefined, {}),
    globalOptions: data["globalOptions"]?.map((d) => maybeNew("GlobalOption", d, {})) || [],
  } as any;
}

export function newChooseOptionsStepBodyV1Response(
  variables: ChooseOptionsStepBodyV1QueryVariables,
  data: ChooseOptionsStepBodyV1DataOptions | Error,
): MockedResponse<ChooseOptionsStepBodyV1QueryVariables, ChooseOptionsStepBodyV1Query> {
  return {
    request: { query: ChooseOptionsStepBodyV1Document, variables },
    result: { data: data instanceof Error ? undefined : newChooseOptionsStepBodyV1Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDataOptions {
  saveReadyPlanOptions?: FactoryInput<SaveReadyPlanOptionsResult, SaveReadyPlanOptionsResultOptions>;
}

export function newChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsData(
  data: ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDataOptions,
): ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptions: maybeNew("SaveReadyPlanOptionsResult", data["saveReadyPlanOptions"] || undefined, {}),
  } as any;
}

export function newChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsResponse(
  variables: ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationVariables,
  data: ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDataOptions | Error,
): MockedResponse<
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationVariables,
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation
> {
  return {
    request: { query: ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplatesApplyStepMetadataDataOptions {
  milestoneTasksForTemplates?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newScopeTemplatesApplyStepMetadataData(
  data: ScopeTemplatesApplyStepMetadataDataOptions,
): ScopeTemplatesApplyStepMetadataQuery {
  return {
    __typename: "Query" as const,
    milestoneTasksForTemplates: data["milestoneTasksForTemplates"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newScopeTemplatesApplyStepMetadataResponse(
  variables: ScopeTemplatesApplyStepMetadataQueryVariables,
  data: ScopeTemplatesApplyStepMetadataDataOptions | Error,
): MockedResponse<ScopeTemplatesApplyStepMetadataQueryVariables, ScopeTemplatesApplyStepMetadataQuery> {
  return {
    request: { query: ScopeTemplatesApplyStepMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplatesApplyStepMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplatesApplyStepDataOptions {
  projectsToUpdateByTemplates?: FactoryInput<
    ProjectsToUpdateByTemplatesResult,
    ProjectsToUpdateByTemplatesResultOptions
  >;
}

export function newScopeTemplatesApplyStepData(data: ScopeTemplatesApplyStepDataOptions): ScopeTemplatesApplyStepQuery {
  return {
    __typename: "Query" as const,
    projectsToUpdateByTemplates: maybeNew(
      "ProjectsToUpdateByTemplatesResult",
      data["projectsToUpdateByTemplates"] || undefined,
      {},
    ),
  } as any;
}

export function newScopeTemplatesApplyStepResponse(
  variables: ScopeTemplatesApplyStepQueryVariables,
  data: ScopeTemplatesApplyStepDataOptions | Error,
): MockedResponse<ScopeTemplatesApplyStepQueryVariables, ScopeTemplatesApplyStepQuery> {
  return {
    request: { query: ScopeTemplatesApplyStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplatesApplyStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplateApplyStepApplyToProjectDataOptions {
  applyProjectReadyPlanConfigs?: FactoryInput<
    ApplyProjectReadyPlanConfigsResult,
    ApplyProjectReadyPlanConfigsResultOptions
  >;
}

export function newScopeTemplateApplyStepApplyToProjectData(
  data: ScopeTemplateApplyStepApplyToProjectDataOptions,
): ScopeTemplateApplyStepApplyToProjectMutation {
  return {
    __typename: "Mutation" as const,
    applyProjectReadyPlanConfigs: maybeNew(
      "ApplyProjectReadyPlanConfigsResult",
      data["applyProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newScopeTemplateApplyStepApplyToProjectResponse(
  variables: ScopeTemplateApplyStepApplyToProjectMutationVariables,
  data: ScopeTemplateApplyStepApplyToProjectDataOptions | Error,
): MockedResponse<ScopeTemplateApplyStepApplyToProjectMutationVariables, ScopeTemplateApplyStepApplyToProjectMutation> {
  return {
    request: { query: ScopeTemplateApplyStepApplyToProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplateApplyStepApplyToProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingCardDataOptions {
  productOfferingConfig?: FactoryInput<ProductOfferingConfig, ProductOfferingConfigOptions>;
}

export function newProductOfferingCardData(data: ProductOfferingCardDataOptions): ProductOfferingCardQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfig: maybeNew("ProductOfferingConfig", data["productOfferingConfig"] || undefined, {}),
  } as any;
}

export function newProductOfferingCardResponse(
  variables: ProductOfferingCardQueryVariables,
  data: ProductOfferingCardDataOptions | Error,
): MockedResponse<ProductOfferingCardQueryVariables, ProductOfferingCardQuery> {
  return {
    request: { query: ProductOfferingCardDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingCardData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageAddProductMetadataDataOptions {
  materialBrands?: FactoryInput<MaterialBrand, MaterialBrandOptions>[];
}

export function newDesignPackageAddProductMetadataData(
  data: DesignPackageAddProductMetadataDataOptions,
): DesignPackageAddProductMetadataQuery {
  return {
    __typename: "Query" as const,
    materialBrands: data["materialBrands"]?.map((d) => maybeNew("MaterialBrand", d, {})) || [],
  } as any;
}

export function newDesignPackageAddProductMetadataResponse(
  data: DesignPackageAddProductMetadataDataOptions | Error,
): MockedResponse<DesignPackageAddProductMetadataQueryVariables, DesignPackageAddProductMetadataQuery> {
  return {
    request: { query: DesignPackageAddProductMetadataDocument },
    result: { data: data instanceof Error ? undefined : newDesignPackageAddProductMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProductTliPlaceholderDataOptions {
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
}

export function newAddProductTliPlaceholderData(
  data: AddProductTliPlaceholderDataOptions,
): AddProductTliPlaceholderQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newAddProductTliPlaceholderResponse(
  variables: AddProductTliPlaceholderQueryVariables,
  data: AddProductTliPlaceholderDataOptions | Error,
): MockedResponse<AddProductTliPlaceholderQueryVariables, AddProductTliPlaceholderQuery> {
  return {
    request: { query: AddProductTliPlaceholderDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProductTliPlaceholderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplatesReviewStepDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
  itemTemplateItemVersions?: FactoryInput<ItemTemplateItemVersion, ItemTemplateItemVersionOptions>[];
  scopeChangeReasons?: FactoryInput<ScopeChangeReason, ScopeChangeReasonOptions>[];
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newScopeTemplatesReviewStepData(
  data: ScopeTemplatesReviewStepDataOptions,
): ScopeTemplatesReviewStepQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
    itemTemplateItemVersions:
      data["itemTemplateItemVersions"]?.map((d) => maybeNew("ItemTemplateItemVersion", d, {})) || [],
    scopeChangeReasons: data["scopeChangeReasons"]?.map((d) => maybeNew("ScopeChangeReason", d, {})) || [],
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newScopeTemplatesReviewStepResponse(
  variables: ScopeTemplatesReviewStepQueryVariables,
  data: ScopeTemplatesReviewStepDataOptions | Error,
): MockedResponse<ScopeTemplatesReviewStepQueryVariables, ScopeTemplatesReviewStepQuery> {
  return {
    request: { query: ScopeTemplatesReviewStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplatesReviewStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplatesReviewStepTableDataOptions {
  itemTemplates?: FactoryInput<ItemTemplate, ItemTemplateOptions>[];
}

export function newScopeTemplatesReviewStepTableData(
  data: ScopeTemplatesReviewStepTableDataOptions,
): ScopeTemplatesReviewStepTableQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => maybeNew("ItemTemplate", d, {})) || [],
  } as any;
}

export function newScopeTemplatesReviewStepTableResponse(
  variables: ScopeTemplatesReviewStepTableQueryVariables,
  data: ScopeTemplatesReviewStepTableDataOptions | Error,
): MockedResponse<ScopeTemplatesReviewStepTableQueryVariables, ScopeTemplatesReviewStepTableQuery> {
  return {
    request: { query: ScopeTemplatesReviewStepTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplatesReviewStepTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplateItemsReviewStepTableDataOptions {
  itemTemplateItemVersionsPage?: FactoryInput<ItemTemplateItemVersionsPage, ItemTemplateItemVersionsPageOptions>;
}

export function newScopeTemplateItemsReviewStepTableData(
  data: ScopeTemplateItemsReviewStepTableDataOptions,
): ScopeTemplateItemsReviewStepTableQuery {
  return {
    __typename: "Query" as const,
    itemTemplateItemVersionsPage: maybeNew(
      "ItemTemplateItemVersionsPage",
      data["itemTemplateItemVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newScopeTemplateItemsReviewStepTableResponse(
  variables: ScopeTemplateItemsReviewStepTableQueryVariables,
  data: ScopeTemplateItemsReviewStepTableDataOptions | Error,
): MockedResponse<ScopeTemplateItemsReviewStepTableQueryVariables, ScopeTemplateItemsReviewStepTableQuery> {
  return {
    request: { query: ScopeTemplateItemsReviewStepTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplateItemsReviewStepTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScopeChangeReasonReviewStepDataOptions {
  saveItemTemplates?: FactoryInput<SaveItemTemplatesResult, SaveItemTemplatesResultOptions>;
  saveItemTemplateItemVersions?: FactoryInput<
    SaveItemTemplateItemVersionsResult,
    SaveItemTemplateItemVersionsResultOptions
  >;
}

export function newSaveScopeChangeReasonReviewStepData(
  data: SaveScopeChangeReasonReviewStepDataOptions,
): SaveScopeChangeReasonReviewStepMutation {
  return {
    __typename: "Mutation" as const,
    saveItemTemplates: maybeNew("SaveItemTemplatesResult", data["saveItemTemplates"] || undefined, {}),
    saveItemTemplateItemVersions: maybeNew(
      "SaveItemTemplateItemVersionsResult",
      data["saveItemTemplateItemVersions"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveScopeChangeReasonReviewStepResponse(
  variables: SaveScopeChangeReasonReviewStepMutationVariables,
  data: SaveScopeChangeReasonReviewStepDataOptions | Error,
): MockedResponse<SaveScopeChangeReasonReviewStepMutationVariables, SaveScopeChangeReasonReviewStepMutation> {
  return {
    request: { query: SaveScopeChangeReasonReviewStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScopeChangeReasonReviewStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActivateTemplateVersionsReviewStepDataOptions {
  activateItemTemplateVersions?: FactoryInput<
    ActivateItemTemplateVersionsResult,
    ActivateItemTemplateVersionsResultOptions
  >;
}

export function newActivateTemplateVersionsReviewStepData(
  data: ActivateTemplateVersionsReviewStepDataOptions,
): ActivateTemplateVersionsReviewStepMutation {
  return {
    __typename: "Mutation" as const,
    activateItemTemplateVersions: maybeNew(
      "ActivateItemTemplateVersionsResult",
      data["activateItemTemplateVersions"] || undefined,
      {},
    ),
  } as any;
}

export function newActivateTemplateVersionsReviewStepResponse(
  variables: ActivateTemplateVersionsReviewStepMutationVariables,
  data: ActivateTemplateVersionsReviewStepDataOptions | Error,
): MockedResponse<ActivateTemplateVersionsReviewStepMutationVariables, ActivateTemplateVersionsReviewStepMutation> {
  return {
    request: { query: ActivateTemplateVersionsReviewStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newActivateTemplateVersionsReviewStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddToOptionModal_PotentialOptionsDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newAddToOptionModal_PotentialOptionsData(
  data: AddToOptionModal_PotentialOptionsDataOptions,
): AddToOptionModal_PotentialOptionsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newAddToOptionModal_PotentialOptionsResponse(
  variables: AddToOptionModal_PotentialOptionsQueryVariables,
  data: AddToOptionModal_PotentialOptionsDataOptions | Error,
): MockedResponse<AddToOptionModal_PotentialOptionsQueryVariables, AddToOptionModal_PotentialOptionsQuery> {
  return {
    request: { query: AddToOptionModal_PotentialOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddToOptionModal_PotentialOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageDesignNotePaneDataOptions {
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
}

export function newDesignPackageDesignNotePaneData(
  data: DesignPackageDesignNotePaneDataOptions,
): DesignPackageDesignNotePaneQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newDesignPackageDesignNotePaneResponse(
  variables: DesignPackageDesignNotePaneQueryVariables,
  data: DesignPackageDesignNotePaneDataOptions | Error,
): MockedResponse<DesignPackageDesignNotePaneQueryVariables, DesignPackageDesignNotePaneQuery> {
  return {
    request: { query: DesignPackageDesignNotePaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageDesignNotePaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageDesignNotePane_MetadataDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newDesignPackageDesignNotePane_MetadataData(
  data: DesignPackageDesignNotePane_MetadataDataOptions,
): DesignPackageDesignNotePane_MetadataQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageDesignNotePane_MetadataResponse(
  variables: DesignPackageDesignNotePane_MetadataQueryVariables,
  data: DesignPackageDesignNotePane_MetadataDataOptions | Error,
): MockedResponse<DesignPackageDesignNotePane_MetadataQueryVariables, DesignPackageDesignNotePane_MetadataQuery> {
  return {
    request: { query: DesignPackageDesignNotePane_MetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageDesignNotePane_MetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanDesignNoteDataOptions {
  saveReadyPlanDesignNote?: FactoryInput<SaveReadyPlanDesignNoteResult, SaveReadyPlanDesignNoteResultOptions>;
}

export function newSaveReadyPlanDesignNoteData(
  data: SaveReadyPlanDesignNoteDataOptions,
): SaveReadyPlanDesignNoteMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanDesignNote: maybeNew(
      "SaveReadyPlanDesignNoteResult",
      data["saveReadyPlanDesignNote"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanDesignNoteResponse(
  variables: SaveReadyPlanDesignNoteMutationVariables,
  data: SaveReadyPlanDesignNoteDataOptions | Error,
): MockedResponse<SaveReadyPlanDesignNoteMutationVariables, SaveReadyPlanDesignNoteMutation> {
  return {
    request: { query: SaveReadyPlanDesignNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanDesignNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageItemSlotEditorDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newDesignPackageItemSlotEditorData(
  data: DesignPackageItemSlotEditorDataOptions,
): DesignPackageItemSlotEditorQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageItemSlotEditorResponse(
  variables: DesignPackageItemSlotEditorQueryVariables,
  data: DesignPackageItemSlotEditorDataOptions | Error,
): MockedResponse<DesignPackageItemSlotEditorQueryVariables, DesignPackageItemSlotEditorQuery> {
  return {
    request: { query: DesignPackageItemSlotEditorDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageItemSlotEditorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageItemSlotEditor_DeleteTliDataOptions {
  saveTakeoffLineItems?: FactoryInput<SaveTakeoffLineItemResult, SaveTakeoffLineItemResultOptions>;
}

export function newDesignPackageItemSlotEditor_DeleteTliData(
  data: DesignPackageItemSlotEditor_DeleteTliDataOptions,
): DesignPackageItemSlotEditor_DeleteTliMutation {
  return {
    __typename: "Mutation" as const,
    saveTakeoffLineItems: maybeNew("SaveTakeoffLineItemResult", data["saveTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newDesignPackageItemSlotEditor_DeleteTliResponse(
  variables: DesignPackageItemSlotEditor_DeleteTliMutationVariables,
  data: DesignPackageItemSlotEditor_DeleteTliDataOptions | Error,
): MockedResponse<
  DesignPackageItemSlotEditor_DeleteTliMutationVariables,
  DesignPackageItemSlotEditor_DeleteTliMutation
> {
  return {
    request: { query: DesignPackageItemSlotEditor_DeleteTliDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageItemSlotEditor_DeleteTliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackagePruneSlotsModal_DataDataOptions {
  takeoffLineItemsPage?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newDesignPackagePruneSlotsModal_DataData(
  data: DesignPackagePruneSlotsModal_DataDataOptions,
): DesignPackagePruneSlotsModal_DataQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newDesignPackagePruneSlotsModal_DataResponse(
  variables: DesignPackagePruneSlotsModal_DataQueryVariables,
  data: DesignPackagePruneSlotsModal_DataDataOptions | Error,
): MockedResponse<DesignPackagePruneSlotsModal_DataQueryVariables, DesignPackagePruneSlotsModal_DataQuery> {
  return {
    request: { query: DesignPackagePruneSlotsModal_DataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackagePruneSlotsModal_DataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackagePruneSlotsModal_SaveDraftDataOptions {
  saveTakeoffLineItems?: FactoryInput<SaveTakeoffLineItemResult, SaveTakeoffLineItemResultOptions>;
}

export function newDesignPackagePruneSlotsModal_SaveDraftData(
  data: DesignPackagePruneSlotsModal_SaveDraftDataOptions,
): DesignPackagePruneSlotsModal_SaveDraftMutation {
  return {
    __typename: "Mutation" as const,
    saveTakeoffLineItems: maybeNew("SaveTakeoffLineItemResult", data["saveTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newDesignPackagePruneSlotsModal_SaveDraftResponse(
  variables: DesignPackagePruneSlotsModal_SaveDraftMutationVariables,
  data: DesignPackagePruneSlotsModal_SaveDraftDataOptions | Error,
): MockedResponse<
  DesignPackagePruneSlotsModal_SaveDraftMutationVariables,
  DesignPackagePruneSlotsModal_SaveDraftMutation
> {
  return {
    request: { query: DesignPackagePruneSlotsModal_SaveDraftDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackagePruneSlotsModal_SaveDraftData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteAltenratesConfirmationModalDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newDeleteAltenratesConfirmationModalData(
  data: DeleteAltenratesConfirmationModalDataOptions,
): DeleteAltenratesConfirmationModalQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDeleteAltenratesConfirmationModalResponse(
  variables: DeleteAltenratesConfirmationModalQueryVariables,
  data: DeleteAltenratesConfirmationModalDataOptions | Error,
): MockedResponse<DeleteAltenratesConfirmationModalQueryVariables, DeleteAltenratesConfirmationModalQuery> {
  return {
    request: { query: DeleteAltenratesConfirmationModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteAltenratesConfirmationModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDpAlternateRplDataOptions {
  deleteDesignPackageAlternateLocation?: FactoryInput<
    SaveDesignPackageLocationPlanMappingsResult,
    SaveDesignPackageLocationPlanMappingsResultOptions
  >;
}

export function newDeleteDpAlternateRplData(data: DeleteDpAlternateRplDataOptions): DeleteDpAlternateRplMutation {
  return {
    __typename: "Mutation" as const,
    deleteDesignPackageAlternateLocation: maybeNew(
      "SaveDesignPackageLocationPlanMappingsResult",
      data["deleteDesignPackageAlternateLocation"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteDpAlternateRplResponse(
  variables: DeleteDpAlternateRplMutationVariables,
  data: DeleteDpAlternateRplDataOptions | Error,
): MockedResponse<DeleteDpAlternateRplMutationVariables, DeleteDpAlternateRplMutation> {
  return {
    request: { query: DeleteDpAlternateRplDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteDpAlternateRplData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyDesignPackageCardsDataOptions {
  copyDesignPackageCards?: FactoryInput<CopyDesignPackageCardsResult, CopyDesignPackageCardsResultOptions>;
}

export function newCopyDesignPackageCardsData(data: CopyDesignPackageCardsDataOptions): CopyDesignPackageCardsMutation {
  return {
    __typename: "Mutation" as const,
    copyDesignPackageCards: maybeNew("CopyDesignPackageCardsResult", data["copyDesignPackageCards"] || undefined, {}),
  } as any;
}

export function newCopyDesignPackageCardsResponse(
  variables: CopyDesignPackageCardsMutationVariables,
  data: CopyDesignPackageCardsDataOptions | Error,
): MockedResponse<CopyDesignPackageCardsMutationVariables, CopyDesignPackageCardsMutation> {
  return {
    request: { query: CopyDesignPackageCardsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyDesignPackageCardsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyDesignPackageCardsModalDataOptions {
  takeoffLineItemsPage?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newCopyDesignPackageCardsModalData(
  data: CopyDesignPackageCardsModalDataOptions,
): CopyDesignPackageCardsModalQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newCopyDesignPackageCardsModalResponse(
  variables: CopyDesignPackageCardsModalQueryVariables,
  data: CopyDesignPackageCardsModalDataOptions | Error,
): MockedResponse<CopyDesignPackageCardsModalQueryVariables, CopyDesignPackageCardsModalQuery> {
  return {
    request: { query: CopyDesignPackageCardsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyDesignPackageCardsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageRoomAlternatesDrawerDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newDesignPackageRoomAlternatesDrawerData(
  data: DesignPackageRoomAlternatesDrawerDataOptions,
): DesignPackageRoomAlternatesDrawerQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageRoomAlternatesDrawerResponse(
  variables: DesignPackageRoomAlternatesDrawerQueryVariables,
  data: DesignPackageRoomAlternatesDrawerDataOptions | Error,
): MockedResponse<DesignPackageRoomAlternatesDrawerQueryVariables, DesignPackageRoomAlternatesDrawerQuery> {
  return {
    request: { query: DesignPackageRoomAlternatesDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageRoomAlternatesDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDpRplAlternateLocationsDataOptions {
  saveDesignPackageLocationPlanMappings?: FactoryInput<
    SaveDesignPackageLocationPlanMappingsResult,
    SaveDesignPackageLocationPlanMappingsResultOptions
  >;
}

export function newSaveDpRplAlternateLocationsData(
  data: SaveDpRplAlternateLocationsDataOptions,
): SaveDpRplAlternateLocationsMutation {
  return {
    __typename: "Mutation" as const,
    saveDesignPackageLocationPlanMappings: maybeNew(
      "SaveDesignPackageLocationPlanMappingsResult",
      data["saveDesignPackageLocationPlanMappings"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveDpRplAlternateLocationsResponse(
  variables: SaveDpRplAlternateLocationsMutationVariables,
  data: SaveDpRplAlternateLocationsDataOptions | Error,
): MockedResponse<SaveDpRplAlternateLocationsMutationVariables, SaveDpRplAlternateLocationsMutation> {
  return {
    request: { query: SaveDpRplAlternateLocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDpRplAlternateLocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDesignPackageDataOptions {
  saveDesignPackage?: FactoryInput<SaveDesignPackageResult, SaveDesignPackageResultOptions>;
}

export function newSaveDesignPackageData(data: SaveDesignPackageDataOptions): SaveDesignPackageMutation {
  return {
    __typename: "Mutation" as const,
    saveDesignPackage: maybeNew("SaveDesignPackageResult", data["saveDesignPackage"] || undefined, {}),
  } as any;
}

export function newSaveDesignPackageResponse(
  variables: SaveDesignPackageMutationVariables,
  data: SaveDesignPackageDataOptions | Error,
): MockedResponse<SaveDesignPackageMutationVariables, SaveDesignPackageMutation> {
  return {
    request: { query: SaveDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageRequiredOptionsPageDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newDesignPackageRequiredOptionsPageData(
  data: DesignPackageRequiredOptionsPageDataOptions,
): DesignPackageRequiredOptionsPageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageRequiredOptionsPageResponse(
  variables: DesignPackageRequiredOptionsPageQueryVariables,
  data: DesignPackageRequiredOptionsPageDataOptions | Error,
): MockedResponse<DesignPackageRequiredOptionsPageQueryVariables, DesignPackageRequiredOptionsPageQuery> {
  return {
    request: { query: DesignPackageRequiredOptionsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageRequiredOptionsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageRequiredOptionsPage_AddOnsDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newDesignPackageRequiredOptionsPage_AddOnsData(
  data: DesignPackageRequiredOptionsPage_AddOnsDataOptions,
): DesignPackageRequiredOptionsPage_AddOnsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageRequiredOptionsPage_AddOnsResponse(
  variables: DesignPackageRequiredOptionsPage_AddOnsQueryVariables,
  data: DesignPackageRequiredOptionsPage_AddOnsDataOptions | Error,
): MockedResponse<DesignPackageRequiredOptionsPage_AddOnsQueryVariables, DesignPackageRequiredOptionsPage_AddOnsQuery> {
  return {
    request: { query: DesignPackageRequiredOptionsPage_AddOnsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageRequiredOptionsPage_AddOnsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageRequiredOptionsPage_CombinationsDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newDesignPackageRequiredOptionsPage_CombinationsData(
  data: DesignPackageRequiredOptionsPage_CombinationsDataOptions,
): DesignPackageRequiredOptionsPage_CombinationsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageRequiredOptionsPage_CombinationsResponse(
  variables: DesignPackageRequiredOptionsPage_CombinationsQueryVariables,
  data: DesignPackageRequiredOptionsPage_CombinationsDataOptions | Error,
): MockedResponse<
  DesignPackageRequiredOptionsPage_CombinationsQueryVariables,
  DesignPackageRequiredOptionsPage_CombinationsQuery
> {
  return {
    request: { query: DesignPackageRequiredOptionsPage_CombinationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageRequiredOptionsPage_CombinationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDesignPackageRequiredOptionsDataOptions {
  saveReadyPlanRequiredOptions?: FactoryInput<
    SaveReadyPlanRequiredOptionsResult,
    SaveReadyPlanRequiredOptionsResultOptions
  >;
}

export function newSaveDesignPackageRequiredOptionsData(
  data: SaveDesignPackageRequiredOptionsDataOptions,
): SaveDesignPackageRequiredOptionsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanRequiredOptions: maybeNew(
      "SaveReadyPlanRequiredOptionsResult",
      data["saveReadyPlanRequiredOptions"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveDesignPackageRequiredOptionsResponse(
  variables: SaveDesignPackageRequiredOptionsMutationVariables,
  data: SaveDesignPackageRequiredOptionsDataOptions | Error,
): MockedResponse<SaveDesignPackageRequiredOptionsMutationVariables, SaveDesignPackageRequiredOptionsMutation> {
  return {
    request: { query: SaveDesignPackageRequiredOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDesignPackageRequiredOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageSlotsDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newDesignPackageSlotsData(data: DesignPackageSlotsDataOptions): DesignPackageSlotsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageSlotsResponse(
  variables: DesignPackageSlotsQueryVariables,
  data: DesignPackageSlotsDataOptions | Error,
): MockedResponse<DesignPackageSlotsQueryVariables, DesignPackageSlotsQuery> {
  return {
    request: { query: DesignPackageSlotsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageSlotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateAlternateLocationDataOptions {
  createDesignPackageAlternateLocation?: FactoryInput<
    CreateDesignPackageAlternateLocationResult,
    CreateDesignPackageAlternateLocationResultOptions
  >;
}

export function newCreateAlternateLocationData(
  data: CreateAlternateLocationDataOptions,
): CreateAlternateLocationMutation {
  return {
    __typename: "Mutation" as const,
    createDesignPackageAlternateLocation: maybeNew(
      "CreateDesignPackageAlternateLocationResult",
      data["createDesignPackageAlternateLocation"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateAlternateLocationResponse(
  variables: CreateAlternateLocationMutationVariables,
  data: CreateAlternateLocationDataOptions | Error,
): MockedResponse<CreateAlternateLocationMutationVariables, CreateAlternateLocationMutation> {
  return {
    request: { query: CreateAlternateLocationDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateAlternateLocationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AcceptDesignUpdatesDataOptions {
  acceptDesignPackageUpdates?: FactoryInput<SaveDesignPackageUpdatesResult, SaveDesignPackageUpdatesResultOptions>;
}

export function newAcceptDesignUpdatesData(data: AcceptDesignUpdatesDataOptions): AcceptDesignUpdatesMutation {
  return {
    __typename: "Mutation" as const,
    acceptDesignPackageUpdates: maybeNew(
      "SaveDesignPackageUpdatesResult",
      data["acceptDesignPackageUpdates"] || undefined,
      {},
    ),
  } as any;
}

export function newAcceptDesignUpdatesResponse(
  variables: AcceptDesignUpdatesMutationVariables,
  data: AcceptDesignUpdatesDataOptions | Error,
): MockedResponse<AcceptDesignUpdatesMutationVariables, AcceptDesignUpdatesMutation> {
  return {
    request: { query: AcceptDesignUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAcceptDesignUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RequestPlanPackageSlotsModal_CreateIncomingSlotsDataOptions {
  createPlanPackageIncomingSlots?: FactoryInput<PlanPackageIncomingSlot, PlanPackageIncomingSlotOptions>[];
}

export function newRequestPlanPackageSlotsModal_CreateIncomingSlotsData(
  data: RequestPlanPackageSlotsModal_CreateIncomingSlotsDataOptions,
): RequestPlanPackageSlotsModal_CreateIncomingSlotsMutation {
  return {
    __typename: "Mutation" as const,
    createPlanPackageIncomingSlots:
      data["createPlanPackageIncomingSlots"]?.map((d) => maybeNew("PlanPackageIncomingSlot", d, {})) || [],
  } as any;
}

export function newRequestPlanPackageSlotsModal_CreateIncomingSlotsResponse(
  variables: RequestPlanPackageSlotsModal_CreateIncomingSlotsMutationVariables,
  data: RequestPlanPackageSlotsModal_CreateIncomingSlotsDataOptions | Error,
): MockedResponse<
  RequestPlanPackageSlotsModal_CreateIncomingSlotsMutationVariables,
  RequestPlanPackageSlotsModal_CreateIncomingSlotsMutation
> {
  return {
    request: { query: RequestPlanPackageSlotsModal_CreateIncomingSlotsDocument, variables },
    result: { data: data instanceof Error ? undefined : newRequestPlanPackageSlotsModal_CreateIncomingSlotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialAssemblyForm_AssemblyComponentsDataOptions {
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
}

export function newMaterialAssemblyForm_AssemblyComponentsData(
  data: MaterialAssemblyForm_AssemblyComponentsDataOptions,
): MaterialAssemblyForm_AssemblyComponentsQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
  } as any;
}

export function newMaterialAssemblyForm_AssemblyComponentsResponse(
  variables: MaterialAssemblyForm_AssemblyComponentsQueryVariables,
  data: MaterialAssemblyForm_AssemblyComponentsDataOptions | Error,
): MockedResponse<MaterialAssemblyForm_AssemblyComponentsQueryVariables, MaterialAssemblyForm_AssemblyComponentsQuery> {
  return {
    request: { query: MaterialAssemblyForm_AssemblyComponentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialAssemblyForm_AssemblyComponentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialAssemblyForm_MaterialVariantsDataOptions {
  materialVariants?: FactoryInput<MaterialVariantsPage, MaterialVariantsPageOptions>;
}

export function newMaterialAssemblyForm_MaterialVariantsData(
  data: MaterialAssemblyForm_MaterialVariantsDataOptions,
): MaterialAssemblyForm_MaterialVariantsQuery {
  return {
    __typename: "Query" as const,
    materialVariants: maybeNew("MaterialVariantsPage", data["materialVariants"] || undefined, {}),
  } as any;
}

export function newMaterialAssemblyForm_MaterialVariantsResponse(
  variables: MaterialAssemblyForm_MaterialVariantsQueryVariables,
  data: MaterialAssemblyForm_MaterialVariantsDataOptions | Error,
): MockedResponse<MaterialAssemblyForm_MaterialVariantsQueryVariables, MaterialAssemblyForm_MaterialVariantsQuery> {
  return {
    request: { query: MaterialAssemblyForm_MaterialVariantsDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialAssemblyForm_MaterialVariantsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialAssemblyForm_ItemsDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newMaterialAssemblyForm_ItemsData(
  data: MaterialAssemblyForm_ItemsDataOptions,
): MaterialAssemblyForm_ItemsQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [] } as any;
}

export function newMaterialAssemblyForm_ItemsResponse(
  data: MaterialAssemblyForm_ItemsDataOptions | Error,
): MockedResponse<MaterialAssemblyForm_ItemsQueryVariables, MaterialAssemblyForm_ItemsQuery> {
  return {
    request: { query: MaterialAssemblyForm_ItemsDocument },
    result: { data: data instanceof Error ? undefined : newMaterialAssemblyForm_ItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MergeHistoryModalDataOptions {
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
}

export function newMergeHistoryModalData(data: MergeHistoryModalDataOptions): MergeHistoryModalQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
  } as any;
}

export function newMergeHistoryModalResponse(
  variables: MergeHistoryModalQueryVariables,
  data: MergeHistoryModalDataOptions | Error,
): MockedResponse<MergeHistoryModalQueryVariables, MergeHistoryModalQuery> {
  return {
    request: { query: MergeHistoryModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newMergeHistoryModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemCostHistoryDataOptions {
  bidContractLineItemsPage?: FactoryInput<BidContractLineItemsPageResult, BidContractLineItemsPageResultOptions>;
}

export function newBidItemCostHistoryData(data: BidItemCostHistoryDataOptions): BidItemCostHistoryQuery {
  return {
    __typename: "Query" as const,
    bidContractLineItemsPage: maybeNew(
      "BidContractLineItemsPageResult",
      data["bidContractLineItemsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newBidItemCostHistoryResponse(
  variables: BidItemCostHistoryQueryVariables,
  data: BidItemCostHistoryDataOptions | Error,
): MockedResponse<BidItemCostHistoryQueryVariables, BidItemCostHistoryQuery> {
  return {
    request: { query: BidItemCostHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidItemCostHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TakeoffsUsageModalDataOptions {
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
}

export function newTakeoffsUsageModalData(data: TakeoffsUsageModalDataOptions): TakeoffsUsageModalQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
  } as any;
}

export function newTakeoffsUsageModalResponse(
  variables: TakeoffsUsageModalQueryVariables,
  data: TakeoffsUsageModalDataOptions | Error,
): MockedResponse<TakeoffsUsageModalQueryVariables, TakeoffsUsageModalQuery> {
  return {
    request: { query: TakeoffsUsageModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newTakeoffsUsageModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialListingHistoryDataOptions {
  materialListings?: FactoryInput<MaterialListingsPage, MaterialListingsPageOptions>;
}

export function newMaterialListingHistoryData(data: MaterialListingHistoryDataOptions): MaterialListingHistoryQuery {
  return {
    __typename: "Query" as const,
    materialListings: maybeNew("MaterialListingsPage", data["materialListings"] || undefined, {}),
  } as any;
}

export function newMaterialListingHistoryResponse(
  variables: MaterialListingHistoryQueryVariables,
  data: MaterialListingHistoryDataOptions | Error,
): MockedResponse<MaterialListingHistoryQueryVariables, MaterialListingHistoryQuery> {
  return {
    request: { query: MaterialListingHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialListingHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GenerateReadyPlanVersionNotesDataOptions {
  generateReadyPlanVersionNotes?: FactoryInput<
    GenerateReadyPlanVersionNotesResult,
    GenerateReadyPlanVersionNotesResultOptions
  >;
}

export function newGenerateReadyPlanVersionNotesData(
  data: GenerateReadyPlanVersionNotesDataOptions,
): GenerateReadyPlanVersionNotesQuery {
  return {
    __typename: "Query" as const,
    generateReadyPlanVersionNotes: maybeNew(
      "GenerateReadyPlanVersionNotesResult",
      data["generateReadyPlanVersionNotes"] || undefined,
      {},
    ),
  } as any;
}

export function newGenerateReadyPlanVersionNotesResponse(
  variables: GenerateReadyPlanVersionNotesQueryVariables,
  data: GenerateReadyPlanVersionNotesDataOptions | Error,
): MockedResponse<GenerateReadyPlanVersionNotesQueryVariables, GenerateReadyPlanVersionNotesQuery> {
  return {
    request: { query: GenerateReadyPlanVersionNotesDocument, variables },
    result: { data: data instanceof Error ? undefined : newGenerateReadyPlanVersionNotesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmDiscardDraftVersionModal_ConfirmActionDataOptions {
  deleteReadyPlanAggregateVersion?: FactoryInput<
    DeleteReadyPlanAggregateVersionResult,
    DeleteReadyPlanAggregateVersionResultOptions
  >;
}

export function newConfirmDiscardDraftVersionModal_ConfirmActionData(
  data: ConfirmDiscardDraftVersionModal_ConfirmActionDataOptions,
): ConfirmDiscardDraftVersionModal_ConfirmActionMutation {
  return {
    __typename: "Mutation" as const,
    deleteReadyPlanAggregateVersion: maybeNew(
      "DeleteReadyPlanAggregateVersionResult",
      data["deleteReadyPlanAggregateVersion"] || undefined,
      {},
    ),
  } as any;
}

export function newConfirmDiscardDraftVersionModal_ConfirmActionResponse(
  variables: ConfirmDiscardDraftVersionModal_ConfirmActionMutationVariables,
  data: ConfirmDiscardDraftVersionModal_ConfirmActionDataOptions | Error,
): MockedResponse<
  ConfirmDiscardDraftVersionModal_ConfirmActionMutationVariables,
  ConfirmDiscardDraftVersionModal_ConfirmActionMutation
> {
  return {
    request: { query: ConfirmDiscardDraftVersionModal_ConfirmActionDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmDiscardDraftVersionModal_ConfirmActionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PublishAggregateVersionModal_IncomingSlotsDataOptions {
  readyPlanAggregateVersion?: FactoryInput<ReadyPlanAggregateVersion, ReadyPlanAggregateVersionOptions>;
}

export function newPublishAggregateVersionModal_IncomingSlotsData(
  data: PublishAggregateVersionModal_IncomingSlotsDataOptions,
): PublishAggregateVersionModal_IncomingSlotsQuery {
  return {
    __typename: "Query" as const,
    readyPlanAggregateVersion: maybeNew(
      "ReadyPlanAggregateVersion",
      data["readyPlanAggregateVersion"] || undefined,
      {},
    ),
  } as any;
}

export function newPublishAggregateVersionModal_IncomingSlotsResponse(
  variables: PublishAggregateVersionModal_IncomingSlotsQueryVariables,
  data: PublishAggregateVersionModal_IncomingSlotsDataOptions | Error,
): MockedResponse<
  PublishAggregateVersionModal_IncomingSlotsQueryVariables,
  PublishAggregateVersionModal_IncomingSlotsQuery
> {
  return {
    request: { query: PublishAggregateVersionModal_IncomingSlotsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPublishAggregateVersionModal_IncomingSlotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanAggregateVersionDataOptions {
  saveReadyPlanAggregateVersion?: FactoryInput<
    SaveReadyPlanAggregateVersionResult,
    SaveReadyPlanAggregateVersionResultOptions
  >;
}

export function newSaveReadyPlanAggregateVersionData(
  data: SaveReadyPlanAggregateVersionDataOptions,
): SaveReadyPlanAggregateVersionMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanAggregateVersion: maybeNew(
      "SaveReadyPlanAggregateVersionResult",
      data["saveReadyPlanAggregateVersion"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanAggregateVersionResponse(
  variables: SaveReadyPlanAggregateVersionMutationVariables,
  data: SaveReadyPlanAggregateVersionDataOptions | Error,
): MockedResponse<SaveReadyPlanAggregateVersionMutationVariables, SaveReadyPlanAggregateVersionMutation> {
  return {
    request: { query: SaveReadyPlanAggregateVersionDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanAggregateVersionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageOverviewDataOptions {
  itemCount?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newPlanPackageOverviewData(data: PlanPackageOverviewDataOptions): PlanPackageOverviewQuery {
  return {
    __typename: "Query" as const,
    itemCount: maybeNew("TakeoffLineItemsPage", data["itemCount"] || undefined, {}),
  } as any;
}

export function newPlanPackageOverviewResponse(
  variables: PlanPackageOverviewQueryVariables,
  data: PlanPackageOverviewDataOptions | Error,
): MockedResponse<PlanPackageOverviewQueryVariables, PlanPackageOverviewQuery> {
  return {
    request: { query: PlanPackageOverviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageOverviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanSummaryAndOptionsDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanSummaryAndOptionsData(data: PlanSummaryAndOptionsDataOptions): PlanSummaryAndOptionsQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanSummaryAndOptionsResponse(
  variables: PlanSummaryAndOptionsQueryVariables,
  data: PlanSummaryAndOptionsDataOptions | Error,
): MockedResponse<PlanSummaryAndOptionsQueryVariables, PlanSummaryAndOptionsQuery> {
  return {
    request: { query: PlanSummaryAndOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanSummaryAndOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseOptionsStepBody_PlanPackageDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newChooseOptionsStepBody_PlanPackageData(
  data: ChooseOptionsStepBody_PlanPackageDataOptions,
): ChooseOptionsStepBody_PlanPackageQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newChooseOptionsStepBody_PlanPackageResponse(
  variables: ChooseOptionsStepBody_PlanPackageQueryVariables,
  data: ChooseOptionsStepBody_PlanPackageDataOptions | Error,
): MockedResponse<ChooseOptionsStepBody_PlanPackageQueryVariables, ChooseOptionsStepBody_PlanPackageQuery> {
  return {
    request: { query: ChooseOptionsStepBody_PlanPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newChooseOptionsStepBody_PlanPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseOptionsStepBody_GlobalOptionsDataOptions {
  globalOptions?: FactoryInput<GlobalOption, GlobalOptionOptions>[];
}

export function newChooseOptionsStepBody_GlobalOptionsData(
  data: ChooseOptionsStepBody_GlobalOptionsDataOptions,
): ChooseOptionsStepBody_GlobalOptionsQuery {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => maybeNew("GlobalOption", d, {})) || [],
  } as any;
}

export function newChooseOptionsStepBody_GlobalOptionsResponse(
  variables: ChooseOptionsStepBody_GlobalOptionsQueryVariables,
  data: ChooseOptionsStepBody_GlobalOptionsDataOptions | Error,
): MockedResponse<ChooseOptionsStepBody_GlobalOptionsQueryVariables, ChooseOptionsStepBody_GlobalOptionsQuery> {
  return {
    request: { query: ChooseOptionsStepBody_GlobalOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChooseOptionsStepBody_GlobalOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddItemsFromExistingPlanModalDataOptions {
  planPackages?: FactoryInput<PlanPackagesPageResult, PlanPackagesPageResultOptions>;
}

export function newAddItemsFromExistingPlanModalData(
  data: AddItemsFromExistingPlanModalDataOptions,
): AddItemsFromExistingPlanModalQuery {
  return {
    __typename: "Query" as const,
    planPackages: maybeNew("PlanPackagesPageResult", data["planPackages"] || undefined, {}),
  } as any;
}

export function newAddItemsFromExistingPlanModalResponse(
  variables: AddItemsFromExistingPlanModalQueryVariables,
  data: AddItemsFromExistingPlanModalDataOptions | Error,
): MockedResponse<AddItemsFromExistingPlanModalQueryVariables, AddItemsFromExistingPlanModalQuery> {
  return {
    request: { query: AddItemsFromExistingPlanModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddItemsFromExistingPlanModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkEditModal_GetTlisDataOptions {
  takeoffLineItemsPage?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newBulkEditModal_GetTlisData(data: BulkEditModal_GetTlisDataOptions): BulkEditModal_GetTlisQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newBulkEditModal_GetTlisResponse(
  variables: BulkEditModal_GetTlisQueryVariables,
  data: BulkEditModal_GetTlisDataOptions | Error,
): MockedResponse<BulkEditModal_GetTlisQueryVariables, BulkEditModal_GetTlisQuery> {
  return {
    request: { query: BulkEditModal_GetTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkEditModal_GetTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageEditorHeaderDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackageEditorHeaderData(data: PlanPackageEditorHeaderDataOptions): PlanPackageEditorHeaderQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageEditorHeaderResponse(
  variables: PlanPackageEditorHeaderQueryVariables,
  data: PlanPackageEditorHeaderDataOptions | Error,
): MockedResponse<PlanPackageEditorHeaderQueryVariables, PlanPackageEditorHeaderQuery> {
  return {
    request: { query: PlanPackageEditorHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageEditorHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TakeoffUploader_ValidateTlisDataOptions {
  takeoffLineItemsPage?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newTakeoffUploader_ValidateTlisData(
  data: TakeoffUploader_ValidateTlisDataOptions,
): TakeoffUploader_ValidateTlisQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newTakeoffUploader_ValidateTlisResponse(
  variables: TakeoffUploader_ValidateTlisQueryVariables,
  data: TakeoffUploader_ValidateTlisDataOptions | Error,
): MockedResponse<TakeoffUploader_ValidateTlisQueryVariables, TakeoffUploader_ValidateTlisQuery> {
  return {
    request: { query: TakeoffUploader_ValidateTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newTakeoffUploader_ValidateTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DuplicateItemsConfirmationModal_GetTlisDataOptions {
  takeoffLineItemsPage?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newDuplicateItemsConfirmationModal_GetTlisData(
  data: DuplicateItemsConfirmationModal_GetTlisDataOptions,
): DuplicateItemsConfirmationModal_GetTlisQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newDuplicateItemsConfirmationModal_GetTlisResponse(
  variables: DuplicateItemsConfirmationModal_GetTlisQueryVariables,
  data: DuplicateItemsConfirmationModal_GetTlisDataOptions | Error,
): MockedResponse<DuplicateItemsConfirmationModal_GetTlisQueryVariables, DuplicateItemsConfirmationModal_GetTlisQuery> {
  return {
    request: { query: DuplicateItemsConfirmationModal_GetTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newDuplicateItemsConfirmationModal_GetTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreatePlanPackageAiProposalDataOptions {
  createPlanPackageAiProposal?: FactoryInput<PlanPackageAiProposal, PlanPackageAiProposalOptions>;
}

export function newCreatePlanPackageAiProposalData(
  data: CreatePlanPackageAiProposalDataOptions,
): CreatePlanPackageAiProposalMutation {
  return {
    __typename: "Mutation" as const,
    createPlanPackageAiProposal: maybeNew(
      "PlanPackageAiProposal",
      data["createPlanPackageAiProposal"] || undefined,
      {},
    ),
  } as any;
}

export function newCreatePlanPackageAiProposalResponse(
  variables: CreatePlanPackageAiProposalMutationVariables,
  data: CreatePlanPackageAiProposalDataOptions | Error,
): MockedResponse<CreatePlanPackageAiProposalMutationVariables, CreatePlanPackageAiProposalMutation> {
  return {
    request: { query: CreatePlanPackageAiProposalDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreatePlanPackageAiProposalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageAiProposalStatusDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackageAiProposalStatusData(
  data: PlanPackageAiProposalStatusDataOptions,
): PlanPackageAiProposalStatusQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageAiProposalStatusResponse(
  variables: PlanPackageAiProposalStatusQueryVariables,
  data: PlanPackageAiProposalStatusDataOptions | Error,
): MockedResponse<PlanPackageAiProposalStatusQueryVariables, PlanPackageAiProposalStatusQuery> {
  return {
    request: { query: PlanPackageAiProposalStatusDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageAiProposalStatusData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddOptionsModalV2DataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newAddOptionsModalV2Data(data: AddOptionsModalV2DataOptions): AddOptionsModalV2Query {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newAddOptionsModalV2Response(
  variables: AddOptionsModalV2QueryVariables,
  data: AddOptionsModalV2DataOptions | Error,
): MockedResponse<AddOptionsModalV2QueryVariables, AddOptionsModalV2Query> {
  return {
    request: { query: AddOptionsModalV2Document, variables },
    result: { data: data instanceof Error ? undefined : newAddOptionsModalV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddOptionsModalV2_GlobalOptionsDataOptions {
  globalOptions?: FactoryInput<GlobalOption, GlobalOptionOptions>[];
}

export function newAddOptionsModalV2_GlobalOptionsData(
  data: AddOptionsModalV2_GlobalOptionsDataOptions,
): AddOptionsModalV2_GlobalOptionsQuery {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => maybeNew("GlobalOption", d, {})) || [],
  } as any;
}

export function newAddOptionsModalV2_GlobalOptionsResponse(
  variables: AddOptionsModalV2_GlobalOptionsQueryVariables,
  data: AddOptionsModalV2_GlobalOptionsDataOptions | Error,
): MockedResponse<AddOptionsModalV2_GlobalOptionsQueryVariables, AddOptionsModalV2_GlobalOptionsQuery> {
  return {
    request: { query: AddOptionsModalV2_GlobalOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddOptionsModalV2_GlobalOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageStepDataOptions {
  planPackages?: FactoryInput<PlanPackagesPageResult, PlanPackagesPageResultOptions>;
}

export function newPlanPackageStepData(data: PlanPackageStepDataOptions): PlanPackageStepQuery {
  return {
    __typename: "Query" as const,
    planPackages: maybeNew("PlanPackagesPageResult", data["planPackages"] || undefined, {}),
  } as any;
}

export function newPlanPackageStepResponse(
  data: PlanPackageStepDataOptions | Error,
): MockedResponse<PlanPackageStepQueryVariables, PlanPackageStepQuery> {
  return {
    request: { query: PlanPackageStepDocument },
    result: { data: data instanceof Error ? undefined : newPlanPackageStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OfferingDetailsStep_DevelopmentsDataOptions {
  developments?: FactoryInput<Development, DevelopmentOptions>[];
}

export function newOfferingDetailsStep_DevelopmentsData(
  data: OfferingDetailsStep_DevelopmentsDataOptions,
): OfferingDetailsStep_DevelopmentsQuery {
  return {
    __typename: "Query" as const,
    developments: data["developments"]?.map((d) => maybeNew("Development", d, {})) || [],
  } as any;
}

export function newOfferingDetailsStep_DevelopmentsResponse(
  data: OfferingDetailsStep_DevelopmentsDataOptions | Error,
): MockedResponse<OfferingDetailsStep_DevelopmentsQueryVariables, OfferingDetailsStep_DevelopmentsQuery> {
  return {
    request: { query: OfferingDetailsStep_DevelopmentsDocument },
    result: { data: data instanceof Error ? undefined : newOfferingDetailsStep_DevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OfferingDetailsStep_CommunitiesDataOptions {
  projects?: FactoryInput<Project, ProjectOptions>[];
}

export function newOfferingDetailsStep_CommunitiesData(
  data: OfferingDetailsStep_CommunitiesDataOptions,
): OfferingDetailsStep_CommunitiesQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newOfferingDetailsStep_CommunitiesResponse(
  data: OfferingDetailsStep_CommunitiesDataOptions | Error,
): MockedResponse<OfferingDetailsStep_CommunitiesQueryVariables, OfferingDetailsStep_CommunitiesQuery> {
  return {
    request: { query: OfferingDetailsStep_CommunitiesDocument },
    result: { data: data instanceof Error ? undefined : newOfferingDetailsStep_CommunitiesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackagesStepDataOptions {
  designPackages?: FactoryInput<DesignPackagesPageResult, DesignPackagesPageResultOptions>;
}

export function newDesignPackagesStepData(data: DesignPackagesStepDataOptions): DesignPackagesStepQuery {
  return {
    __typename: "Query" as const,
    designPackages: maybeNew("DesignPackagesPageResult", data["designPackages"] || undefined, {}),
  } as any;
}

export function newDesignPackagesStepResponse(
  data: DesignPackagesStepDataOptions | Error,
): MockedResponse<DesignPackagesStepQueryVariables, DesignPackagesStepQuery> {
  return {
    request: { query: DesignPackagesStepDocument },
    result: { data: data instanceof Error ? undefined : newDesignPackagesStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OptionsStepDataOptions {
  potentialOptions?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>[];
}

export function newOptionsStepData(data: OptionsStepDataOptions): OptionsStepQuery {
  return {
    __typename: "Query" as const,
    potentialOptions: data["potentialOptions"]?.map((d) => maybeNew("ReadyPlanOption", d, {})) || [],
  } as any;
}

export function newOptionsStepResponse(
  variables: OptionsStepQueryVariables,
  data: OptionsStepDataOptions | Error,
): MockedResponse<OptionsStepQueryVariables, OptionsStepQuery> {
  return {
    request: { query: OptionsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newOptionsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BudgetOverviewTabDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newBudgetOverviewTabData(data: BudgetOverviewTabDataOptions): BudgetOverviewTabQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newBudgetOverviewTabResponse(
  variables: BudgetOverviewTabQueryVariables,
  data: BudgetOverviewTabDataOptions | Error,
): MockedResponse<BudgetOverviewTabQueryVariables, BudgetOverviewTabQuery> {
  return {
    request: { query: BudgetOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newBudgetOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommittedAtStartTabDataOptions {
  projectCostCodes?: FactoryInput<ProjectCostCodesPageResult, ProjectCostCodesPageResultOptions>;
}

export function newCommittedAtStartTabData(data: CommittedAtStartTabDataOptions): CommittedAtStartTabQuery {
  return {
    __typename: "Query" as const,
    projectCostCodes: maybeNew("ProjectCostCodesPageResult", data["projectCostCodes"] || undefined, {}),
  } as any;
}

export function newCommittedAtStartTabResponse(
  variables: CommittedAtStartTabQueryVariables,
  data: CommittedAtStartTabDataOptions | Error,
): MockedResponse<CommittedAtStartTabQueryVariables, CommittedAtStartTabQuery> {
  return {
    request: { query: CommittedAtStartTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommittedAtStartTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommittedAtStartTab_CommitmentsByProjectCostCodeDataOptions {
  commitments?: FactoryInput<Commitment, CommitmentOptions>[];
}

export function newCommittedAtStartTab_CommitmentsByProjectCostCodeData(
  data: CommittedAtStartTab_CommitmentsByProjectCostCodeDataOptions,
): CommittedAtStartTab_CommitmentsByProjectCostCodeQuery {
  return {
    __typename: "Query" as const,
    commitments: data["commitments"]?.map((d) => maybeNew("Commitment", d, {})) || [],
  } as any;
}

export function newCommittedAtStartTab_CommitmentsByProjectCostCodeResponse(
  variables: CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables,
  data: CommittedAtStartTab_CommitmentsByProjectCostCodeDataOptions | Error,
): MockedResponse<
  CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables,
  CommittedAtStartTab_CommitmentsByProjectCostCodeQuery
> {
  return {
    request: { query: CommittedAtStartTab_CommitmentsByProjectCostCodeDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommittedAtStartTab_CommitmentsByProjectCostCodeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewStepDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
  exteriorDesignPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  interiorDesignPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
  readyPlanOptions?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>[];
}

export function newReviewStepData(data: ReviewStepDataOptions): ReviewStepQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    exteriorDesignPackage: maybeNew("DesignPackage", data["exteriorDesignPackage"] || undefined, {}),
    interiorDesignPackage: maybeNew("DesignPackage", data["interiorDesignPackage"] || undefined, {}),
    readyPlanOptions: data["readyPlanOptions"]?.map((d) => maybeNew("ReadyPlanOption", d, {})) || [],
  } as any;
}

export function newReviewStepResponse(
  variables: ReviewStepQueryVariables,
  data: ReviewStepDataOptions | Error,
): MockedResponse<ReviewStepQueryVariables, ReviewStepQuery> {
  return {
    request: { query: ReviewStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewStep_SaveProductOfferingDataOptions {
  saveProductOffering?: FactoryInput<SaveProductOfferingResult, SaveProductOfferingResultOptions>;
}

export function newReviewStep_SaveProductOfferingData(
  data: ReviewStep_SaveProductOfferingDataOptions,
): ReviewStep_SaveProductOfferingMutation {
  return {
    __typename: "Mutation" as const,
    saveProductOffering: maybeNew("SaveProductOfferingResult", data["saveProductOffering"] || undefined, {}),
  } as any;
}

export function newReviewStep_SaveProductOfferingResponse(
  variables: ReviewStep_SaveProductOfferingMutationVariables,
  data: ReviewStep_SaveProductOfferingDataOptions | Error,
): MockedResponse<ReviewStep_SaveProductOfferingMutationVariables, ReviewStep_SaveProductOfferingMutation> {
  return {
    request: { query: ReviewStep_SaveProductOfferingDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewStep_SaveProductOfferingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface VarianceTabDataOptions {
  projectChangeEventGraphs?: FactoryInput<ProjectChangeEventGraphsResult, ProjectChangeEventGraphsResultOptions>;
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newVarianceTabData(data: VarianceTabDataOptions): VarianceTabQuery {
  return {
    __typename: "Query" as const,
    projectChangeEventGraphs: maybeNew(
      "ProjectChangeEventGraphsResult",
      data["projectChangeEventGraphs"] || undefined,
      {},
    ),
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newVarianceTabResponse(
  variables: VarianceTabQueryVariables,
  data: VarianceTabDataOptions | Error,
): MockedResponse<VarianceTabQueryVariables, VarianceTabQuery> {
  return {
    request: { query: VarianceTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newVarianceTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DirectMarginTabDataOptions {
  projectDirectMarginGraph?: FactoryInput<ProjectDirectMarginGraph, ProjectDirectMarginGraphOptions>;
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newDirectMarginTabData(data: DirectMarginTabDataOptions): DirectMarginTabQuery {
  return {
    __typename: "Query" as const,
    projectDirectMarginGraph: maybeNew("ProjectDirectMarginGraph", data["projectDirectMarginGraph"] || undefined, {}),
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newDirectMarginTabResponse(
  variables: DirectMarginTabQueryVariables,
  data: DirectMarginTabDataOptions | Error,
): MockedResponse<DirectMarginTabQueryVariables, DirectMarginTabQuery> {
  return {
    request: { query: DirectMarginTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDirectMarginTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserProjectDocumentsDataOptions {
  userProjectDocuments?: FactoryInput<Document, DocumentOptions>[];
}

export function newUserProjectDocumentsData(data: UserProjectDocumentsDataOptions): UserProjectDocumentsQuery {
  return {
    __typename: "Query" as const,
    userProjectDocuments: data["userProjectDocuments"]?.map((d) => maybeNew("Document", d, {})) || [],
  } as any;
}

export function newUserProjectDocumentsResponse(
  variables: UserProjectDocumentsQueryVariables,
  data: UserProjectDocumentsDataOptions | Error,
): MockedResponse<UserProjectDocumentsQueryVariables, UserProjectDocumentsQuery> {
  return {
    request: { query: UserProjectDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserProjectDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsTileDataOptions {
  jobLogs?: FactoryInput<JobLog, JobLogOptions>[];
}

export function newJobLogsTileData(data: JobLogsTileDataOptions): JobLogsTileQuery {
  return { __typename: "Query" as const, jobLogs: data["jobLogs"]?.map((d) => maybeNew("JobLog", d, {})) || [] } as any;
}

export function newJobLogsTileResponse(
  variables: JobLogsTileQueryVariables,
  data: JobLogsTileDataOptions | Error,
): MockedResponse<JobLogsTileQueryVariables, JobLogsTileQuery> {
  return {
    request: { query: JobLogsTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectDashboardFinancialsDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newProjectDashboardFinancialsData(
  data: ProjectDashboardFinancialsDataOptions,
): ProjectDashboardFinancialsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectDashboardFinancialsResponse(
  variables: ProjectDashboardFinancialsQueryVariables,
  data: ProjectDashboardFinancialsDataOptions | Error,
): MockedResponse<ProjectDashboardFinancialsQueryVariables, ProjectDashboardFinancialsQuery> {
  return {
    request: { query: ProjectDashboardFinancialsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectDashboardFinancialsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerNotesTileDataOptions {
  homeownerNotes?: FactoryInput<HomeownerNote, HomeownerNoteOptions>[];
}

export function newHomeownerNotesTileData(data: HomeownerNotesTileDataOptions): HomeownerNotesTileQuery {
  return {
    __typename: "Query" as const,
    homeownerNotes: data["homeownerNotes"]?.map((d) => maybeNew("HomeownerNote", d, {})) || [],
  } as any;
}

export function newHomeownerNotesTileResponse(
  variables: HomeownerNotesTileQueryVariables,
  data: HomeownerNotesTileDataOptions | Error,
): MockedResponse<HomeownerNotesTileQueryVariables, HomeownerNotesTileQuery> {
  return {
    request: { query: HomeownerNotesTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerNotesTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PhotosTileDataOptions {
  jobLogImages?: FactoryInput<JobLogImage, JobLogImageOptions>[];
}

export function newPhotosTileData(data: PhotosTileDataOptions): PhotosTileQuery {
  return {
    __typename: "Query" as const,
    jobLogImages: data["jobLogImages"]?.map((d) => maybeNew("JobLogImage", d, {})) || [],
  } as any;
}

export function newPhotosTileResponse(
  variables: PhotosTileQueryVariables,
  data: PhotosTileDataOptions | Error,
): MockedResponse<PhotosTileQueryVariables, PhotosTileQuery> {
  return {
    request: { query: PhotosTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newPhotosTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectInfoTileDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  systemTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
  completedMilestoneTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newProjectInfoTileData(data: ProjectInfoTileDataOptions): ProjectInfoTileQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    systemTasks: data["systemTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
    completedMilestoneTasks: data["completedMilestoneTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newProjectInfoTileResponse(
  variables: ProjectInfoTileQueryVariables,
  data: ProjectInfoTileDataOptions | Error,
): MockedResponse<ProjectInfoTileQueryVariables, ProjectInfoTileQuery> {
  return {
    request: { query: ProjectInfoTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectInfoTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RecentActivityRailDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newRecentActivityRailData(data: RecentActivityRailDataOptions): RecentActivityRailQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newRecentActivityRailResponse(
  variables: RecentActivityRailQueryVariables,
  data: RecentActivityRailDataOptions | Error,
): MockedResponse<RecentActivityRailQueryVariables, RecentActivityRailQuery> {
  return {
    request: { query: RecentActivityRailDocument, variables },
    result: { data: data instanceof Error ? undefined : newRecentActivityRailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectScheduleTileDataOptions {
  schedules?: FactoryInput<Schedule, ScheduleOptions>[];
  scheduleTasks?: FactoryInput<ScheduleTask, ScheduleTaskOptions>[];
}

export function newProjectScheduleTileData(data: ProjectScheduleTileDataOptions): ProjectScheduleTileQuery {
  return {
    __typename: "Query" as const,
    schedules: data["schedules"]?.map((d) => maybeNew("Schedule", d, {})) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => maybeNew("ScheduleTask", d, {})) || [],
  } as any;
}

export function newProjectScheduleTileResponse(
  variables: ProjectScheduleTileQueryVariables,
  data: ProjectScheduleTileDataOptions | Error,
): MockedResponse<ProjectScheduleTileQueryVariables, ProjectScheduleTileQuery> {
  return {
    request: { query: ProjectScheduleTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectScheduleTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectToDosTileDataOptions {
  toDos?: FactoryInput<ToDo, ToDoOptions>[];
}

export function newProjectToDosTileData(data: ProjectToDosTileDataOptions): ProjectToDosTileQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => maybeNew("ToDo", d, {})) || [] } as any;
}

export function newProjectToDosTileResponse(
  variables: ProjectToDosTileQueryVariables,
  data: ProjectToDosTileDataOptions | Error,
): MockedResponse<ProjectToDosTileQueryVariables, ProjectToDosTileQuery> {
  return {
    request: { query: ProjectToDosTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectToDosTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TeamMembersTileInternalUsersDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newTeamMembersTileInternalUsersData(
  data: TeamMembersTileInternalUsersDataOptions,
): TeamMembersTileInternalUsersQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newTeamMembersTileInternalUsersResponse(
  variables: TeamMembersTileInternalUsersQueryVariables,
  data: TeamMembersTileInternalUsersDataOptions | Error,
): MockedResponse<TeamMembersTileInternalUsersQueryVariables, TeamMembersTileInternalUsersQuery> {
  return {
    request: { query: TeamMembersTileInternalUsersDocument, variables },
    result: { data: data instanceof Error ? undefined : newTeamMembersTileInternalUsersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TeamMembersTileTradePartnersDataOptions {
  tradePartners?: FactoryInput<TradePartner, TradePartnerOptions>[];
}

export function newTeamMembersTileTradePartnersData(
  data: TeamMembersTileTradePartnersDataOptions,
): TeamMembersTileTradePartnersQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => maybeNew("TradePartner", d, {})) || [],
  } as any;
}

export function newTeamMembersTileTradePartnersResponse(
  variables: TeamMembersTileTradePartnersQueryVariables,
  data: TeamMembersTileTradePartnersDataOptions | Error,
): MockedResponse<TeamMembersTileTradePartnersQueryVariables, TeamMembersTileTradePartnersQuery> {
  return {
    request: { query: TeamMembersTileTradePartnersDocument, variables },
    result: { data: data instanceof Error ? undefined : newTeamMembersTileTradePartnersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanTaskBillModal_ProtoBillsDataOptions {
  planTask?: FactoryInput<PlanTask, PlanTaskOptions>;
}

export function newPlanTaskBillModal_ProtoBillsData(
  data: PlanTaskBillModal_ProtoBillsDataOptions,
): PlanTaskBillModal_ProtoBillsQuery {
  return { __typename: "Query" as const, planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}) } as any;
}

export function newPlanTaskBillModal_ProtoBillsResponse(
  variables: PlanTaskBillModal_ProtoBillsQueryVariables,
  data: PlanTaskBillModal_ProtoBillsDataOptions | Error,
): MockedResponse<PlanTaskBillModal_ProtoBillsQueryVariables, PlanTaskBillModal_ProtoBillsQuery> {
  return {
    request: { query: PlanTaskBillModal_ProtoBillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanTaskBillModal_ProtoBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmDrawProjectStageDataOptions {
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
}

export function newConfirmDrawProjectStageData(data: ConfirmDrawProjectStageDataOptions): ConfirmDrawProjectStageQuery {
  return {
    __typename: "Query" as const,
    projectStage: maybeNew("ProjectStage", data["projectStage"] || undefined, {}),
  } as any;
}

export function newConfirmDrawProjectStageResponse(
  variables: ConfirmDrawProjectStageQueryVariables,
  data: ConfirmDrawProjectStageDataOptions | Error,
): MockedResponse<ConfirmDrawProjectStageQueryVariables, ConfirmDrawProjectStageQuery> {
  return {
    request: { query: ConfirmDrawProjectStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmDrawProjectStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmLineItemsDataDataOptions {
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
}

export function newConfirmLineItemsDataData(data: ConfirmLineItemsDataDataOptions): ConfirmLineItemsDataQuery {
  return {
    __typename: "Query" as const,
    projectStage: maybeNew("ProjectStage", data["projectStage"] || undefined, {}),
  } as any;
}

export function newConfirmLineItemsDataResponse(
  variables: ConfirmLineItemsDataQueryVariables,
  data: ConfirmLineItemsDataDataOptions | Error,
): MockedResponse<ConfirmLineItemsDataQueryVariables, ConfirmLineItemsDataQuery> {
  return {
    request: { query: ConfirmLineItemsDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmLineItemsDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectFixedItemsDataDataOptions {
  projectStage?: FactoryInput<ProjectStage, ProjectStageOptions>;
}

export function newSelectFixedItemsDataData(data: SelectFixedItemsDataDataOptions): SelectFixedItemsDataQuery {
  return {
    __typename: "Query" as const,
    projectStage: maybeNew("ProjectStage", data["projectStage"] || undefined, {}),
  } as any;
}

export function newSelectFixedItemsDataResponse(
  variables: SelectFixedItemsDataQueryVariables,
  data: SelectFixedItemsDataDataOptions | Error,
): MockedResponse<SelectFixedItemsDataQueryVariables, SelectFixedItemsDataQuery> {
  return {
    request: { query: SelectFixedItemsDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectFixedItemsDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleFlagReasonsDataOptions {
  scheduleFlagReasons?: FactoryInput<ScheduleFlagReason, ScheduleFlagReasonOptions>[];
}

export function newScheduleFlagReasonsData(data: ScheduleFlagReasonsDataOptions): ScheduleFlagReasonsQuery {
  return {
    __typename: "Query" as const,
    scheduleFlagReasons: data["scheduleFlagReasons"]?.map((d) => maybeNew("ScheduleFlagReason", d, {})) || [],
  } as any;
}

export function newScheduleFlagReasonsResponse(
  data: ScheduleFlagReasonsDataOptions | Error,
): MockedResponse<ScheduleFlagReasonsQueryVariables, ScheduleFlagReasonsQuery> {
  return {
    request: { query: ScheduleFlagReasonsDocument },
    result: { data: data instanceof Error ? undefined : newScheduleFlagReasonsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleFlagDataOptions {
  saveScheduleFlag?: FactoryInput<SaveScheduleFlagResult, SaveScheduleFlagResultOptions>;
}

export function newSaveScheduleFlagData(data: SaveScheduleFlagDataOptions): SaveScheduleFlagMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleFlag: maybeNew("SaveScheduleFlagResult", data["saveScheduleFlag"] || undefined, {}),
  } as any;
}

export function newSaveScheduleFlagResponse(
  variables: SaveScheduleFlagMutationVariables,
  data: SaveScheduleFlagDataOptions | Error,
): MockedResponse<SaveScheduleFlagMutationVariables, SaveScheduleFlagMutation> {
  return {
    request: { query: SaveScheduleFlagDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleFlagData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteScheduleFlagDataOptions {
  deleteScheduleFlag?: FactoryInput<DeleteScheduleFlagResult, DeleteScheduleFlagResultOptions>;
}

export function newDeleteScheduleFlagData(data: DeleteScheduleFlagDataOptions): DeleteScheduleFlagMutation {
  return {
    __typename: "Mutation" as const,
    deleteScheduleFlag: maybeNew("DeleteScheduleFlagResult", data["deleteScheduleFlag"] || undefined, {}),
  } as any;
}

export function newDeleteScheduleFlagResponse(
  variables: DeleteScheduleFlagMutationVariables,
  data: DeleteScheduleFlagDataOptions | Error,
): MockedResponse<DeleteScheduleFlagMutationVariables, DeleteScheduleFlagMutation> {
  return {
    request: { query: DeleteScheduleFlagDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteScheduleFlagData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotCheckTableMetadataDataOptions {
  siteSpecificInfos?: FactoryInput<SiteSpecificInfo, SiteSpecificInfoOptions>[];
}

export function newLotCheckTableMetadataData(data: LotCheckTableMetadataDataOptions): LotCheckTableMetadataQuery {
  return {
    __typename: "Query" as const,
    siteSpecificInfos: data["siteSpecificInfos"]?.map((d) => maybeNew("SiteSpecificInfo", d, {})) || [],
  } as any;
}

export function newLotCheckTableMetadataResponse(
  data: LotCheckTableMetadataDataOptions | Error,
): MockedResponse<LotCheckTableMetadataQueryVariables, LotCheckTableMetadataQuery> {
  return {
    request: { query: LotCheckTableMetadataDocument },
    result: { data: data instanceof Error ? undefined : newLotCheckTableMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectSiteSpecificInfoDataOptions {
  saveProjectSiteSpecificInfo?: FactoryInput<
    SaveProjectSiteSpecificInfoResult,
    SaveProjectSiteSpecificInfoResultOptions
  >;
}

export function newSaveProjectSiteSpecificInfoData(
  data: SaveProjectSiteSpecificInfoDataOptions,
): SaveProjectSiteSpecificInfoMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectSiteSpecificInfo: maybeNew(
      "SaveProjectSiteSpecificInfoResult",
      data["saveProjectSiteSpecificInfo"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProjectSiteSpecificInfoResponse(
  variables: SaveProjectSiteSpecificInfoMutationVariables,
  data: SaveProjectSiteSpecificInfoDataOptions | Error,
): MockedResponse<SaveProjectSiteSpecificInfoMutationVariables, SaveProjectSiteSpecificInfoMutation> {
  return {
    request: { query: SaveProjectSiteSpecificInfoDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectSiteSpecificInfoData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskBillModal_SaveBillsDataOptions {
  saveBills?: FactoryInput<SaveBillsResult, SaveBillsResultOptions>;
}

export function newTaskBillModal_SaveBillsData(
  data: TaskBillModal_SaveBillsDataOptions,
): TaskBillModal_SaveBillsMutation {
  return {
    __typename: "Mutation" as const,
    saveBills: maybeNew("SaveBillsResult", data["saveBills"] || undefined, {}),
  } as any;
}

export function newTaskBillModal_SaveBillsResponse(
  variables: TaskBillModal_SaveBillsMutationVariables,
  data: TaskBillModal_SaveBillsDataOptions | Error,
): MockedResponse<TaskBillModal_SaveBillsMutationVariables, TaskBillModal_SaveBillsMutation> {
  return {
    request: { query: TaskBillModal_SaveBillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskBillModal_SaveBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskBillModal_ProtoBillsDataOptions {
  task?: FactoryInput<Task, TaskOptions>;
}

export function newTaskBillModal_ProtoBillsData(
  data: TaskBillModal_ProtoBillsDataOptions,
): TaskBillModal_ProtoBillsQuery {
  return { __typename: "Query" as const, task: maybeNew("Task", data["task"] || undefined, {}) } as any;
}

export function newTaskBillModal_ProtoBillsResponse(
  variables: TaskBillModal_ProtoBillsQueryVariables,
  data: TaskBillModal_ProtoBillsDataOptions | Error,
): MockedResponse<TaskBillModal_ProtoBillsQueryVariables, TaskBillModal_ProtoBillsQuery> {
  return {
    request: { query: TaskBillModal_ProtoBillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskBillModal_ProtoBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotDetailDrawerDataOptions {
  projectReadyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>;
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
  readyPlans?: FactoryInput<ReadyPlan, ReadyPlanOptions>[];
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  currentUser?: FactoryInput<User, UserOptions> | null;
  enumDetails?: FactoryInput<AllEnumDetails, AllEnumDetailsOptions>;
}

export function newLotDetailDrawerData(data: LotDetailDrawerDataOptions): LotDetailDrawerQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfig: maybeNew("ProjectReadyPlanConfig", data["projectReadyPlanConfig"] || undefined, {}),
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
    readyPlans: data["readyPlans"]?.map((d) => maybeNew("ReadyPlan", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newLotDetailDrawerResponse(
  variables: LotDetailDrawerQueryVariables,
  data: LotDetailDrawerDataOptions | Error,
): MockedResponse<LotDetailDrawerQueryVariables, LotDetailDrawerQuery> {
  return {
    request: { query: LotDetailDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotDetailDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ComputedProgramDataPreviewDataOptions {
  computeProgramData?: FactoryInput<NewProgramData, NewProgramDataOptions>;
}

export function newComputedProgramDataPreviewData(
  data: ComputedProgramDataPreviewDataOptions,
): ComputedProgramDataPreviewQuery {
  return {
    __typename: "Query" as const,
    computeProgramData: maybeNew("NewProgramData", data["computeProgramData"] || undefined, {}),
  } as any;
}

export function newComputedProgramDataPreviewResponse(
  variables: ComputedProgramDataPreviewQueryVariables,
  data: ComputedProgramDataPreviewDataOptions | Error,
): MockedResponse<ComputedProgramDataPreviewQueryVariables, ComputedProgramDataPreviewQuery> {
  return {
    request: { query: ComputedProgramDataPreviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newComputedProgramDataPreviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectReadyPlanConfigDataOptions {
  saveProjectReadyPlanConfigs?: FactoryInput<
    SaveProjectReadyPlanConfigsResult,
    SaveProjectReadyPlanConfigsResultOptions
  >;
}

export function newSaveProjectReadyPlanConfigData(
  data: SaveProjectReadyPlanConfigDataOptions,
): SaveProjectReadyPlanConfigMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectReadyPlanConfigs: maybeNew(
      "SaveProjectReadyPlanConfigsResult",
      data["saveProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProjectReadyPlanConfigResponse(
  variables: SaveProjectReadyPlanConfigMutationVariables,
  data: SaveProjectReadyPlanConfigDataOptions | Error,
): MockedResponse<SaveProjectReadyPlanConfigMutationVariables, SaveProjectReadyPlanConfigMutation> {
  return {
    request: { query: SaveProjectReadyPlanConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectReadyPlanConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectLotDetailDataOptions {
  saveProjectLotDetails?: FactoryInput<SaveProjectLotDetailsResult, SaveProjectLotDetailsResultOptions>;
}

export function newSaveProjectLotDetailData(data: SaveProjectLotDetailDataOptions): SaveProjectLotDetailMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectLotDetails: maybeNew("SaveProjectLotDetailsResult", data["saveProjectLotDetails"] || undefined, {}),
  } as any;
}

export function newSaveProjectLotDetailResponse(
  variables: SaveProjectLotDetailMutationVariables,
  data: SaveProjectLotDetailDataOptions | Error,
): MockedResponse<SaveProjectLotDetailMutationVariables, SaveProjectLotDetailMutation> {
  return {
    request: { query: SaveProjectLotDetailDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectLotDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotCheckFormDrawerMetadataDataOptions {
  internalUsers?: FactoryInput<InternalUser, InternalUserOptions>[];
  development?: FactoryInput<Development, DevelopmentOptions>;
}

export function newLotCheckFormDrawerMetadataData(
  data: LotCheckFormDrawerMetadataDataOptions,
): LotCheckFormDrawerMetadataQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => maybeNew("InternalUser", d, {})) || [],
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newLotCheckFormDrawerMetadataResponse(
  variables: LotCheckFormDrawerMetadataQueryVariables,
  data: LotCheckFormDrawerMetadataDataOptions | Error,
): MockedResponse<LotCheckFormDrawerMetadataQueryVariables, LotCheckFormDrawerMetadataQuery> {
  return {
    request: { query: LotCheckFormDrawerMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotCheckFormDrawerMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotCheckFormDrawerDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
}

export function newLotCheckFormDrawerData(data: LotCheckFormDrawerDataOptions): LotCheckFormDrawerQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newLotCheckFormDrawerResponse(
  variables: LotCheckFormDrawerQueryVariables,
  data: LotCheckFormDrawerDataOptions | Error,
): MockedResponse<LotCheckFormDrawerQueryVariables, LotCheckFormDrawerQuery> {
  return {
    request: { query: LotCheckFormDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotCheckFormDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectSiteConditionsDataOptions {
  saveProjectSiteCondition?: FactoryInput<SaveProjectSiteConditionResult, SaveProjectSiteConditionResultOptions>;
}

export function newSaveProjectSiteConditionsData(
  data: SaveProjectSiteConditionsDataOptions,
): SaveProjectSiteConditionsMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectSiteCondition: maybeNew(
      "SaveProjectSiteConditionResult",
      data["saveProjectSiteCondition"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProjectSiteConditionsResponse(
  variables: SaveProjectSiteConditionsMutationVariables,
  data: SaveProjectSiteConditionsDataOptions | Error,
): MockedResponse<SaveProjectSiteConditionsMutationVariables, SaveProjectSiteConditionsMutation> {
  return {
    request: { query: SaveProjectSiteConditionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectSiteConditionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendProjectSiteConditionsNotificationDataOptions {
  sendProjectSiteConditionsNotification?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newSendProjectSiteConditionsNotificationData(
  data: SendProjectSiteConditionsNotificationDataOptions,
): SendProjectSiteConditionsNotificationMutation {
  return {
    __typename: "Mutation" as const,
    sendProjectSiteConditionsNotification: maybeNew(
      "EmptyResult",
      data["sendProjectSiteConditionsNotification"] || undefined,
      {},
    ),
  } as any;
}

export function newSendProjectSiteConditionsNotificationResponse(
  variables: SendProjectSiteConditionsNotificationMutationVariables,
  data: SendProjectSiteConditionsNotificationDataOptions | Error,
): MockedResponse<
  SendProjectSiteConditionsNotificationMutationVariables,
  SendProjectSiteConditionsNotificationMutation
> {
  return {
    request: { query: SendProjectSiteConditionsNotificationDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendProjectSiteConditionsNotificationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSequenceSheetTableMetadataDataOptions {
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
  readyPlans?: FactoryInput<ReadyPlan, ReadyPlanOptions>[];
  globalOptionTypes?: FactoryInput<GlobalOptionType, GlobalOptionTypeOptions>[];
}

export function newLotSequenceSheetTableMetadataData(
  data: LotSequenceSheetTableMetadataDataOptions,
): LotSequenceSheetTableMetadataQuery {
  return {
    __typename: "Query" as const,
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
    readyPlans: data["readyPlans"]?.map((d) => maybeNew("ReadyPlan", d, {})) || [],
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => maybeNew("GlobalOptionType", d, {})) || [],
  } as any;
}

export function newLotSequenceSheetTableMetadataResponse(
  variables: LotSequenceSheetTableMetadataQueryVariables,
  data: LotSequenceSheetTableMetadataDataOptions | Error,
): MockedResponse<LotSequenceSheetTableMetadataQueryVariables, LotSequenceSheetTableMetadataQuery> {
  return {
    request: { query: LotSequenceSheetTableMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSequenceSheetTableMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSequenceSheetTableDataOptions {
  projectReadyPlanConfigs?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>[];
  globalTasks?: FactoryInput<GlobalTask, GlobalTaskOptions>[];
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
}

export function newLotSequenceSheetTableData(data: LotSequenceSheetTableDataOptions): LotSequenceSheetTableQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfigs: data["projectReadyPlanConfigs"]?.map((d) => maybeNew("ProjectReadyPlanConfig", d, {})) ||
      [],
    globalTasks: data["globalTasks"]?.map((d) => maybeNew("GlobalTask", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [],
  } as any;
}

export function newLotSequenceSheetTableResponse(
  variables: LotSequenceSheetTableQueryVariables,
  data: LotSequenceSheetTableDataOptions | Error,
): MockedResponse<LotSequenceSheetTableQueryVariables, LotSequenceSheetTableQuery> {
  return {
    request: { query: LotSequenceSheetTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSequenceSheetTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddNewDesignPackageSlotModalDataOptions {
  designPackage?: FactoryInput<DesignPackage, DesignPackageOptions>;
}

export function newAddNewDesignPackageSlotModalData(
  data: AddNewDesignPackageSlotModalDataOptions,
): AddNewDesignPackageSlotModalQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newAddNewDesignPackageSlotModalResponse(
  variables: AddNewDesignPackageSlotModalQueryVariables,
  data: AddNewDesignPackageSlotModalDataOptions | Error,
): MockedResponse<AddNewDesignPackageSlotModalQueryVariables, AddNewDesignPackageSlotModalQuery> {
  return {
    request: { query: AddNewDesignPackageSlotModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddNewDesignPackageSlotModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddNewDesignPackageSlotModal_MaterialAttributeDimensionsDataOptions {
  materialAttributeDimensions?: FactoryInput<MaterialAttributeDimension, MaterialAttributeDimensionOptions>[];
}

export function newAddNewDesignPackageSlotModal_MaterialAttributeDimensionsData(
  data: AddNewDesignPackageSlotModal_MaterialAttributeDimensionsDataOptions,
): AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery {
  return {
    __typename: "Query" as const,
    materialAttributeDimensions:
      data["materialAttributeDimensions"]?.map((d) => maybeNew("MaterialAttributeDimension", d, {})) || [],
  } as any;
}

export function newAddNewDesignPackageSlotModal_MaterialAttributeDimensionsResponse(
  variables: AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables,
  data: AddNewDesignPackageSlotModal_MaterialAttributeDimensionsDataOptions | Error,
): MockedResponse<
  AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables,
  AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery
> {
  return {
    request: { query: AddNewDesignPackageSlotModal_MaterialAttributeDimensionsDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newAddNewDesignPackageSlotModal_MaterialAttributeDimensionsData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddNewDesignPackageSlotModal_CreateSlotDataOptions {
  createDesignPackagePlaceholderTli?: FactoryInput<
    CreateDesignPackagePlaceholderTliResult,
    CreateDesignPackagePlaceholderTliResultOptions
  >;
}

export function newAddNewDesignPackageSlotModal_CreateSlotData(
  data: AddNewDesignPackageSlotModal_CreateSlotDataOptions,
): AddNewDesignPackageSlotModal_CreateSlotMutation {
  return {
    __typename: "Mutation" as const,
    createDesignPackagePlaceholderTli: maybeNew(
      "CreateDesignPackagePlaceholderTliResult",
      data["createDesignPackagePlaceholderTli"] || undefined,
      {},
    ),
  } as any;
}

export function newAddNewDesignPackageSlotModal_CreateSlotResponse(
  variables: AddNewDesignPackageSlotModal_CreateSlotMutationVariables,
  data: AddNewDesignPackageSlotModal_CreateSlotDataOptions | Error,
): MockedResponse<
  AddNewDesignPackageSlotModal_CreateSlotMutationVariables,
  AddNewDesignPackageSlotModal_CreateSlotMutation
> {
  return {
    request: { query: AddNewDesignPackageSlotModal_CreateSlotDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddNewDesignPackageSlotModal_CreateSlotData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateProjectCohortDataOptions {
  saveProject?: FactoryInput<SaveProjectResult, SaveProjectResultOptions>;
}

export function newUpdateProjectCohortData(data: UpdateProjectCohortDataOptions): UpdateProjectCohortMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newUpdateProjectCohortResponse(
  variables: UpdateProjectCohortMutationVariables,
  data: UpdateProjectCohortDataOptions | Error,
): MockedResponse<UpdateProjectCohortMutationVariables, UpdateProjectCohortMutation> {
  return {
    request: { query: UpdateProjectCohortDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateProjectCohortData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CohortDevelopmentsDataOptions {
  cohorts?: FactoryInput<Cohort, CohortOptions>[];
}

export function newCohortDevelopmentsData(data: CohortDevelopmentsDataOptions): CohortDevelopmentsQuery {
  return { __typename: "Query" as const, cohorts: data["cohorts"]?.map((d) => maybeNew("Cohort", d, {})) || [] } as any;
}

export function newCohortDevelopmentsResponse(
  data: CohortDevelopmentsDataOptions | Error,
): MockedResponse<CohortDevelopmentsQueryVariables, CohortDevelopmentsQuery> {
  return {
    request: { query: CohortDevelopmentsDocument },
    result: { data: data instanceof Error ? undefined : newCohortDevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductSearchPage_CurrentMaterialDataOptions {
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
}

export function newProductSearchPage_CurrentMaterialData(
  data: ProductSearchPage_CurrentMaterialDataOptions,
): ProductSearchPage_CurrentMaterialQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newProductSearchPage_CurrentMaterialResponse(
  variables: ProductSearchPage_CurrentMaterialQueryVariables,
  data: ProductSearchPage_CurrentMaterialDataOptions | Error,
): MockedResponse<ProductSearchPage_CurrentMaterialQueryVariables, ProductSearchPage_CurrentMaterialQuery> {
  return {
    request: { query: ProductSearchPage_CurrentMaterialDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductSearchPage_CurrentMaterialData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ElevationDetailsDataOptions {
  readyPlanOption?: FactoryInput<ReadyPlanOption, ReadyPlanOptionOptions>;
}

export function newElevationDetailsData(data: ElevationDetailsDataOptions): ElevationDetailsQuery {
  return {
    __typename: "Query" as const,
    readyPlanOption: maybeNew("ReadyPlanOption", data["readyPlanOption"] || undefined, {}),
  } as any;
}

export function newElevationDetailsResponse(
  variables: ElevationDetailsQueryVariables,
  data: ElevationDetailsDataOptions | Error,
): MockedResponse<ElevationDetailsQueryVariables, ElevationDetailsQuery> {
  return {
    request: { query: ElevationDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newElevationDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageRecentActivityDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newPlanPackageRecentActivityData(
  data: PlanPackageRecentActivityDataOptions,
): PlanPackageRecentActivityQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageRecentActivityResponse(
  variables: PlanPackageRecentActivityQueryVariables,
  data: PlanPackageRecentActivityDataOptions | Error,
): MockedResponse<PlanPackageRecentActivityQueryVariables, PlanPackageRecentActivityQuery> {
  return {
    request: { query: PlanPackageRecentActivityDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageRecentActivityData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditPlaceholderItemModal_GetItemsDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newAddEditPlaceholderItemModal_GetItemsData(
  data: AddEditPlaceholderItemModal_GetItemsDataOptions,
): AddEditPlaceholderItemModal_GetItemsQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [] } as any;
}

export function newAddEditPlaceholderItemModal_GetItemsResponse(
  data: AddEditPlaceholderItemModal_GetItemsDataOptions | Error,
): MockedResponse<AddEditPlaceholderItemModal_GetItemsQueryVariables, AddEditPlaceholderItemModal_GetItemsQuery> {
  return {
    request: { query: AddEditPlaceholderItemModal_GetItemsDocument },
    result: { data: data instanceof Error ? undefined : newAddEditPlaceholderItemModal_GetItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GetTliDataOptions {
  takeoffLineItem?: FactoryInput<TakeoffLineItem, TakeoffLineItemOptions>;
}

export function newAddEditItemModal_GetTliData(data: AddEditItemModal_GetTliDataOptions): AddEditItemModal_GetTliQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newAddEditItemModal_GetTliResponse(
  variables: AddEditItemModal_GetTliQueryVariables,
  data: AddEditItemModal_GetTliDataOptions | Error,
): MockedResponse<AddEditItemModal_GetTliQueryVariables, AddEditItemModal_GetTliQuery> {
  return {
    request: { query: AddEditItemModal_GetTliDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GetTliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GetItemsDataOptions {
  items?: FactoryInput<Item, ItemOptions>[];
}

export function newAddEditItemModal_GetItemsData(
  data: AddEditItemModal_GetItemsDataOptions,
): AddEditItemModal_GetItemsQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => maybeNew("Item", d, {})) || [] } as any;
}

export function newAddEditItemModal_GetItemsResponse(
  variables: AddEditItemModal_GetItemsQueryVariables,
  data: AddEditItemModal_GetItemsDataOptions | Error,
): MockedResponse<AddEditItemModal_GetItemsQueryVariables, AddEditItemModal_GetItemsQuery> {
  return {
    request: { query: AddEditItemModal_GetItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GetItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GetMaterialVariantsDataOptions {
  materialVariants?: FactoryInput<MaterialVariantsPage, MaterialVariantsPageOptions>;
}

export function newAddEditItemModal_GetMaterialVariantsData(
  data: AddEditItemModal_GetMaterialVariantsDataOptions,
): AddEditItemModal_GetMaterialVariantsQuery {
  return {
    __typename: "Query" as const,
    materialVariants: maybeNew("MaterialVariantsPage", data["materialVariants"] || undefined, {}),
  } as any;
}

export function newAddEditItemModal_GetMaterialVariantsResponse(
  variables: AddEditItemModal_GetMaterialVariantsQueryVariables,
  data: AddEditItemModal_GetMaterialVariantsDataOptions | Error,
): MockedResponse<AddEditItemModal_GetMaterialVariantsQueryVariables, AddEditItemModal_GetMaterialVariantsQuery> {
  return {
    request: { query: AddEditItemModal_GetMaterialVariantsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GetMaterialVariantsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GetReadyPlanDataOptions {
  readyPlan?: FactoryInput<ReadyPlan, ReadyPlanOptions>;
}

export function newAddEditItemModal_GetReadyPlanData(
  data: AddEditItemModal_GetReadyPlanDataOptions,
): AddEditItemModal_GetReadyPlanQuery {
  return { __typename: "Query" as const, readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}) } as any;
}

export function newAddEditItemModal_GetReadyPlanResponse(
  variables: AddEditItemModal_GetReadyPlanQueryVariables,
  data: AddEditItemModal_GetReadyPlanDataOptions | Error,
): MockedResponse<AddEditItemModal_GetReadyPlanQueryVariables, AddEditItemModal_GetReadyPlanQuery> {
  return {
    request: { query: AddEditItemModal_GetReadyPlanDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GetReadyPlanData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GlobalPlanTasksDataOptions {
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
}

export function newAddEditItemModal_GlobalPlanTasksData(
  data: AddEditItemModal_GlobalPlanTasksDataOptions,
): AddEditItemModal_GlobalPlanTasksQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newAddEditItemModal_GlobalPlanTasksResponse(
  variables: AddEditItemModal_GlobalPlanTasksQueryVariables,
  data: AddEditItemModal_GlobalPlanTasksDataOptions | Error,
): MockedResponse<AddEditItemModal_GlobalPlanTasksQueryVariables, AddEditItemModal_GlobalPlanTasksQuery> {
  return {
    request: { query: AddEditItemModal_GlobalPlanTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GlobalPlanTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkTaskAllocationModal_GlobalPlanTasksDataOptions {
  globalPlanTasks?: FactoryInput<GlobalPlanTasksPageResult, GlobalPlanTasksPageResultOptions>;
}

export function newBulkTaskAllocationModal_GlobalPlanTasksData(
  data: BulkTaskAllocationModal_GlobalPlanTasksDataOptions,
): BulkTaskAllocationModal_GlobalPlanTasksQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newBulkTaskAllocationModal_GlobalPlanTasksResponse(
  variables: BulkTaskAllocationModal_GlobalPlanTasksQueryVariables,
  data: BulkTaskAllocationModal_GlobalPlanTasksDataOptions | Error,
): MockedResponse<BulkTaskAllocationModal_GlobalPlanTasksQueryVariables, BulkTaskAllocationModal_GlobalPlanTasksQuery> {
  return {
    request: { query: BulkTaskAllocationModal_GlobalPlanTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkTaskAllocationModal_GlobalPlanTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageTakeoffTableDataOptions {
  takeoffLineItemsPage?: FactoryInput<TakeoffLineItemsPage, TakeoffLineItemsPageOptions>;
}

export function newPlanPackageTakeoffTableData(data: PlanPackageTakeoffTableDataOptions): PlanPackageTakeoffTableQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newPlanPackageTakeoffTableResponse(
  variables: PlanPackageTakeoffTableQueryVariables,
  data: PlanPackageTakeoffTableDataOptions | Error,
): MockedResponse<PlanPackageTakeoffTableQueryVariables, PlanPackageTakeoffTableQuery> {
  return {
    request: { query: PlanPackageTakeoffTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageTakeoffTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewSlotRequestsDataOptions {
  planPackage?: FactoryInput<PlanPackage, PlanPackageOptions>;
}

export function newReviewSlotRequestsData(data: ReviewSlotRequestsDataOptions): ReviewSlotRequestsQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newReviewSlotRequestsResponse(
  variables: ReviewSlotRequestsQueryVariables,
  data: ReviewSlotRequestsDataOptions | Error,
): MockedResponse<ReviewSlotRequestsQueryVariables, ReviewSlotRequestsQuery> {
  return {
    request: { query: ReviewSlotRequestsDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewSlotRequestsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewSlotRequests_RejectSlotDataOptions {
  rejectPlanPackageIncomingSlots?: FactoryInput<EmptyResult, EmptyResultOptions>;
}

export function newReviewSlotRequests_RejectSlotData(
  data: ReviewSlotRequests_RejectSlotDataOptions,
): ReviewSlotRequests_RejectSlotMutation {
  return {
    __typename: "Mutation" as const,
    rejectPlanPackageIncomingSlots: maybeNew("EmptyResult", data["rejectPlanPackageIncomingSlots"] || undefined, {}),
  } as any;
}

export function newReviewSlotRequests_RejectSlotResponse(
  variables: ReviewSlotRequests_RejectSlotMutationVariables,
  data: ReviewSlotRequests_RejectSlotDataOptions | Error,
): MockedResponse<ReviewSlotRequests_RejectSlotMutationVariables, ReviewSlotRequests_RejectSlotMutation> {
  return {
    request: { query: ReviewSlotRequests_RejectSlotDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewSlotRequests_RejectSlotData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewSlotRequests_AcceptSlotDataOptions {
  saveTakeoffLineItems?: FactoryInput<SaveTakeoffLineItemResult, SaveTakeoffLineItemResultOptions>;
}

export function newReviewSlotRequests_AcceptSlotData(
  data: ReviewSlotRequests_AcceptSlotDataOptions,
): ReviewSlotRequests_AcceptSlotMutation {
  return {
    __typename: "Mutation" as const,
    saveTakeoffLineItems: maybeNew("SaveTakeoffLineItemResult", data["saveTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newReviewSlotRequests_AcceptSlotResponse(
  variables: ReviewSlotRequests_AcceptSlotMutationVariables,
  data: ReviewSlotRequests_AcceptSlotDataOptions | Error,
): MockedResponse<ReviewSlotRequests_AcceptSlotMutationVariables, ReviewSlotRequests_AcceptSlotMutation> {
  return {
    request: { query: ReviewSlotRequests_AcceptSlotDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewSlotRequests_AcceptSlotData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompletedTaskBudgetReviewWidgetDataOptions {
  projectCompletedTaskBudgetReview?: FactoryInput<
    ProjectCompletedTaskBudgetReview,
    ProjectCompletedTaskBudgetReviewOptions
  >[];
}

export function newCompletedTaskBudgetReviewWidgetData(
  data: CompletedTaskBudgetReviewWidgetDataOptions,
): CompletedTaskBudgetReviewWidgetQuery {
  return {
    __typename: "Query" as const,
    projectCompletedTaskBudgetReview:
      data["projectCompletedTaskBudgetReview"]?.map((d) => maybeNew("ProjectCompletedTaskBudgetReview", d, {})) || [],
  } as any;
}

export function newCompletedTaskBudgetReviewWidgetResponse(
  variables: CompletedTaskBudgetReviewWidgetQueryVariables,
  data: CompletedTaskBudgetReviewWidgetDataOptions | Error,
): MockedResponse<CompletedTaskBudgetReviewWidgetQueryVariables, CompletedTaskBudgetReviewWidgetQuery> {
  return {
    request: { query: CompletedTaskBudgetReviewWidgetDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompletedTaskBudgetReviewWidgetData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewConfigurationStepDataOptions {
  structure?: FactoryInput<Structure, StructureOptions>;
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions>;
}

export function newReviewConfigurationStepData(data: ReviewConfigurationStepDataOptions): ReviewConfigurationStepQuery {
  return {
    __typename: "Query" as const,
    structure: maybeNew("Structure", data["structure"] || undefined, {}),
    checkoutConfig: maybeNew("CheckoutConfig", data["checkoutConfig"] || undefined, {}),
  } as any;
}

export function newReviewConfigurationStepResponse(
  variables: ReviewConfigurationStepQueryVariables,
  data: ReviewConfigurationStepDataOptions | Error,
): MockedResponse<ReviewConfigurationStepQueryVariables, ReviewConfigurationStepQuery> {
  return {
    request: { query: ReviewConfigurationStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewConfigurationStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectConfigurationStepDataOptions {
  structure?: FactoryInput<Structure, StructureOptions>;
}

export function newSelectConfigurationStepData(data: SelectConfigurationStepDataOptions): SelectConfigurationStepQuery {
  return { __typename: "Query" as const, structure: maybeNew("Structure", data["structure"] || undefined, {}) } as any;
}

export function newSelectConfigurationStepResponse(
  variables: SelectConfigurationStepQueryVariables,
  data: SelectConfigurationStepDataOptions | Error,
): MockedResponse<SelectConfigurationStepQueryVariables, SelectConfigurationStepQuery> {
  return {
    request: { query: SelectConfigurationStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectConfigurationStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectConfigurationStep_SelectedConfigDataOptions {
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions>;
}

export function newSelectConfigurationStep_SelectedConfigData(
  data: SelectConfigurationStep_SelectedConfigDataOptions,
): SelectConfigurationStep_SelectedConfigQuery {
  return {
    __typename: "Query" as const,
    checkoutConfig: maybeNew("CheckoutConfig", data["checkoutConfig"] || undefined, {}),
  } as any;
}

export function newSelectConfigurationStep_SelectedConfigResponse(
  variables: SelectConfigurationStep_SelectedConfigQueryVariables,
  data: SelectConfigurationStep_SelectedConfigDataOptions | Error,
): MockedResponse<SelectConfigurationStep_SelectedConfigQueryVariables, SelectConfigurationStep_SelectedConfigQuery> {
  return {
    request: { query: SelectConfigurationStep_SelectedConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectConfigurationStep_SelectedConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyConfigurationDirectly_ReadyPlanConfigDataOptions {
  structure?: FactoryInput<Structure, StructureOptions>;
}

export function newApplyConfigurationDirectly_ReadyPlanConfigData(
  data: ApplyConfigurationDirectly_ReadyPlanConfigDataOptions,
): ApplyConfigurationDirectly_ReadyPlanConfigQuery {
  return { __typename: "Query" as const, structure: maybeNew("Structure", data["structure"] || undefined, {}) } as any;
}

export function newApplyConfigurationDirectly_ReadyPlanConfigResponse(
  variables: ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables,
  data: ApplyConfigurationDirectly_ReadyPlanConfigDataOptions | Error,
): MockedResponse<
  ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables,
  ApplyConfigurationDirectly_ReadyPlanConfigQuery
> {
  return {
    request: { query: ApplyConfigurationDirectly_ReadyPlanConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyConfigurationDirectly_ReadyPlanConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyConfigurationDirectlyDataOptions {
  saveProjectReadyPlanConfigs?: FactoryInput<
    SaveProjectReadyPlanConfigsResult,
    SaveProjectReadyPlanConfigsResultOptions
  >;
}

export function newApplyConfigurationDirectlyData(
  data: ApplyConfigurationDirectlyDataOptions,
): ApplyConfigurationDirectlyMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectReadyPlanConfigs: maybeNew(
      "SaveProjectReadyPlanConfigsResult",
      data["saveProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newApplyConfigurationDirectlyResponse(
  variables: ApplyConfigurationDirectlyMutationVariables,
  data: ApplyConfigurationDirectlyDataOptions | Error,
): MockedResponse<ApplyConfigurationDirectlyMutationVariables, ApplyConfigurationDirectlyMutation> {
  return {
    request: { query: ApplyConfigurationDirectlyDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyConfigurationDirectlyData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewImpactProjectDataOptions {
  project?: FactoryInput<Project, ProjectOptions>;
  projectItemsPage?: FactoryInput<ProjectItemsPage, ProjectItemsPageOptions>;
}

export function newReviewImpactProjectData(data: ReviewImpactProjectDataOptions): ReviewImpactProjectQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    projectItemsPage: maybeNew("ProjectItemsPage", data["projectItemsPage"] || undefined, {}),
  } as any;
}

export function newReviewImpactProjectResponse(
  variables: ReviewImpactProjectQueryVariables,
  data: ReviewImpactProjectDataOptions | Error,
): MockedResponse<ReviewImpactProjectQueryVariables, ReviewImpactProjectQuery> {
  return {
    request: { query: ReviewImpactProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewImpactProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewProjectImpactChangeEventDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newReviewProjectImpactChangeEventData(
  data: ReviewProjectImpactChangeEventDataOptions,
): ReviewProjectImpactChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newReviewProjectImpactChangeEventResponse(
  variables: ReviewProjectImpactChangeEventQueryVariables,
  data: ReviewProjectImpactChangeEventDataOptions | Error,
): MockedResponse<ReviewProjectImpactChangeEventQueryVariables, ReviewProjectImpactChangeEventQuery> {
  return {
    request: { query: ReviewProjectImpactChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewProjectImpactChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewProjectImpactCheckoutConfigDataOptions {
  structure?: FactoryInput<Structure, StructureOptions>;
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions>;
}

export function newReviewProjectImpactCheckoutConfigData(
  data: ReviewProjectImpactCheckoutConfigDataOptions,
): ReviewProjectImpactCheckoutConfigQuery {
  return {
    __typename: "Query" as const,
    structure: maybeNew("Structure", data["structure"] || undefined, {}),
    checkoutConfig: maybeNew("CheckoutConfig", data["checkoutConfig"] || undefined, {}),
  } as any;
}

export function newReviewProjectImpactCheckoutConfigResponse(
  variables: ReviewProjectImpactCheckoutConfigQueryVariables,
  data: ReviewProjectImpactCheckoutConfigDataOptions | Error,
): MockedResponse<ReviewProjectImpactCheckoutConfigQueryVariables, ReviewProjectImpactCheckoutConfigQuery> {
  return {
    request: { query: ReviewProjectImpactCheckoutConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewProjectImpactCheckoutConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewProjectImpactComputeCostDataOptions {
  computeReadyPlanCost?: FactoryInput<ComputeReadyPlanCostResult, ComputeReadyPlanCostResultOptions>;
}

export function newReviewProjectImpactComputeCostData(
  data: ReviewProjectImpactComputeCostDataOptions,
): ReviewProjectImpactComputeCostQuery {
  return {
    __typename: "Query" as const,
    computeReadyPlanCost: maybeNew("ComputeReadyPlanCostResult", data["computeReadyPlanCost"] || undefined, {}),
  } as any;
}

export function newReviewProjectImpactComputeCostResponse(
  variables: ReviewProjectImpactComputeCostQueryVariables,
  data: ReviewProjectImpactComputeCostDataOptions | Error,
): MockedResponse<ReviewProjectImpactComputeCostQueryVariables, ReviewProjectImpactComputeCostQuery> {
  return {
    request: { query: ReviewProjectImpactComputeCostDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewProjectImpactComputeCostData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewStepChangeEventDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newReviewStepChangeEventData(data: ReviewStepChangeEventDataOptions): ReviewStepChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newReviewStepChangeEventResponse(
  variables: ReviewStepChangeEventQueryVariables,
  data: ReviewStepChangeEventDataOptions | Error,
): MockedResponse<ReviewStepChangeEventQueryVariables, ReviewStepChangeEventQuery> {
  return {
    request: { query: ReviewStepChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewStepChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGuidedChangeEventDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newSaveGuidedChangeEventData(data: SaveGuidedChangeEventDataOptions): SaveGuidedChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newSaveGuidedChangeEventResponse(
  variables: SaveGuidedChangeEventMutationVariables,
  data: SaveGuidedChangeEventDataOptions | Error,
): MockedResponse<SaveGuidedChangeEventMutationVariables, SaveGuidedChangeEventMutation> {
  return {
    request: { query: SaveGuidedChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGuidedChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectProductToReplaceProjectItemDataOptions {
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
}

export function newSelectProductToReplaceProjectItemData(
  data: SelectProductToReplaceProjectItemDataOptions,
): SelectProductToReplaceProjectItemQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newSelectProductToReplaceProjectItemResponse(
  variables: SelectProductToReplaceProjectItemQueryVariables,
  data: SelectProductToReplaceProjectItemDataOptions | Error,
): MockedResponse<SelectProductToReplaceProjectItemQueryVariables, SelectProductToReplaceProjectItemQuery> {
  return {
    request: { query: SelectProductToReplaceProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectProductToReplaceProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectProductToReplaceMaterialVariantDataOptions {
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
}

export function newSelectProductToReplaceMaterialVariantData(
  data: SelectProductToReplaceMaterialVariantDataOptions,
): SelectProductToReplaceMaterialVariantQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
  } as any;
}

export function newSelectProductToReplaceMaterialVariantResponse(
  variables: SelectProductToReplaceMaterialVariantQueryVariables,
  data: SelectProductToReplaceMaterialVariantDataOptions | Error,
): MockedResponse<SelectProductToReplaceMaterialVariantQueryVariables, SelectProductToReplaceMaterialVariantQuery> {
  return {
    request: { query: SelectProductToReplaceMaterialVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectProductToReplaceMaterialVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewImpactChangeEventDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newReviewImpactChangeEventData(data: ReviewImpactChangeEventDataOptions): ReviewImpactChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newReviewImpactChangeEventResponse(
  variables: ReviewImpactChangeEventQueryVariables,
  data: ReviewImpactChangeEventDataOptions | Error,
): MockedResponse<ReviewImpactChangeEventQueryVariables, ReviewImpactChangeEventQuery> {
  return {
    request: { query: ReviewImpactChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewImpactChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewImpactProjectItemCountDataOptions {
  projectItemsPage?: FactoryInput<ProjectItemsPage, ProjectItemsPageOptions>;
}

export function newReviewImpactProjectItemCountData(
  data: ReviewImpactProjectItemCountDataOptions,
): ReviewImpactProjectItemCountQuery {
  return {
    __typename: "Query" as const,
    projectItemsPage: maybeNew("ProjectItemsPage", data["projectItemsPage"] || undefined, {}),
  } as any;
}

export function newReviewImpactProjectItemCountResponse(
  variables: ReviewImpactProjectItemCountQueryVariables,
  data: ReviewImpactProjectItemCountDataOptions | Error,
): MockedResponse<ReviewImpactProjectItemCountQueryVariables, ReviewImpactProjectItemCountQuery> {
  return {
    request: { query: ReviewImpactProjectItemCountDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewImpactProjectItemCountData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectOptionStepDataOptions {
  projectReadyPlanConfig?: FactoryInput<ProjectReadyPlanConfig, ProjectReadyPlanConfigOptions>;
}

export function newSelectOptionStepData(data: SelectOptionStepDataOptions): SelectOptionStepQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfig: maybeNew("ProjectReadyPlanConfig", data["projectReadyPlanConfig"] || undefined, {}),
  } as any;
}

export function newSelectOptionStepResponse(
  variables: SelectOptionStepQueryVariables,
  data: SelectOptionStepDataOptions | Error,
): MockedResponse<SelectOptionStepQueryVariables, SelectOptionStepQuery> {
  return {
    request: { query: SelectOptionStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectOptionStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewStep_SaveChangeEventDataOptions {
  saveChangeEvent?: FactoryInput<SaveChangeEventResult, SaveChangeEventResultOptions>;
}

export function newReviewStep_SaveChangeEventData(
  data: ReviewStep_SaveChangeEventDataOptions,
): ReviewStep_SaveChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newReviewStep_SaveChangeEventResponse(
  variables: ReviewStep_SaveChangeEventMutationVariables,
  data: ReviewStep_SaveChangeEventDataOptions | Error,
): MockedResponse<ReviewStep_SaveChangeEventMutationVariables, ReviewStep_SaveChangeEventMutation> {
  return {
    request: { query: ReviewStep_SaveChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewStep_SaveChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseReplacementProjectItemDetailsDataOptions {
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
}

export function newChooseReplacementProjectItemDetailsData(
  data: ChooseReplacementProjectItemDetailsDataOptions,
): ChooseReplacementProjectItemDetailsQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newChooseReplacementProjectItemDetailsResponse(
  variables: ChooseReplacementProjectItemDetailsQueryVariables,
  data: ChooseReplacementProjectItemDetailsDataOptions | Error,
): MockedResponse<ChooseReplacementProjectItemDetailsQueryVariables, ChooseReplacementProjectItemDetailsQuery> {
  return {
    request: { query: ChooseReplacementProjectItemDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChooseReplacementProjectItemDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseReplacementPossibleMaterialsDataOptions {
  materialVariants?: FactoryInput<MaterialVariantsPage, MaterialVariantsPageOptions>;
}

export function newChooseReplacementPossibleMaterialsData(
  data: ChooseReplacementPossibleMaterialsDataOptions,
): ChooseReplacementPossibleMaterialsQuery {
  return {
    __typename: "Query" as const,
    materialVariants: maybeNew("MaterialVariantsPage", data["materialVariants"] || undefined, {}),
  } as any;
}

export function newChooseReplacementPossibleMaterialsResponse(
  variables: ChooseReplacementPossibleMaterialsQueryVariables,
  data: ChooseReplacementPossibleMaterialsDataOptions | Error,
): MockedResponse<ChooseReplacementPossibleMaterialsQueryVariables, ChooseReplacementPossibleMaterialsQuery> {
  return {
    request: { query: ChooseReplacementPossibleMaterialsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChooseReplacementPossibleMaterialsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectConfiguration_PotentialConfigsDataOptions {
  checkoutConfigs?: FactoryInput<CheckoutConfigsPage, CheckoutConfigsPageOptions>;
}

export function newSelectConfiguration_PotentialConfigsData(
  data: SelectConfiguration_PotentialConfigsDataOptions,
): SelectConfiguration_PotentialConfigsQuery {
  return {
    __typename: "Query" as const,
    checkoutConfigs: maybeNew("CheckoutConfigsPage", data["checkoutConfigs"] || undefined, {}),
  } as any;
}

export function newSelectConfiguration_PotentialConfigsResponse(
  variables: SelectConfiguration_PotentialConfigsQueryVariables,
  data: SelectConfiguration_PotentialConfigsDataOptions | Error,
): MockedResponse<SelectConfiguration_PotentialConfigsQueryVariables, SelectConfiguration_PotentialConfigsQuery> {
  return {
    request: { query: SelectConfiguration_PotentialConfigsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectConfiguration_PotentialConfigsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectConfiguration_SelectedConfigDataOptions {
  checkoutConfig?: FactoryInput<CheckoutConfig, CheckoutConfigOptions>;
}

export function newSelectConfiguration_SelectedConfigData(
  data: SelectConfiguration_SelectedConfigDataOptions,
): SelectConfiguration_SelectedConfigQuery {
  return {
    __typename: "Query" as const,
    checkoutConfig: maybeNew("CheckoutConfig", data["checkoutConfig"] || undefined, {}),
  } as any;
}

export function newSelectConfiguration_SelectedConfigResponse(
  variables: SelectConfiguration_SelectedConfigQueryVariables,
  data: SelectConfiguration_SelectedConfigDataOptions | Error,
): MockedResponse<SelectConfiguration_SelectedConfigQueryVariables, SelectConfiguration_SelectedConfigQuery> {
  return {
    request: { query: SelectConfiguration_SelectedConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectConfiguration_SelectedConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DefineReplacementMetadataDataOptions {
  projectItem?: FactoryInput<ProjectItem, ProjectItemOptions>;
  materialBrands?: FactoryInput<MaterialBrand, MaterialBrandOptions>[];
}

export function newDefineReplacementMetadataData(
  data: DefineReplacementMetadataDataOptions,
): DefineReplacementMetadataQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
    materialBrands: data["materialBrands"]?.map((d) => maybeNew("MaterialBrand", d, {})) || [],
  } as any;
}

export function newDefineReplacementMetadataResponse(
  variables: DefineReplacementMetadataQueryVariables,
  data: DefineReplacementMetadataDataOptions | Error,
): MockedResponse<DefineReplacementMetadataQueryVariables, DefineReplacementMetadataQuery> {
  return {
    request: { query: DefineReplacementMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDefineReplacementMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DefineReplacementMaterialVariantDataOptions {
  materialVariant?: FactoryInput<MaterialVariant, MaterialVariantOptions>;
}

export function newDefineReplacementMaterialVariantData(
  data: DefineReplacementMaterialVariantDataOptions,
): DefineReplacementMaterialVariantQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
  } as any;
}

export function newDefineReplacementMaterialVariantResponse(
  variables: DefineReplacementMaterialVariantQueryVariables,
  data: DefineReplacementMaterialVariantDataOptions | Error,
): MockedResponse<DefineReplacementMaterialVariantQueryVariables, DefineReplacementMaterialVariantQuery> {
  return {
    request: { query: DefineReplacementMaterialVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newDefineReplacementMaterialVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DefineReplacement_SaveMaterialListingDataOptions {
  saveMaterialListing?: FactoryInput<MaterialListing, MaterialListingOptions>;
}

export function newDefineReplacement_SaveMaterialListingData(
  data: DefineReplacement_SaveMaterialListingDataOptions,
): DefineReplacement_SaveMaterialListingMutation {
  return {
    __typename: "Mutation" as const,
    saveMaterialListing: maybeNew("MaterialListing", data["saveMaterialListing"] || undefined, {}),
  } as any;
}

export function newDefineReplacement_SaveMaterialListingResponse(
  variables: DefineReplacement_SaveMaterialListingMutationVariables,
  data: DefineReplacement_SaveMaterialListingDataOptions | Error,
): MockedResponse<
  DefineReplacement_SaveMaterialListingMutationVariables,
  DefineReplacement_SaveMaterialListingMutation
> {
  return {
    request: { query: DefineReplacement_SaveMaterialListingDocument, variables },
    result: { data: data instanceof Error ? undefined : newDefineReplacement_SaveMaterialListingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PurchaseOrderCleanupChangeEventDataOptions {
  changeEvent?: FactoryInput<ChangeEvent, ChangeEventOptions>;
}

export function newPurchaseOrderCleanupChangeEventData(
  data: PurchaseOrderCleanupChangeEventDataOptions,
): PurchaseOrderCleanupChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newPurchaseOrderCleanupChangeEventResponse(
  variables: PurchaseOrderCleanupChangeEventQueryVariables,
  data: PurchaseOrderCleanupChangeEventDataOptions | Error,
): MockedResponse<PurchaseOrderCleanupChangeEventQueryVariables, PurchaseOrderCleanupChangeEventQuery> {
  return {
    request: { query: PurchaseOrderCleanupChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newPurchaseOrderCleanupChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyInitialConfigurationGateDataOptions {
  structure?: FactoryInput<Structure, StructureOptions>;
}

export function newApplyInitialConfigurationGateData(
  data: ApplyInitialConfigurationGateDataOptions,
): ApplyInitialConfigurationGateQuery {
  return { __typename: "Query" as const, structure: maybeNew("Structure", data["structure"] || undefined, {}) } as any;
}

export function newApplyInitialConfigurationGateResponse(
  variables: ApplyInitialConfigurationGateQueryVariables,
  data: ApplyInitialConfigurationGateDataOptions | Error,
): MockedResponse<ApplyInitialConfigurationGateQueryVariables, ApplyInitialConfigurationGateQuery> {
  return {
    request: { query: ApplyInitialConfigurationGateDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyInitialConfigurationGateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectProductModalProjectItemsDataOptions {
  projectItemsPage?: FactoryInput<ProjectItemsPage, ProjectItemsPageOptions>;
}

export function newSelectProductModalProjectItemsData(
  data: SelectProductModalProjectItemsDataOptions,
): SelectProductModalProjectItemsQuery {
  return {
    __typename: "Query" as const,
    projectItemsPage: maybeNew("ProjectItemsPage", data["projectItemsPage"] || undefined, {}),
  } as any;
}

export function newSelectProductModalProjectItemsResponse(
  variables: SelectProductModalProjectItemsQueryVariables,
  data: SelectProductModalProjectItemsDataOptions | Error,
): MockedResponse<SelectProductModalProjectItemsQueryVariables, SelectProductModalProjectItemsQuery> {
  return {
    request: { query: SelectProductModalProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectProductModalProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectProductModalMetadataDataOptions {
  projectCostCodes?: FactoryInput<ProjectCostCodesPageResult, ProjectCostCodesPageResultOptions>;
}

export function newSelectProductModalMetadataData(
  data: SelectProductModalMetadataDataOptions,
): SelectProductModalMetadataQuery {
  return {
    __typename: "Query" as const,
    projectCostCodes: maybeNew("ProjectCostCodesPageResult", data["projectCostCodes"] || undefined, {}),
  } as any;
}

export function newSelectProductModalMetadataResponse(
  variables: SelectProductModalMetadataQueryVariables,
  data: SelectProductModalMetadataDataOptions | Error,
): MockedResponse<SelectProductModalMetadataQueryVariables, SelectProductModalMetadataQuery> {
  return {
    request: { query: SelectProductModalMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectProductModalMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}

  export type MockedResponse<V, Q> = {
    request: {
      query: any;
      variables?: V;
    };
    result: {
      data?: Q;
    };
    error?: Error;
    // Note this only works if using Homebound's better-apollo-mocked-provider
    requestedCount?: number;
  };
